(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire19d5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire19d5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hp59o", function(module, exports) {

$parcel$export(module.exports, "HTTPError", function () { return $0fe1f1400993ba8a$export$aa9d629c530f62a7; });
$parcel$export(module.exports, "HTTPClient", function () { return $cbd22d3323bef9ca$export$45cf759b359d3d24; });

var $aVdP5 = parcelRequire("aVdP5");

var $fPf27 = parcelRequire("fPf27");

var $hVBqc = parcelRequire("hVBqc");

var $hW8ac = parcelRequire("hW8ac");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");

var $2wBSb = parcelRequire("2wBSb");

var $1Qmny = parcelRequire("1Qmny");

var $Csf8W = parcelRequire("Csf8W");

var $6tqvJ = parcelRequire("6tqvJ");
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $eef213ff4197108b$exports = {};
$parcel$export($eef213ff4197108b$exports, "Stack", function() {
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
});
var _Array_prototype = Array.prototype, $eef213ff4197108b$var$push = _Array_prototype.push;
var $eef213ff4197108b$export$694e0d28c7ffc90c = /*#__PURE__*/ function() {
    "use strict";
    function $eef213ff4197108b$export$694e0d28c7ffc90c() {
        (0, $7lhcp._)(this, $eef213ff4197108b$export$694e0d28c7ffc90c);
        this.length = 0;
    }
    (0, $8BtP9._)($eef213ff4197108b$export$694e0d28c7ffc90c, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                $eef213ff4197108b$var$push.apply(this, middlewares);
                return this;
            }
        },
        {
            key: "execute",
            value: function execute(context) {
                var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var middleware = this[depth];
                if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
            }
        },
        {
            key: "mount",
            value: function mount(condition, stack) {
                return this.use(function(context, next) {
                    return condition(context) ? stack.execute(context) : next();
                });
            }
        }
    ]);
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
}();
var $0fe1f1400993ba8a$exports = {};
$parcel$export($0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $0fe1f1400993ba8a$export$4125cfe7e08e2040;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
});
$parcel$export($0fe1f1400993ba8a$exports, "headerParser", function() {
    return $0fe1f1400993ba8a$export$b725a69477e4d33f;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $0fe1f1400993ba8a$export$eea2c1c5e1a37e50;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseBody", function() {
    return $0fe1f1400993ba8a$export$3b629cd0ff482602;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $0fe1f1400993ba8a$export$4f2a8c8c11a6373a;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $0fe1f1400993ba8a$export$bda27a3e49197b9;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $0fe1f1400993ba8a$export$ba14d9a5a581e827;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $0fe1f1400993ba8a$export$b7b86d31099674dc;
});
$parcel$export($0fe1f1400993ba8a$exports, "request", function() {
    return $0fe1f1400993ba8a$export$b5fe3f66a567bec0;
});
var $22de11b45b0eeb97$exports = {};
$parcel$export($22de11b45b0eeb97$exports, "polyfillProgressEvent", function() {
    return $22de11b45b0eeb97$export$5e6a03ce7b01784;
});
$parcel$export($22de11b45b0eeb97$exports, "parseDocument", function() {
    return $22de11b45b0eeb97$export$b6a9369736b19f4d;
});
$parcel$export($22de11b45b0eeb97$exports, "makeFormData", function() {
    return $22de11b45b0eeb97$export$2c28ab2e118e73f1;
});
$parcel$export($22de11b45b0eeb97$exports, "serializeNode", function() {
    return $22de11b45b0eeb97$export$a0beee2e55fb5dd1;
});
$parcel$export($22de11b45b0eeb97$exports, "serialize", function() {
    return $22de11b45b0eeb97$export$dfdc1655ccc5b9cb;
});
$parcel$export($22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $22de11b45b0eeb97$export$f8162fcba31fa547;
});
$parcel$export($22de11b45b0eeb97$exports, "emitStreamProgress", function() {
    return $22de11b45b0eeb97$export$cebfdbc318a33abe;
});
$parcel$export($22de11b45b0eeb97$exports, "FileMethod", function() {
    return $22de11b45b0eeb97$export$226b21d2db5eaf9f;
});
$parcel$export($22de11b45b0eeb97$exports, "readAs", function() {
    return $22de11b45b0eeb97$export$e209cbb66c5b18c;
});
$parcel$export($22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $22de11b45b0eeb97$export$8fb536984ec8b4d7;
});
function $22de11b45b0eeb97$export$5e6a03ce7b01784() {
    var _globalThis;
    return (_globalThis = globalThis).ProgressEvent || (_globalThis.ProgressEvent = /*#__PURE__*/ function(Event1) {
        "use strict";
        (0, $h6w6E._)(ProgressEvent1, Event1);
        function ProgressEvent1(type) {
            var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            (0, $7lhcp._)(this, ProgressEvent1);
            var _this;
            var lengthComputable = _param.lengthComputable, total = _param.total, loaded = _param.loaded, meta = (0, $8MJI4._)(_param, [
                "lengthComputable",
                "total",
                "loaded"
            ]);
            _this = (0, $07dqX._)(this, ProgressEvent1, [
                type,
                meta
            ]);
            _this.lengthComputable = lengthComputable;
            _this.total = total;
            _this.loaded = loaded;
            return _this;
        }
        return ProgressEvent1;
    }((0, $1Qmny._)(Event)));
}
function $22de11b45b0eeb97$export$b6a9369736b19f4d(text) {
    var contentType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var _ref, type;
        return (0, $Csf8W.__generator)(this, function(_state) {
            _ref = (0, $leE2g._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(';')) || [], 1), type = _ref[0];
            return [
                2,
                new DOMParser().parseFromString(text, type || 'text/html')
            ];
        });
    })();
}
function $22de11b45b0eeb97$export$2c28ab2e118e73f1(data) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $leE2g._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var list = typeof value !== 'string' && (0, $6tqvJ.likeArray)(value) ? value : [
                value
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Array.from(list)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var item = _step1.value;
                    if (item != null) {
                        if ((typeof item === "undefined" ? "undefined" : (0, $5f0Cq._)(item)) === 'object') formData.append(key, item, item.name);
                        else formData.append(key, item);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $22de11b45b0eeb97$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
        data: (0, $6tqvJ.stringifyDOM)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: 'multipart/form-data',
        data: new FormData(root)
    };
    var data = (0, $6tqvJ.formToJSON)(root);
    switch(contentType = root.enctype){
        case 'text/plain':
            return {
                contentType: contentType,
                data: Object.entries(data).map(function(param) {
                    var _param = (0, $leE2g._)(param, 2), name = _param[0], value = _param[1];
                    return "".concat(name, "=").concat(value);
                }).join('\n')
            };
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        default:
            return {
                contentType: 'application/json',
                data: JSON.stringify(data)
            };
    }
}
function $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(data, contentType) {
    var _ref = (0, $leE2g._)((contentType === null || contentType === void 0 ? void 0 : contentType.split(';')) || [], 1), type = _ref[0];
    switch(type){
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case 'multipart/form-data':
            return {
                data: $22de11b45b0eeb97$export$2c28ab2e118e73f1(data)
            };
        case 'application/json':
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case 'text/html':
        case 'application/xml':
        case 'image/svg':
            return {
                contentType: contentType,
                data: (0, $6tqvJ.stringifyDOM)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: 'application/x-www-form-urlencoded',
            data: data
        };
    } catch (e) {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch (e) {}
    try {
        if (data instanceof Node) return $22de11b45b0eeb97$export$a0beee2e55fb5dd1(data);
    } catch (e) {}
    try {
        if ((0, $6tqvJ.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: 'application/octet-stream',
            data: data
        };
    } catch (e) {}
    try {
        return {
            contentType: 'application/json',
            data: JSON.stringify(data)
        };
    } catch (e) {}
    throw new Error('Unserialized Object needs a specific Content-Type');
}
var $22de11b45b0eeb97$export$f8162fcba31fa547 = function(target) {
    return (0, $6tqvJ.createAsyncIterator)(function(param) {
        var next = param.next, complete = param.complete, error = param.error;
        var handleProgress = function(param) {
            var loaded = param.loaded, total = param.total;
            next({
                loaded: loaded,
                total: total
            });
            if (loaded >= total) complete();
        };
        target.addEventListener('progress', handleProgress);
        target.addEventListener('error', error);
        return function() {
            target.removeEventListener('progress', handleProgress);
            target.removeEventListener('error', error);
        };
    });
};
function $22de11b45b0eeb97$export$cebfdbc318a33abe(stream, total, eventTarget) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function() {
        var loaded, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, event, err;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loaded = 0;
                    $22de11b45b0eeb97$export$5e6a03ce7b01784();
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $fPf27._)(stream);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        4,
                        chunk
                    ];
                case 4:
                    _state.sent();
                    loaded += chunk.byteLength;
                    event = new ProgressEvent('progress', {
                        lengthComputable: isNaN(total),
                        loaded: loaded,
                        total: total
                    });
                    eventTarget.dispatchEvent(event);
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $22de11b45b0eeb97$export$226b21d2db5eaf9f = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
function $22de11b45b0eeb97$export$e209cbb66c5b18c(file, method, encoding) {
    var reader = new FileReader();
    var result = new Promise(function(resolve, reject) {
        reader.onerror = reject;
        reader.onload = function() {
            return resolve(reader.result);
        };
        reader[$22de11b45b0eeb97$export$226b21d2db5eaf9f[method]](file, encoding);
    });
    return {
        progress: $22de11b45b0eeb97$export$f8162fcba31fa547(reader),
        result: result
    };
}
var $22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $22de11b45b0eeb97$export$8fb536984ec8b4d7(raw) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var text, text1;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(raw instanceof Blob)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $22de11b45b0eeb97$export$e209cbb66c5b18c(raw, 'dataURL').result
                    ];
                case 1:
                    text = _state.sent();
                    return [
                        2,
                        ($22de11b45b0eeb97$var$DataURI.exec(text) || '')[4]
                    ];
                case 2:
                    text1 = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, function(_, p1) {
                        return String.fromCharCode(+('0x' + p1));
                    });
                    return [
                        2,
                        btoa(text1)
                    ];
            }
        });
    })();
}
var $0fe1f1400993ba8a$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
var $0fe1f1400993ba8a$export$aa9d629c530f62a7 = /*#__PURE__*/ function(URIError1) {
    "use strict";
    (0, $h6w6E._)($0fe1f1400993ba8a$export$aa9d629c530f62a7, URIError1);
    function $0fe1f1400993ba8a$export$aa9d629c530f62a7(message, request, response) {
        (0, $7lhcp._)(this, $0fe1f1400993ba8a$export$aa9d629c530f62a7);
        var _this;
        _this = (0, $07dqX._)(this, $0fe1f1400993ba8a$export$aa9d629c530f62a7, [
            message
        ]), _this.request = request, _this.response = response;
        return _this;
    }
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
}((0, $1Qmny._)(URIError));
var $0fe1f1400993ba8a$export$b725a69477e4d33f = {
    Link: function(value) {
        return Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), function(param) {
            var _param = (0, $leE2g._)(param, 4), _ = _param[0], URI = _param[1], rel = _param[2], title = _param[3];
            return [
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ];
        }));
    }
};
var $0fe1f1400993ba8a$export$eea2c1c5e1a37e50 = function(raw) {
    return Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), function(param) {
        var _param = (0, $leE2g._)(param, 3), _ = _param[0], key = _param[1], value = _param[2];
        var _$0fe1f1400993ba8a$export$b725a69477e4d33f_key;
        key = key.replace(/(^[a-z]|-[a-z])/g, function(char) {
            return char.toUpperCase();
        });
        var _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1;
        return [
            key,
            (_$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 = (_$0fe1f1400993ba8a$export$b725a69477e4d33f_key = $0fe1f1400993ba8a$export$b725a69477e4d33f[key]) === null || _$0fe1f1400993ba8a$export$b725a69477e4d33f_key === void 0 ? void 0 : _$0fe1f1400993ba8a$export$b725a69477e4d33f_key.call($0fe1f1400993ba8a$export$b725a69477e4d33f, value)) !== null && _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 !== void 0 ? _$0fe1f1400993ba8a$export$b725a69477e4d33f_key1 : value
        ];
    }));
};
function $0fe1f1400993ba8a$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $6tqvJ.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return $22de11b45b0eeb97$export$b6a9369736b19f4d(raw, contentType);
    } catch (e) {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
function $0fe1f1400993ba8a$export$4f2a8c8c11a6373a(_param) {
    var tmp = _param.method, method = tmp === void 0 ? 'GET' : tmp, path = _param.path, tmp1 = _param.headers, headers = tmp1 === void 0 ? {} : tmp1, body = _param.body, signal = _param.signal, rest = (0, $8MJI4._)(_param, [
        "method",
        "path",
        "headers",
        "body",
        "signal"
    ]);
    var request = new XMLHttpRequest();
    var header = new Headers(headers);
    var bodyPromise = body instanceof globalThis.ReadableStream ? Array.fromAsync(body).then(function(parts) {
        return new Blob(parts);
    }) : Promise.resolve(body);
    var abort = function() {
        return request.abort();
    };
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abort);
    var response = new Promise(function(resolve, reject) {
        var _header_get;
        request.onreadystatechange = function() {
            var readyState = request.readyState, status = request.status, statusText = request.statusText, responseType = request.responseType;
            if (readyState !== 4 || !status && !(signal === null || signal === void 0 ? void 0 : signal.aborted)) return;
            resolve({
                status: status,
                statusText: statusText,
                headers: $0fe1f1400993ba8a$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: responseType && responseType !== 'text' ? request.response : request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        var _ref = (0, $leE2g._)(((_header_get = header.get('Accept')) === null || _header_get === void 0 ? void 0 : _header_get.split(',')) || [
            rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
        ], 1), MIMEType = _ref[0];
        if (MIMEType) request.overrideMimeType(MIMEType);
        request.open(method, path + '');
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $leE2g._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                request.setRequestHeader(key, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        Object.assign(request, rest);
        bodyPromise.then(function(body) {
            return request.send(body);
        });
    }).then(function(_param) {
        var body = _param.body, meta = (0, $8MJI4._)(_param, [
            "body"
        ]);
        signal === null || signal === void 0 ? void 0 : signal.throwIfAborted();
        var contentType = request.getResponseHeader('Content-Type') || '';
        if (typeof body === 'string' && !contentType.includes('text')) body = $0fe1f1400993ba8a$export$3b629cd0ff482602(body, contentType);
        return (0, $ctBui._)((0, $6GCxi._)({}, meta), {
            body: body
        });
    });
    response.finally(function() {
        return signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abort);
    });
    return {
        response: response,
        upload: $22de11b45b0eeb97$export$f8162fcba31fa547(request.upload),
        download: $22de11b45b0eeb97$export$f8162fcba31fa547(request)
    };
}
function $0fe1f1400993ba8a$export$bda27a3e49197b9(param) {
    var path = param.path, method = param.method, headers = param.headers, withCredentials = param.withCredentials, body = param.body, signal = param.signal, timeout = param.timeout, responseType = param.responseType;
    var signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === 'text' ? (0, $ctBui._)((0, $6GCxi._)({}, headers), {
        Accept: 'text/plain'
    }) : responseType === 'json' ? (0, $ctBui._)((0, $6GCxi._)({}, headers), {
        Accept: 'application/json'
    }) : responseType === 'document' ? (0, $ctBui._)((0, $6GCxi._)({}, headers), {
        Accept: 'text/html, application/xhtml+xml, application/xml'
    }) : responseType === 'arraybuffer' || responseType === 'blob' ? (0, $ctBui._)((0, $6GCxi._)({}, headers), {
        Accept: 'application/octet-stream'
    }) : headers;
    var isStream = body instanceof globalThis.ReadableStream;
    var upload;
    if (isStream) {
        var uploadProgress = new EventTarget();
        body = globalThis.ReadableStream['from']($22de11b45b0eeb97$export$cebfdbc318a33abe(body, +headers['Content-Length'], uploadProgress));
        upload = $22de11b45b0eeb97$export$f8162fcba31fa547(uploadProgress);
    }
    var downloadProgress = new EventTarget();
    var response = fetch(path + '', {
        method: method,
        headers: headers,
        credentials: withCredentials ? 'include' : 'omit',
        body: body,
        signal: signals[0] && AbortSignal.any(signals),
        // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
        duplex: isStream ? 'half' : undefined
    }).then(function(response) {
        return $0fe1f1400993ba8a$export$ba14d9a5a581e827(response, responseType, downloadProgress);
    });
    return {
        response: response,
        upload: upload,
        download: $22de11b45b0eeb97$export$f8162fcba31fa547(downloadProgress)
    };
}
function $0fe1f1400993ba8a$export$ba14d9a5a581e827(_0, _1, _2) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(param, responseType, downloadProgress) {
        var status, statusText, headers, body, stream, contentType, header, rBody, _tmp;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    status = param.status, statusText = param.statusText, headers = param.headers, body = param.body;
                    stream = globalThis.ReadableStream['from']($22de11b45b0eeb97$export$cebfdbc318a33abe(body, +headers.get('Content-Length'), downloadProgress));
                    contentType = headers.get('Content-Type') || '';
                    header = $0fe1f1400993ba8a$export$eea2c1c5e1a37e50((0, $fsSDT._)(headers).map(function(param) {
                        var _param = (0, $leE2g._)(param, 2), key = _param[0], value = _param[1];
                        return "".concat(key, ": ").concat(value);
                    }).join('\n'));
                    if (!(status === 204)) return [
                        3,
                        1
                    ];
                    _tmp = undefined;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        $0fe1f1400993ba8a$export$b7b86d31099674dc(stream, contentType, responseType)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    rBody = _tmp;
                    return [
                        2,
                        {
                            status: status,
                            statusText: statusText,
                            headers: header,
                            body: rBody
                        }
                    ];
            }
        });
    }).apply(this, arguments);
}
function $0fe1f1400993ba8a$export$b7b86d31099674dc(stream, contentType, responseType) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var blob, _, text;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = Blob.bind;
                    return [
                        4,
                        Array.fromAsync(stream)
                    ];
                case 1:
                    blob = new (_.apply(Blob, [
                        void 0,
                        _state.sent(),
                        {
                            type: contentType
                        }
                    ]));
                    if (responseType === 'blob') return [
                        2,
                        blob
                    ];
                    if (responseType === 'arraybuffer') return [
                        2,
                        blob.arrayBuffer()
                    ];
                    return [
                        4,
                        blob.text()
                    ];
                case 2:
                    text = _state.sent();
                    if (responseType === 'text') return [
                        2,
                        text
                    ];
                    return [
                        2,
                        $0fe1f1400993ba8a$export$3b629cd0ff482602(text, contentType)
                    ];
            }
        });
    })();
}
var $0fe1f1400993ba8a$export$b5fe3f66a567bec0 = typeof globalThis.XMLHttpRequest === 'function' ? $0fe1f1400993ba8a$export$4f2a8c8c11a6373a : $0fe1f1400993ba8a$export$bda27a3e49197b9;
var $cbd22d3323bef9ca$exports = {};
$parcel$export($cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
});
var _Array_prototype1 = Array.prototype, $cbd22d3323bef9ca$var$splice = _Array_prototype1.splice;
var $cbd22d3323bef9ca$export$45cf759b359d3d24 = /*#__PURE__*/ function($eef213ff4197108b$export$694e0d28c7ffc90c) {
    "use strict";
    (0, $h6w6E._)($cbd22d3323bef9ca$export$45cf759b359d3d24, $eef213ff4197108b$export$694e0d28c7ffc90c);
    function $cbd22d3323bef9ca$export$45cf759b359d3d24() {
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $7lhcp._)(this, $cbd22d3323bef9ca$export$45cf759b359d3d24);
        var _this;
        var _this1, _superprop_get_use = function() {
            return (0, $5LQ10._)(((0, $aVdP5._)(_this), (0, $2JFuQ._)($cbd22d3323bef9ca$export$45cf759b359d3d24.prototype)), "use", _this);
        };
        var tmp = _param.baseURI, baseURI = tmp === void 0 ? function() {
            var _globalThis_document;
            return (_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.baseURI;
        }() : tmp, tmp1 = _param.baseRequest, baseRequest = tmp1 === void 0 ? $0fe1f1400993ba8a$export$b5fe3f66a567bec0 : tmp1, options = (0, $8MJI4._)(_param, [
            "baseURI",
            "baseRequest"
        ]);
        _this = (0, $07dqX._)(this, $cbd22d3323bef9ca$export$45cf759b359d3d24), _this1 = _this, _this1.defaultWare = function(param, next) {
            var request = param.request, response = param.response;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var tmp, method, tmp1, headers, body, _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb, contentType, data;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tmp = request.method, method = tmp === void 0 ? 'GET' : tmp, tmp1 = request.headers, headers = tmp1 === void 0 ? {} : tmp1, body = request.body;
                            if (method in $0fe1f1400993ba8a$export$4125cfe7e08e2040 && body && (typeof body === "undefined" ? "undefined" : (0, $5f0Cq._)(body)) === 'object') {
                                _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb = $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(body, headers['Content-Type']), contentType = _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb.contentType, data = _$22de11b45b0eeb97$export$dfdc1655ccc5b9cb.data;
                                if (contentType) headers['Content-Type'] = contentType;
                                request.body = data;
                            }
                            return [
                                4,
                                next()
                            ];
                        case 1:
                            _state.sent();
                            if (response.status > 299) throw new $0fe1f1400993ba8a$export$aa9d629c530f62a7(response.statusText, request, response);
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        _this1.baseURI = baseURI;
        _this1.baseRequest = baseRequest;
        _this1.options = options;
        _superprop_get_use().call(_this1, _this1.defaultWare);
        _superprop_get_use().call(_this1, function(param) {
            var data = param.request, response = param.response;
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var _, _tmp;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            data.path = new URL(data.path + '', _this1.baseURI) + '';
                            _ = Object.assign;
                            _tmp = [
                                response
                            ];
                            return [
                                4,
                                _this1.baseRequest((0, $6GCxi._)({}, options, data)).response
                            ];
                        case 1:
                            _.apply(Object, _tmp.concat([
                                _state.sent()
                            ]));
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        return _this;
    }
    (0, $8BtP9._)($cbd22d3323bef9ca$export$45cf759b359d3d24, [
        {
            key: "use",
            value: function use() {
                for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
                    middlewares[_key] = arguments[_key];
                }
                var _$cbd22d3323bef9ca$var$splice;
                (_$cbd22d3323bef9ca$var$splice = $cbd22d3323bef9ca$var$splice).call.apply(_$cbd22d3323bef9ca$var$splice, [
                    this,
                    -2,
                    0
                ].concat((0, $fsSDT._)(middlewares)));
                return this;
            }
        },
        {
            key: "request",
            value: function request(data) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var context;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                context = {
                                    request: (0, $ctBui._)((0, $6GCxi._)({}, data), {
                                        headers: (0, $6GCxi._)({}, data.headers)
                                    }),
                                    response: {}
                                };
                                return [
                                    4,
                                    this.execute(context)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    context.response
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "head",
            value: function head(path, headers, options) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _ref, data;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.request((0, $6GCxi._)({
                                        method: 'HEAD',
                                        path: path,
                                        headers: headers
                                    }, options))
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.headers;
                                return [
                                    2,
                                    data
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get(path, headers, options) {
                return this.request((0, $6GCxi._)({
                    method: 'GET',
                    path: path,
                    headers: headers
                }, options));
            }
        },
        {
            key: "post",
            value: function post(path, body, headers, options) {
                return this.request((0, $6GCxi._)({
                    method: 'POST',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "put",
            value: function put(path, body, headers, options) {
                return this.request((0, $6GCxi._)({
                    method: 'PUT',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "patch",
            value: function patch(path, body, headers, options) {
                return this.request((0, $6GCxi._)({
                    method: 'PATCH',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "delete",
            value: function _delete(path, body, headers, options) {
                return this.request((0, $6GCxi._)({
                    method: 'DELETE',
                    path: path,
                    headers: headers,
                    body: body
                }, options));
            }
        },
        {
            key: "download",
            value: function download(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function(path) {
                    var _param, headers, tmp, chunkSize, tmp1, _ref, tmp2, start, tmp3, end, options, total, _ref1, length, error, i, j, _ref2, status, _ref_headers, range, body, totalBytes, loaded;
                    var _arguments = arguments;
                    function setEndAsHeader(length) {
                        total = length;
                        if (end === Infinity) end = total;
                    }
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _param = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                                headers = _param.headers, tmp = _param.chunkSize, chunkSize = tmp === void 0 ? Math.pow(1024, 2) : tmp, tmp1 = _param.range, _ref = (0, $leE2g._)(tmp1 === void 0 ? [] : tmp1, 2), tmp2 = _ref[0], start = tmp2 === void 0 ? 0 : tmp2, tmp3 = _ref[1], end = tmp3 === void 0 ? Infinity : tmp3, options = (0, $8MJI4._)(_param, [
                                    "headers",
                                    "chunkSize",
                                    "range"
                                ]);
                                total = 0;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $hW8ac._)(this.head(path, headers, options))
                                ];
                            case 2:
                                _ref1 = _state.sent(), length = _ref1['Content-Length'];
                                setEndAsHeader(+length);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                console.error(error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                i = start, j = i - 1 + chunkSize;
                                _state.label = 5;
                            case 5:
                                if (!(i < end)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    (0, $hW8ac._)(this.get(path, (0, $ctBui._)((0, $6GCxi._)({}, headers), {
                                        Range: "bytes=".concat(i, "-").concat(j)
                                    }), options))
                                ];
                            case 6:
                                _ref2 = _state.sent(), status = _ref2.status, _ref_headers = _ref2.headers, range = _ref_headers['Content-Range'], body = _ref2.body;
                                totalBytes = +(range === null || range === void 0 ? void 0 : range.split('/').pop());
                                if (totalBytes) setEndAsHeader(totalBytes);
                                if (!(status !== 206)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: total,
                                        percent: 100,
                                        buffer: body
                                    }
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    11
                                ];
                            case 8:
                                loaded = i + body.byteLength;
                                return [
                                    4,
                                    {
                                        total: total,
                                        loaded: loaded,
                                        percent: +(loaded / total * 100).toFixed(2),
                                        buffer: body
                                    }
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                i = j + 1, j += chunkSize;
                                return [
                                    3,
                                    5
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
}($eef213ff4197108b$export$694e0d28c7ffc90c);

});
parcelRegister("aVdP5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7f39f33a237f190e$export$71511d61b312f219; });
function $7f39f33a237f190e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("fPf27", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b85747b4d1133a26$export$71511d61b312f219; });
function $b85747b4d1133a26$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $b85747b4d1133a26$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $b85747b4d1133a26$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $b85747b4d1133a26$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $b85747b4d1133a26$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $b85747b4d1133a26$var$AsyncFromSyncIterator(s);
}

});

parcelRegister("hVBqc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d0d4c9b34866bef2$export$71511d61b312f219; });
function $d0d4c9b34866bef2$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $d0d4c9b34866bef2$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d0d4c9b34866bef2$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d0d4c9b34866bef2$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("hW8ac", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d0ee2f9298e52e46$export$71511d61b312f219; });

var $l5Klr = parcelRequire("l5Klr");
function $d0ee2f9298e52e46$export$71511d61b312f219(value) {
    return new (0, $l5Klr._)(value, /* kind: await */ 0);
}

});
parcelRegister("l5Klr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f5ae03b93a1a6621$export$71511d61b312f219; });
function $f5ae03b93a1a6621$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}

});


parcelRegister("07dqX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $000599159e420bd5$export$71511d61b312f219; });

var $2JFuQ = parcelRequire("2JFuQ");

var $3rHyF = parcelRequire("3rHyF");

var $jws2M = parcelRequire("jws2M");
function $000599159e420bd5$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $2JFuQ._)(derived);
    return (0, $jws2M._)(_this, (0, $3rHyF._)() ? Reflect.construct(derived, args || [], (0, $2JFuQ._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("2JFuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1fdff91a59b14204$export$71511d61b312f219; });
function $1fdff91a59b14204$export$71511d61b312f219(o) {
    $1fdff91a59b14204$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1fdff91a59b14204$export$71511d61b312f219(o);
}

});

parcelRegister("3rHyF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2825ae6e2aaf5750$export$71511d61b312f219; });
function $2825ae6e2aaf5750$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($2825ae6e2aaf5750$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("jws2M", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e366c263435e72fe$export$71511d61b312f219; });

var $aVdP5 = parcelRequire("aVdP5");

var $5f0Cq = parcelRequire("5f0Cq");
function $e366c263435e72fe$export$71511d61b312f219(self, call) {
    if (call && ((0, $5f0Cq._)(call) === "object" || typeof call === "function")) return call;
    return (0, $aVdP5._)(self);
}

});
parcelRegister("5f0Cq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d0ed551850ebe7a$export$71511d61b312f219; });
function $3d0ed551850ebe7a$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("7lhcp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5587d5f2091fd611$export$71511d61b312f219; });
function $5587d5f2091fd611$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("8BtP9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6438e9d7e1b4d22e$export$71511d61b312f219; });
function $6438e9d7e1b4d22e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6438e9d7e1b4d22e$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $6438e9d7e1b4d22e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6438e9d7e1b4d22e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("5LQ10", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4339b0acc00eca7a$export$71511d61b312f219; });

var $fQo6v = parcelRequire("fQo6v");
function $4339b0acc00eca7a$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $4339b0acc00eca7a$export$71511d61b312f219 = Reflect.get;
    else $4339b0acc00eca7a$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $fQo6v._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $4339b0acc00eca7a$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("fQo6v", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b88e68dc0ea3dff5$export$71511d61b312f219; });

var $2JFuQ = parcelRequire("2JFuQ");
function $b88e68dc0ea3dff5$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $2JFuQ._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("h6w6E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c73be6d6c22b7a3d$export$71511d61b312f219; });

var $7XHjm = parcelRequire("7XHjm");
function $c73be6d6c22b7a3d$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $7XHjm._)(subClass, superClass);
}

});
parcelRegister("7XHjm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5cbfa3cff2025fe5$export$71511d61b312f219; });
function $5cbfa3cff2025fe5$export$71511d61b312f219(o, p) {
    $5cbfa3cff2025fe5$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5cbfa3cff2025fe5$export$71511d61b312f219(o, p);
}

});


parcelRegister("6GCxi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4de48ecbea56af55$export$71511d61b312f219; });

var $5RfYb = parcelRequire("5RfYb");
function $4de48ecbea56af55$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5RfYb._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5RfYb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $443e4a398575d441$export$71511d61b312f219; });
function $443e4a398575d441$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("ctBui", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $915545b64f09c6f7$export$71511d61b312f219; });
function $915545b64f09c6f7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $915545b64f09c6f7$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $915545b64f09c6f7$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("8MJI4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $665643755561aa0e$export$71511d61b312f219; });

var $jIu9O = parcelRequire("jIu9O");
function $665643755561aa0e$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $jIu9O._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("jIu9O", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e5a984f74ca16fcc$export$71511d61b312f219; });
function $e5a984f74ca16fcc$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("leE2g", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f759f5fdd514f495$export$71511d61b312f219; });

var $1RNxS = parcelRequire("1RNxS");

var $50ydg = parcelRequire("50ydg");

var $lKa1b = parcelRequire("lKa1b");

var $4mlSp = parcelRequire("4mlSp");
function $f759f5fdd514f495$export$71511d61b312f219(arr, i) {
    return (0, $1RNxS._)(arr) || (0, $50ydg._)(arr, i) || (0, $4mlSp._)(arr, i) || (0, $lKa1b._)();
}

});
parcelRegister("1RNxS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15c12c57438e2592$export$71511d61b312f219; });
function $15c12c57438e2592$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("50ydg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3a577dd26f87ec62$export$71511d61b312f219; });
function $3a577dd26f87ec62$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("lKa1b", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fd45aa3fbb928173$export$71511d61b312f219; });
function $fd45aa3fbb928173$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("4mlSp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $32ca2fb75eb1f3e5$export$71511d61b312f219; });

var $6UV3s = parcelRequire("6UV3s");
function $32ca2fb75eb1f3e5$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6UV3s._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6UV3s._)(o, minLen);
}

});
parcelRegister("6UV3s", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $50943af1cf091f13$export$71511d61b312f219; });
function $50943af1cf091f13$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("fsSDT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b423db63f3706eb1$export$71511d61b312f219; });

var $59T82 = parcelRequire("59T82");

var $gS6yU = parcelRequire("gS6yU");

var $j4inp = parcelRequire("j4inp");

var $4mlSp = parcelRequire("4mlSp");
function $b423db63f3706eb1$export$71511d61b312f219(arr) {
    return (0, $59T82._)(arr) || (0, $gS6yU._)(arr) || (0, $4mlSp._)(arr) || (0, $j4inp._)();
}

});
parcelRegister("59T82", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3c188e6ae037512d$export$71511d61b312f219; });

var $6UV3s = parcelRequire("6UV3s");
function $3c188e6ae037512d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $6UV3s._)(arr);
}

});

parcelRegister("gS6yU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c486c791c94f46e0$export$71511d61b312f219; });
function $c486c791c94f46e0$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("j4inp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de1ca53a431eaba2$export$71511d61b312f219; });
function $de1ca53a431eaba2$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2wBSb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1d6bf2b8e33a15bf$export$71511d61b312f219; });

var $5M5I2 = parcelRequire("5M5I2");
function $1d6bf2b8e33a15bf$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $5M5I2._)(fn.apply(this, arguments));
    };
}

});
parcelRegister("5M5I2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4345dd2cb4d4f841$export$71511d61b312f219; });

var $l5Klr = parcelRequire("l5Klr");
function $4345dd2cb4d4f841$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $l5Klr._);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$4345dd2cb4d4f841$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$4345dd2cb4d4f841$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$4345dd2cb4d4f841$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$4345dd2cb4d4f841$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});


parcelRegister("1Qmny", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $157c01c435872767$export$71511d61b312f219; });

var $5LayG = parcelRequire("5LayG");

var $2JFuQ = parcelRequire("2JFuQ");

var $b3wDQ = parcelRequire("b3wDQ");

var $7XHjm = parcelRequire("7XHjm");
function $157c01c435872767$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $157c01c435872767$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $b3wDQ._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $5LayG._)(Class, arguments, (0, $2JFuQ._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $7XHjm._)(Wrapper, Class);
    };
    return $157c01c435872767$export$71511d61b312f219(Class);
}

});
parcelRegister("5LayG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $431988377b851385$export$71511d61b312f219; });

var $3rHyF = parcelRequire("3rHyF");

var $7XHjm = parcelRequire("7XHjm");
function $431988377b851385$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $3rHyF._)()) $431988377b851385$export$71511d61b312f219 = Reflect.construct;
    else $431988377b851385$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $7XHjm._)(instance, Class.prototype);
        return instance;
    };
    return $431988377b851385$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("b3wDQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $80c94b7b1e7eec15$export$71511d61b312f219; });
function $80c94b7b1e7eec15$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("Csf8W", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $6fc8008516332bcb$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $6fc8008516332bcb$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $5f0Cq = parcelRequire("5f0Cq");
var $6fc8008516332bcb$var$extendStatics = function extendStatics1(d, b) {
    $6fc8008516332bcb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6fc8008516332bcb$var$extendStatics(d, b);
};
function $6fc8008516332bcb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6fc8008516332bcb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6fc8008516332bcb$export$18ce0697a983be9b = function __assign1() {
    $6fc8008516332bcb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6fc8008516332bcb$export$18ce0697a983be9b.apply(this, arguments);
};
function $6fc8008516332bcb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6fc8008516332bcb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5f0Cq._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6fc8008516332bcb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6fc8008516332bcb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6fc8008516332bcb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6fc8008516332bcb$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $5f0Cq._)(x)) === "symbol" ? x : "".concat(x);
}
function $6fc8008516332bcb$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6fc8008516332bcb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5f0Cq._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6fc8008516332bcb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6fc8008516332bcb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6fc8008516332bcb$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6fc8008516332bcb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6fc8008516332bcb$export$45d3717a4c69092e(o, m, p);
}
function $6fc8008516332bcb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6fc8008516332bcb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6fc8008516332bcb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6fc8008516332bcb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6fc8008516332bcb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6fc8008516332bcb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6fc8008516332bcb$export$10c90e4f7922046c(v) {
    return this instanceof $6fc8008516332bcb$export$10c90e4f7922046c ? (this.v = v, this) : new $6fc8008516332bcb$export$10c90e4f7922046c(v);
}
function $6fc8008516332bcb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6fc8008516332bcb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6fc8008516332bcb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6fc8008516332bcb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6fc8008516332bcb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6fc8008516332bcb$export$19a8beecd37a4c45 === "function" ? $6fc8008516332bcb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6fc8008516332bcb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6fc8008516332bcb$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $6fc8008516332bcb$var$ownKeys = function ownKeys1(o) {
    $6fc8008516332bcb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $6fc8008516332bcb$var$ownKeys(o);
};
function $6fc8008516332bcb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $6fc8008516332bcb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $6fc8008516332bcb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $6fc8008516332bcb$var$__setModuleDefault(result, mod);
    return result;
}
function $6fc8008516332bcb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6fc8008516332bcb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6fc8008516332bcb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6fc8008516332bcb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $5f0Cq._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $6fc8008516332bcb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $6fc8008516332bcb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $6fc8008516332bcb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $6fc8008516332bcb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $6fc8008516332bcb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $6fc8008516332bcb$export$2e2bcd8739ae039 = {
    __extends: $6fc8008516332bcb$export$a8ba968b8961cb8a,
    __assign: $6fc8008516332bcb$export$18ce0697a983be9b,
    __rest: $6fc8008516332bcb$export$3c9a16f847548506,
    __decorate: $6fc8008516332bcb$export$29e00dfd3077644b,
    __param: $6fc8008516332bcb$export$d5ad3fd78186038f,
    __esDecorate: $6fc8008516332bcb$export$3a84e1ae4e97e9b0,
    __runInitializers: $6fc8008516332bcb$export$d831c04e792af3d,
    __propKey: $6fc8008516332bcb$export$6a2a36740a146cb8,
    __setFunctionName: $6fc8008516332bcb$export$d1a06452d3489bc7,
    __metadata: $6fc8008516332bcb$export$f1db080c865becb9,
    __awaiter: $6fc8008516332bcb$export$1050f835b63b671e,
    __generator: $6fc8008516332bcb$export$67ebef60e6f28a6,
    __createBinding: $6fc8008516332bcb$export$45d3717a4c69092e,
    __exportStar: $6fc8008516332bcb$export$f33643c0debef087,
    __values: $6fc8008516332bcb$export$19a8beecd37a4c45,
    __read: $6fc8008516332bcb$export$8d051b38c9118094,
    __spread: $6fc8008516332bcb$export$afc72e2116322959,
    __spreadArrays: $6fc8008516332bcb$export$6388937ca91ccae8,
    __spreadArray: $6fc8008516332bcb$export$1216008129fb82ed,
    __await: $6fc8008516332bcb$export$10c90e4f7922046c,
    __asyncGenerator: $6fc8008516332bcb$export$e427f37a30a4de9b,
    __asyncDelegator: $6fc8008516332bcb$export$bbd80228419bb833,
    __asyncValues: $6fc8008516332bcb$export$e3b29a3d6162315f,
    __makeTemplateObject: $6fc8008516332bcb$export$4fb47efe1390b86f,
    __importStar: $6fc8008516332bcb$export$c21735bcef00d192,
    __importDefault: $6fc8008516332bcb$export$da59b14a69baef04,
    __classPrivateFieldGet: $6fc8008516332bcb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $6fc8008516332bcb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $6fc8008516332bcb$export$81fdc39f203e4e04,
    __addDisposableResource: $6fc8008516332bcb$export$88ac25d8e944e405,
    __disposeResources: $6fc8008516332bcb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $6fc8008516332bcb$export$889dfb5d17574b0b
};

});

parcelRegister("6tqvJ", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $4b6a03fb021648ad$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "proxyPrototype", function () { return $4b6a03fb021648ad$export$2a489b3f92f4996a; });
$parcel$export(module.exports, "toHyphenCase", function () { return $4b6a03fb021648ad$export$3f34ca2fef821bbd; });
$parcel$export(module.exports, "toCamelCase", function () { return $4b6a03fb021648ad$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "uniqueID", function () { return $4b6a03fb021648ad$export$89912e019eef22aa; });
$parcel$export(module.exports, "likeArray", function () { return $4b6a03fb021648ad$export$b5a4d6f439a5044d; });
$parcel$export(module.exports, "isTypedArray", function () { return $4b6a03fb021648ad$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "makeArray", function () { return $4b6a03fb021648ad$export$7b85fd78dd236198; });
$parcel$export(module.exports, "splitArray", function () { return $4b6a03fb021648ad$export$697c3df919c0e61a; });
$parcel$export(module.exports, "countBy", function () { return $4b6a03fb021648ad$export$1d012a0dff3dab06; });
$parcel$export(module.exports, "createAsyncIterator", function () { return $4b6a03fb021648ad$export$86c18c6347f4a8c4; });
$parcel$export(module.exports, "ByteSize", function () { return $4b6a03fb021648ad$export$271f7c16f175f804; });
$parcel$export(module.exports, "sum", function () { return $4b6a03fb021648ad$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "Second", function () { return $4b6a03fb021648ad$export$c489aa6f7fd82b1a; });
$parcel$export(module.exports, "Day", function () { return $4b6a03fb021648ad$export$7a9a31a911eb9a20; });
$parcel$export(module.exports, "Week", function () { return $4b6a03fb021648ad$export$fca4f8121099df57; });
$parcel$export(module.exports, "diffTime", function () { return $4b6a03fb021648ad$export$506c8e8f8c8edda; });
$parcel$export(module.exports, "formatDate", function () { return $4b6a03fb021648ad$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "changeMonth", function () { return $4b6a03fb021648ad$export$62ad822b3a5fd9a0; });
$parcel$export(module.exports, "parseJSON", function () { return $4b6a03fb021648ad$export$27924e57e9afff7f; });
$parcel$export(module.exports, "parseURLData", function () { return $4b6a03fb021648ad$export$eb9b2aadbe449a20; });
$parcel$export(module.exports, "buildURLData", function () { return $4b6a03fb021648ad$export$13397a83aa5915d6; });
$parcel$export(module.exports, "blobOf", function () { return $4b6a03fb021648ad$export$fd89523fba250fa4; });
$parcel$export(module.exports, "parseCookie", function () { return $4b6a03fb021648ad$export$d0eaf3e94be578f6; });
$parcel$export(module.exports, "setCookie", function () { return $4b6a03fb021648ad$export$110700823644f4a6; });
$parcel$export(module.exports, "parseDOM", function () { return $4b6a03fb021648ad$export$d66b332881d9723f; });
$parcel$export(module.exports, "stringifyDOM", function () { return $4b6a03fb021648ad$export$b0709844452f8b6b; });
$parcel$export(module.exports, "walkDOM", function () { return $4b6a03fb021648ad$export$5118471ee5d5453b; });
$parcel$export(module.exports, "getVisibleText", function () { return $4b6a03fb021648ad$export$be4650432daa84fd; });
$parcel$export(module.exports, "insertToCursor", function () { return $4b6a03fb021648ad$export$28d9d24a8cd0ffc2; });
$parcel$export(module.exports, "scrollTo", function () { return $4b6a03fb021648ad$export$3f99968195accfaf; });
$parcel$export(module.exports, "formToJSON", function () { return $4b6a03fb021648ad$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "sleep", function () { return $4b6a03fb021648ad$export$e772c8ff12451969; });
$parcel$export(module.exports, "serviceWorkerUpdate", function () { return $4b6a03fb021648ad$export$d635d04af3887bbe; });

var $f8MCl = parcelRequire("f8MCl");

var $fPf27 = parcelRequire("fPf27");

var $hVBqc = parcelRequire("hVBqc");

var $hW8ac = parcelRequire("hW8ac");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");

var $2wBSb = parcelRequire("2wBSb");

var $Csf8W = parcelRequire("Csf8W");

var $Csf8W = parcelRequire("Csf8W");
var $4b6a03fb021648ad$var$_String;
function $4b6a03fb021648ad$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $4b6a03fb021648ad$var$$9b05bcda60cc529c$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $4b6a03fb021648ad$export$61cc6ed0f143570b;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $4b6a03fb021648ad$export$dd1bc94b04021eeb;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $4b6a03fb021648ad$export$a09f818797e212c4;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $4b6a03fb021648ad$export$170f4e08cad8229d;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $4b6a03fb021648ad$export$2a489b3f92f4996a;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $4b6a03fb021648ad$export$67a6ce548ae77071;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $4b6a03fb021648ad$export$a48f0734ac7c2329;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $4b6a03fb021648ad$export$3f34ca2fef821bbd;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $4b6a03fb021648ad$export$86f54f62aa7a7514;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $4b6a03fb021648ad$export$89912e019eef22aa;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $4b6a03fb021648ad$export$8fb536984ec8b4d7;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $4b6a03fb021648ad$export$94fdf11bafc8de6b;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $4b6a03fb021648ad$export$1c8ba402144543e5;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $4b6a03fb021648ad$export$2ddabb89308e1a22;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $4b6a03fb021648ad$export$14527669107aa301;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $4b6a03fb021648ad$export$3f063810d7bf01bd;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $4b6a03fb021648ad$export$b5a4d6f439a5044d;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $4b6a03fb021648ad$export$b119cc7e1840e59c;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $4b6a03fb021648ad$export$7b85fd78dd236198;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $4b6a03fb021648ad$export$697c3df919c0e61a;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $4b6a03fb021648ad$export$1d012a0dff3dab06;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $4b6a03fb021648ad$export$e6b5ff3168b5942b;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $4b6a03fb021648ad$export$9cd59f9826255e47;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $4b6a03fb021648ad$export$fbc9cd6af26fa64f;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $4b6a03fb021648ad$export$69a3209f1a06c04d;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $4b6a03fb021648ad$export$86c18c6347f4a8c4;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $4b6a03fb021648ad$export$dce9414bed0662c;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $4b6a03fb021648ad$export$271f7c16f175f804;
});
var $4b6a03fb021648ad$var$$6a9944941b4c1893$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "sum", function() {
    return $4b6a03fb021648ad$export$8a63f25cc62965f1;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $4b6a03fb021648ad$export$e1f36757ecda301d;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $4b6a03fb021648ad$export$8e694e1eafd55acb;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $4b6a03fb021648ad$export$57d7c52a66287430;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $4b6a03fb021648ad$export$2b4693832ca3ce16;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $4b6a03fb021648ad$export$5b784e078da1ce6;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $4b6a03fb021648ad$export$17ec9c9f4f23588c;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $4b6a03fb021648ad$export$595dbf49c602a1f;
});
function $4b6a03fb021648ad$export$8a63f25cc62965f1() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return data.reduce(function(sum, item) {
        return sum + item;
    }, 0);
}
function $4b6a03fb021648ad$export$e1f36757ecda301d() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return $4b6a03fb021648ad$export$8a63f25cc62965f1.apply(void 0, (0, $fsSDT._)(data)) / data.length;
}
function $4b6a03fb021648ad$export$8e694e1eafd55acb(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var average = $4b6a03fb021648ad$export$e1f36757ecda301d.apply(void 0, (0, $fsSDT._)(data));
    var summary = $4b6a03fb021648ad$export$8a63f25cc62965f1.apply(void 0, (0, $fsSDT._)(data.map(function(item) {
        return Math.pow(item - average, 2);
    })));
    return summary / (data.length - (sample ? 1 : 0));
}
function $4b6a03fb021648ad$export$57d7c52a66287430(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Math.sqrt($4b6a03fb021648ad$export$8e694e1eafd55acb(data, sample));
}
function $4b6a03fb021648ad$export$2b4693832ca3ce16() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return Math.sqrt($4b6a03fb021648ad$export$8a63f25cc62965f1.apply(void 0, (0, $fsSDT._)(data.map(function(item) {
        return Math.pow(item, 2);
    }))));
}
function $4b6a03fb021648ad$export$5b784e078da1ce6(raw, length) {
    var text = raw.toFixed(length + 2);
    var offset = text.indexOf('.') + length + 1;
    var cut = function(text) {
        return text.slice(0, offset - (length ? 0 : 1));
    };
    if (!+text.slice(offset)) return cut(text);
    var result = cut((+cut(text) + Math.pow(10, -length)).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $4b6a03fb021648ad$export$17ec9c9f4f23588c(raw) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var text = raw.toFixed(length + 2);
    var floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? "".concat(text, ".").concat('0'.repeat(length)) : text;
    var offset = floatOffset + length + 1;
    var before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    var carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $4b6a03fb021648ad$export$5b784e078da1ce6(raw, length);
    var result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
var $4b6a03fb021648ad$export$595dbf49c602a1f = /*#__PURE__*/ function() {
    "use strict";
    function $6a9944941b4c1893$export$595dbf49c602a1f(value) {
        (0, $7lhcp._)(this, $6a9944941b4c1893$export$595dbf49c602a1f);
        this.value = value;
    }
    (0, $8BtP9._)($6a9944941b4c1893$export$595dbf49c602a1f, [
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        },
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                var _this = this, units = _this.units, value = _this.value;
                var _ref = (0, $fsSDT._)(units).reverse().find(function(param) {
                    var base = param.base;
                    return Math.abs(value) >= base;
                }) || units[0], base = _ref.base, name = _ref.name;
                return "".concat((value / base).toFixed(fractionDigits), " ").concat(name);
            }
        }
    ], [
        {
            key: "distanceOf",
            value: function distanceOf(a, b) {
                return Reflect.construct(this, [
                    a - b
                ]);
            }
        }
    ]);
    return $6a9944941b4c1893$export$595dbf49c602a1f;
}();
var $4b6a03fb021648ad$export$61cc6ed0f143570b = function(value) {
    return !(value != null) || Number.isNaN(value);
};
var $4b6a03fb021648ad$export$dd1bc94b04021eeb = function(value) {
    return $4b6a03fb021648ad$export$61cc6ed0f143570b(value) || ((typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) === 'object' ? !Object.keys(value).length : value === '');
};
var $4b6a03fb021648ad$export$a09f818797e212c4 = function(data) {
    return Object.prototype.toString.call(data).slice(8, -1);
};
var $4b6a03fb021648ad$export$170f4e08cad8229d = function(Sub, Super) {
    return Sub.prototype instanceof Super;
};
function $4b6a03fb021648ad$export$2a489b3f92f4996a(target, dataStore, setter) {
    var prototype = Object.getPrototypeOf(target);
    var prototypeProxy = new Proxy(prototype, {
        set: function(_, key, value, receiver) {
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter === null || setter === void 0 ? void 0 : setter(key, value);
            return true;
        },
        get: function(prototype, key, receiver) {
            return key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver);
        }
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
var $4b6a03fb021648ad$export$67a6ce548ae77071 = function(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
};
var $4b6a03fb021648ad$export$a48f0734ac7c2329 = function(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
};
var $4b6a03fb021648ad$export$3f34ca2fef821bbd = function(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return "".concat(offset ? '-' : '').concat((match[1] || match[0]).toLowerCase());
    });
};
var $4b6a03fb021648ad$export$86f54f62aa7a7514 = function(raw) {
    var large = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase();
    });
};
var $4b6a03fb021648ad$export$89912e019eef22aa = function() {
    return (Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
};
var $4b6a03fb021648ad$export$8fb536984ec8b4d7 = function(input) {
    return btoa(($4b6a03fb021648ad$var$_String = String).fromCharCode.apply($4b6a03fb021648ad$var$_String, (0, $fsSDT._)(new TextEncoder().encode(input))));
};
var $4b6a03fb021648ad$export$94fdf11bafc8de6b = function(input) {
    return new TextDecoder().decode(Uint8Array.from(atob(input), function(char) {
        return char.charCodeAt(0);
    }));
};
var $4b6a03fb021648ad$export$1c8ba402144543e5 = function(values, keys) {
    return Object.fromEntries(values.map(function(value, index) {
        return [
            keys[index],
            value
        ];
    }));
};
var $4b6a03fb021648ad$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $4b6a03fb021648ad$export$14527669107aa301(oldList, newList) {
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oldList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item] = -1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = newList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var _map, _item;
            (_map = map)[_item = item1] || (_map[_item] = 0);
            map[item1] += 1;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        map: map,
        group: $4b6a03fb021648ad$export$3f063810d7bf01bd(Object.entries(map), function(param) {
            var _param = (0, $leE2g._)(param, 2), key = _param[0], status = _param[1];
            return status;
        })
    };
}
function $4b6a03fb021648ad$export$b5a4d6f439a5044d(data) {
    if ($4b6a03fb021648ad$export$61cc6ed0f143570b(data)) return false;
    var length = data.length;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
var $4b6a03fb021648ad$export$b119cc7e1840e59c = function(data) {
    return data instanceof Object.getPrototypeOf(Int8Array);
};
function $4b6a03fb021648ad$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($4b6a03fb021648ad$export$61cc6ed0f143570b(data)) return [];
    if ($4b6a03fb021648ad$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
var $4b6a03fb021648ad$export$697c3df919c0e61a = function(array, unitLength) {
    return array.reduce(function(grid, item, index) {
        var _grid, _ref;
        ((_grid = grid)[_ref = ~~(index / unitLength)] || (_grid[_ref] = []))[index % unitLength] = item;
        return grid;
    }, []);
};
function $4b6a03fb021648ad$export$3f063810d7bf01bd(list, iteratee) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
            if (!(keys instanceof Array)) keys = [
                keys
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = new Set(keys.filter(function(key) {
                    return key != null;
                }))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    (data[key] = data[key] || []).push(item);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
function $4b6a03fb021648ad$export$1d012a0dff3dab06(list, iteratee) {
    var group = $4b6a03fb021648ad$export$3f063810d7bf01bd(list, iteratee);
    var sortedList = Object.entries(group).map(function(param) {
        var _param = (0, $leE2g._)(param, 2), key = _param[0], _param_ = _param[1], length = _param_.length;
        return [
            key,
            length
        ];
    });
    return Object.fromEntries(sortedList);
}
function $4b6a03fb021648ad$export$e6b5ff3168b5942b(list, subKey, handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (handler(item)) return [
                item
            ];
            if (item[subKey] instanceof Array) {
                var result = $4b6a03fb021648ad$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
                if (result.length) return [
                    item
                ].concat((0, $fsSDT._)(result));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function $4b6a03fb021648ad$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch (e) {
        return JSON.parse(JSON.stringify(data));
    }
}
function $4b6a03fb021648ad$export$fbc9cd6af26fa64f(list) {
    var idKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'id', parentIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'parentId', childrenKey = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'children';
    list = $4b6a03fb021648ad$export$9cd59f9826255e47(list);
    var map = {};
    var roots = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item[idKey]] = item;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = list[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var parent = map[item1[parentIdKey]];
            if (!parent) roots.push(item1);
            else {
                var _parent, _childrenKey;
                (_parent = parent)[_childrenKey = childrenKey] || (_parent[_childrenKey] = []);
                parent[childrenKey].push(item1);
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $4b6a03fb021648ad$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function() {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
            data[_key] = arguments[_key];
        }
        var _executor;
        if (cacheData != null) return cacheData;
        console.trace("[Cache] execute: ".concat(title));
        cacheData = (_executor = executor).call.apply(_executor, [
            this,
            function() {
                return cacheData = undefined;
            }
        ].concat((0, $fsSDT._)(data)));
        Promise.resolve(cacheData).then(function(data) {
            return console.log("[Cache] refreshed: ".concat(title, " => ").concat(data));
        }, function(error) {
            return console.error("[Cache] failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
        });
        return cacheData;
    };
}
function $4b6a03fb021648ad$export$86c18c6347f4a8c4(executor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function() {
        var _Promise_withResolvers, promise, resolve, reject, doneSymbol, done, disposer, value, ref;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Promise_withResolvers = Promise.withResolvers(), promise = _Promise_withResolvers.promise, resolve = _Promise_withResolvers.resolve, reject = _Promise_withResolvers.reject;
                    doneSymbol = Symbol('done'), done = Promise.withResolvers();
                    disposer = executor({
                        next: function(value) {
                            return resolve(value);
                        },
                        error: function(error) {
                            reject(error);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        },
                        complete: function() {
                            done.resolve(doneSymbol);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        }
                    });
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $hW8ac._)(Promise.race([
                            promise,
                            done.promise
                        ]))
                    ];
                case 2:
                    value = _state.sent();
                    if (value === doneSymbol) return [
                        2
                    ];
                    return [
                        4,
                        value
                    ];
                case 3:
                    _state.sent();
                    ref = Promise.withResolvers(), promise = ref.promise, resolve = ref.resolve, reject = ref.reject, ref;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $4b6a03fb021648ad$export$dce9414bed0662c() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function() {
        var _loop, iterators;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var dones, i, iterator, _ref, done, value;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dones = [];
                                    i = 0, iterator = void 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(iterator = iterators[i])) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0, $hW8ac._)(iterator.next())
                                    ];
                                case 2:
                                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                    if (!!done) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        value
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    dones.push(i);
                                    _state.label = 5;
                                case 5:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    iterators = iterators.filter(function(_, i) {
                                        return !dones.includes(i);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    iterators = sources.map(function(item) {
                        return item();
                    });
                    _state.label = 1;
                case 1:
                    if (!iterators[0]) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $Csf8W.__values)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $4b6a03fb021648ad$export$271f7c16f175f804 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $h6w6E._)($9b05bcda60cc529c$export$271f7c16f175f804, $6a9944941b4c1893$export$595dbf49c602a1f);
    function $9b05bcda60cc529c$export$271f7c16f175f804() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $9b05bcda60cc529c$export$271f7c16f175f804);
        var _this;
        _this = (0, $07dqX._)(this, $9b05bcda60cc529c$export$271f7c16f175f804, (0, $fsSDT._)(args)), _this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map(function(name, i) {
            return {
                base: Math.pow(1024, i),
                name: name + 'B'
            };
        });
        return _this;
    }
    return $9b05bcda60cc529c$export$271f7c16f175f804;
}($4b6a03fb021648ad$export$595dbf49c602a1f);
var $4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $4b6a03fb021648ad$export$c489aa6f7fd82b1a;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $4b6a03fb021648ad$export$cbd942915f33be50;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $4b6a03fb021648ad$export$9b886f8493244014;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $4b6a03fb021648ad$export$e99cbb807a5bb10d;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $4b6a03fb021648ad$export$7a9a31a911eb9a20;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $4b6a03fb021648ad$export$fca4f8121099df57;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $4b6a03fb021648ad$export$6ce2f08d515512;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $4b6a03fb021648ad$export$951c8378cdfec6e6;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $4b6a03fb021648ad$export$1a4097b876a13bf7;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $4b6a03fb021648ad$export$d9bcbd5e1ff81430;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $4b6a03fb021648ad$export$506c8e8f8c8edda;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $4b6a03fb021648ad$export$3ae94a2503e890a1;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $4b6a03fb021648ad$export$7e1c707225b48c34;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $4b6a03fb021648ad$export$62ad822b3a5fd9a0;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $4b6a03fb021648ad$export$9e85258502147ffb;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $4b6a03fb021648ad$export$3c1f2e5bc03748e2;
});
var $4b6a03fb021648ad$export$c489aa6f7fd82b1a = 1000;
var $4b6a03fb021648ad$export$cbd942915f33be50 = $4b6a03fb021648ad$export$c489aa6f7fd82b1a * 60;
var $4b6a03fb021648ad$export$9b886f8493244014 = $4b6a03fb021648ad$export$cbd942915f33be50 * 15;
var $4b6a03fb021648ad$export$e99cbb807a5bb10d = $4b6a03fb021648ad$export$9b886f8493244014 * 4;
var $4b6a03fb021648ad$export$7a9a31a911eb9a20 = $4b6a03fb021648ad$export$e99cbb807a5bb10d * 24;
var $4b6a03fb021648ad$export$fca4f8121099df57 = $4b6a03fb021648ad$export$7a9a31a911eb9a20 * 7;
var $4b6a03fb021648ad$export$6ce2f08d515512 = $4b6a03fb021648ad$export$7a9a31a911eb9a20 * 365;
var $4b6a03fb021648ad$export$951c8378cdfec6e6 = $4b6a03fb021648ad$export$6ce2f08d515512 / 12;
var $4b6a03fb021648ad$export$1a4097b876a13bf7 = $4b6a03fb021648ad$export$951c8378cdfec6e6 * 3;
var $4b6a03fb021648ad$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $h6w6E._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, $6a9944941b4c1893$export$595dbf49c602a1f);
    function $f872d8bba1c0f79f$export$d9bcbd5e1ff81430() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
        var _this;
        _this = (0, $07dqX._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430, (0, $fsSDT._)(args)), _this.units = [
            {
                base: $4b6a03fb021648ad$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $4b6a03fb021648ad$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $4b6a03fb021648ad$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $4b6a03fb021648ad$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $4b6a03fb021648ad$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $4b6a03fb021648ad$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $4b6a03fb021648ad$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
        return _this;
    }
    (0, $8BtP9._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, [
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return (0, $5LQ10._)((0, $2JFuQ._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430.prototype), "toShortString", this).call(this, fractionDigits);
            }
        }
    ]);
    return $f872d8bba1c0f79f$export$d9bcbd5e1ff81430;
}($4b6a03fb021648ad$export$595dbf49c602a1f);
function $4b6a03fb021648ad$export$506c8e8f8c8edda(end) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var timeDistance = $4b6a03fb021648ad$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    var _timeDistance_toShortString_split = (0, $leE2g._)(timeDistance.toShortString().split(/\s+/), 2), value = _timeDistance_toShortString_split[0], unit = _timeDistance_toShortString_split[1];
    return {
        distance: +value,
        unit: unit
    };
}
function $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return function(template) {
        return (value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
    };
}
function $4b6a03fb021648ad$export$3ae94a2503e890a1() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
    var _toJSON_split = (0, $leE2g._)(new Date(time).toJSON().split(/\D/), 7), year = _toJSON_split[0], month = _toJSON_split[1], day = _toJSON_split[2], hour = _toJSON_split[3], minute = _toJSON_split[4], second = _toJSON_split[5], millisecond = _toJSON_split[6];
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $4b6a03fb021648ad$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $4b6a03fb021648ad$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    var month = date.getMonth() + delta;
    date = $4b6a03fb021648ad$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $4b6a03fb021648ad$export$9e85258502147ffb = function(date, unit, delta) {
    return unit === $4b6a03fb021648ad$export$6ce2f08d515512 ? $4b6a03fb021648ad$export$7e1c707225b48c34(date, delta) : unit === $4b6a03fb021648ad$export$951c8378cdfec6e6 ? $4b6a03fb021648ad$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
};
var $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $4b6a03fb021648ad$export$6ce2f08d515512,
    7: $4b6a03fb021648ad$export$951c8378cdfec6e6,
    10: $4b6a03fb021648ad$export$7a9a31a911eb9a20,
    13: $4b6a03fb021648ad$export$e99cbb807a5bb10d,
    16: $4b6a03fb021648ad$export$cbd942915f33be50,
    19: $4b6a03fb021648ad$export$c489aa6f7fd82b1a
};
function $4b6a03fb021648ad$export$3c1f2e5bc03748e2(value) {
    var defaultValue = "2025-01-01T00:00:00.000Z";
    var startedAt = new Date(value + defaultValue.slice(value.length));
    var endedAt = $4b6a03fb021648ad$export$9e85258502147ffb(startedAt, $4b6a03fb021648ad$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $4b6a03fb021648ad$var$$ba0e5dc395660a7c$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $4b6a03fb021648ad$export$27924e57e9afff7f;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $4b6a03fb021648ad$export$7ea17d45ecdcf634;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $4b6a03fb021648ad$export$bf304e455230454a;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $4b6a03fb021648ad$export$bb8626e4916f587b;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $4b6a03fb021648ad$export$88182f6768071c72;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $4b6a03fb021648ad$export$2427785258f88523;
});
function $4b6a03fb021648ad$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            var date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    var value = parseItem(raw);
    if (typeof value !== 'string' || $4b6a03fb021648ad$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, function(key, value) {
            return parseItem(value);
        });
    } catch (e) {
        return raw;
    }
}
function $4b6a03fb021648ad$export$7ea17d45ecdcf634(raw) {
    var parsed = $4b6a03fb021648ad$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    var number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
var $4b6a03fb021648ad$export$bf304e455230454a = function(data) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    return [
        Object.keys(data[0]).join(separator)
    ].concat((0, $fsSDT._)(data.map(function(item) {
        return Object.values(item).map(function(value) {
            return JSON.stringify(value);
        }).join(separator);
    }))).join('\n');
};
function $4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    var quote = raw[0];
    var index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError("A ".concat(quote, " is missing"));
    return raw.slice(1, index);
}
function $4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$parseRow(row) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    var list = [];
    do {
        var value = void 0;
        if (row[0] === '"' || row[0] === "'") {
            value = $4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            var index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($4b6a03fb021648ad$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $4b6a03fb021648ad$export$bb8626e4916f587b(raw, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ',';
    var data = raw.trim().split(/[\r\n]+/).map(function(row) {
        return $4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$parseRow(row, separator);
    });
    return !header ? data : data.slice(1).map(function(row) {
        return $4b6a03fb021648ad$export$1c8ba402144543e5(row, data[0]);
    });
}
var $4b6a03fb021648ad$export$88182f6768071c72 = function(raw) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        return (0, $Csf8W.__generator)(this, function(_state) {
            return [
                2,
                Array.fromAsync($4b6a03fb021648ad$export$2427785258f88523(raw[Symbol.iterator]()))
            ];
        });
    })();
};
function $4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $fPf27._)(chunks);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $Csf8W.__values)((0, $f8MCl._)((0, $fPf27._)(chunk)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function() {
        var inQuote, quoteChar, prevChar, cellBuffer, currentRow, completeCell, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, char, err;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    inQuote = false;
                    quoteChar = '';
                    prevChar = '';
                    cellBuffer = '';
                    currentRow = [];
                    completeCell = function() {
                        currentRow.push($4b6a03fb021648ad$export$7ea17d45ecdcf634(cellBuffer.trim()));
                        cellBuffer = '';
                    };
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $fPf27._)(chars);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    char = _value;
                    if (!(char === '\n' || char === '\r')) return [
                        3,
                        6
                    ];
                    if (char === '\n' && prevChar === '\r') {
                        prevChar = char;
                        return [
                            3,
                            8
                        ];
                    }
                    completeCell();
                    if (!(currentRow.length > 1 || currentRow[0])) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        currentRow
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    currentRow = [];
                    return [
                        3,
                        7
                    ];
                case 6:
                    if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
                        inQuote = true;
                        quoteChar = char;
                    } else if (char === quoteChar && inQuote) {
                        inQuote = false;
                        quoteChar = '';
                    } else if (inQuote) cellBuffer += char;
                    else if (char === separator) completeCell();
                    else cellBuffer += char;
                    _state.label = 7;
                case 7:
                    prevChar = char;
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.return())
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!(cellBuffer || currentRow.length > 0)) return [
                        3,
                        18
                    ];
                    completeCell();
                    if (!(currentRow.length > 1 || currentRow[0])) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        currentRow
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $4b6a03fb021648ad$export$2427785258f88523(chunks, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ',';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function() {
        var headerRow, isFirstRow, chars, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, row, err;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isFirstRow = true;
                    chars = $4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$characterStream(chunks);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $fPf27._)($4b6a03fb021648ad$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    row = _value;
                    if (!(header && isFirstRow)) return [
                        3,
                        4
                    ];
                    headerRow = row;
                    isFirstRow = false;
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        header && headerRow ? $4b6a03fb021648ad$export$1c8ba402144543e5(row, headerRow) : row
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        (0, $hW8ac._)(_iterator.return())
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $4b6a03fb021648ad$var$$083124ac4b1a50a0$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $4b6a03fb021648ad$export$71e6483fc2b024eb;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $4b6a03fb021648ad$export$eb9b2aadbe449a20;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $4b6a03fb021648ad$export$13397a83aa5915d6;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $4b6a03fb021648ad$export$fd89523fba250fa4;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $4b6a03fb021648ad$export$504fbde693c1771c;
});
var $4b6a03fb021648ad$export$71e6483fc2b024eb = function(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
};
function $4b6a03fb021648ad$export$eb9b2aadbe449a20() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_location;
        return ((_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.search) || '';
    }(), toBuiltIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var rawData = raw.split('#').map(function(URI) {
        var _URI_split = (0, $leE2g._)(URI.split('?'), 2), before = _URI_split[0], after = _URI_split[1];
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    var data = new URLSearchParams(rawData);
    return Object.fromEntries((0, $fsSDT._)(data.keys()).map(function(key) {
        var list = toBuiltIn ? data.getAll(key).map($4b6a03fb021648ad$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
var $4b6a03fb021648ad$var$$083124ac4b1a50a0$var$stringify = function(value) {
    return typeof value === 'string' ? value : $4b6a03fb021648ad$export$b5a4d6f439a5044d(value) ? $4b6a03fb021648ad$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
};
function $4b6a03fb021648ad$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    var list = map.map(function(param) {
        var _param = (0, $leE2g._)(param, 2), key = _param[0], value = _param[1];
        return !$4b6a03fb021648ad$export$dd1bc94b04021eeb(value) && [
            key,
            $4b6a03fb021648ad$var$$083124ac4b1a50a0$var$stringify(value)
        ];
    }).filter(Boolean);
    return new URLSearchParams(list);
}
var $4b6a03fb021648ad$export$fd89523fba250fa4 = function(URI) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(URI + '')
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().blob()
                    ];
            }
        });
    })();
};
var $4b6a03fb021648ad$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $4b6a03fb021648ad$export$504fbde693c1771c(URI) {
    var _ref = (0, $leE2g._)($4b6a03fb021648ad$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [], 5), _ = _ref[0], type = _ref[1], __ = _ref[2], base64 = _ref[3], data = _ref[4];
    data = base64 ? atob(data) : data;
    var aBuffer = Uint8Array.from(data, function(char) {
        return char.charCodeAt(0);
    });
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $4b6a03fb021648ad$var$$d677628cc2ac1e37$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $4b6a03fb021648ad$export$d0eaf3e94be578f6;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $4b6a03fb021648ad$export$110700823644f4a6;
});
var $4b6a03fb021648ad$export$d0eaf3e94be578f6 = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_document;
        return (_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.cookie;
    }();
    return value ? Object.fromEntries(value.split(/;\s*/).map(function(item) {
        return item.split('=');
    })) : {};
};
function $4b6a03fb021648ad$export$110700823644f4a6(key, value) {
    var attributes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var data = "".concat(key, "=").concat(value), option = Object.entries(attributes).map(function(param) {
        var _param = (0, $leE2g._)(param, 2), _$key = _param[0], _$value = _param[1];
        return typeof _$value === 'boolean' ? _$value ? _$key : '' : "".concat(_$key, "=").concat(_$value);
    }).filter(Boolean).join('; ');
    document.cookie = "".concat(data, "; expires=").concat(new Date(0));
    return document.cookie = "".concat(data, "; ").concat(option);
}
var $4b6a03fb021648ad$var$$50872bf213056663$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $4b6a03fb021648ad$export$1b9ac4d3de3ffd2e;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$50872bf213056663$exports, "makeSHA", function() {
    return $4b6a03fb021648ad$export$d51f3b55e8d1aa73;
});
var $4b6a03fb021648ad$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), function(_, cell) {
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $4b6a03fb021648ad$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            value = value >> 8 & 0x00ffffff ^ $4b6a03fb021648ad$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if ((typeof self === "undefined" ? "undefined" : (0, $5f0Cq._)(self)) === 'object') {
    if ('msCrypto' in globalThis) {
        var $4b6a03fb021648ad$var$_loop = function(key) {
            var origin = $4b6a03fb021648ad$var$subtle[key];
            if (origin instanceof Function) $4b6a03fb021648ad$var$subtle[key] = function() {
                var observer = origin.apply(this, arguments);
                return new Promise(function(resolve, reject) {
                    observer.oncomplete = function(param) {
                        var target = param.target;
                        return resolve(target.result);
                    };
                    observer.onabort = observer.onerror = reject;
                });
            };
        };
        // @ts-ignore
        var $4b6a03fb021648ad$var$_ref = globalThis.crypto = globalThis.msCrypto, $4b6a03fb021648ad$var$subtle = $4b6a03fb021648ad$var$_ref.subtle;
        for(var $4b6a03fb021648ad$var$key in $4b6a03fb021648ad$var$subtle)$4b6a03fb021648ad$var$_loop($4b6a03fb021648ad$var$key);
    }
    var $4b6a03fb021648ad$var$crypto1 = globalThis.crypto;
    if (!($4b6a03fb021648ad$var$crypto1 === null || $4b6a03fb021648ad$var$crypto1 === void 0 ? void 0 : $4b6a03fb021648ad$var$crypto1.subtle) && ($4b6a03fb021648ad$var$crypto1 === null || $4b6a03fb021648ad$var$crypto1 === void 0 ? void 0 : $4b6a03fb021648ad$var$crypto1['webkitSubtle'])) $4b6a03fb021648ad$var$crypto1.subtle = $4b6a03fb021648ad$var$crypto1['webkitSubtle'];
}
function $4b6a03fb021648ad$export$d51f3b55e8d1aa73(raw) {
    var algorithm = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'SHA-1';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var buffer;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.digest(algorithm, new TextEncoder().encode(raw))
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        Array.from(new Uint8Array(buffer), function(byte) {
                            return byte.toString(16).padStart(2, '0');
                        }).join('')
                    ];
            }
        });
    })();
}
var $4b6a03fb021648ad$var$$93a3089d2937b23f$exports = {};
var $4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $4b6a03fb021648ad$export$f5a4056b78c72efa;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $4b6a03fb021648ad$export$2ee022bbbc550b25;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $4b6a03fb021648ad$export$a549dd5cef7f8327;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $4b6a03fb021648ad$export$8eece510bcb9c62c;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $4b6a03fb021648ad$export$b8a1af58c024fefd;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $4b6a03fb021648ad$export$a2cf0d4bb6e06de4;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $4b6a03fb021648ad$export$d66b332881d9723f;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $4b6a03fb021648ad$export$b0709844452f8b6b;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $4b6a03fb021648ad$export$5118471ee5d5453b;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $4b6a03fb021648ad$export$6e196edbcc00e5bc;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $4b6a03fb021648ad$export$be4650432daa84fd;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $4b6a03fb021648ad$export$578e38b4a3e0b255;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $4b6a03fb021648ad$export$7cd14c57bbb84350;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $4b6a03fb021648ad$export$5100419dfae0456d;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $4b6a03fb021648ad$export$28d9d24a8cd0ffc2;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $4b6a03fb021648ad$export$3f99968195accfaf;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $4b6a03fb021648ad$export$eafdbaa868ea9975;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $4b6a03fb021648ad$export$36a0c1ca2ae264fa;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $4b6a03fb021648ad$export$86d7c59254d6a2c9;
});
var $4b6a03fb021648ad$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var $4b6a03fb021648ad$var$$3e0a089cc13f69ad$var$templateMap = {};
function $4b6a03fb021648ad$export$2ee022bbbc550b25(tagName) {
    if ($4b6a03fb021648ad$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $4b6a03fb021648ad$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    var spawn = document.createElement('template');
    spawn.innerHTML = "<".concat(tagName, " />");
    return $4b6a03fb021648ad$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $4b6a03fb021648ad$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    var _tagName_split = (0, $leE2g._)(tagName.split(':'), 2), prefix = _tagName_split[0], localName = _tagName_split[1];
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    var node = $4b6a03fb021648ad$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
var $4b6a03fb021648ad$export$8eece510bcb9c62c = function(Class) {
    return $4b6a03fb021648ad$export$170f4e08cad8229d(Class, HTMLElement);
};
var $4b6a03fb021648ad$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $4b6a03fb021648ad$export$b8a1af58c024fefd(Class) {
    var name = $4b6a03fb021648ad$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var _ref = new Class(), tagName = _ref.tagName;
    $4b6a03fb021648ad$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $4b6a03fb021648ad$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ var ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    var template = $4b6a03fb021648ad$export$2ee022bbbc550b25(tagName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ReadOnly_Properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $leE2g._)(_step.value, 2), Class = _step_value[0], keys = _step_value[1];
            if (template instanceof Class && keys.includes(propertyName)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $4b6a03fb021648ad$export$d66b332881d9723f(HTML) {
    var spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return (0, $fsSDT._)(spawn.content.childNodes).map(function(node) {
        node.remove();
        return node;
    });
}
var $4b6a03fb021648ad$export$b0709844452f8b6b = function(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
};
function $4b6a03fb021648ad$export$5118471ee5d5453b(root, type) {
    var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
    return (0, $Csf8W.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                children = (0, $fsSDT._)(root.childNodes);
                if (!($4b6a03fb021648ad$export$dd1bc94b04021eeb(type) || type === root.nodeType)) return [
                    3,
                    2
                ];
                return [
                    4,
                    root
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator = children[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    7
                ];
                node = _step.value;
                return [
                    5,
                    (0, $Csf8W.__values)($4b6a03fb021648ad$export$5118471ee5d5453b(node, type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function $4b6a03fb021648ad$export$6e196edbcc00e5bc(element) {
    var _element_getBoundingClientRect = element.getBoundingClientRect(), left = _element_getBoundingClientRect.left, top = _element_getBoundingClientRect.top;
    return document.elementFromPoint(left, top) === element;
}
function $4b6a03fb021648ad$export$be4650432daa84fd(root) {
    var text = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $4b6a03fb021648ad$export$5118471ee5d5453b(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, nodeType = _step_value.nodeType, parentElement = _step_value.parentElement, nodeValue = _step_value.nodeValue;
            if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
                var _parentElement_getBoundingClientRect = parentElement.getBoundingClientRect(), width = _parentElement_getBoundingClientRect.width, height = _parentElement_getBoundingClientRect.height;
                if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
function $4b6a03fb021648ad$export$578e38b4a3e0b255(param) {
    var offsetWidth = param.offsetWidth, children = param.children, pageHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 841.89, pageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 595.28;
    var scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return (0, $fsSDT._)(children).reduce(function(pages, node) {
        var _pages, _bottomIndex;
        var top = node.offsetTop, height = node.offsetHeight;
        top += offset;
        var bottom = top + height;
        var bottomOffset = bottom / scrollHeight;
        var topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        ((_pages = pages)[_bottomIndex = bottomIndex] || (_pages[_bottomIndex] = [])).push(node);
        return pages;
    }, []);
}
function $4b6a03fb021648ad$export$7cd14c57bbb84350(URI) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var alternate = _param.alternate, options = (0, $8MJI4._)(_param, [
        "alternate"
    ]);
    var style = (0, $fsSDT._)(document.styleSheets).find(function(param) {
        var href = param.href;
        return href === URI;
    });
    if (style) return Promise.resolve(style);
    var link = document.createElement('link');
    return new Promise(function(resolve, reject) {
        link.onload = function() {
            return resolve(link.sheet);
        };
        link.onerror = function(_1, _2, _3, _4, error) {
            return reject(error);
        };
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $4b6a03fb021648ad$export$5100419dfae0456d(data) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, indent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '    ';
    var padding = indent.repeat(depth);
    return Object.entries(data).map(function(param) {
        var _param = (0, $leE2g._)(param, 2), key = _param[0], value = _param[1];
        return (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) !== 'object' ? "".concat(padding).concat($4b6a03fb021648ad$export$3f34ca2fef821bbd(key), ": ").concat(value, ";") : "".concat(padding).concat(key, " {\n").concat($4b6a03fb021648ad$export$5100419dfae0456d(value, depth + 1, indent), "\n").concat(padding, "}");
    }).join('\n');
}
function $4b6a03fb021648ad$export$28d9d24a8cd0ffc2() {
    for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
        nodes[_key] = arguments[_key];
    }
    var _fragment, _node;
    var fragment = document.createDocumentFragment();
    (_fragment = fragment).append.apply(_fragment, (0, $fsSDT._)(nodes));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $4b6a03fb021648ad$export$5118471ee5d5453b(fragment)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (![
                1,
                3,
                11
            ].includes(node.nodeType) || [
                'meta',
                'title',
                'link',
                'script'
            ].includes(node.nodeName.toLowerCase())) (_node = node).replaceWith.apply(_node, (0, $fsSDT._)(node.childNodes));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var selection = globalThis.getSelection();
    if (!selection) return;
    var range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $4b6a03fb021648ad$export$3f99968195accfaf(selector, root, align, justify) {
    var _querySelector;
    var _ref = (0, $leE2g._)(/^#(.+)/.exec(selector) || [], 2), _ = _ref[0], ID = _ref[1];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (_querySelector = (root || document).querySelector(ID ? '[id="'.concat(ID, '"]') : selector)) === null || _querySelector === void 0 ? void 0 : _querySelector.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
var $4b6a03fb021648ad$export$eafdbaa868ea9975 = function(box, handler) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), function(_, index) {
        return "h".concat(++index);
    }) + ''), function(header) {
        new IntersectionObserver(function(param) {
            var _param = (0, $leE2g._)(param, 1), item = _param[0];
            if (!item.isIntersecting) return;
            var target = item.target;
            handler({
                target: target,
                links: (0, $fsSDT._)(target.ownerDocument.querySelectorAll('[href="#'.concat(target.id, '"]')))
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
};
function $4b6a03fb021648ad$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(function(param) {
        var _param = (0, $leE2g._)(param, 1), _param_ = _param[0], isIntersecting = _param_.isIntersecting;
        return change(isIntersecting ? last | 2 : last & 1);
    }).observe(root);
    document.addEventListener('visibilitychange', function() {
        return change(document.visibilityState === 'visible' ? last | 1 : last & 2);
    });
}
function $4b6a03fb021648ad$export$86d7c59254d6a2c9(form) {
    var elements = form.elements, data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var name = field.name, value = field.value, checked = field.checked, defaultValue = field.defaultValue, selectedOptions = field.selectedOptions, files = field.files;
            var type = field.type;
            if (!name || value === '') continue;
            var box = type !== 'fieldset' && field.closest('fieldset');
            if (box && box !== form) continue;
            var parsedValue = value;
            switch(type){
                case 'radio':
                case 'checkbox':
                    if (checked) parsedValue = !defaultValue || $4b6a03fb021648ad$export$7ea17d45ecdcf634(defaultValue);
                    else if ($4b6a03fb021648ad$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                    else parsedValue = false;
                    break;
                case 'select-multiple':
                    parsedValue = Array.from(selectedOptions, function(param) {
                        var value = param.value;
                        return $4b6a03fb021648ad$export$7ea17d45ecdcf634(value);
                    });
                    break;
                case 'fieldset':
                    parsedValue = $4b6a03fb021648ad$export$86d7c59254d6a2c9(field);
                    break;
                case 'file':
                    parsedValue = files && Array.from(files);
                    break;
                case 'date':
                case 'datetime-local':
                case 'month':
                case 'hidden':
                case 'number':
                case 'range':
                case 'select-one':
                    parsedValue = $4b6a03fb021648ad$export$7ea17d45ecdcf634(value);
            }
            if (name in data) data[name] = [].concat(data[name], parsedValue);
            else data[name] = !(parsedValue instanceof Array) || !$4b6a03fb021648ad$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
var $4b6a03fb021648ad$var$$bb23e0c794fefbef$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $4b6a03fb021648ad$export$e772c8ff12451969;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $4b6a03fb021648ad$export$57207d71b8c929c8;
});
function $4b6a03fb021648ad$export$e772c8ff12451969() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, seconds * 1000);
    });
}
function $4b6a03fb021648ad$export$57207d71b8c929c8(executor) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stop = false;
    (function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var result;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!stop) return [
                            3,
                            4
                        ];
                        result = executor();
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            $4b6a03fb021648ad$export$e772c8ff12451969(seconds)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    })();
    return function() {
        return stop = true;
    };
}
var $4b6a03fb021648ad$var$$19ed8aeb7905a045$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $4b6a03fb021648ad$export$10b1921597150314;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $4b6a03fb021648ad$export$3e2b244719956741;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $4b6a03fb021648ad$export$1d1d2ed6b55cf67f;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $4b6a03fb021648ad$export$2155c0b5a4b77fb8;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $4b6a03fb021648ad$export$9d97473344489dfc;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $4b6a03fb021648ad$export$d635d04af3887bbe;
});
function $4b6a03fb021648ad$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
var $4b6a03fb021648ad$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise(function(resolve) {
    var _document;
    function done() {
        var _document;
        (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        var _document;
        ((_document = document) === null || _document === void 0 ? void 0 : _document.readyState) === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $4b6a03fb021648ad$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise(function(resolve, reject) {
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $4b6a03fb021648ad$export$2155c0b5a4b77fb8(handlers) {
    function server(_param) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var _param_data, type, id, source, origin, data, _handlers_type, result;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_data = _param.data, type = _param_data.type, id = _param_data.id, source = _param.source, origin = _param.origin, data = (0, $8MJI4._)(_param.data, [
                            "type",
                            "id"
                        ]);
                        result = (_handlers_type = handlers[type]) === null || _handlers_type === void 0 ? void 0 : _handlers_type.call(handlers, data);
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        // @ts-ignore
                        source.postMessage((0, $ctBui._)((0, $6GCxi._)({}, result), {
                            id: id
                        }), origin);
                        return [
                            2
                        ];
                }
            });
        })();
    }
    globalThis.addEventListener('message', server);
    return function() {
        return globalThis.removeEventListener('message', server);
    };
}
function $4b6a03fb021648ad$export$9d97473344489dfc(target) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '*';
    return function(type, data) {
        return new Promise(function(resolve) {
            var UID = $4b6a03fb021648ad$export$89912e019eef22aa();
            function handler(_param) {
                var _param_data = _param.data, id = _param_data.id, _$data = (0, $8MJI4._)(_param.data, [
                    "id"
                ]);
                if (id !== UID) return;
                resolve(_$data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage((0, $6GCxi._)({
                id: UID,
                type: type
            }, data), origin);
        });
    };
}
function $4b6a03fb021648ad$export$d635d04af3887bbe(registration) {
    return new Promise(function(resolve) {
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = function() {
            var _registration_installing;
            return (_registration_installing = registration.installing) === null || _registration_installing === void 0 ? void 0 : _registration_installing.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
        };
    });
}
var $4b6a03fb021648ad$var$$7a08303ce13c49c5$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $4b6a03fb021648ad$export$1b88f6b6d432a52a;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $4b6a03fb021648ad$export$b70f6380221b1350;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $4b6a03fb021648ad$export$75d6cbe4503e149;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $4b6a03fb021648ad$export$b2618d51188815c2;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $4b6a03fb021648ad$export$490814474ddbb428;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $4b6a03fb021648ad$export$3ea201dffb50dfef;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $4b6a03fb021648ad$export$d1012c7198c6b460;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $4b6a03fb021648ad$export$a35a418b7b17958e;
});
var $4b6a03fb021648ad$export$1b88f6b6d432a52a = /*#__PURE__*/ function() {
    "use strict";
    function $7a08303ce13c49c5$export$1b88f6b6d432a52a(from, to) {
        (0, $7lhcp._)(this, $7a08303ce13c49c5$export$1b88f6b6d432a52a);
        this.from = from;
        this.to = to;
    }
    (0, $8BtP9._)($7a08303ce13c49c5$export$1b88f6b6d432a52a, [
        {
            key: "length",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
            }
        },
        {
            key: "direction",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
                var XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
                switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
                    case XL:
                        return XD > 0 ? 'right' : 'left';
                    case YL:
                        return YD > 0 ? 'forward' : 'backward';
                    case ZL:
                        return ZD > 0 ? 'up' : 'down';
                }
            }
        }
    ]);
    return $7a08303ce13c49c5$export$1b88f6b6d432a52a;
}();
function $4b6a03fb021648ad$export$b70f6380221b1350(from, to) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parseInt(getComputedStyle(document.body).fontSize) * 6;
    var _getSelection;
    var vector = new $4b6a03fb021648ad$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.toString().trim())) return vector;
}
function $4b6a03fb021648ad$export$75d6cbe4503e149(type, element) {
    var _getComputedStyle = getComputedStyle(element), transitionDuration = _getComputedStyle.transitionDuration, animationDuration = _getComputedStyle.animationDuration;
    var duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $4b6a03fb021648ad$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $4b6a03fb021648ad$export$1d1d2ed6b55cf67f(type, element).catch(function(event) {
            return Promise.resolve(event);
        }),
        new Promise(function(resolve) {
            return setTimeout(resolve, $4b6a03fb021648ad$export$75d6cbe4503e149(type, element));
        })
    ]);
}
function $4b6a03fb021648ad$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    var end = $4b6a03fb021648ad$export$b2618d51188815c2(type, element);
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            element.classList.add(className);
            end.then(resolve);
        });
    });
}
function $4b6a03fb021648ad$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var end;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = $4b6a03fb021648ad$export$b2618d51188815c2(type, element);
                    element.classList.remove(className);
                    return [
                        4,
                        end
                    ];
                case 1:
                    _state.sent();
                    if (remove) element.remove();
                    else element.style.display = 'none';
                    return [
                        2
                    ];
            }
        });
    })();
}
function $4b6a03fb021648ad$export$490814474ddbb428(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $4b6a03fb021648ad$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $4b6a03fb021648ad$export$3ea201dffb50dfef(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $4b6a03fb021648ad$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $4b6a03fb021648ad$export$d1012c7198c6b460(element, className, remove) {
    return $4b6a03fb021648ad$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $4b6a03fb021648ad$export$a35a418b7b17958e(element, className, remove) {
    return $4b6a03fb021648ad$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $4b6a03fb021648ad$var$$69bd9f0117925302$exports = {};
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$69bd9f0117925302$exports, "describe", function() {
    return $4b6a03fb021648ad$export$cd5450f3a47e3789;
});
$4b6a03fb021648ad$var$$parcel$export($4b6a03fb021648ad$var$$69bd9f0117925302$exports, "it", function() {
    return $4b6a03fb021648ad$export$3486a10f30cf1ee4;
});
function $4b6a03fb021648ad$export$cd5450f3a47e3789(title, cases) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(title);
                    console.time(title);
                    return [
                        4,
                        cases()
                    ];
                case 1:
                    _state.sent();
                    console.timeEnd(title);
                    return [
                        2
                    ];
            }
        });
    })();
}
function $4b6a03fb021648ad$export$3486a10f30cf1ee4(title, userCase) {
    var secondsOut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var expect, timeOut;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    title = '    ' + title;
                    console.time(title);
                    expect = function(status) {
                        var assert = typeof status === 'function' ? status : undefined;
                        var _assert;
                        status = (_assert = assert === null || assert === void 0 ? void 0 : assert()) !== null && _assert !== void 0 ? _assert : status;
                        if (!status) throw new Error("Assertion failed: ".concat(title, "\n\n").concat(assert || ''));
                    };
                    timeOut = function() {
                        return $4b6a03fb021648ad$export$e772c8ff12451969(secondsOut).then(function() {
                            return Promise.reject(new RangeError('Timed out'));
                        });
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            userCase(expect),
                            timeOut()
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    console.timeEnd(title);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}

});
parcelRegister("f8MCl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b05d50cf56aae5f3$export$71511d61b312f219; });

var $l5Klr = parcelRequire("l5Klr");
function $b05d50cf56aae5f3$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $l5Klr._)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}

});



parcelRegister("arNK5", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "when", function () { return when; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });

var $5f0Cq = parcelRequire("5f0Cq");
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function ownKeys(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if ((typeof key === "undefined" ? "undefined" : (0, $5f0Cq._)(key)) === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $5f0Cq._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $5f0Cq._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $5f0Cq._)(i)) ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return (typeof context === "undefined" ? "undefined" : (0, $5f0Cq._)(context)) == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var _$mthd = initMthd;
        if (!isAction(_$mthd)) _$mthd = _createAction(_$mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            _$mthd = _$mthd.bind(this);
            _$mthd.isMobxAction = true;
        }
        return _$mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if ((typeof v === "undefined" ? "undefined" : (0, $5f0Cq._)(v)) === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && (0, $5f0Cq._)(Symbol.dispose) === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || (typeof source === "undefined" ? "undefined" : (0, $5f0Cq._)(source)) !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && (typeof arg1 === "undefined" ? "undefined" : (0, $5f0Cq._)(arg1)) === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if ((typeof thing === "undefined" ? "undefined" : (0, $5f0Cq._)(thing)) === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a === "undefined" ? "undefined" : (0, $5f0Cq._)(a);
    if (type !== "function" && type !== "object" && (typeof b === "undefined" ? "undefined" : (0, $5f0Cq._)(b)) != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if ((typeof a === "undefined" ? "undefined" : (0, $5f0Cq._)(a)) != "object" || (typeof b === "undefined" ? "undefined" : (0, $5f0Cq._)(b)) != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : (0, $5f0Cq._)(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("1R1LB", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return useLocation; });
$parcel$export(module.exports, "useParams", function () { return useParams; });
$parcel$export(module.exports, "Route", function () { return Route; });
$parcel$export(module.exports, "Routes", function () { return Routes; });
$parcel$export(module.exports, "HashRouter", function () { return HashRouter; });
/**
 * react-router v7.10.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $hVBqc = parcelRequire("hVBqc");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $h6w6E = parcelRequire("h6w6E");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $4L6tH = parcelRequire("4L6tH");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");

var $1Qmny = parcelRequire("1Qmny");

var $Csf8W = parcelRequire("Csf8W");

var $Csf8W = parcelRequire("Csf8W");
parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $12aPv = parcelRequire("12aPv");
var $6mMqj = parcelRequire("6mMqj");
var $bfb15cfc20a4c318$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.10.1_@preact+compat@18.3.1_preact@10.28.0__@preact+compat@18.3.1_preact@10.28.0_/node_modules/react-router/dist/development/chunk-WWGJGFF6.mjs"
});
var __typeError = function(msg) {
    throw TypeError(msg);
};
var __accessCheck = function(obj, member, msg) {
    return member.has(obj) || __typeError("Cannot " + msg);
};
var __privateGet = function(obj, member, getter) {
    return __accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = function(obj, member, value) {
    return member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
// lib/router/history.ts
var Action = /* @__PURE__ */ function(Action2) {
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
}(Action || {});
var PopStateEventType = "popstate";
function createMemoryHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries;
    entries = initialEntries.map(function(entry, index2) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = "POP" /* Pop */ ;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to) {
        var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, key = arguments.length > 2 ? arguments[2] : void 0;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: ".concat(JSON.stringify(to)));
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL: function(to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = "PUSH" /* Push */ ;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = "REPLACE" /* Replace */ ;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = "POP" /* Pop */ ;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createBrowserLocation(window2, globalHistory) {
        var _window2_location = window2.location, pathname = _window2_location.pathname, search = _window2_location.search, hash = _window2_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createHashLocation(window2, globalHistory) {
        var _parsePath = parsePath(window2.location.hash.substring(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        var base = window2.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window2.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(".concat(JSON.stringify(to), ")"));
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function createLocation(current, to) {
    var state = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, key = arguments.length > 3 ? arguments[3] : void 0;
    var location = (0, $ctBui._)((0, $6GCxi._)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to), {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
function createPath(param) {
    var _param_pathname = param.pathname, pathname = _param_pathname === void 0 ? "/" : _param_pathname, _param_search = param.search, search = _param_search === void 0 ? "" : _param_search, _param_hash = param.hash, hash = _param_hash === void 0 ? "" : _param_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var tmp = options.window, window2 = tmp === void 0 ? document.defaultView : tmp, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window2.history;
    var action = "POP" /* Pop */ ;
    var listener = null;
    var index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $ctBui._)((0, $6GCxi._)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return createBrowserURLImpl(to);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function createBrowserURLImpl(to) {
    var isAbsolute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    invariant(base, "No window.location.(origin|href) available to create URL");
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function createContext(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var _map;
var RouterContextProvider = /*#__PURE__*/ function() {
    "use strict";
    function RouterContextProvider(init) {
        (0, $7lhcp._)(this, RouterContextProvider);
        __privateAdd(this, _map, /* @__PURE__ */ new Map());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (init) try {
            for(var _iterator = init[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $leE2g._)(_step.value, 2), context = _step_value[0], value = _step_value[1];
                this.set(context, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $8BtP9._)(RouterContextProvider, [
        {
            /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ key: "get",
            value: function get(context) {
                if (__privateGet(this, _map).has(context)) return __privateGet(this, _map).get(context);
                if (context.defaultValue !== void 0) return context.defaultValue;
                throw new Error("No value found for context");
            }
        },
        {
            /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ key: "set",
            value: function set(context, value) {
                __privateGet(this, _map).set(context, value);
            }
        }
    ]);
    return RouterContextProvider;
}();
_map = new WeakMap();
var unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isUnsupportedLazyRouteObjectKey(key) {
    return unsupportedLazyRouteObjectKeys.has(key);
}
var unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function isUnsupportedLazyRouteFunctionKey(key) {
    return unsupportedLazyRouteFunctionKeys.has(key);
}
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2) {
    var parentPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], manifest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, allowInPlaceMutations = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return routes.map(function(route, index) {
        var treePath = (0, $fsSDT._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(allowInPlaceMutations || !manifest[id], 'Found a route id collision on id "'.concat(id, "\".  Route id's must be globally unique within Data Router usages"));
        if (isIndexRoute(route)) {
            var indexRoute = (0, $ctBui._)((0, $6GCxi._)({}, route), {
                id: id
            });
            manifest[id] = mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            var pathOrLayoutRoute = (0, $ctBui._)((0, $6GCxi._)({}, route), {
                id: id,
                children: void 0
            });
            manifest[id] = mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function mergeRouteUpdates(route, updates) {
    return Object.assign(route, (0, $6GCxi._)({}, updates, (0, $5f0Cq._)(updates.lazy) === "object" && updates.lazy != null ? {
        lazy: (0, $6GCxi._)({}, route.lazy, updates.lazy)
    } : {}));
}
function matchRoutes(routes, locationArg) {
    var basename = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes) {
    var branches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], parentsMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], parentPath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", _hasParentOptionalSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var flattenRoute = function(route, index) {
        var hasParentOptionalSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _hasParentOptionalSegments, relativePath = arguments.length > 3 ? arguments[3] : void 0;
        var meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "'.concat(meta.relativePath, '" nested under path "').concat(parentPath, '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'));
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, 'Index routes must not have child routes. Please remove all child routes from route path "'.concat(path, '".'));
            flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route_path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, true, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
function explodeOptionalSegments(path) {
    var _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $4L6tH._)(segments), first = _segments[0], rest = _segments.slice(1);
    var isOptional = first.endsWith("?");
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $fsSDT._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $fsSDT._)(restExploded));
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    var allowPartial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
        path = path.replace(/\*$/, "/*");
    }
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify2 = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            var star = "*";
            return stringify2(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $leE2g._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":'.concat(key, '" param'));
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $leE2g._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo2, param, index) {
        var paramName = param.paramName, isOptional = param.isOptional;
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path) {
    var caseSensitive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, 'The URL path "'.concat(value, '" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (').concat(error, ")."));
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function prependBasename(param) {
    var basename = param.basename, pathname = param.pathname;
    return pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
}
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var isAbsoluteUrl = function(url) {
    return ABSOLUTE_URL_REGEX.test(url);
};
function resolvePath(to) {
    var fromPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname;
    if (toPathname) {
        if (isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                var oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                warning(false, "Pathnames cannot have embedded double slashes - normalizing ".concat(oldPathname, " -> ").concat(toPathname));
            }
            if (toPathname.startsWith("/")) pathname = resolvePathname(toPathname.substring(1), "/");
            else pathname = resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '".concat(char, "' character in a manually specified `to.").concat(field, "` field [").concat(JSON.stringify(path), "].  Please separate it out to the `to.").concat(dest, '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.');
}
function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
function getResolveToMatches(matches) {
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
}
function resolveTo(toArg, routePathnames, locationPathname) {
    var isPathRelative = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = (0, $6GCxi._)({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
var DataWithResponseInit = function DataWithResponseInit(data2, init) {
    "use strict";
    (0, $7lhcp._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data2;
    this.init = init || null;
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = function(url) {
    var init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $ctBui._)((0, $6GCxi._)({}, responseInit), {
        headers: headers
    }));
};
var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data2) {
    "use strict";
    var internal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    (0, $7lhcp._)(this, ErrorResponseImpl);
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data2 instanceof Error) {
        this.data = data2.toString();
        this.error = data2;
    } else this.data = data2;
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function getRoutePattern(matches) {
    return matches.map(function(m) {
        return m.route.path;
    }).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var UninstrumentedSymbol = Symbol("Uninstrumented");
function getRouteInstrumentationUpdates(fns, route) {
    var aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach(function(fn) {
        return fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument: function(i) {
                var keys = Object.keys(aggregated);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    var updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        var instrumented = wrapImpl(aggregated.lazy, route.lazy, function() {
            return void 0;
        });
        if (instrumented) updates.lazy = instrumented;
    }
    if ((0, $5f0Cq._)(route.lazy) === "object") {
        var lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach(function(key) {
            var lazyFn = lazyObject[key];
            var instrumentations = aggregated["lazy.".concat(key)];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                var instrumented = wrapImpl(instrumentations, lazyFn, function() {
                    return void 0;
                });
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, (0, $5RfYb._)({}, key, instrumented));
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach(function(key) {
        var handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            var _handler_UninstrumentedSymbol;
            var original = (_handler_UninstrumentedSymbol = handler[UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
            var instrumented = wrapImpl(aggregated[key], original, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return getHandlerInfo(args[0]);
            });
            if (instrumented) {
                instrumented[UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map(function(middleware) {
        var _middleware_UninstrumentedSymbol;
        var original = (_middleware_UninstrumentedSymbol = middleware[UninstrumentedSymbol]) !== null && _middleware_UninstrumentedSymbol !== void 0 ? _middleware_UninstrumentedSymbol : middleware;
        var instrumented = wrapImpl(aggregated.middleware, original, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return getHandlerInfo(args[0]);
        });
        if (instrumented) {
            instrumented[UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function instrumentClientSideRouter(router, fns) {
    var aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                var keys = Object.keys(i);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    if (aggregated.navigate.length > 0) {
        var _router_navigate_UninstrumentedSymbol;
        var navigate = (_router_navigate_UninstrumentedSymbol = router.navigate[UninstrumentedSymbol]) !== null && _router_navigate_UninstrumentedSymbol !== void 0 ? _router_navigate_UninstrumentedSymbol : router.navigate;
        var instrumentedNavigate = wrapImpl(aggregated.navigate, navigate, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $leE2g._)(args, 2), to = _args[0], opts = _args[1];
            return (0, $6GCxi._)({
                to: typeof to === "number" || typeof to === "string" ? to : to ? createPath(to) : "."
            }, getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        var _router_fetch_UninstrumentedSymbol;
        var fetch2 = (_router_fetch_UninstrumentedSymbol = router.fetch[UninstrumentedSymbol]) !== null && _router_fetch_UninstrumentedSymbol !== void 0 ? _router_fetch_UninstrumentedSymbol : router.fetch;
        var instrumentedFetch = wrapImpl(aggregated.fetch, fetch2, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $leE2g._)(args, 4), key = _args[0], href = _args[2], opts = _args[3];
            return (0, $6GCxi._)({
                href: href !== null && href !== void 0 ? href : ".",
                fetcherKey: key
            }, getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
        });
        if (instrumentedFetch) {
            instrumentedFetch[UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function instrumentHandler(handler, fns) {
    var aggregated = {
        request: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                var keys = Object.keys(i);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (i[key]) aggregated[key].push(i[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    });
    var instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = wrapImpl(aggregated.request, handler, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _args = (0, $leE2g._)(args, 2), request = _args[0], context = _args[1];
        return {
            request: getReadonlyRequest(request),
            context: context != null ? getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var result;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            recurseRight(impls, getInfo.apply(void 0, (0, $fsSDT._)(args)), function() {
                                return handler.apply(void 0, (0, $fsSDT._)(args));
                            }, impls.length - 1)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.type === "error") throw result.value;
                        return [
                            2,
                            result.value
                        ];
                }
            });
        })();
    };
}
function recurseRight(impls, info, handler, index) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var impl, result, value, e, handlerPromise, callHandler, e1;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    impl = impls[index];
                    if (!!impl) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        handler()
                    ];
                case 2:
                    value = _state.sent();
                    result = {
                        type: "success",
                        value: value
                    };
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    result = {
                        type: "error",
                        value: e
                    };
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        3,
                        13
                    ];
                case 5:
                    handlerPromise = void 0;
                    callHandler = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
                                        else handlerPromise = recurseRight(impls, info, handler, index - 1);
                                        return [
                                            4,
                                            handlerPromise
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        invariant(result, "Expected a result");
                                        if (result.type === "error" && result.value instanceof Error) return [
                                            2,
                                            {
                                                status: "error",
                                                error: result.value
                                            }
                                        ];
                                        return [
                                            2,
                                            {
                                                status: "success",
                                                error: void 0
                                            }
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        impl(callHandler, info)
                    ];
                case 7:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    e1 = _state.sent();
                    console.error("An instrumentation function threw an error:", e1);
                    return [
                        3,
                        9
                    ];
                case 9:
                    if (!!handlerPromise) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        callHandler()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        4,
                        handlerPromise
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    if (result) return [
                        2,
                        result
                    ];
                    return [
                        2,
                        {
                            type: "error",
                            value: new Error("No result assigned in instrumentation chain.")
                        }
                    ];
            }
        });
    })();
}
function getHandlerInfo(args) {
    var request = args.request, context = args.context, params = args.params, unstable_pattern = args.unstable_pattern;
    return {
        request: getReadonlyRequest(request),
        params: (0, $6GCxi._)({}, params),
        unstable_pattern: unstable_pattern,
        context: getReadonlyContext(context)
    };
}
function getRouterInfo(router, opts) {
    return (0, $6GCxi._)({
        currentUrl: createPath(router.state.location)
    }, "formMethod" in opts ? {
        formMethod: opts.formMethod
    } : {}, "formEncType" in opts ? {
        formEncType: opts.formEncType
    } : {}, "formData" in opts ? {
        formData: opts.formData
    } : {}, "body" in opts ? {
        body: opts.body
    } : {});
}
function getReadonlyRequest(request) {
    var _request_headers;
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_request_headers = request.headers).get.apply(_request_headers, (0, $fsSDT._)(args));
            }
        }
    };
}
function getReadonlyContext(context) {
    if (isPlainObject(context)) {
        var frozen = (0, $6GCxi._)({}, context);
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: function(ctx) {
            return context.get(ctx);
        }
    };
}
var objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject(thing) {
    if (thing === null || (typeof thing === "undefined" ? "undefined" : (0, $5f0Cq._)(thing)) !== "object") return false;
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET"
].concat((0, $fsSDT._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    var isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    var _mapRouteProperties = init.mapRouteProperties || defaultMapRouteProperties;
    var mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        var instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = function(route) {
            return (0, $6GCxi._)({}, _mapRouteProperties(route), getRouteInstrumentationUpdates(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = "/".concat(basename);
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategyWithMiddleware;
    var future = (0, $6GCxi._)({}, init.future);
    var unlistenHistory = null;
    var subscribers = /* @__PURE__ */ new Set();
    var savedScrollPositions2 = null;
    var getScrollRestorationKey2 = null;
    var getScrollPosition = null;
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    var initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialized = true;
        initialMatches = matches;
        initialErrors = (0, $5RfYb._)({}, route.id, error);
    } else {
        if (initialMatches && !init.hydrationData) {
            var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        } else if (initialMatches.some(function(m) {
            return m.route.lazy;
        })) initialized = false;
        else if (!initialMatches.some(function(m) {
            return routeHasLoaderOrMiddleware(m.route);
        })) initialized = true;
        else {
            var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            var errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                var idx = initialMatches.findIndex(function(m) {
                    return errors[m.route.id] !== void 0;
                });
                initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                    return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
                });
            } else initialized = initialMatches.every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        }
    }
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    var pendingAction = "POP" /* Pop */ ;
    var pendingPopstateNavigationDfd = null;
    var pendingPreventScrollReset = false;
    var pendingNavigationController;
    var pendingViewTransitionEnabled = false;
    var appliedViewTransitions = /* @__PURE__ */ new Map();
    var removePageHideEventListener = null;
    var isUninterruptedRevalidation = false;
    var isRevalidationRequired = false;
    var cancelledFetcherLoads = /* @__PURE__ */ new Set();
    var fetchControllers = /* @__PURE__ */ new Map();
    var incrementingLoadId = 0;
    var pendingNavigationLoadId = -1;
    var fetchReloadIds = /* @__PURE__ */ new Map();
    var fetchRedirectIds = /* @__PURE__ */ new Set();
    var fetchLoadMatches = /* @__PURE__ */ new Map();
    var activeFetchers = /* @__PURE__ */ new Map();
    var fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    var blockerFunctions = /* @__PURE__ */ new Map();
    var unblockBlockerHistoryUpdate = void 0;
    var pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(function(param) {
            var historyAction = param.action, location = param.location, delta = param.delta;
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    function updateState(newState) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (newState.matches) newState.matches = newState.matches.map(function(m) {
            var route = manifest[m.route.id];
            var matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return (0, $ctBui._)((0, $6GCxi._)({}, m), {
                route: route
            });
            return m;
        });
        state = (0, $6GCxi._)({}, state, newState);
        var unmountedFetchers = [];
        var mountedFetchers = [];
        state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        (0, $fsSDT._)(subscribers).forEach(function(subscriber) {
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach(function(key) {
            return deleteFetcher(key);
        });
        mountedFetchers.forEach(function(key) {
            return state.fetchers.delete(key);
        });
    }
    function completeNavigation(location, newState) {
        var flushSync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).flushSync;
        var _location_state, _location_state1;
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        var restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        var viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $ctBui._)((0, $6GCxi._)({}, newState), {
            // matches, errors, fetchers go through as-is
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var promise, normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                        pendingPopstateNavigationDfd = null;
                        if (typeof to === "number") {
                            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = createDeferred();
                            promise = pendingPopstateNavigationDfd.promise;
                            init.history.go(to);
                            return [
                                2,
                                promise
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        nextLocation = (0, $6GCxi._)({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : void 0;
                        historyAction = "PUSH" /* Push */ ;
                        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: void 0,
                                        reset: void 0,
                                        location: nextLocation
                                    });
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        var promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, scopedContext, _tmp, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $5RfYb._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        if (!(opts && opts.pendingError)) return [
                            3,
                            4
                        ];
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: "error" /* error */ ,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 5:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $leE2g._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $5RfYb._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        fogOfWar.active = false;
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 6;
                    case 6:
                        return [
                            4,
                            handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 7:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        pendingNavigationController = null;
                        completeNavigation(location, (0, $ctBui._)((0, $6GCxi._)({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult)), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleAction(_0, _1, _2, _3, _4, _5, _6) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration) {
            var opts, navigation, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, notFoundMatches, error, route1, result, actionMatch, dsMatches, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, replace2, location2, boundaryMatch;
            var _arguments = arguments;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        opts = _arguments.length > 7 && _arguments[7] !== void 0 ? _arguments[7] : {};
                        interruptActiveLoads();
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        pendingActionResult: [
                                            route.id,
                                            {
                                                type: "error" /* error */ ,
                                                error: discoverResult.error
                                            }
                                        ]
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: "error" /* error */ ,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route1.id,
                                        {
                                            type: "error" /* error */ ,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: "error" /* error */ ,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(request, dsMatches, scopedContext, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match = _step.value;
                                    if (results[match.route.id]) {
                                        result = results[match.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace2 = opts.replace;
                        else {
                            location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace2 = location2 === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isErrorResult(result)) {
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result,
                                        actionMatch.route.id
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, error, notFoundMatches, route1, routesToUse, _getMatchesToLoad, dsMatches, revalidatingFetchers, updatedFetchers2, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect2, _processLoaderData, loaderData, errors, updatedFetchers, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState((0, $6GCxi._)({
                                navigation: loadingNavigation
                            }, actionData !== void 0 ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        loaderData: {},
                                        errors: (0, $5RfYb._)({}, route.id, discoverResult.error)
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $5RfYb._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $5RfYb._)({}, route1.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        pendingNavigationLoadId = ++incrementingLoadId;
                        if (!init.dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        }) && !dsMatches.some(function(m) {
                            return m.route.middleware && m.route.middleware.length > 0;
                        }) && revalidatingFetchers.length === 0) {
                            updatedFetchers2 = markFetchRedirectsDone();
                            completeNavigation(location, (0, $6GCxi._)({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $5RfYb._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers2 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== void 0) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect2 = findRedirect(loaderResults);
                        if (!redirect2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect2 = findRedirect(fetcherResults);
                        if (!redirect2) return [
                            3,
                            7
                        ];
                        fetchRedirectIds.add(redirect2.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        if (initialHydration && state.errors) errors = (0, $6GCxi._)({}, state.errors, errors);
                        updatedFetchers = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            (0, $6GCxi._)({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        })();
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return (0, $5RfYb._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    function fetch2(key, routeId, href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var flushSync, routesToUse, normalizedPath, matches, fogOfWar, _normalizeNavigateOptions, path, submission, error, scopedContext, _tmp, preventScrollReset;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortFetcher(key);
                        flushSync = (opts && opts.flushSync) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        normalizedPath = normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        matches = matchRoutes(routesToUse, normalizedPath, basename);
                        fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: normalizedPath
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        _normalizeNavigateOptions = normalizeNavigateOptions(true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (error) {
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        preventScrollReset = (opts && opts.preventScrollReset) === true;
                        if (!(submission && isMutationMethod(submission.formMethod))) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        fetchLoadMatches.set(key, {
                            routeId: routeId,
                            path: path
                        });
                        return [
                            4,
                            handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, error, originatingLoadId, fetchMatches, actionResults, actionResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match2, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, dsMatches, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, doneFetcher, redirect2, _processLoaderData, loaderData, errors;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else requestMatches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(requestMatches, path);
                        if (!match.route.action && !match.route.lazy) {
                            error = getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        fetchMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, fetchMatches, scopedContext, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (!actionResult) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = fetchMatches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match2 = _step.value;
                                    if (actionResults[match2.route.id]) {
                                        actionResult = actionResults[match2.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (fetchRequest.signal.aborted) {
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (fetchersQueuedForDeletion.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(void 0));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    updateFetcherState(key, getDoneFetcher(void 0));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
                            match.route.id,
                            actionResult
                        ]), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher2 = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        redirect2 = findRedirect(loaderResults);
                        if (redirect2) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect2 = findRedirect(fetcherResults);
                        if (redirect2) {
                            fetchRedirectIds.add(redirect2.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        _processLoaderData = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        abortStaleFetchLoads(loadId);
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, originatingLoadId, dsMatches, results, result;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(matches, path);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, dsMatches, scopedContext, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (fetchersQueuedForDeletion.has(key)) {
                            updateFetcherState(key, getDoneFetcher(void 0));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        updateFetcherState(key, getDoneFetcher(void 0));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function startRedirectNavigation(_0, _1, _2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(request, redirect2, isNavigation) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace2, location, redirectLocation, isDocumentReload, url, redirectNavigationType, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            var _arguments = arguments;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace2 = _ref.replace;
                        if (!isNavigation) {
                            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                            pendingPopstateNavigationDfd = null;
                        }
                        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect2.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser2) {
                            isDocumentReload = false;
                            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
                            else if (isAbsoluteUrl(location)) {
                                url = createBrowserURLImpl(location, true);
                                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace2) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        pendingNavigationController = null;
                        redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                submission: (0, $ctBui._)((0, $6GCxi._)({}, activeSubmission), {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        matches.filter(function(m) {
                            return m.shouldLoad;
                        }).forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: "error" /* error */ ,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        if (request.signal.aborted) return [
                            2,
                            dataResults
                        ];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $leE2g._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: "redirect" /* redirect */ ,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function(f) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                var results, result;
                                return (0, $Csf8W.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.request && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy(f.request, f.matches, scopedContext, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            return [
                                                2,
                                                (0, $5RfYb._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $5RfYb._)({}, f.key, {
                                                    type: "error" /* error */ ,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $5RfYb._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: ".concat(key));
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $leE2g._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: ".concat(key));
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: ".concat(blocker.state, " -> ").concat(newBlocker.state));
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(param) {
        var currentLocation = param.currentLocation, nextLocation = param.nextLocation, historyAction = param.historyAction;
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $leE2g._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            var key = getScrollRestorationKey2(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var _loop, partialMatches, _ret;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches, matchedDeeper;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            init.patchRoutesOnNavigation({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $fsSDT._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        newPartialMatches = null;
                                        if (newMatches) {
                                            if (Object.keys(newMatches[0].params).length === 0) return [
                                                2,
                                                {
                                                    v: {
                                                        type: "success",
                                                        matches: newMatches
                                                    }
                                                }
                                            ];
                                            else {
                                                newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                                matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                                                if (!matchedDeeper) return [
                                                    2,
                                                    {
                                                        v: {
                                                            type: "success",
                                                            matches: newMatches
                                                        }
                                                    }
                                                ];
                                            }
                                        }
                                        if (!newPartialMatches) newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!init.patchRoutesOnNavigation) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $Csf8W.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $5f0Cq._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every(function(m, i) {
            return m.route.id === b[i].route.id;
        });
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        var unstable_allowElementMutations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = (0, $fsSDT._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function(newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = instrumentClientSideRouter(router, init.unstable_instrumentations.map(function(i) {
        return i.router;
    }).filter(Boolean));
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var _mapRouteProperties = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || defaultMapRouteProperties;
    var mapRouteProperties2 = _mapRouteProperties;
    if (opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations) {
        var instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = function(route) {
            return (0, $6GCxi._)({}, _mapRouteProperties(route), getRouteInstrumentationUpdates(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    function query(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(request) {
            var _ref, requestContext, filterMatchesToLoad, skipLoaderErrorBubbling, skipRevalidation, dataStrategy, generateMiddlewareResponse, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, staticContext, error1, _getShortCircuitMatches1, notFoundMatches, route1, staticContext1, renderedStaticContext, response, e, result;
            var _arguments = arguments;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, requestContext = _ref.requestContext, filterMatchesToLoad = _ref.filterMatchesToLoad, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, skipRevalidation = _ref.skipRevalidation, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            staticContext = {
                                basename: basename,
                                location: location,
                                matches: methodNotAllowedMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $5RfYb._)({}, route.id, error),
                                statusCode: error.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext);
                                }) : staticContext
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            staticContext1 = {
                                basename: basename,
                                location: location,
                                matches: notFoundMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $5RfYb._)({}, route1.id, error1),
                                statusCode: error1.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext1);
                                }) : staticContext1
                            ];
                        }
                        if (!generateMiddlewareResponse) return [
                            3,
                            5
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                unstable_pattern: getRoutePattern(matches),
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                    var res;
                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(revalidationRequest) {
                                                        var opts2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                            var _opts2_filterMatchesToLoad, result2;
                                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        if (isResponse(result2)) return [
                                                                            2,
                                                                            result2
                                                                        ];
                                                                        renderedStaticContext = (0, $6GCxi._)({
                                                                            location: location,
                                                                            basename: basename
                                                                        }, result2);
                                                                        return [
                                                                            2,
                                                                            renderedStaticContext
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error, routeId) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                    var _, _tmp, e, staticContext, _matches_find, boundaryRouteId, staticContext1;
                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (isRedirectResponse(error)) return [
                                                    2,
                                                    error
                                                ];
                                                if (!isResponse(error)) return [
                                                    3,
                                                    4
                                                ];
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                _ = ErrorResponseImpl.bind;
                                                _tmp = [
                                                    void 0,
                                                    error.status,
                                                    error.statusText
                                                ];
                                                return [
                                                    4,
                                                    parseResponseBody(error)
                                                ];
                                            case 2:
                                                error = new (_.apply(ErrorResponseImpl, _tmp.concat([
                                                    _state.sent()
                                                ])));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                error = e;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                if (isDataWithResponseInit(error)) error = dataWithResponseInitToErrorResponse(error);
                                                if (renderedStaticContext) {
                                                    if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                                                    staticContext = getStaticContextFromError(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, routeId).route.id);
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext);
                                                        })
                                                    ];
                                                } else {
                                                    ;
                                                    boundaryRouteId = skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, ((_matches_find = matches.find(function(m) {
                                                        return m.route.id === routeId || m.route.loader;
                                                    })) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                                                    staticContext1 = {
                                                        matches: matches,
                                                        location: location,
                                                        basename: basename,
                                                        loaderData: {},
                                                        actionData: null,
                                                        errors: (0, $5RfYb._)({}, boundaryRouteId, error),
                                                        statusCode: isRouteErrorResponse(error) ? error.status : 500,
                                                        actionHeaders: {},
                                                        loaderHeaders: {}
                                                    };
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext1);
                                                        })
                                                    ];
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        invariant(isResponse(response), "Expected a response in query()");
                        return [
                            2,
                            response
                        ];
                    case 4:
                        e = _state.sent();
                        if (isResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 5:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true)
                        ];
                    case 6:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        return [
                            2,
                            (0, $6GCxi._)({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryRoute(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(request) {
            var _ref, routeId, requestContext, dataStrategy, generateMiddlewareResponse, url, method, location, matches, match, response, result;
            var _arguments = arguments;
            function handleQueryResult(result2) {
                if (isResponse(result2)) return result2;
                var error = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error !== void 0) throw error;
                if (result2.actionData) return Object.values(result2.actionData)[0];
                if (result2.loaderData) return Object.values(result2.loaderData)[0];
                return void 0;
            }
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        if (!generateMiddlewareResponse) return [
                            3,
                            3
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                unstable_pattern: getRoutePattern(matches),
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                    var res;
                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(innerRequest) {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                            var result2, processed;
                                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        processed = handleQueryResult(result2);
                                                                        return [
                                                                            2,
                                                                            isResponse(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error) {
                                if (isDataWithResponseInit(error)) return Promise.resolve(dataWithResponseInitToResponse(error));
                                if (isResponse(error)) return Promise.resolve(error);
                                throw error;
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 3:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            handleQueryResult(result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var result2, result, e;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation)
                        ];
                    case 2:
                        result2 = _state.sent();
                        return [
                            2,
                            result2
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            isResponse(result) ? result : (0, $ctBui._)((0, $6GCxi._)({}, result), {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === "error" /* error */ ) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var result, error, dsMatches, results, boundaryMatch, loaderRequest, boundaryMatch1, handlerContext2, handlerContext;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: "error" /* error */ ,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
                        return [
                            4,
                            callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isRouteRequest) {
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $5RfYb._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        }
                        if (skipRevalidation) {
                            if (isErrorResult(result)) {
                                boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                                return [
                                    2,
                                    {
                                        statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                        actionData: null,
                                        actionHeaders: (0, $6GCxi._)({}, result.headers ? (0, $5RfYb._)({}, actionMatch.route.id, result.headers) : {}),
                                        matches: matches,
                                        loaderData: {},
                                        errors: (0, $5RfYb._)({}, boundaryMatch.route.id, result.error),
                                        loaderHeaders: {}
                                    }
                                ];
                            } else return [
                                2,
                                {
                                    actionData: (0, $5RfYb._)({}, actionMatch.route.id, result.data),
                                    actionHeaders: result.headers ? (0, $5RfYb._)({}, actionMatch.route.id, result.headers) : {},
                                    matches: matches,
                                    loaderData: {},
                                    errors: null,
                                    statusCode: result.statusCode || 200,
                                    loaderHeaders: {}
                                }
                            ];
                        }
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch1 = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                                boundaryMatch1.route.id,
                                result
                            ])
                        ];
                    case 4:
                        handlerContext2 = _state.sent();
                        return [
                            2,
                            (0, $ctBui._)((0, $6GCxi._)({}, handlerContext2), {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: (0, $6GCxi._)({}, result.headers ? (0, $5RfYb._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad)
                        ];
                    case 6:
                        handlerContext = _state.sent();
                        return [
                            2,
                            (0, $ctBui._)((0, $6GCxi._)((0, $ctBui._)((0, $6GCxi._)({}, handlerContext), {
                                actionData: (0, $5RfYb._)({}, actionMatch.route.id, result.data)
                            }), result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}), {
                                actionHeaders: result.headers ? (0, $5RfYb._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var isRouteRequest, dsMatches, maxIdx, pattern, results, handlerContext;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
                        });
                        if (routeMatch) dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
                        else {
                            maxIdx = pendingActionResult && isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
                            matches.findIndex(function(m) {
                                return m.route.id === pendingActionResult[0];
                            }) - 1 : void 0;
                            pattern = getRoutePattern(matches);
                            dsMatches = matches.map(function(match, index) {
                                if (maxIdx != null && index > maxIdx) return getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                                return getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
                            });
                        }
                        if (!dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        })) return [
                            2,
                            {
                                matches: matches,
                                loaderData: {},
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $5RfYb._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {}
                            }
                        ];
                        return [
                            4,
                            callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        handlerContext = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
                        return [
                            2,
                            (0, $ctBui._)((0, $6GCxi._)({}, handlerContext), {
                                matches: matches
                            })
                        ];
                }
            });
        })();
    }
    function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var results, dataResults;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, request, matches, null, requestContext, true)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function(match) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                    var result, response, _;
                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResult(result)) {
                                                    response = result.result;
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
                                                }
                                                if (isRouteRequest) {
                                                    if (isResponse(result.result)) throw result;
                                                    else if (isDataWithResponseInit(result.result)) throw dataWithResponseInitToResponse(result.result);
                                                }
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function getStaticContextFromError(routes, handlerContext, error, boundaryId) {
    var errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return (0, $ctBui._)((0, $6GCxi._)({}, handlerContext), {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $5RfYb._)({}, errorBoundaryId, error)
    });
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error("".concat(method, "() call aborted without an `AbortSignal.reason`: ").concat(request.method, " ").concat(request.url));
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if (basename !== "/") path.pathname = prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = rawFormMethod.toUpperCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, param) {
                var _param = (0, $leE2g._)(param, 2), name = _param[0], value = _param[1];
                return "".concat(acc).concat(name, "=").concat(value, "\n");
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    var parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?".concat(searchParams);
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
function getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    var _state_matches_;
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    var maxIdx;
    if (initialHydration && state.errors) {
        var boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
    } else if (pendingActionResult && isErrorResult(pendingActionResult[1])) {
        var boundaryId1 = pendingActionResult[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId1;
        }) - 1;
    }
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    var shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    var baseShouldRevalidateArgs = (0, $ctBui._)((0, $6GCxi._)({
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params
    }, submission), {
        actionResult: actionResult,
        actionStatus: actionStatus
    });
    var pattern = getRoutePattern(matches);
    var dsMatches = matches.map(function(match, index) {
        var route = match.route;
        var forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if (isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        var defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || isNewRouteInstance(state.matches[index], match);
        var shouldRevalidateArgs = (0, $ctBui._)((0, $6GCxi._)({}, baseShouldRevalidateArgs), {
            defaultShouldRevalidate: defaultShouldRevalidate
        });
        var shouldLoad = shouldRevalidateLoader(match, shouldRevalidateArgs);
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || fetchersQueuedForDeletion.has(key)) return;
        var fetcher = state.fetchers.get(key);
        var isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var fetchController = new AbortController();
        var fetchRequest = createClientSideRequest(history, f.path, fetchController.signal);
        var fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            var shouldRevalidateArgs = (0, $ctBui._)((0, $6GCxi._)({}, baseShouldRevalidateArgs), {
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            });
            if (shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!routeHasLoaderOrMiddleware(route)) return false;
    var hasData = loaderData != null && route.id in loaderData;
    var hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    var isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = ".concat(routeId));
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    var uniqueChildren = [];
    var existingChildren = [];
    children.forEach(function(newRoute) {
        var existingRoute = childrenToPatch.find(function(existingRoute2) {
            return isSameRoute(newRoute, existingRoute2);
        });
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        var _childrenToPatch;
        var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $fsSDT._)(newRoutes));
    }
    if (allowElementMutations && existingChildren.length > 0) for(var i = 0; i < existingChildren.length; i++){
        var _existingChildren_i = existingChildren[i], existingRoute = _existingChildren_i.existingRoute, newRoute = _existingChildren_i.newRoute;
        var existingRouteTyped = existingRoute;
        var _convertRoutesToDataRoutes = (0, $leE2g._)(convertRoutesToDataRoutes([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true), 1), newRouteTyped = _convertRoutesToDataRoutes[0];
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
var lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var loadLazyRouteProperty = function(param) {
    var key = param.key, route = param.route, manifest = param.manifest, mapRouteProperties2 = param.mapRouteProperties;
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || (0, $5f0Cq._)(routeToUpdate.lazy) !== "object") return;
    var lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    var cache = lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    var cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    var propertyPromise = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var isUnsupported, staticRouteValue, isStaticallyDefined, value;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isUnsupported = isUnsupportedLazyRouteObjectKey(key);
                        staticRouteValue = routeToUpdate[key];
                        isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
                        if (!isUnsupported) return [
                            3,
                            1
                        ];
                        warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
                        cache[key] = Promise.resolve();
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!isStaticallyDefined) return [
                            3,
                            2
                        ];
                        warning(false, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(key, '" defined. The lazy property will be ignored.'));
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            lazyFn()
                        ];
                    case 3:
                        value = _state.sent();
                        if (value != null) {
                            Object.assign(routeToUpdate, (0, $5RfYb._)({}, key, value));
                            Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
                        }
                        _state.label = 4;
                    case 4:
                        if ((0, $5f0Cq._)(routeToUpdate.lazy) === "object") {
                            routeToUpdate.lazy[key] = void 0;
                            if (Object.values(routeToUpdate.lazy).every(function(value) {
                                return value === void 0;
                            })) routeToUpdate.lazy = void 0;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        var cachedPromise = lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        var lazyRoutePromise2 = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var lazyRoute, routeUpdates, lazyRouteProperty, lazyValue, isUnsupported, staticRouteValue, isStaticallyDefined;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            invariant(typeof route.lazy === "function", "No lazy route function found");
                            return [
                                4,
                                route.lazy()
                            ];
                        case 1:
                            lazyRoute = _state.sent();
                            routeUpdates = {};
                            for(var lazyRouteProperty in lazyRoute){
                                lazyValue = lazyRoute[lazyRouteProperty];
                                if (lazyValue === void 0) continue;
                                isUnsupported = isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                                staticRouteValue = routeToUpdate[lazyRouteProperty];
                                isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                                // on the route updates
                                lazyRouteProperty !== "hasErrorBoundary";
                                if (isUnsupported) warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                                else if (isStaticallyDefined) warning(!isStaticallyDefined, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(lazyRouteProperty, '" defined but its lazy function is also returning a value for this property. The lazy route property "').concat(lazyRouteProperty, '" will be ignored.'));
                                else routeUpdates[lazyRouteProperty] = lazyValue;
                            }
                            Object.assign(routeToUpdate, routeUpdates);
                            Object.assign(routeToUpdate, (0, $ctBui._)((0, $6GCxi._)({}, mapRouteProperties2(routeToUpdate)), {
                                lazy: void 0
                            }));
                            return [
                                2
                            ];
                    }
                });
            })();
        }();
        lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(function() {});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    var lazyKeys = Object.keys(route.lazy);
    var lazyPropertyPromises = [];
    var lazyHandlerPromise = void 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lazyKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
            var promise = loadLazyRouteProperty({
                key: key,
                route: route,
                manifest: manifest,
                mapRouteProperties: mapRouteProperties2
            });
            if (promise) {
                lazyPropertyPromises.push(promise);
                if (key === type) lazyHandlerPromise = promise;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(function() {}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(function() {});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(function() {});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function isNonNullable(value) {
    return value !== void 0;
}
function loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    var promises = matches.map(function(param) {
        var route = param.route;
        if ((0, $5f0Cq._)(route.lazy) !== "object" || !route.lazy.middleware) return void 0;
        return loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter(isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
function defaultDataStrategy(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var matchesToLoad, keyedResults, results;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    keyedResults = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    results.forEach(function(result, i) {
                        keyedResults[matchesToLoad[i].route.id] = result;
                    });
                    return [
                        2,
                        keyedResults
                    ];
            }
        });
    })();
}
function defaultDataStrategyWithMiddleware(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        return (0, $Csf8W.__generator)(this, function(_state) {
            if (!args.matches.some(function(m) {
                return m.route.middleware;
            })) return [
                2,
                defaultDataStrategy(args)
            ];
            return [
                2,
                runClientMiddlewarePipeline(args, function() {
                    return defaultDataStrategy(args);
                })
            ];
        });
    })();
}
function runServerMiddlewarePipeline(args, handler, errorHandler) {
    return runMiddlewarePipeline(args, handler, processResult, isResponse, errorHandler);
    function processResult(result) {
        return isDataWithResponseInit(result) ? dataWithResponseInitToResponse(result) : result;
    }
}
function runClientMiddlewarePipeline(args, handler) {
    return runMiddlewarePipeline(args, handler, function(r) {
        return r;
    }, // No post-processing needed on the client
    isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, (0, $5RfYb._)({}, routeId, {
            type: "error",
            result: error
        })));
        else {
            var matches = args.matches;
            var maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex(function(m) {
                return m.route.id === routeId;
            }), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex(function(m) {
                return m.shouldCallHandler();
            }), 0));
            var boundaryRouteId = findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve((0, $5RfYb._)({}, boundaryRouteId, {
                type: "error",
                result: error
            }));
        }
    }
}
function runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var matches, request, params, context, unstable_pattern, tuples, result;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = args.matches, request = args.request, params = args.params, context = args.context, unstable_pattern = args.unstable_pattern;
                    tuples = matches.flatMap(function(m) {
                        return m.route.middleware ? m.route.middleware.map(function(fn) {
                            return [
                                m.route.id,
                                fn
                            ];
                        }) : [];
                    });
                    return [
                        4,
                        callRouteMiddleware({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern
                        }, tuples, handler, processResult, isResult, errorHandler)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler) {
    var idx = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var request, _request_signal_reason, tuple, result, _tuple, routeId, middleware, nextResult, next, value, result1, _tmp, error, response;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error("Request aborted: ".concat(request.method, " ").concat(request.url));
                    tuple = middlewares[idx];
                    if (!!tuple) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handler()
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 2:
                    _tuple = (0, $leE2g._)(tuple, 2), routeId = _tuple[0], middleware = _tuple[1];
                    next = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                            var result, error, _tmp;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (nextResult) throw new Error("You may only call `next()` once per middleware");
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            5
                                        ]);
                                        return [
                                            4,
                                            callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
                                        ];
                                    case 2:
                                        result = _state.sent();
                                        nextResult = {
                                            value: result
                                        };
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        _tmp = {};
                                        return [
                                            4,
                                            errorHandler(error, routeId, nextResult)
                                        ];
                                    case 4:
                                        nextResult = (_tmp.value = _state.sent(), _tmp);
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        9,
                        ,
                        11
                    ]);
                    return [
                        4,
                        middleware(args, next)
                    ];
                case 4:
                    value = _state.sent();
                    result1 = value != null ? processResult(value) : void 0;
                    if (!isResult(result1)) return [
                        3,
                        5
                    ];
                    return [
                        2,
                        result1
                    ];
                case 5:
                    if (!nextResult) return [
                        3,
                        6
                    ];
                    return [
                        2,
                        result1 !== null && result1 !== void 0 ? result1 : nextResult.value
                    ];
                case 6:
                    _tmp = {};
                    return [
                        4,
                        next()
                    ];
                case 7:
                    nextResult = (_tmp.value = _state.sent(), _tmp);
                    return [
                        2,
                        nextResult.value
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    error = _state.sent();
                    return [
                        4,
                        errorHandler(error, routeId, nextResult)
                    ];
                case 10:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
}
function getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    var lazyMiddlewarePromise = loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    var lazyRoutePromises = loadLazyRoute(match.route, isMutationMethod(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad) {
    var shouldRevalidateArgs = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null;
    var isUsingNewApi = false;
    var _lazyPromises = getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return (0, $ctBui._)((0, $6GCxi._)({}, match), {
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler: function(defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, (0, $ctBui._)((0, $6GCxi._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            return shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve: function(handlerOverride) {
            var _match_route = match.route, lazy = _match_route.lazy, loader = _match_route.loader, middleware = _match_route.middleware;
            var callHandler = isUsingNewApi || shouldLoad || handlerOverride && !isMutationMethod(request.method) && (lazy || loader);
            var isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && (isMutationMethod(request.method) || !isMiddlewareOnlyRoute)) return callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    });
}
function getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext) {
    var shouldRevalidateArgs = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    return matches.map(function(match) {
        if (match.route.id !== targetMatch.route.id) return (0, $ctBui._)((0, $6GCxi._)({}, match), {
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: function() {
                return false;
            },
            _lazyPromises: getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: function() {
                return Promise.resolve({
                    type: "data",
                    result: void 0
                });
            }
        });
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
function callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var dataStrategyArgs, runClientMiddleware, results, e;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matches.some(function(m) {
                        var _m__lazyPromises;
                        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                    })) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(matches.map(function(m) {
                            var _m__lazyPromises;
                            return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                        }))
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    dataStrategyArgs = {
                        request: request,
                        unstable_pattern: getRoutePattern(matches),
                        params: matches[0].params,
                        context: scopedContext,
                        matches: matches
                    };
                    runClientMiddleware = isStaticHandler ? function() {
                        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
                    } : function(cb) {
                        var typedDataStrategyArgs = dataStrategyArgs;
                        return runClientMiddlewarePipeline(typedDataStrategyArgs, function() {
                            return cb((0, $ctBui._)((0, $6GCxi._)({}, typedDataStrategyArgs), {
                                fetcherKey: fetcherKey,
                                runClientMiddleware: function() {
                                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                                }
                            }));
                        });
                    };
                    return [
                        4,
                        dataStrategyImpl((0, $ctBui._)((0, $6GCxi._)({}, dataStrategyArgs), {
                            fetcherKey: fetcherKey,
                            runClientMiddleware: runClientMiddleware
                        }))
                    ];
                case 3:
                    results = _state.sent();
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        Promise.all(matches.flatMap(function(m) {
                            var _m__lazyPromises, _m__lazyPromises1;
                            return [
                                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
                            ];
                        }))
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function callLoaderOrAction(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(param) {
        var request, unstable_pattern, match, lazyHandlerPromise, lazyRoutePromise, handlerOverride, scopedContext, result, onReject, isAction, type, runHandler, handler, handlerError, _ref, value, handler2, ref, url, pathname, url1, pathname1, e;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = param.request, unstable_pattern = param.unstable_pattern, match = param.match, lazyHandlerPromise = param.lazyHandlerPromise, lazyRoutePromise = param.lazyRoutePromise, handlerOverride = param.handlerOverride, scopedContext = param.scopedContext;
                    isAction = isMutationMethod(request.method);
                    type = isAction ? "action" : "loader";
                    runHandler = function(handler) {
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error('You cannot call the handler for a route which defines a boolean "'.concat(type, '" [routeId: ').concat(match.route.id, "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    unstable_pattern: unstable_pattern,
                                    params: match.params,
                                    context: scopedContext
                                }
                            ].concat((0, $fsSDT._)(ctx !== void 0 ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                var val, e;
                                return (0, $Csf8W.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                handlerOverride ? handlerOverride(function(ctx) {
                                                    return actualHandler(ctx);
                                                }) : actualHandler()
                                            ];
                                        case 1:
                                            val = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "data",
                                                    result: val
                                                }
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "error",
                                                    result: e
                                                }
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = isAction ? match.route.action : match.route.loader;
                    if (!(lazyHandlerPromise || lazyRoutePromise)) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            // Ensure all lazy route promises are resolved before continuing
                            lazyHandlerPromise,
                            lazyRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $leE2g._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== void 0) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        lazyHandlerPromise
                    ];
                case 4:
                    _state.sent();
                    handler2 = isAction ? match.route.action : match.route.loader;
                    if (!handler2) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler2),
                            lazyRoutePromise
                        ])
                    ];
                case 5:
                    ref = (0, $leE2g._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0], ref;
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else return [
                        2,
                        {
                            type: "data" /* data */ ,
                            result: void 0
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).apply(this, arguments);
}
function parseResponseBody(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var contentType;
        return (0, $Csf8W.__generator)(this, function(_state) {
            contentType = response.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) return [
                2,
                response.body == null ? null : response.json()
            ];
            return [
                2,
                response.text()
            ];
        });
    })();
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var _result_init, _result_init1, result, type, data2, e, _result_init2, _result_init3, _result_init4;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        parseResponseBody(result)
                    ];
                case 2:
                    data2 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: e
                        }
                    ];
                case 4:
                    if (type === "error" /* error */ ) return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: new ErrorResponseImpl(result.status, result.statusText, data2),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: data2,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 5:
                    if (type === "error" /* error */ ) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: result.data,
                                    statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                                    headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                            return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: dataWithResponseInitToErrorResponse(result),
                                    statusCode: isRouteErrorResponse(result) ? result.status : void 0,
                                    headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: "error" /* error */ ,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : void 0
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result.data,
                            statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
                            headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result
                        }
                    ];
            }
        });
    })();
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!isAbsoluteUrl(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (isAbsoluteUrl(location)) {
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $leE2g._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $leE2g._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult) {
    var isStaticHandler = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, skipLoaderErrorBubbling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = (0, $5RfYb._)({}, pendingActionResult[0], pendingError);
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    revalidatingFetchers.filter(function(f) {
        return !f.matches || f.matches.some(function(m) {
            return m.shouldLoad;
        });
    }).forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        if (controller && controller.signal.aborted) return;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $ctBui._)((0, $6GCxi._)({}, errors), (0, $5RfYb._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = Object.entries(newLoaderData).filter(function(param) {
        var _param = (0, $leE2g._)(param, 2), v = _param[1];
        return v !== ResetLoaderDataSymbol;
    }).reduce(function(merged, param) {
        var _param = (0, $leE2g._)(param, 2), k = _param[0], v = _param[1];
        merged[k] = v;
        return merged;
    }, {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $5RfYb._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $fsSDT._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method, ' request to "').concat(pathname, '" but did not provide a `loader` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "'.concat(routeId, '" does not match URL "').concat(pathname, '"');
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "'.concat(pathname, '"');
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method.toUpperCase(), ' request to "').concat(pathname, '" but did not provide an `action` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (method) errorMessage = 'Invalid request method "'.concat(method.toUpperCase(), '"');
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $leE2g._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath((0, $ctBui._)((0, $6GCxi._)({}, parsedPath), {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new ErrorResponseImpl((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function isDataStrategyResults(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) === "object" && Object.entries(result).every(function(param) {
        var _param = (0, $leE2g._)(param, 2), key = _param[0], value = _param[1];
        return typeof key === "string" && isDataStrategyResult(value);
    });
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $5f0Cq._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    var fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $leE2g._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $leE2g._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $fsSDT._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (".concat(error, ")."));
        }
    }
}
function createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var e;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var e;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
var DataRouterContext = $fClfl.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = $fClfl.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var RSCRouterContext = $fClfl.createContext(false);
function useIsRSCRouterContext() {
    return $12aPv.useContext(RSCRouterContext);
}
var ViewTransitionContext = $fClfl.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = $fClfl.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = $fClfl.createContext(null);
AwaitContext.displayName = "Await";
var AwaitContextProvider = function(props) {
    return $fClfl.createElement(AwaitContext.Provider, props);
};
var NavigationContext = $fClfl.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = $fClfl.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = $fClfl.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = $fClfl.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
function useHref(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    invariant(useInRouterContext(), "useHref() may be used only in the context of a <Router> component.");
    var _React2_useContext = $12aPv.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function useInRouterContext() {
    return $12aPv.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), "useLocation() may be used only in the context of a <Router> component.");
    return $12aPv.useContext(LocationContext).location;
}
function useNavigationType() {
    return $12aPv.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), "useMatch() may be used only in the context of a <Router> component.");
    var pathname = useLocation().pathname;
    return $12aPv.useMemo(function() {
        return matchPath(pattern, decodePath(pathname));
    }, [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function useIsomorphicLayoutEffect(cb) {
    var isStatic = $12aPv.useContext(NavigationContext).static;
    if (!isStatic) $12aPv.useLayoutEffect(cb);
}
function useNavigate() {
    var isDataRoute = $12aPv.useContext(RouteContext).isDataRoute;
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), "useNavigate() may be used only in the context of a <Router> component.");
    var dataRouterContext = $12aPv.useContext(DataRouterContext);
    var _React2_useContext = $12aPv.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var matches = $12aPv.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    var activeRef = $12aPv.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $12aPv.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = $fClfl.createContext(null);
function useOutletContext() {
    return $12aPv.useContext(OutletContext);
}
function useOutlet(context) {
    var outlet = $12aPv.useContext(RouteContext).outlet;
    return $12aPv.useMemo(function() {
        return outlet && /* @__PURE__ */ $fClfl.createElement(OutletContext.Provider, {
            value: context
        }, outlet);
    }, [
        outlet,
        context
    ]);
}
function useParams() {
    var matches = $12aPv.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function useResolvedPath(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var matches = $12aPv.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return $12aPv.useMemo(function() {
        return resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    invariant(useInRouterContext(), "useRoutes() may be used only in the context of a <Router> component.");
    var navigator = $12aPv.useContext(NavigationContext).navigator;
    var _React2_useContext = $12aPv.useContext(RouteContext), parentMatches = _React2_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        var parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), 'You rendered descendant <Routes> (or called `useRoutes()`) at "'.concat(parentPathname, '" (under <Route path="').concat(parentPath, '">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won\'t match anymore and therefore the child routes will never render.\n\nPlease change the parent <Route path="').concat(parentPath, '"> to <Route path="').concat(parentPath === "/" ? "*" : "".concat(parentPath, "/*"), '">.'));
    }
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        var parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), 'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'.concat(parentPathnameBase, '" but pathname "').concat(parsedLocationArg.pathname, '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, 'No routes matched location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" '));
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, 'Matched leaf route at location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
    }
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $fClfl.createElement(LocationContext.Provider, {
        value: {
            location: (0, $6GCxi._)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = isRouteErrorResponse(error) ? "".concat(error.status, " ").concat(error.statusText) : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, /* @__PURE__ */ $fClfl.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $fClfl.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $fClfl.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $fClfl.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, /* @__PURE__ */ $fClfl.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $fClfl.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $fClfl.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ $fClfl.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React2_Component) {
    "use strict";
    (0, $h6w6E._)(RenderErrorBoundary, _React2_Component);
    function RenderErrorBoundary(props) {
        (0, $7lhcp._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $07dqX._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $8BtP9._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("React Router caught the following error during render", error);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== void 0 ? /* @__PURE__ */ $fClfl.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /* @__PURE__ */ $fClfl.createElement(RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                return {
                    error: props.error !== void 0 ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($fClfl.Component);
function RenderedRoute(param) {
    var routeContext = param.routeContext, match = param.match, children = param.children;
    var dataRouterContext = $12aPv.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $fClfl.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches) {
    var parentMatches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dataRouterState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, unstable_onError = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, future = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    var errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0;
        });
        invariant(errorIndex >= 0, "Could not find a matching route for errors on route IDs: ".concat(Object.keys(errors).join(",")));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors2 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    var onError = dataRouterState && unstable_onError ? function(error, errorInfo) {
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        unstable_onError(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            unstable_pattern: getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $fClfl.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $fClfl.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $fClfl.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext(hookName) {
    var ctx = $12aPv.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    var state = $12aPv.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    var route = $12aPv.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, "".concat(hookName, ' can only be used on routes that contain a unique "id"'));
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    var state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function useRevalidator() {
    var dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    var state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    var revalidate = $12aPv.useCallback(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dataRouterContext.router.revalidate()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        dataRouterContext.router
    ]);
    return $12aPv.useMemo(function() {
        return {
            revalidate: revalidate,
            state: state.revalidation
        };
    }, [
        revalidate,
        state.revalidation
    ]);
}
function useMatches() {
    var _useDataRouterState = useDataRouterState("useMatches" /* UseMatches */ ), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $12aPv.useMemo(function() {
        return matches.map(function(m) {
            return convertRouteMatchToUiMatch(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    var state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    var state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    var state = useDataRouterState("useActionData" /* UseActionData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    var _state_errors;
    var error = $12aPv.useContext(RouteErrorContext);
    var state = useDataRouterState("useRouteError" /* UseRouteError */ );
    var routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function useAsyncValue() {
    var value = $12aPv.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function useAsyncError() {
    var value = $12aPv.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    var _useDataRouterContext = useDataRouterContext("useBlocker" /* UseBlocker */ ), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = useDataRouterState("useBlocker" /* UseBlocker */ );
    var _React2_useState = (0, $leE2g._)($12aPv.useState(""), 2), blockerKey = _React2_useState[0], setBlockerKey = _React2_useState[1];
    var blockerFunction = $12aPv.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: (0, $ctBui._)((0, $6GCxi._)({}, currentLocation), {
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $ctBui._)((0, $6GCxi._)({}, nextLocation), {
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $12aPv.useEffect(function() {
        var key = String(++blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    $12aPv.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    var router = useDataRouterContext("useNavigate" /* UseNavigateStable */ ).router;
    var id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    var activeRef = $12aPv.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $12aPv.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        warning(activeRef.current, navigateEffectWarning);
                        if (!activeRef.current) return [
                            2
                        ];
                        if (!(typeof to === "number")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            router.navigate(to)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.navigate(to, (0, $6GCxi._)({
                                fromRouteId: id
                            }, options))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
function useRoute() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _state_actionData;
    var currentRouteId = useCurrentRouteId("useRoute" /* UseRoute */ );
    var _args_;
    var id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    var state = useDataRouterState("useRoute" /* UseRoute */ );
    var route = state.matches.find(function(param) {
        var route2 = param.route;
        return route2.id === id;
    });
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var USE_OPTIMISTIC = "useOptimistic";
var useOptimisticImpl = $6mMqj[USE_OPTIMISTIC];
var stableUseOptimisticSetter = function() {
    return void 0;
};
function useOptimisticSafe(val) {
    if (useOptimisticImpl) return useOptimisticImpl(val);
    else return [
        val,
        stableUseOptimisticSetter
    ];
}
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $6mMqj.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $6mMqj.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $6mMqj.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var hydrationRouteProperties = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: hydrationRouteProperties,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
var Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $7lhcp._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
function RouterProvider(param) {
    var router = param.router, reactDomFlushSyncImpl = param.flushSync, unstable_onError = param.unstable_onError, unstable_useTransitions = param.unstable_useTransitions;
    var _React3_useState = (0, $leE2g._)($6mMqj.useState(router.state), 2), _state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var _useOptimisticSafe = (0, $leE2g._)(useOptimisticSafe(_state), 2), state = _useOptimisticSafe[0], setOptimisticState = _useOptimisticSafe[1];
    var _React3_useState1 = (0, $leE2g._)($6mMqj.useState(), 2), pendingState = _React3_useState1[0], setPendingState = _React3_useState1[1];
    var _React3_useState2 = (0, $leE2g._)($6mMqj.useState({
        isTransitioning: false
    }), 2), vtContext = _React3_useState2[0], setVtContext = _React3_useState2[1];
    var _React3_useState3 = (0, $leE2g._)($6mMqj.useState(), 2), renderDfd = _React3_useState3[0], setRenderDfd = _React3_useState3[1];
    var _React3_useState4 = (0, $leE2g._)($6mMqj.useState(), 2), transition = _React3_useState4[0], setTransition = _React3_useState4[1];
    var _React3_useState5 = (0, $leE2g._)($6mMqj.useState(), 2), interruption = _React3_useState5[0], setInterruption = _React3_useState5[1];
    var fetcherData = $6mMqj.useRef(/* @__PURE__ */ new Map());
    var setState = $6mMqj.useCallback(function(newState, param) {
        var deletedFetchers = param.deletedFetchers, newErrors = param.newErrors, flushSync = param.flushSync, viewTransitionOpts = param.viewTransitionOpts;
        if (newErrors && unstable_onError) Object.values(newErrors).forEach(function(error) {
            var _newState_matches_;
            var _newState_matches__params;
            return unstable_onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                unstable_pattern: getRoutePattern(newState.matches)
            });
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        var isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(function() {
                return setStateImpl(newState);
            });
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $6mMqj.startTransition(function() {
                if (unstable_useTransitions === true) setOptimisticState(function(s) {
                    return getOptimisticRouterState(s, newState);
                });
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(function() {
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            var t = router.window.document.startViewTransition(function() {
                reactDomFlushSyncImpl(function() {
                    return setStateImpl(newState);
                });
            });
            t.finished.finally(function() {
                reactDomFlushSyncImpl(function() {
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(function() {
                return setTransition(t);
            });
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        unstable_onError
    ]);
    $6mMqj.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $6mMqj.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    $6mMqj.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition2 = router.window.document.startViewTransition(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (unstable_useTransitions === false) setStateImpl(newState);
                                else $6mMqj.startTransition(function() {
                                    if (unstable_useTransitions === true) setOptimisticState(function(s) {
                                        return getOptimisticRouterState(s, newState);
                                    });
                                    setStateImpl(newState);
                                });
                                return [
                                    4,
                                    renderPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            transition2.finished.finally(function() {
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $6mMqj.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $6mMqj.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $6mMqj.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state2, opts) {
                return router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state2, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $6mMqj.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        };
    }, [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $6mMqj.createElement($6mMqj.Fragment, null, /* @__PURE__ */ $6mMqj.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $6mMqj.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $6mMqj.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $6mMqj.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $6mMqj.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions === true
    }, /* @__PURE__ */ $6mMqj.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
function getOptimisticRouterState(currentState, newState) {
    return (0, $ctBui._)((0, $6GCxi._)({}, currentState), {
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    });
}
var MemoizedDataRoutes = $6mMqj.memo(DataRoutes);
function DataRoutes(param) {
    var routes = param.routes, future = param.future, state = param.state, unstable_onError = param.unstable_onError;
    return useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function MemoryRouter(param) {
    var basename = param.basename, children = param.children, initialEntries = param.initialEntries, initialIndex = param.initialIndex, unstable_useTransitions = param.unstable_useTransitions;
    var historyRef = $6mMqj.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React3_useState = (0, $leE2g._)($6mMqj.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var setState = $6mMqj.useCallback(function(newState) {
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $6mMqj.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        unstable_useTransitions
    ]);
    $6mMqj.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $6mMqj.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function Navigate(param) {
    var to = param.to, replace2 = param.replace, state = param.state, relative = param.relative;
    invariant(useInRouterContext(), "<Navigate> may be used only in the context of a <Router> component.");
    var _React3_useContext = $6mMqj.useContext(NavigationContext), isStatic = _React3_useContext.static;
    warning(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    var matches = $6mMqj.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate();
    var path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $6mMqj.useEffect(function() {
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(props) {
    invariant(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
function Router(param) {
    var tmp = param.basename, basenameProp = tmp === void 0 ? "/" : tmp, _param_children = param.children, children = _param_children === void 0 ? null : _param_children, locationProp = param.location, _param_navigationType = param.navigationType, navigationType = _param_navigationType === void 0 ? "POP" /* Pop */  : _param_navigationType, navigator = param.navigator, tmp1 = param.static, staticProp = tmp1 === void 0 ? false : tmp1, unstable_useTransitions = param.unstable_useTransitions;
    invariant(!useInRouterContext(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $6mMqj.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        };
    }, [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $6mMqj.useMemo(function() {
        var trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    warning(locationContext != null, '<Router basename="'.concat(basename, '"> is not able to match the URL "').concat(pathname).concat(search).concat(hash, "\" because it does not start with the basename, so the <Router> won't render anything."));
    if (locationContext == null) return null;
    return /* @__PURE__ */ $6mMqj.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $6mMqj.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
function Routes(param) {
    var children = param.children, location = param.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await(param) {
    var children = param.children, errorElement = param.errorElement, resolve = param.resolve;
    var dataRouterContext = $6mMqj.useContext(DataRouterContext);
    var dataRouterStateContext = $6mMqj.useContext(DataRouterStateContext);
    var onError = $6mMqj.useCallback(function(error, errorInfo) {
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.unstable_onError && dataRouterStateContext) dataRouterContext.unstable_onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            unstable_pattern: getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $6mMqj.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $6mMqj.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = /*#__PURE__*/ function(_React3_Component) {
    "use strict";
    (0, $h6w6E._)(AwaitErrorBoundary, _React3_Component);
    function AwaitErrorBoundary(props) {
        (0, $7lhcp._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $07dqX._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $8BtP9._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = 0 /* pending */ ;
                if (!(resolve instanceof Promise)) {
                    status = 1 /* success */ ;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    status = 2 /* error */ ;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {});
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    promise = resolve;
                    status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
                } else {
                    status = 0 /* pending */ ;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data2) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data2;
                            }
                        });
                    }, function(error) {
                        var _this_props_onError, _this_props;
                        (_this_props_onError = (_this_props = _this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                        Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === 2 /* error */  && !errorElement) throw promise._error;
                if (status === 2 /* error */ ) return /* @__PURE__ */ $6mMqj.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === 1 /* success */ ) return /* @__PURE__ */ $6mMqj.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($6mMqj.Component);
function ResolveAwait(param) {
    var children = param.children;
    var data2 = useAsyncValue();
    var toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $6mMqj.createElement($6mMqj.Fragment, null, toRender);
}
function createRoutesFromChildren(children) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var routes = [];
    $6mMqj.Children.forEach(children, function(element, index) {
        if (!$6mMqj.isValidElement(element)) return;
        var treePath = (0, $fsSDT._)(parentPath).concat([
            index
        ]);
        if (element.type === $6mMqj.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, "[".concat(typeof element.type === "string" ? element.type : element.type.name, "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"));
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
function useRouteComponentProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        matches: useMatches()
    };
}
function WithComponentProps(param) {
    var children = param.children;
    var props = useRouteComponentProps();
    return $6mMqj.cloneElement(children, props);
}
function withComponentProps(Component4) {
    return function WithComponentProps2() {
        var props = useRouteComponentProps();
        return $6mMqj.createElement(Component4, props);
    };
}
function useHydrateFallbackProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData()
    };
}
function WithHydrateFallbackProps(param) {
    var children = param.children;
    var props = useHydrateFallbackProps();
    return $6mMqj.cloneElement(children, props);
}
function withHydrateFallbackProps(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        var props = useHydrateFallbackProps();
        return $6mMqj.createElement(HydrateFallback, props);
    };
}
function useErrorBoundaryProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        error: useRouteError()
    };
}
function WithErrorBoundaryProps(param) {
    var children = param.children;
    var props = useErrorBoundaryProps();
    return $6mMqj.cloneElement(children, props);
}
function withErrorBoundaryProps(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        var props = useErrorBoundaryProps();
        return $6mMqj.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams() {
    var init = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo2, key) {
        var value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, '"'.concat(encType, '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "').concat(defaultEncType, '"'));
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if (isFormElement(target)) {
        var attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? stripBasename(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? "".concat(name, ".") : "";
                formData.append("".concat(prefix, "x"), "0");
                formData.append("".concat(prefix, "y"), "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var HOLE = -1;
var NAN = -2;
var NEGATIVE_INFINITY = -3;
var NEGATIVE_ZERO = -4;
var NULL = -5;
var POSITIVE_INFINITY = -6;
var UNDEFINED = -7;
var TYPE_BIGINT = "B";
var TYPE_DATE = "D";
var TYPE_ERROR = "E";
var TYPE_MAP = "M";
var TYPE_NULL_OBJECT = "N";
var TYPE_PROMISE = "P";
var TYPE_REGEXP = "R";
var TYPE_SET = "S";
var TYPE_SYMBOL = "Y";
var TYPE_URL = "U";
var TYPE_PREVIOUS_RESOLVED = "Z";
var Deferred2 = function Deferred2() {
    "use strict";
    var _this = this;
    (0, $7lhcp._)(this, Deferred2);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
function createLineSplittingTransform() {
    var decoder = new TextDecoder();
    var leftover = "";
    return new TransformStream({
        transform: function(chunk, controller) {
            var str = decoder.decode(chunk, {
                stream: true
            });
            var parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var part = _step.value;
                    controller.enqueue(part);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        flush: function(controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function flatten(input) {
    var indices = this.indices;
    var existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return UNDEFINED;
    if (input === null) return NULL;
    if (Number.isNaN(input)) return NAN;
    if (input === Number.POSITIVE_INFINITY) return POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return NEGATIVE_ZERO;
    var index = this.index++;
    indices.set(input, index);
    stringify.call(this, input, index);
    return index;
}
function stringify(input, index) {
    var _this = this;
    var _this1 = this, deferred = _this1.deferred, plugins = _this1.plugins, postPlugins = _this1.postPlugins;
    var str = this.stringified;
    var stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        var _stack_pop = (0, $leE2g._)(stack.pop(), 2), input2 = _stack_pop[0], index2 = _stack_pop[1];
        var partsForObj = function(obj) {
            return Object.keys(obj).map(function(k) {
                return '"_'.concat(flatten.call(_this, k), '":').concat(flatten.call(_this, obj[k]));
            }).join(",");
        };
        var error = null;
        switch(typeof input2 === "undefined" ? "undefined" : (0, $5f0Cq._)(input2)){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = '["'.concat(TYPE_BIGINT, '","').concat(input2, '"]');
                break;
            case "symbol":
                {
                    var keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = '["'.concat(TYPE_SYMBOL, '",').concat(JSON.stringify(keyFor), "]");
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = "".concat(NULL);
                        break;
                    }
                    var isArray = Array.isArray(input2);
                    var pluginHandled = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!isArray && plugins) try {
                        for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var plugin = _step.value;
                            var pluginResult = plugin(input2);
                            if (Array.isArray(pluginResult)) {
                                pluginHandled = true;
                                var _pluginResult = (0, $4L6tH._)(pluginResult), pluginIdentifier = _pluginResult[0], rest = _pluginResult.slice(1);
                                str[index2] = "[".concat(JSON.stringify(pluginIdentifier));
                                if (rest.length > 0) str[index2] += ",".concat(rest.map(function(v) {
                                    return flatten.call(_this, v);
                                }).join(","));
                                str[index2] += "]";
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!pluginHandled) {
                        var result = isArray ? "[" : "{";
                        if (isArray) {
                            for(var i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? flatten.call(this, input2[i]) : HOLE);
                            str[index2] = "".concat(result, "]");
                        } else if (input2 instanceof Date) {
                            var dateTime = input2.getTime();
                            str[index2] = '["'.concat(TYPE_DATE, '",').concat(Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime, "]");
                        } else if (input2 instanceof URL) str[index2] = '["'.concat(TYPE_URL, '",').concat(JSON.stringify(input2.href), "]");
                        else if (input2 instanceof RegExp) str[index2] = '["'.concat(TYPE_REGEXP, '",').concat(JSON.stringify(input2.source), ",").concat(JSON.stringify(input2.flags), "]");
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = '["'.concat(TYPE_SET, '",').concat((0, $fsSDT._)(input2).map(function(val) {
                                return flatten.call(_this, val);
                            }).join(","), "]");
                            else str[index2] = '["'.concat(TYPE_SET, '"]');
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = '["'.concat(TYPE_MAP, '",').concat((0, $fsSDT._)(input2).flatMap(function(param) {
                                var _param = (0, $leE2g._)(param, 2), k = _param[0], v = _param[1];
                                return [
                                    flatten.call(_this, k),
                                    flatten.call(_this, v)
                                ];
                            }).join(","), "]");
                            else str[index2] = '["'.concat(TYPE_MAP, '"]');
                        } else if (input2 instanceof Promise) {
                            str[index2] = '["'.concat(TYPE_PROMISE, '",').concat(index2, "]");
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = '["'.concat(TYPE_ERROR, '",').concat(JSON.stringify(input2.message));
                            if (input2.name !== "Error") str[index2] += ",".concat(JSON.stringify(input2.name));
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = '["'.concat(TYPE_NULL_OBJECT, '",{').concat(partsForObj(input2), "}]");
                        else if (isPlainObject2(input2)) str[index2] = "{".concat(partsForObj(input2), "}");
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    var isArray1 = Array.isArray(input2);
                    var pluginHandled1 = false;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (!isArray1 && plugins) try {
                        for(var _iterator1 = plugins[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var plugin1 = _step1.value;
                            var pluginResult1 = plugin1(input2);
                            if (Array.isArray(pluginResult1)) {
                                pluginHandled1 = true;
                                var _pluginResult1 = (0, $4L6tH._)(pluginResult1), pluginIdentifier1 = _pluginResult1[0], rest1 = _pluginResult1.slice(1);
                                str[index2] = "[".concat(JSON.stringify(pluginIdentifier1));
                                if (rest1.length > 0) str[index2] += ",".concat(rest1.map(function(v) {
                                    return flatten.call(_this, v);
                                }).join(","));
                                str[index2] += "]";
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (!pluginHandled1) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            var pluginHandled2 = false;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (postPlugins) try {
                for(var _iterator2 = postPlugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var plugin2 = _step2.value;
                    var pluginResult2 = plugin2(input2);
                    if (Array.isArray(pluginResult2)) {
                        pluginHandled2 = true;
                        var _pluginResult2 = (0, $4L6tH._)(pluginResult2), pluginIdentifier2 = _pluginResult2[0], rest2 = _pluginResult2.slice(1);
                        str[index2] = "[".concat(JSON.stringify(pluginIdentifier2));
                        if (rest2.length > 0) str[index2] += ",".concat(rest2.map(function(v) {
                            return flatten.call(_this, v);
                        }).join(","));
                        str[index2] += "]";
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            if (!pluginHandled2) throw error;
        }
    }
}
var objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject2(thing) {
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function unflatten(parsed) {
    var _this = this, hydrated = _this.hydrated, values = _this.values;
    if (typeof parsed === "number") return hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    var startIndex = values.length;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            values.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    hydrated.length = values.length;
    return hydrate.call(this, startIndex);
}
function hydrate(index) {
    var _loop = function() {
        var _stack_pop = (0, $leE2g._)(stack.pop(), 2), index2 = _stack_pop[0], set = _stack_pop[1];
        switch(index2){
            case UNDEFINED:
                set(void 0);
                return "continue";
            case NULL:
                set(null);
                return "continue";
            case NAN:
                set(NaN);
                return "continue";
            case POSITIVE_INFINITY:
                set(Infinity);
                return "continue";
            case NEGATIVE_INFINITY:
                set(-Infinity);
                return "continue";
            case NEGATIVE_ZERO:
                set(-0);
                return "continue";
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            return "continue";
        }
        var value = values[index2];
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) !== "object") {
            hydrated[index2] = value;
            set(value);
            return "continue";
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                var _value = (0, $leE2g._)(value, 3), type = _value[0], b = _value[1], c = _value[2];
                switch(type){
                    case TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        return "continue";
                    case TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        return "continue";
                    case TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        return "continue";
                    case TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        return "continue";
                    case TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        return "continue";
                    case TYPE_SET:
                        var newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(var i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            function(v) {
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        return "continue";
                    case TYPE_MAP:
                        var _loop = function(i1) {
                            var r = [];
                            stack.push([
                                value[i1 + 1],
                                function(v) {
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i1],
                                function(k) {
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(function() {
                                map.set(r[0], r[1]);
                            });
                        };
                        var map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(var i1 = value.length - 2; i1 > 0; i1 -= 2)_loop(i1);
                        set(map);
                        return "continue";
                    case TYPE_NULL_OBJECT:
                        var obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop1 = function() {
                                var key = _step.value;
                                var r = [];
                                stack.push([
                                    b[key],
                                    function(v) {
                                        r[1] = v;
                                    }
                                ]);
                                stack.push([
                                    Number(key.slice(1)),
                                    function(k) {
                                        r[0] = k;
                                    }
                                ]);
                                postRun.push(function() {
                                    obj[r[0]] = r[1];
                                });
                            };
                            for(var _iterator = Object.keys(b).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        set(obj);
                        return "continue";
                    case TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            var d = new Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        return "continue";
                    case TYPE_ERROR:
                        var _value1 = (0, $leE2g._)(value, 3), message = _value1[1], errorType = _value1[2];
                        var error = errorType && globalObj && globalObj[errorType] ? new globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        return "continue";
                    case TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        return "continue";
                    default:
                        if (Array.isArray(plugins)) {
                            var _loop2 = function(i2) {
                                var v = vals[i2];
                                stack.push([
                                    v,
                                    function(v2) {
                                        r[i2] = v2;
                                    }
                                ]);
                            };
                            var r = [];
                            var vals = value.slice(1);
                            for(var i2 = 0; i2 < vals.length; i2++)_loop2(i2);
                            postRun.push(function() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var plugin = _step.value;
                                        var result2 = plugin.apply(void 0, [
                                            value[0]
                                        ].concat((0, $fsSDT._)(r)));
                                        if (result2) {
                                            set(hydrated[index2] = result2.value);
                                            return;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                throw new SyntaxError();
                            });
                            return "continue";
                        }
                        throw new SyntaxError();
                }
            } else {
                var _loop3 = function(i3) {
                    var n = value[i3];
                    if (n !== HOLE) stack.push([
                        n,
                        function(v) {
                            array[i3] = v;
                        }
                    ]);
                };
                var array = [];
                hydrated[index2] = array;
                for(var i3 = 0; i3 < value.length; i3++)_loop3(i3);
                set(array);
                return "continue";
            }
        } else {
            var object = {};
            hydrated[index2] = object;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop4 = function() {
                    var key = _step1.value;
                    var r = [];
                    stack.push([
                        value[key],
                        function(v) {
                            r[1] = v;
                        }
                    ]);
                    stack.push([
                        Number(key.slice(1)),
                        function(k) {
                            r[0] = k;
                        }
                    ]);
                    postRun.push(function() {
                        object[r[0]] = r[1];
                    });
                };
                for(var _iterator1 = Object.keys(value).reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop4();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            set(object);
            return "continue";
        }
    };
    var _this = this, hydrated = _this.hydrated, values = _this.values, deferred = _this.deferred, plugins = _this.plugins;
    var result;
    var stack = [
        [
            index,
            function(v) {
                result = v;
            }
        ]
    ];
    var postRun = [];
    while(stack.length > 0)_loop();
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
function decode(readable, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var plugins, done, reader, decoder, decoded, donePromise;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    plugins = (options !== null && options !== void 0 ? options : {}).plugins;
                    done = new Deferred2();
                    reader = readable.pipeThrough(createLineSplittingTransform()).getReader();
                    decoder = {
                        values: [],
                        hydrated: [],
                        deferred: {},
                        plugins: plugins
                    };
                    return [
                        4,
                        decodeInitial.call(decoder, reader)
                    ];
                case 1:
                    decoded = _state.sent();
                    donePromise = done.promise;
                    if (decoded.done) done.resolve();
                    else donePromise = decodeDeferred.call(decoder, reader).then(done.resolve).catch(function(reason) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(decoder.deferred)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var deferred = _step.value;
                                deferred.reject(reason);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        done.reject(reason);
                    });
                    return [
                        2,
                        {
                            done: donePromise.then(function() {
                                return reader.closed;
                            }),
                            value: decoded.value
                        }
                    ];
            }
        });
    })();
}
function decodeInitial(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var read, line;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    if (!read.value) throw new SyntaxError();
                    try {
                        line = JSON.parse(read.value);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    return [
                        2,
                        {
                            done: read.done,
                            value: unflatten.call(this, line)
                        }
                    ];
            }
        });
    }).call(this);
}
function decodeDeferred(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var read, line, colonIndex, deferredId, deferred, lineData, jsonLine, value, colonIndex1, deferredId1, deferred1, lineData1, jsonLine1, value1;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!!read.done) return [
                        3,
                        4
                    ];
                    if (!read.value) return [
                        3,
                        2
                    ];
                    line = read.value;
                    switch(line[0]){
                        case TYPE_PROMISE:
                            {
                                colonIndex = line.indexOf(":");
                                deferredId = Number(line.slice(1, colonIndex));
                                deferred = this.deferred[deferredId];
                                if (!deferred) throw new Error("Deferred ID ".concat(deferredId, " not found in stream"));
                                lineData = line.slice(colonIndex + 1);
                                jsonLine = void 0;
                                try {
                                    jsonLine = JSON.parse(lineData);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value = unflatten.call(this, jsonLine);
                                deferred.resolve(value);
                                break;
                            }
                        case TYPE_ERROR:
                            {
                                colonIndex1 = line.indexOf(":");
                                deferredId1 = Number(line.slice(1, colonIndex1));
                                deferred1 = this.deferred[deferredId1];
                                if (!deferred1) throw new Error("Deferred ID ".concat(deferredId1, " not found in stream"));
                                lineData1 = line.slice(colonIndex1 + 1);
                                jsonLine1 = void 0;
                                try {
                                    jsonLine1 = JSON.parse(lineData1);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value1 = unflatten.call(this, jsonLine1);
                                deferred1.reject(value1);
                                break;
                            }
                        default:
                            throw new SyntaxError();
                    }
                    return [
                        4,
                        reader.read()
                    ];
                case 3:
                    read = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function encode(input, options) {
    var _ref = options !== null && options !== void 0 ? options : {}, plugins = _ref.plugins, postPlugins = _ref.postPlugins, signal = _ref.signal;
    var encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    var textEncoder = new TextEncoder();
    var lastSentIndex = 0;
    var readable = new ReadableStream({
        start: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var id, seenPromises, raceDone, racePromise, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = flatten.call(encoder, input);
                            if (Array.isArray(id)) throw new Error("This should never happen");
                            if (id < 0) controller.enqueue(textEncoder.encode("".concat(id, "\n")));
                            else {
                                controller.enqueue(textEncoder.encode("[".concat(encoder.stringified.join(","), "]\n")));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                            seenPromises = /* @__PURE__ */ new WeakSet();
                            if (!Object.keys(encoder.deferred).length) return [
                                3,
                                4
                            ];
                            racePromise = new Promise(function(resolve, reject) {
                                raceDone = resolve;
                                if (signal) {
                                    var rejectPromise = function() {
                                        return reject(signal.reason || new Error("Signal was aborted."));
                                    };
                                    if (signal.aborted) rejectPromise();
                                    else signal.addEventListener("abort", function(event) {
                                        rejectPromise();
                                    });
                                }
                            });
                            _state.label = 1;
                        case 1:
                            if (!(Object.keys(encoder.deferred).length > 0)) return [
                                3,
                                3
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                _loop = function() {
                                    var _step_value = (0, $leE2g._)(_step.value, 2), deferredId = _step_value[0], deferred = _step_value[1];
                                    if (seenPromises.has(deferred)) return "continue";
                                    seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                    encoder.deferred[Number(deferredId)] = Promise.race([
                                        racePromise,
                                        deferred
                                    ]).then(function(resolved) {
                                        var id2 = flatten.call(encoder, resolved);
                                        if (Array.isArray(id2)) {
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                            encoder.index++;
                                            lastSentIndex++;
                                        } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":").concat(id2, "\n")));
                                        else {
                                            var values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":[").concat(values, "]\n")));
                                            lastSentIndex = encoder.stringified.length - 1;
                                        }
                                    }, function(reason) {
                                        if (!reason || (typeof reason === "undefined" ? "undefined" : (0, $5f0Cq._)(reason)) !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                        var id2 = flatten.call(encoder, reason);
                                        if (Array.isArray(id2)) {
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                            encoder.index++;
                                            lastSentIndex++;
                                        } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":").concat(id2, "\n")));
                                        else {
                                            var values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":[").concat(values, "]\n")));
                                            lastSentIndex = encoder.stringified.length - 1;
                                        }
                                    }).finally(function() {
                                        delete encoder.deferred[Number(deferredId)];
                                    }));
                                };
                                for(_iterator = Object.entries(encoder.deferred)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                4,
                                Promise.race(Object.values(encoder.deferred))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                1
                            ];
                        case 3:
                            raceDone();
                            _state.label = 4;
                        case 4:
                            return [
                                4,
                                Promise.all(Object.values(encoder.deferred))
                            ];
                        case 5:
                            _state.sent();
                            controller.close();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
function createRequestInit(request) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var init, contentType, _, _1;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    init = {
                        signal: request.signal
                    };
                    if (!(request.method !== "GET")) return [
                        3,
                        8
                    ];
                    init.method = request.method;
                    contentType = request.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        2
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    _ = JSON.stringify;
                    return [
                        4,
                        request.json()
                    ];
                case 1:
                    init.body = _.apply(JSON, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        8
                    ];
                case 2:
                    if (!(contentType && /\btext\/plain\b/.test(contentType))) return [
                        3,
                        4
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    return [
                        4,
                        request.text()
                    ];
                case 3:
                    init.body = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!(contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType))) return [
                        3,
                        6
                    ];
                    _1 = URLSearchParams.bind;
                    return [
                        4,
                        request.text()
                    ];
                case 5:
                    init.body = new (_1.apply(URLSearchParams, [
                        void 0,
                        _state.sent()
                    ]));
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        request.formData()
                    ];
                case 7:
                    init.body = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        init
                    ];
            }
        });
    })();
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, function(match) {
        return ESCAPE_LOOKUP[match];
    });
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
var SingleFetchNoResultError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $h6w6E._)(SingleFetchNoResultError, Error1);
    function SingleFetchNoResultError() {
        (0, $7lhcp._)(this, SingleFetchNoResultError);
        return (0, $07dqX._)(this, SingleFetchNoResultError, arguments);
    }
    return SingleFetchNoResultError;
}((0, $1Qmny._)(Error));
var SINGLE_FETCH_REDIRECT_STATUS = 202;
var NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function StreamTransfer(param) {
    var context = param.context, identifier = param.identifier, reader = param.reader, textDecoder = param.textDecoder, nonce = param.nonce;
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    var streamCache = context.renderMeta.streamCache;
    var promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then(function(result) {
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch(function(e) {
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    var _promise_result = promise.result, done = _promise_result.done, value = _promise_result.value;
    var scriptTag = value ? /* @__PURE__ */ $fClfl.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.enqueue(".concat(escapeHtml(JSON.stringify(value)), ");")
        }
    }) : null;
    if (done) return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, scriptTag, /* @__PURE__ */ $fClfl.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.close();"
        }
    }));
    else return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, scriptTag, /* @__PURE__ */ $fClfl.createElement($6mMqj.Suspense, null, /* @__PURE__ */ $fClfl.createElement(StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function getTurboStreamSingleFetchDataStrategy(getRouter, manifest, routeModules, ssr, basename) {
    var dataStrategy = getSingleFetchDataStrategyImpl(getRouter, function(match) {
        var manifestRoute = manifest.routes[match.route.id];
        invariant2(manifestRoute, "Route not found in manifest");
        var routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule === null || routeModule === void 0 ? void 0 : routeModule.shouldRevalidate)
        };
    }, fetchAndDecodeViaTurboStream, ssr, basename);
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            return (0, $Csf8W.__generator)(this, function(_state) {
                return [
                    2,
                    args.runClientMiddleware(dataStrategy)
                ];
            });
        })();
    };
}
function getSingleFetchDataStrategyImpl(getRouter, getRouteInfo, fetchAndDecode, ssr, basename) {
    var shouldAllowOptOut = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function() {
        return true;
    };
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var request, matches, fetcherKey, router, foundRevalidatingServerLoader;
            return (0, $Csf8W.__generator)(this, function(_state) {
                request = args.request, matches = args.matches, fetcherKey = args.fetcherKey;
                router = getRouter();
                if (request.method !== "GET") return [
                    2,
                    singleFetchActionStrategy(args, fetchAndDecode, basename)
                ];
                foundRevalidatingServerLoader = matches.some(function(m) {
                    var _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                    return m.shouldCallHandler() && hasLoader && !hasClientLoader;
                });
                if (!ssr && !foundRevalidatingServerLoader) return [
                    2,
                    nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename)
                ];
                if (fetcherKey) return [
                    2,
                    singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename)
                ];
                return [
                    2,
                    singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut)
                ];
            });
        })();
    };
}
function singleFetchActionStrategy(args, fetchAndDecode, basename) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var actionMatch, actionStatus, result;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    actionMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    invariant2(actionMatch, "No action match found");
                    actionStatus = void 0;
                    return [
                        4,
                        actionMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                var result2;
                                return (0, $Csf8W.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handler(function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                        var _ref, data2, status;
                                                        return (0, $Csf8W.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        fetchAndDecode(args, basename, [
                                                                            actionMatch.route.id
                                                                        ])
                                                                    ];
                                                                case 1:
                                                                    _ref = _state.sent(), data2 = _ref.data, status = _ref.status;
                                                                    actionStatus = status;
                                                                    return [
                                                                        2,
                                                                        unwrapSingleFetchResult(data2, actionMatch.route.id)
                                                                    ];
                                                            }
                                                        });
                                                    })();
                                                })
                                            ];
                                        case 1:
                                            result2 = _state.sent();
                                            return [
                                                2,
                                                result2
                                            ];
                                    }
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (isResponse(result.result) || isRouteErrorResponse(result.result) || isDataWithResponseInit(result.result)) return [
                        2,
                        (0, $5RfYb._)({}, actionMatch.route.id, result)
                    ];
                    return [
                        2,
                        (0, $5RfYb._)({}, actionMatch.route.id, {
                            type: result.type,
                            result: data(result.result, actionStatus)
                        })
                    ];
            }
        });
    })();
}
function nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var matchesToLoad, results;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldCallHandler();
                    });
                    results = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve(function(handler) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                    var hasClientLoader, routeId, result, _tmp, e;
                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    5,
                                                    ,
                                                    6
                                                ]);
                                                hasClientLoader = getRouteInfo(m).hasClientLoader;
                                                routeId = m.route.id;
                                                if (!hasClientLoader) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    handler(function() {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                            var _ref, data2;
                                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            fetchAndDecode(args, basename, [
                                                                                routeId
                                                                            ])
                                                                        ];
                                                                    case 1:
                                                                        _ref = _state.sent(), data2 = _ref.data;
                                                                        return [
                                                                            2,
                                                                            unwrapSingleFetchResult(data2, routeId)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                _tmp = _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    handler()
                                                ];
                                            case 3:
                                                _tmp = _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                result = _tmp;
                                                results[m.route.id] = {
                                                    type: "data",
                                                    result: result
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                e = _state.sent();
                                                results[m.route.id] = {
                                                    type: "error",
                                                    result: e
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 6:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            });
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename) {
    var shouldAllowOptOut = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
        return true;
    };
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var routesParams, foundOptOutRoute, routeDfds, singleFetchDfd, results, resolvePromise, isInitialLoad, targetRoutes, data2, e;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routesParams = /* @__PURE__ */ new Set();
                    foundOptOutRoute = false;
                    routeDfds = args.matches.map(function() {
                        return createDeferred2();
                    });
                    singleFetchDfd = createDeferred2();
                    results = {};
                    resolvePromise = Promise.all(args.matches.map(function(m, i) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                return [
                                    2,
                                    m.resolve(function(handler) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                            var routeId, _getRouteInfo, hasLoader, hasClientLoader, hasShouldRevalidate, defaultShouldRevalidate, shouldCall, result, e, result1, e1;
                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        routeDfds[i].resolve();
                                                        routeId = m.route.id;
                                                        _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader, hasShouldRevalidate = _getRouteInfo.hasShouldRevalidate;
                                                        defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
                                                        shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
                                                        if (!shouldCall) {
                                                            foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                                                            hasLoader && // for a route with a server loader,
                                                            hasShouldRevalidate === true);
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        if (!(shouldAllowOptOut(m) && hasClientLoader)) return [
                                                            3,
                                                            5
                                                        ];
                                                        if (hasLoader) foundOptOutRoute = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                                    var _ref, data2;
                                                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    fetchAndDecode(args, basename, [
                                                                                        routeId
                                                                                    ])
                                                                                ];
                                                                            case 1:
                                                                                _ref = _state.sent(), data2 = _ref.data;
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 2:
                                                        result = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        if (hasLoader) routesParams.add(routeId);
                                                        _state.label = 6;
                                                    case 6:
                                                        _state.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                                    var data2;
                                                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    singleFetchDfd.promise
                                                                                ];
                                                                            case 1:
                                                                                data2 = _state.sent();
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 7:
                                                        result1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 8:
                                                        e1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 9:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    })
                                ];
                            });
                        })();
                    }));
                    return [
                        4,
                        Promise.all(routeDfds.map(function(d) {
                            return d.promise;
                        }))
                    ];
                case 1:
                    _state.sent();
                    isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
                    if (!((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive)) return [
                        3,
                        2
                    ];
                    singleFetchDfd.resolve({
                        routes: {}
                    });
                    return [
                        3,
                        6
                    ];
                case 2:
                    targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? (0, $fsSDT._)(routesParams.keys()) : void 0;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetchAndDecode(args, basename, targetRoutes)
                    ];
                case 4:
                    data2 = _state.sent();
                    singleFetchDfd.resolve(data2.data);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    singleFetchDfd.reject(e);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        4,
                        resolvePromise
                    ];
                case 7:
                    _state.sent();
                    return [
                        4,
                        bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results)
                    ];
                case 8:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var middlewareError, fetchedData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, routeResult, _results_match_route_id, e;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        singleFetchPromise
                    ];
                case 1:
                    fetchedData = _state.sent();
                    if ("routes" in fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                if (match.route.id in fetchedData.routes) {
                                    routeResult = fetchedData.routes[match.route.id];
                                    if ("error" in routeResult) {
                                        ;
                                        middlewareError = routeResult.error;
                                        if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                                            type: "error",
                                            result: middlewareError
                                        };
                                        break;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (middlewareError !== void 0) Array.from(routesParams.values()).forEach(function(routeId) {
                        if (results[routeId].result instanceof SingleFetchNoResultError) results[routeId].result = middlewareError;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var fetcherMatch, routeId, result;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetcherMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    invariant2(fetcherMatch, "No fetcher match found");
                    routeId = fetcherMatch.route.id;
                    return [
                        4,
                        fetcherMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                return (0, $Csf8W.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        handler(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                var _ref, data2;
                                                return (0, $Csf8W.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                fetchAndDecode(args, basename, [
                                                                    routeId
                                                                ])
                                                            ];
                                                        case 1:
                                                            _ref = _state.sent(), data2 = _ref.data;
                                                            return [
                                                                2,
                                                                unwrapSingleFetchResult(data2, routeId)
                                                            ];
                                                    }
                                                });
                                            })();
                                        })
                                    ];
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0, $5RfYb._)({}, fetcherMatch.route.id, result)
                    ];
            }
        });
    })();
}
function stripIndexParam(url) {
    var indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    var indexValuesToKeep = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var indexValue = _step.value;
            if (indexValue) indexValuesToKeep.push(indexValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = indexValuesToKeep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var toKeep = _step1.value;
            url.searchParams.append("index", toKeep);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return url;
}
function singleFetchUrl(reqUrl, basename, extension) {
    var url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.".concat(extension);
    else if (basename && stripBasename(url.pathname, basename) === "/") url.pathname = "".concat(basename.replace(/\/$/, ""), "/_root.").concat(extension);
    else url.pathname = "".concat(url.pathname.replace(/\/$/, ""), ".").concat(extension);
    return url;
}
function fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var request, url, res, _tmp, _, _tmp1, routes, decoded, data2, typed, typed1, routeId, e;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    url = singleFetchUrl(request.url, basename, "data");
                    if (request.method === "GET") {
                        url = stripIndexParam(url);
                        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
                    }
                    _tmp = [
                        url
                    ];
                    return [
                        4,
                        createRequestInit(request)
                    ];
                case 1:
                    return [
                        4,
                        fetch.apply(void 0, _tmp.concat([
                            _state.sent()
                        ]))
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res.status >= 400 && !res.headers.has("X-Remix-Response"))) return [
                        3,
                        4
                    ];
                    _ = ErrorResponseImpl.bind;
                    _tmp1 = [
                        void 0,
                        res.status,
                        res.statusText
                    ];
                    return [
                        4,
                        res.text()
                    ];
                case 3:
                    throw new (_.apply(ErrorResponseImpl, _tmp1.concat([
                        _state.sent()
                    ])));
                case 4:
                    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return [
                        2,
                        {
                            status: SINGLE_FETCH_REDIRECT_STATUS,
                            data: {
                                redirect: {
                                    redirect: res.headers.get("X-Remix-Redirect"),
                                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                                    replace: res.headers.get("X-Remix-Replace") === "true"
                                }
                            }
                        }
                    ];
                    if (NO_BODY_STATUS_CODES.has(res.status)) {
                        routes = {};
                        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                            data: void 0
                        };
                        return [
                            2,
                            {
                                status: res.status,
                                data: {
                                    routes: routes
                                }
                            }
                        ];
                    }
                    invariant2(res.body, "No response body to decode");
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        decodeViaTurboStream(res.body, window)
                    ];
                case 6:
                    decoded = _state.sent();
                    if (request.method === "GET") {
                        typed = decoded.value;
                        if (SingleFetchRedirectSymbol in typed) data2 = {
                            redirect: typed[SingleFetchRedirectSymbol]
                        };
                        else data2 = {
                            routes: typed
                        };
                    } else {
                        typed1 = decoded.value;
                        routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
                        invariant2(routeId, "No routeId found for single fetch call decoding");
                        if ("redirect" in typed1) data2 = {
                            redirect: typed1
                        };
                        else data2 = {
                            routes: (0, $5RfYb._)({}, routeId, typed1)
                        };
                    }
                    return [
                        2,
                        {
                            status: res.status,
                            data: data2
                        }
                    ];
                case 7:
                    e = _state.sent();
                    throw new Error("Unable to decode turbo-stream response");
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function decodeViaTurboStream(body, global) {
    return decode(body, {
        plugins: [
            function(type) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (type === "SanitizedError") {
                    var _rest = (0, $leE2g._)(rest, 3), name = _rest[0], message = _rest[1], stack = _rest[2];
                    var Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    var error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    var _rest1 = (0, $leE2g._)(rest, 3), data2 = _rest1[0], status = _rest1[1], statusText = _rest1[2];
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: (0, $5RfYb._)({}, SingleFetchRedirectSymbol, rest[0])
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        var _result_redirect = result.redirect, location = _result_redirect.redirect, revalidate = _result_redirect.revalidate, reload = _result_redirect.reload, replace2 = _result_redirect.replace, status = _result_redirect.status;
        throw redirect(location, {
            status: status,
            headers: (0, $6GCxi._)({}, revalidate ? {
                "X-Remix-Revalidate": "yes"
            } : null, reload ? {
                "X-Remix-Reload-Document": "yes"
            } : null, replace2 ? {
                "X-Remix-Replace": "yes"
            } : null)
        });
    }
    var routeResult = result.routes[routeId];
    if (routeResult == null) throw new SingleFetchNoResultError('No result found for routeId "'.concat(routeId, '"'));
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error('Invalid response found for routeId "'.concat(routeId, '"'));
}
function createDeferred2() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var e;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var e;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
// lib/dom/ssr/routeModules.ts
function loadRouteModule(route, routeModulesCache) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var routeModule, error;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (route.id in routeModulesCache) return [
                        2,
                        routeModulesCache[route.id]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.module)
                    ];
                case 2:
                    routeModule = _state.sent();
                    routeModulesCache[route.id] = routeModule;
                    return [
                        2,
                        routeModule
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error loading route module `".concat(route.module, "`, reloading page..."));
                    console.error(error);
                    if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
                    $bfb15cfc20a4c318$import_meta.hot) throw error;
                    window.location.reload();
                    return [
                        2,
                        new Promise(function() {})
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    var descriptors = matches.map(function(match) {
        var _module_links;
        var module = routeModules[match.route.id];
        var route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map(function(href) {
                return {
                    rel: "stylesheet",
                    href: href
                };
            }) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    var preloads = getModuleLinkHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
function getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map(function(href) {
        return {
            rel: "stylesheet",
            href: href
        };
    });
}
function prefetchRouteCss(route) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var descriptors;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css) return [
                        2
                    ];
                    descriptors = getRouteCssDescriptors(route);
                    return [
                        4,
                        Promise.all(descriptors.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLinks(route, routeModule) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var _descriptors, _descriptors1, descriptors, styleLinks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, descriptor;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css && !routeModule.links || !isPreloadSupported()) return [
                        2
                    ];
                    descriptors = [];
                    if (route.css) (_descriptors = descriptors).push.apply(_descriptors, (0, $fsSDT._)(getRouteCssDescriptors(route)));
                    if (routeModule.links) (_descriptors1 = descriptors).push.apply(_descriptors1, (0, $fsSDT._)(routeModule.links()));
                    if (descriptors.length === 0) return [
                        2
                    ];
                    styleLinks = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = descriptors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            descriptor = _step.value;
                            if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $ctBui._)((0, $6GCxi._)({}, descriptor), {
                                rel: "preload",
                                as: "style"
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        Promise.all(styleLinks.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLink(descriptor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        return (0, $Csf8W.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector('link[rel="stylesheet"][href="'.concat(descriptor.href, '"]'))) return resolve();
                    var link = document.createElement("link");
                    Object.assign(link, descriptor);
                    function removeLink() {
                        if (document.head.contains(link)) document.head.removeChild(link);
                    }
                    link.onload = function() {
                        removeLink();
                        resolve();
                    };
                    link.onerror = function() {
                        removeLink();
                        resolve();
                    };
                    document.head.appendChild(link);
                })
            ];
        });
    })();
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var links;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(matches.map(function(match) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                var route, mod;
                                return (0, $Csf8W.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            route = manifest.routes[match.route.id];
                                            if (!route) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                loadRouteModule(route, routeModules)
                                            ];
                                        case 1:
                                            mod = _state.sent();
                                            return [
                                                2,
                                                mod.links ? mod.links() : []
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                []
                                            ];
                                    }
                                });
                            })();
                        }))
                    ];
                case 1:
                    links = _state.sent();
                    return [
                        2,
                        dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter(function(link) {
                            return link.rel === "stylesheet" || link.rel === "preload";
                        }).map(function(link) {
                            return link.rel === "stylesheet" ? (0, $ctBui._)((0, $6GCxi._)({}, link), {
                                rel: "prefetch",
                                as: "style"
                            }) : (0, $ctBui._)((0, $6GCxi._)({}, link), {
                                rel: "prefetch"
                            });
                        }))
                    ];
            }
        });
    })();
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    var isNew = function(match, index) {
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    var matchPathChanged = function(match, index) {
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter(function(match, index) {
        return isNew(match, index) || matchPathChanged(match, index);
    });
    if (mode === "data") return nextMatches.filter(function(match, index) {
        var manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            var routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifest) {
    var includeHydrateFallback = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).includeHydrateFallback;
    return dedupeHrefs(matches.map(function(match) {
        var route = manifest.routes[match.route.id];
        if (!route) return [];
        var hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return (0, $fsSDT._)(new Set(hrefs));
}
function sortKeys(obj) {
    var sorted = {};
    var keys = Object.keys(obj).sort();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            sorted[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    var set = /* @__PURE__ */ new Set();
    var preloadsSet = new Set(preloads);
    return descriptors.reduce(function(deduped, descriptor) {
        var alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        var key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    var el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
function RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $fClfl.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, ENABLE_DEV_WARNINGS ? /* @__PURE__ */ $fClfl.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: '\n              console.log(\n                "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this " +\n                "when your app is loading JS modules and/or running `clientLoader` " +\n                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +\n                "for more information."\n              );\n            '
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    var routes = {};
    Object.values(manifest).forEach(function(route) {
        if (route) {
            var parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    var Component4 = getRouteModuleComponent(routeModule);
    var HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    var ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? function() {
        return /* @__PURE__ */ $fClfl.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        });
    } : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $6GCxi._)({}, Component4 ? {
        element: /* @__PURE__ */ $fClfl.createElement(routeModule.Layout, null, /* @__PURE__ */ $fClfl.createElement(Component4, null))
    } : {
        Component: Component4
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $fClfl.createElement(routeModule.Layout, null, /* @__PURE__ */ $fClfl.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $fClfl.createElement(routeModule.Layout, null, /* @__PURE__ */ $fClfl.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode) {
    var parentId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", routesByParentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : groupRoutesByParentId(manifest), spaModeLazyPromise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Promise.resolve({
        Component: function() {
            return null;
        }
    });
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        var dataRoute = (0, $ctBui._)((0, $6GCxi._)({}, getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? function() {
                return spaModeLazyPromise;
            } : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? function() {
                return null;
            } : void 0
        });
        var children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        var fn = type === "action" ? "serverAction()" : "serverLoader()";
        var msg = "You are trying to call ".concat(fn, " on a route that does not have a server ").concat(type, ' (routeId: "').concat(route.id, '")');
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    var article = type === "clientAction" ? "a" : "an";
    var msg = 'Route "'.concat(routeId, '" does not have ').concat(article, " ").concat(type, ", but you are trying to submit to it. To fix this, please add ").concat(article, " `").concat(type, "` function to the route");
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    var parentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", routesByParentId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : groupRoutesByParentId(manifest), needsRevalidation = arguments.length > 7 ? arguments[7] : void 0;
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        function prefetchStylesAndCallHandler(handler) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var cachedModule, linkPrefetchPromise;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cachedModule = routeModulesCache[route.id];
                            linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                2,
                                4
                            ]);
                            return [
                                2,
                                handler()
                            ];
                        case 2:
                            return [
                                4,
                                linkPrefetchPromise
                            ];
                        case 3:
                            _state.sent();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        var dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $ctBui._)((0, $6GCxi._)({}, dataRoute, getRouteComponents(route, routeModule, isSpaMode)), {
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            }));
            var hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            var initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            var hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            var initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            var isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, unstable_pattern = param.unstable_pattern;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var result;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    ,
                                    2,
                                    3
                                ]);
                                return [
                                    4,
                                    prefetchStylesAndCallHandler(function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                invariant2(routeModule, "No `routeModule` available for critical-route loader");
                                                if (!routeModule.clientLoader) return [
                                                    2,
                                                    fetchServerLoader(singleFetch)
                                                ];
                                                return [
                                                    2,
                                                    routeModule.clientLoader({
                                                        request: request,
                                                        params: params,
                                                        context: context,
                                                        unstable_pattern: unstable_pattern,
                                                        serverLoader: function() {
                                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                                return (0, $Csf8W.__generator)(this, function(_state) {
                                                                    preventInvalidServerHandlerCall("loader", route);
                                                                    if (isHydrationRequest) {
                                                                        if (hasInitialData) return [
                                                                            2,
                                                                            initialData
                                                                        ];
                                                                        if (hasInitialError) throw initialError;
                                                                    }
                                                                    return [
                                                                        2,
                                                                        fetchServerLoader(singleFetch)
                                                                    ];
                                                                });
                                                            })();
                                                        }
                                                    })
                                                ];
                                            });
                                        })();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                isHydrationRequest = false;
                                return [
                                    7
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, unstable_pattern = param.unstable_pattern;
                return prefetchStylesAndCallHandler(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            invariant2(routeModule, "No `routeModule` available for critical-route action");
                            if (!routeModule.clientAction) {
                                if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                                return [
                                    2,
                                    fetchServerAction(singleFetch)
                                ];
                            }
                            return [
                                2,
                                routeModule.clientAction({
                                    request: request,
                                    params: params,
                                    context: context,
                                    unstable_pattern: unstable_pattern,
                                    serverAction: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                preventInvalidServerHandlerCall("action", route);
                                                return [
                                                    2,
                                                    fetchServerAction(singleFetch)
                                                ];
                                            });
                                        })();
                                    }
                                })
                            ];
                        });
                    })();
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    return fetchServerLoader(singleFetch);
                });
            };
            if (!route.hasClientAction) dataRoute.action = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            };
            var lazyRoutePromise;
            function getLazyRoute() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!lazyRoutePromise) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                lazyRoutePromise = function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                        var routeModulePromise;
                                        return (0, $Csf8W.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(route.clientLoaderModule || route.clientActionModule)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            return setTimeout(resolve, 0);
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    routeModulePromise = loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                                                    prefetchRouteModuleChunks(route);
                                                    return [
                                                        4,
                                                        routeModulePromise
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    })();
                                }();
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var clientLoader, _tmp;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientLoaderModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientLoader = _tmp.clientLoader;
                                    invariant2(clientLoader, "No `clientLoader` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientLoader((0, $ctBui._)((0, $6GCxi._)({}, args), {
                                                serverLoader: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                        return (0, $Csf8W.__generator)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("loader", route);
                                                            return [
                                                                2,
                                                                fetchServerLoader(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                action: route.hasClientAction ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var clientActionPromise, clientAction;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                                    prefetchRouteModuleChunks(route);
                                    return [
                                        4,
                                        clientActionPromise
                                    ];
                                case 1:
                                    clientAction = _state.sent().clientAction;
                                    invariant2(clientAction, "No `clientAction` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientAction((0, $ctBui._)((0, $6GCxi._)({}, args), {
                                                serverAction: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                        return (0, $Csf8W.__generator)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("action", route);
                                                            return [
                                                                2,
                                                                fetchServerAction(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                middleware: route.hasClientMiddleware ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var clientMiddleware, _tmp;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientMiddlewareModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientMiddleware = _tmp.clientMiddleware;
                                    invariant2(clientMiddleware, "No `clientMiddleware` export found");
                                    return [
                                        2,
                                        clientMiddleware
                                    ];
                            }
                        });
                    })();
                } : void 0,
                shouldRevalidate: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var lazyRoute;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    lazyRoute = _state.sent();
                                    return [
                                        2,
                                        getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation)
                                    ];
                            }
                        });
                    })();
                },
                handle: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().handle
                                    ];
                            }
                        });
                    })();
                },
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().Component
                                    ];
                            }
                        });
                    })();
                },
                ErrorBoundary: route.hasErrorBoundary ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().ErrorBoundary
                                    ];
                            }
                        });
                    })();
                } : void 0
            };
        }
        var children = createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        var myParams = path ? compilePath(path)[1].map(function(p) {
            return p.paramName;
        }) : [];
        var didParamsChange = function(opts) {
            return myParams.some(function(p) {
                return opts.currentParams[p] !== opts.nextParams[p];
            });
        };
        if (route.shouldRevalidate) {
            var fn = route.shouldRevalidate;
            return function(opts) {
                return fn((0, $ctBui._)((0, $6GCxi._)({}, opts), {
                    defaultShouldRevalidate: didParamsChange(opts)
                }));
            };
        } else return function(opts) {
            return didParamsChange(opts);
        };
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    var handledRevalidation = false;
    return function(arg) {
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
function loadRouteModuleWithBlockingLinks(route, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var routeModulePromise, prefetchRouteCssPromise, routeModule;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeModulePromise = loadRouteModule(route, routeModules);
                    prefetchRouteCssPromise = prefetchRouteCss(route);
                    return [
                        4,
                        routeModulePromise
                    ];
                case 1:
                    routeModule = _state.sent();
                    return [
                        4,
                        Promise.all([
                            prefetchRouteCssPromise,
                            prefetchStyleLinks(route, routeModule)
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            Component: getRouteModuleComponent(routeModule),
                            ErrorBoundary: routeModule.ErrorBoundary,
                            clientMiddleware: routeModule.clientMiddleware,
                            clientAction: routeModule.clientAction,
                            clientLoader: routeModule.clientLoader,
                            handle: routeModule.handle,
                            links: routeModule.links,
                            meta: routeModule.meta,
                            shouldRevalidate: routeModule.shouldRevalidate
                        }
                    ];
            }
        });
    })();
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    var isEmptyObject = (0, $5f0Cq._)(routeModule.default) === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function getPartialManifest(_param, router) {
    var sri = _param.sri, manifest = (0, $8MJI4._)(_param, [
        "sri"
    ]);
    var routeIds = new Set(router.state.matches.map(function(m) {
        return m.route.id;
    }));
    var segments = router.state.location.pathname.split("/").filter(Boolean);
    var paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push("/".concat(segments.join("/")));
        segments.pop();
    }
    paths.forEach(function(path) {
        var matches = matchRoutes(router.routes, path, router.basename);
        if (matches) matches.forEach(function(m) {
            return routeIds.add(m.route.id);
        });
    });
    var initialRoutes = (0, $fsSDT._)(routeIds).reduce(function(acc, id) {
        return Object.assign(acc, (0, $5RfYb._)({}, id, manifest.routes[id]));
    }, {});
    return (0, $ctBui._)((0, $6GCxi._)({}, manifest), {
        routes: initialRoutes,
        sri: sri ? true : void 0
    });
}
function getPatchRoutesOnNavigationFunction(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return function(param) {
        var path = param.path, patch = param.patch, signal = param.signal, fetcherKey = param.fetcherKey;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (discoveredPaths.has(path)) return [
                            2
                        ];
                        return [
                            4,
                            fetchAndApplyManifestPatches([
                                path
                            ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
}
function useFogOFWarDiscovery(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $12aPv.useEffect(function() {
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            var path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            var pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!discoveredPaths.has(pathname)) nextPaths.add(pathname);
        }
        function fetchPatches() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var lazyPaths, e;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
                            lazyPaths = Array.from(nextPaths.keys()).filter(function(path) {
                                if (discoveredPaths.has(path)) {
                                    nextPaths.delete(path);
                                    return false;
                                }
                                return true;
                            });
                            if (lazyPaths.length === 0) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error("Failed to fetch manifest patches", e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        var debouncedFetchPatches = debounce(fetchPatches, 100);
        fetchPatches();
        var observer = new MutationObserver(function() {
            return debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function getManifestPath(_manifestPath, basename) {
    var manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return "".concat(basename).concat(manifestPath).replace(/\/+/g, "/");
}
var MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
function fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var searchParams, url, serverPatches, res, _, e, knownRoutes, patches, parentIds;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    searchParams = new URLSearchParams();
                    searchParams.set("paths", paths.sort().join(","));
                    searchParams.set("version", manifest.version);
                    url = new URL(getManifestPath(manifestPath, basename), window.location.origin);
                    url.search = searchParams.toString();
                    if (url.toString().length > URL_LIMIT) {
                        nextPaths.clear();
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    return [
                        4,
                        fetch(url, {
                            signal: signal
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        3
                    ];
                    throw new Error("".concat(res.status, " ").concat(res.statusText));
                case 3:
                    if (!(res.status === 204 && res.headers.has("X-Remix-Reload-Document"))) return [
                        3,
                        5
                    ];
                    if (!errorReloadPath) {
                        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                        return [
                            2
                        ];
                    }
                    try {
                        if (sessionStorage.getItem(MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                            console.error("Unable to discover routes due to manifest version mismatch.");
                            return [
                                2
                            ];
                        }
                        sessionStorage.setItem(MANIFEST_VERSION_STORAGE_KEY, manifest.version);
                    } catch (e) {}
                    window.location.href = errorReloadPath;
                    console.warn("Detected manifest version mismatch, reloading...");
                    return [
                        4,
                        new Promise(function() {})
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    if (!(res.status >= 400)) return [
                        3,
                        7
                    ];
                    _ = Error.bind;
                    return [
                        4,
                        res.text()
                    ];
                case 6:
                    throw new (_.apply(Error, [
                        void 0,
                        _state.sent()
                    ]));
                case 7:
                    try {
                        sessionStorage.removeItem(MANIFEST_VERSION_STORAGE_KEY);
                    } catch (e) {}
                    return [
                        4,
                        res.json()
                    ];
                case 8:
                    serverPatches = _state.sent();
                    return [
                        3,
                        10
                    ];
                case 9:
                    e = _state.sent();
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) return [
                        2
                    ];
                    throw e;
                case 10:
                    knownRoutes = new Set(Object.keys(manifest.routes));
                    patches = Object.values(serverPatches).reduce(function(acc, route) {
                        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
                        return acc;
                    }, {});
                    Object.assign(manifest.routes, patches);
                    paths.forEach(function(p) {
                        return addToFifoQueue(p, discoveredPaths);
                    });
                    parentIds = /* @__PURE__ */ new Set();
                    Object.values(patches).forEach(function(patch) {
                        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
                    });
                    parentIds.forEach(function(parentId) {
                        return patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, ssr, isSpaMode, parentId));
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        var first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    var timeoutId;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            return callback.apply(void 0, (0, $fsSDT._)(args));
        }, wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    var context = $12aPv.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    var context = $12aPv.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = $fClfl.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    var context = $12aPv.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    var frameworkContext = $12aPv.useContext(FrameworkContext);
    var _React8_useState = (0, $leE2g._)($12aPv.useState(false), 2), maybePrefetch = _React8_useState[0], setMaybePrefetch = _React8_useState[1];
    var _React8_useState1 = (0, $leE2g._)($12aPv.useState(false), 2), shouldPrefetch = _React8_useState1[0], setShouldPrefetch = _React8_useState1[1];
    var onFocus = theirElementProps.onFocus, onBlur = theirElementProps.onBlur, onMouseEnter = theirElementProps.onMouseEnter, onMouseLeave = theirElementProps.onMouseLeave, onTouchStart = theirElementProps.onTouchStart;
    var ref = $12aPv.useRef(null);
    $12aPv.useEffect(function() {
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            var observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return function() {
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $12aPv.useEffect(function() {
        if (maybePrefetch) {
            var id = setTimeout(function() {
                setShouldPrefetch(true);
            }, 100);
            return function() {
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    var setIntent = function() {
        setMaybePrefetch(true);
    };
    var cancelIntent = function() {
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return function(event) {
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        var errorIdx = matches.findIndex(function(m) {
            return errors[m.route.id] !== void 0;
        });
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var CRITICAL_CSS_DATA_ATTRIBUTE = "data-react-router-critical-css";
function Links(param) {
    var nonce = param.nonce;
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules, criticalCss = _useFrameworkContext.criticalCss;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches;
    var matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var keyedLinks = $12aPv.useMemo(function() {
        return getKeyedLinksForMatches(matches, routeModules, manifest);
    }, [
        matches,
        routeModules,
        manifest
    ]);
    var _obj, _obj1;
    return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $fClfl.createElement("style", (_obj = {}, (0, $5RfYb._)(_obj, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $5RfYb._)(_obj, "dangerouslySetInnerHTML", {
        __html: criticalCss
    }), _obj)) : null, (typeof criticalCss === "undefined" ? "undefined" : (0, $5f0Cq._)(criticalCss)) === "object" ? /* @__PURE__ */ $fClfl.createElement("link", (_obj1 = {}, (0, $5RfYb._)(_obj1, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $5RfYb._)(_obj1, "rel", "stylesheet"), (0, $5RfYb._)(_obj1, "href", criticalCss.href), (0, $5RfYb._)(_obj1, "nonce", nonce), _obj1)) : null, keyedLinks.map(function(param) {
        var key = param.key, link = param.link;
        return isPageLinkDescriptor(link) ? /* @__PURE__ */ $fClfl.createElement(PrefetchPageLinks, (0, $6GCxi._)({
            key: key,
            nonce: nonce
        }, link)) : /* @__PURE__ */ $fClfl.createElement("link", (0, $6GCxi._)({
            key: key,
            nonce: nonce
        }, link));
    }));
}
function PrefetchPageLinks(_param) {
    var page = _param.page, linkProps = (0, $8MJI4._)(_param, [
        "page"
    ]);
    var router = useDataRouterContext2().router;
    var matches = $12aPv.useMemo(function() {
        return matchRoutes(router.routes, page, router.basename);
    }, [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $fClfl.createElement(PrefetchPageLinksImpl, (0, $6GCxi._)({
        page: page,
        matches: matches
    }, linkProps));
}
function useKeyedPrefetchLinks(matches) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _React8_useState = (0, $leE2g._)($12aPv.useState([]), 2), keyedPrefetchLinks = _React8_useState[0], setKeyedPrefetchLinks = _React8_useState[1];
    $12aPv.useEffect(function() {
        var interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then(function(links) {
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return function() {
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function PrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $8MJI4._)(_param, [
        "page",
        "matches"
    ]);
    var location = useLocation();
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var basename = useDataRouterContext2().basename;
    var _useDataRouterStateContext = useDataRouterStateContext(), loaderData = _useDataRouterStateContext.loaderData, matches = _useDataRouterStateContext.matches;
    var newMatchesForData = $12aPv.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var newMatchesForAssets = $12aPv.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var dataHrefs = $12aPv.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var routesParams = /* @__PURE__ */ new Set();
        var foundOptOutRoute = false;
        nextMatches.forEach(function(m) {
            var _routeModules_m_route_id;
            var manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some(function(m2) {
                return m2.route.id === m.route.id;
            }) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        var url = singleFetchUrl(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter(function(m) {
            return routesParams.has(m.route.id);
        }).map(function(m) {
            return m.route.id;
        }).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    var moduleHrefs = $12aPv.useMemo(function() {
        return getModuleLinkHrefs(newMatchesForAssets, manifest);
    }, [
        newMatchesForAssets,
        manifest
    ]);
    var keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $fClfl.createElement("link", (0, $6GCxi._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }), moduleHrefs.map(function(href) {
        return /* @__PURE__ */ $fClfl.createElement("link", (0, $6GCxi._)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps));
    }), keyedPrefetchLinks.map(function(param) {
        var key = param.key, link = param.link;
        return(// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $fClfl.createElement("link", (0, $6GCxi._)({
            key: key,
            nonce: linkProps.nonce
        }, link)));
    }));
}
function Meta() {
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches, loaderData = _useDataRouterStateContext.loaderData;
    var location = useLocation();
    var _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    var meta = [];
    var leafMeta = null;
    var matches = [];
    for(var i = 0; i < _matches.length; i++){
        var _match = _matches[i];
        var routeId = _match.route.id;
        var data2 = loaderData[routeId];
        var params = _match.params;
        var routeModule = routeModules[routeId];
        var routeMeta = [];
        var match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? (0, $fsSDT._)(routeModule.meta) : routeModule.meta;
        else if (leafMeta) routeMeta = (0, $fsSDT._)(leafMeta);
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = (0, $fsSDT._)(routeMeta);
        leafMeta = meta;
    }
    return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, meta.flat().map(function(metaProps) {
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            var tagName = metaProps.tagName, rest = (0, $8MJI4._)(metaProps, [
                "tagName"
            ]);
            if (!isValidMetaTag(tagName)) {
                console.warn("A meta object uses an invalid tagName: ".concat(tagName, ". Expected either 'link' or 'meta'"));
                return null;
            }
            var Comp = tagName;
            return /* @__PURE__ */ $fClfl.createElement(Comp, (0, $6GCxi._)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $fClfl.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $fClfl.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            var json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $fClfl.createElement("script", {
                key: "script:ld+json:".concat(json),
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: escapeHtml(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $fClfl.createElement("meta", (0, $6GCxi._)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function setIsHydrated() {
    isHydrated = true;
}
function Scripts(scriptProps) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, serverHandoffString = _useFrameworkContext.serverHandoffString, isSpaMode = _useFrameworkContext.isSpaMode, renderMeta = _useFrameworkContext.renderMeta, routeDiscovery = _useFrameworkContext.routeDiscovery, ssr = _useFrameworkContext.ssr;
    var _useDataRouterContext2 = useDataRouterContext2(), router = _useDataRouterContext2.router, isStatic = _useDataRouterContext2.static, staticContext = _useDataRouterContext2.staticContext;
    var _useDataRouterStateContext = useDataRouterStateContext(), routerMatches = _useDataRouterStateContext.matches;
    var isRSCRouterContext = useIsRSCRouterContext();
    var enableFogOfWar = isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    var matches = getActiveMatches(routerMatches, null, isSpaMode);
    $12aPv.useEffect(function() {
        setIsHydrated();
    }, []);
    var initialScripts = $12aPv.useMemo(function() {
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        var streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        var contextScript = staticContext ? "window.__reactRouterContext = ".concat(serverHandoffString, ";").concat(streamScript) : " ";
        var routeModulesScript = !isStatic ? " " : "".concat(((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? "import ".concat(JSON.stringify(manifest.hmr.runtime), ";") : "").concat(!enableFogOfWar ? "import ".concat(JSON.stringify(manifest.url)) : "", ";\n").concat(matches.map(function(match, routeIndex) {
            var routeVarName = "route".concat(routeIndex);
            var manifestEntry = manifest.routes[match.route.id];
            invariant2(manifestEntry, "Route ".concat(match.route.id, " not found in manifest"));
            var clientActionModule = manifestEntry.clientActionModule, clientLoaderModule = manifestEntry.clientLoaderModule, clientMiddlewareModule = manifestEntry.clientMiddlewareModule, hydrateFallbackModule = manifestEntry.hydrateFallbackModule, module = manifestEntry.module;
            var chunks = (0, $fsSDT._)(clientActionModule ? [
                {
                    module: clientActionModule,
                    varName: "".concat(routeVarName, "_clientAction")
                }
            ] : []).concat((0, $fsSDT._)(clientLoaderModule ? [
                {
                    module: clientLoaderModule,
                    varName: "".concat(routeVarName, "_clientLoader")
                }
            ] : []), (0, $fsSDT._)(clientMiddlewareModule ? [
                {
                    module: clientMiddlewareModule,
                    varName: "".concat(routeVarName, "_clientMiddleware")
                }
            ] : []), (0, $fsSDT._)(hydrateFallbackModule ? [
                {
                    module: hydrateFallbackModule,
                    varName: "".concat(routeVarName, "_HydrateFallback")
                }
            ] : []), [
                {
                    module: module,
                    varName: "".concat(routeVarName, "_main")
                }
            ]);
            if (chunks.length === 1) return "import * as ".concat(routeVarName, " from ").concat(JSON.stringify(module), ";");
            var chunkImportsSnippet = chunks.map(function(chunk) {
                return "import * as ".concat(chunk.varName, ' from "').concat(chunk.module, '";');
            }).join("\n");
            var mergedChunksSnippet = "const ".concat(routeVarName, " = {").concat(chunks.map(function(chunk) {
                return "...".concat(chunk.varName);
            }).join(","), "};");
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n"), "\n  ").concat(enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        "window.__reactRouterManifest = ".concat(JSON.stringify(getPartialManifest(manifest, router), null, 2), ";") : "", "\n  window.__reactRouterRouteModules = {").concat(matches.map(function(match, index) {
            return "".concat(JSON.stringify(match.route.id), ":route").concat(index);
        }).join(","), "};\n\nimport(").concat(JSON.stringify(manifest.entry.module), ");");
        return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, /* @__PURE__ */ $fClfl.createElement("script", (0, $ctBui._)((0, $6GCxi._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        })), /* @__PURE__ */ $fClfl.createElement("script", (0, $ctBui._)((0, $6GCxi._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        })));
    }, []);
    var preloads = isHydrated || isRSCRouterContext ? [] : dedupe(manifest.entry.imports.concat(getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    var sri = (0, $5f0Cq._)(manifest.sri) === "object" ? manifest.sri : {};
    warnOnce(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, (0, $5f0Cq._)(manifest.sri) === "object" ? /* @__PURE__ */ $fClfl.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $fClfl.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $fClfl.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map(function(path) {
        return /* @__PURE__ */ $fClfl.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        });
    }), initialScripts);
}
function dedupe(array) {
    return (0, $fsSDT._)(new Set(array));
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var RemixErrorBoundary = /*#__PURE__*/ function(_React9_Component) {
    "use strict";
    (0, $h6w6E._)(RemixErrorBoundary, _React9_Component);
    function RemixErrorBoundary(props) {
        (0, $7lhcp._)(this, RemixErrorBoundary);
        var _this;
        _this = (0, $07dqX._)(this, RemixErrorBoundary, [
            props
        ]);
        _this.state = {
            error: props.error || null,
            location: props.location
        };
        return _this;
    }
    (0, $8BtP9._)(RemixErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.error) return /* @__PURE__ */ $fClfl.createElement(RemixRootDefaultErrorBoundary, {
                    error: this.state.error,
                    isOutsideRemixApp: true
                });
                else return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location) return {
                    error: props.error || null,
                    location: props.location
                };
                return {
                    error: props.error || state.error,
                    location: state.location
                };
            }
        }
    ]);
    return RemixErrorBoundary;
}($fClfl.Component);
function RemixRootDefaultErrorBoundary(param) {
    var error = param.error, isOutsideRemixApp = param.isOutsideRemixApp;
    console.error(error);
    var heyDeveloper = /* @__PURE__ */ $fClfl.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: '\n        console.log(\n          "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."\n        );\n      '
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ $fClfl.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $fClfl.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), ENABLE_DEV_WARNINGS ? heyDeveloper : null);
    var errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        var errorString = error == null ? "Unknown Error" : (typeof error === "undefined" ? "undefined" : (0, $5f0Cq._)(error)) === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $fClfl.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $fClfl.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $fClfl.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell(param) {
    var title = param.title, renderScripts = param.renderScripts, isOutsideRemixApp = param.isOutsideRemixApp, children = param.children;
    var _routeModules_root;
    var routeModules = useFrameworkContext().routeModules;
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $fClfl.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $fClfl.createElement("head", null, /* @__PURE__ */ $fClfl.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $fClfl.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $fClfl.createElement("title", null, title)), /* @__PURE__ */ $fClfl.createElement("body", null, /* @__PURE__ */ $fClfl.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $fClfl.createElement(Scripts, null) : null)));
}
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser) window.__reactRouterVersion = "7.10.1";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createBrowserHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $ctBui._)((0, $6GCxi._)({}, state), {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $leE2g._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        var error = new ErrorConstructor(val.message);
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {}
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function BrowserRouter(param) {
    var basename = param.basename, children = param.children, unstable_useTransitions = param.unstable_useTransitions, window2 = param.window;
    var historyRef = $12aPv.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $leE2g._)($12aPv.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $12aPv.useCallback(function(newState) {
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $6mMqj.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        unstable_useTransitions
    ]);
    $12aPv.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fClfl.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function HashRouter(param) {
    var basename = param.basename, children = param.children, unstable_useTransitions = param.unstable_useTransitions, window2 = param.window;
    var historyRef = $12aPv.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $leE2g._)($12aPv.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $12aPv.useCallback(function(newState) {
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $6mMqj.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        unstable_useTransitions
    ]);
    $12aPv.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fClfl.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function HistoryRouter(param) {
    var basename = param.basename, children = param.children, history = param.history, unstable_useTransitions = param.unstable_useTransitions;
    var _React10_useState = (0, $leE2g._)($12aPv.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $12aPv.useCallback(function(newState) {
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $6mMqj.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        unstable_useTransitions
    ]);
    $12aPv.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $fClfl.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var Link = $6mMqj.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var onClick = _param.onClick, _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, _param_prefetch = _param.prefetch, prefetch = _param_prefetch === void 0 ? "none" : _param_prefetch, relative = _param.relative, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, target = _param.target, to = _param.to, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, rest = (0, $8MJI4._)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition"
    ]);
    var _React10_useContext = $12aPv.useContext(NavigationContext), basename = _React10_useContext.basename, unstable_useTransitions = _React10_useContext.unstable_useTransitions;
    var isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX2.test(to);
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if (isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            warning(false, '<Link to="'.concat(to, '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'));
        }
    }
    var href = useHref(to, {
        relative: relative
    });
    var _usePrefetchBehavior = (0, $leE2g._)(usePrefetchBehavior(prefetch, rest), 3), shouldPrefetch = _usePrefetchBehavior[0], prefetchRef = _usePrefetchBehavior[1], prefetchHandlers = _usePrefetchBehavior[2];
    var internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    var link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $fClfl.createElement("a", (0, $ctBui._)((0, $6GCxi._)({}, rest, prefetchHandlers), {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, link, /* @__PURE__ */ $fClfl.createElement(PrefetchPageLinks, {
        page: href
    })) : link;
});
Link.displayName = "Link";
var NavLink = $6mMqj.forwardRef(function NavLinkWithRef(_param, ref) {
    var tmp = _param["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _param_caseSensitive = _param.caseSensitive, caseSensitive = _param_caseSensitive === void 0 ? false : _param_caseSensitive, tmp1 = _param.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _param_end = _param.end, end = _param_end === void 0 ? false : _param_end, styleProp = _param.style, to = _param.to, viewTransition = _param.viewTransition, children = _param.children, rest = (0, $8MJI4._)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    var path = useResolvedPath(to, {
        relative: rest.relative
    });
    var location = useLocation();
    var routerState = $12aPv.useContext(DataRouterStateContext);
    var _React10_useContext = $12aPv.useContext(NavigationContext), navigator = _React10_useContext.navigator, basename = _React10_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : void 0;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $fClfl.createElement(Link, (0, $ctBui._)((0, $6GCxi._)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = $6mMqj.forwardRef(function(_param, forwardedRef) {
    var _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, fetcherKey = _param.fetcherKey, navigate = _param.navigate, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, _param_method = _param.method, method = _param_method === void 0 ? defaultMethod : _param_method, action = _param.action, onSubmit = _param.onSubmit, relative = _param.relative, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, props = (0, $8MJI4._)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition"
    ]);
    var unstable_useTransitions = $12aPv.useContext(NavigationContext).unstable_useTransitions;
    var submit = useSubmit();
    var formAction = useFormAction(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX2.test(action);
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        var doSubmit = function() {
            return submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition
            });
        };
        if (unstable_useTransitions && navigate !== false) $6mMqj.startTransition(function() {
            return doSubmit();
        });
        else doSubmit();
    };
    return /* @__PURE__ */ $fClfl.createElement("form", (0, $ctBui._)((0, $6GCxi._)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
Form.displayName = "Form";
function ScrollRestoration(_param) {
    var getKey = _param.getKey, storageKey = _param.storageKey, props = (0, $8MJI4._)(_param, [
        "getKey",
        "storageKey"
    ]);
    var remixContext = $12aPv.useContext(FrameworkContext);
    var basename = $12aPv.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    var ssrKey = $12aPv.useMemo(function() {
        if (!remixContext || !getKey) return null;
        var userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    var restoreScroll = (function(storageKey2, restoreKey) {
        if (!window.history.state || !window.history.state.key) {
            var key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            var positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            var storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $fClfl.createElement("script", (0, $ctBui._)((0, $6GCxi._)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: "(".concat(restoreScroll, ")(").concat(JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY), ", ").concat(JSON.stringify(ssrKey), ")")
        }
    }));
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext3(hookName) {
    var ctx = $12aPv.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    var state = $12aPv.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition, unstable_useTransitions = _ref.unstable_useTransitions;
    var navigate = useNavigate();
    var location = useLocation();
    var path = useResolvedPath(to, {
        relative: relative
    });
    return $12aPv.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            var replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            var doNavigate = function() {
                return navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition
                });
            };
            if (unstable_useTransitions) $6mMqj.startTransition(function() {
                return doNavigate();
            });
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_useTransitions
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    var defaultSearchParamsRef = $12aPv.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = $12aPv.useRef(false);
    var location = useLocation();
    var searchParams = $12aPv.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = useNavigate();
    var setSearchParams = $12aPv.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = function() {
    return "__".concat(String(++fetcherId), "__");
};
function useSubmit() {
    var router = useDataRouterContext3("useSubmit" /* UseSubmit */ ).router;
    var basename = $12aPv.useContext(NavigationContext).basename;
    var currentRouteId = useRouteId();
    var routerFetch = router.fetch;
    var routerNavigate = router.navigate;
    return $12aPv.useCallback(function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            var _getFormSubmissionInfo, action, method, encType, formData, body, key;
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _getFormSubmissionInfo = getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
                        if (!(options.navigate === false)) return [
                            3,
                            2
                        ];
                        key = options.fetcherKey || getUniqueFetcherId();
                        return [
                            4,
                            routerFetch(key, currentRouteId, options.action || action, {
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                flushSync: options.flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            routerNavigate(options.action || action, {
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                replace: options.replace,
                                state: options.state,
                                fromRouteId: currentRouteId,
                                flushSync: options.flushSync,
                                viewTransition: options.viewTransition
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var basename = $12aPv.useContext(NavigationContext).basename;
    var routeContext = $12aPv.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    var _routeContext_matches_slice = (0, $leE2g._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    var path = (0, $6GCxi._)({}, useResolvedPath(action ? action : ".", {
        relative: relative
    }));
    var location = useLocation();
    if (action == null) {
        path.search = location.search;
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher() {
    var key = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).key;
    var _route_matches_;
    var router = useDataRouterContext3("useFetcher" /* UseFetcher */ ).router;
    var state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    var fetcherData = $12aPv.useContext(FetchersContext);
    var route = $12aPv.useContext(RouteContext);
    var routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    invariant(fetcherData, "useFetcher must be used inside a FetchersContext");
    invariant(route, "useFetcher must be used inside a RouteContext");
    invariant(routeId != null, 'useFetcher can only be used on routes that contain a unique "id"');
    var defaultKey = $12aPv.useId();
    var _React10_useState = (0, $leE2g._)($12aPv.useState(key || defaultKey), 2), fetcherKey = _React10_useState[0], setFetcherKey = _React10_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    var deleteFetcher = router.deleteFetcher, getFetcher = router.getFetcher, resetFetcher = router.resetFetcher, routerFetch = router.fetch;
    $12aPv.useEffect(function() {
        getFetcher(fetcherKey);
        return function() {
            return deleteFetcher(fetcherKey);
        };
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    var load = $12aPv.useCallback(function(href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(routeId, "No routeId available for fetcher.load()");
                        return [
                            4,
                            routerFetch(fetcherKey, routeId, href, opts)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    var submitImpl = useSubmit();
    var submit = $12aPv.useCallback(function(target, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
            return (0, $Csf8W.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            submitImpl(target, (0, $ctBui._)((0, $6GCxi._)({}, opts), {
                                navigate: false,
                                fetcherKey: fetcherKey
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        submitImpl
    ]);
    var reset = $12aPv.useCallback(function(opts) {
        return resetFetcher(fetcherKey, opts);
    }, [
        resetFetcher,
        fetcherKey
    ]);
    var FetcherForm = $12aPv.useMemo(function() {
        var FetcherForm2 = $6mMqj.forwardRef(function(props, ref) {
            return /* @__PURE__ */ $fClfl.createElement(Form, (0, $ctBui._)((0, $6GCxi._)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    var fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    var data2 = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $12aPv.useMemo(function() {
        return (0, $ctBui._)((0, $6GCxi._)({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset
        }, fetcher), {
            data: data2
        });
    }, [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    var state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(function(param) {
        var _param = (0, $leE2g._)(param, 2), key = _param[0], fetcher = _param[1];
        return (0, $ctBui._)((0, $6GCxi._)({}, fetcher), {
            key: key
        });
    });
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    var key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $ctBui._)((0, $6GCxi._)({}, location), {
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ ).router;
    var _useDataRouterState2 = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ ), restoreScrollPosition = _useDataRouterState2.restoreScrollPosition, preventScrollReset = _useDataRouterState2.preventScrollReset;
    var basename = $12aPv.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    var navigation = useNavigation();
    $12aPv.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide($12aPv.useCallback(function() {
        if (navigation.state === "idle") {
            var key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (".concat(error, ")."));
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $12aPv.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $12aPv.useLayoutEffect(function() {
            var disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKey ? function(location2, matches2) {
                return getScrollRestorationKey(location2, matches2, basename, getKey);
            } : void 0);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        $12aPv.useLayoutEffect(function() {
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch (e) {
                warning(false, '"'.concat(location.hash.slice(1), '" is not a decodable element ID. The view will not scroll to it.'));
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    $12aPv.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $12aPv.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt(param) {
    var when = param.when, message = param.message;
    var blocker = useBlocker(when);
    $12aPv.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $12aPv.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var vtContext = $12aPv.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    var basename = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ ).basename;
    var path = useResolvedPath(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter(param) {
    var basename = param.basename, children = param.children, tmp = param.location, locationProp = tmp === void 0 ? "/" : tmp;
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var action = "POP" /* Pop */ ;
    var location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    var staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ $fClfl.createElement(Router, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function StaticRouterProvider(param) {
    var context = param.context, router = param.router, tmp = param.hydrate, hydrate2 = tmp === void 0 ? true : tmp, nonce = param.nonce;
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    var dataRouterContext = {
        router: router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    var fetchersContext = /* @__PURE__ */ new Map();
    var hydrateScript = "";
    if (hydrate2 !== false) {
        var data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        var json = htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = "window.__staticRouterHydrationData = JSON.parse(".concat(json, ");");
    }
    var state = dataRouterContext.router.state;
    return /* @__PURE__ */ $fClfl.createElement($fClfl.Fragment, null, /* @__PURE__ */ $fClfl.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $fClfl.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $fClfl.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $fClfl.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $fClfl.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $fClfl.createElement(DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $fClfl.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function DataRoutes2(param) {
    var routes = param.routes, future = param.future, state = param.state;
    return useRoutesImpl(routes, void 0, state, void 0, future);
}
function serializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $leE2g._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (isRouteErrorResponse(val)) serialized[key] = (0, $ctBui._)((0, $6GCxi._)({}, val), {
                __type: "RouteErrorResponse"
            });
            else if (val instanceof Error) serialized[key] = (0, $6GCxi._)({
                message: val.message,
                __type: "Error"
            }, val.name !== "Error" ? {
                __subType: val.name
            } : {});
            else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref: createHref,
        encodeLocation: encodeLocation,
        push: function(to) {
            throw new Error("You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ")` somewhere in your app."));
        },
        replace: function(to) {
            throw new Error("You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ", { replace: true })` somewhere in your app."));
        },
        go: function(delta) {
            throw new Error("You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(delta, ")` somewhere in your app."));
        },
        back: function() {
            throw new Error("You cannot use navigator.back() on the server because it is a stateless environment.");
        },
        forward: function() {
            throw new Error("You cannot use navigator.forward() on the server because it is a stateless environment.");
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, (0, $ctBui._)((0, $6GCxi._)({}, opts), {
        mapRouteProperties: mapRouteProperties
    }));
}
function createStaticRouter(routes, context) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    var matches = context.matches.map(function(match) {
        var route = manifest[match.route.id] || match.route;
        return (0, $ctBui._)((0, $6GCxi._)({}, match), {
            route: route
        });
    });
    var msg = function(method) {
        return "You cannot use router.".concat(method, "() on the server because it is a stateless environment");
    };
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return (0, $6GCxi._)({
                v8_middleware: false
            }, opts === null || opts === void 0 ? void 0 : opts.future);
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize: function() {
            throw msg("initialize");
        },
        subscribe: function() {
            throw msg("subscribe");
        },
        enableScrollRestoration: function() {
            throw msg("enableScrollRestoration");
        },
        navigate: function() {
            throw msg("navigate");
        },
        fetch: function() {
            throw msg("fetch");
        },
        revalidate: function() {
            throw msg("revalidate");
        },
        createHref: createHref,
        encodeLocation: encodeLocation,
        getFetcher: function() {
            return IDLE_FETCHER;
        },
        deleteFetcher: function() {
            throw msg("deleteFetcher");
        },
        resetFetcher: function() {
            throw msg("resetFetcher");
        },
        dispose: function() {
            throw msg("dispose");
        },
        getBlocker: function() {
            return IDLE_BLOCKER;
        },
        deleteBlocker: function() {
            throw msg("deleteBlocker");
        },
        patchRoutes: function() {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes: function() {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function() {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    var encoded = ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function htmlEscape(str) {
    return str.replace(ESCAPE_REGEX2, function(match) {
        return ESCAPE_LOOKUP2[match];
    });
}

});
parcelRegister("4L6tH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $37709397c6c24ce4$export$71511d61b312f219; });

var $1RNxS = parcelRequire("1RNxS");

var $gS6yU = parcelRequire("gS6yU");

var $lKa1b = parcelRequire("lKa1b");

var $4mlSp = parcelRequire("4mlSp");
function $37709397c6c24ce4$export$71511d61b312f219(arr) {
    return (0, $1RNxS._)(arr) || (0, $gS6yU._)(arr) || (0, $4mlSp._)(arr) || (0, $lKa1b._)();
}

});

parcelRegister("6mMqj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", function () { return $4a2a5c02759df3f3$export$306c0aa65ff9ec16; });
$parcel$export(module.exports, "startTransition", function () { return $4a2a5c02759df3f3$export$7568632d0d33d16d; });
$parcel$export(module.exports, "useDeferredValue", function () { return $4a2a5c02759df3f3$export$6a7bc4e911dc01cf; });
$parcel$export(module.exports, "useTransition", function () { return $4a2a5c02759df3f3$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $4a2a5c02759df3f3$export$aaabe4eda9ed9969; });
$parcel$export(module.exports, "PureComponent", function () { return $4a2a5c02759df3f3$export$221d75b3f55bb0bd; });
$parcel$export(module.exports, "memo", function () { return $4a2a5c02759df3f3$export$7c73462e0d25e514; });
$parcel$export(module.exports, "forwardRef", function () { return $4a2a5c02759df3f3$export$257a8862b851cb5b; });
$parcel$export(module.exports, "Children", function () { return $4a2a5c02759df3f3$export$dca3b0875bd9a954; });
$parcel$export(module.exports, "Suspense", function () { return $4a2a5c02759df3f3$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "lazy", function () { return $4a2a5c02759df3f3$export$488013bae63b21da; });
$parcel$export(module.exports, "SuspenseList", function () { return $4a2a5c02759df3f3$export$998bcd577473dd93; });
$parcel$export(module.exports, "createPortal", function () { return $4a2a5c02759df3f3$export$d39a5bbd09211389; });
$parcel$export(module.exports, "render", function () { return $4a2a5c02759df3f3$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $4a2a5c02759df3f3$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4a2a5c02759df3f3$export$ae55be85d98224ed; });
$parcel$export(module.exports, "version", function () { return $4a2a5c02759df3f3$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createFactory", function () { return $4a2a5c02759df3f3$export$d38cd72104c1f0e9; });
$parcel$export(module.exports, "isValidElement", function () { return $4a2a5c02759df3f3$export$a8257692ac88316c; });
$parcel$export(module.exports, "isFragment", function () { return $4a2a5c02759df3f3$export$9522e17588c12572; });
$parcel$export(module.exports, "isMemo", function () { return $4a2a5c02759df3f3$export$56885ab8b9c456ab; });
$parcel$export(module.exports, "cloneElement", function () { return $4a2a5c02759df3f3$export$e530037191fcd5d7; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4a2a5c02759df3f3$export$502457920280e6be; });
$parcel$export(module.exports, "findDOMNode", function () { return $4a2a5c02759df3f3$export$466bfc07425424d5; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4a2a5c02759df3f3$export$c78a37762a8d58e1; });
$parcel$export(module.exports, "flushSync", function () { return $4a2a5c02759df3f3$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "StrictMode", function () { return $4a2a5c02759df3f3$export$5f8d39834fd61797; });
$parcel$export(module.exports, "isElement", function () { return $4a2a5c02759df3f3$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "default", function () { return $4a2a5c02759df3f3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("fClfl")).Component; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("fClfl")).Fragment; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("fClfl")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("fClfl")).createElement; });
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("fClfl")).createRef; });

var $5f0Cq = parcelRequire("5f0Cq");

var $fClfl = parcelRequire("fClfl");

var $12aPv = parcelRequire("12aPv");
function $4a2a5c02759df3f3$var$g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function $4a2a5c02759df3f3$var$E(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function $4a2a5c02759df3f3$export$306c0aa65ff9ec16(n, t) {
    var _$e = t(), _$r = (0, $12aPv.useState)({
        t: {
            __: _$e,
            u: t
        }
    }), _$u = _$r[0].t, o = _$r[1];
    return (0, $12aPv.useLayoutEffect)(function() {
        _$u.__ = _$e, _$u.u = t, $4a2a5c02759df3f3$var$x(_$u) && o({
            t: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, $12aPv.useEffect)(function() {
        return $4a2a5c02759df3f3$var$x(_$u) && o({
            t: _$u
        }), n(function() {
            $4a2a5c02759df3f3$var$x(_$u) && o({
                t: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
function $4a2a5c02759df3f3$var$x(n) {
    var _$t, _$e, _$r = n.u, _$u = n.__;
    try {
        var o = _$r();
        return !((_$t = _$u) === (_$e = o) && (0 !== _$t || 1 / _$t == 1 / _$e) || _$t != _$t && _$e != _$e);
    } catch (n) {
        return !0;
    }
}
function $4a2a5c02759df3f3$export$7568632d0d33d16d(n) {
    n();
}
function $4a2a5c02759df3f3$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $4a2a5c02759df3f3$export$7b286972b8d8ccbf() {
    return [
        !1,
        $4a2a5c02759df3f3$export$7568632d0d33d16d
    ];
}
var $4a2a5c02759df3f3$export$aaabe4eda9ed9969 = (0, $12aPv.useLayoutEffect);
function $4a2a5c02759df3f3$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $4a2a5c02759df3f3$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var _$t = this.props.ref, _$r = _$t == n.ref;
        return !_$r && _$t && (_$t.call ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || !_$r : $4a2a5c02759df3f3$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $fClfl.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($4a2a5c02759df3f3$export$221d75b3f55bb0bd.prototype = new (0, $fClfl.Component)).isPureReactComponent = !0, $4a2a5c02759df3f3$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $4a2a5c02759df3f3$var$E(this.props, n) || $4a2a5c02759df3f3$var$E(this.state, t);
};
var $4a2a5c02759df3f3$var$T = (0, $fClfl.options).__b;
(0, $fClfl.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $4a2a5c02759df3f3$var$T && $4a2a5c02759df3f3$var$T(n);
};
var $4a2a5c02759df3f3$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $4a2a5c02759df3f3$export$257a8862b851cb5b(n) {
    function t(t) {
        var _$e = $4a2a5c02759df3f3$var$g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    }
    return t.$$typeof = $4a2a5c02759df3f3$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $4a2a5c02759df3f3$var$L = function L(n, t) {
    return null == n ? null : (0, $fClfl.toChildArray)((0, $fClfl.toChildArray)(n).map(t));
}, $4a2a5c02759df3f3$export$dca3b0875bd9a954 = {
    map: $4a2a5c02759df3f3$var$L,
    forEach: $4a2a5c02759df3f3$var$L,
    count: function count(n) {
        return n ? (0, $fClfl.toChildArray)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, $fClfl.toChildArray)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, $fClfl.toChildArray)
}, $4a2a5c02759df3f3$var$F = (0, $fClfl.options).__e;
(0, $fClfl.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    $4a2a5c02759df3f3$var$F(n, t, e, r);
};
var $4a2a5c02759df3f3$var$U = (0, $fClfl.options).unmount;
function $4a2a5c02759df3f3$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $4a2a5c02759df3f3$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $4a2a5c02759df3f3$var$V(n, t, e);
    })), n;
}
function $4a2a5c02759df3f3$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $4a2a5c02759df3f3$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $4a2a5c02759df3f3$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $4a2a5c02759df3f3$var$j(n) {
    var _$t = n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function $4a2a5c02759df3f3$export$488013bae63b21da(n) {
    var _$e, _$r, _$u, o = null;
    function i(i) {
        if (_$e || (_$e = n()).then(function(n) {
            n && (o = n.default || n), _$u = !0;
        }, function(n) {
            _$r = n, _$u = !0;
        }), _$r) throw _$r;
        if (!_$u) throw _$e;
        return o ? (0, $fClfl.createElement)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $4a2a5c02759df3f3$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $fClfl.options).unmount = function(n) {
    var _$t = n.__c;
    _$t && _$t.__R && _$t.__R(), _$t && 32 & n.__u && (n.type = null), $4a2a5c02759df3f3$var$U && $4a2a5c02759df3f3$var$U(n);
}, ($4a2a5c02759df3f3$export$74bf444e3cd11ea5.prototype = new (0, $fClfl.Component)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.o && (_$r.o = []), _$r.o.push(_$e);
    var _$u = $4a2a5c02759df3f3$var$j(_$r.__v), o = !1, i = function i() {
        o || (o = !0, _$e.__R = null, _$u ? _$u(_$l) : _$l());
    };
    _$e.__R = i;
    var _$l = function l() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = $4a2a5c02759df3f3$var$W(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.o.pop();)_$t.forceUpdate();
        }
    };
    _$r.__u++ || 32 & t.__u || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, $4a2a5c02759df3f3$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $4a2a5c02759df3f3$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $4a2a5c02759df3f3$var$V(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $fClfl.createElement)((0, $fClfl.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $fClfl.createElement)((0, $fClfl.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $4a2a5c02759df3f3$var$H = function H(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $4a2a5c02759df3f3$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $4a2a5c02759df3f3$var$Y(n) {
    var _$e = this, _$r = n.h;
    if (_$e.componentWillUnmount = function() {
        (0, $fClfl.render)(null, _$e.v), _$e.v = null, _$e.h = null;
    }, _$e.h && _$e.h !== _$r && _$e.componentWillUnmount(), !_$e.v) {
        for(var _$u = _$e.__v; null !== _$u && !_$u.__m && null !== _$u.__;)_$u = _$u.__;
        _$e.h = _$r, _$e.v = {
            nodeType: 1,
            parentNode: _$r,
            childNodes: [],
            __k: {
                __m: _$u.__m
            },
            contains: function contains() {
                return !0;
            },
            insertBefore: function insertBefore(n, t) {
                this.childNodes.push(n), _$e.h.insertBefore(n, t);
            },
            removeChild: function removeChild(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.h.removeChild(n);
            }
        };
    }
    (0, $fClfl.render)((0, $fClfl.createElement)($4a2a5c02759df3f3$var$Z, {
        context: _$e.context
    }, n.__v), _$e.v);
}
function $4a2a5c02759df3f3$export$d39a5bbd09211389(n, e) {
    var _$r = (0, $fClfl.createElement)($4a2a5c02759df3f3$var$Y, {
        __v: n,
        h: e
    });
    return _$r.containerInfo = e, _$r;
}
($4a2a5c02759df3f3$export$998bcd577473dd93.prototype = new (0, $fClfl.Component)).__a = function(n) {
    var _$t = this, _$e = $4a2a5c02759df3f3$var$j(_$t.__v), _$r = _$t.l.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), $4a2a5c02759df3f3$var$H(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, $4a2a5c02759df3f3$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var _$t = (0, $fClfl.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.l.set(_$t[_$e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $4a2a5c02759df3f3$export$998bcd577473dd93.prototype.componentDidUpdate = $4a2a5c02759df3f3$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var _$n = this;
    this.l.forEach(function(t, e) {
        $4a2a5c02759df3f3$var$H(_$n, e, t);
    });
};
var $4a2a5c02759df3f3$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $4a2a5c02759df3f3$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $4a2a5c02759df3f3$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $4a2a5c02759df3f3$var$K = /[A-Z0-9]/g, $4a2a5c02759df3f3$var$Q = "undefined" != typeof document, $4a2a5c02759df3f3$var$X = function X(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, $5f0Cq._)(Symbol()) ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $4a2a5c02759df3f3$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $fClfl.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $4a2a5c02759df3f3$export$fa8d919ba61d84db(n, t, e) {
    return (0, $fClfl.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $fClfl.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $fClfl.Component).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $4a2a5c02759df3f3$var$en = (0, $fClfl.options).event;
function $4a2a5c02759df3f3$var$rn() {}
function $4a2a5c02759df3f3$var$un() {
    return this.cancelBubble;
}
function $4a2a5c02759df3f3$var$on() {
    return this.defaultPrevented;
}
(0, $fClfl.options).event = function(n) {
    return $4a2a5c02759df3f3$var$en && (n = $4a2a5c02759df3f3$var$en(n)), n.persist = $4a2a5c02759df3f3$var$rn, n.isPropagationStopped = $4a2a5c02759df3f3$var$un, n.isDefaultPrevented = $4a2a5c02759df3f3$var$on, n.nativeEvent = n;
};
var $4a2a5c02759df3f3$var$ln, $4a2a5c02759df3f3$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function get() {
        return this.class;
    }
}, $4a2a5c02759df3f3$var$fn = (0, $fClfl.options).vnode;
(0, $fClfl.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var _$t = n.props, _$e = n.type, _$u = {}, o = -1 === _$e.indexOf("-");
        for(var i in _$t){
            var _$l = _$t[i];
            if (!("value" === i && "defaultValue" in _$t && null == _$l || $4a2a5c02759df3f3$var$Q && "children" === i && "noscript" === _$e || "class" === i || "className" === i)) {
                var _$c = i.toLowerCase();
                "defaultValue" === i && "value" in _$t && null == _$t.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : "translate" === _$c && "no" === _$l ? _$l = !1 : "o" === _$c[0] && "n" === _$c[1] ? "ondoubleclick" === _$c ? i = "ondblclick" : "onchange" !== _$c || "input" !== _$e && "textarea" !== _$e || $4a2a5c02759df3f3$var$X(_$t.type) ? "onfocus" === _$c ? i = "onfocusin" : "onblur" === _$c ? i = "onfocusout" : $4a2a5c02759df3f3$var$J.test(i) && (i = _$c) : _$c = i = "oninput" : o && $4a2a5c02759df3f3$var$G.test(i) ? i = i.replace($4a2a5c02759df3f3$var$K, "-$&").toLowerCase() : null === _$l && (_$l = void 0), "oninput" === _$c && _$u[i = _$c] && (i = "oninputCapture"), _$u[i] = _$l;
            }
        }
        "select" == _$e && _$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, $fClfl.toChildArray)(_$t.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), "select" == _$e && null != _$u.defaultValue && (_$u.value = (0, $fClfl.toChildArray)(_$t.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        })), _$t.class && !_$t.className ? (_$u.class = _$t.class, Object.defineProperty(_$u, "className", $4a2a5c02759df3f3$var$cn)) : (_$t.className && !_$t.class || _$t.class && _$t.className) && (_$u.class = _$u.className = _$t.className), n.props = _$u;
    }(n), n.$$typeof = $4a2a5c02759df3f3$var$q, $4a2a5c02759df3f3$var$fn && $4a2a5c02759df3f3$var$fn(n);
};
var $4a2a5c02759df3f3$var$an = (0, $fClfl.options).__r;
(0, $fClfl.options).__r = function(n) {
    $4a2a5c02759df3f3$var$an && $4a2a5c02759df3f3$var$an(n), $4a2a5c02759df3f3$var$ln = n.__c;
};
var $4a2a5c02759df3f3$var$sn = (0, $fClfl.options).diffed;
(0, $fClfl.options).diffed = function(n) {
    $4a2a5c02759df3f3$var$sn && $4a2a5c02759df3f3$var$sn(n);
    var _$t = n.props, _$e = n.__e;
    null != _$e && "textarea" === n.type && "value" in _$t && _$t.value !== _$e.value && (_$e.value = null == _$t.value ? "" : _$t.value), $4a2a5c02759df3f3$var$ln = null;
};
var $4a2a5c02759df3f3$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return $4a2a5c02759df3f3$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $12aPv.useCallback),
            useContext: (0, $12aPv.useContext),
            useDebugValue: (0, $12aPv.useDebugValue),
            useDeferredValue: $4a2a5c02759df3f3$export$6a7bc4e911dc01cf,
            useEffect: (0, $12aPv.useEffect),
            useId: (0, $12aPv.useId),
            useImperativeHandle: (0, $12aPv.useImperativeHandle),
            useInsertionEffect: $4a2a5c02759df3f3$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $12aPv.useLayoutEffect),
            useMemo: (0, $12aPv.useMemo),
            useReducer: (0, $12aPv.useReducer),
            useRef: (0, $12aPv.useRef),
            useState: (0, $12aPv.useState),
            useSyncExternalStore: $4a2a5c02759df3f3$export$306c0aa65ff9ec16,
            useTransition: $4a2a5c02759df3f3$export$7b286972b8d8ccbf
        }
    }
}, $4a2a5c02759df3f3$export$83d89fbfd8236492 = "18.3.1";
function $4a2a5c02759df3f3$export$d38cd72104c1f0e9(n) {
    return (0, $fClfl.createElement).bind(null, n);
}
function $4a2a5c02759df3f3$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $4a2a5c02759df3f3$var$q;
}
function $4a2a5c02759df3f3$export$9522e17588c12572(n) {
    return $4a2a5c02759df3f3$export$a8257692ac88316c(n) && n.type === (0, $fClfl.Fragment);
}
function $4a2a5c02759df3f3$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $4a2a5c02759df3f3$export$e530037191fcd5d7(n) {
    return $4a2a5c02759df3f3$export$a8257692ac88316c(n) ? (0, $fClfl.cloneElement).apply(null, arguments) : n;
}
function $4a2a5c02759df3f3$export$502457920280e6be(n) {
    return !!n.__k && ((0, $fClfl.render)(null, n), !0);
}
function $4a2a5c02759df3f3$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $4a2a5c02759df3f3$export$c78a37762a8d58e1 = function gn(n, t) {
    return n(t);
}, $4a2a5c02759df3f3$export$cd75ccfd720a3cd4 = function En(n, t) {
    return n(t);
}, $4a2a5c02759df3f3$export$5f8d39834fd61797 = (0, $fClfl.Fragment), $4a2a5c02759df3f3$export$45a5e7f76e0caa8d = $4a2a5c02759df3f3$export$a8257692ac88316c, $4a2a5c02759df3f3$export$2e2bcd8739ae039 = {
    useState: (0, $12aPv.useState),
    useId: (0, $12aPv.useId),
    useReducer: (0, $12aPv.useReducer),
    useEffect: (0, $12aPv.useEffect),
    useLayoutEffect: (0, $12aPv.useLayoutEffect),
    useInsertionEffect: $4a2a5c02759df3f3$export$aaabe4eda9ed9969,
    useTransition: $4a2a5c02759df3f3$export$7b286972b8d8ccbf,
    useDeferredValue: $4a2a5c02759df3f3$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $4a2a5c02759df3f3$export$306c0aa65ff9ec16,
    startTransition: $4a2a5c02759df3f3$export$7568632d0d33d16d,
    useRef: (0, $12aPv.useRef),
    useImperativeHandle: (0, $12aPv.useImperativeHandle),
    useMemo: (0, $12aPv.useMemo),
    useCallback: (0, $12aPv.useCallback),
    useContext: (0, $12aPv.useContext),
    useDebugValue: (0, $12aPv.useDebugValue),
    version: "18.3.1",
    Children: $4a2a5c02759df3f3$export$dca3b0875bd9a954,
    render: $4a2a5c02759df3f3$export$b3890eb0ae9dca99,
    hydrate: $4a2a5c02759df3f3$export$fa8d919ba61d84db,
    unmountComponentAtNode: $4a2a5c02759df3f3$export$502457920280e6be,
    createPortal: $4a2a5c02759df3f3$export$d39a5bbd09211389,
    createElement: (0, $fClfl.createElement),
    createContext: (0, $fClfl.createContext),
    createFactory: $4a2a5c02759df3f3$export$d38cd72104c1f0e9,
    cloneElement: $4a2a5c02759df3f3$export$e530037191fcd5d7,
    createRef: (0, $fClfl.createRef),
    Fragment: (0, $fClfl.Fragment),
    isValidElement: $4a2a5c02759df3f3$export$a8257692ac88316c,
    isElement: $4a2a5c02759df3f3$export$45a5e7f76e0caa8d,
    isFragment: $4a2a5c02759df3f3$export$9522e17588c12572,
    isMemo: $4a2a5c02759df3f3$export$56885ab8b9c456ab,
    findDOMNode: $4a2a5c02759df3f3$export$466bfc07425424d5,
    Component: (0, $fClfl.Component),
    PureComponent: $4a2a5c02759df3f3$export$221d75b3f55bb0bd,
    memo: $4a2a5c02759df3f3$export$7c73462e0d25e514,
    forwardRef: $4a2a5c02759df3f3$export$257a8862b851cb5b,
    flushSync: $4a2a5c02759df3f3$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $4a2a5c02759df3f3$export$c78a37762a8d58e1,
    StrictMode: $4a2a5c02759df3f3$export$5f8d39834fd61797,
    Suspense: $4a2a5c02759df3f3$export$74bf444e3cd11ea5,
    SuspenseList: $4a2a5c02759df3f3$export$998bcd577473dd93,
    lazy: $4a2a5c02759df3f3$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $4a2a5c02759df3f3$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $12aPv);

});
parcelRegister("fClfl", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $b5eae2b7bd5de36b$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $b5eae2b7bd5de36b$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $b5eae2b7bd5de36b$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $b5eae2b7bd5de36b$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $b5eae2b7bd5de36b$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $b5eae2b7bd5de36b$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $b5eae2b7bd5de36b$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $b5eae2b7bd5de36b$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $b5eae2b7bd5de36b$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $b5eae2b7bd5de36b$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "h", function () { return $b5eae2b7bd5de36b$export$c8a8987d4410bf2d; });

var $5f0Cq = parcelRequire("5f0Cq");
var $b5eae2b7bd5de36b$var$n, $b5eae2b7bd5de36b$export$41c562ebe57d11e2, $b5eae2b7bd5de36b$var$u, $b5eae2b7bd5de36b$export$a8257692ac88316c, $b5eae2b7bd5de36b$var$i, $b5eae2b7bd5de36b$var$r, $b5eae2b7bd5de36b$var$o, $b5eae2b7bd5de36b$var$e, $b5eae2b7bd5de36b$var$f, $b5eae2b7bd5de36b$var$c, $b5eae2b7bd5de36b$var$s, $b5eae2b7bd5de36b$var$a, $b5eae2b7bd5de36b$var$h, $b5eae2b7bd5de36b$var$p = {}, $b5eae2b7bd5de36b$var$v = [], $b5eae2b7bd5de36b$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $b5eae2b7bd5de36b$var$w = Array.isArray;
function $b5eae2b7bd5de36b$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $b5eae2b7bd5de36b$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $b5eae2b7bd5de36b$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $b5eae2b7bd5de36b$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $b5eae2b7bd5de36b$var$m(l, e, i, r, null);
}
function $b5eae2b7bd5de36b$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$b5eae2b7bd5de36b$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $b5eae2b7bd5de36b$export$41c562ebe57d11e2.vnode && $b5eae2b7bd5de36b$export$41c562ebe57d11e2.vnode(e), e;
}
function $b5eae2b7bd5de36b$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $b5eae2b7bd5de36b$export$ffb0004e005737fa(n) {
    return n.children;
}
function $b5eae2b7bd5de36b$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $b5eae2b7bd5de36b$var$S(n, l) {
    if (null == l) return n.__ ? $b5eae2b7bd5de36b$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $b5eae2b7bd5de36b$var$S(n) : null;
}
function $b5eae2b7bd5de36b$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $b5eae2b7bd5de36b$var$C(n);
    }
}
function $b5eae2b7bd5de36b$var$M(n) {
    (!n.__d && (n.__d = !0) && $b5eae2b7bd5de36b$var$i.push(n) && !$b5eae2b7bd5de36b$var$$.__r++ || $b5eae2b7bd5de36b$var$r != $b5eae2b7bd5de36b$export$41c562ebe57d11e2.debounceRendering) && (($b5eae2b7bd5de36b$var$r = $b5eae2b7bd5de36b$export$41c562ebe57d11e2.debounceRendering) || $b5eae2b7bd5de36b$var$o)($b5eae2b7bd5de36b$var$$);
}
function $b5eae2b7bd5de36b$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $b5eae2b7bd5de36b$var$i.length;)$b5eae2b7bd5de36b$var$i.length > s && $b5eae2b7bd5de36b$var$i.sort($b5eae2b7bd5de36b$var$e), n = $b5eae2b7bd5de36b$var$i.shift(), s = $b5eae2b7bd5de36b$var$i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $b5eae2b7bd5de36b$var$d({}, r)).__v = r.__v + 1, $b5eae2b7bd5de36b$export$41c562ebe57d11e2.vnode && $b5eae2b7bd5de36b$export$41c562ebe57d11e2.vnode(t), $b5eae2b7bd5de36b$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $b5eae2b7bd5de36b$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $b5eae2b7bd5de36b$var$N(f, t, c), r.__e = r.__ = null, t.__e != o && $b5eae2b7bd5de36b$var$C(t)));
    $b5eae2b7bd5de36b$var$$.__r = 0;
}
function $b5eae2b7bd5de36b$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || $b5eae2b7bd5de36b$var$v, b = l.length;
    for(f = $b5eae2b7bd5de36b$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $b5eae2b7bd5de36b$var$p : m[y.__i] || $b5eae2b7bd5de36b$var$p, y.__i = a, g = $b5eae2b7bd5de36b$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $b5eae2b7bd5de36b$var$B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $b5eae2b7bd5de36b$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $b5eae2b7bd5de36b$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == (typeof o === "undefined" ? "undefined" : (0, $5f0Cq._)(o)) || o.constructor == String ? o = n.__k[r] = $b5eae2b7bd5de36b$var$m(null, o, null, null, null) : $b5eae2b7bd5de36b$var$w(o) ? o = n.__k[r] = $b5eae2b7bd5de36b$var$m($b5eae2b7bd5de36b$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? o = n.__k[r] = $b5eae2b7bd5de36b$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, -1 != (c = o.__i = $b5eae2b7bd5de36b$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $b5eae2b7bd5de36b$var$S(e)), $b5eae2b7bd5de36b$var$D(e, e));
    return t;
}
function $b5eae2b7bd5de36b$var$A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $b5eae2b7bd5de36b$var$A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $b5eae2b7bd5de36b$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $b5eae2b7bd5de36b$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($b5eae2b7bd5de36b$var$w(n) ? n.some(function(n) {
        $b5eae2b7bd5de36b$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $b5eae2b7bd5de36b$var$L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $b5eae2b7bd5de36b$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $b5eae2b7bd5de36b$var$y.test(l) ? u : u + "px";
}
function $b5eae2b7bd5de36b$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $b5eae2b7bd5de36b$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $b5eae2b7bd5de36b$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($b5eae2b7bd5de36b$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $b5eae2b7bd5de36b$var$c, n.addEventListener(l, r ? $b5eae2b7bd5de36b$var$a : $b5eae2b7bd5de36b$var$s, r)) : n.removeEventListener(l, r ? $b5eae2b7bd5de36b$var$a : $b5eae2b7bd5de36b$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $b5eae2b7bd5de36b$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $b5eae2b7bd5de36b$var$c++;
            else if (u.t < t.u) return;
            return t($b5eae2b7bd5de36b$export$41c562ebe57d11e2.event ? $b5eae2b7bd5de36b$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $b5eae2b7bd5de36b$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, _$$, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $b5eae2b7bd5de36b$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $b5eae2b7bd5de36b$var$E), C && C.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $b5eae2b7bd5de36b$var$d({}, h.__s)), $b5eae2b7bd5de36b$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), _$$ = 0; _$$ < h._sb.length; _$$++)h.__h.push(h._sb[_$$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $b5eae2b7bd5de36b$var$d($b5eae2b7bd5de36b$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $b5eae2b7bd5de36b$export$ffb0004e005737fa && null == a.key && (L = $b5eae2b7bd5de36b$var$V(a.props.children)), f = $b5eae2b7bd5de36b$var$I(n, $b5eae2b7bd5de36b$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)$b5eae2b7bd5de36b$var$g(o[T]);
                $b5eae2b7bd5de36b$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $b5eae2b7bd5de36b$var$z(u);
        $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $b5eae2b7bd5de36b$var$q(t.__e, u, t, i, r, o, e, c, s);
    return (a = $b5eae2b7bd5de36b$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $b5eae2b7bd5de36b$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($b5eae2b7bd5de36b$var$z);
}
function $b5eae2b7bd5de36b$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$b5eae2b7bd5de36b$var$B(t[i], t[++i], t[++i]);
    $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__c && $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $b5eae2b7bd5de36b$var$V(n) {
    return "object" != (typeof n === "undefined" ? "undefined" : (0, $5f0Cq._)(n)) || null == n || n.__b && n.__b > 0 ? n : $b5eae2b7bd5de36b$var$w(n) ? n.map($b5eae2b7bd5de36b$var$V) : $b5eae2b7bd5de36b$var$d({}, n);
}
function $b5eae2b7bd5de36b$var$q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props || $b5eae2b7bd5de36b$var$p, _$k = t.props, _$x = t.type;
    if ("svg" == _$x ? o = "http://www.w3.org/2000/svg" : "math" == _$x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!_$x && (_$x ? d.localName == _$x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == _$x) return document.createTextNode(_$k);
        u = document.createElementNS(o, _$x, _$k.is && _$k), c && ($b5eae2b7bd5de36b$export$41c562ebe57d11e2.__m && $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == _$x) b === _$k || c && u.data == _$k || (u.data = _$k);
    else {
        if (e = e && $b5eae2b7bd5de36b$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in _$k)) {
            if ("value" == a && "defaultValue" in _$k || "checked" == a && "defaultChecked" in _$k) continue;
            $b5eae2b7bd5de36b$var$j(u, a, null, d, o);
        }
        for(a in _$k)d = _$k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $b5eae2b7bd5de36b$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $b5eae2b7bd5de36b$var$I("template" == t.type ? u.content : u, $b5eae2b7bd5de36b$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == _$x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $b5eae2b7bd5de36b$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$b5eae2b7bd5de36b$var$g(e[a]);
        c || (a = "value", "progress" == _$x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == _$x && !_ || "option" == _$x && _ != b[a]) && $b5eae2b7bd5de36b$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $b5eae2b7bd5de36b$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $b5eae2b7bd5de36b$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $b5eae2b7bd5de36b$var$D(n, u, t) {
    var i, r;
    if ($b5eae2b7bd5de36b$export$41c562ebe57d11e2.unmount && $b5eae2b7bd5de36b$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $b5eae2b7bd5de36b$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $b5eae2b7bd5de36b$var$D(i[r], u, t || "function" != typeof n.type);
    t || $b5eae2b7bd5de36b$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $b5eae2b7bd5de36b$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $b5eae2b7bd5de36b$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__ && $b5eae2b7bd5de36b$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $b5eae2b7bd5de36b$var$O(t, u = (!r && i || t).__k = $b5eae2b7bd5de36b$export$c8a8987d4410bf2d($b5eae2b7bd5de36b$export$ffb0004e005737fa, null, [
        u
    ]), o || $b5eae2b7bd5de36b$var$p, $b5eae2b7bd5de36b$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $b5eae2b7bd5de36b$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $b5eae2b7bd5de36b$var$N(e, u, f);
}
function $b5eae2b7bd5de36b$export$fa8d919ba61d84db(n, l) {
    $b5eae2b7bd5de36b$export$b3890eb0ae9dca99(n, l, $b5eae2b7bd5de36b$export$fa8d919ba61d84db);
}
function $b5eae2b7bd5de36b$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $b5eae2b7bd5de36b$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $b5eae2b7bd5de36b$var$n.call(arguments, 2) : t), $b5eae2b7bd5de36b$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $b5eae2b7bd5de36b$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $b5eae2b7bd5de36b$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var _$l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), _$l && _$l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $b5eae2b7bd5de36b$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$b5eae2b7bd5de36b$var$n = $b5eae2b7bd5de36b$var$v.slice, $b5eae2b7bd5de36b$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $b5eae2b7bd5de36b$var$u = 0, $b5eae2b7bd5de36b$export$a8257692ac88316c = function t(n) {
    return null != n && null == n.constructor;
}, $b5eae2b7bd5de36b$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $b5eae2b7bd5de36b$var$d({}, this.state), "function" == typeof n && (n = n($b5eae2b7bd5de36b$var$d({}, u), this.props)), n && $b5eae2b7bd5de36b$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $b5eae2b7bd5de36b$var$M(this));
}, $b5eae2b7bd5de36b$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $b5eae2b7bd5de36b$var$M(this));
}, $b5eae2b7bd5de36b$export$16fa2f45be04daa8.prototype.render = $b5eae2b7bd5de36b$export$ffb0004e005737fa, $b5eae2b7bd5de36b$var$i = [], $b5eae2b7bd5de36b$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $b5eae2b7bd5de36b$var$e = function e(n, l) {
    return n.__v.__b - l.__v.__b;
}, $b5eae2b7bd5de36b$var$$.__r = 0, $b5eae2b7bd5de36b$var$f = /(PointerCapture)$|Capture$/i, $b5eae2b7bd5de36b$var$c = 0, $b5eae2b7bd5de36b$var$s = $b5eae2b7bd5de36b$var$F(!1), $b5eae2b7bd5de36b$var$a = $b5eae2b7bd5de36b$var$F(!0), $b5eae2b7bd5de36b$var$h = 0;

});

parcelRegister("12aPv", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $0c0e60e86bd42802$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $0c0e60e86bd42802$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $0c0e60e86bd42802$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0c0e60e86bd42802$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $0c0e60e86bd42802$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $0c0e60e86bd42802$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0c0e60e86bd42802$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $0c0e60e86bd42802$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $0c0e60e86bd42802$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $0c0e60e86bd42802$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $0c0e60e86bd42802$export$c052f6604b7d51fe; });
$parcel$export(module.exports, "useId", function () { return $0c0e60e86bd42802$export$f680877a34711e37; });

var $fClfl = parcelRequire("fClfl");
var $0c0e60e86bd42802$var$t, $0c0e60e86bd42802$var$r, $0c0e60e86bd42802$var$u, $0c0e60e86bd42802$var$i, $0c0e60e86bd42802$var$o = 0, $0c0e60e86bd42802$var$f = [], $0c0e60e86bd42802$var$c = (0, $fClfl.options), $0c0e60e86bd42802$var$e = $0c0e60e86bd42802$var$c.__b, $0c0e60e86bd42802$var$a = $0c0e60e86bd42802$var$c.__r, $0c0e60e86bd42802$var$v = $0c0e60e86bd42802$var$c.diffed, $0c0e60e86bd42802$var$l = $0c0e60e86bd42802$var$c.__c, $0c0e60e86bd42802$var$m = $0c0e60e86bd42802$var$c.unmount, $0c0e60e86bd42802$var$s = $0c0e60e86bd42802$var$c.__;
function $0c0e60e86bd42802$var$p(n, t) {
    $0c0e60e86bd42802$var$c.__h && $0c0e60e86bd42802$var$c.__h($0c0e60e86bd42802$var$r, n, $0c0e60e86bd42802$var$o || t), $0c0e60e86bd42802$var$o = 0;
    var u = $0c0e60e86bd42802$var$r.__H || ($0c0e60e86bd42802$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $0c0e60e86bd42802$export$60241385465d0a34(n) {
    return $0c0e60e86bd42802$var$o = 1, $0c0e60e86bd42802$export$13e3392192263954($0c0e60e86bd42802$var$D, n);
}
function $0c0e60e86bd42802$export$13e3392192263954(n, u, i) {
    var o = $0c0e60e86bd42802$var$p($0c0e60e86bd42802$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $0c0e60e86bd42802$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $0c0e60e86bd42802$var$r, !$0c0e60e86bd42802$var$r.__f)) {
        var f = function f(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var _$i = o.__c.props !== n;
            return _$u.forEach(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), c && c.call(this, n, t, r) || _$i;
        };
        $0c0e60e86bd42802$var$r.__f = !0;
        var c = $0c0e60e86bd42802$var$r.shouldComponentUpdate, e = $0c0e60e86bd42802$var$r.componentWillUpdate;
        $0c0e60e86bd42802$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var _$u = c;
                c = void 0, f(n, t, r), c = _$u;
            }
            e && e.call(this, n, t, r);
        }, $0c0e60e86bd42802$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $0c0e60e86bd42802$export$6d9c69b0de29b591(n, u) {
    var i = $0c0e60e86bd42802$var$p($0c0e60e86bd42802$var$t++, 3);
    !$0c0e60e86bd42802$var$c.__s && $0c0e60e86bd42802$var$C(i.__H, u) && (i.__ = n, i.u = u, $0c0e60e86bd42802$var$r.__H.__h.push(i));
}
function $0c0e60e86bd42802$export$e5c5a5f917a5871c(n, u) {
    var i = $0c0e60e86bd42802$var$p($0c0e60e86bd42802$var$t++, 4);
    !$0c0e60e86bd42802$var$c.__s && $0c0e60e86bd42802$var$C(i.__H, u) && (i.__ = n, i.u = u, $0c0e60e86bd42802$var$r.__h.push(i));
}
function $0c0e60e86bd42802$export$b8f5890fc79d6aca(n) {
    return $0c0e60e86bd42802$var$o = 5, $0c0e60e86bd42802$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $0c0e60e86bd42802$export$d5a552a76deda3c2(n, t, r) {
    $0c0e60e86bd42802$var$o = 6, $0c0e60e86bd42802$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var _$r = n(t());
            return function() {
                n(null), _$r && "function" == typeof _$r && _$r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $0c0e60e86bd42802$export$1538c33de8887b59(n, r) {
    var u = $0c0e60e86bd42802$var$p($0c0e60e86bd42802$var$t++, 7);
    return $0c0e60e86bd42802$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $0c0e60e86bd42802$export$35808ee640e87ca7(n, t) {
    return $0c0e60e86bd42802$var$o = 8, $0c0e60e86bd42802$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $0c0e60e86bd42802$export$fae74005e78b1a27(n) {
    var u = $0c0e60e86bd42802$var$r.context[n.__c], i = $0c0e60e86bd42802$var$p($0c0e60e86bd42802$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($0c0e60e86bd42802$var$r)), u.props.value) : n.__;
}
function $0c0e60e86bd42802$export$dc8fbce3eb94dc1e(n, t) {
    $0c0e60e86bd42802$var$c.useDebugValue && $0c0e60e86bd42802$var$c.useDebugValue(t ? t(n) : n);
}
function $0c0e60e86bd42802$export$c052f6604b7d51fe(n) {
    var u = $0c0e60e86bd42802$var$p($0c0e60e86bd42802$var$t++, 10), i = $0c0e60e86bd42802$export$60241385465d0a34();
    return u.__ = n, $0c0e60e86bd42802$var$r.componentDidCatch || ($0c0e60e86bd42802$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $0c0e60e86bd42802$export$f680877a34711e37() {
    var _$n = $0c0e60e86bd42802$var$p($0c0e60e86bd42802$var$t++, 11);
    if (!_$n.__) {
        for(var u = $0c0e60e86bd42802$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function $0c0e60e86bd42802$var$j() {
    for(var _$n; _$n = $0c0e60e86bd42802$var$f.shift();)if (_$n.__P && _$n.__H) try {
        _$n.__H.__h.forEach($0c0e60e86bd42802$var$z), _$n.__H.__h.forEach($0c0e60e86bd42802$var$B), _$n.__H.__h = [];
    } catch (t) {
        _$n.__H.__h = [], $0c0e60e86bd42802$var$c.__e(t, _$n.__v);
    }
}
$0c0e60e86bd42802$var$c.__b = function(n) {
    $0c0e60e86bd42802$var$r = null, $0c0e60e86bd42802$var$e && $0c0e60e86bd42802$var$e(n);
}, $0c0e60e86bd42802$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $0c0e60e86bd42802$var$s && $0c0e60e86bd42802$var$s(n, t);
}, $0c0e60e86bd42802$var$c.__r = function(n) {
    $0c0e60e86bd42802$var$a && $0c0e60e86bd42802$var$a(n), $0c0e60e86bd42802$var$t = 0;
    var i = ($0c0e60e86bd42802$var$r = n.__c).__H;
    i && ($0c0e60e86bd42802$var$u === $0c0e60e86bd42802$var$r ? (i.__h = [], $0c0e60e86bd42802$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($0c0e60e86bd42802$var$z), i.__h.forEach($0c0e60e86bd42802$var$B), i.__h = [], $0c0e60e86bd42802$var$t = 0)), $0c0e60e86bd42802$var$u = $0c0e60e86bd42802$var$r;
}, $0c0e60e86bd42802$var$c.diffed = function(n) {
    $0c0e60e86bd42802$var$v && $0c0e60e86bd42802$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $0c0e60e86bd42802$var$f.push(t) && $0c0e60e86bd42802$var$i === $0c0e60e86bd42802$var$c.requestAnimationFrame || (($0c0e60e86bd42802$var$i = $0c0e60e86bd42802$var$c.requestAnimationFrame) || $0c0e60e86bd42802$var$w)($0c0e60e86bd42802$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $0c0e60e86bd42802$var$u = $0c0e60e86bd42802$var$r = null;
}, $0c0e60e86bd42802$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($0c0e60e86bd42802$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $0c0e60e86bd42802$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $0c0e60e86bd42802$var$c.__e(r, n.__v);
        }
    }), $0c0e60e86bd42802$var$l && $0c0e60e86bd42802$var$l(n, t);
}, $0c0e60e86bd42802$var$c.unmount = function(n) {
    $0c0e60e86bd42802$var$m && $0c0e60e86bd42802$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $0c0e60e86bd42802$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $0c0e60e86bd42802$var$c.__e(t, r.__v));
};
var $0c0e60e86bd42802$var$k = "function" == typeof requestAnimationFrame;
function $0c0e60e86bd42802$var$w(n) {
    var t, r = function r() {
        clearTimeout(u), $0c0e60e86bd42802$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $0c0e60e86bd42802$var$k && (t = requestAnimationFrame(r));
}
function $0c0e60e86bd42802$var$z(n) {
    var t = $0c0e60e86bd42802$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $0c0e60e86bd42802$var$r = t;
}
function $0c0e60e86bd42802$var$B(n) {
    var t = $0c0e60e86bd42802$var$r;
    n.__c = n.__(), $0c0e60e86bd42802$var$r = t;
}
function $0c0e60e86bd42802$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $0c0e60e86bd42802$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});



parcelRegister("c5KQ9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $024595d31d12e077$export$2b8d127b894957b9; }, function (v) { return $024595d31d12e077$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $024595d31d12e077$export$cea3a54a6425200c; }, function (v) { return $024595d31d12e077$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $024595d31d12e077$export$a7c73072b1a182ae; }, function (v) { return $024595d31d12e077$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $024595d31d12e077$export$9f27bc3417b4524d; }, function (v) { return $024595d31d12e077$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $024595d31d12e077$export$db77ccec0bb4ccac; }, function (v) { return $024595d31d12e077$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $024595d31d12e077$export$8392c0c9d3dcbd35; }, function (v) { return $024595d31d12e077$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $024595d31d12e077$export$ffb0004e005737fa; }, function (v) { return $024595d31d12e077$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $024595d31d12e077$export$b624eff549462981; }, function (v) { return $024595d31d12e077$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $024595d31d12e077$export$7897aa7841a5380c; }, function (v) { return $024595d31d12e077$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $024595d31d12e077$export$602eac185826482c; }, function (v) { return $024595d31d12e077$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $024595d31d12e077$export$e2c29f18771995cb; }, function (v) { return $024595d31d12e077$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $024595d31d12e077$export$5f8d39834fd61797; }, function (v) { return $024595d31d12e077$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $024595d31d12e077$export$74bf444e3cd11ea5; }, function (v) { return $024595d31d12e077$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $024595d31d12e077$export$92387174baf9b227; }, function (v) { return $024595d31d12e077$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $024595d31d12e077$export$ec112efeb987d9c6; }, function (v) { return $024595d31d12e077$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $024595d31d12e077$export$b706b080d889d2c9; }, function (v) { return $024595d31d12e077$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $024595d31d12e077$export$5be5a87408f70ddc; }, function (v) { return $024595d31d12e077$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $024595d31d12e077$export$45a5e7f76e0caa8d; }, function (v) { return $024595d31d12e077$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $024595d31d12e077$export$455c2e768291efa6; }, function (v) { return $024595d31d12e077$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $024595d31d12e077$export$9522e17588c12572; }, function (v) { return $024595d31d12e077$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $024595d31d12e077$export$2110ac352bb060b9; }, function (v) { return $024595d31d12e077$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $024595d31d12e077$export$56885ab8b9c456ab; }, function (v) { return $024595d31d12e077$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $024595d31d12e077$export$d927fcb6adf8f9de; }, function (v) { return $024595d31d12e077$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $024595d31d12e077$export$b82d16f27459e05a; }, function (v) { return $024595d31d12e077$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $024595d31d12e077$export$522c17b4f5e123e8; }, function (v) { return $024595d31d12e077$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $024595d31d12e077$export$1aabd8a0274ecfd6; }, function (v) { return $024595d31d12e077$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $024595d31d12e077$export$9b621391a187a31a; }, function (v) { return $024595d31d12e077$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $024595d31d12e077$export$f5bbd400c2f4426f; }, function (v) { return $024595d31d12e077$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5f0Cq = parcelRequire("5f0Cq");
var $024595d31d12e077$export$2b8d127b894957b9;
var $024595d31d12e077$export$cea3a54a6425200c;
var $024595d31d12e077$export$a7c73072b1a182ae;
var $024595d31d12e077$export$9f27bc3417b4524d;
var $024595d31d12e077$export$db77ccec0bb4ccac;
var $024595d31d12e077$export$8392c0c9d3dcbd35;
var $024595d31d12e077$export$ffb0004e005737fa;
var $024595d31d12e077$export$b624eff549462981;
var $024595d31d12e077$export$7897aa7841a5380c;
var $024595d31d12e077$export$602eac185826482c;
var $024595d31d12e077$export$e2c29f18771995cb;
var $024595d31d12e077$export$5f8d39834fd61797;
var $024595d31d12e077$export$74bf444e3cd11ea5;
var $024595d31d12e077$export$92387174baf9b227;
var $024595d31d12e077$export$ec112efeb987d9c6;
var $024595d31d12e077$export$b706b080d889d2c9;
var $024595d31d12e077$export$5be5a87408f70ddc;
var $024595d31d12e077$export$45a5e7f76e0caa8d;
var $024595d31d12e077$export$455c2e768291efa6;
var $024595d31d12e077$export$9522e17588c12572;
var $024595d31d12e077$export$2110ac352bb060b9;
var $024595d31d12e077$export$56885ab8b9c456ab;
var $024595d31d12e077$export$d927fcb6adf8f9de;
var $024595d31d12e077$export$b82d16f27459e05a;
var $024595d31d12e077$export$522c17b4f5e123e8;
var $024595d31d12e077$export$1aabd8a0274ecfd6;
var $024595d31d12e077$export$9b621391a187a31a;
var $024595d31d12e077$export$f5bbd400c2f4426f;
'use strict';
var $024595d31d12e077$var$b = "function" === typeof Symbol && Symbol.for, $024595d31d12e077$var$c = $024595d31d12e077$var$b ? Symbol.for("react.element") : 60103, $024595d31d12e077$var$d = $024595d31d12e077$var$b ? Symbol.for("react.portal") : 60106, $024595d31d12e077$var$e = $024595d31d12e077$var$b ? Symbol.for("react.fragment") : 60107, $024595d31d12e077$var$f = $024595d31d12e077$var$b ? Symbol.for("react.strict_mode") : 60108, $024595d31d12e077$var$g = $024595d31d12e077$var$b ? Symbol.for("react.profiler") : 60114, $024595d31d12e077$var$h = $024595d31d12e077$var$b ? Symbol.for("react.provider") : 60109, $024595d31d12e077$var$k = $024595d31d12e077$var$b ? Symbol.for("react.context") : 60110, $024595d31d12e077$var$l = $024595d31d12e077$var$b ? Symbol.for("react.async_mode") : 60111, $024595d31d12e077$var$m = $024595d31d12e077$var$b ? Symbol.for("react.concurrent_mode") : 60111, $024595d31d12e077$var$n = $024595d31d12e077$var$b ? Symbol.for("react.forward_ref") : 60112, $024595d31d12e077$var$p = $024595d31d12e077$var$b ? Symbol.for("react.suspense") : 60113, $024595d31d12e077$var$q = $024595d31d12e077$var$b ? Symbol.for("react.suspense_list") : 60120, $024595d31d12e077$var$r = $024595d31d12e077$var$b ? Symbol.for("react.memo") : 60115, $024595d31d12e077$var$t = $024595d31d12e077$var$b ? Symbol.for("react.lazy") : 60116, $024595d31d12e077$var$v = $024595d31d12e077$var$b ? Symbol.for("react.block") : 60121, $024595d31d12e077$var$w = $024595d31d12e077$var$b ? Symbol.for("react.fundamental") : 60117, $024595d31d12e077$var$x = $024595d31d12e077$var$b ? Symbol.for("react.responder") : 60118, $024595d31d12e077$var$y = $024595d31d12e077$var$b ? Symbol.for("react.scope") : 60119;
function $024595d31d12e077$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $5f0Cq._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $024595d31d12e077$var$c:
                switch(a = a.type, a){
                    case $024595d31d12e077$var$l:
                    case $024595d31d12e077$var$m:
                    case $024595d31d12e077$var$e:
                    case $024595d31d12e077$var$g:
                    case $024595d31d12e077$var$f:
                    case $024595d31d12e077$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $024595d31d12e077$var$k:
                            case $024595d31d12e077$var$n:
                            case $024595d31d12e077$var$t:
                            case $024595d31d12e077$var$r:
                            case $024595d31d12e077$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $024595d31d12e077$var$d:
                return u;
        }
    }
}
function $024595d31d12e077$var$A(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$m;
}
$024595d31d12e077$export$2b8d127b894957b9 = $024595d31d12e077$var$l;
$024595d31d12e077$export$cea3a54a6425200c = $024595d31d12e077$var$m;
$024595d31d12e077$export$a7c73072b1a182ae = $024595d31d12e077$var$k;
$024595d31d12e077$export$9f27bc3417b4524d = $024595d31d12e077$var$h;
$024595d31d12e077$export$db77ccec0bb4ccac = $024595d31d12e077$var$c;
$024595d31d12e077$export$8392c0c9d3dcbd35 = $024595d31d12e077$var$n;
$024595d31d12e077$export$ffb0004e005737fa = $024595d31d12e077$var$e;
$024595d31d12e077$export$b624eff549462981 = $024595d31d12e077$var$t;
$024595d31d12e077$export$7897aa7841a5380c = $024595d31d12e077$var$r;
$024595d31d12e077$export$602eac185826482c = $024595d31d12e077$var$d;
$024595d31d12e077$export$e2c29f18771995cb = $024595d31d12e077$var$g;
$024595d31d12e077$export$5f8d39834fd61797 = $024595d31d12e077$var$f;
$024595d31d12e077$export$74bf444e3cd11ea5 = $024595d31d12e077$var$p;
$024595d31d12e077$export$92387174baf9b227 = function(a) {
    return $024595d31d12e077$var$A(a) || $024595d31d12e077$var$z(a) === $024595d31d12e077$var$l;
};
$024595d31d12e077$export$ec112efeb987d9c6 = $024595d31d12e077$var$A;
$024595d31d12e077$export$b706b080d889d2c9 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$k;
};
$024595d31d12e077$export$5be5a87408f70ddc = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$h;
};
$024595d31d12e077$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $5f0Cq._)(a)) && null !== a && a.$$typeof === $024595d31d12e077$var$c;
};
$024595d31d12e077$export$455c2e768291efa6 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$n;
};
$024595d31d12e077$export$9522e17588c12572 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$e;
};
$024595d31d12e077$export$2110ac352bb060b9 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$t;
};
$024595d31d12e077$export$56885ab8b9c456ab = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$r;
};
$024595d31d12e077$export$d927fcb6adf8f9de = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$d;
};
$024595d31d12e077$export$b82d16f27459e05a = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$g;
};
$024595d31d12e077$export$522c17b4f5e123e8 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$f;
};
$024595d31d12e077$export$1aabd8a0274ecfd6 = function(a) {
    return $024595d31d12e077$var$z(a) === $024595d31d12e077$var$p;
};
$024595d31d12e077$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $024595d31d12e077$var$e || a === $024595d31d12e077$var$m || a === $024595d31d12e077$var$g || a === $024595d31d12e077$var$f || a === $024595d31d12e077$var$p || a === $024595d31d12e077$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $5f0Cq._)(a)) && null !== a && (a.$$typeof === $024595d31d12e077$var$t || a.$$typeof === $024595d31d12e077$var$r || a.$$typeof === $024595d31d12e077$var$h || a.$$typeof === $024595d31d12e077$var$k || a.$$typeof === $024595d31d12e077$var$n || a.$$typeof === $024595d31d12e077$var$w || a.$$typeof === $024595d31d12e077$var$x || a.$$typeof === $024595d31d12e077$var$y || a.$$typeof === $024595d31d12e077$var$v);
};
$024595d31d12e077$export$f5bbd400c2f4426f = $024595d31d12e077$var$z;

});

parcelRegister("56BWk", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $3b7af15436ec7708$export$306c0aa65ff9ec16; }, function (v) { return $3b7af15436ec7708$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3b7af15436ec7708$export$306c0aa65ff9ec16;
"use strict";
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
var $6mMqj = parcelRequire("6mMqj");
function $3b7af15436ec7708$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $3b7af15436ec7708$var$objectIs = "function" === typeof Object.is ? Object.is : $3b7af15436ec7708$var$is, $3b7af15436ec7708$var$useState = $12aPv.useState, $3b7af15436ec7708$var$useEffect = $12aPv.useEffect, $3b7af15436ec7708$var$useLayoutEffect = $12aPv.useLayoutEffect, $3b7af15436ec7708$var$useDebugValue = $12aPv.useDebugValue;
function $3b7af15436ec7708$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $3b7af15436ec7708$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $3b7af15436ec7708$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $3b7af15436ec7708$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $3b7af15436ec7708$var$useEffect(function() {
        $3b7af15436ec7708$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $3b7af15436ec7708$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $3b7af15436ec7708$var$useDebugValue(value);
    return value;
}
function $3b7af15436ec7708$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$3b7af15436ec7708$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $3b7af15436ec7708$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $3b7af15436ec7708$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $3b7af15436ec7708$var$useSyncExternalStore$1 : $3b7af15436ec7708$var$useSyncExternalStore$2;
$3b7af15436ec7708$export$306c0aa65ff9ec16 = void 0 !== $6mMqj.useSyncExternalStore ? $6mMqj.useSyncExternalStore : $3b7af15436ec7708$var$shim;

});

parcelRegister("k4gAU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e9c10da6b17a6d6e$export$2e2bcd8739ae039; });

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $Csf8W = parcelRequire("Csf8W");

var $6mMqj = parcelRequire("6mMqj");

var $eKVdo = parcelRequire("eKVdo");

var $5aDIn = parcelRequire("5aDIn");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $e9c10da6b17a6d6e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e9c10da6b17a6d6e$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e9c10da6b17a6d6e$var$ReactEditorJS(_a) {
    var factory = _a.factory, holder = _a.holder, defaultValue = _a.defaultValue, children = _a.children, value = _a.value, onInitialize = _a.onInitialize, restProps = $e9c10da6b17a6d6e$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    var memoizedHolder = (0, $6mMqj.default).useRef(holder !== null && holder !== void 0 ? holder : "react-editor-js-".concat(Date.now().toString(16)));
    var editorJS = (0, $6mMqj.default).useRef(null);
    (0, $6mMqj.default).useEffect(function() {
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return function() {
            var _$_a;
            (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.destroy();
        };
    }, []);
    (0, $6mMqj.default).useEffect(function() {
        var _$_a;
        if (value) (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.render(value);
    }, [
        value
    ]);
    return children || (0, $6mMqj.default).createElement("div", {
        id: memoizedHolder.current
    });
}
var $e9c10da6b17a6d6e$var$ClientEditorCore = /*#__PURE__*/ function() {
    "use strict";
    function ClientEditorCore(_a) {
        (0, $7lhcp._)(this, ClientEditorCore);
        var tools = _a.tools, config = $e9c10da6b17a6d6e$var$__rest(_a, [
            "tools"
        ]);
        var extendTools = Object.assign({
            // default tools
            paragraph: {
                class: (0, $5aDIn.default),
                inlineToolbar: true
            }
        }, tools);
        this._editorJS = new (0, $eKVdo.default)(Object.assign({
            tools: extendTools
        }, config));
    }
    (0, $8BtP9._)(ClientEditorCore, [
        {
            key: "dangerouslyLowLevelInstance",
            get: function get() {
                return this._editorJS;
            }
        },
        {
            key: "clear",
            value: function clear() {
                return $e9c10da6b17a6d6e$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._editorJS.clear()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "save",
            value: function save() {
                return $e9c10da6b17a6d6e$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        return [
                            2,
                            this._editorJS.save()
                        ];
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $e9c10da6b17a6d6e$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._editorJS.isReady
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._editorJS.destroy()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "render",
            value: function render(data) {
                return $e9c10da6b17a6d6e$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this._editorJS.render(data)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return ClientEditorCore;
}();
function $e9c10da6b17a6d6e$export$2e2bcd8739ae039(props) {
    var factory = (0, $6mMqj.default).useCallback(function(config) {
        return new $e9c10da6b17a6d6e$var$ClientEditorCore(config);
    }, []);
    return (0, $6mMqj.default).createElement($e9c10da6b17a6d6e$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});
parcelRegister("eKVdo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e310f5997d90c4d6$export$2e2bcd8739ae039; });

var $aVdP5 = parcelRequire("aVdP5");

var $hVBqc = parcelRequire("hVBqc");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");

var $1Qmny = parcelRequire("1Qmny");

var $Csf8W = parcelRequire("Csf8W");

var $Csf8W = parcelRequire("Csf8W");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $5f0Cq._)(document)) < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $e310f5997d90c4d6$var$Ce = (typeof globalThis === "undefined" ? "undefined" : (0, $5f0Cq._)(globalThis)) < "u" ? globalThis : (typeof window === "undefined" ? "undefined" : (0, $5f0Cq._)(window)) < "u" ? window : (typeof $parcel$global === "undefined" ? "undefined" : (0, $5f0Cq._)($parcel$global)) < "u" ? $parcel$global : (typeof self === "undefined" ? "undefined" : (0, $5f0Cq._)(self)) < "u" ? self : {};
function $e310f5997d90c4d6$var$Ke(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $e310f5997d90c4d6$var$Xn(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t1 = function o() {
            return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t1.prototype = e.prototype;
    } else t1 = {};
    return Object.defineProperty(t1, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(o) {
        var i = Object.getOwnPropertyDescriptor(n, o);
        Object.defineProperty(t1, o, i.get ? i : {
            enumerable: !0,
            get: function get() {
                return n[o];
            }
        });
    }), t1;
}
function $e310f5997d90c4d6$var$ot() {}
Object.assign($e310f5997d90c4d6$var$ot, {
    default: $e310f5997d90c4d6$var$ot,
    register: $e310f5997d90c4d6$var$ot,
    revert: function revert() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    var e = (this.document || this.ownerDocument).querySelectorAll(n);
    var t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    var e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    var t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach(function(o) {
        var i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    var e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, a = this.offsetLeft - e.offsetLeft < e.scrollLeft, l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    var e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function timeRemaining() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
var $e310f5997d90c4d6$var$Vn = function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    return crypto.getRandomValues(new Uint8Array(n)).reduce(function(e, t1) {
        return t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e;
    }, "");
};
var $e310f5997d90c4d6$var$Lo = /* @__PURE__ */ function(n) {
    return n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n;
}($e310f5997d90c4d6$var$Lo || {});
var $e310f5997d90c4d6$var$y = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $e310f5997d90c4d6$var$qn = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $e310f5997d90c4d6$var$Ie(n, e) {
    var t1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "log", o = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "color: inherit";
    if (!("console" in window) || !window.console[t1]) return;
    var s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($e310f5997d90c4d6$var$Ie.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    var a = "Editor.js 2.31.0", l = "line-height: 1em;\n            color: #006FEA;\n            display: inline-block;\n            font-size: 11px;\n            line-height: 1em;\n            background-color: #fff;\n            padding: 4px 9px;\n            border-radius: 30px;\n            border: 1px solid rgba(56, 138, 229, 0.16);\n            margin: 4px 5px 4px 0;";
    n && (s ? (r.unshift(l, i), e = "%c".concat(a, "%c ").concat(e)) : e = "( ".concat(a, " )").concat(e));
    try {
        var _console, _console1;
        s ? o ? (_console = console)[t1].apply(_console, [
            "".concat(e, " %o")
        ].concat((0, $fsSDT._)(r))) : (_console1 = console)[t1].apply(_console1, [
            e
        ].concat((0, $fsSDT._)(r))) : console[t1](e);
    } catch (e) {}
}
$e310f5997d90c4d6$var$Ie.logLevel = "VERBOSE";
function $e310f5997d90c4d6$var$Zn(n) {
    $e310f5997d90c4d6$var$Ie.logLevel = n;
}
var $e310f5997d90c4d6$var$S = $e310f5997d90c4d6$var$Ie.bind(window, !1), $e310f5997d90c4d6$var$X = $e310f5997d90c4d6$var$Ie.bind(window, !0);
function $e310f5997d90c4d6$var$le(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $e310f5997d90c4d6$var$A(n) {
    return $e310f5997d90c4d6$var$le(n) === "function" || $e310f5997d90c4d6$var$le(n) === "asyncfunction";
}
function $e310f5997d90c4d6$var$D(n) {
    return $e310f5997d90c4d6$var$le(n) === "object";
}
function $e310f5997d90c4d6$var$te(n) {
    return $e310f5997d90c4d6$var$le(n) === "string";
}
function $e310f5997d90c4d6$var$Gn(n) {
    return $e310f5997d90c4d6$var$le(n) === "boolean";
}
function $e310f5997d90c4d6$var$yo(n) {
    return $e310f5997d90c4d6$var$le(n) === "number";
}
function $e310f5997d90c4d6$var$wo(n) {
    return $e310f5997d90c4d6$var$le(n) === "undefined";
}
function $e310f5997d90c4d6$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $e310f5997d90c4d6$var$Po(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
function $e310f5997d90c4d6$var$Qn(n) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {}, t1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        function o(i, s, r) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var e;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                i.function(i.data)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                s($e310f5997d90c4d6$var$wo(i.data) ? {} : i.data)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            r($e310f5997d90c4d6$var$wo(i.data) ? {} : i.data);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
        return (0, $Csf8W.__generator)(this, function(_state) {
            return [
                2,
                n.reduce(function(i, s) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        i
                                    ];
                                case 1:
                                    return [
                                        2,
                                        (_state.sent(), o(s, e, t1))
                                    ];
                            }
                        });
                    })();
                }, Promise.resolve())
            ];
        });
    })();
}
function $e310f5997d90c4d6$var$No(n) {
    return Array.prototype.slice.call(n);
}
function $e310f5997d90c4d6$var$Fe(n, e) {
    return function() {
        var t1 = this, o = arguments;
        window.setTimeout(function() {
            return n.apply(t1, o);
        }, e);
    };
}
function $e310f5997d90c4d6$var$Jn(n) {
    return n.name.split(".").pop();
}
function $e310f5997d90c4d6$var$ei(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $e310f5997d90c4d6$var$Eo(n, e, t1) {
    var _this = this;
    var o;
    return function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        var s = _this, r = function() {
            o = null, t1 || n.apply(s, i);
        }, a = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $e310f5997d90c4d6$var$dt(n, e, t1) {
    var o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    var l = function l() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        var c = Date.now();
        !a && t1.leading === !1 && (a = c);
        var d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
function $e310f5997d90c4d6$var$ti() {
    var n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find(function(t1) {
        return window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1;
    });
    return e && (n[e] = !0), n;
}
function $e310f5997d90c4d6$var$je(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $e310f5997d90c4d6$var$ut(n) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    if (!e.length) return n;
    var t1 = e.shift();
    if ($e310f5997d90c4d6$var$D(n) && $e310f5997d90c4d6$var$D(t1)) for(var o in t1)$e310f5997d90c4d6$var$D(t1[o]) ? (n[o] || Object.assign(n, (0, $5RfYb._)({}, o, {})), $e310f5997d90c4d6$var$ut(n[o], t1[o])) : Object.assign(n, (0, $5RfYb._)({}, o, t1[o]));
    return $e310f5997d90c4d6$var$ut.apply(void 0, [
        n
    ].concat((0, $fsSDT._)(e)));
}
function $e310f5997d90c4d6$var$vt(n) {
    var e = $e310f5997d90c4d6$var$ti();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $e310f5997d90c4d6$var$oi(n) {
    try {
        return new URL(n).href;
    } catch (e) {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $e310f5997d90c4d6$var$ni() {
    return $e310f5997d90c4d6$var$Vn(10);
}
function $e310f5997d90c4d6$var$ii(n) {
    window.open(n, "_blank");
}
function $e310f5997d90c4d6$var$si() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat(n).concat(Math.floor(Math.random() * 1e8).toString(16));
}
function $e310f5997d90c4d6$var$ht(n, e, t1) {
    var o = "\xab".concat(e, "\xbb is deprecated and will be removed in the next major release. Please use the \xab").concat(t1, "\xbb instead.");
    n && $e310f5997d90c4d6$var$X(o, "warn");
}
function $e310f5997d90c4d6$var$me(n, e, t1) {
    var o = t1.value ? "value" : "get", i = t1[o], s = "#".concat(e, "Cache");
    if (t1[o] = function() {
        for(var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++){
            r[_key] = arguments[_key];
        }
        var _i;
        return this[s] === void 0 && (this[s] = (_i = i).apply.apply(_i, [
            this
        ].concat((0, $fsSDT._)(r)))), this[s];
    }, o === "get" && t1.set) {
        var r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
var $e310f5997d90c4d6$var$Ro = 650;
function $e310f5997d90c4d6$var$be() {
    return window.matchMedia("(max-width: ".concat($e310f5997d90c4d6$var$Ro, "px)")).matches;
}
var $e310f5997d90c4d6$var$pt = (typeof window === "undefined" ? "undefined" : (0, $5f0Cq._)(window)) < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $e310f5997d90c4d6$var$ri(n, e) {
    var t1 = Array.isArray(n) || $e310f5997d90c4d6$var$D(n), o = Array.isArray(e) || $e310f5997d90c4d6$var$D(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
var $e310f5997d90c4d6$var$u = /*#__PURE__*/ function() {
    "use strict";
    function u() {
        (0, $7lhcp._)(this, u);
    }
    (0, $8BtP9._)(u, null, [
        {
            key: "isSingleTag",
            value: /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ function isSingleTag(e) {
                return e.tagName && [
                    "AREA",
                    "BASE",
                    "BR",
                    "COL",
                    "COMMAND",
                    "EMBED",
                    "HR",
                    "IMG",
                    "INPUT",
                    "KEYGEN",
                    "LINK",
                    "META",
                    "PARAM",
                    "SOURCE",
                    "TRACK",
                    "WBR"
                ].includes(e.tagName);
            }
        },
        {
            key: "isLineBreakTag",
            value: /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ function isLineBreakTag(e) {
                return e && e.tagName && [
                    "BR",
                    "WBR"
                ].includes(e.tagName);
            }
        },
        {
            key: "make",
            value: /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ function make(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var i = document.createElement(e);
                if (Array.isArray(t1)) {
                    var _i_classList;
                    var s = t1.filter(function(r) {
                        return r !== void 0;
                    });
                    (_i_classList = i.classList).add.apply(_i_classList, (0, $fsSDT._)(s));
                } else t1 && i.classList.add(t1);
                for(var s1 in o)Object.prototype.hasOwnProperty.call(o, s1) && (i[s1] = o[s1]);
                return i;
            }
        },
        {
            key: "text",
            value: /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ function text(e) {
                return document.createTextNode(e);
            }
        },
        {
            key: "append",
            value: /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ function append(e, t1) {
                Array.isArray(t1) ? t1.forEach(function(o) {
                    return e.appendChild(o);
                }) : e.appendChild(t1);
            }
        },
        {
            key: "prepend",
            value: /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ function prepend(e, t1) {
                Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach(function(o) {
                    return e.prepend(o);
                })) : e.prepend(t1);
            }
        },
        {
            key: "swap",
            value: /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ function swap(e, t1) {
                var o = document.createElement("div"), i = e.parentNode;
                i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
            }
        },
        {
            key: "find",
            value: /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ function find() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t1 = arguments.length > 1 ? arguments[1] : void 0;
                return e.querySelector(t1);
            }
        },
        {
            key: "get",
            value: /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ function get(e) {
                return document.getElementById(e);
            }
        },
        {
            key: "findAll",
            value: /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ function findAll() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t1 = arguments.length > 1 ? arguments[1] : void 0;
                return e.querySelectorAll(t1);
            }
        },
        {
            key: "allInputsSelector",
            get: /**
   * Returns CSS selector for all text inputs
   */ function get() {
                return "[contenteditable=true], textarea, input:not([type]), " + [
                    "text",
                    "password",
                    "email",
                    "number",
                    "search",
                    "tel",
                    "url"
                ].map(function(t1) {
                    return 'input[type="'.concat(t1, '"]');
                }).join(", ");
            }
        },
        {
            key: "findAllInputs",
            value: /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ function findAllInputs(e) {
                return $e310f5997d90c4d6$var$No(e.querySelectorAll(u.allInputsSelector)).reduce(function(t1, o) {
                    return u.isNativeInput(o) || u.containsOnlyInlineElements(o) ? (0, $fsSDT._)(t1).concat([
                        o
                    ]) : (0, $fsSDT._)(t1).concat((0, $fsSDT._)(u.getDeepestBlockElements(o)));
                }, []);
            }
        },
        {
            key: "getDeepestNode",
            value: /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ function getDeepestNode(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
                if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
                    var s = e[o];
                    if (u.isSingleTag(s) && !u.isNativeInput(s) && !u.isLineBreakTag(s)) {
                        if (s[i]) s = s[i];
                        else if (s.parentNode[i]) s = s.parentNode[i];
                        else return s.parentNode;
                    }
                    return this.getDeepestNode(s, t1);
                }
                return e;
            }
        },
        {
            key: "isElement",
            value: /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function isElement(e) {
                return $e310f5997d90c4d6$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
            }
        },
        {
            key: "isFragment",
            value: /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function isFragment(e) {
                return $e310f5997d90c4d6$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
            }
        },
        {
            key: "isContentEditable",
            value: /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ function isContentEditable(e) {
                return e.contentEditable === "true";
            }
        },
        {
            key: "isNativeInput",
            value: /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function isNativeInput(e) {
                var t1 = [
                    "INPUT",
                    "TEXTAREA"
                ];
                return e && e.tagName ? t1.includes(e.tagName) : !1;
            }
        },
        {
            key: "canSetCaret",
            value: /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ function canSetCaret(e) {
                var t1 = !0;
                if (u.isNativeInput(e)) switch(e.type){
                    case "file":
                    case "checkbox":
                    case "radio":
                    case "hidden":
                    case "submit":
                    case "button":
                    case "image":
                    case "reset":
                        t1 = !1;
                        break;
                }
                else t1 = u.isContentEditable(e);
                return t1;
            }
        },
        {
            key: "isNodeEmpty",
            value: /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ function isNodeEmpty(e, t1) {
                var o;
                return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.length === 0);
            }
        },
        {
            key: "isLeaf",
            value: /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ function isLeaf(e) {
                return e ? e.childNodes.length === 0 : !1;
            }
        },
        {
            key: "isEmpty",
            value: /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ function isEmpty(e, t1) {
                var o = [
                    e
                ];
                for(; o.length > 0;)if (e = o.shift(), !!e) {
                    var _o;
                    if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
                    e.childNodes && (_o = o).push.apply(_o, (0, $fsSDT._)(Array.from(e.childNodes)));
                }
                return !0;
            }
        },
        {
            key: "isHTMLString",
            value: /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ function isHTMLString(e) {
                var t1 = u.make("div");
                return t1.innerHTML = e, t1.childElementCount > 0;
            }
        },
        {
            key: "getContentLength",
            value: /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ function getContentLength(e) {
                return u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
            }
        },
        {
            key: "blockElements",
            get: /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ function get() {
                return [
                    "address",
                    "article",
                    "aside",
                    "blockquote",
                    "canvas",
                    "div",
                    "dl",
                    "dt",
                    "fieldset",
                    "figcaption",
                    "figure",
                    "footer",
                    "form",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "header",
                    "hgroup",
                    "hr",
                    "li",
                    "main",
                    "nav",
                    "noscript",
                    "ol",
                    "output",
                    "p",
                    "pre",
                    "ruby",
                    "section",
                    "table",
                    "tbody",
                    "thead",
                    "tr",
                    "tfoot",
                    "ul",
                    "video"
                ];
            }
        },
        {
            key: "containsOnlyInlineElements",
            value: /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ function containsOnlyInlineElements(e) {
                var t1;
                $e310f5997d90c4d6$var$te(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
                var o = function(i) {
                    return !u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
                };
                return Array.from(t1.children).every(o);
            }
        },
        {
            key: "getDeepestBlockElements",
            value: /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ function getDeepestBlockElements(e) {
                return u.containsOnlyInlineElements(e) ? [
                    e
                ] : Array.from(e.children).reduce(function(t1, o) {
                    return (0, $fsSDT._)(t1).concat((0, $fsSDT._)(u.getDeepestBlockElements(o)));
                }, []);
            }
        },
        {
            key: "getHolder",
            value: /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ function getHolder(e) {
                return $e310f5997d90c4d6$var$te(e) ? document.getElementById(e) : e;
            }
        },
        {
            key: "isAnchor",
            value: /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ function isAnchor(e) {
                return e.tagName.toLowerCase() === "a";
            }
        },
        {
            key: "offset",
            value: /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ function offset(e) {
                var t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
                return {
                    top: s,
                    left: r,
                    bottom: s + t1.height,
                    right: r + t1.width
                };
            }
        },
        {
            key: "getNodeByOffset",
            value: /**
   * Find text node and offset by total content offset
   *
   * @param {Node} root - root node to start search from
   * @param {number} totalOffset - offset relative to the root node content
   * @returns {{node: Node | null, offset: number}} - node and offset inside node
   */ function getNodeByOffset(e, t1) {
                var o = 0, i = null;
                var s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
                var r = s.nextNode();
                for(; r;){
                    var c = r.textContent, d = c === null ? 0 : c.length;
                    if (i = r, o + d >= t1) break;
                    o += d, r = s.nextNode();
                }
                if (!i) return {
                    node: null,
                    offset: 0
                };
                var a = i.textContent;
                if (a === null || a.length === 0) return {
                    node: null,
                    offset: 0
                };
                var l = Math.min(t1 - o, a.length);
                return {
                    node: i,
                    offset: l
                };
            }
        }
    ]);
    return u;
}();
function $e310f5997d90c4d6$var$ai(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $e310f5997d90c4d6$var$li(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2;
    return r + s + i + l + a;
}
function $e310f5997d90c4d6$var$Do(n) {
    n.dataset.empty = $e310f5997d90c4d6$var$u.isEmpty(n) ? "true" : "false";
}
var $e310f5997d90c4d6$var$ci = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $e310f5997d90c4d6$var$di = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $e310f5997d90c4d6$var$ui = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $e310f5997d90c4d6$var$hi = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $e310f5997d90c4d6$var$Fo = {
    ui: $e310f5997d90c4d6$var$ci,
    toolNames: $e310f5997d90c4d6$var$di,
    tools: $e310f5997d90c4d6$var$ui,
    blockTunes: $e310f5997d90c4d6$var$hi
}, $e310f5997d90c4d6$var$jo = /*#__PURE__*/ function() {
    "use strict";
    function he() {
        (0, $7lhcp._)(this, he);
    }
    (0, $8BtP9._)(he, null, [
        {
            key: "ui",
            value: /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ function ui(e, t1) {
                return he._t(e, t1);
            }
        },
        {
            key: "t",
            value: /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ function t1(e, _t) {
                return he._t(e, _t);
            }
        },
        {
            key: "setDictionary",
            value: /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ function setDictionary(e) {
                he.currentDictionary = e;
            }
        },
        {
            key: "_t",
            value: /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ function _t(e, t1) {
                var o = he.getNamespace(e);
                return !o || !o[t1] ? t1 : o[t1];
            }
        },
        {
            key: "getNamespace",
            value: /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ function getNamespace(e) {
                return e.split(".").reduce(function(o, i) {
                    return !o || !Object.keys(o).length ? {} : o[i];
                }, he.currentDictionary);
            }
        }
    ]);
    return he;
}();
$e310f5997d90c4d6$var$jo.currentDictionary = $e310f5997d90c4d6$var$Fo;
var $e310f5997d90c4d6$var$z = $e310f5997d90c4d6$var$jo;
var $e310f5997d90c4d6$var$Ho = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $h6w6E._)(Ho, Error1);
    function Ho() {
        (0, $7lhcp._)(this, Ho);
        return (0, $07dqX._)(this, Ho, arguments);
    }
    return Ho;
}((0, $1Qmny._)(Error));
var $e310f5997d90c4d6$var$Oe = /*#__PURE__*/ function() {
    "use strict";
    function Oe() {
        (0, $7lhcp._)(this, Oe);
        this.subscribers = {};
    }
    (0, $8BtP9._)(Oe, [
        {
            /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ key: "on",
            value: function on(e, t1) {
                e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
            }
        },
        {
            /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ key: "once",
            value: function once(e, t1) {
                var _this = this;
                e in this.subscribers || (this.subscribers[e] = []);
                var o = function(i) {
                    var s = t1(i), r = _this.subscribers[e].indexOf(o);
                    return r !== -1 && _this.subscribers[e].splice(r, 1), s;
                };
                this.subscribers[e].push(o);
            }
        },
        {
            /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ key: "emit",
            value: function emit(e, t1) {
                $e310f5997d90c4d6$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce(function(o, i) {
                    var s = i(o);
                    return s !== void 0 ? s : o;
                }, t1);
            }
        },
        {
            /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ key: "off",
            value: function off(e, t1) {
                if (this.subscribers[e] === void 0) {
                    console.warn('EventDispatcher .off(): there is no subscribers for event "'.concat(e.toString(), '". Probably, .off() called before .on()'));
                    return;
                }
                for(var o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
                    delete this.subscribers[e][o];
                    break;
                }
            }
        },
        {
            /**
   * Destroyer
   * clears subscribers list
   */ key: "destroy",
            value: function destroy() {
                this.subscribers = {};
            }
        }
    ]);
    return Oe;
}();
function $e310f5997d90c4d6$var$J(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call: function(t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save: function() {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate: function(t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange: function() {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry: function() {
            return n.getActiveToolboxEntry();
        }
    });
}
var $e310f5997d90c4d6$var$_e = /*#__PURE__*/ function() {
    "use strict";
    function _e() {
        (0, $7lhcp._)(this, _e);
        this.allListeners = [];
    }
    (0, $8BtP9._)(_e, [
        {
            /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ key: "on",
            value: function on(e, t1, o) {
                var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                var s = $e310f5997d90c4d6$var$si("l"), r = {
                    id: s,
                    element: e,
                    eventType: t1,
                    handler: o,
                    options: i
                };
                if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
            }
        },
        {
            /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ key: "off",
            value: function off(e, t1, o, i) {
                var _this = this;
                var s = this.findAll(e, t1, o);
                s.forEach(function(r, a) {
                    var l = _this.allListeners.indexOf(s[a]);
                    l > -1 && (_this.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
                });
            }
        },
        {
            /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ key: "offById",
            value: function offById(e) {
                var t1 = this.findById(e);
                t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
            }
        },
        {
            /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ key: "findOne",
            value: function findOne(e, t1, o) {
                var i = this.findAll(e, t1, o);
                return i.length > 0 ? i[0] : null;
            }
        },
        {
            /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ key: "findAll",
            value: function findAll(e, t1, o) {
                var i;
                var s = e ? this.findByEventTarget(e) : [];
                return e && t1 && o ? i = s.filter(function(r) {
                    return r.eventType === t1 && r.handler === o;
                }) : e && t1 ? i = s.filter(function(r) {
                    return r.eventType === t1;
                }) : i = s, i;
            }
        },
        {
            /**
   * Removes all listeners
   */ key: "removeAll",
            value: function removeAll() {
                this.allListeners.map(function(e) {
                    e.element.removeEventListener(e.eventType, e.handler, e.options);
                }), this.allListeners = [];
            }
        },
        {
            /**
   * Module cleanup on destruction
   */ key: "destroy",
            value: function destroy() {
                this.removeAll();
            }
        },
        {
            /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ key: "findByEventTarget",
            value: function findByEventTarget(e) {
                return this.allListeners.filter(function(t1) {
                    if (t1.element === e) return t1;
                });
            }
        },
        {
            /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ key: "findByType",
            value: function findByType(e) {
                return this.allListeners.filter(function(t1) {
                    if (t1.eventType === e) return t1;
                });
            }
        },
        {
            /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ key: "findByHandler",
            value: function findByHandler(e) {
                return this.allListeners.filter(function(t1) {
                    if (t1.handler === e) return t1;
                });
            }
        },
        {
            /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ key: "findById",
            value: function findById(e) {
                return this.allListeners.find(function(t1) {
                    return t1.id === e;
                });
            }
        }
    ]);
    return _e;
}();
var $e310f5997d90c4d6$var$E = /*#__PURE__*/ function _target() {
    "use strict";
    function E(param) {
        var _this = this;
        var e = param.config, t1 = param.eventsDispatcher;
        var _this1 = this;
        (0, $7lhcp._)(this, E);
        if (this.nodes = {}, this.listeners = new $e310f5997d90c4d6$var$_e(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: function(o, i, s) {
                var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                _this1.mutableListenerIds.push(_this1.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _this.mutableListenerIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var o = _step.value;
                        _this.listeners.offById(o);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                _this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], (this instanceof E ? this.constructor : void 0) === E) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    (0, $8BtP9._)(E, [
        {
            key: "state",
            set: /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ function set(e) {
                this.Editor = e;
            }
        },
        {
            /**
   * Remove memorized nodes
   */ key: "removeAllNodes",
            value: function removeAllNodes() {
                for(var e in this.nodes){
                    var t1 = this.nodes[e];
                    t1 instanceof HTMLElement && t1.remove();
                }
            }
        },
        {
            key: "isRtl",
            get: /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ function get() {
                return this.config.i18n.direction === "rtl";
            }
        }
    ]);
    return E;
}();
var $e310f5997d90c4d6$var$b = /*#__PURE__*/ function() {
    "use strict";
    function b() {
        (0, $7lhcp._)(this, b);
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor", this.commandRemoveFormat = "removeFormat";
    }
    (0, $8BtP9._)(b, [
        {
            /**
   * Removes fake background
   */ key: "removeFakeBackground",
            value: function removeFakeBackground() {
                this.isFakeBackgroundEnabled && (this.isFakeBackgroundEnabled = !1, document.execCommand(this.commandRemoveFormat));
            }
        },
        {
            /**
   * Sets fake background
   */ key: "setFakeBackground",
            value: function setFakeBackground() {
                document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
            }
        },
        {
            /**
   * Save SelectionUtils's range
   */ key: "save",
            value: function save() {
                this.savedSelectionRange = b.range;
            }
        },
        {
            /**
   * Restore saved SelectionUtils's range
   */ key: "restore",
            value: function restore() {
                if (!this.savedSelectionRange) return;
                var e = window.getSelection();
                e.removeAllRanges(), e.addRange(this.savedSelectionRange);
            }
        },
        {
            /**
   * Clears saved selection
   */ key: "clearSaved",
            value: function clearSaved() {
                this.savedSelectionRange = null;
            }
        },
        {
            /**
   * Collapse current selection
   */ key: "collapseToEnd",
            value: function collapseToEnd() {
                var e = window.getSelection(), t1 = document.createRange();
                t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
            }
        },
        {
            /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ key: "findParentTag",
            value: function findParentTag(e, t1) {
                var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
                var i = window.getSelection();
                var s = null;
                return !i || !i.anchorNode || !i.focusNode ? null : ([
                    /** the Node in which the selection begins */ i.anchorNode,
                    /** the Node in which the selection ends */ i.focusNode
                ].forEach(function(a) {
                    var l = o;
                    for(; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t1 && a.classList && !a.classList.contains(t1) && (s = null), s));)a = a.parentNode, l--;
                }), s);
            }
        },
        {
            /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ key: "expandToTag",
            value: function expandToTag(e) {
                var t1 = window.getSelection();
                t1.removeAllRanges();
                var o = document.createRange();
                o.selectNodeContents(e), t1.addRange(o);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ function get() {
                return {
                    editorWrapper: "codex-editor",
                    editorZone: "codex-editor__redactor"
                };
            }
        },
        {
            key: "anchorNode",
            get: /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ function get() {
                var e = window.getSelection();
                return e ? e.anchorNode : null;
            }
        },
        {
            key: "anchorElement",
            get: /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ function get() {
                var e = window.getSelection();
                if (!e) return null;
                var t1 = e.anchorNode;
                return t1 ? $e310f5997d90c4d6$var$u.isElement(t1) ? t1 : t1.parentElement : null;
            }
        },
        {
            key: "anchorOffset",
            get: /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ function get() {
                var e = window.getSelection();
                return e ? e.anchorOffset : null;
            }
        },
        {
            key: "isCollapsed",
            get: /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ function get() {
                var e = window.getSelection();
                return e ? e.isCollapsed : null;
            }
        },
        {
            key: "isAtEditor",
            get: /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ function get() {
                return this.isSelectionAtEditor(b.get());
            }
        },
        {
            key: "isSelectionAtEditor",
            value: /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ function isSelectionAtEditor(e) {
                if (!e) return !1;
                var t1 = e.anchorNode || e.focusNode;
                t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
                var o = null;
                return t1 && t1 instanceof Element && (o = t1.closest(".".concat(b.CSS.editorZone))), o ? o.nodeType === Node.ELEMENT_NODE : !1;
            }
        },
        {
            key: "isRangeAtEditor",
            value: /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ function isRangeAtEditor(e) {
                if (!e) return;
                var t1 = e.startContainer;
                t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
                var o = null;
                return t1 && t1 instanceof Element && (o = t1.closest(".".concat(b.CSS.editorZone))), o ? o.nodeType === Node.ELEMENT_NODE : !1;
            }
        },
        {
            key: "isSelectionExists",
            get: /**
   * Methods return boolean that true if selection exists on the page
   */ function get() {
                return !!b.get().anchorNode;
            }
        },
        {
            key: "range",
            get: /**
   * Return first range
   *
   * @returns {Range|null}
   */ function get() {
                return this.getRangeFromSelection(this.get());
            }
        },
        {
            key: "getRangeFromSelection",
            value: /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ function getRangeFromSelection(e) {
                return e && e.rangeCount ? e.getRangeAt(0) : null;
            }
        },
        {
            key: "rect",
            get: /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ function get() {
                var e = document.selection, t1, o = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
                if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
                if (!window.getSelection) return $e310f5997d90c4d6$var$S("Method window.getSelection is not supported", "warn"), o;
                if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $e310f5997d90c4d6$var$S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
                if (e.rangeCount === 0) return o;
                if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
                    var i = document.createElement("span");
                    if (i.getBoundingClientRect) {
                        i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                        var s = i.parentNode;
                        s.removeChild(i), s.normalize();
                    }
                }
                return o;
            }
        },
        {
            key: "text",
            get: /**
   * Returns selected text as String
   *
   * @returns {string}
   */ function get() {
                return window.getSelection ? window.getSelection().toString() : "";
            }
        },
        {
            key: "get",
            value: /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ function get() {
                return window.getSelection();
            }
        },
        {
            key: "setCursor",
            value: /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ function setCursor(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var o = document.createRange(), i = window.getSelection();
                return $e310f5997d90c4d6$var$u.isNativeInput(e) ? $e310f5997d90c4d6$var$u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
            }
        },
        {
            key: "isRangeInsideContainer",
            value: /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ function isRangeInsideContainer(e) {
                var t1 = b.range;
                return t1 === null ? !1 : e.contains(t1.startContainer);
            }
        },
        {
            key: "addFakeCursor",
            value: /**
   * Adds fake cursor to the current range
   */ function addFakeCursor() {
                var e = b.range;
                if (e === null) return;
                var t1 = $e310f5997d90c4d6$var$u.make("span", "codex-editor__fake-cursor");
                t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
            }
        },
        {
            key: "isFakeCursorInsideContainer",
            value: /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ function isFakeCursorInsideContainer(e) {
                return $e310f5997d90c4d6$var$u.find(e, ".codex-editor__fake-cursor") !== null;
            }
        },
        {
            key: "removeFakeCursor",
            value: /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ function removeFakeCursor() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.body;
                var t1 = $e310f5997d90c4d6$var$u.find(e, ".codex-editor__fake-cursor");
                t1 && t1.remove();
            }
        }
    ]);
    return b;
}();
function $e310f5997d90c4d6$var$pi(n, e) {
    var t1 = n.type, o = n.target, i = n.addedNodes, s = n.removedNodes;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some(function(l) {
        return l === e;
    }) || Array.from(s).some(function(l) {
        return l === e;
    })));
}
var $e310f5997d90c4d6$var$ft = "redactor dom changed", $e310f5997d90c4d6$var$$o = "block changed", $e310f5997d90c4d6$var$zo = "fake cursor is about to be toggled", $e310f5997d90c4d6$var$Uo = "fake cursor have been set", $e310f5997d90c4d6$var$Te = "editor mobile layout toggled";
function $e310f5997d90c4d6$var$gt(n, e) {
    if (!n.conversionConfig) return !1;
    var t1 = n.conversionConfig[e];
    return $e310f5997d90c4d6$var$A(t1) || $e310f5997d90c4d6$var$te(t1);
}
function $e310f5997d90c4d6$var$He(n, e) {
    return $e310f5997d90c4d6$var$gt(n.tool, e);
}
function $e310f5997d90c4d6$var$Wo(n, e) {
    return Object.entries(n).some(function(param) {
        var _param = (0, $leE2g._)(param, 2), t1 = _param[0], o = _param[1];
        return e[t1] && $e310f5997d90c4d6$var$ri(e[t1], o);
    });
}
function $e310f5997d90c4d6$var$Yo(n, e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var o, i;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        n.save()
                    ];
                case 1:
                    o = _state.sent().data, i = e.find(function(s) {
                        return s.name === n.name;
                    });
                    return [
                        2,
                        i !== void 0 && !$e310f5997d90c4d6$var$gt(i, "export") ? [] : e.reduce(function(s, r) {
                            if (!$e310f5997d90c4d6$var$gt(r, "import") || r.toolbox === void 0) return s;
                            var a = r.toolbox.filter(function(l) {
                                if ($e310f5997d90c4d6$var$V(l) || l.icon === void 0) return !1;
                                if (l.data !== void 0) {
                                    if ($e310f5997d90c4d6$var$Wo(l.data, o)) return !1;
                                } else if (r.name === n.name) return !1;
                                return !0;
                            });
                            return s.push((0, $ctBui._)((0, $6GCxi._)({}, r), {
                                toolbox: a
                            })), s;
                        }, [])
                    ];
            }
        });
    })();
}
function $e310f5997d90c4d6$var$xo(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $e310f5997d90c4d6$var$He(e, "export") && $e310f5997d90c4d6$var$He(n, "import") : !1;
}
function $e310f5997d90c4d6$var$fi(n, e) {
    var t1 = e == null ? void 0 : e.export;
    return $e310f5997d90c4d6$var$A(t1) ? t1(n) : $e310f5997d90c4d6$var$te(t1) ? n[t1] : (t1 !== void 0 && $e310f5997d90c4d6$var$S("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $e310f5997d90c4d6$var$Bo(n, e, t1) {
    var o = e == null ? void 0 : e.import;
    return $e310f5997d90c4d6$var$A(o) ? o(n, t1) : $e310f5997d90c4d6$var$te(o) ? (0, $5RfYb._)({}, o, n) : (o !== void 0 && $e310f5997d90c4d6$var$S("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $e310f5997d90c4d6$var$_ = /* @__PURE__ */ function(n) {
    return n.Default = "default", n.Separator = "separator", n.Html = "html", n;
}($e310f5997d90c4d6$var$_ || {}), $e310f5997d90c4d6$var$ee = /* @__PURE__ */ function(n) {
    return n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n;
}($e310f5997d90c4d6$var$ee || {});
var $e310f5997d90c4d6$var$R = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $h6w6E._)(R, Oe);
    function R(param, r) {
        var tmp = param.id, e = tmp === void 0 ? $e310f5997d90c4d6$var$ni() : tmp, t1 = param.data, o = param.tool, i = param.readOnly, s = param.tunesData;
        (0, $7lhcp._)(this, R);
        var _this;
        _this = (0, $07dqX._)(this, R), _this.cachedInputs = [], _this.toolRenderedElement = null, _this.tunesInstances = /* @__PURE__ */ new Map(), _this.defaultTunesInstances = /* @__PURE__ */ new Map(), _this.unavailableTunesData = {}, _this.inputIndex = 0, _this.editorEventBus = null, _this.handleFocus = function() {
            _this.dropInputsCache(), _this.updateCurrentInput();
        }, _this.didMutated = function(a) {
            var l = a === void 0, c = a instanceof InputEvent;
            !l && !c && _this.detectToolRootChange(a);
            var d;
            l || c ? d = !0 : d = !(a.length > 0 && a.every(function(p) {
                var g = p.addedNodes, f = p.removedNodes, v = p.target;
                return (0, $fsSDT._)(Array.from(g)).concat((0, $fsSDT._)(Array.from(f)), [
                    v
                ]).some(function(T) {
                    return $e310f5997d90c4d6$var$u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null;
                });
            })), d && (_this.dropInputsCache(), _this.updateCurrentInput(), _this.toggleInputsEmptyMark(), _this.call("updated"), _this.emit("didMutated", _this));
        }, _this.name = o.name, _this.id = e, _this.settings = o.settings, _this.config = o.settings.config || {}, _this.editorEventBus = r || null, _this.blockAPI = new $e310f5997d90c4d6$var$J(_this), _this.tool = o, _this.toolInstance = o.create(t1, _this.blockAPI, i), _this.tunes = o.tunes, _this.composeTunes(s), _this.holder = _this.compose(), window.requestIdleCallback(function() {
            _this.watchBlockMutations(), _this.addInputEvents(), _this.toggleInputsEmptyMark();
        });
        return _this;
    }
    (0, $8BtP9._)(R, [
        {
            key: "inputs",
            get: /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ function get() {
                if (this.cachedInputs.length !== 0) return this.cachedInputs;
                var e = $e310f5997d90c4d6$var$u.findAllInputs(this.holder);
                return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
            }
        },
        {
            key: "currentInput",
            get: /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[this.inputIndex];
            },
            set: /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ function set(e) {
                var t1 = this.inputs.findIndex(function(o) {
                    return o === e || o.contains(e);
                });
                t1 !== -1 && (this.inputIndex = t1);
            }
        },
        {
            key: "firstInput",
            get: /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[0];
            }
        },
        {
            key: "lastInput",
            get: /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                var e = this.inputs;
                return e[e.length - 1];
            }
        },
        {
            key: "nextInput",
            get: /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[this.inputIndex + 1];
            }
        },
        {
            key: "previousInput",
            get: /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ function get() {
                return this.inputs[this.inputIndex - 1];
            }
        },
        {
            key: "data",
            get: /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ function get() {
                return this.save().then(function(e) {
                    return e && !$e310f5997d90c4d6$var$V(e.data) ? e.data : {};
                });
            }
        },
        {
            key: "sanitize",
            get: /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ function get() {
                return this.tool.sanitizeConfig;
            }
        },
        {
            key: "mergeable",
            get: /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ function get() {
                return $e310f5997d90c4d6$var$A(this.toolInstance.merge);
            }
        },
        {
            key: "focusable",
            get: /**
   * If Block contains inputs, it is focusable
   */ function get() {
                return this.inputs.length !== 0;
            }
        },
        {
            key: "isEmpty",
            get: /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ function get() {
                var e = $e310f5997d90c4d6$var$u.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
                return e && t1;
            }
        },
        {
            key: "hasMedia",
            get: /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ function get() {
                var e = [
                    "img",
                    "iframe",
                    "video",
                    "audio",
                    "source",
                    "input",
                    "textarea",
                    "twitterwidget"
                ];
                return !!this.holder.querySelector(e.join(","));
            }
        },
        {
            key: "selected",
            get: /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ function get() {
                return this.holder.classList.contains(R.CSS.selected);
            },
            set: /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ function set(e) {
                var i, s;
                this.holder.classList.toggle(R.CSS.selected, e);
                var t1 = e === !0 && $e310f5997d90c4d6$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $e310f5997d90c4d6$var$b.isFakeCursorInsideContainer(this.holder);
                (t1 || o) && ((i = this.editorEventBus) == null || i.emit($e310f5997d90c4d6$var$zo, {
                    state: e
                }), t1 ? $e310f5997d90c4d6$var$b.addFakeCursor() : $e310f5997d90c4d6$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($e310f5997d90c4d6$var$Uo, {
                    state: e
                }));
            }
        },
        {
            key: "stretched",
            get: /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ function get() {
                return this.holder.classList.contains(R.CSS.wrapperStretched);
            },
            set: /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ function set(e) {
                this.holder.classList.toggle(R.CSS.wrapperStretched, e);
            }
        },
        {
            key: "dropTarget",
            set: /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ function set(e) {
                this.holder.classList.toggle(R.CSS.dropTarget, e);
            }
        },
        {
            key: "pluginsContent",
            get: /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ function get() {
                return this.toolRenderedElement;
            }
        },
        {
            /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ key: "call",
            value: function call(e, t1) {
                if ($e310f5997d90c4d6$var$A(this.toolInstance[e])) {
                    e === "appendCallback" && $e310f5997d90c4d6$var$S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
                    try {
                        this.toolInstance[e].call(this.toolInstance, t1);
                    } catch (o) {
                        $e310f5997d90c4d6$var$S("Error during '".concat(e, "' call: ").concat(o.message), "error");
                    }
                }
            }
        },
        {
            key: "mergeWith",
            value: /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ function mergeWith(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.toolInstance.merge(e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "save",
            value: /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ function save() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, e, t1, o, i;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.toolInstance.save(this.pluginsContent)
                                ];
                            case 1:
                                e = _state.sent(), t1 = this.unavailableTunesData;
                                (0, $fsSDT._)(this.tunesInstances.entries()).concat((0, $fsSDT._)(this.defaultTunesInstances.entries())).forEach(function(param) {
                                    var _param = (0, $leE2g._)(param, 2), s = _param[0], r = _param[1];
                                    if ($e310f5997d90c4d6$var$A(r.save)) try {
                                        t1[s] = r.save();
                                    } catch (a) {
                                        $e310f5997d90c4d6$var$S("Tune ".concat(r.constructor.name, " save method throws an Error %o"), "warn", a);
                                    }
                                });
                                o = window.performance.now();
                                return [
                                    2,
                                    Promise.resolve(e).then(function(s) {
                                        return i = window.performance.now(), {
                                            id: _this.id,
                                            tool: _this.name,
                                            data: s,
                                            tunes: t1,
                                            time: i - o
                                        };
                                    }).catch(function(s) {
                                        $e310f5997d90c4d6$var$S("Saving process for ".concat(_this.name, " tool failed due to the ").concat(s), "log", "red");
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "validate",
            value: /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ function validate(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var t1, _tmp;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                t1 = !0;
                                _tmp = this.toolInstance.validate instanceof Function;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.toolInstance.validate(e)
                                ];
                            case 1:
                                _tmp = t1 = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (_tmp, t1)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ key: "getTunes",
            value: function getTunes() {
                var _e;
                var e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
                return $e310f5997d90c4d6$var$u.isElement(o) ? e.push({
                    type: $e310f5997d90c4d6$var$_.Html,
                    element: o
                }) : Array.isArray(o) ? (_e = e).push.apply(_e, (0, $fsSDT._)(o)) : e.push(o), (0, $fsSDT._)(this.tunesInstances.values()).concat((0, $fsSDT._)(this.defaultTunesInstances.values())).map(function(s) {
                    return s.render();
                }).forEach(function(s) {
                    var _t;
                    $e310f5997d90c4d6$var$u.isElement(s) ? t1.push({
                        type: $e310f5997d90c4d6$var$_.Html,
                        element: s
                    }) : Array.isArray(s) ? (_t = t1).push.apply(_t, (0, $fsSDT._)(s)) : t1.push(s);
                }), {
                    toolTunes: e,
                    commonTunes: t1
                };
            }
        },
        {
            /**
   * Update current input index with selection anchor node
   */ key: "updateCurrentInput",
            value: function updateCurrentInput() {
                this.currentInput = $e310f5997d90c4d6$var$u.isNativeInput(document.activeElement) || !$e310f5997d90c4d6$var$b.anchorNode ? document.activeElement : $e310f5997d90c4d6$var$b.anchorNode;
            }
        },
        {
            /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ key: "dispatchChange",
            value: function dispatchChange() {
                this.didMutated();
            }
        },
        {
            /**
   * Call Tool instance destroy method
   */ key: "destroy",
            value: function destroy() {
                this.unwatchBlockMutations(), this.removeInputEvents(), (0, $5LQ10._)((0, $2JFuQ._)(R.prototype), "destroy", this).call(this), $e310f5997d90c4d6$var$A(this.toolInstance.destroy) && this.toolInstance.destroy();
            }
        },
        {
            key: "getActiveToolboxEntry",
            value: /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ function getActiveToolboxEntry() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var e, t1, o;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = this.tool.toolbox;
                                if (e.length === 1) return [
                                    2,
                                    Promise.resolve(this.tool.toolbox[0])
                                ];
                                return [
                                    4,
                                    this.data
                                ];
                            case 1:
                                t1 = _state.sent(), o = e;
                                return [
                                    2,
                                    o == null ? void 0 : o.find(function(i) {
                                        return $e310f5997d90c4d6$var$Wo(i.data, t1);
                                    })
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "exportDataAsString",
            value: /**
   * Exports Block data as string using conversion config
   */ function exportDataAsString() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var e;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.data
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    2,
                                    $e310f5997d90c4d6$var$fi(e, this.tool.conversionConfig)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ key: "compose",
            value: function compose() {
                var e = $e310f5997d90c4d6$var$u.make("div", R.CSS.wrapper), t1 = $e310f5997d90c4d6$var$u.make("div", R.CSS.content), o = this.toolInstance.render();
                e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
                var i = t1;
                return (0, $fsSDT._)(this.tunesInstances.values()).concat((0, $fsSDT._)(this.defaultTunesInstances.values())).forEach(function(s) {
                    if ($e310f5997d90c4d6$var$A(s.wrap)) try {
                        i = s.wrap(i);
                    } catch (r) {
                        $e310f5997d90c4d6$var$S("Tune ".concat(s.constructor.name, " wrap method throws an Error %o"), "warn", r);
                    }
                }), e.appendChild(i), e;
            }
        },
        {
            /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ key: "composeTunes",
            value: function composeTunes(e) {
                var _this = this;
                Array.from(this.tunes.values()).forEach(function(t1) {
                    (t1.isInternal ? _this.defaultTunesInstances : _this.tunesInstances).set(t1.name, t1.create(e[t1.name], _this.blockAPI));
                }), Object.entries(e).forEach(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[0], o = _param[1];
                    _this.tunesInstances.has(t1) || (_this.unavailableTunesData[t1] = o);
                });
            }
        },
        {
            /**
   * Adds focus event listeners to all inputs and contenteditable
   */ key: "addInputEvents",
            value: function addInputEvents() {
                var _this = this;
                this.inputs.forEach(function(e) {
                    e.addEventListener("focus", _this.handleFocus), $e310f5997d90c4d6$var$u.isNativeInput(e) && e.addEventListener("input", _this.didMutated);
                });
            }
        },
        {
            /**
   * removes focus event listeners from all inputs and contenteditable
   */ key: "removeInputEvents",
            value: function removeInputEvents() {
                var _this = this;
                this.inputs.forEach(function(e) {
                    e.removeEventListener("focus", _this.handleFocus), $e310f5997d90c4d6$var$u.isNativeInput(e) && e.removeEventListener("input", _this.didMutated);
                });
            }
        },
        {
            /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ key: "watchBlockMutations",
            value: function watchBlockMutations() {
                var _this = this;
                var e;
                this.redactorDomChangedCallback = function(t1) {
                    var o = t1.mutations;
                    o.some(function(s) {
                        return $e310f5997d90c4d6$var$pi(s, _this.toolRenderedElement);
                    }) && _this.didMutated(o);
                }, (e = this.editorEventBus) == null || e.on($e310f5997d90c4d6$var$ft, this.redactorDomChangedCallback);
            }
        },
        {
            /**
   * Remove redactor dom change event listener
   */ key: "unwatchBlockMutations",
            value: function unwatchBlockMutations() {
                var e;
                (e = this.editorEventBus) == null || e.off($e310f5997d90c4d6$var$ft, this.redactorDomChangedCallback);
            }
        },
        {
            /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ key: "detectToolRootChange",
            value: function detectToolRootChange(e) {
                var _this = this;
                e.forEach(function(t1) {
                    if (Array.from(t1.removedNodes).includes(_this.toolRenderedElement)) {
                        var i = t1.addedNodes[t1.addedNodes.length - 1];
                        _this.toolRenderedElement = i;
                    }
                });
            }
        },
        {
            /**
   * Clears inputs cached value
   */ key: "dropInputsCache",
            value: function dropInputsCache() {
                this.cachedInputs = [];
            }
        },
        {
            /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ key: "toggleInputsEmptyMark",
            value: function toggleInputsEmptyMark() {
                this.inputs.forEach($e310f5997d90c4d6$var$Do);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ function get() {
                return {
                    wrapper: "ce-block",
                    wrapperStretched: "ce-block--stretched",
                    content: "ce-block__content",
                    selected: "ce-block--selected",
                    dropTarget: "ce-block--drop-target"
                };
            }
        }
    ]);
    return R;
}($e310f5997d90c4d6$var$Oe);
var $e310f5997d90c4d6$var$gi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(gi, E);
    function gi() {
        (0, $7lhcp._)(this, gi);
        var _this;
        var _this1, _arguments = arguments;
        _this = (0, $07dqX._)(this, gi, (0, $fsSDT._)(_arguments)), _this1 = _this, _this1.insert = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this1.config.defaultBlock, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0, s = arguments.length > 4 ? arguments[4] : void 0, r = arguments.length > 5 ? arguments[5] : void 0, a = arguments.length > 6 ? arguments[6] : void 0;
            var l = _this1.Editor.BlockManager.insert({
                id: a,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $e310f5997d90c4d6$var$J(l);
        }, _this1.composeBlockData = function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var t1;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    t1 = _this1.Editor.Tools.blockTools.get(e);
                    return [
                        2,
                        new $e310f5997d90c4d6$var$R({
                            tool: t1,
                            api: _this1.Editor.API,
                            readOnly: !0,
                            data: {},
                            tunesData: {}
                        }).data
                    ];
                });
            })();
        }, _this1.update = function(e, t1, o) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var _this_Editor, i, s, r;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_Editor = _this1.Editor, i = _this_Editor.BlockManager, s = i.getBlockById(e);
                            if (s === void 0) throw new Error('Block with id "'.concat(e, '" not found'));
                            return [
                                4,
                                i.update(s, t1, o)
                            ];
                        case 1:
                            r = _state.sent();
                            return [
                                2,
                                new $e310f5997d90c4d6$var$J(r)
                            ];
                    }
                });
            })();
        }, _this1.convert = function(e, t1, o) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var h, p, _this_Editor, i, s, r, a, l, c, d, g, g1;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_Editor = _this1.Editor, i = _this_Editor.BlockManager, s = _this_Editor.Tools, r = i.getBlockById(e);
                            if (!r) throw new Error('Block with id "'.concat(e, '" not found'));
                            a = s.blockTools.get(r.name), l = s.blockTools.get(t1);
                            if (!l) throw new Error('Block Tool with type "'.concat(t1, '" not found'));
                            c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;
                            if (!(c && d)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                i.convert(r, t1, o)
                            ];
                        case 1:
                            g = _state.sent();
                            return [
                                2,
                                new $e310f5997d90c4d6$var$J(g)
                            ];
                        case 2:
                            g1 = [
                                c ? !1 : $e310f5997d90c4d6$var$je(r.name),
                                d ? !1 : $e310f5997d90c4d6$var$je(t1)
                            ].filter(Boolean).join(" and ");
                            throw new Error('Conversion from "'.concat(r.name, '" to "').concat(t1, '" is not possible. ').concat(g1, ' tool(s) should provide a "conversionConfig"'));
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        }, _this1.insertMany = function(e) {
            var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _this1.Editor.BlockManager.blocks.length - 1;
            _this1.validateIndex(t1);
            var o = e.map(function(param) {
                var i = param.id, s = param.type, r = param.data;
                return _this1.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || _this1.config.defaultBlock,
                    data: r
                });
            });
            return _this1.Editor.BlockManager.insertMany(o, t1), o.map(function(i) {
                return new $e310f5997d90c4d6$var$J(i);
            });
        };
        return _this;
    }
    (0, $8BtP9._)(gi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Blocks}
   */ function get() {
                var _this = this;
                var _this1 = this;
                return {
                    clear: function() {
                        return _this.clear();
                    },
                    render: function(e) {
                        return _this.render(e);
                    },
                    renderFromHTML: function(e) {
                        return _this.renderFromHTML(e);
                    },
                    delete: function(e) {
                        return _this.delete(e);
                    },
                    swap: function(e, t1) {
                        return _this.swap(e, t1);
                    },
                    move: function(e, t1) {
                        return _this.move(e, t1);
                    },
                    getBlockByIndex: function(e) {
                        return _this.getBlockByIndex(e);
                    },
                    getById: function(e) {
                        return _this.getById(e);
                    },
                    getCurrentBlockIndex: function() {
                        return _this.getCurrentBlockIndex();
                    },
                    getBlockIndex: function(e) {
                        return _this.getBlockIndex(e);
                    },
                    getBlocksCount: function() {
                        return _this.getBlocksCount();
                    },
                    getBlockByElement: function(e) {
                        return _this.getBlockByElement(e);
                    },
                    stretchBlock: function(e) {
                        var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                        return _this1.stretchBlock(e, t1);
                    },
                    insertNewBlock: function() {
                        return _this.insertNewBlock();
                    },
                    insert: this.insert,
                    insertMany: this.insertMany,
                    update: this.update,
                    composeBlockData: this.composeBlockData,
                    convert: this.convert
                };
            }
        },
        {
            /**
   * Returns Blocks count
   *
   * @returns {number}
   */ key: "getBlocksCount",
            value: function getBlocksCount() {
                return this.Editor.BlockManager.blocks.length;
            }
        },
        {
            /**
   * Returns current block index
   *
   * @returns {number}
   */ key: "getCurrentBlockIndex",
            value: function getCurrentBlockIndex() {
                return this.Editor.BlockManager.currentBlockIndex;
            }
        },
        {
            /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ key: "getBlockIndex",
            value: function getBlockIndex(e) {
                var t1 = this.Editor.BlockManager.getBlockById(e);
                if (!t1) {
                    $e310f5997d90c4d6$var$X("There is no block with id `" + e + "`", "warn");
                    return;
                }
                return this.Editor.BlockManager.getBlockIndex(t1);
            }
        },
        {
            /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ key: "getBlockByIndex",
            value: function getBlockByIndex(e) {
                var t1 = this.Editor.BlockManager.getBlockByIndex(e);
                if (t1 === void 0) {
                    $e310f5997d90c4d6$var$X("There is no block at index `" + e + "`", "warn");
                    return;
                }
                return new $e310f5997d90c4d6$var$J(t1);
            }
        },
        {
            /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ key: "getById",
            value: function getById(e) {
                var t1 = this.Editor.BlockManager.getBlockById(e);
                return t1 === void 0 ? ($e310f5997d90c4d6$var$X("There is no block with id `" + e + "`", "warn"), null) : new $e310f5997d90c4d6$var$J(t1);
            }
        },
        {
            /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ key: "getBlockByElement",
            value: function getBlockByElement(e) {
                var t1 = this.Editor.BlockManager.getBlock(e);
                if (t1 === void 0) {
                    $e310f5997d90c4d6$var$X("There is no block corresponding to element `" + e + "`", "warn");
                    return;
                }
                return new $e310f5997d90c4d6$var$J(t1);
            }
        },
        {
            /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ key: "swap",
            value: function swap(e, t1) {
                $e310f5997d90c4d6$var$S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
            }
        },
        {
            /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ key: "move",
            value: function move(e, t1) {
                this.Editor.BlockManager.move(e, t1);
            }
        },
        {
            /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ key: "delete",
            value: function _delete() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.Editor.BlockManager.currentBlockIndex;
                try {
                    var _$t = this.Editor.BlockManager.getBlockByIndex(e);
                    this.Editor.BlockManager.removeBlock(_$t);
                } catch (t1) {
                    $e310f5997d90c4d6$var$X(t1, "warn");
                    return;
                }
                this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
            }
        },
        {
            key: "clear",
            value: /**
   * Clear Editor's area
   */ function clear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.Editor.BlockManager.clear(!0)
                                ];
                            case 1:
                                _state.sent(), this.Editor.InlineToolbar.close();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "render",
            value: /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ function render(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
                                this.Editor.ModificationsObserver.disable();
                                return [
                                    4,
                                    this.Editor.BlockManager.clear()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.Editor.Renderer.render(e.blocks)
                                ];
                            case 2:
                                _state.sent(), this.Editor.ModificationsObserver.enable();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "renderFromHTML",
            value: /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ function renderFromHTML(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.Editor.BlockManager.clear()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), this.Editor.Paste.processText(e, !0))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ key: "stretchBlock",
            value: function stretchBlock(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                $e310f5997d90c4d6$var$ht(!0, "blocks.stretchBlock()", "BlockAPI");
                var o = this.Editor.BlockManager.getBlockByIndex(e);
                o && (o.stretched = t1);
            }
        },
        {
            /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ key: "insertNewBlock",
            value: function insertNewBlock() {
                $e310f5997d90c4d6$var$S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
            }
        },
        {
            /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ key: "validateIndex",
            value: function validateIndex(e) {
                if (typeof e != "number") throw new Error("Index should be a number");
                if (e < 0) throw new Error("Index should be greater than or equal to 0");
                if (e === null) throw new Error("Index should be greater than or equal to 0");
            }
        }
    ]);
    return gi;
}($e310f5997d90c4d6$var$E);
function $e310f5997d90c4d6$var$mi(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
var $e310f5997d90c4d6$var$bi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(bi, E);
    function bi() {
        (0, $7lhcp._)(this, bi);
        var _this;
        _this = (0, $07dqX._)(this, bi, arguments), _this.setToFirstBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.firstBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.firstBlock, e, t1), !0) : !1;
        }, _this.setToLastBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.lastBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.lastBlock, e, t1), !0) : !1;
        }, _this.setToPreviousBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.previousBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.previousBlock, e, t1), !0) : !1;
        }, _this.setToNextBlock = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _this.Editor.Caret.positions.DEFAULT, t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return _this.Editor.BlockManager.nextBlock ? (_this.Editor.Caret.setToBlock(_this.Editor.BlockManager.nextBlock, e, t1), !0) : !1;
        }, _this.setToBlock = function(e) {
            var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _this.Editor.Caret.positions.DEFAULT, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            var i = $e310f5997d90c4d6$var$mi(e, _this.Editor);
            return i === void 0 ? !1 : (_this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, _this.focus = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
            return e ? _this.setToLastBlock(_this.Editor.Caret.positions.END) : _this.setToFirstBlock(_this.Editor.Caret.positions.START);
        };
        return _this;
    }
    (0, $8BtP9._)(bi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Caret}
   */ function get() {
                return {
                    setToFirstBlock: this.setToFirstBlock,
                    setToLastBlock: this.setToLastBlock,
                    setToPreviousBlock: this.setToPreviousBlock,
                    setToNextBlock: this.setToNextBlock,
                    setToBlock: this.setToBlock,
                    focus: this.focus
                };
            }
        }
    ]);
    return bi;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$vi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(vi, E);
    function vi() {
        (0, $7lhcp._)(this, vi);
        return (0, $07dqX._)(this, vi, arguments);
    }
    (0, $8BtP9._)(vi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Events}
   */ function get() {
                var _this = this;
                return {
                    emit: function(e, t1) {
                        return _this.emit(e, t1);
                    },
                    off: function(e, t1) {
                        return _this.off(e, t1);
                    },
                    on: function(e, t1) {
                        return _this.on(e, t1);
                    }
                };
            }
        },
        {
            /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ key: "on",
            value: function on(e, t1) {
                this.eventsDispatcher.on(e, t1);
            }
        },
        {
            /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ key: "emit",
            value: function emit(e, t1) {
                this.eventsDispatcher.emit(e, t1);
            }
        },
        {
            /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ key: "off",
            value: function off(e, t1) {
                this.eventsDispatcher.off(e, t1);
            }
        }
    ]);
    return vi;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$kt = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(kt, E);
    function kt() {
        (0, $7lhcp._)(this, kt);
        return (0, $07dqX._)(this, kt, arguments);
    }
    (0, $8BtP9._)(kt, [
        {
            key: "methods",
            get: /**
   * Return I18n API methods with global dictionary access
   */ function get() {
                return {
                    t: function() {
                        $e310f5997d90c4d6$var$X("I18n.t() method can be accessed only from Tools", "warn");
                    }
                };
            }
        },
        {
            /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ key: "getMethodsForTool",
            value: function getMethodsForTool(e, t1) {
                return Object.assign(this.methods, {
                    t: function(o) {
                        return $e310f5997d90c4d6$var$z.t(kt.getNamespace(e, t1), o);
                    }
                });
            }
        }
    ], [
        {
            key: "getNamespace",
            value: /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ function getNamespace(e, t1) {
                return t1 ? "blockTunes.".concat(e) : "tools.".concat(e);
            }
        }
    ]);
    return kt;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$ki = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(ki, E);
    function ki() {
        (0, $7lhcp._)(this, ki);
        return (0, $07dqX._)(this, ki, arguments);
    }
    (0, $8BtP9._)(ki, [
        {
            key: "methods",
            get: /**
   * Editor.js Core API modules
   */ function get() {
                return {
                    blocks: this.Editor.BlocksAPI.methods,
                    caret: this.Editor.CaretAPI.methods,
                    tools: this.Editor.ToolsAPI.methods,
                    events: this.Editor.EventsAPI.methods,
                    listeners: this.Editor.ListenersAPI.methods,
                    notifier: this.Editor.NotifierAPI.methods,
                    sanitizer: this.Editor.SanitizerAPI.methods,
                    saver: this.Editor.SaverAPI.methods,
                    selection: this.Editor.SelectionAPI.methods,
                    styles: this.Editor.StylesAPI.classes,
                    toolbar: this.Editor.ToolbarAPI.methods,
                    inlineToolbar: this.Editor.InlineToolbarAPI.methods,
                    tooltip: this.Editor.TooltipAPI.methods,
                    i18n: this.Editor.I18nAPI.methods,
                    readOnly: this.Editor.ReadOnlyAPI.methods,
                    ui: this.Editor.UiAPI.methods
                };
            }
        },
        {
            /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ key: "getMethodsForTool",
            value: function getMethodsForTool(e, t1) {
                return Object.assign(this.methods, {
                    i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
                });
            }
        }
    ]);
    return ki;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$yi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(yi, E);
    function yi() {
        (0, $7lhcp._)(this, yi);
        return (0, $07dqX._)(this, yi, arguments);
    }
    (0, $8BtP9._)(yi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ function get() {
                var _this = this;
                return {
                    close: function() {
                        return _this.close();
                    },
                    open: function() {
                        return _this.open();
                    }
                };
            }
        },
        {
            /**
   * Open Inline Toolbar
   */ key: "open",
            value: function open() {
                this.Editor.InlineToolbar.tryToShow();
            }
        },
        {
            /**
   * Close Inline Toolbar
   */ key: "close",
            value: function close() {
                this.Editor.InlineToolbar.close();
            }
        }
    ]);
    return yi;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$wi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(wi, E);
    function wi() {
        (0, $7lhcp._)(this, wi);
        return (0, $07dqX._)(this, wi, arguments);
    }
    (0, $8BtP9._)(wi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Listeners}
   */ function get() {
                var _this = this;
                return {
                    on: function(e, t1, o, i) {
                        return _this.on(e, t1, o, i);
                    },
                    off: function(e, t1, o, i) {
                        return _this.off(e, t1, o, i);
                    },
                    offById: function(e) {
                        return _this.offById(e);
                    }
                };
            }
        },
        {
            /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ key: "on",
            value: function on(e, t1, o, i) {
                return this.listeners.on(e, t1, o, i);
            }
        },
        {
            /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ key: "off",
            value: function off(e, t1, o, i) {
                this.listeners.off(e, t1, o, i);
            }
        },
        {
            /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ key: "offById",
            value: function offById(e) {
                this.listeners.offById(e);
            }
        }
    ]);
    return wi;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Ko = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $5f0Cq._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && (typeof s === "undefined" ? "undefined" : (0, $5f0Cq._)(s)) == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function r() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", a = null;
                    return {
                        show: function show(l) {
                            if (l.message) {
                                (function() {
                                    if (a) return !0;
                                    a = s.getWrapper(), document.body.appendChild(a);
                                })();
                                var c = null, d = l.time || 8e3;
                                switch(l.type){
                                    case "confirm":
                                        c = s.confirm(l);
                                        break;
                                    case "prompt":
                                        c = s.prompt(l);
                                        break;
                                    default:
                                        c = s.alert(l), window.setTimeout(function() {
                                            c.remove();
                                        }, d);
                                }
                                a.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    '.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:\'\';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:\'\';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}',
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var a = function(l, c) {
                                var d = l[1] || "", h = l[3];
                                if (!h) return d;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(v) {
                                        return "/*# sourceURL=" + h.sourceRoot + v + " */";
                                    });
                                    return [
                                        d
                                    ].concat(g).concat([
                                        p
                                    ]).join("\n");
                                }
                                var f;
                                return [
                                    d
                                ].join("\n");
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
                        }).join("");
                    }, s.i = function(r, a) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var l = {}, c = 0; c < this.length; c++){
                            var d = this[c][0];
                            typeof d == "number" && (l[d] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, a = {}, l = (s = function s() {
                    return window && document && document.all && !window.atob;
                }, function l() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(k) {
                    var m = {};
                    return function(w) {
                        if (typeof w == "function") return w();
                        if (m[w] === void 0) {
                            var x = (function(I) {
                                return document.querySelector(I);
                            }).call(this, w);
                            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
                                x = x.contentDocument.head;
                            } catch (e) {
                                x = null;
                            }
                            m[w] = x;
                        }
                        return m[w];
                    };
                }(), d = null, h = 0, p = [], g = i(5);
                function f(k, m) {
                    for(var w = 0; w < k.length; w++){
                        var x = k[w], I = a[x.id];
                        if (I) {
                            I.refs++;
                            for(var C = 0; C < I.parts.length; C++)I.parts[C](x.parts[C]);
                            for(; C < x.parts.length; C++)I.parts.push(F(x.parts[C], m));
                        } else {
                            var N = [];
                            for(C = 0; C < x.parts.length; C++)N.push(F(x.parts[C], m));
                            a[x.id] = {
                                id: x.id,
                                refs: 1,
                                parts: N
                            };
                        }
                    }
                }
                function v(k, m) {
                    for(var w = [], x = {}, I = 0; I < k.length; I++){
                        var C = k[I], N = m.base ? C[0] + m.base : C[0], B = {
                            css: C[1],
                            media: C[2],
                            sourceMap: C[3]
                        };
                        x[N] ? x[N].parts.push(B) : w.push(x[N] = {
                            id: N,
                            parts: [
                                B
                            ]
                        });
                    }
                    return w;
                }
                function O(k, m) {
                    var w = c(k.insertInto);
                    if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var x = p[p.length - 1];
                    if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);
                    else if (k.insertAt === "bottom") w.appendChild(m);
                    else {
                        if ((0, $5f0Cq._)(k.insertAt) != "object" || !k.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
                        var I = c(k.insertInto + " " + k.insertAt.before);
                        w.insertBefore(m, I);
                    }
                }
                function T(k) {
                    if (k.parentNode === null) return !1;
                    k.parentNode.removeChild(k);
                    var m = p.indexOf(k);
                    m >= 0 && p.splice(m, 1);
                }
                function M(k) {
                    var m = document.createElement("style");
                    return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
                }
                function q(k, m) {
                    Object.keys(m).forEach(function(w) {
                        k.setAttribute(w, m[w]);
                    });
                }
                function F(k, m) {
                    var w, x, I, C;
                    if (m.transform && k.css) {
                        if (!(C = m.transform(k.css))) return function() {};
                        k.css = C;
                    }
                    if (m.singleton) {
                        var N = h++;
                        w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
                    } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function(B) {
                        var W = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
                    }(m), x = (function(B, W, ve) {
                        var se = ve.css, tt = ve.sourceMap, Yn = W.convertToAbsoluteUrls === void 0 && tt;
                        (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
                        var Kn = new Blob([
                            se
                        ], {
                            type: "text/css"
                        }), ko = B.href;
                        B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
                    }).bind(null, w, m), I = function I() {
                        T(w), w.href && URL.revokeObjectURL(w.href);
                    }) : (w = M(m), x = (function(B, W) {
                        var ve = W.css, se = W.media;
                        if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ve));
                        }
                    }).bind(null, w), I = function I() {
                        T(w);
                    });
                    return x(k), function(B) {
                        if (B) {
                            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
                            x(k = B);
                        } else I();
                    };
                }
                t1.exports = function(k, m) {
                    if ((typeof DEBUG === "undefined" ? "undefined" : (0, $5f0Cq._)(DEBUG)) < "u" && DEBUG && (typeof document === "undefined" ? "undefined" : (0, $5f0Cq._)(document)) != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = (0, $5f0Cq._)(m.attrs) == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var w = v(k, m);
                    return f(w, m), function(x) {
                        for(var I = [], C = 0; C < w.length; C++){
                            var N = w[C];
                            (B = a[N.id]).refs--, I.push(B);
                        }
                        for(x && f(v(x, m), m), C = 0; C < I.length; C++){
                            var B;
                            if ((B = I[C]).refs === 0) {
                                for(var W = 0; W < B.parts.length; W++)B.parts[W]();
                                delete a[B.id];
                            }
                        }
                    };
                };
                var H, Q = (H = [], function Q(k, m) {
                    return H[k] = m, H.filter(Boolean).join("\n");
                });
                function ie(k, m, w, x) {
                    var I = w ? "" : x.css;
                    if (k.styleSheet) k.styleSheet.cssText = Q(m, I);
                    else {
                        var C = document.createTextNode(I), N = k.childNodes;
                        N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = (typeof window === "undefined" ? "undefined" : (0, $5f0Cq._)(window)) < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, a = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(l, c) {
                        var d, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, a, l, c, d, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function g(f) {
                        var v = document.createElement("DIV"), O = document.createElement("DIV"), T = f.message, M = f.style;
                        return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
                    },
                    confirm: function confirm(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("button"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
                    },
                    prompt: function prompt(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("input"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function() {
                            H(M.value);
                        }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
                    },
                    getWrapper: function getWrapper() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($e310f5997d90c4d6$var$Ko);
var $e310f5997d90c4d6$var$Ei = $e310f5997d90c4d6$var$Ko.exports;
var $e310f5997d90c4d6$var$xi = /* @__PURE__ */ $e310f5997d90c4d6$var$Ke($e310f5997d90c4d6$var$Ei);
var $e310f5997d90c4d6$var$Bi = /*#__PURE__*/ function() {
    "use strict";
    function Bi() {
        (0, $7lhcp._)(this, Bi);
    }
    (0, $8BtP9._)(Bi, [
        {
            /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ key: "show",
            value: function show(e) {
                $e310f5997d90c4d6$var$xi.show(e);
            }
        }
    ]);
    return Bi;
}();
var $e310f5997d90c4d6$var$Ci = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Ci, E);
    function Ci(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $7lhcp._)(this, Ci);
        var _this;
        _this = (0, $07dqX._)(this, Ci, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.notifier = new $e310f5997d90c4d6$var$Bi();
        return _this;
    }
    (0, $8BtP9._)(Ci, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                return {
                    show: function(e) {
                        return _this.show(e);
                    }
                };
            }
        },
        {
            /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ key: "show",
            value: function show(e) {
                return this.notifier.show(e);
            }
        }
    ]);
    return Ci;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Ti = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Ti, E);
    function Ti() {
        (0, $7lhcp._)(this, Ti);
        return (0, $07dqX._)(this, Ti, arguments);
    }
    (0, $8BtP9._)(Ti, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                var e = function() {
                    return _this.isEnabled;
                };
                return {
                    toggle: function(t1) {
                        return _this.toggle(t1);
                    },
                    get isEnabled () {
                        return e();
                    }
                };
            }
        },
        {
            /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ key: "toggle",
            value: function toggle(e) {
                return this.Editor.ReadOnly.toggle(e);
            }
        },
        {
            key: "isEnabled",
            get: /**
   * Returns current read-only state
   */ function get() {
                return this.Editor.ReadOnly.isEnabled;
            }
        }
    ]);
    return Ti;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Xo = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($e310f5997d90c4d6$var$Ce, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(v) {
                return (0, $5f0Cq._)(p[v]);
            }).every(function(v) {
                return v === "object" || v === "boolean" || v === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            var p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = a(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var v = r(f), O;
                v && (O = Array.prototype.some.call(f.childNodes, i));
                var T = !!p.parentNode, M = i(p) && i(f) && T, q = f.nodeName.toLowerCase(), F = l(this.config, q, f), H = v && O;
                if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var Q = 0; Q < f.attributes.length; Q += 1){
                    var ie = f.attributes[Q];
                    d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function a(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function l(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return (typeof p === "undefined" ? "undefined" : (0, $5f0Cq._)(p)) > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function d(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : (0, $5f0Cq._)(p[f]) > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($e310f5997d90c4d6$var$Xo);
var $e310f5997d90c4d6$var$Si = $e310f5997d90c4d6$var$Xo.exports;
var $e310f5997d90c4d6$var$Ii = /* @__PURE__ */ $e310f5997d90c4d6$var$Ke($e310f5997d90c4d6$var$Si);
function $e310f5997d90c4d6$var$yt(n, e) {
    return n.map(function(t1) {
        var o = $e310f5997d90c4d6$var$A(e) ? e(t1.tool) : e;
        return $e310f5997d90c4d6$var$V(o) || (t1.data = $e310f5997d90c4d6$var$wt(t1.data, o)), t1;
    });
}
function $e310f5997d90c4d6$var$Z(n) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var t1 = {
        tags: e
    };
    return new $e310f5997d90c4d6$var$Ii(t1).clean(n);
}
function $e310f5997d90c4d6$var$wt(n, e) {
    return Array.isArray(n) ? $e310f5997d90c4d6$var$Oi(n, e) : $e310f5997d90c4d6$var$D(n) ? $e310f5997d90c4d6$var$_i(n, e) : $e310f5997d90c4d6$var$te(n) ? $e310f5997d90c4d6$var$Mi(n, e) : n;
}
function $e310f5997d90c4d6$var$Oi(n, e) {
    return n.map(function(t1) {
        return $e310f5997d90c4d6$var$wt(t1, e);
    });
}
function $e310f5997d90c4d6$var$_i(n, e) {
    var t1 = {};
    for(var o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        var i = n[o], s = $e310f5997d90c4d6$var$Ai(e[o]) ? e[o] : e;
        t1[o] = $e310f5997d90c4d6$var$wt(i, s);
    }
    return t1;
}
function $e310f5997d90c4d6$var$Mi(n, e) {
    return $e310f5997d90c4d6$var$D(e) ? $e310f5997d90c4d6$var$Z(n, e) : e === !1 ? $e310f5997d90c4d6$var$Z(n, {}) : n;
}
function $e310f5997d90c4d6$var$Ai(n) {
    return $e310f5997d90c4d6$var$D(n) || $e310f5997d90c4d6$var$Gn(n) || $e310f5997d90c4d6$var$A(n);
}
var $e310f5997d90c4d6$var$Li = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Li, E);
    function Li() {
        (0, $7lhcp._)(this, Li);
        return (0, $07dqX._)(this, Li, arguments);
    }
    (0, $8BtP9._)(Li, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ function get() {
                var _this = this;
                return {
                    clean: function(e, t1) {
                        return _this.clean(e, t1);
                    }
                };
            }
        },
        {
            /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ key: "clean",
            value: function clean(e, t1) {
                return $e310f5997d90c4d6$var$Z(e, t1);
            }
        }
    ]);
    return Li;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Pi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Pi, E);
    function Pi() {
        (0, $7lhcp._)(this, Pi);
        return (0, $07dqX._)(this, Pi, arguments);
    }
    (0, $8BtP9._)(Pi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Saver}
   */ function get() {
                var _this = this;
                return {
                    save: function() {
                        return _this.save();
                    }
                };
            }
        },
        {
            /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ key: "save",
            value: function save() {
                var e = "Editor's content can not be saved in read-only mode";
                return this.Editor.ReadOnly.isEnabled ? ($e310f5997d90c4d6$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
            }
        }
    ]);
    return Pi;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Ni = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Ni, E);
    function Ni() {
        (0, $7lhcp._)(this, Ni);
        var _this;
        _this = (0, $07dqX._)(this, Ni, arguments), _this.selectionUtils = new $e310f5997d90c4d6$var$b();
        return _this;
    }
    (0, $8BtP9._)(Ni, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ function get() {
                var _this = this;
                return {
                    findParentTag: function(e, t1) {
                        return _this.findParentTag(e, t1);
                    },
                    expandToTag: function(e) {
                        return _this.expandToTag(e);
                    },
                    save: function() {
                        return _this.selectionUtils.save();
                    },
                    restore: function() {
                        return _this.selectionUtils.restore();
                    },
                    setFakeBackground: function() {
                        return _this.selectionUtils.setFakeBackground();
                    },
                    removeFakeBackground: function() {
                        return _this.selectionUtils.removeFakeBackground();
                    }
                };
            }
        },
        {
            /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ key: "findParentTag",
            value: function findParentTag(e, t1) {
                return this.selectionUtils.findParentTag(e, t1);
            }
        },
        {
            /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ key: "expandToTag",
            value: function expandToTag(e) {
                this.selectionUtils.expandToTag(e);
            }
        }
    ]);
    return Ni;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Ri = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Ri, E);
    function Ri() {
        (0, $7lhcp._)(this, Ri);
        return (0, $07dqX._)(this, Ri, arguments);
    }
    (0, $8BtP9._)(Ri, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                return {
                    getBlockTools: function() {
                        return Array.from(_this.Editor.Tools.blockTools.values());
                    }
                };
            }
        }
    ]);
    return Ri;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Di = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Di, E);
    function Di() {
        (0, $7lhcp._)(this, Di);
        return (0, $07dqX._)(this, Di, arguments);
    }
    (0, $8BtP9._)(Di, [
        {
            key: "classes",
            get: /**
   * Exported classes
   */ function get() {
                return {
                    /**
       * Base Block styles
       */ block: "cdx-block",
                    /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
                    inlineToolButtonActive: "ce-inline-tool--active",
                    /**
       * UI elements
       */ input: "cdx-input",
                    loader: "cdx-loader",
                    button: "cdx-button",
                    /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
                    settingsButtonActive: "cdx-settings-button--active"
                };
            }
        }
    ]);
    return Di;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Fi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Fi, E);
    function Fi() {
        (0, $7lhcp._)(this, Fi);
        return (0, $07dqX._)(this, Fi, arguments);
    }
    (0, $8BtP9._)(Fi, [
        {
            key: "methods",
            get: /**
   * Available methods
   *
   * @returns {Toolbar}
   */ function get() {
                var _this = this;
                return {
                    close: function() {
                        return _this.close();
                    },
                    open: function() {
                        return _this.open();
                    },
                    toggleBlockSettings: function(e) {
                        return _this.toggleBlockSettings(e);
                    },
                    toggleToolbox: function(e) {
                        return _this.toggleToolbox(e);
                    }
                };
            }
        },
        {
            /**
   * Open toolbar
   */ key: "open",
            value: function open() {
                this.Editor.Toolbar.moveAndOpen();
            }
        },
        {
            /**
   * Close toolbar and all included elements
   */ key: "close",
            value: function close() {
                this.Editor.Toolbar.close();
            }
        },
        {
            /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ key: "toggleBlockSettings",
            value: function toggleBlockSettings(e) {
                if (this.Editor.BlockManager.currentBlockIndex === -1) {
                    $e310f5997d90c4d6$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
                    return;
                }
                (e !== null && e !== void 0 ? e : !this.Editor.BlockSettings.opened) ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
            }
        },
        {
            /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ key: "toggleToolbox",
            value: function toggleToolbox(e) {
                if (this.Editor.BlockManager.currentBlockIndex === -1) {
                    $e310f5997d90c4d6$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
                    return;
                }
                (e !== null && e !== void 0 ? e : !this.Editor.Toolbar.toolbox.opened) ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
            }
        }
    ]);
    return Fi;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Vo = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $5f0Cq._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && (typeof s === "undefined" ? "undefined" : (0, $5f0Cq._)(s)) == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function r() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                var s = /*#__PURE__*/ function() {
                    "use strict";
                    function s() {
                        var _this = this;
                        (0, $7lhcp._)(this, s);
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = function() {
                            _this.showed && _this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    (0, $8BtP9._)(s, [
                        {
                            key: "CSS",
                            get: function get() {
                                return {
                                    tooltip: "ct",
                                    tooltipContent: "ct__content",
                                    tooltipShown: "ct--shown",
                                    placement: {
                                        left: "ct--left",
                                        bottom: "ct--bottom",
                                        right: "ct--right",
                                        top: "ct--top"
                                    }
                                };
                            }
                        },
                        {
                            key: "show",
                            value: function show(a, l, c) {
                                var _this = this;
                                var _this_nodes_wrapper_classList;
                                this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                                var d = Object.assign({
                                    placement: "bottom",
                                    marginTop: 0,
                                    marginLeft: 0,
                                    marginRight: 0,
                                    marginBottom: 0,
                                    delay: 70,
                                    hidingDelay: 0
                                }, c);
                                if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));
                                else {
                                    if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + (typeof l === "undefined" ? "undefined" : (0, $5f0Cq._)(l)) + " given.");
                                    this.nodes.content.appendChild(l);
                                }
                                switch((_this_nodes_wrapper_classList = this.nodes.wrapper.classList).remove.apply(_this_nodes_wrapper_classList, (0, $fsSDT._)(Object.values(this.CSS.placement))), d.placement){
                                    case "top":
                                        this.placeTop(a, d);
                                        break;
                                    case "left":
                                        this.placeLeft(a, d);
                                        break;
                                    case "right":
                                        this.placeRight(a, d);
                                        break;
                                    case "bottom":
                                    default:
                                        this.placeBottom(a, d);
                                }
                                d && d.delay ? this.showingTimeout = setTimeout(function() {
                                    _this.nodes.wrapper.classList.add(_this.CSS.tooltipShown), _this.showed = !0;
                                }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                            }
                        },
                        {
                            key: "hide",
                            value: function hide() {
                                var _this = this;
                                var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                                if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(function() {
                                    _this.hide(!0);
                                }, this.hidingDelay));
                                this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                            }
                        },
                        {
                            key: "onHover",
                            value: function onHover(a, l, c) {
                                var _this = this;
                                a.addEventListener("mouseenter", function() {
                                    _this.show(a, l, c);
                                }), a.addEventListener("mouseleave", function() {
                                    _this.hide();
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                            }
                        },
                        {
                            key: "prepare",
                            value: function prepare() {
                                this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                            }
                        },
                        {
                            key: "loadStyles",
                            value: function loadStyles() {
                                var a = "codex-tooltips-style";
                                if (document.getElementById(a)) return;
                                var l = i(2), c = this.make("style", null, {
                                    textContent: l.toString(),
                                    id: a
                                });
                                this.prepend(document.head, c);
                            }
                        },
                        {
                            key: "placeBottom",
                            value: function placeBottom(a, l) {
                                var c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
                                this.applyPlacement("bottom", d, h);
                            }
                        },
                        {
                            key: "placeTop",
                            value: function placeTop(a, l) {
                                var c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                                this.applyPlacement("top", d, h);
                            }
                        },
                        {
                            key: "placeLeft",
                            value: function placeLeft(a, l) {
                                var c = a.getBoundingClientRect(), d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                                this.applyPlacement("left", d, h);
                            }
                        },
                        {
                            key: "placeRight",
                            value: function placeRight(a, l) {
                                var c = a.getBoundingClientRect(), d = c.right + this.offsetRight + l.marginRight, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                                this.applyPlacement("right", d, h);
                            }
                        },
                        {
                            key: "applyPlacement",
                            value: function applyPlacement(a, l, c) {
                                this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
                            }
                        },
                        {
                            key: "make",
                            value: function make(a) {
                                var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                                var _d_classList;
                                var d = document.createElement(a);
                                Array.isArray(l) ? (_d_classList = d.classList).add.apply(_d_classList, (0, $fsSDT._)(l)) : l && d.classList.add(l);
                                for(var h in c)c.hasOwnProperty(h) && (d[h] = c[h]);
                                return d;
                            }
                        },
                        {
                            key: "append",
                            value: function append(a, l) {
                                Array.isArray(l) ? l.forEach(function(c) {
                                    return a.appendChild(c);
                                }) : a.appendChild(l);
                            }
                        },
                        {
                            key: "prepend",
                            value: function prepend(a, l) {
                                Array.isArray(l) ? (l = l.reverse()).forEach(function(c) {
                                    return a.prepend(c);
                                }) : a.prepend(l);
                            }
                        }
                    ]);
                    return s;
                }();
            },
            function(t1, o) {
                t1.exports = '.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>\') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}';
            }
        ]).default;
    });
})($e310f5997d90c4d6$var$Vo);
var $e310f5997d90c4d6$var$ji = $e310f5997d90c4d6$var$Vo.exports;
var $e310f5997d90c4d6$var$Hi = /* @__PURE__ */ $e310f5997d90c4d6$var$Ke($e310f5997d90c4d6$var$ji);
var $e310f5997d90c4d6$var$U = null;
function $e310f5997d90c4d6$var$Et() {
    $e310f5997d90c4d6$var$U || ($e310f5997d90c4d6$var$U = new $e310f5997d90c4d6$var$Hi());
}
function $e310f5997d90c4d6$var$$i(n, e, t1) {
    $e310f5997d90c4d6$var$Et(), $e310f5997d90c4d6$var$U == null || $e310f5997d90c4d6$var$U.show(n, e, t1);
}
function $e310f5997d90c4d6$var$$e() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    $e310f5997d90c4d6$var$Et(), $e310f5997d90c4d6$var$U == null || $e310f5997d90c4d6$var$U.hide(n);
}
function $e310f5997d90c4d6$var$ze(n, e, t1) {
    $e310f5997d90c4d6$var$Et(), $e310f5997d90c4d6$var$U == null || $e310f5997d90c4d6$var$U.onHover(n, e, t1);
}
function $e310f5997d90c4d6$var$zi() {
    $e310f5997d90c4d6$var$U == null || $e310f5997d90c4d6$var$U.destroy(), $e310f5997d90c4d6$var$U = null;
}
var $e310f5997d90c4d6$var$Ui = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Ui, E);
    function Ui(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $7lhcp._)(this, Ui);
        return (0, $07dqX._)(this, Ui, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]);
    }
    (0, $8BtP9._)(Ui, [
        {
            key: "methods",
            get: /**
   * Available methods
   */ function get() {
                var _this = this;
                return {
                    show: function(e, t1, o) {
                        return _this.show(e, t1, o);
                    },
                    hide: function() {
                        return _this.hide();
                    },
                    onHover: function(e, t1, o) {
                        return _this.onHover(e, t1, o);
                    }
                };
            }
        },
        {
            /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ key: "show",
            value: function show(e, t1, o) {
                $e310f5997d90c4d6$var$$i(e, t1, o);
            }
        },
        {
            /**
   * Method hides tooltip on HTML page
   */ key: "hide",
            value: function hide() {
                $e310f5997d90c4d6$var$$e();
            }
        },
        {
            /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ key: "onHover",
            value: function onHover(e, t1, o) {
                $e310f5997d90c4d6$var$ze(e, t1, o);
            }
        }
    ]);
    return Ui;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Wi = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Wi, E);
    function Wi() {
        (0, $7lhcp._)(this, Wi);
        return (0, $07dqX._)(this, Wi, arguments);
    }
    (0, $8BtP9._)(Wi, [
        {
            key: "methods",
            get: /**
   * Available methods / getters
   */ function get() {
                return {
                    nodes: this.editorNodes
                };
            }
        },
        {
            key: "editorNodes",
            get: /**
   * Exported classes
   */ function get() {
                return {
                    /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
                    /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
                };
            }
        }
    ]);
    return Wi;
}($e310f5997d90c4d6$var$E);
function $e310f5997d90c4d6$var$qo(n, e) {
    var t1 = {};
    return Object.entries(n).forEach(function(param) {
        var _param = (0, $leE2g._)(param, 2), o = _param[0], i = _param[1];
        if ($e310f5997d90c4d6$var$D(i)) {
            var s = e ? "".concat(e, ".").concat(o) : o;
            Object.values(i).every(function(a) {
                return $e310f5997d90c4d6$var$te(a);
            }) ? t1[o] = s : t1[o] = $e310f5997d90c4d6$var$qo(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
var $e310f5997d90c4d6$var$K = $e310f5997d90c4d6$var$qo($e310f5997d90c4d6$var$Fo);
function $e310f5997d90c4d6$var$Yi(n, e) {
    var t1 = {};
    return Object.keys(n).forEach(function(o) {
        var i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
var $e310f5997d90c4d6$var$Zo = /*#__PURE__*/ function() {
    "use strict";
    function Ee(e, t1) {
        (0, $7lhcp._)(this, Ee);
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    (0, $8BtP9._)(Ee, [
        {
            key: "currentItem",
            get: /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ function get() {
                return this.cursor === -1 ? null : this.items[this.cursor];
            }
        },
        {
            /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ key: "setCursor",
            value: function setCursor(e) {
                e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
            }
        },
        {
            /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ key: "setItems",
            value: function setItems(e) {
                this.items = e;
            }
        },
        {
            /**
   * Sets cursor next to the current
   */ key: "next",
            value: function next() {
                this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
            }
        },
        {
            /**
   * Sets cursor before current
   */ key: "previous",
            value: function previous() {
                this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
            }
        },
        {
            /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ key: "dropCursor",
            value: function dropCursor() {
                this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
            }
        },
        {
            /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ key: "leafNodesAndReturnIndex",
            value: function leafNodesAndReturnIndex(e) {
                var _this = this;
                if (this.items.length === 0) return this.cursor;
                var t1 = this.cursor;
                return t1 === -1 ? t1 = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $e310f5997d90c4d6$var$u.canSetCaret(this.items[t1]) && $e310f5997d90c4d6$var$Fe(function() {
                    return $e310f5997d90c4d6$var$b.setCursor(_this.items[t1]);
                }, 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
            }
        }
    ]);
    return Ee;
}();
$e310f5997d90c4d6$var$Zo.directions = {
    RIGHT: "right",
    LEFT: "left"
};
var $e310f5997d90c4d6$var$ke = $e310f5997d90c4d6$var$Zo;
var $e310f5997d90c4d6$var$ce = /*#__PURE__*/ function() {
    "use strict";
    function ce(e) {
        var _this = this;
        (0, $7lhcp._)(this, ce);
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = function(t1) {
            if (!(!_this.isEventReadyForHandling(t1) || t1.shiftKey === !0)) switch(ce.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $e310f5997d90c4d6$var$y.TAB:
                    _this.handleTabPress(t1);
                    break;
                case $e310f5997d90c4d6$var$y.LEFT:
                case $e310f5997d90c4d6$var$y.UP:
                    _this.flipLeft();
                    break;
                case $e310f5997d90c4d6$var$y.RIGHT:
                case $e310f5997d90c4d6$var$y.DOWN:
                    _this.flipRight();
                    break;
                case $e310f5997d90c4d6$var$y.ENTER:
                    _this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $e310f5997d90c4d6$var$ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || ce.usedKeys;
    }
    (0, $8BtP9._)(ce, [
        {
            key: "isActivated",
            get: /**
   * True if flipper is currently activated
   */ function get() {
                return this.activated;
            }
        },
        {
            /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ key: "activate",
            value: function activate(e, t1) {
                this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
            }
        },
        {
            /**
   * Disable tab/arrows handling by flipper
   */ key: "deactivate",
            value: function deactivate() {
                this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
            }
        },
        {
            /**
   * Focus first item
   */ key: "focusFirst",
            value: function focusFirst() {
                this.dropCursor(), this.flipRight();
            }
        },
        {
            /**
   * Focuses previous flipper iterator item
   */ key: "flipLeft",
            value: function flipLeft() {
                this.iterator.previous(), this.flipCallback();
            }
        },
        {
            /**
   * Focuses next flipper iterator item
   */ key: "flipRight",
            value: function flipRight() {
                this.iterator.next(), this.flipCallback();
            }
        },
        {
            /**
   * Return true if some button is focused
   */ key: "hasFocus",
            value: function hasFocus() {
                return !!this.iterator.currentItem;
            }
        },
        {
            /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ key: "onFlip",
            value: function onFlip(e) {
                this.flipCallbacks.push(e);
            }
        },
        {
            /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ key: "removeOnFlip",
            value: function removeOnFlip(e) {
                this.flipCallbacks = this.flipCallbacks.filter(function(t1) {
                    return t1 !== e;
                });
            }
        },
        {
            /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ key: "dropCursor",
            value: function dropCursor() {
                this.iterator.dropCursor();
            }
        },
        {
            /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ key: "isEventReadyForHandling",
            value: function isEventReadyForHandling(e) {
                return this.activated && this.allowedKeys.includes(e.keyCode);
            }
        },
        {
            /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ key: "handleTabPress",
            value: function handleTabPress(e) {
                switch(e.shiftKey ? $e310f5997d90c4d6$var$ke.directions.LEFT : $e310f5997d90c4d6$var$ke.directions.RIGHT){
                    case $e310f5997d90c4d6$var$ke.directions.RIGHT:
                        this.flipRight();
                        break;
                    case $e310f5997d90c4d6$var$ke.directions.LEFT:
                        this.flipLeft();
                        break;
                }
            }
        },
        {
            /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ key: "handleEnterPress",
            value: function handleEnterPress(e) {
                this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $e310f5997d90c4d6$var$A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
            }
        },
        {
            /**
   * Fired after flipping in any direction
   */ key: "flipCallback",
            value: function flipCallback() {
                this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach(function(e) {
                    return e();
                });
            }
        }
    ], [
        {
            key: "usedKeys",
            get: /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ function get() {
                return [
                    $e310f5997d90c4d6$var$y.TAB,
                    $e310f5997d90c4d6$var$y.LEFT,
                    $e310f5997d90c4d6$var$y.RIGHT,
                    $e310f5997d90c4d6$var$y.ENTER,
                    $e310f5997d90c4d6$var$y.UP,
                    $e310f5997d90c4d6$var$y.DOWN
                ];
            }
        }
    ]);
    return ce;
}();
var $e310f5997d90c4d6$var$Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $e310f5997d90c4d6$var$Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $e310f5997d90c4d6$var$Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $e310f5997d90c4d6$var$qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $e310f5997d90c4d6$var$Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $e310f5997d90c4d6$var$Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $e310f5997d90c4d6$var$Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $e310f5997d90c4d6$var$Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $e310f5997d90c4d6$var$Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $e310f5997d90c4d6$var$es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $e310f5997d90c4d6$var$ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $e310f5997d90c4d6$var$Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $e310f5997d90c4d6$var$os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $e310f5997d90c4d6$var$ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $e310f5997d90c4d6$var$is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $e310f5997d90c4d6$var$ss = "__", $e310f5997d90c4d6$var$rs = "--";
function $e310f5997d90c4d6$var$ne(n) {
    return function(e, t1) {
        return [
            [
                n,
                e
            ].filter(function(i) {
                return !!i;
            }).join($e310f5997d90c4d6$var$ss),
            t1
        ].filter(function(i) {
            return !!i;
        }).join($e310f5997d90c4d6$var$rs);
    };
}
var $e310f5997d90c4d6$var$ye = $e310f5997d90c4d6$var$ne("ce-hint"), $e310f5997d90c4d6$var$we = {
    root: $e310f5997d90c4d6$var$ye(),
    alignedStart: $e310f5997d90c4d6$var$ye(null, "align-left"),
    alignedCenter: $e310f5997d90c4d6$var$ye(null, "align-center"),
    title: $e310f5997d90c4d6$var$ye("title"),
    description: $e310f5997d90c4d6$var$ye("description")
};
var $e310f5997d90c4d6$var$as = /*#__PURE__*/ function() {
    "use strict";
    function as(e) {
        (0, $7lhcp._)(this, as);
        this.nodes = {
            root: $e310f5997d90c4d6$var$u.make("div", [
                $e310f5997d90c4d6$var$we.root,
                e.alignment === "center" ? $e310f5997d90c4d6$var$we.alignedCenter : $e310f5997d90c4d6$var$we.alignedStart
            ]),
            title: $e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$we.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$we.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    (0, $8BtP9._)(as, [
        {
            /**
   * Returns the root element of the hint content
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        }
    ]);
    return as;
}();
var $e310f5997d90c4d6$var$xt = /*#__PURE__*/ function() {
    "use strict";
    function xt(e) {
        (0, $7lhcp._)(this, xt);
        this.params = e;
    }
    (0, $8BtP9._)(xt, [
        {
            key: "name",
            get: /**
   * Item name if exists
   */ function get() {
                if (this.params !== void 0 && "name" in this.params) return this.params.name;
            }
        },
        {
            /**
   * Destroys the instance
   */ key: "destroy",
            value: function destroy() {
                $e310f5997d90c4d6$var$$e();
            }
        },
        {
            /**
   * Called when children popover is opened (if exists)
   */ key: "onChildrenOpen",
            value: function onChildrenOpen() {
                var e;
                this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
            }
        },
        {
            /**
   * Called when children popover is closed (if exists)
   */ key: "onChildrenClose",
            value: function onChildrenClose() {
                var e;
                this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
            }
        },
        {
            /**
   * Called on popover item click
   */ key: "handleClick",
            value: function handleClick() {
                var e, t1;
                this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
            }
        },
        {
            /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ key: "addHint",
            value: function addHint(e, t1) {
                var o = new $e310f5997d90c4d6$var$as(t1);
                $e310f5997d90c4d6$var$ze(e, o.getElement(), {
                    placement: t1.position,
                    hidingDelay: 100
                });
            }
        },
        {
            key: "children",
            get: /**
   * Returns item children that are represented as popover items
   */ function get() {
                var e;
                return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
            }
        },
        {
            key: "hasChildren",
            get: /**
   * Returns true if item has any type of children
   */ function get() {
                return this.children.length > 0;
            }
        },
        {
            key: "isChildrenOpen",
            get: /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ function get() {
                var e;
                return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
            }
        },
        {
            key: "isChildrenFlippable",
            get: /**
   * True if item children items should be navigatable via keyboard
   */ function get() {
                var e;
                return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
            }
        },
        {
            key: "isChildrenSearchable",
            get: /**
   * Returns true if item has children that should be searchable
   */ function get() {
                var e;
                return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
            }
        },
        {
            key: "closeOnActivate",
            get: /**
   * True if popover should close once item is activated
   */ function get() {
                return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
            }
        },
        {
            key: "isActive",
            get: /**
   * True if item is active
   */ function get() {
                return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
            }
        }
    ]);
    return xt;
}();
var $e310f5997d90c4d6$var$Y = $e310f5997d90c4d6$var$ne("ce-popover-item"), $e310f5997d90c4d6$var$L = {
    container: $e310f5997d90c4d6$var$Y(),
    active: $e310f5997d90c4d6$var$Y(null, "active"),
    disabled: $e310f5997d90c4d6$var$Y(null, "disabled"),
    focused: $e310f5997d90c4d6$var$Y(null, "focused"),
    hidden: $e310f5997d90c4d6$var$Y(null, "hidden"),
    confirmationState: $e310f5997d90c4d6$var$Y(null, "confirmation"),
    noHover: $e310f5997d90c4d6$var$Y(null, "no-hover"),
    noFocus: $e310f5997d90c4d6$var$Y(null, "no-focus"),
    title: $e310f5997d90c4d6$var$Y("title"),
    secondaryTitle: $e310f5997d90c4d6$var$Y("secondary-title"),
    icon: $e310f5997d90c4d6$var$Y("icon"),
    iconTool: $e310f5997d90c4d6$var$Y("icon", "tool"),
    iconChevronRight: $e310f5997d90c4d6$var$Y("icon", "chevron-right"),
    wobbleAnimation: $e310f5997d90c4d6$var$ne("wobble")()
};
var $e310f5997d90c4d6$var$re = /*#__PURE__*/ function(xt) {
    "use strict";
    (0, $h6w6E._)(re, xt);
    function re(e, t1) {
        (0, $7lhcp._)(this, re);
        var _this;
        _this = (0, $07dqX._)(this, re, [
            e
        ]), _this.params = e, _this.nodes = {
            root: null,
            icon: null
        }, _this.confirmationState = null, _this.removeSpecialFocusBehavior = function() {
            var o;
            (o = _this.nodes.root) == null || o.classList.remove($e310f5997d90c4d6$var$L.noFocus);
        }, _this.removeSpecialHoverBehavior = function() {
            var o;
            (o = _this.nodes.root) == null || o.classList.remove($e310f5997d90c4d6$var$L.noHover);
        }, _this.onErrorAnimationEnd = function() {
            var o, i;
            (o = _this.nodes.icon) == null || o.classList.remove($e310f5997d90c4d6$var$L.wobbleAnimation), (i = _this.nodes.icon) == null || i.removeEventListener("animationend", _this.onErrorAnimationEnd);
        }, _this.nodes.root = _this.make(e, t1);
        return _this;
    }
    (0, $8BtP9._)(re, [
        {
            key: "isDisabled",
            get: /**
   * True if item is disabled and hence not clickable
   */ function get() {
                return this.params.isDisabled === !0;
            }
        },
        {
            key: "toggle",
            get: /**
   * Exposes popover item toggle parameter
   */ function get() {
                return this.params.toggle;
            }
        },
        {
            key: "title",
            get: /**
   * Item title
   */ function get() {
                return this.params.title;
            }
        },
        {
            key: "isConfirmationStateEnabled",
            get: /**
   * True if confirmation state is enabled for popover item
   */ function get() {
                return this.confirmationState !== null;
            }
        },
        {
            key: "isFocused",
            get: /**
   * True if item is focused in keyboard navigation process
   */ function get() {
                return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($e310f5997d90c4d6$var$L.focused);
            }
        },
        {
            /**
   * Returns popover item root element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Called on popover item click
   */ key: "handleClick",
            value: function handleClick() {
                if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
                    this.activateOrEnableConfirmationMode(this.confirmationState);
                    return;
                }
                this.activateOrEnableConfirmationMode(this.params);
            }
        },
        {
            /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ key: "toggleActive",
            value: function toggleActive(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($e310f5997d90c4d6$var$L.active, e);
            }
        },
        {
            /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ key: "toggleHidden",
            value: function toggleHidden(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($e310f5997d90c4d6$var$L.hidden, e);
            }
        },
        {
            /**
   * Resets popover item to its original state
   */ key: "reset",
            value: function reset() {
                this.isConfirmationStateEnabled && this.disableConfirmationMode();
            }
        },
        {
            /**
   * Method called once item becomes focused during keyboard navigation
   */ key: "onFocus",
            value: function onFocus() {
                this.disableSpecialHoverAndFocusBehavior();
            }
        },
        {
            /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ key: "make",
            value: function make(e, t1) {
                var s, r;
                var o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $e310f5997d90c4d6$var$u.make(o, $e310f5997d90c4d6$var$L.container, {
                    type: o === "button" ? "button" : void 0
                });
                return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $e310f5997d90c4d6$var$u.make("div", [
                    $e310f5997d90c4d6$var$L.icon,
                    $e310f5997d90c4d6$var$L.iconTool
                ], {
                    innerHTML: e.icon || $e310f5997d90c4d6$var$Qi
                }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$L.title, {
                    innerHTML: e.title || ""
                })), e.secondaryLabel && i.appendChild($e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$L.secondaryTitle, {
                    textContent: e.secondaryLabel
                })), this.hasChildren && i.appendChild($e310f5997d90c4d6$var$u.make("div", [
                    $e310f5997d90c4d6$var$L.icon,
                    $e310f5997d90c4d6$var$L.iconChevronRight
                ], {
                    innerHTML: $e310f5997d90c4d6$var$qi
                })), this.isActive && i.classList.add($e310f5997d90c4d6$var$L.active), e.isDisabled && i.classList.add($e310f5997d90c4d6$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, (0, $ctBui._)((0, $6GCxi._)({}, e.hint), {
                    position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
                })), i;
            }
        },
        {
            /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ key: "enableConfirmationMode",
            value: function enableConfirmationMode(e) {
                if (this.nodes.root === null) return;
                var t1 = (0, $ctBui._)((0, $6GCxi._)({}, this.params, e), {
                    confirmation: "confirmation" in e ? e.confirmation : void 0
                }), o = this.make(t1);
                this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($e310f5997d90c4d6$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
            }
        },
        {
            /**
   * Returns item to its original state
   */ key: "disableConfirmationMode",
            value: function disableConfirmationMode() {
                if (this.nodes.root === null) return;
                var e = this.make(this.params);
                this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($e310f5997d90c4d6$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
            }
        },
        {
            /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ key: "enableSpecialHoverAndFocusBehavior",
            value: function enableSpecialHoverAndFocusBehavior() {
                var e, t1, o;
                (e = this.nodes.root) == null || e.classList.add($e310f5997d90c4d6$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($e310f5997d90c4d6$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
                    once: !0
                });
            }
        },
        {
            /**
   * Disables special focus and hover behavior
   */ key: "disableSpecialHoverAndFocusBehavior",
            value: function disableSpecialHoverAndFocusBehavior() {
                var e;
                this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
            }
        },
        {
            /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ key: "activateOrEnableConfirmationMode",
            value: function activateOrEnableConfirmationMode(e) {
                var t1;
                if (!("confirmation" in e) || e.confirmation === void 0) try {
                    (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
                } catch (e) {
                    this.animateError();
                }
                else this.enableConfirmationMode(e.confirmation);
            }
        },
        {
            /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ key: "animateError",
            value: function animateError() {
                var e, t1, o;
                (e = this.nodes.icon) != null && e.classList.contains($e310f5997d90c4d6$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($e310f5997d90c4d6$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
            }
        }
    ]);
    return re;
}($e310f5997d90c4d6$var$xt);
var $e310f5997d90c4d6$var$nt = $e310f5997d90c4d6$var$ne("ce-popover-item-separator"), $e310f5997d90c4d6$var$it = {
    container: $e310f5997d90c4d6$var$nt(),
    line: $e310f5997d90c4d6$var$nt("line"),
    hidden: $e310f5997d90c4d6$var$nt(null, "hidden")
};
var $e310f5997d90c4d6$var$Qo = /*#__PURE__*/ function(xt) {
    "use strict";
    (0, $h6w6E._)(Qo, xt);
    function Qo() {
        (0, $7lhcp._)(this, Qo);
        var _this;
        _this = (0, $07dqX._)(this, Qo), _this.nodes = {
            root: $e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$it.container),
            line: $e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$it.line)
        }, _this.nodes.root.appendChild(_this.nodes.line);
        return _this;
    }
    (0, $8BtP9._)(Qo, [
        {
            /**
   * Returns popover separator root element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ key: "toggleHidden",
            value: function toggleHidden(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($e310f5997d90c4d6$var$it.hidden, e);
            }
        }
    ]);
    return Qo;
}($e310f5997d90c4d6$var$xt);
var $e310f5997d90c4d6$var$G = /* @__PURE__ */ function(n) {
    return n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n;
}($e310f5997d90c4d6$var$G || {});
var $e310f5997d90c4d6$var$$ = $e310f5997d90c4d6$var$ne("ce-popover"), $e310f5997d90c4d6$var$P = {
    popover: $e310f5997d90c4d6$var$$(),
    popoverContainer: $e310f5997d90c4d6$var$$("container"),
    popoverOpenTop: $e310f5997d90c4d6$var$$(null, "open-top"),
    popoverOpenLeft: $e310f5997d90c4d6$var$$(null, "open-left"),
    popoverOpened: $e310f5997d90c4d6$var$$(null, "opened"),
    search: $e310f5997d90c4d6$var$$("search"),
    nothingFoundMessage: $e310f5997d90c4d6$var$$("nothing-found-message"),
    nothingFoundMessageDisplayed: $e310f5997d90c4d6$var$$("nothing-found-message", "displayed"),
    items: $e310f5997d90c4d6$var$$("items"),
    overlay: $e310f5997d90c4d6$var$$("overlay"),
    overlayHidden: $e310f5997d90c4d6$var$$("overlay", "hidden"),
    popoverNested: $e310f5997d90c4d6$var$$(null, "nested"),
    getPopoverNestedClass: function(n) {
        return $e310f5997d90c4d6$var$$(null, "nested-level-".concat(n.toString()));
    },
    popoverInline: $e310f5997d90c4d6$var$$(null, "inline"),
    popoverHeader: $e310f5997d90c4d6$var$$("header")
};
var $e310f5997d90c4d6$var$fe = /* @__PURE__ */ function(n) {
    return n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n;
}($e310f5997d90c4d6$var$fe || {});
var $e310f5997d90c4d6$var$To = $e310f5997d90c4d6$var$ne("ce-popover-item-html"), $e310f5997d90c4d6$var$So = {
    root: $e310f5997d90c4d6$var$To(),
    hidden: $e310f5997d90c4d6$var$To(null, "hidden")
};
var $e310f5997d90c4d6$var$Se = /*#__PURE__*/ function(xt) {
    "use strict";
    (0, $h6w6E._)(Se, xt);
    function Se(e, t1) {
        (0, $7lhcp._)(this, Se);
        var _this;
        var o, i;
        _this = (0, $07dqX._)(this, Se, [
            e
        ]), _this.nodes = {
            root: $e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$So.root)
        }, _this.nodes.root.appendChild(e.element), e.name && (_this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && _this.addHint(_this.nodes.root, (0, $ctBui._)((0, $6GCxi._)({}, e.hint), {
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        }));
        return _this;
    }
    (0, $8BtP9._)(Se, [
        {
            /**
   * Returns popover item root element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ key: "toggleHidden",
            value: function toggleHidden(e) {
                var t1;
                (t1 = this.nodes.root) == null || t1.classList.toggle($e310f5997d90c4d6$var$So.hidden, e);
            }
        },
        {
            /**
   * Returns list of buttons and inputs inside custom content
   */ key: "getControls",
            value: function getControls() {
                var e = this.nodes.root.querySelectorAll("button, ".concat($e310f5997d90c4d6$var$u.allInputsSelector));
                return Array.from(e);
            }
        }
    ]);
    return Se;
}($e310f5997d90c4d6$var$xt);
var $e310f5997d90c4d6$var$Jo = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $h6w6E._)(Jo, Oe);
    function Jo(e) {
        var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $7lhcp._)(this, Jo);
        var _this;
        _this = (0, $07dqX._)(this, Jo), _this.params = e, _this.itemsRenderParams = t1, _this.listeners = new $e310f5997d90c4d6$var$_e(), _this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, _this.items = _this.buildItems(e.items), e.messages && (_this.messages = (0, $6GCxi._)({}, _this.messages, e.messages)), _this.nodes = {}, _this.nodes.popoverContainer = $e310f5997d90c4d6$var$u.make("div", [
            $e310f5997d90c4d6$var$P.popoverContainer
        ]), _this.nodes.nothingFoundMessage = $e310f5997d90c4d6$var$u.make("div", [
            $e310f5997d90c4d6$var$P.nothingFoundMessage
        ], {
            textContent: _this.messages.nothingFound
        }), _this.nodes.popoverContainer.appendChild(_this.nodes.nothingFoundMessage), _this.nodes.items = $e310f5997d90c4d6$var$u.make("div", [
            $e310f5997d90c4d6$var$P.items
        ]), _this.items.forEach(function(o) {
            var i = o.getElement();
            i !== null && _this.nodes.items.appendChild(i);
        }), _this.nodes.popoverContainer.appendChild(_this.nodes.items), _this.listeners.on(_this.nodes.popoverContainer, "click", function(o) {
            return _this.handleClick(o);
        }), _this.nodes.popover = $e310f5997d90c4d6$var$u.make("div", [
            $e310f5997d90c4d6$var$P.popover,
            _this.params.class
        ]), _this.nodes.popover.appendChild(_this.nodes.popoverContainer);
        return _this;
    }
    (0, $8BtP9._)(Jo, [
        {
            key: "itemsDefault",
            get: /**
   * List of default popover items that are searchable and may have confirmation state
   */ function get() {
                return this.items.filter(function(e) {
                    return e instanceof $e310f5997d90c4d6$var$re;
                });
            }
        },
        {
            /**
   * Returns HTML element corresponding to the popover
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.popover;
            }
        },
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                this.nodes.popover.classList.add($e310f5997d90c4d6$var$P.popoverOpened), this.search !== void 0 && this.search.focus();
            }
        },
        {
            /**
   * Closes popover
   */ key: "hide",
            value: function hide() {
                this.nodes.popover.classList.remove($e310f5997d90c4d6$var$P.popoverOpened), this.nodes.popover.classList.remove($e310f5997d90c4d6$var$P.popoverOpenTop), this.itemsDefault.forEach(function(e) {
                    return e.reset();
                }), this.search !== void 0 && this.search.clear(), this.emit($e310f5997d90c4d6$var$G.Closed);
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                var e;
                this.items.forEach(function(t1) {
                    return t1.destroy();
                }), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
            }
        },
        {
            /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ key: "activateItemByName",
            value: function activateItemByName(e) {
                var t1 = this.items.find(function(o) {
                    return o.name === e;
                });
                this.handleItemClick(t1);
            }
        },
        {
            /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ key: "buildItems",
            value: function buildItems(e) {
                var _this = this;
                return e.map(function(t1) {
                    switch(t1.type){
                        case $e310f5997d90c4d6$var$_.Separator:
                            return new $e310f5997d90c4d6$var$Qo();
                        case $e310f5997d90c4d6$var$_.Html:
                            return new $e310f5997d90c4d6$var$Se(t1, _this.itemsRenderParams[$e310f5997d90c4d6$var$_.Html]);
                        default:
                            return new $e310f5997d90c4d6$var$re(t1, _this.itemsRenderParams[$e310f5997d90c4d6$var$_.Default]);
                    }
                });
            }
        },
        {
            /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ key: "getTargetItem",
            value: function getTargetItem(e) {
                return this.items.filter(function(t1) {
                    return t1 instanceof $e310f5997d90c4d6$var$re || t1 instanceof $e310f5997d90c4d6$var$Se;
                }).find(function(t1) {
                    var o = t1.getElement();
                    return o === null ? !1 : e.composedPath().includes(o);
                });
            }
        },
        {
            /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ key: "handleItemClick",
            value: function handleItemClick(e) {
                if (!("isDisabled" in e && e.isDisabled)) {
                    if (e.hasChildren) {
                        this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                        return;
                    }
                    this.itemsDefault.filter(function(t1) {
                        return t1 !== e;
                    }).forEach(function(t1) {
                        return t1.reset();
                    }), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($e310f5997d90c4d6$var$G.ClosedOnActivate));
                }
            }
        },
        {
            /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ key: "handleClick",
            value: function handleClick(e) {
                var t1 = this.getTargetItem(e);
                t1 !== void 0 && this.handleItemClick(t1);
            }
        },
        {
            /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ key: "toggleItemActivenessIfNeeded",
            value: function toggleItemActivenessIfNeeded(e) {
                if (e instanceof $e310f5997d90c4d6$var$re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
                    var t1 = this.itemsDefault.filter(function(o) {
                        return o.toggle === e.toggle;
                    });
                    if (t1.length === 1) {
                        e.toggleActive();
                        return;
                    }
                    t1.forEach(function(o) {
                        o.toggleActive(o === e);
                    });
                }
            }
        }
    ]);
    return Jo;
}($e310f5997d90c4d6$var$Oe);
var $e310f5997d90c4d6$var$Ue = /* @__PURE__ */ function(n) {
    return n.Search = "search", n;
}($e310f5997d90c4d6$var$Ue || {});
var $e310f5997d90c4d6$var$st = $e310f5997d90c4d6$var$ne("cdx-search-field"), $e310f5997d90c4d6$var$rt = {
    wrapper: $e310f5997d90c4d6$var$st(),
    icon: $e310f5997d90c4d6$var$st("icon"),
    input: $e310f5997d90c4d6$var$st("input")
};
var $e310f5997d90c4d6$var$ls = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $h6w6E._)(ls, Oe);
    function ls(param) {
        var e = param.items, t1 = param.placeholder;
        (0, $7lhcp._)(this, ls);
        var _this;
        _this = (0, $07dqX._)(this, ls), _this.listeners = new $e310f5997d90c4d6$var$_e(), _this.items = e, _this.wrapper = $e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$rt.wrapper);
        var o = $e310f5997d90c4d6$var$u.make("div", $e310f5997d90c4d6$var$rt.icon, {
            innerHTML: $e310f5997d90c4d6$var$os
        });
        _this.input = $e310f5997d90c4d6$var$u.make("input", $e310f5997d90c4d6$var$rt.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), _this.wrapper.appendChild(o), _this.wrapper.appendChild(_this.input), _this.listeners.on(_this.input, "input", function() {
            _this.searchQuery = _this.input.value, _this.emit($e310f5997d90c4d6$var$Ue.Search, {
                query: _this.searchQuery,
                items: _this.foundItems
            });
        });
        return _this;
    }
    (0, $8BtP9._)(ls, [
        {
            /**
   * Returns search field element
   */ key: "getElement",
            value: function getElement() {
                return this.wrapper;
            }
        },
        {
            /**
   * Sets focus to the input
   */ key: "focus",
            value: function focus() {
                this.input.focus();
            }
        },
        {
            /**
   * Clears search query and results
   */ key: "clear",
            value: function clear() {
                this.input.value = "", this.searchQuery = "", this.emit($e310f5997d90c4d6$var$Ue.Search, {
                    query: "",
                    items: this.foundItems
                });
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                this.listeners.removeAll();
            }
        },
        {
            key: "foundItems",
            get: /**
   * Returns list of found items for the current search query
   */ function get() {
                var _this = this;
                return this.items.filter(function(e) {
                    return _this.checkItem(e);
                });
            }
        },
        {
            /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ key: "checkItem",
            value: function checkItem(e) {
                var i, s;
                var t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
                return o !== void 0 ? t1.includes(o) : !1;
            }
        }
    ]);
    return ls;
}($e310f5997d90c4d6$var$Oe);
var $e310f5997d90c4d6$var$cs = Object.defineProperty, $e310f5997d90c4d6$var$ds = Object.getOwnPropertyDescriptor, $e310f5997d90c4d6$var$us = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $e310f5997d90c4d6$var$ds(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e310f5997d90c4d6$var$cs(e, t1, i), i;
};
var $e310f5997d90c4d6$var$en = /*#__PURE__*/ function(Jo) {
    "use strict";
    (0, $h6w6E._)(tn, Jo);
    function tn(e, t1) {
        (0, $7lhcp._)(this, tn);
        var _this;
        _this = (0, $07dqX._)(this, tn, [
            e,
            t1
        ]), _this.nestingLevel = 0, _this.nestedPopoverTriggerItem = null, _this.previouslyHoveredItem = null, _this.scopeElement = document.body, _this.hide = function() {
            var o;
            (0, $5LQ10._)(((0, $aVdP5._)(_this), (0, $2JFuQ._)(tn.prototype)), "hide", _this).call(_this), _this.destroyNestedPopoverIfExists(), (o = _this.flipper) == null || o.deactivate(), _this.previouslyHoveredItem = null;
        }, _this.onFlip = function() {
            var o = _this.itemsDefault.find(function(i) {
                return i.isFocused;
            });
            o == null || o.onFocus();
        }, _this.onSearch = function(o) {
            var a;
            var i = o.query === "", s = o.items.length === 0;
            _this.items.forEach(function(l) {
                var c = !1;
                l instanceof $e310f5997d90c4d6$var$re ? c = !o.items.includes(l) : (l instanceof $e310f5997d90c4d6$var$Qo || l instanceof $e310f5997d90c4d6$var$Se) && (c = s || !i), l.toggleHidden(c);
            }), _this.toggleNothingFoundMessage(s);
            var r = o.query === "" ? _this.flippableElements : o.items.map(function(l) {
                return l.getElement();
            });
            (a = _this.flipper) != null && a.isActivated && (_this.flipper.deactivate(), _this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (_this.nestingLevel = e.nestingLevel), _this.nestingLevel > 0 && _this.nodes.popover.classList.add($e310f5997d90c4d6$var$P.popoverNested), e.scopeElement !== void 0 && (_this.scopeElement = e.scopeElement), _this.nodes.popoverContainer !== null && _this.listeners.on(_this.nodes.popoverContainer, "mouseover", function(o) {
            return _this.handleHover(o);
        }), e.searchable && _this.addSearch(), e.flippable !== !1 && (_this.flipper = new $e310f5997d90c4d6$var$ce({
            items: _this.flippableElements,
            focusedItemClass: $e310f5997d90c4d6$var$L.focused,
            allowedKeys: [
                $e310f5997d90c4d6$var$y.TAB,
                $e310f5997d90c4d6$var$y.UP,
                $e310f5997d90c4d6$var$y.DOWN,
                $e310f5997d90c4d6$var$y.ENTER
            ]
        }), _this.flipper.onFlip(_this.onFlip));
        return _this;
    }
    (0, $8BtP9._)(tn, [
        {
            /**
   * Returns true if some item inside popover is focused
   */ key: "hasFocus",
            value: function hasFocus() {
                return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
            }
        },
        {
            key: "scrollTop",
            get: /**
   * Scroll position inside items container of the popover
   */ function get() {
                return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
            }
        },
        {
            key: "offsetTop",
            get: /**
   * Returns visible element offset top
   */ function get() {
                return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
            }
        },
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                var e;
                this.nodes.popover.style.setProperty($e310f5997d90c4d6$var$fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($e310f5997d90c4d6$var$P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($e310f5997d90c4d6$var$P.popoverOpenLeft), (0, $5LQ10._)((0, $2JFuQ._)(tn.prototype), "show", this).call(this), (e = this.flipper) == null || e.activate(this.flippableElements);
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                this.hide(), (0, $5LQ10._)((0, $2JFuQ._)(tn.prototype), "destroy", this).call(this);
            }
        },
        {
            /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ key: "showNestedItems",
            value: function showNestedItems(e) {
                this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
            }
        },
        {
            /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ key: "handleHover",
            value: function handleHover(e) {
                var t1 = this.getTargetItem(e);
                t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
            }
        },
        {
            /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ key: "setTriggerItemPosition",
            value: function setTriggerItemPosition(e, t1) {
                var o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
                e.style.setProperty($e310f5997d90c4d6$var$fe.TriggerItemTop, s + "px");
            }
        },
        {
            /**
   * Destroys existing nested popover
   */ key: "destroyNestedPopoverIfExists",
            value: function destroyNestedPopoverIfExists() {
                var e, t1;
                this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($e310f5997d90c4d6$var$G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
            }
        },
        {
            /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ key: "showNestedPopoverForItem",
            value: function showNestedPopoverForItem(e) {
                var o;
                this.nestedPopover = new tn({
                    searchable: e.isChildrenSearchable,
                    items: e.children,
                    nestingLevel: this.nestingLevel + 1,
                    flippable: e.isChildrenFlippable,
                    messages: this.messages
                }), e.onChildrenOpen(), this.nestedPopover.on($e310f5997d90c4d6$var$G.ClosedOnActivate, this.hide);
                var t1 = this.nestedPopover.getElement();
                return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($e310f5997d90c4d6$var$fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
            }
        },
        {
            key: "shouldOpenBottom",
            get: /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ function get() {
                if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
                var e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
                return s < t1.top || i <= r;
            }
        },
        {
            key: "shouldOpenRight",
            get: /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ function get() {
                if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
                var e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
                return s < t1.left || i <= r;
            }
        },
        {
            key: "size",
            get: function get() {
                var i;
                var e = {
                    height: 0,
                    width: 0
                };
                if (this.nodes.popover === null) return e;
                var t1 = this.nodes.popover.cloneNode(!0);
                t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($e310f5997d90c4d6$var$P.popoverOpened), (i = t1.querySelector("." + $e310f5997d90c4d6$var$P.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
                var o = t1.querySelector("." + $e310f5997d90c4d6$var$P.popoverContainer);
                return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
            }
        },
        {
            key: "flippableElements",
            get: /**
   * Returns list of elements available for keyboard navigation.
   */ function get() {
                return this.items.map(function(t1) {
                    if (t1 instanceof $e310f5997d90c4d6$var$re) return t1.getElement();
                    if (t1 instanceof $e310f5997d90c4d6$var$Se) return t1.getControls();
                }).flat().filter(function(t1) {
                    return t1 != null;
                });
            }
        },
        {
            /**
   * Adds search to the popover
   */ key: "addSearch",
            value: function addSearch() {
                this.search = new $e310f5997d90c4d6$var$ls({
                    items: this.itemsDefault,
                    placeholder: this.messages.search
                }), this.search.on($e310f5997d90c4d6$var$Ue.Search, this.onSearch);
                var e = this.search.getElement();
                e.classList.add($e310f5997d90c4d6$var$P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
            }
        },
        {
            /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ key: "toggleNothingFoundMessage",
            value: function toggleNothingFoundMessage(e) {
                this.nodes.nothingFoundMessage.classList.toggle($e310f5997d90c4d6$var$P.nothingFoundMessageDisplayed, e);
            }
        }
    ]);
    return tn;
}($e310f5997d90c4d6$var$Jo);
$e310f5997d90c4d6$var$us([
    $e310f5997d90c4d6$var$me
], $e310f5997d90c4d6$var$en.prototype, "size", 1);
var $e310f5997d90c4d6$var$Bt = $e310f5997d90c4d6$var$en;
var $e310f5997d90c4d6$var$hs = /*#__PURE__*/ function(Bt) {
    "use strict";
    (0, $h6w6E._)(hs, Bt);
    function hs(e) {
        (0, $7lhcp._)(this, hs);
        var _this;
        var t1 = !$e310f5997d90c4d6$var$be();
        var _obj;
        _this = (0, $07dqX._)(this, hs, [
            (0, $ctBui._)((0, $6GCxi._)({}, e), {
                class: $e310f5997d90c4d6$var$P.popoverInline
            }),
            (_obj = {}, (0, $5RfYb._)(_obj, $e310f5997d90c4d6$var$_.Default, {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }), (0, $5RfYb._)(_obj, $e310f5997d90c4d6$var$_.Html, {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }), _obj)
        ]), _this.items.forEach(function(o) {
            !(o instanceof $e310f5997d90c4d6$var$re) && !(o instanceof $e310f5997d90c4d6$var$Se) || o.hasChildren && o.isChildrenOpen && _this.showNestedItems(o);
        });
        return _this;
    }
    (0, $8BtP9._)(hs, [
        {
            key: "offsetLeft",
            get: /**
   * Returns visible element offset top
   */ function get() {
                return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
            }
        },
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                this.nestingLevel === 0 && this.nodes.popover.style.setProperty($e310f5997d90c4d6$var$fe.InlinePopoverWidth, this.size.width + "px"), (0, $5LQ10._)((0, $2JFuQ._)(hs.prototype), "show", this).call(this);
            }
        },
        {
            /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ key: "handleHover",
            value: function handleHover() {}
        },
        {
            /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ key: "setTriggerItemPosition",
            value: function setTriggerItemPosition(e, t1) {
                var o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
                e.style.setProperty($e310f5997d90c4d6$var$fe.TriggerItemLeft, s + "px");
            }
        },
        {
            /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ key: "showNestedItems",
            value: function showNestedItems(e) {
                if (this.nestedPopoverTriggerItem === e) {
                    this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
                    return;
                }
                (0, $5LQ10._)((0, $2JFuQ._)(hs.prototype), "showNestedItems", this).call(this, e);
            }
        },
        {
            /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ key: "showNestedPopoverForItem",
            value: function showNestedPopoverForItem(e) {
                var t1 = (0, $5LQ10._)((0, $2JFuQ._)(hs.prototype), "showNestedPopoverForItem", this).call(this, e);
                return t1.getElement().classList.add($e310f5997d90c4d6$var$P.getPopoverNestedClass(t1.nestingLevel)), t1;
            }
        },
        {
            /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ key: "handleItemClick",
            value: function handleItemClick(e) {
                var t1;
                e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), (0, $5LQ10._)((0, $2JFuQ._)(hs.prototype), "destroyNestedPopoverIfExists", this).call(this)), (0, $5LQ10._)((0, $2JFuQ._)(hs.prototype), "handleItemClick", this).call(this, e);
            }
        }
    ]);
    return hs;
}($e310f5997d90c4d6$var$Bt);
var $e310f5997d90c4d6$var$on = /*#__PURE__*/ function() {
    "use strict";
    function xe() {
        (0, $7lhcp._)(this, xe);
        this.scrollPosition = null;
    }
    (0, $8BtP9._)(xe, [
        {
            /**
   * Locks body element scroll
   */ key: "lock",
            value: function lock() {
                $e310f5997d90c4d6$var$pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
            }
        },
        {
            /**
   * Unlocks body element scroll
   */ key: "unlock",
            value: function unlock() {
                $e310f5997d90c4d6$var$pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
            }
        },
        {
            /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ key: "lockHard",
            value: function lockHard() {
                this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", "".concat(this.scrollPosition, "px")), document.body.classList.add(xe.CSS.scrollLockedHard);
            }
        },
        {
            /**
   * Unlocks hard scroll lock
   */ key: "unlockHard",
            value: function unlockHard() {
                document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
            }
        }
    ]);
    return xe;
}();
$e310f5997d90c4d6$var$on.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
var $e310f5997d90c4d6$var$ps = $e310f5997d90c4d6$var$on;
var $e310f5997d90c4d6$var$at = $e310f5997d90c4d6$var$ne("ce-popover-header"), $e310f5997d90c4d6$var$lt = {
    root: $e310f5997d90c4d6$var$at(),
    text: $e310f5997d90c4d6$var$at("text"),
    backButton: $e310f5997d90c4d6$var$at("back-button")
};
var $e310f5997d90c4d6$var$fs = /*#__PURE__*/ function() {
    "use strict";
    function fs(param) {
        var e = param.text, t1 = param.onBackButtonClick;
        (0, $7lhcp._)(this, fs);
        this.listeners = new $e310f5997d90c4d6$var$_e(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $e310f5997d90c4d6$var$u.make("div", [
                $e310f5997d90c4d6$var$lt.root
            ]),
            backButton: $e310f5997d90c4d6$var$u.make("button", [
                $e310f5997d90c4d6$var$lt.backButton
            ]),
            text: $e310f5997d90c4d6$var$u.make("div", [
                $e310f5997d90c4d6$var$lt.text
            ])
        }, this.nodes.backButton.innerHTML = $e310f5997d90c4d6$var$Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    (0, $8BtP9._)(fs, [
        {
            /**
   * Returns popover header root html element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.root;
            }
        },
        {
            /**
   * Destroys the instance
   */ key: "destroy",
            value: function destroy() {
                this.nodes.root.remove(), this.listeners.destroy();
            }
        }
    ]);
    return fs;
}();
var $e310f5997d90c4d6$var$gs = /*#__PURE__*/ function() {
    "use strict";
    function gs() {
        (0, $7lhcp._)(this, gs);
        this.history = [];
    }
    (0, $8BtP9._)(gs, [
        {
            /**
   * Push new popover state
   *
   * @param state - new state
   */ key: "push",
            value: function push(e) {
                this.history.push(e);
            }
        },
        {
            /**
   * Pop last popover state
   */ key: "pop",
            value: function pop() {
                return this.history.pop();
            }
        },
        {
            key: "currentTitle",
            get: /**
   * Title retrieved from the current state
   */ function get() {
                return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
            }
        },
        {
            key: "currentItems",
            get: /**
   * Items list retrieved from the current state
   */ function get() {
                return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
            }
        },
        {
            /**
   * Returns history to initial popover state
   */ key: "reset",
            value: function reset() {
                for(; this.history.length > 1;)this.pop();
            }
        }
    ]);
    return gs;
}();
var $e310f5997d90c4d6$var$nn = /*#__PURE__*/ function(Jo) {
    "use strict";
    (0, $h6w6E._)(nn, Jo);
    function nn(e) {
        (0, $7lhcp._)(this, nn);
        var _this;
        var _obj;
        _this = (0, $07dqX._)(this, nn, [
            e,
            (_obj = {}, (0, $5RfYb._)(_obj, $e310f5997d90c4d6$var$_.Default, {
                hint: {
                    enabled: !1
                }
            }), (0, $5RfYb._)(_obj, $e310f5997d90c4d6$var$_.Html, {
                hint: {
                    enabled: !1
                }
            }), _obj)
        ]), _this.scrollLocker = new $e310f5997d90c4d6$var$ps(), _this.history = new $e310f5997d90c4d6$var$gs(), _this.isHidden = !0, _this.nodes.overlay = $e310f5997d90c4d6$var$u.make("div", [
            $e310f5997d90c4d6$var$P.overlay,
            $e310f5997d90c4d6$var$P.overlayHidden
        ]), _this.nodes.popover.insertBefore(_this.nodes.overlay, _this.nodes.popover.firstChild), _this.listeners.on(_this.nodes.overlay, "click", function() {
            _this.hide();
        }), _this.history.push({
            items: e.items
        });
        return _this;
    }
    (0, $8BtP9._)(nn, [
        {
            /**
   * Open popover
   */ key: "show",
            value: function show() {
                this.nodes.overlay.classList.remove($e310f5997d90c4d6$var$P.overlayHidden), (0, $5LQ10._)((0, $2JFuQ._)(nn.prototype), "show", this).call(this), this.scrollLocker.lock(), this.isHidden = !1;
            }
        },
        {
            /**
   * Closes popover
   */ key: "hide",
            value: function hide() {
                this.isHidden || ((0, $5LQ10._)((0, $2JFuQ._)(nn.prototype), "hide", this).call(this), this.nodes.overlay.classList.add($e310f5997d90c4d6$var$P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
            }
        },
        {
            /**
   * Clears memory
   */ key: "destroy",
            value: function destroy() {
                (0, $5LQ10._)((0, $2JFuQ._)(nn.prototype), "destroy", this).call(this), this.scrollLocker.unlock();
            }
        },
        {
            /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ key: "showNestedItems",
            value: function showNestedItems(e) {
                this.updateItemsAndHeader(e.children, e.title), this.history.push({
                    title: e.title,
                    items: e.children
                });
            }
        },
        {
            /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ key: "updateItemsAndHeader",
            value: function updateItemsAndHeader(e, t1) {
                var _this = this;
                if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
                    this.header = new $e310f5997d90c4d6$var$fs({
                        text: t1,
                        onBackButtonClick: function() {
                            _this.history.pop(), _this.updateItemsAndHeader(_this.history.currentItems, _this.history.currentTitle);
                        }
                    });
                    var o = this.header.getElement();
                    o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
                }
                this.items.forEach(function(o) {
                    var i;
                    return (i = o.getElement()) == null ? void 0 : i.remove();
                }), this.items = this.buildItems(e), this.items.forEach(function(o) {
                    var s;
                    var i = o.getElement();
                    i !== null && ((s = _this.nodes.items) == null || s.appendChild(i));
                });
            }
        }
    ]);
    return nn;
}($e310f5997d90c4d6$var$Jo);
var $e310f5997d90c4d6$var$ms = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(ms, E);
    function ms() {
        (0, $7lhcp._)(this, ms);
        var _this;
        _this = (0, $07dqX._)(this, ms, arguments), _this.opened = !1, _this.selection = new $e310f5997d90c4d6$var$b(), _this.popover = null, _this.close = function() {
            _this.opened && (_this.opened = !1, $e310f5997d90c4d6$var$b.isAtEditor || _this.selection.restore(), _this.selection.clearSaved(), !_this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && _this.Editor.BlockManager.currentBlock && _this.Editor.BlockSelection.unselectBlock(_this.Editor.BlockManager.currentBlock), _this.eventsDispatcher.emit(_this.events.closed), _this.popover && (_this.popover.off($e310f5997d90c4d6$var$G.Closed, _this.onPopoverClose), _this.popover.destroy(), _this.popover.getElement().remove(), _this.popover = null));
        }, _this.onPopoverClose = function() {
            _this.close();
        };
        return _this;
    }
    (0, $8BtP9._)(ms, [
        {
            key: "events",
            get: /**
   * Module Events
   */ function get() {
                return {
                    opened: "block-settings-opened",
                    closed: "block-settings-closed"
                };
            }
        },
        {
            key: "CSS",
            get: /**
   * Block Settings CSS
   */ function get() {
                return {
                    settings: "ce-settings"
                };
            }
        },
        {
            key: "flipper",
            get: /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ function get() {
                var e;
                if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
            }
        },
        {
            /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ key: "make",
            value: function make() {
                this.nodes.wrapper = $e310f5997d90c4d6$var$u.make("div", [
                    this.CSS.settings
                ]), this.eventsDispatcher.on($e310f5997d90c4d6$var$Te, this.close);
            }
        },
        {
            /**
   * Destroys module
   */ key: "destroy",
            value: function destroy() {
                this.removeAllNodes(), this.listeners.destroy(), this.eventsDispatcher.off($e310f5997d90c4d6$var$Te, this.close);
            }
        },
        {
            key: "open",
            value: /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ function open() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var e, s, _e_getTunes, t1, o, i, _, _1, _tmp;
                    var _arguments = arguments;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.Editor.BlockManager.currentBlock;
                                this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
                                _e_getTunes = e.getTunes(), t1 = _e_getTunes.toolTunes, o = _e_getTunes.commonTunes;
                                this.eventsDispatcher.emit(this.events.opened);
                                i = $e310f5997d90c4d6$var$be() ? $e310f5997d90c4d6$var$nn : $e310f5997d90c4d6$var$Bt;
                                _ = this;
                                _1 = i.bind;
                                _tmp = {
                                    searchable: !0
                                };
                                return [
                                    4,
                                    this.getTunesItems(e, o, t1)
                                ];
                            case 1:
                                _.popover = new (_1.apply(i, [
                                    void 0,
                                    (_tmp.items = _state.sent(), _tmp.scopeElement = this.Editor.API.methods.ui.nodes.redactor, _tmp.messages = {
                                        nothingFound: $e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.popover, "Nothing found"),
                                        search: $e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.popover, "Filter")
                                    }, _tmp)
                                ])), this.popover.on($e310f5997d90c4d6$var$G.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Returns root block settings element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.wrapper;
            }
        },
        {
            key: "getTunesItems",
            value: /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ function getTunesItems(e, t1, o) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, _i, _i1, i, s, a;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                i = [];
                                o !== void 0 && o.length > 0 && ((_i = i).push.apply(_i, (0, $fsSDT._)(o)), i.push({
                                    type: $e310f5997d90c4d6$var$_.Separator
                                }));
                                s = Array.from(this.Editor.Tools.blockTools.values());
                                return [
                                    4,
                                    $e310f5997d90c4d6$var$Yo(e, s)
                                ];
                            case 1:
                                a = _state.sent().reduce(function(l, c) {
                                    return c.toolbox.forEach(function(d) {
                                        l.push({
                                            icon: d.icon,
                                            title: $e310f5997d90c4d6$var$z.t($e310f5997d90c4d6$var$K.toolNames, d.title),
                                            name: c.name,
                                            closeOnActivate: !0,
                                            onActivate: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                    var _this_Editor, h, p, g, f;
                                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _this_Editor = this.Editor, h = _this_Editor.BlockManager, p = _this_Editor.Caret, g = _this_Editor.Toolbar;
                                                                return [
                                                                    4,
                                                                    h.convert(e, c.name, d.data)
                                                                ];
                                                            case 1:
                                                                f = _state.sent();
                                                                g.close(), p.setToBlock(f, p.positions.END);
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        });
                                    }), l;
                                }, []);
                                return [
                                    2,
                                    (a.length > 0 && (i.push({
                                        icon: $e310f5997d90c4d6$var$Go,
                                        name: "convert-to",
                                        title: $e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.popover, "Convert to"),
                                        children: {
                                            searchable: !0,
                                            items: a
                                        }
                                    }), i.push({
                                        type: $e310f5997d90c4d6$var$_.Separator
                                    })), (_i1 = i).push.apply(_i1, (0, $fsSDT._)(t1)), i.map(function(l) {
                                        return _this.resolveTuneAliases(l);
                                    }))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ key: "resolveTuneAliases",
            value: function resolveTuneAliases(e) {
                if (e.type === $e310f5997d90c4d6$var$_.Separator || e.type === $e310f5997d90c4d6$var$_.Html) return e;
                var t1 = $e310f5997d90c4d6$var$Yi(e, {
                    label: "title"
                });
                return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
            }
        }
    ]);
    return ms;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$sn = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                (typeof Symbol === "undefined" ? "undefined" : (0, $5f0Cq._)(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && (typeof s === "undefined" ? "undefined" : (0, $5f0Cq._)(s)) == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function r() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(l, c) {
                    for(var d = 0; d < c.length; d++){
                        var h = c[d];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
                    }
                }
                function r(l, c, d) {
                    return c && s(l.prototype, c), d && s(l, d), l;
                }
                i.r(o);
                var a = function() {
                    function l(c) {
                        var d = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            d.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(l, null, [
                        {
                            key: "supportedCommands",
                            get: function get() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function get() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(l, [
                        {
                            key: "parseShortcutName",
                            value: function value(c) {
                                c = c.split("+");
                                for(var d = 0; d < c.length; d++){
                                    c[d] = c[d].toUpperCase();
                                    var h = !1;
                                    for(var p in l.supportedCommands)if (l.supportedCommands[p].includes(c[d])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[d]] = !0);
                                }
                                for(var g in l.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function value(c) {
                                var d, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(d in this.commands)this.commands[d] !== h[d] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === l.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function value() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), l;
                }();
                o.default = a;
            }
        ]).default;
    });
})($e310f5997d90c4d6$var$sn);
var $e310f5997d90c4d6$var$bs = $e310f5997d90c4d6$var$sn.exports;
var $e310f5997d90c4d6$var$vs = /* @__PURE__ */ $e310f5997d90c4d6$var$Ke($e310f5997d90c4d6$var$bs);
var $e310f5997d90c4d6$var$ks = /*#__PURE__*/ function() {
    "use strict";
    function ks() {
        (0, $7lhcp._)(this, ks);
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    (0, $8BtP9._)(ks, [
        {
            /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ key: "add",
            value: function add(e) {
                if (this.findShortcut(e.on, e.name)) throw Error("Shortcut ".concat(e.name, " is already registered for ").concat(e.on, ". Please remove it before add a new handler."));
                var o = new $e310f5997d90c4d6$var$vs({
                    name: e.name,
                    on: e.on,
                    callback: e.handler
                }), i = this.registeredShortcuts.get(e.on) || [];
                this.registeredShortcuts.set(e.on, (0, $fsSDT._)(i).concat([
                    o
                ]));
            }
        },
        {
            /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ key: "remove",
            value: function remove(e, t1) {
                var o = this.findShortcut(e, t1);
                if (!o) return;
                o.remove();
                var s = this.registeredShortcuts.get(e).filter(function(r) {
                    return r !== o;
                });
                if (s.length === 0) {
                    this.registeredShortcuts.delete(e);
                    return;
                }
                this.registeredShortcuts.set(e, s);
            }
        },
        {
            /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ key: "findShortcut",
            value: function findShortcut(e, t1) {
                return (this.registeredShortcuts.get(e) || []).find(function(param) {
                    var i = param.name;
                    return i === t1;
                });
            }
        }
    ]);
    return ks;
}();
var $e310f5997d90c4d6$var$ge = new $e310f5997d90c4d6$var$ks();
var $e310f5997d90c4d6$var$ys = Object.defineProperty, $e310f5997d90c4d6$var$ws = Object.getOwnPropertyDescriptor, $e310f5997d90c4d6$var$rn = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $e310f5997d90c4d6$var$ws(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e310f5997d90c4d6$var$ys(e, t1, i), i;
}, $e310f5997d90c4d6$var$Le = /* @__PURE__ */ function(n) {
    return n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n;
}($e310f5997d90c4d6$var$Le || {});
var $e310f5997d90c4d6$var$Ct = /*#__PURE__*/ function(Oe) {
    "use strict";
    (0, $h6w6E._)(an, Oe);
    function an(param) {
        var e = param.api, t1 = param.tools, o = param.i18nLabels;
        (0, $7lhcp._)(this, an);
        var _this;
        _this = (0, $07dqX._)(this, an), _this.opened = !1, _this.listeners = new $e310f5997d90c4d6$var$_e(), _this.popover = null, _this.handleMobileLayoutToggle = function() {
            _this.destroyPopover(), _this.initPopover();
        }, _this.onPopoverClose = function() {
            _this.opened = !1, _this.emit("toolbox-closed");
        }, _this.api = e, _this.tools = t1, _this.i18nLabels = o, _this.enableShortcuts(), _this.nodes = {
            toolbox: $e310f5997d90c4d6$var$u.make("div", an.CSS.toolbox)
        }, _this.initPopover(), _this.api.events.on($e310f5997d90c4d6$var$Te, _this.handleMobileLayoutToggle);
        return _this;
    }
    (0, $8BtP9._)(an, [
        {
            key: "isEmpty",
            get: /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ function get() {
                return this.toolsToBeDisplayed.length === 0;
            }
        },
        {
            /**
   * Returns root block settings element
   */ key: "getElement",
            value: function getElement() {
                return this.nodes.toolbox;
            }
        },
        {
            /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ key: "hasFocus",
            value: function hasFocus() {
                if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
            }
        },
        {
            /**
   * Destroy Module
   */ key: "destroy",
            value: function destroy() {
                var e;
                (0, $5LQ10._)((0, $2JFuQ._)(an.prototype), "destroy", this).call(this), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($e310f5997d90c4d6$var$G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($e310f5997d90c4d6$var$Te, this.handleMobileLayoutToggle);
            }
        },
        {
            /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ key: "toolButtonActivated",
            value: function toolButtonActivated(e, t1) {
                this.insertNewBlock(e, t1);
            }
        },
        {
            /**
   * Open Toolbox with Tools
   */ key: "open",
            value: function open() {
                var e;
                this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
            }
        },
        {
            /**
   * Close Toolbox
   */ key: "close",
            value: function close() {
                var e;
                (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
            }
        },
        {
            /**
   * Close Toolbox
   */ key: "toggle",
            value: function toggle() {
                this.opened ? this.close() : this.open();
            }
        },
        {
            /**
   * Creates toolbox popover and appends it inside wrapper element
   */ key: "initPopover",
            value: function initPopover() {
                var t1;
                var e = $e310f5997d90c4d6$var$be() ? $e310f5997d90c4d6$var$nn : $e310f5997d90c4d6$var$Bt;
                this.popover = new e({
                    scopeElement: this.api.ui.nodes.redactor,
                    searchable: !0,
                    messages: {
                        nothingFound: this.i18nLabels.nothingFound,
                        search: this.i18nLabels.filter
                    },
                    items: this.toolboxItemsToBeDisplayed
                }), this.popover.on($e310f5997d90c4d6$var$G.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
            }
        },
        {
            /**
   * Destroys popover instance and removes it from DOM
   */ key: "destroyPopover",
            value: function destroyPopover() {
                this.popover !== null && (this.popover.hide(), this.popover.off($e310f5997d90c4d6$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
            }
        },
        {
            key: "toolsToBeDisplayed",
            get: function get() {
                var e = [];
                return this.tools.forEach(function(t1) {
                    t1.toolbox && e.push(t1);
                }), e;
            }
        },
        {
            key: "toolboxItemsToBeDisplayed",
            get: function get() {
                var _this = this;
                var e = function(t1, o) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                    return {
                        icon: t1.icon,
                        title: $e310f5997d90c4d6$var$z.t($e310f5997d90c4d6$var$K.toolNames, t1.title || $e310f5997d90c4d6$var$je(o.name)),
                        name: o.name,
                        onActivate: function() {
                            _this.toolButtonActivated(o.name, t1.data);
                        },
                        secondaryLabel: o.shortcut && i ? $e310f5997d90c4d6$var$vt(o.shortcut) : ""
                    };
                };
                return this.toolsToBeDisplayed.reduce(function(t1, o) {
                    return Array.isArray(o.toolbox) ? o.toolbox.forEach(function(i, s) {
                        t1.push(e(i, o, s === 0));
                    }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1;
                }, []);
            }
        },
        {
            /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ key: "enableShortcuts",
            value: function enableShortcuts() {
                var _this = this;
                this.toolsToBeDisplayed.forEach(function(e) {
                    var t1 = e.shortcut;
                    t1 && _this.enableShortcutForTool(e.name, t1);
                });
            }
        },
        {
            /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ key: "enableShortcutForTool",
            value: function enableShortcutForTool(e, t1) {
                var _this = this;
                $e310f5997d90c4d6$var$ge.add({
                    name: t1,
                    on: this.api.ui.nodes.redactor,
                    handler: function(o) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                            var i, s, r, e1;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        o.preventDefault();
                                        i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                                        if (!s) return [
                                            3,
                                            4
                                        ];
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            this.api.blocks.convert(s.id, e)
                                        ];
                                    case 2:
                                        r = _state.sent();
                                        this.api.caret.setToBlock(r, "end");
                                        return [
                                            2
                                        ];
                                    case 3:
                                        e1 = _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        this.insertNewBlock(e);
                                        return [
                                            2
                                        ];
                                }
                            });
                        }).call(_this);
                    }
                });
            }
        },
        {
            /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ key: "removeAllShortcuts",
            value: function removeAllShortcuts() {
                var _this = this;
                this.toolsToBeDisplayed.forEach(function(e) {
                    var t1 = e.shortcut;
                    t1 && $e310f5997d90c4d6$var$ge.remove(_this.api.ui.nodes.redactor, t1);
                });
            }
        },
        {
            key: "insertNewBlock",
            value: /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ function insertNewBlock(e, t1) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var o, i, s, r, l, a;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
                                if (!i) return [
                                    2
                                ];
                                s = i.isEmpty ? o : o + 1;
                                if (!t1) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.api.blocks.composeBlockData(e)
                                ];
                            case 1:
                                l = _state.sent();
                                r = Object.assign(l, t1);
                                _state.label = 2;
                            case 2:
                                a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
                                a.call($e310f5997d90c4d6$var$ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
                                    block: a
                                }), this.api.toolbar.close();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * CSS styles
   */ function get() {
                return {
                    toolbox: "ce-toolbox"
                };
            }
        }
    ]);
    return an;
}($e310f5997d90c4d6$var$Oe);
$e310f5997d90c4d6$var$rn([
    $e310f5997d90c4d6$var$me
], $e310f5997d90c4d6$var$Ct.prototype, "toolsToBeDisplayed", 1);
$e310f5997d90c4d6$var$rn([
    $e310f5997d90c4d6$var$me
], $e310f5997d90c4d6$var$Ct.prototype, "toolboxItemsToBeDisplayed", 1);
var $e310f5997d90c4d6$var$Es = $e310f5997d90c4d6$var$Ct;
var $e310f5997d90c4d6$var$ln = "block hovered";
function $e310f5997d90c4d6$var$xs(n, e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var t1, o;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t1 = navigator.keyboard;
                    if (!t1) return [
                        2,
                        e
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        t1.getLayoutMap()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().get(n) || e
                    ];
                case 3:
                    o = _state.sent();
                    return [
                        2,
                        (console.error(o), e)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $e310f5997d90c4d6$var$Bs = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Bs, E);
    function Bs(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $7lhcp._)(this, Bs);
        var _this;
        _this = (0, $07dqX._)(this, Bs, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.toolboxInstance = null;
        return _this;
    }
    (0, $8BtP9._)(Bs, [
        {
            key: "CSS",
            get: /**
   * CSS styles
   *
   * @returns {object}
   */ function get() {
                return {
                    toolbar: "ce-toolbar",
                    content: "ce-toolbar__content",
                    actions: "ce-toolbar__actions",
                    actionsOpened: "ce-toolbar__actions--opened",
                    toolbarOpened: "ce-toolbar--opened",
                    openedToolboxHolderModifier: "codex-editor--toolbox-opened",
                    plusButton: "ce-toolbar__plus",
                    plusButtonShortcut: "ce-toolbar__plus-shortcut",
                    settingsToggler: "ce-toolbar__settings-btn",
                    settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
                };
            }
        },
        {
            key: "opened",
            get: /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ function get() {
                return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
            }
        },
        {
            key: "toolbox",
            get: /**
   * Public interface for accessing the Toolbox
   */ function get() {
                var _this = this;
                var e;
                return {
                    opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
                    close: function() {
                        var t1;
                        (t1 = _this.toolboxInstance) == null || t1.close();
                    },
                    open: function() {
                        if (_this.toolboxInstance === null) {
                            $e310f5997d90c4d6$var$S("toolbox.open() called before initialization is finished", "warn");
                            return;
                        }
                        _this.Editor.BlockManager.currentBlock = _this.hoveredBlock, _this.toolboxInstance.open();
                    },
                    toggle: function() {
                        if (_this.toolboxInstance === null) {
                            $e310f5997d90c4d6$var$S("toolbox.toggle() called before initialization is finished", "warn");
                            return;
                        }
                        _this.toolboxInstance.toggle();
                    },
                    hasFocus: function() {
                        var t1;
                        return (t1 = _this.toolboxInstance) == null ? void 0 : t1.hasFocus();
                    }
                };
            }
        },
        {
            key: "blockActions",
            get: /**
   * Block actions appearance manipulations
   */ function get() {
                var _this = this;
                return {
                    hide: function() {
                        _this.nodes.actions.classList.remove(_this.CSS.actionsOpened);
                    },
                    show: function() {
                        _this.nodes.actions.classList.add(_this.CSS.actionsOpened);
                    }
                };
            }
        },
        {
            key: "blockTunesToggler",
            get: /**
   * Methods for working with Block Tunes toggler
   */ function get() {
                var _this = this;
                return {
                    hide: function() {
                        return _this.nodes.settingsToggler.classList.add(_this.CSS.settingsTogglerHidden);
                    },
                    show: function() {
                        return _this.nodes.settingsToggler.classList.remove(_this.CSS.settingsTogglerHidden);
                    }
                };
            }
        },
        {
            /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                var _this = this;
                e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(function() {
                    _this.drawUI(), _this.enableModuleBindings();
                }, {
                    timeout: 2e3
                });
            }
        },
        {
            /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ key: "moveAndOpen",
            value: function moveAndOpen() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.Editor.BlockManager.currentBlock;
                if (this.toolboxInstance === null) {
                    $e310f5997d90c4d6$var$S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
                    return;
                }
                if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
                this.hoveredBlock = e;
                var t1 = e.holder, _this_Editor_UI = this.Editor.UI, o = _this_Editor_UI.isMobile;
                var i;
                var s = 20, r = e.firstInput, a = t1.getBoundingClientRect(), l = r !== void 0 ? r.getBoundingClientRect() : null, c = l !== null ? l.top - a.top : null, d = c !== null ? c > s : void 0;
                if (o) i = t1.offsetTop + t1.offsetHeight;
                else if (r === void 0 || d) {
                    var h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
                    i = t1.offsetTop + h;
                } else {
                    var h1 = $e310f5997d90c4d6$var$li(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
                    i = t1.offsetTop + h1 - p + g + c;
                }
                this.nodes.wrapper.style.top = "".concat(Math.floor(i), "px"), this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
            }
        },
        {
            /**
   * Close the Toolbar
   */ key: "close",
            value: function close() {
                var e, t1;
                this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
            }
        },
        {
            /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ key: "reset",
            value: function reset() {
                this.nodes.wrapper.style.top = "unset";
            }
        },
        {
            /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ key: "open",
            value: function open() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
            }
        },
        {
            key: "make",
            value: /**
   * Draws Toolbar elements
   */ function make() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, e, t1, o, i;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                this.nodes.wrapper = $e310f5997d90c4d6$var$u.make("div", this.CSS.toolbar), [
                                    "content",
                                    "actions"
                                ].forEach(function(s) {
                                    _this.nodes[s] = $e310f5997d90c4d6$var$u.make("div", _this.CSS[s]);
                                }), $e310f5997d90c4d6$var$u.append(this.nodes.wrapper, this.nodes.content), $e310f5997d90c4d6$var$u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $e310f5997d90c4d6$var$u.make("div", this.CSS.plusButton, {
                                    innerHTML: $e310f5997d90c4d6$var$ts
                                }), $e310f5997d90c4d6$var$u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", function() {
                                    $e310f5997d90c4d6$var$$e(!0), _this.plusButtonClicked();
                                }, !1);
                                e = $e310f5997d90c4d6$var$u.make("div");
                                e.appendChild(document.createTextNode($e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($e310f5997d90c4d6$var$u.make("div", this.CSS.plusButtonShortcut, {
                                    textContent: "/"
                                })), $e310f5997d90c4d6$var$ze(this.nodes.plusButton, e, {
                                    hidingDelay: 400
                                }), this.nodes.settingsToggler = $e310f5997d90c4d6$var$u.make("span", this.CSS.settingsToggler, {
                                    innerHTML: $e310f5997d90c4d6$var$es
                                }), $e310f5997d90c4d6$var$u.append(this.nodes.actions, this.nodes.settingsToggler);
                                t1 = $e310f5997d90c4d6$var$u.make("div"), o = $e310f5997d90c4d6$var$u.text($e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.blockTunes.toggler, "Click to tune"));
                                return [
                                    4,
                                    $e310f5997d90c4d6$var$xs("Slash", "/")
                                ];
                            case 1:
                                i = _state.sent();
                                t1.appendChild(o), t1.appendChild($e310f5997d90c4d6$var$u.make("div", this.CSS.plusButtonShortcut, {
                                    textContent: $e310f5997d90c4d6$var$vt("CMD + ".concat(i))
                                })), $e310f5997d90c4d6$var$ze(this.nodes.settingsToggler, t1, {
                                    hidingDelay: 400
                                }), $e310f5997d90c4d6$var$u.append(this.nodes.actions, this.makeToolbox()), $e310f5997d90c4d6$var$u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $e310f5997d90c4d6$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Creates the Toolbox instance and return it's rendered element
   */ key: "makeToolbox",
            value: function makeToolbox() {
                var _this = this;
                return this.toolboxInstance = new $e310f5997d90c4d6$var$Es({
                    api: this.Editor.API.methods,
                    tools: this.Editor.Tools.blockTools,
                    i18nLabels: {
                        filter: $e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.popover, "Filter"),
                        nothingFound: $e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.popover, "Nothing found")
                    }
                }), this.toolboxInstance.on($e310f5997d90c4d6$var$Le.Opened, function() {
                    _this.Editor.UI.nodes.wrapper.classList.add(_this.CSS.openedToolboxHolderModifier);
                }), this.toolboxInstance.on($e310f5997d90c4d6$var$Le.Closed, function() {
                    _this.Editor.UI.nodes.wrapper.classList.remove(_this.CSS.openedToolboxHolderModifier);
                }), this.toolboxInstance.on($e310f5997d90c4d6$var$Le.BlockAdded, function(param) {
                    var e = param.block;
                    var _this_Editor = _this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = t1.getBlockById(e.id);
                    i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
                }), this.toolboxInstance.getElement();
            }
        },
        {
            /**
   * Handler for Plus Button
   */ key: "plusButtonClicked",
            value: function plusButtonClicked() {
                var e;
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
            }
        },
        {
            /**
   * Enable bindings
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", function(e) {
                    var t1;
                    e.stopPropagation(), _this.settingsTogglerClicked(), (t1 = _this.toolboxInstance) != null && t1.opened && _this.toolboxInstance.close(), $e310f5997d90c4d6$var$$e(!0);
                }, !0), $e310f5997d90c4d6$var$be() || this.eventsDispatcher.on($e310f5997d90c4d6$var$ln, function(e) {
                    var t1;
                    _this.Editor.BlockSettings.opened || (t1 = _this.toolboxInstance) != null && t1.opened || _this.moveAndOpen(e.block);
                });
            }
        },
        {
            /**
   * Disable bindings
   */ key: "disableModuleBindings",
            value: function disableModuleBindings() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            /**
   * Clicks on the Block Settings toggler
   */ key: "settingsTogglerClicked",
            value: function settingsTogglerClicked() {
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
            }
        },
        {
            /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ key: "drawUI",
            value: function drawUI() {
                this.Editor.BlockSettings.make(), this.make();
            }
        },
        {
            /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ key: "destroy",
            value: function destroy() {
                this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
            }
        }
    ]);
    return Bs;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$ae = /* @__PURE__ */ function(n) {
    return n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n;
}($e310f5997d90c4d6$var$ae || {}), $e310f5997d90c4d6$var$Pe = /* @__PURE__ */ function(n) {
    return n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n;
}($e310f5997d90c4d6$var$Pe || {}), $e310f5997d90c4d6$var$cn = /* @__PURE__ */ function(n) {
    return n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n;
}($e310f5997d90c4d6$var$cn || {}), $e310f5997d90c4d6$var$pe = /* @__PURE__ */ function(n) {
    return n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n;
}($e310f5997d90c4d6$var$pe || {}), $e310f5997d90c4d6$var$We = /* @__PURE__ */ function(n) {
    return n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n;
}($e310f5997d90c4d6$var$We || {}), $e310f5997d90c4d6$var$mt = /* @__PURE__ */ function(n) {
    return n.IsTune = "isTune", n;
}($e310f5997d90c4d6$var$mt || {});
var $e310f5997d90c4d6$var$Tt = /*#__PURE__*/ function() {
    "use strict";
    function Tt(param) {
        var e = param.name, t1 = param.constructable, o = param.config, i = param.api, s = param.isDefault, tmp = param.isInternal, r = tmp === void 0 ? !1 : tmp, a = param.defaultPlaceholder;
        (0, $7lhcp._)(this, Tt);
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
    }
    (0, $8BtP9._)(Tt, [
        {
            key: "settings",
            get: /**
   * Returns Tool user configuration
   */ function get() {
                var e = this.config.config || {};
                return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
            }
        },
        {
            /**
   * Calls Tool's reset method
   */ key: "reset",
            value: function reset() {
                if ($e310f5997d90c4d6$var$A(this.constructable.reset)) return this.constructable.reset();
            }
        },
        {
            /**
   * Calls Tool's prepare method
   */ key: "prepare",
            value: function prepare() {
                if ($e310f5997d90c4d6$var$A(this.constructable.prepare)) return this.constructable.prepare({
                    toolName: this.name,
                    config: this.settings
                });
            }
        },
        {
            key: "shortcut",
            get: /**
   * Returns shortcut for Tool (internal or specified by user)
   */ function get() {
                var e = this.constructable.shortcut;
                return this.config.shortcut || e;
            }
        },
        {
            key: "sanitizeConfig",
            get: /**
   * Returns Tool's sanitizer configuration
   */ function get() {
                return this.constructable.sanitize || {};
            }
        },
        {
            /**
   * Returns true if Tools is inline
   */ key: "isInline",
            value: function isInline() {
                return this.type === $e310f5997d90c4d6$var$ae.Inline;
            }
        },
        {
            /**
   * Returns true if Tools is block
   */ key: "isBlock",
            value: function isBlock() {
                return this.type === $e310f5997d90c4d6$var$ae.Block;
            }
        },
        {
            /**
   * Returns true if Tools is tune
   */ key: "isTune",
            value: function isTune() {
                return this.type === $e310f5997d90c4d6$var$ae.Tune;
            }
        }
    ]);
    return Tt;
}();
var $e310f5997d90c4d6$var$Cs = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Cs, E);
    function Cs(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $7lhcp._)(this, Cs);
        var _this;
        _this = (0, $07dqX._)(this, Cs, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, _this.opened = !1, _this.popover = null, _this.toolbarVerticalMargin = $e310f5997d90c4d6$var$be() ? 20 : 6, _this.tools = /* @__PURE__ */ new Map(), window.requestIdleCallback(function() {
            _this.make();
        }, {
            timeout: 2e3
        });
        return _this;
    }
    (0, $8BtP9._)(Cs, [
        {
            key: "tryToShow",
            value: /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ function tryToShow() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var e, _tmp;
                    var _arguments = arguments;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !1;
                                e && this.close();
                                _tmp = this.allowedToShow();
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.open()
                                ];
                            case 1:
                                _tmp = (_state.sent(), this.Editor.Toolbar.close());
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Hides Inline Toolbar
   */ key: "close",
            value: function close() {
                var e, t1;
                if (this.opened) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.tools[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $leE2g._)(_step.value, 2), o = _step_value[0], i = _step_value[1];
                            var s = this.getToolShortcut(o.name);
                            s !== void 0 && $e310f5997d90c4d6$var$ge.remove(this.Editor.UI.nodes.redactor, s), $e310f5997d90c4d6$var$A(i.clear) && i.clear();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.tools = /* @__PURE__ */ new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null;
                }
            }
        },
        {
            /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ key: "containsNode",
            value: function containsNode(e) {
                return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
            }
        },
        {
            /**
   * Removes UI and its components
   */ key: "destroy",
            value: function destroy() {
                var e;
                this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
            }
        },
        {
            /**
   * Making DOM
   */ key: "make",
            value: function make() {
                this.nodes.wrapper = $e310f5997d90c4d6$var$u.make("div", [
                    this.CSS.inlineToolbar
                ].concat((0, $fsSDT._)(this.isRtl ? [
                    this.Editor.UI.CSS.editorRtlFix
                ] : []))), $e310f5997d90c4d6$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
            }
        },
        {
            key: "open",
            value: /**
   * Shows Inline Toolbar
   */ function open() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var t1, e;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.opened) return [
                                    2
                                ];
                                this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
                                return [
                                    4,
                                    this.getPopoverItems()
                                ];
                            case 1:
                                e = _state.sent();
                                this.popover = new $e310f5997d90c4d6$var$hs({
                                    items: e,
                                    scopeElement: this.Editor.API.methods.ui.nodes.redactor,
                                    messages: {
                                        nothingFound: $e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.popover, "Nothing found"),
                                        search: $e310f5997d90c4d6$var$z.ui($e310f5997d90c4d6$var$K.ui.popover, "Filter")
                                    }
                                }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ key: "move",
            value: function move(e) {
                var t1 = $e310f5997d90c4d6$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
                    x: t1.x - o.x,
                    y: t1.y + t1.height - // + window.scrollY
                    o.top + this.toolbarVerticalMargin
                };
                i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
            }
        },
        {
            /**
   * Clear orientation classes and reset position
   */ key: "reset",
            value: function reset() {
                this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
            }
        },
        {
            /**
   * Need to show Inline Toolbar or not
   */ key: "allowedToShow",
            value: function allowedToShow() {
                var e = [
                    "IMG",
                    "INPUT"
                ], t1 = $e310f5997d90c4d6$var$b.get(), o = $e310f5997d90c4d6$var$b.text;
                if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
                var i = $e310f5997d90c4d6$var$u.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
                if (i === null || t1 !== null && e.includes(i.tagName)) return !1;
                var s = this.Editor.BlockManager.getBlock(t1.anchorNode);
                return !s || this.getTools().some(function(c) {
                    return s.tool.inlineTools.has(c.name);
                }) === !1 ? !1 : i.closest("[contenteditable]") !== null;
            }
        },
        {
            /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns tools that are available for current block
   *
   * Used to check if Inline Toolbar could be shown
   * and to render tools in the Inline Toolbar
   */ key: "getTools",
            value: function getTools() {
                var _this = this;
                var e = this.Editor.BlockManager.currentBlock;
                return e ? Array.from(e.tool.inlineTools.values()).filter(function(o) {
                    return !(_this.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0);
                }) : [];
            }
        },
        {
            /**
   * Constructs tools instances and saves them to this.tools
   */ key: "createToolsInstances",
            value: function createToolsInstances() {
                var _this = this;
                this.tools = /* @__PURE__ */ new Map(), this.getTools().forEach(function(t1) {
                    var o = t1.create();
                    _this.tools.set(t1, o);
                });
            }
        },
        {
            key: "getPopoverItems",
            value: /**
   * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
   */ function getPopoverItems() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, e, t1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this1, _loop, _iterator, _step, err;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                e = [];
                                t1 = 0;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _loop = function() {
                                    var _step_value, o, i, s, r, a, l;
                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _step_value = (0, $leE2g._)(_step.value, 2), o = _step_value[0], i = _step_value[1];
                                                return [
                                                    4,
                                                    i.render()
                                                ];
                                            case 1:
                                                s = _state.sent(), r = _this1.getToolShortcut(o.name);
                                                if (r !== void 0) try {
                                                    _this1.enableShortcuts(o.name, r);
                                                } catch (e) {}
                                                a = r !== void 0 ? $e310f5997d90c4d6$var$vt(r) : void 0, l = $e310f5997d90c4d6$var$z.t($e310f5997d90c4d6$var$K.toolNames, o.title || $e310f5997d90c4d6$var$je(o.name));
                                                [
                                                    s
                                                ].flat().forEach(function(c) {
                                                    var h, p;
                                                    var d = {
                                                        name: o.name,
                                                        onActivate: function() {
                                                            _this.toolClicked(i);
                                                        },
                                                        hint: {
                                                            title: l,
                                                            description: a
                                                        }
                                                    };
                                                    if ($e310f5997d90c4d6$var$u.isElement(c)) {
                                                        var g = (0, $ctBui._)((0, $6GCxi._)({}, d), {
                                                            element: c,
                                                            type: $e310f5997d90c4d6$var$_.Html
                                                        });
                                                        if ($e310f5997d90c4d6$var$A(i.renderActions)) {
                                                            var f = i.renderActions();
                                                            g.children = {
                                                                isOpen: (h = i.checkState) == null ? void 0 : h.call(i, $e310f5997d90c4d6$var$b.get()),
                                                                /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                                                                items: [
                                                                    {
                                                                        type: $e310f5997d90c4d6$var$_.Html,
                                                                        element: f
                                                                    }
                                                                ]
                                                            };
                                                        } else (p = i.checkState) == null || p.call(i, $e310f5997d90c4d6$var$b.get());
                                                        e.push(g);
                                                    } else if (c.type === $e310f5997d90c4d6$var$_.Html) e.push((0, $ctBui._)((0, $6GCxi._)({}, d, c), {
                                                        type: $e310f5997d90c4d6$var$_.Html
                                                    }));
                                                    else if (c.type === $e310f5997d90c4d6$var$_.Separator) e.push({
                                                        type: $e310f5997d90c4d6$var$_.Separator
                                                    });
                                                    else {
                                                        var g1 = (0, $ctBui._)((0, $6GCxi._)({}, d, c), {
                                                            type: $e310f5997d90c4d6$var$_.Default
                                                        });
                                                        "children" in g1 && t1 !== 0 && e.push({
                                                            type: $e310f5997d90c4d6$var$_.Separator
                                                        }), e.push(g1), "children" in g1 && t1 < _this.tools.size - 1 && e.push({
                                                            type: $e310f5997d90c4d6$var$_.Separator
                                                        });
                                                    }
                                                }), t1++;
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = this.tools[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                _this1 = this;
                                return [
                                    5,
                                    (0, $Csf8W.__values)(_loop())
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ key: "getToolShortcut",
            value: function getToolShortcut(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.Tools, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
                return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$e310f5997d90c4d6$var$cn.Shortcut] : o == null ? void 0 : o.shortcut;
            }
        },
        {
            /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ key: "enableShortcuts",
            value: function enableShortcuts(e, t1) {
                var _this = this;
                $e310f5997d90c4d6$var$ge.add({
                    name: t1,
                    handler: function(o) {
                        var s;
                        var _this_Editor_BlockManager = _this.Editor.BlockManager, i = _this_Editor_BlockManager.currentBlock;
                        i && i.tool.enabledInlineTools && (o.preventDefault(), (s = _this.popover) == null || s.activateItemByName(e));
                    },
                    /**
       * We need to bind shortcut to the document to make it work in read-only mode
       */ on: document
                });
            }
        },
        {
            /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ key: "toolClicked",
            value: function toolClicked(e) {
                var o;
                var t1 = $e310f5997d90c4d6$var$b.range;
                (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
            }
        },
        {
            /**
   * Check Tools` state by selection
   */ key: "checkToolsState",
            value: function checkToolsState() {
                var e;
                (e = this.tools) == null || e.forEach(function(t1) {
                    var o;
                    (o = t1.checkState) == null || o.call(t1, $e310f5997d90c4d6$var$b.get());
                });
            }
        },
        {
            key: "inlineTools",
            get: /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ function get() {
                var e = {};
                return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[0], o = _param[1];
                    e[t1] = o.create();
                }), e;
            }
        }
    ]);
    return Cs;
}($e310f5997d90c4d6$var$E);
function $e310f5997d90c4d6$var$dn() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $e310f5997d90c4d6$var$un(n, e, t1, o) {
    var i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    var s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    var a = r.textContent || "";
    return $e310f5997d90c4d6$var$ai(a);
}
function $e310f5997d90c4d6$var$Ne(n) {
    var e = $e310f5997d90c4d6$var$u.getDeepestNode(n);
    if (e === null || $e310f5997d90c4d6$var$u.isEmpty(n)) return !0;
    if ($e310f5997d90c4d6$var$u.isNativeInput(e)) return e.selectionEnd === 0;
    if ($e310f5997d90c4d6$var$u.isEmpty(n)) return !0;
    var _dn = (0, $leE2g._)($e310f5997d90c4d6$var$dn(), 2), t1 = _dn[0], o = _dn[1];
    return t1 === null ? !1 : $e310f5997d90c4d6$var$un(n, t1, o, "left");
}
function $e310f5997d90c4d6$var$Re(n) {
    var e = $e310f5997d90c4d6$var$u.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($e310f5997d90c4d6$var$u.isNativeInput(e)) return e.selectionEnd === e.value.length;
    var _dn = (0, $leE2g._)($e310f5997d90c4d6$var$dn(), 2), t1 = _dn[0], o = _dn[1];
    return t1 === null ? !1 : $e310f5997d90c4d6$var$un(n, t1, o, "right");
}
var $e310f5997d90c4d6$var$hn = {}, $e310f5997d90c4d6$var$St = {}, $e310f5997d90c4d6$var$Xe = {}, $e310f5997d90c4d6$var$de = {}, $e310f5997d90c4d6$var$It = {}, $e310f5997d90c4d6$var$Ot = {};
Object.defineProperty($e310f5997d90c4d6$var$Ot, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Ot.allInputsSelector = $e310f5997d90c4d6$var$Ts;
function $e310f5997d90c4d6$var$Ts() {
    var n = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + n.map(function(e) {
        return 'input[type="'.concat(e, '"]');
    }).join(", ");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.allInputsSelector = void 0;
    var e = $e310f5997d90c4d6$var$Ot;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return e.allInputsSelector;
        }
    });
})($e310f5997d90c4d6$var$It);
var $e310f5997d90c4d6$var$ue = {}, $e310f5997d90c4d6$var$_t = {};
Object.defineProperty($e310f5997d90c4d6$var$_t, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$_t.isNativeInput = $e310f5997d90c4d6$var$Ss;
function $e310f5997d90c4d6$var$Ss(n) {
    var e = [
        "INPUT",
        "TEXTAREA"
    ];
    return n && n.tagName ? e.includes(n.tagName) : !1;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNativeInput = void 0;
    var e = $e310f5997d90c4d6$var$_t;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return e.isNativeInput;
        }
    });
})($e310f5997d90c4d6$var$ue);
var $e310f5997d90c4d6$var$pn = {}, $e310f5997d90c4d6$var$Mt = {};
Object.defineProperty($e310f5997d90c4d6$var$Mt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Mt.append = $e310f5997d90c4d6$var$Is;
function $e310f5997d90c4d6$var$Is(n, e) {
    Array.isArray(e) ? e.forEach(function(t1) {
        n.appendChild(t1);
    }) : n.appendChild(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.append = void 0;
    var e = $e310f5997d90c4d6$var$Mt;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function get() {
            return e.append;
        }
    });
})($e310f5997d90c4d6$var$pn);
var $e310f5997d90c4d6$var$At = {}, $e310f5997d90c4d6$var$Lt = {};
Object.defineProperty($e310f5997d90c4d6$var$Lt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Lt.blockElements = $e310f5997d90c4d6$var$Os;
function $e310f5997d90c4d6$var$Os() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.blockElements = void 0;
    var e = $e310f5997d90c4d6$var$Lt;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function get() {
            return e.blockElements;
        }
    });
})($e310f5997d90c4d6$var$At);
var $e310f5997d90c4d6$var$fn = {}, $e310f5997d90c4d6$var$Pt = {};
Object.defineProperty($e310f5997d90c4d6$var$Pt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Pt.calculateBaseline = $e310f5997d90c4d6$var$_s;
function $e310f5997d90c4d6$var$_s(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2, c = r + s + i + l + a;
    return c;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.calculateBaseline = void 0;
    var e = $e310f5997d90c4d6$var$Pt;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return e.calculateBaseline;
        }
    });
})($e310f5997d90c4d6$var$fn);
var $e310f5997d90c4d6$var$gn = {}, $e310f5997d90c4d6$var$Nt = {}, $e310f5997d90c4d6$var$Rt = {}, $e310f5997d90c4d6$var$Dt = {};
Object.defineProperty($e310f5997d90c4d6$var$Dt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Dt.isContentEditable = $e310f5997d90c4d6$var$Ms;
function $e310f5997d90c4d6$var$Ms(n) {
    return n.contentEditable === "true";
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isContentEditable = void 0;
    var e = $e310f5997d90c4d6$var$Dt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return e.isContentEditable;
        }
    });
})($e310f5997d90c4d6$var$Rt);
Object.defineProperty($e310f5997d90c4d6$var$Nt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Nt.canSetCaret = $e310f5997d90c4d6$var$Ps;
var $e310f5997d90c4d6$var$As = $e310f5997d90c4d6$var$ue, $e310f5997d90c4d6$var$Ls = $e310f5997d90c4d6$var$Rt;
function $e310f5997d90c4d6$var$Ps(n) {
    var e = !0;
    if ((0, $e310f5997d90c4d6$var$As.isNativeInput)(n)) switch(n.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            e = !1;
            break;
    }
    else e = (0, $e310f5997d90c4d6$var$Ls.isContentEditable)(n);
    return e;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.canSetCaret = void 0;
    var e = $e310f5997d90c4d6$var$Nt;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return e.canSetCaret;
        }
    });
})($e310f5997d90c4d6$var$gn);
var $e310f5997d90c4d6$var$Ve = {}, $e310f5997d90c4d6$var$Ft = {};
function $e310f5997d90c4d6$var$Ns(n, e, t1) {
    var o = t1.value !== void 0 ? "value" : "get", i = t1[o], s = "#".concat(e, "Cache");
    if (t1[o] = function() {
        for(var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++){
            r[_key] = arguments[_key];
        }
        return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
    }, o === "get" && t1.set) {
        var r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
function $e310f5997d90c4d6$var$mn() {
    var n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find(function(t1) {
        return window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1;
    });
    return e !== void 0 && (n[e] = !0), n;
}
function $e310f5997d90c4d6$var$jt(n) {
    return n != null && n !== "" && ((typeof n === "undefined" ? "undefined" : (0, $5f0Cq._)(n)) != "object" || Object.keys(n).length > 0);
}
function $e310f5997d90c4d6$var$Rs(n) {
    return !$e310f5997d90c4d6$var$jt(n);
}
var $e310f5997d90c4d6$var$Ds = function() {
    return (typeof window === "undefined" ? "undefined" : (0, $5f0Cq._)(window)) < "u" && window.navigator !== null && $e310f5997d90c4d6$var$jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
};
function $e310f5997d90c4d6$var$Fs(n) {
    var e = $e310f5997d90c4d6$var$mn();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $e310f5997d90c4d6$var$js(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $e310f5997d90c4d6$var$Hs(n) {
    var e = document.createElement("div");
    e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
    var t1 = window.getSelection(), o = document.createRange();
    if (o.selectNode(e), t1 === null) throw new Error("Cannot copy text to clipboard");
    t1.removeAllRanges(), t1.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}
function $e310f5997d90c4d6$var$$s(n, e, t1) {
    var _this = this;
    var o;
    return function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        var s = _this, r = function() {
            o = void 0, t1 !== !0 && n.apply(s, i);
        }, a = t1 === !0 && o !== void 0;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $e310f5997d90c4d6$var$oe(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $e310f5997d90c4d6$var$zs(n) {
    return $e310f5997d90c4d6$var$oe(n) === "boolean";
}
function $e310f5997d90c4d6$var$bn(n) {
    return $e310f5997d90c4d6$var$oe(n) === "function" || $e310f5997d90c4d6$var$oe(n) === "asyncfunction";
}
function $e310f5997d90c4d6$var$Us(n) {
    return $e310f5997d90c4d6$var$bn(n) && /^\s*class\s+/.test(n.toString());
}
function $e310f5997d90c4d6$var$Ws(n) {
    return $e310f5997d90c4d6$var$oe(n) === "number";
}
function $e310f5997d90c4d6$var$De(n) {
    return $e310f5997d90c4d6$var$oe(n) === "object";
}
function $e310f5997d90c4d6$var$Ys(n) {
    return Promise.resolve(n) === n;
}
function $e310f5997d90c4d6$var$Ks(n) {
    return $e310f5997d90c4d6$var$oe(n) === "string";
}
function $e310f5997d90c4d6$var$Xs(n) {
    return $e310f5997d90c4d6$var$oe(n) === "undefined";
}
function $e310f5997d90c4d6$var$bt(n) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    if (!e.length) return n;
    var t1 = e.shift();
    if ($e310f5997d90c4d6$var$De(n) && $e310f5997d90c4d6$var$De(t1)) for(var o in t1)$e310f5997d90c4d6$var$De(t1[o]) ? (n[o] === void 0 && Object.assign(n, (0, $5RfYb._)({}, o, {})), $e310f5997d90c4d6$var$bt(n[o], t1[o])) : Object.assign(n, (0, $5RfYb._)({}, o, t1[o]));
    return $e310f5997d90c4d6$var$bt.apply(void 0, [
        n
    ].concat((0, $fsSDT._)(e)));
}
function $e310f5997d90c4d6$var$Vs(n, e, t1) {
    var o = "\xab".concat(e, "\xbb is deprecated and will be removed in the next major release. Please use the \xab").concat(t1, "\xbb instead.");
    n && console.warn(o);
}
function $e310f5997d90c4d6$var$qs(n) {
    try {
        return new URL(n).href;
    } catch (e) {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $e310f5997d90c4d6$var$Zs(n) {
    return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}
var $e310f5997d90c4d6$var$Gs = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $e310f5997d90c4d6$var$Qs = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
var $e310f5997d90c4d6$var$Js = /*#__PURE__*/ function() {
    "use strict";
    function Js() {
        (0, $7lhcp._)(this, Js);
        this.completed = Promise.resolve();
    }
    (0, $8BtP9._)(Js, [
        {
            /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ key: "add",
            value: function add(e) {
                var _this = this;
                return new Promise(function(t1, o) {
                    _this.completed = _this.completed.then(e).then(t1).catch(o);
                });
            }
        }
    ]);
    return Js;
}();
function $e310f5997d90c4d6$var$er(n, e, t1) {
    var o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    var l = function l() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
    };
    return function() {
        var c = Date.now();
        !a && t1.leading === !1 && (a = c);
        var d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
var $e310f5997d90c4d6$var$tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $e310f5997d90c4d6$var$Js,
    beautifyShortcut: $e310f5997d90c4d6$var$Fs,
    cacheable: $e310f5997d90c4d6$var$Ns,
    capitalize: $e310f5997d90c4d6$var$js,
    copyTextToClipboard: $e310f5997d90c4d6$var$Hs,
    debounce: $e310f5997d90c4d6$var$$s,
    deepMerge: $e310f5997d90c4d6$var$bt,
    deprecationAssert: $e310f5997d90c4d6$var$Vs,
    getUserOS: $e310f5997d90c4d6$var$mn,
    getValidUrl: $e310f5997d90c4d6$var$qs,
    isBoolean: $e310f5997d90c4d6$var$zs,
    isClass: $e310f5997d90c4d6$var$Us,
    isEmpty: $e310f5997d90c4d6$var$Rs,
    isFunction: $e310f5997d90c4d6$var$bn,
    isIosDevice: $e310f5997d90c4d6$var$Ds,
    isNumber: $e310f5997d90c4d6$var$Ws,
    isObject: $e310f5997d90c4d6$var$De,
    isPrintableKey: $e310f5997d90c4d6$var$Zs,
    isPromise: $e310f5997d90c4d6$var$Ys,
    isString: $e310f5997d90c4d6$var$Ks,
    isUndefined: $e310f5997d90c4d6$var$Xs,
    keyCodes: $e310f5997d90c4d6$var$Gs,
    mouseButtons: $e310f5997d90c4d6$var$Qs,
    notEmpty: $e310f5997d90c4d6$var$jt,
    throttle: $e310f5997d90c4d6$var$er,
    typeOf: $e310f5997d90c4d6$var$oe
}, Symbol.toStringTag, {
    value: "Module"
})), $e310f5997d90c4d6$var$Ht = /* @__PURE__ */ $e310f5997d90c4d6$var$Xn($e310f5997d90c4d6$var$tr);
Object.defineProperty($e310f5997d90c4d6$var$Ft, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Ft.containsOnlyInlineElements = $e310f5997d90c4d6$var$ir;
var $e310f5997d90c4d6$var$or = $e310f5997d90c4d6$var$Ht, $e310f5997d90c4d6$var$nr = $e310f5997d90c4d6$var$At;
function $e310f5997d90c4d6$var$ir(n) {
    var e;
    (0, $e310f5997d90c4d6$var$or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;
    var t1 = function t2(o) {
        return !(0, $e310f5997d90c4d6$var$nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t1);
    };
    return Array.from(e.children).every(t1);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.containsOnlyInlineElements = void 0;
    var e = $e310f5997d90c4d6$var$Ft;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return e.containsOnlyInlineElements;
        }
    });
})($e310f5997d90c4d6$var$Ve);
var $e310f5997d90c4d6$var$vn = {}, $e310f5997d90c4d6$var$$t = {}, $e310f5997d90c4d6$var$qe = {}, $e310f5997d90c4d6$var$zt = {};
Object.defineProperty($e310f5997d90c4d6$var$zt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$zt.make = $e310f5997d90c4d6$var$sr;
function $e310f5997d90c4d6$var$sr(n, e, t1) {
    var o;
    e === void 0 && (e = null), t1 === void 0 && (t1 = {});
    var i = document.createElement(n);
    if (Array.isArray(e)) {
        var s = e.filter(function(a) {
            return a !== void 0;
        });
        (o = i.classList).add.apply(o, s);
    } else e !== null && i.classList.add(e);
    for(var r in t1)Object.prototype.hasOwnProperty.call(t1, r) && (i[r] = t1[r]);
    return i;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.make = void 0;
    var e = $e310f5997d90c4d6$var$zt;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function get() {
            return e.make;
        }
    });
})($e310f5997d90c4d6$var$qe);
Object.defineProperty($e310f5997d90c4d6$var$$t, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$$t.fragmentToString = $e310f5997d90c4d6$var$ar;
var $e310f5997d90c4d6$var$rr = $e310f5997d90c4d6$var$qe;
function $e310f5997d90c4d6$var$ar(n) {
    var e = (0, $e310f5997d90c4d6$var$rr.make)("div");
    return e.appendChild(n), e.innerHTML;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.fragmentToString = void 0;
    var e = $e310f5997d90c4d6$var$$t;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return e.fragmentToString;
        }
    });
})($e310f5997d90c4d6$var$vn);
var $e310f5997d90c4d6$var$kn = {}, $e310f5997d90c4d6$var$Ut = {};
Object.defineProperty($e310f5997d90c4d6$var$Ut, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Ut.getContentLength = $e310f5997d90c4d6$var$cr;
var $e310f5997d90c4d6$var$lr = $e310f5997d90c4d6$var$ue;
function $e310f5997d90c4d6$var$cr(n) {
    var e, t1;
    return (0, $e310f5997d90c4d6$var$lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t1 = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t1 !== void 0 ? t1 : 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContentLength = void 0;
    var e = $e310f5997d90c4d6$var$Ut;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return e.getContentLength;
        }
    });
})($e310f5997d90c4d6$var$kn);
var $e310f5997d90c4d6$var$Wt = {}, $e310f5997d90c4d6$var$Yt = {}, $e310f5997d90c4d6$var$Io = $e310f5997d90c4d6$var$Ce && $e310f5997d90c4d6$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($e310f5997d90c4d6$var$Yt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Yt.getDeepestBlockElements = $e310f5997d90c4d6$var$yn;
var $e310f5997d90c4d6$var$dr = $e310f5997d90c4d6$var$Ve;
function $e310f5997d90c4d6$var$yn(n) {
    return (0, $e310f5997d90c4d6$var$dr.containsOnlyInlineElements)(n) ? [
        n
    ] : Array.from(n.children).reduce(function(e, t1) {
        return $e310f5997d90c4d6$var$Io($e310f5997d90c4d6$var$Io([], e, !0), $e310f5997d90c4d6$var$yn(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestBlockElements = void 0;
    var e = $e310f5997d90c4d6$var$Yt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return e.getDeepestBlockElements;
        }
    });
})($e310f5997d90c4d6$var$Wt);
var $e310f5997d90c4d6$var$wn = {}, $e310f5997d90c4d6$var$Kt = {}, $e310f5997d90c4d6$var$Ze = {}, $e310f5997d90c4d6$var$Xt = {};
Object.defineProperty($e310f5997d90c4d6$var$Xt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Xt.isLineBreakTag = $e310f5997d90c4d6$var$ur;
function $e310f5997d90c4d6$var$ur(n) {
    return [
        "BR",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLineBreakTag = void 0;
    var e = $e310f5997d90c4d6$var$Xt;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return e.isLineBreakTag;
        }
    });
})($e310f5997d90c4d6$var$Ze);
var $e310f5997d90c4d6$var$Ge = {}, $e310f5997d90c4d6$var$Vt = {};
Object.defineProperty($e310f5997d90c4d6$var$Vt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Vt.isSingleTag = $e310f5997d90c4d6$var$hr;
function $e310f5997d90c4d6$var$hr(n) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isSingleTag = void 0;
    var e = $e310f5997d90c4d6$var$Vt;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return e.isSingleTag;
        }
    });
})($e310f5997d90c4d6$var$Ge);
Object.defineProperty($e310f5997d90c4d6$var$Kt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Kt.getDeepestNode = $e310f5997d90c4d6$var$En;
var $e310f5997d90c4d6$var$pr = $e310f5997d90c4d6$var$ue, $e310f5997d90c4d6$var$fr = $e310f5997d90c4d6$var$Ze, $e310f5997d90c4d6$var$gr = $e310f5997d90c4d6$var$Ge;
function $e310f5997d90c4d6$var$En(n, e) {
    e === void 0 && (e = !1);
    var t1 = e ? "lastChild" : "firstChild", o = e ? "previousSibling" : "nextSibling";
    if (n.nodeType === Node.ELEMENT_NODE && n[t1]) {
        var i = n[t1];
        if ((0, $e310f5997d90c4d6$var$gr.isSingleTag)(i) && !(0, $e310f5997d90c4d6$var$pr.isNativeInput)(i) && !(0, $e310f5997d90c4d6$var$fr.isLineBreakTag)(i)) {
            if (i[o]) i = i[o];
            else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];
            else return i.parentNode;
        }
        return $e310f5997d90c4d6$var$En(i, e);
    }
    return n;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestNode = void 0;
    var e = $e310f5997d90c4d6$var$Kt;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return e.getDeepestNode;
        }
    });
})($e310f5997d90c4d6$var$wn);
var $e310f5997d90c4d6$var$xn = {}, $e310f5997d90c4d6$var$qt = {}, $e310f5997d90c4d6$var$Me = $e310f5997d90c4d6$var$Ce && $e310f5997d90c4d6$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($e310f5997d90c4d6$var$qt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$qt.findAllInputs = $e310f5997d90c4d6$var$yr;
var $e310f5997d90c4d6$var$mr = $e310f5997d90c4d6$var$Ve, $e310f5997d90c4d6$var$br = $e310f5997d90c4d6$var$Wt, $e310f5997d90c4d6$var$vr = $e310f5997d90c4d6$var$It, $e310f5997d90c4d6$var$kr = $e310f5997d90c4d6$var$ue;
function $e310f5997d90c4d6$var$yr(n) {
    return Array.from(n.querySelectorAll((0, $e310f5997d90c4d6$var$vr.allInputsSelector)())).reduce(function(e, t1) {
        return (0, $e310f5997d90c4d6$var$kr.isNativeInput)(t1) || (0, $e310f5997d90c4d6$var$mr.containsOnlyInlineElements)(t1) ? $e310f5997d90c4d6$var$Me($e310f5997d90c4d6$var$Me([], e, !0), [
            t1
        ], !1) : $e310f5997d90c4d6$var$Me($e310f5997d90c4d6$var$Me([], e, !0), (0, $e310f5997d90c4d6$var$br.getDeepestBlockElements)(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.findAllInputs = void 0;
    var e = $e310f5997d90c4d6$var$qt;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return e.findAllInputs;
        }
    });
})($e310f5997d90c4d6$var$xn);
var $e310f5997d90c4d6$var$Bn = {}, $e310f5997d90c4d6$var$Zt = {};
Object.defineProperty($e310f5997d90c4d6$var$Zt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Zt.isCollapsedWhitespaces = $e310f5997d90c4d6$var$wr;
function $e310f5997d90c4d6$var$wr(n) {
    return !/[^\t\n\r ]/.test(n);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCollapsedWhitespaces = void 0;
    var e = $e310f5997d90c4d6$var$Zt;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return e.isCollapsedWhitespaces;
        }
    });
})($e310f5997d90c4d6$var$Bn);
var $e310f5997d90c4d6$var$Gt = {}, $e310f5997d90c4d6$var$Qt = {};
Object.defineProperty($e310f5997d90c4d6$var$Qt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Qt.isElement = $e310f5997d90c4d6$var$xr;
var $e310f5997d90c4d6$var$Er = $e310f5997d90c4d6$var$Ht;
function $e310f5997d90c4d6$var$xr(n) {
    return (0, $e310f5997d90c4d6$var$Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isElement = void 0;
    var e = $e310f5997d90c4d6$var$Qt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function get() {
            return e.isElement;
        }
    });
})($e310f5997d90c4d6$var$Gt);
var $e310f5997d90c4d6$var$Cn = {}, $e310f5997d90c4d6$var$Jt = {}, $e310f5997d90c4d6$var$eo = {}, $e310f5997d90c4d6$var$to = {};
Object.defineProperty($e310f5997d90c4d6$var$to, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$to.isLeaf = $e310f5997d90c4d6$var$Br;
function $e310f5997d90c4d6$var$Br(n) {
    return n === null ? !1 : n.childNodes.length === 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLeaf = void 0;
    var e = $e310f5997d90c4d6$var$to;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return e.isLeaf;
        }
    });
})($e310f5997d90c4d6$var$eo);
var $e310f5997d90c4d6$var$oo = {}, $e310f5997d90c4d6$var$no = {};
Object.defineProperty($e310f5997d90c4d6$var$no, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$no.isNodeEmpty = $e310f5997d90c4d6$var$Or;
var $e310f5997d90c4d6$var$Cr = $e310f5997d90c4d6$var$Ze, $e310f5997d90c4d6$var$Tr = $e310f5997d90c4d6$var$Gt, $e310f5997d90c4d6$var$Sr = $e310f5997d90c4d6$var$ue, $e310f5997d90c4d6$var$Ir = $e310f5997d90c4d6$var$Ge;
function $e310f5997d90c4d6$var$Or(n, e) {
    var t1 = "";
    return (0, $e310f5997d90c4d6$var$Ir.isSingleTag)(n) && !(0, $e310f5997d90c4d6$var$Cr.isLineBreakTag)(n) ? !1 : ((0, $e310f5997d90c4d6$var$Tr.isElement)(n) && (0, $e310f5997d90c4d6$var$Sr.isNativeInput)(n) ? t1 = n.value : n.textContent !== null && (t1 = n.textContent.replace("\u200B", "")), e !== void 0 && (t1 = t1.replace(new RegExp(e, "g"), "")), t1.trim().length === 0);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNodeEmpty = void 0;
    var e = $e310f5997d90c4d6$var$no;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return e.isNodeEmpty;
        }
    });
})($e310f5997d90c4d6$var$oo);
Object.defineProperty($e310f5997d90c4d6$var$Jt, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Jt.isEmpty = $e310f5997d90c4d6$var$Ar;
var $e310f5997d90c4d6$var$_r = $e310f5997d90c4d6$var$eo, $e310f5997d90c4d6$var$Mr = $e310f5997d90c4d6$var$oo;
function $e310f5997d90c4d6$var$Ar(n, e) {
    n.normalize();
    for(var t1 = [
        n
    ]; t1.length > 0;){
        var o = t1.shift();
        if (o) {
            if (n = o, (0, $e310f5997d90c4d6$var$_r.isLeaf)(n) && !(0, $e310f5997d90c4d6$var$Mr.isNodeEmpty)(n, e)) return !1;
            t1.push.apply(t1, Array.from(n.childNodes));
        }
    }
    return !0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isEmpty = void 0;
    var e = $e310f5997d90c4d6$var$Jt;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return e.isEmpty;
        }
    });
})($e310f5997d90c4d6$var$Cn);
var $e310f5997d90c4d6$var$Tn = {}, $e310f5997d90c4d6$var$io = {};
Object.defineProperty($e310f5997d90c4d6$var$io, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$io.isFragment = $e310f5997d90c4d6$var$Pr;
var $e310f5997d90c4d6$var$Lr = $e310f5997d90c4d6$var$Ht;
function $e310f5997d90c4d6$var$Pr(n) {
    return (0, $e310f5997d90c4d6$var$Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isFragment = void 0;
    var e = $e310f5997d90c4d6$var$io;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function get() {
            return e.isFragment;
        }
    });
})($e310f5997d90c4d6$var$Tn);
var $e310f5997d90c4d6$var$Sn = {}, $e310f5997d90c4d6$var$so = {};
Object.defineProperty($e310f5997d90c4d6$var$so, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$so.isHTMLString = $e310f5997d90c4d6$var$Rr;
var $e310f5997d90c4d6$var$Nr = $e310f5997d90c4d6$var$qe;
function $e310f5997d90c4d6$var$Rr(n) {
    var e = (0, $e310f5997d90c4d6$var$Nr.make)("div");
    return e.innerHTML = n, e.childElementCount > 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isHTMLString = void 0;
    var e = $e310f5997d90c4d6$var$so;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return e.isHTMLString;
        }
    });
})($e310f5997d90c4d6$var$Sn);
var $e310f5997d90c4d6$var$In = {}, $e310f5997d90c4d6$var$ro = {};
Object.defineProperty($e310f5997d90c4d6$var$ro, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$ro.offset = $e310f5997d90c4d6$var$Dr;
function $e310f5997d90c4d6$var$Dr(n) {
    var e = n.getBoundingClientRect(), t1 = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop, i = e.top + o, s = e.left + t1;
    return {
        top: i,
        left: s,
        bottom: i + e.height,
        right: s + e.width
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.offset = void 0;
    var e = $e310f5997d90c4d6$var$ro;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function get() {
            return e.offset;
        }
    });
})($e310f5997d90c4d6$var$In);
var $e310f5997d90c4d6$var$On = {}, $e310f5997d90c4d6$var$ao = {};
Object.defineProperty($e310f5997d90c4d6$var$ao, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$ao.prepend = $e310f5997d90c4d6$var$Fr;
function $e310f5997d90c4d6$var$Fr(n, e) {
    Array.isArray(e) ? (e = e.reverse(), e.forEach(function(t1) {
        return n.prepend(t1);
    })) : n.prepend(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = void 0;
    var e = $e310f5997d90c4d6$var$ao;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function get() {
            return e.prepend;
        }
    });
})($e310f5997d90c4d6$var$On);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
    var e = $e310f5997d90c4d6$var$It;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function get() {
            return e.allInputsSelector;
        }
    });
    var t1 = $e310f5997d90c4d6$var$ue;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function get() {
            return t1.isNativeInput;
        }
    });
    var o = $e310f5997d90c4d6$var$pn;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function get() {
            return o.append;
        }
    });
    var i = $e310f5997d90c4d6$var$At;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function get() {
            return i.blockElements;
        }
    });
    var s = $e310f5997d90c4d6$var$fn;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function get() {
            return s.calculateBaseline;
        }
    });
    var r = $e310f5997d90c4d6$var$gn;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function get() {
            return r.canSetCaret;
        }
    });
    var a = $e310f5997d90c4d6$var$Ve;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function get() {
            return a.containsOnlyInlineElements;
        }
    });
    var l = $e310f5997d90c4d6$var$vn;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function get() {
            return l.fragmentToString;
        }
    });
    var c = $e310f5997d90c4d6$var$kn;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function get() {
            return c.getContentLength;
        }
    });
    var d = $e310f5997d90c4d6$var$Wt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function get() {
            return d.getDeepestBlockElements;
        }
    });
    var h = $e310f5997d90c4d6$var$wn;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function get() {
            return h.getDeepestNode;
        }
    });
    var p = $e310f5997d90c4d6$var$xn;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function get() {
            return p.findAllInputs;
        }
    });
    var g = $e310f5997d90c4d6$var$Bn;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function get() {
            return g.isCollapsedWhitespaces;
        }
    });
    var f = $e310f5997d90c4d6$var$Rt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function get() {
            return f.isContentEditable;
        }
    });
    var v = $e310f5997d90c4d6$var$Gt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function get() {
            return v.isElement;
        }
    });
    var O = $e310f5997d90c4d6$var$Cn;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function get() {
            return O.isEmpty;
        }
    });
    var T = $e310f5997d90c4d6$var$Tn;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function get() {
            return T.isFragment;
        }
    });
    var M = $e310f5997d90c4d6$var$Sn;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function get() {
            return M.isHTMLString;
        }
    });
    var q = $e310f5997d90c4d6$var$eo;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function get() {
            return q.isLeaf;
        }
    });
    var F = $e310f5997d90c4d6$var$oo;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function get() {
            return F.isNodeEmpty;
        }
    });
    var H = $e310f5997d90c4d6$var$Ze;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function get() {
            return H.isLineBreakTag;
        }
    });
    var Q = $e310f5997d90c4d6$var$Ge;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function get() {
            return Q.isSingleTag;
        }
    });
    var ie = $e310f5997d90c4d6$var$qe;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function get() {
            return ie.make;
        }
    });
    var k = $e310f5997d90c4d6$var$In;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function get() {
            return k.offset;
        }
    });
    var m = $e310f5997d90c4d6$var$On;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function get() {
            return m.prepend;
        }
    });
})($e310f5997d90c4d6$var$de);
var $e310f5997d90c4d6$var$Qe = {};
Object.defineProperty($e310f5997d90c4d6$var$Qe, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Qe.getContenteditableSlice = $e310f5997d90c4d6$var$Hr;
var $e310f5997d90c4d6$var$jr = $e310f5997d90c4d6$var$de;
function $e310f5997d90c4d6$var$Hr(n, e, t1, o, i) {
    var s;
    i === void 0 && (i = !1);
    var r = document.createRange();
    if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t1)) : (r.setStart(e, t1), r.setEnd(n, n.childNodes.length)), i === !0) {
        var a = r.extractContents();
        return (0, $e310f5997d90c4d6$var$jr.fragmentToString)(a);
    }
    var l = r.cloneContents(), c = document.createElement("div");
    c.appendChild(l);
    var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
    return d;
}
Object.defineProperty($e310f5997d90c4d6$var$Xe, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Xe.checkContenteditableSliceForEmptiness = $e310f5997d90c4d6$var$Ur;
var $e310f5997d90c4d6$var$$r = $e310f5997d90c4d6$var$de, $e310f5997d90c4d6$var$zr = $e310f5997d90c4d6$var$Qe;
function $e310f5997d90c4d6$var$Ur(n, e, t1, o) {
    var i = (0, $e310f5997d90c4d6$var$zr.getContenteditableSlice)(n, e, t1, o);
    return (0, $e310f5997d90c4d6$var$$r.isCollapsedWhitespaces)(i);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.checkContenteditableSliceForEmptiness = void 0;
    var e = $e310f5997d90c4d6$var$Xe;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function get() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
})($e310f5997d90c4d6$var$St);
var $e310f5997d90c4d6$var$_n = {};
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContenteditableSlice = void 0;
    var e = $e310f5997d90c4d6$var$Qe;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function get() {
            return e.getContenteditableSlice;
        }
    });
})($e310f5997d90c4d6$var$_n);
var $e310f5997d90c4d6$var$Mn = {}, $e310f5997d90c4d6$var$lo = {};
Object.defineProperty($e310f5997d90c4d6$var$lo, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$lo.focus = $e310f5997d90c4d6$var$Yr;
var $e310f5997d90c4d6$var$Wr = $e310f5997d90c4d6$var$de;
function $e310f5997d90c4d6$var$Yr(n, e) {
    var t1, o;
    if (e === void 0 && (e = !0), (0, $e310f5997d90c4d6$var$Wr.isNativeInput)(n)) {
        n.focus();
        var i = e ? 0 : n.value.length;
        n.setSelectionRange(i, i);
    } else {
        var s = document.createRange(), r = window.getSelection();
        if (!r) return;
        var a = function a(p) {
            var g = document.createTextNode("");
            p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
        }, l = function l(p) {
            return p != null;
        }, c = n.childNodes, d = e ? c[0] : c[c.length - 1];
        if (l(d)) {
            for(; l(d) && d.nodeType !== Node.TEXT_NODE;)d = e ? d.firstChild : d.lastChild;
            if (l(d) && d.nodeType === Node.TEXT_NODE) {
                var h = (o = (t1 = d.textContent) === null || t1 === void 0 ? void 0 : t1.length) !== null && o !== void 0 ? o : 0, i = e ? 0 : h;
                s.setStart(d, i), s.setEnd(d, i);
            } else a(n);
        } else a(n);
        r.removeAllRanges(), r.addRange(s);
    }
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.focus = void 0;
    var e = $e310f5997d90c4d6$var$lo;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function get() {
            return e.focus;
        }
    });
})($e310f5997d90c4d6$var$Mn);
var $e310f5997d90c4d6$var$co = {}, $e310f5997d90c4d6$var$Je = {};
Object.defineProperty($e310f5997d90c4d6$var$Je, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$Je.getCaretNodeAndOffset = $e310f5997d90c4d6$var$Kr;
function $e310f5997d90c4d6$var$Kr() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] !== void 0 ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], e.textContent !== null && (t1 = e.textContent.length))), [
        e,
        t1
    ]);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getCaretNodeAndOffset = void 0;
    var e = $e310f5997d90c4d6$var$Je;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function get() {
            return e.getCaretNodeAndOffset;
        }
    });
})($e310f5997d90c4d6$var$co);
var $e310f5997d90c4d6$var$An = {}, $e310f5997d90c4d6$var$et = {};
Object.defineProperty($e310f5997d90c4d6$var$et, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$et.getRange = $e310f5997d90c4d6$var$Xr;
function $e310f5997d90c4d6$var$Xr() {
    var n = window.getSelection();
    return n && n.rangeCount ? n.getRangeAt(0) : null;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getRange = void 0;
    var e = $e310f5997d90c4d6$var$et;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function get() {
            return e.getRange;
        }
    });
})($e310f5997d90c4d6$var$An);
var $e310f5997d90c4d6$var$Ln = {}, $e310f5997d90c4d6$var$uo = {};
Object.defineProperty($e310f5997d90c4d6$var$uo, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$uo.isCaretAtEndOfInput = $e310f5997d90c4d6$var$Zr;
var $e310f5997d90c4d6$var$Oo = $e310f5997d90c4d6$var$de, $e310f5997d90c4d6$var$Vr = $e310f5997d90c4d6$var$co, $e310f5997d90c4d6$var$qr = $e310f5997d90c4d6$var$St;
function $e310f5997d90c4d6$var$Zr(n) {
    var e = (0, $e310f5997d90c4d6$var$Oo.getDeepestNode)(n, !0);
    if (e === null) return !0;
    if ((0, $e310f5997d90c4d6$var$Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
    var t1 = (0, $e310f5997d90c4d6$var$Vr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $e310f5997d90c4d6$var$qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtEndOfInput = void 0;
    var e = $e310f5997d90c4d6$var$uo;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function get() {
            return e.isCaretAtEndOfInput;
        }
    });
})($e310f5997d90c4d6$var$Ln);
var $e310f5997d90c4d6$var$Pn = {}, $e310f5997d90c4d6$var$ho = {};
Object.defineProperty($e310f5997d90c4d6$var$ho, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$ho.isCaretAtStartOfInput = $e310f5997d90c4d6$var$Jr;
var $e310f5997d90c4d6$var$Ae = $e310f5997d90c4d6$var$de, $e310f5997d90c4d6$var$Gr = $e310f5997d90c4d6$var$Je, $e310f5997d90c4d6$var$Qr = $e310f5997d90c4d6$var$Xe;
function $e310f5997d90c4d6$var$Jr(n) {
    var e = (0, $e310f5997d90c4d6$var$Ae.getDeepestNode)(n);
    if (e === null || (0, $e310f5997d90c4d6$var$Ae.isEmpty)(n)) return !0;
    if ((0, $e310f5997d90c4d6$var$Ae.isNativeInput)(e)) return e.selectionEnd === 0;
    if ((0, $e310f5997d90c4d6$var$Ae.isEmpty)(n)) return !0;
    var t1 = (0, $e310f5997d90c4d6$var$Gr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $e310f5997d90c4d6$var$Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtStartOfInput = void 0;
    var e = $e310f5997d90c4d6$var$ho;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function get() {
            return e.isCaretAtStartOfInput;
        }
    });
})($e310f5997d90c4d6$var$Pn);
var $e310f5997d90c4d6$var$Nn = {}, $e310f5997d90c4d6$var$po = {};
Object.defineProperty($e310f5997d90c4d6$var$po, "__esModule", {
    value: !0
});
$e310f5997d90c4d6$var$po.save = $e310f5997d90c4d6$var$oa;
var $e310f5997d90c4d6$var$ea = $e310f5997d90c4d6$var$de, $e310f5997d90c4d6$var$ta = $e310f5997d90c4d6$var$et;
function $e310f5997d90c4d6$var$oa() {
    var n = (0, $e310f5997d90c4d6$var$ta.getRange)(), e = (0, $e310f5997d90c4d6$var$ea.make)("span");
    if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function() {
        var o = window.getSelection();
        o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function() {
            e.remove();
        }, 150));
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = void 0;
    var e = $e310f5997d90c4d6$var$po;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function get() {
            return e.save;
        }
    });
})($e310f5997d90c4d6$var$Nn);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
    var e = $e310f5997d90c4d6$var$St;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function get() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
    var t1 = $e310f5997d90c4d6$var$_n;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function get() {
            return t1.getContenteditableSlice;
        }
    });
    var o = $e310f5997d90c4d6$var$Mn;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function get() {
            return o.focus;
        }
    });
    var i = $e310f5997d90c4d6$var$co;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function get() {
            return i.getCaretNodeAndOffset;
        }
    });
    var s = $e310f5997d90c4d6$var$An;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function get() {
            return s.getRange;
        }
    });
    var r = $e310f5997d90c4d6$var$Ln;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function get() {
            return r.isCaretAtEndOfInput;
        }
    });
    var a = $e310f5997d90c4d6$var$Pn;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function get() {
            return a.isCaretAtStartOfInput;
        }
    });
    var l = $e310f5997d90c4d6$var$Nn;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function get() {
            return l.save;
        }
    });
})($e310f5997d90c4d6$var$hn);
var $e310f5997d90c4d6$var$na = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(na, E);
    function na() {
        (0, $7lhcp._)(this, na);
        return (0, $07dqX._)(this, na, arguments);
    }
    (0, $8BtP9._)(na, [
        {
            /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "keydown",
            value: function keydown(e) {
                switch(this.beforeKeydownProcessing(e), e.keyCode){
                    case $e310f5997d90c4d6$var$y.BACKSPACE:
                        this.backspace(e);
                        break;
                    case $e310f5997d90c4d6$var$y.DELETE:
                        this.delete(e);
                        break;
                    case $e310f5997d90c4d6$var$y.ENTER:
                        this.enter(e);
                        break;
                    case $e310f5997d90c4d6$var$y.DOWN:
                    case $e310f5997d90c4d6$var$y.RIGHT:
                        this.arrowRightAndDown(e);
                        break;
                    case $e310f5997d90c4d6$var$y.UP:
                    case $e310f5997d90c4d6$var$y.LEFT:
                        this.arrowLeftAndUp(e);
                        break;
                    case $e310f5997d90c4d6$var$y.TAB:
                        this.tabPressed(e);
                        break;
                }
                e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
            }
        },
        {
            /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "beforeKeydownProcessing",
            value: function beforeKeydownProcessing(e) {
                this.needToolbarClosing(e) && $e310f5997d90c4d6$var$Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
            }
        },
        {
            /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ key: "keyup",
            value: function keyup(e) {
                e.shiftKey || this.Editor.UI.checkEmptiness();
            }
        },
        {
            /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ key: "dragOver",
            value: function dragOver(e) {
                var t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
                t1.dropTarget = !0;
            }
        },
        {
            /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ key: "dragLeave",
            value: function dragLeave(e) {
                var t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
                t1.dropTarget = !1;
            }
        },
        {
            /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ key: "handleCommandC",
            value: function handleCommandC(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockSelection;
                t1.anyBlockSelected && t1.copySelectedBlocks(e);
            }
        },
        {
            /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ key: "handleCommandX",
            value: function handleCommandX(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockSelection, o = _this_Editor.BlockManager, i = _this_Editor.Caret;
                t1.anyBlockSelected && t1.copySelectedBlocks(e).then(function() {
                    var s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
                    i.setToBlock(r, i.positions.START), t1.clearSelection(e);
                });
            }
        },
        {
            /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "tabPressed",
            value: function tabPressed(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.InlineToolbar, o = _this_Editor.Caret;
                if (t1.opened) return;
                (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
            }
        },
        {
            /**
   * '/' + 'command' keydown inside a Block
   */ key: "commandSlashPressed",
            value: function commandSlashPressed() {
                this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
            }
        },
        {
            /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ key: "slashPressed",
            value: function slashPressed(e) {
                !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
            }
        },
        {
            /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "enter",
            value: function enter(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.UI, i = t1.currentBlock;
                if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$e310f5997d90c4d6$var$pt) return;
                var s = i;
                i.currentInput !== void 0 && $e310f5997d90c4d6$var$Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $e310f5997d90c4d6$var$Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
            }
        },
        {
            /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "backspace",
            value: function backspace(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = t1.currentBlock, s = t1.previousBlock;
                if (i === void 0 || !$e310f5997d90c4d6$var$b.isCollapsed || !i.currentInput || !$e310f5997d90c4d6$var$Ne(i.currentInput)) return;
                if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
                    o.navigatePrevious();
                    return;
                }
                if (s === null) return;
                if (s.isEmpty) {
                    t1.removeBlock(s);
                    return;
                }
                if (i.isEmpty) {
                    t1.removeBlock(i);
                    var l = t1.currentBlock;
                    o.setToBlock(l, o.positions.END);
                    return;
                }
                $e310f5997d90c4d6$var$xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
            }
        },
        {
            /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ key: "delete",
            value: function _delete(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = t1.currentBlock, s = t1.nextBlock;
                if (!$e310f5997d90c4d6$var$b.isCollapsed || !$e310f5997d90c4d6$var$Re(i.currentInput)) return;
                if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
                    o.navigateNext();
                    return;
                }
                if (s === null) return;
                if (s.isEmpty) {
                    t1.removeBlock(s);
                    return;
                }
                if (i.isEmpty) {
                    t1.removeBlock(i), o.setToBlock(s, o.positions.START);
                    return;
                }
                $e310f5997d90c4d6$var$xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
            }
        },
        {
            /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ key: "mergeBlocks",
            value: function mergeBlocks(e, t1) {
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.Toolbar;
                e.lastInput !== void 0 && ($e310f5997d90c4d6$var$hn.focus(e.lastInput, !1), o.mergeBlocks(e, t1).then(function() {
                    i.close();
                }));
            }
        },
        {
            /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "arrowRightAndDown",
            value: function arrowRightAndDown(e) {
                var _this = this;
                var t1 = $e310f5997d90c4d6$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $e310f5997d90c4d6$var$y.TAB);
                if (this.Editor.UI.someToolbarOpened && t1) return;
                this.Editor.Toolbar.close();
                var _this_Editor_BlockManager = this.Editor.BlockManager, o = _this_Editor_BlockManager.currentBlock, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $e310f5997d90c4d6$var$Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
                if (e.shiftKey && e.keyCode === $e310f5997d90c4d6$var$y.DOWN && s) {
                    this.Editor.CrossBlockSelection.toggleBlockSelectedState();
                    return;
                }
                if (e.keyCode === $e310f5997d90c4d6$var$y.DOWN || e.keyCode === $e310f5997d90c4d6$var$y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
                    e.preventDefault();
                    return;
                }
                $e310f5997d90c4d6$var$Fe(function() {
                    _this.Editor.BlockManager.currentBlock && _this.Editor.BlockManager.currentBlock.updateCurrentInput();
                }, 20)(), this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "arrowLeftAndUp",
            value: function arrowLeftAndUp(e) {
                var _this = this;
                if (this.Editor.UI.someToolbarOpened) {
                    if ($e310f5997d90c4d6$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $e310f5997d90c4d6$var$y.TAB)) return;
                    this.Editor.UI.closeAllToolbars();
                }
                this.Editor.Toolbar.close();
                var _this_Editor_BlockManager = this.Editor.BlockManager, t1 = _this_Editor_BlockManager.currentBlock, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $e310f5997d90c4d6$var$Ne(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
                if (e.shiftKey && e.keyCode === $e310f5997d90c4d6$var$y.UP && i) {
                    this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
                    return;
                }
                if (e.keyCode === $e310f5997d90c4d6$var$y.UP || e.keyCode === $e310f5997d90c4d6$var$y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
                    e.preventDefault();
                    return;
                }
                $e310f5997d90c4d6$var$Fe(function() {
                    _this.Editor.BlockManager.currentBlock && _this.Editor.BlockManager.currentBlock.updateCurrentInput();
                }, 20)(), this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "needToolbarClosing",
            value: function needToolbarClosing(e) {
                var t1 = e.keyCode === $e310f5997d90c4d6$var$y.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $e310f5997d90c4d6$var$y.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $e310f5997d90c4d6$var$y.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $e310f5997d90c4d6$var$y.TAB;
                return !(e.shiftKey || s || t1 || o || i);
            }
        },
        {
            /**
   * If Toolbox is not open, then just open it and show plus button
   */ key: "activateToolbox",
            value: function activateToolbox() {
                this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
            }
        },
        {
            /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ key: "activateBlockSettings",
            value: function activateBlockSettings() {
                this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
            }
        }
    ]);
    return na;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$ct = /*#__PURE__*/ function() {
    "use strict";
    function ct(e) {
        (0, $7lhcp._)(this, ct);
        this.blocks = [], this.workingArea = e;
    }
    (0, $8BtP9._)(ct, [
        {
            key: "length",
            get: /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ function get() {
                return this.blocks.length;
            }
        },
        {
            key: "array",
            get: /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ function get() {
                return this.blocks;
            }
        },
        {
            key: "nodes",
            get: /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ function get() {
                return $e310f5997d90c4d6$var$No(this.workingArea.children);
            }
        },
        {
            /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ key: "push",
            value: function push(e) {
                this.blocks.push(e), this.insertToDOM(e);
            }
        },
        {
            /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ key: "swap",
            value: function swap(e, t1) {
                var o = this.blocks[t1];
                $e310f5997d90c4d6$var$u.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
            }
        },
        {
            /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ key: "move",
            value: function move(e, t1) {
                var o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
                e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
                var a = this.composeBlockEvent("move", {
                    fromIndex: t1,
                    toIndex: e
                });
                o.call($e310f5997d90c4d6$var$ee.MOVED, a);
            }
        },
        {
            /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ key: "insert",
            value: function insert(e, t1) {
                var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                if (!this.length) {
                    this.push(t1);
                    return;
                }
                e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($e310f5997d90c4d6$var$ee.REMOVED));
                var i = o ? 1 : 0;
                if (this.blocks.splice(e, i, t1), e > 0) {
                    var s = this.blocks[e - 1];
                    this.insertToDOM(t1, "afterend", s);
                } else {
                    var s1 = this.blocks[e + 1];
                    s1 ? this.insertToDOM(t1, "beforebegin", s1) : this.insertToDOM(t1);
                }
            }
        },
        {
            /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ key: "replace",
            value: function replace(e, t1) {
                if (this.blocks[e] === void 0) throw Error("Incorrect index");
                this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
            }
        },
        {
            /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ key: "insertMany",
            value: function insertMany(e, t1) {
                var _this_blocks;
                var o = new DocumentFragment();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        o.appendChild(i.holder);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this.length > 0) {
                    var _this_blocks1;
                    if (t1 > 0) {
                        var i1 = Math.min(t1 - 1, this.length - 1);
                        this.blocks[i1].holder.after(o);
                    } else t1 === 0 && this.workingArea.prepend(o);
                    (_this_blocks1 = this.blocks).splice.apply(_this_blocks1, [
                        t1,
                        0
                    ].concat((0, $fsSDT._)(e)));
                } else (_this_blocks = this.blocks).push.apply(_this_blocks, (0, $fsSDT._)(e)), this.workingArea.appendChild(o);
                e.forEach(function(i) {
                    return i.call($e310f5997d90c4d6$var$ee.RENDERED);
                });
            }
        },
        {
            /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ key: "remove",
            value: function remove(e) {
                isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($e310f5997d90c4d6$var$ee.REMOVED), this.blocks.splice(e, 1);
            }
        },
        {
            /**
   * Remove all blocks
   */ key: "removeAll",
            value: function removeAll() {
                this.workingArea.innerHTML = "", this.blocks.forEach(function(e) {
                    return e.call($e310f5997d90c4d6$var$ee.REMOVED);
                }), this.blocks.length = 0;
            }
        },
        {
            /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ key: "insertAfter",
            value: function insertAfter(e, t1) {
                var o = this.blocks.indexOf(e);
                this.insert(o + 1, t1);
            }
        },
        {
            /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ key: "get",
            value: function get(e) {
                return this.blocks[e];
            }
        },
        {
            /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ key: "indexOf",
            value: function indexOf(e) {
                return this.blocks.indexOf(e);
            }
        },
        {
            /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ key: "insertToDOM",
            value: function insertToDOM(e, t1, o) {
                t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($e310f5997d90c4d6$var$ee.RENDERED);
            }
        },
        {
            /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ key: "composeBlockEvent",
            value: function composeBlockEvent(e, t1) {
                return new CustomEvent(e, {
                    detail: t1
                });
            }
        }
    ], [
        {
            key: "set",
            value: /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ function set(e, t1, o) {
                return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
            }
        },
        {
            key: "get",
            value: /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ function get(e, t1) {
                return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
            }
        }
    ]);
    return ct;
}();
var $e310f5997d90c4d6$var$_o = "block-removed", $e310f5997d90c4d6$var$Mo = "block-added", $e310f5997d90c4d6$var$ia = "block-moved", $e310f5997d90c4d6$var$Ao = "block-changed";
var $e310f5997d90c4d6$var$sa = /*#__PURE__*/ function() {
    "use strict";
    function sa() {
        (0, $7lhcp._)(this, sa);
        this.completed = Promise.resolve();
    }
    (0, $8BtP9._)(sa, [
        {
            /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ key: "add",
            value: function add(e) {
                var _this = this;
                return new Promise(function(t1, o) {
                    _this.completed = _this.completed.then(e).then(t1).catch(o);
                });
            }
        }
    ]);
    return sa;
}();
var $e310f5997d90c4d6$var$ra = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(ra, E);
    function ra() {
        (0, $7lhcp._)(this, ra);
        var _this;
        _this = (0, $07dqX._)(this, ra, arguments), _this._currentBlockIndex = -1, _this._blocks = null;
        return _this;
    }
    (0, $8BtP9._)(ra, [
        {
            key: "currentBlockIndex",
            get: /**
   * Returns current Block index
   *
   * @returns {number}
   */ function get() {
                return this._currentBlockIndex;
            },
            set: /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ function set(e) {
                this._currentBlockIndex = e;
            }
        },
        {
            key: "firstBlock",
            get: /**
   * returns first Block
   *
   * @returns {Block}
   */ function get() {
                return this._blocks[0];
            }
        },
        {
            key: "lastBlock",
            get: /**
   * returns last Block
   *
   * @returns {Block}
   */ function get() {
                return this._blocks[this._blocks.length - 1];
            }
        },
        {
            key: "currentBlock",
            get: /**
   * Get current Block instance
   *
   * @returns {Block}
   */ function get() {
                return this._blocks[this.currentBlockIndex];
            },
            set: /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ function set(e) {
                this.currentBlockIndex = this.getBlockIndex(e);
            }
        },
        {
            key: "nextBlock",
            get: /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ function get() {
                return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
            }
        },
        {
            key: "nextContentfulBlock",
            get: /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ function get() {
                return this.blocks.slice(this.currentBlockIndex + 1).find(function(t1) {
                    return !!t1.inputs.length;
                });
            }
        },
        {
            key: "previousContentfulBlock",
            get: /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ function get() {
                return this.blocks.slice(0, this.currentBlockIndex).reverse().find(function(t1) {
                    return !!t1.inputs.length;
                });
            }
        },
        {
            key: "previousBlock",
            get: /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ function get() {
                return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
            }
        },
        {
            key: "blocks",
            get: /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ function get() {
                return this._blocks.array;
            }
        },
        {
            key: "isEditorEmpty",
            get: /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ function get() {
                return this.blocks.every(function(e) {
                    return e.isEmpty;
                });
            }
        },
        {
            /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ key: "prepare",
            value: function prepare() {
                var _this = this;
                var e = new $e310f5997d90c4d6$var$ct(this.Editor.UI.nodes.redactor);
                this._blocks = new Proxy(e, {
                    set: $e310f5997d90c4d6$var$ct.set,
                    get: $e310f5997d90c4d6$var$ct.get
                }), this.listeners.on(document, "copy", function(t1) {
                    return _this.Editor.BlockEvents.handleCommandC(t1);
                });
            }
        },
        {
            /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                e ? this.disableModuleBindings() : this.enableModuleBindings();
            }
        },
        {
            /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ key: "composeBlock",
            value: function composeBlock(param) {
                var _this = this;
                var e = param.tool, tmp = param.data, t1 = tmp === void 0 ? {} : tmp, o = param.id, tmp1 = param.tunes, i = tmp1 === void 0 ? {} : tmp1;
                var s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), a = new $e310f5997d90c4d6$var$R({
                    id: o,
                    data: t1,
                    tool: r,
                    api: this.Editor.API,
                    readOnly: s,
                    tunesData: i
                }, this.eventsDispatcher);
                return s || window.requestIdleCallback(function() {
                    _this.bindBlockEvents(a);
                }, {
                    timeout: 2e3
                }), a;
            }
        },
        {
            /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ key: "insert",
            value: function insert() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _ref.id, tmp = _ref.tool, t1 = tmp === void 0 ? this.config.defaultBlock : tmp, tmp1 = _ref.data, o = tmp1 === void 0 ? {} : tmp1, i = _ref.index, tmp2 = _ref.needToFocus, s = tmp2 === void 0 ? !0 : tmp2, tmp3 = _ref.replace, r = tmp3 === void 0 ? !1 : tmp3, tmp4 = _ref.tunes, a = tmp4 === void 0 ? {} : tmp4;
                var l = i;
                l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
                var c = this.composeBlock({
                    id: e,
                    tool: t1,
                    data: o,
                    tunes: a
                });
                return r && this.blockDidMutated($e310f5997d90c4d6$var$_o, this.getBlockByIndex(l), {
                    index: l
                }), this._blocks.insert(l, c, r), this.blockDidMutated($e310f5997d90c4d6$var$Mo, c, {
                    index: l
                }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
            }
        },
        {
            /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ key: "insertMany",
            value: function insertMany(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this._blocks.insertMany(e, t1);
            }
        },
        {
            key: "update",
            value: /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ function update(e, t1, o) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var i, s, r;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!t1 && !o) return [
                                    2,
                                    e
                                ];
                                return [
                                    4,
                                    e.data
                                ];
                            case 1:
                                i = _state.sent(), s = this.composeBlock({
                                    id: e.id,
                                    tool: e.name,
                                    data: Object.assign({}, i, t1 !== null && t1 !== void 0 ? t1 : {}),
                                    tunes: o !== null && o !== void 0 ? o : e.tunes
                                }), r = this.getBlockIndex(e);
                                return [
                                    2,
                                    (this._blocks.replace(r, s), this.blockDidMutated($e310f5997d90c4d6$var$Ao, s, {
                                        index: r
                                    }), s)
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ key: "replace",
            value: function replace(e, t1, o) {
                var i = this.getBlockIndex(e);
                return this.insert({
                    tool: t1,
                    data: o,
                    index: i,
                    replace: !0
                });
            }
        },
        {
            /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ key: "paste",
            value: function paste(e, t1) {
                var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                var i = this.insert({
                    tool: e,
                    replace: o
                });
                try {
                    window.requestIdleCallback(function() {
                        i.call($e310f5997d90c4d6$var$ee.ON_PASTE, t1);
                    });
                } catch (s) {
                    $e310f5997d90c4d6$var$S("".concat(e, ": onPaste callback call is failed"), "error", s);
                }
                return i;
            }
        },
        {
            /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ key: "insertDefaultBlockAtIndex",
            value: function insertDefaultBlockAtIndex(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var o = this.composeBlock({
                    tool: this.config.defaultBlock
                });
                return this._blocks[e] = o, this.blockDidMutated($e310f5997d90c4d6$var$Mo, o, {
                    index: e
                }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
            }
        },
        {
            /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ key: "insertAtEnd",
            value: function insertAtEnd() {
                return this.currentBlockIndex = this.blocks.length - 1, this.insert();
            }
        },
        {
            key: "mergeBlocks",
            value: /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ function mergeBlocks(e, t1) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var o, i, _yt, s, i1, s1, _tmp;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(e.name === t1.name && e.mergeable)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    t1.data
                                ];
                            case 1:
                                i = _state.sent();
                                if ($e310f5997d90c4d6$var$V(i)) {
                                    console.error("Could not merge Block. Failed to extract original Block data.");
                                    return [
                                        2
                                    ];
                                }
                                _yt = (0, $leE2g._)($e310f5997d90c4d6$var$yt([
                                    i
                                ], e.tool.sanitizeConfig), 1), s = _yt[0];
                                o = s;
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                if (!(e.mergeable && $e310f5997d90c4d6$var$He(t1, "export") && $e310f5997d90c4d6$var$He(e, "import"))) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    t1.exportDataAsString()
                                ];
                            case 3:
                                i1 = _state.sent(), s1 = $e310f5997d90c4d6$var$Z(i1, e.tool.sanitizeConfig);
                                o = $e310f5997d90c4d6$var$Bo(s1, e.tool.conversionConfig);
                                _state.label = 4;
                            case 4:
                                _tmp = o !== void 0;
                                if (!_tmp) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    e.mergeWith(o)
                                ];
                            case 5:
                                _tmp = (_state.sent(), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ key: "removeBlock",
            value: function removeBlock(e) {
                var _this = this;
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                return new Promise(function(o) {
                    var i = _this._blocks.indexOf(e);
                    if (!_this.validateIndex(i)) throw new Error("Can't find a Block to remove");
                    _this._blocks.remove(i), e.destroy(), _this.blockDidMutated($e310f5997d90c4d6$var$_o, e, {
                        index: i
                    }), _this.currentBlockIndex >= i && _this.currentBlockIndex--, _this.blocks.length ? i === 0 && (_this.currentBlockIndex = 0) : (_this.unsetCurrentBlock(), t1 && _this.insert()), o();
                });
            }
        },
        {
            /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ key: "removeSelectedBlocks",
            value: function removeSelectedBlocks() {
                var e;
                for(var t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
                return e;
            }
        },
        {
            /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ key: "removeAllBlocks",
            value: function removeAllBlocks() {
                for(var e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
                this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
            }
        },
        {
            /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ key: "split",
            value: function split() {
                var e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $e310f5997d90c4d6$var$u.make("div");
                t1.appendChild(e);
                var o = {
                    text: $e310f5997d90c4d6$var$u.isEmpty(t1) ? "" : t1.innerHTML
                };
                return this.insert({
                    data: o
                });
            }
        },
        {
            /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ key: "getBlockByIndex",
            value: function getBlockByIndex(e) {
                return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
            }
        },
        {
            /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ key: "getBlockIndex",
            value: function getBlockIndex(e) {
                return this._blocks.indexOf(e);
            }
        },
        {
            /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ key: "getBlockById",
            value: function getBlockById(e) {
                return this._blocks.array.find(function(t1) {
                    return t1.id === e;
                });
            }
        },
        {
            /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ key: "getBlock",
            value: function getBlock(e) {
                $e310f5997d90c4d6$var$u.isElement(e) || (e = e.parentNode);
                var t1 = this._blocks.nodes, o = e.closest(".".concat($e310f5997d90c4d6$var$R.CSS.wrapper)), i = t1.indexOf(o);
                if (i >= 0) return this._blocks[i];
            }
        },
        {
            /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ key: "setCurrentBlockByChildNode",
            value: function setCurrentBlockByChildNode(e) {
                $e310f5997d90c4d6$var$u.isElement(e) || (e = e.parentNode);
                var t1 = e.closest(".".concat($e310f5997d90c4d6$var$R.CSS.wrapper));
                if (!t1) return;
                var o = t1.closest(".".concat(this.Editor.UI.CSS.editorWrapper));
                if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
            }
        },
        {
            /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ key: "getBlockByChildNode",
            value: function getBlockByChildNode(e) {
                if (!e || !(e instanceof Node)) return;
                $e310f5997d90c4d6$var$u.isElement(e) || (e = e.parentNode);
                var t1 = e.closest(".".concat($e310f5997d90c4d6$var$R.CSS.wrapper));
                return this.blocks.find(function(o) {
                    return o.holder === t1;
                });
            }
        },
        {
            /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ key: "swap",
            value: function swap(e, t1) {
                this._blocks.swap(e, t1), this.currentBlockIndex = t1;
            }
        },
        {
            /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ key: "move",
            value: function move(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.currentBlockIndex;
                if (isNaN(e) || isNaN(t1)) {
                    $e310f5997d90c4d6$var$S("Warning during 'move' call: incorrect indices provided.", "warn");
                    return;
                }
                if (!this.validateIndex(e) || !this.validateIndex(t1)) {
                    $e310f5997d90c4d6$var$S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
                    return;
                }
                this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($e310f5997d90c4d6$var$ia, this.currentBlock, {
                    fromIndex: t1,
                    toIndex: e
                });
            }
        },
        {
            key: "convert",
            value: /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ function convert(e, t1, o) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var s, r, a, l;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    e.save()
                                ];
                            case 1:
                                if (!_state.sent()) throw new Error("Could not convert Block. Failed to extract original Block data.");
                                s = this.Editor.Tools.blockTools.get(t1);
                                if (!s) throw new Error("Could not convert Block. Tool \xab".concat(t1, "\xbb not found."));
                                return [
                                    4,
                                    e.exportDataAsString()
                                ];
                            case 2:
                                r = _state.sent(), a = $e310f5997d90c4d6$var$Z(r, s.sanitizeConfig);
                                l = $e310f5997d90c4d6$var$Bo(a, s.conversionConfig, s.settings);
                                return [
                                    2,
                                    (o && (l = Object.assign(l, o)), this.replace(e, s.name, l))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ key: "unsetCurrentBlock",
            value: function unsetCurrentBlock() {
                this.currentBlockIndex = -1;
            }
        },
        {
            key: "clear",
            value: /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ function clear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, e, t1;
                    var _arguments = arguments;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !1;
                                t1 = new $e310f5997d90c4d6$var$sa();
                                (0, $fsSDT._)(this.blocks).forEach(function(i) {
                                    t1.add(function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            this.removeBlock(i, !1)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        }).call(_this);
                                    });
                                });
                                return [
                                    4,
                                    t1.completed
                                ];
                            case 1:
                                _state.sent(), this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "destroy",
            value: /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ function destroy() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(this.blocks.map(function(e) {
                                        return e.destroy();
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ key: "bindBlockEvents",
            value: function bindBlockEvents(e) {
                var _this = this;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockEvents;
                this.readOnlyMutableListeners.on(e.holder, "keydown", function(o) {
                    t1.keydown(o);
                }), this.readOnlyMutableListeners.on(e.holder, "keyup", function(o) {
                    t1.keyup(o);
                }), this.readOnlyMutableListeners.on(e.holder, "dragover", function(o) {
                    t1.dragOver(o);
                }), this.readOnlyMutableListeners.on(e.holder, "dragleave", function(o) {
                    t1.dragLeave(o);
                }), e.on("didMutated", function(o) {
                    return _this.blockDidMutated($e310f5997d90c4d6$var$Ao, o, {
                        index: _this.getBlockIndex(o)
                    });
                });
            }
        },
        {
            /**
   * Disable mutable handlers and bindings
   */ key: "disableModuleBindings",
            value: function disableModuleBindings() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            /**
   * Enables all module handlers and bindings for all Blocks
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                this.readOnlyMutableListeners.on(document, "cut", function(e) {
                    return _this.Editor.BlockEvents.handleCommandX(e);
                }), this.blocks.forEach(function(e) {
                    _this.bindBlockEvents(e);
                });
            }
        },
        {
            /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ key: "validateIndex",
            value: function validateIndex(e) {
                return !(e < 0 || e >= this._blocks.length);
            }
        },
        {
            /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ key: "blockDidMutated",
            value: function blockDidMutated(e, t1, o) {
                var i = new CustomEvent(e, {
                    detail: (0, $6GCxi._)({
                        target: new $e310f5997d90c4d6$var$J(t1)
                    }, o)
                });
                return this.eventsDispatcher.emit($e310f5997d90c4d6$var$$o, {
                    event: i
                }), t1;
            }
        }
    ]);
    return ra;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$aa = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(aa, E);
    function aa() {
        (0, $7lhcp._)(this, aa);
        var _this;
        _this = (0, $07dqX._)(this, aa, arguments), _this.anyBlockSelectedCache = null, _this.needToSelectAll = !1, _this.nativeInputSelected = !1, _this.readyToBlockSelection = !1;
        return _this;
    }
    (0, $8BtP9._)(aa, [
        {
            key: "sanitizerConfig",
            get: /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ function get() {
                return {
                    p: {},
                    h1: {},
                    h2: {},
                    h3: {},
                    h4: {},
                    h5: {},
                    h6: {},
                    ol: {},
                    ul: {},
                    li: {},
                    br: !0,
                    img: {
                        src: !0,
                        width: !0,
                        height: !0
                    },
                    a: {
                        href: !0
                    },
                    b: {},
                    i: {},
                    u: {}
                };
            }
        },
        {
            key: "allBlocksSelected",
            get: /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ function get() {
                var _this_Editor = this.Editor, e = _this_Editor.BlockManager;
                return e.blocks.every(function(t1) {
                    return t1.selected === !0;
                });
            },
            set: /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ function set(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                t1.blocks.forEach(function(o) {
                    o.selected = e;
                }), this.clearCache();
            }
        },
        {
            key: "anyBlockSelected",
            get: /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ function get() {
                var _this_Editor = this.Editor, e = _this_Editor.BlockManager;
                return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some(function(t1) {
                    return t1.selected === !0;
                })), this.anyBlockSelectedCache;
            }
        },
        {
            key: "selectedBlocks",
            get: /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ function get() {
                return this.Editor.BlockManager.blocks.filter(function(e) {
                    return e.selected;
                });
            }
        },
        {
            /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ key: "prepare",
            value: function prepare() {
                var _this = this;
                this.selection = new $e310f5997d90c4d6$var$b(), $e310f5997d90c4d6$var$ge.add({
                    name: "CMD+A",
                    handler: function(e) {
                        var _this_Editor = _this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.ReadOnly;
                        if (o.isEnabled) {
                            e.preventDefault(), _this.selectAllBlocks();
                            return;
                        }
                        t1.currentBlock && _this.handleCommandA(e);
                    },
                    on: this.Editor.UI.nodes.redactor
                });
            }
        },
        {
            /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ key: "toggleReadOnly",
            value: function toggleReadOnly() {
                $e310f5997d90c4d6$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
            }
        },
        {
            /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ key: "unSelectBlockByIndex",
            value: function unSelectBlockByIndex(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                var o;
                isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
            }
        },
        {
            /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ key: "clearSelection",
            value: function clearSelection(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.Caret, s = _this_Editor.RectangleSelection;
                this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
                var r = e && e instanceof KeyboardEvent, a = r && $e310f5997d90c4d6$var$Po(e.keyCode);
                if (this.anyBlockSelected && r && a && !$e310f5997d90c4d6$var$b.isSelectionExists) {
                    var l = o.removeSelectedBlocks();
                    o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), $e310f5997d90c4d6$var$Fe(function() {
                        var c = e.key;
                        i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
                    }, 20)();
                }
                if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
                    this.Editor.RectangleSelection.clearSelection();
                    return;
                }
                t1 && this.selection.restore(), this.allBlocksSelected = !1;
            }
        },
        {
            /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ key: "copySelectedBlocks",
            value: function copySelectedBlocks(e) {
                var _this = this;
                e.preventDefault();
                var t1 = $e310f5997d90c4d6$var$u.make("div");
                this.selectedBlocks.forEach(function(s) {
                    var r = $e310f5997d90c4d6$var$Z(s.holder.innerHTML, _this.sanitizerConfig), a = $e310f5997d90c4d6$var$u.make("p");
                    a.innerHTML = r, t1.appendChild(a);
                });
                var o = Array.from(t1.childNodes).map(function(s) {
                    return s.textContent;
                }).join("\n\n"), i = t1.innerHTML;
                return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map(function(s) {
                    return s.save();
                })).then(function(s) {
                    try {
                        e.clipboardData.setData(_this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
                    } catch (e) {}
                });
            }
        },
        {
            /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ key: "selectBlockByIndex",
            value: function selectBlockByIndex(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = t1.getBlockByIndex(e);
                o !== void 0 && this.selectBlock(o);
            }
        },
        {
            /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ key: "selectBlock",
            value: function selectBlock(e) {
                this.selection.save(), $e310f5997d90c4d6$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
            }
        },
        {
            /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ key: "unselectBlock",
            value: function unselectBlock(e) {
                e.selected = !1, this.clearCache();
            }
        },
        {
            /**
   * Clear anyBlockSelected cache
   */ key: "clearCache",
            value: function clearCache() {
                this.anyBlockSelectedCache = null;
            }
        },
        {
            /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ key: "destroy",
            value: function destroy() {
                $e310f5997d90c4d6$var$ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
            }
        },
        {
            /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "handleCommandA",
            value: function handleCommandA(e) {
                if (this.Editor.RectangleSelection.clearSelection(), $e310f5997d90c4d6$var$u.isNativeInput(e.target) && !this.readyToBlockSelection) {
                    this.readyToBlockSelection = !0;
                    return;
                }
                var t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
                if (o.length > 1 && !this.readyToBlockSelection) {
                    this.readyToBlockSelection = !0;
                    return;
                }
                if (o.length === 1 && !this.needToSelectAll) {
                    this.needToSelectAll = !0;
                    return;
                }
                this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
            }
        },
        {
            /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ key: "selectAllBlocks",
            value: function selectAllBlocks() {
                this.selection.save(), $e310f5997d90c4d6$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
            }
        }
    ]);
    return aa;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Ye = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Ye, E);
    function Ye() {
        (0, $7lhcp._)(this, Ye);
        return (0, $07dqX._)(this, Ye, arguments);
    }
    (0, $8BtP9._)(Ye, [
        {
            key: "positions",
            get: /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ function get() {
                return {
                    START: "start",
                    END: "end",
                    DEFAULT: "default"
                };
            }
        },
        {
            /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the block content
   */ key: "setToBlock",
            value: function setToBlock(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.positions.DEFAULT, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var c;
                var _this_Editor = this.Editor, i = _this_Editor.BlockManager, s = _this_Editor.BlockSelection;
                if (s.clearSelection(), !e.focusable) {
                    (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
                    return;
                }
                var r;
                switch(t1){
                    case this.positions.START:
                        r = e.firstInput;
                        break;
                    case this.positions.END:
                        r = e.lastInput;
                        break;
                    default:
                        r = e.currentInput;
                }
                if (!r) return;
                var a, l = o;
                if (t1 === this.positions.START) a = $e310f5997d90c4d6$var$u.getDeepestNode(r, !1), l = 0;
                else if (t1 === this.positions.END) a = $e310f5997d90c4d6$var$u.getDeepestNode(r, !0), l = $e310f5997d90c4d6$var$u.getContentLength(a);
                else {
                    var _u_getNodeByOffset = $e310f5997d90c4d6$var$u.getNodeByOffset(r, o), d = _u_getNodeByOffset.node, h = _u_getNodeByOffset.offset;
                    d ? (a = d, l = h) : (a = $e310f5997d90c4d6$var$u.getDeepestNode(r, !1), l = 0);
                }
                this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
            }
        },
        {
            /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ key: "setToInput",
            value: function setToInput(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.positions.DEFAULT, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var _this_Editor_BlockManager = this.Editor.BlockManager, i = _this_Editor_BlockManager.currentBlock, s = $e310f5997d90c4d6$var$u.getDeepestNode(e);
                switch(t1){
                    case this.positions.START:
                        this.set(s, 0);
                        break;
                    case this.positions.END:
                        this.set(s, $e310f5997d90c4d6$var$u.getContentLength(s));
                        break;
                    default:
                        o && this.set(s, o);
                }
                i.currentInput = e;
            }
        },
        {
            /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ key: "set",
            value: function set(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var _b_setCursor = $e310f5997d90c4d6$var$b.setCursor(e, t1), i = _b_setCursor.top, s = _b_setCursor.bottom, r = window.innerHeight;
                i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
            }
        },
        {
            /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ key: "setToTheLastBlock",
            value: function setToTheLastBlock() {
                var e = this.Editor.BlockManager.lastBlock;
                if (e) {
                    if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
                    else {
                        var t1 = this.Editor.BlockManager.insertAtEnd();
                        this.setToBlock(t1);
                    }
                }
            }
        },
        {
            /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ key: "extractFragmentFromCaretPosition",
            value: function extractFragmentFromCaretPosition() {
                var e = $e310f5997d90c4d6$var$b.get();
                if (e.rangeCount) {
                    var t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
                    if (t1.deleteContents(), o) {
                        if ($e310f5997d90c4d6$var$u.isNativeInput(o)) {
                            var i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), a = i.value.substring(i.selectionStart);
                            return s.textContent = a, i.value = r, s;
                        } else {
                            var i1 = t1.cloneRange();
                            return i1.selectNodeContents(o), i1.setStart(t1.endContainer, t1.endOffset), i1.extractContents();
                        }
                    }
                }
            }
        },
        {
            /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ key: "navigateNext",
            value: function navigateNext() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = t1.currentBlock, i = t1.nextBlock;
                if (o === void 0) return !1;
                var s = o.nextInput, r = o.currentInput, a = r !== void 0 ? $e310f5997d90c4d6$var$Re(r) : void 0;
                var l = i;
                var c = e || a || !o.focusable;
                if (s && c) return this.setToInput(s, this.positions.START), !0;
                if (l === null) {
                    if (o.tool.isDefault || !c) return !1;
                    l = t1.insertAtEnd();
                }
                return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
            }
        },
        {
            /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ key: "navigatePrevious",
            value: function navigatePrevious() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                var _this_Editor_BlockManager = this.Editor.BlockManager, t1 = _this_Editor_BlockManager.currentBlock, o = _this_Editor_BlockManager.previousBlock;
                if (!t1) return !1;
                var i = t1.previousInput, s = t1.currentInput, r = s !== void 0 ? $e310f5997d90c4d6$var$Ne(s) : void 0, a = e || r || !t1.focusable;
                return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
            }
        },
        {
            /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ key: "createShadow",
            value: function createShadow(e) {
                var t1 = document.createElement("span");
                t1.classList.add(Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
            }
        },
        {
            /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ key: "restoreCaret",
            value: function restoreCaret(e) {
                var t1 = e.querySelector(".".concat(Ye.CSS.shadowCaret));
                if (!t1) return;
                new $e310f5997d90c4d6$var$b().expandToTag(t1);
                var i = document.createRange();
                i.selectNode(t1), i.extractContents();
            }
        },
        {
            /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ key: "insertContentAtCaretPosition",
            value: function insertContentAtCaretPosition(e) {
                var t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $e310f5997d90c4d6$var$b.get(), s = $e310f5997d90c4d6$var$b.range;
                o.innerHTML = e, Array.from(o.childNodes).forEach(function(c) {
                    return t1.appendChild(c);
                }), t1.childNodes.length === 0 && t1.appendChild(new Text());
                var r = t1.lastChild;
                s.deleteContents(), s.insertNode(t1);
                var a = document.createRange(), l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
                l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * Elements styles that can be useful for Caret Module
   */ function get() {
                return {
                    shadowCaret: "cdx-shadow-caret"
                };
            }
        }
    ]);
    return Ye;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$la = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(la, E);
    function la() {
        (0, $7lhcp._)(this, la);
        var _this;
        _this = (0, $07dqX._)(this, la, arguments), _this.onMouseUp = function() {
            _this.listeners.off(document, "mouseover", _this.onMouseOver), _this.listeners.off(document, "mouseup", _this.onMouseUp);
        }, _this.onMouseOver = function(e) {
            var _this_Editor = _this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection;
            if (e.relatedTarget === null && e.target === null) return;
            var i = t1.getBlockByChildNode(e.relatedTarget) || _this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === _this.firstSelectedBlock) {
                    $e310f5997d90c4d6$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === _this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                _this.Editor.InlineToolbar.close(), _this.toggleBlocksSelectedState(i, s), _this.lastSelectedBlock = s;
            }
        };
        return _this;
    }
    (0, $8BtP9._)(la, [
        {
            key: "prepare",
            value: /**
   * Module preparation
   *
   * @returns {Promise}
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        _this = this;
                        this.listeners.on(document, "mousedown", function(e) {
                            _this.enableCrossBlockSelection(e);
                        });
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ key: "watchSelection",
            value: function watchSelection(e) {
                if (e.button !== $e310f5997d90c4d6$var$qn.LEFT) return;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
            }
        },
        {
            key: "isCrossBlockSelectionStarted",
            get: /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ function get() {
                return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
            }
        },
        {
            /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ key: "toggleBlockSelectedState",
            value: function toggleBlockSelectedState() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection;
                this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $e310f5997d90c4d6$var$b.get().removeAllRanges());
                var i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
                s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
                    block: "nearest"
                }));
            }
        },
        {
            /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ key: "clear",
            value: function clear(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection, i = _this_Editor.Caret, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
                if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
                    case $e310f5997d90c4d6$var$y.DOWN:
                    case $e310f5997d90c4d6$var$y.RIGHT:
                        i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                        break;
                    case $e310f5997d90c4d6$var$y.UP:
                    case $e310f5997d90c4d6$var$y.LEFT:
                        i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                        break;
                    default:
                        i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                }
                this.firstSelectedBlock = this.lastSelectedBlock = null;
            }
        },
        {
            /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ key: "enableCrossBlockSelection",
            value: function enableCrossBlockSelection(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.UI;
                $e310f5997d90c4d6$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ key: "toggleBlocksSelectedState",
            value: function toggleBlocksSelectedState(e, t1) {
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.BlockSelection, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), a = e.selected !== t1.selected;
                for(var l = Math.min(s, r); l <= Math.max(s, r); l++){
                    var c = o.blocks[l];
                    c !== this.firstSelectedBlock && c !== (a ? e : t1) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
                }
            }
        }
    ]);
    return la;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$ca = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(ca, E);
    function ca() {
        (0, $7lhcp._)(this, ca);
        var _this;
        _this = (0, $07dqX._)(this, ca, arguments), _this.isStartedAtEditor = !1;
        return _this;
    }
    (0, $8BtP9._)(ca, [
        {
            /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                e ? this.disableModuleBindings() : this.enableModuleBindings();
            }
        },
        {
            /**
   * Add drag events listeners to editor zone
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                var _this_Editor = this.Editor, e = _this_Editor.UI;
                this.readOnlyMutableListeners.on(e.nodes.holder, "drop", function(t1) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.processDrop(t1)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", function() {
                    _this.processDragStart();
                }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", function(t1) {
                    _this.processDragOver(t1);
                }, !0);
            }
        },
        {
            /**
   * Unbind drag-n-drop event handlers
   */ key: "disableModuleBindings",
            value: function disableModuleBindings() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            key: "processDrop",
            value: /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ function processDrop(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this_Editor, t1, o, i, s, r;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Paste, i = _this_Editor.Caret;
                                e.preventDefault(), t1.blocks.forEach(function(r) {
                                    r.dropTarget = !1;
                                }), $e310f5997d90c4d6$var$b.isAtEditor && !$e310f5997d90c4d6$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
                                s = t1.setCurrentBlockByChildNode(e.target);
                                if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
                                else {
                                    r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
                                    this.Editor.Caret.setToBlock(r, i.positions.END);
                                }
                                return [
                                    4,
                                    o.processDataTransfer(e.dataTransfer, !0)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Handle drag start event
   */ key: "processDragStart",
            value: function processDragStart() {
                $e310f5997d90c4d6$var$b.isAtEditor && !$e310f5997d90c4d6$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
            }
        },
        {
            /**
   * @param {DragEvent} dragEvent - drag event
   */ key: "processDragOver",
            value: function processDragOver(e) {
                e.preventDefault();
            }
        }
    ]);
    return ca;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$da = 180, $e310f5997d90c4d6$var$ua = 400;
var $e310f5997d90c4d6$var$ha = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(ha, E);
    function ha(param) {
        var e = param.config, t1 = param.eventsDispatcher;
        (0, $7lhcp._)(this, ha);
        var _this;
        _this = (0, $07dqX._)(this, ha, [
            {
                config: e,
                eventsDispatcher: t1
            }
        ]), _this.disabled = !1, _this.batchingTimeout = null, _this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), _this.batchTime = $e310f5997d90c4d6$var$ua, _this.mutationObserver = new MutationObserver(function(o) {
            _this.redactorChanged(o);
        }), _this.eventsDispatcher.on($e310f5997d90c4d6$var$$o, function(o) {
            _this.particularBlockChanged(o.event);
        }), _this.eventsDispatcher.on($e310f5997d90c4d6$var$zo, function() {
            _this.disable();
        }), _this.eventsDispatcher.on($e310f5997d90c4d6$var$Uo, function() {
            _this.enable();
        });
        return _this;
    }
    (0, $8BtP9._)(ha, [
        {
            /**
   * Enables onChange event
   */ key: "enable",
            value: function enable() {
                this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
                    childList: !0,
                    subtree: !0,
                    characterData: !0,
                    attributes: !0
                }), this.disabled = !1;
            }
        },
        {
            /**
   * Disables onChange event
   */ key: "disable",
            value: function disable() {
                this.mutationObserver.disconnect(), this.disabled = !0;
            }
        },
        {
            /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ key: "particularBlockChanged",
            value: function particularBlockChanged(e) {
                var _this = this;
                this.disabled || !$e310f5997d90c4d6$var$A(this.config.onChange) || (this.batchingOnChangeQueue.set("block:".concat(e.detail.target.id, ":event:").concat(e.type), e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(function() {
                    var t1;
                    _this.batchingOnChangeQueue.size === 1 ? t1 = _this.batchingOnChangeQueue.values().next().value : t1 = Array.from(_this.batchingOnChangeQueue.values()), _this.config.onChange && _this.config.onChange(_this.Editor.API.methods, t1), _this.batchingOnChangeQueue.clear();
                }, this.batchTime));
            }
        },
        {
            /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ key: "redactorChanged",
            value: function redactorChanged(e) {
                this.eventsDispatcher.emit($e310f5997d90c4d6$var$ft, {
                    mutations: e
                });
            }
        }
    ]);
    return ha;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Rn = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Dn, E);
    function Dn() {
        (0, $7lhcp._)(this, Dn);
        var _this;
        var _this1, _arguments = arguments;
        _this = (0, $07dqX._)(this, Dn, (0, $fsSDT._)(_arguments)), _this1 = _this, _this1.MIME_TYPE = "application/x-editor-js", _this1.toolsTags = {}, _this1.tagsByTool = {}, _this1.toolsPatterns = [], _this1.toolsFiles = {}, _this1.exceptionList = [], _this1.processTool = function(e) {
            try {
                var _$t = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    _this1.exceptionList.push(e.name);
                    return;
                }
                if (!$e310f5997d90c4d6$var$A(_$t.onPaste)) return;
                _this1.getTagsConfig(e), _this1.getFilesConfig(e), _this1.getPatternsConfig(e);
            } catch (t1) {
                $e310f5997d90c4d6$var$S("Paste handling for \xab".concat(e.name, "\xbb Tool hasn't been set up because of the error"), "warn", t1);
            }
        }, _this1.handlePasteEvent = function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var _this_Editor, t1, o, i;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    _this_Editor = _this1.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Toolbar, i = t1.setCurrentBlockByChildNode(e.target);
                    !i || _this1.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && _this1.exceptionList.includes(i.name) || (e.preventDefault(), _this1.processDataTransfer(e.clipboardData), o.close());
                    return [
                        2
                    ];
                });
            })();
        };
        return _this;
    }
    (0, $8BtP9._)(Dn, [
        {
            key: "prepare",
            value: /**
   * Set onPaste callback and collect tools` paste configurations
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        this.processTools();
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                e ? this.unsetCallback() : this.setCallback();
            }
        },
        {
            key: "processDataTransfer",
            value: /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ function processDataTransfer(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(e) {
                    var _this, t1, _this_Editor, o, i, r, a, l, c, d, h, _tmp;
                    var _arguments = arguments;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                t1 = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                                _this_Editor = this.Editor, o = _this_Editor.Tools, i = e.types;
                                if (!((i.includes ? i.includes("Files") : i.contains("Files")) && !$e310f5997d90c4d6$var$V(this.toolsFiles))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.processFiles(e.files)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
                                l = e.getData("text/html");
                                if (r) try {
                                    this.insertEditorJSData(JSON.parse(r));
                                    return [
                                        2
                                    ];
                                } catch (e) {}
                                t1 && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
                                c = Object.keys(this.toolsTags).reduce(function(p, g) {
                                    var _this_toolsTags_g_sanitizationConfig;
                                    return p[g.toLowerCase()] = (_this_toolsTags_g_sanitizationConfig = _this.toolsTags[g].sanitizationConfig) !== null && _this_toolsTags_g_sanitizationConfig !== void 0 ? _this_toolsTags_g_sanitizationConfig : {}, p;
                                }, {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
                                    br: {}
                                }), h = $e310f5997d90c4d6$var$Z(l, d);
                                if (!(!h.trim() || h.trim() === a || !$e310f5997d90c4d6$var$u.isHTMLString(h))) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.processText(a)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    this.processText(h, !0)
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "processText",
            value: /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ function processText(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(e) {
                    var _this, t1, _this_Editor, o, i, s, a;
                    var _arguments = arguments;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        _this = this;
                        t1 = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                        _this_Editor = this.Editor, o = _this_Editor.Caret, i = _this_Editor.BlockManager, s = t1 ? this.processHTML(e) : this.processPlain(e);
                        if (!s.length) return [
                            2
                        ];
                        if (s.length === 1) {
                            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
                            return [
                                2
                            ];
                        }
                        a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
                        s.map(function(l, c) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                return (0, $Csf8W.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        this.insertBlock(l, c === 0 && a)
                                    ];
                                });
                            }).call(_this);
                        }), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
                        return [
                            2
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Set onPaste callback handler
   */ key: "setCallback",
            value: function setCallback() {
                this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
            }
        },
        {
            /**
   * Unset onPaste callback handler
   */ key: "unsetCallback",
            value: function unsetCallback() {
                this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
            }
        },
        {
            /**
   * Get and process tool`s paste configs
   */ key: "processTools",
            value: function processTools() {
                var e = this.Editor.Tools.blockTools;
                Array.from(e.values()).forEach(this.processTool);
            }
        },
        {
            /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ key: "collectTagNames",
            value: function collectTagNames(e) {
                return $e310f5997d90c4d6$var$te(e) ? [
                    e
                ] : $e310f5997d90c4d6$var$D(e) ? Object.keys(e) : [];
            }
        },
        {
            /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ key: "getTagsConfig",
            value: function getTagsConfig(e) {
                var _this = this;
                if (e.pasteConfig === !1) return;
                var t1 = e.pasteConfig.tags || [], o = [];
                t1.forEach(function(i) {
                    var _o;
                    var s = _this.collectTagNames(i);
                    (_o = o).push.apply(_o, (0, $fsSDT._)(s)), s.forEach(function(r) {
                        if (Object.prototype.hasOwnProperty.call(_this.toolsTags, r)) {
                            $e310f5997d90c4d6$var$S("Paste handler for \xab".concat(e.name, "\xbb Tool on \xab").concat(r, "\xbb tag is skipped because it is already used by \xab").concat(_this.toolsTags[r].tool.name, "\xbb Tool."), "warn");
                            return;
                        }
                        var a = $e310f5997d90c4d6$var$D(i) ? i[r] : null;
                        _this.toolsTags[r.toUpperCase()] = {
                            tool: e,
                            sanitizationConfig: a
                        };
                    });
                }), this.tagsByTool[e.name] = o.map(function(i) {
                    return i.toUpperCase();
                });
            }
        },
        {
            /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ key: "getFilesConfig",
            value: function getFilesConfig(e) {
                if (e.pasteConfig === !1) return;
                var _e_pasteConfig = e.pasteConfig, tmp = _e_pasteConfig.files, t1 = tmp === void 0 ? {} : tmp;
                var o = t1.extensions, i = t1.mimeTypes;
                !o && !i || (o && !Array.isArray(o) && ($e310f5997d90c4d6$var$S("\xabextensions\xbb property of the onDrop config for \xab".concat(e.name, "\xbb Tool should be an array")), o = []), i && !Array.isArray(i) && ($e310f5997d90c4d6$var$S("\xabmimeTypes\xbb property of the onDrop config for \xab".concat(e.name, "\xbb Tool should be an array")), i = []), i && (i = i.filter(function(s) {
                    return $e310f5997d90c4d6$var$ei(s) ? !0 : ($e310f5997d90c4d6$var$S("MIME type value \xab".concat(s, "\xbb for the \xab").concat(e.name, "\xbb Tool is not a valid MIME type"), "warn"), !1);
                })), this.toolsFiles[e.name] = {
                    extensions: o || [],
                    mimeTypes: i || []
                });
            }
        },
        {
            /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ key: "getPatternsConfig",
            value: function getPatternsConfig(e) {
                var _this = this;
                e.pasteConfig === !1 || !e.pasteConfig.patterns || $e310f5997d90c4d6$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[0], o = _param[1];
                    o instanceof RegExp || $e310f5997d90c4d6$var$S("Pattern ".concat(o, " for \xab").concat(e.name, "\xbb Tool is skipped because it should be a Regexp instance."), "warn"), _this.toolsPatterns.push({
                        key: t1,
                        pattern: o,
                        tool: e
                    });
                });
            }
        },
        {
            /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ key: "isNativeBehaviour",
            value: function isNativeBehaviour(e) {
                return $e310f5997d90c4d6$var$u.isNativeInput(e);
            }
        },
        {
            key: "processFiles",
            value: /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ function processFiles(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, _this_Editor, t1, o, s;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _this_Editor = this.Editor, t1 = _this_Editor.BlockManager;
                                return [
                                    4,
                                    Promise.all(Array.from(e).map(function(r) {
                                        return _this.processFile(r);
                                    }))
                                ];
                            case 1:
                                o = _state.sent(), o = o.filter(function(r) {
                                    return !!r;
                                });
                                s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
                                o.forEach(function(r, a) {
                                    t1.paste(r.type, r.event, a === 0 && s);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "processFile",
            value: /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ function processFile(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var t1, o, _o, i;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        t1 = $e310f5997d90c4d6$var$Jn(e), o = Object.entries(this.toolsFiles).find(function(param) {
                            var _param = (0, $leE2g._)(param, 2), r = _param[0], _param_ = _param[1], a = _param_.mimeTypes, l = _param_.extensions;
                            var _e_type_split = (0, $leE2g._)(e.type.split("/"), 2), c = _e_type_split[0], d = _e_type_split[1], h = l.find(function(g) {
                                return g.toLowerCase() === t1.toLowerCase();
                            }), p = a.find(function(g) {
                                var _g_split = (0, $leE2g._)(g.split("/"), 2), f = _g_split[0], v = _g_split[1];
                                return f === c && (v === d || v === "*");
                            });
                            return !!h || !!p;
                        });
                        if (!o) return [
                            2
                        ];
                        _o = (0, $leE2g._)(o, 1), i = _o[0];
                        return [
                            2,
                            {
                                event: this.composePasteEvent("file", {
                                    file: e
                                }),
                                type: i
                            }
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ key: "processHTML",
            value: function processHTML(e) {
                var _this = this;
                var _this_Editor = this.Editor, t1 = _this_Editor.Tools, o = $e310f5997d90c4d6$var$u.make("DIV");
                return o.innerHTML = e, this.getNodes(o).map(function(s) {
                    var r, a = t1.defaultTool, l = !1;
                    switch(s.nodeType){
                        case Node.DOCUMENT_FRAGMENT_NODE:
                            r = $e310f5997d90c4d6$var$u.make("div"), r.appendChild(s);
                            break;
                        case Node.ELEMENT_NODE:
                            r = s, l = !0, _this.toolsTags[r.tagName] && (a = _this.toolsTags[r.tagName].tool);
                            break;
                    }
                    var _ref = a.pasteConfig || {
                        tags: []
                    }, c = _ref.tags, d = c.reduce(function(g, f) {
                        return _this.collectTagNames(f).forEach(function(O) {
                            var T = $e310f5997d90c4d6$var$D(f) ? f[O] : null;
                            g[O.toLowerCase()] = T || {};
                        }), g;
                    }, {}), h = Object.assign({}, d, a.baseSanitizeConfig);
                    if (r.tagName.toLowerCase() === "table") {
                        var g = $e310f5997d90c4d6$var$Z(r.outerHTML, h);
                        r = $e310f5997d90c4d6$var$u.make("div", void 0, {
                            innerHTML: g
                        }).firstChild;
                    } else r.innerHTML = $e310f5997d90c4d6$var$Z(r.innerHTML, h);
                    var p = _this.composePasteEvent("tag", {
                        data: r
                    });
                    return {
                        content: r,
                        isBlock: l,
                        tool: a.name,
                        event: p
                    };
                }).filter(function(s) {
                    var r = $e310f5997d90c4d6$var$u.isEmpty(s.content), a = $e310f5997d90c4d6$var$u.isSingleTag(s.content);
                    return !r || a;
                });
            }
        },
        {
            /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ key: "processPlain",
            value: function processPlain(e) {
                var _this = this;
                var _this_config = this.config, t1 = _this_config.defaultBlock;
                if (!e) return [];
                var o = t1;
                return e.split(/\r?\n/).filter(function(i) {
                    return i.trim();
                }).map(function(i) {
                    var s = $e310f5997d90c4d6$var$u.make("div");
                    s.textContent = i;
                    var r = _this.composePasteEvent("tag", {
                        data: s
                    });
                    return {
                        content: s,
                        tool: o,
                        isBlock: !1,
                        event: r
                    };
                });
            }
        },
        {
            key: "processSingleBlock",
            value: /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ function processSingleBlock(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this_Editor, t1, o, i;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        _this_Editor = this.Editor, t1 = _this_Editor.Caret, o = _this_Editor.BlockManager, i = o.currentBlock;
                        if (!i || e.tool !== i.name || !$e310f5997d90c4d6$var$u.containsOnlyInlineElements(e.content.innerHTML)) {
                            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
                            return [
                                2
                            ];
                        }
                        t1.insertContentAtCaretPosition(e.content.innerHTML);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "processInlinePaste",
            value: /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ function processInlinePaste(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this_Editor, t1, o, i, r, a, l, r1;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = e.content;
                                if (!(t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.processPattern(i.textContent)
                                ];
                            case 1:
                                r = _state.sent();
                                if (r) {
                                    a = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, l = t1.paste(r.tool, r.event, a);
                                    o.setToBlock(l, o.positions.END);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 2;
                            case 2:
                                if (t1.currentBlock && t1.currentBlock.currentInput) {
                                    r1 = t1.currentBlock.tool.baseSanitizeConfig;
                                    document.execCommand("insertHTML", !1, $e310f5997d90c4d6$var$Z(i.innerHTML, r1));
                                } else this.insertBlock(e);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "processPattern",
            value: /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ function processPattern(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var t1;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        t1 = this.toolsPatterns.find(function(i) {
                            var s = i.pattern.exec(e);
                            return s ? e === s.shift() : !1;
                        });
                        return [
                            2,
                            t1 ? {
                                event: this.composePasteEvent("pattern", {
                                    key: t1.key,
                                    data: e
                                }),
                                tool: t1.tool.name
                            } : void 0
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ key: "insertBlock",
            value: function insertBlock(e) {
                var t1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                var _this_Editor = this.Editor, o = _this_Editor.BlockManager, i = _this_Editor.Caret, s = o.currentBlock;
                var r;
                if (t1 && s && s.isEmpty) {
                    r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
                    return;
                }
                r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
            }
        },
        {
            /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ key: "insertEditorJSData",
            value: function insertEditorJSData(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.Caret, i = _this_Editor.Tools;
                $e310f5997d90c4d6$var$yt(e, function(r) {
                    return i.blockTools.get(r).sanitizeConfig;
                }).forEach(function(param, l) {
                    var r = param.tool, a = param.data;
                    var c = !1;
                    l === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
                    var d = t1.insert({
                        tool: r,
                        data: a,
                        replace: c
                    });
                    o.setToBlock(d, o.positions.END);
                });
            }
        },
        {
            /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ key: "processElementNode",
            value: function processElementNode(e, t1, o) {
                var i = Object.keys(this.toolsTags), s = e, _ref = this.toolsTags[s.tagName] || {}, r = _ref.tool, a = this.tagsByTool[r == null ? void 0 : r.name] || [], l = i.includes(s.tagName), c = $e310f5997d90c4d6$var$u.blockElements.includes(s.tagName.toLowerCase()), d = Array.from(s.children).some(function(param) {
                    var p = param.tagName;
                    return i.includes(p) && !a.includes(p);
                }), h = Array.from(s.children).some(function(param) {
                    var p = param.tagName;
                    return $e310f5997d90c4d6$var$u.blockElements.includes(p.toLowerCase());
                });
                if (!c && !l && !d) return o.appendChild(s), (0, $fsSDT._)(t1).concat([
                    o
                ]);
                if (l && !d || c && !h && !d) return (0, $fsSDT._)(t1).concat([
                    o,
                    s
                ]);
            }
        },
        {
            /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ key: "getNodes",
            value: function getNodes(e) {
                var _this = this;
                var t1 = Array.from(e.childNodes);
                var o;
                var i = function(s, r) {
                    if ($e310f5997d90c4d6$var$u.isEmpty(r) && !$e310f5997d90c4d6$var$u.isSingleTag(r)) return s;
                    var a = s[s.length - 1];
                    var l = new DocumentFragment();
                    switch(a && $e310f5997d90c4d6$var$u.isFragment(a) && (l = s.pop()), r.nodeType){
                        case Node.ELEMENT_NODE:
                            if (o = _this.processElementNode(r, s, l), o) return o;
                            break;
                        case Node.TEXT_NODE:
                            return l.appendChild(r), (0, $fsSDT._)(s).concat([
                                l
                            ]);
                        default:
                            return (0, $fsSDT._)(s).concat([
                                l
                            ]);
                    }
                    return (0, $fsSDT._)(s).concat((0, $fsSDT._)(Array.from(r.childNodes).reduce(i, [])));
                };
                return t1.reduce(i, []);
            }
        },
        {
            /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ key: "composePasteEvent",
            value: function composePasteEvent(e, t1) {
                return new CustomEvent(e, {
                    detail: t1
                });
            }
        }
    ]);
    return Dn;
}($e310f5997d90c4d6$var$E);
$e310f5997d90c4d6$var$Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
var $e310f5997d90c4d6$var$pa = $e310f5997d90c4d6$var$Rn;
var $e310f5997d90c4d6$var$fa = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(fa, E);
    function fa() {
        (0, $7lhcp._)(this, fa);
        var _this;
        _this = (0, $07dqX._)(this, fa, arguments), _this.toolsDontSupportReadOnly = [], _this.readOnlyEnabled = !1;
        return _this;
    }
    (0, $8BtP9._)(fa, [
        {
            key: "isEnabled",
            get: /**
   * Returns state of read only mode
   */ function get() {
                return this.readOnlyEnabled;
            }
        },
        {
            key: "prepare",
            value: /**
   * Set initial state
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this_Editor, e, t1, o;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        _this_Editor = this.Editor, e = _this_Editor.Tools, t1 = e.blockTools, o = [];
                        Array.from(t1.entries()).forEach(function(param) {
                            var _param = (0, $leE2g._)(param, 2), i = _param[0], s = _param[1];
                            s.isReadOnlySupported || o.push(i);
                        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "toggle",
            value: /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ function toggle() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var e, t1, o, s, i;
                    var _arguments = arguments;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !this.readOnlyEnabled, t1 = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                                e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
                                o = this.readOnlyEnabled;
                                this.readOnlyEnabled = e;
                                for(var s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
                                if (o === e) return [
                                    2,
                                    this.readOnlyEnabled
                                ];
                                if (t1) return [
                                    2,
                                    this.readOnlyEnabled
                                ];
                                this.Editor.ModificationsObserver.disable();
                                return [
                                    4,
                                    this.Editor.Saver.save()
                                ];
                            case 1:
                                i = _state.sent();
                                return [
                                    4,
                                    this.Editor.BlockManager.clear()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    this.Editor.Renderer.render(i.blocks)
                                ];
                            case 3:
                                return [
                                    2,
                                    (_state.sent(), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled)
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            /**
   * Throws an error about tools which don't support read-only mode
   */ key: "throwCriticalError",
            value: function throwCriticalError() {
                throw new $e310f5997d90c4d6$var$Ho("To enable read-only mode all connected tools should support it. Tools ".concat(this.toolsDontSupportReadOnly.join(", "), " don't support read-only mode."));
            }
        }
    ]);
    return fa;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Be = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Be, E);
    function Be() {
        (0, $7lhcp._)(this, Be);
        var _this;
        _this = (0, $07dqX._)(this, Be, arguments), _this.isRectSelectionActivated = !1, _this.SCROLL_SPEED = 3, _this.HEIGHT_OF_SCROLL_ZONE = 40, _this.BOTTOM_SCROLL_ZONE = 1, _this.TOP_SCROLL_ZONE = 2, _this.MAIN_MOUSE_BUTTON = 0, _this.mousedown = !1, _this.isScrolling = !1, _this.inScrollZone = null, _this.startX = 0, _this.startY = 0, _this.mouseX = 0, _this.mouseY = 0, _this.stackOfSelected = [], _this.listenerIds = [];
        return _this;
    }
    (0, $8BtP9._)(Be, [
        {
            /**
   * Module Preparation
   * Creating rect and hang handlers
   */ key: "prepare",
            value: function prepare() {
                this.enableModuleBindings();
            }
        },
        {
            /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ key: "startSelection",
            value: function startSelection(e, t1) {
                var o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
                o.closest(".".concat(this.Editor.Toolbar.CSS.toolbar)) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
                var s = [
                    ".".concat($e310f5997d90c4d6$var$R.CSS.content),
                    ".".concat(this.Editor.Toolbar.CSS.toolbar),
                    ".".concat(this.Editor.InlineToolbar.CSS.inlineToolbar)
                ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), a = s.some(function(l) {
                    return !!o.closest(l);
                });
                !r || a || (this.mousedown = !0, this.startX = e, this.startY = t1);
            }
        },
        {
            /**
   * Clear all params to end selection
   */ key: "endSelection",
            value: function endSelection() {
                this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
            }
        },
        {
            /**
   * is RectSelection Activated
   */ key: "isRectActivated",
            value: function isRectActivated() {
                return this.isRectSelectionActivated;
            }
        },
        {
            /**
   * Mark that selection is end
   */ key: "clearSelection",
            value: function clearSelection() {
                this.isRectSelectionActivated = !1;
            }
        },
        {
            /**
   * Sets Module necessary event handlers
   */ key: "enableModuleBindings",
            value: function enableModuleBindings() {
                var _this = this;
                var _this_genHTML = this.genHTML(), e = _this_genHTML.container;
                this.listeners.on(e, "mousedown", function(t1) {
                    _this.processMouseDown(t1);
                }, !1), this.listeners.on(document.body, "mousemove", $e310f5997d90c4d6$var$dt(function(t1) {
                    _this.processMouseMove(t1);
                }, 10), {
                    passive: !0
                }), this.listeners.on(document.body, "mouseleave", function() {
                    _this.processMouseLeave();
                }), this.listeners.on(window, "scroll", $e310f5997d90c4d6$var$dt(function(t1) {
                    _this.processScroll(t1);
                }, 10), {
                    passive: !0
                }), this.listeners.on(document.body, "mouseup", function() {
                    _this.processMouseUp();
                }, !1);
            }
        },
        {
            /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ key: "processMouseDown",
            value: function processMouseDown(e) {
                if (e.button !== this.MAIN_MOUSE_BUTTON) return;
                e.target.closest($e310f5997d90c4d6$var$u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
            }
        },
        {
            /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ key: "processMouseMove",
            value: function processMouseMove(e) {
                this.changingRectangle(e), this.scrollByZones(e.clientY);
            }
        },
        {
            /**
   * Handle mouse leave
   */ key: "processMouseLeave",
            value: function processMouseLeave() {
                this.clearSelection(), this.endSelection();
            }
        },
        {
            /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ key: "processScroll",
            value: function processScroll(e) {
                this.changingRectangle(e);
            }
        },
        {
            /**
   * Handle mouse up
   */ key: "processMouseUp",
            value: function processMouseUp() {
                this.clearSelection(), this.endSelection();
            }
        },
        {
            /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ key: "scrollByZones",
            value: function scrollByZones(e) {
                if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
                    this.isScrolling = !1;
                    return;
                }
                this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
            }
        },
        {
            /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ key: "genHTML",
            value: function genHTML() {
                var _this_Editor = this.Editor, e = _this_Editor.UI, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $e310f5997d90c4d6$var$u.make("div", Be.CSS.overlay, {}), i = $e310f5997d90c4d6$var$u.make("div", Be.CSS.overlayContainer, {}), s = $e310f5997d90c4d6$var$u.make("div", Be.CSS.rect, {});
                return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
                    container: t1,
                    overlay: o
                };
            }
        },
        {
            /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ key: "scrollVertical",
            value: function scrollVertical(e) {
                var _this = this;
                if (!(this.inScrollZone && this.mousedown)) return;
                var t1 = window.pageYOffset;
                window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(function() {
                    _this.scrollVertical(e);
                }, 0);
            }
        },
        {
            /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ key: "changingRectangle",
            value: function changingRectangle(e) {
                if (!this.mousedown) return;
                e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
                var _this_genInfoForMouseSelection = this.genInfoForMouseSelection(), t1 = _this_genInfoForMouseSelection.rightPos, o = _this_genInfoForMouseSelection.leftPos, i = _this_genInfoForMouseSelection.index, s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
                this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $e310f5997d90c4d6$var$b.get().removeAllRanges());
            }
        },
        {
            /**
   * Shrink rect to singular point
   */ key: "shrinkRectangleToPoint",
            value: function shrinkRectangleToPoint() {
                this.overlayRectangle.style.left = "".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.top = "".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.right = "calc(100% - ".concat(this.startX - window.pageXOffset, "px");
            }
        },
        {
            /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ key: "inverseSelection",
            value: function inverseSelection() {
                var t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.rectCrossesBlocks && !t1) try {
                    for(var _iterator = this.stackOfSelected[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var o = _step.value;
                        this.Editor.BlockSelection.selectBlockByIndex(o);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (!this.rectCrossesBlocks && t1) try {
                    for(var _iterator1 = this.stackOfSelected[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var o1 = _step1.value;
                        this.Editor.BlockSelection.unSelectBlockByIndex(o1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            /**
   * Updates size of rectangle
   */ key: "updateRectangleSize",
            value: function updateRectangleSize() {
                this.mouseY >= this.startY ? (this.overlayRectangle.style.top = "".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.mouseY - window.pageYOffset, "px")) : (this.overlayRectangle.style.bottom = "calc(100% - ".concat(this.startY - window.pageYOffset, "px"), this.overlayRectangle.style.top = "".concat(this.mouseY - window.pageYOffset, "px")), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = "".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.right = "calc(100% - ".concat(this.mouseX - window.pageXOffset, "px")) : (this.overlayRectangle.style.right = "calc(100% - ".concat(this.startX - window.pageXOffset, "px"), this.overlayRectangle.style.left = "".concat(this.mouseX - window.pageXOffset, "px"));
            }
        },
        {
            /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ key: "genInfoForMouseSelection",
            value: function genInfoForMouseSelection() {
                var t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
                var r;
                s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex(function(h) {
                    return h.holder === s.holder;
                }));
                var a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $e310f5997d90c4d6$var$R.CSS.content), l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2, c = t1 - l, d = t1 + l;
                return {
                    index: r,
                    leftPos: c,
                    rightPos: d
                };
            }
        },
        {
            /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ key: "addBlockInSelection",
            value: function addBlockInSelection(e) {
                this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
            }
        },
        {
            /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ key: "trySelectNextBlock",
            value: function trySelectNextBlock(e) {
                var _this = this;
                var t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
                if (t1) return;
                var a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
                var l = r;
                o > 1 && (l = a ? i : s);
                var c = e > this.stackOfSelected[o - 1] && l === i, d = e < this.stackOfSelected[o - 1] && l === s, p = !(c || d || l === r);
                if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
                    var v = this.stackOfSelected[o - 1] + 1 || e;
                    for(v; v <= e; v++)this.addBlockInSelection(v);
                    return;
                }
                if (!p && e < this.stackOfSelected[o - 1]) {
                    for(var v1 = this.stackOfSelected[o - 1] - 1; v1 >= e; v1--)this.addBlockInSelection(v1);
                    return;
                }
                if (!p) return;
                var g = o - 1, f;
                for(e > this.stackOfSelected[o - 1] ? f = function() {
                    return e > _this.stackOfSelected[g];
                } : f = function() {
                    return e < _this.stackOfSelected[g];
                }; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
            }
        }
    ], [
        {
            key: "CSS",
            get: /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ function get() {
                return {
                    overlay: "codex-editor-overlay",
                    overlayContainer: "codex-editor-overlay__container",
                    rect: "codex-editor-overlay__rectangle",
                    topScrollZone: "codex-editor-overlay__scroll-zone--top",
                    bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
                };
            }
        }
    ]);
    return Be;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$ga = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(ga, E);
    function ga() {
        (0, $7lhcp._)(this, ga);
        return (0, $07dqX._)(this, ga, arguments);
    }
    (0, $8BtP9._)(ga, [
        {
            key: "render",
            value: /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ function render(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            new Promise(function(t1) {
                                var _this_Editor = _this.Editor, o = _this_Editor.Tools, i = _this_Editor.BlockManager;
                                if (e.length === 0) i.insert();
                                else {
                                    var s = e.map(function(param) {
                                        var r = param.type, a = param.data, l = param.tunes, c = param.id;
                                        o.available.has(r) === !1 && ($e310f5997d90c4d6$var$X("Tool \xab".concat(r, "\xbb is not found. Check 'tools' property at the Editor.js config."), "warn"), a = _this.composeStubDataForTool(r, a, c), r = o.stubTool);
                                        var d;
                                        try {
                                            d = i.composeBlock({
                                                id: c,
                                                tool: r,
                                                data: a,
                                                tunes: l
                                            });
                                        } catch (h) {
                                            $e310f5997d90c4d6$var$S("Block \xab".concat(r, "\xbb skipped because of plugins error"), "error", {
                                                data: a,
                                                error: h
                                            }), a = _this.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                                                id: c,
                                                tool: r,
                                                data: a,
                                                tunes: l
                                            });
                                        }
                                        return d;
                                    });
                                    i.insertMany(s);
                                }
                                window.requestIdleCallback(function() {
                                    t1();
                                }, {
                                    timeout: 2e3
                                });
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ key: "composeStubDataForTool",
            value: function composeStubDataForTool(e, t1, o) {
                var _this_Editor = this.Editor, i = _this_Editor.Tools;
                var s = e;
                if (i.unavailable.has(e)) {
                    var r = i.unavailable.get(e).toolbox;
                    r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
                }
                return {
                    savedData: {
                        id: o,
                        type: e,
                        data: t1
                    },
                    title: s
                };
            }
        }
    ]);
    return ga;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$ma = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(ma, E);
    function ma() {
        (0, $7lhcp._)(this, ma);
        return (0, $07dqX._)(this, ma, arguments);
    }
    (0, $8BtP9._)(ma, [
        {
            key: "save",
            value: /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ function save() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, _this_Editor, e, t1, o, i, _$s, r, s;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _this_Editor = this.Editor, e = _this_Editor.BlockManager, t1 = _this_Editor.Tools, o = e.blocks, i = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                o.forEach(function(a) {
                                    i.push(_this.getSavedData(a));
                                });
                                return [
                                    4,
                                    Promise.all(i)
                                ];
                            case 2:
                                _$s = _state.sent();
                                return [
                                    4,
                                    $e310f5997d90c4d6$var$yt(_$s, function(a) {
                                        return t1.blockTools.get(a).sanitizeConfig;
                                    })
                                ];
                            case 3:
                                r = _state.sent();
                                return [
                                    2,
                                    this.makeOutput(r)
                                ];
                            case 4:
                                s = _state.sent();
                                $e310f5997d90c4d6$var$X("Saving failed due to the Error %o", "error", s);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getSavedData",
            value: /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ function getSavedData(e) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var t1, o, _tmp;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    e.save()
                                ];
                            case 1:
                                t1 = _state.sent();
                                _tmp = t1;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    e.validate(t1.data)
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                o = _tmp;
                                return [
                                    2,
                                    (0, $ctBui._)((0, $6GCxi._)({}, t1), {
                                        isValid: o
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ key: "makeOutput",
            value: function makeOutput(e) {
                var _this = this;
                var t1 = [];
                return e.forEach(function(param) {
                    var o = param.id, i = param.tool, s = param.data, r = param.tunes, a = param.isValid;
                    if (!a) {
                        $e310f5997d90c4d6$var$S("Block \xab".concat(i, "\xbb skipped because saved data is invalid"));
                        return;
                    }
                    if (i === _this.Editor.Tools.stubTool) {
                        t1.push(s);
                        return;
                    }
                    var l = (0, $6GCxi._)({
                        id: o,
                        type: i,
                        data: s
                    }, !$e310f5997d90c4d6$var$V(r) && {
                        tunes: r
                    });
                    t1.push(l);
                }), {
                    time: +/* @__PURE__ */ new Date(),
                    blocks: t1,
                    version: "2.31.0"
                };
            }
        }
    ]);
    return ma;
}($e310f5997d90c4d6$var$E);
(function() {
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $5f0Cq._)(document)) < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
var $e310f5997d90c4d6$var$ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $e310f5997d90c4d6$var$va(n) {
    var _t;
    var e = document.createElement("div");
    e.innerHTML = n.trim();
    var t1 = document.createDocumentFragment();
    return (_t = t1).append.apply(_t, (0, $fsSDT._)(Array.from(e.childNodes))), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ var $e310f5997d90c4d6$var$fo = /*#__PURE__*/ function() {
    "use strict";
    function fo(param) {
        var e = param.data, t1 = param.config, o = param.api, i = param.readOnly;
        (0, $7lhcp._)(this, fo);
        var _t_preserveBlank;
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : fo.DEFAULT_PLACEHOLDER, this._data = e !== null && e !== void 0 ? e : {}, this._element = null, this._preserveBlank = (_t_preserveBlank = t1.preserveBlank) !== null && _t_preserveBlank !== void 0 ? _t_preserveBlank : !1;
    }
    (0, $8BtP9._)(fo, [
        {
            /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ key: "onKeyUp",
            value: function onKeyUp(e) {
                if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
                var _this__element = this._element, t1 = _this__element.textContent;
                t1 === "" && (this._element.innerHTML = "");
            }
        },
        {
            /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ key: "drawView",
            value: function drawView() {
                var e = document.createElement("DIV");
                return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
            }
        },
        {
            /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ key: "render",
            value: function render() {
                return this._element = this.drawView(), this._element;
            }
        },
        {
            /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ key: "merge",
            value: function merge(e) {
                if (!this._element) return;
                this._data.text += e.text;
                var t1 = $e310f5997d90c4d6$var$va(e.text);
                this._element.appendChild(t1), this._element.normalize();
            }
        },
        {
            /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ key: "validate",
            value: function validate(e) {
                return !(e.text.trim() === "" && !this._preserveBlank);
            }
        },
        {
            /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ key: "save",
            value: function save(e) {
                return {
                    text: e.innerHTML
                };
            }
        },
        {
            /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ key: "onPaste",
            value: function onPaste(e) {
                var _this = this;
                var t1 = {
                    text: e.detail.data.innerHTML
                };
                this._data = t1, window.requestAnimationFrame(function() {
                    _this._element && (_this._element.innerHTML = _this._data.text || "");
                });
            }
        }
    ], [
        {
            key: "DEFAULT_PLACEHOLDER",
            get: /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ function get() {
                return "";
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ function get() {
                return {
                    export: "text",
                    // to convert Paragraph to other block, use 'text' property of saved data
                    import: "text"
                };
            }
        },
        {
            key: "sanitize",
            get: /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ function get() {
                return {
                    text: {
                        br: !0
                    }
                };
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ function get() {
                return !0;
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ function get() {
                return {
                    tags: [
                        "P"
                    ]
                };
            }
        },
        {
            key: "toolbox",
            get: /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ function get() {
                return {
                    icon: $e310f5997d90c4d6$var$ba,
                    title: "Text"
                };
            }
        }
    ]);
    return fo;
}();
var $e310f5997d90c4d6$var$go = /*#__PURE__*/ function() {
    "use strict";
    function go() {
        (0, $7lhcp._)(this, go);
        this.commandName = "bold";
    }
    (0, $8BtP9._)(go, [
        {
            /**
   * Create button for Inline Toolbar
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $e310f5997d90c4d6$var$Ki,
                    name: "bold",
                    onActivate: function() {
                        document.execCommand(_this.commandName);
                    },
                    isActive: function() {
                        return document.queryCommandState(_this.commandName);
                    }
                };
            }
        },
        {
            key: "shortcut",
            get: /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ function get() {
                return "CMD+B";
            }
        }
    ], [
        {
            key: "sanitize",
            get: /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ function get() {
                return {
                    b: {}
                };
            }
        }
    ]);
    return go;
}();
$e310f5997d90c4d6$var$go.isInline = !0;
$e310f5997d90c4d6$var$go.title = "Bold";
var $e310f5997d90c4d6$var$mo = /*#__PURE__*/ function() {
    "use strict";
    function mo() {
        (0, $7lhcp._)(this, mo);
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    (0, $8BtP9._)(mo, [
        {
            /**
   * Create button for Inline Toolbar
   */ key: "render",
            value: function render() {
                return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $e310f5997d90c4d6$var$Ji, this.nodes.button;
            }
        },
        {
            /**
   * Wrap range with <i> tag
   */ key: "surround",
            value: function surround() {
                document.execCommand(this.commandName);
            }
        },
        {
            /**
   * Check selection and set activated state to button if there are <i> tag
   */ key: "checkState",
            value: function checkState() {
                var e = document.queryCommandState(this.commandName);
                return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
            }
        },
        {
            key: "shortcut",
            get: /**
   * Set a shortcut
   */ function get() {
                return "CMD+I";
            }
        }
    ], [
        {
            key: "sanitize",
            get: /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ function get() {
                return {
                    i: {}
                };
            }
        }
    ]);
    return mo;
}();
$e310f5997d90c4d6$var$mo.isInline = !0;
$e310f5997d90c4d6$var$mo.title = "Italic";
var $e310f5997d90c4d6$var$bo = /*#__PURE__*/ function() {
    "use strict";
    function bo(param) {
        var e = param.api;
        (0, $7lhcp._)(this, bo);
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $e310f5997d90c4d6$var$b();
    }
    (0, $8BtP9._)(bo, [
        {
            /**
   * Create button for Inline Toolbar
   */ key: "render",
            value: function render() {
                return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $e310f5997d90c4d6$var$Co, this.nodes.button;
            }
        },
        {
            /**
   * Input for the link
   */ key: "renderActions",
            value: function renderActions() {
                var _this = this;
                return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", function(e) {
                    e.keyCode === _this.ENTER_KEY && _this.enterPressed(e);
                }), this.nodes.input;
            }
        },
        {
            /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ key: "surround",
            value: function surround(e) {
                if (e) {
                    this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
                    var t1 = this.selection.findParentTag("A");
                    if (t1) {
                        this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close();
                        return;
                    }
                }
                this.toggleActions();
            }
        },
        {
            /**
   * Check selection and set activated state to button if there are <a> tag
   */ key: "checkState",
            value: function checkState() {
                var e = this.selection.findParentTag("A");
                if (e) {
                    this.nodes.button.innerHTML = $e310f5997d90c4d6$var$ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
                    var t1 = e.getAttribute("href");
                    this.nodes.input.value = t1 !== "null" ? t1 : "", this.selection.save();
                } else this.nodes.button.innerHTML = $e310f5997d90c4d6$var$Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
                return !!e;
            }
        },
        {
            /**
   * Function called with Inline Toolbar closing
   */ key: "clear",
            value: function clear() {
                this.closeActions();
            }
        },
        {
            key: "shortcut",
            get: /**
   * Set a shortcut
   */ function get() {
                return "CMD+K";
            }
        },
        {
            /**
   * Show/close link input
   */ key: "toggleActions",
            value: function toggleActions() {
                this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
            }
        },
        {
            /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ key: "openActions",
            value: function openActions() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
            }
        },
        {
            /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ key: "closeActions",
            value: function closeActions() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                if (this.selection.isFakeBackgroundEnabled) {
                    var t1 = new $e310f5997d90c4d6$var$b();
                    t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
                }
                this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
            }
        },
        {
            /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ key: "enterPressed",
            value: function enterPressed(e) {
                var t1 = this.nodes.input.value || "";
                if (!t1.trim()) {
                    this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
                    return;
                }
                if (!this.validateURL(t1)) {
                    this.notifier.show({
                        message: "Pasted link is not valid.",
                        style: "error"
                    }), $e310f5997d90c4d6$var$S("Incorrect Link pasted", "warn", t1);
                    return;
                }
                t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
            }
        },
        {
            /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ key: "validateURL",
            value: function validateURL(e) {
                return !/\s/.test(e);
            }
        },
        {
            /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ key: "prepareLink",
            value: function prepareLink(e) {
                return e = e.trim(), e = this.addProtocol(e), e;
            }
        },
        {
            /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ key: "addProtocol",
            value: function addProtocol(e) {
                if (/^(\w+):(\/\/)?/.test(e)) return e;
                var t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
                return !t1 && !o && !i && (e = "http://" + e), e;
            }
        },
        {
            /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ key: "insertLink",
            value: function insertLink(e) {
                var t1 = this.selection.findParentTag("A");
                t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
            }
        },
        {
            /**
   * Removes <a> tag
   */ key: "unlink",
            value: function unlink() {
                document.execCommand(this.commandUnlink);
            }
        }
    ], [
        {
            key: "sanitize",
            get: /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ function get() {
                return {
                    a: {
                        href: !0,
                        target: "_blank",
                        rel: "nofollow"
                    }
                };
            }
        }
    ]);
    return bo;
}();
$e310f5997d90c4d6$var$bo.isInline = !0;
$e310f5997d90c4d6$var$bo.title = "Link";
var $e310f5997d90c4d6$var$Fn = /*#__PURE__*/ function() {
    "use strict";
    function Fn(param) {
        var e = param.api;
        (0, $7lhcp._)(this, Fn);
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    (0, $8BtP9._)(Fn, [
        {
            key: "render",
            value: /**
   * Returns tool's UI config
   */ function render() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, e, t1, o, i, s, r, a, l;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                e = $e310f5997d90c4d6$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
                                if (t1 === void 0) return [
                                    2,
                                    []
                                ];
                                o = this.toolsAPI.getBlockTools();
                                return [
                                    4,
                                    $e310f5997d90c4d6$var$Yo(t1, o)
                                ];
                            case 1:
                                i = _state.sent();
                                if (i.length === 0) return [
                                    2,
                                    []
                                ];
                                s = i.reduce(function(c, d) {
                                    var h;
                                    return (h = d.toolbox) == null || h.forEach(function(p) {
                                        c.push({
                                            icon: p.icon,
                                            title: $e310f5997d90c4d6$var$z.t($e310f5997d90c4d6$var$K.toolNames, p.title),
                                            name: d.name,
                                            closeOnActivate: !0,
                                            onActivate: function() {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                    var g;
                                                    return (0, $Csf8W.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                return [
                                                                    4,
                                                                    this.blocksAPI.convert(t1.id, d.name, p.data)
                                                                ];
                                                            case 1:
                                                                g = _state.sent();
                                                                this.caretAPI.setToBlock(g, "end");
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }).call(_this);
                                            }
                                        });
                                    }), c;
                                }, []);
                                return [
                                    4,
                                    t1.getActiveToolboxEntry()
                                ];
                            case 2:
                                r = _state.sent(), a = r !== void 0 ? r.icon : $e310f5997d90c4d6$var$Go, l = !$e310f5997d90c4d6$var$be();
                                return [
                                    2,
                                    {
                                        icon: a,
                                        name: "convert-to",
                                        hint: {
                                            title: this.i18nAPI.t("Convert to")
                                        },
                                        children: {
                                            searchable: l,
                                            items: s,
                                            onOpen: function() {
                                                l && (_this.selectionAPI.setFakeBackground(), _this.selectionAPI.save());
                                            },
                                            onClose: function() {
                                                l && (_this.selectionAPI.restore(), _this.selectionAPI.removeFakeBackground());
                                            }
                                        }
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return Fn;
}();
$e310f5997d90c4d6$var$Fn.isInline = !0;
var $e310f5997d90c4d6$var$jn = /*#__PURE__*/ function() {
    "use strict";
    function jn(param) {
        var e = param.data, t1 = param.api;
        (0, $7lhcp._)(this, jn);
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    (0, $8BtP9._)(jn, [
        {
            /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ key: "render",
            value: function render() {
                return this.wrapper;
            }
        },
        {
            /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ key: "save",
            value: function save() {
                return this.savedData;
            }
        },
        {
            /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ key: "make",
            value: function make() {
                var e = $e310f5997d90c4d6$var$u.make("div", this.CSS.wrapper), t1 = $e310f5997d90c4d6$var$is, o = $e310f5997d90c4d6$var$u.make("div", this.CSS.info), i = $e310f5997d90c4d6$var$u.make("div", this.CSS.title, {
                    textContent: this.title
                }), s = $e310f5997d90c4d6$var$u.make("div", this.CSS.subtitle, {
                    textContent: this.subtitle
                });
                return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
            }
        }
    ]);
    return jn;
}();
$e310f5997d90c4d6$var$jn.isReadOnlySupported = !0;
var $e310f5997d90c4d6$var$ka = /*#__PURE__*/ function(Tt) {
    "use strict";
    (0, $h6w6E._)(ka, Tt);
    function ka() {
        (0, $7lhcp._)(this, ka);
        var _this;
        _this = (0, $07dqX._)(this, ka, arguments), _this.type = $e310f5997d90c4d6$var$ae.Inline;
        return _this;
    }
    (0, $8BtP9._)(ka, [
        {
            key: "title",
            get: /**
   * Returns title for Inline Tool if specified by user
   */ function get() {
                return this.constructable[$e310f5997d90c4d6$var$We.Title];
            }
        },
        {
            /**
   * Constructs new InlineTool instance from constructable
   */ key: "create",
            value: function create() {
                return new this.constructable({
                    api: this.api,
                    config: this.settings
                });
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Allows inline tool to be available in read-only mode
   * Can be used, for example, by comments tool
   */ function get() {
                var _this_constructable_We_IsReadOnlySupported;
                return (_this_constructable_We_IsReadOnlySupported = this.constructable[$e310f5997d90c4d6$var$We.IsReadOnlySupported]) !== null && _this_constructable_We_IsReadOnlySupported !== void 0 ? _this_constructable_We_IsReadOnlySupported : !1;
            }
        }
    ]);
    return ka;
}($e310f5997d90c4d6$var$Tt);
var $e310f5997d90c4d6$var$ya = /*#__PURE__*/ function(Tt) {
    "use strict";
    (0, $h6w6E._)(ya, Tt);
    function ya() {
        (0, $7lhcp._)(this, ya);
        var _this;
        _this = (0, $07dqX._)(this, ya, arguments), _this.type = $e310f5997d90c4d6$var$ae.Tune;
        return _this;
    }
    (0, $8BtP9._)(ya, [
        {
            /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ key: "create",
            value: function create(e, t1) {
                return new this.constructable({
                    api: this.api,
                    config: this.settings,
                    block: t1,
                    data: e
                });
            }
        }
    ]);
    return ya;
}($e310f5997d90c4d6$var$Tt);
var $e310f5997d90c4d6$var$j = /*#__PURE__*/ function(Map1) {
    "use strict";
    (0, $h6w6E._)(j, Map1);
    function j() {
        (0, $7lhcp._)(this, j);
        return (0, $07dqX._)(this, j, arguments);
    }
    (0, $8BtP9._)(j, [
        {
            key: "blockTools",
            get: /**
   * Returns Block Tools collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[1];
                    return t1.isBlock();
                });
                return new j(e);
            }
        },
        {
            key: "inlineTools",
            get: /**
   * Returns Inline Tools collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[1];
                    return t1.isInline();
                });
                return new j(e);
            }
        },
        {
            key: "blockTunes",
            get: /**
   * Returns Block Tunes collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[1];
                    return t1.isTune();
                });
                return new j(e);
            }
        },
        {
            key: "internalTools",
            get: /**
   * Returns internal Tools collection
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[1];
                    return t1.isInternal;
                });
                return new j(e);
            }
        },
        {
            key: "externalTools",
            get: /**
   * Returns Tools collection provided by user
   */ function get() {
                var e = Array.from(this.entries()).filter(function(param) {
                    var _param = (0, $leE2g._)(param, 2), t1 = _param[1];
                    return !t1.isInternal;
                });
                return new j(e);
            }
        }
    ]);
    return j;
}((0, $1Qmny._)(Map));
var $e310f5997d90c4d6$var$wa = Object.defineProperty, $e310f5997d90c4d6$var$Ea = Object.getOwnPropertyDescriptor, $e310f5997d90c4d6$var$Hn = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $e310f5997d90c4d6$var$Ea(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e310f5997d90c4d6$var$wa(e, t1, i), i;
};
var $e310f5997d90c4d6$var$vo = /*#__PURE__*/ function(Tt) {
    "use strict";
    (0, $h6w6E._)(vo, Tt);
    function vo() {
        (0, $7lhcp._)(this, vo);
        var _this;
        _this = (0, $07dqX._)(this, vo, arguments), _this.type = $e310f5997d90c4d6$var$ae.Block, _this.inlineTools = new $e310f5997d90c4d6$var$j(), _this.tunes = new $e310f5997d90c4d6$var$j();
        return _this;
    }
    (0, $8BtP9._)(vo, [
        {
            /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ key: "create",
            value: function create(e, t1, o) {
                return new this.constructable({
                    data: e,
                    block: t1,
                    readOnly: o,
                    api: this.api,
                    config: this.settings
                });
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Returns true if read-only mode is supported by Tool
   */ function get() {
                return this.constructable[$e310f5997d90c4d6$var$pe.IsReadOnlySupported] === !0;
            }
        },
        {
            key: "isLineBreaksEnabled",
            get: /**
   * Returns true if Tool supports linebreaks
   */ function get() {
                return this.constructable[$e310f5997d90c4d6$var$pe.IsEnabledLineBreaks];
            }
        },
        {
            key: "toolbox",
            get: /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ function get() {
                var e = this.constructable[$e310f5997d90c4d6$var$pe.Toolbox], t1 = this.config[$e310f5997d90c4d6$var$Pe.Toolbox];
                if (!$e310f5997d90c4d6$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map(function(o, i) {
                    var s = e[i];
                    return s ? (0, $6GCxi._)({}, s, o) : o;
                }) : [
                    t1
                ] : Array.isArray(t1) ? t1 : [
                    (0, $6GCxi._)({}, e, t1)
                ] : Array.isArray(e) ? e : [
                    e
                ];
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Returns Tool conversion configuration
   */ function get() {
                return this.constructable[$e310f5997d90c4d6$var$pe.ConversionConfig];
            }
        },
        {
            key: "enabledInlineTools",
            get: /**
   * Returns enabled inline tools for Tool
   */ function get() {
                return this.config[$e310f5997d90c4d6$var$Pe.EnabledInlineTools] || !1;
            }
        },
        {
            key: "enabledBlockTunes",
            get: /**
   * Returns enabled tunes for Tool
   */ function get() {
                return this.config[$e310f5997d90c4d6$var$Pe.EnabledBlockTunes];
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Returns Tool paste configuration
   */ function get() {
                var _this_constructable_pe_PasteConfig;
                return (_this_constructable_pe_PasteConfig = this.constructable[$e310f5997d90c4d6$var$pe.PasteConfig]) !== null && _this_constructable_pe_PasteConfig !== void 0 ? _this_constructable_pe_PasteConfig : {};
            }
        },
        {
            key: "sanitizeConfig",
            get: function get() {
                var e = (0, $5LQ10._)((0, $2JFuQ._)(vo.prototype), "sanitizeConfig", this), t1 = this.baseSanitizeConfig;
                if ($e310f5997d90c4d6$var$V(e)) return t1;
                var o = {};
                for(var i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
                    var s = e[i];
                    $e310f5997d90c4d6$var$D(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
                }
                return o;
            }
        },
        {
            key: "baseSanitizeConfig",
            get: function get() {
                var e = {};
                return Array.from(this.inlineTools.values()).forEach(function(t1) {
                    return Object.assign(e, t1.sanitizeConfig);
                }), Array.from(this.tunes.values()).forEach(function(t1) {
                    return Object.assign(e, t1.sanitizeConfig);
                }), e;
            }
        }
    ]);
    return vo;
}($e310f5997d90c4d6$var$Tt);
$e310f5997d90c4d6$var$Hn([
    $e310f5997d90c4d6$var$me
], $e310f5997d90c4d6$var$vo.prototype, "sanitizeConfig", 1);
$e310f5997d90c4d6$var$Hn([
    $e310f5997d90c4d6$var$me
], $e310f5997d90c4d6$var$vo.prototype, "baseSanitizeConfig", 1);
var $e310f5997d90c4d6$var$xa = /*#__PURE__*/ function() {
    "use strict";
    function xa(e, t1, o) {
        (0, $7lhcp._)(this, xa);
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    (0, $8BtP9._)(xa, [
        {
            /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ key: "get",
            value: function get(e) {
                var _this_config_e = this.config[e], t1 = _this_config_e.class, tmp = _this_config_e.isInternal, o = tmp === void 0 ? !1 : tmp, i = (0, $8MJI4._)(_this_config_e, [
                    "class",
                    "isInternal"
                ]), s = this.getConstructor(t1), r = t1[$e310f5997d90c4d6$var$mt.IsTune];
                return new s({
                    name: e,
                    constructable: t1,
                    config: i,
                    api: this.api.getMethodsForTool(e, r),
                    isDefault: e === this.editorConfig.defaultBlock,
                    defaultPlaceholder: this.editorConfig.placeholder,
                    isInternal: o
                });
            }
        },
        {
            /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ key: "getConstructor",
            value: function getConstructor(e) {
                switch(!0){
                    case e[$e310f5997d90c4d6$var$We.IsInline]:
                        return $e310f5997d90c4d6$var$ka;
                    case e[$e310f5997d90c4d6$var$mt.IsTune]:
                        return $e310f5997d90c4d6$var$ya;
                    default:
                        return $e310f5997d90c4d6$var$vo;
                }
            }
        }
    ]);
    return xa;
}();
var $e310f5997d90c4d6$var$$n = /*#__PURE__*/ function() {
    "use strict";
    function $n(param) {
        var e = param.api;
        (0, $7lhcp._)(this, $n);
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    (0, $8BtP9._)($n, [
        {
            /**
   * Tune's appearance in block settings menu
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $e310f5997d90c4d6$var$Xi,
                    title: this.api.i18n.t("Move down"),
                    onActivate: function() {
                        return _this.handleClick();
                    },
                    name: "move-down"
                };
            }
        },
        {
            /**
   * Handle clicks on 'move down' button
   */ key: "handleClick",
            value: function handleClick() {
                var e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
                if (!t1) throw new Error("Unable to move Block down since it is already the last");
                var o = t1.holder, i = o.getBoundingClientRect();
                var s = Math.abs(window.innerHeight - o.offsetHeight);
                i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
            }
        }
    ]);
    return $n;
}();
$e310f5997d90c4d6$var$$n.isTune = !0;
var $e310f5997d90c4d6$var$zn = /*#__PURE__*/ function() {
    "use strict";
    function zn(param) {
        var e = param.api;
        (0, $7lhcp._)(this, zn);
        this.api = e;
    }
    (0, $8BtP9._)(zn, [
        {
            /**
   * Tune's appearance in block settings menu
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $e310f5997d90c4d6$var$Gi,
                    title: this.api.i18n.t("Delete"),
                    name: "delete",
                    confirmation: {
                        title: this.api.i18n.t("Click to delete"),
                        onActivate: function() {
                            return _this.handleClick();
                        }
                    }
                };
            }
        },
        {
            /**
   * Delete block conditions passed
   */ key: "handleClick",
            value: function handleClick() {
                this.api.blocks.delete();
            }
        }
    ]);
    return zn;
}();
$e310f5997d90c4d6$var$zn.isTune = !0;
var $e310f5997d90c4d6$var$Un = /*#__PURE__*/ function() {
    "use strict";
    function Un(param) {
        var e = param.api;
        (0, $7lhcp._)(this, Un);
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    (0, $8BtP9._)(Un, [
        {
            /**
   * Tune's appearance in block settings menu
   */ key: "render",
            value: function render() {
                var _this = this;
                return {
                    icon: $e310f5997d90c4d6$var$Zi,
                    title: this.api.i18n.t("Move up"),
                    onActivate: function() {
                        return _this.handleClick();
                    },
                    name: "move-up"
                };
            }
        },
        {
            /**
   * Move current block up
   */ key: "handleClick",
            value: function handleClick() {
                var e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
                if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
                var i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), a = s.getBoundingClientRect();
                var l;
                a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
            }
        }
    ]);
    return Un;
}();
$e310f5997d90c4d6$var$Un.isTune = !0;
var $e310f5997d90c4d6$var$Ba = Object.defineProperty, $e310f5997d90c4d6$var$Ca = Object.getOwnPropertyDescriptor, $e310f5997d90c4d6$var$Ta = function(n, e, t1, o) {
    for(var i = o > 1 ? void 0 : o ? $e310f5997d90c4d6$var$Ca(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $e310f5997d90c4d6$var$Ba(e, t1, i), i;
};
var $e310f5997d90c4d6$var$Wn = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Wn, E);
    function Wn() {
        (0, $7lhcp._)(this, Wn);
        var _this;
        _this = (0, $07dqX._)(this, Wn, arguments), _this.stubTool = "stub", _this.toolsAvailable = new $e310f5997d90c4d6$var$j(), _this.toolsUnavailable = new $e310f5997d90c4d6$var$j();
        return _this;
    }
    (0, $8BtP9._)(Wn, [
        {
            key: "available",
            get: /**
   * Returns available Tools
   */ function get() {
                return this.toolsAvailable;
            }
        },
        {
            key: "unavailable",
            get: /**
   * Returns unavailable Tools
   */ function get() {
                return this.toolsUnavailable;
            }
        },
        {
            key: "inlineTools",
            get: /**
   * Return Tools for the Inline Toolbar
   */ function get() {
                return this.available.inlineTools;
            }
        },
        {
            key: "blockTools",
            get: /**
   * Return editor block tools
   */ function get() {
                return this.available.blockTools;
            }
        },
        {
            key: "blockTunes",
            get: /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ function get() {
                return this.available.blockTunes;
            }
        },
        {
            key: "defaultTool",
            get: /**
   * Returns default Tool object
   */ function get() {
                return this.blockTools.get(this.config.defaultBlock);
            }
        },
        {
            key: "internal",
            get: /**
   * Returns internal tools
   */ function get() {
                return this.available.internalTools;
            }
        },
        {
            key: "prepare",
            value: /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this, e, t1;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (this.validateTools(), this.config.tools = $e310f5997d90c4d6$var$ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
                                e = this.prepareConfig();
                                this.factory = new $e310f5997d90c4d6$var$xa(e, this.config, this.Editor.API);
                                t1 = this.getListOfPrepareFunctions(e);
                                if (t1.length === 0) return [
                                    2,
                                    Promise.resolve()
                                ];
                                return [
                                    4,
                                    $e310f5997d90c4d6$var$Qn(t1, function(o) {
                                        _this.toolPrepareMethodSuccess(o);
                                    }, function(o) {
                                        _this.toolPrepareMethodFallback(o);
                                    })
                                ];
                            case 1:
                                _state.sent(), this.prepareBlockTools();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getAllInlineToolsSanitizeConfig",
            value: function getAllInlineToolsSanitizeConfig() {
                var e = {};
                return Array.from(this.inlineTools.values()).forEach(function(t1) {
                    Object.assign(e, t1.sanitizeConfig);
                }), e;
            }
        },
        {
            /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ key: "destroy",
            value: function destroy() {
                Object.values(this.available).forEach(function(e) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var _tmp;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = $e310f5997d90c4d6$var$A(e.reset);
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        e.reset()
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                });
            }
        },
        {
            key: "internalTools",
            get: /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ function get() {
                return {
                    convertTo: {
                        class: $e310f5997d90c4d6$var$Fn,
                        isInternal: !0
                    },
                    link: {
                        class: $e310f5997d90c4d6$var$bo,
                        isInternal: !0
                    },
                    bold: {
                        class: $e310f5997d90c4d6$var$go,
                        isInternal: !0
                    },
                    italic: {
                        class: $e310f5997d90c4d6$var$mo,
                        isInternal: !0
                    },
                    paragraph: {
                        class: $e310f5997d90c4d6$var$fo,
                        inlineToolbar: !0,
                        isInternal: !0
                    },
                    stub: {
                        class: $e310f5997d90c4d6$var$jn,
                        isInternal: !0
                    },
                    moveUp: {
                        class: $e310f5997d90c4d6$var$Un,
                        isInternal: !0
                    },
                    delete: {
                        class: $e310f5997d90c4d6$var$zn,
                        isInternal: !0
                    },
                    moveDown: {
                        class: $e310f5997d90c4d6$var$$n,
                        isInternal: !0
                    }
                };
            }
        },
        {
            /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ key: "toolPrepareMethodSuccess",
            value: function toolPrepareMethodSuccess(e) {
                var t1 = this.factory.get(e.toolName);
                if (t1.isInline()) {
                    var i = [
                        "render"
                    ].filter(function(s) {
                        return !t1.create()[s];
                    });
                    if (i.length) {
                        $e310f5997d90c4d6$var$S("Incorrect Inline Tool: ".concat(t1.name, ". Some of required methods is not implemented %o"), "warn", i), this.toolsUnavailable.set(t1.name, t1);
                        return;
                    }
                }
                this.toolsAvailable.set(t1.name, t1);
            }
        },
        {
            /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ key: "toolPrepareMethodFallback",
            value: function toolPrepareMethodFallback(e) {
                this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
            }
        },
        {
            /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ key: "getListOfPrepareFunctions",
            value: function getListOfPrepareFunctions(e) {
                var t1 = [];
                return Object.entries(e).forEach(function(param) {
                    var _param = (0, $leE2g._)(param, 2), o = _param[0], i = _param[1];
                    t1.push({
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        function: $e310f5997d90c4d6$var$A(i.class.prepare) ? i.class.prepare : function() {},
                        data: {
                            toolName: o,
                            config: i.config
                        }
                    });
                }), t1;
            }
        },
        {
            /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ key: "prepareBlockTools",
            value: function prepareBlockTools() {
                var _this = this;
                Array.from(this.blockTools.values()).forEach(function(e) {
                    _this.assignInlineToolsToBlockTool(e), _this.assignBlockTunesToBlockTool(e);
                });
            }
        },
        {
            /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ key: "assignInlineToolsToBlockTool",
            value: function assignInlineToolsToBlockTool(e) {
                var _this = this;
                if (this.config.inlineToolbar !== !1) {
                    if (e.enabledInlineTools === !0) {
                        e.inlineTools = new $e310f5997d90c4d6$var$j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map(function(t1) {
                            return [
                                t1,
                                _this.inlineTools.get(t1)
                            ];
                        }) : Array.from(this.inlineTools.entries()));
                        return;
                    }
                    Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $e310f5997d90c4d6$var$j(/** Prepend ConvertTo Inline Tool */ [
                        "convertTo"
                    ].concat((0, $fsSDT._)(e.enabledInlineTools)).map(function(t1) {
                        return [
                            t1,
                            _this.inlineTools.get(t1)
                        ];
                    })));
                }
            }
        },
        {
            /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ key: "assignBlockTunesToBlockTool",
            value: function assignBlockTunesToBlockTool(e) {
                var _this = this;
                if (e.enabledBlockTunes !== !1) {
                    if (Array.isArray(e.enabledBlockTunes)) {
                        var t1 = new $e310f5997d90c4d6$var$j(e.enabledBlockTunes.map(function(o) {
                            return [
                                o,
                                _this.blockTunes.get(o)
                            ];
                        }));
                        e.tunes = new $e310f5997d90c4d6$var$j((0, $fsSDT._)(t1).concat((0, $fsSDT._)(this.blockTunes.internalTools)));
                        return;
                    }
                    if (Array.isArray(this.config.tunes)) {
                        var t2 = new $e310f5997d90c4d6$var$j(this.config.tunes.map(function(o) {
                            return [
                                o,
                                _this.blockTunes.get(o)
                            ];
                        }));
                        e.tunes = new $e310f5997d90c4d6$var$j((0, $fsSDT._)(t2).concat((0, $fsSDT._)(this.blockTunes.internalTools)));
                        return;
                    }
                    e.tunes = this.blockTunes.internalTools;
                }
            }
        },
        {
            /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ key: "validateTools",
            value: function validateTools() {
                for(var e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
                    if (e in this.internalTools) return;
                    var t1 = this.config.tools[e];
                    if (!$e310f5997d90c4d6$var$A(t1) && !$e310f5997d90c4d6$var$A(t1.class)) throw Error("Tool \xab".concat(e, "\xbb must be a constructor function or an object with function in the \xabclass\xbb property"));
                }
            }
        },
        {
            /**
   * Unify tools config
   */ key: "prepareConfig",
            value: function prepareConfig() {
                var e = {};
                for(var t1 in this.config.tools)$e310f5997d90c4d6$var$D(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
                    class: this.config.tools[t1]
                };
                return e;
            }
        }
    ]);
    return Wn;
}($e310f5997d90c4d6$var$E);
$e310f5997d90c4d6$var$Ta([
    $e310f5997d90c4d6$var$me
], $e310f5997d90c4d6$var$Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
var $e310f5997d90c4d6$var$Sa = ':root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}\n';
var $e310f5997d90c4d6$var$Ia = /*#__PURE__*/ function(E) {
    "use strict";
    (0, $h6w6E._)(Ia, E);
    function Ia() {
        (0, $7lhcp._)(this, Ia);
        var _this;
        _this = (0, $07dqX._)(this, Ia, arguments), _this.isMobile = !1, _this.contentRectCache = null, _this.resizeDebouncer = $e310f5997d90c4d6$var$Eo(function() {
            _this.windowResize();
        }, 200), _this.selectionChangeDebounced = $e310f5997d90c4d6$var$Eo(function() {
            _this.selectionChanged();
        }, $e310f5997d90c4d6$var$da), _this.documentTouchedListener = function(e) {
            _this.documentTouched(e);
        };
        return _this;
    }
    (0, $8BtP9._)(Ia, [
        {
            key: "CSS",
            get: /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ function get() {
                return {
                    editorWrapper: "codex-editor",
                    editorWrapperNarrow: "codex-editor--narrow",
                    editorZone: "codex-editor__redactor",
                    editorZoneHidden: "codex-editor__redactor--hidden",
                    editorEmpty: "codex-editor--empty",
                    editorRtlFix: "codex-editor--rtl"
                };
            }
        },
        {
            key: "contentRect",
            get: /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ function get() {
                if (this.contentRectCache !== null) return this.contentRectCache;
                var e = this.nodes.wrapper.querySelector(".".concat($e310f5997d90c4d6$var$R.CSS.content));
                return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
                    width: 650,
                    left: 0,
                    right: 0
                };
            }
        },
        {
            key: "prepare",
            value: /**
   * Making main interface
   */ function prepare() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        this.setIsMobile(), this.make(), this.loadStyles();
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ key: "toggleReadOnly",
            value: function toggleReadOnly(e) {
                var _this = this;
                e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(function() {
                    _this.bindReadOnlySensitiveListeners();
                }, {
                    timeout: 2e3
                });
            }
        },
        {
            /**
   * Check if Editor is empty and set CSS class to wrapper
   */ key: "checkEmptiness",
            value: function checkEmptiness() {
                var _this_Editor = this.Editor, e = _this_Editor.BlockManager;
                this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
            }
        },
        {
            key: "someToolbarOpened",
            get: /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ function get() {
                var _this_Editor = this.Editor, e = _this_Editor.Toolbar, t1 = _this_Editor.BlockSettings, o = _this_Editor.InlineToolbar;
                return !!(t1.opened || o.opened || e.toolbox.opened);
            }
        },
        {
            key: "someFlipperButtonFocused",
            get: /**
   * Check for some Flipper-buttons is under focus
   */ function get() {
                return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(function(param) {
                    var _param = (0, $leE2g._)(param, 2), e = _param[0], t1 = _param[1];
                    return t1.flipper instanceof $e310f5997d90c4d6$var$ce;
                }).some(function(param) {
                    var _param = (0, $leE2g._)(param, 2), e = _param[0], t1 = _param[1];
                    return t1.flipper.hasFocus();
                });
            }
        },
        {
            /**
   * Clean editor`s UI
   */ key: "destroy",
            value: function destroy() {
                this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
            }
        },
        {
            /**
   * Close all Editor's toolbars
   */ key: "closeAllToolbars",
            value: function closeAllToolbars() {
                var _this_Editor = this.Editor, e = _this_Editor.Toolbar, t1 = _this_Editor.BlockSettings, o = _this_Editor.InlineToolbar;
                t1.close(), o.close(), e.toolbox.close();
            }
        },
        {
            /**
   * Check for mobile mode and save the result
   */ key: "setIsMobile",
            value: function setIsMobile() {
                var e = window.innerWidth < $e310f5997d90c4d6$var$Ro;
                e !== this.isMobile && this.eventsDispatcher.emit($e310f5997d90c4d6$var$Te, {
                    isEnabled: this.isMobile
                }), this.isMobile = e;
            }
        },
        {
            /**
   * Makes Editor.js interface
   */ key: "make",
            value: function make() {
                this.nodes.holder = $e310f5997d90c4d6$var$u.getHolder(this.config.holder), this.nodes.wrapper = $e310f5997d90c4d6$var$u.make("div", [
                    this.CSS.editorWrapper
                ].concat((0, $fsSDT._)(this.isRtl ? [
                    this.CSS.editorRtlFix
                ] : []))), this.nodes.redactor = $e310f5997d90c4d6$var$u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
            }
        },
        {
            /**
   * Appends CSS
   */ key: "loadStyles",
            value: function loadStyles() {
                var e = "editor-js-styles";
                if ($e310f5997d90c4d6$var$u.get(e)) return;
                var t1 = $e310f5997d90c4d6$var$u.make("style", null, {
                    id: e,
                    textContent: $e310f5997d90c4d6$var$Sa.toString()
                });
                this.config.style && !$e310f5997d90c4d6$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $e310f5997d90c4d6$var$u.prepend(document.head, t1);
            }
        },
        {
            /**
   * Adds listeners that should work both in read-only and read-write modes
   */ key: "bindReadOnlyInsensitiveListeners",
            value: function bindReadOnlyInsensitiveListeners() {
                this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
                    passive: !0
                }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
                    capture: !0,
                    passive: !0
                }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
                    capture: !0,
                    passive: !0
                });
            }
        },
        {
            /**
   * Removes listeners that should work both in read-only and read-write modes
   */ key: "unbindReadOnlyInsensitiveListeners",
            value: function unbindReadOnlyInsensitiveListeners() {
                this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
            }
        },
        {
            /**
   * Adds listeners that should work only in read-only mode
   */ key: "bindReadOnlySensitiveListeners",
            value: function bindReadOnlySensitiveListeners() {
                var _this = this;
                this.readOnlyMutableListeners.on(this.nodes.redactor, "click", function(e) {
                    _this.redactorClicked(e);
                }, !1), this.readOnlyMutableListeners.on(document, "keydown", function(e) {
                    _this.documentKeydown(e);
                }, !0), this.readOnlyMutableListeners.on(document, "mousedown", function(e) {
                    _this.documentClicked(e);
                }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
            }
        },
        {
            /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ key: "watchBlockHoveredEvents",
            value: function watchBlockHoveredEvents() {
                var _this = this;
                var e;
                this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $e310f5997d90c4d6$var$dt(function(t1) {
                    var o = t1.target.closest(".ce-block");
                    _this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, _this.eventsDispatcher.emit($e310f5997d90c4d6$var$ln, {
                        block: _this.Editor.BlockManager.getBlockByChildNode(o)
                    }));
                }, 20), {
                    passive: !0
                });
            }
        },
        {
            /**
   * Unbind events that should work only in read-only mode
   */ key: "unbindReadOnlySensitiveListeners",
            value: function unbindReadOnlySensitiveListeners() {
                this.readOnlyMutableListeners.clearAll();
            }
        },
        {
            /**
   * Resize window handler
   */ key: "windowResize",
            value: function windowResize() {
                this.contentRectCache = null, this.setIsMobile();
            }
        },
        {
            /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "documentKeydown",
            value: function documentKeydown(e) {
                switch(e.keyCode){
                    case $e310f5997d90c4d6$var$y.ENTER:
                        this.enterPressed(e);
                        break;
                    case $e310f5997d90c4d6$var$y.BACKSPACE:
                    case $e310f5997d90c4d6$var$y.DELETE:
                        this.backspacePressed(e);
                        break;
                    case $e310f5997d90c4d6$var$y.ESC:
                        this.escapePressed(e);
                        break;
                    default:
                        this.defaultBehaviour(e);
                        break;
                }
            }
        },
        {
            /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "defaultBehaviour",
            value: function defaultBehaviour(e) {
                var _this_Editor_BlockManager = this.Editor.BlockManager, t1 = _this_Editor_BlockManager.currentBlock, o = e.target.closest(".".concat(this.CSS.editorWrapper)), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
                if (t1 !== void 0 && o === null) {
                    this.Editor.BlockEvents.keydown(e);
                    return;
                }
                o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
            }
        },
        {
            /**
   * @param {KeyboardEvent} event - keyboard event
   */ key: "backspacePressed",
            value: function backspacePressed(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection, i = _this_Editor.Caret;
                if (o.anyBlockSelected && !$e310f5997d90c4d6$var$b.isSelectionExists) {
                    var s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
                    i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
                }
            }
        },
        {
            /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ key: "escapePressed",
            value: function escapePressed(e) {
                this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
            }
        },
        {
            /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ key: "enterPressed",
            value: function enterPressed(e) {
                var _this_Editor = this.Editor, t1 = _this_Editor.BlockManager, o = _this_Editor.BlockSelection;
                if (this.someToolbarOpened) return;
                var i = t1.currentBlockIndex >= 0;
                if (o.anyBlockSelected && !$e310f5997d90c4d6$var$b.isSelectionExists) {
                    o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
                    return;
                }
                if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
                    var s = this.Editor.BlockManager.insert();
                    e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
                }
                this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ key: "documentClicked",
            value: function documentClicked(e) {
                var a, l;
                if (!e.isTrusted) return;
                var t1 = e.target;
                this.nodes.holder.contains(t1) || $e310f5997d90c4d6$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
                var i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t1), s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t1), r = i || s;
                if (this.Editor.BlockSettings.opened && !r) {
                    this.Editor.BlockSettings.close();
                    var c = this.Editor.BlockManager.getBlockByChildNode(t1);
                    this.Editor.Toolbar.moveAndOpen(c);
                }
                this.Editor.BlockSelection.clearSelection(e);
            }
        },
        {
            /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param event - touch or mouse event
   */ key: "documentTouched",
            value: function documentTouched(e) {
                var t1 = e.target;
                if (t1 === this.nodes.redactor) {
                    var o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
                    t1 = document.elementFromPoint(o, i);
                }
                try {
                    this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
                } catch (e) {
                    this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
                }
                this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
            }
        },
        {
            /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ key: "redactorClicked",
            value: function redactorClicked(e) {
                if (!$e310f5997d90c4d6$var$b.isCollapsed) return;
                var t1 = e.target, o = e.metaKey || e.ctrlKey;
                if ($e310f5997d90c4d6$var$u.isAnchor(t1) && o) {
                    e.stopImmediatePropagation(), e.stopPropagation();
                    var i = t1.getAttribute("href"), s = $e310f5997d90c4d6$var$oi(i);
                    $e310f5997d90c4d6$var$ii(s);
                    return;
                }
                this.processBottomZoneClick(e);
            }
        },
        {
            /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ key: "processBottomZoneClick",
            value: function processBottomZoneClick(e) {
                var t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $e310f5997d90c4d6$var$u.offset(t1.holder).bottom, i = e.pageY, _this_Editor = this.Editor, s = _this_Editor.BlockSelection;
                if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
                    e.stopImmediatePropagation(), e.stopPropagation();
                    var _this_Editor1 = this.Editor, a = _this_Editor1.BlockManager, l = _this_Editor1.Caret, c = _this_Editor1.Toolbar;
                    (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
                }
            }
        },
        {
            /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ key: "selectionChanged",
            value: function selectionChanged() {
                var _this_Editor = this.Editor, e = _this_Editor.CrossBlockSelection, t1 = _this_Editor.BlockSelection, o = $e310f5997d90c4d6$var$b.anchorElement;
                if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $e310f5997d90c4d6$var$b.get().removeAllRanges(), !o) {
                    $e310f5997d90c4d6$var$b.range || this.Editor.InlineToolbar.close();
                    return;
                }
                var i = o.closest(".".concat($e310f5997d90c4d6$var$R.CSS.content));
                (i === null || i.closest(".".concat($e310f5997d90c4d6$var$b.CSS.editorWrapper)) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
            }
        },
        {
            /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ key: "enableInputsEmptyMark",
            value: function enableInputsEmptyMark() {
                function e(t1) {
                    var o = t1.target;
                    $e310f5997d90c4d6$var$Do(o);
                }
                this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
            }
        }
    ]);
    return Ia;
}($e310f5997d90c4d6$var$E);
var $e310f5997d90c4d6$var$Oa = {
    // API Modules
    BlocksAPI: $e310f5997d90c4d6$var$gi,
    CaretAPI: $e310f5997d90c4d6$var$bi,
    EventsAPI: $e310f5997d90c4d6$var$vi,
    I18nAPI: $e310f5997d90c4d6$var$kt,
    API: $e310f5997d90c4d6$var$ki,
    InlineToolbarAPI: $e310f5997d90c4d6$var$yi,
    ListenersAPI: $e310f5997d90c4d6$var$wi,
    NotifierAPI: $e310f5997d90c4d6$var$Ci,
    ReadOnlyAPI: $e310f5997d90c4d6$var$Ti,
    SanitizerAPI: $e310f5997d90c4d6$var$Li,
    SaverAPI: $e310f5997d90c4d6$var$Pi,
    SelectionAPI: $e310f5997d90c4d6$var$Ni,
    ToolsAPI: $e310f5997d90c4d6$var$Ri,
    StylesAPI: $e310f5997d90c4d6$var$Di,
    ToolbarAPI: $e310f5997d90c4d6$var$Fi,
    TooltipAPI: $e310f5997d90c4d6$var$Ui,
    UiAPI: $e310f5997d90c4d6$var$Wi,
    // Toolbar Modules
    BlockSettings: $e310f5997d90c4d6$var$ms,
    Toolbar: $e310f5997d90c4d6$var$Bs,
    InlineToolbar: $e310f5997d90c4d6$var$Cs,
    // Modules
    BlockEvents: $e310f5997d90c4d6$var$na,
    BlockManager: $e310f5997d90c4d6$var$ra,
    BlockSelection: $e310f5997d90c4d6$var$aa,
    Caret: $e310f5997d90c4d6$var$Ye,
    CrossBlockSelection: $e310f5997d90c4d6$var$la,
    DragNDrop: $e310f5997d90c4d6$var$ca,
    ModificationsObserver: $e310f5997d90c4d6$var$ha,
    Paste: $e310f5997d90c4d6$var$pa,
    ReadOnly: $e310f5997d90c4d6$var$fa,
    RectangleSelection: $e310f5997d90c4d6$var$Be,
    Renderer: $e310f5997d90c4d6$var$ga,
    Saver: $e310f5997d90c4d6$var$ma,
    Tools: $e310f5997d90c4d6$var$Wn,
    UI: $e310f5997d90c4d6$var$Ia
};
var $e310f5997d90c4d6$var$_a = /*#__PURE__*/ function() {
    "use strict";
    function _a(e) {
        var _this = this;
        (0, $7lhcp._)(this, _a);
        this.moduleInstances = {}, this.eventsDispatcher = new $e310f5997d90c4d6$var$Oe();
        var t1, o;
        this.isReady = new Promise(function(i, s) {
            t1 = i, o = s;
        }), Promise.resolve().then(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                var _this_moduleInstances, i, s, r, a;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            this.configuration = e, this.validate(), this.init();
                            return [
                                4,
                                this.start()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.render()
                            ];
                        case 2:
                            _state.sent();
                            _this_moduleInstances = this.moduleInstances, i = _this_moduleInstances.BlockManager, s = _this_moduleInstances.Caret, r = _this_moduleInstances.UI, a = _this_moduleInstances.ModificationsObserver;
                            r.checkEmptiness(), a.enable(), this.configuration.autofocus === !0 && this.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t1();
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        }).catch(function(i) {
            $e310f5997d90c4d6$var$S("Editor.js is not ready because of ".concat(i), "error"), o(i);
        });
    }
    (0, $8BtP9._)(_a, [
        {
            key: "configuration",
            get: /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ function get() {
                return this.config;
            },
            set: /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ function set(e) {
                var o, i;
                $e310f5997d90c4d6$var$D(e) ? this.config = (0, $6GCxi._)({}, e) : this.config = {
                    holder: e
                }, $e310f5997d90c4d6$var$ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $e310f5997d90c4d6$var$Lo.VERBOSE), $e310f5997d90c4d6$var$Zn(this.config.logLevel), $e310f5997d90c4d6$var$ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
                var t1 = {
                    type: this.config.defaultBlock,
                    data: {}
                };
                this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
                    p: !0,
                    b: !0,
                    a: !0
                }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
                    blocks: []
                }, this.config.onReady = this.config.onReady || function() {}, this.config.onChange = this.config.onChange || function() {}, this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($e310f5997d90c4d6$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
                    blocks: [
                        t1
                    ]
                }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $e310f5997d90c4d6$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
            }
        },
        {
            /**
   * Checks for required fields in Editor's config
   */ key: "validate",
            value: function validate() {
                var _this_config = this.config, e = _this_config.holderId, t1 = _this_config.holder;
                if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
                if ($e310f5997d90c4d6$var$te(t1) && !$e310f5997d90c4d6$var$u.get(t1)) throw Error("element with ID \xab".concat(t1, "\xbb is missing. Pass correct holder's ID."));
                if (t1 && $e310f5997d90c4d6$var$D(t1) && !$e310f5997d90c4d6$var$u.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
            }
        },
        {
            /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ key: "init",
            value: function init() {
                this.constructModules(), this.configureModules();
            }
        },
        {
            key: "start",
            value: /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ function start() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var _this;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    [
                                        "Tools",
                                        "UI",
                                        "BlockManager",
                                        "Paste",
                                        "BlockSelection",
                                        "RectangleSelection",
                                        "CrossBlockSelection",
                                        "ReadOnly"
                                    ].reduce(function(t1, o) {
                                        return t1.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                var i;
                                                return (0, $Csf8W.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _state.trys.push([
                                                                0,
                                                                2,
                                                                ,
                                                                3
                                                            ]);
                                                            return [
                                                                4,
                                                                this.moduleInstances[o].prepare()
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            return [
                                                                3,
                                                                3
                                                            ];
                                                        case 2:
                                                            i = _state.sent();
                                                            if (i instanceof $e310f5997d90c4d6$var$Ho) throw new Error(i.message);
                                                            $e310f5997d90c4d6$var$S("Module ".concat(o, " was skipped because of %o"), "warn", i);
                                                            return [
                                                                3,
                                                                3
                                                            ];
                                                        case 3:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }).call(_this);
                                        });
                                    }, Promise.resolve())
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
   * Render initial data
   */ key: "render",
            value: function render() {
                return this.moduleInstances.Renderer.render(this.config.data.blocks);
            }
        },
        {
            /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ key: "constructModules",
            value: function constructModules() {
                var _this = this;
                Object.entries($e310f5997d90c4d6$var$Oa).forEach(function(param) {
                    var _param = (0, $leE2g._)(param, 2), e = _param[0], t1 = _param[1];
                    try {
                        _this.moduleInstances[e] = new t1({
                            config: _this.configuration,
                            eventsDispatcher: _this.eventsDispatcher
                        });
                    } catch (o) {
                        $e310f5997d90c4d6$var$S("[constructModules]", "Module ".concat(e, " skipped because"), "error", o);
                    }
                });
            }
        },
        {
            /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ key: "configureModules",
            value: function configureModules() {
                for(var e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
            }
        },
        {
            /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ key: "getModulesDiff",
            value: function getModulesDiff(e) {
                var t1 = {};
                for(var o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
                return t1;
            }
        }
    ]);
    return _a;
}();
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ var $e310f5997d90c4d6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Aa(e) {
        var _this = this;
        (0, $7lhcp._)(this, Aa);
        var t1 = function() {};
        $e310f5997d90c4d6$var$D(e) && $e310f5997d90c4d6$var$A(e.onReady) && (t1 = e.onReady);
        var o = new $e310f5997d90c4d6$var$_a(e);
        this.isReady = o.isReady.then(function() {
            _this.exportAPI(o), t1();
        });
    }
    (0, $8BtP9._)(Aa, [
        {
            /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ key: "exportAPI",
            value: function exportAPI(e) {
                var _this = this;
                var t1 = [
                    "configuration"
                ], o = function() {
                    Object.values(e.moduleInstances).forEach(function(s) {
                        $e310f5997d90c4d6$var$A(s.destroy) && s.destroy(), s.listeners.removeAll();
                    }), $e310f5997d90c4d6$var$zi(), e = null;
                    for(var s in _this)Object.prototype.hasOwnProperty.call(_this, s) && delete _this[s];
                    Object.setPrototypeOf(_this, null);
                };
                t1.forEach(function(s) {
                    _this[s] = e[s];
                }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
                    blocks: {
                        clear: "clear",
                        render: "render"
                    },
                    caret: {
                        focus: "focus"
                    },
                    events: {
                        on: "on",
                        off: "off",
                        emit: "emit"
                    },
                    saver: {
                        save: "save"
                    }
                }).forEach(function(param) {
                    var _param = (0, $leE2g._)(param, 2), s = _param[0], r = _param[1];
                    Object.entries(r).forEach(function(param) {
                        var _param = (0, $leE2g._)(param, 2), a = _param[0], l = _param[1];
                        _this[l] = e.moduleInstances.API.methods[s][a];
                    });
                });
            }
        }
    ], [
        {
            key: "version",
            get: /** Editor version */ function get() {
                return "2.31.0";
            }
        }
    ]);
    return Aa;
}();

});

parcelRegister("5aDIn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c40db05385952c$export$2e2bcd8739ae039; });

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");
(function() {
    "use strict";
    try {
        if ((typeof document === "undefined" ? "undefined" : (0, $5f0Cq._)(document)) < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
var $59c40db05385952c$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $59c40db05385952c$var$l(r) {
    var _e;
    var t = document.createElement("div");
    t.innerHTML = r.trim();
    var e = document.createDocumentFragment();
    return (_e = e).append.apply(_e, (0, $fsSDT._)(Array.from(t.childNodes))), e;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ var $59c40db05385952c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function n(param) {
        var t = param.data, e = param.config, i = param.api, s = param.readOnly;
        (0, $7lhcp._)(this, n);
        var _e_preserveBlank;
        this.api = i, this.readOnly = s, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = e.placeholder ? e.placeholder : n.DEFAULT_PLACEHOLDER, this._data = t !== null && t !== void 0 ? t : {}, this._element = null, this._preserveBlank = (_e_preserveBlank = e.preserveBlank) !== null && _e_preserveBlank !== void 0 ? _e_preserveBlank : !1;
    }
    (0, $8BtP9._)(n, [
        {
            /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ key: "onKeyUp",
            value: function onKeyUp(t) {
                if (t.code !== "Backspace" && t.code !== "Delete" || !this._element) return;
                var _this__element = this._element, e = _this__element.textContent;
                e === "" && (this._element.innerHTML = "");
            }
        },
        {
            /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ key: "drawView",
            value: function drawView() {
                var t = document.createElement("DIV");
                return t.classList.add(this._CSS.wrapper, this._CSS.block), t.contentEditable = "false", t.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (t.innerHTML = this._data.text), this.readOnly || (t.contentEditable = "true", t.addEventListener("keyup", this.onKeyUp)), t;
            }
        },
        {
            /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ key: "render",
            value: function render() {
                return this._element = this.drawView(), this._element;
            }
        },
        {
            /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ key: "merge",
            value: function merge(t) {
                if (!this._element) return;
                this._data.text += t.text;
                var e = $59c40db05385952c$var$l(t.text);
                this._element.appendChild(e), this._element.normalize();
            }
        },
        {
            /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ key: "validate",
            value: function validate(t) {
                return !(t.text.trim() === "" && !this._preserveBlank);
            }
        },
        {
            /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ key: "save",
            value: function save(t) {
                return {
                    text: t.innerHTML
                };
            }
        },
        {
            /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ key: "onPaste",
            value: function onPaste(t) {
                var _this = this;
                var e = {
                    text: t.detail.data.innerHTML
                };
                this._data = e, window.requestAnimationFrame(function() {
                    _this._element && (_this._element.innerHTML = _this._data.text || "");
                });
            }
        }
    ], [
        {
            key: "DEFAULT_PLACEHOLDER",
            get: /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ function get() {
                return "";
            }
        },
        {
            key: "conversionConfig",
            get: /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ function get() {
                return {
                    export: "text",
                    // to convert Paragraph to other block, use 'text' property of saved data
                    import: "text"
                };
            }
        },
        {
            key: "sanitize",
            get: /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ function get() {
                return {
                    text: {
                        br: !0
                    }
                };
            }
        },
        {
            key: "isReadOnlySupported",
            get: /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ function get() {
                return !0;
            }
        },
        {
            key: "pasteConfig",
            get: /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ function get() {
                return {
                    tags: [
                        "P"
                    ]
                };
            }
        },
        {
            key: "toolbox",
            get: /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ function get() {
                return {
                    icon: $59c40db05385952c$var$a,
                    title: "Text"
                };
            }
        }
    ]);
    return n;
}();

});


parcelRegister("kVnWJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f3bbb4c45f4ca0c5$export$2e2bcd8739ae039; });

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $Csf8W = parcelRequire("Csf8W");

var $6mMqj = parcelRequire("6mMqj");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f3bbb4c45f4ca0c5$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f3bbb4c45f4ca0c5$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f3bbb4c45f4ca0c5$var$ReactEditorJS(_a) {
    var factory = _a.factory, holder = _a.holder, defaultValue = _a.defaultValue, children = _a.children, value = _a.value, onInitialize = _a.onInitialize, restProps = $f3bbb4c45f4ca0c5$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    var memoizedHolder = (0, $6mMqj.default).useRef(holder !== null && holder !== void 0 ? holder : "react-editor-js-".concat(Date.now().toString(16)));
    var editorJS = (0, $6mMqj.default).useRef(null);
    (0, $6mMqj.default).useEffect(function() {
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return function() {
            var _$_a;
            (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.destroy();
        };
    }, []);
    (0, $6mMqj.default).useEffect(function() {
        var _$_a;
        if (value) (_$_a = editorJS.current) === null || _$_a === void 0 || _$_a.render(value);
    }, [
        value
    ]);
    return children || (0, $6mMqj.default).createElement("div", {
        id: memoizedHolder.current
    });
}
var $f3bbb4c45f4ca0c5$var$ServerEditorCore = /*#__PURE__*/ function() {
    "use strict";
    function ServerEditorCore(param) {
        var data = param.data;
        (0, $7lhcp._)(this, ServerEditorCore);
        if (data) this._memoizedData = data;
    }
    (0, $8BtP9._)(ServerEditorCore, [
        {
            key: "dangerouslyLowLevelInstance",
            get: function get() {
                return null;
            }
        },
        {
            key: "clear",
            value: function clear() {
                return $f3bbb4c45f4ca0c5$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                });
            }
        },
        {
            key: "save",
            value: function save() {
                return $f3bbb4c45f4ca0c5$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        return [
                            2,
                            this._memoizedData
                        ];
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $f3bbb4c45f4ca0c5$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return $f3bbb4c45f4ca0c5$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                });
            }
        }
    ]);
    return ServerEditorCore;
}();
function $f3bbb4c45f4ca0c5$export$2e2bcd8739ae039(props) {
    var factory = (0, $6mMqj.default).useCallback(function(config) {
        return new $f3bbb4c45f4ca0c5$var$ServerEditorCore(config);
    }, []);
    return (0, $6mMqj.default).createElement($f3bbb4c45f4ca0c5$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});

parcelRegister("dNvVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $hgwVv = parcelRequire("hgwVv");
function $a0b89debaf1d2861$var$emptyFunction() {}
function $a0b89debaf1d2861$var$emptyFunctionWithReset() {}
$a0b89debaf1d2861$var$emptyFunctionWithReset.resetWarningCache = $a0b89debaf1d2861$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hgwVv) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a0b89debaf1d2861$var$emptyFunctionWithReset,
        resetWarningCache: $a0b89debaf1d2861$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hgwVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $c91d78cefd8560cc$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $c91d78cefd8560cc$var$ReactPropTypesSecret;

});


parcelRegister("cInIr", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ 
var $5f0Cq = parcelRequire("5f0Cq");
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $5f0Cq._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, $5f0Cq._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("1a2Y6", function(module, exports) {

module.exports = (parcelRequire("5f7s9"))($parcel$resolve("7JXq8")).then(function() {
    return parcelRequire('ddAXi');
});

});
parcelRegister("5f7s9", function(module, exports) {
"use strict";

var $dp63s = parcelRequire("dp63s");
module.exports = $dp63s(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("dp63s", function(module, exports) {
"use strict";
var $0284aeaf97d328c5$var$cachedBundles = {};
var $0284aeaf97d328c5$var$cachedPreloads = {};
var $0284aeaf97d328c5$var$cachedPrefetches = {};
function $0284aeaf97d328c5$var$getCache(type) {
    switch(type){
        case 'preload':
            return $0284aeaf97d328c5$var$cachedPreloads;
        case 'prefetch':
            return $0284aeaf97d328c5$var$cachedPrefetches;
        default:
            return $0284aeaf97d328c5$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $0284aeaf97d328c5$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("1Vlz5", function(module, exports) {

module.exports = (parcelRequire("5f7s9"))($parcel$resolve("9V63F")).then(function() {
    return parcelRequire('dmHCI');
});

});

parcelRegister("l5IE3", function(module, exports) {

$parcel$export(module.exports, "marked", function () { return marked; });
/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ // src/defaults.ts

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");
var _class;
function _getDefaults() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
var _defaults = _getDefaults();
function changeDefaults(newDefaults) {
    _defaults = newDefaults;
}
// src/rules.ts
var noopTest = {
    exec: function() {
        return null;
    }
};
function edit(regex) {
    var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var source = typeof regex === "string" ? regex : regex.source;
    var obj = {
        replace: function(name, val) {
            var valSource = typeof val === "string" ? val : val.source;
            valSource = valSource.replace(other.caret, "$1");
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: function() {
            return new RegExp(source, opt);
        }
    };
    return obj;
}
var other = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: RegExp("[\\p{L}\\p{N}]", "u"),
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: function(bull) {
        return new RegExp("^( {0,3}".concat(bull, ")((?:[	 ][^\\n]*)?(?:\\n|$))"));
    },
    nextBulletRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))"));
    },
    hrRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"));
    },
    fencesBeginRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}(?:```|~~~)"));
    },
    headingBeginRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}#"));
    },
    htmlBeginRegex: function(indent) {
        return new RegExp("^ {0,".concat(Math.min(3, indent - 1), "}<(?:[a-z].*>|!--)"), "i");
    }
};
var newline = /^(?:[ \t]*(?:\n|$))+/;
var blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var bullet = /(?:[*+-]|\d{1,9}[.)])/;
var lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var lheading = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var blockText = /^[^\n]+/;
var _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
var _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
var blockNormal = {
    blockquote: blockquote,
    code: blockCode,
    def: def,
    fences: fences,
    heading: heading,
    hr: hr,
    html: html,
    lheading: lheading,
    list: list,
    newline: newline,
    paragraph: paragraph,
    table: noopTest,
    text: blockText
};
var gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockGfm = (0, $ctBui._)((0, $6GCxi._)({}, blockNormal), {
    lheading: lheadingGfm,
    table: gfmTable,
    paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex()
});
var blockPedantic = (0, $ctBui._)((0, $6GCxi._)({}, blockNormal), {
    html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
});
var escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var br = /^( {2,}|\\)\n(?!\s*$)/;
var inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var _punctuation = RegExp("[\\p{P}\\p{S}]", "u");
var _punctuationOrSpace = RegExp("[\\s\\p{P}\\p{S}]", "u");
var _notPunctuationOrSpace = RegExp("[^\\s\\p{P}\\p{S}]", "u");
var punctuation = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, _punctuationOrSpace).getRegex();
var _punctuationGfmStrongEm = RegExp("(?!~)[\\p{P}\\p{S}]", "u");
var _punctuationOrSpaceGfmStrongEm = RegExp("(?!~)[\\s\\p{P}\\p{S}]", "u");
var _notPunctuationOrSpaceGfmStrongEm = RegExp("(?:[^\\s\\p{P}\\p{S}]|~)", "u");
var blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var emStrongLDelim = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuation).getRegex();
var emStrongLDelimGfm = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var emStrongRDelimAst = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
var emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
var anyPunctuation = edit(/\\(punct)/, "gu").replace(/punct/g, _punctuation).getRegex();
var autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
var tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var link = edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
var nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
var reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
var inlineNormal = {
    _backpedal: noopTest,
    // only used for GFM url
    anyPunctuation: anyPunctuation,
    autolink: autolink,
    blockSkip: blockSkip,
    br: br,
    code: inlineCode,
    del: noopTest,
    emStrongLDelim: emStrongLDelim,
    emStrongRDelimAst: emStrongRDelimAst,
    emStrongRDelimUnd: emStrongRDelimUnd,
    escape: escape,
    link: link,
    nolink: nolink,
    punctuation: punctuation,
    reflink: reflink,
    reflinkSearch: reflinkSearch,
    tag: tag,
    text: inlineText,
    url: noopTest
};
var inlinePedantic = (0, $ctBui._)((0, $6GCxi._)({}, inlineNormal), {
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
});
var inlineGfm = (0, $ctBui._)((0, $6GCxi._)({}, inlineNormal), {
    emStrongRDelimAst: emStrongRDelimAstGfm,
    emStrongLDelim: emStrongLDelimGfm,
    url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
});
var inlineBreaks = (0, $ctBui._)((0, $6GCxi._)({}, inlineGfm), {
    br: edit(br).replace("{2,}", "*").getRegex(),
    text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
});
var block = {
    normal: blockNormal,
    gfm: blockGfm,
    pedantic: blockPedantic
};
var inline = {
    normal: inlineNormal,
    gfm: inlineGfm,
    breaks: inlineBreaks,
    pedantic: inlinePedantic
};
// src/helpers.ts
var escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var getEscapeReplacement = function(ch) {
    return escapeReplacements[ch];
};
function escape2(html2, encode) {
    if (encode) {
        if (other.escapeTest.test(html2)) return html2.replace(other.escapeReplace, getEscapeReplacement);
    } else {
        if (other.escapeTestNoEncode.test(html2)) return html2.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
    }
    return html2;
}
function cleanUrl(href) {
    try {
        href = encodeURI(href).replace(other.percentDecode, "%");
    } catch (e) {
        return null;
    }
    return href;
}
function splitCells(tableRow, count) {
    var _cells_at;
    var row = tableRow.replace(other.findPipe, function(match, offset, str) {
        var escaped = false;
        var curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row.split(other.splitPipe);
    var i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !((_cells_at = cells.at(-1)) === null || _cells_at === void 0 ? void 0 : _cells_at.trim())) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace(other.slashPipe, "|");
    return cells;
}
function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) return "";
    var suffLen = 0;
    while(suffLen < l){
        var currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    var level = 0;
    for(var i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}
// src/Tokenizer.ts
function outputLink(cap, link2, raw, lexer2, rules) {
    var href = link2.href;
    var title = link2.title || null;
    var text = cap[1].replace(rules.other.outputLinkReplace, "$1");
    lexer2.state.inLink = true;
    var token = {
        type: cap[0].charAt(0) === "!" ? "image" : "link",
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
}
function indentCodeCompensation(raw, text, rules) {
    var matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    var indentToCode = matchIndentToCode[1];
    return text.split("\n").map(function(node) {
        var matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        var _matchIndentInNode = (0, $leE2g._)(matchIndentInNode, 1), indentInNode = _matchIndentInNode[0];
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
var _Tokenizer = /*#__PURE__*/ function() {
    "use strict";
    function _Tokenizer(options2) {
        (0, $7lhcp._)(this, _Tokenizer);
        (0, $5RfYb._)(this, "options", void 0);
        (0, $5RfYb._)(this, "rules", void 0);
        // set by the lexer
        (0, $5RfYb._)(this, "lexer", void 0);
        this.options = options2 || _defaults;
    }
    (0, $8BtP9._)(_Tokenizer, [
        {
            key: "space",
            value: function space(src) {
                var cap = this.rules.block.newline.exec(src);
                if (cap && cap[0].length > 0) return {
                    type: "space",
                    raw: cap[0]
                };
            }
        },
        {
            key: "code",
            value: function code(src) {
                var cap = this.rules.block.code.exec(src);
                if (cap) {
                    var text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
                    return {
                        type: "code",
                        raw: cap[0],
                        codeBlockStyle: "indented",
                        text: !this.options.pedantic ? rtrim(text, "\n") : text
                    };
                }
            }
        },
        {
            key: "fences",
            value: function fences(src) {
                var cap = this.rules.block.fences.exec(src);
                if (cap) {
                    var raw = cap[0];
                    var text = indentCodeCompensation(raw, cap[3] || "", this.rules);
                    return {
                        type: "code",
                        raw: raw,
                        lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                        text: text
                    };
                }
            }
        },
        {
            key: "heading",
            value: function heading(src) {
                var cap = this.rules.block.heading.exec(src);
                if (cap) {
                    var text = cap[2].trim();
                    if (this.rules.other.endingHash.test(text)) {
                        var trimmed = rtrim(text, "#");
                        if (this.options.pedantic) text = trimmed.trim();
                        else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
                    }
                    return {
                        type: "heading",
                        raw: cap[0],
                        depth: cap[1].length,
                        text: text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
        },
        {
            key: "hr",
            value: function hr(src) {
                var cap = this.rules.block.hr.exec(src);
                if (cap) return {
                    type: "hr",
                    raw: rtrim(cap[0], "\n")
                };
            }
        },
        {
            key: "blockquote",
            value: function blockquote(src) {
                var cap = this.rules.block.blockquote.exec(src);
                if (cap) {
                    var lines = rtrim(cap[0], "\n").split("\n");
                    var raw = "";
                    var text = "";
                    var tokens = [];
                    while(lines.length > 0){
                        var inBlockquote = false;
                        var currentLines = [];
                        var i = void 0;
                        for(i = 0; i < lines.length; i++){
                            if (this.rules.other.blockquoteStart.test(lines[i])) {
                                currentLines.push(lines[i]);
                                inBlockquote = true;
                            } else if (!inBlockquote) currentLines.push(lines[i]);
                            else break;
                        }
                        lines = lines.slice(i);
                        var currentRaw = currentLines.join("\n");
                        var currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                        raw = raw ? "".concat(raw, "\n").concat(currentRaw) : currentRaw;
                        text = text ? "".concat(text, "\n").concat(currentText) : currentText;
                        var top = this.lexer.state.top;
                        this.lexer.state.top = true;
                        this.lexer.blockTokens(currentText, tokens, true);
                        this.lexer.state.top = top;
                        if (lines.length === 0) break;
                        var lastToken = tokens.at(-1);
                        if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "code") break;
                        else if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "blockquote") {
                            var oldToken = lastToken;
                            var newText = oldToken.raw + "\n" + lines.join("\n");
                            var newToken = this.blockquote(newText);
                            tokens[tokens.length - 1] = newToken;
                            raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                            text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                            break;
                        } else if ((lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "list") {
                            var oldToken1 = lastToken;
                            var newText1 = oldToken1.raw + "\n" + lines.join("\n");
                            var newToken1 = this.list(newText1);
                            tokens[tokens.length - 1] = newToken1;
                            raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken1.raw;
                            text = text.substring(0, text.length - oldToken1.raw.length) + newToken1.raw;
                            lines = newText1.substring(tokens.at(-1).raw.length).split("\n");
                            continue;
                        }
                    }
                    return {
                        type: "blockquote",
                        raw: raw,
                        tokens: tokens,
                        text: text
                    };
                }
            }
        },
        {
            key: "list",
            value: function list(src) {
                var _this = this;
                var cap = this.rules.block.list.exec(src);
                if (cap) {
                    var bull = cap[1].trim();
                    var isordered = bull.length > 1;
                    var list2 = {
                        type: "list",
                        raw: "",
                        ordered: isordered,
                        start: isordered ? +bull.slice(0, -1) : "",
                        loose: false,
                        items: []
                    };
                    bull = isordered ? "\\d{1,9}\\".concat(bull.slice(-1)) : "\\".concat(bull);
                    if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                    var itemRegex = this.rules.other.listItemRegex(bull);
                    var endsWithBlankLine = false;
                    while(src){
                        var endEarly = false;
                        var raw = "";
                        var itemContents = "";
                        if (!(cap = itemRegex.exec(src))) break;
                        if (this.rules.block.hr.test(src)) break;
                        raw = cap[0];
                        src = src.substring(raw.length);
                        var line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, function(t) {
                            return " ".repeat(3 * t.length);
                        });
                        var nextLine = src.split("\n", 1)[0];
                        var blankLine = !line.trim();
                        var indent = 0;
                        if (this.options.pedantic) {
                            indent = 2;
                            itemContents = line.trimStart();
                        } else if (blankLine) indent = cap[1].length + 1;
                        else {
                            indent = cap[2].search(this.rules.other.nonSpaceChar);
                            indent = indent > 4 ? 1 : indent;
                            itemContents = line.slice(indent);
                            indent += cap[1].length;
                        }
                        if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                            raw += nextLine + "\n";
                            src = src.substring(nextLine.length + 1);
                            endEarly = true;
                        }
                        if (!endEarly) {
                            var nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                            var hrRegex = this.rules.other.hrRegex(indent);
                            var fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                            var headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                            var htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                            while(src){
                                var rawLine = src.split("\n", 1)[0];
                                var nextLineWithoutTabs = void 0;
                                nextLine = rawLine;
                                if (this.options.pedantic) {
                                    nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                                    nextLineWithoutTabs = nextLine;
                                } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                                if (fencesBeginRegex.test(nextLine)) break;
                                if (headingBeginRegex.test(nextLine)) break;
                                if (htmlBeginRegex.test(nextLine)) break;
                                if (nextBulletRegex.test(nextLine)) break;
                                if (hrRegex.test(nextLine)) break;
                                if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                                else {
                                    if (blankLine) break;
                                    if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                                    if (fencesBeginRegex.test(line)) break;
                                    if (headingBeginRegex.test(line)) break;
                                    if (hrRegex.test(line)) break;
                                    itemContents += "\n" + nextLine;
                                }
                                if (!blankLine && !nextLine.trim()) blankLine = true;
                                raw += rawLine + "\n";
                                src = src.substring(rawLine.length + 1);
                                line = nextLineWithoutTabs.slice(indent);
                            }
                        }
                        if (!list2.loose) {
                            if (endsWithBlankLine) list2.loose = true;
                            else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                        }
                        var istask = null;
                        var ischecked = void 0;
                        if (this.options.gfm) {
                            istask = this.rules.other.listIsTask.exec(itemContents);
                            if (istask) {
                                ischecked = istask[0] !== "[ ] ";
                                itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                            }
                        }
                        list2.items.push({
                            type: "list_item",
                            raw: raw,
                            task: !!istask,
                            checked: ischecked,
                            loose: false,
                            text: itemContents,
                            tokens: []
                        });
                        list2.raw += raw;
                    }
                    var lastItem = list2.items.at(-1);
                    if (lastItem) {
                        lastItem.raw = lastItem.raw.trimEnd();
                        lastItem.text = lastItem.text.trimEnd();
                    } else return;
                    list2.raw = list2.raw.trimEnd();
                    for(var i = 0; i < list2.items.length; i++){
                        this.lexer.state.top = false;
                        list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                        if (!list2.loose) {
                            var spacers = list2.items[i].tokens.filter(function(t) {
                                return t.type === "space";
                            });
                            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                                return _this.rules.other.anyLine.test(t.raw);
                            });
                            list2.loose = hasMultipleLineBreaks;
                        }
                    }
                    if (list2.loose) for(var i1 = 0; i1 < list2.items.length; i1++)list2.items[i1].loose = true;
                    return list2;
                }
            }
        },
        {
            key: "html",
            value: function html(src) {
                var cap = this.rules.block.html.exec(src);
                if (cap) {
                    var token = {
                        type: "html",
                        block: true,
                        raw: cap[0],
                        pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                        text: cap[0]
                    };
                    return token;
                }
            }
        },
        {
            key: "def",
            value: function def(src) {
                var cap = this.rules.block.def.exec(src);
                if (cap) {
                    var tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
                    var href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                    var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                    return {
                        type: "def",
                        tag: tag2,
                        raw: cap[0],
                        href: href,
                        title: title
                    };
                }
            }
        },
        {
            key: "table",
            value: function table(src) {
                var _this = this;
                var _cap_;
                var cap = this.rules.block.table.exec(src);
                if (!cap) return;
                if (!this.rules.other.tableDelimiter.test(cap[2])) return;
                var headers = splitCells(cap[1]);
                var aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
                var rows = ((_cap_ = cap[3]) === null || _cap_ === void 0 ? void 0 : _cap_.trim()) ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
                var item = {
                    type: "table",
                    raw: cap[0],
                    header: [],
                    align: [],
                    rows: []
                };
                if (headers.length !== aligns.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = aligns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var align = _step.value;
                        if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
                        else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
                        else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
                        else item.align.push(null);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                for(var i = 0; i < headers.length; i++)item.header.push({
                    text: headers[i],
                    tokens: this.lexer.inline(headers[i]),
                    header: true,
                    align: item.align[i]
                });
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = rows[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var row = _step1.value;
                        item.rows.push(splitCells(row, item.header.length).map(function(cell, i) {
                            return {
                                text: cell,
                                tokens: _this.lexer.inline(cell),
                                header: false,
                                align: item.align[i]
                            };
                        }));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return item;
            }
        },
        {
            key: "lheading",
            value: function lheading(src) {
                var cap = this.rules.block.lheading.exec(src);
                if (cap) return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[2].charAt(0) === "=" ? 1 : 2,
                    text: cap[1],
                    tokens: this.lexer.inline(cap[1])
                };
            }
        },
        {
            key: "paragraph",
            value: function paragraph(src) {
                var cap = this.rules.block.paragraph.exec(src);
                if (cap) {
                    var text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                    return {
                        type: "paragraph",
                        raw: cap[0],
                        text: text,
                        tokens: this.lexer.inline(text)
                    };
                }
            }
        },
        {
            key: "text",
            value: function text(src) {
                var cap = this.rules.block.text.exec(src);
                if (cap) return {
                    type: "text",
                    raw: cap[0],
                    text: cap[0],
                    tokens: this.lexer.inline(cap[0])
                };
            }
        },
        {
            key: "escape",
            value: function escape(src) {
                var cap = this.rules.inline.escape.exec(src);
                if (cap) return {
                    type: "escape",
                    raw: cap[0],
                    text: cap[1]
                };
            }
        },
        {
            key: "tag",
            value: function tag(src) {
                var cap = this.rules.inline.tag.exec(src);
                if (cap) {
                    if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                    else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                    if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                    else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                    return {
                        type: "html",
                        raw: cap[0],
                        inLink: this.lexer.state.inLink,
                        inRawBlock: this.lexer.state.inRawBlock,
                        block: false,
                        text: cap[0]
                    };
                }
            }
        },
        {
            key: "link",
            value: function link(src) {
                var cap = this.rules.inline.link.exec(src);
                if (cap) {
                    var trimmedUrl = cap[2].trim();
                    if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                        if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                        var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                    } else {
                        var lastParenIndex = findClosingBracket(cap[2], "()");
                        if (lastParenIndex === -2) return;
                        if (lastParenIndex > -1) {
                            var start = cap[0].indexOf("!") === 0 ? 5 : 4;
                            var linkLen = start + cap[1].length + lastParenIndex;
                            cap[2] = cap[2].substring(0, lastParenIndex);
                            cap[0] = cap[0].substring(0, linkLen).trim();
                            cap[3] = "";
                        }
                    }
                    var href = cap[2];
                    var title = "";
                    if (this.options.pedantic) {
                        var link2 = this.rules.other.pedanticHrefTitle.exec(href);
                        if (link2) {
                            href = link2[1];
                            title = link2[3];
                        }
                    } else title = cap[3] ? cap[3].slice(1, -1) : "";
                    href = href.trim();
                    if (this.rules.other.startAngleBracket.test(href)) {
                        if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                        else href = href.slice(1, -1);
                    }
                    return outputLink(cap, {
                        href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                        title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                    }, cap[0], this.lexer, this.rules);
                }
            }
        },
        {
            key: "reflink",
            value: function reflink(src, links) {
                var cap;
                if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                    var linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
                    var link2 = links[linkString.toLowerCase()];
                    if (!link2) {
                        var text = cap[0].charAt(0);
                        return {
                            type: "text",
                            raw: text,
                            text: text
                        };
                    }
                    return outputLink(cap, link2, cap[0], this.lexer, this.rules);
                }
            }
        },
        {
            key: "emStrong",
            value: function emStrong(src, maskedSrc) {
                var prevChar = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                var match = this.rules.inline.emStrongLDelim.exec(src);
                if (!match) return;
                if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
                var nextChar = match[1] || match[2] || "";
                if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                    var lLength = (0, $fsSDT._)(match[0]).length - 1;
                    var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                    var endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                    endReg.lastIndex = 0;
                    maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                    while((match = endReg.exec(maskedSrc)) != null){
                        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                        if (!rDelim) continue;
                        rLength = (0, $fsSDT._)(rDelim).length;
                        if (match[3] || match[4]) {
                            delimTotal += rLength;
                            continue;
                        } else if (match[5] || match[6]) {
                            if (lLength % 3 && !((lLength + rLength) % 3)) {
                                midDelimTotal += rLength;
                                continue;
                            }
                        }
                        delimTotal -= rLength;
                        if (delimTotal > 0) continue;
                        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                        var lastCharLength = (0, $fsSDT._)(match[0])[0].length;
                        var raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                        if (Math.min(lLength, rLength) % 2) {
                            var text2 = raw.slice(1, -1);
                            return {
                                type: "em",
                                raw: raw,
                                text: text2,
                                tokens: this.lexer.inlineTokens(text2)
                            };
                        }
                        var text = raw.slice(2, -2);
                        return {
                            type: "strong",
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                }
            }
        },
        {
            key: "codespan",
            value: function codespan(src) {
                var cap = this.rules.inline.code.exec(src);
                if (cap) {
                    var text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
                    var hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                    var hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                    if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                    return {
                        type: "codespan",
                        raw: cap[0],
                        text: text
                    };
                }
            }
        },
        {
            key: "br",
            value: function br(src) {
                var cap = this.rules.inline.br.exec(src);
                if (cap) return {
                    type: "br",
                    raw: cap[0]
                };
            }
        },
        {
            key: "del",
            value: function del(src) {
                var cap = this.rules.inline.del.exec(src);
                if (cap) return {
                    type: "del",
                    raw: cap[0],
                    text: cap[2],
                    tokens: this.lexer.inlineTokens(cap[2])
                };
            }
        },
        {
            key: "autolink",
            value: function autolink(src) {
                var cap = this.rules.inline.autolink.exec(src);
                if (cap) {
                    var text, href;
                    if (cap[2] === "@") {
                        text = cap[1];
                        href = "mailto:" + text;
                    } else {
                        text = cap[1];
                        href = text;
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text: text,
                        href: href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text: text
                            }
                        ]
                    };
                }
            }
        },
        {
            key: "url",
            value: function url(src) {
                var cap;
                if (cap = this.rules.inline.url.exec(src)) {
                    var text, href;
                    if (cap[2] === "@") {
                        text = cap[0];
                        href = "mailto:" + text;
                    } else {
                        var prevCapZero;
                        do {
                            var _this_rules_inline__backpedal_exec;
                            prevCapZero = cap[0];
                            var _this_rules_inline__backpedal_exec_;
                            cap[0] = (_this_rules_inline__backpedal_exec_ = (_this_rules_inline__backpedal_exec = this.rules.inline._backpedal.exec(cap[0])) === null || _this_rules_inline__backpedal_exec === void 0 ? void 0 : _this_rules_inline__backpedal_exec[0]) !== null && _this_rules_inline__backpedal_exec_ !== void 0 ? _this_rules_inline__backpedal_exec_ : "";
                        }while (prevCapZero !== cap[0]);
                        text = cap[0];
                        if (cap[1] === "www.") href = "http://" + cap[0];
                        else href = cap[0];
                    }
                    return {
                        type: "link",
                        raw: cap[0],
                        text: text,
                        href: href,
                        tokens: [
                            {
                                type: "text",
                                raw: text,
                                text: text
                            }
                        ]
                    };
                }
            }
        },
        {
            key: "inlineText",
            value: function inlineText(src) {
                var cap = this.rules.inline.text.exec(src);
                if (cap) {
                    var escaped = this.lexer.state.inRawBlock;
                    return {
                        type: "text",
                        raw: cap[0],
                        text: cap[0],
                        escaped: escaped
                    };
                }
            }
        }
    ]);
    return _Tokenizer;
}();
// src/Lexer.ts
var _Lexer = /*#__PURE__*/ function() {
    "use strict";
    function __Lexer(options2) {
        (0, $7lhcp._)(this, __Lexer);
        (0, $5RfYb._)(this, "tokens", void 0);
        (0, $5RfYb._)(this, "options", void 0);
        (0, $5RfYb._)(this, "state", void 0);
        (0, $5RfYb._)(this, "tokenizer", void 0);
        (0, $5RfYb._)(this, "inlineQueue", void 0);
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options2 || _defaults;
        this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        var rules = {
            other: other,
            block: block.normal,
            inline: inline.normal
        };
        if (this.options.pedantic) {
            rules.block = block.pedantic;
            rules.inline = inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = block.gfm;
            if (this.options.breaks) rules.inline = inline.breaks;
            else rules.inline = inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    (0, $8BtP9._)(__Lexer, [
        {
            /**
   * Preprocessing
   */ key: "lex",
            value: function lex(src) {
                src = src.replace(other.carriageReturn, "\n");
                this.blockTokens(src, this.tokens);
                for(var i = 0; i < this.inlineQueue.length; i++){
                    var next = this.inlineQueue[i];
                    this.inlineTokens(next.src, next.tokens);
                }
                this.inlineQueue = [];
                return this.tokens;
            }
        },
        {
            key: "blockTokens",
            value: function blockTokens(src) {
                var _this, _loop = function() {
                    var _this_options_extensions_block, _this_options_extensions, _this_options_extensions1;
                    var token = void 0;
                    if ((_this_options_extensions = _this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_block = _this_options_extensions.block) === null || _this_options_extensions_block === void 0 ? void 0 : _this_options_extensions_block.some(function(extTokenizer) {
                        if (token = extTokenizer.call({
                            lexer: _this1
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) return "continue";
                    if (token = _this.tokenizer.space(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken = tokens.at(-1);
                        if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                        else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.code(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken1 = tokens.at(-1);
                        if ((lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "paragraph" || (lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "text") {
                            lastToken1.raw += "\n" + token.raw;
                            lastToken1.text += "\n" + token.text;
                            _this.inlineQueue.at(-1).src = lastToken1.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.fences(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.heading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.hr(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.blockquote(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.list(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.html(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.def(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken2 = tokens.at(-1);
                        if ((lastToken2 === null || lastToken2 === void 0 ? void 0 : lastToken2.type) === "paragraph" || (lastToken2 === null || lastToken2 === void 0 ? void 0 : lastToken2.type) === "text") {
                            lastToken2.raw += "\n" + token.raw;
                            lastToken2.text += "\n" + token.raw;
                            _this.inlineQueue.at(-1).src = lastToken2.text;
                        } else if (!_this.tokens.links[token.tag]) _this.tokens.links[token.tag] = {
                            href: token.href,
                            title: token.title
                        };
                        return "continue";
                    }
                    if (token = _this.tokenizer.table(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.lheading(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    var cutSrc = src;
                    if ((_this_options_extensions1 = _this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startBlock) {
                        var startIndex = Infinity;
                        var tempSrc = src.slice(1);
                        var tempStart = void 0;
                        _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                            tempStart = getStartIndex.call({
                                lexer: _this1
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (_this.state.top && (token = _this.tokenizer.paragraph(cutSrc))) {
                        var lastToken3 = tokens.at(-1);
                        if (lastParagraphClipped && (lastToken3 === null || lastToken3 === void 0 ? void 0 : lastToken3.type) === "paragraph") {
                            lastToken3.raw += "\n" + token.raw;
                            lastToken3.text += "\n" + token.text;
                            _this.inlineQueue.pop();
                            _this.inlineQueue.at(-1).src = lastToken3.text;
                        } else tokens.push(token);
                        lastParagraphClipped = cutSrc.length !== src.length;
                        src = src.substring(token.raw.length);
                        return "continue";
                    }
                    if (token = _this.tokenizer.text(src)) {
                        src = src.substring(token.raw.length);
                        var lastToken4 = tokens.at(-1);
                        if ((lastToken4 === null || lastToken4 === void 0 ? void 0 : lastToken4.type) === "text") {
                            lastToken4.raw += "\n" + token.raw;
                            lastToken4.text += "\n" + token.text;
                            _this.inlineQueue.pop();
                            _this.inlineQueue.at(-1).src = lastToken4.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (src) {
                        var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (_this.options.silent) {
                            console.error(errMsg);
                            return "break";
                        } else throw new Error(errMsg);
                    }
                };
                var _this1 = this;
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], lastParagraphClipped = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (this.options.pedantic) src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
                while(src){
                    var _ret = (_this = this, _loop());
                    if (_ret === "break") break;
                }
                this.state.top = true;
                return tokens;
            }
        },
        {
            key: "inline",
            value: function inline(src) {
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                this.inlineQueue.push({
                    src: src,
                    tokens: tokens
                });
                return tokens;
            }
        },
        {
            /**
   * Lexing/Compiling
   */ key: "inlineTokens",
            value: function inlineTokens(src) {
                var _this, _loop = function() {
                    var _this_options_extensions_inline, _this_options_extensions, _this_options_extensions1;
                    if (!keepPrevChar) prevChar = "";
                    keepPrevChar = false;
                    var token = void 0;
                    if ((_this_options_extensions = _this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_inline = _this_options_extensions.inline) === null || _this_options_extensions_inline === void 0 ? void 0 : _this_options_extensions_inline.some(function(extTokenizer) {
                        if (token = extTokenizer.call({
                            lexer: _this1
                        }, src, tokens)) {
                            src = src.substring(token.raw.length);
                            tokens.push(token);
                            return true;
                        }
                        return false;
                    })) return "continue";
                    if (token = _this.tokenizer.escape(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.tag(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.link(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.reflink(src, _this.tokens.links)) {
                        src = src.substring(token.raw.length);
                        var lastToken = tokens.at(-1);
                        if (token.type === "text" && (lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === "text") {
                            lastToken.raw += token.raw;
                            lastToken.text += token.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.codespan(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.br(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.del(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (token = _this.tokenizer.autolink(src)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    if (!_this.state.inLink && (token = _this.tokenizer.url(src))) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return "continue";
                    }
                    var cutSrc = src;
                    if ((_this_options_extensions1 = _this.options.extensions) === null || _this_options_extensions1 === void 0 ? void 0 : _this_options_extensions1.startInline) {
                        var startIndex = Infinity;
                        var tempSrc = src.slice(1);
                        var tempStart = void 0;
                        _this.options.extensions.startInline.forEach(function(getStartIndex) {
                            tempStart = getStartIndex.call({
                                lexer: _this1
                            }, tempSrc);
                            if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                        });
                        if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                    }
                    if (token = _this.tokenizer.inlineText(cutSrc)) {
                        src = src.substring(token.raw.length);
                        if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                        keepPrevChar = true;
                        var lastToken1 = tokens.at(-1);
                        if ((lastToken1 === null || lastToken1 === void 0 ? void 0 : lastToken1.type) === "text") {
                            lastToken1.raw += token.raw;
                            lastToken1.text += token.text;
                        } else tokens.push(token);
                        return "continue";
                    }
                    if (src) {
                        var errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                        if (_this.options.silent) {
                            console.error(errMsg);
                            return "break";
                        } else throw new Error(errMsg);
                    }
                };
                var _this1 = this;
                var tokens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var maskedSrc = src;
                var match = null;
                if (this.tokens.links) {
                    var links = Object.keys(this.tokens.links);
                    if (links.length > 0) {
                        while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                    }
                }
                while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
                while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
                var keepPrevChar = false;
                var prevChar = "";
                while(src){
                    var _ret = (_this = this, _loop());
                    if (_ret === "break") break;
                }
                return tokens;
            }
        }
    ], [
        {
            key: "rules",
            get: /**
   * Expose Rules
   */ function get() {
                return {
                    block: block,
                    inline: inline
                };
            }
        },
        {
            key: "lex",
            value: /**
   * Static Lex Method
   */ function lex(src, options2) {
                var lexer2 = new __Lexer(options2);
                return lexer2.lex(src);
            }
        },
        {
            key: "lexInline",
            value: /**
   * Static Lex Inline Method
   */ function lexInline(src, options2) {
                var lexer2 = new __Lexer(options2);
                return lexer2.inlineTokens(src);
            }
        }
    ]);
    return __Lexer;
}();
// src/Renderer.ts
var _Renderer = /*#__PURE__*/ function() {
    "use strict";
    function _Renderer(options2) {
        (0, $7lhcp._)(this, _Renderer);
        (0, $5RfYb._)(this, "options", void 0);
        (0, $5RfYb._)(this, "parser", void 0);
        this.options = options2 || _defaults;
    }
    (0, $8BtP9._)(_Renderer, [
        {
            key: "space",
            value: function space(token) {
                return "";
            }
        },
        {
            key: "code",
            value: function code(param) {
                var text = param.text, lang = param.lang, escaped = param.escaped;
                var _match;
                var langString = (_match = (lang || "").match(other.notSpaceStart)) === null || _match === void 0 ? void 0 : _match[0];
                var code = text.replace(other.endingNewline, "") + "\n";
                if (!langString) return "<pre><code>" + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
                return '<pre><code class="language-' + escape2(langString) + '">' + (escaped ? code : escape2(code, true)) + "</code></pre>\n";
            }
        },
        {
            key: "blockquote",
            value: function blockquote(param) {
                var tokens = param.tokens;
                var body = this.parser.parse(tokens);
                return "<blockquote>\n".concat(body, "</blockquote>\n");
            }
        },
        {
            key: "html",
            value: function html(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "heading",
            value: function heading(param) {
                var tokens = param.tokens, depth = param.depth;
                return "<h".concat(depth, ">").concat(this.parser.parseInline(tokens), "</h").concat(depth, ">\n");
            }
        },
        {
            key: "hr",
            value: function hr(token) {
                return "<hr>\n";
            }
        },
        {
            key: "list",
            value: function list(token) {
                var ordered = token.ordered;
                var start = token.start;
                var body = "";
                for(var j = 0; j < token.items.length; j++){
                    var item = token.items[j];
                    body += this.listitem(item);
                }
                var type = ordered ? "ol" : "ul";
                var startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
                return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
            }
        },
        {
            key: "listitem",
            value: function listitem(item) {
                var itemBody = "";
                if (item.task) {
                    var checkbox = this.checkbox({
                        checked: !!item.checked
                    });
                    if (item.loose) {
                        var _item_tokens_;
                        if (((_item_tokens_ = item.tokens[0]) === null || _item_tokens_ === void 0 ? void 0 : _item_tokens_.type) === "paragraph") {
                            item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                            if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                                item.tokens[0].tokens[0].text = checkbox + " " + escape2(item.tokens[0].tokens[0].text);
                                item.tokens[0].tokens[0].escaped = true;
                            }
                        } else item.tokens.unshift({
                            type: "text",
                            raw: checkbox + " ",
                            text: checkbox + " ",
                            escaped: true
                        });
                    } else itemBody += checkbox + " ";
                }
                itemBody += this.parser.parse(item.tokens, !!item.loose);
                return "<li>".concat(itemBody, "</li>\n");
            }
        },
        {
            key: "checkbox",
            value: function checkbox(param) {
                var checked = param.checked;
                return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
            }
        },
        {
            key: "paragraph",
            value: function paragraph(param) {
                var tokens = param.tokens;
                return "<p>".concat(this.parser.parseInline(tokens), "</p>\n");
            }
        },
        {
            key: "table",
            value: function table(token) {
                var header = "";
                var cell = "";
                for(var j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
                header += this.tablerow({
                    text: cell
                });
                var body = "";
                for(var j1 = 0; j1 < token.rows.length; j1++){
                    var row = token.rows[j1];
                    cell = "";
                    for(var k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                    body += this.tablerow({
                        text: cell
                    });
                }
                if (body) body = "<tbody>".concat(body, "</tbody>");
                return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
            }
        },
        {
            key: "tablerow",
            value: function tablerow(param) {
                var text = param.text;
                return "<tr>\n".concat(text, "</tr>\n");
            }
        },
        {
            key: "tablecell",
            value: function tablecell(token) {
                var content = this.parser.parseInline(token.tokens);
                var type = token.header ? "th" : "td";
                var tag2 = token.align ? "<".concat(type, ' align="').concat(token.align, '">') : "<".concat(type, ">");
                return tag2 + content + "</".concat(type, ">\n");
            }
        },
        {
            /**
   * span level renderer
   */ key: "strong",
            value: function strong(param) {
                var tokens = param.tokens;
                return "<strong>".concat(this.parser.parseInline(tokens), "</strong>");
            }
        },
        {
            key: "em",
            value: function em(param) {
                var tokens = param.tokens;
                return "<em>".concat(this.parser.parseInline(tokens), "</em>");
            }
        },
        {
            key: "codespan",
            value: function codespan(param) {
                var text = param.text;
                return "<code>".concat(escape2(text, true), "</code>");
            }
        },
        {
            key: "br",
            value: function br(token) {
                return "<br>";
            }
        },
        {
            key: "del",
            value: function del(param) {
                var tokens = param.tokens;
                return "<del>".concat(this.parser.parseInline(tokens), "</del>");
            }
        },
        {
            key: "link",
            value: function link(param) {
                var href = param.href, title = param.title, tokens = param.tokens;
                var text = this.parser.parseInline(tokens);
                var cleanHref = cleanUrl(href);
                if (cleanHref === null) return text;
                href = cleanHref;
                var out = '<a href="' + href + '"';
                if (title) out += ' title="' + escape2(title) + '"';
                out += ">" + text + "</a>";
                return out;
            }
        },
        {
            key: "image",
            value: function image(param) {
                var href = param.href, title = param.title, text = param.text, tokens = param.tokens;
                if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
                var cleanHref = cleanUrl(href);
                if (cleanHref === null) return escape2(text);
                href = cleanHref;
                var out = '<img src="'.concat(href, '" alt="').concat(text, '"');
                if (title) out += ' title="'.concat(escape2(title), '"');
                out += ">";
                return out;
            }
        },
        {
            key: "text",
            value: function text(token) {
                return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : escape2(token.text);
            }
        }
    ]);
    return _Renderer;
}();
// src/TextRenderer.ts
var _TextRenderer = /*#__PURE__*/ function() {
    "use strict";
    function _TextRenderer() {
        (0, $7lhcp._)(this, _TextRenderer);
    }
    (0, $8BtP9._)(_TextRenderer, [
        {
            // no need for block level renderers
            key: "strong",
            value: function strong(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "em",
            value: function em(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "codespan",
            value: function codespan(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "del",
            value: function del(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "html",
            value: function html(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "text",
            value: function text(param) {
                var text = param.text;
                return text;
            }
        },
        {
            key: "link",
            value: function link(param) {
                var text = param.text;
                return "" + text;
            }
        },
        {
            key: "image",
            value: function image(param) {
                var text = param.text;
                return "" + text;
            }
        },
        {
            key: "br",
            value: function br() {
                return "";
            }
        }
    ]);
    return _TextRenderer;
}();
// src/Parser.ts
var _Parser = /*#__PURE__*/ function() {
    "use strict";
    function __Parser(options2) {
        (0, $7lhcp._)(this, __Parser);
        (0, $5RfYb._)(this, "options", void 0);
        (0, $5RfYb._)(this, "renderer", void 0);
        (0, $5RfYb._)(this, "textRenderer", void 0);
        this.options = options2 || _defaults;
        this.options.renderer = this.options.renderer || new _Renderer();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new _TextRenderer();
    }
    (0, $8BtP9._)(__Parser, [
        {
            /**
   * Parse Loop
   */ key: "parse",
            value: function parse(tokens) {
                var top = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var out = "";
                for(var i = 0; i < tokens.length; i++){
                    var _this_options_extensions_renderers, _this_options_extensions;
                    var anyToken = tokens[i];
                    if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[anyToken.type]) {
                        var genericToken = anyToken;
                        var ret = this.options.extensions.renderers[genericToken.type].call({
                            parser: this
                        }, genericToken);
                        if (ret !== false || ![
                            "space",
                            "hr",
                            "heading",
                            "code",
                            "table",
                            "blockquote",
                            "list",
                            "html",
                            "paragraph",
                            "text"
                        ].includes(genericToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    var token = anyToken;
                    switch(token.type){
                        case "space":
                            out += this.renderer.space(token);
                            continue;
                        case "hr":
                            out += this.renderer.hr(token);
                            continue;
                        case "heading":
                            out += this.renderer.heading(token);
                            continue;
                        case "code":
                            out += this.renderer.code(token);
                            continue;
                        case "table":
                            out += this.renderer.table(token);
                            continue;
                        case "blockquote":
                            out += this.renderer.blockquote(token);
                            continue;
                        case "list":
                            out += this.renderer.list(token);
                            continue;
                        case "html":
                            out += this.renderer.html(token);
                            continue;
                        case "paragraph":
                            out += this.renderer.paragraph(token);
                            continue;
                        case "text":
                            {
                                var textToken = token;
                                var body = this.renderer.text(textToken);
                                while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                    textToken = tokens[++i];
                                    body += "\n" + this.renderer.text(textToken);
                                }
                                if (top) out += this.renderer.paragraph({
                                    type: "paragraph",
                                    raw: body,
                                    text: body,
                                    tokens: [
                                        {
                                            type: "text",
                                            raw: body,
                                            text: body,
                                            escaped: true
                                        }
                                    ]
                                });
                                else out += body;
                                continue;
                            }
                        default:
                            {
                                var errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
        },
        {
            /**
   * Parse Inline Tokens
   */ key: "parseInline",
            value: function parseInline(tokens) {
                var renderer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.renderer;
                var out = "";
                for(var i = 0; i < tokens.length; i++){
                    var _this_options_extensions_renderers, _this_options_extensions;
                    var anyToken = tokens[i];
                    if ((_this_options_extensions = this.options.extensions) === null || _this_options_extensions === void 0 ? void 0 : (_this_options_extensions_renderers = _this_options_extensions.renderers) === null || _this_options_extensions_renderers === void 0 ? void 0 : _this_options_extensions_renderers[anyToken.type]) {
                        var ret = this.options.extensions.renderers[anyToken.type].call({
                            parser: this
                        }, anyToken);
                        if (ret !== false || ![
                            "escape",
                            "html",
                            "link",
                            "image",
                            "strong",
                            "em",
                            "codespan",
                            "br",
                            "del",
                            "text"
                        ].includes(anyToken.type)) {
                            out += ret || "";
                            continue;
                        }
                    }
                    var token = anyToken;
                    switch(token.type){
                        case "escape":
                            out += renderer.text(token);
                            break;
                        case "html":
                            out += renderer.html(token);
                            break;
                        case "link":
                            out += renderer.link(token);
                            break;
                        case "image":
                            out += renderer.image(token);
                            break;
                        case "strong":
                            out += renderer.strong(token);
                            break;
                        case "em":
                            out += renderer.em(token);
                            break;
                        case "codespan":
                            out += renderer.codespan(token);
                            break;
                        case "br":
                            out += renderer.br(token);
                            break;
                        case "del":
                            out += renderer.del(token);
                            break;
                        case "text":
                            out += renderer.text(token);
                            break;
                        default:
                            {
                                var errMsg = 'Token with "' + token.type + '" type was not found.';
                                if (this.options.silent) {
                                    console.error(errMsg);
                                    return "";
                                } else throw new Error(errMsg);
                            }
                    }
                }
                return out;
            }
        }
    ], [
        {
            key: "parse",
            value: /**
   * Static Parse Method
   */ function parse(tokens, options2) {
                var parser2 = new __Parser(options2);
                return parser2.parse(tokens);
            }
        },
        {
            key: "parseInline",
            value: /**
   * Static Parse Inline Method
   */ function parseInline(tokens, options2) {
                var parser2 = new __Parser(options2);
                return parser2.parseInline(tokens);
            }
        }
    ]);
    return __Parser;
}();
// src/Hooks.ts
var _Hooks = (_class = /*#__PURE__*/ function() {
    "use strict";
    function _class(options2) {
        (0, $7lhcp._)(this, _class);
        (0, $5RfYb._)(this, "options", void 0);
        (0, $5RfYb._)(this, "block", void 0);
        this.options = options2 || _defaults;
    }
    (0, $8BtP9._)(_class, [
        {
            /**
   * Process markdown before marked
   */ key: "preprocess",
            value: function preprocess(markdown) {
                return markdown;
            }
        },
        {
            /**
   * Process HTML after marked is finished
   */ key: "postprocess",
            value: function postprocess(html2) {
                return html2;
            }
        },
        {
            /**
   * Process all tokens before walk tokens
   */ key: "processAllTokens",
            value: function processAllTokens(tokens) {
                return tokens;
            }
        },
        {
            /**
   * Provide function to tokenize markdown
   */ key: "provideLexer",
            value: function provideLexer() {
                return this.block ? _Lexer.lex : _Lexer.lexInline;
            }
        },
        {
            /**
   * Provide function to parse tokens
   */ key: "provideParser",
            value: function provideParser() {
                return this.block ? _Parser.parse : _Parser.parseInline;
            }
        }
    ]);
    return _class;
}(), (0, $5RfYb._)(_class, "passThroughHooks", /* @__PURE__ */ new Set([
    "preprocess",
    "postprocess",
    "processAllTokens"
])), _class);
// src/Instance.ts
var Marked = /*#__PURE__*/ function() {
    "use strict";
    function Marked() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, Marked);
        (0, $5RfYb._)(this, "defaults", _getDefaults());
        (0, $5RfYb._)(this, "options", this.setOptions);
        (0, $5RfYb._)(this, "parse", this.parseMarkdown(true));
        (0, $5RfYb._)(this, "parseInline", this.parseMarkdown(false));
        (0, $5RfYb._)(this, "Parser", _Parser);
        (0, $5RfYb._)(this, "Renderer", _Renderer);
        (0, $5RfYb._)(this, "TextRenderer", _TextRenderer);
        (0, $5RfYb._)(this, "Lexer", _Lexer);
        (0, $5RfYb._)(this, "Tokenizer", _Tokenizer);
        (0, $5RfYb._)(this, "Hooks", _Hooks);
        this.use.apply(this, (0, $fsSDT._)(args));
    }
    (0, $8BtP9._)(Marked, [
        {
            /**
   * Run callback for every token
   */ key: "walkTokens",
            value: function walkTokens(tokens, callback) {
                var _this = this;
                var values = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this1, _loop = function() {
                        var token = _step.value;
                        values = values.concat(callback.call(_this1, token));
                        switch(token.type){
                            case "table":
                                {
                                    var tableToken = token;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = tableToken.header[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var cell = _step1.value;
                                            values = values.concat(_this1.walkTokens(cell.tokens, callback));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator1 = tableToken.rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                            var row = _step2.value;
                                            try {
                                                for(var _iterator2 = row[Symbol.iterator](), _step3; !(_iteratorNormalCompletion1 = (_step3 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                                                    var cell1 = _step3.value;
                                                    values = values.concat(_this1.walkTokens(cell1.tokens, callback));
                                                }
                                            } catch (err) {
                                                _didIteratorError1 = true;
                                                _iteratorError1 = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                                                        _iterator2.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError1) {
                                                        throw _iteratorError1;
                                                    }
                                                }
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    break;
                                }
                            case "list":
                                {
                                    var listToken = token;
                                    values = values.concat(_this1.walkTokens(listToken.items, callback));
                                    break;
                                }
                            default:
                                {
                                    var _this_defaults_extensions_childTokens, _this_defaults_extensions;
                                    var genericToken = token;
                                    if ((_this_defaults_extensions = _this1.defaults.extensions) === null || _this_defaults_extensions === void 0 ? void 0 : (_this_defaults_extensions_childTokens = _this_defaults_extensions.childTokens) === null || _this_defaults_extensions_childTokens === void 0 ? void 0 : _this_defaults_extensions_childTokens[genericToken.type]) _this1.defaults.extensions.childTokens[genericToken.type].forEach(function(childTokens) {
                                        var tokens2 = genericToken[childTokens].flat(Infinity);
                                        values = values.concat(_this.walkTokens(tokens2, callback));
                                    });
                                    else if (genericToken.tokens) values = values.concat(_this1.walkTokens(genericToken.tokens, callback));
                                }
                        }
                    };
                    for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this1 = this, _loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return values;
            }
        },
        {
            key: "use",
            value: function use() {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var extensions = this.defaults.extensions || {
                    renderers: {},
                    childTokens: {}
                };
                args.forEach(function(pack) {
                    var opts = (0, $6GCxi._)({}, pack);
                    opts.async = _this.defaults.async || opts.async || false;
                    if (pack.extensions) {
                        pack.extensions.forEach(function(ext) {
                            if (!ext.name) throw new Error("extension name required");
                            if ("renderer" in ext) {
                                var prevRenderer = extensions.renderers[ext.name];
                                if (prevRenderer) extensions.renderers[ext.name] = function() {
                                    for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                        args2[_key] = arguments[_key];
                                    }
                                    var ret = ext.renderer.apply(this, args2);
                                    if (ret === false) ret = prevRenderer.apply(this, args2);
                                    return ret;
                                };
                                else extensions.renderers[ext.name] = ext.renderer;
                            }
                            if ("tokenizer" in ext) {
                                if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                                var extLevel = extensions[ext.level];
                                if (extLevel) extLevel.unshift(ext.tokenizer);
                                else extensions[ext.level] = [
                                    ext.tokenizer
                                ];
                                if (ext.start) {
                                    if (ext.level === "block") {
                                        if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                        else extensions.startBlock = [
                                            ext.start
                                        ];
                                    } else if (ext.level === "inline") {
                                        if (extensions.startInline) extensions.startInline.push(ext.start);
                                        else extensions.startInline = [
                                            ext.start
                                        ];
                                    }
                                }
                            }
                            if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                        });
                        opts.extensions = extensions;
                    }
                    if (pack.renderer) {
                        var _loop = function(prop) {
                            if (!(prop in renderer)) throw new Error("renderer '".concat(prop, "' does not exist"));
                            if ([
                                "options",
                                "parser"
                            ].includes(prop)) return "continue";
                            var rendererProp = prop;
                            var rendererFunc = pack.renderer[rendererProp];
                            var prevRenderer = renderer[rendererProp];
                            renderer[rendererProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = rendererFunc.apply(renderer, args2);
                                if (ret === false) ret = prevRenderer.apply(renderer, args2);
                                return ret || "";
                            };
                        };
                        var renderer = _this.defaults.renderer || new _Renderer(_this.defaults);
                        for(var prop in pack.renderer)_loop(prop);
                        opts.renderer = renderer;
                    }
                    if (pack.tokenizer) {
                        var _loop1 = function(prop1) {
                            if (!(prop1 in tokenizer)) throw new Error("tokenizer '".concat(prop1, "' does not exist"));
                            if ([
                                "options",
                                "rules",
                                "lexer"
                            ].includes(prop1)) return "continue";
                            var tokenizerProp = prop1;
                            var tokenizerFunc = pack.tokenizer[tokenizerProp];
                            var prevTokenizer = tokenizer[tokenizerProp];
                            tokenizer[tokenizerProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = tokenizerFunc.apply(tokenizer, args2);
                                if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                                return ret;
                            };
                        };
                        var tokenizer = _this.defaults.tokenizer || new _Tokenizer(_this.defaults);
                        for(var prop1 in pack.tokenizer)_loop1(prop1);
                        opts.tokenizer = tokenizer;
                    }
                    if (pack.hooks) {
                        var _loop2 = function(prop2) {
                            if (!(prop2 in hooks)) throw new Error("hook '".concat(prop2, "' does not exist"));
                            if ([
                                "options",
                                "block"
                            ].includes(prop2)) return "continue";
                            var hooksProp = prop2;
                            var hooksFunc = pack.hooks[hooksProp];
                            var prevHook = hooks[hooksProp];
                            if (_Hooks.passThroughHooks.has(prop2)) hooks[hooksProp] = function(arg) {
                                if (_this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then(function(ret2) {
                                    return prevHook.call(hooks, ret2);
                                });
                                var ret = hooksFunc.call(hooks, arg);
                                return prevHook.call(hooks, ret);
                            };
                            else hooks[hooksProp] = function() {
                                for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
                                    args2[_key] = arguments[_key];
                                }
                                var ret = hooksFunc.apply(hooks, args2);
                                if (ret === false) ret = prevHook.apply(hooks, args2);
                                return ret;
                            };
                        };
                        var hooks = _this.defaults.hooks || new _Hooks();
                        for(var prop2 in pack.hooks)_loop2(prop2);
                        opts.hooks = hooks;
                    }
                    if (pack.walkTokens) {
                        var walkTokens2 = _this.defaults.walkTokens;
                        var packWalktokens = pack.walkTokens;
                        opts.walkTokens = function(token) {
                            var values = [];
                            values.push(packWalktokens.call(this, token));
                            if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                            return values;
                        };
                    }
                    _this.defaults = (0, $6GCxi._)({}, _this.defaults, opts);
                });
                return this;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(opt) {
                this.defaults = (0, $6GCxi._)({}, this.defaults, opt);
                return this;
            }
        },
        {
            key: "lexer",
            value: function lexer(src, options2) {
                return _Lexer.lex(src, options2 !== null && options2 !== void 0 ? options2 : this.defaults);
            }
        },
        {
            key: "parser",
            value: function parser(tokens, options2) {
                return _Parser.parse(tokens, options2 !== null && options2 !== void 0 ? options2 : this.defaults);
            }
        },
        {
            key: "parseMarkdown",
            value: function parseMarkdown(blockType) {
                var _this = this;
                var parse2 = function(src, options2) {
                    var origOpt = (0, $6GCxi._)({}, options2);
                    var opt = (0, $6GCxi._)({}, _this.defaults, origOpt);
                    var throwError = _this.onError(!!opt.silent, !!opt.async);
                    if (_this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                    if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                    if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                    if (opt.hooks) {
                        opt.hooks.options = opt;
                        opt.hooks.block = blockType;
                    }
                    var lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                    var parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                    if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src2) {
                        return lexer2(src2, opt);
                    }).then(function(tokens) {
                        return opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens;
                    }).then(function(tokens) {
                        return opt.walkTokens ? Promise.all(_this.walkTokens(tokens, opt.walkTokens)).then(function() {
                            return tokens;
                        }) : tokens;
                    }).then(function(tokens) {
                        return parser2(tokens, opt);
                    }).then(function(html2) {
                        return opt.hooks ? opt.hooks.postprocess(html2) : html2;
                    }).catch(throwError);
                    try {
                        if (opt.hooks) src = opt.hooks.preprocess(src);
                        var tokens = lexer2(src, opt);
                        if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                        if (opt.walkTokens) _this.walkTokens(tokens, opt.walkTokens);
                        var html2 = parser2(tokens, opt);
                        if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                        return html2;
                    } catch (e) {
                        return throwError(e);
                    }
                };
                return parse2;
            }
        },
        {
            key: "onError",
            value: function onError(silent, async) {
                return function(e) {
                    e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                    if (silent) {
                        var msg = "<p>An error occurred:</p><pre>" + escape2(e.message + "", true) + "</pre>";
                        if (async) return Promise.resolve(msg);
                        return msg;
                    }
                    if (async) return Promise.reject(e);
                    throw e;
                };
            }
        }
    ]);
    return Marked;
}();
// src/marked.ts
var markedInstance = new Marked();
function marked(src, opt) {
    return markedInstance.parse(src, opt);
}
marked.options = marked.setOptions = function(options2) {
    markedInstance.setOptions(options2);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
marked.use = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _markedInstance;
    (_markedInstance = markedInstance).use.apply(_markedInstance, (0, $fsSDT._)(args));
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
};
marked.walkTokens = function(tokens, callback) {
    return markedInstance.walkTokens(tokens, callback);
};
marked.parseInline = markedInstance.parseInline;
marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
var options = marked.options;
var setOptions = marked.setOptions;
var use = marked.use;
var walkTokens = marked.walkTokens;
var parseInline = marked.parseInline;
var parse = marked;
var parser = _Parser.parse;
var lexer = _Lexer.lex;

});

parcelRegister("dKdZ4", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
var $5f0Cq = parcelRequire("5f0Cq");
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $5f0Cq._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, $5f0Cq._)(self)) == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(_$Object, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)['delete'](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data['delete'](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if ((typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join('') : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) _$result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + '', array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case 'drop':
                        start += _$size;
                        break;
                    case 'dropRight':
                        end -= _$size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + _$size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, $5f0Cq._)(index);
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var _$result = value + '';
            return _$result == '0' && 1 / value == -INFINITY ? '-0' : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == 'function' ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + 'return ' + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (_$result.__dir__ < 0 ? 'Right' : '')
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == 'function' && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && (0, $5f0Cq._)(define.amd) == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

});

var $ba25363c745335da$exports = {};
$parcel$extendImportMap({
    "7JXq8": "zh-TW.8e54626c.js",
    "9V63F": "en-US.6492aa8e.js"
});


var $5f0Cq = parcelRequire("5f0Cq");

var $fClfl = parcelRequire("fClfl");
var $1c838ced510d5939$var$t = /["&<]/;
function $1c838ced510d5939$var$n(r) {
    if (0 === r.length || !1 === $1c838ced510d5939$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $1c838ced510d5939$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $1c838ced510d5939$var$f = 0, $1c838ced510d5939$var$i = Array.isArray;
function $1c838ced510d5939$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$1c838ced510d5939$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $fClfl.options).vnode && (0, $fClfl.options).vnode(l), l;
}
function $1c838ced510d5939$export$45700d561b2268ac(r) {
    var t = $1c838ced510d5939$export$34b9dba7ce09269b((0, $fClfl.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $1c838ced510d5939$var$c = {}, $1c838ced510d5939$var$p = /[A-Z]/g;
function $1c838ced510d5939$export$991f6ffe102e5bac(e, t) {
    if ((0, $fClfl.options).attr) {
        var f = (0, $fClfl.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == (typeof r === "undefined" ? "undefined" : (0, $5f0Cq._)(r)) && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == (typeof t === "undefined" ? "undefined" : (0, $5f0Cq._)(t))) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $1c838ced510d5939$var$c[u] || ($1c838ced510d5939$var$c[u] = u.replace($1c838ced510d5939$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $1c838ced510d5939$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $1c838ced510d5939$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == (typeof t === "undefined" ? "undefined" : (0, $5f0Cq._)(t)) ? "" : !0 === t ? e : e + '="' + $1c838ced510d5939$var$n("" + t) + '"';
}
function $1c838ced510d5939$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == (typeof r === "undefined" ? "undefined" : (0, $5f0Cq._)(r))) {
        if (void 0 === r.constructor) return r;
        if ($1c838ced510d5939$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $1c838ced510d5939$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $1c838ced510d5939$var$n("" + r);
}


var $3959ba5a3cb8c567$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $3959ba5a3cb8c567$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $3959ba5a3cb8c567$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $3959ba5a3cb8c567$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $3959ba5a3cb8c567$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype;
    return promise;
};
$3959ba5a3cb8c567$var$InstrumentedPromise$1.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise.prototype;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $3959ba5a3cb8c567$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $3959ba5a3cb8c567$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $3959ba5a3cb8c567$export$cea1c58a6db52bca() {
    Promise = $3959ba5a3cb8c567$var$InstrumentedPromise$1;
}
function $3959ba5a3cb8c567$export$dfb5619354ba860() {
    if ($3959ba5a3cb8c567$export$baf72085f5fb4df()) $3959ba5a3cb8c567$export$cea1c58a6db52bca();
}
var $3959ba5a3cb8c567$export$2e2bcd8739ae039 = $3959ba5a3cb8c567$var$InstrumentedPromise$1;



var $hp59o = parcelRequire("hp59o");

var $arNK5 = parcelRequire("arNK5");

var $6mMqj = parcelRequire("6mMqj");
function $e50729c8f73eecd9$export$882461b6382ed46c(container) {
    return {
        // eslint-disable-next-line
        render: function render1(children) {
            (0, $6mMqj.render)(children, container);
        },
        // eslint-disable-next-line
        unmount: function unmount() {
            (0, $6mMqj.unmountComponentAtNode)(container);
        }
    };
}
function $e50729c8f73eecd9$export$757ceba2d55c277e(container, children) {
    (0, $6mMqj.hydrate)(children, container);
    return $e50729c8f73eecd9$export$882461b6382ed46c(container);
}
var $e50729c8f73eecd9$export$2e2bcd8739ae039 = {
    createRoot: $e50729c8f73eecd9$export$882461b6382ed46c,
    hydrateRoot: $e50729c8f73eecd9$export$757ceba2d55c277e
};



var $6tqvJ = parcelRequire("6tqvJ");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");
var $610b646be40f0c4b$exports = {};

$parcel$export($610b646be40f0c4b$exports, "promisifyRequest", function () { return $610b646be40f0c4b$export$b327150396135fe7; });
$parcel$export($610b646be40f0c4b$exports, "createStore", function () { return $610b646be40f0c4b$export$f51a9068ac82ea43; });
$parcel$export($610b646be40f0c4b$exports, "get", function () { return $610b646be40f0c4b$export$3988ae62b71be9a3; });
$parcel$export($610b646be40f0c4b$exports, "set", function () { return $610b646be40f0c4b$export$adaa4cf7ef1b65be; });
$parcel$export($610b646be40f0c4b$exports, "setMany", function () { return $610b646be40f0c4b$export$daa0a5170277c7a8; });
$parcel$export($610b646be40f0c4b$exports, "getMany", function () { return $610b646be40f0c4b$export$5df405cccea42673; });
$parcel$export($610b646be40f0c4b$exports, "update", function () { return $610b646be40f0c4b$export$722fbec263ad908a; });
$parcel$export($610b646be40f0c4b$exports, "del", function () { return $610b646be40f0c4b$export$1d2f21e549771e67; });
$parcel$export($610b646be40f0c4b$exports, "delMany", function () { return $610b646be40f0c4b$export$c8aa84257229cac8; });
$parcel$export($610b646be40f0c4b$exports, "clear", function () { return $610b646be40f0c4b$export$42ffd38884aecdac; });
$parcel$export($610b646be40f0c4b$exports, "keys", function () { return $610b646be40f0c4b$export$ed97f33186d4b816; });
$parcel$export($610b646be40f0c4b$exports, "values", function () { return $610b646be40f0c4b$export$68c286be0e7e55b7; });
$parcel$export($610b646be40f0c4b$exports, "entries", function () { return $610b646be40f0c4b$export$3e9f948b41964866; });

var $leE2g = parcelRequire("leE2g");
function $610b646be40f0c4b$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $610b646be40f0c4b$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp;
    var getDB = function() {
        if (dbp) return dbp;
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        dbp = $610b646be40f0c4b$export$b327150396135fe7(request);
        dbp.then(function(db) {
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = function() {
                return dbp = undefined;
            };
        }, function() {});
        return dbp;
    };
    return function(txMode, callback) {
        return getDB().then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $610b646be40f0c4b$var$defaultGetStoreFunc;
function $610b646be40f0c4b$var$defaultGetStore() {
    if (!$610b646be40f0c4b$var$defaultGetStoreFunc) $610b646be40f0c4b$var$defaultGetStoreFunc = $610b646be40f0c4b$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $610b646be40f0c4b$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return $610b646be40f0c4b$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.put(value, key);
        return $610b646be40f0c4b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $610b646be40f0c4b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return Promise.all(keys.map(function(key) {
            return $610b646be40f0c4b$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        return(// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($610b646be40f0c4b$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.delete(key);
        return $610b646be40f0c4b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $610b646be40f0c4b$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.clear();
        return $610b646be40f0c4b$export$b327150396135fe7(store.transaction);
    });
}
function $610b646be40f0c4b$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $610b646be40f0c4b$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $610b646be40f0c4b$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $610b646be40f0c4b$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $610b646be40f0c4b$export$b327150396135fe7(store.getAll());
        var items = [];
        return $610b646be40f0c4b$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $610b646be40f0c4b$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $610b646be40f0c4b$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $610b646be40f0c4b$export$b327150396135fe7(store.getAllKeys()),
            $610b646be40f0c4b$export$b327150396135fe7(store.getAll())
        ]).then(function(param) {
            var _param = (0, $leE2g._)(param, 2), keys = _param[0], values = _param[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore('readonly', function(store) {
            return $610b646be40f0c4b$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}



var $hp59o = parcelRequire("hp59o");

var $arNK5 = parcelRequire("arNK5");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");
function $4b94edc8487dfe49$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");

var $Csf8W = parcelRequire("Csf8W");

var $arNK5 = parcelRequire("arNK5");

var $6tqvJ = parcelRequire("6tqvJ");

function $a1830bff0fabd0b0$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $a1830bff0fabd0b0$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $a1830bff0fabd0b0$var$$082ef78710a13331$exports = {};
var $a1830bff0fabd0b0$var$$80184bab4212ab17$exports = {};
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$exports = {};
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $a1830bff0fabd0b0$export$e03c1c3201ee8bb7;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $a1830bff0fabd0b0$export$6287f85d0f6a9342;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$400caf514fe4dd82$exports, "PersistNode", function() {
    return $a1830bff0fabd0b0$export$d1e7755b007c0847;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$400caf514fe4dd82$exports, "persist", function() {
    return $a1830bff0fabd0b0$export$9a6132153fba2e0;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$400caf514fe4dd82$exports, "restore", function() {
    return $a1830bff0fabd0b0$export$db239ef39aadc7fe;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $a1830bff0fabd0b0$export$b1fb4cac938035f7;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$400caf514fe4dd82$exports, "persistList", function() {
    return $a1830bff0fabd0b0$export$8001d3a0cfa5d8fd;
});
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__esDecorate = function $400caf514fe4dd82$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers = function $400caf514fe4dd82$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter = function $400caf514fe4dd82$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldGet = function $400caf514fe4dd82$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldSet = function $400caf514fe4dd82$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__rest = function $400caf514fe4dd82$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $a1830bff0fabd0b0$export$e03c1c3201ee8bb7(property) {
    return function(origin, param) {
        var ref = (0, $4b94edc8487dfe49$export$71511d61b312f219)(param);
        return function() {
            for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
                data[_key] = arguments[_key];
            }
            return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                var value;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            value = Reflect.get(this, property);
                            Reflect.set(this, property, typeof value === 'number' ? ++value : true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                origin.apply(this, data)
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            value = Reflect.get(this, property);
                            Reflect.set(this, property, typeof value === 'number' ? --value : false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
}
function $a1830bff0fabd0b0$export$6287f85d0f6a9342(message) {
    return function(origin, param) {
        var ref = (0, $4b94edc8487dfe49$export$71511d61b312f219)(param);
        return function() {
            for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
                data[_key] = arguments[_key];
            }
            return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                var _this, notification;
                return (0, $Csf8W.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            notification = Notification.requestPermission().then(function(permission) {
                                if (permission === 'granted') return new Notification(typeof message === 'function' ? message(_this) : message);
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                origin.apply(this, data)
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            notification.then(function(notification) {
                                return notification === null || notification === void 0 ? void 0 : notification.close();
                            });
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
}
var $a1830bff0fabd0b0$export$d1e7755b007c0847 = /*#__PURE__*/ function() {
    "use strict";
    function $400caf514fe4dd82$export$d1e7755b007c0847(meta) {
        (0, $7lhcp._)(this, $400caf514fe4dd82$export$d1e7755b007c0847);
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expireIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.assign(this, meta);
    }
    (0, $8BtP9._)($400caf514fe4dd82$export$d1e7755b007c0847, [
        {
            key: "save",
            value: function save(storeKey, value) {
                return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _b, _, _ref, set, data;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(value != null)) return [
                                    3,
                                    2
                                ];
                                _ = this;
                                return [
                                    4,
                                    (_a = this.set) === null || _a === void 0 ? void 0 : _a.call(this, value)
                                ];
                            case 1:
                                _.value = (0, $arNK5.toJS).apply(void 0, [
                                    (_b = _state.sent()) !== null && _b !== void 0 ? _b : value
                                ]);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    $610b646be40f0c4b$exports
                                ];
                            case 3:
                                _ref = _state.sent(), set = _ref.set, data = {
                                    value: this.value,
                                    expireAt: this.expireIn + Date.now()
                                };
                                return [
                                    2,
                                    set("".concat(storeKey, "-").concat(this.key), data)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "load",
            value: function load(storeKey) {
                return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _b, _c, _ref, get, del, _ref1, value, expireAt, _tmp;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $610b646be40f0c4b$exports
                                ];
                            case 1:
                                _ref = _state.sent(), get = _ref.get, del = _ref.del;
                                storeKey += "-".concat(this.key);
                                return [
                                    4,
                                    get(storeKey)
                                ];
                            case 2:
                                _ref1 = (_a = _state.sent()) !== null && _a !== void 0 ? _a : {}, value = _ref1.value, expireAt = _ref1.expireAt;
                                if (expireAt && expireAt < Date.now()) {
                                    delete this.value;
                                    return [
                                        2,
                                        del(storeKey)
                                    ];
                                }
                                this.value = value;
                                if (!(value != null)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (_b = this.get) === null || _b === void 0 ? void 0 : _b.call(this, value)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = value;
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    (_c = _tmp) !== null && _c !== void 0 ? _c : value
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function destroy(storeKey) {
                return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _a, _ref, del;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (_a = this.disposer) === null || _a === void 0 || _a.call(this);
                                return [
                                    4,
                                    $610b646be40f0c4b$exports
                                ];
                            case 1:
                                _ref = _state.sent(), del = _ref.del;
                                return [
                                    2,
                                    del("".concat(storeKey, "-").concat(this.key))
                                ];
                        }
                    });
                });
            }
        }
    ], [
        {
            key: "detectIDB",
            value: function detectIDB() {
                return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
                    var _ref, get;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (this.readyIDB) return [
                                    2,
                                    this.readyIDB
                                ];
                                return [
                                    4,
                                    $610b646be40f0c4b$exports
                                ];
                            case 1:
                                _ref = _state.sent(), get = _ref.get;
                                return [
                                    2,
                                    this.readyIDB = get('ready')
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return $400caf514fe4dd82$export$d1e7755b007c0847;
}();
var $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$PersistNodes = new WeakMap();
function $a1830bff0fabd0b0$export$9a6132153fba2e0() {
    var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = _a.expireIn, expireIn = tmp === void 0 ? Infinity : tmp, meta = $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__rest(_a, [
        "expireIn"
    ]);
    return function(param, param1) {
        var ref = (0, $4b94edc8487dfe49$export$71511d61b312f219)(param), name = param1.name, addInitializer = param1.addInitializer;
        addInitializer(function() {
            var list = $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$PersistNodes.get(this) || [];
            list.push(new $a1830bff0fabd0b0$export$d1e7755b007c0847(Object.assign(Object.assign({}, meta), {
                key: name.toString(),
                expireIn: expireIn
            })));
            $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$PersistNodes.set(this, list);
        });
    };
}
function $a1830bff0fabd0b0$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
        var _a, list, restoredData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $a1830bff0fabd0b0$export$d1e7755b007c0847.detectIDB()
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _a = _state.sent();
                    return [
                        2,
                        console.warn('IndexedDB or its polyfill is not found in this runtime engine, MobX-RESTful persistence is disabled.')
                    ];
                case 3:
                    list = $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [], restoredData = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    _loop = function() {
                        var item, key, value;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    item = _step.value;
                                    key = item.key;
                                    return [
                                        4,
                                        item.load(storeKey)
                                    ];
                                case 1:
                                    value = _state.sent();
                                    if (value != null) {
                                        Reflect.set(classInstance, key, value);
                                        restoredData[key] = value;
                                    }
                                    item.disposer = (0, $arNK5.reaction)(function() {
                                        return classInstance[key];
                                    }, function(value) {
                                        return item.save(storeKey, value);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = list[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        8
                    ];
                    return [
                        5,
                        (0, $Csf8W.__values)(_loop())
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    if ((0, $6tqvJ.isEmpty)(restoredData)) return [
                        2
                    ];
                    console.group("Restored ".concat(storeKey));
                    console.table(restoredData);
                    console.groupEnd();
                    return [
                        2
                    ];
            }
        });
    });
}
function $a1830bff0fabd0b0$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function() {
        var list, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    list = $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = list[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    node = _step.value;
                    return [
                        4,
                        node.destroy(storeKey)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
}
function $a1830bff0fabd0b0$export$8001d3a0cfa5d8fd() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, storeKey = _ref.storeKey, tmp = _ref.expireIn, expireIn = tmp === void 0 ? Infinity : tmp;
    return function(Super, param) {
        var ref = (0, $4b94edc8487dfe49$export$71511d61b312f219)(param);
        return function() {
            var _a, _PersistListModel_pageIndex_accessor_storage, _PersistListModel_pageSize_accessor_storage, _PersistListModel_filter_accessor_storage, _PersistListModel_totalCount_accessor_storage, _PersistListModel_pageList_accessor_storage;
            var _classSuper = Super;
            var _pageIndex_decorators;
            var _pageIndex_initializers = [];
            var _pageIndex_extraInitializers = [];
            var _pageSize_decorators;
            var _pageSize_initializers = [];
            var _pageSize_extraInitializers = [];
            var _filter_decorators;
            var _filter_initializers = [];
            var _filter_extraInitializers = [];
            var _totalCount_decorators;
            var _totalCount_initializers = [];
            var _totalCount_extraInitializers = [];
            var _pageList_decorators;
            var _pageList_initializers = [];
            var _pageList_extraInitializers = [];
            return _a = /*#__PURE__*/ function(_classSuper) {
                "use strict";
                (0, $h6w6E._)(PersistListModel, _classSuper);
                function PersistListModel() {
                    (0, $7lhcp._)(this, PersistListModel);
                    var _this;
                    _this = (0, $07dqX._)(this, PersistListModel, arguments);
                    _PersistListModel_pageIndex_accessor_storage.set(_this, $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageIndex_initializers, 0));
                    _PersistListModel_pageSize_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageIndex_extraInitializers), $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageSize_initializers, 10)));
                    _PersistListModel_filter_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageSize_extraInitializers), $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _filter_initializers, {})));
                    _PersistListModel_totalCount_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _filter_extraInitializers), $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _totalCount_initializers, undefined)));
                    _PersistListModel_pageList_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _totalCount_extraInitializers), $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageList_initializers, [])));
                    Object.defineProperty(_this, "restored", {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: ($a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__runInitializers(_this, _pageList_extraInitializers), globalThis.indexedDB && $a1830bff0fabd0b0$export$db239ef39aadc7fe(_this, typeof storeKey === 'function' ? storeKey(_this) : storeKey))
                    });
                    return _this;
                }
                (0, $8BtP9._)(PersistListModel, [
                    {
                        key: "pageIndex",
                        get: function get() {
                            return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageIndex_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageIndex_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "pageSize",
                        get: function get() {
                            return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageSize_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageSize_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "filter",
                        get: function get() {
                            return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_filter_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_filter_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "totalCount",
                        get: function get() {
                            return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_totalCount_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_totalCount_accessor_storage, value, "f");
                        }
                    },
                    {
                        key: "pageList",
                        get: function get() {
                            return $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageList_accessor_storage, "f");
                        },
                        set: function set(value) {
                            $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageList_accessor_storage, value, "f");
                        }
                    }
                ]);
                return PersistListModel;
            }(_classSuper), _PersistListModel_pageIndex_accessor_storage = new WeakMap(), _PersistListModel_pageSize_accessor_storage = new WeakMap(), _PersistListModel_filter_accessor_storage = new WeakMap(), _PersistListModel_totalCount_accessor_storage = new WeakMap(), _PersistListModel_pageList_accessor_storage = new WeakMap(), function() {
                var _b;
                var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
                _pageIndex_decorators = [
                    $a1830bff0fabd0b0$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $arNK5.observable)
                ];
                _pageSize_decorators = [
                    $a1830bff0fabd0b0$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $arNK5.observable)
                ];
                _filter_decorators = [
                    $a1830bff0fabd0b0$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $arNK5.observable)
                ];
                _totalCount_decorators = [
                    $a1830bff0fabd0b0$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $arNK5.observable)
                ];
                _pageList_decorators = [
                    $a1830bff0fabd0b0$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $arNK5.observable)
                ];
                $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageIndex_decorators, {
                    kind: "accessor",
                    name: "pageIndex",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "pageIndex" in obj;
                        },
                        get: function(obj) {
                            return obj.pageIndex;
                        },
                        set: function(obj, value) {
                            obj.pageIndex = value;
                        }
                    },
                    metadata: _metadata
                }, _pageIndex_initializers, _pageIndex_extraInitializers);
                $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageSize_decorators, {
                    kind: "accessor",
                    name: "pageSize",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "pageSize" in obj;
                        },
                        get: function(obj) {
                            return obj.pageSize;
                        },
                        set: function(obj, value) {
                            obj.pageSize = value;
                        }
                    },
                    metadata: _metadata
                }, _pageSize_initializers, _pageSize_extraInitializers);
                $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _filter_decorators, {
                    kind: "accessor",
                    name: "filter",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "filter" in obj;
                        },
                        get: function(obj) {
                            return obj.filter;
                        },
                        set: function(obj, value) {
                            obj.filter = value;
                        }
                    },
                    metadata: _metadata
                }, _filter_initializers, _filter_extraInitializers);
                $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _totalCount_decorators, {
                    kind: "accessor",
                    name: "totalCount",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "totalCount" in obj;
                        },
                        get: function(obj) {
                            return obj.totalCount;
                        },
                        set: function(obj, value) {
                            obj.totalCount = value;
                        }
                    },
                    metadata: _metadata
                }, _totalCount_initializers, _totalCount_extraInitializers);
                $a1830bff0fabd0b0$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageList_decorators, {
                    kind: "accessor",
                    name: "pageList",
                    static: false,
                    private: false,
                    access: {
                        has: function(obj) {
                            return "pageList" in obj;
                        },
                        get: function(obj) {
                            return obj.pageList;
                        },
                        set: function(obj, value) {
                            obj.pageList = value;
                        }
                    },
                    metadata: _metadata
                }, _pageList_initializers, _pageList_extraInitializers);
                if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _metadata
                });
            }(), _a;
        }();
    };
}
$a1830bff0fabd0b0$var$$parcel$exportWildcard($a1830bff0fabd0b0$var$$082ef78710a13331$exports, $a1830bff0fabd0b0$var$$80184bab4212ab17$exports);
$a1830bff0fabd0b0$var$$parcel$exportWildcard($a1830bff0fabd0b0$var$$082ef78710a13331$exports, $a1830bff0fabd0b0$var$$400caf514fe4dd82$exports);
var $a1830bff0fabd0b0$var$$16892940cfb7bd51$exports = {};
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $a1830bff0fabd0b0$export$d12e20a4eec10acf;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $a1830bff0fabd0b0$export$673dbc4a8d0cb20a;
});
var $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers = function $16892940cfb7bd51$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate = function $16892940cfb7bd51$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__awaiter = function $16892940cfb7bd51$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function $16892940cfb7bd51$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function $16892940cfb7bd51$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $a1830bff0fabd0b0$export$d12e20a4eec10acf = function() {
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    var _instanceExtraInitializers = [];
    var _downloading_decorators;
    var _downloading_initializers = [];
    var _downloading_extraInitializers = [];
    var _uploading_decorators;
    var _uploading_initializers = [];
    var _uploading_extraInitializers = [];
    var _clear_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function BaseModel() {
            (0, $7lhcp._)(this, BaseModel);
            _BaseModel_downloading_accessor_storage.set(this, ($a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
        (0, $8BtP9._)(BaseModel, [
            {
                key: "downloading",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
                }
            },
            {
                key: "uploading",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.downloading = this.uploading = 0;
                }
            }
        ]);
        return BaseModel;
    }(), _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $arNK5.observable)
        ];
        _uploading_decorators = [
            (0, $arNK5.observable)
        ];
        _clear_decorators = [
            (0, $arNK5.action)
        ];
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "downloading" in obj;
                },
                get: function(obj) {
                    return obj.downloading;
                },
                set: function(obj, value) {
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "uploading" in obj;
                },
                get: function(obj) {
                    return obj.uploading;
                },
                set: function(obj, value) {
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "clear" in obj;
                },
                get: function(obj) {
                    return obj.clear;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
/**
 * This basic class is a middle class, which isn't for direct using
 */ var $a1830bff0fabd0b0$export$673dbc4a8d0cb20a = function() {
    var _a, _BaseListModel_currentOne_accessor_storage;
    var _classSuper = $a1830bff0fabd0b0$export$d12e20a4eec10acf;
    var _instanceExtraInitializers = [];
    var _currentOne_decorators;
    var _currentOne_initializers = [];
    var _currentOne_extraInitializers = [];
    var _clearCurrent_decorators;
    var _updateOne_decorators;
    var _getOne_decorators;
    var _deleteOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(BaseListModel, _classSuper);
        function BaseListModel() {
            (0, $7lhcp._)(this, BaseListModel);
            var _this;
            _this = (0, $07dqX._)(this, BaseListModel, arguments);
            Object.defineProperty(_this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(_this, _instanceExtraInitializers), 'id')
            });
            _BaseListModel_currentOne_accessor_storage.set(_this, $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(_this, _currentOne_initializers, {}));
            $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__runInitializers(_this, _currentOne_extraInitializers);
            return _this;
        }
        (0, $8BtP9._)(BaseListModel, [
            {
                key: "currentOne",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
                }
            },
            {
                key: "clearCurrent",
                value: function clearCurrent() {
                    this.currentOne = {};
                // this.validity = {};
                }
            },
            {
                key: "clear",
                value: function clear() {
                    (0, $5LQ10._)((0, $2JFuQ._)(BaseListModel.prototype), "clear", this).call(this);
                    this.clearCurrent();
                }
            },
            {
                key: "updateOne",
                value: function updateOne(data, id) {
                    return $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        id ? this.client.patch("".concat(this.baseURI, "/").concat(id), data) : this.client.post(this.baseURI, data)
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    return [
                                        2,
                                        this.currentOne = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getOne",
                value: function getOne(id) {
                    return $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.get("".concat(this.baseURI, "/").concat(id))
                                    ];
                                case 1:
                                    _ref = _state.sent(), body = _ref.body;
                                    return [
                                        2,
                                        this.currentOne = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "deleteOne",
                value: function deleteOne(id) {
                    return $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.delete("".concat(this.baseURI, "/").concat(id))
                                    ];
                                case 1:
                                    _state.sent();
                                    if (this.currentOne[this.indexKey] === id) this.clearCurrent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ], [
            {
                key: "createNested",
                value: // @observable
                // validity: InvalidMessage<D> = {};
                function createNested(parentId) {
                    var Model = this;
                    var store = new Model();
                    store.baseURI = store.baseURI.replace(/:\w+/, parentId + '');
                    return store;
                }
            }
        ]);
        return BaseListModel;
    }(_classSuper), _BaseListModel_currentOne_accessor_storage = new WeakMap(), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $arNK5.observable)
        ];
        _clearCurrent_decorators = [
            (0, $arNK5.action)
        ];
        _updateOne_decorators = [
            $a1830bff0fabd0b0$export$e03c1c3201ee8bb7('uploading')
        ];
        _getOne_decorators = [
            $a1830bff0fabd0b0$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $a1830bff0fabd0b0$export$e03c1c3201ee8bb7('uploading')
        ];
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentOne" in obj;
                },
                get: function(obj) {
                    return obj.currentOne;
                },
                set: function(obj, value) {
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "clearCurrent" in obj;
                },
                get: function(obj) {
                    return obj.clearCurrent;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "updateOne" in obj;
                },
                get: function(obj) {
                    return obj.updateOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getOne" in obj;
                },
                get: function(obj) {
                    return obj.getOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "deleteOne" in obj;
                },
                get: function(obj) {
                    return obj.deleteOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$exports = {};
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $a1830bff0fabd0b0$export$36e5777a1ba4b7c3;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $a1830bff0fabd0b0$export$a143d493d941bafc;
});
$a1830bff0fabd0b0$var$$parcel$export($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $a1830bff0fabd0b0$export$6a4eb2e7fc9e8903;
});
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers = function $5766c49bacaeb5b8$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate = function $5766c49bacaeb5b8$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter = function $5766c49bacaeb5b8$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function $5766c49bacaeb5b8$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function $5766c49bacaeb5b8$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__await = function $5766c49bacaeb5b8$var$__await1(v) {
    return this instanceof $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__await ? (this.v = v, this) : new $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__await(v);
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__asyncValues = function $5766c49bacaeb5b8$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__asyncDelegator = function $5766c49bacaeb5b8$var$__asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__asyncGenerator = function $5766c49bacaeb5b8$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $a1830bff0fabd0b0$export$36e5777a1ba4b7c3 = function() {
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage, _b;
    var _classSuper = $a1830bff0fabd0b0$export$673dbc4a8d0cb20a;
    var _instanceExtraInitializers = [];
    var _pageIndex_decorators;
    var _pageIndex_initializers = [];
    var _pageIndex_extraInitializers = [];
    var _pageSize_decorators;
    var _pageSize_initializers = [];
    var _pageSize_extraInitializers = [];
    var _filter_decorators;
    var _filter_initializers = [];
    var _filter_extraInitializers = [];
    var _totalCount_decorators;
    var _totalCount_initializers = [];
    var _totalCount_extraInitializers = [];
    var _pageList_decorators;
    var _pageList_initializers = [];
    var _pageList_extraInitializers = [];
    var _get_currentPage_decorators;
    var _get_pageCount_decorators;
    var _get_allItems_decorators;
    var _get_noMore_decorators;
    var _statistic_decorators;
    var _statistic_initializers = [];
    var _statistic_extraInitializers = [];
    var _clearList_decorators;
    var _restoreList_decorators;
    var _turnTo_decorators;
    var _getList_decorators;
    var _deleteOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(ListModel, _classSuper);
        function ListModel() {
            (0, $7lhcp._)(this, ListModel);
            var _this;
            _this = (0, $07dqX._)(this, ListModel, arguments);
            _ListModel_pageIndex_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _instanceExtraInitializers), $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageIndex_extraInitializers), $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageSize_extraInitializers), $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _filter_extraInitializers), $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _totalCount_extraInitializers), $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(_this, ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _pageList_extraInitializers), $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _statistic_initializers, {})));
            Object.defineProperty(_this, _b, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _statistic_extraInitializers), _this.getAllInStream)
            });
            return _this;
        }
        (0, $8BtP9._)(ListModel, [
            {
                key: "pageIndex",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
                }
            },
            {
                key: "pageSize",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
                }
            },
            {
                key: "filter",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
                }
            },
            {
                key: "totalCount",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
                }
            },
            {
                key: "pageList",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
                }
            },
            {
                key: "currentPage",
                get: function get() {
                    return this.pageList[this.pageIndex - 1] || [];
                }
            },
            {
                key: "pageCount",
                get: function get() {
                    return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
                }
            },
            {
                key: "allItems",
                get: function get() {
                    var pageList = (0, $arNK5.toJS)(this.pageList), _this = this, pageSize = _this.pageSize, totalCount = _this.totalCount;
                    var index = (0, $fsSDT._)(pageList).reverse().findIndex(function(item) {
                        return (item === null || item === void 0 ? void 0 : item[0]) != null;
                    });
                    return Array.from(pageList.slice(0, -index || Infinity), function(page) {
                        return (page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({});
                    }).flat().slice(0, totalCount || 0);
                }
            },
            {
                key: "noMore",
                get: function get() {
                    return this.pageIndex * this.pageSize >= this.totalCount;
                }
            },
            {
                key: "statistic",
                get: function get() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
                },
                set: function set(value) {
                    $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
                }
            },
            {
                key: "clearList",
                value: function clearList() {
                    this.pageIndex = 0;
                    this.pageSize = 10;
                    this.filter = {};
                    this.pageList = [];
                    this.totalCount = undefined;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    (0, $5LQ10._)((0, $2JFuQ._)(ListModel.prototype), "clear", this).call(this);
                    this.clearList();
                }
            },
            {
                key: "restoreList",
                value: function restoreList() {
                    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.pageIndex, pageIndex = tmp === void 0 ? this.pageIndex + 1 : tmp, tmp1 = _ref.pageSize, pageSize = tmp1 === void 0 ? this.pageSize : tmp1, tmp2 = _ref.allItems, allItems = tmp2 === void 0 ? this.allItems : tmp2, tmp3 = _ref.totalCount, totalCount = tmp3 === void 0 ? Infinity : tmp3;
                    if (!allItems.length) return;
                    this.pageList = (0, $6tqvJ.splitArray)(allItems, pageSize);
                    this.pageIndex = pageIndex;
                    this.pageSize = pageSize;
                    this.totalCount = totalCount;
                }
            },
            {
                key: "turnTo",
                value: function turnTo(pageIndex) {
                    var pageSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.pageSize;
                    this.pageIndex = pageIndex;
                    if (this.pageSize !== pageSize) this.pageList = (0, $6tqvJ.splitArray)(this.allItems, this.pageSize = pageSize);
                    return this;
                }
            },
            {
                /**
             * @protected
             */ key: "loadNewPage",
                value: function loadNewPage(pageIndex, pageSize, filter) {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, pageData, totalCount, list;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.loadPage(pageIndex, pageSize, filter)
                                    ];
                                case 1:
                                    _ref = _state.sent(), pageData = _ref.pageData, totalCount = _ref.totalCount;
                                    this.pageSize = pageSize;
                                    list = (0, $fsSDT._)(this.pageList);
                                    list[pageIndex - 1] = pageData;
                                    this.pageList = list;
                                    this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                                    return [
                                        2,
                                        {
                                            pageData: pageData,
                                            totalCount: totalCount
                                        }
                                    ];
                            }
                        });
                    });
                }
            },
            {
                // @action  // disabled for @override bug of MobX 6
                key: "getList",
                value: function getList() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function() {
                        var filter, pageIndex, pageSize, _ref, pageData;
                        var _arguments = arguments;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    filter = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.filter, pageIndex = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.pageIndex + 1, pageSize = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : this.pageSize;
                                    return [
                                        4,
                                        this.loadNewPage(pageIndex, pageSize, filter)
                                    ];
                                case 1:
                                    _ref = _state.sent(), pageData = _ref.pageData;
                                    this.filter = filter;
                                    this.turnTo(pageIndex, pageSize);
                                    return [
                                        2,
                                        pageData
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "refreshList",
                value: function refreshList() {
                    var _this = this, filter = _this.filter, pageSize = _this.pageSize;
                    this.clearList();
                    return this.getList(filter, 1, pageSize);
                }
            },
            {
                key: "getAllInStream",
                value: function getAllInStream() {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__asyncGenerator(this, arguments, function getAllInStream_1() {
                        var filter, pageSize;
                        var _arguments = arguments;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    filter = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.filter, pageSize = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.pageSize;
                                    this.pageIndex = 0;
                                    _state.label = 1;
                                case 1:
                                    if (!!this.noMore) return [
                                        3,
                                        5
                                    ];
                                    return [
                                        4,
                                        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__await(this.getList(filter, undefined, pageSize))
                                    ];
                                case 2:
                                    return [
                                        5,
                                        (0, $Csf8W.__values)($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__asyncDelegator.apply(void 0, [
                                            $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__asyncValues.apply(void 0, [
                                                _state.sent()
                                            ])
                                        ]))
                                    ];
                                case 3:
                                    return [
                                        4,
                                        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__await.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        3,
                                        1
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getAll",
                value: function getAll() {
                    var filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.filter, pageSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.pageSize;
                    return Array.fromAsync(this.getAllInStream(filter, pageSize));
                }
            },
            {
                key: "countAll",
                value: function countAll(keys_1) {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function(keys) {
                        var filter, pageSize, allItems, statistic;
                        var _arguments = arguments;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    filter = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.filter, pageSize = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : this.pageSize;
                                    return [
                                        4,
                                        this.getAll(filter, pageSize)
                                    ];
                                case 1:
                                    allItems = _state.sent();
                                    statistic = Object.fromEntries(keys.map(function(key) {
                                        return [
                                            key,
                                            (0, $6tqvJ.countBy)(allItems, key)
                                        ];
                                    }));
                                    return [
                                        2,
                                        this.statistic = statistic
                                    ];
                            }
                        });
                    });
                }
            },
            (0, $5RfYb._)({
                key: "indexOf"
            }, "value", function indexOf(id) {
                var _this = this, indexKey = _this.indexKey, allItems = _this.allItems;
                return allItems.findIndex(function(param) {
                    var ID = param[indexKey];
                    return ID === id;
                });
            }),
            {
                key: "changeOne",
                value: function changeOne(data, id) {
                    var patch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                    var _this = this, pageIndex = _this.pageIndex, allItems = _this.allItems, totalCount = _this.totalCount, index = this.indexOf(id);
                    if (index > -1) this.restoreList({
                        pageIndex: pageIndex,
                        allItems: (0, $fsSDT._)(allItems.slice(0, index)).concat([
                            patch ? Object.assign(Object.assign({}, allItems[index]), data) : data
                        ], (0, $fsSDT._)(allItems.slice(index + 1))),
                        totalCount: totalCount
                    });
                }
            },
            {
                key: "updateOne",
                value: function updateOne(data, id) {
                    var _this = this;
                    var _super = Object.create(null, {
                        updateOne: {
                            get: function() {
                                return (0, $5LQ10._)((0, $2JFuQ._)(ListModel.prototype), "updateOne", _this);
                            }
                        }
                    });
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _super.updateOne.call(this, data, id)
                                    ];
                                case 1:
                                    _state.sent();
                                    if (id) this.changeOne(this.currentOne, id);
                                    return [
                                        2,
                                        this.currentOne
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "removeOne",
                value: function removeOne(id) {
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        var _this, filter, pageIndex, allItems, index, _ref, pageData;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, filter = _this.filter, pageIndex = _this.pageIndex, allItems = _this.allItems, index = this.indexOf(id);
                                    return [
                                        4,
                                        this.loadPage(allItems.length + 1, 1, filter)
                                    ];
                                case 1:
                                    _ref = _state.sent(), pageData = _ref.pageData;
                                    return [
                                        2,
                                        this.restoreList({
                                            pageIndex: pageIndex,
                                            allItems: (0, $fsSDT._)(allItems.slice(0, index)).concat((0, $fsSDT._)(allItems.slice(index + 1)), (0, $fsSDT._)(pageData)),
                                            totalCount: this.totalCount--
                                        })
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "deleteOne",
                value: function deleteOne(id) {
                    var _this = this;
                    var _super = Object.create(null, {
                        deleteOne: {
                            get: function() {
                                return (0, $5LQ10._)((0, $2JFuQ._)(ListModel.prototype), "deleteOne", _this);
                            }
                        }
                    });
                    return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        _super.deleteOne.call(this, id)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        this.removeOne(id)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return ListModel;
    }(_classSuper), _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), _b = (_pageIndex_decorators = [
        (0, $arNK5.observable)
    ], _pageSize_decorators = [
        (0, $arNK5.observable)
    ], _filter_decorators = [
        (0, $arNK5.observable)
    ], _totalCount_decorators = [
        (0, $arNK5.observable)
    ], _pageList_decorators = [
        (0, $arNK5.observable)
    ], _get_currentPage_decorators = [
        (0, $arNK5.computed)
    ], _get_pageCount_decorators = [
        (0, $arNK5.computed)
    ], _get_allItems_decorators = [
        (0, $arNK5.computed)
    ], _get_noMore_decorators = [
        (0, $arNK5.computed)
    ], _statistic_decorators = [
        (0, $arNK5.observable)
    ], _clearList_decorators = [
        (0, $arNK5.action)
    ], _restoreList_decorators = [
        (0, $arNK5.action)
    ], _turnTo_decorators = [
        (0, $arNK5.action)
    ], _getList_decorators = [
        $a1830bff0fabd0b0$export$e03c1c3201ee8bb7('downloading')
    ], Symbol.asyncIterator), function() {
        var _c;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_c = _classSuper[Symbol.metadata]) !== null && _c !== void 0 ? _c : null) : void 0;
        _deleteOne_decorators = [
            $a1830bff0fabd0b0$export$e03c1c3201ee8bb7('uploading')
        ];
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageIndex" in obj;
                },
                get: function(obj) {
                    return obj.pageIndex;
                },
                set: function(obj, value) {
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageSize" in obj;
                },
                get: function(obj) {
                    return obj.pageSize;
                },
                set: function(obj, value) {
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filter" in obj;
                },
                get: function(obj) {
                    return obj.filter;
                },
                set: function(obj, value) {
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "totalCount" in obj;
                },
                get: function(obj) {
                    return obj.totalCount;
                },
                set: function(obj, value) {
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageList" in obj;
                },
                get: function(obj) {
                    return obj.pageList;
                },
                set: function(obj, value) {
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentPage" in obj;
                },
                get: function(obj) {
                    return obj.currentPage;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "pageCount" in obj;
                },
                get: function(obj) {
                    return obj.pageCount;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "allItems" in obj;
                },
                get: function(obj) {
                    return obj.allItems;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "noMore" in obj;
                },
                get: function(obj) {
                    return obj.noMore;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "statistic" in obj;
                },
                get: function(obj) {
                    return obj.statistic;
                },
                set: function(obj, value) {
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "clearList" in obj;
                },
                get: function(obj) {
                    return obj.clearList;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "restoreList" in obj;
                },
                get: function(obj) {
                    return obj.restoreList;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "turnTo" in obj;
                },
                get: function(obj) {
                    return obj.turnTo;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getList" in obj;
                },
                get: function(obj) {
                    return obj.getList;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "deleteOne" in obj;
                },
                get: function(obj) {
                    return obj.deleteOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
function $a1830bff0fabd0b0$export$a143d493d941bafc(Super) {
    var BufferListMixin = function() {
        var _a;
        var _classSuper = Super;
        var _instanceExtraInitializers = [];
        var _getList_decorators;
        return _a = /*#__PURE__*/ function(_classSuper) {
            "use strict";
            (0, $h6w6E._)(BufferListMixin, _classSuper);
            function BufferListMixin() {
                (0, $7lhcp._)(this, BufferListMixin);
                var _this;
                _this = (0, $07dqX._)(this, BufferListMixin, arguments);
                Object.defineProperty(_this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _instanceExtraInitializers), [])
                });
                return _this;
            }
            (0, $8BtP9._)(BufferListMixin, [
                {
                    key: "clearList",
                    value: function clearList() {
                        (0, $5LQ10._)((0, $2JFuQ._)(BufferListMixin.prototype), "clearList", this).call(this);
                        this.pendingList = [];
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        (0, $5LQ10._)((0, $2JFuQ._)(BufferListMixin.prototype), "clear", this).call(this);
                        this.clearList();
                    }
                },
                {
                    key: "getList",
                    value: function getList() {
                        var _this = this;
                        var _super = Object.create(null, {
                            getList: {
                                get: function() {
                                    return (0, $5LQ10._)((0, $2JFuQ._)(BufferListMixin.prototype), "getList", _this);
                                }
                            }
                        });
                        return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function() {
                            var _this, filter, pageIndex, pageSize, currentIndex, _ref, pageData, list, nextIndex;
                            var _arguments = arguments;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this;
                                        filter = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.filter, pageIndex = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : this.pageIndex + 1, pageSize = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : this.pageSize;
                                        currentIndex = pageIndex - 1;
                                        if (!this.pendingList[currentIndex]) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            this.pendingList[currentIndex]
                                        ];
                                    case 1:
                                        _ref = _state.sent(), pageData = _ref.pageData;
                                        this.turnTo(pageIndex, pageSize);
                                        return [
                                            2,
                                            pageData
                                        ];
                                    case 2:
                                        if (!this.pageList[currentIndex]) return [
                                            3,
                                            3
                                        ];
                                        this.turnTo(pageIndex, pageSize);
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            _super.getList.call(this, filter, pageIndex, pageSize)
                                        ];
                                    case 4:
                                        list = _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        nextIndex = pageIndex + 1;
                                        this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then(function(data) {
                                            _this.pendingList[nextIndex] = undefined;
                                            return data;
                                        });
                                        return [
                                            2,
                                            list
                                        ];
                                }
                            });
                        });
                    }
                }
            ]);
            return BufferListMixin;
        }(_classSuper), function() {
            var _b;
            var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $arNK5.action),
                $a1830bff0fabd0b0$export$e03c1c3201ee8bb7('downloading')
            ];
            $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "getList" in obj;
                    },
                    get: function(obj) {
                        return obj.getList;
                    }
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }(), _a;
    }();
    return BufferListMixin;
}
function $a1830bff0fabd0b0$export$6a4eb2e7fc9e8903(Super) {
    var StreamListMixin = function() {
        var _a;
        var _classSuper = Super;
        var _instanceExtraInitializers = [];
        var _restoreList_decorators;
        return _a = /*#__PURE__*/ function(_classSuper) {
            "use strict";
            (0, $h6w6E._)(StreamListMixin, _classSuper);
            function StreamListMixin() {
                (0, $7lhcp._)(this, StreamListMixin);
                var _this;
                _this = (0, $07dqX._)(this, StreamListMixin, arguments);
                Object.defineProperty(_this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__runInitializers(_this, _instanceExtraInitializers)
                });
                return _this;
            }
            (0, $8BtP9._)(StreamListMixin, [
                {
                    key: "clearList",
                    value: function clearList() {
                        (0, $5LQ10._)((0, $2JFuQ._)(StreamListMixin.prototype), "clearList", this).call(this);
                        this.stream = undefined;
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        (0, $5LQ10._)((0, $2JFuQ._)(StreamListMixin.prototype), "clear", this).call(this);
                        this.clearList();
                    }
                },
                {
                    key: "restoreList",
                    value: function restoreList() {
                        var _this = this;
                        var _super = Object.create(null, {
                            restoreList: {
                                get: function() {
                                    return (0, $5LQ10._)((0, $2JFuQ._)(StreamListMixin.prototype), "restoreList", _this);
                                }
                            }
                        });
                        return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function() {
                            var _ref, tmp, filter, tmp1, pageIndex, tmp2, pageSize, tmp3, allItems, tmp4, totalCount;
                            var _arguments = arguments;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, tmp = _ref.filter, filter = tmp === void 0 ? this.filter : tmp, tmp1 = _ref.pageIndex, pageIndex = tmp1 === void 0 ? this.pageIndex + 1 : tmp1, tmp2 = _ref.pageSize, pageSize = tmp2 === void 0 ? this.pageSize : tmp2, tmp3 = _ref.allItems, allItems = tmp3 === void 0 ? this.allItems : tmp3, tmp4 = _ref.totalCount, totalCount = tmp4 === void 0 ? Infinity : tmp4;
                                        _super.restoreList.call(this, {
                                            pageIndex: pageIndex,
                                            pageSize: pageSize,
                                            allItems: allItems,
                                            totalCount: totalCount
                                        });
                                        if (!allItems.length) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            this.loadStream(filter, allItems.length)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    /**
                 * @protected
                 */ key: "loadStream",
                    value: function loadStream(filter, newCount) {
                        return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                            var newList, stream, i, _ref, done, value;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        newList = [];
                                        stream = this.stream || (this.stream = this.openStream(filter));
                                        i = 0;
                                        _state.label = 1;
                                    case 1:
                                        if (!(i < newCount)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            stream.next()
                                        ];
                                    case 2:
                                        _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                        if (done) return [
                                            3,
                                            4
                                        ];
                                        newList.push(value);
                                        _state.label = 3;
                                    case 3:
                                        i++;
                                        return [
                                            3,
                                            1
                                        ];
                                    case 4:
                                        return [
                                            2,
                                            newList
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    /**
                 * @protected
                 */ key: "loadPage",
                    value: function loadPage(pageIndex, pageSize, filter) {
                        return $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function() {
                            var _this, totalCount, allItems, requiredCount, newCount, newList;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this, totalCount = _this.totalCount, allItems = _this.allItems, requiredCount = pageIndex * pageSize;
                                        newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                                        return [
                                            4,
                                            this.loadStream(filter, newCount)
                                        ];
                                    case 1:
                                        newList = _state.sent();
                                        this.pageList = (0, $6tqvJ.splitArray)((0, $fsSDT._)(this.allItems).concat((0, $fsSDT._)(newList)), pageSize);
                                        return [
                                            2,
                                            {
                                                pageData: this.pageList[pageIndex - 1] || [],
                                                totalCount: this.totalCount
                                            }
                                        ];
                                }
                            });
                        });
                    }
                }
            ]);
            return StreamListMixin;
        }(_classSuper), function() {
            var _b;
            var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $a1830bff0fabd0b0$export$e03c1c3201ee8bb7('downloading')
            ];
            $a1830bff0fabd0b0$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: function(obj) {
                        return "restoreList" in obj;
                    },
                    get: function(obj) {
                        return obj.restoreList;
                    }
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }(), _a;
    }();
    return StreamListMixin;
}



var $6tqvJ = parcelRequire("6tqvJ");
var $66f68a4f6b0aa2a1$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $66f68a4f6b0aa2a1$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $66f68a4f6b0aa2a1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $66f68a4f6b0aa2a1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $66f68a4f6b0aa2a1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $66f68a4f6b0aa2a1$export$74061d4f476da680 = "https://ai-work-order-service.onrender.com";
var $66f68a4f6b0aa2a1$export$621c2e9225361608 = function() {
    var _a, _UserModel_session_accessor_storage;
    var _classSuper = (0, $a1830bff0fabd0b0$export$d12e20a4eec10acf);
    var _instanceExtraInitializers = [];
    var _session_decorators;
    var _session_initializers = [];
    var _session_extraInitializers = [];
    var _sendOTP_decorators;
    var _signUp_decorators;
    var _signIn_decorators;
    var _signOut_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(UserModel, _classSuper);
        function UserModel() {
            (0, $7lhcp._)(this, UserModel);
            var _this;
            _this = (0, $07dqX._)(this, UserModel, arguments);
            _UserModel_session_accessor_storage.set(_this, ($66f68a4f6b0aa2a1$var$__runInitializers(_this, _instanceExtraInitializers), $66f68a4f6b0aa2a1$var$__runInitializers(_this, _session_initializers, void 0)));
            Object.defineProperty(_this, "restored", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($66f68a4f6b0aa2a1$var$__runInitializers(_this, _session_extraInitializers), (0, $a1830bff0fabd0b0$export$db239ef39aadc7fe)(_this, 'User'))
            });
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $hp59o.HTTPClient)({
                    baseURI: $66f68a4f6b0aa2a1$export$74061d4f476da680,
                    responseType: 'json'
                }).use(function(param, next) {
                    var request = param.request;
                    var isSameDomain = $66f68a4f6b0aa2a1$export$74061d4f476da680.startsWith(new URL(request.path, $66f68a4f6b0aa2a1$export$74061d4f476da680).origin);
                    if (isSameDomain && _this.session) request.headers = Object.assign(Object.assign({}, request.headers), {
                        Authorization: "Bearer ".concat(_this.session.token)
                    });
                    return next();
                })
            });
            return _this;
        }
        (0, $8BtP9._)(UserModel, [
            {
                key: "session",
                get: function get() {
                    return $66f68a4f6b0aa2a1$var$__classPrivateFieldGet(this, _UserModel_session_accessor_storage, "f");
                },
                set: function set(value) {
                    $66f68a4f6b0aa2a1$var$__classPrivateFieldSet(this, _UserModel_session_accessor_storage, value, "f");
                }
            },
            {
                key: "sendOTP",
                value: function sendOTP(address) {
                    return $66f68a4f6b0aa2a1$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.post("user/session/email/".concat(address, "/OTP"))
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "signUp",
                value: function signUp(email, password) {
                    return $66f68a4f6b0aa2a1$var$__awaiter(this, void 0, void 0, function() {
                        var body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.post('user', {
                                            email: email,
                                            password: password
                                        })
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "signIn",
                value: function signIn(email, password) {
                    return $66f68a4f6b0aa2a1$var$__awaiter(this, void 0, void 0, function() {
                        var body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.post('user/session', {
                                            email: email,
                                            password: password
                                        })
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        this.session = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "signOut",
                value: function signOut() {
                    return $66f68a4f6b0aa2a1$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    this.session = undefined;
                                    return [
                                        4,
                                        (0, $6tqvJ.sleep)()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        (0, $610b646be40f0c4b$export$42ffd38884aecdac)()
                                    ];
                                case 2:
                                    _state.sent();
                                    location.hash = '';
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return UserModel;
    }(_classSuper), _UserModel_session_accessor_storage = new WeakMap(), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _session_decorators = [
            (0, $a1830bff0fabd0b0$export$9a6132153fba2e0)(),
            (0, $arNK5.observable)
        ];
        _sendOTP_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('uploading')
        ];
        _signUp_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('uploading')
        ];
        _signIn_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('uploading')
        ];
        _signOut_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('uploading')
        ];
        $66f68a4f6b0aa2a1$var$__esDecorate(_a, null, _session_decorators, {
            kind: "accessor",
            name: "session",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "session" in obj;
                },
                get: function(obj) {
                    return obj.session;
                },
                set: function(obj, value) {
                    obj.session = value;
                }
            },
            metadata: _metadata
        }, _session_initializers, _session_extraInitializers);
        $66f68a4f6b0aa2a1$var$__esDecorate(_a, null, _sendOTP_decorators, {
            kind: "method",
            name: "sendOTP",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "sendOTP" in obj;
                },
                get: function(obj) {
                    return obj.sendOTP;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $66f68a4f6b0aa2a1$var$__esDecorate(_a, null, _signUp_decorators, {
            kind: "method",
            name: "signUp",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "signUp" in obj;
                },
                get: function(obj) {
                    return obj.signUp;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $66f68a4f6b0aa2a1$var$__esDecorate(_a, null, _signIn_decorators, {
            kind: "method",
            name: "signIn",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "signIn" in obj;
                },
                get: function(obj) {
                    return obj.signIn;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $66f68a4f6b0aa2a1$var$__esDecorate(_a, null, _signOut_decorators, {
            kind: "method",
            name: "signOut",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "signOut" in obj;
                },
                get: function(obj) {
                    return obj.signOut;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $66f68a4f6b0aa2a1$export$2e2bcd8739ae039 = new $66f68a4f6b0aa2a1$export$621c2e9225361608();




var $1R1LB = parcelRequire("1R1LB");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $fClfl = parcelRequire("fClfl");
var $def56be66887619b$exports = {};
var $def56be66887619b$var$$14c85ffeff1ab241$export$fad3c8302a7540c6, $def56be66887619b$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd, $def56be66887619b$var$$14c85ffeff1ab241$export$1a22ace05a045e3f, $def56be66887619b$var$$14c85ffeff1ab241$export$c7aa240077ad8340, $def56be66887619b$var$$14c85ffeff1ab241$export$5add10f2a1e13991, $def56be66887619b$var$$4bfbcb67a3daf664$export$79ffe56a765070d2, $def56be66887619b$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, $def56be66887619b$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, $def56be66887619b$var$$7d37db9df1578ff2$export$5c452ff88e35e47d, $def56be66887619b$var$$7d37db9df1578ff2$export$30d389775d7a0f3c, $def56be66887619b$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6, $def56be66887619b$var$$7d37db9df1578ff2$export$896c314ae37c4db9, $def56be66887619b$var$$7d37db9df1578ff2$export$717db1a952ac2d26, $def56be66887619b$var$$7d37db9df1578ff2$export$74fdf2685172213b, $def56be66887619b$var$$7d37db9df1578ff2$export$fb184b623420d9be, $def56be66887619b$var$$7d37db9df1578ff2$export$ec176431609ba4c9, $def56be66887619b$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b, $def56be66887619b$var$$c628d4ba96623bb8$export$1a22ace05a045e3f, $def56be66887619b$var$$c628d4ba96623bb8$export$c7aa240077ad8340;
var $ada009390fa7849c$export$71511d61b312f219;
"use strict";
var $c7bc4073be5d29be$export$71511d61b312f219;
"use strict";
function $c7bc4073be5d29be$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
$c7bc4073be5d29be$export$71511d61b312f219 = $c7bc4073be5d29be$var$_array_with_holes;


var $7d416a60cadb1e66$export$71511d61b312f219;
"use strict";
function $7d416a60cadb1e66$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$7d416a60cadb1e66$export$71511d61b312f219 = $7d416a60cadb1e66$var$_iterable_to_array_limit;


var $5768a74a1d487907$export$71511d61b312f219;
"use strict";
function $5768a74a1d487907$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$5768a74a1d487907$export$71511d61b312f219 = $5768a74a1d487907$var$_non_iterable_rest;


var $8d557826eabb1eea$export$71511d61b312f219;
"use strict";
var $ed4ff1eb03639915$export$71511d61b312f219;
"use strict";
function $ed4ff1eb03639915$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$ed4ff1eb03639915$export$71511d61b312f219 = $ed4ff1eb03639915$var$_array_like_to_array;


function $8d557826eabb1eea$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ed4ff1eb03639915$export$71511d61b312f219(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ed4ff1eb03639915$export$71511d61b312f219(o, minLen);
}
$8d557826eabb1eea$export$71511d61b312f219 = $8d557826eabb1eea$var$_unsupported_iterable_to_array;


function $ada009390fa7849c$var$_sliced_to_array(arr, i) {
    return $c7bc4073be5d29be$export$71511d61b312f219(arr) || $7d416a60cadb1e66$export$71511d61b312f219(arr, i) || $8d557826eabb1eea$export$71511d61b312f219(arr, i) || $5768a74a1d487907$export$71511d61b312f219();
}
$ada009390fa7849c$export$71511d61b312f219 = $ada009390fa7849c$var$_sliced_to_array;


var $36427be7dd51c5e7$export$71511d61b312f219;
"use strict";
var $963c27511d823062$export$71511d61b312f219;
"use strict";

function $963c27511d823062$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $ed4ff1eb03639915$export$71511d61b312f219(arr);
}
$963c27511d823062$export$71511d61b312f219 = $963c27511d823062$var$_array_without_holes;


var $ca42406c5bfa9096$export$71511d61b312f219;
"use strict";
function $ca42406c5bfa9096$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$ca42406c5bfa9096$export$71511d61b312f219 = $ca42406c5bfa9096$var$_iterable_to_array;


var $0975b5373932f394$export$71511d61b312f219;
"use strict";
function $0975b5373932f394$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$0975b5373932f394$export$71511d61b312f219 = $0975b5373932f394$var$_non_iterable_spread;



function $36427be7dd51c5e7$var$_to_consumable_array(arr) {
    return $963c27511d823062$export$71511d61b312f219(arr) || $ca42406c5bfa9096$export$71511d61b312f219(arr) || $8d557826eabb1eea$export$71511d61b312f219(arr) || $0975b5373932f394$export$71511d61b312f219();
}
$36427be7dd51c5e7$export$71511d61b312f219 = $36427be7dd51c5e7$var$_to_consumable_array;



var $fClfl = parcelRequire("fClfl");
var $8bd163097a5514bf$exports = {};

var $5f0Cq = parcelRequire("5f0Cq");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if ((typeof arg === "undefined" ? "undefined" : (0, $5f0Cq._)(arg)) !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($8bd163097a5514bf$exports) {
        classNames.default = classNames;
        $8bd163097a5514bf$exports = classNames;
    } else if (typeof define === 'function' && (0, $5f0Cq._)(define.amd) === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $c4dbf9b956236295$export$71511d61b312f219;
"use strict";
var $435c1b7a62b9651a$export$71511d61b312f219;
"use strict";
function $435c1b7a62b9651a$var$_get_prototype_of(o) {
    $435c1b7a62b9651a$export$71511d61b312f219 = $435c1b7a62b9651a$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $435c1b7a62b9651a$var$_get_prototype_of(o);
}
$435c1b7a62b9651a$export$71511d61b312f219 = $435c1b7a62b9651a$var$_get_prototype_of;


var $b8c8dbc1d05ae88c$export$71511d61b312f219;
"use strict";
function $b8c8dbc1d05ae88c$var$_is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($b8c8dbc1d05ae88c$export$71511d61b312f219 = $b8c8dbc1d05ae88c$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
$b8c8dbc1d05ae88c$export$71511d61b312f219 = $b8c8dbc1d05ae88c$var$_is_native_reflect_construct;


var $5ae9b1b0b180a011$export$71511d61b312f219;
"use strict";
var $81bbac5d50416a33$export$71511d61b312f219;
"use strict";
function $81bbac5d50416a33$var$_assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$81bbac5d50416a33$export$71511d61b312f219 = $81bbac5d50416a33$var$_assert_this_initialized;


var $a4f5296238ef68ec$export$71511d61b312f219;
"use strict";
function $a4f5296238ef68ec$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
$a4f5296238ef68ec$export$71511d61b312f219 = $a4f5296238ef68ec$var$_type_of;


function $5ae9b1b0b180a011$var$_possible_constructor_return(self, call) {
    if (call && ($a4f5296238ef68ec$export$71511d61b312f219(call) === "object" || typeof call === "function")) return call;
    return $81bbac5d50416a33$export$71511d61b312f219(self);
}
$5ae9b1b0b180a011$export$71511d61b312f219 = $5ae9b1b0b180a011$var$_possible_constructor_return;


function $c4dbf9b956236295$var$_call_super(_this, derived, args) {
    // Super
    derived = $435c1b7a62b9651a$export$71511d61b312f219(derived);
    return $5ae9b1b0b180a011$export$71511d61b312f219(_this, $b8c8dbc1d05ae88c$export$71511d61b312f219() ? Reflect.construct(derived, args || [], $435c1b7a62b9651a$export$71511d61b312f219(_this).constructor) : derived.apply(_this, args));
}
$c4dbf9b956236295$export$71511d61b312f219 = $c4dbf9b956236295$var$_call_super;


var $62cfae4fe2618c9c$export$71511d61b312f219;
"use strict";
function $62cfae4fe2618c9c$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$62cfae4fe2618c9c$export$71511d61b312f219 = $62cfae4fe2618c9c$var$_class_call_check;


var $355cb88dd58749ed$export$71511d61b312f219;
"use strict";
function $355cb88dd58749ed$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $355cb88dd58749ed$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $355cb88dd58749ed$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $355cb88dd58749ed$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
$355cb88dd58749ed$export$71511d61b312f219 = $355cb88dd58749ed$var$_create_class;


var $abf03f88ba10b724$export$71511d61b312f219;
"use strict";
var $6bf3a766df389960$export$71511d61b312f219;
"use strict";
function $6bf3a766df389960$var$_set_prototype_of(o, p) {
    $6bf3a766df389960$export$71511d61b312f219 = $6bf3a766df389960$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6bf3a766df389960$var$_set_prototype_of(o, p);
}
$6bf3a766df389960$export$71511d61b312f219 = $6bf3a766df389960$var$_set_prototype_of;


function $abf03f88ba10b724$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6bf3a766df389960$export$71511d61b312f219(subClass, superClass);
}
$abf03f88ba10b724$export$71511d61b312f219 = $abf03f88ba10b724$var$_inherits;


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $6mMqj = parcelRequire("6mMqj");
var $0e70cb6ccf37e2dd$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $0e70cb6ccf37e2dd$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $0e70cb6ccf37e2dd$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function type(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function objId(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function getLanguage(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function setLanguage(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function currentScript() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function isActive(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function extend(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function insertBefore(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function highlightAll(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function highlightAllUnder(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function highlightElement(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function highlight(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function tokenize(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function add(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function run(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($0e70cb6ccf37e2dd$var$_self);
if ($0e70cb6ccf37e2dd$exports) $0e70cb6ccf37e2dd$exports = $0e70cb6ccf37e2dd$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $0e70cb6ccf37e2dd$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $0e70cb6ccf37e2dd$var$Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$0e70cb6ccf37e2dd$var$Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $0e70cb6ccf37e2dd$var$Prism.languages.markup['entity'];
$0e70cb6ccf37e2dd$var$Prism.languages.markup['doctype'].inside['internal-subset'].inside = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$0e70cb6ccf37e2dd$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($0e70cb6ccf37e2dd$var$Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($0e70cb6ccf37e2dd$var$Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function value(attrName, lang) {
        $0e70cb6ccf37e2dd$var$Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $0e70cb6ccf37e2dd$var$Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$0e70cb6ccf37e2dd$var$Prism.languages.html = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
$0e70cb6ccf37e2dd$var$Prism.languages.mathml = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
$0e70cb6ccf37e2dd$var$Prism.languages.svg = $0e70cb6ccf37e2dd$var$Prism.languages.markup;
$0e70cb6ccf37e2dd$var$Prism.languages.xml = $0e70cb6ccf37e2dd$var$Prism.languages.extend('markup', {});
$0e70cb6ccf37e2dd$var$Prism.languages.ssml = $0e70cb6ccf37e2dd$var$Prism.languages.xml;
$0e70cb6ccf37e2dd$var$Prism.languages.atom = $0e70cb6ccf37e2dd$var$Prism.languages.xml;
$0e70cb6ccf37e2dd$var$Prism.languages.rss = $0e70cb6ccf37e2dd$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($0e70cb6ccf37e2dd$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $0e70cb6ccf37e2dd$var$Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $0e70cb6ccf37e2dd$var$Prism.languages.javascript = $0e70cb6ccf37e2dd$var$Prism.languages.extend('clike', {
    'class-name': [
        $0e70cb6ccf37e2dd$var$Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$0e70cb6ccf37e2dd$var$Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $0e70cb6ccf37e2dd$var$Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $0e70cb6ccf37e2dd$var$Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$0e70cb6ccf37e2dd$var$Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($0e70cb6ccf37e2dd$var$Prism.languages.markup) {
    $0e70cb6ccf37e2dd$var$Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $0e70cb6ccf37e2dd$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$0e70cb6ccf37e2dd$var$Prism.languages.js = $0e70cb6ccf37e2dd$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $0e70cb6ccf37e2dd$var$Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function FAILURE_MESSAGE(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $0e70cb6ccf37e2dd$var$Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    $0e70cb6ccf37e2dd$var$Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $0e70cb6ccf37e2dd$var$Prism.util.setLanguage(code, language);
            $0e70cb6ccf37e2dd$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $0e70cb6ccf37e2dd$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $0e70cb6ccf37e2dd$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $0e70cb6ccf37e2dd$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$0e70cb6ccf37e2dd$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $0e70cb6ccf37e2dd$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        $0e70cb6ccf37e2dd$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();


var $52394bb05ad00d71$exports = {};

var $5f0Cq = parcelRequire("5f0Cq");
'use strict';
Object.defineProperty($52394bb05ad00d71$exports, '__esModule', {
    value: true
});
var $244e45c4ae06bfb5$exports = {};
'use strict';
Object.defineProperty($244e45c4ae06bfb5$exports, '__esModule', {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $244e45c4ae06bfb5$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $244e45c4ae06bfb5$var$isPlainObject(o) {
    var ctor, prot;
    if ($244e45c4ae06bfb5$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($244e45c4ae06bfb5$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}
$244e45c4ae06bfb5$exports.isPlainObject = $244e45c4ae06bfb5$var$isPlainObject;



var $6mMqj = parcelRequire("6mMqj");
var $8327cfee14109576$exports = {};

var $5f0Cq = parcelRequire("5f0Cq");
"use strict";
var $8327cfee14109576$var$__assign = undefined && undefined.__assign || function() {
    $8327cfee14109576$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8327cfee14109576$var$__assign.apply(this, arguments);
};
var $8327cfee14109576$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($8327cfee14109576$exports, "__esModule", {
    value: true
});
$8327cfee14109576$exports.prettyPrint = void 0;
var $8327cfee14109576$var$seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */ function $8327cfee14109576$var$isObj(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
    return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */ function $8327cfee14109576$var$isRegexp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */ function $8327cfee14109576$var$getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function(keySymbol) {
        return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
    });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */ function $8327cfee14109576$var$prettyPrint(input, options, pad) {
    if (pad === void 0) pad = '';
    // sensible option defaults
    var defaultOptions = {
        indent: '\t',
        singleQuotes: true
    };
    var combinedOptions = $8327cfee14109576$var$__assign($8327cfee14109576$var$__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) tokens = {
        newLine: '\n',
        newLineOrSpace: '\n',
        pad: pad,
        indent: pad + combinedOptions.indent
    };
    else tokens = {
        newLine: '@@__PRETTY_PRINT_NEW_LINE__@@',
        newLineOrSpace: '@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@',
        pad: '@@__PRETTY_PRINT_PAD__@@',
        indent: '@@__PRETTY_PRINT_INDENT__@@'
    };
    var expandWhiteSpace = function expandWhiteSpace(string) {
        if (combinedOptions.inlineCharacterLimit === undefined) return string;
        var oneLined = string.replace(new RegExp(tokens.newLine, 'g'), '').replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) return oneLined;
        return string.replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').replace(new RegExp(tokens.pad, 'g'), pad).replace(new RegExp(tokens.indent, 'g'), pad + combinedOptions.indent);
    };
    if ($8327cfee14109576$var$seen.indexOf(input) !== -1) return '"[Circular]"';
    if (input === null || input === undefined || typeof input === 'number' || typeof input === 'boolean' || typeof input === 'function' || (typeof input === "undefined" ? "undefined" : (0, $5f0Cq._)(input)) === 'symbol' || $8327cfee14109576$var$isRegexp(input)) return String(input);
    if (input instanceof Date) return "new Date('".concat(input.toISOString(), "')");
    if (Array.isArray(input)) {
        if (input.length === 0) return '[]';
        $8327cfee14109576$var$seen.push(input);
        var ret = '[' + tokens.newLine + input.map(function(el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var value = $8327cfee14109576$var$prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, i, value);
            return tokens.indent + value + eol;
        }).join('') + tokens.pad + ']';
        $8327cfee14109576$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    if ($8327cfee14109576$var$isObj(input)) {
        var objKeys_1 = $8327cfee14109576$var$__spreadArray($8327cfee14109576$var$__spreadArray([], Object.keys(input), true), $8327cfee14109576$var$getOwnEnumPropSymbols(input), true);
        if (combinedOptions.filter) objKeys_1 = objKeys_1.filter(function(el) {
            return combinedOptions.filter && combinedOptions.filter(input, el);
        });
        if (objKeys_1.length === 0) return '{}';
        $8327cfee14109576$var$seen.push(input);
        var ret = '{' + tokens.newLine + objKeys_1.map(function(el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var isSymbol = (typeof el === "undefined" ? "undefined" : (0, $5f0Cq._)(el)) === 'symbol';
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : $8327cfee14109576$var$prettyPrint(el, combinedOptions);
            var value = $8327cfee14109576$var$prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, el, value);
            return tokens.indent + String(key) + ': ' + value + eol;
        }).join('') + tokens.pad + '}';
        $8327cfee14109576$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function(x) {
        return x === '\n' ? '\\n' : '\\r';
    });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return "\"".concat(input, "\"");
    }
    input = input.replace(/\\?'/g, '\\\'');
    return "'".concat(input, "'");
}
$8327cfee14109576$exports.prettyPrint = $8327cfee14109576$var$prettyPrint;


var $75fcee2ea3d13b1e$exports = {};
'use strict';

$75fcee2ea3d13b1e$exports = (parcelRequire("c5KQ9"));


function $52394bb05ad00d71$var$_interopDefaultLegacy(e) {
    return e && (typeof e === "undefined" ? "undefined" : (0, $5f0Cq._)(e)) === 'object' && 'default' in e ? e : {
        'default': e
    };
}
function $52394bb05ad00d71$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function get() {
                    return e[k];
                }
            });
        }
    });
    n["default"] = e;
    return Object.freeze(n);
}
var $52394bb05ad00d71$var$React__namespace = /*#__PURE__*/ $52394bb05ad00d71$var$_interopNamespace($6mMqj);
var $52394bb05ad00d71$var$React__default = /*#__PURE__*/ $52394bb05ad00d71$var$_interopDefaultLegacy($6mMqj);
var $52394bb05ad00d71$var$spacer = function spacer(times, tabStop) {
    if (times === 0) return '';
    return new Array(times * tabStop).fill(' ').join('');
};
function $52394bb05ad00d71$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $52394bb05ad00d71$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $52394bb05ad00d71$var$_arrayLikeToArray(r);
}
function $52394bb05ad00d71$var$_defineProperty(e, r, t) {
    return (r = $52394bb05ad00d71$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $52394bb05ad00d71$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $52394bb05ad00d71$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $52394bb05ad00d71$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52394bb05ad00d71$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52394bb05ad00d71$var$ownKeys(Object(t), !0).forEach(function(r) {
            $52394bb05ad00d71$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52394bb05ad00d71$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $52394bb05ad00d71$var$_toConsumableArray(r) {
    return $52394bb05ad00d71$var$_arrayWithoutHoles(r) || $52394bb05ad00d71$var$_iterableToArray(r) || $52394bb05ad00d71$var$_unsupportedIterableToArray(r) || $52394bb05ad00d71$var$_nonIterableSpread();
}
function $52394bb05ad00d71$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $5f0Cq._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $5f0Cq._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $52394bb05ad00d71$var$_toPropertyKey(t) {
    var i = $52394bb05ad00d71$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $5f0Cq._)(i)) ? i : i + "";
}
function $52394bb05ad00d71$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $52394bb05ad00d71$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $52394bb05ad00d71$var$_typeof(o);
}
function $52394bb05ad00d71$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $52394bb05ad00d71$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $52394bb05ad00d71$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $52394bb05ad00d71$var$safeSortObject(value, seen) {
    // return non-object value as is
    if (value === null || $52394bb05ad00d71$var$_typeof(value) !== 'object') return value;
    // return date and regexp values as is
    if (value instanceof Date || value instanceof RegExp) return value;
    // return react element as is but remove _owner key because it can lead to recursion
    if (/*#__PURE__*/ $52394bb05ad00d71$var$React__namespace.isValidElement(value)) {
        var copyObj = $52394bb05ad00d71$var$_objectSpread2({}, value);
        delete copyObj._owner;
        return copyObj;
    }
    seen.add(value);
    // make a copy of array with each item passed through the sorting algorithm
    if (Array.isArray(value)) return value.map(function(v) {
        return $52394bb05ad00d71$var$safeSortObject(v, seen);
    });
    // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function(result, key) {
        if (key === 'current' || seen.has(value[key])) // eslint-disable-next-line no-param-reassign
        result[key] = '[Circular]';
        else // eslint-disable-next-line no-param-reassign
        result[key] = $52394bb05ad00d71$var$safeSortObject(value[key], seen);
        return result;
    }, {});
}
function $52394bb05ad00d71$var$sortObject(value) {
    return $52394bb05ad00d71$var$safeSortObject(value, new WeakSet());
}
/* eslint-disable no-use-before-define */ var $52394bb05ad00d71$var$createStringTreeNode = function createStringTreeNode(value) {
    return {
        type: 'string',
        value: value
    };
};
var $52394bb05ad00d71$var$createNumberTreeNode = function createNumberTreeNode(value) {
    return {
        type: 'number',
        value: value
    };
};
var $52394bb05ad00d71$var$createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: defaultProps,
        childrens: childrens
    };
};
var $52394bb05ad00d71$var$createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
        type: 'ReactFragment',
        key: key,
        childrens: childrens
    };
};
var $52394bb05ad00d71$var$supportFragment = Boolean($6mMqj.Fragment);
var $52394bb05ad00d71$var$getFunctionTypeName = function getFunctionTypeName(functionType) {
    if (!functionType.name || functionType.name === '_default') return 'No Display Name';
    return functionType.name;
};
var $52394bb05ad00d71$var$_getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
    switch(true){
        case Boolean(Component.displayName):
            return Component.displayName;
        case Component.$$typeof === $75fcee2ea3d13b1e$exports.Memo:
            return $52394bb05ad00d71$var$_getWrappedComponentDisplayName(Component.type);
        case Component.$$typeof === $75fcee2ea3d13b1e$exports.ForwardRef:
            return $52394bb05ad00d71$var$_getWrappedComponentDisplayName(Component.render);
        default:
            return $52394bb05ad00d71$var$getFunctionTypeName(Component);
    }
};
// heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496
var $52394bb05ad00d71$var$getReactElementDisplayName = function getReactElementDisplayName(element) {
    switch(true){
        case typeof element.type === 'string':
            return element.type;
        case typeof element.type === 'function':
            if (element.type.displayName) return element.type.displayName;
            return $52394bb05ad00d71$var$getFunctionTypeName(element.type);
        case $75fcee2ea3d13b1e$exports.isForwardRef(element):
        case $75fcee2ea3d13b1e$exports.isMemo(element):
            return $52394bb05ad00d71$var$_getWrappedComponentDisplayName(element.type);
        case $75fcee2ea3d13b1e$exports.isContextConsumer(element):
            return "".concat(element.type._context.displayName || 'Context', ".Consumer");
        case $75fcee2ea3d13b1e$exports.isContextProvider(element):
            return "".concat(element.type.displayName || 'Context', ".Provider");
        case $75fcee2ea3d13b1e$exports.isLazy(element):
            return 'Lazy';
        case $75fcee2ea3d13b1e$exports.isProfiler(element):
            return 'Profiler';
        case $75fcee2ea3d13b1e$exports.isStrictMode(element):
            return 'StrictMode';
        case $75fcee2ea3d13b1e$exports.isSuspense(element):
            return 'Suspense';
        default:
            return 'UnknownElementType';
    }
};
var $52394bb05ad00d71$var$noChildren = function noChildren(propsValue, propName) {
    return propName !== 'children';
};
var $52394bb05ad00d71$var$onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== '';
};
var $52394bb05ad00d71$var$filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};
    Object.keys(originalProps).filter(function(key) {
        return cb(originalProps[key], key);
    }).forEach(function(key) {
        return filteredProps[key] = originalProps[key];
    });
    return filteredProps;
};
var $52394bb05ad00d71$var$_parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName, displayNameFn = _options$displayName === void 0 ? $52394bb05ad00d71$var$getReactElementDisplayName : _options$displayName;
    if (typeof element === 'string') return $52394bb05ad00d71$var$createStringTreeNode(element);
    else if (typeof element === 'number') return $52394bb05ad00d71$var$createNumberTreeNode(element);
    else if (!/*#__PURE__*/ $52394bb05ad00d71$var$React__default["default"].isValidElement(element)) throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat($52394bb05ad00d71$var$_typeof(element), "`"));
    var displayName = displayNameFn(element);
    var props = $52394bb05ad00d71$var$filterProps(element.props, $52394bb05ad00d71$var$noChildren);
    var key = element.key;
    if (typeof key === 'string' && key.search(/^\./)) // React automatically add key=".X" when there are some children
    props.key = key;
    var defaultProps = $52394bb05ad00d71$var$filterProps(element.type.defaultProps || {}, $52394bb05ad00d71$var$noChildren);
    var childrens = $52394bb05ad00d71$var$React__default["default"].Children.toArray(element.props.children).filter($52394bb05ad00d71$var$onlyMeaningfulChildren).map(function(child) {
        return $52394bb05ad00d71$var$_parseReactElement(child, options);
    });
    if ($52394bb05ad00d71$var$supportFragment && element.type === $6mMqj.Fragment) return $52394bb05ad00d71$var$createReactFragmentTreeNode(key, childrens);
    return $52394bb05ad00d71$var$createReactElementTreeNode(displayName, props, defaultProps, childrens);
};
function $52394bb05ad00d71$var$noRefCheck() {}
var $52394bb05ad00d71$var$inlineFunction = function inlineFunction(fn) {
    return fn.toString().split('\n').map(function(line) {
        return line.trim();
    }).join('');
};
var $52394bb05ad00d71$var$preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
    return fn.toString();
};
var $52394bb05ad00d71$var$defaultFunctionValue = $52394bb05ad00d71$var$inlineFunction;
var $52394bb05ad00d71$var$formatFunction = function formatFunction(fn, options) {
    var _options$functionValu = options.functionValue, functionValue = _options$functionValu === void 0 ? $52394bb05ad00d71$var$defaultFunctionValue : _options$functionValu, showFunctions = options.showFunctions;
    if (!showFunctions && functionValue === $52394bb05ad00d71$var$defaultFunctionValue) return functionValue($52394bb05ad00d71$var$noRefCheck);
    return functionValue(fn);
};
var $52394bb05ad00d71$var$formatComplexDataStructure = function formatComplexDataStructure(value, inline, lvl, options) {
    var normalizedValue = $52394bb05ad00d71$var$sortObject(value);
    var stringifiedValue = $8327cfee14109576$exports.prettyPrint(normalizedValue, {
        transform: function transform(currentObj, prop, originalResult) {
            var currentValue = currentObj[prop];
            if (currentValue && /*#__PURE__*/ $6mMqj.isValidElement(currentValue)) return $52394bb05ad00d71$var$formatTreeNode($52394bb05ad00d71$var$_parseReactElement(currentValue, options), true, lvl, options);
            if (typeof currentValue === 'function') return $52394bb05ad00d71$var$formatFunction(currentValue, options);
            return originalResult;
        }
    });
    if (inline) return stringifiedValue.replace(/\s+/g, ' ').replace(/{ /g, '{').replace(/ }/g, '}').replace(/\[ /g, '[').replace(/ ]/g, ']');
    // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, $52394bb05ad00d71$var$spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat($52394bb05ad00d71$var$spacer(lvl + 1, options.tabStop), "$1"));
};
var $52394bb05ad00d71$var$escape$1 = function escape(s) {
    return s.replace(/"/g, '&quot;');
};
var $52394bb05ad00d71$var$formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === 'number') return "{".concat(String(propValue), "}");
    if (typeof propValue === 'string') return "\"".concat($52394bb05ad00d71$var$escape$1(propValue), "\"");
    // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if ($52394bb05ad00d71$var$_typeof(propValue) === 'symbol') {
        var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, '$1');
        if (!symbolDescription) return "{Symbol()}";
        return "{Symbol('".concat(symbolDescription, "')}");
    }
    if (typeof propValue === 'function') return "{".concat($52394bb05ad00d71$var$formatFunction(propValue, options), "}");
    if (/*#__PURE__*/ $6mMqj.isValidElement(propValue)) return "{".concat($52394bb05ad00d71$var$formatTreeNode($52394bb05ad00d71$var$_parseReactElement(propValue, options), true, lvl, options), "}");
    if (propValue instanceof Date) {
        if (isNaN(propValue.valueOf())) return "{new Date(NaN)}";
        return "{new Date(\"".concat(propValue.toISOString(), "\")}");
    }
    if ($244e45c4ae06bfb5$exports.isPlainObject(propValue) || Array.isArray(propValue)) return "{".concat($52394bb05ad00d71$var$formatComplexDataStructure(propValue, inline, lvl, options), "}");
    return "{".concat(String(propValue), "}");
};
var $52394bb05ad00d71$var$formatProp = function formatProp(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) throw new Error("The prop \"".concat(name, "\" has no value and no default: could not be formatted"));
    var usedValue = hasValue ? value : defaultValue;
    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax, tabStop = options.tabStop;
    var formattedPropValue = $52394bb05ad00d71$var$formatPropValue(usedValue, inline, lvl, options);
    var attributeFormattedInline = ' ';
    var attributeFormattedMultiline = "\n".concat($52394bb05ad00d71$var$spacer(lvl + 1, tabStop));
    var isMultilineAttribute = formattedPropValue.includes('\n');
    if (useBooleanShorthandSyntax && formattedPropValue === '{false}' && !hasDefaultValue) {
        // If a boolean is false and not different from it's default, we do not render the attribute
        attributeFormattedInline = '';
        attributeFormattedMultiline = '';
    } else if (useBooleanShorthandSyntax && formattedPropValue === '{true}') {
        attributeFormattedInline += "".concat(name);
        attributeFormattedMultiline += "".concat(name);
    } else {
        attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
        attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
    }
    return {
        attributeFormattedInline: attributeFormattedInline,
        attributeFormattedMultiline: attributeFormattedMultiline,
        isMultilineAttribute: isMultilineAttribute
    };
};
var $52394bb05ad00d71$var$mergeSiblingPlainStringChildrenReducer = function mergeSiblingPlainStringChildrenReducer(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];
    if (previousNode && (currentNode.type === 'string' || currentNode.type === 'number') && (previousNode.type === 'string' || previousNode.type === 'number')) nodes.push($52394bb05ad00d71$var$createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    else {
        if (previousNode) nodes.push(previousNode);
        nodes.push(currentNode);
    }
    return nodes;
};
var $52394bb05ad00d71$var$isKeyOrRefProps = function isKeyOrRefProps(propName) {
    return [
        'key',
        'ref'
    ].includes(propName);
};
var $52394bb05ad00d71$var$sortPropsByNames = function sortPropsByNames(shouldSortUserProps) {
    return function(props) {
        var haveKeyProp = props.includes('key');
        var haveRefProp = props.includes('ref');
        var userPropsOnly = props.filter(function(oneProp) {
            return !$52394bb05ad00d71$var$isKeyOrRefProps(oneProp);
        });
        var sortedProps = shouldSortUserProps ? $52394bb05ad00d71$var$_toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
         : $52394bb05ad00d71$var$_toConsumableArray(userPropsOnly);
        if (haveRefProp) sortedProps.unshift('ref');
        if (haveKeyProp) sortedProps.unshift('key');
        return sortedProps;
    };
};
function $52394bb05ad00d71$var$createPropFilter(props, filter) {
    if (Array.isArray(filter)) return function(key) {
        return filter.indexOf(key) === -1;
    };
    else return function(key) {
        return filter(props[key], key);
    };
}
var $52394bb05ad00d71$var$compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;
    if (element.type === 'string') return formattedElement.split('\n').map(function(line, offset) {
        if (offset === 0) return line;
        return "".concat($52394bb05ad00d71$var$spacer(lvl, tabStop)).concat(line);
    }).join('\n');
    return formattedElement;
};
var $52394bb05ad00d71$var$formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function(element) {
        return $52394bb05ad00d71$var$compensateMultilineStringElementIndentation(element, $52394bb05ad00d71$var$formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
};
var $52394bb05ad00d71$var$onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function(propName) {
        var haveDefaultValue = Object.keys(defaultProps).includes(propName);
        return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
};
var $52394bb05ad00d71$var$isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) return attributes.length > 1;
    return $52394bb05ad00d71$var$spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};
var $52394bb05ad00d71$var$shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return ($52394bb05ad00d71$var$isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};
var $52394bb05ad00d71$var$formatReactElementNode = function formatReactElementNode(node, inline, lvl, options) {
    var type = node.type, _node$displayName = node.displayName, displayName = _node$displayName === void 0 ? '' : _node$displayName, childrens = node.childrens, _node$props = node.props, props = _node$props === void 0 ? {} : _node$props, _node$defaultProps = node.defaultProps, defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;
    if (type !== 'ReactElement') throw new Error("The \"formatReactElementNode\" function could only format node of type \"ReactElement\". Given:  ".concat(type));
    var filterProps = options.filterProps, maxInlineAttributesLineLength = options.maxInlineAttributesLineLength, showDefaultProps = options.showDefaultProps, sortProps = options.sortProps, tabStop = options.tabStop;
    var out = "<".concat(displayName);
    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;
    var visibleAttributeNames = [];
    var propFilter = $52394bb05ad00d71$var$createPropFilter(props, filterProps);
    Object.keys(props).filter(propFilter).filter($52394bb05ad00d71$var$onlyPropsWithOriginalValue(defaultProps, props)).forEach(function(propName) {
        return visibleAttributeNames.push(propName);
    });
    Object.keys(defaultProps).filter(propFilter).filter(function() {
        return showDefaultProps;
    }).filter(function(defaultPropName) {
        return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function(defaultPropName) {
        return visibleAttributeNames.push(defaultPropName);
    });
    var attributes = $52394bb05ad00d71$var$sortPropsByNames(sortProps)(visibleAttributeNames);
    attributes.forEach(function(attributeName) {
        var _formatProp = $52394bb05ad00d71$var$formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options), attributeFormattedInline = _formatProp.attributeFormattedInline, attributeFormattedMultiline = _formatProp.attributeFormattedMultiline, isMultilineAttribute = _formatProp.isMultilineAttribute;
        if (isMultilineAttribute) containsMultilineAttr = true;
        outInlineAttr += attributeFormattedInline;
        outMultilineAttr += attributeFormattedMultiline;
    });
    outMultilineAttr += "\n".concat($52394bb05ad00d71$var$spacer(lvl, tabStop));
    if ($52394bb05ad00d71$var$shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) out = outMultilineAttr;
    else out = outInlineAttr;
    if (childrens && childrens.length > 0) {
        var newLvl = lvl + 1;
        out += '>';
        if (!inline) {
            out += '\n';
            out += $52394bb05ad00d71$var$spacer(newLvl, tabStop);
        }
        out += childrens.reduce($52394bb05ad00d71$var$mergeSiblingPlainStringChildrenReducer, []).map($52394bb05ad00d71$var$formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat($52394bb05ad00d71$var$spacer(newLvl, tabStop)) : '');
        if (!inline) {
            out += '\n';
            out += $52394bb05ad00d71$var$spacer(newLvl - 1, tabStop);
        }
        out += "</".concat(displayName, ">");
    } else {
        if (!$52394bb05ad00d71$var$isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) out += ' ';
        out += '/>';
    }
    return out;
};
var $52394bb05ad00d71$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = '';
var $52394bb05ad00d71$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = 'React.Fragment';
var $52394bb05ad00d71$var$toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) props = {
        key: key
    };
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: {},
        childrens: childrens
    };
};
var $52394bb05ad00d71$var$isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
};
var $52394bb05ad00d71$var$hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
};
var $52394bb05ad00d71$var$formatReactFragmentNode = function formatReactFragmentNode(node, inline, lvl, options) {
    var type = node.type, key = node.key, childrens = node.childrens;
    if (type !== 'ReactFragment') throw new Error("The \"formatReactFragmentNode\" function could only format node of type \"ReactFragment\". Given: ".concat(type));
    var useFragmentShortSyntax = options.useFragmentShortSyntax;
    var displayName;
    if (useFragmentShortSyntax) {
        if ($52394bb05ad00d71$var$hasNoChildren(node) || $52394bb05ad00d71$var$isKeyedFragment(node)) displayName = $52394bb05ad00d71$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
        else displayName = $52394bb05ad00d71$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    } else displayName = $52394bb05ad00d71$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    return $52394bb05ad00d71$var$formatReactElementNode($52394bb05ad00d71$var$toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
};
var $52394bb05ad00d71$var$jsxStopChars = [
    '<',
    '>',
    '{',
    '}'
];
var $52394bb05ad00d71$var$shouldBeEscaped = function shouldBeEscaped(s) {
    return $52394bb05ad00d71$var$jsxStopChars.some(function(jsxStopChar) {
        return s.includes(jsxStopChar);
    });
};
var $52394bb05ad00d71$var$escape = function escape(s) {
    if (!$52394bb05ad00d71$var$shouldBeEscaped(s)) return s;
    return "{`".concat(s, "`}");
};
var $52394bb05ad00d71$var$preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(' ')) result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
    if (result.startsWith(' ')) result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
    return result;
};
var $52394bb05ad00d71$var$formatTreeNode = function formatTreeNode(node, inline, lvl, options) {
    if (node.type === 'number') return String(node.value);
    if (node.type === 'string') return node.value ? "".concat($52394bb05ad00d71$var$preserveTrailingSpace($52394bb05ad00d71$var$escape(String(node.value)))) : '';
    if (node.type === 'ReactElement') return $52394bb05ad00d71$var$formatReactElementNode(node, inline, lvl, options);
    if (node.type === 'ReactFragment') return $52394bb05ad00d71$var$formatReactFragmentNode(node, inline, lvl, options);
    throw new TypeError("Unknow format type \"".concat(node.type, "\""));
};
var $52394bb05ad00d71$var$formatTree = function formatTree(node, options) {
    return $52394bb05ad00d71$var$formatTreeNode(node, false, 0, options);
};
var $52394bb05ad00d71$var$reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$filterProps = _ref.filterProps, filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps, _ref$showDefaultProps = _ref.showDefaultProps, showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps, _ref$showFunctions = _ref.showFunctions, showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions, functionValue = _ref.functionValue, _ref$tabStop = _ref.tabStop, tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop, _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax, useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth, _ref$useFragmentShort = _ref.useFragmentShortSyntax, useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort, _ref$sortProps = _ref.sortProps, sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps, maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength, displayName = _ref.displayName;
    if (!element) throw new Error('react-element-to-jsx-string: Expected a ReactElement');
    var options = {
        filterProps: filterProps,
        showDefaultProps: showDefaultProps,
        showFunctions: showFunctions,
        functionValue: functionValue,
        tabStop: tabStop,
        useBooleanShorthandSyntax: useBooleanShorthandSyntax,
        useFragmentShortSyntax: useFragmentShortSyntax,
        sortProps: sortProps,
        maxInlineAttributesLineLength: maxInlineAttributesLineLength,
        displayName: displayName
    };
    return $52394bb05ad00d71$var$formatTree($52394bb05ad00d71$var$_parseReactElement(element, options), options);
};
$52394bb05ad00d71$exports["default"] = $52394bb05ad00d71$var$reactElementToJsxString;
$52394bb05ad00d71$exports.inlineFunction = $52394bb05ad00d71$var$inlineFunction;
$52394bb05ad00d71$exports.preserveFunctionLineBreak = $52394bb05ad00d71$var$preserveFunctionLineBreak;



var $073406e1dc6df849$export$71511d61b312f219;
"use strict";
var $650fa137dbfb3b42$export$71511d61b312f219;
"use strict";


function $650fa137dbfb3b42$var$_construct(Parent, args, Class) {
    if ($b8c8dbc1d05ae88c$export$71511d61b312f219()) $650fa137dbfb3b42$export$71511d61b312f219 = $650fa137dbfb3b42$var$_construct = Reflect.construct;
    else $650fa137dbfb3b42$export$71511d61b312f219 = $650fa137dbfb3b42$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $6bf3a766df389960$export$71511d61b312f219(instance, Class.prototype);
        return instance;
    };
    return $650fa137dbfb3b42$var$_construct.apply(null, arguments);
}
$650fa137dbfb3b42$export$71511d61b312f219 = $650fa137dbfb3b42$var$_construct;



var $047959298dde7a27$export$71511d61b312f219;
"use strict";
function $047959298dde7a27$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
$047959298dde7a27$export$71511d61b312f219 = $047959298dde7a27$var$_is_native_function;



function $073406e1dc6df849$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $073406e1dc6df849$export$71511d61b312f219 = $073406e1dc6df849$var$_wrap_native_super = function(Class) {
        if (Class === null || !$047959298dde7a27$export$71511d61b312f219(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $650fa137dbfb3b42$export$71511d61b312f219(Class, arguments, $435c1b7a62b9651a$export$71511d61b312f219(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $6bf3a766df389960$export$71511d61b312f219(Wrapper, Class);
    };
    return $073406e1dc6df849$var$_wrap_native_super(Class);
}
$073406e1dc6df849$export$71511d61b312f219 = $073406e1dc6df849$var$_wrap_native_super;



var $fPf27 = parcelRequire("fPf27");

var $hVBqc = parcelRequire("hVBqc");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $fsSDT = parcelRequire("fsSDT");

var $2wBSb = parcelRequire("2wBSb");

var $Csf8W = parcelRequire("Csf8W");
function $edbe2f6a95b5edf7$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $edbe2f6a95b5edf7$var$$22de11b45b0eeb97$exports = {};
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $edbe2f6a95b5edf7$export$c7e91f8aec23ae14;
});
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $edbe2f6a95b5edf7$export$51ca94569b882c51;
});
var $edbe2f6a95b5edf7$export$c7e91f8aec23ae14 = function $22de11b45b0eeb97$export$c7e91f8aec23ae14() {
    "use strict";
    var _this = this;
    (0, $7lhcp._)(this, $22de11b45b0eeb97$export$c7e91f8aec23ae14);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
var $edbe2f6a95b5edf7$export$51ca94569b882c51 = function() {
    return new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14();
};
var $edbe2f6a95b5edf7$var$$e3640f413e0c36e7$exports = {};
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $edbe2f6a95b5edf7$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
var $edbe2f6a95b5edf7$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    "use strict";
    function $e3640f413e0c36e7$export$77cea355fa80b5f4(subscriber) {
        (0, $7lhcp._)(this, $e3640f413e0c36e7$export$77cea355fa80b5f4);
        this.subscriber = subscriber;
    }
    (0, $8BtP9._)($e3640f413e0c36e7$export$77cea355fa80b5f4, [
        {
            key: Symbol.observable,
            value: function value() {
                return this;
            }
        },
        {
            key: Symbol.asyncIterator,
            value: function value() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $2wBSb._)(function() {
                    var queue, canceler, done, observer;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                queue = [
                                    new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14()
                                ], done = false;
                                observer = {
                                    next: function(value) {
                                        if (done) return;
                                        queue[queue.length - 1].resolve(value);
                                        queue.push(new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14());
                                    },
                                    error: function(reason) {
                                        if (!done) queue[queue.length - 1].reject(reason), done = true;
                                        if (canceler) canceler();
                                    },
                                    complete: function() {
                                        if (!done) queue[queue.length - 1].resolve(), done = true;
                                        if (canceler) canceler();
                                    }
                                };
                                canceler = this.subscriber(observer);
                                _state.label = 1;
                            case 1:
                                return [
                                    4,
                                    queue[0].promise
                                ];
                            case 2:
                                _state.sent();
                                queue.shift();
                                _state.label = 3;
                            case 3:
                                if (queue[0]) return [
                                    3,
                                    1
                                ];
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var stack, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stack = [];
                                _iteratorAbruptCompletion = false, _didIteratorError = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    12
                                ]);
                                _iterator = (0, $fPf27._)(this);
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _iterator.next()
                                ];
                            case 3:
                                if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                    3,
                                    5
                                ];
                                _value = _step.value;
                                item = _value;
                                stack.push(item);
                                if (stack.length > 2) stack.shift();
                                _state.label = 4;
                            case 4:
                                _iteratorAbruptCompletion = false;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    12
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    12
                                ];
                            case 7:
                                _state.trys.push([
                                    7,
                                    ,
                                    10,
                                    11
                                ]);
                                if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    _iterator.return()
                                ];
                            case 8:
                                _state.sent();
                                _state.label = 9;
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    2,
                                    stack[0]
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(onNext, onError, onComplete) {
                var _this = this;
                var stop = false;
                (function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, error;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        13,
                                        ,
                                        14
                                    ]);
                                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        7,
                                        12
                                    ]);
                                    _iterator = (0, $fPf27._)(this);
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        _iterator.next()
                                    ];
                                case 3:
                                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                        3,
                                        5
                                    ];
                                    _value = _step.value;
                                    item = _value;
                                    if (!stop) onNext(item);
                                    else return [
                                        3,
                                        5
                                    ];
                                    _state.label = 4;
                                case 4:
                                    _iteratorAbruptCompletion = false;
                                    return [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        12
                                    ];
                                case 6:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        12
                                    ];
                                case 7:
                                    _state.trys.push([
                                        7,
                                        ,
                                        10,
                                        11
                                    ]);
                                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                        3,
                                        9
                                    ];
                                    return [
                                        4,
                                        _iterator.return()
                                    ];
                                case 8:
                                    _state.sent();
                                    _state.label = 9;
                                case 9:
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                    return [
                                        7
                                    ];
                                case 11:
                                    return [
                                        7
                                    ];
                                case 12:
                                    if (onComplete instanceof Function) onComplete();
                                    return [
                                        3,
                                        14
                                    ];
                                case 13:
                                    error = _state.sent();
                                    if (onError instanceof Function) onError(error);
                                    return [
                                        3,
                                        14
                                    ];
                                case 14:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                })();
                return {
                    unsubscribe: function() {
                        return stop = true;
                    },
                    get closed () {
                        return stop;
                    }
                };
            }
        }
    ], [
        {
            key: "fromStream",
            value: function fromStream(list) {
                return new this(function(param) {
                    var next = param.next, complete = param.complete, error = param.error;
                    var stopped = false;
                    (function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                            var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, item, err, bug;
                            return (0, $Csf8W.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            13,
                                            ,
                                            14
                                        ]);
                                        _iteratorAbruptCompletion = false, _didIteratorError = false;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            7,
                                            12
                                        ]);
                                        _iterator = (0, $fPf27._)(list);
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            _iterator.next()
                                        ];
                                    case 3:
                                        if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                                            3,
                                            5
                                        ];
                                        _value = _step.value;
                                        item = _value;
                                        if (!stopped) next(item);
                                        else return [
                                            3,
                                            5
                                        ];
                                        _state.label = 4;
                                    case 4:
                                        _iteratorAbruptCompletion = false;
                                        return [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            12
                                        ];
                                    case 6:
                                        err = _state.sent();
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                        return [
                                            3,
                                            12
                                        ];
                                    case 7:
                                        _state.trys.push([
                                            7,
                                            ,
                                            10,
                                            11
                                        ]);
                                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                                            3,
                                            9
                                        ];
                                        return [
                                            4,
                                            _iterator.return()
                                        ];
                                    case 8:
                                        _state.sent();
                                        _state.label = 9;
                                    case 9:
                                        return [
                                            3,
                                            11
                                        ];
                                    case 10:
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                        return [
                                            7
                                        ];
                                    case 11:
                                        return [
                                            7
                                        ];
                                    case 12:
                                        if (!stopped) complete();
                                        return [
                                            3,
                                            14
                                        ];
                                    case 13:
                                        bug = _state.sent();
                                        if (!stopped) error(bug);
                                        return [
                                            3,
                                            14
                                        ];
                                    case 14:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    })();
                    return function() {
                        return stopped = true;
                    };
                });
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
                    items[_key] = arguments[_key];
                }
                return this.fromStream(items);
            }
        },
        {
            key: "from",
            value: function from(observable) {
                if (Symbol.iterator in observable) return this.of.apply(this, (0, $fsSDT._)(observable));
                if (Symbol.asyncIterator in observable) return this.fromStream(observable);
                return new this(function(param) {
                    var next = param.next, error = param.error, complete = param.complete;
                    return observable.subscribe(next, error, complete).unsubscribe;
                });
            }
        },
        {
            key: "fromEvent",
            value: function fromEvent(target, name) {
                return new this(function(param) {
                    var next = param.next, error = param.error;
                    if (typeof target.on === "function") target.on(name, next).on("error", error);
                    else {
                        target.addEventListener(name, next);
                        target.addEventListener("error", error);
                    }
                    return function() {
                        if (typeof target.off === "function") target.off(name, next).off("error", error);
                        else {
                            target.removeEventListener(name, next);
                            target.removeEventListener("error", error);
                        }
                    };
                });
            }
        }
    ]);
    return $e3640f413e0c36e7$export$77cea355fa80b5f4;
}();
var $edbe2f6a95b5edf7$var$$603f33a01a36ab56$exports = {};
$edbe2f6a95b5edf7$var$$parcel$export($edbe2f6a95b5edf7$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $edbe2f6a95b5edf7$export$d16acf4b6e75743d;
});
function $edbe2f6a95b5edf7$export$d16acf4b6e75743d() {
    var feedNext, stop;
    var observable = new $edbe2f6a95b5edf7$export$77cea355fa80b5f4(function(param) {
        var next = param.next, complete = param.complete;
        feedNext = next, stop = complete;
    });
    return {
        process: function(data) {
            var defer = new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy: function() {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}



var $arNK5 = parcelRequire("arNK5");

var $5f0Cq = parcelRequire("5f0Cq");

var $arNK5 = parcelRequire("arNK5");
parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $6mMqj = parcelRequire("6mMqj");

var $arNK5 = parcelRequire("arNK5");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
if (!(0, $12aPv.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $arNK5.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $6mMqj = parcelRequire("6mMqj");


var $6mMqj = parcelRequire("6mMqj");

var $arNK5 = parcelRequire("arNK5");
function $d080f66d55cb8007$export$fb2daceae6f5097a(callback) {
    callback();
}
function $d080f66d55cb8007$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $d080f66d55cb8007$export$fb2daceae6f5097a;
    (0, $arNK5.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $d080f66d55cb8007$export$13ce1459b9a04b51 = function isObserverBatched() {
    return true;
};


var $8da1f706795dcd9c$var$deprecatedMessages = [];
function $8da1f706795dcd9c$export$be38475be17599d(msg) {
    if (!$8da1f706795dcd9c$var$deprecatedMessages.includes(msg)) {
        $8da1f706795dcd9c$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $arNK5 = parcelRequire("arNK5");

var $6mMqj = parcelRequire("6mMqj");

var $arNK5 = parcelRequire("arNK5");
function $c064cd71d117b07c$export$ef795f1f307682c7(v) {
    return (0, $arNK5.getDependencyTree)(v);
}


var $fcad34362b610385$var$globalIsUsingStaticRendering = false;
function $fcad34362b610385$export$5d52eaa7c0f24c9e(enable) {
    $fcad34362b610385$var$globalIsUsingStaticRendering = enable;
}
function $fcad34362b610385$export$55979271896d643e() {
    return $fcad34362b610385$var$globalIsUsingStaticRendering;
}


var $1948ec40849aa820$export$e901ba0ffe10ba41 = 10000;
var $1948ec40849aa820$export$1ae22ce5a82f26b6 = 10000;
var $1948ec40849aa820$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value(maxAge) {
                if (maxAge === void 0) maxAge = $1948ec40849aa820$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function value() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(target, _value, token) {
            this.registrations.set(token, {
                value: _value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $1948ec40849aa820$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $1948ec40849aa820$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $1948ec40849aa820$export$b7a00d372cedeedd;


var $fecaf762ae7ac445$export$10e8a12fbfd8583c = new (0, $1948ec40849aa820$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $b59bdcd7aecdb994$exports = {};
'use strict';

$b59bdcd7aecdb994$exports = (parcelRequire("56BWk"));


function $9a117933bb13c08d$var$createReaction(adm) {
    adm.reaction = new (0, $arNK5.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $9a117933bb13c08d$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $fcad34362b610385$export$55979271896d643e)()) return render();
    var admRef = (0, $6mMqj.default).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function subscribe(onStoreChange) {
                // Do NOT access admRef here!
                (0, $fecaf762ae7ac445$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $9a117933bb13c08d$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function getSnapshot() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $9a117933bb13c08d$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $fecaf762ae7ac445$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, $6mMqj.default).useDebugValue(adm.reaction, (0, $c064cd71d117b07c$export$ef795f1f307682c7));
    (0, $b59bdcd7aecdb994$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $6mMqj = parcelRequire("6mMqj");


var $9e49fe152147dee5$var$_a, $9e49fe152147dee5$var$_b;
var $9e49fe152147dee5$var$warnObserverOptionsDeprecated = true;
var $9e49fe152147dee5$var$warnLegacyContextTypes = true;
var $9e49fe152147dee5$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $9e49fe152147dee5$var$isFunctionNameConfigurable = ($9e49fe152147dee5$var$_b = ($9e49fe152147dee5$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $9e49fe152147dee5$var$_a === void 0 ? void 0 : $9e49fe152147dee5$var$_a.configurable) !== null && $9e49fe152147dee5$var$_b !== void 0 ? $9e49fe152147dee5$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $9e49fe152147dee5$var$ReactForwardRefSymbol = $9e49fe152147dee5$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $6mMqj.forwardRef) === "function" && (0, $6mMqj.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $9e49fe152147dee5$var$ReactMemoSymbol = $9e49fe152147dee5$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $6mMqj.memo) === "function" && (0, $6mMqj.memo)(function(props) {
    return null;
})["$$typeof"];
function $9e49fe152147dee5$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($9e49fe152147dee5$var$ReactMemoSymbol && baseComponent["$$typeof"] === $9e49fe152147dee5$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $fcad34362b610385$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($9e49fe152147dee5$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $9e49fe152147dee5$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function observerComponent(props, ref) {
        return (0, $9a117933bb13c08d$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($9e49fe152147dee5$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $6mMqj.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $6mMqj.memo)(observerComponent);
    $9e49fe152147dee5$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $9e49fe152147dee5$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $9e49fe152147dee5$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$9e49fe152147dee5$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



var $5f0Cq = parcelRequire("5f0Cq");

function $7a8ba0af19646281$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $9a117933bb13c08d$export$b9c7ecd090a87b14)(component);
}
$7a8ba0af19646281$export$c1cbdee04e18ea8b.displayName = "Observer";
function $7a8ba0af19646281$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + (0, $5f0Cq._)(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $arNK5 = parcelRequire("arNK5");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $71367577f23166de$export$aa207039f277c5f(initializer, annotations) {
    return (0, $12aPv.useState)(function() {
        return (0, $arNK5.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $arNK5 = parcelRequire("arNK5");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



var $arNK5 = parcelRequire("arNK5");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $7bcb5ed9afdddf66$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $12aPv.useState)(function() {
        return (0, $arNK5.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $arNK5.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $317a4076026d077e$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $7bcb5ed9afdddf66$export$e0ded3646391939c)(current);
    return (0, $12aPv.useState)(function() {
        return (0, $arNK5.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $6d27aa7b05aa38c1$var$_a;
(0, $d080f66d55cb8007$export$294943bbc3c74f4f)((0, $6mMqj.unstable_batchedUpdates));
var $6d27aa7b05aa38c1$export$469d51fb8d268227 = ($6d27aa7b05aa38c1$var$_a = (0, $fecaf762ae7ac445$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $6d27aa7b05aa38c1$var$_a !== void 0 ? $6d27aa7b05aa38c1$var$_a : function clearTimers() {};
function $6d27aa7b05aa38c1$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $9a117933bb13c08d$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $6d27aa7b05aa38c1$export$7613124ee4202834(enable) {
    (0, $fcad34362b610385$export$5d52eaa7c0f24c9e)(enable);
}


function $5bcfa0e0ec438674$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($5bcfa0e0ec438674$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $5f0Cq._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $5f0Cq._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$5bcfa0e0ec438674$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $5bcfa0e0ec438674$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $5bcfa0e0ec438674$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $5bcfa0e0ec438674$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$5bcfa0e0ec438674$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $5bcfa0e0ec438674$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $5bcfa0e0ec438674$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $5bcfa0e0ec438674$var$getMixins(target, methodName) {
    var mixins = target[$5bcfa0e0ec438674$var$mobxMixins] = target[$5bcfa0e0ec438674$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $5bcfa0e0ec438674$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $5bcfa0e0ec438674$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $5bcfa0e0ec438674$var$wrapper.call.apply($5bcfa0e0ec438674$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $5bcfa0e0ec438674$var$patch(target, methodName, mixinMethod) {
    var mixins = $5bcfa0e0ec438674$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$5bcfa0e0ec438674$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $5bcfa0e0ec438674$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $5bcfa0e0ec438674$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $5bcfa0e0ec438674$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$5bcfa0e0ec438674$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $5bcfa0e0ec438674$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $5bcfa0e0ec438674$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $5bcfa0e0ec438674$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $5bcfa0e0ec438674$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $5bcfa0e0ec438674$var$observablePropDescriptors;
function $5bcfa0e0ec438674$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$5bcfa0e0ec438674$var$administrationSymbol]) != null ? _component$administra : component[$5bcfa0e0ec438674$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $5bcfa0e0ec438674$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $5bcfa0e0ec438674$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$5bcfa0e0ec438674$var$isMobXReactObserverSymbol]) {
        var displayName = $5bcfa0e0ec438674$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$5bcfa0e0ec438674$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $6mMqj.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $5bcfa0e0ec438674$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $5bcfa0e0ec438674$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $5bcfa0e0ec438674$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $fcad34362b610385$export$55979271896d643e)() ? originalRender : $5bcfa0e0ec438674$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $5bcfa0e0ec438674$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $fecaf762ae7ac445$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $5bcfa0e0ec438674$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $fcad34362b610385$export$55979271896d643e)()) return;
        var admin = $5bcfa0e0ec438674$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $5bcfa0e0ec438674$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $5bcfa0e0ec438674$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $5bcfa0e0ec438674$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $5bcfa0e0ec438674$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $fecaf762ae7ac445$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $arNK5._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $5bcfa0e0ec438674$var$createReaction(admin) {
    return new (0, $arNK5.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $5bcfa0e0ec438674$var$observerSCU(nextProps, nextState) {
    if ((0, $fcad34362b610385$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$5bcfa0e0ec438674$var$shallowEqual(this.props, nextProps);
}
function $5bcfa0e0ec438674$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $5bcfa0e0ec438674$var$getAdministration(this);
            var derivation = (0, $arNK5._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $5bcfa0e0ec438674$var$getAdministration(this)[key] = value;
        }
    };
}
function $5bcfa0e0ec438674$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $fClfl.Component), component) || Object.prototype.isPrototypeOf.call((0, $6mMqj.PureComponent), component)) // Class component
    return $5bcfa0e0ec438674$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $9e49fe152147dee5$export$b6ae1bc530f4c149)(component);
}
function $5bcfa0e0ec438674$var$_extends() {
    return $5bcfa0e0ec438674$var$_extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5bcfa0e0ec438674$var$_extends.apply(null, arguments);
}
function $5bcfa0e0ec438674$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $5bcfa0e0ec438674$var$_excluded = [
    "children"
];
var $5bcfa0e0ec438674$export$f07786cea590ef31 = /*#__PURE__*/ (0, $6mMqj.default).createContext({});
function $5bcfa0e0ec438674$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $5bcfa0e0ec438674$var$_objectWithoutPropertiesLoose(props, $5bcfa0e0ec438674$var$_excluded);
    var parentValue = (0, $6mMqj.default).useContext($5bcfa0e0ec438674$export$f07786cea590ef31);
    var mutableProviderRef = (0, $6mMqj.default).useRef($5bcfa0e0ec438674$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, $6mMqj.default).createElement($5bcfa0e0ec438674$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$5bcfa0e0ec438674$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $5bcfa0e0ec438674$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, $6mMqj.default).forwardRef(function(props, ref) {
        var newProps = $5bcfa0e0ec438674$var$_extends({}, props);
        var context = (0, $6mMqj.default).useContext($5bcfa0e0ec438674$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, $6mMqj.default).createElement(component, newProps);
    });
    if (makeReactive) Injector = $5bcfa0e0ec438674$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $5bcfa0e0ec438674$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $5bcfa0e0ec438674$var$getInjectName(component, injectNames);
    return Injector;
}
function $5bcfa0e0ec438674$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $5bcfa0e0ec438674$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $5bcfa0e0ec438674$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $5bcfa0e0ec438674$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $5bcfa0e0ec438674$var$createStoreInjector($5bcfa0e0ec438674$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $5bcfa0e0ec438674$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, $6mMqj.default).version.split(".")[0]);
var $5bcfa0e0ec438674$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $5bcfa0e0ec438674$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $5bcfa0e0ec438674$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $5bcfa0e0ec438674$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$5bcfa0e0ec438674$var$protoStoreKey] || [], this[$5bcfa0e0ec438674$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $5bcfa0e0ec438674$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $5bcfa0e0ec438674$export$4e749cb731da87a9(target, fn);
    });
    if (!$5bcfa0e0ec438674$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($5bcfa0e0ec438674$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $5bcfa0e0ec438674$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, $6mMqj.default).Component || c === (0, $6mMqj.default).PureComponent || c2 === (0, $6mMqj.default).Component || c2 === (0, $6mMqj.default).PureComponent || c3 === (0, $6mMqj.default).Component || c3 === (0, $6mMqj.default).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$5bcfa0e0ec438674$var$protoStoreKey] || !!target[$5bcfa0e0ec438674$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$5bcfa0e0ec438674$var$protoStoreKey] || (target[$5bcfa0e0ec438674$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$5bcfa0e0ec438674$var$instStoreKey] || (target[$5bcfa0e0ec438674$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $5bcfa0e0ec438674$var$patch(target, "componentWillUnmount", $5bcfa0e0ec438674$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $5bcfa0e0ec438674$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $arNK5.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $5bcfa0e0ec438674$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $5bcfa0e0ec438674$var$getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : (0, $5f0Cq._)(propValue);
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($5bcfa0e0ec438674$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $5bcfa0e0ec438674$var$getPreciseType(propValue) {
    var propType = $5bcfa0e0ec438674$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $5bcfa0e0ec438674$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $5bcfa0e0ec438674$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $arNK5.untracked)(function() {
            if (allowNativeType) {
                if ($5bcfa0e0ec438674$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $arNK5.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $arNK5.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $arNK5.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $5bcfa0e0ec438674$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $5bcfa0e0ec438674$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $5bcfa0e0ec438674$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $arNK5.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $5bcfa0e0ec438674$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $5bcfa0e0ec438674$var$observableArray = /*#__PURE__*/ $5bcfa0e0ec438674$var$createObservableTypeCheckerCreator(false, "Array");
var $5bcfa0e0ec438674$var$observableArrayOf = /*#__PURE__*/ $5bcfa0e0ec438674$var$createObservableArrayOfTypeChecker.bind(null, false);
var $5bcfa0e0ec438674$var$observableMap = /*#__PURE__*/ $5bcfa0e0ec438674$var$createObservableTypeCheckerCreator(false, "Map");
var $5bcfa0e0ec438674$var$observableObject = /*#__PURE__*/ $5bcfa0e0ec438674$var$createObservableTypeCheckerCreator(false, "Object");
var $5bcfa0e0ec438674$var$arrayOrObservableArray = /*#__PURE__*/ $5bcfa0e0ec438674$var$createObservableTypeCheckerCreator(true, "Array");
var $5bcfa0e0ec438674$var$arrayOrObservableArrayOf = /*#__PURE__*/ $5bcfa0e0ec438674$var$createObservableArrayOfTypeChecker.bind(null, true);
var $5bcfa0e0ec438674$var$objectOrObservableObject = /*#__PURE__*/ $5bcfa0e0ec438674$var$createObservableTypeCheckerCreator(true, "Object");
var $5bcfa0e0ec438674$export$e0c95a451cd220b7 = {
    observableArray: $5bcfa0e0ec438674$var$observableArray,
    observableArrayOf: $5bcfa0e0ec438674$var$observableArrayOf,
    observableMap: $5bcfa0e0ec438674$var$observableMap,
    observableObject: $5bcfa0e0ec438674$var$observableObject,
    arrayOrObservableArray: $5bcfa0e0ec438674$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $5bcfa0e0ec438674$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $5bcfa0e0ec438674$var$objectOrObservableObject
};
if (!(0, $fClfl.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $arNK5.observable)) throw new Error("mobx-react requires mobx to be available");


var $678eb2518fcd1152$export$71511d61b312f219;
"use strict";

$678eb2518fcd1152$export$71511d61b312f219 = (parcelRequire("Csf8W")).__generator;




function $819452666ec7d3d4$export$da8ca15f4115b46e() {
    if (typeof window !== 'undefined') {
        var Component = (parcelRequire("k4gAU"));
        return Component.default || Component;
    } else {
        var Component1 = (parcelRequire("kVnWJ"));
        return Component1.default || Component1;
    }
}


var $3e3a7251f1f53fd8$exports = {};

var $6GCxi = parcelRequire("6GCxi");
"use strict";
var $3e3a7251f1f53fd8$var$e = {
    code: function(param) {
        var e = param.data;
        return "<pre><code>".concat(e.code, "</code></pre>");
    },
    embed: function(param) {
        var e = param.data;
        var t = e.service;
        return "vimeo" === t ? '<iframe src="'.concat(e.embed, '" height="').concat(e.height, '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>') : "youtube" === t ? '<iframe width="'.concat(e.width, '" height="').concat(e.height, '" src="').concat(e.embed, '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>') : (console.error("[editorjs-html]: Only Youtube & Vimeo embeds are available by default. Write your own embed parser for other options."), "");
    },
    header: function(param) {
        var e = param.data;
        return "<h".concat(e.level, ">").concat(e.text, "</h").concat(e.level, ">");
    },
    image: function(param) {
        var e = param.data;
        var _e_file;
        var t = e.caption ? e.caption : "Image";
        return '<img src="'.concat((e === null || e === void 0 ? void 0 : (_e_file = e.file) === null || _e_file === void 0 ? void 0 : _e_file.url) || (e === null || e === void 0 ? void 0 : e.url), '" alt="').concat(t, '" />');
    },
    list: function(param) {
        var e = param.data;
        var t = "unordered" === e.style ? "ul" : "ol", r = function(e, t) {
            var o = e.map(function(e) {
                var _e_items;
                if (!e.content && !e.items) return "<li>".concat(e, "</li>");
                var o = "";
                return ((_e_items = e.items) === null || _e_items === void 0 ? void 0 : _e_items.length) && (o = r(e.items, t)), e.content ? "<li>".concat(e.content).concat(o, "</li>") : void 0;
            });
            return "<".concat(t, ">").concat(o.join(""), "</").concat(t, ">");
        };
        return r(e.items, t);
    },
    paragraph: function(param) {
        var e = param.data;
        var t = e.alignment || e.align;
        return t ? '<p style="text-align:'.concat(t, '"> ').concat(e.text, " </p>") : "<p>".concat(e.text, "</p>");
    },
    quote: function(param) {
        var e = param.data;
        return "<blockquote>".concat(e.text, "</blockquote> - ").concat(e.caption);
    },
    delimiter: function(param) {
        var e = param.data;
        return "<br/>";
    }
};
$3e3a7251f1f53fd8$exports = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        strict: !1
    };
    var o = (0, $6GCxi._)({}, $3e3a7251f1f53fd8$var$e, t);
    return {
        parse: function(e) {
            return function(param, t, r) {
                var _$e = param.blocks;
                return _$e.reduce(function(e, o) {
                    if (o.type in t) return e + t[o.type](o);
                    var i = "[editorjs-html]: Parser function for ".concat(o.type, " does not exist");
                    if (r.strict) throw new Error(i);
                    return console.error(i), e;
                }, "");
            }(e, o, r);
        },
        parseBlock: function(e) {
            return function(e, t, r) {
                if (e.type in t) return t[e.type](e);
                var o = "[editorjs-html]: Parser function for ".concat(e.type, " does not exist");
                if (r.strict) throw new Error(o);
                console.error(o);
            }(e, o, r);
        }
    };
};



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
function $b1b5af5a4dd68de6$export$71511d61b312f219() {
    $b1b5af5a4dd68de6$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1b5af5a4dd68de6$export$71511d61b312f219.apply(this, arguments);
}




var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");
parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

"use client";
var $fb3854fa54537b64$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $fb3854fa54537b64$export$ff817e17bad2e091 = 'xs';
var $fb3854fa54537b64$var$ThemeContext = /*#__PURE__*/ $fClfl.createContext({
    prefixes: {},
    breakpoints: $fb3854fa54537b64$export$666ad80b5007f835,
    minBreakpoint: $fb3854fa54537b64$export$ff817e17bad2e091
});
var $fb3854fa54537b64$export$b631efc24e9d5e2f = $fb3854fa54537b64$var$ThemeContext.Consumer, $fb3854fa54537b64$var$Provider = $fb3854fa54537b64$var$ThemeContext.Provider;
function $fb3854fa54537b64$var$ThemeProvider(param) {
    var _param_prefixes = param.prefixes, prefixes = _param_prefixes === void 0 ? {} : _param_prefixes, _param_breakpoints = param.breakpoints, breakpoints = _param_breakpoints === void 0 ? $fb3854fa54537b64$export$666ad80b5007f835 : _param_breakpoints, _param_minBreakpoint = param.minBreakpoint, minBreakpoint = _param_minBreakpoint === void 0 ? $fb3854fa54537b64$export$ff817e17bad2e091 : _param_minBreakpoint, dir = param.dir, children = param.children;
    var contextValue = (0, $12aPv.useMemo)(function() {
        return {
            prefixes: (0, $6GCxi._)({}, prefixes),
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        };
    }, [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fb3854fa54537b64$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $fb3854fa54537b64$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $12aPv.useContext)($fb3854fa54537b64$var$ThemeContext).prefixes;
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $fb3854fa54537b64$export$8970c8db816a5863() {
    var breakpoints = (0, $12aPv.useContext)($fb3854fa54537b64$var$ThemeContext).breakpoints;
    return breakpoints;
}
function $fb3854fa54537b64$export$d926d6ef38f3fd32() {
    var minBreakpoint = (0, $12aPv.useContext)($fb3854fa54537b64$var$ThemeContext).minBreakpoint;
    return minBreakpoint;
}
function $fb3854fa54537b64$export$35e511eefa30ac5a() {
    var dir = (0, $12aPv.useContext)($fb3854fa54537b64$var$ThemeContext).dir;
    return dir === 'rtl';
}
function $fb3854fa54537b64$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    var prefix = opts.prefix, _opts_forwardRefAs = opts.forwardRefAs, forwardRefAs = _opts_forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts_forwardRefAs;
    var Wrapped = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
        var props = (0, $b1b5af5a4dd68de6$export$71511d61b312f219)({}, (0, $4b94edc8487dfe49$export$71511d61b312f219)(_param));
        props[forwardRefAs] = ref;
        var bsPrefix = $fb3854fa54537b64$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(".concat(Component.displayName || Component.name, ")");
    return Wrapped;
}
var $fb3854fa54537b64$export$2e2bcd8739ae039 = $fb3854fa54537b64$var$ThemeProvider;



"use client";
var $f1387cf7abf6568e$var$Badge = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_bg = _param.bg, bg = _param_bg === void 0 ? 'primary' : _param_bg, _param_pill = _param.pill, pill = _param_pill === void 0 ? false : _param_pill, text = _param.text, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "bg",
        "pill",
        "text",
        "className",
        "as"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, pill && "rounded-pill", text && "text-".concat(text), bg && "bg-".concat(bg))
    }));
});
$f1387cf7abf6568e$var$Badge.displayName = 'Badge';
var $f1387cf7abf6568e$export$2e2bcd8739ae039 = $f1387cf7abf6568e$var$Badge;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");


var $6mMqj = parcelRequire("6mMqj");

var $leE2g = parcelRequire("leE2g");

var $6mMqj = parcelRequire("6mMqj");

var $920182a7008094bc$var$_excluded = [
    "as",
    "disabled"
];
function $920182a7008094bc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $920182a7008094bc$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $920182a7008094bc$export$a0ee72f2c720a5c3(param) {
    var tagName = param.tagName, disabled = param.disabled, href = param.href, target = param.target, rel = param.rel, role = param.role, onClick = param.onClick, _param_tabIndex = param.tabIndex, tabIndex = _param_tabIndex === void 0 ? 0 : _param_tabIndex, type = param.type;
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    var meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    var handleClick = function(event) {
        if (disabled || tagName === 'a' && $920182a7008094bc$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    var handleKeyDown = function(event) {
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
var $920182a7008094bc$var$Button = /*#__PURE__*/ $6mMqj.forwardRef(function(_ref, ref) {
    var asProp = _ref.as, disabled = _ref.disabled, props = $920182a7008094bc$var$_objectWithoutPropertiesLoose(_ref, $920182a7008094bc$var$_excluded);
    var _useButtonProps = (0, $leE2g._)($920182a7008094bc$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props)), 2), buttonProps = _useButtonProps[0], _useButtonProps_ = _useButtonProps[1], Component = _useButtonProps_.tagName;
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$920182a7008094bc$var$Button.displayName = 'Button';
var $920182a7008094bc$export$2e2bcd8739ae039 = $920182a7008094bc$var$Button;




"use client";
var $4a228d6edec70b31$var$Button = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var as = _param.as, bsPrefix = _param.bsPrefix, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'primary' : _param_variant, size = _param.size, _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = _param.className, props = (0, $8MJI4._)(_param, [
        "as",
        "bsPrefix",
        "variant",
        "size",
        "active",
        "disabled",
        "className"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'btn');
    var _useButtonProps = (0, $leE2g._)((0, $920182a7008094bc$export$a0ee72f2c720a5c3)((0, $6GCxi._)({
        tagName: as,
        disabled: disabled
    }, props)), 2), buttonProps = _useButtonProps[0], tagName = _useButtonProps[1].tagName;
    var Component = tagName;
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, buttonProps, props), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, active && 'active', variant && "".concat(prefix, "-").concat(variant), size && "".concat(prefix, "-").concat(size), props.href && disabled && 'disabled')
    }));
});
$4a228d6edec70b31$var$Button.displayName = 'Button';
var $4a228d6edec70b31$export$2e2bcd8739ae039 = $4a228d6edec70b31$var$Button;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $22af339f277c488c$var$CardBody = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$22af339f277c488c$var$CardBody.displayName = 'CardBody';
var $22af339f277c488c$export$2e2bcd8739ae039 = $22af339f277c488c$var$CardBody;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $fd0fb91cf862952b$var$CardFooter = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$fd0fb91cf862952b$var$CardFooter.displayName = 'CardFooter';
var $fd0fb91cf862952b$export$2e2bcd8739ae039 = $fd0fb91cf862952b$var$CardFooter;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
"use client";
var $2cf1243542873def$var$context = /*#__PURE__*/ $fClfl.createContext(null);
$2cf1243542873def$var$context.displayName = 'CardHeaderContext';
var $2cf1243542873def$export$2e2bcd8739ae039 = $2cf1243542873def$var$context;



"use client";
var $74844a2b3d3414c9$var$CardHeader = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    var contextValue = (0, $12aPv.useMemo)(function() {
        return {
            cardHeaderBsPrefix: prefix
        };
    }, [
        prefix
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $2cf1243542873def$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix)
        }))
    });
});
$74844a2b3d3414c9$var$CardHeader.displayName = 'CardHeader';
var $74844a2b3d3414c9$export$2e2bcd8739ae039 = $74844a2b3d3414c9$var$CardHeader;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $78a3ea901b8be149$var$CardImg = /*#__PURE__*/ $6mMqj.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, variant = _param.variant, tmp = _param.as, Component = tmp === void 0 ? 'img' : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "variant",
        "as"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(variant ? "".concat(prefix, "-").concat(variant) : prefix, className)
    }, props));
});
$78a3ea901b8be149$var$CardImg.displayName = 'CardImg';
var $78a3ea901b8be149$export$2e2bcd8739ae039 = $78a3ea901b8be149$var$CardImg;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $c2a91a11c1bff6d1$var$CardImgOverlay = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$c2a91a11c1bff6d1$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $c2a91a11c1bff6d1$export$2e2bcd8739ae039 = $c2a91a11c1bff6d1$var$CardImgOverlay;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $959d147215ddfd50$var$CardLink = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'a' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$959d147215ddfd50$var$CardLink.displayName = 'CardLink';
var $959d147215ddfd50$export$2e2bcd8739ae039 = $959d147215ddfd50$var$CardLink;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $6mMqj = parcelRequire("6mMqj");


var $197a01a380243da0$export$2e2bcd8739ae039 = function(className) {
    return(/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $6mMqj.forwardRef(function(p, ref) {
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({}, p), {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(p.className, className)
        }));
    }));
};



"use client";
var $7fc165b262d8450f$var$DivStyledAsH6 = (0, $197a01a380243da0$export$2e2bcd8739ae039)('h6');
var $7fc165b262d8450f$var$CardSubtitle = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $7fc165b262d8450f$var$DivStyledAsH6 : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$7fc165b262d8450f$var$CardSubtitle.displayName = 'CardSubtitle';
var $7fc165b262d8450f$export$2e2bcd8739ae039 = $7fc165b262d8450f$var$CardSubtitle;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $e4392c585993d248$var$CardText = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'p' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$e4392c585993d248$var$CardText.displayName = 'CardText';
var $e4392c585993d248$export$2e2bcd8739ae039 = $e4392c585993d248$var$CardText;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");




"use client";
var $da5a3a670cc78d81$var$DivStyledAsH5 = (0, $197a01a380243da0$export$2e2bcd8739ae039)('h5');
var $da5a3a670cc78d81$var$CardTitle = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $da5a3a670cc78d81$var$DivStyledAsH5 : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$da5a3a670cc78d81$var$CardTitle.displayName = 'CardTitle';
var $da5a3a670cc78d81$export$2e2bcd8739ae039 = $da5a3a670cc78d81$var$CardTitle;



"use client";
var $5144fe88f07c89a5$var$Card = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, bg = _param.bg, text = _param.text, border = _param.border, _param_body = _param.body, body = _param_body === void 0 ? false : _param_body, children = _param.children, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children",
        "as"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, bg && "bg-".concat(bg), text && "text-".concat(text), border && "border-".concat(border)),
        children: body ? /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $22af339f277c488c$export$2e2bcd8739ae039), {
            children: children
        }) : children
    }));
});
$5144fe88f07c89a5$var$Card.displayName = 'Card';
var $5144fe88f07c89a5$export$2e2bcd8739ae039 = Object.assign($5144fe88f07c89a5$var$Card, {
    Img: (0, $78a3ea901b8be149$export$2e2bcd8739ae039),
    Title: (0, $da5a3a670cc78d81$export$2e2bcd8739ae039),
    Subtitle: (0, $7fc165b262d8450f$export$2e2bcd8739ae039),
    Body: (0, $22af339f277c488c$export$2e2bcd8739ae039),
    Link: (0, $959d147215ddfd50$export$2e2bcd8739ae039),
    Text: (0, $e4392c585993d248$export$2e2bcd8739ae039),
    Header: (0, $74844a2b3d3414c9$export$2e2bcd8739ae039),
    Footer: (0, $fd0fb91cf862952b$export$2e2bcd8739ae039),
    ImgOverlay: (0, $c2a91a11c1bff6d1$export$2e2bcd8739ae039)
});


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");


var $6mMqj = parcelRequire("6mMqj");


"use client";
function $27ad5a1fd7e6d114$export$2ed43d61a0a9f5a3(_param) {
    var as = _param.as, bsPrefix = _param.bsPrefix, className = _param.className, props = (0, $8MJI4._)(_param, [
        "as",
        "bsPrefix",
        "className"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'col');
    var breakpoints = (0, $fb3854fa54537b64$export$8970c8db816a5863)();
    var minBreakpoint = (0, $fb3854fa54537b64$export$d926d6ef38f3fd32)();
    var spans = [];
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        var ref;
        if ((typeof propValue === "undefined" ? "undefined" : (0, $5f0Cq._)(propValue)) === 'object' && propValue != null) ref = propValue, span = ref.span, offset = ref.offset, order = ref.order, ref;
        else span = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
        if (span) spans.push(span === true ? "".concat(bsPrefix).concat(infix) : "".concat(bsPrefix).concat(infix, "-").concat(span));
        if (order != null) classes.push("order".concat(infix, "-").concat(order));
        if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
    });
    return [
        (0, $ctBui._)((0, $6GCxi._)({}, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
                className
            ].concat((0, $fsSDT._)(spans), (0, $fsSDT._)(classes)))
        }),
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
var $27ad5a1fd7e6d114$var$Col = /*#__PURE__*/ $6mMqj.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(props, ref) {
    var _useCol = $27ad5a1fd7e6d114$export$2ed43d61a0a9f5a3(props), _useCol1 = (0, $leE2g._)(_useCol, 2), className = _useCol1[0].className, _useCol_ = _useCol1[1], tmp = _useCol_.as, Component = tmp === void 0 ? 'div' : tmp, bsPrefix = _useCol_.bsPrefix, spans = _useCol_.spans, colProps = (0, $8MJI4._)(_useCol[0], [
        "className"
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, colProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, !spans.length && bsPrefix)
    }));
});
$27ad5a1fd7e6d114$var$Col.displayName = 'Col';
var $27ad5a1fd7e6d114$export$2e2bcd8739ae039 = $27ad5a1fd7e6d114$var$Col;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $leE2g = parcelRequire("leE2g");
var $aa7848f343bf09c4$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $aa7848f343bf09c4$export$2e2bcd8739ae039(element, selector) {
    return $aa7848f343bf09c4$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $64f258eaaf92e603$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $fe9809a8616a080a$export$63fefd044b2bc624 = false;
var $fe9809a8616a080a$export$a614c6b395900f69 = false;
try {
    var $fe9809a8616a080a$var$options = {
        get passive () {
            return $fe9809a8616a080a$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $fe9809a8616a080a$export$a614c6b395900f69 = $fe9809a8616a080a$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $64f258eaaf92e603$export$2e2bcd8739ae039) {
        window.addEventListener('test', $fe9809a8616a080a$var$options, $fe9809a8616a080a$var$options);
        window.removeEventListener('test', $fe9809a8616a080a$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $fe9809a8616a080a$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$fe9809a8616a080a$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$fe9809a8616a080a$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $fe9809a8616a080a$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $fe9809a8616a080a$export$2e2bcd8739ae039 = $fe9809a8616a080a$var$addEventListener;


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $5RfYb = parcelRequire("5RfYb");

var $leE2g = parcelRequire("leE2g");

var $4L6tH = parcelRequire("4L6tH");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $b478810c3b863a04$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b478810c3b863a04$var$_toPropertyKey(arg) {
    var key = $b478810c3b863a04$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $5f0Cq._)(key)) === "symbol" ? key : String(key);
}
function $b478810c3b863a04$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $5f0Cq._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $5f0Cq._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b478810c3b863a04$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b478810c3b863a04$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $12aPv.useRef)(propValue !== undefined);
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(defaultValue), 2), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $12aPv.useCallback)(function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _args = (0, $4L6tH._)(args), value = _args[0], rest = _args.slice(1);
            var returnValue = handler == null ? void 0 : handler.apply(void 0, [
                value
            ].concat((0, $fsSDT._)(rest)));
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $b478810c3b863a04$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _ref = result, _defaultKey = $b478810c3b863a04$export$26cbf8c37e721e67(fieldName), defaultValue = _ref[_defaultKey], propsValue = _ref[fieldName], rest = $b478810c3b863a04$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($b478810c3b863a04$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = (0, $leE2g._)($b478810c3b863a04$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), 2), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        var _obj;
        return Object.assign({}, rest, (_obj = {}, (0, $5RfYb._)(_obj, fieldName, value), (0, $5RfYb._)(_obj, handlerName, handler), _obj));
    }, props);
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $3b1b41e6f8e3c97a$export$2e2bcd8739ae039(value) {
    var ref = (0, $12aPv.useRef)(null);
    (0, $12aPv.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}



var $leE2g = parcelRequire("leE2g");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $3250bc95c1f69221$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    var _useReducer = (0, $leE2g._)((0, $12aPv.useReducer)(function(revision) {
        return revision + 1;
    }, 0), 2), dispatch = _useReducer[1];
    return dispatch;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $fsSDT = parcelRequire("fsSDT");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ce1b11e01dbf9498$var$useCommittedRef(value) {
    var ref = (0, $12aPv.useRef)(value);
    (0, $12aPv.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ce1b11e01dbf9498$export$2e2bcd8739ae039 = $ce1b11e01dbf9498$var$useCommittedRef;


function $0339cc266363564f$export$2e2bcd8739ae039(fn) {
    var ref = (0, $ce1b11e01dbf9498$export$2e2bcd8739ae039)(fn);
    return (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _ref;
        return ref.current && (_ref = ref).current.apply(_ref, (0, $fsSDT._)(args));
    }, [
        ref
    ]);
}


function $d9d4d7632cfc61e6$export$2e2bcd8739ae039(eventTarget, event, listener) {
    var capture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var handler = (0, $0339cc266363564f$export$2e2bcd8739ae039)(listener);
    (0, $12aPv.useEffect)(function() {
        var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return function() {
            return target.removeEventListener(event, handler, capture);
        };
    }, [
        eventTarget
    ]);
}



parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $e907ac86c8746eae$var$DropdownContext = /*#__PURE__*/ $fClfl.createContext(null);
var $e907ac86c8746eae$export$2e2bcd8739ae039 = $e907ac86c8746eae$var$DropdownContext;



var $leE2g = parcelRequire("leE2g");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $5c8dc24218cf5898$export$2e2bcd8739ae039() {
    return (0, $12aPv.useState)(null);
}




var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $5f0Cq = parcelRequire("5f0Cq");
var $e720145b3d6bea34$var$has = Object.prototype.hasOwnProperty;
function $e720145b3d6bea34$var$find(iter, tar, key) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iter.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            key = _step.value;
            if ($e720145b3d6bea34$export$de8294bb3be0322f(key, tar)) return key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $e720145b3d6bea34$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $e720145b3d6bea34$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = foo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    len = _step.value;
                    tmp = len;
                    if (tmp && (typeof tmp === "undefined" ? "undefined" : (0, $5f0Cq._)(tmp)) === 'object') {
                        tmp = $e720145b3d6bea34$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!bar.has(tmp)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = foo[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    len = _step1.value;
                    tmp = len[0];
                    if (tmp && (typeof tmp === "undefined" ? "undefined" : (0, $5f0Cq._)(tmp)) === 'object') {
                        tmp = $e720145b3d6bea34$var$find(bar, tmp);
                        if (!tmp) return false;
                    }
                    if (!$e720145b3d6bea34$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || (typeof foo === "undefined" ? "undefined" : (0, $5f0Cq._)(foo)) === 'object') {
            len = 0;
            for(ctor in foo){
                if ($e720145b3d6bea34$var$has.call(foo, ctor) && ++len && !$e720145b3d6bea34$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$e720145b3d6bea34$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $4e9fdf12852de5b4$export$2e2bcd8739ae039() {
    var mounted = (0, $12aPv.useRef)(true);
    var isMounted = (0, $12aPv.useRef)(function() {
        return mounted.current;
    });
    (0, $12aPv.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $bb2efebb647fe5bc$var$useSafeState(state) {
    var isMounted = (0, $4e9fdf12852de5b4$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $12aPv.useCallback)(function(nextState) {
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $bb2efebb647fe5bc$export$2e2bcd8739ae039 = $bb2efebb647fe5bc$var$useSafeState;



function $f9d884b554ea4bf4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $1e4f141c0d6b4103$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $bbffdd6323c1f82e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bbffdd6323c1f82e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bbffdd6323c1f82e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $72df85f12ea79b54$export$8960430cfd85939f = Math.max;
var $72df85f12ea79b54$export$96ec731ed4dcb222 = Math.min;
var $72df85f12ea79b54$export$2077e0241d6afd3c = Math.round;



function $4637f1b0681fa27a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b1834fcf2fae3cca$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
}


function $60809149f86c2179$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b1834fcf2fae3cca$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $103f1f67b99aec04$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $39cf95a59efb4181$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $4a1bdbded0efa4e8$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $3e3b1486c04ee7a8$export$2e2bcd8739ae039(element) {
    return (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $582da07d1f9d6e0d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(element)) >= 0;
}




function $cff48eaff5e06d70$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $bc26653e17f18903$export$2e2bcd8739ae039(element) {
    if ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $5f7645d1b576086d$var$getTrueOffsetParent(element) {
    if (!(0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5f7645d1b576086d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $4637f1b0681fa27a$export$2e2bcd8739ae039)());
    if (isIE && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $bc26653e17f18903$export$2e2bcd8739ae039)(element);
    if ((0, $bbffdd6323c1f82e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5f7645d1b576086d$export$2e2bcd8739ae039(element) {
    var window = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element);
    var offsetParent = $5f7645d1b576086d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $582da07d1f9d6e0d$export$2e2bcd8739ae039)(offsetParent) && (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $5f7645d1b576086d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $5f7645d1b576086d$var$getContainingBlock(element) || window;
}


function $e0d7cc9881440195$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $a7122274de1cc429$export$f28d906d67a997f3(min, value, max) {
    return (0, $72df85f12ea79b54$export$8960430cfd85939f)(min, (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(value, max));
}
function $a7122274de1cc429$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $a7122274de1cc429$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $55af678c44975866$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $8dd19ddc34578741$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $55af678c44975866$export$2e2bcd8739ae039)(), paddingObject);
}


function $a96029e4eb2bae52$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $22e99ddc6089aa5c$export$1e95b668f3b82d = 'top';
var $22e99ddc6089aa5c$export$40e543e69a8b3fbb = 'bottom';
var $22e99ddc6089aa5c$export$79ffe56a765070d2 = 'right';
var $22e99ddc6089aa5c$export$eabcd2c8791e7bf4 = 'left';
var $22e99ddc6089aa5c$export$dfb5619354ba860 = 'auto';
var $22e99ddc6089aa5c$export$aec2ce47c367b8c3 = [
    $22e99ddc6089aa5c$export$1e95b668f3b82d,
    $22e99ddc6089aa5c$export$40e543e69a8b3fbb,
    $22e99ddc6089aa5c$export$79ffe56a765070d2,
    $22e99ddc6089aa5c$export$eabcd2c8791e7bf4
];
var $22e99ddc6089aa5c$export$b3571188c770cc5a = 'start';
var $22e99ddc6089aa5c$export$bd5df0f255a350f8 = 'end';
var $22e99ddc6089aa5c$export$390fd549c5303b4d = 'clippingParents';
var $22e99ddc6089aa5c$export$d7b7311ec04a3e8f = 'viewport';
var $22e99ddc6089aa5c$export$ae5ab1c730825774 = 'popper';
var $22e99ddc6089aa5c$export$ca50aac9f3ba507f = 'reference';
var $22e99ddc6089aa5c$export$368f9a87e87fa4e1 = /*#__PURE__*/ $22e99ddc6089aa5c$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $22e99ddc6089aa5c$export$b3571188c770cc5a,
        placement + "-" + $22e99ddc6089aa5c$export$bd5df0f255a350f8
    ]);
}, []);
var $22e99ddc6089aa5c$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($22e99ddc6089aa5c$export$aec2ce47c367b8c3, [
    $22e99ddc6089aa5c$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $22e99ddc6089aa5c$export$b3571188c770cc5a,
        placement + "-" + $22e99ddc6089aa5c$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $22e99ddc6089aa5c$export$421679a7c3d56e = 'beforeRead';
var $22e99ddc6089aa5c$export$aafa59e2e03f2942 = 'read';
var $22e99ddc6089aa5c$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $22e99ddc6089aa5c$export$c65e99957a05207c = 'beforeMain';
var $22e99ddc6089aa5c$export$f22da7240b7add18 = 'main';
var $22e99ddc6089aa5c$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $22e99ddc6089aa5c$export$8d4d2d70e7d46032 = 'beforeWrite';
var $22e99ddc6089aa5c$export$68d8715fc104d294 = 'write';
var $22e99ddc6089aa5c$export$70a6e5159acce2e6 = 'afterWrite';
var $22e99ddc6089aa5c$export$d087d3878fdf71d5 = [
    $22e99ddc6089aa5c$export$421679a7c3d56e,
    $22e99ddc6089aa5c$export$aafa59e2e03f2942,
    $22e99ddc6089aa5c$export$6964f6c886723980,
    $22e99ddc6089aa5c$export$c65e99957a05207c,
    $22e99ddc6089aa5c$export$f22da7240b7add18,
    $22e99ddc6089aa5c$export$bab79516f2d662fe,
    $22e99ddc6089aa5c$export$8d4d2d70e7d46032,
    $22e99ddc6089aa5c$export$68d8715fc104d294,
    $22e99ddc6089aa5c$export$70a6e5159acce2e6
];


var $187ac7d7e133663b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $8dd19ddc34578741$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $a96029e4eb2bae52$export$2e2bcd8739ae039)(padding, (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3)));
};
function $187ac7d7e133663b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $187ac7d7e133663b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $a7122274de1cc429$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $187ac7d7e133663b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $39cf95a59efb4181$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $187ac7d7e133663b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $187ac7d7e133663b$var$arrow,
    effect: $187ac7d7e133663b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $82387fc5bc72ad7c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $ccbbd6437d6f1dc0$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ccbbd6437d6f1dc0$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ccbbd6437d6f1dc0$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
    var sideY = (0, $22e99ddc6089aa5c$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(popper);
            if ((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) || (placement === (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) || placement === (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)) && variation === (0, $22e99ddc6089aa5c$export$bd5df0f255a350f8)) {
            sideY = (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) || (placement === (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) || placement === (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)) && variation === (0, $22e99ddc6089aa5c$export$bd5df0f255a350f8)) {
            sideX = (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ccbbd6437d6f1dc0$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ccbbd6437d6f1dc0$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $ccbbd6437d6f1dc0$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ccbbd6437d6f1dc0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ccbbd6437d6f1dc0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ccbbd6437d6f1dc0$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $ccbbd6437d6f1dc0$var$computeStyles,
    data: {}
};



var $ac76324de7a4bf14$var$passive = {
    passive: true
};
function $ac76324de7a4bf14$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ac76324de7a4bf14$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ac76324de7a4bf14$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ac76324de7a4bf14$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ac76324de7a4bf14$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ac76324de7a4bf14$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ac76324de7a4bf14$var$effect,
    data: {}
};


var $280b7124a30a8a0e$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $280b7124a30a8a0e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $280b7124a30a8a0e$var$hash[matched];
    });
}



var $45cb87f5d981a852$var$hash = {
    start: 'end',
    end: 'start'
};
function $45cb87f5d981a852$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $45cb87f5d981a852$var$hash[matched];
    });
}








function $0457e65694e7b463$export$2e2bcd8739ae039(node) {
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $82e56b3c9202f1bc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $60809149f86c2179$export$2e2bcd8739ae039)((0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element)).left + (0, $0457e65694e7b463$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $ed96f5b6e84ce0d6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(element);
    var html = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b1834fcf2fae3cca$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $bead1d02fb1ff5b7$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0457e65694e7b463$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $72df85f12ea79b54$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $07fcf859739eaae8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $4af9f5dd66ae033b$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(node) && (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(node)) return node;
    return $4af9f5dd66ae033b$export$2e2bcd8739ae039((0, $bc26653e17f18903$export$2e2bcd8739ae039)(node));
}





function $bdbb9e30d785ac6a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4af9f5dd66ae033b$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($bdbb9e30d785ac6a$export$2e2bcd8739ae039((0, $bc26653e17f18903$export$2e2bcd8739ae039)(target)));
}










function $f29ca087f4c184d0$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $4c533b586cbb17f5$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $4c533b586cbb17f5$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $22e99ddc6089aa5c$export$d7b7311ec04a3e8f) ? (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)((0, $ed96f5b6e84ce0d6$export$2e2bcd8739ae039)(element, strategy)) : (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clippingParent) ? $4c533b586cbb17f5$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)((0, $bead1d02fb1ff5b7$export$2e2bcd8739ae039)((0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $4c533b586cbb17f5$var$getClippingParents(element) {
    var clippingParents = (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)((0, $bc26653e17f18903$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3e3b1486c04ee7a8$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(element) ? (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $39cf95a59efb4181$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $4c533b586cbb17f5$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $4c533b586cbb17f5$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $4c533b586cbb17f5$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $72df85f12ea79b54$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $72df85f12ea79b54$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $4c533b586cbb17f5$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $c0a524493d0afb7d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $22e99ddc6089aa5c$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $22e99ddc6089aa5c$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $22e99ddc6089aa5c$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $22e99ddc6089aa5c$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $50ef0f40f7ca922c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $22e99ddc6089aa5c$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $22e99ddc6089aa5c$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $8dd19ddc34578741$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $a96029e4eb2bae52$export$2e2bcd8739ae039)(padding, (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) ? (0, $22e99ddc6089aa5c$export$ca50aac9f3ba507f) : (0, $22e99ddc6089aa5c$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4c533b586cbb17f5$export$2e2bcd8739ae039)((0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c0a524493d0afb7d$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $f29ca087f4c184d0$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $22e99ddc6089aa5c$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $22e99ddc6089aa5c$export$79ffe56a765070d2),
                (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
                (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $c934dccc7bdf321d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $22e99ddc6089aa5c$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $22e99ddc6089aa5c$export$368f9a87e87fa4e1) : (0, $22e99ddc6089aa5c$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $22e99ddc6089aa5c$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $c7ad662b98d4d1dc$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(placement);
    return [
        (0, $45cb87f5d981a852$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $45cb87f5d981a852$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $c7ad662b98d4d1dc$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $c7ad662b98d4d1dc$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$dfb5619354ba860) ? (0, $c934dccc7bdf321d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(placement) === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a);
        var isVertical = [
            (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
            (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $22e99ddc6089aa5c$export$79ffe56a765070d2) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $280b7124a30a8a0e$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $c7ad662b98d4d1dc$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $c7ad662b98d4d1dc$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $2d88d9f94be5b0ba$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $2d88d9f94be5b0ba$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2),
        (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb),
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $2d88d9f94be5b0ba$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $2d88d9f94be5b0ba$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $2d88d9f94be5b0ba$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $2d88d9f94be5b0ba$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $2d88d9f94be5b0ba$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $2d88d9f94be5b0ba$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $2d88d9f94be5b0ba$var$hide
};




function $311ce567045aea2b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4),
        (0, $22e99ddc6089aa5c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $311ce567045aea2b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $22e99ddc6089aa5c$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $311ce567045aea2b$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $311ce567045aea2b$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $311ce567045aea2b$var$offset
};



function $3133aaf1ec566bd5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c0a524493d0afb7d$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3133aaf1ec566bd5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $3133aaf1ec566bd5$var$popperOffsets,
    data: {}
};





function $e4efa183da5e1e17$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $00a8e20b8c0bfbdf$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $50ef0f40f7ca922c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f9d884b554ea4bf4$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $82387fc5bc72ad7c$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $e0d7cc9881440195$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e4efa183da5e1e17$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $22e99ddc6089aa5c$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $55af678c44975866$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $a7122274de1cc429$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $a7122274de1cc429$export$f28d906d67a997f3)(tether ? (0, $72df85f12ea79b54$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $72df85f12ea79b54$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $22e99ddc6089aa5c$export$1e95b668f3b82d) : (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $22e99ddc6089aa5c$export$40e543e69a8b3fbb) : (0, $22e99ddc6089aa5c$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $22e99ddc6089aa5c$export$1e95b668f3b82d),
            (0, $22e99ddc6089aa5c$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $a7122274de1cc429$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $a7122274de1cc429$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $00a8e20b8c0bfbdf$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $00a8e20b8c0bfbdf$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $8d58228048724510$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $1112e259f7d2e76a$export$2e2bcd8739ae039(node) {
    if (node === (0, $1e4f141c0d6b4103$export$2e2bcd8739ae039)(node) || !(0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(node)) return (0, $0457e65694e7b463$export$2e2bcd8739ae039)(node);
    else return (0, $8d58228048724510$export$2e2bcd8739ae039)(node);
}








function $97cb7d18733c60e6$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $72df85f12ea79b54$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $97cb7d18733c60e6$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent) && $97cb7d18733c60e6$var$isElementScaled(offsetParent);
    var documentElement = (0, $cff48eaff5e06d70$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $60809149f86c2179$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4a1bdbded0efa4e8$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $07fcf859739eaae8$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $1112e259f7d2e76a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $bbffdd6323c1f82e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $60809149f86c2179$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $82e56b3c9202f1bc$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $02405386c900bb58$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $02405386c900bb58$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $02405386c900bb58$var$order(modifiers); // order based on phase
    return (0, $22e99ddc6089aa5c$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $dcb610874f96ade2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f0869ad452512909$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $c029c2062637204e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $c029c2062637204e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $c029c2062637204e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c029c2062637204e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $c029c2062637204e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $bbffdd6323c1f82e$export$45a5e7f76e0caa8d)(reference) ? (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $bdbb9e30d785ac6a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $02405386c900bb58$export$2e2bcd8739ae039)((0, $f0869ad452512909$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c029c2062637204e$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $97cb7d18733c60e6$export$2e2bcd8739ae039)(_$reference, (0, $5f7645d1b576086d$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $103f1f67b99aec04$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dcb610874f96ade2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c029c2062637204e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c029c2062637204e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c029c2062637204e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $319837e024968b71$export$8f7491d57c8f97a9 = (0, $c029c2062637204e$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $2d88d9f94be5b0ba$export$2e2bcd8739ae039),
        (0, $3133aaf1ec566bd5$export$2e2bcd8739ae039),
        (0, $ccbbd6437d6f1dc0$export$2e2bcd8739ae039),
        (0, $ac76324de7a4bf14$export$2e2bcd8739ae039),
        (0, $311ce567045aea2b$export$2e2bcd8739ae039),
        (0, $c7ad662b98d4d1dc$export$2e2bcd8739ae039),
        (0, $00a8e20b8c0bfbdf$export$2e2bcd8739ae039),
        (0, $187ac7d7e133663b$export$2e2bcd8739ae039)
    ]
});


var $5de61c0f65289cab$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $5de61c0f65289cab$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $5de61c0f65289cab$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: function() {
        return undefined;
    }
};
// until docjs supports type exports...
var $5de61c0f65289cab$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function(param) {
        var state = param.state;
        return function() {
            var _state_elements = state.elements, reference = _state_elements.reference, popper = _state_elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function(param) {
        var state = param.state;
        var _popper$getAttribute;
        var _state_elements = state.elements, popper = _state_elements.popper, reference = _state_elements.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? "".concat(ids, ",").concat(popper.id) : popper.id);
        }
    }
};
var $5de61c0f65289cab$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $5de61c0f65289cab$var$usePopper(referenceElement, popperElement) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _ref_enabled = _ref.enabled, enabled = _ref_enabled === void 0 ? true : _ref_enabled, _ref_placement = _ref.placement, placement = _ref_placement === void 0 ? 'bottom' : _ref_placement, _ref_strategy = _ref.strategy, strategy = _ref_strategy === void 0 ? 'absolute' : _ref_strategy, _ref_modifiers = _ref.modifiers, modifiers = _ref_modifiers === void 0 ? $5de61c0f65289cab$var$EMPTY_MODIFIERS : _ref_modifiers, config = $5de61c0f65289cab$var$_objectWithoutPropertiesLoose(_ref, $5de61c0f65289cab$var$_excluded);
    var prevModifiers = (0, $12aPv.useRef)(modifiers);
    var popperInstanceRef = (0, $12aPv.useRef)();
    var update = (0, $12aPv.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $12aPv.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $leE2g._)((0, $bb2efebb647fe5bc$export$2e2bcd8739ae039)((0, $12aPv.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    })), 2), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $12aPv.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function(param) {
                var state = param.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    var nextModifiers = (0, $12aPv.useMemo)(function() {
        if (!(0, $e720145b3d6bea34$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $12aPv.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: (0, $fsSDT._)(nextModifiers).concat([
                updateModifier,
                $5de61c0f65289cab$var$disabledApplyStylesModifier
            ])
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $12aPv.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $319837e024968b71$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: (0, $fsSDT._)(nextModifiers).concat([
                $5de61c0f65289cab$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    });
                });
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $5de61c0f65289cab$export$2e2bcd8739ae039 = $5de61c0f65289cab$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $a784322fcbc350d7$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $0e5e4de4085acd94$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $0e5e4de4085acd94$export$2e2bcd8739ae039 = $0e5e4de4085acd94$var$removeEventListener;


function $709dbe0f51f464e8$var$listen(node, eventName, handler, options) {
    (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $709dbe0f51f464e8$export$2e2bcd8739ae039 = $709dbe0f51f464e8$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $cb03b130654deaba$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $7b1e807e6b1a71ff$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $7b1e807e6b1a71ff$var$__DEV__ = false;
var $7b1e807e6b1a71ff$var$warning = function warning() {};
if ($7b1e807e6b1a71ff$var$__DEV__) {
    var $7b1e807e6b1a71ff$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $7b1e807e6b1a71ff$var$warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $7b1e807e6b1a71ff$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$7b1e807e6b1a71ff$exports = $7b1e807e6b1a71ff$var$warning;


var $7e8c2992c3b0ec82$var$noop = function() {};
function $7e8c2992c3b0ec82$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $7e8c2992c3b0ec82$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $7e8c2992c3b0ec82$export$347601c75fcd4732 = function(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
var $7e8c2992c3b0ec82$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $7e8c2992c3b0ec82$var$useClickOutside(ref) {
    var onClickOutside = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7e8c2992c3b0ec82$var$noop, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, disabled = _ref.disabled, _ref_clickTrigger = _ref.clickTrigger, clickTrigger = _ref_clickTrigger === void 0 ? 'click' : _ref_clickTrigger;
    var preventMouseClickOutsideRef = (0, $12aPv.useRef)(false);
    var waitingForTrigger = (0, $12aPv.useRef)(false);
    var handleMouseCapture = (0, $12aPv.useCallback)(function(e) {
        var currentTarget = $7e8c2992c3b0ec82$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($7b1e807e6b1a71ff$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $7e8c2992c3b0ec82$var$isModifiedEvent(e) || !$7e8c2992c3b0ec82$var$isLeftClickEvent(e) || !!(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    var handleInitialMouse = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(e) {
        var currentTarget = $7e8c2992c3b0ec82$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $a784322fcbc350d7$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    var handleMouse = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $12aPv.useEffect)(function() {
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)($7e8c2992c3b0ec82$export$347601c75fcd4732(ref));
        var ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        var currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        var removeInitialTriggerListener = null;
        if ($7e8c2992c3b0ec82$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, $7e8c2992c3b0ec82$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(el, 'mousemove', $7e8c2992c3b0ec82$var$noop);
        });
        return function() {
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $7e8c2992c3b0ec82$export$2e2bcd8739ae039 = $7e8c2992c3b0ec82$var$useClickOutside;


function $d7821eb5a3db5dd9$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $d7821eb5a3db5dd9$export$af3a999d4a134c86() {
    var map = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $d7821eb5a3db5dd9$export$2e2bcd8739ae039(param) {
    var enabled = param.enabled, enableEvents = param.enableEvents, placement = param.placement, flip = param.flip, offset = param.offset, fixed = param.fixed, containerPadding = param.containerPadding, arrowElement = param.arrowElement, _param_popperConfig = param.popperConfig, popperConfig = _param_popperConfig === void 0 ? {} : _param_popperConfig;
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var modifiers = $d7821eb5a3db5dd9$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $d7821eb5a3db5dd9$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



var $fClfl = parcelRequire("fClfl");
var $3d076ad0fe745b7c$var$_excluded = [
    "children",
    "usePopper"
];
function $3d076ad0fe745b7c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $3d076ad0fe745b7c$var$noop = function() {};
function $3d076ad0fe745b7c$export$133c4d08f3775d64() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var context = (0, $12aPv.useContext)((0, $e907ac86c8746eae$export$2e2bcd8739ae039));
    var _useCallbackRef = (0, $leE2g._)((0, $5c8dc24218cf5898$export$2e2bcd8739ae039)(), 2), arrowElement = _useCallbackRef[0], attachArrowRef = _useCallbackRef[1];
    var hasShownRef = (0, $12aPv.useRef)(false);
    var flip = options.flip, offset = options.offset, rootCloseEvent = options.rootCloseEvent, _options_fixed = options.fixed, fixed = _options_fixed === void 0 ? false : _options_fixed, placementOverride = options.placement, _options_popperConfig = options.popperConfig, popperConfig = _options_popperConfig === void 0 ? {} : _options_popperConfig, _options_enableEventListeners = options.enableEventListeners, enableEventListeners = _options_enableEventListeners === void 0 ? true : _options_enableEventListeners, tmp = options.usePopper, shouldUsePopper = tmp === void 0 ? !!context : tmp;
    var show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    var handleClose = function(e) {
        context == null || context.toggle(false, e);
    };
    var _ref = context || {}, placement = _ref.placement, setMenu = _ref.setMenu, menuElement = _ref.menuElement, toggleElement = _ref.toggleElement;
    var popper = (0, $5de61c0f65289cab$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $d7821eb5a3db5dd9$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    var menuProps = Object.assign({
        ref: setMenu || $3d076ad0fe745b7c$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    var metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $7e8c2992c3b0ec82$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $3d076ad0fe745b7c$var$DropdownMenu(_ref) {
    var children = _ref.children, tmp = _ref.usePopper, usePopperProp = tmp === void 0 ? true : tmp, options = $3d076ad0fe745b7c$var$_objectWithoutPropertiesLoose(_ref, $3d076ad0fe745b7c$var$_excluded);
    var _useDropdownMenu = (0, $leE2g._)($3d076ad0fe745b7c$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    })), 2), props = _useDropdownMenu[0], meta = _useDropdownMenu[1];
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: children(props, meta)
    });
}
$3d076ad0fe745b7c$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $3d076ad0fe745b7c$export$2e2bcd8739ae039 = $3d076ad0fe745b7c$var$DropdownMenu;



var $leE2g = parcelRequire("leE2g");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $leE2g = parcelRequire("leE2g");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
var $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
var $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$SSRContext = (0, $6mMqj.default).createContext($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$defaultContext);
var $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$IsSSRContext = (0, $6mMqj.default).createContext(false);
// This is only used in React < 18.
function $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    var cur = (0, $12aPv.useContext)($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$SSRContext);
    var counter = $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$useCounter(cur === $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$defaultContext);
    var _$670gB$useState = (0, $leE2g._)((0, $12aPv.useState)(true), 2), isSSR = _$670gB$useState[0], setIsSSR = _$670gB$useState[1];
    var value = (0, $12aPv.useMemo)(function() {
        return {
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$defaultContext ? '' : "".concat(cur.prefix, "-").concat(counter),
            current: 0
        };
    }, [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $12aPv.useLayoutEffect)(function() {
        setIsSSR(false);
    }, []);
    return (0, $6mMqj.default).createElement($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, $6mMqj.default).createElement($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
var $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $e0d9d56cdaced4b8$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, $6mMqj.default)['useId'] === 'function') return (0, $6mMqj.default).createElement((0, $6mMqj.default).Fragment, null, props.children);
    return (0, $6mMqj.default).createElement($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
var $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
var $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$useCounter() {
    var isDisabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ctx = (0, $12aPv.useContext)($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$SSRContext);
    var ref = (0, $12aPv.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        var currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, $6mMqj.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            var prevComponentValue = $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    var ctx = (0, $12aPv.useContext)($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$defaultContext && $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$canUseDOM;
    var counter = $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    var prefix = "react-aria".concat(ctx.prefix);
    return defaultId || "".concat(prefix, "-").concat(counter);
}
function $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    var id = (0, $6mMqj.default).useId();
    var _$670gB$useState = (0, $leE2g._)((0, $12aPv.useState)($e0d9d56cdaced4b8$export$535bd6ca7f90a273()), 1), didSSR = _$670gB$useState[0];
    var prefix = didSSR || false ? 'react-aria' : "react-aria".concat($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$defaultContext.prefix);
    return defaultId || "".concat(prefix, "-").concat(id);
}
var $e0d9d56cdaced4b8$export$619500959fc48b26 = typeof (0, $6mMqj.default)['useId'] === 'function' ? $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$useModernSSRSafeId : $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return function() {};
}
function $e0d9d56cdaced4b8$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, $6mMqj.default)['useSyncExternalStore'] === 'function') return (0, $6mMqj.default)['useSyncExternalStore']($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$subscribe, $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$getSnapshot, $e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $12aPv.useContext)($e0d9d56cdaced4b8$var$$b5e257d569688ac6$var$IsSSRContext);
}




var $fClfl = parcelRequire("fClfl");
var $56e153e015e9dec7$export$386b1213cf9779d8 = function(el) {
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
var $56e153e015e9dec7$var$noop = function() {};
function $56e153e015e9dec7$export$96df6c7c5036b9a2() {
    var id = (0, $e0d9d56cdaced4b8$export$619500959fc48b26)();
    var _ref = (0, $12aPv.useContext)((0, $e907ac86c8746eae$export$2e2bcd8739ae039)) || {}, _ref_show = _ref.show, show = _ref_show === void 0 ? false : _ref_show, _ref_toggle = _ref.toggle, toggle = _ref_toggle === void 0 ? $56e153e015e9dec7$var$noop : _ref_toggle, setToggle = _ref.setToggle, menuElement = _ref.menuElement;
    var handleClick = (0, $12aPv.useCallback)(function(e) {
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    var props = {
        id: id,
        ref: setToggle || $56e153e015e9dec7$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $56e153e015e9dec7$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $56e153e015e9dec7$var$DropdownToggle(param) {
    var children = param.children;
    var _useDropdownToggle = (0, $leE2g._)($56e153e015e9dec7$export$96df6c7c5036b9a2(), 2), props = _useDropdownToggle[0], meta = _useDropdownToggle[1];
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: children(props, meta)
    });
}
$56e153e015e9dec7$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $56e153e015e9dec7$export$2e2bcd8739ae039 = $56e153e015e9dec7$var$DropdownToggle;



var $5RfYb = parcelRequire("5RfYb");

var $leE2g = parcelRequire("leE2g");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $5d7ccc5fefa2a642$var$SelectableContext = /*#__PURE__*/ $fClfl.createContext(null);
var $5d7ccc5fefa2a642$export$eef49b42fde998a3 = function(eventKey) {
    var href = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $5d7ccc5fefa2a642$export$2e2bcd8739ae039 = $5d7ccc5fefa2a642$var$SelectableContext;


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $fa3bdd6553a6b3a2$var$NavContext = /*#__PURE__*/ $fClfl.createContext(null);
$fa3bdd6553a6b3a2$var$NavContext.displayName = 'NavContext';
var $fa3bdd6553a6b3a2$export$2e2bcd8739ae039 = $fa3bdd6553a6b3a2$var$NavContext;



var $a16dacb94031d905$export$fd7bcb7e9bef4e8a = "data-rr-ui-";
var $a16dacb94031d905$export$635202801f9383a0 = "rrUi";
function $a16dacb94031d905$export$5cc3b7b83e34ade7(property) {
    return "".concat($a16dacb94031d905$export$fd7bcb7e9bef4e8a).concat(property);
}
function $a16dacb94031d905$export$7776c0a7cd2eb3e0(property) {
    return "".concat($a16dacb94031d905$export$635202801f9383a0).concat(property);
}



var $28e49492b719672c$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $28e49492b719672c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $28e49492b719672c$export$522d7e1e4e0e22b2(param) {
    var key = param.key, href = param.href, active = param.active, disabled = param.disabled, onClick = param.onClick;
    var onSelectCtx = (0, $12aPv.useContext)((0, $5d7ccc5fefa2a642$export$2e2bcd8739ae039));
    var navContext = (0, $12aPv.useContext)((0, $fa3bdd6553a6b3a2$export$2e2bcd8739ae039));
    var activeKey = (navContext || {}).activeKey;
    var eventKey = (0, $5d7ccc5fefa2a642$export$eef49b42fde998a3)(key, href);
    var isActive = active == null && key != null ? (0, $5d7ccc5fefa2a642$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    var handleClick = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(event) {
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        (0, $5RfYb._)({
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive
        }, (0, $a16dacb94031d905$export$5cc3b7b83e34ade7)('dropdown-item'), ''),
        {
            isActive: isActive
        }
    ];
}
var $28e49492b719672c$var$DropdownItem = /*#__PURE__*/ $6mMqj.forwardRef(function(_ref, ref) {
    var eventKey = _ref.eventKey, disabled = _ref.disabled, onClick = _ref.onClick, active = _ref.active, tmp = _ref.as, Component = tmp === void 0 ? (0, $920182a7008094bc$export$2e2bcd8739ae039) : tmp, props = $28e49492b719672c$var$_objectWithoutPropertiesLoose(_ref, $28e49492b719672c$var$_excluded);
    var _useDropdownItem = (0, $leE2g._)($28e49492b719672c$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    }), 1), dropdownItemProps = _useDropdownItem[0];
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$28e49492b719672c$var$DropdownItem.displayName = 'DropdownItem';
var $28e49492b719672c$export$2e2bcd8739ae039 = $28e49492b719672c$var$DropdownItem;




parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $12aPv = parcelRequire("12aPv");

var $2b9d532f6e6b62e7$var$Context = /*#__PURE__*/ (0, $fClfl.createContext)((0, $64f258eaaf92e603$export$2e2bcd8739ae039) ? window : undefined);
var $2b9d532f6e6b62e7$export$f7d306aeb1cf5fbc = $2b9d532f6e6b62e7$var$Context.Provider;
function $2b9d532f6e6b62e7$export$2e2bcd8739ae039() {
    return (0, $12aPv.useContext)($2b9d532f6e6b62e7$var$Context);
}



function $26bd6b1a11aefddc$var$useRefWithUpdate() {
    var forceUpdate = (0, $3250bc95c1f69221$export$2e2bcd8739ae039)();
    var ref = (0, $12aPv.useRef)(null);
    var attachRef = (0, $12aPv.useCallback)(function(element) {
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $26bd6b1a11aefddc$var$Dropdown(param) {
    var defaultShow = param.defaultShow, rawShow = param.show, onSelect = param.onSelect, rawOnToggle = param.onToggle, _param_itemSelector = param.itemSelector, itemSelector = _param_itemSelector === void 0 ? "* [".concat((0, $a16dacb94031d905$export$5cc3b7b83e34ade7)('dropdown-item'), "]") : _param_itemSelector, focusFirstItemOnShow = param.focusFirstItemOnShow, _param_placement = param.placement, placement = _param_placement === void 0 ? 'bottom-start' : _param_placement, children = param.children;
    var window = (0, $2b9d532f6e6b62e7$export$2e2bcd8739ae039)();
    var _useUncontrolledProp = (0, $leE2g._)((0, $b478810c3b863a04$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle), 2), show = _useUncontrolledProp[0], onToggle = _useUncontrolledProp[1];
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    var _useRefWithUpdate = (0, $leE2g._)($26bd6b1a11aefddc$var$useRefWithUpdate(), 2), menuRef = _useRefWithUpdate[0], setMenu = _useRefWithUpdate[1];
    var menuElement = menuRef.current;
    var _useRefWithUpdate1 = (0, $leE2g._)($26bd6b1a11aefddc$var$useRefWithUpdate(), 2), toggleRef = _useRefWithUpdate1[0], setToggle = _useRefWithUpdate1[1];
    var toggleElement = toggleRef.current;
    var lastShow = (0, $3b1b41e6f8e3c97a$export$2e2bcd8739ae039)(show);
    var lastSourceEvent = (0, $12aPv.useRef)(null);
    var focusInDropdown = (0, $12aPv.useRef)(false);
    var onSelectCtx = (0, $12aPv.useContext)((0, $5d7ccc5fefa2a642$export$2e2bcd8739ae039));
    var toggle = (0, $12aPv.useCallback)(function(nextShow, event) {
        var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : event == null ? void 0 : event.type;
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    var handleSelect = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(key, event) {
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    var context = (0, $12aPv.useMemo)(function() {
        return {
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        };
    }, [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    var focusToggle = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function() {
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    var maybeFocusFirst = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function() {
        var type = lastSourceEvent.current;
        var focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $56e153e015e9dec7$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        var first = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $12aPv.useEffect)(function() {
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $12aPv.useEffect)(function() {
        lastSourceEvent.current = null;
    });
    var getNextFocusedChild = function(current, offset) {
        if (!menuRef.current) return null;
        var items = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        var index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $d9d4d7632cfc61e6$export$2e2bcd8739ae039)((0, $12aPv.useCallback)(function() {
        return window.document;
    }, [
        window
    ]), 'keydown', function(event) {
        var _menuRef$current, _toggleRef$current;
        var key = event.key;
        var target = event.target;
        var fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        var fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        var isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        var meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    var next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    var next1 = getNextFocusedChild(target, 1);
                    if (next1 && next1.focus) next1.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', function(e) {
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5d7ccc5fefa2a642$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e907ac86c8746eae$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$26bd6b1a11aefddc$var$Dropdown.displayName = 'Dropdown';
$26bd6b1a11aefddc$var$Dropdown.Menu = (0, $3d076ad0fe745b7c$export$2e2bcd8739ae039);
$26bd6b1a11aefddc$var$Dropdown.Toggle = (0, $56e153e015e9dec7$export$2e2bcd8739ae039);
$26bd6b1a11aefddc$var$Dropdown.Item = (0, $28e49492b719672c$export$2e2bcd8739ae039);
var $26bd6b1a11aefddc$export$2e2bcd8739ae039 = $26bd6b1a11aefddc$var$Dropdown;



var $5f0Cq = parcelRequire("5f0Cq");
function $1b819ac42a9c2e15$export$2e2bcd8739ae039() {
    return $1b819ac42a9c2e15$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1b819ac42a9c2e15$export$2e2bcd8739ae039.apply(null, arguments);
}


function $60abe64823f8b6d2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
var $81648fdbf254d6a1$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $81648fdbf254d6a1$var$invariant = function invariant(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$81648fdbf254d6a1$exports = $81648fdbf254d6a1$var$invariant;


var $7edf28496672b200$var$noop = function noop() {};
function $7edf28496672b200$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $7edf28496672b200$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $7edf28496672b200$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$7edf28496672b200$export$26cbf8c37e721e67(prop)] = $7edf28496672b200$var$noop;
        var handler;
    });
    return propTypes;
}
function $7edf28496672b200$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $7edf28496672b200$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $7edf28496672b200$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $c573222c50547131$var$_toPropertyKey(arg) {
    var key = $c573222c50547131$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $5f0Cq._)(key)) === "symbol" ? key : String(key);
}
function $c573222c50547131$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $5f0Cq._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $5f0Cq._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c573222c50547131$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $12aPv.useRef)(propValue !== undefined);
    var _useState = (0, $12aPv.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $12aPv.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $c573222c50547131$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$7edf28496672b200$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $60abe64823f8b6d2$export$2e2bcd8739ae039)(_ref, [
            $7edf28496672b200$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($c573222c50547131$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $c573222c50547131$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $1b819ac42a9c2e15$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $b3e8a3771e22578c$export$2e2bcd8739ae039(t, e) {
    return $b3e8a3771e22578c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $b3e8a3771e22578c$export$2e2bcd8739ae039(t, e);
}


function $da0f998d8efa0f93$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $b3e8a3771e22578c$export$2e2bcd8739ae039)(t, o);
}



var $6mMqj = parcelRequire("6mMqj");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c235d951ddc27ab7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c235d951ddc27ab7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c235d951ddc27ab7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c235d951ddc27ab7$var$componentWillMount.__suppressDeprecationWarning = true;
$c235d951ddc27ab7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c235d951ddc27ab7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c235d951ddc27ab7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c235d951ddc27ab7$var$componentWillMount;
        prototype.componentWillReceiveProps = $c235d951ddc27ab7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c235d951ddc27ab7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $c2f2fdaffa327da7$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $c2f2fdaffa327da7$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $7edf28496672b200$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($7edf28496672b200$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($81648fdbf254d6a1$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $da0f998d8efa0f93$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $1b819ac42a9c2e15$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$7edf28496672b200$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $1b819ac42a9c2e15$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$7edf28496672b200$export$12ae2baa35bd9b8b(props, key) && $7edf28496672b200$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$7edf28496672b200$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $60abe64823f8b6d2$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, $6mMqj.default).createElement(Component, (0, $1b819ac42a9c2e15$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, $6mMqj.default).Component);
    (0, $c235d951ddc27ab7$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $1b819ac42a9c2e15$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $7edf28496672b200$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, $6mMqj.default).forwardRef) {
        WrappedComponent = (0, $6mMqj.default).forwardRef(function(props, ref) {
            return (0, $6mMqj.default).createElement(UncontrolledComponent, (0, $1b819ac42a9c2e15$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $c2f2fdaffa327da7$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $c2f2fdaffa327da7$export$2e2bcd8739ae039(newComponent, (0, $1b819ac42a9c2e15$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $fsSDT = parcelRequire("fsSDT");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $99492e5666e04dd3$var$useCommittedRef(value) {
    var ref = (0, $12aPv.useRef)(value);
    (0, $12aPv.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $99492e5666e04dd3$export$2e2bcd8739ae039 = $99492e5666e04dd3$var$useCommittedRef;


function $5eab4b92b9a4d41c$export$2e2bcd8739ae039(fn) {
    var ref = (0, $99492e5666e04dd3$export$2e2bcd8739ae039)(fn);
    return (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _ref;
        return ref.current && (_ref = ref).current.apply(_ref, (0, $fsSDT._)(args));
    }, [
        ref
    ]);
}


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
"use client";
var $e943ae74d1f664ae$var$DropdownContext = /*#__PURE__*/ $fClfl.createContext({});
$e943ae74d1f664ae$var$DropdownContext.displayName = 'DropdownContext';
var $e943ae74d1f664ae$export$2e2bcd8739ae039 = $e943ae74d1f664ae$var$DropdownContext;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $5abfa7587af7e208$var$DropdownDivider = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'hr' : tmp, _param_role = _param.role, role = _param_role === void 0 ? 'separator' : _param_role, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as",
        "role"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        role: role
    }, props));
});
$5abfa7587af7e208$var$DropdownDivider.displayName = 'DropdownDivider';
var $5abfa7587af7e208$export$2e2bcd8739ae039 = $5abfa7587af7e208$var$DropdownDivider;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $79430e8070503c62$var$DropdownHeader = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, _param_role = _param.role, role = _param_role === void 0 ? 'heading' : _param_role, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as",
        "role"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        role: role
    }, props));
});
$79430e8070503c62$var$DropdownHeader.displayName = 'DropdownHeader';
var $79430e8070503c62$export$2e2bcd8739ae039 = $79430e8070503c62$var$DropdownHeader;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");


var $6mMqj = parcelRequire("6mMqj");


var $leE2g = parcelRequire("leE2g");

var $6mMqj = parcelRequire("6mMqj");





parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $c06deba65277398d$export$2e2bcd8739ae039(event, handler) {
    var capture = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var documentTarget = (0, $12aPv.useCallback)(function() {
        return document;
    }, []);
    return (0, $d9d4d7632cfc61e6$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $5b2e40934b4a3f10$var$useInterval(fn, ms) {
    var paused = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, runImmediately = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var handle;
    var fnRef = (0, $ce1b11e01dbf9498$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $ce1b11e01dbf9498$export$2e2bcd8739ae039)(paused);
    var tick = function() {
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    var schedule = function() {
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $12aPv.useEffect)(function() {
        if (runImmediately) tick();
        else schedule();
        return function() {
            return clearTimeout(handle);
        };
    }, [
        paused,
        runImmediately
    ]);
}
var $5b2e40934b4a3f10$export$2e2bcd8739ae039 = $5b2e40934b4a3f10$var$useInterval;


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

function $1e856035b3bf360b$var$useRafInterval(fn, ms) {
    var paused = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var handle;
    var start = new Date().getTime();
    var fnRef = (0, $ce1b11e01dbf9498$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $ce1b11e01dbf9498$export$2e2bcd8739ae039)(paused);
    function loop() {
        var current = new Date().getTime();
        var delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $12aPv.useEffect)(function() {
        handle = requestAnimationFrame(loop);
        return function() {
            return cancelAnimationFrame(handle);
        };
    }, []);
}
var $1e856035b3bf360b$export$2e2bcd8739ae039 = $1e856035b3bf360b$var$useRafInterval;



var $leE2g = parcelRequire("leE2g");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $644f8bf49e83036d$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(initialState), 2), state = _useState[0], setState = _useState[1];
    var updater = (0, $12aPv.useCallback)(function(update) {
        if (update === null) return;
        if (typeof update === 'function') setState(function(state) {
            var nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState(function(state) {
            return Object.assign({}, state, update);
        });
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



var $leE2g = parcelRequire("leE2g");

function $983266d715e99560$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    var _useMergeState = (0, $leE2g._)((0, $644f8bf49e83036d$export$2e2bcd8739ae039)(initialState), 2), state = _useMergeState[0], setState = _useMergeState[1];
    var nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $leE2g = parcelRequire("leE2g");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $70e8eb9d0d456cb8$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    var _useState = (0, $leE2g._)((0, $12aPv.useState)({
        image: null,
        error: null
    }), 2), state = _useState[0], setState = _useState[1];
    (0, $12aPv.useEffect)(function() {
        if (!imageOrUrl) return undefined;
        var image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return function() {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $leE2g = parcelRequire("leE2g");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
var $26f7a380474a7232$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
var $26f7a380474a7232$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $26f7a380474a7232$export$2e2bcd8739ae039 = $26f7a380474a7232$var$isDOM || $26f7a380474a7232$var$isReactNative ? (0, $12aPv.useLayoutEffect) : (0, $12aPv.useEffect);


var $f384d9ddbefb1870$var$targetMap = new WeakMap();
var $f384d9ddbefb1870$var$resizeObserver;
function $f384d9ddbefb1870$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $f384d9ddbefb1870$var$resizeObserver = $f384d9ddbefb1870$var$resizeObserver || new window.ResizeObserver(function(entries) {
        entries.forEach(function(entry) {
            var handler = $f384d9ddbefb1870$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $f384d9ddbefb1870$export$2e2bcd8739ae039(element) {
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(null), 2), rect = _useState[0], setRect = _useState[1];
    (0, $26f7a380474a7232$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        $f384d9ddbefb1870$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $f384d9ddbefb1870$var$targetMap.set(element, function(rect) {
            setRect(rect);
        });
        return function() {
            $f384d9ddbefb1870$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






var $5a6bc24f902d75f2$var$_excluded = [
    "onKeyDown"
];
function $5a6bc24f902d75f2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $5a6bc24f902d75f2$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ var $5a6bc24f902d75f2$var$Anchor = /*#__PURE__*/ $6mMqj.forwardRef(function(_ref, ref) {
    var onKeyDown = _ref.onKeyDown, props = $5a6bc24f902d75f2$var$_objectWithoutPropertiesLoose(_ref, $5a6bc24f902d75f2$var$_excluded);
    var _useButtonProps = (0, $leE2g._)((0, $920182a7008094bc$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props)), 1), buttonProps = _useButtonProps[0];
    var handleKeyDown = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(e) {
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($5a6bc24f902d75f2$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$5a6bc24f902d75f2$var$Anchor.displayName = 'Anchor';
var $5a6bc24f902d75f2$export$2e2bcd8739ae039 = $5a6bc24f902d75f2$var$Anchor;




"use client";
var $46e2f51f2d6b9d55$var$DropdownItem = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, eventKey = _param.eventKey, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, onClick = _param.onClick, active = _param.active, tmp = _param.as, Component = tmp === void 0 ? (0, $5a6bc24f902d75f2$export$2e2bcd8739ae039) : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "eventKey",
        "disabled",
        "onClick",
        "active",
        "as"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    var _useDropdownItem = (0, $leE2g._)((0, $28e49492b719672c$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    }), 2), dropdownItemProps = _useDropdownItem[0], meta = _useDropdownItem[1];
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props, dropdownItemProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    }));
});
$46e2f51f2d6b9d55$var$DropdownItem.displayName = 'DropdownItem';
var $46e2f51f2d6b9d55$export$2e2bcd8739ae039 = $46e2f51f2d6b9d55$var$DropdownItem;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $c481de6f3bd2755f$var$DropdownItemText = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$c481de6f3bd2755f$var$DropdownItemText.displayName = 'DropdownItemText';
var $c481de6f3bd2755f$export$2e2bcd8739ae039 = $c481de6f3bd2755f$var$DropdownItemText;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
var $5d85ac82b8d2ad7b$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
var $5d85ac82b8d2ad7b$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $5d85ac82b8d2ad7b$export$2e2bcd8739ae039 = $5d85ac82b8d2ad7b$var$isDOM || $5d85ac82b8d2ad7b$var$isReactNative ? (0, $12aPv.useLayoutEffect) : (0, $12aPv.useEffect);


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
var $3a5cc5c5ad7c23ef$var$toFnRef = function(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $3a5cc5c5ad7c23ef$export$c9058316764c140e(refA, refB) {
    var a = $3a5cc5c5ad7c23ef$var$toFnRef(refA);
    var b = $3a5cc5c5ad7c23ef$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $3a5cc5c5ad7c23ef$var$useMergedRefs(refA, refB) {
    return (0, $12aPv.useMemo)(function() {
        return $3a5cc5c5ad7c23ef$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $3a5cc5c5ad7c23ef$export$2e2bcd8739ae039 = $3a5cc5c5ad7c23ef$var$useMergedRefs;




parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
"use client";
var $dabdca7318d4a13a$var$context = /*#__PURE__*/ $fClfl.createContext(null);
$dabdca7318d4a13a$var$context.displayName = 'InputGroupContext';
var $dabdca7318d4a13a$export$2e2bcd8739ae039 = $dabdca7318d4a13a$var$context;


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
"use client";
// TODO: check
var $f8be656c279f8b3f$var$context = /*#__PURE__*/ $fClfl.createContext(null);
$f8be656c279f8b3f$var$context.displayName = 'NavbarContext';
var $f8be656c279f8b3f$export$2e2bcd8739ae039 = $f8be656c279f8b3f$var$context;




parcelRequire("6mMqj");

function $ebec78d8b5c58702$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $17d2fbaf243d0537$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    var topStart = isRTL ? 'top-end' : 'top-start';
    var topEnd = isRTL ? 'top-start' : 'top-end';
    var bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    var bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    var leftStart = isRTL ? 'right-start' : 'left-start';
    var leftEnd = isRTL ? 'right-end' : 'left-end';
    var rightStart = isRTL ? 'left-start' : 'right-start';
    var rightEnd = isRTL ? 'left-end' : 'right-end';
    var placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
var $17d2fbaf243d0537$var$DropdownMenu = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, align = _param.align, rootCloseEvent = _param.rootCloseEvent, _param_flip = _param.flip, flip = _param_flip === void 0 ? true : _param_flip, showProps = _param.show, renderOnMount = _param.renderOnMount, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, popperConfig = _param.popperConfig, variant = _param.variant, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "align",
        "rootCloseEvent",
        "flip",
        "show",
        "renderOnMount",
        "as",
        "popperConfig",
        "variant"
    ]);
    var alignEnd = false;
    var isNavbar = (0, $12aPv.useContext)((0, $f8be656c279f8b3f$export$2e2bcd8739ae039));
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    var _useContext = (0, $12aPv.useContext)((0, $e943ae74d1f664ae$export$2e2bcd8739ae039)), contextAlign = _useContext.align, drop = _useContext.drop, isRTL = _useContext.isRTL;
    align = align || contextAlign;
    var isInputGroup = (0, $12aPv.useContext)((0, $dabdca7318d4a13a$export$2e2bcd8739ae039));
    var alignClasses = [];
    if (align) {
        if ((typeof align === "undefined" ? "undefined" : (0, $5f0Cq._)(align)) === 'object') {
            var keys = Object.keys(align);
            if (keys.length) {
                var brkPoint = keys[0];
                var direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push("".concat(prefix, "-").concat(brkPoint, "-").concat(direction));
            }
        } else if (align === 'end') alignEnd = true;
    }
    var placement = $17d2fbaf243d0537$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    var _useDropdownMenu = (0, $leE2g._)((0, $3d076ad0fe745b7c$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    }), 2), menuProps = _useDropdownMenu[0], _useDropdownMenu_ = _useDropdownMenu[1], hasShown = _useDropdownMenu_.hasShown, popper = _useDropdownMenu_.popper, show = _useDropdownMenu_.show, toggle = _useDropdownMenu_.toggle;
    menuProps.ref = (0, $3a5cc5c5ad7c23ef$export$2e2bcd8739ae039)((0, $ebec78d8b5c58702$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $5d85ac82b8d2ad7b$export$2e2bcd8739ae039)(function() {
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = function() {
            return toggle == null ? void 0 : toggle(false);
        };
        menuProps.align = align;
    }
    var style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = (0, $6GCxi._)({}, props.style, menuProps.style);
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)((0, $ctBui._)((0, $6GCxi._)({}, props, menuProps), {
        style: style
    }), (alignClasses.length || isNavbar) && {
        'data-bs-popper': 'static'
    }), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
            className,
            prefix,
            show && 'show',
            alignEnd && "".concat(prefix, "-end"),
            variant && "".concat(prefix, "-").concat(variant)
        ].concat((0, $fsSDT._)(alignClasses)))
    }));
});
$17d2fbaf243d0537$var$DropdownMenu.displayName = 'DropdownMenu';
var $17d2fbaf243d0537$export$2e2bcd8739ae039 = $17d2fbaf243d0537$var$DropdownMenu;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");





var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");




"use client";
var $fd08832402c1b5e9$var$DropdownToggle = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, split = _param.split, className = _param.className, childBsPrefix = _param.childBsPrefix, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? (0, $4a228d6edec70b31$export$2e2bcd8739ae039) : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "split",
        "className",
        "childBsPrefix",
        "as"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    var dropdownContext = (0, $12aPv.useContext)((0, $e907ac86c8746eae$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    var _useDropdownToggle = (0, $leE2g._)((0, $56e153e015e9dec7$export$96df6c7c5036b9a2)(), 1), toggleProps = _useDropdownToggle[0];
    toggleProps.ref = (0, $3a5cc5c5ad7c23ef$export$2e2bcd8739ae039)(toggleProps.ref, (0, $ebec78d8b5c58702$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, prefix, split && "".concat(prefix, "-split"), (dropdownContext == null ? void 0 : dropdownContext.show) && 'show')
    }, toggleProps, props));
});
$fd08832402c1b5e9$var$DropdownToggle.displayName = 'DropdownToggle';
var $fd08832402c1b5e9$export$2e2bcd8739ae039 = $fd08832402c1b5e9$var$DropdownToggle;






"use client";
var $ee420024178a4af8$var$Dropdown = /*#__PURE__*/ $6mMqj.forwardRef(function(pProps, ref) {
    var _useUncontrolled = (0, $c573222c50547131$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    }), bsPrefix = _useUncontrolled.bsPrefix, _useUncontrolled_drop = _useUncontrolled.drop, drop = _useUncontrolled_drop === void 0 ? 'down' : _useUncontrolled_drop, show = _useUncontrolled.show, className = _useUncontrolled.className, _useUncontrolled_align = _useUncontrolled.align, align = _useUncontrolled_align === void 0 ? 'start' : _useUncontrolled_align, onSelect = _useUncontrolled.onSelect, onToggle = _useUncontrolled.onToggle, focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow, tmp = _useUncontrolled.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, _4 = _useUncontrolled.navbar, _useUncontrolled_autoClose = _useUncontrolled.autoClose, autoClose = _useUncontrolled_autoClose === void 0 ? true : _useUncontrolled_autoClose, props = (0, $8MJI4._)(_useUncontrolled, [
        "bsPrefix",
        "drop",
        "show",
        "className",
        "align",
        "onSelect",
        "onToggle",
        "focusFirstItemOnShow",
        "as",
        "navbar",
        "autoClose"
    ]);
    var isInputGroup = (0, $12aPv.useContext)((0, $dabdca7318d4a13a$export$2e2bcd8739ae039));
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    var isRTL = (0, $fb3854fa54537b64$export$35e511eefa30ac5a)();
    var isClosingPermitted = function(source) {
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    var handleToggle = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(function(nextShow, meta) {
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ var isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    var alignEnd = align === 'end';
    var placement = (0, $17d2fbaf243d0537$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    var contextValue = (0, $12aPv.useMemo)(function() {
        return {
            align: align,
            drop: drop,
            isRTL: isRTL
        };
    }, [
        align,
        drop,
        isRTL
    ]);
    var directionClasses = {
        down: prefix,
        'down-centered': "".concat(prefix, "-center"),
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e943ae74d1f664ae$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $26bd6b1a11aefddc$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: ".".concat(prefix, "-item:not(.disabled):not(:disabled)"),
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, show && 'show', directionClasses[drop])
            }))
        })
    });
});
$ee420024178a4af8$var$Dropdown.displayName = 'Dropdown';
var $ee420024178a4af8$export$2e2bcd8739ae039 = Object.assign($ee420024178a4af8$var$Dropdown, {
    Toggle: (0, $fd08832402c1b5e9$export$2e2bcd8739ae039),
    Menu: (0, $17d2fbaf243d0537$export$2e2bcd8739ae039),
    Item: (0, $46e2f51f2d6b9d55$export$2e2bcd8739ae039),
    ItemText: (0, $c481de6f3bd2755f$export$2e2bcd8739ae039),
    Divider: (0, $5abfa7587af7e208$export$2e2bcd8739ae039),
    Header: (0, $79430e8070503c62$export$2e2bcd8739ae039)
});


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $dbf9032451b6d05a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dbf9032451b6d05a$var$ReactIs, $dbf9032451b6d05a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$dbf9032451b6d05a$exports = (parcelRequire("dNvVv"))();




"use client";
var $4833a765594519c8$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool
};
var $4833a765594519c8$var$Image = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_fluid = _param.fluid, fluid = _param_fluid === void 0 ? false : _param_fluid, _param_rounded = _param.rounded, rounded = _param_rounded === void 0 ? false : _param_rounded, _param_roundedCircle = _param.roundedCircle, roundedCircle = _param_roundedCircle === void 0 ? false : _param_roundedCircle, _param_thumbnail = _param.thumbnail, thumbnail = _param_thumbnail === void 0 ? false : _param_thumbnail, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "fluid",
        "rounded",
        "roundedCircle",
        "thumbnail"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("img", (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, fluid && "".concat(bsPrefix, "-fluid"), rounded && "rounded", roundedCircle && "rounded-circle", thumbnail && "".concat(bsPrefix, "-thumbnail"))
    }));
});
$4833a765594519c8$var$Image.displayName = 'Image';
var $4833a765594519c8$export$2e2bcd8739ae039 = $4833a765594519c8$var$Image;


var $5RfYb = parcelRequire("5RfYb");

var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
var $0e2e1b24ec7da626$var$toFnRef = function(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $0e2e1b24ec7da626$export$c9058316764c140e(refA, refB) {
    var a = $0e2e1b24ec7da626$var$toFnRef(refA);
    var b = $0e2e1b24ec7da626$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $0e2e1b24ec7da626$var$useMergedRefs(refA, refB) {
    return (0, $12aPv.useMemo)(function() {
        return $0e2e1b24ec7da626$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $0e2e1b24ec7da626$export$2e2bcd8739ae039 = $0e2e1b24ec7da626$var$useMergedRefs;




parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $0de085d245ac082b$var$TabContext = /*#__PURE__*/ $fClfl.createContext(null);
var $0de085d245ac082b$export$2e2bcd8739ae039 = $0de085d245ac082b$var$TabContext;




var $leE2g = parcelRequire("leE2g");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");







var $a42d15e4dd8fe1c8$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $a42d15e4dd8fe1c8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a42d15e4dd8fe1c8$export$d7a68693710982a(param) {
    var key = param.key, onClick = param.onClick, active = param.active, id = param.id, role = param.role, disabled = param.disabled;
    var parentOnSelect = (0, $12aPv.useContext)((0, $5d7ccc5fefa2a642$export$2e2bcd8739ae039));
    var navContext = (0, $12aPv.useContext)((0, $fa3bdd6553a6b3a2$export$2e2bcd8739ae039));
    var tabContext = (0, $12aPv.useContext)((0, $0de085d245ac082b$export$2e2bcd8739ae039));
    var isActive = active;
    var props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        var contextControllerId = navContext.getControllerId(key != null ? key : null);
        var contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $a16dacb94031d905$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(e) {
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
var $a42d15e4dd8fe1c8$var$NavItem = /*#__PURE__*/ $6mMqj.forwardRef(function(_ref, ref) {
    var tmp = _ref.as, Component = tmp === void 0 ? (0, $920182a7008094bc$export$2e2bcd8739ae039) : tmp, active = _ref.active, eventKey = _ref.eventKey, options = $a42d15e4dd8fe1c8$var$_objectWithoutPropertiesLoose(_ref, $a42d15e4dd8fe1c8$var$_excluded);
    var _useNavItem = (0, $leE2g._)($a42d15e4dd8fe1c8$export$d7a68693710982a(Object.assign({
        key: (0, $5d7ccc5fefa2a642$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options)), 2), props = _useNavItem[0], meta = _useNavItem[1];
    // @ts-ignore
    props[(0, $a16dacb94031d905$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$a42d15e4dd8fe1c8$var$NavItem.displayName = 'NavItem';
var $a42d15e4dd8fe1c8$export$2e2bcd8739ae039 = $a42d15e4dd8fe1c8$var$NavItem;



var $507c6782315cb9fe$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $507c6782315cb9fe$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
var $507c6782315cb9fe$var$noop = function() {};
var $507c6782315cb9fe$var$EVENT_KEY_ATTR = (0, $a16dacb94031d905$export$5cc3b7b83e34ade7)('event-key');
var $507c6782315cb9fe$var$Nav = /*#__PURE__*/ $6mMqj.forwardRef(function(_ref, ref) {
    var tmp = _ref.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, onSelect = _ref.onSelect, activeKey = _ref.activeKey, role = _ref.role, onKeyDown = _ref.onKeyDown, props = $507c6782315cb9fe$var$_objectWithoutPropertiesLoose(_ref, $507c6782315cb9fe$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    var forceUpdate = (0, $3250bc95c1f69221$export$2e2bcd8739ae039)();
    var needsRefocusRef = (0, $12aPv.useRef)(false);
    var parentOnSelect = (0, $12aPv.useContext)((0, $5d7ccc5fefa2a642$export$2e2bcd8739ae039));
    var tabContext = (0, $12aPv.useContext)((0, $0de085d245ac082b$export$2e2bcd8739ae039));
    var getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    var listNode = (0, $12aPv.useRef)(null);
    var getNextActiveTab = function(offset) {
        var currentListNode = listNode.current;
        if (!currentListNode) return null;
        var items = (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(currentListNode, "[".concat($507c6782315cb9fe$var$EVENT_KEY_ATTR, "]:not([aria-disabled=true])"));
        var activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        var index = items.indexOf(activeChild);
        if (index === -1) return null;
        var nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    var handleSelect = function(key, event) {
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    var handleKeyDown = function(event) {
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        var nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $a16dacb94031d905$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $12aPv.useEffect)(function() {
        if (listNode.current && needsRefocusRef.current) {
            var activeChild = listNode.current.querySelector("[".concat($507c6782315cb9fe$var$EVENT_KEY_ATTR, "][aria-selected=true]"));
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    var mergedRef = (0, $0e2e1b24ec7da626$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5d7ccc5fefa2a642$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fa3bdd6553a6b3a2$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $5d7ccc5fefa2a642$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $507c6782315cb9fe$var$noop,
                getControllerId: getControllerId || $507c6782315cb9fe$var$noop
            },
            children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$507c6782315cb9fe$var$Nav.displayName = 'Nav';
var $507c6782315cb9fe$export$2e2bcd8739ae039 = Object.assign($507c6782315cb9fe$var$Nav, {
    Item: (0, $a42d15e4dd8fe1c8$export$2e2bcd8739ae039)
});






var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $7d11cf88cefe6956$var$NavItem = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$7d11cf88cefe6956$var$NavItem.displayName = 'NavItem';
var $7d11cf88cefe6956$export$2e2bcd8739ae039 = $7d11cf88cefe6956$var$NavItem;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");


var $6mMqj = parcelRequire("6mMqj");





"use client";
var $abcdaf7110dfe9fd$var$NavLink = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? (0, $5a6bc24f902d75f2$export$2e2bcd8739ae039) : tmp, active = _param.active, eventKey = _param.eventKey, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "as",
        "active",
        "eventKey",
        "disabled"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    var _useNavItem = (0, $leE2g._)((0, $a42d15e4dd8fe1c8$export$d7a68693710982a)((0, $6GCxi._)({
        key: (0, $5d7ccc5fefa2a642$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled
    }, props)), 2), navItemProps = _useNavItem[0], meta = _useNavItem[1];
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props, navItemProps), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    }));
});
$abcdaf7110dfe9fd$var$NavLink.displayName = 'NavLink';
var $abcdaf7110dfe9fd$export$2e2bcd8739ae039 = $abcdaf7110dfe9fd$var$NavLink;



"use client";
var $e5d030dc0e0e8f4f$var$Nav = /*#__PURE__*/ $6mMqj.forwardRef(function(uncontrolledProps, ref) {
    var _useUncontrolled = (0, $c573222c50547131$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    }), _useUncontrolled_as = _useUncontrolled.as, as = _useUncontrolled_as === void 0 ? 'div' : _useUncontrolled_as, initialBsPrefix = _useUncontrolled.bsPrefix, variant = _useUncontrolled.variant, _useUncontrolled_fill = _useUncontrolled.fill, fill = _useUncontrolled_fill === void 0 ? false : _useUncontrolled_fill, _useUncontrolled_justify = _useUncontrolled.justify, justify = _useUncontrolled_justify === void 0 ? false : _useUncontrolled_justify, navbar = _useUncontrolled.navbar, navbarScroll = _useUncontrolled.navbarScroll, className = _useUncontrolled.className, activeKey = _useUncontrolled.activeKey, props = (0, $8MJI4._)(_useUncontrolled, [
        "as",
        "bsPrefix",
        "variant",
        "fill",
        "justify",
        "navbar",
        "navbarScroll",
        "className",
        "activeKey"
    ]);
    var bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    var navbarBsPrefix;
    var cardHeaderBsPrefix;
    var isNavbar = false;
    var navbarContext = (0, $12aPv.useContext)((0, $f8be656c279f8b3f$export$2e2bcd8739ae039));
    var cardHeaderContext = (0, $12aPv.useContext)((0, $2cf1243542873def$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) cardHeaderBsPrefix = cardHeaderContext.cardHeaderBsPrefix;
    var _obj;
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $507c6782315cb9fe$export$2e2bcd8739ae039), (0, $6GCxi._)({
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, (_obj = {}, (0, $5RfYb._)(_obj, bsPrefix, !isNavbar), (0, $5RfYb._)(_obj, "".concat(navbarBsPrefix, "-nav"), isNavbar), (0, $5RfYb._)(_obj, "".concat(navbarBsPrefix, "-nav-scroll"), isNavbar && navbarScroll), (0, $5RfYb._)(_obj, "".concat(cardHeaderBsPrefix, "-").concat(variant), !!cardHeaderBsPrefix), (0, $5RfYb._)(_obj, "".concat(bsPrefix, "-").concat(variant), !!variant), (0, $5RfYb._)(_obj, "".concat(bsPrefix, "-fill"), fill), (0, $5RfYb._)(_obj, "".concat(bsPrefix, "-justified"), justify), _obj))
    }, props));
});
$e5d030dc0e0e8f4f$var$Nav.displayName = 'Nav';
var $e5d030dc0e0e8f4f$export$2e2bcd8739ae039 = Object.assign($e5d030dc0e0e8f4f$var$Nav, {
    Item: (0, $7d11cf88cefe6956$export$2e2bcd8739ae039),
    Link: (0, $abcdaf7110dfe9fd$export$2e2bcd8739ae039)
});


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");



var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $8ec4d17a98d70a17$export$2e2bcd8739ae039() {
    var mounted = (0, $12aPv.useRef)(true);
    var isMounted = (0, $12aPv.useRef)(function() {
        return mounted.current;
    });
    (0, $12aPv.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $8d43e144765eec3d$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $12aPv.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $894eb9f2b4db4bf9$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $8d43e144765eec3d$export$2e2bcd8739ae039)(fn);
    (0, $12aPv.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ var $576a6d784a380a3b$var$MAX_DELAY_MS = Math.pow(2, 31) - 1;
function $576a6d784a380a3b$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    var delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $576a6d784a380a3b$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function() {
        return $576a6d784a380a3b$var$setChainedTimeout(handleRef, fn, timeoutAtMs);
    }, $576a6d784a380a3b$var$MAX_DELAY_MS);
}
function $576a6d784a380a3b$export$2e2bcd8739ae039() {
    var isMounted = (0, $8ec4d17a98d70a17$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    var handleRef = (0, $12aPv.useRef)();
    (0, $894eb9f2b4db4bf9$export$2e2bcd8739ae039)(function() {
        return clearTimeout(handleRef.current);
    });
    return (0, $12aPv.useMemo)(function() {
        var clear = function() {
            return clearTimeout(handleRef.current);
        };
        function set(fn) {
            var delayMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            if (!isMounted()) return;
            clear();
            if (delayMs <= $576a6d784a380a3b$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $576a6d784a380a3b$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}






var $6mMqj = parcelRequire("6mMqj");
function $66cdf71ba3c1e5cb$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $66cdf71ba3c1e5cb$export$13e065f3a74cfe36() {
    var parts = $6mMqj.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $66cdf71ba3c1e5cb$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    var major = $66cdf71ba3c1e5cb$export$13e065f3a74cfe36().major;
    var childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");


var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $6mMqj = parcelRequire("6mMqj");





parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



var $53b3c31e5491eff4$var$noop = function() {};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $53b3c31e5491eff4$var$useRootClose(ref, onRootClose) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, disabled = _ref.disabled, clickTrigger = _ref.clickTrigger;
    var onClose = onRootClose || $53b3c31e5491eff4$var$noop;
    (0, $7e8c2992c3b0ec82$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    var handleKeyUp = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(e) {
        if ((0, $66cdf71ba3c1e5cb$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $12aPv.useEffect)(function() {
        if (disabled || ref == null) return undefined;
        var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)((0, $7e8c2992c3b0ec82$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = (doc.defaultView || window).event;
        var removeKeyupListener = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return function() {
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $53b3c31e5491eff4$export$2e2bcd8739ae039 = $53b3c31e5491eff4$var$useRootClose;



var $leE2g = parcelRequire("leE2g");


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $dcc9211d5a5ebe94$export$c91fd81e6d65f84a = function(ref, document) {
    if (!(0, $64f258eaaf92e603$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $cb03b130654deaba$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $dcc9211d5a5ebe94$export$2e2bcd8739ae039(ref, onResolved) {
    var window = (0, $2b9d532f6e6b62e7$export$2e2bcd8739ae039)();
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(function() {
        return $dcc9211d5a5ebe94$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document);
    }), 2), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $dcc9211d5a5ebe94$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $12aPv.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $12aPv.useEffect)(function() {
        var nextRef = $dcc9211d5a5ebe94$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $leE2g = parcelRequire("leE2g");




var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

function $f0a7e2279caf3041$var$NoopTransition(param) {
    var children = param.children, inProp = param.in, onExited = param.onExited, mountOnEnter = param.mountOnEnter, unmountOnExit = param.unmountOnExit;
    var ref = (0, $12aPv.useRef)(null);
    var hasEnteredRef = (0, $12aPv.useRef)(inProp);
    var handleExited = (0, $0339cc266363564f$export$2e2bcd8739ae039)(onExited);
    (0, $12aPv.useEffect)(function() {
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    var combinedRef = (0, $0e2e1b24ec7da626$export$2e2bcd8739ae039)(ref, (0, $66cdf71ba3c1e5cb$export$87943f2672146d57)(children));
    var child = /*#__PURE__*/ (0, $6mMqj.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $f0a7e2279caf3041$export$2e2bcd8739ae039 = $f0a7e2279caf3041$var$NoopTransition;



var $6mMqj = parcelRequire("6mMqj");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");


var $9194eedcba4e6486$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $9194eedcba4e6486$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $9194eedcba4e6486$export$2e2bcd8739ae039(_ref) {
    var onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, onExit = _ref.onExit, onExiting = _ref.onExiting, onExited = _ref.onExited, addEndListener = _ref.addEndListener, children = _ref.children, props = $9194eedcba4e6486$var$_objectWithoutPropertiesLoose(_ref, $9194eedcba4e6486$var$_excluded);
    var nodeRef = (0, $12aPv.useRef)(null);
    var mergedRef = (0, $0e2e1b24ec7da626$export$2e2bcd8739ae039)(nodeRef, (0, $66cdf71ba3c1e5cb$export$87943f2672146d57)(children));
    var normalize = function(callback) {
        return function(param) {
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    };
    /* eslint-disable react-hooks/exhaustive-deps */ var handleEnter = (0, $12aPv.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    var handleEntering = (0, $12aPv.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    var handleEntered = (0, $12aPv.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    var handleExit = (0, $12aPv.useCallback)(normalize(onExit), [
        onExit
    ]);
    var handleExiting = (0, $12aPv.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    var handleExited = (0, $12aPv.useCallback)(normalize(onExited), [
        onExited
    ]);
    var handleAddEndListener = (0, $12aPv.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? function(status, innerProps) {
            return(// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })));
        } : /*#__PURE__*/ (0, $6mMqj.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



var $10833bd06082838a$var$_excluded = [
    "component"
];
function $10833bd06082838a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
var $10833bd06082838a$var$RTGTransition = /*#__PURE__*/ $6mMqj.forwardRef(function(_ref, ref) {
    var Component = _ref.component, props = $10833bd06082838a$var$_objectWithoutPropertiesLoose(_ref, $10833bd06082838a$var$_excluded);
    var transitionProps = (0, $9194eedcba4e6486$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $10833bd06082838a$export$2e2bcd8739ae039 = $10833bd06082838a$var$RTGTransition;




function $1671eb5ae115cdb6$export$7b286972b8d8ccbf(param) {
    var inProp = param.in, onTransition = param.onTransition;
    var ref = (0, $12aPv.useRef)(null);
    var isInitialRef = (0, $12aPv.useRef)(true);
    var handleTransition = (0, $0339cc266363564f$export$2e2bcd8739ae039)(onTransition);
    (0, $26f7a380474a7232$export$2e2bcd8739ae039)(function() {
        if (!ref.current) return undefined;
        var stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: function() {
                return stale;
            }
        });
        return function() {
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $26f7a380474a7232$export$2e2bcd8739ae039)(function() {
        isInitialRef.current = false;
        // this is for strict mode
        return function() {
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $1671eb5ae115cdb6$export$2e2bcd8739ae039(param) {
    var children = param.children, inProp = param.in, onExited = param.onExited, onEntered = param.onEntered, transition = param.transition;
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(!inProp), 2), exited = _useState[0], setExited = _useState[1];
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    var ref = $1671eb5ae115cdb6$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: function(options) {
            var onFinish = function() {
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, function(error) {
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    var combinedRef = (0, $0e2e1b24ec7da626$export$2e2bcd8739ae039)(ref, (0, $66cdf71ba3c1e5cb$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $6mMqj.cloneElement)(children, {
        ref: combinedRef
    });
}
function $1671eb5ae115cdb6$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $10833bd06082838a$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)($1671eb5ae115cdb6$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f0a7e2279caf3041$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $0cb7bb63ef88946d$var$Overlay = /*#__PURE__*/ $6mMqj.forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, containerPadding = props.containerPadding, _props_popperConfig = props.popperConfig, popperConfig = _props_popperConfig === void 0 ? {} : _props_popperConfig, Transition = props.transition, runTransition = props.runTransition;
    var _useCallbackRef = (0, $leE2g._)((0, $5c8dc24218cf5898$export$2e2bcd8739ae039)(), 2), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef1 = (0, $leE2g._)((0, $5c8dc24218cf5898$export$2e2bcd8739ae039)(), 2), arrowElement = _useCallbackRef1[0], attachArrowRef = _useCallbackRef1[1];
    var mergedRef = (0, $0e2e1b24ec7da626$export$2e2bcd8739ae039)(attachRef, outerRef);
    var container = (0, $dcc9211d5a5ebe94$export$2e2bcd8739ae039)(props.container);
    var target = (0, $dcc9211d5a5ebe94$export$2e2bcd8739ae039)(props.target);
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(!props.show), 2), exited = _useState[0], setExited = _useState[1];
    var popper = (0, $5de61c0f65289cab$export$2e2bcd8739ae039)(target, rootElement, (0, $d7821eb5a3db5dd9$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    var handleHidden = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _props;
        setExited(true);
        if (props.onExited) (_props = props).onExited.apply(_props, (0, $fsSDT._)(args));
    };
    // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || !exited;
    (0, $53b3c31e5491eff4$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
    var child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $1671eb5ae115cdb6$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, $6mMqj.default).createPortal(child, container) : null;
});
$0cb7bb63ef88946d$var$Overlay.displayName = 'Overlay';
var $0cb7bb63ef88946d$export$2e2bcd8739ae039 = $0cb7bb63ef88946d$var$Overlay;





parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $00f98d1dc049abf7$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}




var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");


var $6mMqj = parcelRequire("6mMqj");


var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $435c2e734a02bfb3$var$PopoverHeader = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$435c2e734a02bfb3$var$PopoverHeader.displayName = 'PopoverHeader';
var $435c2e734a02bfb3$export$2e2bcd8739ae039 = $435c2e734a02bfb3$var$PopoverHeader;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $fa2f34fd69703cec$var$PopoverBody = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$fa2f34fd69703cec$var$PopoverBody.displayName = 'PopoverBody';
var $fa2f34fd69703cec$export$2e2bcd8739ae039 = $fa2f34fd69703cec$var$PopoverBody;



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $bd484ad70b9868d1$export$34582a676b91ff07 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $h6w6E._)(BsPrefixComponent, _React_Component);
    function BsPrefixComponent() {
        (0, $7lhcp._)(this, BsPrefixComponent);
        return (0, $07dqX._)(this, BsPrefixComponent, arguments);
    }
    return BsPrefixComponent;
}($fClfl.Component);
function $bd484ad70b9868d1$export$c15856915a9b3464(placement, isRTL) {
    var bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $10e8d1975dba4281$export$2e2bcd8739ae039() {
    var position = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'absolute';
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
var $28df708aa4e6cfe9$var$Popover = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_placement = _param.placement, placement = _param_placement === void 0 ? 'right' : _param_placement, className = _param.className, style = _param.style, children = _param.children, body = _param.body, arrowProps = _param.arrowProps, hasDoneInitialMeasure = _param.hasDoneInitialMeasure, popper = _param.popper, show = _param.show, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "placement",
        "className",
        "style",
        "children",
        "body",
        "arrowProps",
        "hasDoneInitialMeasure",
        "popper",
        "show"
    ]);
    var decoratedBsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'popover');
    var isRTL = (0, $fb3854fa54537b64$export$35e511eefa30ac5a)();
    var _ref = (0, $leE2g._)((placement == null ? void 0 : placement.split('-')) || [], 1), primaryPlacement = _ref[0];
    var bsDirection = (0, $bd484ad70b9868d1$export$c15856915a9b3464)(primaryPlacement, isRTL);
    var computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = (0, $6GCxi._)({}, style, (0, $10e8d1975dba4281$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy));
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, decoratedBsPrefix, primaryPlacement && "bs-popover-".concat(bsDirection))
    }, props), {
        children: [
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $6GCxi._)({
                className: "popover-arrow"
            }, arrowProps)),
            body ? /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fa2f34fd69703cec$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    }));
});
$28df708aa4e6cfe9$var$Popover.displayName = 'Popover';
var $28df708aa4e6cfe9$export$2e2bcd8739ae039 = Object.assign($28df708aa4e6cfe9$var$Popover, {
    Header: (0, $435c2e734a02bfb3$export$2e2bcd8739ae039),
    Body: (0, $fa2f34fd69703cec$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");


var $6mMqj = parcelRequire("6mMqj");




"use client";
var $655d2cba841ecf22$var$Tooltip = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_placement = _param.placement, placement = _param_placement === void 0 ? 'right' : _param_placement, className = _param.className, style = _param.style, children = _param.children, arrowProps = _param.arrowProps, hasDoneInitialMeasure = _param.hasDoneInitialMeasure, popper = _param.popper, show = _param.show, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "placement",
        "className",
        "style",
        "children",
        "arrowProps",
        "hasDoneInitialMeasure",
        "popper",
        "show"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    var isRTL = (0, $fb3854fa54537b64$export$35e511eefa30ac5a)();
    var _ref = (0, $leE2g._)((placement == null ? void 0 : placement.split('-')) || [], 1), primaryPlacement = _ref[0];
    var bsDirection = (0, $bd484ad70b9868d1$export$c15856915a9b3464)(primaryPlacement, isRTL);
    var computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = (0, $6GCxi._)({}, style, (0, $10e8d1975dba4281$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy));
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, "bs-tooltip-".concat(bsDirection))
    }, props), {
        children: [
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $6GCxi._)({
                className: "tooltip-arrow"
            }, arrowProps)),
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                className: "".concat(bsPrefix, "-inner"),
                children: children
            })
        ]
    }));
});
$655d2cba841ecf22$var$Tooltip.displayName = 'Tooltip';
var $655d2cba841ecf22$export$2e2bcd8739ae039 = Object.assign($655d2cba841ecf22$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $9a1f0951c45cbbaa$export$2e2bcd8739ae039(customOffset) {
    var overlayRef = (0, $12aPv.useRef)(null);
    var popoverClass = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(undefined, 'popover');
    var tooltipClass = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(undefined, 'tooltip');
    var offset = (0, $12aPv.useMemo)(function() {
        return {
            name: 'offset',
            options: {
                offset: function() {
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $00f98d1dc049abf7$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $28df708aa4e6cfe9$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $00f98d1dc049abf7$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $655d2cba841ecf22$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        };
    }, [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}



var $5RfYb = parcelRequire("5RfYb");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");




var $6mMqj = parcelRequire("6mMqj");

var $6mMqj = parcelRequire("6mMqj");
var $e045e8eee697cafc$export$2e2bcd8739ae039 = {
    disabled: false
};




var $6mMqj = parcelRequire("6mMqj");
var $01110395489bde57$export$2e2bcd8739ae039 = (0, $6mMqj.default).createContext(null);


var $7125f96fb9c31d4c$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $9f32e062b2a84f9f$export$bb38bb9a1161268 = 'unmounted';
var $9f32e062b2a84f9f$export$84cbff306f539230 = 'exited';
var $9f32e062b2a84f9f$export$df38205c966be359 = 'entering';
var $9f32e062b2a84f9f$export$78e9e6e3e014d60a = 'entered';
var $9f32e062b2a84f9f$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9f32e062b2a84f9f$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $da0f998d8efa0f93$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9f32e062b2a84f9f$export$84cbff306f539230;
                _this.appearStatus = $9f32e062b2a84f9f$export$df38205c966be359;
            } else initialStatus = $9f32e062b2a84f9f$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9f32e062b2a84f9f$export$bb38bb9a1161268;
        else initialStatus = $9f32e062b2a84f9f$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9f32e062b2a84f9f$export$bb38bb9a1161268) return {
            status: $9f32e062b2a84f9f$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9f32e062b2a84f9f$export$df38205c966be359 && status !== $9f32e062b2a84f9f$export$78e9e6e3e014d60a) nextStatus = $9f32e062b2a84f9f$export$df38205c966be359;
            } else if (status === $9f32e062b2a84f9f$export$df38205c966be359 || status === $9f32e062b2a84f9f$export$78e9e6e3e014d60a) nextStatus = $9f32e062b2a84f9f$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9f32e062b2a84f9f$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $6mMqj.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $7125f96fb9c31d4c$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9f32e062b2a84f9f$export$84cbff306f539230) this.setState({
            status: $9f32e062b2a84f9f$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, $6mMqj.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $e045e8eee697cafc$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9f32e062b2a84f9f$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9f32e062b2a84f9f$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9f32e062b2a84f9f$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, $6mMqj.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $e045e8eee697cafc$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $9f32e062b2a84f9f$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9f32e062b2a84f9f$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9f32e062b2a84f9f$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $6mMqj.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9f32e062b2a84f9f$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $60abe64823f8b6d2$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, $6mMqj.default).createElement((0, $01110395489bde57$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, $6mMqj.default).cloneElement((0, $6mMqj.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, $6mMqj.default).Component);
$9f32e062b2a84f9f$var$Transition.contextType = (0, $01110395489bde57$export$2e2bcd8739ae039);
$9f32e062b2a84f9f$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9f32e062b2a84f9f$var$noop() {}
$9f32e062b2a84f9f$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9f32e062b2a84f9f$var$noop,
    onEntering: $9f32e062b2a84f9f$var$noop,
    onEntered: $9f32e062b2a84f9f$var$noop,
    onExit: $9f32e062b2a84f9f$var$noop,
    onExiting: $9f32e062b2a84f9f$var$noop,
    onExited: $9f32e062b2a84f9f$var$noop
};
$9f32e062b2a84f9f$var$Transition.UNMOUNTED = $9f32e062b2a84f9f$export$bb38bb9a1161268;
$9f32e062b2a84f9f$var$Transition.EXITED = $9f32e062b2a84f9f$export$84cbff306f539230;
$9f32e062b2a84f9f$var$Transition.ENTERING = $9f32e062b2a84f9f$export$df38205c966be359;
$9f32e062b2a84f9f$var$Transition.ENTERED = $9f32e062b2a84f9f$export$78e9e6e3e014d60a;
$9f32e062b2a84f9f$var$Transition.EXITING = $9f32e062b2a84f9f$export$4aacc83d4d59139f;
var $9f32e062b2a84f9f$export$2e2bcd8739ae039 = $9f32e062b2a84f9f$var$Transition;




function $a9aa5d166d13a472$export$2e2bcd8739ae039(node) {
    var doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bb63774a12698c7f$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $a9aa5d166d13a472$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $f8efbd1b1d8a9be0$var$rUpper = /([A-Z])/g;
function $f8efbd1b1d8a9be0$export$2e2bcd8739ae039(string) {
    return string.replace($f8efbd1b1d8a9be0$var$rUpper, '-$1').toLowerCase();
}


var $f10058893718c5ed$var$msPattern = /^ms-/;
function $f10058893718c5ed$export$2e2bcd8739ae039(string) {
    return (0, $f8efbd1b1d8a9be0$export$2e2bcd8739ae039)(string).replace($f10058893718c5ed$var$msPattern, '-ms-');
}


var $edfb6b9719fedecb$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $edfb6b9719fedecb$export$2e2bcd8739ae039(value) {
    return !!(value && $edfb6b9719fedecb$var$supportedTransforms.test(value));
}


function $2743bc2e9a1bad0a$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $f10058893718c5ed$export$2e2bcd8739ae039)(property)) || (0, $bb63774a12698c7f$export$2e2bcd8739ae039)(node).getPropertyValue((0, $f10058893718c5ed$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $f10058893718c5ed$export$2e2bcd8739ae039)(key));
        else if ((0, $edfb6b9719fedecb$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $f10058893718c5ed$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $2743bc2e9a1bad0a$export$2e2bcd8739ae039 = $2743bc2e9a1bad0a$var$style;




/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $34f3e4134ad86d5e$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $eb2ed0bd2d792c29$var$parseDuration(node) {
    var str = (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $eb2ed0bd2d792c29$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $34f3e4134ad86d5e$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $eb2ed0bd2d792c29$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $eb2ed0bd2d792c29$var$parseDuration(element) || 0;
    var removeEmulate = $eb2ed0bd2d792c29$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $6c4c03751b92b480$var$parseDuration(node, property) {
    var str = (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(node, property) || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $6c4c03751b92b480$export$2e2bcd8739ae039(element, handler) {
    var duration = $6c4c03751b92b480$var$parseDuration(element, 'transitionDuration');
    var delay = $6c4c03751b92b480$var$parseDuration(element, 'transitionDelay');
    var remove = (0, $eb2ed0bd2d792c29$export$2e2bcd8739ae039)(element, function(e) {
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $93931f8490664cd7$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



var $6mMqj = parcelRequire("6mMqj");
function $0e938b839aed4e3d$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, $6mMqj.default).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
var $10cca68523ec8a45$var$TransitionWrapper = /*#__PURE__*/ (0, $6mMqj.default).forwardRef(function(_param, ref) {
    var onEnter = _param.onEnter, onEntering = _param.onEntering, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onExited = _param.onExited, addEndListener = _param.addEndListener, children = _param.children, childRef = _param.childRef, props = (0, $8MJI4._)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "addEndListener",
        "children",
        "childRef"
    ]);
    var nodeRef = (0, $12aPv.useRef)(null);
    var mergedRef = (0, $3a5cc5c5ad7c23ef$export$2e2bcd8739ae039)(nodeRef, childRef);
    var attachRef = function(r) {
        mergedRef((0, $0e938b839aed4e3d$export$2e2bcd8739ae039)(r));
    };
    var normalize = function(callback) {
        return function(param) {
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    };
    var handleEnter = (0, $12aPv.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    var handleEntering = (0, $12aPv.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    var handleEntered = (0, $12aPv.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    var handleExit = (0, $12aPv.useCallback)(normalize(onExit), [
        onExit
    ]);
    var handleExiting = (0, $12aPv.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    var handleExited = (0, $12aPv.useCallback)(normalize(onExited), [
        onExited
    ]);
    var handleAddEndListener = (0, $12aPv.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $9f32e062b2a84f9f$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? function(status, innerProps) {
            return(// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, (0, $ctBui._)((0, $6GCxi._)({}, innerProps), {
                ref: attachRef
            })));
        } : /*#__PURE__*/ (0, $6mMqj.default).cloneElement(children, {
            ref: attachRef
        })
    }));
});
$10cca68523ec8a45$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $10cca68523ec8a45$export$2e2bcd8739ae039 = $10cca68523ec8a45$var$TransitionWrapper;



var $f4bd4b28ec6f3d4e$var$_obj;
var $f4bd4b28ec6f3d4e$var$fadeStyles = ($f4bd4b28ec6f3d4e$var$_obj = {}, (0, $5RfYb._)($f4bd4b28ec6f3d4e$var$_obj, (0, $9f32e062b2a84f9f$export$df38205c966be359), 'show'), (0, $5RfYb._)($f4bd4b28ec6f3d4e$var$_obj, (0, $9f32e062b2a84f9f$export$78e9e6e3e014d60a), 'show'), $f4bd4b28ec6f3d4e$var$_obj);
var $f4bd4b28ec6f3d4e$var$Fade = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, _param_transitionClasses = _param.transitionClasses, transitionClasses = _param_transitionClasses === void 0 ? {} : _param_transitionClasses, onEnter = _param.onEnter, rest = (0, $8MJI4._)(_param, [
        "className",
        "children",
        "transitionClasses",
        "onEnter"
    ]);
    var props = (0, $6GCxi._)({
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false
    }, rest);
    var handleEnter = (0, $12aPv.useCallback)(function(node, isAppearing) {
        (0, $93931f8490664cd7$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $10cca68523ec8a45$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref,
        addEndListener: (0, $6c4c03751b92b480$export$2e2bcd8739ae039)
    }, props), {
        onEnter: handleEnter,
        childRef: (0, $66cdf71ba3c1e5cb$export$87943f2672146d57)(children),
        children: function(status, innerProps) {
            return /*#__PURE__*/ $6mMqj.cloneElement(children, (0, $ctBui._)((0, $6GCxi._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))('fade', className, children.props.className, $f4bd4b28ec6f3d4e$var$fadeStyles[status], transitionClasses[status])
            }));
        }
    }));
});
$f4bd4b28ec6f3d4e$var$Fade.displayName = 'Fade';
var $f4bd4b28ec6f3d4e$export$2e2bcd8739ae039 = $f4bd4b28ec6f3d4e$var$Fade;




"use client";
function $fdc8da78bc1d85a7$var$wrapRefs(props, arrowProps) {
    var ref = props.ref;
    var aRef = arrowProps.ref;
    props.ref = ref.__wrapped || (ref.__wrapped = function(r) {
        return ref((0, $0e938b839aed4e3d$export$2e2bcd8739ae039)(r));
    });
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function(r) {
        return aRef((0, $0e938b839aed4e3d$export$2e2bcd8739ae039)(r));
    });
}
var $fdc8da78bc1d85a7$var$Overlay = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, outerRef) {
    var overlay = _param.children, _param_transition = _param.transition, transition = _param_transition === void 0 ? (0, $f4bd4b28ec6f3d4e$export$2e2bcd8739ae039) : _param_transition, _param_popperConfig = _param.popperConfig, popperConfig = _param_popperConfig === void 0 ? {} : _param_popperConfig, _param_rootClose = _param.rootClose, rootClose = _param_rootClose === void 0 ? false : _param_rootClose, _param_placement = _param.placement, placement = _param_placement === void 0 ? 'top' : _param_placement, tmp = _param.show, outerShow = tmp === void 0 ? false : tmp, outerProps = (0, $8MJI4._)(_param, [
        "children",
        "transition",
        "popperConfig",
        "rootClose",
        "placement",
        "show"
    ]);
    var popperRef = (0, $12aPv.useRef)({});
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(null), 2), firstRenderedState = _useState[0], setFirstRenderedState = _useState[1];
    var _useOverlayOffset = (0, $leE2g._)((0, $9a1f0951c45cbbaa$export$2e2bcd8739ae039)(outerProps.offset), 2), ref = _useOverlayOffset[0], modifiers = _useOverlayOffset[1];
    var mergedRef = (0, $3a5cc5c5ad7c23ef$export$2e2bcd8739ae039)(outerRef, ref);
    var actualTransition = transition === true ? (0, $f4bd4b28ec6f3d4e$export$2e2bcd8739ae039) : transition || undefined;
    var handleFirstUpdate = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(function(state) {
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $5d85ac82b8d2ad7b$export$2e2bcd8739ae039)(function() {
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $12aPv.useEffect)(function() {
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $0cb7bb63ef88946d$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({}, outerProps), {
        ref: mergedRef,
        popperConfig: (0, $ctBui._)((0, $6GCxi._)({}, popperConfig), {
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        }),
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: function(overlayProps, param) {
            var arrowProps = param.arrowProps, popperObj = param.popper, show = param.show;
            var _popperObj$state;
            $fdc8da78bc1d85a7$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            var updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            var popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            var hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay((0, $ctBui._)((0, $6GCxi._)((0, $ctBui._)((0, $6GCxi._)({}, overlayProps), {
                placement: updatedPlacement,
                show: show
            }), !transition && show && {
                className: 'show'
            }), {
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            }));
            return /*#__PURE__*/ $6mMqj.cloneElement(overlay, (0, $ctBui._)((0, $6GCxi._)({}, overlayProps), {
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(overlay.props.className, !transition && show && 'show'),
                style: (0, $6GCxi._)({}, overlay.props.style, overlayProps.style)
            }));
        }
    }));
});
$fdc8da78bc1d85a7$var$Overlay.displayName = 'Overlay';
var $fdc8da78bc1d85a7$export$2e2bcd8739ae039 = $fdc8da78bc1d85a7$var$Overlay;




var $fClfl = parcelRequire("fClfl");
"use client";
function $81a5f1fbcdaf3a22$var$normalizeDelay(delay) {
    return delay && (typeof delay === "undefined" ? "undefined" : (0, $5f0Cq._)(delay)) === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $81a5f1fbcdaf3a22$var$handleMouseOverOut(handler, args, relatedNative) {
    var _args = (0, $leE2g._)(args, 1), e = _args[0];
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(target, related)) handler.apply(void 0, (0, $fsSDT._)(args));
}
var $81a5f1fbcdaf3a22$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
var $81a5f1fbcdaf3a22$var$OverlayTrigger = function(_param) {
    var _param_trigger = _param.trigger, trigger = _param_trigger === void 0 ? [
        'hover',
        'focus'
    ] : _param_trigger, overlay = _param.overlay, children = _param.children, _param_popperConfig = _param.popperConfig, popperConfig = _param_popperConfig === void 0 ? {} : _param_popperConfig, propsShow = _param.show, _param_defaultShow = _param.defaultShow, defaultShow = _param_defaultShow === void 0 ? false : _param_defaultShow, onToggle = _param.onToggle, propsDelay = _param.delay, placement = _param.placement, _param_flip = _param.flip, flip = _param_flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _param_flip, props = (0, $8MJI4._)(_param, [
        "trigger",
        "overlay",
        "children",
        "popperConfig",
        "show",
        "defaultShow",
        "onToggle",
        "delay",
        "placement",
        "flip"
    ]);
    var triggerNodeRef = (0, $12aPv.useRef)(null);
    var mergedRef = (0, $3a5cc5c5ad7c23ef$export$2e2bcd8739ae039)(triggerNodeRef, (0, $66cdf71ba3c1e5cb$export$87943f2672146d57)(children));
    var timeout = (0, $576a6d784a380a3b$export$2e2bcd8739ae039)();
    var hoverStateRef = (0, $12aPv.useRef)('');
    var _useUncontrolledProp = (0, $leE2g._)((0, $c573222c50547131$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle), 2), show = _useUncontrolledProp[0], setShow = _useUncontrolledProp[1];
    var delay = $81a5f1fbcdaf3a22$var$normalizeDelay(propsDelay);
    var _ref = typeof children !== 'function' ? $6mMqj.Children.only(children).props : {}, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onClick = _ref.onClick;
    var attachRef = function(r) {
        mergedRef((0, $0e938b839aed4e3d$export$2e2bcd8739ae039)(r));
    };
    var handleShow = (0, $12aPv.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    var handleHide = (0, $12aPv.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    var handleFocus = (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        handleShow();
        onFocus == null || onFocus.apply(void 0, (0, $fsSDT._)(args));
    }, [
        handleShow,
        onFocus
    ]);
    var handleBlur = (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        handleHide();
        onBlur == null || onBlur.apply(void 0, (0, $fsSDT._)(args));
    }, [
        handleHide,
        onBlur
    ]);
    var handleClick = (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setShow(!show);
        onClick == null || onClick.apply(void 0, (0, $fsSDT._)(args));
    }, [
        onClick,
        setShow,
        show
    ]);
    var handleMouseOver = (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        $81a5f1fbcdaf3a22$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    var handleMouseOut = (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        $81a5f1fbcdaf3a22$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    var triggers = trigger == null ? [] : [].concat(trigger);
    var triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $6mMqj.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fdc8da78bc1d85a7$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({}, props), {
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            }))
        ]
    });
};
var $81a5f1fbcdaf3a22$export$2e2bcd8739ae039 = $81a5f1fbcdaf3a22$var$OverlayTrigger;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $fc12ef00830c07c6$var$Row = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var decoratedBsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'row');
    var breakpoints = (0, $fb3854fa54537b64$export$8970c8db816a5863)();
    var minBreakpoint = (0, $fb3854fa54537b64$export$d926d6ef38f3fd32)();
    var sizePrefix = "".concat(decoratedBsPrefix, "-cols");
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var cols;
        if (propValue != null && (typeof propValue === "undefined" ? "undefined" : (0, $5f0Cq._)(propValue)) === 'object') cols = propValue.cols;
        else cols = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : '';
        if (cols != null) classes.push("".concat(sizePrefix).concat(infix, "-").concat(cols));
    });
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
            className,
            decoratedBsPrefix
        ].concat((0, $fsSDT._)(classes)))
    }));
});
$fc12ef00830c07c6$var$Row.displayName = 'Row';
var $fc12ef00830c07c6$export$2e2bcd8739ae039 = $fc12ef00830c07c6$var$Row;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $ef6032f7425abfe5$var$Spinner = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, variant = _param.variant, _param_animation = _param.animation, animation = _param_animation === void 0 ? 'border' : _param_animation, size = _param.size, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, className = _param.className, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "variant",
        "animation",
        "size",
        "as",
        "className"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    var bsSpinnerPrefix = "".concat(bsPrefix, "-").concat(animation);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsSpinnerPrefix, size && "".concat(bsSpinnerPrefix, "-").concat(size), variant && "text-".concat(variant))
    }));
});
$ef6032f7425abfe5$var$Spinner.displayName = 'Spinner';
var $ef6032f7425abfe5$export$2e2bcd8739ae039 = $ef6032f7425abfe5$var$Spinner;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $ae5c70201edf55c0$var$Table = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, striped = _param.striped, bordered = _param.bordered, borderless = _param.borderless, hover = _param.hover, size = _param.size, variant = _param.variant, responsive = _param.responsive, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "striped",
        "bordered",
        "borderless",
        "hover",
        "size",
        "variant",
        "responsive"
    ]);
    var decoratedBsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'table');
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, decoratedBsPrefix, variant && "".concat(decoratedBsPrefix, "-").concat(variant), size && "".concat(decoratedBsPrefix, "-").concat(size), striped && "".concat(decoratedBsPrefix, "-").concat(typeof striped === 'string' ? "striped-".concat(striped) : 'striped'), bordered && "".concat(decoratedBsPrefix, "-bordered"), borderless && "".concat(decoratedBsPrefix, "-borderless"), hover && "".concat(decoratedBsPrefix, "-hover"));
    var table = /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("table", (0, $ctBui._)((0, $6GCxi._)({}, props), {
        className: classes,
        ref: ref
    }));
    if (responsive) {
        var responsiveClass = "".concat(decoratedBsPrefix, "-responsive");
        if (typeof responsive === 'string') responsiveClass = "".concat(responsiveClass, "-").concat(responsive);
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$ae5c70201edf55c0$var$Table.displayName = 'Table';
var $ae5c70201edf55c0$export$2e2bcd8739ae039 = $ae5c70201edf55c0$var$Table;


var $f8c7f7c57e720586$exports = {};



var $6f4acbd166de2c44$export$71511d61b312f219;
"use strict";
var $b94e4bad2128251c$export$71511d61b312f219;
"use strict";

function $b94e4bad2128251c$var$_super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $435c1b7a62b9651a$export$71511d61b312f219(object);
        if (object === null) break;
    }
    return object;
}
$b94e4bad2128251c$export$71511d61b312f219 = $b94e4bad2128251c$var$_super_prop_base;


function $6f4acbd166de2c44$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $6f4acbd166de2c44$export$71511d61b312f219 = $6f4acbd166de2c44$var$_get = Reflect.get;
    else $6f4acbd166de2c44$export$71511d61b312f219 = $6f4acbd166de2c44$var$_get = function get(target, property, receiver) {
        var base = $b94e4bad2128251c$export$71511d61b312f219(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $6f4acbd166de2c44$var$_get(target, property, receiver || target);
}
$6f4acbd166de2c44$export$71511d61b312f219 = $6f4acbd166de2c44$var$_get;






var $cInIr = parcelRequire("cInIr");

var $arNK5 = parcelRequire("arNK5");
parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");

var $6tqvJ = parcelRequire("6tqvJ");
function $f8c7f7c57e720586$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $f8c7f7c57e720586$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $f8c7f7c57e720586$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $f8c7f7c57e720586$var$$0172b398bee57f0a$exports = {};
$f8c7f7c57e720586$var$$parcel$export($f8c7f7c57e720586$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $f8c7f7c57e720586$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $f8c7f7c57e720586$var$$parcel$export($f8c7f7c57e720586$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $f8c7f7c57e720586$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__esDecorate = function $0172b398bee57f0a$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__runInitializers = function $0172b398bee57f0a$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function $0172b398bee57f0a$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function $0172b398bee57f0a$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $f8c7f7c57e720586$var$$0172b398bee57f0a$export$7112c88e033533b8 = function $0172b398bee57f0a$export$7112c88e033533b8(e, t) {
    return $f8c7f7c57e720586$var$$parcel$interopDefault($cInIr)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $f8c7f7c57e720586$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, u, $ = $fClfl.Component, f = [], d = [], b = [], p = [], v = [], _ = [];
    return r = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), a.set(_$e, $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__runInitializers(_$e, f, _$e.props)), s.set(_$e, ($f8c7f7c57e720586$var$$0172b398bee57f0a$var$__runInitializers(_$e, d), $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__runInitializers(_$e, b, _$e.state))), n.set(_$e, ($f8c7f7c57e720586$var$$0172b398bee57f0a$var$__runInitializers(_$e, p), $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__runInitializers(_$e, v, _$e.context))), $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__runInitializers(_$e, _), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function get() {
                    return $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "observedState",
                get: function get() {
                    return $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function get() {
                    return $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function set(e) {
                    $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e, r, a) {
                    var s;
                    $f8c7f7c57e720586$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $f8c7f7c57e720586$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }($), a = new WeakMap, s = new WeakMap, n = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, o = [
        (e = $arNK5.observable).shallow.bind(e)
    ], l = [
        (i = $arNK5.observable).shallow.bind(i)
    ], u = [
        (c = $arNK5.observable).shallow.bind(c)
    ], $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__esDecorate(r, null, o, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedProps" in e;
            },
            get: function get(e) {
                return e.observedProps;
            },
            set: function set(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, f, d), $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedState" in e;
            },
            get: function get(e) {
                return e.observedState;
            },
            set: function set(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, b, p), $f8c7f7c57e720586$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedContext" in e;
            },
            get: function get(e) {
                return e.observedContext;
            },
            set: function set(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, v, _), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $f8c7f7c57e720586$var$$621b7277d4dc39e9$exports = {};
$f8c7f7c57e720586$var$$parcel$export($f8c7f7c57e720586$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $f8c7f7c57e720586$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__runInitializers = function $621b7277d4dc39e9$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__esDecorate = function $621b7277d4dc39e9$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function $621b7277d4dc39e9$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function $621b7277d4dc39e9$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $f8c7f7c57e720586$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], u = [], $ = [];
    return e = function(e) {
        "use strict";
        function n() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, n), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(_$e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__runInitializers(_$e, l), (0, $fClfl.createRef)())
            }), s.set(_$e, $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__runInitializers(_$e, u, _$e.props.defaultValue)), t.set(_$e, $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__runInitializers(_$e, $)), r.set(_$e, void 0), a.set(_$e, function(t) {
                !(0, $6tqvJ.isEmpty)(t) && (0, $6tqvJ.isEmpty)(_$e.innerValue) && (_$e.innerValue = t);
            }), Object.defineProperty(_$e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r, a;
                    return null == (a = (r = _$e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "object" ? (0, $arNK5.toJS)(t) : t);
                }
            }), Object.defineProperty(_$e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    return _$e.innerValue = _$e.props.defaultValue;
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(n, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function get() {
                    return $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function get() {
                    var _$e;
                    return null != (_$e = this.observedProps.value) ? _$e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e, s, _$n = this;
                    $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $arNK5.reaction)(function() {
                        return _$n.observedProps.defaultValue;
                    }, $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $arNK5.reaction)(function() {
                        return _$n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (_$e = this.ref.current) ? void 0 : _$e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e, a, s, _$n;
                    null == (_$e = $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || _$e.call(this), $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (_$n = null == (s = this.ref.current) ? void 0 : s.form) || _$n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($f8c7f7c57e720586$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $f8c7f7c57e720586$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $arNK5.observable
    ], i = [
        $arNK5.computed
    ], $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "innerValue" in e;
            },
            get: function get(e) {
                return e.innerValue;
            },
            set: function set(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, u, $), $f8c7f7c57e720586$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "value" in e;
            },
            get: function get(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$f8c7f7c57e720586$var$$parcel$exportWildcard($f8c7f7c57e720586$exports, $f8c7f7c57e720586$var$$0172b398bee57f0a$exports), $f8c7f7c57e720586$var$$parcel$exportWildcard($f8c7f7c57e720586$exports, $f8c7f7c57e720586$var$$621b7277d4dc39e9$exports);



var $6tqvJ = parcelRequire("6tqvJ");
var $b664ecd293cb806f$exports = {};

var $5f0Cq = parcelRequire("5f0Cq");
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $b664ecd293cb806f$exports = factory();
})(undefined, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function __assign1() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function parseBounds(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function parseDocumentSize(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function toCodePoints$1(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function fromCodePoint$1() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function decode$1(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function polyUint16Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function polyUint32Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function slice16$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function slice32$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function createTrieFromBase64$1(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function LineBreaker(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function next() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function isDigit(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function isSurrogateCodePoint(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function isHex(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function isLowerCaseLetter(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function isUpperCaseLetter(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function isLetter(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function isNonASCIICodePoint(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function isWhiteSpace(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function isNameStartCodePoint(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function isNameCodePoint(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function isNonPrintableCodePoint(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function isValidEscape(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function isIdentifierStart(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function isNumberStart(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function stringToNumber(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function isDimensionToken(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function isNumberToken(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function isIdentToken(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function isStringToken(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function isIdentWithValue(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function nonWhiteSpace(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function nonFunctionArgSeparator(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function parseFunctionArgs(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function isEndingTokenFor(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function isLength(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function isLengthPercentage(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function parseLengthPercentageTuple(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function getAbsoluteValueForTuple(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function getAbsoluteValue(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function isAngle(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function parseNamedSide(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function deg(_deg) {
        return Math.PI * _deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function parse(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function isTransparent(color) {
        return (0xff & color) === 0;
    };
    var asString = function asString(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function pack(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function getTokenColorValue(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function rgb(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function hsl(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function parseColor(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function parseColorStop(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function processColorStops(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function getAngleFromCorner(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function calculateGradientDirection(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function distance(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function findCorner(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function calculateRadius(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function linearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function prefixLinearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function webkitGradient(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function radialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function prefixRadialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function isLinearGradient(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function isRadialGradient(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function parse(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function parseBackgroundRepeat(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function isBackgroundSizeInfoToken(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function borderColorForSide(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function borderRadiusForSide(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function parse(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function borderStyleForSide(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function parse(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function borderWidthForSide(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function parse(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function parseDisplayValue(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function computeLineHeight(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function marginForSide(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function paddingForSide(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function matrix(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function matrix3d(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function contains(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function getQuote(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function parse(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function getElementDebugType(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function isDebugging(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function decode(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function polyUint16Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function polyUint32Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function slice16(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function slice32(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function createTrieFromBase64(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function toCodePoints(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function fromCodePoint() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function codePointToClass(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function _graphemeBreakAtIndex(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function GraphemeBreaker(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function next() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function splitGraphemes(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function testRangeBounds(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function testIOSLineBreak(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function testCORS() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function testResponseType() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function testSVG(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function isGreenPixel(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function testForeignObject(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function loadSerializedSVG$1(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function parseTextBounds(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function getWrapperBounds(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function createRange(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function segmentGraphemes(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function segmentWords(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function breakText(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function breakWords(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function _loop_1() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function transform(text, _transform) {
        switch(_transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function capitalize(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function reformatInputBounds(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function getInputValue(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function parseNodeTree1(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function createContainer(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function parseTree(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function createsRealStackingContext(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function createsStackingContext(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function isHTMLElementNode(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function isSVGElementNode(element) {
        return (0, $5f0Cq._)(element.className) === 'object';
    };
    var isLIElement = function isLIElement(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function isOLElement(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function isInputElement(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function isHTMLElement(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function isSVGElement(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function isBodyElement(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function isCanvasElement(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function isVideoElement(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function isImageElement(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function isIFrameElement(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function isStyleElement(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function isScriptElement(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function isTextareaElement(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function isSelectElement(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function isSlotElement(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function isCustomElement(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function createCounterText(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var _$window = node.ownerDocument.defaultView;
            if (_$window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = _$window.getComputedStyle(node);
                var styleBefore = _$window.getComputedStyle(node, ':before');
                var styleAfter = _$window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var _$document = clone.ownerDocument;
            if (!_$document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = _$document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = _$document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(_$document.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(_$document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(_$document.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function createIFrameContainer(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function imageReady(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function imagesReady(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function iframeLoader(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function copyCSSStyles(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function serializeDoctype(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function restoreNodeScroll(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function createPseudoHideStyles(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function createStyles(body, styles) {
        var _$document = body.ownerDocument;
        if (_$document) {
            var style = _$document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function isRenderable(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function isInlineImage(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function isInlineBase64Image(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function isBlobImage(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function isSVG(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function lerp(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function isBezierCurve(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function calculateContentBoxPath(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function isTransformEffect(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function isClipEffect(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function isOpacityEffect(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function equalPath(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function transformPath(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function parseStackTree1(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function processListItems(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function parseStackingContexts(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function parsePathForBorder(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function parsePathForBorderDoubleOuter(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function parsePathForBorderDoubleInner(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function parsePathForBorderStroke(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function createStrokePathFromCurves(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function paddingBox(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function contentBox(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function calculateBackgroundPositioningArea(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function calculateBackgroundPaintingArea(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function calculateBackgroundRendering(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function isAuto(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function hasIntrinsicValue(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function calculateBackgroundSize(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function getBackgroundValueForIndex(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function _loop_1(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function isTextInputElement(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function calculateBackgroundCurvedPaintingArea(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function canvasTextAlign(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function fixIOSSystemFonts(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function loadSerializedSVG(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function html2canvas(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function renderElement(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || (typeof element === "undefined" ? "undefined" : (0, $5f0Cq._)(element)) !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function parseBackgroundColor(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


function $def56be66887619b$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $def56be66887619b$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $def56be66887619b$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $def56be66887619b$var$$fd019656019bb4f3$exports = {};
function $def56be66887619b$var$$fd019656019bb4f3$export$e3607ec2d7a891c4(e) {
    return function(t) {
        return t && new IntersectionObserver(function(t, r) {
            var a, c, n = (0, $ada009390fa7849c$export$71511d61b312f219)(t, 1)[0], o = n.isIntersecting, i = n.target;
            if (o) {
                var s = [
                    "animate__animated",
                    "animate__".concat(e)
                ];
                (a = i.classList).add.apply(a, (0, $36427be7dd51c5e7$export$71511d61b312f219)(s)), i.addEventListener("animationend", function() {
                    return (c = i.classList).remove.apply(c, (0, $36427be7dd51c5e7$export$71511d61b312f219)(s));
                }, {
                    once: !0
                }), r.disconnect();
            }
        }).observe(t);
    };
}
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$fd019656019bb4f3$exports, "animate", function() {
    return $def56be66887619b$var$$fd019656019bb4f3$export$e3607ec2d7a891c4;
});
var $def56be66887619b$var$$757747c0209676cc$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$757747c0209676cc$exports, "Avatar", function() {
    return $def56be66887619b$var$$757747c0209676cc$export$e2255cf6045e8d47;
});
var $def56be66887619b$var$$757747c0209676cc$var$__rest = function $757747c0209676cc$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$757747c0209676cc$export$e2255cf6045e8d47 = function $757747c0209676cc$export$e2255cf6045e8d47(e) {
    var t = e.className, r = e.style, a = e.size, c = void 0 === a ? 3 : a, n = $def56be66887619b$var$$757747c0209676cc$var$__rest(e, [
        "className",
        "style",
        "size"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("img", Object.assign({
        className: $def56be66887619b$var$$parcel$interopDefault($8bd163097a5514bf$exports)("object-fit-cover rounded-circle", t),
        style: Object.assign({
            width: "".concat(c, "rem"),
            height: "".concat(c, "rem")
        }, r)
    }, n));
};
$def56be66887619b$var$$757747c0209676cc$export$e2255cf6045e8d47.displayName = "Avatar";
var $def56be66887619b$var$$a40a1c3d6dc84a7a$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$a40a1c3d6dc84a7a$exports, "ClickBoundary", function() {
    return $def56be66887619b$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa;
});
var $def56be66887619b$var$$a40a1c3d6dc84a7a$var$__rest = function $a40a1c3d6dc84a7a$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa = function(e) {
    "use strict";
    function t() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "root", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, $fClfl.createRef)()
        }), Object.defineProperty(_$e, "switchClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function value(t) {
                var r, a = _$e.props, c = a.onInnerClick, n = a.onOuterClick;
                (null == (r = _$e.root.current) ? void 0 : r.contains(t.target)) ? null == c || c(t) : null == n || n(t);
            }
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
        {
            key: "componentDidMount",
            value: function value() {
                window.addEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function value() {
                window.removeEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "render",
            value: function value() {
                var _$e = this.props, _$t = _$e.children, r = (_$e.onInnerClick, _$e.onOuterClick, $def56be66887619b$var$$a40a1c3d6dc84a7a$var$__rest(_$e, [
                    "children",
                    "onInnerClick",
                    "onOuterClick"
                ]));
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({
                    ref: this.root
                }, r, {
                    children: _$t
                }));
            }
        }
    ]), t;
}($6mMqj.PureComponent), $def56be66887619b$var$$89fa9a64cf869995$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$89fa9a64cf869995$exports, "CodeBlock", function() {
    return $def56be66887619b$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb;
});
var $def56be66887619b$var$$89fa9a64cf869995$var$__rest = function $89fa9a64cf869995$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb = function $89fa9a64cf869995$export$6c415d1fdae3dfdb(e) {
    var t = e.className, r = e.language, a = e.children, c = $def56be66887619b$var$$89fa9a64cf869995$var$__rest(e, [
        "className",
        "language",
        "children"
    ]), n = "string" == typeof a ? a : $def56be66887619b$var$$parcel$interopDefault($52394bb05ad00d71$exports)((0, $6mMqj.isValidElement)(a) ? a : (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
        children: a
    })), o = (0, $0e70cb6ccf37e2dd$exports.highlight)(n, $0e70cb6ccf37e2dd$exports.languages[r], r);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("pre", Object.assign({
        className: "language-".concat(r, " ").concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("code", {
            dangerouslySetInnerHTML: {
                __html: o
            },
            className: "language-".concat(r)
        })
    }));
}, $def56be66887619b$var$$924d73683971f901$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$924d73683971f901$exports, "VariantColors", function() {
    return $def56be66887619b$var$$924d73683971f901$export$50b010be9260e56b;
}), $def56be66887619b$var$$parcel$export($def56be66887619b$var$$924d73683971f901$exports, "text2color", function() {
    return $def56be66887619b$var$$924d73683971f901$export$b480d00b75c9ac2d;
});
var $def56be66887619b$var$$924d73683971f901$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "dark",
    "light"
];
function $def56be66887619b$var$$924d73683971f901$export$b480d00b75c9ac2d(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = t[0] ? $def56be66887619b$var$$924d73683971f901$export$50b010be9260e56b.filter(function(e) {
        return !t.find(function(t) {
            return t === e;
        });
    }) : $def56be66887619b$var$$924d73683971f901$export$50b010be9260e56b;
    return r[(0, $36427be7dd51c5e7$export$71511d61b312f219)(e).reduce(function(e, t) {
        return e + t.charCodeAt(0);
    }, 0) % r.length];
}
var $def56be66887619b$var$$e308f4ff6755d29b$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$e308f4ff6755d29b$exports, "DialogClose", function() {
    return $def56be66887619b$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac;
}), $def56be66887619b$var$$parcel$export($def56be66887619b$var$$e308f4ff6755d29b$exports, "Dialog", function() {
    return $def56be66887619b$var$$e308f4ff6755d29b$export$3ddf2d174ce01153;
});
var $def56be66887619b$var$$e308f4ff6755d29b$var$__esDecorate = function $e308f4ff6755d29b$var$__esDecorate(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $def56be66887619b$var$$e308f4ff6755d29b$var$__runInitializers = function $e308f4ff6755d29b$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $def56be66887619b$var$$e308f4ff6755d29b$var$__classPrivateFieldGet = function $e308f4ff6755d29b$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $def56be66887619b$var$$e308f4ff6755d29b$var$__classPrivateFieldSet = function $e308f4ff6755d29b$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $def56be66887619b$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac = function(e) {
    "use strict";
    function t() {
        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Dialog closed";
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, [
            _$e
        ]);
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), t;
}((0, $073406e1dc6df849$export$71511d61b312f219)(Error)), $def56be66887619b$var$$e308f4ff6755d29b$export$3ddf2d174ce01153 = function() {
    var e, t, r, a, c, n, o = [], i = [], s = [], l = [];
    return t = function() {
        "use strict";
        function e(t) {
            var c = this;
            (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, e), r.set(this, $def56be66887619b$var$$e308f4ff6755d29b$var$__runInitializers(this, o, {})), a.set(this, ($def56be66887619b$var$$e308f4ff6755d29b$var$__runInitializers(this, i), $def56be66887619b$var$$e308f4ff6755d29b$var$__runInitializers(this, s, void 0))), Object.defineProperty(this, "Component", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: $def56be66887619b$var$$e308f4ff6755d29b$var$__runInitializers(this, l)
            }), this.Component = (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)(function(e) {
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)(t, Object.assign({}, e, c.input, {
                    defer: c.defer
                }));
            }), this.Component.displayName = "DialogComponent";
        }
        return (0, $355cb88dd58749ed$export$71511d61b312f219)(e, [
            {
                key: "input",
                get: function get() {
                    return $def56be66887619b$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "defer",
                get: function get() {
                    return $def56be66887619b$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "open",
                value: function value(e) {
                    var t = this;
                    return e && (this.input = e), this.defer = new $edbe2f6a95b5edf7$export$c7e91f8aec23ae14, this.defer.promise.finally(function() {
                        return t.defer = void 0;
                    }), this.defer.promise;
                }
            }
        ]), e;
    }(), r = new WeakMap, a = new WeakMap, e = "function" == typeof Symbol && Symbol.metadata ? Object.create(null) : void 0, c = [
        $arNK5.observable
    ], n = [
        $arNK5.observable
    ], $def56be66887619b$var$$e308f4ff6755d29b$var$__esDecorate(t, null, c, {
        kind: "accessor",
        name: "input",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "input" in e;
            },
            get: function get(e) {
                return e.input;
            },
            set: function set(e, t) {
                e.input = t;
            }
        },
        metadata: e
    }, o, i), $def56be66887619b$var$$e308f4ff6755d29b$var$__esDecorate(t, null, n, {
        kind: "accessor",
        name: "defer",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "defer" in e;
            },
            get: function get(e) {
                return e.defer;
            },
            set: function set(e, t) {
                e.defer = t;
            }
        },
        metadata: e
    }, s, l), e && Object.defineProperty(t, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }), t;
}(), $def56be66887619b$var$$68aab1d0e8e5016c$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $def56be66887619b$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $def56be66887619b$var$$68aab1d0e8e5016c$var$__esDecorate = function $68aab1d0e8e5016c$var$__esDecorate(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $def56be66887619b$var$$68aab1d0e8e5016c$var$__runInitializers = function $68aab1d0e8e5016c$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $def56be66887619b$var$$68aab1d0e8e5016c$var$__awaiter = function $68aab1d0e8e5016c$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function o(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function i(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var _$t;
            e.done ? c(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(o, i);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $def56be66887619b$var$$68aab1d0e8e5016c$var$__setFunctionName = function $68aab1d0e8e5016c$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $def56be66887619b$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function $68aab1d0e8e5016c$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $def56be66887619b$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function $68aab1d0e8e5016c$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $def56be66887619b$var$$68aab1d0e8e5016c$var$__rest = function $68aab1d0e8e5016c$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$68aab1d0e8e5016c$var$ReactEditorJS = (0, $819452666ec7d3d4$export$da8ca15f4115b46e)(), $def56be66887619b$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, t, r, a, c, n = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], o = [], i = $fClfl.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "core", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), r.set(_$e, $def56be66887619b$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, s, _$e.props.defaultValue)), Object.defineProperty(_$e, "save", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($def56be66887619b$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, l), function() {
                    return $def56be66887619b$var$$68aab1d0e8e5016c$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, _$t;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(r) {
                            switch(r.label){
                                case 0:
                                    if (!(_$e = this.core)) return [
                                        3,
                                        2
                                    ];
                                    return _$t = this, [
                                        4,
                                        this.core.save()
                                    ];
                                case 1:
                                    _$e = _$t.innerValue = r.sent(), r.label = 2;
                                case 2:
                                    return [
                                        2,
                                        _$e
                                    ];
                            }
                        });
                    });
                })
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "innerValue",
                get: function get() {
                    return $def56be66887619b$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.props, r = _$t.name, a = _$t.required, c = (_$t.children, $def56be66887619b$var$$68aab1d0e8e5016c$var$__rest(_$t, [
                        "name",
                        "required",
                        "children"
                    ])), n = this.innerValue;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "form-control",
                        tabIndex: -1,
                        onBlur: this.save,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                hidden: !0,
                                name: r,
                                required: a,
                                value: JSON.stringify(n)
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$68aab1d0e8e5016c$var$ReactEditorJS, Object.assign({}, c, {
                                onInitialize: function onInitialize(t) {
                                    var r;
                                    _$e.core = t, null == (r = c.onInitialize) || r.call(c, t);
                                }
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }(i), r = new WeakMap, $def56be66887619b$var$$68aab1d0e8e5016c$var$__setFunctionName(c, "Editor"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = i[Symbol.metadata]) ? e : null) : void 0, $def56be66887619b$var$$68aab1d0e8e5016c$var$__esDecorate(c, null, [
        $arNK5.observable
    ], {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "innerValue" in e;
            },
            get: function get(e) {
                return e.innerValue;
            },
            set: function set(e, t) {
                e.innerValue = t;
            }
        },
        metadata: t
    }, s, l), $def56be66887619b$var$$68aab1d0e8e5016c$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, o), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $def56be66887619b$var$$68aab1d0e8e5016c$var$__runInitializers(c, o), c;
}(), $def56be66887619b$var$$db3d9d99c159855a$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$db3d9d99c159855a$exports, "parser", function() {
    return $def56be66887619b$var$$db3d9d99c159855a$export$8f49e4af10703ce3;
}), $def56be66887619b$var$$parcel$export($def56be66887619b$var$$db3d9d99c159855a$exports, "EditorHTML", function() {
    return $def56be66887619b$var$$db3d9d99c159855a$export$f9c5335a01b13a5a;
});
var $def56be66887619b$var$$db3d9d99c159855a$var$__rest = function $db3d9d99c159855a$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$db3d9d99c159855a$export$8f49e4af10703ce3 = $def56be66887619b$var$$parcel$interopDefault($3e3a7251f1f53fd8$exports)({
    link: function link(e) {
        var t = e.data.link;
        return '<a href="'.concat(t, '">').concat(t, "</a>");
    }
}), $def56be66887619b$var$$db3d9d99c159855a$export$f9c5335a01b13a5a = function $db3d9d99c159855a$export$f9c5335a01b13a5a(e) {
    var t = e.data, r = $def56be66887619b$var$$db3d9d99c159855a$var$__rest(e, [
        "data"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("article", Object.assign({}, r, {
        dangerouslySetInnerHTML: {
            __html: $def56be66887619b$var$$db3d9d99c159855a$export$8f49e4af10703ce3.parse(t)
        }
    }));
};
$def56be66887619b$var$$db3d9d99c159855a$export$f9c5335a01b13a5a.displayName = "EditorHTML";
var $def56be66887619b$var$$e400f030e8cea549$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$e400f030e8cea549$exports, "HorizontalMarquee", function() {
    return $def56be66887619b$var$$e400f030e8cea549$export$4eb895ecfe5a67d5;
}), $def56be66887619b$var$$parcel$export($def56be66887619b$var$$e400f030e8cea549$exports, "HorizontalMarqueeBox", function() {
    return $def56be66887619b$var$$e400f030e8cea549$export$e22877062eb47c32;
}), $def56be66887619b$var$$14c85ffeff1ab241$export$fad3c8302a7540c6 = "_4_3lnG_scrollContainer", $def56be66887619b$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd = "_4_3lnG_scrollHeightWrap", $def56be66887619b$var$$14c85ffeff1ab241$export$1a22ace05a045e3f = "_4_3lnG_scrollItem", $def56be66887619b$var$$14c85ffeff1ab241$export$c7aa240077ad8340 = "_4_3lnG_scrollWrap", $def56be66887619b$var$$14c85ffeff1ab241$export$5add10f2a1e13991 = "_4_3lnG_unScrollItem";
var $def56be66887619b$var$$e400f030e8cea549$var$__rest = function $e400f030e8cea549$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$e400f030e8cea549$export$4eb895ecfe5a67d5 = function $e400f030e8cea549$export$4eb895ecfe5a67d5(e) {
    var t = e.className, r = e.children, a = e.maxWidth, c = e.duration, n = e.height, o = $def56be66887619b$var$$e400f030e8cea549$var$__rest(e, [
        "className",
        "children",
        "maxWidth",
        "duration",
        "height"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({
        className: "overflow-hidden mw-100 ".concat(void 0 === t ? "" : t)
    }, o, {
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block align-top text-nowrap ".concat($def56be66887619b$var$$14c85ffeff1ab241$export$c7aa240077ad8340),
            style: {
                maxWidth: void 0 === a ? "100%" : a,
                animationDuration: c,
                height: n,
                lineHeight: n
            },
            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                className: "d-inline-block ".concat($def56be66887619b$var$$14c85ffeff1ab241$export$1a22ace05a045e3f),
                style: {
                    animationDuration: c
                },
                children: r
            })
        })
    }));
}, $def56be66887619b$var$$e400f030e8cea549$export$e22877062eb47c32 = function $e400f030e8cea549$export$e22877062eb47c32(e) {
    var t = e.children, r = e.maxWidth, a = e.duration, c = e.height;
    return c ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
        className: "overflow-hidden ".concat($def56be66887619b$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd),
        style: {
            maxWidth: r,
            "--scroll-height": c
        },
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block overflow-hidden mw-100 ".concat($def56be66887619b$var$$14c85ffeff1ab241$export$fad3c8302a7540c6),
            children: [
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                    className: "d-block overflow-hidden text-wrap text-break ".concat($def56be66887619b$var$$14c85ffeff1ab241$export$5add10f2a1e13991),
                    children: t
                }),
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
                    duration: a,
                    children: t
                })
            ]
        })
    }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
        maxWidth: r,
        duration: a,
        height: c,
        children: t
    });
};
$def56be66887619b$var$$e400f030e8cea549$export$4eb895ecfe5a67d5.displayName = "HorizontalMarquee";
var $def56be66887619b$var$$cf5cdc2ffed4bc45$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$cf5cdc2ffed4bc45$exports, "Icon", function() {
    return $def56be66887619b$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f;
});
var $def56be66887619b$var$$cf5cdc2ffed4bc45$var$__rest = function $cf5cdc2ffed4bc45$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f = function $cf5cdc2ffed4bc45$export$f04a61298a47a40f(e) {
    var t = e.className, r = e.style, a = e.name, c = e.size, n = $def56be66887619b$var$$cf5cdc2ffed4bc45$var$__rest(e, [
        "className",
        "style",
        "name",
        "size"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", Object.assign({
        className: $def56be66887619b$var$$parcel$interopDefault($8bd163097a5514bf$exports)("bi-".concat(a), t),
        style: Object.assign({
            fontSize: c && "".concat(c, "rem")
        }, r)
    }, n));
};
$def56be66887619b$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f.displayName = "Icon";
var $def56be66887619b$var$$1f7252b8d0187295$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$1f7252b8d0187295$exports, "Loading", function() {
    return $def56be66887619b$var$$1f7252b8d0187295$export$669f6ea7d267feaf;
});
var $def56be66887619b$var$$1f7252b8d0187295$var$__rest = function $1f7252b8d0187295$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$1f7252b8d0187295$export$669f6ea7d267feaf = function $1f7252b8d0187295$export$669f6ea7d267feaf(e) {
    var t = e.className, r = e.children, a = $def56be66887619b$var$$1f7252b8d0187295$var$__rest(e, [
        "className",
        "children"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({
        className: "fixed-top h-100 w-100 d-flex justify-content-center align-items-center opacity-25 bg-black ".concat(void 0 === t ? "" : t)
    }, a, {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ef6032f7425abfe5$export$2e2bcd8739ae039, {
                animation: "border",
                variant: "success"
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                className: "ml-3 text-white",
                children: void 0 === r ? "Loading..." : r
            })
        ]
    }));
};
$def56be66887619b$var$$1f7252b8d0187295$export$669f6ea7d267feaf.displayName = "Loading";
var $def56be66887619b$var$$ec6e3ccd45c7b7c0$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$ec6e3ccd45c7b7c0$exports, "MonthCalendar", function() {
    return $def56be66887619b$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a;
});
var $def56be66887619b$var$$a121893c5bead7fc$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$a121893c5bead7fc$exports, "OverlayBox", function() {
    return $def56be66887619b$var$$a121893c5bead7fc$export$5169ff31790bf260;
});
var $def56be66887619b$var$$a121893c5bead7fc$var$__rest = function $a121893c5bead7fc$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$a121893c5bead7fc$export$5169ff31790bf260 = function $a121893c5bead7fc$export$5169ff31790bf260(e) {
    var t = e.title, r = e.detail, a = e.children, c = $def56be66887619b$var$$a121893c5bead7fc$var$__rest(e, [
        "title",
        "detail",
        "children"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($81a5f1fbcdaf3a22$export$2e2bcd8739ae039, Object.assign({}, c, {
        overlay: r ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($28df708aa4e6cfe9$export$2e2bcd8739ae039, {
            children: [
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)($28df708aa4e6cfe9$export$2e2bcd8739ae039.Header, {
                    children: t
                }),
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)($28df708aa4e6cfe9$export$2e2bcd8739ae039.Body, {
                    children: r
                })
            ]
        }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)($655d2cba841ecf22$export$2e2bcd8739ae039, {
            children: t
        }),
        children: a
    }));
};
$def56be66887619b$var$$a121893c5bead7fc$export$5169ff31790bf260.displayName = "OverlayBox";
var $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__runInitializers = function $ec6e3ccd45c7b7c0$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__esDecorate = function $ec6e3ccd45c7b7c0$var$__esDecorate(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__setFunctionName = function $ec6e3ccd45c7b7c0$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet = function $ec6e3ccd45c7b7c0$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet = function $ec6e3ccd45c7b7c0$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__rest = function $ec6e3ccd45c7b7c0$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a = function() {
    var e, t, r, a, c, n, o, i, s = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], l = [], $ = $f8c7f7c57e720586$exports.ObservedComponent, u = [], d = [], f = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__runInitializers(_$e, u), $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__runInitializers(_$e, d, new Date))), Object.defineProperty(_$e, "renderDate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__runInitializers(_$e, f), function(t) {
                    var r = _$e.observedProps, a = (r.variant, r.value), c = r.onSelect, n = (0, $6tqvJ.formatDate)(t, "YYYY-MM-DD"), o = null == a ? void 0 : a.filter(function(e) {
                        var _$t = e.date;
                        return (0, $6tqvJ.formatDate)(_$t, "YYYY-MM-DD") === n;
                    });
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                        className: $def56be66887619b$var$$parcel$interopDefault($8bd163097a5514bf$exports)({
                            "opacity-50": t.getMonth() !== _$e.currentDate.getMonth(),
                            "fw-bold": n === (0, $6tqvJ.formatDate)(new Date, "YYYY-MM-DD")
                        }),
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("time", {
                                className: "d-block",
                                dateTime: t.toJSON(),
                                children: t.getDate()
                            }),
                            null == o ? void 0 : o.map(function(e) {
                                return "object" === (0, $a4f5296238ef68ec$export$71511d61b312f219)(e.content) ? e.content : (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$a121893c5bead7fc$export$5169ff31790bf260, {
                                    title: e.content,
                                    children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($f1387cf7abf6568e$export$2e2bcd8739ae039, {
                                        as: "a",
                                        className: "d-inline-block text-decoration-none w-100 text-truncate",
                                        bg: $def56be66887619b$var$$924d73683971f901$export$b480d00b75c9ac2d(e.content + "", [
                                            "light"
                                        ]),
                                        href: e.link,
                                        onClick: function onClick() {
                                            return null == c ? void 0 : c(e);
                                        },
                                        children: e.content
                                    })
                                }, e.date + "");
                            })
                        ]
                    }, t + "");
                })
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "weekFormatter",
                get: function get() {
                    var _$e, _$t = this.observedProps.locale, r = void 0 === _$t ? null == (_$e = globalThis.navigator) ? void 0 : _$e.language : _$t;
                    return new Intl.DateTimeFormat(r, {
                        weekday: "long"
                    });
                }
            },
            {
                key: "currentDate",
                get: function get() {
                    return $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "dateGrid",
                get: function get() {
                    var _$e = new Date(this.currentDate);
                    _$e.setDate(1), _$e = new Date(_$e - _$e.getDay() * $6tqvJ.Day);
                    var _$t = Array.from(Array(42), function(t, r) {
                        return new Date(+_$e + r * $6tqvJ.Day);
                    });
                    return (0, $6tqvJ.splitArray)(_$t, 7);
                }
            },
            {
                key: "changeMonth",
                value: function value(e) {
                    var _$t, r;
                    this.currentDate = (0, $6tqvJ.changeMonth)(this.currentDate, e), null == (r = (_$t = this.props).onChange) || r.call(_$t, this.currentDate);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.weekFormatter, r = this.currentDate, a = this.dateGrid, c = this.observedProps, n = c.style, o = c.variant, i = void 0 === o ? "primary" : o, s = (c.onChange, c.onSelect, $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__rest(c, [
                        "style",
                        "variant",
                        "onChange",
                        "onSelect"
                    ]));
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ae5c70201edf55c0$export$2e2bcd8739ae039, Object.assign({}, s, {
                        style: Object.assign({
                            tableLayout: "fixed"
                        }, n),
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("caption", {
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex justify-content-between align-items-center",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                            variant: i,
                                            onClick: function onClick() {
                                                return _$e.changeMonth(-1);
                                            },
                                            children: "<"
                                        }),
                                        (0, $6tqvJ.formatDate)(r, "YYYY-MM"),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                            variant: i,
                                            onClick: function onClick() {
                                                return _$e.changeMonth(1);
                                            },
                                            children: ">"
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("thead", {
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                    children: a[0].map(function(e, r, a) {
                                        var c = a.length;
                                        return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                            className: "bg-".concat(i, " text-white"),
                                            style: {
                                                width: "calc(100% / ".concat(c, ")")
                                            },
                                            children: _$t.format(e)
                                        }, r);
                                    })
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tbody", {
                                children: a.map(function(t) {
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                        children: t.map(_$e.renderDate)
                                    }, t[0] + "");
                                })
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__setFunctionName(c, "MonthCalendar"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, n = [
        $arNK5.computed
    ], o = [
        $arNK5.observable
    ], i = [
        $arNK5.computed
    ], $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, n, {
        kind: "getter",
        name: "weekFormatter",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "weekFormatter" in e;
            },
            get: function get(e) {
                return e.weekFormatter;
            }
        },
        metadata: t
    }, null, u), $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, o, {
        kind: "accessor",
        name: "currentDate",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "currentDate" in e;
            },
            get: function get(e) {
                return e.currentDate;
            },
            set: function set(e, t) {
                e.currentDate = t;
            }
        },
        metadata: t
    }, d, f), $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "dateGrid",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "dateGrid" in e;
            },
            get: function get(e) {
                return e.dateGrid;
            }
        },
        metadata: t
    }, null, u), $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__esDecorate(null, a = {
        value: c
    }, s, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "MonthCalendar"
    }), $def56be66887619b$var$$ec6e3ccd45c7b7c0$var$__runInitializers(c, l), c;
}(), $def56be66887619b$var$$4f69bf8d62d4bac9$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$4f69bf8d62d4bac9$exports, "Nameplate", function() {
    return $def56be66887619b$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601;
});
var $def56be66887619b$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601 = function $4f69bf8d62d4bac9$export$caa4d5435e8fb601(e) {
    var t = e.avatar, r = e.name;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$757747c0209676cc$export$e2255cf6045e8d47, {
                size: 2,
                style: {
                    marginRight: "0.5rem"
                },
                src: t
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                className: "align-middle",
                children: r
            })
        ]
    });
};
$def56be66887619b$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601.displayName = "Nameplate";
var $def56be66887619b$var$$d78fd73e1713e936$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$d78fd73e1713e936$exports, "PageNav", function() {
    return $def56be66887619b$var$$d78fd73e1713e936$export$f24150b9675a2c65;
});
var $def56be66887619b$var$$d78fd73e1713e936$var$__runInitializers = function $d78fd73e1713e936$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $def56be66887619b$var$$d78fd73e1713e936$var$__esDecorate = function $d78fd73e1713e936$var$__esDecorate(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $def56be66887619b$var$$d78fd73e1713e936$var$__setFunctionName = function $d78fd73e1713e936$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $def56be66887619b$var$$d78fd73e1713e936$var$__classPrivateFieldGet = function $d78fd73e1713e936$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $def56be66887619b$var$$d78fd73e1713e936$var$__classPrivateFieldSet = function $d78fd73e1713e936$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $def56be66887619b$var$$d78fd73e1713e936$var$__rest = function $d78fd73e1713e936$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$d78fd73e1713e936$var$HeadingSelector = Array.from(Array(6), function(e, t) {
    return "h".concat(++t);
}) + "", $def56be66887619b$var$$d78fd73e1713e936$export$f24150b9675a2c65 = function() {
    var e, t, r, a, c, n, o, i, s, l = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], $ = [], u = $fClfl.Component, d = [], f = [], p = [], b = [], m = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($def56be66887619b$var$$d78fd73e1713e936$var$__runInitializers(_$e, d), $def56be66887619b$var$$d78fd73e1713e936$var$__runInitializers(_$e, f, []))), a.set(_$e, ($def56be66887619b$var$$d78fd73e1713e936$var$__runInitializers(_$e, p), $def56be66887619b$var$$d78fd73e1713e936$var$__runInitializers(_$e, b, 0))), Object.defineProperty(_$e, "updateScrollY", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($def56be66887619b$var$$d78fd73e1713e936$var$__runInitializers(_$e, m), function() {
                    return _$e.scrollY = window.scrollY;
                })
            }), Object.defineProperty(_$e, "scrollTo", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return function() {
                        var r, a;
                        setTimeout(function() {
                            return (0, $6tqvJ.scrollTo)('[id="'.concat(t.id, '"]'));
                        }), null == (a = (r = _$e.props).onItemClick) || a.call(r, t);
                    };
                }
            }), Object.defineProperty(_$e, "renderLink", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.id, a = t.level, c = t.text, n = t.top, o = _$e.currentActiveId, i = _$e.props.depth;
                    return a <= (void 0 === i ? 1 / 0 : i) && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($e5d030dc0e0e8f4f$export$2e2bcd8739ae039.Item, {
                        style: {
                            textIndent: "".concat(a - 1, "rem")
                        },
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($e5d030dc0e0e8f4f$export$2e2bcd8739ae039.Link, {
                            href: "#".concat(r),
                            active: o === r,
                            onClick: _$e.scrollTo({
                                id: r,
                                level: a,
                                text: c,
                                top: n
                            }),
                            children: c
                        })
                    }, r);
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "list",
                get: function get() {
                    return $def56be66887619b$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "scrollY",
                get: function get() {
                    return $def56be66887619b$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "currentActiveId",
                get: function get() {
                    var _$e, _$t = this.list, r = this.scrollY, a = _$t.findIndex(function(e) {
                        return e.top > r;
                    });
                    return null == (_$e = _$t[a - 1]) ? void 0 : _$e.id;
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    globalThis.document && (window.addEventListener("scroll", this.updateScrollY), this.list = Array.from(document.querySelectorAll($def56be66887619b$var$$d78fd73e1713e936$var$HeadingSelector), function(e) {
                        e.id || (e.id = (0, $6tqvJ.uniqueID)());
                        var _$t = e.id, r = e.tagName, a = e.textContent, c = e.offsetTop;
                        return {
                            id: _$t,
                            level: +r[1],
                            text: a.trim(),
                            top: c
                        };
                    }));
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e;
                    null == (_$e = globalThis.removeEventListener) || _$e.call(globalThis, "scroll", this.updateScrollY);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.list, _$t = this.props, r = _$t.style, a = _$t.variant, c = $def56be66887619b$var$$d78fd73e1713e936$var$__rest(_$t, [
                        "style",
                        "variant"
                    ]);
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($e5d030dc0e0e8f4f$export$2e2bcd8739ae039, Object.assign({}, c, {
                        variant: void 0 === a ? "underline" : a,
                        style: Object.assign({
                            flexDirection: "column"
                        }, r),
                        children: _$e.map(this.renderLink)
                    }));
                }
            }
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $def56be66887619b$var$$d78fd73e1713e936$var$__setFunctionName(n, "PageNav"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, o = [
        $arNK5.observable
    ], i = [
        $arNK5.observable
    ], s = [
        $arNK5.computed
    ], $def56be66887619b$var$$d78fd73e1713e936$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "list",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "list" in e;
            },
            get: function get(e) {
                return e.list;
            },
            set: function set(e, t) {
                e.list = t;
            }
        },
        metadata: t
    }, f, p), $def56be66887619b$var$$d78fd73e1713e936$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "scrollY",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "scrollY" in e;
            },
            get: function get(e) {
                return e.scrollY;
            },
            set: function set(e, t) {
                e.scrollY = t;
            }
        },
        metadata: t
    }, b, m), $def56be66887619b$var$$d78fd73e1713e936$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "currentActiveId",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "currentActiveId" in e;
            },
            get: function get(e) {
                return e.currentActiveId;
            }
        },
        metadata: t
    }, null, d), $def56be66887619b$var$$d78fd73e1713e936$var$__esDecorate(null, c = {
        value: n
    }, l, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, $), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "PageNav"
    }), $def56be66887619b$var$$d78fd73e1713e936$var$__runInitializers(n, $), n;
}(), $def56be66887619b$var$$5d0c8d8af5c3c7e5$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$5d0c8d8af5c3c7e5$exports, "Option", function() {
    return $def56be66887619b$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20;
}), $def56be66887619b$var$$parcel$export($def56be66887619b$var$$5d0c8d8af5c3c7e5$exports, "Select", function() {
    return $def56be66887619b$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f;
});
var $def56be66887619b$var$$5d0c8d8af5c3c7e5$var$__rest = function $5d0c8d8af5c3c7e5$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 = function $5d0c8d8af5c3c7e5$export$36d18380658d5d20(e) {
    var t = e.value, r = e.children, a = $def56be66887619b$var$$5d0c8d8af5c3c7e5$var$__rest(e, [
        "value",
        "children"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ee420024178a4af8$export$2e2bcd8739ae039.Item, Object.assign({}, a, {
        "data-value": t,
        children: r
    }));
};
$def56be66887619b$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20.displayName = "Option";
var $def56be66887619b$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f = function $5d0c8d8af5c3c7e5$export$ef9b1a59e592288f(e) {
    var t = e.className, r = e.style, a = e.variant, c = e.menuVariant, n = e.children, o = e.value, i = e.onChange, s = e.valueRender, l = (0, $6tqvJ.makeArray)(n).flat(1 / 0).find(function(e) {
        return (0, $6mMqj.isValidElement)(e) && e.type === $def56be66887619b$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 && e.props.value === o;
    });
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ee420024178a4af8$export$2e2bcd8739ae039, {
        onClick: function onClick(e) {
            var t = e.target.closest(".dropdown-item");
            if (t) {
                var r = t.dataset.value;
                null == i || i(r);
            }
        },
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ee420024178a4af8$export$2e2bcd8739ae039.Toggle, {
                className: $def56be66887619b$var$$parcel$interopDefault($8bd163097a5514bf$exports)("w-100", "d-flex", "justify-content-between", "align-items-center", !a && "bg-white text-dark", t),
                style: r,
                variant: a,
                children: (null == s ? void 0 : s(o)) || (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                    className: null == l ? void 0 : l.props.className,
                    children: null == l ? void 0 : l.props.children
                })
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ee420024178a4af8$export$2e2bcd8739ae039.Menu, {
                variant: c,
                children: n
            })
        ]
    });
};
$def56be66887619b$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f.displayName = "Select";
var $def56be66887619b$var$$5c7497f9f3fe6432$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$5c7497f9f3fe6432$exports, "elementToImage", function() {
    return $def56be66887619b$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc;
}), $def56be66887619b$var$$parcel$export($def56be66887619b$var$$5c7497f9f3fe6432$exports, "ShareBox", function() {
    return $def56be66887619b$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c;
});
var $def56be66887619b$var$$5c7497f9f3fe6432$var$__esDecorate = function $5c7497f9f3fe6432$var$__esDecorate(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $def56be66887619b$var$$5c7497f9f3fe6432$var$__runInitializers = function $5c7497f9f3fe6432$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $def56be66887619b$var$$5c7497f9f3fe6432$var$__awaiter = function $5c7497f9f3fe6432$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function o(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function i(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var _$t;
            e.done ? c(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(o, i);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $def56be66887619b$var$$5c7497f9f3fe6432$var$__setFunctionName = function $5c7497f9f3fe6432$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $def56be66887619b$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet = function $5c7497f9f3fe6432$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $def56be66887619b$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet = function $5c7497f9f3fe6432$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $def56be66887619b$var$$5c7497f9f3fe6432$var$__rest = function $5c7497f9f3fe6432$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
};
function $def56be66887619b$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(e, t, r) {
    return $def56be66887619b$var$$5c7497f9f3fe6432$var$__awaiter(this, void 0, void 0, function() {
        var a;
        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(c) {
            switch(c.label){
                case 0:
                    return [
                        4,
                        $def56be66887619b$var$$parcel$interopDefault($b664ecd293cb806f$exports)(e, {
                            useCORS: !0
                        })
                    ];
                case 1:
                    return a = c.sent(), [
                        2,
                        new Promise(function(e, c) {
                            return a.toBlob(function(t) {
                                return t ? e(URL.createObjectURL(t)) : c();
                            }, t, r);
                        })
                    ];
            }
        });
    });
}
var $def56be66887619b$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c = function() {
    var e, t, r, a, c, n, o, i, s = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], l = [], $ = $fClfl.Component, u = [], d = [], f = [], p = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "root", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $fClfl.createRef)()
            }), r.set(_$e, $def56be66887619b$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, u, !1)), a.set(_$e, ($def56be66887619b$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, d), $def56be66887619b$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, f, ""))), Object.defineProperty(_$e, "generateImage", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($def56be66887619b$var$$5c7497f9f3fe6432$var$__runInitializers(_$e, p), function() {
                    return $def56be66887619b$var$$5c7497f9f3fe6432$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.imageURI && (URL.revokeObjectURL(this.imageURI), this.imageURI = ""), this.loading = !0, _$e = this, [
                                        4,
                                        $def56be66887619b$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(this.root.current)
                                    ];
                                case 1:
                                    return _$e.imageURI = t.sent(), this.loading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(_$e, "share", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return $def56be66887619b$var$$5c7497f9f3fe6432$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, r, a;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(c) {
                            switch(c.label){
                                case 0:
                                    return t.stopPropagation(), [
                                        4,
                                        (0, $6tqvJ.blobOf)(this.imageURI)
                                    ];
                                case 1:
                                    return a = new File([
                                        r = c.sent()
                                    ], "".concat(this.props.title, ".png"), {
                                        type: r.type
                                    }), [
                                        4,
                                        null == (_$e = navigator.share) ? void 0 : _$e.call(navigator, Object.assign({
                                            files: [
                                                a
                                            ]
                                        }, this.props))
                                    ];
                                case 2:
                                    return c.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "loading",
                get: function get() {
                    return $def56be66887619b$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "imageURI",
                get: function get() {
                    return $def56be66887619b$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e;
                    null == (_$e = globalThis.addEventListener) || _$e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e;
                    null == (_$e = globalThis.removeEventListener) || _$e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.className, r = _$e.children, a = $def56be66887619b$var$$5c7497f9f3fe6432$var$__rest(_$e, [
                        "className",
                        "children"
                    ]), c = this.loading, n = this.imageURI;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
                        children: [
                            c && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$1f7252b8d0187295$export$669f6ea7d267feaf, {}),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({}, a, {
                                ref: this.root,
                                className: "position-relative ".concat(void 0 === _$t ? "" : _$t),
                                onMouseEnter: n ? void 0 : this.generateImage,
                                onTouchStart: n ? void 0 : this.generateImage,
                                children: [
                                    r,
                                    n && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4833a765594519c8$export$2e2bcd8739ae039, {
                                        className: "position-absolute start-0 top-0 w-100 h-100",
                                        src: n,
                                        alt: "Share Image",
                                        fluid: !0,
                                        onClick: this.share
                                    })
                                ]
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $def56be66887619b$var$$5c7497f9f3fe6432$var$__setFunctionName(n, "ShareBox"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, o = [
        $arNK5.observable
    ], i = [
        $arNK5.observable
    ], $def56be66887619b$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "loading",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "loading" in e;
            },
            get: function get(e) {
                return e.loading;
            },
            set: function set(e, t) {
                e.loading = t;
            }
        },
        metadata: t
    }, u, d), $def56be66887619b$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "imageURI",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "imageURI" in e;
            },
            get: function get(e) {
                return e.imageURI;
            },
            set: function set(e, t) {
                e.imageURI = t;
            }
        },
        metadata: t
    }, f, p), $def56be66887619b$var$$5c7497f9f3fe6432$var$__esDecorate(null, c = {
        value: n
    }, s, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, l), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ShareBox"
    }), $def56be66887619b$var$$5c7497f9f3fe6432$var$__runInitializers(n, l), n;
}(), $def56be66887619b$var$$ad4a2cea628613d5$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$ad4a2cea628613d5$exports, "SpinnerButton", function() {
    return $def56be66887619b$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb;
});
var $def56be66887619b$var$$ad4a2cea628613d5$var$__rest = function $ad4a2cea628613d5$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb = function $ad4a2cea628613d5$export$4cfabf47f4311ebb(e) {
    var t = e.animation, r = e.loading, a = e.disabled, c = e.children, n = $def56be66887619b$var$$ad4a2cea628613d5$var$__rest(e, [
        "animation",
        "loading",
        "disabled",
        "children"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, Object.assign({}, n, {
        disabled: r || a,
        children: [
            r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ef6032f7425abfe5$export$2e2bcd8739ae039, {
                        as: "span",
                        className: c ? "me-2" : "",
                        size: "sm",
                        animation: t,
                        role: "status",
                        "aria-hidden": "true"
                    }),
                    !c && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                ]
            }),
            c
        ]
    }));
};
$def56be66887619b$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb.displayName = "SpinnerButton";
var $def56be66887619b$var$$53fa7c21606566cb$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$53fa7c21606566cb$exports, "TableSpinner", function() {
    return $def56be66887619b$var$$53fa7c21606566cb$export$4706ba151aa92b7e;
});
var $def56be66887619b$var$$53fa7c21606566cb$var$__rest = function $53fa7c21606566cb$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$53fa7c21606566cb$export$4706ba151aa92b7e = function $53fa7c21606566cb$export$4706ba151aa92b7e(e) {
    var t = e.animation, r = e.variant, a = e.size, c = e.colSpan, n = $def56be66887619b$var$$53fa7c21606566cb$var$__rest(e, [
        "animation",
        "variant",
        "size",
        "colSpan"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", Object.assign({}, n, {
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
            className: "text-center p-4",
            colSpan: c,
            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ef6032f7425abfe5$export$2e2bcd8739ae039, {
                animation: void 0 === t ? "border" : t,
                variant: void 0 === r ? "primary" : r,
                size: a
            })
        })
    }));
};
$def56be66887619b$var$$53fa7c21606566cb$export$4706ba151aa92b7e.displayName = "TableSpinner";
var $def56be66887619b$var$$03c0468daff9422a$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$03c0468daff9422a$exports, "Time", function() {
    return $def56be66887619b$var$$03c0468daff9422a$export$680ea196effce5f;
});
var $def56be66887619b$var$$03c0468daff9422a$var$__rest = function $03c0468daff9422a$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$03c0468daff9422a$export$680ea196effce5f = function $03c0468daff9422a$export$680ea196effce5f(e) {
    var t = e.dateTime, r = e.format, a = $def56be66887619b$var$$03c0468daff9422a$var$__rest(e, [
        "dateTime",
        "format"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("time", Object.assign({
        dateTime: new Date(t).toJSON()
    }, a, {
        children: (0, $6tqvJ.formatDate)(t, r)
    }));
}, $def56be66887619b$var$$2f5f9093a9aac8ee$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$2f5f9093a9aac8ee$exports, "TimeDistance", function() {
    return $def56be66887619b$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969;
});
var $def56be66887619b$var$$2f5f9093a9aac8ee$var$__rest = function $2f5f9093a9aac8ee$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$2f5f9093a9aac8ee$var$UnitWords = {
    ms: "millisecond(s)",
    s: "second(s)",
    m: "minute(s)",
    H: "hour(s)",
    D: "day(s)",
    W: "week(s)",
    M: "month(s)",
    Y: "year(s)"
}, $def56be66887619b$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969 = function $2f5f9093a9aac8ee$export$db3f63f9e19e5969(e) {
    var t = e.date, r = e.unitWords, a = e.beforeWord, c = e.afterWord, n = $def56be66887619b$var$$2f5f9093a9aac8ee$var$__rest(e, [
        "date",
        "unitWords",
        "beforeWord",
        "afterWord"
    ]);
    t = new Date(t);
    var o = (0, $6tqvJ.diffTime)(t), i = o.distance, s = o.unit;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("time", Object.assign({}, n, {
        dateTime: t.toJSON(),
        title: t.toLocaleString(),
        children: [
            Math.abs(i),
            " ",
            (void 0 === r ? $def56be66887619b$var$$2f5f9093a9aac8ee$var$UnitWords : r)[s],
            i < 0 ? void 0 === a ? " before" : a : void 0 === c ? " after" : c
        ]
    }));
};
$def56be66887619b$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969.displayName = "TimeDistance";
var $def56be66887619b$var$$31b55198d5058ded$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$31b55198d5058ded$exports, "Timeline", function() {
    return $def56be66887619b$var$$31b55198d5058ded$export$e6a97ba2cae5bb94;
}), $def56be66887619b$var$$4bfbcb67a3daf664$export$79ffe56a765070d2 = "TOztta_right", $def56be66887619b$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461 = "TOztta_timeline", $def56be66887619b$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7 = "TOztta_timelineItem";
var $def56be66887619b$var$$31b55198d5058ded$var$__rest = function $31b55198d5058ded$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$31b55198d5058ded$export$e6a97ba2cae5bb94 = function $31b55198d5058ded$export$e6a97ba2cae5bb94(e) {
    var t = e.className, r = e.events, a = e.timeFormat, c = $def56be66887619b$var$$31b55198d5058ded$var$__rest(e, [
        "className",
        "events",
        "timeFormat"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ol", Object.assign({
        className: "list-unstyled ".concat($def56be66887619b$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, " ").concat(t)
    }, c, {
        children: r.map(function(e) {
            var t = e.title, r = e.summary, c = e.time, n = e.link, o = e.people;
            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                className: "position-relative ".concat($def56be66887619b$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, " ").concat($def56be66887619b$var$$4bfbcb67a3daf664$export$79ffe56a765070d2),
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($5144fe88f07c89a5$export$2e2bcd8739ae039, {
                    children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($5144fe88f07c89a5$export$2e2bcd8739ae039.Body, {
                        className: "p-4 d-flex flex-column gap-3 align-items-center",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                className: "h5 m-0",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                    className: "text-decoration-none stretched-link",
                                    href: n,
                                    children: t
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "small text-muted d-flex gap-2",
                                children: [
                                    "\u23F2\uFE0F",
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[0],
                                        format: a
                                    }),
                                    c[1] && "~",
                                    c[1] && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[1],
                                        format: a
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", {
                                className: "list-unstyled m-0 d-flex gap-2 flex-wrap justify-content-around",
                                children: null == o ? void 0 : o.map(function(e) {
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601, Object.assign({}, e))
                                    }, e.name);
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                className: "m-0",
                                children: r
                            })
                        ]
                    })
                })
            }, t);
        })
    }));
};
$def56be66887619b$var$$31b55198d5058ded$export$e6a97ba2cae5bb94.displayName = "Timeline";
var $def56be66887619b$var$$f4c02b33c4295ca8$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$f4c02b33c4295ca8$exports, "TypeEcho", function() {
    return $def56be66887619b$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6;
});
var $def56be66887619b$var$$f4c02b33c4295ca8$var$__esDecorate = function $f4c02b33c4295ca8$var$__esDecorate(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $def56be66887619b$var$$f4c02b33c4295ca8$var$__runInitializers = function $f4c02b33c4295ca8$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $def56be66887619b$var$$f4c02b33c4295ca8$var$__awaiter = function $f4c02b33c4295ca8$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function o(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function i(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var _$t;
            e.done ? c(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(o, i);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $def56be66887619b$var$$f4c02b33c4295ca8$var$__setFunctionName = function $f4c02b33c4295ca8$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $def56be66887619b$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet = function $f4c02b33c4295ca8$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $def56be66887619b$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet = function $f4c02b33c4295ca8$var$__classPrivateFieldSet(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $def56be66887619b$var$$f4c02b33c4295ca8$var$__rest = function $f4c02b33c4295ca8$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6 = function() {
    var e, t, r, a, c, n = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], o = [], i = $fClfl.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, $def56be66887619b$var$$f4c02b33c4295ca8$var$__runInitializers(_$e, s, "")), Object.defineProperty(_$e, "init", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($def56be66887619b$var$$f4c02b33c4295ca8$var$__runInitializers(_$e, l), function(t) {
                    return t && new IntersectionObserver(function(t, r) {
                        return $def56be66887619b$var$$f4c02b33c4295ca8$var$__awaiter(_$e, [
                            t,
                            r
                        ], void 0, function(e, t) {
                            var _$r, a, c, n, o, i, s, l, $, u, d;
                            return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(f) {
                                switch(f.label){
                                    case 0:
                                        if (!(0, $ada009390fa7849c$export$71511d61b312f219)(e, 1)[0].isIntersecting) return [
                                            2
                                        ];
                                        t.disconnect(), a = (_$r = this.props).text, n = void 0 === (c = _$r.intervals) ? 150 : c, o = !0, i = !1, s = void 0, f.label = 1;
                                    case 1:
                                        f.trys.push([
                                            1,
                                            6,
                                            7,
                                            8
                                        ]), l = a[Symbol.iterator](), f.label = 2;
                                    case 2:
                                        if (o = ($ = l.next()).done) return [
                                            3,
                                            5
                                        ];
                                        return u = $.value, [
                                            4,
                                            (0, $6tqvJ.sleep)(n / 1e3)
                                        ];
                                    case 3:
                                        f.sent(), this.echoed += u, f.label = 4;
                                    case 4:
                                        return o = !0, [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 6:
                                        return d = f.sent(), i = !0, s = d, [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        try {
                                            o || null == l.return || l.return();
                                        } finally{
                                            if (i) throw s;
                                        }
                                        return [
                                            7
                                        ];
                                    case 8:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }).observe(t);
                })
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "echoed",
                get: function get() {
                    return $def56be66887619b$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $def56be66887619b$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.className, r = _$e.text, a = $def56be66887619b$var$$f4c02b33c4295ca8$var$__rest(_$e, [
                        "className",
                        "text"
                    ]), c = this.echoed;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("pre", Object.assign({}, a, {
                        ref: this.init,
                        className: $def56be66887619b$var$$parcel$interopDefault($8bd163097a5514bf$exports)("text-wrap", _$t),
                        children: c + (c === r ? "" : "_")
                    }));
                }
            }
        ]), t;
    }(i), r = new WeakMap, $def56be66887619b$var$$f4c02b33c4295ca8$var$__setFunctionName(c, "TypeEcho"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = i[Symbol.metadata]) ? e : null) : void 0, $def56be66887619b$var$$f4c02b33c4295ca8$var$__esDecorate(c, null, [
        $arNK5.observable
    ], {
        kind: "accessor",
        name: "echoed",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "echoed" in e;
            },
            get: function get(e) {
                return e.echoed;
            },
            set: function set(e, t) {
                e.echoed = t;
            }
        },
        metadata: t
    }, s, l), $def56be66887619b$var$$f4c02b33c4295ca8$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, o), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "TypeEcho"
    }), $def56be66887619b$var$$f4c02b33c4295ca8$var$__runInitializers(c, o), c;
}(), $def56be66887619b$var$$77dc12b8e0b9d622$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$77dc12b8e0b9d622$exports, "UserRankView", function() {
    return $def56be66887619b$var$$77dc12b8e0b9d622$export$4ed039229ec81818;
});
var $def56be66887619b$var$$c5da9bad1903a67d$export$5f821f795e2d2901 = function $c5da9bad1903a67d$export$5f821f795e2d2901(e) {
    var t = e.email, r = e.website;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("address", {
        className: "mb-0 d-flex justify-content-around gap-2",
        children: [
            t && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: "mailto:" + t,
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "envelope"
                })
            }),
            r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: r,
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "globe2"
                })
            })
        ]
    });
};
$def56be66887619b$var$$7d37db9df1578ff2$export$5c452ff88e35e47d = "WavURG_image", $def56be66887619b$var$$7d37db9df1578ff2$export$30d389775d7a0f3c = "WavURG_medal", $def56be66887619b$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6 = "WavURG_name", $def56be66887619b$var$$7d37db9df1578ff2$export$896c314ae37c4db9 = "WavURG_rankBox", $def56be66887619b$var$$7d37db9df1578ff2$export$717db1a952ac2d26 = "WavURG_restUsers", $def56be66887619b$var$$7d37db9df1578ff2$export$74fdf2685172213b = "WavURG_suspension", $def56be66887619b$var$$7d37db9df1578ff2$export$fb184b623420d9be = "WavURG_title", $def56be66887619b$var$$7d37db9df1578ff2$export$ec176431609ba4c9 = "WavURG_topUser", $def56be66887619b$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b = "WavURG_topUsers";
var $def56be66887619b$var$$77dc12b8e0b9d622$var$__rest = function $77dc12b8e0b9d622$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$77dc12b8e0b9d622$export$4ed039229ec81818 = function(e) {
    "use strict";
    function t() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "renderMedal", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function value(t) {
                var r, a;
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($27ad5a1fd7e6d114$export$2e2bcd8739ae039, {
                    as: "li",
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                            className: "shadow-lg overflow-hidden rounded-circle m-auto ".concat($def56be66887619b$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4833a765594519c8$export$2e2bcd8739ae039, {
                                src: t.avatar,
                                alt: t.name,
                                loading: "lazy",
                                fluid: !0
                            })
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                            className: "position-relative overflow-hidden ".concat($def56be66887619b$var$$7d37db9df1578ff2$export$ec176431609ba4c9),
                            children: [
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "position-relative",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("i", {
                                            className: "d-block overflow-hidden m-auto mb-1 rounded-circle"
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                            className: "d-block mb-0 stretched-link",
                                            href: (null == (a = (r = _$e.props).linkOf) ? void 0 : a.call(r, t)) || "#",
                                            children: t.name
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("strong", {
                                            children: t.score
                                        })
                                    ]
                                }),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                            ]
                        })
                    ]
                }, t.id);
            }
        }), Object.defineProperty(_$e, "renderRow", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function value(t, r, a) {
                var c, n, o = a.length;
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                    className: "position-relative",
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($f1387cf7abf6568e$export$2e2bcd8739ae039, {
                                className: "fw-bold fst-italic",
                                children: (r + 4 + "").padStart((o + "").length, "0")
                            })
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                            className: "position-relative mw-50 text-truncate ".concat($def56be66887619b$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6),
                            children: [
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-inline-block overflow-hidden align-middle rounded-circle ".concat($def56be66887619b$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                                    children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4833a765594519c8$export$2e2bcd8739ae039, {
                                        src: t.avatar,
                                        alt: t.name,
                                        loading: "lazy",
                                        fluid: !0
                                    })
                                }),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                    className: "ms-2 d-inline-block align-middle stretched-link",
                                    style: {
                                        color: "rgb(248, ".concat((r + 2) * 15, ", ").concat((r + 2) * 35, ")")
                                    },
                                    href: (null == (n = (c = _$e.props).linkOf) ? void 0 : n.call(c, t)) || "#",
                                    children: t.name
                                })
                            ]
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: t.score
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($def56be66887619b$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                        })
                    ]
                }, t.id);
            }
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
        {
            key: "render",
            value: function value() {
                var _$e = this.props, _$t = _$e.className, r = _$e.title, a = _$e.rank, c = void 0 === a ? [] : a, n = (_$e.linkOf, $def56be66887619b$var$$77dc12b8e0b9d622$var$__rest(_$e, [
                    "className",
                    "title",
                    "rank",
                    "linkOf"
                ]));
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fc12ef00830c07c6$export$2e2bcd8739ae039, Object.assign({
                    className: "".concat($def56be66887619b$var$$7d37db9df1578ff2$export$896c314ae37c4db9, " ").concat(void 0 === _$t ? "" : _$t)
                }, n, {
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)($27ad5a1fd7e6d114$export$2e2bcd8739ae039, {
                            sm: 12,
                            xs: 12,
                            lg: 7,
                            children: [
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "shadow rounded-3 ".concat($def56be66887619b$var$$7d37db9df1578ff2$export$fb184b623420d9be),
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: $def56be66887619b$var$$7d37db9df1578ff2$export$30d389775d7a0f3c,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                })
                                            ]
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                            "data-text": r,
                                            className: "position-relative m-auto mb-0 fw-bold text-center",
                                            children: r
                                        })
                                    ]
                                }),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fc12ef00830c07c6$export$2e2bcd8739ae039, {
                                    as: "ul",
                                    className: "mt-2 g-0 align-items-end text-center ps-0 pt-2 list-unstyled ".concat($def56be66887619b$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b),
                                    children: c.slice(0, 3).map(this.renderMedal)
                                })
                            ]
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)($27ad5a1fd7e6d114$export$2e2bcd8739ae039, {
                            xs: 12,
                            sm: 12,
                            lg: 5,
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ae5c70201edf55c0$export$2e2bcd8739ae039, {
                                className: "my-3 pt-2 ".concat($def56be66887619b$var$$7d37db9df1578ff2$export$717db1a952ac2d26),
                                responsive: !0,
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tbody", {
                                    children: c.slice(3, 10).map(this.renderRow)
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ]), t;
}($6mMqj.PureComponent);
Object.defineProperty($def56be66887619b$var$$77dc12b8e0b9d622$export$4ed039229ec81818, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "UserRankView"
});
var $def56be66887619b$var$$42613c749094b4e3$exports = {};
$def56be66887619b$var$$parcel$export($def56be66887619b$var$$42613c749094b4e3$exports, "VerticalMarquee", function() {
    return $def56be66887619b$var$$42613c749094b4e3$export$125576d08e40b98f;
}), $def56be66887619b$var$$c628d4ba96623bb8$export$1a22ace05a045e3f = "QSMqAq_scrollItem", $def56be66887619b$var$$c628d4ba96623bb8$export$c7aa240077ad8340 = "QSMqAq_scrollWrap";
var $def56be66887619b$var$$42613c749094b4e3$var$__rest = function $42613c749094b4e3$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $def56be66887619b$var$$42613c749094b4e3$export$125576d08e40b98f = function $42613c749094b4e3$export$125576d08e40b98f(e) {
    var t = e.className, r = e.children, a = e.duration, c = $def56be66887619b$var$$42613c749094b4e3$var$__rest(e, [
        "className",
        "children",
        "duration"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({
        className: "overflow-hidden ".concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block mw-100 mh-100 ".concat($def56be66887619b$var$$c628d4ba96623bb8$export$c7aa240077ad8340),
            style: {
                "--duration": a
            },
            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                className: "d-inline-block ".concat($def56be66887619b$var$$c628d4ba96623bb8$export$1a22ace05a045e3f),
                children: r
            })
        })
    }));
};
$def56be66887619b$var$$42613c749094b4e3$export$125576d08e40b98f.displayName = "VerticalMarquee", $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$fd019656019bb4f3$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$757747c0209676cc$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$a40a1c3d6dc84a7a$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$89fa9a64cf869995$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$924d73683971f901$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$e308f4ff6755d29b$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$68aab1d0e8e5016c$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$db3d9d99c159855a$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$e400f030e8cea549$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$cf5cdc2ffed4bc45$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$1f7252b8d0187295$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$ec6e3ccd45c7b7c0$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$4f69bf8d62d4bac9$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$a121893c5bead7fc$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$d78fd73e1713e936$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$5d0c8d8af5c3c7e5$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$5c7497f9f3fe6432$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$ad4a2cea628613d5$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$53fa7c21606566cb$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$03c0468daff9422a$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$2f5f9093a9aac8ee$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$31b55198d5058ded$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$f4c02b33c4295ca8$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$77dc12b8e0b9d622$exports), $def56be66887619b$var$$parcel$exportWildcard($def56be66887619b$exports, $def56be66887619b$var$$42613c749094b4e3$exports); //# sourceMappingURL=index.js.map



parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $fsSDT = parcelRequire("fsSDT");


var $6tqvJ = parcelRequire("6tqvJ");

var $1R1LB = parcelRequire("1R1LB");
var $397c81af6d5568dc$var$$ed859e9f463198da$var$HooksWrapper = function(param) {
    var ClassComponent = param.ClassComponent;
    var location = (0, $1R1LB.useLocation)(), params = (0, $1R1LB.useParams)();
    var tmp = location.pathname, pathname = tmp === void 0 ? '/' : tmp, tmp1 = location.search, search = tmp1 === void 0 ? '' : tmp1, tmp2 = location.hash, hash = tmp2 === void 0 ? '' : tmp2;
    var path = pathname + search + hash;
    var match = {
        url: globalThis.location.origin + path,
        path: path,
        params: params
    }, query = (0, $6tqvJ.parseURLData)(search);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)(ClassComponent, {
        location: location,
        match: match,
        query: query
    });
};
var $397c81af6d5568dc$export$369b6b2b30582e8e = function(Class, context) {
    var ComponentWithRouter = /*#__PURE__*/ function(Class1) {
        "use strict";
        (0, $h6w6E._)(ComponentWithRouter, Class1);
        function ComponentWithRouter() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $7lhcp._)(this, ComponentWithRouter);
            var _this;
            _this = (0, $07dqX._)(this, ComponentWithRouter, (0, $fsSDT._)(args)), _this.state = {};
            return _this;
        }
        (0, $8BtP9._)(ComponentWithRouter, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {}
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {}
            },
            {
                key: "shouldComponentUpdate",
                value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
                    return true;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState, snapshot) {}
            },
            {
                key: "componentDidCatch",
                value: function componentDidCatch(error, errorInfo) {}
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {}
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($397c81af6d5568dc$var$$ed859e9f463198da$var$HooksWrapper, {
                        ClassComponent: Class
                    });
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, prevState) {
                    return {};
                }
            },
            {
                key: "getDerivedStateFromError",
                value: function getDerivedStateFromError(error) {}
            }
        ]);
        return ComponentWithRouter;
    }(Class);
    ComponentWithRouter.WrappedComponent = Class;
    ComponentWithRouter.displayName = "withRouter(".concat(Class.displayName || Class.name, ")");
    return ComponentWithRouter;
};



var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");

var $Csf8W = parcelRequire("Csf8W");

var $arNK5 = parcelRequire("arNK5");

var $6tqvJ = parcelRequire("6tqvJ");
function $945120c25ea0130f$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $945120c25ea0130f$var$$c6af500b4433b08b$exports = {};
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$c6af500b4433b08b$exports, "SpeechSynthesisState", function() {
    return $945120c25ea0130f$export$bf098d6e10b5582a;
});
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$c6af500b4433b08b$exports, "SpeechSynthesisModel", function() {
    return $945120c25ea0130f$export$6c5d58455f3ab236;
});
var $945120c25ea0130f$var$$c6af500b4433b08b$var$__runInitializers = function $c6af500b4433b08b$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $945120c25ea0130f$var$$c6af500b4433b08b$var$__esDecorate = function $c6af500b4433b08b$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $945120c25ea0130f$var$$c6af500b4433b08b$var$__awaiter = function $c6af500b4433b08b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $945120c25ea0130f$var$$c6af500b4433b08b$var$__classPrivateFieldGet = function $c6af500b4433b08b$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $945120c25ea0130f$var$$c6af500b4433b08b$var$__classPrivateFieldSet = function $c6af500b4433b08b$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $945120c25ea0130f$export$bf098d6e10b5582a;
(function(SpeechSynthesisState) {
    SpeechSynthesisState[SpeechSynthesisState["Clear"] = 0] = "Clear";
    SpeechSynthesisState[SpeechSynthesisState["Speaking"] = 1] = "Speaking";
    SpeechSynthesisState[SpeechSynthesisState["Pause"] = 2] = "Pause";
})($945120c25ea0130f$export$bf098d6e10b5582a || ($945120c25ea0130f$export$bf098d6e10b5582a = {}));
var $945120c25ea0130f$export$6c5d58455f3ab236 = function() {
    var _a, _SpeechSynthesisModel_disposer, _SpeechSynthesisModel_state_accessor_storage;
    var _instanceExtraInitializers = [];
    var _state_decorators;
    var _state_initializers = [];
    var _state_extraInitializers = [];
    var _get_language_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function SpeechSynthesisModel(i18n) {
            var _this = this;
            (0, $7lhcp._)(this, SpeechSynthesisModel);
            Object.defineProperty(this, "i18n", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($945120c25ea0130f$var$$c6af500b4433b08b$var$__runInitializers(this, _instanceExtraInitializers), i18n)
            });
            _SpeechSynthesisModel_state_accessor_storage.set(this, $945120c25ea0130f$var$$c6af500b4433b08b$var$__runInitializers(this, _state_initializers, $945120c25ea0130f$export$bf098d6e10b5582a.Clear));
            _SpeechSynthesisModel_disposer.set(this, $945120c25ea0130f$var$$c6af500b4433b08b$var$__runInitializers(this, _state_extraInitializers));
            Object.defineProperty(this, "clear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    var _b;
                    _this.state = $945120c25ea0130f$export$bf098d6e10b5582a.Clear;
                    (_b = $945120c25ea0130f$var$$c6af500b4433b08b$var$__classPrivateFieldGet(_this, _SpeechSynthesisModel_disposer, "f")) === null || _b === void 0 || _b.call(_this);
                    speechSynthesis.cancel();
                }
            });
            if (i18n) $945120c25ea0130f$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_disposer, (0, $arNK5.reaction)(function() {
                return i18n.currentLanguage;
            }, this.clear), "f");
            globalThis.addEventListener('unload', this.clear);
        }
        (0, $8BtP9._)(SpeechSynthesisModel, [
            {
                key: "state",
                get: function get() {
                    return $945120c25ea0130f$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_state_accessor_storage, "f");
                },
                set: function set(value) {
                    $945120c25ea0130f$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_state_accessor_storage, value, "f");
                }
            },
            {
                key: "language",
                get: function get() {
                    var _b, _c;
                    return ((_b = this.i18n) === null || _b === void 0 ? void 0 : _b.currentLanguage) || ((_c = globalThis.navigator) === null || _c === void 0 ? void 0 : _c.language);
                }
            },
            {
                key: "speak",
                value: function speak(text) {
                    return $945120c25ea0130f$var$$c6af500b4433b08b$var$__awaiter(this, void 0, void 0, function() {
                        var _this, language, content, voices, result;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, language = _this.language, content = new SpeechSynthesisUtterance(text);
                                    return [
                                        4,
                                        _a.getVoices()
                                    ];
                                case 1:
                                    voices = _state.sent();
                                    content.voice = voices.find(function(param) {
                                        var localService = param.localService, lang = param.lang;
                                        return localService && lang === language;
                                    }) || voices.find(function(param) {
                                        var backup = param.default;
                                        return backup;
                                    });
                                    result = new Promise(function(resolve, reject) {
                                        content.onend = resolve;
                                        content.onerror = reject;
                                    });
                                    speechSynthesis.speak(content);
                                    this.state = $945120c25ea0130f$export$bf098d6e10b5582a.Speaking;
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        ,
                                        4,
                                        5
                                    ]);
                                    return [
                                        4,
                                        result
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    this.clear();
                                    return [
                                        7
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "toggle",
                value: function toggle() {
                    if (this.state === $945120c25ea0130f$export$bf098d6e10b5582a.Speaking) {
                        speechSynthesis.pause();
                        this.state = $945120c25ea0130f$export$bf098d6e10b5582a.Pause;
                    } else {
                        speechSynthesis.resume();
                        this.state = $945120c25ea0130f$export$bf098d6e10b5582a.Speaking;
                    }
                }
            }
        ], [
            {
                key: "getVoices",
                value: function getVoices() {
                    var voices = speechSynthesis.getVoices();
                    return voices[0] ? Promise.resolve(voices) : new Promise(function(resolve) {
                        (0, $6tqvJ.sleep)(1).then(function() {
                            return resolve([]);
                        });
                        speechSynthesis.onvoiceschanged = function() {
                            return resolve(speechSynthesis.getVoices());
                        };
                    });
                }
            },
            {
                key: "walk",
                value: function walk(range) {
                    var commonAncestorContainer, endContainer, walker, current;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                commonAncestorContainer = range.commonAncestorContainer, endContainer = range.endContainer;
                                walker = document.createNodeIterator(commonAncestorContainer);
                                _state.label = 1;
                            case 1:
                                if (!(current = walker.nextNode())) return [
                                    3,
                                    4
                                ];
                                if (!range.intersectsNode(current)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    current
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                if (commonAncestorContainer !== endContainer && current === endContainer) return [
                                    3,
                                    4
                                ];
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }
            },
            {
                key: "getSelectedText",
                value: function getSelectedText(box) {
                    var _b;
                    var range = (_b = getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
                    if (!(range === null || range === void 0 ? void 0 : range.toString()) || !(box === null || box === void 0 ? void 0 : box.contains(range.commonAncestorContainer))) throw new RangeError('No text selected');
                    return (0, $fsSDT._)(this.walk(range)).filter(function(param) {
                        var nodeType = param.nodeType, parentNode = param.parentNode;
                        if (nodeType !== 3) return;
                        var _parentNode_getBoundingClientRect = parentNode.getBoundingClientRect(), width = _parentNode_getBoundingClientRect.width, height = _parentNode_getBoundingClientRect.height;
                        return width && height;
                    }).map(function(param, index, param1) {
                        var nodeValue = param.nodeValue, length = param1.length;
                        return nodeValue.slice(index === 0 ? range.startOffset : 0, index === length - 1 ? range.endOffset : Infinity);
                    }).filter(function(text) {
                        return text.trim();
                    }).join('').trim();
                }
            },
            {
                key: "getReadableText",
                value: function getReadableText(box) {
                    try {
                        return this.getSelectedText(box);
                    } catch (_b) {
                        return (0, $6tqvJ.getVisibleText)(box);
                    }
                }
            }
        ]);
        return SpeechSynthesisModel;
    }(), _SpeechSynthesisModel_disposer = new WeakMap(), _SpeechSynthesisModel_state_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _state_decorators = [
            (0, $arNK5.observable)
        ];
        _get_language_decorators = [
            (0, $arNK5.computed)
        ];
        $945120c25ea0130f$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "state" in obj;
                },
                get: function(obj) {
                    return obj.state;
                },
                set: function(obj, value) {
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $945120c25ea0130f$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _get_language_decorators, {
            kind: "getter",
            name: "language",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "language" in obj;
                },
                get: function(obj) {
                    return obj.language;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $945120c25ea0130f$var$$d1a4b21e19b1b67c$exports = {};
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$d1a4b21e19b1b67c$exports, "TranslationModel", function() {
    return $945120c25ea0130f$export$d91823dfc159395b;
});
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$d1a4b21e19b1b67c$exports, "loadLanguageMap", function() {
    return $945120c25ea0130f$export$745e12634107cb52;
});
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$d1a4b21e19b1b67c$exports, "loadLanguageMapFrom", function() {
    return $945120c25ea0130f$export$b9f85f5ba933b8e7;
});
var $945120c25ea0130f$var$$552a56cc5ff3f479$exports = {};
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$552a56cc5ff3f479$exports, "isNumberLetter", function() {
    return $945120c25ea0130f$export$df0b442c7f8df5c1;
});
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$552a56cc5ff3f479$exports, "textJoin", function() {
    return $945120c25ea0130f$export$d977f7cd0cb45fe1;
});
$945120c25ea0130f$var$$parcel$export($945120c25ea0130f$var$$552a56cc5ff3f479$exports, "parseLanguageHeader", function() {
    return $945120c25ea0130f$export$2557e81a557a81ea;
});
var $945120c25ea0130f$export$df0b442c7f8df5c1 = function() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return new RegExp('\\p{N}', 'u').test(raw) || new RegExp('\\p{Ll}', 'u').test(raw.toLowerCase());
};
var $945120c25ea0130f$export$d977f7cd0cb45fe1 = function() {
    for(var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++){
        parts[_key] = arguments[_key];
    }
    return parts.map(function(raw, index) {
        var _a;
        var isNL = $945120c25ea0130f$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        var diff = isNL !== $945120c25ea0130f$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? ' ' : '');
    }).join('');
};
var $945120c25ea0130f$export$2557e81a557a81ea = function(value) {
    return value.split(',').map(function(language) {
        var _language_split = (0, $leE2g._)(language.split(';'), 2), name = _language_split[0], tmp = _language_split[1], quantity = tmp === void 0 ? '' : tmp;
        var _quantity_split = (0, $leE2g._)(quantity.split('='), 2), _ = _quantity_split[0], tmp1 = _quantity_split[1], _$value = tmp1 === void 0 ? '1' : tmp1;
        return [
            name.trim(),
            +_$value
        ];
    }).sort(function(param, param1) {
        var _param = (0, $leE2g._)(param, 2), _ = _param[0], a = _param[1], _param1 = (0, $leE2g._)(param1, 2), __ = _param1[0], b = _param1[1];
        return b - a;
    }).map(function(param) {
        var _param = (0, $leE2g._)(param, 1), name = _param[0];
        return name;
    });
};
var $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers = function $d1a4b21e19b1b67c$var$__runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__esDecorate = function $d1a4b21e19b1b67c$var$__esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__awaiter = function $d1a4b21e19b1b67c$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet = function $d1a4b21e19b1b67c$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet = function $d1a4b21e19b1b67c$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $945120c25ea0130f$export$d91823dfc159395b = function() {
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    var _instanceExtraInitializers = [];
    var _loading_decorators;
    var _loading_initializers = [];
    var _loading_extraInitializers = [];
    var _currentLanguage_decorators;
    var _currentLanguage_initializers = [];
    var _currentLanguage_extraInitializers = [];
    var _currentMap_decorators;
    var _currentMap_initializers = [];
    var _currentMap_extraInitializers = [];
    var _get_defaultMap_decorators;
    var _loadLanguages_decorators;
    return _a = /*#__PURE__*/ function() {
        "use strict";
        function TranslationModel(configuration) {
            var _this = this;
            (0, $7lhcp._)(this, TranslationModel);
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_extraInitializers)
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_initializers, ''));
            _TranslationModel_currentMap_accessor_storage.set(this, ($945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_extraInitializers), $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_initializers, {})));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_extraInitializers), this.textOf.bind(this))
            });
            for(var name in configuration)if (typeof configuration[name] !== 'function') this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError('One static language map is required');
            if (!globalThis.window) return;
            var languages = [
                (0, $6tqvJ.parseCookie)().language
            ].concat((0, $fsSDT._)(navigator.languages || [
                this.defaultLanguage
            ]), [
                document.documentElement.lang
            ]).filter(Boolean);
            this.loadLanguages.apply(this, (0, $fsSDT._)(languages));
            window.addEventListener('languagechange', function() {
                return _this.loadLanguages(navigator.language);
            });
        }
        (0, $8BtP9._)(TranslationModel, [
            {
                key: "loading",
                get: function get() {
                    return $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
                },
                set: function set(value) {
                    $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
                }
            },
            {
                key: "currentLanguage",
                get: function get() {
                    return $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
                },
                set: function set(value) {
                    $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
                }
            },
            {
                key: "currentMap",
                get: function get() {
                    return $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
                },
                set: function set(value) {
                    $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
                }
            },
            {
                key: "defaultMap",
                get: function get() {
                    return this.configuration[this.defaultLanguage];
                }
            },
            {
                key: "onLanguageChange",
                value: function onLanguageChange(handler) {
                    var _this = this;
                    (0, $arNK5.reaction)(function() {
                        return _this.currentLanguage;
                    }, function(currentLanguage, lastLanguage) {
                        if (lastLanguage) handler.call(_this, currentLanguage);
                    });
                }
            },
            {
                key: "setLanguage",
                value: function setLanguage(name) {
                    var _b;
                    this.currentLanguage = name;
                    if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) (0, $6tqvJ.setCookie)('language', document.documentElement.lang = name, {
                        path: '/'
                    });
                }
            },
            {
                key: "loadLanguages",
                value: function loadLanguages() {
                    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
                        names[_key] = arguments[_key];
                    }
                    return $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function() {
                        var _ref, tmp, language, tmp1, languageMap;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    this.loading = true;
                                    return [
                                        4,
                                        $945120c25ea0130f$export$745e12634107cb52(this.configuration, names)
                                    ];
                                case 1:
                                    _ref = _state.sent() || {}, tmp = _ref.language, language = tmp === void 0 ? this.defaultLanguage : tmp, tmp1 = _ref.languageMap, languageMap = tmp1 === void 0 ? this.configuration[this.defaultLanguage] : tmp1;
                                    this.loading = false;
                                    this.setLanguage(language);
                                    return [
                                        2,
                                        this.currentMap = languageMap
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "textOf",
                value: function textOf(key, data) {
                    var value = this.currentMap[key] || this.defaultMap[key];
                    if (typeof value !== 'function') return value;
                    if (!data) throw ReferenceError('Input data is required for Translation Resolver');
                    return value(data);
                }
            }
        ]);
        return TranslationModel;
    }(), _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), function() {
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $arNK5.observable)
        ];
        _currentLanguage_decorators = [
            (0, $arNK5.observable)
        ];
        _currentMap_decorators = [
            (0, $arNK5.observable)
        ];
        _get_defaultMap_decorators = [
            (0, $arNK5.computed)
        ];
        _loadLanguages_decorators = [
            (0, $arNK5.action)
        ];
        $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "loading" in obj;
                },
                get: function(obj) {
                    return obj.loading;
                },
                set: function(obj, value) {
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentLanguage" in obj;
                },
                get: function(obj) {
                    return obj.currentLanguage;
                },
                set: function(obj, value) {
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
        $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentMap" in obj;
                },
                get: function(obj) {
                    return obj.currentMap;
                },
                set: function(obj, value) {
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _currentMap_extraInitializers);
        $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "defaultMap" in obj;
                },
                get: function(obj) {
                    return obj.defaultMap;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loadLanguages_decorators, {
            kind: "method",
            name: "loadLanguages",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "loadLanguages" in obj;
                },
                get: function(obj) {
                    return obj.loadLanguages;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $945120c25ea0130f$export$745e12634107cb52 = function(configuration, names) {
    return $945120c25ea0130f$var$$d1a4b21e19b1b67c$var$__awaiter(void 0, void 0, void 0, function() {
        var languages, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, err;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    languages = Object.keys(configuration).sort(function(param, param1) {
                        var a = param.length, b = param1.length;
                        return b - a;
                    });
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _loop = function() {
                        var name, language, languageMap, _ref, data, _a;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    name = _step.value;
                                    language = languages.includes(name) ? name : languages.find(function(language) {
                                        return name.startsWith(language) || language.startsWith(name);
                                    });
                                    if (!language) return [
                                        2,
                                        "continue"
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    languageMap = configuration[language];
                                    if (typeof languageMap !== 'function') return [
                                        2,
                                        {
                                            v: {
                                                language: language,
                                                languageMap: languageMap
                                            }
                                        }
                                    ];
                                    return [
                                        4,
                                        languageMap()
                                    ];
                                case 2:
                                    _ref = _state.sent(), data = _ref.default;
                                    configuration[language] = data;
                                    return [
                                        2,
                                        {
                                            v: {
                                                language: language,
                                                languageMap: data
                                            }
                                        }
                                    ];
                                case 3:
                                    _a = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = names[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    return [
                        5,
                        (0, $Csf8W.__values)(_loop())
                    ];
                case 3:
                    _ret = _state.sent();
                    if ((0, $5f0Cq._)(_ret) === "object") return [
                        2,
                        _ret.v
                    ];
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
};
var $945120c25ea0130f$export$b9f85f5ba933b8e7 = function(configuration, param) {
    var acceptLanguage = param['accept-language'], cookie = param.cookie;
    var _$42h8L$parseCookie = (0, $6tqvJ.parseCookie)(cookie || ''), language = _$42h8L$parseCookie.language, languages = $945120c25ea0130f$export$2557e81a557a81ea(acceptLanguage || '');
    return $945120c25ea0130f$export$745e12634107cb52(configuration, [
        language
    ].concat((0, $fsSDT._)(languages)).filter(Boolean));
};


var $4f4598c544ae7941$export$2e2bcd8739ae039 = {
    welcome: "\u6B22\u8FCE",
    upstream_projects: "\u4E0A\u6E38\u9879\u76EE",
    home_page: "\u4E3B\u9875",
    console: "\u63A7\u5236\u53F0",
    source_code: "\u6E90\u4EE3\u7801",
    component: "\u7EC4\u4EF6",
    pagination: "\u5206\u9875",
    chart: "\u56FE\u8868",
    downloader: "\u4E0B\u8F7D\u5668",
    powered_by: "\u5F3A\u529B\u9A71\u52A8\u81EA",
    documentation: "\u6587\u6863",
    learn: "\u5B66\u4E60",
    examples: "\u793A\u4F8B",
    deploy: "\u90E8\u7F72",
    // REST table
    create: "\u65B0\u589E",
    submit: "\u63D0\u4EA4",
    cancel: "\u53D6\u6D88",
    view: "\u67E5\u770B",
    edit: "\u7F16\u8F91",
    delete: "\u5220\u9664",
    total_x_rows: function(param) {
        var totalCount = param.totalCount;
        return "\u5171 ".concat(totalCount, " \u884C");
    },
    sure_to_delete_x: function(param) {
        var keys = param.keys;
        return "\u60A8\u786E\u5B9A\u5220\u9664 ".concat(keys.join("\u3001"), " \u5417\uFF1F");
    },
    repository_name: "\u4ED3\u5E93\u540D",
    programming_language: "\u7F16\u7A0B\u8BED\u8A00",
    topic: "\u8BDD\u9898",
    star_count: "\u661F\u6807\u6570",
    // Scroll List
    scroll_list: "\u6EDA\u52A8\u5217\u8868",
    load_more: "\u52A0\u8F7D\u66F4\u591A\u2026\u2026",
    no_more: "\u6CA1\u6709\u66F4\u591A",
    // Login
    user_login: "\u7528\u6237\u767B\u5F55",
    enter_login_info: "\u8BF7\u8F93\u5165\u60A8\u7684\u767B\u5F55\u51ED\u636E",
    username: "\u7528\u6237\u540D",
    enter_username: "\u8BF7\u8F93\u5165\u7528\u6237\u540D",
    password: "\u5BC6\u7801",
    enter_password: "\u8BF7\u8F93\u5165\u5BC6\u7801",
    remember_login: "\u8BB0\u4F4F\u767B\u5F55\u72B6\u6001",
    login_now: "\u7ACB\u5373\u767B\u5F55",
    ai_work_order: "AI\u5355\u738B",
    work_order_ai_assistant: "\u8425\u670D\u5DE5\u5355AI\u667A\u80FD\u52A9\u624B",
    system_normal: "\u7CFB\u7EDF\u6B63\u5E38",
    network_normal: "\u7F51\u7EDC\u8FDE\u63A5\u6B63\u5E38",
    copyright_info: "\xa9 2025 AI\u5355\u738B \u7248\u672C 1.0.0",
    // Category page
    category_system: "\u5206\u7C7B\u4F53\u7CFB\u7BA1\u7406",
    ai_auto_classify: "AI \u81EA\u52A8\u5206\u7C7B",
    new_category: "\u65B0\u589E\u5206\u7C7B",
    business_type: "\u4E1A\u52A1\u7C7B\u578B",
    level1_category: "\u4E00\u7EA7\u7C7B\u522B",
    level2_category: "\u4E8C\u7EA7\u7C7B\u522B",
    level3_category: "\u4E09\u7EA7\u7C7B\u522B",
    level3_detail: "\u4E09\u7EA7\u7C7B\u522B\u7EC6\u5206\u9879",
    remark: "\u5907\u6CE8",
    order_count: "\u5DE5\u5355\u6570\u91CF",
    department: "\u90E8\u95E8",
    specialist_office: "\u4E13\u4E1A\u5904\u5BA4",
    sort_order: "\u6392\u5E8F",
    search_category: "\u641C\u7D22\u5206\u7C7B...",
    enter_text: "\u8BF7\u8F93\u5165",
    enter_sort_hint: "\u8BF7\u8F93\u5165\u6392\u5E8F\uFF0C\u6570\u5B57\u5C0F\u7684\u6392\u5728\u6700\u524D\u9762",
    confirm: "\u786E\u5B9A",
    ai_classifying: "\u5149\u660E\u7535\u529B\u5927\u6A21\u578B - \u81EA\u52A8\u5206\u7C7B\u8FDB\u884C\u4E2D",
    analyzing_data: "\u6B63\u5728\u5206\u6790\u5386\u53F2\u5DE5\u5355\u6570\u636E\uFF0C\u8BC6\u522B\u65B0\u7684\u5DE5\u5355\u7C7B\u522B\u548C\u6A21\u5F0F\u3002\u8FD9\u4E2A\u8FC7\u7A0B\u53EF\u80FD\u9700\u8981\u51E0\u5206\u949F\u65F6\u95F4\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u3002",
    analyzing_orders: "\u6B63\u5728\u5206\u6790\u5DE5\u5355\u6570\u636E",
    new_category_suggestions: "\u53D1\u73B0\u65B0\u7684\u5206\u7C7B\u5EFA\u8BAE",
    last_update_time: "\u4E0A\u6B21\u66F4\u65B0\u65F6\u95F4",
    reject: "\u62D2\u7EDD",
    accept: "\u91C7\u7EB3",
    close: "\u5173\u95ED",
    confirm_update: "\u786E\u8BA4\u66F4\u65B0",
    matching_orders: "\u5339\u914D\u5DE5\u5355\u6570\uFF1A",
    confidence: "\u7F6E\u4FE1\u5EA6\uFF1A",
    new_category_tag: "\u65B0\u7C7B\u522B",
    // Work Order Management
    work_order_management: "\u5DE5\u5355\u7BA1\u7406",
    order_id: "ID\u53F7",
    order_number: "\u5DE5\u5355\u7F16\u53F7",
    order_type: "\u5DE5\u5355\u5C5E\u6027",
    category: "\u5206\u7C7B\u5C5E\u6027",
    acceptance_time: "\u53D7\u7406\u65F6\u95F4",
    acceptance_content: "\u53D7\u7406\u5185\u5BB9",
    processing_status: "\u5904\u7406\u60C5\u51B5",
    processing_result: "\u5904\u7406\u7ED3\u679C",
    satisfaction_level: "AI\u5316\u4F18\u5316",
    ai_optimization_reason: "\u5206\u7C7B\u4F18\u5316",
    upload_time: "\u4E0A\u4F20\u65F6\u95F4",
    operation: "\u64CD\u4F5C",
    normal_order: "\u67E5\u770B\u5DE5\u5355",
    duplicate_order: "\u91CD\u590D\u5DE5\u5355",
    sensitive_order: "\u654F\u611F\u5DE5\u5355",
    responsible_order: "\u6709\u8D23\u5DE5\u5355",
    satisfied: "\u6EE1\u610F",
    basic: "\u57FA\u672C\u6EE1\u610F",
    unsatisfied: "\u4E0D\u6EE1\u610F",
    time_period: "\u5DE5\u5355\u65F6\u95F4\u6BB5",
    search_order_number: "\u8BF7\u8F93\u5165\u5DE5\u5355\u7F16\u53F7\u8FDB\u884C\u641C\u7D22",
    category_filter: "\u8BF7\u9009\u62E9\u5206\u7C7B",
    screening: "\u7B5B\u9009",
    internal_search: "\u5185\u5BB9\u641C\u7D22",
    search_keywords: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22\u53D7\u7406\u5185\u5BB9\u3001\u5904\u7406\u60C5\u51B5",
    // Classification Task Management
    classification_task_list: "\u5DE5\u5355\u5206\u7C7B\u4F18\u5316\u4EFB\u52A1\u5217\u8868",
    classification_task_management: "\u5206\u7C7B\u4F18\u5316\u4EFB\u52A1\u7BA1\u7406",
    task_id: "\u4EFB\u52A1ID",
    task_name: "\u4EFB\u52A1\u540D\u79F0",
    ai_capabilities: "AI\u80FD\u529B",
    task_status: "\u4EFB\u52A1\u72B6\u6001",
    total_work_orders: "\u5DE5\u5355\u603B\u6570",
    processed_work_orders: "\u5DF2\u5904\u7406\u5DE5\u5355",
    started_at: "\u5F00\u59CB\u65F6\u95F4",
    ended_at: "\u7ED3\u675F\u65F6\u95F4",
    created_at: "\u521B\u5EFA\u65F6\u95F4",
    updated_at: "\u66F4\u65B0\u65F6\u95F4",
    completed_at: "\u5B8C\u6210\u65F6\u95F4",
    actions: "\u64CD\u4F5C",
    view_details: "\u67E5\u770B\u8BE6\u60C5",
    create_task: "\u65B0\u589E\u4EFB\u52A1",
    edit_task: "\u7F16\u8F91\u4EFB\u52A1",
    task_details: "\u4EFB\u52A1\u8BE6\u60C5",
    category_information: "\u5206\u7C7B\u4FE1\u606F",
    remarks: "\u5907\u6CE8",
    task_pending: "\u5F85\u5904\u7406",
    task_in_progress: "\u8FDB\u884C\u4E2D",
    task_completed: "\u5DF2\u5B8C\u6210",
    task_rejected: "\u5DF2\u62D2\u7EDD",
    enter_task_name: "\u8BF7\u8F93\u5165\u4EFB\u52A1\u540D\u79F0",
    enter_work_order_number: "\u8BF7\u8F93\u5165\u5DE5\u5355\u7F16\u53F7",
    enter_original_category: "\u8BF7\u8F93\u5165\u539F\u5206\u7C7B",
    enter_suggested_category: "\u8BF7\u8F93\u5165\u5EFA\u8BAE\u5206\u7C7B",
    enter_optimization_reason: "\u8BF7\u8F93\u5165\u4F18\u5316\u7406\u7531",
    enter_assignee: "\u8BF7\u8F93\u5165\u5206\u914D\u4EBA",
    enter_remarks: "\u8BF7\u8F93\u5165\u5907\u6CE8",
    saving: "\u4FDD\u5B58\u4E2D...",
    update: "\u66F4\u65B0",
    back_to_list: "\u8FD4\u56DE\u5217\u8868",
    confirm_delete_task: "\u786E\u5B9A\u8981\u5220\u9664\u8FD9\u4E2A\u4EFB\u52A1\u5417\uFF1F",
    task_not_found: "\u4EFB\u52A1\u672A\u627E\u5230",
    loading: "\u52A0\u8F7D\u4E2D...",
    // Document Knowledge Base
    document_knowledge_base: "\u6587\u6863\u77E5\u8BC6\u5E93",
    document_list: "\u6587\u6863\u5217\u8868",
    upload_document: "\u4E0A\u4F20\u6587\u6863",
    document_name: "\u6587\u6863\u540D\u79F0",
    file_type: "\u6587\u4EF6\u7C7B\u578B",
    file_size: "\u6587\u4EF6\u5927\u5C0F",
    status: "\u72B6\u6001",
    processing: "\u5904\u7406\u4E2D",
    completed: "\u5DF2\u5B8C\u6210",
    failed: "\u5931\u8D25",
    select_files: "\u9009\u62E9\u6587\u4EF6",
    drag_files_here: "\u62D6\u62FD\u6587\u4EF6\u5230\u6B64\u5904",
    or: "\u6216",
    click_to_select: "\u70B9\u51FB\u9009\u62E9\u6587\u4EF6",
    selected_files: "\u5DF2\u9009\u62E9\u6587\u4EF6",
    file_info: "\u6587\u4EF6\u4FE1\u606F",
    description: "\u63CF\u8FF0",
    please_input: "\u8BF7\u8F93\u5165",
    next_step: "\u4E0B\u4E00\u6B65",
    previous_step: "\u4E0A\u4E00\u6B65",
    // Dashboard
    welcome_back: "\u6B22\u8FCE\u56DE\u6765",
    all_branches: "\u5168\u90E8\u5206\u516C\u53F8",
    all_power_stations: "\u5168\u90E8\u4F9B\u7535\u6240",
    total_orders: "\u5DE5\u5355\u603B\u6570",
    basic_orders: "\u57FA\u7840\u5DE5\u5355",
    sensitive_orders: "\u654F\u611F\u5DE5\u5355",
    responsible_orders: "\u6709\u8D23\u5DE5\u5355",
    generated_supervision: "\u5DF2\u751F\u6210\u7763\u529E\u5355",
    resolved_orders: "\u5DF2\u5316\u89E3\u5DE5\u5355\u6570",
    order_data_7days: "\u5DE5\u5355\u6570\u636E\uFF08\u8FD17\u65E5\uFF09",
    new_orders: "\u65B0\u589E\u5DE5\u5355",
    duplicate_orders: "\u91CD\u590D\u5DE5\u5355",
    business_type_distribution: "\u5DE5\u5355\u4E1A\u52A1\u7C7B\u578B\u5360\u6BD4\uFF08\u5168\u90E8\uFF09",
    problem_category_distribution: "\u95EE\u9898\u5DE5\u5355\u7C7B\u522B\u5360\u6BD4\uFF08\u5168\u90E8\uFF09",
    current_tasks: "\u5F53\u524D\u4EFB\u52A1",
    work_order_classification: "\u5DE5\u5355\u5206\u7C7B",
    view_more: "\u67E5\u770B\u66F4\u591A",
    rank: "\u6392\u540D",
    task_serial_number: "\u5E8F\u53F7",
    current_status: "\u5F53\u524D\u72B6\u6001",
    abnormal: "\u5F02\u5E38",
    // Document Upload Steps
    upload_text_file: "\u4E0A\u4F20\u6587\u672C\u6587\u4EF6",
    drag_or_select: "\u62D6\u62FD\u6587\u4EF6\u6216\u6587\u4EF6\u5939\u81F3\u6B64\uFF0C\u6216\u8005",
    select_file: "\u9009\u62E9\u6587\u4EF6",
    supported_formats: "\u5DF2\u652F\u6301",
    max_files_hint: "\u6BCF\u6279\u6700\u591A",
    files_unit: "\u4E2A\u6587\u4EF6",
    max_size_hint: "\u6BCF\u4E2A\u6587\u4EF6\u4E0D\u8D85\u8FC7",
    file_exceeds_limit: function(param) {
        var name = param.name;
        return "\u6587\u4EF6 ".concat(name, " \u8D85\u8FC7 512 MB \u9650\u5236");
    },
    preview: "\u9884\u89C8",
    chunks_unit: "\u4E2A\u5757",
    document_uploaded: "\u6587\u6863\u5DF2\u4E0A\u4F20",
    upload_to_kb_hint: "\u6587\u6863\u5DF2\u4E0A\u4F20\u81F3\u77E5\u8BC6\u5E93\uFF1A\u4F9B\u7535\u65B9\u6848-\u6848\u4F8B\uFF0C\u4F60\u53EF\u4EE5\u5728\u77E5\u8BC6\u5E93\u7684\u6587\u6863\u5217\u8868\u4E2D\u627E\u5230\u5B83\u3002",
    embedding_processing: "\u5D4C\u5165\u5904\u7406\u4E2D...",
    chunking_mode: "\u5206\u6BB5\u6A21\u5F0F",
    custom: "\u81EA\u5B9A\u4E49",
    max_chunk_length: "\u6700\u5927\u5206\u6BB5\u957F\u5EA6",
    text_preprocessing: "\u6587\u672C\u9884\u5904\u7406\u89C4\u5219",
    replace_whitespace: "\u66FF\u6362\u6389\u8FDE\u7EED\u7684\u7A7A\u683C\u3001\u6362\u884C\u7B26\u548C\u5236\u8868\u7B26",
    index_method: "\u7D22\u5F15\u65B9\u5F0F",
    high_quality: "\u9AD8\u8D28\u91CF",
    retrieval_settings: "\u68C0\u7D22\u8BBE\u7F6E",
    hybrid_search: "\u6DF7\u5408\u68C0\u7D22",
    complete: "\u5B8C\u6210",
    select_data_source: "\u9009\u62E9\u6570\u636E\u6E90",
    text_chunking_cleaning: "\u6587\u672C\u5206\u6BB5\u4E0E\u6E05\u6D17",
    process_complete: "\u5904\u7406\u5E76\u5B8C\u6210",
    // Deduplication Task Pages
    create_extraction_task: "\u521B\u5EFA\u63D0\u53D6\u4EFB\u52A1",
    duplicate_work_order_extraction: "\u91CD\u590D\u5DE5\u5355\u667A\u80FD\u63D0\u53D6",
    deduplication_task_list: "\u91CD\u590D\u5DE5\u5355\u4EFB\u52A1\u5217\u8868",
    rule_knowledge_base: "\u89C4\u5219\u77E5\u8BC6\u5E93",
    task_time: "\u4EFB\u52A1\u65F6\u95F4",
    enter_task_name_search: "\u8BF7\u8F93\u5165\u4EFB\u52A1\u540D\u79F0\u8FDB\u884C\u641C\u7D22",
    search: "\u641C\u7D22",
    all: "\u5168\u90E8",
    in_progress: "\u8FDB\u884C\u4E2D",
    deduplication_result: "\u91CD\u590D\u5DE5\u5355\u5206\u6790\u7ED3\u679C",
    deduplication_task_detail: "\u91CD\u590D\u5DE5\u5355\u4EFB\u52A1\u8BE6\u60C5",
    task_steps: "\u4EFB\u52A1\u6B65\u9AA4",
    real_time_logs: "\u5B9E\u65F6\u65E5\u5FD7",
    data_preprocessing: "\u6570\u636E\u9884\u5904\u7406",
    reading_classification_workorders: function(param) {
        var task = param.task;
        return "\u8BFB\u53D6\u5DE5\u5355\u5206\u7C7B\u4EFB\u52A1\u7B2C ".concat(task, " \u4E2A\u5DE5\u5355");
    },
    analyzing_workorders: "\u6B63\u5728\u5206\u6790\u5DE5\u5355",
    // Optimization Task Creator
    create_optimization_task: "\u521B\u5EFA\u4F18\u5316\u4EFB\u52A1",
    upload_work_order_file: "\u4E0A\u4F20\u5DE5\u5355\u6587\u4EF6",
    historical_data: "\u5386\u53F2\u6570\u636E",
    support_excel_format: "\u652F\u6301 Excel \u683C\u5F0F\u6587\u4EF6",
    max_size_10mb: "\u6700\u5927 10MB",
    or_drag_file_here: "\u6216\u62D6\u62FD\u6587\u4EF6\u81F3\u6B64",
    uploading: "\u6B63\u5728\u4E0A\u4F20",
    format_validation: "\u6587\u4EF6\u683C\u5F0F\u6821\u5BF9",
    file_format_not_correct: "\u6587\u4EF6\u683C\u5F0F\u4E0D\u6B63\u786E",
    error_label: "\u9519\u8BEF",
    column_missing: "\u5217\u7F3A\u5931",
    wrong_file_type: "\u6587\u4EF6\u7C7B\u578B\u9519\u8BEF",
    word_vs_expected_format: "\u5B57\u6BB5\u4E0E\u9884\u671F\u683C\u5F0F",
    check_file_not_correct: "\u68C0\u67E5\u6587\u4EF6\u4E0D\u6B63\u786E",
    work_order_count: "\u5DE5\u5355\u6570\u91CF",
    uploaded_orders: "\u5DF2\u4E0A\u4F20\u5DE5\u5355",
    orders_excluded: "\u5DF2\u6392\u9664/\u603B\u5DE5\u5355",
    reselect_file: "\u91CD\u65B0\u9009\u62E9\u6587\u4EF6",
    ai_analysis_capabilities: "AI \u5206\u6790\u529F\u80FD",
    work_order_classification_optimization: "\u5DE5\u5355\u5206\u7C7B\u667A\u80FD\u4F18\u5316",
    create_sensitive_task: "\u65B0\u589E\u654F\u611F\u4EFB\u52A1",
    create_responsible_task: "\u65B0\u589E\u6709\u8D23\u4EFB\u52A1",
    report_analysis_center: "\u62A5\u8868\u5206\u6790\u4E2D\u5FC3",
    report_template_management: "\u62A5\u8868\u6A21\u677F\u7BA1\u7406",
    report_template_library: "\u62A5\u8868\u6A21\u677F\u5E93",
    weekly_report_template: "\u5468\u62A5\u6A21\u677F",
    monthly_report_template: "\u6708\u62A5\u6A21\u677F",
    quarterly_report_template: "\u5B63\u62A5\u6A21\u677F",
    weekly_report_description: "\u4F9B\u7535\u670D\u52A1\u91CD\u70B9\u95EE\u9898\u901A\u62A5",
    monthly_report_description: "\u4F18\u8D28\u670D\u52A1\u8FD0\u8425\u5468\u62A5",
    quarterly_report_description: "\u4F9B\u7535\u670D\u52A1\u91CD\u70B9\u95EE\u9898\u901A\u62A5",
    chars_unit: "\u5B57\u7B26",
    related_data_unit: "\u5173\u8054\u6570\u636E",
    auto_identify_work_orders: "\u81EA\u52A8\u8BC6\u522B\u5DE5\u5355\u7C7B\u522B\uFF0C\u63D0\u5347\u5206\u7C7B\u6548\u7387",
    identify_duplicate_records: "\u8BC6\u522B\u91CD\u590D\u5DE5\u5355\u8BB0\u5F55\uFF0C\u907F\u514D\u91CD\u590D\u5904\u7406",
    sensitive_work_order_extraction: "\u654F\u611F\u5DE5\u5355\u667A\u80FD\u63D0\u53D6",
    auto_detect_sensitive_data: "\u81EA\u52A8\u68C0\u6D4B\u654F\u611F\u4FE1\u606F\uFF0C\u52A0\u5F3A\u6570\u636E\u5B89\u5168",
    employee_work_order_audit: "\u6709\u5458\u5DE5\u5DE5\u5355\u5BA1\u8BA1",
    analyze_employee_handling: "\u5206\u6790\u5458\u5DE5\u5DE5\u5355\u5904\u7406\u60C5\u51B5\uFF0C\u63D0\u5347\u7BA1\u7406\u6548\u7387",
    start_now: "\u7ACB\u5373\u4E0A\u7EBF",
    file_exceeds_max_size: function(param) {
        var size = param.size;
        return "\u6587\u4EF6\u8D85\u8FC7\u6700\u5927\u9650\u5236 ".concat(size);
    },
    original_category: "\u539F\u5206\u7C7B",
    change_reason: "\u53D8\u66F4\u539F\u56E0",
    duplicate_workorder_analysis: "\u91CD\u590D\u5DE5\u5355\u5206\u6790",
    duplicate_workorder_found: function(param) {
        var count = param.count;
        return "\u53D1\u73B0 ".concat(count, " \u4E2A\u91CD\u590D\u5DE5\u5355");
    },
    in_analysis: "\u5206\u6790\u4E2D",
    analysis_progress: function(param) {
        var percent = param.percent, count = param.count;
        return "\u5206\u6790\u8FDB\u5EA6\uFF1A".concat(percent, "%\uFF0C\u53D1\u73B0 ").concat(count, " \u4E2A\u91CD\u590D\u5DE5\u5355");
    },
    id_number: "ID\u53F7",
    work_order_id: "\u5DE5\u5355\u7F16\u53F7",
    duplicate_type: "\u91CD\u590D\u7C7B\u578B",
    classification_result: "\u5206\u7C7B\u7ED3\u679C",
    corresponding_workorder: "\u5BF9\u5E94\u5DE5\u5355\u53F7",
    reason_for_duplication: "\u91CD\u590D\u539F\u56E0",
    processing_time: "\u5904\u7406\u65F6\u95F4",
    details: "\u8BE6\u60C5",
    pending: "\u5F85\u5904\u7406",
    processed: "\u5DF2\u5904\u7406",
    no_change: "\u65E0\u9700\u53D8\u66F4",
    manual_review: "\u4EBA\u5DE5\u5BA1\u6838",
    similarity: "\u76F8\u4F3C\u5EA6",
    // Sensitive and Responsible work order fields
    sensitive_type: "\u654F\u611F\u7C7B\u578B",
    ai_extraction_reason: "AI\u63D0\u53D6\u539F\u56E0",
    unit_name: "\u5355\u4F4D\u540D\u79F0",
    power_supply_office: "\u4F9B\u7535\u6240",
    area_manager: "\u7247\u533A\u7ECF\u7406",
    violation_issue: "\u8FDD\u7AE0\u95EE\u9898",
    rectification_requirement: "\u6574\u6539\u8981\u6C42",
    referenced_policy: "\u5F15\u7528\u4F9D\u636E",
    // Additional task page translations
    start_time: "\u5F00\u59CB\u65F6\u95F4",
    current_stage: "\u5F53\u524D\u9636\u6BB5",
    estimated_remaining: "\u9884\u8BA1\u5269\u4F59",
    please_select_classification_result: "\u8BF7\u5148\u9009\u62E9\u5DE5\u5355\u5206\u7C7B\u7ED3\u679C",
    select_classification_task_hint: "\uFF08\u8BF7\u9009\u62E9\u5206\u7C7B\u4EFB\u52A1\u540E\uFF0C\u5F00\u59CB\u5BF9\u6307\u5B9A\u5206\u7C7B\u4EFB\u52A1\u4E0B\u7684\u5DE5\u5355\u8FDB\u884C",
    analysis_suffix: "\u5206\u6790\uFF09",
    estimated_analysis_time_15_30: "\u9884\u8BA1\u5206\u6790\u8017\u65F6\uFF1A15~30\u5206\u949F",
    start_analysis_button: "\u5F00\u59CB\u5206\u6790",
    export_file: "\u5BFC\u51FA\u6587\u4EF6",
    // Supervision Order Management
    supervision_order_management: "\u7763\u529E\u5DE5\u5355\u667A\u80FD\u63D0\u53D6",
    supervision_order_list: "\u7763\u529E\u5355\u5217\u8868",
    supervision_order_intelligent_generation: "\u7763\u529E\u5355\u667A\u80FD\u751F\u6210",
    create_supervision_task: "\u521B\u5EFA\u63D0\u53D6\u4EFB\u52A1",
    supervision_task_list: "\u7763\u529E\u5DE5\u5355\u4EFB\u52A1\u5217\u8868",
    pending_supervision_orders: "\u5F85\u7763\u529E\u5DE5\u5355",
    supervision_status: "\u7763\u529E\u72B6\u6001",
    supervision_type: "\u7763\u529E\u7C7B\u578B",
    problem_description: "\u95EE\u9898\u63CF\u8FF0",
    create_supervision_order: "\u751F\u6210\u7763\u529E\u5355",
    new_supervision_order: "\u65B0\u5EFA\u7763\u529E\u5355",
    work_order_original_info: "\u5DE5\u5355\u539F\u59CB\u4FE1\u606F",
    primary_category: "\u4E00\u7EA7\u7C7B\u578B",
    secondary_category: "\u4E8C\u7EA7\u7C7B\u578B",
    tertiary_category: "\u4E09\u7EA7\u7C7B\u578B",
    order_completion_time: "\u5DE5\u5355\u4E0B\u53D1\u65F6\u95F4",
    return_timestamp: "\u5F52\u6863\u65F6\u95F4",
    processing_situation: "\u5904\u7406\u60C5\u51B5",
    problem_extraction_info: "\u95EE\u9898\u63D0\u53D6\u4FE1\u606F",
    problem_category: "\u95EE\u9898\u7C7B\u578B",
    warning_level: "\u9884\u8B66\u7B49\u7EA7",
    red_warning: "\u7EA2\u8272\u9884\u8B66",
    trigger_keywords: "\u89E6\u53D1\u5173\u952E\u8BCD",
    trigger_count: "\u89E6\u53D1\u6B21\u6570",
    supervision_order_creation_info: "\u7763\u529E\u5355\u751F\u6210\u4FE1\u606F",
    supervisor: "\u7763\u529E\u4EBA",
    responsible_department: "\u8D23\u4EFB\u90E8\u95E8",
    receiver: "\u63A5\u6536\u4EBA",
    supervision_template: "\u7763\u529E\u5355\u6A21\u677F",
    supervision_template_1: "\u7763\u529E\u5355\u6A21\u72481",
    confirm_create: "\u786E\u5B9A\u751F\u6210",
    all_statuses: "\u5168\u90E8",
    pending_supervision: "\u5F85\u7763\u529E",
    supervising: "\u7763\u529E\u4E2D",
    supervision_completed: "\u5DF2\u7763\u529E",
    order_time: "\u5DE5\u5355\u65F6\u95F4",
    select_date: "\u5E74/\u6708/\u65E5",
    filter: "\u7B5B\u9009",
    export_all: "\u5168\u90E8",
    duplicate_discovery: "\u91CD\u590D\u81F4\u7535",
    cancelled_orders: "\u654F\u611F\u5DE5\u5355",
    listed_orders: "\u8FDD\u89C4\u5DE5\u5355",
    complaint: "\u6295\u8BC9",
    poor_attitude: "\u6001\u5EA6\u4E0D\u597D",
    // Sensitive Rule List Page
    sensitive_rule_list: "\u654F\u611F\u5DE5\u5355\u667A\u80FD\u63D0\u53D6",
    add_rule: "\u6DFB\u52A0\u89C4\u5219",
    batch_delete: "\u6279\u91CF\u5220\u9664",
    vocabulary_name: "\u8BCD\u6C47\u540D\u79F0",
    vocabulary_description: "\u8BCD\u6C47\u63CF\u8FF0",
    rule_type: "\u89C4\u5219\u7C7B\u578B",
    triggered_work_order_count: "\u89E6\u53D1\u5DE5\u5355\u6570",
    work_order_chain: "\u5DE5\u5355\u94FE",
    keyword_semantic: "\u5173\u952E\u8BCD\u8BED\u4E49",
    level_1_warning: "\u4E00\u7EA7\u9884\u8B66",
    level_2_warning: "\u4E8C\u7EA7\u9884\u8B66",
    level_3_warning: "\u4E09\u7EA7\u9884\u8B66",
    search_classification: "\u641C\u7D22\u5206\u7C7B...",
    sensitive_task_list: "\u654F\u611F\u5DE5\u5355\u4EFB\u52A1\u5217\u8868",
    responsible_task_list: "\u6709\u8D23\u5DE5\u5355\u4EFB\u52A1\u5217\u8868",
    create_audit_task: "\u521B\u5EFA\u5BA1\u67E5\u4EFB\u52A1",
    // Responsible Rule List Page
    responsible_rule_list: "\u6709\u8D23\u5DE5\u5355\u667A\u80FD\u5BA1\u67E5",
    rule_name: "\u89C4\u5219\u540D\u79F0",
    rule_description: "\u89C4\u5219\u63CF\u8FF0",
    associated_documents: "\u5173\u8054\u77E5\u8BC6\u5E93\u6587\u6863",
    // Report List Page
    report_management: "\u62A5\u8868\u7BA1\u7406",
    report_list: "\u62A5\u8868\u4EFB\u52A1\u5217\u8868",
    create_report_task: "\u65B0\u5EFA\u62A5\u8868\u5206\u6790\u4EFB\u52A1",
    report_name: "\u4EFB\u52A1\u540D\u79F0",
    report_type: "\u62A5\u8868\u7C7B\u578B",
    analysis_range: "\u5206\u6790\u8303\u56F4",
    report_status: "\u72B6\u6001",
    report_in_progress: "\u8FDB\u884C\u4E2D",
    report_queued: "\u6392\u961F\u4E2D",
    report_completed: "\u5DF2\u5B8C\u6210",
    report_failed: "\u5931\u8D25",
    report_type_weekly: "\u5468\u62A5",
    report_type_monthly: "\u6708\u62A5",
    report_type_quarterly: "\u5B63\u62A5",
    report_type_yearly: "\u5E74\u62A5",
    download: "\u4E0B\u8F7D",
    time_range: "\u65F6\u95F4\u8303\u56F4",
    select_template: "\u9009\u62E9\u6A21\u677F",
    quality_service_weekly: "\u4F18\u8D28\u670D\u52A1\u8FD0\u8425\u5468\u62A5",
    power_service_issues: "\u4F9B\u7535\u670D\u52A1\u91CD\u70B9\u95EE\u9898\u901A\u62A5",
    annual_summary: "\u5168\u5E74\u603B\u7ED3",
    all_business_control: "\u5168\u4E1A\u52A1\u7BA1\u63A7",
    quality_service: "\u4F18\u8D28\u670D\u52A1",
    ai_suggestion: "AI \u667A\u80FD\u5EFA\u8BAE",
    based_on_history: "\u57FA\u4E8E\u5386\u53F2\u6570\u636E\u5206\u6790\uFF0CAI \u5EFA\u8BAE\u5173\u6CE8\u4EE5\u4E0B\u5F02\u5E38\u6307\u6807\uFF1A",
    duplicate_rate_increase: "\u91CD\u590D\u5DE5\u5355\u7387\u8F83\u4E0A\u6708\u4E0A\u5347 15%\uFF0C\u5EFA\u8BAE\u5206\u6790\u6839\u56E0",
    night_failure_low: "\u591C\u95F4\u6545\u969C\u5904\u7406\u65F6\u6548\u4F4E 8%\uFF0C\u5EFA\u8BAE\u4F18\u5316\u503C\u73ED\u5B89\u6392",
    time_range_has_orders: "\u8BE5\u65F6\u95F4\u8303\u56F4\u6709 2342 \u4E2A\u5DE5\u5355\uFF0C\u9884\u8BA1\u5206\u6790\u8017\u65F6\uFF1A3~5\u5206\u949F",
    start_analysis: "\u5F00\u59CB\u5206\u6790",
    monthly_total_orders: "\u672C\u6708\u5DE5\u5355\u603B\u91CF",
    pending_orders: "\u5F85\u5904\u7406\u5DE5\u5355",
    processing_timeliness: "\u5904\u7406\u53CA\u65F6\u7387",
    abnormal_orders: "\u5F02\u5E38\u5DE5\u5355\u6570",
    compare_last_month: "\u8F83\u4E0A\u6708"
};




var $50993b47476de2e7$export$a7357cdd1f0b0168 = new (0, $945120c25ea0130f$export$d91823dfc159395b)({
    'zh-CN': (0, $4f4598c544ae7941$export$2e2bcd8739ae039),
    'zh-TW': function() {
        return (parcelRequire("1a2Y6"));
    },
    'en-US': function() {
        return (parcelRequire("1Vlz5"));
    }
});
var $50993b47476de2e7$export$625550452a3fa3ec = $50993b47476de2e7$export$a7357cdd1f0b0168.t;
var $50993b47476de2e7$export$4b3850bcaaad82f1 = {
    'zh-CN': "\u7B80\u4F53\u4E2D\u6587",
    'zh-TW': "\u7E41\u9AD4\u4E2D\u6587",
    'en-US': 'English'
};


var $bbbe91238a04fd85$export$3baea55415cc8bd1 = function() {
    return [
        {
            href: '#/',
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('console'),
            icon: 'terminal'
        },
        {
            href: '#/work-order',
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_management'),
            icon: 'file-text'
        },
        {
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_classification_optimization'),
            icon: 'magic',
            subs: [
                {
                    href: '#/task/optimization/creator',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('create_optimization_task')
                },
                {
                    href: '#/task/classification',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('classification_task_management')
                }
            ]
        },
        {
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_work_order_extraction'),
            icon: 'phone',
            subs: [
                {
                    href: '#/task/deduplication/creator',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('create_extraction_task')
                },
                {
                    href: '#/task/deduplication',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('deduplication_task_list')
                }
            ]
        },
        {
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_rule_list'),
            icon: 'shield-exclamation',
            subs: [
                {
                    href: '#/task/sensitive/creator',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('create_sensitive_task')
                },
                {
                    href: '#/task/sensitive',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_task_list')
                }
            ]
        },
        {
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_rule_list'),
            icon: 'shield-check',
            subs: [
                {
                    href: '#/task/responsible/creator',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('create_responsible_task')
                },
                {
                    href: '#/task/responsible',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_task_list')
                }
            ]
        },
        {
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('supervision_order_intelligent_generation'),
            icon: 'file-earmark-text',
            subs: [
                {
                    href: '#/supervision-order',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('supervision_order_list')
                }
            ]
        },
        {
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_management'),
            icon: 'graph-up-arrow',
            subs: [
                {
                    href: '#/report',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_analysis_center')
                },
                {
                    href: '#/report/template',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_template_management')
                }
            ]
        },
        {
            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rule_knowledge_base'),
            icon: 'book',
            subs: [
                {
                    href: '#/category',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('category_system')
                },
                {
                    href: '#/rule/sensitive',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_rule_list')
                },
                {
                    href: '#/rule/responsible',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_rule_list')
                },
                {
                    href: '#/document',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('document_knowledge_base')
                }
            ]
        }
    ];
};


var $ee7d0c95ceceb68f$export$89da14300d534261;
var $ee7d0c95ceceb68f$export$6ee01cf16d42268d;
var $ee7d0c95ceceb68f$export$6fbb9cd2843e91b2;
$ee7d0c95ceceb68f$export$89da14300d534261 = "e28V8G_active";
$ee7d0c95ceceb68f$export$6ee01cf16d42268d = "e28V8G_navLink";
$ee7d0c95ceceb68f$export$6fbb9cd2843e91b2 = "e28V8G_sidebar";


var $7a40ea284503ee0f$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7a40ea284503ee0f$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7a40ea284503ee0f$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $7a40ea284503ee0f$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7a40ea284503ee0f$export$3cabf771c4f2de = function() {
    var _LeftSidebar_root;
    var _classDecorators = [
        (0, $397c81af6d5568dc$export$369b6b2b30582e8e),
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var LeftSidebar = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _LeftSidebar_root.set(_this, /*#__PURE__*/ (0, $fClfl.createRef)());
            Object.defineProperty(_this, "scrollToTop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            });
            Object.defineProperty(_this, "renderItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var title = param.title, icon = param.icon, href = param.href, subs = param.subs, depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    var hash = '#' + _this.props.location.pathname;
                    var active = hash === href || href === '#/' && hash === '';
                    var className = "".concat($ee7d0c95ceceb68f$export$6ee01cf16d42268d, " ").concat(active ? $ee7d0c95ceceb68f$export$89da14300d534261 : ''), marginLeft = depth * 1 + 'rem';
                    var text = (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
                        children: [
                            icon && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                name: icon
                            }),
                            title
                        ]
                    });
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                        className: "p-1",
                        children: href ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                            className: className,
                            style: {
                                marginLeft: marginLeft
                            },
                            href: href,
                            children: text
                        }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)("details", {
                            open: true,
                            children: [
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("summary", {
                                    className: className,
                                    style: {
                                        marginLeft: marginLeft
                                    },
                                    children: [
                                        text,
                                        " ",
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "chevron-down"
                                        })
                                    ]
                                }),
                                _this.renderMenu(subs, depth + 1)
                            ]
                        })
                    }, title);
                }
            });
            Object.defineProperty(_this, "renderMenu", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(items) {
                    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", {
                        className: "list-unstyled",
                        children: items.map(function(item) {
                            return _this.renderItem(item, depth);
                        })
                    });
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _a;
                    (_a = $7a40ea284503ee0f$var$__classPrivateFieldGet(this, _LeftSidebar_root, "f").current) === null || _a === void 0 || _a.addEventListener('click', this.scrollToTop);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _a;
                    (_a = $7a40ea284503ee0f$var$__classPrivateFieldGet(this, _LeftSidebar_root, "f").current) === null || _a === void 0 || _a.removeEventListener('click', this.scrollToTop);
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("nav", {
                        ref: $7a40ea284503ee0f$var$__classPrivateFieldGet(this, _LeftSidebar_root, "f"),
                        className: $ee7d0c95ceceb68f$export$6fbb9cd2843e91b2,
                        children: this.renderMenu((0, $bbbe91238a04fd85$export$3baea55415cc8bd1)())
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _LeftSidebar_root = new WeakMap();
    $7a40ea284503ee0f$var$__setFunctionName(_classThis, "LeftSidebar");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $7a40ea284503ee0f$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        LeftSidebar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $7a40ea284503ee0f$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return LeftSidebar = _classThis;
}();



var $leE2g = parcelRequire("leE2g");




var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $eb8ef8f36513dc70$var$Container = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_fluid = _param.fluid, fluid = _param_fluid === void 0 ? false : _param_fluid, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, className = _param.className, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "fluid",
        "as",
        "className"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'container');
    var suffix = typeof fluid === 'string' ? "-".concat(fluid) : '-fluid';
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
    }));
});
$eb8ef8f36513dc70$var$Container.displayName = 'Container';
var $eb8ef8f36513dc70$export$2e2bcd8739ae039 = $eb8ef8f36513dc70$var$Container;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $fsSDT = parcelRequire("fsSDT");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $a0f5750c1724025a$var$NavbarBrand = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, as = _param.as, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    var Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }));
});
$a0f5750c1724025a$var$NavbarBrand.displayName = 'NavbarBrand';
var $a0f5750c1724025a$export$2e2bcd8739ae039 = $a0f5750c1724025a$var$NavbarBrand;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $5RfYb = parcelRequire("5RfYb");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");



var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $1e532f6b8893d2cb$var$createChainedFunction() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    return funcs.filter(function(f) {
        return f != null;
    }).reduce(function(acc, f) {
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $1e532f6b8893d2cb$export$2e2bcd8739ae039 = $1e532f6b8893d2cb$var$createChainedFunction;





var $0d741764bbcfe2e8$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $0d741764bbcfe2e8$var$getDefaultDimensionValue(dimension, elem) {
    var offset = "offset".concat(dimension[0].toUpperCase()).concat(dimension.slice(1));
    var value = elem[offset];
    var margins = $0d741764bbcfe2e8$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
var $0d741764bbcfe2e8$var$_obj;
var $0d741764bbcfe2e8$var$collapseStyles = ($0d741764bbcfe2e8$var$_obj = {}, (0, $5RfYb._)($0d741764bbcfe2e8$var$_obj, (0, $9f32e062b2a84f9f$export$84cbff306f539230), 'collapse'), (0, $5RfYb._)($0d741764bbcfe2e8$var$_obj, (0, $9f32e062b2a84f9f$export$4aacc83d4d59139f), 'collapsing'), (0, $5RfYb._)($0d741764bbcfe2e8$var$_obj, (0, $9f32e062b2a84f9f$export$df38205c966be359), 'collapsing'), (0, $5RfYb._)($0d741764bbcfe2e8$var$_obj, (0, $9f32e062b2a84f9f$export$78e9e6e3e014d60a), 'collapse show'), $0d741764bbcfe2e8$var$_obj);
var $0d741764bbcfe2e8$var$Collapse = /*#__PURE__*/ (0, $6mMqj.default).forwardRef(function(_param, ref) {
    var onEnter = _param.onEnter, onEntering = _param.onEntering, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, className = _param.className, children = _param.children, _param_dimension = _param.dimension, dimension = _param_dimension === void 0 ? 'height' : _param_dimension, tmp = _param.in, inProp = tmp === void 0 ? false : tmp, _param_timeout = _param.timeout, timeout = _param_timeout === void 0 ? 300 : _param_timeout, _param_mountOnEnter = _param.mountOnEnter, mountOnEnter = _param_mountOnEnter === void 0 ? false : _param_mountOnEnter, _param_unmountOnExit = _param.unmountOnExit, unmountOnExit = _param_unmountOnExit === void 0 ? false : _param_unmountOnExit, _param_appear = _param.appear, appear = _param_appear === void 0 ? false : _param_appear, _param_getDimensionValue = _param.getDimensionValue, getDimensionValue = _param_getDimensionValue === void 0 ? $0d741764bbcfe2e8$var$getDefaultDimensionValue : _param_getDimensionValue, props = (0, $8MJI4._)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "className",
        "children",
        "dimension",
        "in",
        "timeout",
        "mountOnEnter",
        "unmountOnExit",
        "appear",
        "getDimensionValue"
    ]);
    /* Compute dimension */ var computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ var handleEnter = (0, $12aPv.useMemo)(function() {
        return (0, $1e532f6b8893d2cb$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = '0';
        }, onEnter);
    }, [
        computedDimension,
        onEnter
    ]);
    var handleEntering = (0, $12aPv.useMemo)(function() {
        return (0, $1e532f6b8893d2cb$export$2e2bcd8739ae039)(function(elem) {
            var scroll = "scroll".concat(computedDimension[0].toUpperCase()).concat(computedDimension.slice(1));
            elem.style[computedDimension] = "".concat(elem[scroll], "px");
        }, onEntering);
    }, [
        computedDimension,
        onEntering
    ]);
    var handleEntered = (0, $12aPv.useMemo)(function() {
        return (0, $1e532f6b8893d2cb$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = null;
        }, onEntered);
    }, [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ var handleExit = (0, $12aPv.useMemo)(function() {
        return (0, $1e532f6b8893d2cb$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = "".concat(getDimensionValue(computedDimension, elem), "px");
            (0, $93931f8490664cd7$export$2e2bcd8739ae039)(elem);
        }, onExit);
    }, [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    var handleExiting = (0, $12aPv.useMemo)(function() {
        return (0, $1e532f6b8893d2cb$export$2e2bcd8739ae039)(function(elem) {
            elem.style[computedDimension] = null;
        }, onExiting);
    }, [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $10cca68523ec8a45$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref,
        addEndListener: (0, $6c4c03751b92b480$export$2e2bcd8739ae039)
    }, props), {
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $66cdf71ba3c1e5cb$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: function(state, innerProps) {
            return /*#__PURE__*/ (0, $6mMqj.default).cloneElement(children, (0, $ctBui._)((0, $6GCxi._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, children.props.className, $0d741764bbcfe2e8$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            }));
        }
    }));
});
$0d741764bbcfe2e8$var$Collapse.displayName = 'Collapse';
var $0d741764bbcfe2e8$export$2e2bcd8739ae039 = $0d741764bbcfe2e8$var$Collapse;





"use client";
var $e0753b940d8a46be$var$NavbarCollapse = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var children = _param.children, bsPrefix = _param.bsPrefix, props = (0, $8MJI4._)(_param, [
        "children",
        "bsPrefix"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    var context = (0, $12aPv.useContext)((0, $f8be656c279f8b3f$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $0d741764bbcfe2e8$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        in: !!(context && context.expanded)
    }, props), {
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    }));
});
$e0753b940d8a46be$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $e0753b940d8a46be$export$2e2bcd8739ae039 = $e0753b940d8a46be$var$NavbarCollapse;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");




"use client";
var $b965509503cc2b85$var$NavbarToggle = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, _param_label = _param.label, label = _param_label === void 0 ? 'Toggle navigation' : _param_label, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'button' : tmp, onClick = _param.onClick, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "label",
        "as",
        "onClick"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    var _ref = (0, $12aPv.useContext)((0, $f8be656c279f8b3f$export$2e2bcd8739ae039)) || {}, onToggle = _ref.onToggle, expanded = _ref.expanded;
    var handleClick = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(function(e) {
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
            className: "".concat(bsPrefix, "-icon")
        })
    }));
});
$b965509503cc2b85$var$NavbarToggle.displayName = 'NavbarToggle';
var $b965509503cc2b85$export$2e2bcd8739ae039 = $b965509503cc2b85$var$NavbarToggle;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");


var $5RfYb = parcelRequire("5RfYb");

var $leE2g = parcelRequire("leE2g");

var $5f0Cq = parcelRequire("5f0Cq");

var $leE2g = parcelRequire("leE2g");

parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
var $d2870ddc258a3625$var$matchersByWindow = new WeakMap();
var $d2870ddc258a3625$var$getMatcher = function(query, targetWindow) {
    if (!query || !targetWindow) return undefined;
    var matchers = $d2870ddc258a3625$var$matchersByWindow.get(targetWindow) || new Map();
    $d2870ddc258a3625$var$matchersByWindow.set(targetWindow, matchers);
    var mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $d2870ddc258a3625$export$2e2bcd8739ae039(query) {
    var targetWindow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : typeof window === 'undefined' ? undefined : window;
    var mql = $d2870ddc258a3625$var$getMatcher(query, targetWindow);
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(function() {
        return mql ? mql.matches : false;
    }), 2), matches = _useState[0], setMatches = _useState[1];
    (0, $5d85ac82b8d2ad7b$export$2e2bcd8739ae039)(function() {
        var mql = $d2870ddc258a3625$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        var matchers = $d2870ddc258a3625$var$matchersByWindow.get(targetWindow);
        var handleChange = function() {
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return function() {
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $cd5040378682415b$export$9c6950edc251641e(breakpointValues) {
    var names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? "".concat(query, " and ").concat(next) : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        var next = getNext(breakpoint);
        var value = breakpointValues[next];
        if (typeof value === 'number') value = "".concat(value - 0.2, "px");
        else value = "calc(".concat(value, " - 0.2px)");
        return "(max-width: ".concat(value, ")");
    }
    function getMinQuery(breakpoint) {
        var value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = "".concat(value, "px");
        return "(min-width: ".concat(value, ")");
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        var breakpointMap;
        if ((typeof breakpointOrMap === "undefined" ? "undefined" : (0, $5f0Cq._)(breakpointOrMap)) === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = (0, $5RfYb._)({}, breakpointOrMap, direction);
        }
        var query = (0, $12aPv.useMemo)(function() {
            return Object.entries(breakpointMap).reduce(function(query, param) {
                var _param = (0, $leE2g._)(param, 2), key = _param[0], _$direction = _param[1];
                if (_$direction === 'up' || _$direction === true) query = and(query, getMinQuery(key));
                if (_$direction === 'down' || _$direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, '');
        }, [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $d2870ddc258a3625$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
var $cd5040378682415b$var$useBreakpoint = $cd5040378682415b$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $cd5040378682415b$export$2e2bcd8739ae039 = $cd5040378682415b$var$useBreakpoint;




var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

function $607d6e14baa19d0a$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $cb03b130654deaba$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $6mMqj = parcelRequire("6mMqj");

parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $78ec88c72531caee$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $12aPv.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $8eee82210b3b3a42$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $78ec88c72531caee$export$2e2bcd8739ae039)(fn);
    (0, $12aPv.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}





var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $fsSDT = parcelRequire("fsSDT");


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $e23a0461c8253851$export$2e2bcd8739ae039() {
    var ownerDocument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    var window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


var $a526f12457846a26$export$1a88c12b8b979fa0 = (0, $a16dacb94031d905$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ var $a526f12457846a26$var$ModalManager = /*#__PURE__*/ function() {
    "use strict";
    function ModalManager() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ownerDocument = _ref.ownerDocument, _ref_handleContainerOverflow = _ref.handleContainerOverflow, handleContainerOverflow = _ref_handleContainerOverflow === void 0 ? true : _ref_handleContainerOverflow, _ref_isRTL = _ref.isRTL, isRTL = _ref_isRTL === void 0 ? false : _ref_isRTL;
        (0, $7lhcp._)(this, ModalManager);
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    (0, $8BtP9._)(ModalManager, [
        {
            key: "getScrollbarWidth",
            value: function getScrollbarWidth() {
                return (0, $e23a0461c8253851$export$2e2bcd8739ae039)(this.ownerDocument);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return (this.ownerDocument || document).body;
            }
        },
        {
            key: "setModalAttributes",
            value: function setModalAttributes(_modal) {
            // For overriding
            }
        },
        {
            key: "removeModalAttributes",
            value: function removeModalAttributes(_modal) {
            // For overriding
            }
        },
        {
            key: "setContainerStyle",
            value: function setContainerStyle(containerState) {
                var style = {
                    overflow: 'hidden'
                };
                // we are only interested in the actual `style` here
                // because we will override it
                var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
                var container = this.getElement();
                containerState.style = (0, $5RfYb._)({
                    overflow: container.style.overflow
                }, paddingProp, container.style[paddingProp]);
                if (containerState.scrollBarWidth) // use computed style, here to get the real padding
                // to add our scrollbar width
                style[paddingProp] = "".concat(parseInt((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth, "px");
                container.setAttribute($a526f12457846a26$export$1a88c12b8b979fa0, '');
                (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(container, style);
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                (0, $fsSDT._)(this.modals).forEach(function(m) {
                    return _this.remove(m);
                });
            }
        },
        {
            key: "removeContainerStyle",
            value: function removeContainerStyle(containerState) {
                var container = this.getElement();
                container.removeAttribute($a526f12457846a26$export$1a88c12b8b979fa0);
                Object.assign(container.style, containerState.style);
            }
        },
        {
            key: "add",
            value: function add(modal) {
                var modalIdx = this.modals.indexOf(modal);
                if (modalIdx !== -1) return modalIdx;
                modalIdx = this.modals.length;
                this.modals.push(modal);
                this.setModalAttributes(modal);
                if (modalIdx !== 0) return modalIdx;
                this.state = {
                    scrollBarWidth: this.getScrollbarWidth(),
                    style: {}
                };
                if (this.handleContainerOverflow) this.setContainerStyle(this.state);
                return modalIdx;
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIdx = this.modals.indexOf(modal);
                if (modalIdx === -1) return;
                this.modals.splice(modalIdx, 1);
                // if that was the last modal in a container,
                // clean up the container
                if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
                this.removeModalAttributes(modal);
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();
var $a526f12457846a26$export$2e2bcd8739ae039 = $a526f12457846a26$var$ModalManager;







var $fClfl = parcelRequire("fClfl");
var $7aeba65c918723c4$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $7aeba65c918723c4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $7aeba65c918723c4$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $7aeba65c918723c4$var$getManager(window) {
    if (!$7aeba65c918723c4$var$manager) $7aeba65c918723c4$var$manager = new (0, $a526f12457846a26$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $7aeba65c918723c4$var$manager;
}
function $7aeba65c918723c4$var$useModalManager(provided) {
    var window = (0, $2b9d532f6e6b62e7$export$2e2bcd8739ae039)();
    var modalManager = provided || $7aeba65c918723c4$var$getManager(window);
    var modal = (0, $12aPv.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: function() {
            return modalManager.add(modal.current);
        },
        remove: function() {
            return modalManager.remove(modal.current);
        },
        isTopModal: function() {
            return modalManager.isTopModal(modal.current);
        },
        setDialogRef: (0, $12aPv.useCallback)(function(ref) {
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $12aPv.useCallback)(function(ref) {
            modal.current.backdrop = ref;
        }, [])
    });
}
var $7aeba65c918723c4$var$Modal = /*#__PURE__*/ (0, $6mMqj.forwardRef)(function(_ref, ref) {
    var _ref_show = _ref.show, show = _ref_show === void 0 ? false : _ref_show, _ref_role = _ref.role, role = _ref_role === void 0 ? 'dialog' : _ref_role, className = _ref.className, style = _ref.style, children = _ref.children, _ref_backdrop = _ref.backdrop, backdrop = _ref_backdrop === void 0 ? true : _ref_backdrop, _ref_keyboard = _ref.keyboard, keyboard = _ref_keyboard === void 0 ? true : _ref_keyboard, onBackdropClick = _ref.onBackdropClick, onEscapeKeyDown = _ref.onEscapeKeyDown, transition = _ref.transition, runTransition = _ref.runTransition, backdropTransition = _ref.backdropTransition, runBackdropTransition = _ref.runBackdropTransition, _ref_autoFocus = _ref.autoFocus, autoFocus = _ref_autoFocus === void 0 ? true : _ref_autoFocus, _ref_enforceFocus = _ref.enforceFocus, enforceFocus = _ref_enforceFocus === void 0 ? true : _ref_enforceFocus, _ref_restoreFocus = _ref.restoreFocus, restoreFocus = _ref_restoreFocus === void 0 ? true : _ref_restoreFocus, restoreFocusOptions = _ref.restoreFocusOptions, renderDialog = _ref.renderDialog, _ref_renderBackdrop = _ref.renderBackdrop, renderBackdrop = _ref_renderBackdrop === void 0 ? function(props) {
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({}, props));
    } : _ref_renderBackdrop, providedManager = _ref.manager, containerRef = _ref.container, onShow = _ref.onShow, _ref_onHide = _ref.onHide, onHide = _ref_onHide === void 0 ? function() {} : _ref_onHide, onExit = _ref.onExit, onExited = _ref.onExited, onExiting = _ref.onExiting, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, rest = $7aeba65c918723c4$var$_objectWithoutPropertiesLoose(_ref, $7aeba65c918723c4$var$_excluded);
    var ownerWindow = (0, $2b9d532f6e6b62e7$export$2e2bcd8739ae039)();
    var container = (0, $dcc9211d5a5ebe94$export$2e2bcd8739ae039)(containerRef);
    var modal = $7aeba65c918723c4$var$useModalManager(providedManager);
    var isMounted = (0, $4e9fdf12852de5b4$export$2e2bcd8739ae039)();
    var prevShow = (0, $3b1b41e6f8e3c97a$export$2e2bcd8739ae039)(show);
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(!show), 2), exited = _useState[0], setExited = _useState[1];
    var lastFocusRef = (0, $12aPv.useRef)(null);
    (0, $12aPv.useImperativeHandle)(ref, function() {
        return modal;
    }, [
        modal
    ]);
    if ((0, $64f258eaaf92e603$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    var handleShow = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function() {
        modal.add();
        removeKeydownListenerRef.current = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $709dbe0f51f464e8$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        function() {
            return setTimeout(handleEnforceFocus);
        }, true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            var currentActiveElement = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    var handleHide = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function() {
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $12aPv.useEffect)(function() {
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $12aPv.useEffect)(function() {
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $8eee82210b3b3a42$export$2e2bcd8739ae039)(function() {
        handleHide();
    });
    // --------------------------------
    var handleEnforceFocus = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function() {
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        var currentActiveElement = (0, $607d6e14baa19d0a$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $a784322fcbc350d7$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    var handleBackdropClick = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(e) {
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    var handleDocumentKeyDown = (0, $0339cc266363564f$export$2e2bcd8739ae039)(function(e) {
        if (keyboard && (0, $66cdf71ba3c1e5cb$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    var removeFocusListenerRef = (0, $12aPv.useRef)();
    var removeKeydownListenerRef = (0, $12aPv.useRef)();
    var handleHidden = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setExited(true);
        onExited == null || onExited.apply(void 0, (0, $fsSDT._)(args));
    };
    if (!container) return null;
    var dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $6mMqj.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $1671eb5ae115cdb6$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    var backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $1671eb5ae115cdb6$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: /*#__PURE__*/ (0, $6mMqj.default).createPortal(/*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$7aeba65c918723c4$var$Modal.displayName = 'Modal';
var $7aeba65c918723c4$export$2e2bcd8739ae039 = Object.assign($7aeba65c918723c4$var$Modal, {
    Manager: (0, $a526f12457846a26$export$2e2bcd8739ae039)
});




var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $cccc902c2e2b93cd$var$OffcanvasBody = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$cccc902c2e2b93cd$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $cccc902c2e2b93cd$export$2e2bcd8739ae039 = $cccc902c2e2b93cd$var$OffcanvasBody;



var $5RfYb = parcelRequire("5RfYb");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");






"use client";
var $0f0f44f2e9bfc61d$var$_obj;
var $0f0f44f2e9bfc61d$var$transitionStyles = ($0f0f44f2e9bfc61d$var$_obj = {}, (0, $5RfYb._)($0f0f44f2e9bfc61d$var$_obj, (0, $9f32e062b2a84f9f$export$df38205c966be359), 'show'), (0, $5RfYb._)($0f0f44f2e9bfc61d$var$_obj, (0, $9f32e062b2a84f9f$export$78e9e6e3e014d60a), 'show'), $0f0f44f2e9bfc61d$var$_obj);
var $0f0f44f2e9bfc61d$var$OffcanvasToggling = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, tmp = _param.in, inProp = tmp === void 0 ? false : tmp, _param_mountOnEnter = _param.mountOnEnter, mountOnEnter = _param_mountOnEnter === void 0 ? false : _param_mountOnEnter, _param_unmountOnExit = _param.unmountOnExit, unmountOnExit = _param_unmountOnExit === void 0 ? false : _param_unmountOnExit, _param_appear = _param.appear, appear = _param_appear === void 0 ? false : _param_appear, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "in",
        "mountOnEnter",
        "unmountOnExit",
        "appear"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $10cca68523ec8a45$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref,
        addEndListener: (0, $6c4c03751b92b480$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear
    }, props), {
        childRef: (0, $66cdf71ba3c1e5cb$export$87943f2672146d57)(children),
        children: function(status, innerProps) {
            return /*#__PURE__*/ $6mMqj.cloneElement(children, (0, $ctBui._)((0, $6GCxi._)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, children.props.className, (status === (0, $9f32e062b2a84f9f$export$df38205c966be359) || status === (0, $9f32e062b2a84f9f$export$4aacc83d4d59139f)) && "".concat(bsPrefix, "-toggling"), $0f0f44f2e9bfc61d$var$transitionStyles[status])
            }));
        }
    }));
});
$0f0f44f2e9bfc61d$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $0f0f44f2e9bfc61d$export$2e2bcd8739ae039 = $0f0f44f2e9bfc61d$var$OffcanvasToggling;


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
"use client";
var $ef43a88dc0d809e8$var$ModalContext = /*#__PURE__*/ $fClfl.createContext({
    onHide: function() {}
});
var $ef43a88dc0d809e8$export$2e2bcd8739ae039 = $ef43a88dc0d809e8$var$ModalContext;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");


var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


var $032c440f677b0c75$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).oneOf([
        'white'
    ])
};
var $032c440f677b0c75$var$CloseButton = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, tmp = _param['aria-label'], ariaLabel = tmp === void 0 ? 'Close' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "variant",
        'aria-label'
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("button", (0, $6GCxi._)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))('btn-close', variant && "btn-close-".concat(variant), className),
        "aria-label": ariaLabel
    }, props));
});
$032c440f677b0c75$var$CloseButton.displayName = 'CloseButton';
$032c440f677b0c75$var$CloseButton.propTypes = $032c440f677b0c75$var$propTypes;
var $032c440f677b0c75$export$2e2bcd8739ae039 = $032c440f677b0c75$var$CloseButton;




"use client";
var $bdd1b17e5034285f$var$AbstractModalHeader = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? 'Close' : _param_closeLabel, closeVariant = _param.closeVariant, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, onHide = _param.onHide, children = _param.children, props = (0, $8MJI4._)(_param, [
        "closeLabel",
        "closeVariant",
        "closeButton",
        "onHide",
        "children"
    ]);
    var context = (0, $12aPv.useContext)((0, $ef43a88dc0d809e8$export$2e2bcd8739ae039));
    var handleClick = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(function() {
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $032c440f677b0c75$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    }));
});
$bdd1b17e5034285f$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $bdd1b17e5034285f$export$2e2bcd8739ae039 = $bdd1b17e5034285f$var$AbstractModalHeader;



"use client";
var $b1a2b772d4e4a3c3$var$OffcanvasHeader = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? 'Close' : _param_closeLabel, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $bdd1b17e5034285f$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$b1a2b772d4e4a3c3$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $b1a2b772d4e4a3c3$export$2e2bcd8739ae039 = $b1a2b772d4e4a3c3$var$OffcanvasHeader;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");




"use client";
var $99758bbd510b7cf7$var$DivStyledAsH5 = (0, $197a01a380243da0$export$2e2bcd8739ae039)('h5');
var $99758bbd510b7cf7$var$OffcanvasTitle = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $99758bbd510b7cf7$var$DivStyledAsH5 : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$99758bbd510b7cf7$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $99758bbd510b7cf7$export$2e2bcd8739ae039 = $99758bbd510b7cf7$var$OffcanvasTitle;




var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");

function $238a4fd6ca67df0c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $00f98d1dc049abf7$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $62f26c8f9df85416$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $62f26c8f9df85416$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $62f26c8f9df85416$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $62f26c8f9df85416$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $d679232cd27e43e1$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
var $d679232cd27e43e1$var$BootstrapModalManager = /*#__PURE__*/ function(ModalManager) {
    "use strict";
    (0, $h6w6E._)(BootstrapModalManager, ModalManager);
    function BootstrapModalManager() {
        (0, $7lhcp._)(this, BootstrapModalManager);
        return (0, $07dqX._)(this, BootstrapModalManager, arguments);
    }
    (0, $8BtP9._)(BootstrapModalManager, [
        {
            key: "adjustAndStore",
            value: function adjustAndStore(prop, element, adjust) {
                var actual = element.style[prop];
                // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
                element.dataset[prop] = actual;
                (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, (0, $5RfYb._)({}, prop, "".concat(parseFloat((0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, prop)) + adjust, "px")));
            }
        },
        {
            key: "restore",
            value: function restore(prop, element) {
                var value = element.dataset[prop];
                if (value !== undefined) {
                    delete element.dataset[prop];
                    (0, $2743bc2e9a1bad0a$export$2e2bcd8739ae039)(element, (0, $5RfYb._)({}, prop, value));
                }
            }
        },
        {
            key: "setContainerStyle",
            value: function setContainerStyle(containerState) {
                var _this = this;
                (0, $5LQ10._)((0, $2JFuQ._)(BootstrapModalManager.prototype), "setContainerStyle", this).call(this, containerState);
                var container = this.getElement();
                (0, $238a4fd6ca67df0c$export$2e2bcd8739ae039)(container, 'modal-open');
                if (!containerState.scrollBarWidth) return;
                var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
                var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $d679232cd27e43e1$var$Selector.FIXED_CONTENT).forEach(function(el) {
                    return _this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $d679232cd27e43e1$var$Selector.STICKY_CONTENT).forEach(function(el) {
                    return _this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $d679232cd27e43e1$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
                    return _this.adjustAndStore(marginProp, el, containerState.scrollBarWidth);
                });
            }
        },
        {
            key: "removeContainerStyle",
            value: function removeContainerStyle(containerState) {
                var _this = this;
                (0, $5LQ10._)((0, $2JFuQ._)(BootstrapModalManager.prototype), "removeContainerStyle", this).call(this, containerState);
                var container = this.getElement();
                (0, $62f26c8f9df85416$export$2e2bcd8739ae039)(container, 'modal-open');
                var paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
                var marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $d679232cd27e43e1$var$Selector.FIXED_CONTENT).forEach(function(el) {
                    return _this.restore(paddingProp, el);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $d679232cd27e43e1$var$Selector.STICKY_CONTENT).forEach(function(el) {
                    return _this.restore(marginProp, el);
                });
                (0, $aa7848f343bf09c4$export$2e2bcd8739ae039)(container, $d679232cd27e43e1$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
                    return _this.restore(marginProp, el);
                });
            }
        }
    ]);
    return BootstrapModalManager;
}((0, $a526f12457846a26$export$2e2bcd8739ae039));
var $d679232cd27e43e1$var$sharedManager;
function $d679232cd27e43e1$export$a03641438014b436(options) {
    if (!$d679232cd27e43e1$var$sharedManager) $d679232cd27e43e1$var$sharedManager = new $d679232cd27e43e1$var$BootstrapModalManager(options);
    return $d679232cd27e43e1$var$sharedManager;
}
var $d679232cd27e43e1$export$2e2bcd8739ae039 = $d679232cd27e43e1$var$BootstrapModalManager;



var $fClfl = parcelRequire("fClfl");
"use client";
function $2d739f414cff631b$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $0f0f44f2e9bfc61d$export$2e2bcd8739ae039), (0, $6GCxi._)({}, props));
}
function $2d739f414cff631b$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f4bd4b28ec6f3d4e$export$2e2bcd8739ae039), (0, $6GCxi._)({}, props));
}
var $2d739f414cff631b$var$Offcanvas = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, ariaLabelledby = _param['aria-labelledby'], _param_placement = _param.placement, placement = _param_placement === void 0 ? 'start' : _param_placement, responsive = _param.responsive, _param_show = _param./* BaseModal props */ show, show = _param_show === void 0 ? false : _param_show, _param_backdrop = _param.backdrop, backdrop = _param_backdrop === void 0 ? true : _param_backdrop, _param_keyboard = _param.keyboard, keyboard = _param_keyboard === void 0 ? true : _param_keyboard, _param_scroll = _param.scroll, scroll = _param_scroll === void 0 ? false : _param_scroll, onEscapeKeyDown = _param.onEscapeKeyDown, onShow = _param.onShow, onHide = _param.onHide, container = _param.container, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, _param_enforceFocus = _param.enforceFocus, enforceFocus = _param_enforceFocus === void 0 ? true : _param_enforceFocus, _param_restoreFocus = _param.restoreFocus, restoreFocus = _param_restoreFocus === void 0 ? true : _param_restoreFocus, restoreFocusOptions = _param.restoreFocusOptions, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, backdropClassName = _param.backdropClassName, propsManager = _param.manager, _param_renderStaticNode = _param.renderStaticNode, renderStaticNode = _param_renderStaticNode === void 0 ? false : _param_renderStaticNode, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "children",
        'aria-labelledby',
        "placement",
        "responsive",
        "show",
        "backdrop",
        "keyboard",
        "scroll",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager",
        "renderStaticNode"
    ]);
    var modalManager = (0, $12aPv.useRef)();
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    var _useState = (0, $leE2g._)((0, $12aPv.useState)(false), 2), showOffcanvas = _useState[0], setShowOffcanvas = _useState[1];
    var handleHide = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(onHide);
    var hideResponsiveOffcanvas = (0, $cd5040378682415b$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $12aPv.useEffect)(function() {
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    var modalContext = (0, $12aPv.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $d679232cd27e43e1$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $d679232cd27e43e1$export$a03641438014b436)();
    }
    var handleEnter = function(node) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter.apply(void 0, [
            node
        ].concat((0, $fsSDT._)(args)));
    };
    var handleExited = function(node) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (node) node.style.visibility = '';
        onExited == null || onExited.apply(void 0, (0, $fsSDT._)(args));
    };
    var renderBackdrop = (0, $12aPv.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-backdrop"), backdropClassName)
        }));
    }, [
        backdropClassName,
        bsPrefix
    ]);
    var renderDialog = function(dialogProps) {
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({}, dialogProps, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, responsive ? "".concat(bsPrefix, "-").concat(responsive) : bsPrefix, "".concat(bsPrefix, "-").concat(placement)),
            "aria-labelledby": ariaLabelledby,
            children: children
        }));
    };
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $ef43a88dc0d809e8$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $7aeba65c918723c4$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $2d739f414cff631b$var$DialogTransition,
                    backdropTransition: $2d739f414cff631b$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$2d739f414cff631b$var$Offcanvas.displayName = 'Offcanvas';
var $2d739f414cff631b$export$2e2bcd8739ae039 = Object.assign($2d739f414cff631b$var$Offcanvas, {
    Body: (0, $cccc902c2e2b93cd$export$2e2bcd8739ae039),
    Header: (0, $b1a2b772d4e4a3c3$export$2e2bcd8739ae039),
    Title: (0, $99758bbd510b7cf7$export$2e2bcd8739ae039)
});




"use client";
var $3a92085e74bec294$var$NavbarOffcanvas = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var onHide = _param.onHide, props = (0, $8MJI4._)(_param, [
        "onHide"
    ]);
    var context = (0, $12aPv.useContext)((0, $f8be656c279f8b3f$export$2e2bcd8739ae039));
    var handleHide = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(function() {
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $2d739f414cff631b$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref,
        show: !!(context != null && context.expanded)
    }, props), {
        renderStaticNode: true,
        onHide: handleHide
    }));
});
$3a92085e74bec294$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $3a92085e74bec294$export$2e2bcd8739ae039 = $3a92085e74bec294$var$NavbarOffcanvas;





var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $f15fdbeb1435fdba$var$NavbarText = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$f15fdbeb1435fdba$var$NavbarText.displayName = 'NavbarText';
var $f15fdbeb1435fdba$export$2e2bcd8739ae039 = $f15fdbeb1435fdba$var$NavbarText;



"use client";
var $ee6fcdef1cc33380$var$Navbar = /*#__PURE__*/ $6mMqj.forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $c573222c50547131$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    }), initialBsPrefix = _useUncontrolled.bsPrefix, _useUncontrolled_expand = _useUncontrolled.expand, expand = _useUncontrolled_expand === void 0 ? true : _useUncontrolled_expand, _useUncontrolled_variant = _useUncontrolled.variant, variant = _useUncontrolled_variant === void 0 ? 'light' : _useUncontrolled_variant, bg = _useUncontrolled.bg, fixed = _useUncontrolled.fixed, sticky = _useUncontrolled.sticky, className = _useUncontrolled.className, tmp = _useUncontrolled.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'nav' : tmp, expanded = _useUncontrolled.expanded, onToggle = _useUncontrolled.onToggle, onSelect = _useUncontrolled.onSelect, _useUncontrolled_collapseOnSelect = _useUncontrolled.collapseOnSelect, collapseOnSelect = _useUncontrolled_collapseOnSelect === void 0 ? false : _useUncontrolled_collapseOnSelect, controlledProps = (0, $8MJI4._)(_useUncontrolled, [
        "bsPrefix",
        "expand",
        "variant",
        "bg",
        "fixed",
        "sticky",
        "className",
        "as",
        "expanded",
        "onToggle",
        "onSelect",
        "collapseOnSelect"
    ]);
    var bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    var handleCollapse = (0, $12aPv.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        onSelect == null || onSelect.apply(void 0, (0, $fsSDT._)(args));
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    var expandClass = "".concat(bsPrefix, "-expand");
    if (typeof expand === 'string') expandClass = "".concat(expandClass, "-").concat(expand);
    var navbarContext = (0, $12aPv.useMemo)(function() {
        return {
            onToggle: function() {
                return onToggle == null ? void 0 : onToggle(!expanded);
            },
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        };
    }, [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f8be656c279f8b3f$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5d7ccc5fefa2a642$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
                ref: ref
            }, controlledProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, expand && expandClass, variant && "".concat(bsPrefix, "-").concat(variant), bg && "bg-".concat(bg), sticky && "sticky-".concat(sticky), fixed && "fixed-".concat(fixed))
            }))
        })
    });
});
$ee6fcdef1cc33380$var$Navbar.displayName = 'Navbar';
var $ee6fcdef1cc33380$export$2e2bcd8739ae039 = Object.assign($ee6fcdef1cc33380$var$Navbar, {
    Brand: (0, $a0f5750c1724025a$export$2e2bcd8739ae039),
    Collapse: (0, $e0753b940d8a46be$export$2e2bcd8739ae039),
    Offcanvas: (0, $3a92085e74bec294$export$2e2bcd8739ae039),
    Text: (0, $f15fdbeb1435fdba$export$2e2bcd8739ae039),
    Toggle: (0, $b965509503cc2b85$export$2e2bcd8739ae039)
});





var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



var $arNK5 = parcelRequire("arNK5");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");





var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");


var $6mMqj = parcelRequire("6mMqj");






"use client";
var $2422dfed6e9eb9a3$var$ListGroupItem = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, active = _param.active, disabled = _param.disabled, eventKey = _param.eventKey, className = _param.className, variant = _param.variant, action = _param.action, as = _param.as, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "active",
        "disabled",
        "eventKey",
        "className",
        "variant",
        "action",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    var _useNavItem = (0, $leE2g._)((0, $a42d15e4dd8fe1c8$export$d7a68693710982a)((0, $6GCxi._)({
        key: (0, $5d7ccc5fefa2a642$export$eef49b42fde998a3)(eventKey, props.href),
        active: active
    }, props)), 2), navItemProps = _useNavItem[0], meta = _useNavItem[1];
    var handleClick = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(function(event) {
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    var Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props, navItemProps), {
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && "".concat(bsPrefix, "-").concat(variant), action && "".concat(bsPrefix, "-action"))
    }));
});
$2422dfed6e9eb9a3$var$ListGroupItem.displayName = 'ListGroupItem';
var $2422dfed6e9eb9a3$export$2e2bcd8739ae039 = $2422dfed6e9eb9a3$var$ListGroupItem;



"use client";
var $a2847098175bdaa7$var$ListGroup = /*#__PURE__*/ $6mMqj.forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $c573222c50547131$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    }), className = _useUncontrolled.className, initialBsPrefix = _useUncontrolled.bsPrefix, variant = _useUncontrolled.variant, horizontal = _useUncontrolled.horizontal, numbered = _useUncontrolled.numbered, _useUncontrolled_as = _useUncontrolled.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, as = _useUncontrolled_as === void 0 ? 'div' : _useUncontrolled_as, controlledProps = (0, $8MJI4._)(_useUncontrolled, [
        "className",
        "bsPrefix",
        "variant",
        "horizontal",
        "numbered",
        "as"
    ]);
    var bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    var horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : "horizontal-".concat(horizontal);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $507c6782315cb9fe$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, controlledProps), {
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, variant && "".concat(bsPrefix, "-").concat(variant), horizontalVariant && "".concat(bsPrefix, "-").concat(horizontalVariant), numbered && "".concat(bsPrefix, "-numbered"))
    }));
});
$a2847098175bdaa7$var$ListGroup.displayName = 'ListGroup';
var $a2847098175bdaa7$export$2e2bcd8739ae039 = Object.assign($a2847098175bdaa7$var$ListGroup, {
    Item: (0, $2422dfed6e9eb9a3$export$2e2bcd8739ae039)
});



var $c047a8eabaefb27b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c047a8eabaefb27b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c047a8eabaefb27b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $c047a8eabaefb27b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c047a8eabaefb27b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c047a8eabaefb27b$export$72d0b49a56703654 = function() {
    var _UserMenu_open_accessor_storage;
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _open_decorators;
    var _open_initializers = [];
    var _open_extraInitializers = [];
    var UserMenu = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _UserMenu_open_accessor_storage.set(_this, $c047a8eabaefb27b$var$__runInitializers(_this, _open_initializers, false));
            Object.defineProperty(_this, "renderMenu", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c047a8eabaefb27b$var$__runInitializers(_this, _open_extraInitializers), function() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $a2847098175bdaa7$export$2e2bcd8739ae039), {
                        className: "position-absolute start-0 top-100",
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $a2847098175bdaa7$export$2e2bcd8739ae039).Item, {
                            action: true,
                            onClick: function() {
                                return (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).signOut();
                            },
                            children: "\u9000\u51FA"
                        })
                    });
                })
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "open",
                get: function get() {
                    return $c047a8eabaefb27b$var$__classPrivateFieldGet(this, _UserMenu_open_accessor_storage, "f");
                },
                set: function set(value) {
                    $c047a8eabaefb27b$var$__classPrivateFieldSet(this, _UserMenu_open_accessor_storage, value, "f");
                }
            },
            {
                key: "renderButton",
                value: function renderButton() {
                    var _this = this;
                    var _this_props = this.props, avatar = _this_props.avatar, name = _this_props.name;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("button", {
                        className: "border-0 bg-transparent d-flex align-items-center gap-2",
                        style: {
                            appearance: 'none'
                        },
                        onClick: function() {
                            return _this.open = !_this.open;
                        },
                        children: [
                            avatar ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4833a765594519c8$export$2e2bcd8739ae039), {
                                style: {
                                    width: '2rem',
                                    height: '2rem'
                                },
                                src: avatar,
                                alt: name,
                                roundedCircle: true
                            }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                name: "person-circle",
                                size: 2
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                children: name
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.ClickBoundary), {
                        className: "position-relative",
                        onOuterClick: function() {
                            return _this.open = false;
                        },
                        children: [
                            this.renderButton(),
                            this.open && this.renderMenu()
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _UserMenu_open_accessor_storage = new WeakMap();
    $c047a8eabaefb27b$var$__setFunctionName(_classThis, "UserMenu");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _open_decorators = [
            (0, $arNK5.observable)
        ];
        $c047a8eabaefb27b$var$__esDecorate(_classThis, null, _open_decorators, {
            kind: "accessor",
            name: "open",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "open" in obj;
                },
                get: function(obj) {
                    return obj.open;
                },
                set: function(obj, value) {
                    obj.open = value;
                }
            },
            metadata: _metadata
        }, _open_initializers, _open_extraInitializers);
        $c047a8eabaefb27b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        UserMenu = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $c047a8eabaefb27b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return UserMenu = _classThis;
}();


var $aca7ac1a0ae40101$export$8b543871300e74c2 = (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)(function() {
    var currentLanguage = (0, $50993b47476de2e7$export$a7357cdd1f0b0168).currentLanguage;
    var session = (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).session;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $ee6fcdef1cc33380$export$2e2bcd8739ae039), {
        className: "border-bottom",
        style: {
            zIndex: 1030
        },
        bg: "white",
        variant: "light",
        sticky: "top",
        expand: "lg",
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $eb8ef8f36513dc70$export$2e2bcd8739ae039), {
            fluid: true,
            children: [
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $ee6fcdef1cc33380$export$2e2bcd8739ae039).Brand, {
                    className: "d-flex align-items-center gap-2",
                    href: ".",
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                            className: "text-primary",
                            name: "robot",
                            size: 2
                        }),
                        document.title
                    ]
                }),
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                    className: "d-flex align-items-center gap-3",
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Select), {
                            value: currentLanguage,
                            onChange: function(key) {
                                return (0, $50993b47476de2e7$export$a7357cdd1f0b0168).loadLanguages(key);
                            },
                            children: Object.entries((0, $50993b47476de2e7$export$4b3850bcaaad82f1)).map(function(param) {
                                var _param = (0, $leE2g._)(param, 2), key = _param[0], name = _param[1];
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Option), {
                                    value: key,
                                    children: name
                                }, key);
                            })
                        }),
                        session && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c047a8eabaefb27b$export$72d0b49a56703654), Object.assign({}, session))
                    ]
                })
            ]
        })
    });
});



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");

var $6tqvJ = parcelRequire("6tqvJ");



var $b533b81bb3fec826$export$6fb48dc3079cee11 = function(param) {
    var className = param.className;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("svg", {
        className: className,
        viewBox: "0 0 100 100",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "4",
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("polyline", {
            points: "10,50 30,30 50,70 70,20 90,50",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


var $9c9acf691ee5dd89$export$eb1a6f91881a35fd;
var $9c9acf691ee5dd89$export$b507296dd3c7a2ce;
var $9c9acf691ee5dd89$export$666c3ad173ff70db;
var $9c9acf691ee5dd89$export$1afaec556d5731ad;
var $9c9acf691ee5dd89$export$d2297815c52203ee;
var $9c9acf691ee5dd89$export$38e42c68cf43b5d4;
var $9c9acf691ee5dd89$export$76006b3b1ed92028;
var $9c9acf691ee5dd89$export$248a47518f3a0001;
var $9c9acf691ee5dd89$export$9e2d21f784c42f44;
var $9c9acf691ee5dd89$export$7abe78e1eda562aa;
var $9c9acf691ee5dd89$export$8ad55ac0c46ccac8;
var $9c9acf691ee5dd89$export$ef604ebebea21dcf;
var $9c9acf691ee5dd89$export$d59c1ce74b98507b;
var $9c9acf691ee5dd89$export$3f51feea65531060;
var $9c9acf691ee5dd89$export$6d2e7473e733612a;
var $9c9acf691ee5dd89$export$f870f1aaf41fd9d9;
var $9c9acf691ee5dd89$export$f6ec0f1c757b56b8;
var $9c9acf691ee5dd89$export$4ac653885abdd1d4;
var $9c9acf691ee5dd89$export$d32f18b7f7721ef0;
$9c9acf691ee5dd89$export$eb1a6f91881a35fd = "Ye-QYG_activityIcon";
$9c9acf691ee5dd89$export$b507296dd3c7a2ce = "Ye-QYG_checkboxGroup";
$9c9acf691ee5dd89$export$666c3ad173ff70db = "Ye-QYG_copyright";
$9c9acf691ee5dd89$export$1afaec556d5731ad = "Ye-QYG_formBody";
$9c9acf691ee5dd89$export$d2297815c52203ee = "Ye-QYG_formGroup";
$9c9acf691ee5dd89$export$38e42c68cf43b5d4 = "Ye-QYG_header";
$9c9acf691ee5dd89$export$76006b3b1ed92028 = "Ye-QYG_inputIcon";
$9c9acf691ee5dd89$export$248a47518f3a0001 = "Ye-QYG_inputWrapper";
$9c9acf691ee5dd89$export$9e2d21f784c42f44 = "Ye-QYG_leftPanel";
$9c9acf691ee5dd89$export$7abe78e1eda562aa = "Ye-QYG_loginButton";
$9c9acf691ee5dd89$export$8ad55ac0c46ccac8 = "Ye-QYG_loginCard";
$9c9acf691ee5dd89$export$ef604ebebea21dcf = "Ye-QYG_logoSection";
$9c9acf691ee5dd89$export$d59c1ce74b98507b = "Ye-QYG_rightPanel";
$9c9acf691ee5dd89$export$3f51feea65531060 = "Ye-QYG_shieldIcon";
$9c9acf691ee5dd89$export$6d2e7473e733612a = "Ye-QYG_statusIcon";
$9c9acf691ee5dd89$export$f870f1aaf41fd9d9 = "Ye-QYG_statusItem";
$9c9acf691ee5dd89$export$f6ec0f1c757b56b8 = "Ye-QYG_statusSection";
$9c9acf691ee5dd89$export$4ac653885abdd1d4 = "Ye-QYG_systemSubtitle";
$9c9acf691ee5dd89$export$d32f18b7f7721ef0 = "Ye-QYG_systemTitle";


var $77c8f0735dbc1c18$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $77c8f0735dbc1c18$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $77c8f0735dbc1c18$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $77c8f0735dbc1c18$export$a476b4f7d4df5522 = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var SessionBox = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "handleSubmit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(event) {
                    event.preventDefault();
                    var _formToJSON = (0, $6tqvJ.formToJSON)(event.currentTarget), email = _formToJSON.email, password = _formToJSON.password;
                    (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).signIn(email, password);
                }
            });
            Object.defineProperty(_this, "renderForm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("form", {
                        className: $9c9acf691ee5dd89$export$1afaec556d5731ad,
                        onSubmit: _this.handleSubmit,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: $9c9acf691ee5dd89$export$d2297815c52203ee,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("label", {
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('username')
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: $9c9acf691ee5dd89$export$248a47518f3a0001,
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "person",
                                                className: $9c9acf691ee5dd89$export$76006b3b1ed92028
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                                type: "text",
                                                name: "email",
                                                placeholder: (0, $50993b47476de2e7$export$625550452a3fa3ec)('enter_username'),
                                                required: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: $9c9acf691ee5dd89$export$d2297815c52203ee,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("label", {
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('password')
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: $9c9acf691ee5dd89$export$248a47518f3a0001,
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "lock",
                                                className: $9c9acf691ee5dd89$export$76006b3b1ed92028
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                                type: "password",
                                                name: "password",
                                                placeholder: (0, $50993b47476de2e7$export$625550452a3fa3ec)('enter_password'),
                                                required: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: $9c9acf691ee5dd89$export$b507296dd3c7a2ce,
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("label", {
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                            type: "checkbox"
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('remember_login')
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("button", {
                                type: "submit",
                                className: $9c9acf691ee5dd89$export$7abe78e1eda562aa,
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('login_now')
                            })
                        ]
                    });
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "render",
                value: function render() {
                    return (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).session ? this.props.children : (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "position-fixed start-0 top-0 w-100 h-100 bg-white d-flex",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: $9c9acf691ee5dd89$export$9e2d21f784c42f44,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("hgroup", {
                                        className: $9c9acf691ee5dd89$export$ef604ebebea21dcf,
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $b533b81bb3fec826$export$6fb48dc3079cee11), {
                                                className: $9c9acf691ee5dd89$export$eb1a6f91881a35fd
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h1", {
                                                        className: $9c9acf691ee5dd89$export$d32f18b7f7721ef0,
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_work_order')
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                                        className: $9c9acf691ee5dd89$export$4ac653885abdd1d4,
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_ai_assistant')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", {
                                        className: $9c9acf691ee5dd89$export$f6ec0f1c757b56b8,
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                                                className: $9c9acf691ee5dd89$export$f870f1aaf41fd9d9,
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                        name: "check-circle",
                                                        className: $9c9acf691ee5dd89$export$6d2e7473e733612a
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('system_normal')
                                                    })
                                                ]
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                                                className: $9c9acf691ee5dd89$export$f870f1aaf41fd9d9,
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                        name: "wifi",
                                                        className: $9c9acf691ee5dd89$export$6d2e7473e733612a
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('network_normal')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                        className: $9c9acf691ee5dd89$export$666c3ad173ff70db,
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('copyright_info')
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: $9c9acf691ee5dd89$export$d59c1ce74b98507b,
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: $9c9acf691ee5dd89$export$8ad55ac0c46ccac8,
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: $9c9acf691ee5dd89$export$38e42c68cf43b5d4,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                    name: "shield",
                                                    className: $9c9acf691ee5dd89$export$3f51feea65531060
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h4", {
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('user_login')
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('enter_login_info')
                                                })
                                            ]
                                        }),
                                        this.renderForm()
                                    ]
                                })
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $77c8f0735dbc1c18$var$__setFunctionName(_classThis, "SessionBox");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $77c8f0735dbc1c18$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        SessionBox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $77c8f0735dbc1c18$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return SessionBox = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



var $arNK5 = parcelRequire("arNK5");

var $62ac3db46cb6ed0e$exports = {};
var $62ac3db46cb6ed0e$var$$aac96070b6d8b41d$export$5eeb11949c905cc1;


var $fClfl = parcelRequire("fClfl");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $218cf913ebc6a9cf$var$ButtonGroup = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, _param_vertical = _param.vertical, vertical = _param_vertical === void 0 ? false : _param_vertical, className = _param.className, _param_role = _param.role, role = _param_role === void 0 ? 'group' : _param_role, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, rest = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "size",
        "vertical",
        "className",
        "role",
        "as"
    ]);
    var prefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    var baseClass = prefix;
    if (vertical) baseClass = "".concat(prefix, "-vertical");
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, rest), {
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, baseClass, size && "".concat(prefix, "-").concat(size))
    }));
});
$218cf913ebc6a9cf$var$ButtonGroup.displayName = 'ButtonGroup';
var $218cf913ebc6a9cf$export$2e2bcd8739ae039 = $218cf913ebc6a9cf$var$ButtonGroup;


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");



var $6mMqj = parcelRequire("6mMqj");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


var $7609797d653842d6$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).elementType
};
var $7609797d653842d6$var$Feedback = /*#__PURE__*/ $6mMqj.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? 'valid' : _param_type, _param_tooltip = _param.tooltip, tooltip = _param_tooltip === void 0 ? false : _param_tooltip, props = (0, $8MJI4._)(_param, [
        "as",
        "className",
        "type",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, "".concat(type, "-").concat(tooltip ? 'tooltip' : 'feedback'))
    }));
});
$7609797d653842d6$var$Feedback.displayName = 'Feedback';
$7609797d653842d6$var$Feedback.propTypes = $7609797d653842d6$var$propTypes;
var $7609797d653842d6$export$2e2bcd8739ae039 = $7609797d653842d6$var$Feedback;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
"use client";
// TODO
var $7776ff134f053f61$var$FormContext = /*#__PURE__*/ $fClfl.createContext({});
var $7776ff134f053f61$export$2e2bcd8739ae039 = $7776ff134f053f61$var$FormContext;




"use client";
var $e14e249815b81549$var$FormCheckInput = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var id = _param.id, bsPrefix = _param.bsPrefix, className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? 'checkbox' : _param_type, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'input' : tmp, props = (0, $8MJI4._)(_param, [
        "id",
        "bsPrefix",
        "className",
        "type",
        "isValid",
        "isInvalid",
        "as"
    ]);
    var controlId = (0, $12aPv.useContext)((0, $7776ff134f053f61$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$e14e249815b81549$var$FormCheckInput.displayName = 'FormCheckInput';
var $e14e249815b81549$export$2e2bcd8739ae039 = $e14e249815b81549$var$FormCheckInput;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



"use client";
var $4f99b535bf394f81$var$FormCheckLabel = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, htmlFor = _param.htmlFor, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "htmlFor"
    ]);
    var controlId = (0, $12aPv.useContext)((0, $7776ff134f053f61$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("label", (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }));
});
$4f99b535bf394f81$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $4f99b535bf394f81$export$2e2bcd8739ae039 = $4f99b535bf394f81$var$FormCheckLabel;





var $6mMqj = parcelRequire("6mMqj");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $93a729f6ca0a816f$export$871de8747c9eaa88(children, func) {
    var index = 0;
    return $6mMqj.Children.map(children, function(child) {
        return /*#__PURE__*/ $6mMqj.isValidElement(child) ? func(child, index++) : child;
    });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $93a729f6ca0a816f$export$4b80e395e36b5a56(children, func) {
    var index = 0;
    $6mMqj.Children.forEach(children, function(child) {
        if (/*#__PURE__*/ $6mMqj.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $93a729f6ca0a816f$export$500fd6099226ffae(children, type) {
    return $6mMqj.Children.toArray(children).some(function(child) {
        return /*#__PURE__*/ $6mMqj.isValidElement(child) && child.type === type;
    });
}



var $fClfl = parcelRequire("fClfl");
"use client";
var $c996fbf445bb44a0$var$FormCheck = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var id = _param.id, bsPrefix = _param.bsPrefix, bsSwitchPrefix = _param.bsSwitchPrefix, _param_inline = _param.inline, inline = _param_inline === void 0 ? false : _param_inline, _param_reverse = _param.reverse, reverse = _param_reverse === void 0 ? false : _param_reverse, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, _param_feedbackTooltip = _param.feedbackTooltip, feedbackTooltip = _param_feedbackTooltip === void 0 ? false : _param_feedbackTooltip, feedback = _param.feedback, feedbackType = _param.feedbackType, className = _param.className, style = _param.style, _param_title = _param.title, title = _param_title === void 0 ? '' : _param_title, _param_type = _param.type, type = _param_type === void 0 ? 'checkbox' : _param_type, label = _param.label, children = _param.children, _param_as = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, as = _param_as === void 0 ? 'input' : _param_as, props = (0, $8MJI4._)(_param, [
        "id",
        "bsPrefix",
        "bsSwitchPrefix",
        "inline",
        "reverse",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "feedbackType",
        "className",
        "style",
        "title",
        "type",
        "label",
        "children",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    var controlId = (0, $12aPv.useContext)((0, $7776ff134f053f61$export$2e2bcd8739ae039)).controlId;
    var innerFormContext = (0, $12aPv.useMemo)(function() {
        return {
            controlId: id || controlId
        };
    }, [
        controlId,
        id
    ]);
    var hasLabel = !children && label != null && label !== false || (0, $93a729f6ca0a816f$export$500fd6099226ffae)(children, (0, $4f99b535bf394f81$export$2e2bcd8739ae039));
    var input = /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e14e249815b81549$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({}, props), {
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    }));
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $7776ff134f053f61$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, hasLabel && bsPrefix, inline && "".concat(bsPrefix, "-inline"), reverse && "".concat(bsPrefix, "-reverse"), type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4f99b535bf394f81$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $7609797d653842d6$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$c996fbf445bb44a0$var$FormCheck.displayName = 'FormCheck';
var $c996fbf445bb44a0$export$2e2bcd8739ae039 = Object.assign($c996fbf445bb44a0$var$FormCheck, {
    Input: (0, $e14e249815b81549$export$2e2bcd8739ae039),
    Label: (0, $4f99b535bf394f81$export$2e2bcd8739ae039)
});



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");





"use client";
var $5c296c727f05ae92$var$FormControl = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, type = _param.type, size = _param.size, htmlSize = _param.htmlSize, id = _param.id, className = _param.className, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, plaintext = _param.plaintext, readOnly = _param.readOnly, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'input' : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "type",
        "size",
        "htmlSize",
        "id",
        "className",
        "isValid",
        "isInvalid",
        "plaintext",
        "readOnly",
        "as"
    ]);
    var controlId = (0, $12aPv.useContext)((0, $7776ff134f053f61$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, plaintext ? "".concat(bsPrefix, "-plaintext") : bsPrefix, size && "".concat(bsPrefix, "-").concat(size), type === 'color' && "".concat(bsPrefix, "-color"), isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$5c296c727f05ae92$var$FormControl.displayName = 'FormControl';
var $5c296c727f05ae92$export$2e2bcd8739ae039 = Object.assign($5c296c727f05ae92$var$FormControl, {
    Feedback: (0, $7609797d653842d6$export$2e2bcd8739ae039)
});



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $546682e9f5e0b58b$var$FormFloating = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$546682e9f5e0b58b$var$FormFloating.displayName = 'FormFloating';
var $546682e9f5e0b58b$export$2e2bcd8739ae039 = $546682e9f5e0b58b$var$FormFloating;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");


var $1149514afcb74ea9$var$FormGroup = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var controlId = _param.controlId, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "controlId",
        "as"
    ]);
    var context = (0, $12aPv.useMemo)(function() {
        return {
            controlId: controlId
        };
    }, [
        controlId
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $7776ff134f053f61$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
            ref: ref
        }))
    });
});
$1149514afcb74ea9$var$FormGroup.displayName = 'FormGroup';
var $1149514afcb74ea9$export$2e2bcd8739ae039 = $1149514afcb74ea9$var$FormGroup;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");





"use client";
var $0ad824080dcab3e5$var$FormLabel = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'label' : tmp, bsPrefix = _param.bsPrefix, _param_column = _param.column, column = _param_column === void 0 ? false : _param_column, _param_visuallyHidden = _param.visuallyHidden, visuallyHidden = _param_visuallyHidden === void 0 ? false : _param_visuallyHidden, className = _param.className, htmlFor = _param.htmlFor, props = (0, $8MJI4._)(_param, [
        "as",
        "bsPrefix",
        "column",
        "visuallyHidden",
        "className",
        "htmlFor"
    ]);
    var controlId = (0, $12aPv.useContext)((0, $7776ff134f053f61$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    var columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = "".concat(columnClass, " ").concat(columnClass, "-").concat(column);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), (0, $6GCxi._)({
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor
    }, props));
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: classes,
        htmlFor: htmlFor
    }, props));
});
$0ad824080dcab3e5$var$FormLabel.displayName = 'FormLabel';
var $0ad824080dcab3e5$export$2e2bcd8739ae039 = $0ad824080dcab3e5$var$FormLabel;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



"use client";
var $81d190b9f3d772fa$var$FormRange = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, id = _param.id, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "id"
    ]);
    var controlId = (0, $12aPv.useContext)((0, $7776ff134f053f61$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", (0, $ctBui._)((0, $6GCxi._)({}, props), {
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        id: id || controlId
    }));
});
$81d190b9f3d772fa$var$FormRange.displayName = 'FormRange';
var $81d190b9f3d772fa$export$2e2bcd8739ae039 = $81d190b9f3d772fa$var$FormRange;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");



"use client";
var $8ff2da639f9d47e6$var$FormSelect = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, htmlSize = _param.htmlSize, className = _param.className, _param_isValid = _param.isValid, isValid = _param_isValid === void 0 ? false : _param_isValid, _param_isInvalid = _param.isInvalid, isInvalid = _param_isInvalid === void 0 ? false : _param_isInvalid, id = _param.id, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "size",
        "htmlSize",
        "className",
        "isValid",
        "isInvalid",
        "id"
    ]);
    var controlId = (0, $12aPv.useContext)((0, $7776ff134f053f61$export$2e2bcd8739ae039)).controlId;
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("select", (0, $ctBui._)((0, $6GCxi._)({}, props), {
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), isValid && "is-valid", isInvalid && "is-invalid"),
        id: id || controlId
    }));
});
$8ff2da639f9d47e6$var$FormSelect.displayName = 'FormSelect';
var $8ff2da639f9d47e6$export$2e2bcd8739ae039 = $8ff2da639f9d47e6$var$FormSelect;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $e93868cca7ea8156$var$FormText = /*#__PURE__*/ $6mMqj.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.as, Component = tmp === void 0 ? 'small' : tmp, muted = _param.muted, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "as",
        "muted"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, muted && 'text-muted')
    }));
});
$e93868cca7ea8156$var$FormText.displayName = 'FormText';
var $e93868cca7ea8156$export$2e2bcd8739ae039 = $e93868cca7ea8156$var$FormText;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $6mMqj = parcelRequire("6mMqj");


var $0f6cdd1e14b5fc49$var$Switch = /*#__PURE__*/ $6mMqj.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c996fbf445bb44a0$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        type: "switch"
    }));
});
$0f6cdd1e14b5fc49$var$Switch.displayName = 'Switch';
var $0f6cdd1e14b5fc49$export$2e2bcd8739ae039 = Object.assign($0f6cdd1e14b5fc49$var$Switch, {
    Input: (0, $c996fbf445bb44a0$export$2e2bcd8739ae039).Input,
    Label: (0, $c996fbf445bb44a0$export$2e2bcd8739ae039).Label
});



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");



"use client";
var $c72fb70b90e21e2b$var$FloatingLabel = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, children = _param.children, controlId = _param.controlId, label = _param.label, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "children",
        "controlId",
        "label"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1149514afcb74ea9$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        controlId: controlId
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    }));
});
$c72fb70b90e21e2b$var$FloatingLabel.displayName = 'FloatingLabel';
var $c72fb70b90e21e2b$export$2e2bcd8739ae039 = $c72fb70b90e21e2b$var$FloatingLabel;



var $aec14c1b82632aca$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).elementType
};
var $aec14c1b82632aca$var$Form = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, validated = _param.validated, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'form' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "validated",
        "as"
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, validated && 'was-validated')
    }));
});
$aec14c1b82632aca$var$Form.displayName = 'Form';
$aec14c1b82632aca$var$Form.propTypes = $aec14c1b82632aca$var$propTypes;
var $aec14c1b82632aca$export$2e2bcd8739ae039 = Object.assign($aec14c1b82632aca$var$Form, {
    Group: (0, $1149514afcb74ea9$export$2e2bcd8739ae039),
    Control: (0, $5c296c727f05ae92$export$2e2bcd8739ae039),
    Floating: (0, $546682e9f5e0b58b$export$2e2bcd8739ae039),
    Check: (0, $c996fbf445bb44a0$export$2e2bcd8739ae039),
    Switch: (0, $0f6cdd1e14b5fc49$export$2e2bcd8739ae039),
    Label: (0, $0ad824080dcab3e5$export$2e2bcd8739ae039),
    Text: (0, $e93868cca7ea8156$export$2e2bcd8739ae039),
    Range: (0, $81d190b9f3d772fa$export$2e2bcd8739ae039),
    Select: (0, $8ff2da639f9d47e6$export$2e2bcd8739ae039),
    FloatingLabel: (0, $c72fb70b90e21e2b$export$2e2bcd8739ae039)
});


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");




var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $d5534aeaf0793fc1$var$InputGroupText = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'span' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$d5534aeaf0793fc1$var$InputGroupText.displayName = 'InputGroupText';
var $d5534aeaf0793fc1$export$2e2bcd8739ae039 = $d5534aeaf0793fc1$var$InputGroupText;



"use client";
var $0f0265dfbf11fad4$var$InputGroupCheckbox = function(props) {
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $d5534aeaf0793fc1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e14e249815b81549$export$2e2bcd8739ae039), (0, $6GCxi._)({
            type: "checkbox"
        }, props))
    });
};
var $0f0265dfbf11fad4$var$InputGroupRadio = function(props) {
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $d5534aeaf0793fc1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e14e249815b81549$export$2e2bcd8739ae039), (0, $6GCxi._)({
            type: "radio"
        }, props))
    });
};
var $0f0265dfbf11fad4$var$InputGroup = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, size = _param.size, hasValidation = _param.hasValidation, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "size",
        "hasValidation",
        "className",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    var contextValue = (0, $12aPv.useMemo)(function() {
        return {};
    }, []);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $dabdca7318d4a13a$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, size && "".concat(bsPrefix, "-").concat(size), hasValidation && 'has-validation')
        }))
    });
});
$0f0265dfbf11fad4$var$InputGroup.displayName = 'InputGroup';
var $0f0265dfbf11fad4$export$2e2bcd8739ae039 = Object.assign($0f0265dfbf11fad4$var$InputGroup, {
    Text: (0, $d5534aeaf0793fc1$export$2e2bcd8739ae039),
    Radio: $0f0265dfbf11fad4$var$InputGroupRadio,
    Checkbox: $0f0265dfbf11fad4$var$InputGroupCheckbox
});


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");

var $leE2g = parcelRequire("leE2g");






var $1a02a97bdd063b41$var$size;
function $1a02a97bdd063b41$export$2e2bcd8739ae039(recalc) {
    if (!$1a02a97bdd063b41$var$size && $1a02a97bdd063b41$var$size !== 0 || recalc) {
        if (0, $64f258eaaf92e603$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $1a02a97bdd063b41$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $1a02a97bdd063b41$var$size;
}


parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");
function $04ca96cfed6ec0bf$export$2e2bcd8739ae039() {
    return (0, $12aPv.useState)(null);
}







var $6mMqj = parcelRequire("6mMqj");
var $12aPv = parcelRequire("12aPv");




var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $05facf676c5993f9$var$ModalBody = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$05facf676c5993f9$var$ModalBody.displayName = 'ModalBody';
var $05facf676c5993f9$export$2e2bcd8739ae039 = $05facf676c5993f9$var$ModalBody;




var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


"use client";
var $087073d096edf317$var$ModalDialog = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, contentClassName = _param.contentClassName, centered = _param.centered, size = _param.size, fullscreen = _param.fullscreen, children = _param.children, scrollable = _param.scrollable, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "contentClassName",
        "centered",
        "size",
        "fullscreen",
        "children",
        "scrollable"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'modal');
    var dialogClass = "".concat(bsPrefix, "-dialog");
    var fullScreenClass = typeof fullscreen === 'string' ? "".concat(bsPrefix, "-fullscreen-").concat(fullscreen) : "".concat(bsPrefix, "-fullscreen");
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(dialogClass, className, size && "".concat(bsPrefix, "-").concat(size), centered && "".concat(dialogClass, "-centered"), scrollable && "".concat(dialogClass, "-scrollable"), fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-content"), contentClassName),
            children: children
        })
    }));
});
$087073d096edf317$var$ModalDialog.displayName = 'ModalDialog';
var $087073d096edf317$export$2e2bcd8739ae039 = $087073d096edf317$var$ModalDialog;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");



"use client";
var $da1947298d40a423$var$ModalFooter = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? 'div' : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$da1947298d40a423$var$ModalFooter.displayName = 'ModalFooter';
var $da1947298d40a423$export$2e2bcd8739ae039 = $da1947298d40a423$var$ModalFooter;



var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");



"use client";
var $a36690fa5d0d781c$var$ModalHeader = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_closeLabel = _param.closeLabel, closeLabel = _param_closeLabel === void 0 ? 'Close' : _param_closeLabel, _param_closeButton = _param.closeButton, closeButton = _param_closeButton === void 0 ? false : _param_closeButton, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $bdd1b17e5034285f$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$a36690fa5d0d781c$var$ModalHeader.displayName = 'ModalHeader';
var $a36690fa5d0d781c$export$2e2bcd8739ae039 = $a36690fa5d0d781c$var$ModalHeader;



var $6GCxi = parcelRequire("6GCxi");

var $8MJI4 = parcelRequire("8MJI4");

var $6mMqj = parcelRequire("6mMqj");




"use client";
var $a9cbebb6633d5061$var$DivStyledAsH4 = (0, $197a01a380243da0$export$2e2bcd8739ae039)('h4');
var $a9cbebb6633d5061$var$ModalTitle = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var className = _param.className, bsPrefix = _param.bsPrefix, tmp = _param.as, Component = tmp === void 0 ? $a9cbebb6633d5061$var$DivStyledAsH4 : tmp, props = (0, $8MJI4._)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $6GCxi._)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix)
    }, props));
});
$a9cbebb6633d5061$var$ModalTitle.displayName = 'ModalTitle';
var $a9cbebb6633d5061$export$2e2bcd8739ae039 = $a9cbebb6633d5061$var$ModalTitle;




"use client";
function $365d964e345f76dd$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f4bd4b28ec6f3d4e$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({}, props), {
        timeout: null
    }));
}
function $365d964e345f76dd$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f4bd4b28ec6f3d4e$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({}, props), {
        timeout: null
    }));
}
var $365d964e345f76dd$var$Modal = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, style = _param.style, dialogClassName = _param.dialogClassName, contentClassName = _param.contentClassName, children = _param.children, tmp = _param.dialogAs, Dialog = tmp === void 0 ? (0, $087073d096edf317$export$2e2bcd8739ae039) : tmp, dataBsTheme = _param['data-bs-theme'], ariaLabelledby = _param['aria-labelledby'], ariaDescribedby = _param['aria-describedby'], ariaLabel = _param['aria-label'], _param_show = _param./* BaseModal props */ show, show = _param_show === void 0 ? false : _param_show, _param_animation = _param.animation, animation = _param_animation === void 0 ? true : _param_animation, _param_backdrop = _param.backdrop, backdrop = _param_backdrop === void 0 ? true : _param_backdrop, _param_keyboard = _param.keyboard, keyboard = _param_keyboard === void 0 ? true : _param_keyboard, onEscapeKeyDown = _param.onEscapeKeyDown, onShow = _param.onShow, onHide = _param.onHide, container = _param.container, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? true : _param_autoFocus, _param_enforceFocus = _param.enforceFocus, enforceFocus = _param_enforceFocus === void 0 ? true : _param_enforceFocus, _param_restoreFocus = _param.restoreFocus, restoreFocus = _param_restoreFocus === void 0 ? true : _param_restoreFocus, restoreFocusOptions = _param.restoreFocusOptions, onEntered = _param.onEntered, onExit = _param.onExit, onExiting = _param.onExiting, onEnter = _param.onEnter, onEntering = _param.onEntering, onExited = _param.onExited, backdropClassName = _param.backdropClassName, propsManager = _param.manager, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "style",
        "dialogClassName",
        "contentClassName",
        "children",
        "dialogAs",
        'data-bs-theme',
        'aria-labelledby',
        'aria-describedby',
        'aria-label',
        "show",
        "animation",
        "backdrop",
        "keyboard",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager"
    ]);
    var _useState = (0, $leE2g._)((0, $12aPv.useState)({}), 2), modalStyle = _useState[0], setStyle = _useState[1];
    var _useState1 = (0, $leE2g._)((0, $12aPv.useState)(false), 2), animateStaticModal = _useState1[0], setAnimateStaticModal = _useState1[1];
    var waitingForMouseUpRef = (0, $12aPv.useRef)(false);
    var ignoreBackdropClickRef = (0, $12aPv.useRef)(false);
    var removeStaticModalAnimationRef = (0, $12aPv.useRef)(null);
    var _useCallbackRef = (0, $leE2g._)((0, $04ca96cfed6ec0bf$export$2e2bcd8739ae039)(), 2), modal = _useCallbackRef[0], setModalRef = _useCallbackRef[1];
    var mergedRef = (0, $3a5cc5c5ad7c23ef$export$2e2bcd8739ae039)(ref, setModalRef);
    var handleHide = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(onHide);
    var isRTL = (0, $fb3854fa54537b64$export$35e511eefa30ac5a)();
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'modal');
    var modalContext = (0, $12aPv.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $d679232cd27e43e1$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $64f258eaaf92e603$export$2e2bcd8739ae039)) return;
        var containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        var modalIsOverflowing = node.scrollHeight > (0, $cb03b130654deaba$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $1a02a97bdd063b41$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $1a02a97bdd063b41$export$2e2bcd8739ae039)() : undefined
        });
    }
    var handleWindowResize = (0, $5eab4b92b9a4d41c$export$2e2bcd8739ae039)(function() {
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $894eb9f2b4db4bf9$export$2e2bcd8739ae039)(function() {
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    var handleDialogMouseDown = function() {
        waitingForMouseUpRef.current = true;
    };
    var handleMouseUp = function(e) {
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    var handleStaticModalAnimation = function() {
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $eb2ed0bd2d792c29$export$2e2bcd8739ae039)(modal.dialog, function() {
            setAnimateStaticModal(false);
        });
    };
    var handleStaticBackdropClick = function(e) {
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    var handleClick = function(e) {
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    var handleEscapeKeyDown = function(e) {
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    var handleEnter = function(node, isAppearing) {
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    var handleExit = function(node) {
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    var handleEntering = function(node, isAppearing) {
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $fe9809a8616a080a$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    var handleExited = function(node) {
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $0e5e4de4085acd94$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    var renderBackdrop = (0, $12aPv.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("".concat(bsPrefix, "-backdrop"), backdropClassName, !animation && 'show')
        }));
    }, [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    var baseModalStyle = (0, $6GCxi._)({}, style, modalStyle);
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    var renderDialog = function(dialogProps) {
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({
            role: "dialog"
        }, dialogProps), {
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix, animateStaticModal && "".concat(bsPrefix, "-static"), !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Dialog, (0, $ctBui._)((0, $6GCxi._)({}, props), {
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            }))
        }));
    };
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $ef43a88dc0d809e8$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $7aeba65c918723c4$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $365d964e345f76dd$var$DialogTransition : undefined,
            backdropTransition: animation ? $365d964e345f76dd$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$365d964e345f76dd$var$Modal.displayName = 'Modal';
var $365d964e345f76dd$export$2e2bcd8739ae039 = Object.assign($365d964e345f76dd$var$Modal, {
    Body: (0, $05facf676c5993f9$export$2e2bcd8739ae039),
    Header: (0, $a36690fa5d0d781c$export$2e2bcd8739ae039),
    Title: (0, $a9cbebb6633d5061$export$2e2bcd8739ae039),
    Footer: (0, $da1947298d40a423$export$2e2bcd8739ae039),
    Dialog: (0, $087073d096edf317$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");


var $c740342d215ad7ed$var$PageItem = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var _param_active = _param.active, active = _param_active === void 0 ? false : _param_active, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = _param.className, style = _param.style, _param_activeLabel = _param.activeLabel, activeLabel = _param_activeLabel === void 0 ? '(current)' : _param_activeLabel, children = _param.children, linkStyle = _param.linkStyle, linkClassName = _param.linkClassName, _param_as = _param.as, as = _param_as === void 0 ? (0, $5a6bc24f902d75f2$export$2e2bcd8739ae039) : _param_as, props = (0, $8MJI4._)(_param, [
        "active",
        "disabled",
        "className",
        "style",
        "activeLabel",
        "children",
        "linkStyle",
        "linkClassName",
        "as"
    ]);
    var Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, 'page-item', {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)(Component, (0, $ctBui._)((0, $6GCxi._)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))('page-link', linkClassName),
            style: linkStyle
        }, props), {
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        }))
    });
});
$c740342d215ad7ed$var$PageItem.displayName = 'PageItem';
var $c740342d215ad7ed$export$2e2bcd8739ae039 = $c740342d215ad7ed$var$PageItem;
function $c740342d215ad7ed$var$createButton(name, defaultValue) {
    var label = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : name;
    var Button = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
        var children = _param.children, props = (0, $8MJI4._)(_param, [
            "children"
        ]);
        return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)($c740342d215ad7ed$var$PageItem, (0, $ctBui._)((0, $6GCxi._)({}, props), {
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    });
    Button.displayName = name;
    return Button;
}
var $c740342d215ad7ed$export$b25abba66f7be210 = $c740342d215ad7ed$var$createButton('First', "\xab");
var $c740342d215ad7ed$export$1b265216817111b9 = $c740342d215ad7ed$var$createButton('Prev', "\u2039", 'Previous');
var $c740342d215ad7ed$export$1297970233533a7d = $c740342d215ad7ed$var$createButton('Ellipsis', "\u2026", 'More');
var $c740342d215ad7ed$export$b820fc49f2736e85 = $c740342d215ad7ed$var$createButton('Next', "\u203A");
var $c740342d215ad7ed$export$bed9238d8933c9a8 = $c740342d215ad7ed$var$createButton('Last', "\xbb");



"use client";
var $26712abca8b89b64$var$Pagination = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, size = _param.size, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "className",
        "size"
    ]);
    var decoratedBsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, decoratedBsPrefix, size && "".concat(decoratedBsPrefix, "-").concat(size))
    }));
});
$26712abca8b89b64$var$Pagination.displayName = 'Pagination';
var $26712abca8b89b64$export$2e2bcd8739ae039 = Object.assign($26712abca8b89b64$var$Pagination, {
    First: (0, $c740342d215ad7ed$export$b25abba66f7be210),
    Prev: (0, $c740342d215ad7ed$export$1b265216817111b9),
    Ellipsis: (0, $c740342d215ad7ed$export$1297970233533a7d),
    Item: (0, $c740342d215ad7ed$export$2e2bcd8739ae039),
    Next: (0, $c740342d215ad7ed$export$b820fc49f2736e85),
    Last: (0, $c740342d215ad7ed$export$bed9238d8933c9a8)
});



var $6tqvJ = parcelRequire("6tqvJ");








var $arNK5 = parcelRequire("arNK5");

var $28c230f99d2758cc$exports = {};








var $cInIr = parcelRequire("cInIr");

var $arNK5 = parcelRequire("arNK5");
parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");

var $6tqvJ = parcelRequire("6tqvJ");
function $28c230f99d2758cc$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $28c230f99d2758cc$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $28c230f99d2758cc$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $28c230f99d2758cc$var$$0172b398bee57f0a$exports = {};
$28c230f99d2758cc$var$$parcel$export($28c230f99d2758cc$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $28c230f99d2758cc$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $28c230f99d2758cc$var$$parcel$export($28c230f99d2758cc$var$$0172b398bee57f0a$exports, "reaction", function() {
    return $28c230f99d2758cc$var$$0172b398bee57f0a$export$7203b476385689ae;
}), $28c230f99d2758cc$var$$parcel$export($28c230f99d2758cc$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $28c230f99d2758cc$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $28c230f99d2758cc$var$$0172b398bee57f0a$var$__esDecorate = function $0172b398bee57f0a$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $28c230f99d2758cc$var$$0172b398bee57f0a$var$__runInitializers = function $0172b398bee57f0a$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function $0172b398bee57f0a$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function $0172b398bee57f0a$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $28c230f99d2758cc$var$$0172b398bee57f0a$export$7112c88e033533b8 = function $0172b398bee57f0a$export$7112c88e033533b8(e, t) {
    return $28c230f99d2758cc$var$$parcel$interopDefault($cInIr)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $28c230f99d2758cc$var$$0172b398bee57f0a$var$reactionMap = new WeakMap, $28c230f99d2758cc$var$$0172b398bee57f0a$export$7203b476385689ae = function $0172b398bee57f0a$export$7203b476385689ae(e) {
    return function(t, r) {
        return (0, r.addInitializer)(function() {
            var _$r = $28c230f99d2758cc$var$$0172b398bee57f0a$var$reactionMap.get(this) || [];
            _$r.push({
                expression: e,
                effect: t
            }), $28c230f99d2758cc$var$$0172b398bee57f0a$var$reactionMap.set(this, _$r);
        });
    };
}, $28c230f99d2758cc$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, $, u, f = $fClfl.Component, d = [], b = [], p = [], v = [], _ = [], h = [];
    return r = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), s.set(_$e, $28c230f99d2758cc$var$$0172b398bee57f0a$var$__runInitializers(_$e, d, _$e.props)), n.set(_$e, ($28c230f99d2758cc$var$$0172b398bee57f0a$var$__runInitializers(_$e, b), $28c230f99d2758cc$var$$0172b398bee57f0a$var$__runInitializers(_$e, p, _$e.state))), i.set(_$e, ($28c230f99d2758cc$var$$0172b398bee57f0a$var$__runInitializers(_$e, v), $28c230f99d2758cc$var$$0172b398bee57f0a$var$__runInitializers(_$e, _, _$e.context))), a.set(_$e, $28c230f99d2758cc$var$$0172b398bee57f0a$var$__runInitializers(_$e, h)), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function get() {
                    return $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedState",
                get: function get() {
                    return $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function set(e) {
                    $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function get() {
                    return $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, i, "f");
                },
                set: function set(e) {
                    $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, i, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e, _$t = this;
                    $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, null == (_$e = $28c230f99d2758cc$var$$0172b398bee57f0a$var$reactionMap.get(this)) ? void 0 : _$e.map(function(e) {
                        var r = e.expression, a = e.effect;
                        return (0, $arNK5.reaction)(function(e) {
                            return r(_$t, e);
                        }, a.bind(_$t));
                    }), "f");
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e;
                    null == (_$e = $28c230f99d2758cc$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f")) || _$e.forEach(function(e) {
                        return e();
                    });
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e, r, a) {
                    var s;
                    $28c230f99d2758cc$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $28c230f99d2758cc$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }(f), a = new WeakMap, s = new WeakMap, n = new WeakMap, i = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, l = [
        (e = $arNK5.observable).shallow.bind(e)
    ], $ = [
        (c = $arNK5.observable).shallow.bind(c)
    ], u = [
        (o = $arNK5.observable).shallow.bind(o)
    ], $28c230f99d2758cc$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedProps" in e;
            },
            get: function get(e) {
                return e.observedProps;
            },
            set: function set(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, d, b), $28c230f99d2758cc$var$$0172b398bee57f0a$var$__esDecorate(r, null, $, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedState" in e;
            },
            get: function get(e) {
                return e.observedState;
            },
            set: function set(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, p, v), $28c230f99d2758cc$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "observedContext" in e;
            },
            get: function get(e) {
                return e.observedContext;
            },
            set: function set(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, _, h), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $28c230f99d2758cc$var$$621b7277d4dc39e9$exports = {};
$28c230f99d2758cc$var$$parcel$export($28c230f99d2758cc$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $28c230f99d2758cc$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__runInitializers = function $621b7277d4dc39e9$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__esDecorate = function $621b7277d4dc39e9$var$__esDecorate(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function $621b7277d4dc39e9$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function $621b7277d4dc39e9$var$__classPrivateFieldSet(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $28c230f99d2758cc$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], $ = [], u = [];
    return e = function(e) {
        "use strict";
        function n() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, n), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(_$e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($28c230f99d2758cc$var$$621b7277d4dc39e9$var$__runInitializers(_$e, l), (0, $fClfl.createRef)())
            }), s.set(_$e, $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__runInitializers(_$e, $, _$e.props.defaultValue)), t.set(_$e, $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__runInitializers(_$e, u)), r.set(_$e, void 0), a.set(_$e, function(t) {
                !(0, $6tqvJ.isEmpty)(t) && (0, $6tqvJ.isEmpty)(_$e.innerValue) && (_$e.innerValue = t);
            }), Object.defineProperty(_$e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r, a;
                    return null == (a = (r = _$e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "object" ? (0, $arNK5.toJS)(t) : t);
                }
            }), Object.defineProperty(_$e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    return _$e.innerValue = _$e.props.defaultValue;
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(n, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function get() {
                    return $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function set(e) {
                    $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function get() {
                    var _$e;
                    return null != (_$e = this.observedProps.value) ? _$e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e, s, _$n = this;
                    $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $arNK5.reaction)(function() {
                        return _$n.observedProps.defaultValue;
                    }, $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $arNK5.reaction)(function() {
                        return _$n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (_$e = this.ref.current) ? void 0 : _$e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    var _$e, a, s, _$n;
                    null == (_$e = $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || _$e.call(this), $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (_$n = null == (s = this.ref.current) ? void 0 : s.form) || _$n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($28c230f99d2758cc$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $28c230f99d2758cc$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $arNK5.observable
    ], i = [
        $arNK5.computed
    ], $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "innerValue" in e;
            },
            get: function get(e) {
                return e.innerValue;
            },
            set: function set(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, $, u), $28c230f99d2758cc$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "value" in e;
            },
            get: function get(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$28c230f99d2758cc$var$$parcel$exportWildcard($28c230f99d2758cc$exports, $28c230f99d2758cc$var$$0172b398bee57f0a$exports), $28c230f99d2758cc$var$$parcel$exportWildcard($28c230f99d2758cc$exports, $28c230f99d2758cc$var$$621b7277d4dc39e9$exports);


var $78abda9ee4cae853$export$71511d61b312f219;
"use strict";




function $78abda9ee4cae853$var$_to_array(arr) {
    return $c7bc4073be5d29be$export$71511d61b312f219(arr) || $ca42406c5bfa9096$export$71511d61b312f219(arr) || $8d557826eabb1eea$export$71511d61b312f219(arr) || $5768a74a1d487907$export$71511d61b312f219();
}
$78abda9ee4cae853$export$71511d61b312f219 = $78abda9ee4cae853$var$_to_array;





var $5f1da914d9b7563a$export$71511d61b312f219;
"use strict";
function $5f1da914d9b7563a$var$_object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
$5f1da914d9b7563a$export$71511d61b312f219 = $5f1da914d9b7563a$var$_object_destructuring_empty;


var $27ac2acf61c4734a$export$71511d61b312f219;
"use strict";
function $27ac2acf61c4734a$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$27ac2acf61c4734a$export$71511d61b312f219 = $27ac2acf61c4734a$var$_define_property;


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $09063b8df282f9e7$exports = {};

var $fClfl = parcelRequire("fClfl");





var $hVBqc = parcelRequire("hVBqc");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");


var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $Csf8W = parcelRequire("Csf8W");

var $hVBqc = parcelRequire("hVBqc");

var $fsSDT = parcelRequire("fsSDT");

var $Csf8W = parcelRequire("Csf8W");
var $e0062df735681f1b$export$5f747a46dc0eb6ee = function() {
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
        top.window.document._ = 0;
    } catch (e) {
        return !1;
    }
    return "showOpenFilePicker" in self;
}(), $e0062df735681f1b$var$t = $e0062df735681f1b$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e0062df735681f1b$var$c;
}) : Promise.resolve().then(function() {
    return $e0062df735681f1b$var$h;
});
function $e0062df735681f1b$export$c1bd535e520dbbc3() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var _instance;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $e0062df735681f1b$var$t
                    ];
                case 1:
                    return [
                        2,
                        (_instance = _state.sent()).default.apply(_instance, (0, $fsSDT._)(e))
                    ];
            }
        });
    })();
}
var $e0062df735681f1b$var$r = $e0062df735681f1b$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e0062df735681f1b$var$y;
}) : Promise.resolve().then(function() {
    return $e0062df735681f1b$var$b;
});
function $e0062df735681f1b$export$270aed3754275094() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var _instance;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $e0062df735681f1b$var$r
                    ];
                case 1:
                    return [
                        2,
                        (_instance = _state.sent()).default.apply(_instance, (0, $fsSDT._)(e))
                    ];
            }
        });
    })();
}
var $e0062df735681f1b$var$a = $e0062df735681f1b$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e0062df735681f1b$var$m;
}) : Promise.resolve().then(function() {
    return $e0062df735681f1b$var$_;
});
function $e0062df735681f1b$export$cf414c79194c40b9() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var _instance;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $e0062df735681f1b$var$a
                    ];
                case 1:
                    return [
                        2,
                        (_instance = _state.sent()).default.apply(_instance, (0, $fsSDT._)(e))
                    ];
            }
        });
    })();
}
var $e0062df735681f1b$var$s = function(e) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var t;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        e.getFile()
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        2,
                        (t.handle = e, t)
                    ];
            }
        });
    })();
};
var $e0062df735681f1b$export$73dd4a3df259d52 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        {}
    ];
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var t, n, r;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    t = [];
                    e.forEach(function(e, n) {
                        t[n] = {
                            description: e.description || "Files",
                            accept: {}
                        }, e.mimeTypes ? e.mimeTypes.map(function(r) {
                            t[n].accept[r] = e.extensions || [];
                        }) : t[n].accept["*/*"] = e.extensions || [];
                    });
                    return [
                        4,
                        window.showOpenFilePicker({
                            id: e[0].id,
                            startIn: e[0].startIn,
                            types: t,
                            multiple: e[0].multiple || !1,
                            excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1
                        })
                    ];
                case 1:
                    n = _state.sent();
                    return [
                        4,
                        Promise.all(n.map($e0062df735681f1b$var$s))
                    ];
                case 2:
                    r = _state.sent();
                    return [
                        2,
                        e[0].multiple ? r : r[0]
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$c = {
    __proto__: null,
    default: $e0062df735681f1b$export$73dd4a3df259d52
};
function $e0062df735681f1b$var$u(e) {
    function t(e) {
        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
        var t = e.done;
        return Promise.resolve(e.value).then(function(e) {
            return {
                value: e,
                done: t
            };
        });
    }
    return $e0062df735681f1b$var$u = function u(e) {
        this.s = e, this.n = e.next;
    }, $e0062df735681f1b$var$u.prototype = {
        s: null,
        n: null,
        next: function next() {
            return t(this.n.apply(this.s, arguments));
        },
        return: function _return(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.resolve({
                value: e,
                done: !0
            }) : t(n.apply(this.s, arguments));
        },
        throw: function _throw(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
        }
    }, new $e0062df735681f1b$var$u(e);
}
var $e0062df735681f1b$var$p = function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.name, r = arguments.length > 3 ? arguments[3] : void 0;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var i, a, o, s, l, _loop, c, d, e1, _tmp, _, _1;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = [], a = [];
                    s = !1, l = !1;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _loop = function() {
                        var o = c.value, s = "".concat(n, "/").concat(o.name);
                        "file" === o.kind ? a.push(o.getFile().then(function(t) {
                            return t.directoryHandle = e, t.handle = o, Object.defineProperty(t, "webkitRelativePath", {
                                configurable: !0,
                                enumerable: !0,
                                get: function() {
                                    return s;
                                }
                            });
                        })) : "directory" !== o.kind || !t || r && r(o) || i.push($e0062df735681f1b$var$p(o, t, s, r));
                    };
                    d = function(e) {
                        var _$t, n, r, i = 2;
                        for("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); i--;){
                            if (n && null != (_$t = e[n])) return _$t.call(e);
                            if (r && null != (_$t = e[r])) return new $e0062df735681f1b$var$u(_$t.call(e));
                            n = "@@asyncIterator", r = "@@iterator";
                        }
                        throw new TypeError("Object is not async iterable");
                    }(e.values());
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        d.next()
                    ];
                case 3:
                    if (!(s = !(c = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _loop();
                    _state.label = 4;
                case 4:
                    s = !1;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    e1 = _state.sent();
                    l = !0, o = e1;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    _tmp = s && null != d.return;
                    if (!_tmp) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        d.return()
                    ];
                case 8:
                    _tmp = _state.sent();
                    _state.label = 9;
                case 9:
                    _tmp;
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (l) throw o;
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        4,
                        Promise.all(i)
                    ];
                case 13:
                    _1 = (_ = (0, $fsSDT._).apply(void 0, [
                        _state.sent().flat()
                    ])).concat;
                    return [
                        4,
                        Promise.all(a)
                    ];
                case 14:
                    return [
                        2,
                        _1.apply(_, [
                            (0, $fsSDT._).apply(void 0, [
                                _state.sent()
                            ])
                        ])
                    ];
            }
        });
    })();
};
var $e0062df735681f1b$export$aeb41617a6d6e89 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var t;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.recursive = e.recursive || !1, e.mode = e.mode || "read";
                    return [
                        4,
                        window.showDirectoryPicker({
                            id: e.id,
                            startIn: e.startIn,
                            mode: e.mode
                        })
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        4,
                        t.values()
                    ];
                case 2:
                    return [
                        4,
                        _state.sent().next()
                    ];
                case 3:
                    return [
                        2,
                        _state.sent().done ? [
                            t
                        ] : $e0062df735681f1b$var$p(t, e.recursive, void 0, e.skipDirectory)
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$y = {
    __proto__: null,
    default: $e0062df735681f1b$export$aeb41617a6d6e89
}, $e0062df735681f1b$export$ff17ca902e7337af = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        {}
    ], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var a, o, e1, s, _tmp, l, t1, _tmp1, _;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    Array.isArray(t) || (t = [
                        t
                    ]), t[0].fileName = t[0].fileName || "Untitled";
                    a = [];
                    o = null;
                    if (!(e instanceof Blob && e.type ? o = e.type : e.headers && e.headers.get("content-type") && (o = e.headers.get("content-type")), t.forEach(function(e, t) {
                        a[t] = {
                            description: e.description || "Files",
                            accept: {}
                        }, e.mimeTypes ? (0 === t && o && e.mimeTypes.push(o), e.mimeTypes.map(function(n) {
                            a[t].accept[n] = e.extensions || [];
                        })) : o ? a[t].accept[o] = e.extensions || [] : a[t].accept["*/*"] = e.extensions || [];
                    }), n)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        n.getFile()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    if (n = null, r) throw e1;
                    return [
                        3,
                        4
                    ];
                case 4:
                    _tmp = n;
                    if (_tmp) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        window.showSaveFilePicker({
                            suggestedName: t[0].fileName,
                            id: t[0].id,
                            startIn: t[0].startIn,
                            types: a,
                            excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    _state.label = 6;
                case 6:
                    s = _tmp;
                    !n && i && i(s);
                    return [
                        4,
                        s.createWritable()
                    ];
                case 7:
                    l = _state.sent();
                    if (!("stream" in e)) return [
                        3,
                        9
                    ];
                    t1 = e.stream();
                    return [
                        4,
                        t1.pipeTo(l)
                    ];
                case 8:
                    return [
                        2,
                        (_state.sent(), s)
                    ];
                case 9:
                    if (!("body" in e)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        e.body.pipeTo(l)
                    ];
                case 10:
                    _tmp1 = (_state.sent(), s);
                    return [
                        3,
                        15
                    ];
                case 11:
                    _ = l.write;
                    return [
                        4,
                        e
                    ];
                case 12:
                    return [
                        4,
                        _.apply(l, [
                            _state.sent()
                        ])
                    ];
                case 13:
                    _state.sent();
                    return [
                        4,
                        l.close()
                    ];
                case 14:
                    _tmp1 = (_state.sent(), s);
                    _state.label = 15;
                case 15:
                    return [
                        2,
                        _tmp1
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$m = {
    __proto__: null,
    default: $e0062df735681f1b$export$ff17ca902e7337af
}, $e0062df735681f1b$export$f1c676766788056a = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        {}
    ];
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        return (0, $Csf8W.__generator)(this, function(_state) {
            return [
                2,
                (Array.isArray(e) || (e = [
                    e
                ]), new Promise(function(t, n) {
                    var r = document.createElement("input");
                    r.type = "file";
                    var i = (0, $fsSDT._)(e.map(function(e) {
                        return e.mimeTypes || [];
                    })).concat((0, $fsSDT._)(e.map(function(e) {
                        return e.extensions || [];
                    }))).join();
                    r.multiple = e[0].multiple || !1, r.accept = i || "", r.style.display = "none", document.body.append(r), r.addEventListener("cancel", function() {
                        r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
                    }), r.addEventListener("change", function() {
                        r.remove(), t(r.multiple ? Array.from(r.files) : r.files[0]);
                    }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
                }))
            ];
        });
    })();
}, $e0062df735681f1b$var$h = {
    __proto__: null,
    default: $e0062df735681f1b$export$f1c676766788056a
}, $e0062df735681f1b$export$14ab45eaad58ab5 = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
        {}
    ];
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        return (0, $Csf8W.__generator)(this, function(_state) {
            return [
                2,
                (Array.isArray(e) || (e = [
                    e
                ]), e[0].recursive = e[0].recursive || !1, new Promise(function(t, n) {
                    var r = document.createElement("input");
                    r.type = "file", r.webkitdirectory = !0, r.style.display = "none", document.body.append(r), r.addEventListener("cancel", function() {
                        r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
                    }), r.addEventListener("change", function() {
                        r.remove();
                        var n = Array.from(r.files);
                        e[0].recursive ? e[0].recursive && e[0].skipDirectory && (n = n.filter(function(t) {
                            return t.webkitRelativePath.split("/").every(function(t) {
                                return !e[0].skipDirectory({
                                    name: t,
                                    kind: "directory"
                                });
                            });
                        })) : n = n.filter(function(e) {
                            return 2 === e.webkitRelativePath.split("/").length;
                        }), t(n);
                    }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
                }))
            ];
        });
    })();
}, $e0062df735681f1b$var$b = {
    __proto__: null,
    default: $e0062df735681f1b$export$14ab45eaad58ab5
}, $e0062df735681f1b$export$19f956f8dbe9df86 = function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
        var n, r, _tmp, _, i, a;
        return (0, $Csf8W.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    Array.isArray(t) && (t = t[0]);
                    n = document.createElement("a");
                    r = e;
                    _tmp = "body" in e;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        function(e, t) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                var n, r, i, a;
                                return (0, $Csf8W.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            n = e.getReader(), r = new ReadableStream({
                                                start: function(e) {
                                                    return function t() {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                                                            return (0, $Csf8W.__generator)(this, function(_state) {
                                                                return [
                                                                    2,
                                                                    n.read().then(function(param) {
                                                                        var n = param.done, r = param.value;
                                                                        if (!n) return e.enqueue(r), t();
                                                                        e.close();
                                                                    })
                                                                ];
                                                            });
                                                        })();
                                                    }();
                                                }
                                            }), i = new Response(r);
                                            return [
                                                4,
                                                i.blob()
                                            ];
                                        case 1:
                                            a = _state.sent();
                                            return [
                                                2,
                                                (n.releaseLock(), new Blob([
                                                    a
                                                ], {
                                                    type: t
                                                }))
                                            ];
                                    }
                                });
                            })();
                        }(e.body, e.headers.get("content-type"))
                    ];
                case 1:
                    _tmp = r = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp, n.download = t.fileName || "Untitled";
                    _ = URL.createObjectURL;
                    return [
                        4,
                        r
                    ];
                case 3:
                    n.href = _.apply(URL, [
                        _state.sent()
                    ]);
                    i = function() {
                        "function" == typeof a && a();
                    }, a = t.legacySetup && t.legacySetup(i, function() {
                        return a();
                    }, n);
                    return [
                        2,
                        (n.addEventListener("click", function() {
                            setTimeout(function() {
                                return URL.revokeObjectURL(n.href);
                            }, 3e4), i();
                        }), n.click(), null)
                    ];
            }
        });
    })();
}, $e0062df735681f1b$var$_ = {
    __proto__: null,
    default: $e0062df735681f1b$export$19f956f8dbe9df86
};


function $97dd0405afd9b1ca$var$extend(destination) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (source.hasOwnProperty(key)) destination[key] = source[key];
    }
    return destination;
}
function $97dd0405afd9b1ca$var$repeat(character, count) {
    return Array(count + 1).join(character);
}
function $97dd0405afd9b1ca$var$trimLeadingNewlines(string) {
    return string.replace(/^\n*/, '');
}
function $97dd0405afd9b1ca$var$trimTrailingNewlines(string) {
    // avoid match-at-end regexp bottleneck, see #370
    var indexEnd = string.length;
    while(indexEnd > 0 && string[indexEnd - 1] === '\n')indexEnd--;
    return string.substring(0, indexEnd);
}
function $97dd0405afd9b1ca$var$trimNewlines(string) {
    return $97dd0405afd9b1ca$var$trimTrailingNewlines($97dd0405afd9b1ca$var$trimLeadingNewlines(string));
}
var $97dd0405afd9b1ca$var$blockElements = [
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'AUDIO',
    'BLOCKQUOTE',
    'BODY',
    'CANVAS',
    'CENTER',
    'DD',
    'DIR',
    'DIV',
    'DL',
    'DT',
    'FIELDSET',
    'FIGCAPTION',
    'FIGURE',
    'FOOTER',
    'FORM',
    'FRAMESET',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'HGROUP',
    'HR',
    'HTML',
    'ISINDEX',
    'LI',
    'MAIN',
    'MENU',
    'NAV',
    'NOFRAMES',
    'NOSCRIPT',
    'OL',
    'OUTPUT',
    'P',
    'PRE',
    'SECTION',
    'TABLE',
    'TBODY',
    'TD',
    'TFOOT',
    'TH',
    'THEAD',
    'TR',
    'UL'
];
function $97dd0405afd9b1ca$var$isBlock(node) {
    return $97dd0405afd9b1ca$var$is(node, $97dd0405afd9b1ca$var$blockElements);
}
var $97dd0405afd9b1ca$var$voidElements = [
    'AREA',
    'BASE',
    'BR',
    'COL',
    'COMMAND',
    'EMBED',
    'HR',
    'IMG',
    'INPUT',
    'KEYGEN',
    'LINK',
    'META',
    'PARAM',
    'SOURCE',
    'TRACK',
    'WBR'
];
function $97dd0405afd9b1ca$var$isVoid(node) {
    return $97dd0405afd9b1ca$var$is(node, $97dd0405afd9b1ca$var$voidElements);
}
function $97dd0405afd9b1ca$var$hasVoid(node) {
    return $97dd0405afd9b1ca$var$has(node, $97dd0405afd9b1ca$var$voidElements);
}
var $97dd0405afd9b1ca$var$meaningfulWhenBlankElements = [
    'A',
    'TABLE',
    'THEAD',
    'TBODY',
    'TFOOT',
    'TH',
    'TD',
    'IFRAME',
    'SCRIPT',
    'AUDIO',
    'VIDEO'
];
function $97dd0405afd9b1ca$var$isMeaningfulWhenBlank(node) {
    return $97dd0405afd9b1ca$var$is(node, $97dd0405afd9b1ca$var$meaningfulWhenBlankElements);
}
function $97dd0405afd9b1ca$var$hasMeaningfulWhenBlank(node) {
    return $97dd0405afd9b1ca$var$has(node, $97dd0405afd9b1ca$var$meaningfulWhenBlankElements);
}
function $97dd0405afd9b1ca$var$is(node, tagNames) {
    return tagNames.indexOf(node.nodeName) >= 0;
}
function $97dd0405afd9b1ca$var$has(node, tagNames) {
    return node.getElementsByTagName && tagNames.some(function(tagName) {
        return node.getElementsByTagName(tagName).length;
    });
}
var $97dd0405afd9b1ca$var$rules = {};
$97dd0405afd9b1ca$var$rules.paragraph = {
    filter: 'p',
    replacement: function replacement(content) {
        return '\n\n' + content + '\n\n';
    }
};
$97dd0405afd9b1ca$var$rules.lineBreak = {
    filter: 'br',
    replacement: function replacement(content, node, options) {
        return options.br + '\n';
    }
};
$97dd0405afd9b1ca$var$rules.heading = {
    filter: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ],
    replacement: function replacement(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === 'setext' && hLevel < 3) {
            var underline = $97dd0405afd9b1ca$var$repeat(hLevel === 1 ? '=' : '-', content.length);
            return '\n\n' + content + '\n' + underline + '\n\n';
        } else return '\n\n' + $97dd0405afd9b1ca$var$repeat('#', hLevel) + ' ' + content + '\n\n';
    }
};
$97dd0405afd9b1ca$var$rules.blockquote = {
    filter: 'blockquote',
    replacement: function replacement(content) {
        content = $97dd0405afd9b1ca$var$trimNewlines(content).replace(/^/gm, '> ');
        return '\n\n' + content + '\n\n';
    }
};
$97dd0405afd9b1ca$var$rules.list = {
    filter: [
        'ul',
        'ol'
    ],
    replacement: function replacement(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === 'LI' && parent.lastElementChild === node) return '\n' + content;
        else return '\n\n' + content + '\n\n';
    }
};
$97dd0405afd9b1ca$var$rules.listItem = {
    filter: 'li',
    replacement: function replacement(content, node, options) {
        var prefix = options.bulletListMarker + '   ';
        var parent = node.parentNode;
        if (parent.nodeName === 'OL') {
            var start = parent.getAttribute('start');
            var index = Array.prototype.indexOf.call(parent.children, node);
            prefix = (start ? Number(start) + index : index + 1) + '.  ';
        }
        var isParagraph = /\n$/.test(content);
        content = $97dd0405afd9b1ca$var$trimNewlines(content) + (isParagraph ? '\n' : '');
        content = content.replace(/\n/gm, '\n' + ' '.repeat(prefix.length)); // indent
        return prefix + content + (node.nextSibling ? '\n' : '');
    }
};
$97dd0405afd9b1ca$var$rules.indentedCodeBlock = {
    filter: function filter(node, options) {
        return options.codeBlockStyle === 'indented' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function replacement(content, node, options) {
        return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n';
    }
};
$97dd0405afd9b1ca$var$rules.fencedCodeBlock = {
    filter: function filter(node, options) {
        return options.codeBlockStyle === 'fenced' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function replacement(content, node, options) {
        var className = node.firstChild.getAttribute('class') || '';
        var language = (className.match(/language-(\S+)/) || [
            null,
            ''
        ])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp('^' + fenceChar + '{3,}', 'gm');
        var match;
        while(match = fenceInCodeRegex.exec(code))if (match[0].length >= fenceSize) fenceSize = match[0].length + 1;
        var fence = $97dd0405afd9b1ca$var$repeat(fenceChar, fenceSize);
        return '\n\n' + fence + language + '\n' + code.replace(/\n$/, '') + '\n' + fence + '\n\n';
    }
};
$97dd0405afd9b1ca$var$rules.horizontalRule = {
    filter: 'hr',
    replacement: function replacement(content, node, options) {
        return '\n\n' + options.hr + '\n\n';
    }
};
$97dd0405afd9b1ca$var$rules.inlineLink = {
    filter: function filter(node, options) {
        return options.linkStyle === 'inlined' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function replacement(content, node) {
        var href = node.getAttribute('href');
        if (href) href = href.replace(/([()])/g, '\\$1');
        var title = $97dd0405afd9b1ca$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + title.replace(/"/g, '\\"') + '"';
        return '[' + content + '](' + href + title + ')';
    }
};
$97dd0405afd9b1ca$var$rules.referenceLink = {
    filter: function filter(node, options) {
        return options.linkStyle === 'referenced' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function replacement(content, node, options) {
        var href = node.getAttribute('href');
        var title = $97dd0405afd9b1ca$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + title + '"';
        var replacement;
        var reference;
        switch(options.linkReferenceStyle){
            case 'collapsed':
                replacement = '[' + content + '][]';
                reference = '[' + content + ']: ' + href + title;
                break;
            case 'shortcut':
                replacement = '[' + content + ']';
                reference = '[' + content + ']: ' + href + title;
                break;
            default:
                var id = this.references.length + 1;
                replacement = '[' + content + '][' + id + ']';
                reference = '[' + id + ']: ' + href + title;
        }
        this.references.push(reference);
        return replacement;
    },
    references: [],
    append: function append(options) {
        var references = '';
        if (this.references.length) {
            references = '\n\n' + this.references.join('\n') + '\n\n';
            this.references = []; // Reset references
        }
        return references;
    }
};
$97dd0405afd9b1ca$var$rules.emphasis = {
    filter: [
        'em',
        'i'
    ],
    replacement: function replacement(content, node, options) {
        if (!content.trim()) return '';
        return options.emDelimiter + content + options.emDelimiter;
    }
};
$97dd0405afd9b1ca$var$rules.strong = {
    filter: [
        'strong',
        'b'
    ],
    replacement: function replacement(content, node, options) {
        if (!content.trim()) return '';
        return options.strongDelimiter + content + options.strongDelimiter;
    }
};
$97dd0405afd9b1ca$var$rules.code = {
    filter: function filter(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;
        return node.nodeName === 'CODE' && !isCodeBlock;
    },
    replacement: function replacement(content) {
        if (!content) return '';
        content = content.replace(/\r?\n|\r/g, ' ');
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? ' ' : '';
        var delimiter = '`';
        var matches = content.match(/`+/gm) || [];
        while(matches.indexOf(delimiter) !== -1)delimiter = delimiter + '`';
        return delimiter + extraSpace + content + extraSpace + delimiter;
    }
};
$97dd0405afd9b1ca$var$rules.image = {
    filter: 'img',
    replacement: function replacement(content, node) {
        var alt = $97dd0405afd9b1ca$var$cleanAttribute(node.getAttribute('alt'));
        var src = node.getAttribute('src') || '';
        var title = $97dd0405afd9b1ca$var$cleanAttribute(node.getAttribute('title'));
        var titlePart = title ? ' "' + title + '"' : '';
        return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
    }
};
function $97dd0405afd9b1ca$var$cleanAttribute(attribute) {
    return attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : '';
}
/**
 * Manages a collection of rules used to convert HTML to Markdown
 */ function $97dd0405afd9b1ca$var$Rules(options) {
    this.options = options;
    this._keep = [];
    this._remove = [];
    this.blankRule = {
        replacement: options.blankReplacement
    };
    this.keepReplacement = options.keepReplacement;
    this.defaultRule = {
        replacement: options.defaultReplacement
    };
    this.array = [];
    for(var key in options.rules)this.array.push(options.rules[key]);
}
$97dd0405afd9b1ca$var$Rules.prototype = {
    add: function add(key, rule) {
        this.array.unshift(rule);
    },
    keep: function keep(filter) {
        this._keep.unshift({
            filter: filter,
            replacement: this.keepReplacement
        });
    },
    remove: function remove(filter) {
        this._remove.unshift({
            filter: filter,
            replacement: function replacement() {
                return '';
            }
        });
    },
    forNode: function forNode(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = $97dd0405afd9b1ca$var$findRule(this.array, node, this.options)) return rule;
        if (rule = $97dd0405afd9b1ca$var$findRule(this._keep, node, this.options)) return rule;
        if (rule = $97dd0405afd9b1ca$var$findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
    },
    forEach: function forEach(fn) {
        for(var i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
};
function $97dd0405afd9b1ca$var$findRule(rules, node, options) {
    for(var i = 0; i < rules.length; i++){
        var rule = rules[i];
        if ($97dd0405afd9b1ca$var$filterValue(rule, node, options)) return rule;
    }
    return void 0;
}
function $97dd0405afd9b1ca$var$filterValue(rule, node, options) {
    var filter = rule.filter;
    if (typeof filter === 'string') {
        if (filter === node.nodeName.toLowerCase()) return true;
    } else if (Array.isArray(filter)) {
        if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true;
    } else if (typeof filter === 'function') {
        if (filter.call(rule, node, options)) return true;
    } else throw new TypeError('`filter` needs to be a string, array, or function');
}
/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */ function $97dd0405afd9b1ca$var$collapseWhitespace(options) {
    var element = options.element;
    var isBlock = options.isBlock;
    var isVoid = options.isVoid;
    var isPre = options.isPre || function(node) {
        return node.nodeName === 'PRE';
    };
    if (!element.firstChild || isPre(element)) return;
    var prevText = null;
    var keepLeadingWs = false;
    var prev = null;
    var node = $97dd0405afd9b1ca$var$next(prev, element, isPre);
    while(node !== element){
        if (node.nodeType === 3 || node.nodeType === 4) {
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $97dd0405afd9b1ca$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                keepLeadingWs = false;
            } else if (isVoid(node) || isPre(node)) {
                // Avoid trimming space around non-block, non-BR void elements and inline PRE.
                prevText = null;
                keepLeadingWs = true;
            } else if (prevText) // Drop protection if set previously.
            keepLeadingWs = false;
        } else {
            node = $97dd0405afd9b1ca$var$remove(node);
            continue;
        }
        var nextNode = $97dd0405afd9b1ca$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $97dd0405afd9b1ca$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $97dd0405afd9b1ca$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $97dd0405afd9b1ca$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
/*
 * Set up window for Node.js
 */ var $97dd0405afd9b1ca$var$root = typeof window !== 'undefined' ? window : {};
/*
 * Parsing HTML strings
 */ function $97dd0405afd9b1ca$var$canParseHTMLNatively() {
    var Parser = $97dd0405afd9b1ca$var$root.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString('', 'text/html')) canParse = true;
    } catch (e) {}
    return canParse;
}
function $97dd0405afd9b1ca$var$createHTMLParser() {
    var Parser = function Parser() {};
    if ($97dd0405afd9b1ca$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on'; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $97dd0405afd9b1ca$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument('').open();
    } catch (e) {
        if ($97dd0405afd9b1ca$var$root.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
var $97dd0405afd9b1ca$var$HTMLParser = $97dd0405afd9b1ca$var$canParseHTMLNatively() ? $97dd0405afd9b1ca$var$root.DOMParser : $97dd0405afd9b1ca$var$createHTMLParser();
function $97dd0405afd9b1ca$var$RootNode(input, options) {
    var root;
    if (typeof input === 'string') {
        var doc = $97dd0405afd9b1ca$var$htmlParser().parseFromString(// DOM parsers arrange elements in the <head> and <body>.
        // Wrapping in a custom element ensures elements are reliably arranged in
        // a single element.
        '<x-turndown id="turndown-root">' + input + '</x-turndown>', 'text/html');
        root = doc.getElementById('turndown-root');
    } else root = input.cloneNode(true);
    $97dd0405afd9b1ca$var$collapseWhitespace({
        element: root,
        isBlock: $97dd0405afd9b1ca$var$isBlock,
        isVoid: $97dd0405afd9b1ca$var$isVoid,
        isPre: options.preformattedCode ? $97dd0405afd9b1ca$var$isPreOrCode : null
    });
    return root;
}
var $97dd0405afd9b1ca$var$_htmlParser;
function $97dd0405afd9b1ca$var$htmlParser() {
    $97dd0405afd9b1ca$var$_htmlParser = $97dd0405afd9b1ca$var$_htmlParser || new $97dd0405afd9b1ca$var$HTMLParser();
    return $97dd0405afd9b1ca$var$_htmlParser;
}
function $97dd0405afd9b1ca$var$isPreOrCode(node) {
    return node.nodeName === 'PRE' || node.nodeName === 'CODE';
}
function $97dd0405afd9b1ca$var$Node(node, options) {
    node.isBlock = $97dd0405afd9b1ca$var$isBlock(node);
    node.isCode = node.nodeName === 'CODE' || node.parentNode.isCode;
    node.isBlank = $97dd0405afd9b1ca$var$isBlank(node);
    node.flankingWhitespace = $97dd0405afd9b1ca$var$flankingWhitespace(node, options);
    return node;
}
function $97dd0405afd9b1ca$var$isBlank(node) {
    return !$97dd0405afd9b1ca$var$isVoid(node) && !$97dd0405afd9b1ca$var$isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !$97dd0405afd9b1ca$var$hasVoid(node) && !$97dd0405afd9b1ca$var$hasMeaningfulWhenBlank(node);
}
function $97dd0405afd9b1ca$var$flankingWhitespace(node, options) {
    if (node.isBlock || options.preformattedCode && node.isCode) return {
        leading: '',
        trailing: ''
    };
    var edges = $97dd0405afd9b1ca$var$edgeWhitespace(node.textContent);
    // abandon leading ASCII WS if left-flanked by ASCII WS
    if (edges.leadingAscii && $97dd0405afd9b1ca$var$isFlankedByWhitespace('left', node, options)) edges.leading = edges.leadingNonAscii;
    // abandon trailing ASCII WS if right-flanked by ASCII WS
    if (edges.trailingAscii && $97dd0405afd9b1ca$var$isFlankedByWhitespace('right', node, options)) edges.trailing = edges.trailingNonAscii;
    return {
        leading: edges.leading,
        trailing: edges.trailing
    };
}
function $97dd0405afd9b1ca$var$edgeWhitespace(string) {
    var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
    return {
        leading: m[1],
        leadingAscii: m[2],
        leadingNonAscii: m[3],
        trailing: m[4],
        trailingNonAscii: m[5],
        trailingAscii: m[6]
    };
}
function $97dd0405afd9b1ca$var$isFlankedByWhitespace(side, node, options) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === 'left') {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (options.preformattedCode && sibling.nodeName === 'CODE') isFlanked = false;
        else if (sibling.nodeType === 1 && !$97dd0405afd9b1ca$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
var $97dd0405afd9b1ca$var$reduce = Array.prototype.reduce;
var $97dd0405afd9b1ca$var$escapes = [
    [
        /\\/g,
        '\\\\'
    ],
    [
        /\*/g,
        '\\*'
    ],
    [
        /^-/g,
        '\\-'
    ],
    [
        /^\+ /g,
        '\\+ '
    ],
    [
        /^(=+)/g,
        '\\$1'
    ],
    [
        /^(#{1,6}) /g,
        '\\$1 '
    ],
    [
        /`/g,
        '\\`'
    ],
    [
        /^~~~/g,
        '\\~~~'
    ],
    [
        /\[/g,
        '\\['
    ],
    [
        /\]/g,
        '\\]'
    ],
    [
        /^>/g,
        '\\>'
    ],
    [
        /_/g,
        '\\_'
    ],
    [
        /^(\d+)\. /g,
        '$1\\. '
    ]
];
function $97dd0405afd9b1ca$var$TurndownService(options) {
    if (!(this instanceof $97dd0405afd9b1ca$var$TurndownService)) return new $97dd0405afd9b1ca$var$TurndownService(options);
    var defaults = {
        rules: $97dd0405afd9b1ca$var$rules,
        headingStyle: 'setext',
        hr: '* * *',
        bulletListMarker: '*',
        codeBlockStyle: 'indented',
        fence: '```',
        emDelimiter: '_',
        strongDelimiter: '**',
        linkStyle: 'inlined',
        linkReferenceStyle: 'full',
        br: '  ',
        preformattedCode: false,
        blankReplacement: function blankReplacement(content, node) {
            return node.isBlock ? '\n\n' : '';
        },
        keepReplacement: function keepReplacement(content, node) {
            return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML;
        },
        defaultReplacement: function defaultReplacement(content, node) {
            return node.isBlock ? '\n\n' + content + '\n\n' : content;
        }
    };
    this.options = $97dd0405afd9b1ca$var$extend({}, defaults, options);
    this.rules = new $97dd0405afd9b1ca$var$Rules(this.options);
}
$97dd0405afd9b1ca$var$TurndownService.prototype = {
    /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */ turndown: function turndown(input) {
        if (!$97dd0405afd9b1ca$var$canConvert(input)) throw new TypeError(input + ' is not a string, or an element/document/fragment node.');
        if (input === '') return '';
        var output = $97dd0405afd9b1ca$var$process.call(this, new $97dd0405afd9b1ca$var$RootNode(input, this.options));
        return $97dd0405afd9b1ca$var$postProcess.call(this, output);
    },
    /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */ use: function use(plugin) {
        if (Array.isArray(plugin)) for(var i = 0; i < plugin.length; i++)this.use(plugin[i]);
        else if (typeof plugin === 'function') plugin(this);
        else throw new TypeError('plugin must be a Function or an Array of Functions');
        return this;
    },
    /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ addRule: function addRule(key, rule) {
        this.rules.add(key, rule);
        return this;
    },
    /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ keep: function keep(filter) {
        this.rules.keep(filter);
        return this;
    },
    /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ remove: function remove(filter) {
        this.rules.remove(filter);
        return this;
    },
    /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */ escape: function escape(string) {
        return $97dd0405afd9b1ca$var$escapes.reduce(function(accumulator, escape) {
            return accumulator.replace(escape[0], escape[1]);
        }, string);
    }
};
/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $97dd0405afd9b1ca$var$process(parentNode) {
    var self = this;
    return $97dd0405afd9b1ca$var$reduce.call(parentNode.childNodes, function(output, node) {
        node = new $97dd0405afd9b1ca$var$Node(node, self.options);
        var replacement = '';
        if (node.nodeType === 3) replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
        else if (node.nodeType === 1) replacement = $97dd0405afd9b1ca$var$replacementForNode.call(self, node);
        return $97dd0405afd9b1ca$var$join(output, replacement);
    }, '');
}
/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */ function $97dd0405afd9b1ca$var$postProcess(output) {
    var self = this;
    this.rules.forEach(function(rule) {
        if (typeof rule.append === 'function') output = $97dd0405afd9b1ca$var$join(output, rule.append(self.options));
    });
    return output.replace(/^[\t\r\n]+/, '').replace(/[\t\r\n\s]+$/, '');
}
/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $97dd0405afd9b1ca$var$replacementForNode(node) {
    var rule = this.rules.forNode(node);
    var content = $97dd0405afd9b1ca$var$process.call(this, node);
    var whitespace = node.flankingWhitespace;
    if (whitespace.leading || whitespace.trailing) content = content.trim();
    return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */ function $97dd0405afd9b1ca$var$join(output, replacement) {
    var s1 = $97dd0405afd9b1ca$var$trimTrailingNewlines(output);
    var s2 = $97dd0405afd9b1ca$var$trimLeadingNewlines(replacement);
    var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
    var separator = '\n\n'.substring(0, nls);
    return s1 + separator + s2;
}
/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */ function $97dd0405afd9b1ca$var$canConvert(input) {
    return input != null && (typeof input === 'string' || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}
var $97dd0405afd9b1ca$export$2e2bcd8739ae039 = $97dd0405afd9b1ca$var$TurndownService;


var $7d59e34d58a0f292$var$highlightRegExp = /highlight-(?:text|source)-([a-z0-9]+)/;
function $7d59e34d58a0f292$export$c359330ed80b1889(turndownService) {
    turndownService.addRule('highlightedCodeBlock', {
        filter: function filter(node) {
            var firstChild = node.firstChild;
            return node.nodeName === 'DIV' && $7d59e34d58a0f292$var$highlightRegExp.test(node.className) && firstChild && firstChild.nodeName === 'PRE';
        },
        replacement: function replacement(content, node, options) {
            var className = node.className || '';
            var language = (className.match($7d59e34d58a0f292$var$highlightRegExp) || [
                null,
                ''
            ])[1];
            return '\n\n' + options.fence + language + '\n' + node.firstChild.textContent + '\n' + options.fence + '\n\n';
        }
    });
}
function $7d59e34d58a0f292$export$19426ff118fe8be(turndownService) {
    turndownService.addRule('strikethrough', {
        filter: [
            'del',
            's',
            'strike'
        ],
        replacement: function replacement(content) {
            return '~' + content + '~';
        }
    });
}
var $7d59e34d58a0f292$var$indexOf = Array.prototype.indexOf;
var $7d59e34d58a0f292$var$every = Array.prototype.every;
var $7d59e34d58a0f292$var$rules = {};
$7d59e34d58a0f292$var$rules.tableCell = {
    filter: [
        'th',
        'td'
    ],
    replacement: function replacement(content, node) {
        return $7d59e34d58a0f292$var$cell(content, node);
    }
};
$7d59e34d58a0f292$var$rules.tableRow = {
    filter: 'tr',
    replacement: function replacement(content, node) {
        var borderCells = '';
        var alignMap = {
            left: ':--',
            right: '--:',
            center: ':-:'
        };
        if ($7d59e34d58a0f292$var$isHeadingRow(node)) for(var i = 0; i < node.childNodes.length; i++){
            var border = '---';
            var align = (node.childNodes[i].getAttribute('align') || '').toLowerCase();
            if (align) border = alignMap[align] || border;
            borderCells += $7d59e34d58a0f292$var$cell(border, node.childNodes[i]);
        }
        return '\n' + content + (borderCells ? '\n' + borderCells : '');
    }
};
$7d59e34d58a0f292$var$rules.table = {
    // Only convert tables with a heading row.
    // Tables with no heading row are kept using `keep` (see below).
    filter: function filter(node) {
        return node.nodeName === 'TABLE' && $7d59e34d58a0f292$var$isHeadingRow(node.rows[0]);
    },
    replacement: function replacement(content) {
        // Ensure there are no blank lines
        content = content.replace('\n\n', '\n');
        return '\n\n' + content + '\n\n';
    }
};
$7d59e34d58a0f292$var$rules.tableSection = {
    filter: [
        'thead',
        'tbody',
        'tfoot'
    ],
    replacement: function replacement(content) {
        return content;
    }
};
// A tr is a heading row if:
// - the parent is a THEAD
// - or if its the first child of the TABLE or the first TBODY (possibly
//   following a blank THEAD)
// - and every cell is a TH
function $7d59e34d58a0f292$var$isHeadingRow(tr) {
    var parentNode = tr.parentNode;
    return parentNode.nodeName === 'THEAD' || parentNode.firstChild === tr && (parentNode.nodeName === 'TABLE' || $7d59e34d58a0f292$var$isFirstTbody(parentNode)) && $7d59e34d58a0f292$var$every.call(tr.childNodes, function(n) {
        return n.nodeName === 'TH';
    });
}
function $7d59e34d58a0f292$var$isFirstTbody(element) {
    var previousSibling = element.previousSibling;
    return element.nodeName === 'TBODY' && (!previousSibling || previousSibling.nodeName === 'THEAD' && /^\s*$/i.test(previousSibling.textContent));
}
function $7d59e34d58a0f292$var$cell(content, node) {
    var index = $7d59e34d58a0f292$var$indexOf.call(node.parentNode.childNodes, node);
    var prefix = ' ';
    if (index === 0) prefix = '| ';
    return prefix + content + ' |';
}
function $7d59e34d58a0f292$export$cc4ff83fc7bd256e(turndownService) {
    turndownService.keep(function(node) {
        return node.nodeName === 'TABLE' && !$7d59e34d58a0f292$var$isHeadingRow(node.rows[0]);
    });
    for(var key in $7d59e34d58a0f292$var$rules)turndownService.addRule(key, $7d59e34d58a0f292$var$rules[key]);
}
function $7d59e34d58a0f292$export$1f0c2747e2ba0b8d(turndownService) {
    turndownService.addRule('taskListItems', {
        filter: function filter(node) {
            return node.type === 'checkbox' && node.parentNode.nodeName === 'LI';
        },
        replacement: function replacement(content, node) {
            return (node.checked ? '[x]' : '[ ]') + ' ';
        }
    });
}
function $7d59e34d58a0f292$export$59ffe8c4d7a4aab2(turndownService) {
    turndownService.use([
        $7d59e34d58a0f292$export$c359330ed80b1889,
        $7d59e34d58a0f292$export$19426ff118fe8be,
        $7d59e34d58a0f292$export$cc4ff83fc7bd256e,
        $7d59e34d58a0f292$export$1f0c2747e2ba0b8d
    ]);
}



var $6tqvJ = parcelRequire("6tqvJ");

var $l5IE3 = parcelRequire("l5IE3");
function $ec0d3058e92a8855$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $ec0d3058e92a8855$var$$57ba63c17513cbba$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$57ba63c17513cbba$exports, "getAnchorElement", function() {
    return $ec0d3058e92a8855$export$ac81f1ba58a5f363;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$57ba63c17513cbba$exports, "Tool", function() {
    return $ec0d3058e92a8855$export$724f6b867059ef5f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$57ba63c17513cbba$exports, "FileTool", function() {
    return $ec0d3058e92a8855$export$de3122b2484864a7;
});
function $ec0d3058e92a8855$export$ac81f1ba58a5f363() {
    var _globalThis_getSelection, _globalThis;
    var _ref = ((_globalThis_getSelection = (_globalThis = globalThis).getSelection) === null || _globalThis_getSelection === void 0 ? void 0 : _globalThis_getSelection.call(_globalThis)) || {}, anchorNode = _ref.anchorNode;
    if (anchorNode) return anchorNode.parentElement;
}
var $ec0d3058e92a8855$export$724f6b867059ef5f = /*#__PURE__*/ function() {
    "use strict";
    function $57ba63c17513cbba$export$724f6b867059ef5f() {
        (0, $7lhcp._)(this, $57ba63c17513cbba$export$724f6b867059ef5f);
    }
    (0, $8BtP9._)($57ba63c17513cbba$export$724f6b867059ef5f, [
        {
            key: "usable",
            get: function get() {
                var _this = this, command = _this.command;
                return !command || !globalThis.document || document.queryCommandSupported(command) || document.queryCommandEnabled(command);
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                var _this = this, command = _this.command, tags = _this.tags;
                if (tags) {
                    var box = $ec0d3058e92a8855$export$ac81f1ba58a5f363();
                    return !!box && box.matches(tags.map(function(tag) {
                        return "".concat(tag, ", ").concat(tag, " *");
                    }).join(', '));
                }
                if (command) return !!globalThis.document && document.queryCommandState(command);
                return false;
            }
        },
        {
            key: "active",
            get: function get() {
                return this.getActive();
            }
        },
        {
            key: "title",
            get: function get() {
                var _this = this, name = _this.name, keys = _this.keys, usable = _this.usable;
                return "".concat(name).concat(usable ? keys ? "\n(".concat(keys.join(' + '), ")") : '' : '\n(not supported)');
            }
        },
        {
            key: "edit",
            value: function edit(editor) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var _document;
                editor.focus();
                (_document = document).execCommand.apply(_document, [
                    this.command,
                    null
                ].concat((0, $fsSDT._)(data)));
            }
        },
        {
            key: "execute",
            value: function execute(editor) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var _this = this, inputs = _this.inputs, values = [];
                if (inputs) {
                    var data1 = inputs.map(function(input) {
                        return self.prompt(input);
                    });
                    if (!data1.filter(Boolean)[0]) return;
                    values = data1;
                }
                this.edit.apply(this, [
                    editor
                ].concat((0, $fsSDT._)(values)));
            }
        }
    ]);
    return $57ba63c17513cbba$export$724f6b867059ef5f;
}();
var $ec0d3058e92a8855$export$de3122b2484864a7 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($57ba63c17513cbba$export$de3122b2484864a7, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $57ba63c17513cbba$export$de3122b2484864a7() {
        (0, $7lhcp._)(this, $57ba63c17513cbba$export$de3122b2484864a7);
        return (0, $07dqX._)(this, $57ba63c17513cbba$export$de3122b2484864a7, arguments);
    }
    (0, $8BtP9._)($57ba63c17513cbba$export$de3122b2484864a7, [
        {
            key: "save",
            value: function save(data) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        return [
                            2,
                            URL.createObjectURL(data)
                        ];
                    });
                })();
            }
        },
        {
            key: "codeOf",
            value: function codeOf(path) {
                return path;
            }
        },
        {
            key: "execute",
            value: function execute(editor) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var path, _, _1, e, path;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                _1 = (_ = this).save;
                                return [
                                    4,
                                    (0, $e0062df735681f1b$export$c1bd535e520dbbc3)()
                                ];
                            case 1:
                                return [
                                    4,
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ];
                            case 2:
                                path = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                path = self.prompt('No file uploaded, please input an URL');
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                if (path) this.edit(editor, this.codeOf(path));
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return $57ba63c17513cbba$export$de3122b2484864a7;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$761e5fca3dae08eb$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "BoldTool", function() {
    return $ec0d3058e92a8855$export$10056a49e3b218eb;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "ItalicTool", function() {
    return $ec0d3058e92a8855$export$edf99d0f51bacb1e;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "UnderlineTool", function() {
    return $ec0d3058e92a8855$export$4b6d9c17188960d2;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "StrikeThroughTool", function() {
    return $ec0d3058e92a8855$export$a35bffaeae8fdda0;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "HeadingTool", function() {
    return $ec0d3058e92a8855$export$85cf7848e2652151;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "H1Tool", function() {
    return $ec0d3058e92a8855$export$30e8c6b428f8749f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "H2Tool", function() {
    return $ec0d3058e92a8855$export$58443375efa91029;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "H3Tool", function() {
    return $ec0d3058e92a8855$export$75d24d6b8b747307;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "FontSizeDownTool", function() {
    return $ec0d3058e92a8855$export$a20806c6ef6938f8;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "FontSizeUpTool", function() {
    return $ec0d3058e92a8855$export$744da7e24e4a7382;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "SubscriptTool", function() {
    return $ec0d3058e92a8855$export$6137518b4e998008;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "SuperscriptTool", function() {
    return $ec0d3058e92a8855$export$7217f06c61ebd4fc;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$761e5fca3dae08eb$exports, "LinkTool", function() {
    return $ec0d3058e92a8855$export$f6c54364b5332e66;
});
var $ec0d3058e92a8855$export$10056a49e3b218eb = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$10056a49e3b218eb, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$10056a49e3b218eb() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$10056a49e3b218eb);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$10056a49e3b218eb, (0, $fsSDT._)(args)), _this.name = 'Bold', _this.tags = [
            'b',
            'strong'
        ], _this.keys = [
            'Ctrl',
            'B'
        ], _this.command = 'bold';
        return _this;
    }
    return $761e5fca3dae08eb$export$10056a49e3b218eb;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$edf99d0f51bacb1e = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$edf99d0f51bacb1e, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$edf99d0f51bacb1e() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$edf99d0f51bacb1e);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$edf99d0f51bacb1e, (0, $fsSDT._)(args)), _this.name = 'Italic', _this.tags = [
            'i',
            'em'
        ], _this.keys = [
            'Ctrl',
            'I'
        ], _this.command = 'italic';
        return _this;
    }
    return $761e5fca3dae08eb$export$edf99d0f51bacb1e;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$4b6d9c17188960d2 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$4b6d9c17188960d2, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$4b6d9c17188960d2() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$4b6d9c17188960d2);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$4b6d9c17188960d2, (0, $fsSDT._)(args)), _this.name = 'Underline', _this.tags = [
            'u'
        ], _this.keys = [
            'Ctrl',
            'U'
        ], _this.command = 'underline';
        return _this;
    }
    return $761e5fca3dae08eb$export$4b6d9c17188960d2;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$a35bffaeae8fdda0 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$a35bffaeae8fdda0, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$a35bffaeae8fdda0() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$a35bffaeae8fdda0);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$a35bffaeae8fdda0, (0, $fsSDT._)(args)), _this.name = 'Strike through', _this.tags = [
            's',
            'del',
            'strike'
        ], _this.command = 'strikeThrough';
        return _this;
    }
    return $761e5fca3dae08eb$export$a35bffaeae8fdda0;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$85cf7848e2652151 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$85cf7848e2652151, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$85cf7848e2652151() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$85cf7848e2652151);
        var _this;
        var _globalThis_document;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$85cf7848e2652151, (0, $fsSDT._)(args)), _this.command = ((_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.queryCommandSupported('heading')) ? 'heading' : 'formatBlock';
        return _this;
    }
    (0, $8BtP9._)($761e5fca3dae08eb$export$85cf7848e2652151, [
        {
            key: "execute",
            value: function execute(editor) {
                this.edit(editor, this.name);
            }
        }
    ]);
    return $761e5fca3dae08eb$export$85cf7848e2652151;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$30e8c6b428f8749f = /*#__PURE__*/ function($761e5fca3dae08eb$export$85cf7848e2652151) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$30e8c6b428f8749f, $761e5fca3dae08eb$export$85cf7848e2652151);
    function $761e5fca3dae08eb$export$30e8c6b428f8749f() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$30e8c6b428f8749f);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$30e8c6b428f8749f, (0, $fsSDT._)(args)), _this.name = 'H1', _this.tags = [
            'h1'
        ];
        return _this;
    }
    return $761e5fca3dae08eb$export$30e8c6b428f8749f;
}($ec0d3058e92a8855$export$85cf7848e2652151);
var $ec0d3058e92a8855$export$58443375efa91029 = /*#__PURE__*/ function($761e5fca3dae08eb$export$85cf7848e2652151) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$58443375efa91029, $761e5fca3dae08eb$export$85cf7848e2652151);
    function $761e5fca3dae08eb$export$58443375efa91029() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$58443375efa91029);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$58443375efa91029, (0, $fsSDT._)(args)), _this.name = 'H2', _this.tags = [
            'h2'
        ];
        return _this;
    }
    return $761e5fca3dae08eb$export$58443375efa91029;
}($ec0d3058e92a8855$export$85cf7848e2652151);
var $ec0d3058e92a8855$export$75d24d6b8b747307 = /*#__PURE__*/ function($761e5fca3dae08eb$export$85cf7848e2652151) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$75d24d6b8b747307, $761e5fca3dae08eb$export$85cf7848e2652151);
    function $761e5fca3dae08eb$export$75d24d6b8b747307() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$75d24d6b8b747307);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$75d24d6b8b747307, (0, $fsSDT._)(args)), _this.name = 'H3', _this.tags = [
            'h3'
        ];
        return _this;
    }
    return $761e5fca3dae08eb$export$75d24d6b8b747307;
}($ec0d3058e92a8855$export$85cf7848e2652151);
var $ec0d3058e92a8855$export$a20806c6ef6938f8 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$a20806c6ef6938f8, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$a20806c6ef6938f8() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$a20806c6ef6938f8);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$a20806c6ef6938f8, (0, $fsSDT._)(args)), _this.name = 'Font Size down', _this.tags = [
            'small'
        ], _this.command = 'decreaseFontSize';
        return _this;
    }
    return $761e5fca3dae08eb$export$a20806c6ef6938f8;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$744da7e24e4a7382 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$744da7e24e4a7382, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$744da7e24e4a7382() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$744da7e24e4a7382);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$744da7e24e4a7382, (0, $fsSDT._)(args)), _this.name = 'Font Size up', _this.tags = [
            'big'
        ], _this.command = 'increaseFontSize';
        return _this;
    }
    return $761e5fca3dae08eb$export$744da7e24e4a7382;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$6137518b4e998008 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$6137518b4e998008, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$6137518b4e998008() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$6137518b4e998008);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$6137518b4e998008, (0, $fsSDT._)(args)), _this.name = 'Subscript', _this.tags = [
            'sub'
        ], _this.command = 'subscript';
        return _this;
    }
    return $761e5fca3dae08eb$export$6137518b4e998008;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$7217f06c61ebd4fc = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$7217f06c61ebd4fc, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$7217f06c61ebd4fc() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$7217f06c61ebd4fc);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$7217f06c61ebd4fc, (0, $fsSDT._)(args)), _this.name = 'Superscript', _this.tags = [
            'sup'
        ], _this.command = 'superscript';
        return _this;
    }
    return $761e5fca3dae08eb$export$7217f06c61ebd4fc;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$f6c54364b5332e66 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($761e5fca3dae08eb$export$f6c54364b5332e66, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $761e5fca3dae08eb$export$f6c54364b5332e66() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $761e5fca3dae08eb$export$f6c54364b5332e66);
        var _this;
        _this = (0, $07dqX._)(this, $761e5fca3dae08eb$export$f6c54364b5332e66, (0, $fsSDT._)(args)), _this.name = 'Link', _this.tags = [
            'a'
        ], _this.inputs = [
            'Path'
        ], _this.command = 'createLink';
        return _this;
    }
    return $761e5fca3dae08eb$export$f6c54364b5332e66;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$e999eec76d3b8abe$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$e999eec76d3b8abe$exports, "ColorTool", function() {
    return $ec0d3058e92a8855$export$ba9bbe5370f1bf2f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$e999eec76d3b8abe$exports, "ForeColorTool", function() {
    return $ec0d3058e92a8855$export$cab0e15cfb8489d7;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$e999eec76d3b8abe$exports, "BackColorTool", function() {
    return $ec0d3058e92a8855$export$92bb6183e7459be2;
});
var $ec0d3058e92a8855$export$ba9bbe5370f1bf2f = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($e999eec76d3b8abe$export$ba9bbe5370f1bf2f, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $e999eec76d3b8abe$export$ba9bbe5370f1bf2f() {
        (0, $7lhcp._)(this, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f);
        return (0, $07dqX._)(this, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f, arguments);
    }
    (0, $8BtP9._)($e999eec76d3b8abe$export$ba9bbe5370f1bf2f, [
        (0, $5RfYb._)({
            key: "getColor"
        }, "value", function getColor() {
            var box = $ec0d3058e92a8855$export$ac81f1ba58a5f363(), _this = this, colorName = _this.colorName;
            if (!box) return colorName === 'color' ? '#000000' : '#ffffff';
            var _getComputedStyle = getComputedStyle(box), color = _getComputedStyle[colorName];
            var _color_match = (0, $leE2g._)(color.match(/\d+/g), 3), red = _color_match[0], green = _color_match[1], blue = _color_match[2];
            return '#' + (+red).toString(16).padStart(2, '0') + (+green).toString(16).padStart(2, '0') + (+blue).toString(16).padStart(2, '0');
        }),
        {
            key: "active",
            get: function get() {
                return !!this.getColor();
            }
        },
        {
            key: "execute",
            value: function execute(editor, color) {
                this.edit(editor, color);
            }
        }
    ]);
    return $e999eec76d3b8abe$export$ba9bbe5370f1bf2f;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$cab0e15cfb8489d7 = /*#__PURE__*/ function($e999eec76d3b8abe$export$ba9bbe5370f1bf2f) {
    "use strict";
    (0, $h6w6E._)($e999eec76d3b8abe$export$cab0e15cfb8489d7, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f);
    function $e999eec76d3b8abe$export$cab0e15cfb8489d7() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $e999eec76d3b8abe$export$cab0e15cfb8489d7);
        var _this;
        _this = (0, $07dqX._)(this, $e999eec76d3b8abe$export$cab0e15cfb8489d7, (0, $fsSDT._)(args)), _this.name = 'Fore Color', _this.command = 'foreColor', _this.colorName = 'color';
        return _this;
    }
    return $e999eec76d3b8abe$export$cab0e15cfb8489d7;
}($ec0d3058e92a8855$export$ba9bbe5370f1bf2f);
var $ec0d3058e92a8855$export$92bb6183e7459be2 = /*#__PURE__*/ function($e999eec76d3b8abe$export$ba9bbe5370f1bf2f) {
    "use strict";
    (0, $h6w6E._)($e999eec76d3b8abe$export$92bb6183e7459be2, $e999eec76d3b8abe$export$ba9bbe5370f1bf2f);
    function $e999eec76d3b8abe$export$92bb6183e7459be2() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $e999eec76d3b8abe$export$92bb6183e7459be2);
        var _this;
        _this = (0, $07dqX._)(this, $e999eec76d3b8abe$export$92bb6183e7459be2, (0, $fsSDT._)(args)), _this.name = 'Back Color', _this.command = 'backColor', _this.colorName = 'backgroundColor';
        return _this;
    }
    return $e999eec76d3b8abe$export$92bb6183e7459be2;
}($ec0d3058e92a8855$export$ba9bbe5370f1bf2f);
var $ec0d3058e92a8855$var$$258f24df7a3cbf67$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignTool", function() {
    return $ec0d3058e92a8855$export$6c1211091eb3b68f;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignLeftTool", function() {
    return $ec0d3058e92a8855$export$42a444ebfdcfe7b9;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignCenterTool", function() {
    return $ec0d3058e92a8855$export$9a2e6e0294a984eb;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignRightTool", function() {
    return $ec0d3058e92a8855$export$22363f91860fc258;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "AlignFullTool", function() {
    return $ec0d3058e92a8855$export$42827b1362fed748;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "OrderedListTool", function() {
    return $ec0d3058e92a8855$export$faf4e70f09f43a15;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "UnorderedListTool", function() {
    return $ec0d3058e92a8855$export$cf4030b57a3fbe37;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$258f24df7a3cbf67$exports, "HorizontalRuleTool", function() {
    return $ec0d3058e92a8855$export$dce8a7d6279fc201;
});
var $ec0d3058e92a8855$export$6c1211091eb3b68f = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$6c1211091eb3b68f, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$6c1211091eb3b68f() {
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$6c1211091eb3b68f);
        return (0, $07dqX._)(this, $258f24df7a3cbf67$export$6c1211091eb3b68f, arguments);
    }
    (0, $8BtP9._)($258f24df7a3cbf67$export$6c1211091eb3b68f, [
        {
            key: "active",
            get: function get() {
                if ((0, $5LQ10._)((0, $2JFuQ._)($258f24df7a3cbf67$export$6c1211091eb3b68f.prototype), "getActive", this).call(this)) return true;
                var box = $ec0d3058e92a8855$export$ac81f1ba58a5f363();
                return !!box && getComputedStyle(box).textAlign === this.align;
            }
        }
    ]);
    return $258f24df7a3cbf67$export$6c1211091eb3b68f;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$42a444ebfdcfe7b9 = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$42a444ebfdcfe7b9, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$42a444ebfdcfe7b9() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$42a444ebfdcfe7b9);
        var _this;
        _this = (0, $07dqX._)(this, $258f24df7a3cbf67$export$42a444ebfdcfe7b9, (0, $fsSDT._)(args)), _this.name = 'Align Left', _this.command = 'justifyLeft', _this.align = 'left';
        return _this;
    }
    return $258f24df7a3cbf67$export$42a444ebfdcfe7b9;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$9a2e6e0294a984eb = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$9a2e6e0294a984eb, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$9a2e6e0294a984eb() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$9a2e6e0294a984eb);
        var _this;
        _this = (0, $07dqX._)(this, $258f24df7a3cbf67$export$9a2e6e0294a984eb, (0, $fsSDT._)(args)), _this.name = 'Align Center', _this.command = 'justifyCenter', _this.align = 'center';
        return _this;
    }
    return $258f24df7a3cbf67$export$9a2e6e0294a984eb;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$22363f91860fc258 = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$22363f91860fc258, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$22363f91860fc258() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$22363f91860fc258);
        var _this;
        _this = (0, $07dqX._)(this, $258f24df7a3cbf67$export$22363f91860fc258, (0, $fsSDT._)(args)), _this.name = 'Align Right', _this.command = 'justifyRight', _this.align = 'right';
        return _this;
    }
    return $258f24df7a3cbf67$export$22363f91860fc258;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$42827b1362fed748 = /*#__PURE__*/ function($258f24df7a3cbf67$export$6c1211091eb3b68f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$42827b1362fed748, $258f24df7a3cbf67$export$6c1211091eb3b68f);
    function $258f24df7a3cbf67$export$42827b1362fed748() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$42827b1362fed748);
        var _this;
        _this = (0, $07dqX._)(this, $258f24df7a3cbf67$export$42827b1362fed748, (0, $fsSDT._)(args)), _this.name = 'Align Full', _this.command = 'justifyFull', _this.align = 'justify';
        return _this;
    }
    return $258f24df7a3cbf67$export$42827b1362fed748;
}($ec0d3058e92a8855$export$6c1211091eb3b68f);
var $ec0d3058e92a8855$export$faf4e70f09f43a15 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$faf4e70f09f43a15, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$faf4e70f09f43a15() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$faf4e70f09f43a15);
        var _this;
        _this = (0, $07dqX._)(this, $258f24df7a3cbf67$export$faf4e70f09f43a15, (0, $fsSDT._)(args)), _this.name = 'Ordered list', _this.tags = [
            'ol'
        ], _this.command = 'insertOrderedList';
        return _this;
    }
    return $258f24df7a3cbf67$export$faf4e70f09f43a15;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$cf4030b57a3fbe37 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$cf4030b57a3fbe37, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$cf4030b57a3fbe37() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$cf4030b57a3fbe37);
        var _this;
        _this = (0, $07dqX._)(this, $258f24df7a3cbf67$export$cf4030b57a3fbe37, (0, $fsSDT._)(args)), _this.name = 'Unordered list', _this.tags = [
            'ul'
        ], _this.command = 'insertUnorderedList';
        return _this;
    }
    return $258f24df7a3cbf67$export$cf4030b57a3fbe37;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$dce8a7d6279fc201 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($258f24df7a3cbf67$export$dce8a7d6279fc201, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $258f24df7a3cbf67$export$dce8a7d6279fc201() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $258f24df7a3cbf67$export$dce8a7d6279fc201);
        var _this;
        _this = (0, $07dqX._)(this, $258f24df7a3cbf67$export$dce8a7d6279fc201, (0, $fsSDT._)(args)), _this.name = 'Horizontal rule', _this.tags = [
            'hr'
        ], _this.command = 'insertHorizontalRule';
        return _this;
    }
    return $258f24df7a3cbf67$export$dce8a7d6279fc201;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$0769f8c709024b7a$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "IFrameTool", function() {
    return $ec0d3058e92a8855$export$3e557574863db086;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "ImageTool", function() {
    return $ec0d3058e92a8855$export$982f47444a2f88da;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "AudioTool", function() {
    return $ec0d3058e92a8855$export$6024938f37e646f8;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$0769f8c709024b7a$exports, "VideoTool", function() {
    return $ec0d3058e92a8855$export$932111b8028f79ed;
});
var $ec0d3058e92a8855$export$3e557574863db086 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($0769f8c709024b7a$export$3e557574863db086, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $0769f8c709024b7a$export$3e557574863db086() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $0769f8c709024b7a$export$3e557574863db086);
        var _this;
        _this = (0, $07dqX._)(this, $0769f8c709024b7a$export$3e557574863db086, (0, $fsSDT._)(args)), _this.name = 'Embed Web page', _this.tags = [
            'iframe'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $8BtP9._)($0769f8c709024b7a$export$3e557574863db086, [
        {
            key: "execute",
            value: function execute(editor) {
                var path = self.prompt('Path');
                if (path) this.edit(editor, '<iframe style="width: 100%; height: 50vh; border: none" src="'.concat(path, '"></iframe>'));
            }
        }
    ]);
    return $0769f8c709024b7a$export$3e557574863db086;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$982f47444a2f88da = /*#__PURE__*/ function($57ba63c17513cbba$export$de3122b2484864a7) {
    "use strict";
    (0, $h6w6E._)($0769f8c709024b7a$export$982f47444a2f88da, $57ba63c17513cbba$export$de3122b2484864a7);
    function $0769f8c709024b7a$export$982f47444a2f88da() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $0769f8c709024b7a$export$982f47444a2f88da);
        var _this;
        _this = (0, $07dqX._)(this, $0769f8c709024b7a$export$982f47444a2f88da, (0, $fsSDT._)(args)), _this.name = 'Image', _this.tags = [
            'img'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $8BtP9._)($0769f8c709024b7a$export$982f47444a2f88da, [
        {
            key: "codeOf",
            value: function codeOf(path) {
                return '<img style="max-width: 100%; height: auto" src="'.concat(path, '"/>');
            }
        }
    ]);
    return $0769f8c709024b7a$export$982f47444a2f88da;
}($ec0d3058e92a8855$export$de3122b2484864a7);
var $ec0d3058e92a8855$export$6024938f37e646f8 = /*#__PURE__*/ function($57ba63c17513cbba$export$de3122b2484864a7) {
    "use strict";
    (0, $h6w6E._)($0769f8c709024b7a$export$6024938f37e646f8, $57ba63c17513cbba$export$de3122b2484864a7);
    function $0769f8c709024b7a$export$6024938f37e646f8() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $0769f8c709024b7a$export$6024938f37e646f8);
        var _this;
        _this = (0, $07dqX._)(this, $0769f8c709024b7a$export$6024938f37e646f8, (0, $fsSDT._)(args)), _this.name = 'Audio', _this.tags = [
            'audio'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $8BtP9._)($0769f8c709024b7a$export$6024938f37e646f8, [
        {
            key: "codeOf",
            value: function codeOf(path) {
                return '<audio controls src="'.concat(path, '"></audio>');
            }
        }
    ]);
    return $0769f8c709024b7a$export$6024938f37e646f8;
}($ec0d3058e92a8855$export$de3122b2484864a7);
var $ec0d3058e92a8855$export$932111b8028f79ed = /*#__PURE__*/ function($57ba63c17513cbba$export$de3122b2484864a7) {
    "use strict";
    (0, $h6w6E._)($0769f8c709024b7a$export$932111b8028f79ed, $57ba63c17513cbba$export$de3122b2484864a7);
    function $0769f8c709024b7a$export$932111b8028f79ed() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $0769f8c709024b7a$export$932111b8028f79ed);
        var _this;
        _this = (0, $07dqX._)(this, $0769f8c709024b7a$export$932111b8028f79ed, (0, $fsSDT._)(args)), _this.name = 'Video', _this.tags = [
            'video'
        ], _this.command = 'insertHTML';
        return _this;
    }
    (0, $8BtP9._)($0769f8c709024b7a$export$932111b8028f79ed, [
        {
            key: "codeOf",
            value: function codeOf(path) {
                return '<video controls src="'.concat(path, '"></video>');
            }
        }
    ]);
    return $0769f8c709024b7a$export$932111b8028f79ed;
}($ec0d3058e92a8855$export$de3122b2484864a7);
var $ec0d3058e92a8855$var$$2c12cf671c105d76$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "UndoTool", function() {
    return $ec0d3058e92a8855$export$65235875731ff287;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "RedoTool", function() {
    return $ec0d3058e92a8855$export$b60f30d254d1e1a6;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "ResetTool", function() {
    return $ec0d3058e92a8855$export$6f46dc3d81fbb4bd;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$2c12cf671c105d76$exports, "ClearTool", function() {
    return $ec0d3058e92a8855$export$25eb377ce1feaada;
});
var $ec0d3058e92a8855$export$65235875731ff287 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($2c12cf671c105d76$export$65235875731ff287, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$65235875731ff287() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $2c12cf671c105d76$export$65235875731ff287);
        var _this;
        _this = (0, $07dqX._)(this, $2c12cf671c105d76$export$65235875731ff287, (0, $fsSDT._)(args)), _this.name = 'Undo', _this.command = 'undo';
        return _this;
    }
    return $2c12cf671c105d76$export$65235875731ff287;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$b60f30d254d1e1a6 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($2c12cf671c105d76$export$b60f30d254d1e1a6, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$b60f30d254d1e1a6() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $2c12cf671c105d76$export$b60f30d254d1e1a6);
        var _this;
        _this = (0, $07dqX._)(this, $2c12cf671c105d76$export$b60f30d254d1e1a6, (0, $fsSDT._)(args)), _this.name = 'Redo', _this.command = 'redo';
        return _this;
    }
    return $2c12cf671c105d76$export$b60f30d254d1e1a6;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$6f46dc3d81fbb4bd = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($2c12cf671c105d76$export$6f46dc3d81fbb4bd, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$6f46dc3d81fbb4bd() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $2c12cf671c105d76$export$6f46dc3d81fbb4bd);
        var _this;
        _this = (0, $07dqX._)(this, $2c12cf671c105d76$export$6f46dc3d81fbb4bd, (0, $fsSDT._)(args)), _this.name = 'Reset', _this.command = 'removeFormat';
        return _this;
    }
    return $2c12cf671c105d76$export$6f46dc3d81fbb4bd;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$export$25eb377ce1feaada = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($2c12cf671c105d76$export$25eb377ce1feaada, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $2c12cf671c105d76$export$25eb377ce1feaada() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $2c12cf671c105d76$export$25eb377ce1feaada);
        var _this;
        _this = (0, $07dqX._)(this, $2c12cf671c105d76$export$25eb377ce1feaada, (0, $fsSDT._)(args)), _this.name = 'Clear';
        return _this;
    }
    (0, $8BtP9._)($2c12cf671c105d76$export$25eb377ce1feaada, [
        {
            key: "execute",
            value: function execute(editor) {
                editor.focus();
                document.execCommand('selectAll');
                document.execCommand('delete');
            }
        }
    ]);
    return $2c12cf671c105d76$export$25eb377ce1feaada;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$6e883fb0ea04260a$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$6e883fb0ea04260a$exports, "turndown", function() {
    return $ec0d3058e92a8855$export$48d4d6bf65314082;
});
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$6e883fb0ea04260a$exports, "CopyMarkdownTool", function() {
    return $ec0d3058e92a8855$export$4b13df0a6effdd72;
});
var $ec0d3058e92a8855$var$$6e883fb0ea04260a$var$Empty_HREF = /^(#|javascript:\s*void\(0\);?\s*)$/;
var $ec0d3058e92a8855$export$48d4d6bf65314082 = new (0, $97dd0405afd9b1ca$export$2e2bcd8739ae039)({
    hr: '---',
    linkStyle: 'referenced',
    headingStyle: 'atx',
    bulletListMarker: '-',
    codeBlockStyle: 'fenced'
}).use((0, $7d59e34d58a0f292$export$19426ff118fe8be)).use((0, $7d59e34d58a0f292$export$cc4ff83fc7bd256e)).use((0, $7d59e34d58a0f292$export$1f0c2747e2ba0b8d)).use((0, $7d59e34d58a0f292$export$59ffe8c4d7a4aab2)).addRule('non_url', {
    filter: function(node) {
        return [
            'a',
            'area'
        ].includes(node.nodeName.toLowerCase()) && $ec0d3058e92a8855$var$$6e883fb0ea04260a$var$Empty_HREF.test(node.getAttribute('href') || '');
    },
    replacement: function() {
        return '';
    }
}).addRule('img-srcset', {
    filter: [
        'img'
    ],
    replacement: function(_, param) {
        var alt = param.alt, title = param.title, src = param.src, srcset = param.srcset;
        var _srcset_split_;
        var _ref = (0, $leE2g._)(((_srcset_split_ = srcset.split(',')[0]) === null || _srcset_split_ === void 0 ? void 0 : _srcset_split_.split(/\s+/)) || [], 1), firstSet = _ref[0];
        var content = [
            src || firstSet,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return "![".concat(alt, "](").concat(content.join(' '), ")");
    }
}).addRule('source-srcset', {
    filter: [
        'picture'
    ],
    replacement: function(_, node) {
        var _sources_;
        var _ref = node.querySelector('img') || {}, src = _ref.src, alt = _ref.alt, title = _ref.title;
        var sourceList = (0, $fsSDT._)(node.querySelectorAll('source')).map(function(param) {
            var sizes = param.sizes, srcset = param.srcset;
            var _Math;
            var _srcset_split_;
            var size = (_Math = Math).max.apply(_Math, (0, $fsSDT._)(sizes.split(/,|\)/).map(function(pixel) {
                return parseFloat(pixel.trim());
            }).filter(Boolean)));
            var _ref = (0, $leE2g._)(((_srcset_split_ = srcset.split(',')[0]) === null || _srcset_split_ === void 0 ? void 0 : _srcset_split_.split(/\s+/)) || [], 1), src = _ref[0];
            return {
                size: size,
                src: src
            };
        });
        var sources = sourceList.sort(function(param, param1) {
            var a = param.size, b = param1.size;
            return b - a;
        });
        var content = [
            src || ((_sources_ = sources[0]) === null || _sources_ === void 0 ? void 0 : _sources_.src),
            title && JSON.stringify(title)
        ].filter(Boolean);
        return "![".concat(alt, "](").concat(content.join(' '), ")");
    }
}).remove(function(node) {
    return node.matches('style, script, aside, form, [class*="ads" i]');
}).keep(function(node) {
    return node.matches('kbd, iframe');
});
var $ec0d3058e92a8855$export$4b13df0a6effdd72 = /*#__PURE__*/ function($57ba63c17513cbba$export$724f6b867059ef5f) {
    "use strict";
    (0, $h6w6E._)($6e883fb0ea04260a$export$4b13df0a6effdd72, $57ba63c17513cbba$export$724f6b867059ef5f);
    function $6e883fb0ea04260a$export$4b13df0a6effdd72() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $7lhcp._)(this, $6e883fb0ea04260a$export$4b13df0a6effdd72);
        var _this;
        _this = (0, $07dqX._)(this, $6e883fb0ea04260a$export$4b13df0a6effdd72, (0, $fsSDT._)(args)), _this.name = 'Copy Markdown';
        return _this;
    }
    (0, $8BtP9._)($6e883fb0ea04260a$export$4b13df0a6effdd72, [
        {
            key: "execute",
            value: function execute(_0) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function(param) {
                    var innerHTML, markdown;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                innerHTML = param.innerHTML;
                                markdown = $ec0d3058e92a8855$export$48d4d6bf65314082.turndown(innerHTML);
                                return [
                                    4,
                                    navigator.clipboard.writeText(markdown)
                                ];
                            case 1:
                                _state.sent();
                                alert('Markdown copied to clipboard');
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        }
    ]);
    return $6e883fb0ea04260a$export$4b13df0a6effdd72;
}($ec0d3058e92a8855$export$724f6b867059ef5f);
var $ec0d3058e92a8855$var$$b738b8c7b1139833$exports = {};
$ec0d3058e92a8855$var$$parcel$export($ec0d3058e92a8855$var$$b738b8c7b1139833$exports, "editor", function() {
    return $ec0d3058e92a8855$export$b5d042d2b680aed6;
});
var $ec0d3058e92a8855$export$b5d042d2b680aed6 = function(Class, param) {
    var ref = (0, $4b94edc8487dfe49$export$71511d61b312f219)(param);
    var EditorTrait = /*#__PURE__*/ function(Class) {
        "use strict";
        (0, $h6w6E._)(EditorTrait, Class);
        function EditorTrait() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            (0, $7lhcp._)(this, EditorTrait);
            var _this;
            var _this1;
            _this = (0, $07dqX._)(this, EditorTrait, (0, $fsSDT._)(args)), _this1 = _this, _this1.handlePasteDrop = function(event) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                    var root, list, _list_filter, plainText, htmlText, _iteratorNormalCompletion, _didIteratorError, _iteratorError, raw, _iterator, _step, item, err;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                root = event.currentTarget;
                                list = event.type === 'paste' ? (0, $fsSDT._)(event.clipboardData.items) : (0, $fsSDT._)(event.dataTransfer.items);
                                root.focus();
                                _list_filter = (0, $leE2g._)(list.filter(function(param) {
                                    var type = param.type;
                                    return type.startsWith('text/');
                                }), 2), plainText = _list_filter[0], htmlText = _list_filter[1];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!(!htmlText && plainText.type === 'text/plain')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return plainText.getAsString(resolve);
                                    })
                                ];
                            case 1:
                                raw = _state.sent();
                                return [
                                    4,
                                    _this1.clearHTML((0, $l5IE3.marked)(raw))
                                ];
                            case 2:
                                (0, $6tqvJ.insertToCursor).apply(void 0, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    10
                                ];
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = list[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                item = _step.value;
                                return [
                                    4,
                                    _this1.transferMedia(item)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _this1.updateValue(root.innerHTML);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            return _this;
        }
        (0, $8BtP9._)(EditorTrait, [
            {
                key: "uploadFile",
                value: function uploadFile(tool, data) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var _, _tmp, error;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (typeof data === 'string' && !/^(data|blob):/.test(data)) return [
                                        2,
                                        data
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        ,
                                        7
                                    ]);
                                    _ = tool.save;
                                    if (!(typeof data === 'string')) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        (0, $6tqvJ.blobOf)(data)
                                    ];
                                case 2:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    _tmp = data;
                                    _state.label = 4;
                                case 4:
                                    return [
                                        4,
                                        _.apply(tool, [
                                            _tmp
                                        ])
                                    ];
                                case 5:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 6:
                                    error = _state.sent();
                                    console.error(error);
                                    if (typeof data === 'string') return [
                                        2,
                                        data
                                    ];
                                    return [
                                        3,
                                        7
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            },
            {
                key: "clearHTML",
                value: function clearHTML(markup) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var _fragment, _this, imageTool, audioTool, videoTool, fragment, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, style, dataset, key, err;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, imageTool = _this.imageTool, audioTool = _this.audioTool, videoTool = _this.videoTool, fragment = document.createDocumentFragment();
                                    (_fragment = fragment).append.apply(_fragment, (0, $fsSDT._)((0, $6tqvJ.parseDOM)(markup)));
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        10,
                                        11,
                                        12
                                    ]);
                                    _iterator = (0, $6tqvJ.walkDOM)(fragment, Node.ELEMENT_NODE)[Symbol.iterator]();
                                    _state.label = 2;
                                case 2:
                                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                        3,
                                        9
                                    ];
                                    element = _step.value;
                                    style = element.style, dataset = element.dataset;
                                    if ([
                                        'nowrap',
                                        'pre'
                                    ].includes(style.whiteSpace)) style.whiteSpace = 'normal';
                                    for(var key in dataset)delete dataset[key];
                                    if (!(element instanceof HTMLImageElement && imageTool)) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(imageTool, element.src)
                                    ];
                                case 3:
                                    element.src = _state.sent();
                                    return [
                                        3,
                                        8
                                    ];
                                case 4:
                                    if (!(element instanceof HTMLAudioElement && audioTool)) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(audioTool, element.src)
                                    ];
                                case 5:
                                    element.src = _state.sent();
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    if (!(element instanceof HTMLVideoElement && videoTool)) return [
                                        3,
                                        8
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(videoTool, element.src)
                                    ];
                                case 7:
                                    element.src = _state.sent();
                                    _state.label = 8;
                                case 8:
                                    _iteratorNormalCompletion = true;
                                    return [
                                        3,
                                        2
                                    ];
                                case 9:
                                    return [
                                        3,
                                        12
                                    ];
                                case 10:
                                    err = _state.sent();
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                    return [
                                        3,
                                        12
                                    ];
                                case 11:
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                    return [
                                        7
                                    ];
                                case 12:
                                    return [
                                        2,
                                        fragment
                                    ];
                            }
                        });
                    }).call(this);
                }
            },
            {
                key: "transferMedia",
                value: function transferMedia(item) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $hVBqc._)(function() {
                        var _this, imageTool, audioTool, videoTool, raw, URI, URI1, URI2;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this, imageTool = _this.imageTool, audioTool = _this.audioTool, videoTool = _this.videoTool;
                                    if (!(item.type === 'text/html')) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        new Promise(function(resolve) {
                                            return item.getAsString(resolve);
                                        })
                                    ];
                                case 1:
                                    raw = _state.sent();
                                    return [
                                        4,
                                        this.clearHTML(raw)
                                    ];
                                case 2:
                                    (0, $6tqvJ.insertToCursor).apply(void 0, [
                                        _state.sent()
                                    ]);
                                    return [
                                        3,
                                        9
                                    ];
                                case 3:
                                    if (!(item.type.startsWith('image/') && imageTool)) return [
                                        3,
                                        5
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(imageTool, item.getAsFile())
                                    ];
                                case 4:
                                    URI = _state.sent();
                                    if (URI) (0, $6tqvJ.insertToCursor)((0, $6tqvJ.parseDOM)('<img src="'.concat(URI, '" />'))[0]);
                                    return [
                                        3,
                                        9
                                    ];
                                case 5:
                                    if (!(item.type.startsWith('audio/') && audioTool)) return [
                                        3,
                                        7
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(audioTool, item.getAsFile())
                                    ];
                                case 6:
                                    URI1 = _state.sent();
                                    if (URI1) (0, $6tqvJ.insertToCursor)((0, $6tqvJ.parseDOM)('<audio src="'.concat(URI1, '" />'))[0]);
                                    return [
                                        3,
                                        9
                                    ];
                                case 7:
                                    if (!(item.type.startsWith('video/') && videoTool)) return [
                                        3,
                                        9
                                    ];
                                    return [
                                        4,
                                        this.uploadFile(videoTool, item.getAsFile())
                                    ];
                                case 8:
                                    URI2 = _state.sent();
                                    if (URI2) (0, $6tqvJ.insertToCursor)((0, $6tqvJ.parseDOM)('<video src="'.concat(URI2, '" />'))[0]);
                                    _state.label = 9;
                                case 9:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(this);
                }
            }
        ]);
        return EditorTrait;
    }(Class);
    return EditorTrait;
};







var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
function $09063b8df282f9e7$var$$parcel$exportWildcard(e, r) {
    return Object.keys(r).forEach(function(c) {
        "default" === c || "__esModule" === c || Object.prototype.hasOwnProperty.call(e, c) || Object.defineProperty(e, c, {
            enumerable: !0,
            get: function get() {
                return r[c];
            }
        });
    }), e;
}
function $09063b8df282f9e7$var$$parcel$export(e, r, c, t) {
    Object.defineProperty(e, r, {
        get: c,
        set: t,
        enumerable: !0,
        configurable: !0
    });
}
var $09063b8df282f9e7$var$$73a8882fd67c0324$exports = {};
function $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363(e) {
    var r = this, c = this.title, t = this.active, a = this.icon, $ = this.usable;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("button", {
        type: "button",
        title: c,
        className: "btn btn-".concat((t ? "" : "outline-") + "secondary", " me-2 mb-2"),
        style: {
            cursor: $ ? "pointer" : "not-allowed"
        },
        disabled: !$,
        onClick: function onClick(c) {
            c.preventDefault(), e.current && r.execute(e.current);
        },
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("i", {
            className: "bi-".concat(a)
        })
    }, a);
}
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$73a8882fd67c0324$exports, "renderTool", function() {
    return $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363;
});
var $09063b8df282f9e7$var$$a01145bb2edfc771$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "TextTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$e252ba763eff5cdc;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "ColorTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$bdef6e97a10dbad4;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "LayoutTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$145c1b37c0810d7;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "MediaTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$999636c6e25075fb;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "ControlTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$f35db4b82786c3a4;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "ExtraTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$b8ecf7d74432d529;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "OriginalTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$9ddb256264948609;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$a01145bb2edfc771$exports, "DefaultTools", function() {
    return $09063b8df282f9e7$var$$a01145bb2edfc771$export$aa718db1466ce312;
});
var $09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "BoldTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "ItalicTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "UnderlineTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "StrikeThroughTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "H1Tool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "H2Tool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$58443375efa91029;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "H3Tool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "FontSizeDownTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "FontSizeUpTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "SubscriptTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$6137518b4e998008;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "SuperscriptTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports, "LinkTool", function() {
    return $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66;
});
var $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-bold"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$10056a49e3b218eb), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-italic"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$edf99d0f51bacb1e), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-underline"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$4b6d9c17188960d2), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-strikethrough"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$a35bffaeae8fdda0), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h1"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$30e8c6b428f8749f), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$58443375efa91029 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h2"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$58443375efa91029), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h3"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$75d24d6b8b747307), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-down"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$a20806c6ef6938f8), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-up"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$744da7e24e4a7382), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$6137518b4e998008 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-down-right"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$6137518b4e998008), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-up-right"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$7217f06c61ebd4fc), $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "link"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$f6c54364b5332e66), $09063b8df282f9e7$var$$b1f503bd59fa3427$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$b1f503bd59fa3427$exports, "ColorSelector", function() {
    return $09063b8df282f9e7$var$$b1f503bd59fa3427$export$9012acaf449cdfcb;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$b1f503bd59fa3427$exports, "renderColorTool", function() {
    return $09063b8df282f9e7$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$b1f503bd59fa3427$exports, "ForeColorTool", function() {
    return $09063b8df282f9e7$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$b1f503bd59fa3427$exports, "BackColorTool", function() {
    return $09063b8df282f9e7$var$$b1f503bd59fa3427$export$92bb6183e7459be2;
});
var $09063b8df282f9e7$var$$b1f503bd59fa3427$export$9012acaf449cdfcb = function $b1f503bd59fa3427$export$9012acaf449cdfcb(e) {
    var r = e.className, c = e.title, t = e.type, a = e.value, $ = e.onChange, o = e.icon;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
        className: "d-inline-block align-middle position-relative ".concat(void 0 === r ? "" : r),
        title: c,
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                className: "position-absolute w-100 h-100 start-0 top-0 z-n1 rounded-3",
                type: "color",
                value: a,
                onChange: function onChange(e) {
                    var r = e.target.value;
                    return null == $ ? void 0 : $(r);
                }
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("button", {
                className: "btn",
                style: {
                    color: "color" === t ? a : "lightgray",
                    backgroundColor: "color" === t ? "white" : a,
                    borderColor: a
                },
                onClick: function onClick(e) {
                    e.preventDefault(), e.currentTarget.previousElementSibling.click();
                },
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("i", {
                    className: "bi-".concat(o)
                })
            })
        ]
    });
};
function $09063b8df282f9e7$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29(e) {
    var r = this, c = this.icon, t = this.name, a = this.colorName;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($09063b8df282f9e7$var$$b1f503bd59fa3427$export$9012acaf449cdfcb, {
        className: "me-2 mb-2",
        title: t,
        icon: c,
        type: a,
        value: this.getColor(),
        onChange: function onChange(c) {
            return e.current && r.execute(e.current, c);
        }
    }, c);
}
var $09063b8df282f9e7$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$cab0e15cfb8489d7), $09063b8df282f9e7$var$$b1f503bd59fa3427$export$92bb6183e7459be2 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font-fill"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$92bb6183e7459be2), $09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports, "AlignLeftTool", function() {
    return $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports, "AlignCenterTool", function() {
    return $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports, "AlignRightTool", function() {
    return $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$22363f91860fc258;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports, "AlignFullTool", function() {
    return $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42827b1362fed748;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports, "OrderedListTool", function() {
    return $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports, "UnorderedListTool", function() {
    return $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports, "HorizontalRuleTool", function() {
    return $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201;
});
var $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-left"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$42a444ebfdcfe7b9), $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-center"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$9a2e6e0294a984eb), $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$22363f91860fc258 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-right"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$22363f91860fc258), $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42827b1362fed748 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "justify"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$42827b1362fed748), $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ol"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$faf4e70f09f43a15), $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ul"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$cf4030b57a3fbe37), $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "reception-0"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$dce8a7d6279fc201), $09063b8df282f9e7$var$$345f51138f435756$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$345f51138f435756$exports, "IFrameTool", function() {
    return $09063b8df282f9e7$var$$345f51138f435756$export$3e557574863db086;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$345f51138f435756$exports, "ImageTool", function() {
    return $09063b8df282f9e7$var$$345f51138f435756$export$982f47444a2f88da;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$345f51138f435756$exports, "AudioTool", function() {
    return $09063b8df282f9e7$var$$345f51138f435756$export$6024938f37e646f8;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$345f51138f435756$exports, "VideoTool", function() {
    return $09063b8df282f9e7$var$$345f51138f435756$export$932111b8028f79ed;
});
var $09063b8df282f9e7$var$$345f51138f435756$export$3e557574863db086 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "window"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$3e557574863db086), $09063b8df282f9e7$var$$345f51138f435756$export$982f47444a2f88da = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "image"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$982f47444a2f88da), $09063b8df282f9e7$var$$345f51138f435756$export$6024938f37e646f8 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "voicemail"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$6024938f37e646f8), $09063b8df282f9e7$var$$345f51138f435756$export$932111b8028f79ed = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "camera-video"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$932111b8028f79ed), $09063b8df282f9e7$var$$15eac7d4db191f2f$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$15eac7d4db191f2f$exports, "UndoTool", function() {
    return $09063b8df282f9e7$var$$15eac7d4db191f2f$export$65235875731ff287;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$15eac7d4db191f2f$exports, "RedoTool", function() {
    return $09063b8df282f9e7$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$15eac7d4db191f2f$exports, "ResetTool", function() {
    return $09063b8df282f9e7$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd;
}), $09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$15eac7d4db191f2f$exports, "ClearTool", function() {
    return $09063b8df282f9e7$var$$15eac7d4db191f2f$export$25eb377ce1feaada;
});
var $09063b8df282f9e7$var$$15eac7d4db191f2f$export$65235875731ff287 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-counterclockwise"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$65235875731ff287), $09063b8df282f9e7$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-clockwise"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$b60f30d254d1e1a6), $09063b8df282f9e7$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "eraser"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$6f46dc3d81fbb4bd), $09063b8df282f9e7$var$$15eac7d4db191f2f$export$25eb377ce1feaada = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-x"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$25eb377ce1feaada), $09063b8df282f9e7$var$$b9bef41109a8f18c$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$b9bef41109a8f18c$exports, "CopyMarkdownTool", function() {
    return $09063b8df282f9e7$var$$b9bef41109a8f18c$export$4b13df0a6effdd72;
});
var $09063b8df282f9e7$var$$b9bef41109a8f18c$export$4b13df0a6effdd72 = function(e) {
    "use strict";
    function r() {
        var _$e;
        return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "markdown"
        }), Object.defineProperty(_$e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $09063b8df282f9e7$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), _$e;
    }
    return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), r;
}($ec0d3058e92a8855$export$4b13df0a6effdd72), $09063b8df282f9e7$var$$a01145bb2edfc771$export$e252ba763eff5cdc = [
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66
], $09063b8df282f9e7$var$$a01145bb2edfc771$export$bdef6e97a10dbad4 = [
    $09063b8df282f9e7$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $09063b8df282f9e7$var$$b1f503bd59fa3427$export$92bb6183e7459be2
], $09063b8df282f9e7$var$$a01145bb2edfc771$export$145c1b37c0810d7 = [
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201
], $09063b8df282f9e7$var$$a01145bb2edfc771$export$999636c6e25075fb = [
    $09063b8df282f9e7$var$$345f51138f435756$export$3e557574863db086,
    $09063b8df282f9e7$var$$345f51138f435756$export$982f47444a2f88da,
    $09063b8df282f9e7$var$$345f51138f435756$export$6024938f37e646f8,
    $09063b8df282f9e7$var$$345f51138f435756$export$932111b8028f79ed
], $09063b8df282f9e7$var$$a01145bb2edfc771$export$f35db4b82786c3a4 = [
    $09063b8df282f9e7$var$$15eac7d4db191f2f$export$65235875731ff287,
    $09063b8df282f9e7$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $09063b8df282f9e7$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd,
    $09063b8df282f9e7$var$$15eac7d4db191f2f$export$25eb377ce1feaada
], $09063b8df282f9e7$var$$a01145bb2edfc771$export$b8ecf7d74432d529 = [
    $09063b8df282f9e7$var$$b9bef41109a8f18c$export$4b13df0a6effdd72
], $09063b8df282f9e7$var$$a01145bb2edfc771$export$9ddb256264948609 = (0, $36427be7dd51c5e7$export$71511d61b312f219)($09063b8df282f9e7$var$$a01145bb2edfc771$export$e252ba763eff5cdc).concat((0, $36427be7dd51c5e7$export$71511d61b312f219)($09063b8df282f9e7$var$$a01145bb2edfc771$export$bdef6e97a10dbad4), (0, $36427be7dd51c5e7$export$71511d61b312f219)($09063b8df282f9e7$var$$a01145bb2edfc771$export$145c1b37c0810d7), (0, $36427be7dd51c5e7$export$71511d61b312f219)($09063b8df282f9e7$var$$a01145bb2edfc771$export$999636c6e25075fb), (0, $36427be7dd51c5e7$export$71511d61b312f219)($09063b8df282f9e7$var$$a01145bb2edfc771$export$f35db4b82786c3a4)), $09063b8df282f9e7$var$$a01145bb2edfc771$export$aa718db1466ce312 = [
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $09063b8df282f9e7$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $09063b8df282f9e7$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $09063b8df282f9e7$var$$b1f503bd59fa3427$export$92bb6183e7459be2,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $09063b8df282f9e7$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201,
    $09063b8df282f9e7$var$$345f51138f435756$export$982f47444a2f88da,
    $09063b8df282f9e7$var$$15eac7d4db191f2f$export$65235875731ff287,
    $09063b8df282f9e7$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $09063b8df282f9e7$var$$15eac7d4db191f2f$export$25eb377ce1feaada
];
$09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$var$$a01145bb2edfc771$exports, $09063b8df282f9e7$var$$fe2cab60e3c7ea35$exports), $09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$var$$a01145bb2edfc771$exports, $09063b8df282f9e7$var$$b1f503bd59fa3427$exports), $09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$var$$a01145bb2edfc771$exports, $09063b8df282f9e7$var$$eb30d0fbb9378b9a$exports), $09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$var$$a01145bb2edfc771$exports, $09063b8df282f9e7$var$$345f51138f435756$exports), $09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$var$$a01145bb2edfc771$exports, $09063b8df282f9e7$var$$15eac7d4db191f2f$exports), $09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$var$$a01145bb2edfc771$exports, $09063b8df282f9e7$var$$b9bef41109a8f18c$exports);
var $09063b8df282f9e7$var$$68aab1d0e8e5016c$exports = {};
$09063b8df282f9e7$var$$parcel$export($09063b8df282f9e7$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $09063b8df282f9e7$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__runInitializers = function $68aab1d0e8e5016c$var$__runInitializers(e, r, c) {
    for(var t = arguments.length > 2, a = 0; a < r.length; a++)c = t ? r[a].call(e, c) : r[a].call(e);
    return t ? c : void 0;
}, $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__esDecorate = function $68aab1d0e8e5016c$var$__esDecorate(e, r, c, t, a, $) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var s, n = t.kind, l = "getter" === n ? "get" : "setter" === n ? "set" : "value", i = !r && e ? t.static ? e : e.prototype : null, u = r || (i ? Object.getOwnPropertyDescriptor(i, t.name) : {}), b = !1, p = c.length - 1; p >= 0; p--){
        var f = {};
        for(var d in t)f[d] = "access" === d ? {} : t[d];
        for(var d in t.access)f.access[d] = t.access[d];
        f.addInitializer = function(e) {
            if (b) throw TypeError("Cannot add initializers after decoration has completed");
            $.push(o(e || null));
        };
        var _ = (0, c[p])("accessor" === n ? {
            get: u.get,
            set: u.set
        } : u[l], f);
        if ("accessor" === n) {
            if (void 0 === _) continue;
            if (null === _ || (void 0 === _ ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(_)) !== "object") throw TypeError("Object expected");
            (s = o(_.get)) && (u.get = s), (s = o(_.set)) && (u.set = s), (s = o(_.init)) && a.unshift(s);
        } else (s = o(_)) && ("field" === n ? a.unshift(s) : u[l] = s);
    }
    i && Object.defineProperty(i, t.name, u), b = !0;
}, $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__setFunctionName = function $68aab1d0e8e5016c$var$__setFunctionName(e, r, c) {
    return (void 0 === r ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(r)) === "symbol" && (r = r.description ? "[".concat(r.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: c ? "".concat(c, " ", r) : r
    });
}, $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function $68aab1d0e8e5016c$var$__classPrivateFieldGet(e, r, c, t) {
    if ("a" === c && !t) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof r ? e !== r || !t : !r.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === c ? t : "a" === c ? t.call(e) : t ? t.value : r.get(e);
}, $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function $68aab1d0e8e5016c$var$__classPrivateFieldSet(e, r, c, t, a) {
    if ("m" === t) throw TypeError("Private method is not writable");
    if ("a" === t && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof r ? e !== r || !a : !r.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === t ? a.call(e, c) : a ? a.value = c : r.set(e, c), c;
}, $09063b8df282f9e7$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, r, c, t, a, $, o, s, n, l, i = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149,
        $ec0d3058e92a8855$export$b5d042d2b680aed6
    ], u = [], b = $f8c7f7c57e720586$exports.FormComponent, p = [], f = [], d = [];
    return a = function(e) {
        "use strict";
        function r() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, r), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(_$e, "box", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, p), (0, $fClfl.createRef)())
            }), c.set(_$e, $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, f, "")), Object.defineProperty(_$e, "updateTools", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__runInitializers(_$e, d), function() {
                    if (_$e.box.current === document.activeElement) {
                        var _$r, c = (getSelection().getRangeAt(0) || {}).endContainer, t = (null == (_$r = c instanceof Element ? c : c.parentElement) ? void 0 : _$r.getBoundingClientRect()) || {};
                        _$e.cursorPoint = [
                            t.x,
                            t.y
                        ] + "";
                    }
                })
            }), Object.defineProperty(_$e, "updateValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(r) {
                    return _$e.innerValue = r.trim();
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(r, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(r, [
            {
                key: "cursorPoint",
                get: function get() {
                    return $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, c, "f");
                },
                set: function set(e) {
                    $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, c, e, "f");
                }
            },
            {
                key: "toolList",
                get: function get() {
                    return (this.observedProps.tools || $09063b8df282f9e7$var$$a01145bb2edfc771$export$aa718db1466ce312).map(function(e) {
                        return new e;
                    });
                }
            },
            {
                key: "imageTool",
                get: function get() {
                    return this.toolList.find(function(e) {
                        return e instanceof $ec0d3058e92a8855$export$982f47444a2f88da;
                    });
                }
            },
            {
                key: "audioTool",
                get: function get() {
                    return this.toolList.find(function(e) {
                        return e instanceof $09063b8df282f9e7$var$$345f51138f435756$export$6024938f37e646f8;
                    });
                }
            },
            {
                key: "videoTool",
                get: function get() {
                    return this.toolList.find(function(e) {
                        return e instanceof $09063b8df282f9e7$var$$345f51138f435756$export$932111b8028f79ed;
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(r.prototype), "componentDidMount", this).call(this);
                    var _$e = this.props.defaultValue;
                    null != _$e && (this.box.current.innerHTML = _$e), document.addEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(r.prototype), "componentWillUnmount", this).call(this), document.removeEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this;
                    this.cursorPoint;
                    var _$r = this.toolList, c = this.innerValue, t = this.props.name;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                children: _$r.map(function(r) {
                                    return r.render(_$e.box);
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                ref: this.box,
                                className: "form-control h-auto",
                                contentEditable: !0,
                                onInput: function onInput(r) {
                                    var c = r.currentTarget.innerHTML;
                                    return _$e.updateValue(c);
                                },
                                onPaste: this.handlePasteDrop,
                                onDrop: this.handlePasteDrop
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: t,
                                value: c
                            })
                        ]
                    });
                }
            }
        ]), r;
    }(b), c = new WeakMap, $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__setFunctionName(a, "Editor"), r = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, $ = [
        $arNK5.observable
    ], o = [
        $arNK5.computed
    ], s = [
        $arNK5.computed
    ], n = [
        $arNK5.computed
    ], l = [
        $arNK5.computed
    ], $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, $, {
        kind: "accessor",
        name: "cursorPoint",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "cursorPoint" in e;
            },
            get: function get(e) {
                return e.cursorPoint;
            },
            set: function set(e, r) {
                e.cursorPoint = r;
            }
        },
        metadata: r
    }, f, d), $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, o, {
        kind: "getter",
        name: "toolList",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "toolList" in e;
            },
            get: function get(e) {
                return e.toolList;
            }
        },
        metadata: r
    }, null, p), $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, s, {
        kind: "getter",
        name: "imageTool",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "imageTool" in e;
            },
            get: function get(e) {
                return e.imageTool;
            }
        },
        metadata: r
    }, null, p), $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, n, {
        kind: "getter",
        name: "audioTool",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "audioTool" in e;
            },
            get: function get(e) {
                return e.audioTool;
            }
        },
        metadata: r
    }, null, p), $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, l, {
        kind: "getter",
        name: "videoTool",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "videoTool" in e;
            },
            get: function get(e) {
                return e.videoTool;
            }
        },
        metadata: r
    }, null, p), $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__esDecorate(null, t = {
        value: a
    }, i, {
        kind: "class",
        name: a.name,
        metadata: r
    }, null, u), a = t.value, r && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $09063b8df282f9e7$var$$68aab1d0e8e5016c$var$__runInitializers(a, u), a;
}();
$09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$exports, $09063b8df282f9e7$var$$73a8882fd67c0324$exports), $09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$exports, $09063b8df282f9e7$var$$a01145bb2edfc771$exports), $09063b8df282f9e7$var$$parcel$exportWildcard($09063b8df282f9e7$exports, $09063b8df282f9e7$var$$68aab1d0e8e5016c$exports);



var $dKdZ4 = parcelRequire("dKdZ4");

function $62ac3db46cb6ed0e$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
                return t[r];
            }
        });
    }), e;
}
function $62ac3db46cb6ed0e$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $62ac3db46cb6ed0e$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $62ac3db46cb6ed0e$var$$f600741b98acd6fe$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$f600741b98acd6fe$exports, "VariantColors", function() {
    return $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$50b010be9260e56b;
}), $62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$f600741b98acd6fe$exports, "text2color", function() {
    return $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$b480d00b75c9ac2d;
}), $62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$f600741b98acd6fe$exports, "BadgeBar", function() {
    return $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$ef1c4106ceccca63;
});
var $62ac3db46cb6ed0e$var$$f600741b98acd6fe$var$__rest = function $f600741b98acd6fe$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info"
], $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$b480d00b75c9ac2d = function $f600741b98acd6fe$export$b480d00b75c9ac2d(e) {
    return $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$50b010be9260e56b[$6tqvJ.sum.apply(void 0, (0, $36427be7dd51c5e7$export$71511d61b312f219)(Array.from(e, function(e) {
        return e.charCodeAt(0);
    }))) % $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$50b010be9260e56b.length];
}, $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$ef1c4106ceccca63 = function $f600741b98acd6fe$export$ef1c4106ceccca63(e) {
    var t = e.className, r = e.list, a = e.bgResolver, n = void 0 === a ? $62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$b480d00b75c9ac2d : a, c = e.onCheck, s = e.onDelete, i = $62ac3db46cb6ed0e$var$$f600741b98acd6fe$var$__rest(e, [
        "className",
        "list",
        "bgResolver",
        "onCheck",
        "onDelete"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", Object.assign({
        className: "list-unstyled m-0 d-flex flex-wrap gap-2 ".concat(void 0 === t ? "" : t)
    }, i, {
        children: r.map(function(e, t) {
            var r = e.text, a = e.link;
            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($f1387cf7abf6568e$export$2e2bcd8739ae039, {
                bg: n(r),
                text: "white",
                as: "li",
                className: "d-flex align-items-center gap-2",
                children: [
                    a || URL.canParse(r) ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                        className: "text-decoration-none text-white",
                        href: a || r,
                        children: r
                    }) : c ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                        onClick: function onClick() {
                            return c({
                                text: r,
                                link: a
                            }, t);
                        },
                        children: r
                    }) : r,
                    s && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($032c440f677b0c75$export$2e2bcd8739ae039, {
                        onClick: function onClick() {
                            return s({
                                text: r,
                                link: a
                            }, t);
                        }
                    })
                ]
            }, r);
        })
    }));
};
$62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$ef1c4106ceccca63.displayName = "BadgeBar";
var $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$exports, "ImagePreview", function() {
    return $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2;
});
var $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers = function $faee9857e4bdfa8b$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__esDecorate = function $faee9857e4bdfa8b$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__awaiter = function $faee9857e4bdfa8b$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__setFunctionName = function $faee9857e4bdfa8b$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet = function $faee9857e4bdfa8b$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet = function $faee9857e4bdfa8b$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__rest = function $faee9857e4bdfa8b$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], $ = [], f = $28c230f99d2758cc$exports.ObservedComponent, d = [], b = [], m = [], v = [], h = [], _ = [], j = [];
    return s = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, d), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, b, !1))), a.set(_$e, ($62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, m), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, v, ""))), n.set(_$e, ($62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, h), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, _, !1))), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(_$e, j), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "downloading",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "loadedPath",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "viewing",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.observedProps.src;
                    this.loadedPath = "", _$e && this.load(_$e);
                }
            },
            {
                key: "load",
                value: function value(e) {
                    return $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.downloading = !0, [
                                        4,
                                        new Promise(function(t, r) {
                                            var a = new globalThis.Image;
                                            a.onload = t, a.onerror = r, a.src = e;
                                        })
                                    ];
                                case 1:
                                    return t.sent(), this.loadedPath = e, this.downloading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.downloading, r = this.loadedPath, a = this.viewing, n = this.props, c = n.className, s = n.loading, i = (n.src, n.fluid), o = n.rounded, l = n.roundedCircle, u = n.thumbnail, p = $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__rest(n, [
                        "className",
                        "loading",
                        "src",
                        "fluid",
                        "rounded",
                        "roundedCircle",
                        "thumbnail"
                    ]);
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({
                        className: $62ac3db46cb6ed0e$var$$parcel$interopDefault($8bd163097a5514bf$exports)("m-0", _$t && "d-flex justify-content-center align-items-center", c)
                    }, p, {
                        children: [
                            _$t ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ef6032f7425abfe5$export$2e2bcd8739ae039, {}) : r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4833a765594519c8$export$2e2bcd8739ae039, {
                                className: "object-fit-contain",
                                loading: s,
                                fluid: i,
                                rounded: o,
                                roundedCircle: l,
                                thumbnail: u,
                                src: r,
                                onClick: function onClick() {
                                    return _$e.viewing = !0;
                                }
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($365d964e345f76dd$export$2e2bcd8739ae039, {
                                centered: !0,
                                show: a,
                                onHide: function onHide() {
                                    return _$e.viewing = !1;
                                },
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($365d964e345f76dd$export$2e2bcd8739ae039.Body, {
                                        className: "text-center",
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4833a765594519c8$export$2e2bcd8739ae039, {
                                            fluid: !0,
                                            src: r
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($365d964e345f76dd$export$2e2bcd8739ae039.Footer, {
                                        className: "justify-content-center",
                                        as: "a",
                                        href: r,
                                        target: "_blank",
                                        download: r.split("/").pop(),
                                        children: r
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(f), r = new WeakMap, a = new WeakMap, n = new WeakMap, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__setFunctionName(s, "ImagePreview"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, i = [
        $arNK5.observable
    ], o = [
        $arNK5.observable
    ], l = [
        $arNK5.observable
    ], u = [
        (0, $28c230f99d2758cc$exports.reaction)(function(e) {
            return e.observedProps.src;
        })
    ], $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, i, {
        kind: "accessor",
        name: "downloading",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "downloading" in e;
            },
            get: function get(e) {
                return e.downloading;
            },
            set: function set(e, t) {
                e.downloading = t;
            }
        },
        metadata: t
    }, b, m), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, o, {
        kind: "accessor",
        name: "loadedPath",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "loadedPath" in e;
            },
            get: function get(e) {
                return e.loadedPath;
            },
            set: function set(e, t) {
                e.loadedPath = t;
            }
        },
        metadata: t
    }, v, h), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, l, {
        kind: "accessor",
        name: "viewing",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "viewing" in e;
            },
            get: function get(e) {
                return e.viewing;
            },
            set: function set(e, t) {
                e.viewing = t;
            }
        },
        metadata: t
    }, _, j), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, u, {
        kind: "method",
        name: "componentDidMount",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "componentDidMount" in e;
            },
            get: function get(e) {
                return e.componentDidMount;
            }
        },
        metadata: t
    }, null, d), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__esDecorate(null, c = {
        value: s
    }, p, {
        kind: "class",
        name: s.name,
        metadata: t
    }, null, $), s = c.value, t && Object.defineProperty(s, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(s, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ImagePreview"
    }), $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$var$__runInitializers(s, $), s;
}(), $62ac3db46cb6ed0e$var$$8663609ea235ec39$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$8663609ea235ec39$exports, "FileTypeMap", function() {
    return $62ac3db46cb6ed0e$var$$8663609ea235ec39$export$413fb8502ce63cf9;
}), $62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$8663609ea235ec39$exports, "FilePreview", function() {
    return $62ac3db46cb6ed0e$var$$8663609ea235ec39$export$a127194569a41afb;
});
var $62ac3db46cb6ed0e$var$$8663609ea235ec39$var$__rest = function $8663609ea235ec39$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$8663609ea235ec39$export$413fb8502ce63cf9 = {
    stream: "binary",
    compressed: "zip",
    msword: "doc",
    document: "docx",
    powerpoint: "ppt",
    presentation: "pptx",
    excel: "xls",
    sheet: "xlsx"
}, $62ac3db46cb6ed0e$var$$8663609ea235ec39$export$a127194569a41afb = function $8663609ea235ec39$export$a127194569a41afb(e) {
    var t = e.className, r = e.style, a = e.hidden, n = e.type, c = e.path, s = $62ac3db46cb6ed0e$var$$8663609ea235ec39$var$__rest(e, [
        "className",
        "style",
        "hidden",
        "type",
        "path"
    ]), i = (0, $78abda9ee4cae853$export$71511d61b312f219)((null == n ? void 0 : n.split(/\W+/)) || []), o = i[0], l = i.slice(1), u = decodeURI(new URL(c, "http://localhost").pathname.split("/").at(-1)), p = $62ac3db46cb6ed0e$var$$8663609ea235ec39$export$413fb8502ce63cf9[l.at(-1)] || ((null == u ? void 0 : u.includes(".")) ? u.split(".").at(-1) : l.at(-1));
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("figure", {
        className: "d-flex flex-column align-items-center justify-content-center m-0 ".concat(void 0 === t ? "" : t),
        style: r,
        hidden: a,
        children: "image" === o ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2, Object.assign({
            className: "h-100",
            fluid: !0,
            loading: "lazy",
            src: c
        }, s)) : "audio" === o ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("audio", Object.assign({
            controls: !0,
            src: c
        }, s)) : "video" === o ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("video", Object.assign({
            muted: !0,
            src: c,
            onMouseEnter: function onMouseEnter(e) {
                return e.currentTarget.play();
            },
            onMouseLeave: function onMouseLeave(e) {
                return e.currentTarget.pause();
            }
        }, s)) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
            children: [
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", Object.assign({
                    className: "d-inline-flex justify-content-center align-items-center",
                    href: c,
                    target: "_blank",
                    download: u
                }, s, {
                    children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("i", {
                        className: "bi bi-filetype-".concat(p || "file-earmark", " fs-1")
                    })
                })),
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("figcaption", {
                    className: "mw-100 text-truncate",
                    children: u
                })
            ]
        })
    });
};
$62ac3db46cb6ed0e$var$$8663609ea235ec39$export$a127194569a41afb.displayName = "FilePreview";
var $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$exports, "FilePicker", function() {
    return $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1;
});
var $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__runInitializers = function $f2af1554fbcf9c96$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__esDecorate = function $f2af1554fbcf9c96$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__awaiter = function $f2af1554fbcf9c96$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__setFunctionName = function $f2af1554fbcf9c96$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet = function $f2af1554fbcf9c96$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet = function $f2af1554fbcf9c96$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$blobCache = new WeakMap, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1 = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], p = [], $ = $28c230f99d2758cc$exports.FormComponent, f = [], d = [], b = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), a.set(_$e, ($62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__runInitializers(_$e, f), $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__runInitializers(_$e, d, void 0))), r.set(_$e, ($62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__runInitializers(_$e, b), function(t) {
                if (_$e.file = t, t) _$e.innerValue = t, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$blobCache.set(t, URL.createObjectURL(t));
                else if (_$e.value) {
                    var r = _$e.innerValue;
                    "string" == typeof r && r.startsWith("blob:") ? URL.revokeObjectURL(r) : r instanceof File && $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$blobCache.delete(r), _$e.innerValue = "";
                }
            })), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "file",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "fileType",
                get: function get() {
                    var _$e, _$t = this.observedProps.accept, r = this.file;
                    return (null == r ? void 0 : r.type) || (null == (_$e = null == r ? void 0 : r.name.match(/\.\w+$/)) ? void 0 : _$e[0]) || _$t;
                }
            },
            {
                key: "filePath",
                get: function get() {
                    var _$e = this.value;
                    return "string" == typeof _$e ? _$e : $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$blobCache.get(_$e);
                }
            },
            {
                key: "restoreFile",
                value: function value(e) {
                    return $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__awaiter(this, void 0, void 0, function() {
                        var _$t, r;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(a) {
                            switch(a.label){
                                case 0:
                                    if ("string" != typeof e) return [
                                        3,
                                        4
                                    ];
                                    a.label = 1;
                                case 1:
                                    return a.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        (0, $6tqvJ.blobOf)(e)
                                    ];
                                case 2:
                                    return r = new File([
                                        _$t = a.sent()
                                    ], e.split("/").at(-1), {
                                        type: _$t.type
                                    }), $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$blobCache.set(r, e), [
                                        2,
                                        this.file = r
                                    ];
                                case 3:
                                    return a.sent(), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    if (e instanceof File) return $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$blobCache.has(e) || $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$blobCache.set(e, URL.createObjectURL(e)), [
                                        2,
                                        this.file = e
                                    ];
                                    return [
                                        2,
                                        this.file = void 0
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.restoreFile(this.value);
                }
            },
            {
                key: "renderInput",
                value: function value() {
                    var _$e = this, _$t = this.props, a = _$t.id, n = _$t.name, c = _$t.value, s = _$t.required, i = _$t.disabled, o = _$t.accept, l = _$t.multiple, u = this.filePath;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                ref: this.ref,
                                className: "position-absolute start-0 top-0 w-100 h-100 opacity-0",
                                type: "file",
                                name: c ? void 0 : n,
                                required: !c && s,
                                id: a,
                                disabled: i,
                                accept: o,
                                multiple: l,
                                onChange: function onChange(t) {
                                    var a = t.currentTarget.files;
                                    return $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(_$e, r, "f").call(_$e, null == a ? void 0 : a[0]);
                                }
                            }),
                            u && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: n,
                                value: u
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.filePath, a = this.fileType, n = this.props, c = n.className, s = n.style;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "d-inline-block border rounded position-relative ".concat(void 0 === c ? "" : c),
                        style: Object.assign({
                            width: "10rem",
                            height: "10rem"
                        }, s),
                        children: [
                            _$t ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$8663609ea235ec39$export$a127194569a41afb, {
                                className: "w-100 h-100",
                                type: a,
                                path: _$t
                            }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "w-100 h-100 d-flex justify-content-center align-items-center display-1",
                                children: "+"
                            }),
                            this.renderInput(),
                            _$t && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($032c440f677b0c75$export$2e2bcd8739ae039, {
                                className: "position-absolute top-0 end-0",
                                style: {
                                    width: "0.5rem",
                                    height: "0.5rem"
                                },
                                onClick: function onClick() {
                                    return $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(_$e, r, "f").call(_$e);
                                }
                            })
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__setFunctionName(c, "FilePicker"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, s = [
        $arNK5.observable
    ], i = [
        $arNK5.computed
    ], o = [
        $arNK5.computed
    ], l = [
        (0, $28c230f99d2758cc$exports.reaction)(function(e) {
            return e.value;
        })
    ], $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "file",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "file" in e;
            },
            get: function get(e) {
                return e.file;
            },
            set: function set(e, t) {
                e.file = t;
            }
        },
        metadata: t
    }, d, b), $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "fileType",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fileType" in e;
            },
            get: function get(e) {
                return e.fileType;
            }
        },
        metadata: t
    }, null, f), $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, o, {
        kind: "getter",
        name: "filePath",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "filePath" in e;
            },
            get: function get(e) {
                return e.filePath;
            }
        },
        metadata: t
    }, null, f), $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, l, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "restoreFile" in e;
            },
            get: function get(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, f), $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__esDecorate(null, n = {
        value: c
    }, u, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, p), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FilePicker"
    }), $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$var$__runInitializers(c, p), c;
}(), $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$exports, "FileModel", function() {
    return $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$export$424c8de2e117ab22;
}), $62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$exports, "FileUploader", function() {
    return $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749;
});
var $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__esDecorate = function $a21a50f24f1cbd28$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__runInitializers = function $a21a50f24f1cbd28$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__awaiter = function $a21a50f24f1cbd28$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet = function $a21a50f24f1cbd28$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet = function $a21a50f24f1cbd28$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__setFunctionName = function $a21a50f24f1cbd28$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__rest = function $a21a50f24f1cbd28$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$export$424c8de2e117ab22 = function() {
    var e, t, r, a, n = $a1830bff0fabd0b0$export$d12e20a4eec10acf, c = [], s = [];
    return r = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), a.set(_$e, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, c, [])), $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, s), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "files",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "clear",
                value: function value() {
                    (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(t.prototype), "clear", this).call(this), this.files = [];
                }
            },
            {
                key: "upload",
                value: function value(e) {
                    return $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var _$t;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(r) {
                            return e instanceof Blob && (e = URL.createObjectURL(e)), (_$t = this.files).includes(e) || (this.files = (0, $36427be7dd51c5e7$export$71511d61b312f219)(_$t).concat([
                                e
                            ])), [
                                2,
                                e
                            ];
                        });
                    });
                }
            },
            {
                key: "delete",
                value: function value(e) {
                    return $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var _$t, r;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(a) {
                            return r = (_$t = this.files).indexOf(e), this.files = (0, $36427be7dd51c5e7$export$71511d61b312f219)(_$t.slice(0, r)).concat((0, $36427be7dd51c5e7$export$71511d61b312f219)(_$t.slice(r + 1))), [
                                2
                            ];
                        });
                    });
                }
            },
            {
                key: "move",
                value: function value(e, t) {
                    var r = this.files, a = r[e], n = r[t], c = Math.min(e, t), s = Math.max(e, t), i = r.slice(0, c), o = r.slice(c + 1, s), l = r.slice(s + 1);
                    this.files = e < t ? (0, $36427be7dd51c5e7$export$71511d61b312f219)(i).concat((0, $36427be7dd51c5e7$export$71511d61b312f219)(o), [
                        n,
                        a
                    ], (0, $36427be7dd51c5e7$export$71511d61b312f219)(l)) : (0, $36427be7dd51c5e7$export$71511d61b312f219)(i).concat([
                        a,
                        n
                    ], (0, $36427be7dd51c5e7$export$71511d61b312f219)(o), (0, $36427be7dd51c5e7$export$71511d61b312f219)(l));
                }
            }
        ]), t;
    }(n), a = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = n[Symbol.metadata]) ? e : null) : void 0, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__esDecorate(r, null, [
        $arNK5.observable
    ], {
        kind: "accessor",
        name: "files",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "files" in e;
            },
            get: function get(e) {
                return e.files;
            },
            set: function set(e, t) {
                e.files = t;
            }
        },
        metadata: t
    }, c, s), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749 = function() {
    var e, t, r, a, n, c, s, i = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], o = [], l = $28c230f99d2758cc$exports.FormComponent, u = [], p = [], $ = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, u), $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, p, void 0))), Object.defineProperty(_$e, "handleDrop", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__runInitializers(_$e, $), function(t) {
                    return function(r) {
                        r.preventDefault();
                        var a = _$e.props, n = _$e.pickIndex;
                        null != n && (a.store.move(n, t), _$e.innerValue = a.store.files);
                    };
                })
            }), Object.defineProperty(_$e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    var _$t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return function(r) {
                        return $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__awaiter(_$e, void 0, void 0, function() {
                            var _$e;
                            return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        if (_$e = this.props.store, !_$t) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            _$e.delete(_$t)
                                        ];
                                    case 1:
                                        a.sent(), a.label = 2;
                                    case 2:
                                        if (!r) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            _$e.upload(r)
                                        ];
                                    case 3:
                                        a.sent(), a.label = 4;
                                    case 4:
                                        return this.innerValue = _$e.files, [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "pickIndex",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.props.store.files = this.value || [];
                }
            },
            {
                key: "restoreFile",
                value: function value(e) {
                    this.props.store.files = e;
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.props, r = _$t.className, a = _$t.style, n = _$t.multiple, c = (_$t.store, _$t.value, _$t.defaultValue, _$t.onChange, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__rest(_$t, [
                        "className",
                        "style",
                        "multiple",
                        "store",
                        "value",
                        "defaultValue",
                        "onChange"
                    ])), s = this.value;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ol", {
                        className: "list-inline d-flex ".concat(void 0 === r ? "m-0" : r),
                        style: a,
                        onDragOver: function onDragOver(e) {
                            return e.preventDefault();
                        },
                        children: [
                            null == s ? void 0 : s.map(function(t, r) {
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                                    className: "list-inline-item",
                                    draggable: !0,
                                    onDragStart: function onDragStart() {
                                        return _$e.pickIndex = r;
                                    },
                                    onDrop: _$e.handleDrop(r),
                                    children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                        value: t,
                                        onChange: _$e.handleChange(t)
                                    }))
                                }, t);
                            }),
                            (n || !(null == s ? void 0 : s[0])) && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                                className: "list-inline-item",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                    name: void 0,
                                    value: "",
                                    required: !(null == s ? void 0 : s[0]) && c.required,
                                    onChange: this.handleChange()
                                }))
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(l), r = new WeakMap, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__setFunctionName(n, "FileUploader"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = l[Symbol.metadata]) ? e : null) : void 0, c = [
        $arNK5.observable
    ], s = [
        (0, $28c230f99d2758cc$exports.reaction)(function(e) {
            return e.value;
        })
    ], $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "pickIndex",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "pickIndex" in e;
            },
            get: function get(e) {
                return e.pickIndex;
            },
            set: function set(e, t) {
                e.pickIndex = t;
            }
        },
        metadata: t
    }, p, $), $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, s, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "restoreFile" in e;
            },
            get: function get(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, u), $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__esDecorate(null, a = {
        value: n
    }, i, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, o), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FileUploader"
    }), $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$var$__runInitializers(n, o), n;
}(), $62ac3db46cb6ed0e$var$$4e6504f15de995a8$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$4e6504f15de995a8$exports, "FormField", function() {
    return $62ac3db46cb6ed0e$var$$4e6504f15de995a8$export$56e87bf42978147a;
});
var $62ac3db46cb6ed0e$var$$4e6504f15de995a8$var$__rest = function $4e6504f15de995a8$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$4e6504f15de995a8$export$56e87bf42978147a = function $4e6504f15de995a8$export$56e87bf42978147a(e) {
    var t = e.className, r = e.style, a = e.label, n = e.placeholder, c = e.id, s = e.name, i = e.options, o = e.multiple, l = e.rows, u = e.onBlur, p = $62ac3db46cb6ed0e$var$$4e6504f15de995a8$var$__rest(e, [
        "className",
        "style",
        "label",
        "placeholder",
        "id",
        "name",
        "options",
        "multiple",
        "rows",
        "onBlur"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.FloatingLabel, {
        className: t,
        style: r,
        label: a,
        controlId: s || c,
        onBlur: function onBlur(e) {
            e.target.checkValidity() ? (e.target.classList.remove("is-invalid"), e.currentTarget.classList.remove("is-invalid")) : (e.target.classList.add("is-invalid"), e.currentTarget.classList.add("is-invalid")), null == u || u(e);
        },
        children: i ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Select, Object.assign({
            className: o ? "h-auto" : "",
            name: s,
            multiple: o,
            htmlSize: l
        }, p, {
            children: i.map(function(e) {
                var t = e.value, r = e.text, a = e.label, n = e.disabled;
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("option", {
                    value: t,
                    label: a,
                    disabled: n,
                    children: r || t
                }, t);
            })
        })) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control, Object.assign({
            className: l > 1 ? "h-auto" : "",
            name: s,
            multiple: o,
            rows: l
        }, p, {
            placeholder: n || ("string" == typeof a ? a : s || c)
        }))
    });
};
$62ac3db46cb6ed0e$var$$4e6504f15de995a8$export$56e87bf42978147a.displayName = "FormField";
var $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$exports, "RangeInput", function() {
    return $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9;
});
var $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__esDecorate = function $92bd5b9c2e8cd28e$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__runInitializers = function $92bd5b9c2e8cd28e$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__setFunctionName = function $92bd5b9c2e8cd28e$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__rest = function $92bd5b9c2e8cd28e$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9 = function() {
    var e, t, r, a, n = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], c = [], s = $28c230f99d2758cc$exports.FormComponent;
    return $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments);
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "renderItem",
                value: function value(e) {
                    var _$t = this.value, r = this.observedProps, a = r.icon, n = r.step, c = void 0 === n ? 1 : n, s = Math.max(Math.min((void 0 === _$t ? 0 : _$t) - c * e, +c), 0);
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                        className: "text-center",
                        children: "function" == typeof a ? a(s) : a
                    }, e);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.observedProps, r = _$t.className, a = _$t.icon, n = _$t.min, c = _$t.max, s = void 0 === c ? a ? 5 : 100 : c, i = (_$t.onChange, $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__rest(_$t, [
                        "className",
                        "icon",
                        "min",
                        "max",
                        "onChange"
                    ])), o = this.value, l = void 0 === o ? n || 0 : o;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: void 0 === r ? "d-inline-block position-relative" : r,
                        title: l + "",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", Object.assign({
                                min: n,
                                max: s,
                                value: l
                            }, i, {
                                className: a ? "opacity-0" : "",
                                style: {
                                    margin: "0 -0.5rem",
                                    cursor: "pointer"
                                },
                                type: "range",
                                onChange: function onChange(t) {
                                    return _$e.innerValue = t.currentTarget.value;
                                }
                            })),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ol", {
                                className: "list-unstyled user-select-none position-absolute start-0 top-0 w-100 h-100 pe-none d-flex justify-content-around",
                                children: Array.from({
                                    length: +s
                                }, function(t, r) {
                                    return _$e.renderItem(r);
                                })
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(s), "RangeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RangeInput"
    }), $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$var$__runInitializers(a, c), a;
}(), $62ac3db46cb6ed0e$var$$fa84453248a3f065$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$fa84453248a3f065$exports, "TextInputTypes", function() {
    return $62ac3db46cb6ed0e$var$$fa84453248a3f065$export$82cd8db40d0f609c;
}), $62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$fa84453248a3f065$exports, "BadgeInput", function() {
    return $62ac3db46cb6ed0e$var$$fa84453248a3f065$export$76834b0602c89bd;
});
var $62ac3db46cb6ed0e$var$$fa84453248a3f065$var$__esDecorate = function $fa84453248a3f065$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$fa84453248a3f065$var$__runInitializers = function $fa84453248a3f065$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$fa84453248a3f065$var$__setFunctionName = function $fa84453248a3f065$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$fa84453248a3f065$export$82cd8db40d0f609c = [
    "text",
    "number",
    "tel",
    "email",
    "url"
], $62ac3db46cb6ed0e$var$$fa84453248a3f065$export$76834b0602c89bd = function() {
    var e, t, r, a, n = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], c = [], s = $28c230f99d2758cc$exports.FormComponent;
    return $62ac3db46cb6ed0e$var$$fa84453248a3f065$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "handleInput", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.currentTarget, a = r.value, n = _$e.innerValue || [];
                    switch(t.key){
                        case "Enter":
                            t.preventDefault(), r.value = "", a && (_$e.innerValue = (0, $36427be7dd51c5e7$export$71511d61b312f219)(n).concat([
                                a
                            ]));
                            break;
                        case "Backspace":
                            a || (_$e.innerValue = n.slice(0, -1));
                    }
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "delete",
                value: function value(e) {
                    var _$t = this.innerValue;
                    this.innerValue = (0, $36427be7dd51c5e7$export$71511d61b312f219)(_$t.slice(0, e)).concat((0, $36427be7dd51c5e7$export$71511d61b312f219)(_$t.slice(e + 1)));
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.value, r = this.props, a = r.className, n = r.style, c = r.type, s = r.name, i = r.required, o = r.placeholder;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "form-control p-2 d-flex flex-wrap gap-2 ".concat(void 0 === a ? "" : a),
                        style: n,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                                list: (_$t || []).map(function(e) {
                                    return {
                                        text: e
                                    };
                                }),
                                onDelete: function onDelete(t, r) {
                                    return (0, $5f1da914d9b7563a$export$71511d61b312f219)(t), _$e.delete(r);
                                }
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                className: "border-0 flex-fill",
                                style: {
                                    outline: "none"
                                },
                                type: c,
                                required: (0, $6tqvJ.isEmpty)(_$t) ? i : void 0,
                                placeholder: o,
                                onKeyDown: this.handleInput
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: s,
                                value: JSON.stringify(_$t)
                            })
                        ]
                    });
                }
            }
        ], [
            {
                key: "match",
                value: function value(e) {
                    return $62ac3db46cb6ed0e$var$$fa84453248a3f065$export$82cd8db40d0f609c.includes(e);
                }
            }
        ]), t;
    }(s), "BadgeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $62ac3db46cb6ed0e$var$$fa84453248a3f065$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "BadgeInput"
    }), $62ac3db46cb6ed0e$var$$fa84453248a3f065$var$__runInitializers(a, c), a;
}(), $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$exports, "ArrayField", function() {
    return $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$export$42efeba470be9198;
});
var $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$var$__esDecorate = function $36ed2012ed0bbec3$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$var$__runInitializers = function $36ed2012ed0bbec3$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$var$__setFunctionName = function $36ed2012ed0bbec3$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$export$42efeba470be9198 = function() {
    var e, t, r, a, n = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], c = [], s = $28c230f99d2758cc$exports.FormComponent;
    return $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value() {
                    return _$e.innerValue = (0, $36427be7dd51c5e7$export$71511d61b312f219)(_$e.innerValue || []).concat([
                        {}
                    ]);
                }
            }), Object.defineProperty(_$e, "remove", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r;
                    return _$e.innerValue = null == (r = _$e.innerValue) ? void 0 : r.filter(function(e, r) {
                        return r !== t;
                    });
                }
            }), Object.defineProperty(_$e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return function(r) {
                        var a, n, c = r.currentTarget, s = (0, $6tqvJ.formToJSON)(c), i = _$e.innerValue, o = (0, $36427be7dd51c5e7$export$71511d61b312f219)(i.slice(0, t)).concat([
                            s
                        ], (0, $36427be7dd51c5e7$export$71511d61b312f219)(i.slice(t + 1))).map(function(e) {
                            return (0, $arNK5.toJS)(e);
                        });
                        null == (n = (a = _$e.props).onChange) || n.call(a, o);
                    };
                }
            }), Object.defineProperty(_$e, "handleUpdate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return function(r) {
                        var a = r.currentTarget;
                        return _$e.innerValue[t] = (0, $6tqvJ.formToJSON)(a);
                    };
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function value() {
                    (0, $6f4acbd166de2c44$export$71511d61b312f219)((0, $435c1b7a62b9651a$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), (0, $6tqvJ.isEmpty)(this.value) && this.add();
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e, _$t = this, r = this.props, a = r.className, n = void 0 === a ? "" : a, c = r.style, s = r.name, i = r.renderItem;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
                        children: null == (_$e = this.value) ? void 0 : _$e.map(function(e, r, a) {
                            var o = a.length;
                            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("fieldset", {
                                className: "d-flex align-items-center my-2 gap-2 ".concat(n),
                                style: c,
                                name: s,
                                onChange: _$t.handleChange(r),
                                onBlur: _$t.handleUpdate(r),
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "flex-fill",
                                        children: i(e, r)
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($218cf913ebc6a9cf$export$2e2bcd8739ae039, {
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "warning",
                                                onClick: _$t.add,
                                                children: "+"
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "danger",
                                                disabled: o < 2,
                                                onClick: function onClick() {
                                                    return _$t.remove(r);
                                                },
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }, JSON.stringify(e));
                        })
                    });
                }
            }
        ]), t;
    }(s), "ArrayField"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ArrayField"
    }), $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$var$__runInitializers(a, c), a;
}(), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$cd7ba08b282791a9$exports, "RestForm", function() {
    return $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$export$341e3470805a945e;
});
var $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__runInitializers = function $cd7ba08b282791a9$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__esDecorate = function $cd7ba08b282791a9$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__awaiter = function $cd7ba08b282791a9$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__setFunctionName = function $cd7ba08b282791a9$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__classPrivateFieldGet = function $cd7ba08b282791a9$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__classPrivateFieldSet = function $cd7ba08b282791a9$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest = function $cd7ba08b282791a9$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$export$341e3470805a945e = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], p = [], $ = $28c230f99d2758cc$exports.ObservedComponent, f = [], d = [], b = [], m = n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__runInitializers(_$e, f), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__runInitializers(_$e, d, !1))), Object.defineProperty(_$e, "handleSubmit", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__runInitializers(_$e, b), function(t) {
                    return $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, r, a, n, c, s, i;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(o) {
                            switch(o.label){
                                case 0:
                                    if (t.preventDefault(), t.stopPropagation(), r = (_$e = t.currentTarget).checkValidity(), this.validated = !0, !r) return [
                                        3,
                                        2
                                    ];
                                    return n = (a = this.props).id, c = a.store, s = a.onSubmit, i = (0, $6tqvJ.formToJSON)(_$e), [
                                        4,
                                        null == c ? void 0 : c.updateOne(i, n)
                                    ];
                                case 1:
                                    i = o.sent(), null == s || s(i), null == c || c.clearCurrent(), o.label = 2;
                                case 2:
                                    return this.validated = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(_$e, "handleReset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.currentTarget, a = _$e.props, n = a.onReset, c = a.store;
                    null == n || n((0, $6tqvJ.formToJSON)(r)), null == c || c.clearCurrent();
                }
            }), Object.defineProperty(_$e, "renderFile", (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var _$t = e.key, r = e.type, a = e.required, n = e.multiple, c = e.accept, s = e.uploader, i = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(e, [
                    "key",
                    "type",
                    "required",
                    "multiple",
                    "accept",
                    "uploader"
                ]);
                return function(e) {
                    var o = e[_$t], l = (Array.isArray(o) ? o : [
                        o
                    ]).filter(Boolean);
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: _$t
                    }, i, {
                        children: s ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749, {
                            store: s,
                            name: null == _$t ? void 0 : _$t.toString(),
                            required: a,
                            multiple: n,
                            accept: c,
                            defaultValue: l
                        }) : l.map(function(e) {
                            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$8663609ea235ec39$export$a127194569a41afb, {
                                type: r,
                                path: e
                            });
                        })
                    }));
                };
            })), Object.defineProperty(_$e, "renderCheckGroup", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.key, a = t.type, n = t.options, c = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(t, [
                        "key",
                        "type",
                        "options"
                    ]);
                    return function(t) {
                        return (0, $1c838ced510d5939$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                            name: r
                        }, c, {
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                children: _$e.fieldReady && n.map(function(e) {
                                    var n, s = e.value, i = e.label, o = void 0 === i ? s : i;
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Check, Object.assign({
                                        id: [
                                            r,
                                            s
                                        ] + "",
                                        label: o,
                                        inline: !0
                                    }, c, {
                                        type: a,
                                        name: r.toString(),
                                        value: s,
                                        defaultChecked: null == (n = t[r]) ? void 0 : n.includes(s)
                                    }), s);
                                })
                            })
                        }));
                    };
                }
            }), Object.defineProperty(_$e, "renderMultipleInput", (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.type, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type"
                ]));
                return function(t) {
                    var n = t[r];
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, a, {
                        children: _$e.fieldReady && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$fa84453248a3f065$export$76834b0602c89bd, Object.assign({}, a, {
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: n
                        }))
                    }));
                };
            })), Object.defineProperty(_$e, "renderHTMLEditor", (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.contentEditable, t.tools), n = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "contentEditable",
                    "tools"
                ]);
                return function(t) {
                    var c = t[r];
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, n, {
                        children: _$e.fieldReady && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($09063b8df282f9e7$exports.Editor, {
                            tools: a,
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: c
                        })
                    }));
                };
            })), Object.defineProperty(_$e, "renderField", (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t, r) {
                var a = t.key, n = t.type, c = t.step, s = t.renderLabel, i = (t.renderInput, t.validMessage), o = t.invalidMessage, l = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type",
                    "step",
                    "renderLabel",
                    "renderInput",
                    "validMessage",
                    "invalidMessage"
                ]);
                void 0 === r && (r = {});
                var u = "function" == typeof s ? null == s ? void 0 : s(a) : s || a;
                return function(t) {
                    var s = t[a];
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($0f0265dfbf11fad4$export$2e2bcd8739ae039, {
                        hasValidation: _$e.customValidation,
                        children: [
                            _$e.fieldReady && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$4e6504f15de995a8$export$56e87bf42978147a, Object.assign({}, r, l, {
                                type: n,
                                step: c,
                                label: u,
                                size: _$e.observedProps.size,
                                name: a.toString(),
                                defaultValue: m.dateValueOf({
                                    type: n,
                                    step: c
                                }, s)
                            })),
                            i && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "valid",
                                children: i
                            }),
                            o && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "invalid",
                                children: o
                            })
                        ]
                    });
                };
            })), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "validated",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.props, _$t = _$e.id, r = _$e.store;
                    _$t && (null == r || r.getOne(_$t));
                }
            },
            {
                key: "fields",
                get: function get() {
                    var _$e = this;
                    return this.observedProps.fields.map(function(t) {
                        var r = t.renderInput, a = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(t, [
                            "renderInput"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderInput: null != r ? r : "file" === a.type ? _$e.renderFile(a) : ("radio" === a.type || "checkbox" === a.type) && a.options ? _$e.renderCheckGroup(a) : a.contentEditable ? _$e.renderHTMLEditor(a) : !a.options && a.multiple ? _$e.renderMultipleInput(a) : a.key && _$e.renderField(a, a.rows && !a.options ? {
                                as: "textarea"
                            } : {})
                        });
                    });
                }
            },
            {
                key: "readOnly",
                get: function get() {
                    return this.fields.every(function(e) {
                        var _$t = e.readOnly, r = e.disabled;
                        return _$t || r;
                    });
                }
            },
            {
                key: "customValidation",
                get: function get() {
                    return this.fields.some(function(e) {
                        var _$t = e.validMessage, r = e.invalidMessage;
                        return _$t || r;
                    });
                }
            },
            {
                key: "fieldReady",
                get: function get() {
                    var _$e = this.observedProps, _$t = _$e.id, r = _$e.store;
                    return !_$t || (null == r ? void 0 : r.downloading) < 1;
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.fields, _$t = this.readOnly, r = this.customValidation, a = this.validated, n = this.props, c = (n.id, n.className), s = n.size, i = n.store, o = n.translator, l = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(n, [
                        "id",
                        "className",
                        "size",
                        "store",
                        "translator"
                    ]), u = i || {}, p = u.downloading, $ = u.uploading, f = u.currentOne, d = void 0 === f ? {} : f, b = o.t, m = p > 0 || $ > 0;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039, Object.assign({}, l, {
                        className: void 0 === c ? "d-flex flex-column gap-3" : c,
                        validated: a,
                        noValidate: r,
                        onSubmit: this.handleSubmit,
                        onReset: this.handleReset,
                        children: [
                            _$e.map(function(e) {
                                var _$t, r = e.renderInput, a = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(e, [
                                    "renderInput"
                                ]);
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
                                    children: null == r ? void 0 : r(d, a)
                                }, null == (_$t = a.key) ? void 0 : _$t.toString());
                            }),
                            !_$t && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex gap-3",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "submit",
                                        disabled: m,
                                        children: b("submit")
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "reset",
                                        variant: "danger",
                                        disabled: m,
                                        children: b("cancel")
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($);
    return r = new WeakMap, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__setFunctionName(n, "RestForm"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, c = [
        $arNK5.observable
    ], s = [
        $arNK5.computed
    ], i = [
        $arNK5.computed
    ], o = [
        $arNK5.computed
    ], l = [
        $arNK5.computed
    ], $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "validated",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "validated" in e;
            },
            get: function get(e) {
                return e.validated;
            },
            set: function set(e, t) {
                e.validated = t;
            }
        },
        metadata: t
    }, d, b), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "fields",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fields" in e;
            },
            get: function get(e) {
                return e.fields;
            }
        },
        metadata: t
    }, null, f), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "readOnly",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "readOnly" in e;
            },
            get: function get(e) {
                return e.readOnly;
            }
        },
        metadata: t
    }, null, f), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "customValidation",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "customValidation" in e;
            },
            get: function get(e) {
                return e.customValidation;
            }
        },
        metadata: t
    }, null, f), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "fieldReady",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fieldReady" in e;
            },
            get: function get(e) {
                return e.fieldReady;
            }
        },
        metadata: t
    }, null, f), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__esDecorate(null, a = {
        value: n
    }, u, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, p), m = n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestForm"
    }), Object.defineProperty(n, "dateValueOf", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function value(e, t) {
            var r = e.type, a = e.step;
            return (0, $6tqvJ.isEmpty)(t) ? t : "month" === r ? (0, $6tqvJ.formatDate)(t, "YYYY-MM") : "date" === r ? (0, $6tqvJ.formatDate)(t, "YYYY-MM-DD") : "datetime-local" === r ? (0, $6tqvJ.formatDate)(t, "YYYY-MM-DDTHH:mm".concat(60 > +(void 0 === a ? "60" : a) ? ":ss" : "")) : t;
        }
    }), Object.defineProperty(n, "FieldBox", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function value(e) {
            var t = e.name, r = e.renderLabel, a = e.validMessage, n = e.invalidMessage, c = e.children, s = $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__rest(e, [
                "name",
                "renderLabel",
                "validMessage",
                "invalidMessage",
                "children"
            ]);
            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Group, Object.assign({}, s, {
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Label, {
                        children: "function" == typeof r ? r(t) : r || t
                    }),
                    c,
                    a && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "valid",
                        children: a
                    }),
                    n && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "invalid",
                        children: n
                    })
                ]
            }));
        }
    }), $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$var$__runInitializers(n, p), m = n;
}(), $62ac3db46cb6ed0e$var$$bcc38e2aa906301f$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$bcc38e2aa906301f$exports, "Pager", function() {
    return $62ac3db46cb6ed0e$var$$bcc38e2aa906301f$export$57625d62e5386b09;
});
var $62ac3db46cb6ed0e$var$$bcc38e2aa906301f$export$57625d62e5386b09 = function $bcc38e2aa906301f$export$57625d62e5386b09(e) {
    var t = e.pageSize, r = e.pageIndex, a = e.pageCount, n = e.onChange;
    function c() {
        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, r = {
            pageSize: t,
            pageIndex: _$e
        };
        return {
            href: "?".concat((0, $6tqvJ.buildURLData)(Object.assign(Object.assign({}, (0, $6tqvJ.parseURLData)()), r))),
            onClick: n && function(e) {
                e.preventDefault(), n(r);
            }
        };
    }
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("form", {
        className: "m-0 d-flex align-items-center gap-2",
        onSubmit: n && function(e) {
            return e.preventDefault(), e.stopPropagation();
        },
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageSize",
                defaultValue: t,
                min: 1,
                required: !0,
                onChange: function onChange(e) {
                    var t = e.currentTarget;
                    return t.reportValidity() && (null == n ? void 0 : n({
                        pageSize: +t.value,
                        pageIndex: r
                    }));
                }
            }),
            "x",
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageIndex",
                defaultValue: r || 1,
                min: 1,
                max: a,
                required: !0,
                onChange: function onChange(e) {
                    var r = e.currentTarget;
                    return r.reportValidity() && (null == n ? void 0 : n({
                        pageSize: t,
                        pageIndex: +r.value
                    }));
                }
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039, {
                className: "m-0",
                children: [
                    r > 1 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039.Item, Object.assign({}, c(1), {
                        children: "1"
                    })),
                    r > 3 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039.Ellipsis, {}),
                    r > 2 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039.Item, Object.assign({}, c(r - 1), {
                        children: r - 1
                    })),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039.Item, {
                        active: !0,
                        children: r
                    }),
                    a - r > 1 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039.Item, Object.assign({}, c(r + 1), {
                        children: r + 1
                    })),
                    a - r > 2 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039.Ellipsis, {}),
                    r < a && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($26712abca8b89b64$export$2e2bcd8739ae039.Item, Object.assign({}, c(a), {
                        children: a
                    }))
                ]
            })
        ]
    });
};
$62ac3db46cb6ed0e$var$$bcc38e2aa906301f$export$57625d62e5386b09.displayName = "Pager";
var $62ac3db46cb6ed0e$var$$3800431d840f9bec$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$3800431d840f9bec$exports, "RestTable", function() {
    return $62ac3db46cb6ed0e$var$$3800431d840f9bec$export$fd90441354a7d816;
});
var $62ac3db46cb6ed0e$var$$bfbc9f72f179e373$var$__rest = function $bfbc9f72f179e373$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$bfbc9f72f179e373$export$28baae8ef86bbf36 = (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)(function(e) {
    var t = e.fields, r = e.store, a = e.translator, n = $62ac3db46cb6ed0e$var$$bfbc9f72f179e373$var$__rest(e, [
        "fields",
        "store",
        "translator"
    ]), c = r.indexKey, s = r.currentOne, i = !(0, $6tqvJ.isEmpty)(s), o = s[c];
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($365d964e345f76dd$export$2e2bcd8739ae039, {
        show: i,
        onHide: function onHide() {
            return r.clearCurrent();
        },
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($365d964e345f76dd$export$2e2bcd8739ae039.Header, {
                closeButton: !0,
                children: o
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)($365d964e345f76dd$export$2e2bcd8739ae039.Body, {
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$cd7ba08b282791a9$export$341e3470805a945e, Object.assign({
                    id: o,
                    fields: t,
                    store: r,
                    translator: a
                }, n))
            })
        ]
    });
});
$62ac3db46cb6ed0e$var$$aac96070b6d8b41d$export$5eeb11949c905cc1 = "SrGRNq_filterBar";
var $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__runInitializers = function $3800431d840f9bec$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate = function $3800431d840f9bec$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__awaiter = function $3800431d840f9bec$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__setFunctionName = function $3800431d840f9bec$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__classPrivateFieldGet = function $3800431d840f9bec$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__classPrivateFieldSet = function $3800431d840f9bec$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__rest = function $3800431d840f9bec$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$export$fd90441354a7d816 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p, $, f = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], d = [], b = $28c230f99d2758cc$exports.ObservedComponent, m = [], v = [], h = [];
    return n = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, ($62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__runInitializers(_$e, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__runInitializers(_$e, v, []))), Object.defineProperty(_$e, "toggleCheckAll", (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", ($62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__runInitializers(_$e, h), function() {
                var _$t = _$e.props, r = _$t.store, a = _$t.onCheck, n = r.indexKey, c = r.currentPage;
                _$e.checkedKeys = _$e.checkedKeys.length ? [] : c.map(function(e) {
                    return e[n];
                }), null == a || a(_$e.checkedKeys);
            }))), Object.defineProperty(_$e, "renderCustomBody", (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var _$t = e.key, r = e.type, a = e.multiple, n = e.options, c = e.accept, s = e.rows;
                return "url" === r ? function(e) {
                    var r = e[_$t];
                    return r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                        target: "_blank",
                        href: r,
                        children: r
                    });
                } : "email" === r ? function(e) {
                    var r = e[_$t];
                    return r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                        href: "mailto:".concat(r),
                        children: r
                    });
                } : "tel" === r ? function(e) {
                    var r = e[_$t];
                    return r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                        href: "tel:".concat(r),
                        children: r
                    });
                } : "file" === r ? function(e) {
                    var r = e[_$t];
                    return (Array.isArray(r) ? r : [
                        r
                    ]).map(function(e) {
                        return e && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$8663609ea235ec39$export$a127194569a41afb, {
                            type: c,
                            path: e
                        }, e);
                    });
                } : n || a ? function(e) {
                    var r = e[_$t];
                    return r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                        list: r.map(function(e) {
                            return {
                                text: e
                            };
                        })
                    });
                } : !n && s ? function(e) {
                    var r = e[_$t];
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                        className: "m-0 text-truncate",
                        style: {
                            maxWidth: "20rem"
                        },
                        title: r,
                        children: r
                    });
                } : void 0;
            })), Object.defineProperty(_$e, "getList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $dKdZ4.debounce)(function(t) {
                    var r = t.pageIndex, a = t.pageSize, n = _$e.props, c = n.store, s = n.filter;
                    c.downloading < 1 && c.getList(s, r, a);
                })
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.props, _$t = _$e.store, r = _$e.filter;
                    _$t.clear(), _$t.getList(r);
                }
            },
            {
                key: "fieldSize",
                get: function get() {
                    var _$e = this.observedProps.size;
                    return _$e ? "sm" === _$e ? "sm" : "lg" : void 0;
                }
            },
            {
                key: "checkedKeys",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "toggleCheck",
                value: function value(e) {
                    var _$t, r, a = this.checkedKeys, n = a.indexOf(e);
                    this.checkedKeys = n < 0 ? (0, $36427be7dd51c5e7$export$71511d61b312f219)(a).concat([
                        e
                    ]) : (0, $36427be7dd51c5e7$export$71511d61b312f219)(a.slice(0, n)).concat((0, $36427be7dd51c5e7$export$71511d61b312f219)(a.slice(n + 1))), null == (r = (_$t = this.props).onCheck) || r.call(_$t, this.checkedKeys);
                }
            },
            (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                key: "checkColumn"
            }, "get", function() {
                var _$e, _$t = this, r = this.checkedKeys, a = this.toggleCheckAll, n = this.observedProps.store, c = n.indexKey, s = n.currentPage;
                return _$e = {}, (0, $27ac2acf61c4734a$export$71511d61b312f219)(_$e, "renderHead", function() {
                    var _$e;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Check, (_$e = {
                        type: "checkbox",
                        name: "all-".concat(c.toString()),
                        value: r + ""
                    }, (0, $27ac2acf61c4734a$export$71511d61b312f219)(_$e, "checked", !!s[0] && s.every(function(e) {
                        var _$t = e[c];
                        return r.includes(_$t);
                    })), (0, $27ac2acf61c4734a$export$71511d61b312f219)(_$e, "ref", function(e) {
                        e && (e.indeterminate = !!r.length && r.length < s.length);
                    }), (0, $27ac2acf61c4734a$export$71511d61b312f219)(_$e, "onClick", a), (0, $27ac2acf61c4734a$export$71511d61b312f219)(_$e, "onKeyUp", function(e) {
                        return " " === e.key && a();
                    }), _$e));
                }), (0, $27ac2acf61c4734a$export$71511d61b312f219)(_$e, "renderBody", function(e) {
                    var a = e[c];
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Check, {
                        type: "checkbox",
                        name: c.toString(),
                        value: a,
                        checked: r.includes(a),
                        onClick: function onClick() {
                            return _$t.toggleCheck(a);
                        },
                        onKeyUp: function onKeyUp(e) {
                            return " " === e.key && _$t.toggleCheck(a);
                        }
                    });
                }), _$e;
            }),
            {
                key: "operateColumn",
                get: function get() {
                    var _$e = this, _$t = this.observedProps, r = _$t.editable, a = _$t.deletable, n = _$t.columns, c = _$t.store, s = _$t.translator, i = this.fieldSize, o = s.t, l = n.every(function(e) {
                        return e.readOnly;
                    }), u = n.every(function(e) {
                        return e.disabled;
                    });
                    return {
                        renderHead: function renderHead() {
                            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {});
                        },
                        renderBody: function renderBody(t) {
                            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {
                                children: [
                                    u ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($fClfl.Fragment, {}) : r && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: l ? "primary" : "warning",
                                        size: i,
                                        onClick: function onClick() {
                                            return c.currentOne = t;
                                        },
                                        children: l ? o("view") : o("edit")
                                    }),
                                    a && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: "danger",
                                        size: i,
                                        onClick: function onClick() {
                                            return _$e.deleteList([
                                                t.id
                                            ]);
                                        },
                                        children: o("delete")
                                    })
                                ]
                            });
                        }
                    };
                }
            },
            {
                key: "columns",
                get: function get() {
                    var _$e = this, _$t = this.observedProps, r = _$t.editable, a = _$t.deletable, n = _$t.columns;
                    return [
                        _$t.onCheck && this.checkColumn
                    ].concat((0, $36427be7dd51c5e7$export$71511d61b312f219)(n.map(function(t) {
                        var r = t.renderBody, a = $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__rest(t, [
                            "renderBody"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderBody: null != r ? r : _$e.renderCustomBody(a)
                        });
                    })), [
                        (r || a) && this.operateColumn
                    ]).filter(Boolean);
                }
            },
            {
                key: "hasHeader",
                get: function get() {
                    return this.columns.some(function(e) {
                        return e.renderHead;
                    });
                }
            },
            {
                key: "hasFooter",
                get: function get() {
                    return this.columns.some(function(e) {
                        return e.renderFoot;
                    });
                }
            },
            {
                key: "editing",
                get: function get() {
                    return !(0, $6tqvJ.isEmpty)(this.observedProps.store.currentOne);
                }
            },
            {
                key: "renderTable",
                value: function value() {
                    var _$e = this.props, _$t = (_$e.className, _$e.columns, _$e.store), r = (_$e.translator, _$e.editable, _$e.deletable, _$e.onCheck, _$e.onSubmit, _$e.onReset, _$e.responsive), a = $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__rest(_$e, [
                        "className",
                        "columns",
                        "store",
                        "translator",
                        "editable",
                        "deletable",
                        "onCheck",
                        "onSubmit",
                        "onReset",
                        "responsive"
                    ]), n = this.hasHeader, c = this.hasFooter, s = this.columns, i = this.editing, o = _$t.indexKey, l = _$t.downloading, u = _$t.currentPage;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ae5c70201edf55c0$export$2e2bcd8739ae039, Object.assign({}, a, {
                        responsive: void 0 === r || r,
                        children: [
                            n && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("thead", {
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle text-nowrap",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderHead;
                                        return (r || a) && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tbody", {
                                children: !i && l > 0 ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                    children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                        className: "text-center p-3",
                                        colSpan: s.length,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ef6032f7425abfe5$export$2e2bcd8739ae039, {})
                                    })
                                }) : u.map(function(e) {
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                        className: "align-middle",
                                        children: s.map(function(t, r) {
                                            var a = t.key, n = t.renderBody;
                                            return (a || n) && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: (null == n ? void 0 : n(e)) || a && e[a]
                                            }, (null == a ? void 0 : a.toString()) || r);
                                        })
                                    }, e[o]);
                                })
                            }),
                            c && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tfoot", {
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderFoot;
                                        return (r || a) && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            })
                        ]
                    }));
                }
            },
            {
                key: "deleteList",
                value: function value(e) {
                    return $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__awaiter(this, void 0, void 0, function() {
                        var _$t, r, a, n, c, s, i, o, l, u;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(p) {
                            switch(p.label){
                                case 0:
                                    if (r = (_$t = this.props).translator, a = _$t.store, n = !0, c = !1, s = void 0, !confirm(r.t("sure_to_delete_x", {
                                        keys: e
                                    }))) return [
                                        3,
                                        8
                                    ];
                                    p.label = 1;
                                case 1:
                                    p.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), i = e[Symbol.iterator](), p.label = 2;
                                case 2:
                                    if (n = (o = i.next()).done) return [
                                        3,
                                        5
                                    ];
                                    return l = o.value, [
                                        4,
                                        a.deleteOne(l)
                                    ];
                                case 3:
                                    p.sent(), p.label = 4;
                                case 4:
                                    return n = !0, [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return u = p.sent(), c = !0, s = u, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        n || null == i.return || i.return();
                                    } finally{
                                        if (c) throw s;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.props, r = _$t.className, a = _$t.editable, n = _$t.deletable, c = _$t.filterFields, s = _$t.store, i = _$t.translator, o = _$t.onSubmit, l = (_$t.onReset, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__rest(_$t, [
                        "className",
                        "editable",
                        "deletable",
                        "filterFields",
                        "store",
                        "translator",
                        "onSubmit",
                        "onReset"
                    ])), u = this.fieldSize, p = i.t, $ = s.indexKey, f = s.pageSize, d = s.pageIndex, b = s.pageCount, m = s.totalCount;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({
                        className: void 0 === r ? "overflow-auto d-flex flex-column gap-3" : r
                    }, l, {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                className: "sticky-top bg-white py-3 d-flex flex-column gap-3",
                                children: [
                                    c && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$cd7ba08b282791a9$export$341e3470805a945e, {
                                        className: "d-flex flex-wrap align-items-center gap-3 pb-3 border-bottom ".concat($62ac3db46cb6ed0e$var$$aac96070b6d8b41d$export$5eeb11949c905cc1),
                                        size: u,
                                        translator: i,
                                        fields: c,
                                        onSubmit: function onSubmit(e) {
                                            return s.getList(e, 1);
                                        },
                                        onReset: function onReset() {
                                            return s.getList({}, 1);
                                        }
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex justify-content-between align-items-center",
                                        children: [
                                            n && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                                className: "mx-2",
                                                variant: "danger",
                                                size: u,
                                                onClick: function onClick() {
                                                    return _$e.deleteList(_$e.checkedKeys);
                                                },
                                                children: p("delete")
                                            }),
                                            a && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                                                size: u,
                                                onClick: function onClick() {
                                                    return s.currentOne[$] = "";
                                                },
                                                children: p("create")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            this.renderTable(),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    !!m && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "mx-3 fs14",
                                        children: p("total_x_rows", {
                                            totalCount: m
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$bcc38e2aa906301f$export$57625d62e5386b09, {
                                        pageSize: f,
                                        pageIndex: d,
                                        pageCount: b,
                                        onChange: this.getList
                                    })
                                ]
                            }),
                            a && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, {
                                size: u,
                                fields: this.columns.map(function(e) {
                                    var _$t = e.renderHead;
                                    return Object.assign(Object.assign({}, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__rest(e, [
                                        "renderHead"
                                    ])), {
                                        renderLabel: _$t
                                    });
                                }),
                                store: s,
                                translator: i,
                                onSubmit: o
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(b), r = new WeakMap, $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__setFunctionName(n, "RestTable"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, c = [
        $arNK5.computed
    ], s = [
        $arNK5.observable
    ], i = [
        $arNK5.computed
    ], o = [
        $arNK5.computed
    ], l = [
        $arNK5.computed
    ], u = [
        $arNK5.computed
    ], p = [
        $arNK5.computed
    ], $ = [
        $arNK5.computed
    ], $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, c, {
        kind: "getter",
        name: "fieldSize",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "fieldSize" in e;
            },
            get: function get(e) {
                return e.fieldSize;
            }
        },
        metadata: t
    }, null, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, s, {
        kind: "accessor",
        name: "checkedKeys",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "checkedKeys" in e;
            },
            get: function get(e) {
                return e.checkedKeys;
            },
            set: function set(e, t) {
                e.checkedKeys = t;
            }
        },
        metadata: t
    }, v, h), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "checkColumn",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "checkColumn" in e;
            },
            get: function get(e) {
                return e.checkColumn;
            }
        },
        metadata: t
    }, null, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "operateColumn",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "operateColumn" in e;
            },
            get: function get(e) {
                return e.operateColumn;
            }
        },
        metadata: t
    }, null, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "columns",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "columns" in e;
            },
            get: function get(e) {
                return e.columns;
            }
        },
        metadata: t
    }, null, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, u, {
        kind: "getter",
        name: "hasHeader",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "hasHeader" in e;
            },
            get: function get(e) {
                return e.hasHeader;
            }
        },
        metadata: t
    }, null, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, p, {
        kind: "getter",
        name: "hasFooter",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "hasFooter" in e;
            },
            get: function get(e) {
                return e.hasFooter;
            }
        },
        metadata: t
    }, null, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(n, null, $, {
        kind: "getter",
        name: "editing",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "editing" in e;
            },
            get: function get(e) {
                return e.editing;
            }
        },
        metadata: t
    }, null, m), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__esDecorate(null, a = {
        value: n
    }, f, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, d), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestTable"
    }), $62ac3db46cb6ed0e$var$$3800431d840f9bec$var$__runInitializers(n, d), n;
}(), $62ac3db46cb6ed0e$var$$3330ccfab53de794$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$3330ccfab53de794$exports, "ScrollBoundary", function() {
    return $62ac3db46cb6ed0e$var$$3330ccfab53de794$export$d086fcc3bc3f366f;
});
var $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$__rest = function $3330ccfab53de794$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$EdgeOrder = [
    "top",
    "right",
    "bottom",
    "left"
], $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$touch = function $3330ccfab53de794$var$touch(e, t) {
    return function(r) {
        if (r) {
            var a, n = null == (a = r.parentElement) ? void 0 : a.parentElement, c = n ? getComputedStyle(n) : {}, s = c.overflowX, i = c.overflowY, o = "".concat(s).concat(i).match(/auto|scroll/) ? n : null, l = [
                ,
                ,
                ,
                , 
            ].fill("0px");
            l[$62ac3db46cb6ed0e$var$$3330ccfab53de794$var$EdgeOrder.indexOf(e)] = "200px", new IntersectionObserver(function(r) {
                return (0, $ada009390fa7849c$export$71511d61b312f219)(r, 1)[0].isIntersecting && t(e);
            }, {
                root: o,
                rootMargin: l.join(" ")
            }).observe(r);
        }
    };
}, $62ac3db46cb6ed0e$var$$3330ccfab53de794$export$d086fcc3bc3f366f = function $3330ccfab53de794$export$d086fcc3bc3f366f(e) {
    var t = e.className, r = e.onTouch, a = e.top, n = e.left, c = e.right, s = e.bottom, i = e.children, o = $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$__rest(e, [
        "className",
        "onTouch",
        "top",
        "left",
        "right",
        "bottom",
        "children"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", Object.assign({
        className: $62ac3db46cb6ed0e$var$$parcel$interopDefault($8bd163097a5514bf$exports)("position-relative", t)
    }, o, {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$touch("top", r),
                children: a
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$touch("left", r),
                children: n
            }),
            i,
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$touch("right", r),
                children: c
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $62ac3db46cb6ed0e$var$$3330ccfab53de794$var$touch("bottom", r),
                children: s
            })
        ]
    }));
};
$62ac3db46cb6ed0e$var$$3330ccfab53de794$export$d086fcc3bc3f366f.displayName = "ScrollBoundary";
var $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$6c88af5e81334c9f$exports, "ScrollList", function() {
    return $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$export$797e591eba0ca37c;
});
var $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__esDecorate = function $6c88af5e81334c9f$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__runInitializers = function $6c88af5e81334c9f$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__awaiter = function $6c88af5e81334c9f$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__setFunctionName = function $6c88af5e81334c9f$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__rest = function $6c88af5e81334c9f$var$__rest(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$export$797e591eba0ca37c = function() {
    var e, t, r, a, n = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], c = [], s = $fClfl.Component;
    return $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(_$e, "loadMore", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $dKdZ4.debounce)(function(t) {
                    var r = _$e.props.store;
                    "bottom" === t && r.downloading < 1 && !r.noMore && r.getList();
                })
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function value() {
                    return $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__awaiter(this, void 0, void 0, function() {
                        var _$e, _$t, r, a;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    return $a1830bff0fabd0b0$export$6a4eb2e7fc9e8903, _$t = (_$e = this.props).filter, r = _$e.defaultData, a = this.props.store, [
                                        4,
                                        (0, $arNK5.when)(function() {
                                            return a.downloading < 1;
                                        })
                                    ];
                                case 1:
                                    if (n.sent(), a.clearList(), !r) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        a.restoreList({
                                            allItems: r,
                                            filter: _$t
                                        })
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        4,
                                        a.getList(_$t, a.pageList.length + 1)
                                    ];
                                case 4:
                                    return n.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    this.props.store.clearList();
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.translator, r = _$e.store, a = _$e.renderList, n = $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__rest(_$e, [
                        "translator",
                        "store",
                        "renderList"
                    ]), c = _$t.t, s = r.noMore, i = r.allItems;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$3330ccfab53de794$export$d086fcc3bc3f366f, Object.assign({}, n, {
                        onTouch: this.loadMore,
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                            children: [
                                a(i),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                    className: "mt-2 text-center text-muted small",
                                    children: c(s || !i.length ? "no_more" : "load_more")
                                })
                            ]
                        })
                    }));
                }
            }
        ]), t;
    }(s), "ScrollList"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ScrollList"
    }), $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$var$__runInitializers(a, c), a;
}(), $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$exports = {};
$62ac3db46cb6ed0e$var$$parcel$export($62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$exports, "SearchableInput", function() {
    return $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc;
});
var $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__esDecorate = function $5dc3ca4c9dfca0f7$var$__esDecorate(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__runInitializers = function $5dc3ca4c9dfca0f7$var$__runInitializers(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__awaiter = function $5dc3ca4c9dfca0f7$var$__awaiter(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var _$t;
            e.done ? n(e.value) : ((_$t = e.value) instanceof r ? _$t : new r(function(e) {
                e(_$t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__setFunctionName = function $5dc3ca4c9dfca0f7$var$__setFunctionName(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $a4f5296238ef68ec$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet = function $5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet = function $5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc = function() {
    var e, t, r, a, n, c, s, i, o = [
        $5bcfa0e0ec438674$export$b6ae1bc530f4c149
    ], l = [], u = $28c230f99d2758cc$exports.FormComponent, p = [], $ = [], f = [], d = [];
    return c = function(e) {
        "use strict";
        function t() {
            var _$e;
            return (0, $62cfae4fe2618c9c$export$71511d61b312f219)(this, t), _$e = (0, $c4dbf9b956236295$export$71511d61b312f219)(this, t, arguments), r.set(_$e, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, p, _$e.props.filter)), a.set(_$e, ($62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, $), $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, f, !1))), Object.defineProperty(_$e, "search", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__runInitializers(_$e, d), (0, $dKdZ4.debounce)(function(t) {
                    return $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__awaiter(_$e, void 0, void 0, function() {
                        var _$e, r, a;
                        return (0, $678eb2518fcd1152$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    if (r = (_$e = this.props).store, a = _$e.labelKey, t = t.trim(), this.filter = Object.assign(Object.assign({}, this.filter), (0, $27ac2acf61c4734a$export$71511d61b312f219)({}, a, t || void 0)), !(r.downloading < 1)) return [
                                        3,
                                        5
                                    ];
                                    if (!t) return [
                                        3,
                                        4
                                    ];
                                    if (this.listShown) return [
                                        3,
                                        1
                                    ];
                                    return this.listShown = !0, [
                                        3,
                                        3
                                    ];
                                case 1:
                                    return [
                                        4,
                                        r.getList(this.filter, 1)
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    this.listShown = !1, r.clearList(), n.label = 5;
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, $6tqvJ.Second))
            }), Object.defineProperty(_$e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t, r) {
                    var a = _$e.value || [];
                    !a.find(function(e) {
                        return e.value === r;
                    }) && (_$e.innerValue = (0, $36427be7dd51c5e7$export$71511d61b312f219)(a).concat([
                        {
                            label: t,
                            value: r
                        }
                    ]), _$e.props.multiple || (_$e.listShown = !1));
                }
            }), Object.defineProperty(_$e, "delete", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return _$e.innerValue = (0, $36427be7dd51c5e7$export$71511d61b312f219)(_$e.value.slice(0, t)).concat((0, $36427be7dd51c5e7$export$71511d61b312f219)(_$e.value.slice(t + 1)));
                }
            }), Object.defineProperty(_$e, "handleBlur", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    var r = t.target, a = t.relatedTarget;
                    r.parentElement !== (null == a ? void 0 : a.parentElement) && (_$e.listShown = !1);
                }
            }), Object.defineProperty(_$e, "renderList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function value(t) {
                    return t[0] ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)($a2847098175bdaa7$export$2e2bcd8739ae039, {
                        children: t.map(function(t) {
                            var r = _$e.observedProps, a = r.labelKey, n = r.valueKey, c = t[a], s = t[n];
                            return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($a2847098175bdaa7$export$2e2bcd8739ae039.Item, {
                                as: "button",
                                type: "button",
                                action: !0,
                                onClick: function onClick() {
                                    return _$e.add(c, s);
                                },
                                children: c
                            }, s);
                        })
                    }) : _$e.observedProps.store.downloading > 0 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "text-center my-3",
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($ef6032f7425abfe5$export$2e2bcd8739ae039, {})
                    });
                }
            }), _$e;
        }
        return (0, $abf03f88ba10b724$export$71511d61b312f219)(t, e), (0, $355cb88dd58749ed$export$71511d61b312f219)(t, [
            {
                key: "filter",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "listShown",
                get: function get() {
                    return $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function set(e) {
                    $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                key: "renderOverlay"
            }, "value", function() {
                var _$e = this.filter, _$t = this.props, r = _$t.translator, a = _$t.fields, n = _$t.store, c = _$t.labelKey, s = _$t.renderList, i = void 0 === s ? this.renderList : s, o = _$e[c], l = !n.allItems.some(function(e) {
                    return e[c] === o;
                });
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                    className: "position-absolute start-0 z-3 overflow-auto py-1 bg-white shadow-sm",
                    style: {
                        top: "100%",
                        maxHeight: "30vh"
                    },
                    onBlurCapture: this.handleBlur,
                    children: [
                        l && (null == a ? void 0 : a[0]) && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($4a228d6edec70b31$export$2e2bcd8739ae039, {
                            className: "w-100 sticky-top",
                            variant: "warning",
                            size: "sm",
                            type: "button",
                            onClick: function onClick() {
                                return n.currentOne = (0, $27ac2acf61c4734a$export$71511d61b312f219)({}, c, o);
                            },
                            children: [
                                "+ ",
                                o
                            ]
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$6c88af5e81334c9f$export$797e591eba0ca37c, {
                            translator: r,
                            store: n,
                            filter: _$e,
                            renderList: i
                        })
                    ]
                });
            }),
            (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                key: "render"
            }, "value", function() {
                var _$e = this, _$t = this.value, r = this.listShown, a = this.props, n = a.translator, c = a.fields, s = a.store, i = a.labelKey, o = a.valueKey, l = a.type, u = a.name, p = a.required, $ = a.readOnly, f = a.disabled, d = a.placeholder;
                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)($0f0265dfbf11fad4$export$2e2bcd8739ae039, (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                    className: "position-relative"
                }, "children", [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($0f0265dfbf11fad4$export$2e2bcd8739ae039.Text, {
                        className: "d-flex flex-wrap align-items-center gap-2",
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                            list: (_$t || []).map(function(e) {
                                return {
                                    text: e.label
                                };
                            }),
                            onDelete: function onDelete(t, r) {
                                return (0, $5f1da914d9b7563a$export$71511d61b312f219)(t), _$e.delete(r);
                            }
                        })
                    }),
                    r && this.renderOverlay(),
                    (null == c ? void 0 : c[0]) && (0, $1c838ced510d5939$export$34b9dba7ce09269b)($62ac3db46cb6ed0e$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, (0, $27ac2acf61c4734a$export$71511d61b312f219)({
                        translator: n,
                        fields: c,
                        store: s
                    }, "onSubmit", function(t) {
                        var r = t[i], a = t[o];
                        _$e.add(r, a), _$e.listShown = !1;
                    })),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                        type: "hidden",
                        name: u,
                        value: JSON.stringify(null == _$t ? void 0 : _$t.map(function(e) {
                            return e.value;
                        }))
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)($aec14c1b82632aca$export$2e2bcd8739ae039.Control, {
                        type: void 0 === l ? "search" : l,
                        placeholder: d,
                        required: p,
                        readOnly: $,
                        disabled: f,
                        onChange: function onChange(t) {
                            var r = t.currentTarget.value;
                            return _$e.search(r);
                        }
                    })
                ]));
            })
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__setFunctionName(c, "SearchableInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, s = [
        $arNK5.observable
    ], i = [
        $arNK5.observable
    ], $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "filter",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "filter" in e;
            },
            get: function get(e) {
                return e.filter;
            },
            set: function set(e, t) {
                e.filter = t;
            }
        },
        metadata: t
    }, p, $), $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "listShown",
        static: !1,
        private: !1,
        access: {
            has: function has(e) {
                return "listShown" in e;
            },
            get: function get(e) {
                return e.listShown;
            },
            set: function set(e, t) {
                e.listShown = t;
            }
        },
        metadata: t
    }, f, d), $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__esDecorate(null, n = {
        value: c
    }, o, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "SearchableInput"
    }), $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$var$__runInitializers(c, l), c;
}();
$62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$f600741b98acd6fe$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$faee9857e4bdfa8b$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$8663609ea235ec39$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$f2af1554fbcf9c96$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$a21a50f24f1cbd28$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$4e6504f15de995a8$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$92bd5b9c2e8cd28e$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$fa84453248a3f065$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$36ed2012ed0bbec3$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$cd7ba08b282791a9$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$bcc38e2aa906301f$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$3800431d840f9bec$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$3330ccfab53de794$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$6c88af5e81334c9f$exports), $62ac3db46cb6ed0e$var$$parcel$exportWildcard($62ac3db46cb6ed0e$exports, $62ac3db46cb6ed0e$var$$5dc3ca4c9dfca0f7$exports); //# sourceMappingURL=index.js.map


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $fClfl = parcelRequire("fClfl");


var $arNK5 = parcelRequire("arNK5");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");

var $5RfYb = parcelRequire("5RfYb");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");



"use client";
var $c1e72b825e10557b$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $c1e72b825e10557b$var$onlyProgressBar(props, propName, componentName) {
    var children = props[propName];
    if (!children) return null;
    var error = null;
    $6mMqj.Children.forEach(children, function(child) {
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ var element = /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)($c1e72b825e10557b$var$ProgressBar, {});
        if (child.type === element.type) return;
        var childType = child.type;
        var childIdentifier = /*#__PURE__*/ $6mMqj.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error("Children of ".concat(componentName, " can contain only ProgressBar ") + "components. Found ".concat(childIdentifier, "."));
    });
    return error;
}
function $c1e72b825e10557b$var$getPercentage(now, min, max) {
    var percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $c1e72b825e10557b$var$ROUND_PRECISION) / $c1e72b825e10557b$var$ROUND_PRECISION;
}
function $c1e72b825e10557b$var$renderProgressBar(_param, ref) {
    var min = _param.min, now = _param.now, max = _param.max, label = _param.label, visuallyHidden = _param.visuallyHidden, striped = _param.striped, animated = _param.animated, className = _param.className, style = _param.style, variant = _param.variant, bsPrefix = _param.bsPrefix, props = (0, $8MJI4._)(_param, [
        "min",
        "now",
        "max",
        "label",
        "visuallyHidden",
        "striped",
        "animated",
        "className",
        "style",
        "variant",
        "bsPrefix"
    ]);
    var _obj;
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, props), {
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, "".concat(bsPrefix, "-bar"), (_obj = {}, (0, $5RfYb._)(_obj, "bg-".concat(variant), variant), (0, $5RfYb._)(_obj, "".concat(bsPrefix, "-bar-animated"), animated), (0, $5RfYb._)(_obj, "".concat(bsPrefix, "-bar-striped"), animated || striped), _obj)),
        style: (0, $6GCxi._)({
            width: "".concat($c1e72b825e10557b$var$getPercentage(now, min, max), "%")
        }, style),
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    }));
}
var $c1e72b825e10557b$var$ProgressBar = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var _param_isChild = _param.isChild, isChild = _param_isChild === void 0 ? false : _param_isChild, rest = (0, $8MJI4._)(_param, [
        "isChild"
    ]);
    var props = (0, $6GCxi._)({
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false
    }, rest);
    props.bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(props.bsPrefix, 'progress');
    if (isChild) return $c1e72b825e10557b$var$renderProgressBar(props, ref);
    var min = props.min, now = props.now, max = props.max, label = props.label, visuallyHidden = props.visuallyHidden, striped = props.striped, animated = props.animated, bsPrefix = props.bsPrefix, variant = props.variant, className = props.className, children = props.children, wrapperProps = (0, $8MJI4._)(props, [
        "min",
        "now",
        "max",
        "label",
        "visuallyHidden",
        "striped",
        "animated",
        "bsPrefix",
        "variant",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", (0, $ctBui._)((0, $6GCxi._)({
        ref: ref
    }, wrapperProps), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, bsPrefix),
        children: children ? (0, $93a729f6ca0a816f$export$871de8747c9eaa88)(children, function(child) {
            return /*#__PURE__*/ (0, $6mMqj.cloneElement)(child, {
                isChild: true
            });
        }) : $c1e72b825e10557b$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    }));
});
$c1e72b825e10557b$var$ProgressBar.displayName = 'ProgressBar';
var $c1e72b825e10557b$export$2e2bcd8739ae039 = $c1e72b825e10557b$var$ProgressBar;



var $1708356b9399d0ed$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $1708356b9399d0ed$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $1708356b9399d0ed$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $1708356b9399d0ed$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $1708356b9399d0ed$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $1708356b9399d0ed$export$19360f044bb8798 = function() {
    var _AIClassifier_aiProgress_accessor_storage, _AIClassifier_aiStage_accessor_storage, _AIClassifier_suggestions_accessor_storage;
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _aiProgress_decorators;
    var _aiProgress_initializers = [];
    var _aiProgress_extraInitializers = [];
    var _aiStage_decorators;
    var _aiStage_initializers = [];
    var _aiStage_extraInitializers = [];
    var _suggestions_decorators;
    var _suggestions_initializers = [];
    var _suggestions_extraInitializers = [];
    var AIClassifier = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _AIClassifier_aiProgress_accessor_storage.set(_this, $1708356b9399d0ed$var$__runInitializers(_this, _aiProgress_initializers, 0));
            _AIClassifier_aiStage_accessor_storage.set(_this, ($1708356b9399d0ed$var$__runInitializers(_this, _aiProgress_extraInitializers), $1708356b9399d0ed$var$__runInitializers(_this, _aiStage_initializers, 'analyzing')));
            _AIClassifier_suggestions_accessor_storage.set(_this, ($1708356b9399d0ed$var$__runInitializers(_this, _aiStage_extraInitializers), $1708356b9399d0ed$var$__runInitializers(_this, _suggestions_initializers, [])));
            Object.defineProperty(_this, "intervalId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $1708356b9399d0ed$var$__runInitializers(_this, _suggestions_extraInitializers)
            });
            Object.defineProperty(_this, "renderAnalyzingStage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "p-4 bg-primary bg-opacity-10 rounded",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "text-center mb-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "d-inline-flex align-items-center justify-content-center mb-3",
                                        style: {
                                            width: '80px',
                                            height: '80px',
                                            backgroundColor: '#2196F3',
                                            borderRadius: '12px'
                                        },
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            className: "text-white",
                                            name: "stars",
                                            size: 3
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                                        className: "mb-2",
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_classifying')
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                        className: "text-muted",
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('analyzing_data')
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mb-3",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c1e72b825e10557b$export$2e2bcd8739ae039), {
                                    now: _this.aiProgress,
                                    variant: "primary",
                                    style: {
                                        height: '8px'
                                    }
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "text-center text-muted",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("small", {
                                    children: [
                                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('analyzing_orders'),
                                        " ",
                                        _this.aiProgress,
                                        "%"
                                    ]
                                })
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderSuggestionItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var name = param.name, description = param.description, isNew = param.isNew, matchingOrders = param.matchingOrders, confidence = param.confidence;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                        className: "border rounded p-3 mb-3",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between align-items-start mb-2",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h6", {
                                            className: "mb-1",
                                            children: [
                                                name,
                                                isNew && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                                    bg: "success",
                                                    className: "ms-2",
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('new_category_tag')
                                                })
                                            ]
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                            className: "text-muted mb-2 small",
                                            children: description
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "small text-muted",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                className: "me-3",
                                                children: [
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('matching_orders'),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("strong", {
                                                        className: "text-primary ms-1",
                                                        children: matchingOrders
                                                    })
                                                ]
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                children: [
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('confidence'),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("strong", {
                                                        className: "text-primary ms-1",
                                                        children: [
                                                            confidence,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                                size: "sm",
                                                variant: "outline-danger",
                                                className: "me-2",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('reject')
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                                size: "sm",
                                                variant: "success",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('accept')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, name);
                }
            });
            Object.defineProperty(_this, "renderSuggestionsStage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h6", {
                                        className: "my-3",
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('new_category_suggestions')
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ol", {
                                        className: "list-unstyled",
                                        children: _this.suggestions.map(_this.renderSuggestionItem)
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex justify-content-between align-items-center border-top",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "text-muted small text-center mt-3",
                                        children: [
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('last_update_time'),
                                            ": 2024-01-15 14:30"
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex justify-content-end gap-2 mt-4 pt-3",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                                variant: "secondary",
                                                onClick: _this.props.onCancel,
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('close')
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                                variant: "primary",
                                                onClick: _this.props.onComplete,
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('confirm_update')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "aiProgress",
                get: function get() {
                    return $1708356b9399d0ed$var$__classPrivateFieldGet(this, _AIClassifier_aiProgress_accessor_storage, "f");
                },
                set: function set(value) {
                    $1708356b9399d0ed$var$__classPrivateFieldSet(this, _AIClassifier_aiProgress_accessor_storage, value, "f");
                }
            },
            {
                key: "aiStage",
                get: function get() {
                    return $1708356b9399d0ed$var$__classPrivateFieldGet(this, _AIClassifier_aiStage_accessor_storage, "f");
                },
                set: function set(value) {
                    $1708356b9399d0ed$var$__classPrivateFieldSet(this, _AIClassifier_aiStage_accessor_storage, value, "f");
                }
            },
            {
                key: "suggestions",
                get: function get() {
                    return $1708356b9399d0ed$var$__classPrivateFieldGet(this, _AIClassifier_suggestions_accessor_storage, "f");
                },
                set: function set(value) {
                    $1708356b9399d0ed$var$__classPrivateFieldSet(this, _AIClassifier_suggestions_accessor_storage, value, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.startAnalysis();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearAnalysis();
                }
            },
            {
                key: "startAnalysis",
                value: function startAnalysis() {
                    var _this = this;
                    this.aiProgress = 0;
                    this.aiStage = 'analyzing';
                    this.suggestions = [];
                    this.intervalId = setInterval(function() {
                        _this.aiProgress += 5;
                        if (_this.aiProgress < 100) return;
                        _this.clearAnalysis();
                        _this.aiProgress = 45;
                        _this.aiStage = 'suggestions';
                        _this.suggestions = [
                            {
                                name: "\u65B0\u80FD\u6E90\u8BBE\u5907\u5B89\u88C5",
                                description: "\u5149\u4F0F\u53D1\u7535\u8BBE\u5907\u3001\u50A8\u80FD\u8BBE\u5907\u7B49\u65B0\u80FD\u6E90\u8BBE\u5907\u5B89\u88C5\u9700\u6C42",
                                matchingOrders: 156,
                                confidence: 92,
                                isNew: true
                            },
                            {
                                name: "\u667A\u80FD\u7535\u8868\u95EE\u9898",
                                description: "\u667A\u80FD\u7535\u8868\u5B89\u88C5\u3001\u663E\u793A\u5F02\u5E38\u7B49\u76F8\u5173\u95EE\u9898",
                                matchingOrders: 89,
                                confidence: 88,
                                isNew: true
                            }
                        ];
                    }, 200);
                }
            },
            {
                key: "clearAnalysis",
                value: function clearAnalysis() {
                    if (!this.intervalId) return;
                    clearInterval(this.intervalId);
                    this.intervalId = undefined;
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
                        children: [
                            this.renderAnalyzingStage(),
                            this.aiStage === 'suggestions' && this.renderSuggestionsStage()
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _AIClassifier_aiProgress_accessor_storage = new WeakMap();
    _AIClassifier_aiStage_accessor_storage = new WeakMap();
    _AIClassifier_suggestions_accessor_storage = new WeakMap();
    $1708356b9399d0ed$var$__setFunctionName(_classThis, "AIClassifier");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _aiProgress_decorators = [
            (0, $arNK5.observable)
        ];
        _aiStage_decorators = [
            (0, $arNK5.observable)
        ];
        _suggestions_decorators = [
            (0, $arNK5.observable)
        ];
        $1708356b9399d0ed$var$__esDecorate(_classThis, null, _aiProgress_decorators, {
            kind: "accessor",
            name: "aiProgress",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "aiProgress" in obj;
                },
                get: function(obj) {
                    return obj.aiProgress;
                },
                set: function(obj, value) {
                    obj.aiProgress = value;
                }
            },
            metadata: _metadata
        }, _aiProgress_initializers, _aiProgress_extraInitializers);
        $1708356b9399d0ed$var$__esDecorate(_classThis, null, _aiStage_decorators, {
            kind: "accessor",
            name: "aiStage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "aiStage" in obj;
                },
                get: function(obj) {
                    return obj.aiStage;
                },
                set: function(obj, value) {
                    obj.aiStage = value;
                }
            },
            metadata: _metadata
        }, _aiStage_initializers, _aiStage_extraInitializers);
        $1708356b9399d0ed$var$__esDecorate(_classThis, null, _suggestions_decorators, {
            kind: "accessor",
            name: "suggestions",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "suggestions" in obj;
                },
                get: function(obj) {
                    return obj.suggestions;
                },
                set: function(obj, value) {
                    obj.suggestions = value;
                }
            },
            metadata: _metadata
        }, _suggestions_initializers, _suggestions_extraInitializers);
        $1708356b9399d0ed$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AIClassifier = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $1708356b9399d0ed$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AIClassifier = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");


var $6tqvJ = parcelRequire("6tqvJ");

var $8cc1d201d3325d46$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8cc1d201d3325d46$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8cc1d201d3325d46$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8cc1d201d3325d46$export$ebde44b8e65d8876 = function() {
    var _a;
    var _classSuper = (0, $a1830bff0fabd0b0$export$36e5777a1ba4b7c3);
    var _instanceExtraInitializers = [];
    var _updateOne_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(TableModel, _classSuper);
        function TableModel() {
            (0, $7lhcp._)(this, TableModel);
            var _this;
            _this = (0, $07dqX._)(this, TableModel, arguments);
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($8cc1d201d3325d46$var$__runInitializers(_this, _instanceExtraInitializers), (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client)
            });
            return _this;
        }
        (0, $8BtP9._)(TableModel, [
            {
                key: "updateOne",
                value: function updateOne(data, id) {
                    return $8cc1d201d3325d46$var$__awaiter(this, void 0, void 0, function() {
                        var body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        id ? this.client.put("".concat(this.baseURI, "/").concat(id), data) : this.client.post(this.baseURI, data)
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        this.currentOne = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "loadPage",
                value: function loadPage(pageIndex, pageSize, filter) {
                    return $8cc1d201d3325d46$var$__awaiter(this, void 0, void 0, function() {
                        var body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.get("".concat(this.baseURI, "?").concat((0, $6tqvJ.buildURLData)(Object.assign(Object.assign({}, filter), {
                                            pageIndex: pageIndex,
                                            pageSize: pageSize
                                        }))))
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        {
                                            pageData: body.list,
                                            totalCount: body.count
                                        }
                                    ];
                            }
                        });
                    });
                }
            }
        ]);
        return TableModel;
    }(_classSuper), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _updateOne_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('uploading')
        ];
        $8cc1d201d3325d46$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "updateOne" in obj;
                },
                get: function(obj) {
                    return obj.updateOne;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();


var $fb2682a0e3edbe09$export$e1bbb50836aa0481 = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(CategoryModel, TableModel);
    function CategoryModel() {
        (0, $7lhcp._)(this, CategoryModel);
        var _this;
        _this = (0, $07dqX._)(this, CategoryModel, arguments);
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'category'
        });
        return _this;
    }
    return CategoryModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $fb2682a0e3edbe09$export$2e2bcd8739ae039 = new $fb2682a0e3edbe09$export$e1bbb50836aa0481();



var $c455d3a7d8d2d4e1$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c455d3a7d8d2d4e1$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c455d3a7d8d2d4e1$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $c455d3a7d8d2d4e1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c455d3a7d8d2d4e1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c455d3a7d8d2d4e1$export$f7d2f673fc2f091d = function() {
    var _CategoryPage_showAIModal_accessor_storage;
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _showAIModal_decorators;
    var _showAIModal_initializers = [];
    var _showAIModal_extraInitializers = [];
    var _get_columns_decorators;
    var CategoryPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _CategoryPage_showAIModal_accessor_storage.set(_this, ($c455d3a7d8d2d4e1$var$__runInitializers(_this, _instanceExtraInitializers), $c455d3a7d8d2d4e1$var$__runInitializers(_this, _showAIModal_initializers, false)));
            Object.defineProperty(_this, "handleAIClassify", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c455d3a7d8d2d4e1$var$__runInitializers(_this, _showAIModal_extraInitializers), function() {
                    _this.showAIModal = true;
                })
            });
            Object.defineProperty(_this, "handleCloseAIModal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    _this.showAIModal = false;
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "showAIModal",
                get: function get() {
                    return $c455d3a7d8d2d4e1$var$__classPrivateFieldGet(this, _CategoryPage_showAIModal_accessor_storage, "f");
                },
                set: function set(value) {
                    $c455d3a7d8d2d4e1$var$__classPrivateFieldSet(this, _CategoryPage_showAIModal_accessor_storage, value, "f");
                }
            },
            {
                key: "columns",
                get: function get() {
                    return [
                        {
                            key: 'businessType',
                            type: 'text',
                            required: true,
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('business_type')
                        },
                        {
                            key: 'level1Category',
                            type: 'text',
                            required: true,
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level1_category')
                        },
                        {
                            key: 'level2Category',
                            type: 'text',
                            required: true,
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level2_category')
                        },
                        {
                            key: 'level3Category',
                            type: 'text',
                            required: true,
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level3_category')
                        },
                        {
                            key: 'level3Subdivision',
                            type: 'text',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level3_detail'),
                            renderBody: function(param) {
                                var level3Subdivision = param.level3Subdivision;
                                return level3Subdivision || '-';
                            }
                        },
                        {
                            key: 'notes',
                            type: 'text',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('remark'),
                            renderBody: function(param) {
                                var notes = param.notes;
                                return notes || '-';
                            }
                        },
                        {
                            key: 'department',
                            type: 'text',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('department')
                        },
                        {
                            key: 'professionalOffice',
                            type: 'text',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('specialist_office')
                        },
                        {
                            key: 'sortOrder',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sort_order')
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "m-3",
                        body: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mb-3 d-flex justify-content-between align-items-center",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    onClick: this.handleAIClassify,
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "stars"
                                        }),
                                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_auto_classify')
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                columns: this.columns,
                                store: (0, $fb2682a0e3edbe09$export$2e2bcd8739ae039),
                                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                striped: true,
                                hover: true,
                                editable: true,
                                deletable: true
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039), {
                                show: this.showAIModal,
                                size: "lg",
                                centered: true,
                                onHide: this.handleCloseAIModal,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Header, {
                                        closeButton: true,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Title, {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_auto_classify')
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Body, {
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1708356b9399d0ed$export$19360f044bb8798), {
                                            onComplete: this.handleCloseAIModal,
                                            onCancel: this.handleCloseAIModal
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _CategoryPage_showAIModal_accessor_storage = new WeakMap();
    $c455d3a7d8d2d4e1$var$__setFunctionName(_classThis, "CategoryPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _showAIModal_decorators = [
            (0, $arNK5.observable)
        ];
        _get_columns_decorators = [
            (0, $arNK5.computed)
        ];
        $c455d3a7d8d2d4e1$var$__esDecorate(_classThis, null, _showAIModal_decorators, {
            kind: "accessor",
            name: "showAIModal",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "showAIModal" in obj;
                },
                get: function(obj) {
                    return obj.showAIModal;
                },
                set: function(obj, value) {
                    obj.showAIModal = value;
                }
            },
            metadata: _metadata
        }, _showAIModal_initializers, _showAIModal_extraInitializers);
        $c455d3a7d8d2d4e1$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c455d3a7d8d2d4e1$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CategoryPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $c455d3a7d8d2d4e1$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CategoryPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");


var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $5RfYb = parcelRequire("5RfYb");

var $h6w6E = parcelRequire("h6w6E");


var $b60bedf248b12f36$export$61db76a97f26b7e1;
(function(TaskStatus) {
    TaskStatus["InProgress"] = "in_progress";
    TaskStatus["Completed"] = "completed";
    TaskStatus["Failed"] = "failed";
})($b60bedf248b12f36$export$61db76a97f26b7e1 || ($b60bedf248b12f36$export$61db76a97f26b7e1 = {}));
var $b60bedf248b12f36$export$c231f934a7f2b792;
(function(AIAnalysisCapability) {
    AIAnalysisCapability["IntelligentClassification"] = "intelligent_classification";
    AIAnalysisCapability["DuplicateRecovery"] = "duplicate_recovery";
    AIAnalysisCapability["SensitiveWorkOrder"] = "sensitive_work_order";
    AIAnalysisCapability["ResponsibleWorkOrder"] = "responsible_work_order";
})($b60bedf248b12f36$export$c231f934a7f2b792 || ($b60bedf248b12f36$export$c231f934a7f2b792 = {}));
var $b60bedf248b12f36$var$_obj;
var $b60bedf248b12f36$export$423c9ded25c887f5 = ($b60bedf248b12f36$var$_obj = {}, (0, $5RfYb._)($b60bedf248b12f36$var$_obj, $b60bedf248b12f36$export$61db76a97f26b7e1.InProgress, 'task_in_progress'), (0, $5RfYb._)($b60bedf248b12f36$var$_obj, $b60bedf248b12f36$export$61db76a97f26b7e1.Completed, 'task_completed'), (0, $5RfYb._)($b60bedf248b12f36$var$_obj, $b60bedf248b12f36$export$61db76a97f26b7e1.Failed, 'task_failed'), $b60bedf248b12f36$var$_obj);
var $b60bedf248b12f36$var$_obj1;
var $b60bedf248b12f36$export$cee4e6e777f01419 = ($b60bedf248b12f36$var$_obj1 = {}, (0, $5RfYb._)($b60bedf248b12f36$var$_obj1, $b60bedf248b12f36$export$61db76a97f26b7e1.InProgress, 'primary'), (0, $5RfYb._)($b60bedf248b12f36$var$_obj1, $b60bedf248b12f36$export$61db76a97f26b7e1.Completed, 'success'), (0, $5RfYb._)($b60bedf248b12f36$var$_obj1, $b60bedf248b12f36$export$61db76a97f26b7e1.Failed, 'danger'), $b60bedf248b12f36$var$_obj1);
var $b60bedf248b12f36$var$_obj2;
var $b60bedf248b12f36$export$610e3768869993af = ($b60bedf248b12f36$var$_obj2 = {}, (0, $5RfYb._)($b60bedf248b12f36$var$_obj2, $b60bedf248b12f36$export$c231f934a7f2b792.IntelligentClassification, 'ai_intelligent_classification'), (0, $5RfYb._)($b60bedf248b12f36$var$_obj2, $b60bedf248b12f36$export$c231f934a7f2b792.DuplicateRecovery, 'ai_duplicate_recovery'), (0, $5RfYb._)($b60bedf248b12f36$var$_obj2, $b60bedf248b12f36$export$c231f934a7f2b792.SensitiveWorkOrder, 'ai_sensitive_work_order'), (0, $5RfYb._)($b60bedf248b12f36$var$_obj2, $b60bedf248b12f36$export$c231f934a7f2b792.ResponsibleWorkOrder, 'ai_responsible_work_order'), $b60bedf248b12f36$var$_obj2);
var $b60bedf248b12f36$export$35b7e576f66fe829 = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(ClassificationTaskModel, TableModel);
    function ClassificationTaskModel() {
        (0, $7lhcp._)(this, ClassificationTaskModel);
        var _this;
        _this = (0, $07dqX._)(this, ClassificationTaskModel, arguments);
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'task/classification'
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        return _this;
    }
    return ClassificationTaskModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $b60bedf248b12f36$export$2e2bcd8739ae039 = new $b60bedf248b12f36$export$35b7e576f66fe829();



var $889de7132d9e2a11$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $889de7132d9e2a11$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $889de7132d9e2a11$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $889de7132d9e2a11$export$1bffee0f80fe862b = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _get_filterFields_decorators;
    var _get_columns_decorators;
    var ClassificationTaskListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            $889de7132d9e2a11$var$__runInitializers(_this, _instanceExtraInitializers);
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "filterFields",
                get: function get() {
                    return [
                        {
                            key: 'name',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_name')
                        },
                        {
                            key: 'status',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_status'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'in_progress',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_in_progress')
                                },
                                {
                                    value: 'completed',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_completed')
                                },
                                {
                                    value: 'failed',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_failed')
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "columns",
                get: function get() {
                    return [
                        {
                            key: 'id',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_id')
                        },
                        {
                            key: 'name',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_name')
                        },
                        {
                            key: 'aiCapabilities',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_capabilities'),
                            renderBody: function(param) {
                                var aiCapabilities = param.aiCapabilities;
                                return aiCapabilities === null || aiCapabilities === void 0 ? void 0 : aiCapabilities.map(function(cap) {
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                        bg: "info",
                                        className: "me-1",
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)((0, $b60bedf248b12f36$export$610e3768869993af)[cap])
                                    }, cap);
                                });
                            }
                        },
                        {
                            key: 'status',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_status'),
                            renderBody: function(param) {
                                var status = param.status;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: (0, $b60bedf248b12f36$export$cee4e6e777f01419)[status],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)((0, $b60bedf248b12f36$export$423c9ded25c887f5)[status])
                                });
                            }
                        },
                        {
                            key: 'totalWorkOrders',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('total_work_orders'),
                            renderBody: function(param) {
                                var totalWorkOrders = param.totalWorkOrders;
                                return totalWorkOrders || 0;
                            }
                        },
                        {
                            key: 'processedWorkOrders',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('processed_work_orders'),
                            renderBody: function(param) {
                                var processedWorkOrders = param.processedWorkOrders;
                                return processedWorkOrders || 0;
                            }
                        },
                        {
                            key: 'startedAt',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('started_at'),
                            renderBody: function(param) {
                                var startedAt = param.startedAt;
                                return startedAt ? new Date(startedAt).toLocaleString() : '-';
                            }
                        },
                        {
                            key: 'endedAt',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ended_at'),
                            renderBody: function(param) {
                                var endedAt = param.endedAt;
                                return endedAt ? new Date(endedAt).toLocaleString() : '-';
                            }
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('actions'),
                            renderBody: function(param) {
                                var id = param.id;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                    href: "#/task/classification/".concat(id),
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('view_details')
                                });
                            }
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "m-3",
                        body: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between align-items-center mb-3",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h2", {
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('classification_task_list')
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                filterFields: this.filterFields,
                                columns: this.columns,
                                store: (0, $b60bedf248b12f36$export$2e2bcd8739ae039),
                                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                striped: true,
                                hover: true
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $889de7132d9e2a11$var$__setFunctionName(_classThis, "ClassificationTaskListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_filterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_columns_decorators = [
            (0, $arNK5.computed)
        ];
        $889de7132d9e2a11$var$__esDecorate(_classThis, null, _get_filterFields_decorators, {
            kind: "getter",
            name: "filterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filterFields" in obj;
                },
                get: function(obj) {
                    return obj.filterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $889de7132d9e2a11$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $889de7132d9e2a11$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ClassificationTaskListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $889de7132d9e2a11$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ClassificationTaskListPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $fClfl = parcelRequire("fClfl");


var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");




var $c3b841a1e7b08b62$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c3b841a1e7b08b62$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c3b841a1e7b08b62$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $c3b841a1e7b08b62$var$TaskName = function(param) {
    var t = param.t;
    return {
        deduplication: t('duplicate_work_order_extraction')
    };
};
var $c3b841a1e7b08b62$export$af6b5c503c29f2f0 = function() {
    var _classDecorators = [
        (0, $397c81af6d5568dc$export$369b6b2b30582e8e),
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _get_columns_decorators;
    var TaskCreatorPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            $c3b841a1e7b08b62$var$__runInitializers(_this, _instanceExtraInitializers);
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "columns",
                get: function get() {
                    return [
                        {
                            key: 'id',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_id')
                        },
                        {
                            key: 'name',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_name')
                        },
                        {
                            key: 'aiCapabilities',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_capabilities'),
                            renderBody: function(param) {
                                var aiCapabilities = param.aiCapabilities;
                                return aiCapabilities === null || aiCapabilities === void 0 ? void 0 : aiCapabilities.map(function(cap) {
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                        bg: "info",
                                        className: "me-1",
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)((0, $b60bedf248b12f36$export$610e3768869993af)[cap])
                                    }, cap);
                                });
                            }
                        },
                        {
                            key: 'status',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_status'),
                            renderBody: function(param) {
                                var status = param.status;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: (0, $b60bedf248b12f36$export$cee4e6e777f01419)[status],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)((0, $b60bedf248b12f36$export$423c9ded25c887f5)[status])
                                });
                            }
                        },
                        {
                            key: 'totalWorkOrders',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('total_work_orders'),
                            renderBody: function(param) {
                                var totalWorkOrders = param.totalWorkOrders;
                                return totalWorkOrders || 0;
                            }
                        },
                        {
                            key: 'processedWorkOrders',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('processed_work_orders'),
                            renderBody: function(param) {
                                var processedWorkOrders = param.processedWorkOrders;
                                return processedWorkOrders || 0;
                            }
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    var type = this.props.match.params.type;
                    var typeName = $c3b841a1e7b08b62$var$TaskName((0, $50993b47476de2e7$export$a7357cdd1f0b0168))[type];
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                className: "m-3",
                                body: true,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("hgroup", {
                                        className: "p-4 d-flex align-items-center gap-4",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "compass",
                                                className: "text-primary",
                                                size: 3
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h2", {
                                                        className: "fs-3",
                                                        children: [
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('create'),
                                                            typeName,
                                                            ":",
                                                            ' ',
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('please_select_classification_result')
                                                        ]
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                                        className: "text-primary m-0",
                                                        children: [
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('select_classification_task_hint'),
                                                            typeName,
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('analysis_suffix')
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                        columns: this.columns,
                                        store: (0, $b60bedf248b12f36$export$2e2bcd8739ae039),
                                        translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                        striped: true,
                                        hover: true
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                className: "bg-white py-4 px-5 d-flex align-items-center gap-2",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                        name: "clock",
                                        size: 2
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "flex-fill",
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('estimated_analysis_time_15_30')
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        size: "lg",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "play-fill",
                                                className: "me-2"
                                            }),
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('start_analysis_button')
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $c3b841a1e7b08b62$var$__setFunctionName(_classThis, "TaskCreatorPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_columns_decorators = [
            (0, $arNK5.computed)
        ];
        $c3b841a1e7b08b62$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c3b841a1e7b08b62$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TaskCreatorPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $c3b841a1e7b08b62$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TaskCreatorPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $leE2g = parcelRequire("leE2g");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");


var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ 
var $5f0Cq = parcelRequire("5f0Cq");
var $3785de68a34a44e8$var$extendStatics = function extendStatics1(d, b) {
    $3785de68a34a44e8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3785de68a34a44e8$var$extendStatics(d, b);
};
function $3785de68a34a44e8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3785de68a34a44e8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3785de68a34a44e8$export$18ce0697a983be9b = function __assign1() {
    $3785de68a34a44e8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3785de68a34a44e8$export$18ce0697a983be9b.apply(this, arguments);
};
function $3785de68a34a44e8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3785de68a34a44e8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5f0Cq._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3785de68a34a44e8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3785de68a34a44e8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $5f0Cq._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3785de68a34a44e8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3785de68a34a44e8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3785de68a34a44e8$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3785de68a34a44e8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3785de68a34a44e8$export$45d3717a4c69092e(o, m, p);
}
function $3785de68a34a44e8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3785de68a34a44e8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3785de68a34a44e8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3785de68a34a44e8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3785de68a34a44e8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3785de68a34a44e8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $3785de68a34a44e8$export$10c90e4f7922046c(v) {
    return this instanceof $3785de68a34a44e8$export$10c90e4f7922046c ? (this.v = v, this) : new $3785de68a34a44e8$export$10c90e4f7922046c(v);
}
function $3785de68a34a44e8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3785de68a34a44e8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3785de68a34a44e8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3785de68a34a44e8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3785de68a34a44e8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3785de68a34a44e8$export$19a8beecd37a4c45 === "function" ? $3785de68a34a44e8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3785de68a34a44e8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3785de68a34a44e8$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3785de68a34a44e8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3785de68a34a44e8$export$45d3717a4c69092e(result, mod, k);
    }
    $3785de68a34a44e8$var$__setModuleDefault(result, mod);
    return result;
}
function $3785de68a34a44e8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3785de68a34a44e8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3785de68a34a44e8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ 
var $5f0Cq = parcelRequire("5f0Cq");
var $e870be04527b939a$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $e870be04527b939a$var$Env = function() {
    function Env() {
        this.browser = new $e870be04527b939a$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}();
var $e870be04527b939a$var$env = new $e870be04527b939a$var$Env();
if ((typeof wx === "undefined" ? "undefined" : (0, $5f0Cq._)(wx)) === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $e870be04527b939a$var$env.wxa = true;
    $e870be04527b939a$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') $e870be04527b939a$var$env.worker = true;
else if (!$e870be04527b939a$var$env.hasGlobalWindow || 'Deno' in window || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Node.js') > -1) {
    $e870be04527b939a$var$env.node = true;
    $e870be04527b939a$var$env.svgSupported = true;
} else $e870be04527b939a$var$detect(navigator.userAgent, $e870be04527b939a$var$env);
function $e870be04527b939a$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    var domSupported = env.domSupported = typeof document !== 'undefined';
    if (domSupported) {
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
}
var $e870be04527b939a$export$2e2bcd8739ae039 = $e870be04527b939a$var$env;



var $5f0Cq = parcelRequire("5f0Cq");
var $1fba639b3abe29b0$export$b1461457ea2c1179 = 12;
var $1fba639b3abe29b0$export$2653e0d5dd45b294 = 'sans-serif';
var $1fba639b3abe29b0$export$7d7a232b6d2cc80c = $1fba639b3abe29b0$export$b1461457ea2c1179 + "px " + $1fba639b3abe29b0$export$2653e0d5dd45b294;
var $1fba639b3abe29b0$var$OFFSET = 20;
var $1fba639b3abe29b0$var$SCALE = 100;
var $1fba639b3abe29b0$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $1fba639b3abe29b0$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $1fba639b3abe29b0$var$OFFSET) / $1fba639b3abe29b0$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $1fba639b3abe29b0$export$69462fcc6bf851a4 = $1fba639b3abe29b0$var$getTextWidthMap($1fba639b3abe29b0$var$defaultWidthMapStr);
var $1fba639b3abe29b0$export$ef5e599365494451 = {
    createCanvas: function createCanvas() {
        return typeof document !== 'undefined' && document.createElement('canvas');
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $1fba639b3abe29b0$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $1fba639b3abe29b0$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || '';
                font = font || $1fba639b3abe29b0$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $1fba639b3abe29b0$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf('mono') >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $1fba639b3abe29b0$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function loadImage(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function $1fba639b3abe29b0$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $1fba639b3abe29b0$export$ef5e599365494451)if (newPlatformApis[key]) $1fba639b3abe29b0$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $99026af6cdabc3e1$var$BUILTIN_OBJECT = $99026af6cdabc3e1$export$533b26079ad0b4b([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function(obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var $99026af6cdabc3e1$var$TYPED_ARRAY = $99026af6cdabc3e1$export$533b26079ad0b4b([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function(obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var $99026af6cdabc3e1$var$objToString = Object.prototype.toString;
var $99026af6cdabc3e1$var$arrayProto = Array.prototype;
var $99026af6cdabc3e1$var$nativeForEach = $99026af6cdabc3e1$var$arrayProto.forEach;
var $99026af6cdabc3e1$var$nativeFilter = $99026af6cdabc3e1$var$arrayProto.filter;
var $99026af6cdabc3e1$var$nativeSlice = $99026af6cdabc3e1$var$arrayProto.slice;
var $99026af6cdabc3e1$var$nativeMap = $99026af6cdabc3e1$var$arrayProto.map;
var $99026af6cdabc3e1$var$ctorFunction = (function ctorFunction() {}).constructor;
var $99026af6cdabc3e1$var$protoFunction = $99026af6cdabc3e1$var$ctorFunction ? $99026af6cdabc3e1$var$ctorFunction.prototype : null;
var $99026af6cdabc3e1$var$protoKey = '__proto__';
var $99026af6cdabc3e1$var$idStart = 0x0907;
function $99026af6cdabc3e1$export$46e8f25c7328f77e() {
    return $99026af6cdabc3e1$var$idStart++;
}
function $99026af6cdabc3e1$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $99026af6cdabc3e1$export$9cd59f9826255e47(source) {
    if (source == null || (typeof source === "undefined" ? "undefined" : (0, $5f0Cq._)(source)) !== 'object') return source;
    var result = source;
    var typeStr = $99026af6cdabc3e1$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$99026af6cdabc3e1$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $99026af6cdabc3e1$export$9cd59f9826255e47(source[i]);
        }
    } else if ($99026af6cdabc3e1$var$TYPED_ARRAY[typeStr]) {
        if (!$99026af6cdabc3e1$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$99026af6cdabc3e1$var$BUILTIN_OBJECT[typeStr] && !$99026af6cdabc3e1$export$c3825b437cbdea5c(source) && !$99026af6cdabc3e1$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $99026af6cdabc3e1$var$protoKey) result[key] = $99026af6cdabc3e1$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $99026af6cdabc3e1$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$99026af6cdabc3e1$export$a6cdc56e425d0d0a(source) || !$99026af6cdabc3e1$export$a6cdc56e425d0d0a(target)) return overwrite ? $99026af6cdabc3e1$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $99026af6cdabc3e1$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($99026af6cdabc3e1$export$a6cdc56e425d0d0a(sourceProp) && $99026af6cdabc3e1$export$a6cdc56e425d0d0a(targetProp) && !$99026af6cdabc3e1$export$43bee75e5e14138e(sourceProp) && !$99026af6cdabc3e1$export$43bee75e5e14138e(targetProp) && !$99026af6cdabc3e1$export$9f57505b7bd8dae(sourceProp) && !$99026af6cdabc3e1$export$9f57505b7bd8dae(targetProp) && !$99026af6cdabc3e1$export$fa523b2c4941fd4f(sourceProp) && !$99026af6cdabc3e1$export$fa523b2c4941fd4f(targetProp) && !$99026af6cdabc3e1$export$c3825b437cbdea5c(sourceProp) && !$99026af6cdabc3e1$export$c3825b437cbdea5c(targetProp)) $99026af6cdabc3e1$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $99026af6cdabc3e1$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $99026af6cdabc3e1$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $99026af6cdabc3e1$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $99026af6cdabc3e1$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $99026af6cdabc3e1$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $99026af6cdabc3e1$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $99026af6cdabc3e1$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $99026af6cdabc3e1$export$cd3d1f114b139967 = (0, $1fba639b3abe29b0$export$ef5e599365494451).createCanvas;
function $99026af6cdabc3e1$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $99026af6cdabc3e1$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $99026af6cdabc3e1$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $99026af6cdabc3e1$export$ebe90cb607ad99e(target, source, override);
}
function $99026af6cdabc3e1$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $99026af6cdabc3e1$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $99026af6cdabc3e1$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $99026af6cdabc3e1$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $99026af6cdabc3e1$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $99026af6cdabc3e1$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $99026af6cdabc3e1$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $99026af6cdabc3e1$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $99026af6cdabc3e1$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $99026af6cdabc3e1$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $99026af6cdabc3e1$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $99026af6cdabc3e1$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $99026af6cdabc3e1$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($99026af6cdabc3e1$var$nativeSlice.call(arguments)));
    };
}
var $99026af6cdabc3e1$export$2385a24977818dd0 = $99026af6cdabc3e1$var$protoFunction && $99026af6cdabc3e1$export$f6e2535fb5126e54($99026af6cdabc3e1$var$protoFunction.bind) ? $99026af6cdabc3e1$var$protoFunction.call.bind($99026af6cdabc3e1$var$protoFunction.bind) : $99026af6cdabc3e1$var$bindPolyfill;
function $99026af6cdabc3e1$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($99026af6cdabc3e1$var$nativeSlice.call(arguments)));
    };
}
function $99026af6cdabc3e1$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $99026af6cdabc3e1$var$objToString.call(value) === '[object Array]';
}
function $99026af6cdabc3e1$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $99026af6cdabc3e1$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $99026af6cdabc3e1$export$29d0bb2a4e07b252(value) {
    return $99026af6cdabc3e1$var$objToString.call(value) === '[object String]';
}
function $99026af6cdabc3e1$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $99026af6cdabc3e1$export$a6cdc56e425d0d0a(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value);
    return type === 'function' || !!value && type === 'object';
}
function $99026af6cdabc3e1$export$fa523b2c4941fd4f(value) {
    return !!$99026af6cdabc3e1$var$BUILTIN_OBJECT[$99026af6cdabc3e1$var$objToString.call(value)];
}
function $99026af6cdabc3e1$export$b119cc7e1840e59c(value) {
    return !!$99026af6cdabc3e1$var$TYPED_ARRAY[$99026af6cdabc3e1$var$objToString.call(value)];
}
function $99026af6cdabc3e1$export$9f57505b7bd8dae(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) === 'object' && typeof value.nodeType === 'number' && (0, $5f0Cq._)(value.ownerDocument) === 'object';
}
function $99026af6cdabc3e1$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $99026af6cdabc3e1$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $99026af6cdabc3e1$export$49841c62b9eff15(value) {
    return $99026af6cdabc3e1$var$objToString.call(value) === '[object RegExp]';
}
function $99026af6cdabc3e1$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $99026af6cdabc3e1$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $99026af6cdabc3e1$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $99026af6cdabc3e1$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $99026af6cdabc3e1$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $99026af6cdabc3e1$var$nativeSlice.apply(arr, args);
}
function $99026af6cdabc3e1$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $99026af6cdabc3e1$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $99026af6cdabc3e1$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $99026af6cdabc3e1$var$primitiveKey = '__ec_primitive__';
function $99026af6cdabc3e1$export$112e66431016387b(obj) {
    obj[$99026af6cdabc3e1$var$primitiveKey] = true;
}
function $99026af6cdabc3e1$export$c3825b437cbdea5c(obj) {
    return obj[$99026af6cdabc3e1$var$primitiveKey];
}
var $99026af6cdabc3e1$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $99026af6cdabc3e1$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $99026af6cdabc3e1$var$isNativeMapSupported = typeof Map === 'function';
function $99026af6cdabc3e1$var$maybeNativeMap() {
    return $99026af6cdabc3e1$var$isNativeMapSupported ? new Map() : new $99026af6cdabc3e1$var$MapPolyfill();
}
var $99026af6cdabc3e1$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $99026af6cdabc3e1$export$43bee75e5e14138e(obj);
        this.data = $99026af6cdabc3e1$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $99026af6cdabc3e1$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $99026af6cdabc3e1$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $99026af6cdabc3e1$export$55f8aa7ef875b0a4(obj) {
    return new $99026af6cdabc3e1$export$60ef0b43d585640a(obj);
}
function $99026af6cdabc3e1$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $99026af6cdabc3e1$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function StyleCtor() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $99026af6cdabc3e1$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $99026af6cdabc3e1$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function $99026af6cdabc3e1$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $99026af6cdabc3e1$export$8793edee2d425525() {}
var $99026af6cdabc3e1$export$bce8e055322a0ce6 = 180 / Math.PI;
var $99026af6cdabc3e1$export$fd293b15f47e270 = Number.EPSILON || Math.pow(2, -52);




function $0a1f57488570eee3$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $0a1f57488570eee3$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $0a1f57488570eee3$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $0a1f57488570eee3$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $0a1f57488570eee3$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $0a1f57488570eee3$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $0a1f57488570eee3$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $0a1f57488570eee3$export$fc1400facf92c78(v) {
    return Math.sqrt($0a1f57488570eee3$export$48e33bc611e4c25a(v));
}
var $0a1f57488570eee3$export$f24224f1c91d8156 = $0a1f57488570eee3$export$fc1400facf92c78;
function $0a1f57488570eee3$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $0a1f57488570eee3$export$2f106540dd9a5136 = $0a1f57488570eee3$export$48e33bc611e4c25a;
function $0a1f57488570eee3$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $0a1f57488570eee3$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $0a1f57488570eee3$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $0a1f57488570eee3$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $0a1f57488570eee3$export$a3295358bff77e(out, v) {
    var d = $0a1f57488570eee3$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $0a1f57488570eee3$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $0a1f57488570eee3$export$6c4a311cc157c764 = $0a1f57488570eee3$export$9f17032d917177de;
function $0a1f57488570eee3$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $0a1f57488570eee3$export$c68db45a034c13b0 = $0a1f57488570eee3$export$137c0a69d1ff4a79;
function $0a1f57488570eee3$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $0a1f57488570eee3$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $0a1f57488570eee3$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $0a1f57488570eee3$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $0a1f57488570eee3$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $7ff8017d9e9c3a60$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $7ff8017d9e9c3a60$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $7ff8017d9e9c3a60$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $7ff8017d9e9c3a60$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $7ff8017d9e9c3a60$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $7ff8017d9e9c3a60$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $7ff8017d9e9c3a60$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $7ff8017d9e9c3a60$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $7ff8017d9e9c3a60$export$2e2bcd8739ae039 = $7ff8017d9e9c3a60$var$Draggable;


var $7e07f1848583fc40$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $7e07f1848583fc40$export$2e2bcd8739ae039 = $7e07f1848583fc40$var$Eventful;





var $971268c72a345194$var$LN2 = Math.log(2);
function $971268c72a345194$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $971268c72a345194$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $971268c72a345194$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $971268c72a345194$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $971268c72a345194$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $971268c72a345194$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}



var $30ce8acf08cde25e$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $30ce8acf08cde25e$var$_calcOut = [];
function $30ce8acf08cde25e$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $30ce8acf08cde25e$export$1219648acc517df4($30ce8acf08cde25e$var$_calcOut, elFrom, inX, inY, true) && $30ce8acf08cde25e$export$1219648acc517df4(out, elTarget, $30ce8acf08cde25e$var$_calcOut[0], $30ce8acf08cde25e$var$_calcOut[1]);
}
function $30ce8acf08cde25e$export$a29dbe4b7d3cd586(elFrom, elTarget) {
    elFrom && dealClear(elFrom);
    elTarget && dealClear(elTarget);
    function dealClear(el) {
        var saved = el[$30ce8acf08cde25e$var$EVENT_SAVED_PROP];
        if (saved) {
            saved.clearMarkers && saved.clearMarkers();
            delete el[$30ce8acf08cde25e$var$EVENT_SAVED_PROP];
        }
    }
}
function $30ce8acf08cde25e$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $e870be04527b939a$export$2e2bcd8739ae039).domSupported && !$30ce8acf08cde25e$export$1b92e4fe606eff6d(el)) {
        var saved = el[$30ce8acf08cde25e$var$EVENT_SAVED_PROP] || (el[$30ce8acf08cde25e$var$EVENT_SAVED_PROP] = {});
        var markers = $30ce8acf08cde25e$var$prepareCoordMarkers(el, saved);
        var transformer = $30ce8acf08cde25e$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $30ce8acf08cde25e$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    saved.clearMarkers = function() {
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(markers, function(marker) {
            marker.parentNode && marker.parentNode.removeChild(marker);
        });
    };
    return markers;
}
function $30ce8acf08cde25e$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $971268c72a345194$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $971268c72a345194$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $30ce8acf08cde25e$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}
var $30ce8acf08cde25e$var$replaceReg = /([&<>"'])/g;
var $30ce8acf08cde25e$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $30ce8acf08cde25e$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($30ce8acf08cde25e$var$replaceReg, function(str, c) {
        return $30ce8acf08cde25e$var$replaceMap[c];
    });
}


var $daa01fa9060de3a2$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $daa01fa9060de3a2$var$_calcOut = [];
var $daa01fa9060de3a2$var$firefoxNotSupportOffsetXY = (0, $e870be04527b939a$export$2e2bcd8739ae039).browser.firefox && +(0, $e870be04527b939a$export$2e2bcd8739ae039).browser.version.split('.')[0] < 39;
function $daa01fa9060de3a2$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $daa01fa9060de3a2$var$calculateZrXY(el, e, out);
    else if ($daa01fa9060de3a2$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $daa01fa9060de3a2$var$calculateZrXY(el, e, out);
    return out;
}
function $daa01fa9060de3a2$var$calculateZrXY(el, e, out) {
    if ((0, $e870be04527b939a$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $30ce8acf08cde25e$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $30ce8acf08cde25e$export$1219648acc517df4)($daa01fa9060de3a2$var$_calcOut, el, ex, ey)) {
            out.zrX = $daa01fa9060de3a2$var$_calcOut[0];
            out.zrY = $daa01fa9060de3a2$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $daa01fa9060de3a2$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $daa01fa9060de3a2$export$40fadb093aebad71(el, e, calculate) {
    e = $daa01fa9060de3a2$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $daa01fa9060de3a2$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $daa01fa9060de3a2$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $daa01fa9060de3a2$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $daa01fa9060de3a2$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $daa01fa9060de3a2$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $daa01fa9060de3a2$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $daa01fa9060de3a2$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $daa01fa9060de3a2$export$fa6813432f753b0d = function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $daa01fa9060de3a2$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $d5f2627087fc12a4$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $daa01fa9060de3a2$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $d5f2627087fc12a4$var$recognizers)if ($d5f2627087fc12a4$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $d5f2627087fc12a4$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $d5f2627087fc12a4$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $d5f2627087fc12a4$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $d5f2627087fc12a4$var$recognizers = {
    pinch: function pinch(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $d5f2627087fc12a4$var$dist(pinchEnd) / $d5f2627087fc12a4$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $d5f2627087fc12a4$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $e84a7b06db3848b3$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $e84a7b06db3848b3$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $e84a7b06db3848b3$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $e84a7b06db3848b3$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $e84a7b06db3848b3$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $e84a7b06db3848b3$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $e84a7b06db3848b3$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $e84a7b06db3848b3$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $e84a7b06db3848b3$export$9cd59f9826255e47(a) {
    var b = $e84a7b06db3848b3$export$185802fd694ee1f5();
    $e84a7b06db3848b3$export$784d13d8ee351f07(b, a);
    return b;
}


var $c753ea00dcbe469a$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $c753ea00dcbe469a$export$2e2bcd8739ae039 = $c753ea00dcbe469a$var$Point;


var $faa61116fee85ae6$var$mathMin = Math.min;
var $faa61116fee85ae6$var$mathMax = Math.max;
var $faa61116fee85ae6$var$mathAbs = Math.abs;
var $faa61116fee85ae6$var$XY = [
    'x',
    'y'
];
var $faa61116fee85ae6$var$WH = [
    'width',
    'height'
];
var $faa61116fee85ae6$var$lt = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $faa61116fee85ae6$var$rb = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $faa61116fee85ae6$var$lb = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $faa61116fee85ae6$var$rt = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $faa61116fee85ae6$var$_intersectCtx = $faa61116fee85ae6$export$a0be2bdbd2369e0e();
var $faa61116fee85ae6$var$_minTv = $faa61116fee85ae6$var$_intersectCtx.minTv;
var $faa61116fee85ae6$var$_maxTv = $faa61116fee85ae6$var$_intersectCtx.maxTv;
var $faa61116fee85ae6$var$_lenMinMax = [
    0,
    0
];
var $faa61116fee85ae6$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        BoundingRect.set(this, x, y, width, height);
    }
    BoundingRect.set = function(target, x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        target.x = x;
        target.y = y;
        target.width = width;
        target.height = height;
        return target;
    };
    BoundingRect.prototype.union = function(other) {
        var x = $faa61116fee85ae6$var$mathMin(other.x, this.x);
        var y = $faa61116fee85ae6$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $faa61116fee85ae6$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $faa61116fee85ae6$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $e84a7b06db3848b3$export$185802fd694ee1f5();
        $e84a7b06db3848b3$export$d73ee8ef04f5226a(m, m, [
            -a.x,
            -a.y
        ]);
        $e84a7b06db3848b3$export$dcdf75081b88279d(m, m, [
            sx,
            sy
        ]);
        $e84a7b06db3848b3$export$d73ee8ef04f5226a(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv, opt) {
        return BoundingRect.intersect(this, b, mtv, opt);
    };
    BoundingRect.intersect = function(a, b, mtv, opt) {
        if (mtv) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).set(mtv, 0, 0);
        var outIntersectRect = opt && opt.outIntersectRect || null;
        var clamp = opt && opt.clamp;
        if (outIntersectRect) outIntersectRect.x = outIntersectRect.y = outIntersectRect.width = outIntersectRect.height = NaN;
        if (!a || !b) return false;
        if (!(a instanceof BoundingRect)) a = BoundingRect.set($faa61116fee85ae6$var$_tmpIntersectA, a.x, a.y, a.width, a.height);
        if (!(b instanceof BoundingRect)) b = BoundingRect.set($faa61116fee85ae6$var$_tmpIntersectB, b.x, b.y, b.width, b.height);
        var useMTV = !!mtv;
        $faa61116fee85ae6$var$_intersectCtx.reset(opt, useMTV);
        var touchThreshold = $faa61116fee85ae6$var$_intersectCtx.touchThreshold;
        var ax0 = a.x + touchThreshold;
        var ax1 = a.x + a.width - touchThreshold;
        var ay0 = a.y + touchThreshold;
        var ay1 = a.y + a.height - touchThreshold;
        var bx0 = b.x + touchThreshold;
        var bx1 = b.x + b.width - touchThreshold;
        var by0 = b.y + touchThreshold;
        var by1 = b.y + b.height - touchThreshold;
        if (ax0 > ax1 || ay0 > ay1 || bx0 > bx1 || by0 > by1) return false;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (useMTV || outIntersectRect) {
            $faa61116fee85ae6$var$_lenMinMax[0] = Infinity;
            $faa61116fee85ae6$var$_lenMinMax[1] = 0;
            $faa61116fee85ae6$var$intersectOneDim(ax0, ax1, bx0, bx1, 0, useMTV, outIntersectRect, clamp);
            $faa61116fee85ae6$var$intersectOneDim(ay0, ay1, by0, by1, 1, useMTV, outIntersectRect, clamp);
            if (useMTV) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).copy(mtv, overlap ? $faa61116fee85ae6$var$_intersectCtx.useDir ? $faa61116fee85ae6$var$_intersectCtx.dirMinTv : $faa61116fee85ae6$var$_minTv : $faa61116fee85ae6$var$_maxTv);
        }
        return overlap;
    };
    BoundingRect.contain = function(rect, x, y) {
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.contain = function(x, y) {
        return BoundingRect.contain(this, x, y);
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
        return target;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $faa61116fee85ae6$var$lt.x = $faa61116fee85ae6$var$lb.x = source.x;
        $faa61116fee85ae6$var$lt.y = $faa61116fee85ae6$var$rt.y = source.y;
        $faa61116fee85ae6$var$rb.x = $faa61116fee85ae6$var$rt.x = source.x + source.width;
        $faa61116fee85ae6$var$rb.y = $faa61116fee85ae6$var$lb.y = source.y + source.height;
        $faa61116fee85ae6$var$lt.transform(m);
        $faa61116fee85ae6$var$rt.transform(m);
        $faa61116fee85ae6$var$rb.transform(m);
        $faa61116fee85ae6$var$lb.transform(m);
        target.x = $faa61116fee85ae6$var$mathMin($faa61116fee85ae6$var$lt.x, $faa61116fee85ae6$var$rb.x, $faa61116fee85ae6$var$lb.x, $faa61116fee85ae6$var$rt.x);
        target.y = $faa61116fee85ae6$var$mathMin($faa61116fee85ae6$var$lt.y, $faa61116fee85ae6$var$rb.y, $faa61116fee85ae6$var$lb.y, $faa61116fee85ae6$var$rt.y);
        var maxX = $faa61116fee85ae6$var$mathMax($faa61116fee85ae6$var$lt.x, $faa61116fee85ae6$var$rb.x, $faa61116fee85ae6$var$lb.x, $faa61116fee85ae6$var$rt.x);
        var maxY = $faa61116fee85ae6$var$mathMax($faa61116fee85ae6$var$lt.y, $faa61116fee85ae6$var$rb.y, $faa61116fee85ae6$var$lb.y, $faa61116fee85ae6$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $faa61116fee85ae6$var$_tmpIntersectA = new $faa61116fee85ae6$var$BoundingRect(0, 0, 0, 0);
var $faa61116fee85ae6$var$_tmpIntersectB = new $faa61116fee85ae6$var$BoundingRect(0, 0, 0, 0);
function $faa61116fee85ae6$var$intersectOneDim(a0, a1, b0, b1, updateDimIdx, useMTV, outIntersectRect, clamp) {
    var d0 = $faa61116fee85ae6$var$mathAbs(a1 - b0);
    var d1 = $faa61116fee85ae6$var$mathAbs(b1 - a0);
    var d01min = $faa61116fee85ae6$var$mathMin(d0, d1);
    var updateDim = $faa61116fee85ae6$var$XY[updateDimIdx];
    var zeroDim = $faa61116fee85ae6$var$XY[1 - updateDimIdx];
    var wh = $faa61116fee85ae6$var$WH[updateDimIdx];
    if (a1 < b0 || b1 < a0) {
        if (d0 < d1) {
            if (useMTV) $faa61116fee85ae6$var$_maxTv[updateDim] = -d0;
            if (clamp) {
                outIntersectRect[updateDim] = a1;
                outIntersectRect[wh] = 0;
            }
        } else {
            if (useMTV) $faa61116fee85ae6$var$_maxTv[updateDim] = d1;
            if (clamp) {
                outIntersectRect[updateDim] = a0;
                outIntersectRect[wh] = 0;
            }
        }
    } else {
        if (outIntersectRect) {
            outIntersectRect[updateDim] = $faa61116fee85ae6$var$mathMax(a0, b0);
            outIntersectRect[wh] = $faa61116fee85ae6$var$mathMin(a1, b1) - outIntersectRect[updateDim];
        }
        if (useMTV) {
            if (d01min < $faa61116fee85ae6$var$_lenMinMax[0] || $faa61116fee85ae6$var$_intersectCtx.useDir) {
                $faa61116fee85ae6$var$_lenMinMax[0] = $faa61116fee85ae6$var$mathMin(d01min, $faa61116fee85ae6$var$_lenMinMax[0]);
                if (d0 < d1 || !$faa61116fee85ae6$var$_intersectCtx.bidirectional) {
                    $faa61116fee85ae6$var$_minTv[updateDim] = d0;
                    $faa61116fee85ae6$var$_minTv[zeroDim] = 0;
                    if ($faa61116fee85ae6$var$_intersectCtx.useDir) $faa61116fee85ae6$var$_intersectCtx.calcDirMTV();
                }
                if (d0 >= d1 || !$faa61116fee85ae6$var$_intersectCtx.bidirectional) {
                    $faa61116fee85ae6$var$_minTv[updateDim] = -d1;
                    $faa61116fee85ae6$var$_minTv[zeroDim] = 0;
                    if ($faa61116fee85ae6$var$_intersectCtx.useDir) $faa61116fee85ae6$var$_intersectCtx.calcDirMTV();
                }
            }
        }
    }
}
function $faa61116fee85ae6$export$a0be2bdbd2369e0e() {
    var _direction = 0;
    var _dirCheckVec = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
    var _dirTmp = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
    var _ctx = {
        minTv: new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(),
        maxTv: new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(),
        useDir: false,
        dirMinTv: new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(),
        touchThreshold: 0,
        bidirectional: true,
        negativeSize: false,
        reset: function reset(opt, useMTV) {
            _ctx.touchThreshold = 0;
            if (opt && opt.touchThreshold != null) _ctx.touchThreshold = $faa61116fee85ae6$var$mathMax(0, opt.touchThreshold);
            _ctx.negativeSize = false;
            if (!useMTV) return;
            _ctx.minTv.set(Infinity, Infinity);
            _ctx.maxTv.set(0, 0);
            _ctx.useDir = false;
            if (opt && opt.direction != null) {
                _ctx.useDir = true;
                _ctx.dirMinTv.copy(_ctx.minTv);
                _dirTmp.copy(_ctx.minTv);
                _direction = opt.direction;
                _ctx.bidirectional = opt.bidirectional == null || !!opt.bidirectional;
                if (!_ctx.bidirectional) _dirCheckVec.set(Math.cos(_direction), Math.sin(_direction));
            }
        },
        calcDirMTV: function calcDirMTV() {
            var minTv = _ctx.minTv;
            var dirMinTv = _ctx.dirMinTv;
            var squareMag = minTv.y * minTv.y + minTv.x * minTv.x;
            var dirSin = Math.sin(_direction);
            var dirCos = Math.cos(_direction);
            var dotProd = dirSin * minTv.y + dirCos * minTv.x;
            if (nearZero(dotProd)) {
                if (nearZero(minTv.x) && nearZero(minTv.y)) dirMinTv.set(0, 0);
                return;
            }
            _dirTmp.x = squareMag * dirCos / dotProd;
            _dirTmp.y = squareMag * dirSin / dotProd;
            if (nearZero(_dirTmp.x) && nearZero(_dirTmp.y)) {
                dirMinTv.set(0, 0);
                return;
            }
            if ((_ctx.bidirectional || _dirCheckVec.dot(_dirTmp) > 0) && _dirTmp.len() < dirMinTv.len()) dirMinTv.copy(_dirTmp);
        }
    };
    function nearZero(val) {
        return $faa61116fee85ae6$var$mathAbs(val) < 1e-10;
    }
    return _ctx;
}
var $faa61116fee85ae6$export$2e2bcd8739ae039 = $faa61116fee85ae6$var$BoundingRect;


var $c7978fd25ee31f46$var$SILENT = 'silent';
function $c7978fd25ee31f46$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $c7978fd25ee31f46$var$stopEvent
    };
}
function $c7978fd25ee31f46$var$stopEvent() {
    $daa01fa9060de3a2$export$fa6813432f753b0d(this.event);
}
var $c7978fd25ee31f46$var$EmptyProxy = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $7e07f1848583fc40$export$2e2bcd8739ae039));
var $c7978fd25ee31f46$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $c7978fd25ee31f46$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $c7978fd25ee31f46$var$tmpRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $c7978fd25ee31f46$var$Handler = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $c7978fd25ee31f46$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $c7978fd25ee31f46$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $7ff8017d9e9c3a60$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $99026af6cdabc3e1$export$79b2f7037acddd43($c7978fd25ee31f46$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $c7978fd25ee31f46$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $c7978fd25ee31f46$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $c7978fd25ee31f46$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $c7978fd25ee31f46$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $c7978fd25ee31f46$var$HoveredResult(x, y);
        $c7978fd25ee31f46$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $c7978fd25ee31f46$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $c7978fd25ee31f46$var$tmpRect.applyTransform(el.transform);
                    if ($c7978fd25ee31f46$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $c7978fd25ee31f46$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $d5f2627087fc12a4$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $c7978fd25ee31f46$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $7e07f1848583fc40$export$2e2bcd8739ae039));
$99026af6cdabc3e1$export$79b2f7037acddd43([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $c7978fd25ee31f46$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $c7978fd25ee31f46$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $0a1f57488570eee3$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $c7978fd25ee31f46$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return isSilent ? $c7978fd25ee31f46$var$SILENT : true;
    }
    return false;
}
function $c7978fd25ee31f46$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $c7978fd25ee31f46$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $c7978fd25ee31f46$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $c7978fd25ee31f46$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $c7978fd25ee31f46$export$2e2bcd8739ae039 = $c7978fd25ee31f46$var$Handler;



var $e2ccd138a3d2fc78$var$DEFAULT_MIN_MERGE = 32;
var $e2ccd138a3d2fc78$var$DEFAULT_MIN_GALLOPING = 7;
function $e2ccd138a3d2fc78$var$minRunLength(n) {
    var r = 0;
    while(n >= $e2ccd138a3d2fc78$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $e2ccd138a3d2fc78$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $e2ccd138a3d2fc78$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $e2ccd138a3d2fc78$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $e2ccd138a3d2fc78$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $e2ccd138a3d2fc78$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $e2ccd138a3d2fc78$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $e2ccd138a3d2fc78$var$TimSort(array, compare) {
    var minGallop = $e2ccd138a3d2fc78$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $e2ccd138a3d2fc78$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $e2ccd138a3d2fc78$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $e2ccd138a3d2fc78$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $e2ccd138a3d2fc78$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $e2ccd138a3d2fc78$var$DEFAULT_MIN_GALLOPING || count2 >= $e2ccd138a3d2fc78$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $e2ccd138a3d2fc78$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $e2ccd138a3d2fc78$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $e2ccd138a3d2fc78$var$DEFAULT_MIN_GALLOPING || count2 >= $e2ccd138a3d2fc78$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $e2ccd138a3d2fc78$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $e2ccd138a3d2fc78$var$DEFAULT_MIN_MERGE) {
        runLength = $e2ccd138a3d2fc78$var$makeAscendingRun(array, lo, hi, compare);
        $e2ccd138a3d2fc78$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $e2ccd138a3d2fc78$var$TimSort(array, compare);
    var minRun = $e2ccd138a3d2fc78$var$minRunLength(remaining);
    do {
        runLength = $e2ccd138a3d2fc78$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $e2ccd138a3d2fc78$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $8feacd04f2aac739$export$a7b6db622c6c7dbd = 1;
var $8feacd04f2aac739$export$ada8b2beb3d76671 = 2;
var $8feacd04f2aac739$export$f75fe89a33ebe115 = 4;


var $0c58279aa4affd00$var$invalidZErrorLogged = false;
function $0c58279aa4affd00$var$logInvalidZError() {
    if ($0c58279aa4affd00$var$invalidZErrorLogged) return;
    $0c58279aa4affd00$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $0c58279aa4affd00$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $0c58279aa4affd00$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $0c58279aa4affd00$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $e2ccd138a3d2fc78$export$2e2bcd8739ae039)(displayList, $0c58279aa4affd00$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, parentClipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        var parentHasClipPaths = parentClipPaths && parentClipPaths.length;
        var clipPathIdx = 0;
        var thisClipPaths = el.__clipPaths;
        if (!el.ignoreClip && (parentHasClipPaths || userSetClipPath)) {
            if (!thisClipPaths) thisClipPaths = el.__clipPaths = [];
            if (parentHasClipPaths) for(var idx = 0; idx < parentClipPaths.length; idx++)thisClipPaths[clipPathIdx++] = parentClipPaths[idx];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                thisClipPaths[clipPathIdx++] = currentClipPath;
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (thisClipPaths) thisClipPaths.length = clipPathIdx;
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, thisClipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (isNaN(disp.z)) {
                $0c58279aa4affd00$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $0c58279aa4affd00$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $0c58279aa4affd00$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, thisClipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, thisClipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, thisClipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $99026af6cdabc3e1$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $0c58279aa4affd00$export$2e2bcd8739ae039 = $0c58279aa4affd00$var$Storage;





var $43ccfca6e1382147$var$requestAnimationFrame;
$43ccfca6e1382147$var$requestAnimationFrame = (0, $e870be04527b939a$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $43ccfca6e1382147$export$2e2bcd8739ae039 = $43ccfca6e1382147$var$requestAnimationFrame;


var $d1c20a6f5d1a5fab$var$easingFuncs = {
    linear: function linear(k) {
        return k;
    },
    quadraticIn: function quadraticIn(k) {
        return k * k;
    },
    quadraticOut: function quadraticOut(k) {
        return k * (2 - k);
    },
    quadraticInOut: function quadraticInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function cubicIn(k) {
        return k * k * k;
    },
    cubicOut: function cubicOut(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function cubicInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function quarticIn(k) {
        return k * k * k * k;
    },
    quarticOut: function quarticOut(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function quarticInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function quinticIn(k) {
        return k * k * k * k * k;
    },
    quinticOut: function quinticOut(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function quinticInOut(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function sinusoidalIn(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function sinusoidalOut(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function sinusoidalInOut(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function exponentialIn(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function exponentialOut(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function exponentialInOut(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function circularIn(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function circularOut(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function circularInOut(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function elasticIn(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function elasticOut(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function elasticInOut(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function backIn(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function backOut(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function backInOut(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function bounceIn(k) {
        return 1 - $d1c20a6f5d1a5fab$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function bounceOut(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function bounceInOut(k) {
        if (k < 0.5) return $d1c20a6f5d1a5fab$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $d1c20a6f5d1a5fab$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $d1c20a6f5d1a5fab$export$2e2bcd8739ae039 = $d1c20a6f5d1a5fab$var$easingFuncs;




var $196091227dfded05$var$mathPow = Math.pow;
var $196091227dfded05$var$mathSqrt = Math.sqrt;
var $196091227dfded05$var$EPSILON = 1e-8;
var $196091227dfded05$var$EPSILON_NUMERIC = 1e-4;
var $196091227dfded05$var$THREE_SQRT = $196091227dfded05$var$mathSqrt(3);
var $196091227dfded05$var$ONE_THIRD = 1 / 3;
var $196091227dfded05$var$_v0 = (0, $0a1f57488570eee3$export$185802fd694ee1f5)();
var $196091227dfded05$var$_v1 = (0, $0a1f57488570eee3$export$185802fd694ee1f5)();
var $196091227dfded05$var$_v2 = (0, $0a1f57488570eee3$export$185802fd694ee1f5)();
function $196091227dfded05$var$isAroundZero(val) {
    return val > -$196091227dfded05$var$EPSILON && val < $196091227dfded05$var$EPSILON;
}
function $196091227dfded05$var$isNotAroundZero(val) {
    return val > $196091227dfded05$var$EPSILON || val < -$196091227dfded05$var$EPSILON;
}
function $196091227dfded05$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $196091227dfded05$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $196091227dfded05$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($196091227dfded05$var$isAroundZero(A) && $196091227dfded05$var$isAroundZero(B)) {
        if ($196091227dfded05$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($196091227dfded05$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $196091227dfded05$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$196091227dfded05$var$mathPow(-Y1, $196091227dfded05$var$ONE_THIRD);
            else Y1 = $196091227dfded05$var$mathPow(Y1, $196091227dfded05$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$196091227dfded05$var$mathPow(-Y2, $196091227dfded05$var$ONE_THIRD);
            else Y2 = $196091227dfded05$var$mathPow(Y2, $196091227dfded05$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $196091227dfded05$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $196091227dfded05$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $196091227dfded05$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $196091227dfded05$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $196091227dfded05$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($196091227dfded05$var$isAroundZero(a)) {
        if ($196091227dfded05$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($196091227dfded05$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $196091227dfded05$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $196091227dfded05$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $196091227dfded05$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $196091227dfded05$var$_v0[0] = x;
    $196091227dfded05$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $196091227dfded05$var$_v1[0] = $196091227dfded05$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $196091227dfded05$var$_v1[1] = $196091227dfded05$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $0a1f57488570eee3$export$c68db45a034c13b0)($196091227dfded05$var$_v0, $196091227dfded05$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $196091227dfded05$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $196091227dfded05$var$_v1[0] = $196091227dfded05$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $196091227dfded05$var$_v1[1] = $196091227dfded05$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $0a1f57488570eee3$export$c68db45a034c13b0)($196091227dfded05$var$_v1, $196091227dfded05$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $196091227dfded05$var$_v2[0] = $196091227dfded05$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $196091227dfded05$var$_v2[1] = $196091227dfded05$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $0a1f57488570eee3$export$c68db45a034c13b0)($196091227dfded05$var$_v2, $196091227dfded05$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $196091227dfded05$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $196091227dfded05$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $196091227dfded05$var$mathSqrt(d);
}
function $196091227dfded05$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $196091227dfded05$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $196091227dfded05$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $196091227dfded05$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $196091227dfded05$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $196091227dfded05$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($196091227dfded05$var$isAroundZero(a)) {
        if ($196091227dfded05$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($196091227dfded05$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $196091227dfded05$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $196091227dfded05$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $196091227dfded05$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $196091227dfded05$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $196091227dfded05$var$_v0[0] = x;
    $196091227dfded05$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $196091227dfded05$var$_v1[0] = $196091227dfded05$export$af17094a950f5073(x0, x1, x2, _t);
        $196091227dfded05$var$_v1[1] = $196091227dfded05$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $0a1f57488570eee3$export$c68db45a034c13b0)($196091227dfded05$var$_v0, $196091227dfded05$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $196091227dfded05$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $196091227dfded05$var$_v1[0] = $196091227dfded05$export$af17094a950f5073(x0, x1, x2, prev);
        $196091227dfded05$var$_v1[1] = $196091227dfded05$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $0a1f57488570eee3$export$c68db45a034c13b0)($196091227dfded05$var$_v1, $196091227dfded05$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $196091227dfded05$var$_v2[0] = $196091227dfded05$export$af17094a950f5073(x0, x1, x2, next);
            $196091227dfded05$var$_v2[1] = $196091227dfded05$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $0a1f57488570eee3$export$c68db45a034c13b0)($196091227dfded05$var$_v2, $196091227dfded05$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $196091227dfded05$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $196091227dfded05$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $196091227dfded05$var$mathSqrt(d);
}
function $196091227dfded05$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $196091227dfded05$export$af17094a950f5073(x0, x1, x2, t);
        var y = $196091227dfded05$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $41d3bbb04c5429c7$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $41d3bbb04c5429c7$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $41d3bbb04c5429c7$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +(0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $196091227dfded05$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $196091227dfded05$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $bda0197cadaf3462$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $99026af6cdabc3e1$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $99026af6cdabc3e1$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $99026af6cdabc3e1$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(easing) ? easing : (0, $d1c20a6f5d1a5fab$export$2e2bcd8739ae039)[easing] || (0, $41d3bbb04c5429c7$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $bda0197cadaf3462$export$2e2bcd8739ae039 = $bda0197cadaf3462$var$Clip;


var $66144e99afcfd957$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $66144e99afcfd957$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $66144e99afcfd957$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $66144e99afcfd957$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $66144e99afcfd957$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $66144e99afcfd957$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $66144e99afcfd957$export$2e2bcd8739ae039 = $66144e99afcfd957$var$LRU;



var $9148d8aa0f446713$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $9148d8aa0f446713$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $9148d8aa0f446713$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $9148d8aa0f446713$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $9148d8aa0f446713$export$e6be818e738239a(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $9148d8aa0f446713$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $9148d8aa0f446713$var$clampCssByte(parseInt(str, 10));
}
function $9148d8aa0f446713$export$7638a67891c3b497(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $9148d8aa0f446713$var$clampCssFloat(parseFloat(str) / 100);
    return $9148d8aa0f446713$var$clampCssFloat(parseFloat(str));
}
function $9148d8aa0f446713$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $9148d8aa0f446713$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $9148d8aa0f446713$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $9148d8aa0f446713$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $9148d8aa0f446713$var$colorCache = new (0, $66144e99afcfd957$export$2e2bcd8739ae039)(20);
var $9148d8aa0f446713$var$lastRemovedArr = null;
function $9148d8aa0f446713$var$putToCache(colorStr, rgbaArr) {
    if ($9148d8aa0f446713$var$lastRemovedArr) $9148d8aa0f446713$var$copyRgba($9148d8aa0f446713$var$lastRemovedArr, rgbaArr);
    $9148d8aa0f446713$var$lastRemovedArr = $9148d8aa0f446713$var$colorCache.put(colorStr, $9148d8aa0f446713$var$lastRemovedArr || rgbaArr.slice());
}
function $9148d8aa0f446713$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $9148d8aa0f446713$var$colorCache.get(colorStr);
    if (cached) return $9148d8aa0f446713$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $9148d8aa0f446713$var$kCSSColorTable) {
        $9148d8aa0f446713$var$copyRgba(rgbaArr, $9148d8aa0f446713$var$kCSSColorTable[str]);
        $9148d8aa0f446713$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $9148d8aa0f446713$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $9148d8aa0f446713$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $9148d8aa0f446713$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $9148d8aa0f446713$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $9148d8aa0f446713$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $9148d8aa0f446713$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $9148d8aa0f446713$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $9148d8aa0f446713$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $9148d8aa0f446713$export$7638a67891c3b497(params.pop());
            case 'rgb':
                if (params.length >= 3) {
                    $9148d8aa0f446713$var$setRgba(rgbaArr, $9148d8aa0f446713$export$e6be818e738239a(params[0]), $9148d8aa0f446713$export$e6be818e738239a(params[1]), $9148d8aa0f446713$export$e6be818e738239a(params[2]), params.length === 3 ? alpha : $9148d8aa0f446713$export$7638a67891c3b497(params[3]));
                    $9148d8aa0f446713$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $9148d8aa0f446713$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case 'hsla':
                if (params.length !== 4) {
                    $9148d8aa0f446713$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $9148d8aa0f446713$export$7638a67891c3b497(params[3]);
                $9148d8aa0f446713$var$hsla2rgba(params, rgbaArr);
                $9148d8aa0f446713$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $9148d8aa0f446713$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $9148d8aa0f446713$var$hsla2rgba(params, rgbaArr);
                $9148d8aa0f446713$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $9148d8aa0f446713$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $9148d8aa0f446713$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $9148d8aa0f446713$export$7638a67891c3b497(hsla[1]);
    var l = $9148d8aa0f446713$export$7638a67891c3b497(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $9148d8aa0f446713$var$setRgba(rgba, $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$cssHueToRgb(m1, m2, h) * 255), $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $9148d8aa0f446713$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $9148d8aa0f446713$export$590e8b2c435046d9(color, level) {
    var colorArr = $9148d8aa0f446713$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $9148d8aa0f446713$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $9148d8aa0f446713$export$7ea66e3774a60b67(color) {
    var colorArr = $9148d8aa0f446713$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $9148d8aa0f446713$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $9148d8aa0f446713$var$clampCssFloat($9148d8aa0f446713$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $9148d8aa0f446713$export$daa5a65daad5df58 = $9148d8aa0f446713$export$66cb3c0e9efc61c8;
function $9148d8aa0f446713$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $9148d8aa0f446713$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $9148d8aa0f446713$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $9148d8aa0f446713$export$fac44ee5b035f737([
        $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $9148d8aa0f446713$var$clampCssByte($9148d8aa0f446713$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $9148d8aa0f446713$var$clampCssFloat($9148d8aa0f446713$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $9148d8aa0f446713$export$296e08242b78a3ec = $9148d8aa0f446713$export$3a89f8d6f6bf6c9f;
function $9148d8aa0f446713$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $9148d8aa0f446713$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $9148d8aa0f446713$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $9148d8aa0f446713$var$clampCssAngle((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(h) ? h(colorArr[0]) : h));
        s != null && (colorArr[1] = $9148d8aa0f446713$export$7638a67891c3b497((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(s) ? s(colorArr[1]) : s));
        l != null && (colorArr[2] = $9148d8aa0f446713$export$7638a67891c3b497((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(l) ? l(colorArr[2]) : l));
        return $9148d8aa0f446713$export$fac44ee5b035f737($9148d8aa0f446713$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $9148d8aa0f446713$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $9148d8aa0f446713$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $9148d8aa0f446713$var$clampCssFloat(alpha);
        return $9148d8aa0f446713$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $9148d8aa0f446713$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $9148d8aa0f446713$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $9148d8aa0f446713$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $9148d8aa0f446713$export$4385e60b38654f68() {
    return $9148d8aa0f446713$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}
var $9148d8aa0f446713$var$liftedColorCache = new (0, $66144e99afcfd957$export$2e2bcd8739ae039)(100);
function $9148d8aa0f446713$export$2b47e247dfb87a73(color) {
    if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(color)) {
        var liftedColor = $9148d8aa0f446713$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $9148d8aa0f446713$export$590e8b2c435046d9(color, -0.1);
            $9148d8aa0f446713$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $99026af6cdabc3e1$export$fa2c283003ed971c)(color)) {
        var ret = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $9148d8aa0f446713$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");
var $6c5a0d6caccac2f9$export$a143d493d941bafc;
var $6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a;
var $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
var $6c5a0d6caccac2f9$export$599f31c3813fae4d;
'use strict';
var $954a4b447490bcaa$export$a48f0734ac7c2329;
var $954a4b447490bcaa$export$d622b2ad8d90c771;
var $954a4b447490bcaa$export$6100ba28696e12de;
'use strict';
$954a4b447490bcaa$export$a48f0734ac7c2329 = $954a4b447490bcaa$var$byteLength;
$954a4b447490bcaa$export$d622b2ad8d90c771 = $954a4b447490bcaa$var$toByteArray;
$954a4b447490bcaa$export$6100ba28696e12de = $954a4b447490bcaa$var$fromByteArray;
var $954a4b447490bcaa$var$lookup = [];
var $954a4b447490bcaa$var$revLookup = [];
var $954a4b447490bcaa$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $954a4b447490bcaa$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $954a4b447490bcaa$var$i = 0, $954a4b447490bcaa$var$len = $954a4b447490bcaa$var$code.length; $954a4b447490bcaa$var$i < $954a4b447490bcaa$var$len; ++$954a4b447490bcaa$var$i){
    $954a4b447490bcaa$var$lookup[$954a4b447490bcaa$var$i] = $954a4b447490bcaa$var$code[$954a4b447490bcaa$var$i];
    $954a4b447490bcaa$var$revLookup[$954a4b447490bcaa$var$code.charCodeAt($954a4b447490bcaa$var$i)] = $954a4b447490bcaa$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$954a4b447490bcaa$var$revLookup['-'.charCodeAt(0)] = 62;
$954a4b447490bcaa$var$revLookup['_'.charCodeAt(0)] = 63;
function $954a4b447490bcaa$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $954a4b447490bcaa$var$byteLength(b64) {
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$toByteArray(b64) {
    var tmp;
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $954a4b447490bcaa$var$Arr($954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 18 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 2 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 10 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $954a4b447490bcaa$var$tripletToBase64(num) {
    return $954a4b447490bcaa$var$lookup[num >> 18 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 12 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 6 & 0x3F] + $954a4b447490bcaa$var$lookup[num & 0x3F];
}
function $954a4b447490bcaa$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($954a4b447490bcaa$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $954a4b447490bcaa$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($954a4b447490bcaa$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 2] + $954a4b447490bcaa$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 10] + $954a4b447490bcaa$var$lookup[tmp >> 4 & 0x3F] + $954a4b447490bcaa$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f99c5859a5f73a56$export$aafa59e2e03f2942;
var $f99c5859a5f73a56$export$68d8715fc104d294;
$f99c5859a5f73a56$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f99c5859a5f73a56$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $6c5a0d6caccac2f9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6c5a0d6caccac2f9$export$a143d493d941bafc = $6c5a0d6caccac2f9$var$Buffer;
$6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a = $6c5a0d6caccac2f9$var$SlowBuffer;
$6c5a0d6caccac2f9$export$f99ded8fe4b79145 = 50;
var $6c5a0d6caccac2f9$var$K_MAX_LENGTH = 0x7fffffff;
$6c5a0d6caccac2f9$export$599f31c3813fae4d = $6c5a0d6caccac2f9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT = $6c5a0d6caccac2f9$var$typedArraySupport();
if (!$6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6c5a0d6caccac2f9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6c5a0d6caccac2f9$var$createBuffer(length) {
    if (length > $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6c5a0d6caccac2f9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6c5a0d6caccac2f9$var$allocUnsafe(arg);
    }
    return $6c5a0d6caccac2f9$var$from(arg, encodingOrOffset, length);
}
$6c5a0d6caccac2f9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6c5a0d6caccac2f9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6c5a0d6caccac2f9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)));
    if ($6c5a0d6caccac2f9$var$isInstance(value, ArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, ArrayBuffer)) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6c5a0d6caccac2f9$var$isInstance(value, SharedArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, SharedArrayBuffer))) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6c5a0d6caccac2f9$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $6c5a0d6caccac2f9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6c5a0d6caccac2f9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6c5a0d6caccac2f9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer, Uint8Array);
function $6c5a0d6caccac2f9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6c5a0d6caccac2f9$var$alloc(size, fill, encoding) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    if (size <= 0) return $6c5a0d6caccac2f9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill, encoding) : $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill);
    return $6c5a0d6caccac2f9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6c5a0d6caccac2f9$var$Buffer.alloc = function(size, fill, encoding) {
    return $6c5a0d6caccac2f9$var$alloc(size, fill, encoding);
};
function $6c5a0d6caccac2f9$var$allocUnsafe(size) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    return $6c5a0d6caccac2f9$var$createBuffer(size < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafe = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafeSlow = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
function $6c5a0d6caccac2f9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $6c5a0d6caccac2f9$var$byteLength(string, encoding) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(array.length) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayView(arrayView) {
    if ($6c5a0d6caccac2f9$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $6c5a0d6caccac2f9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6c5a0d6caccac2f9$var$fromArrayLike(arrayView);
}
function $6c5a0d6caccac2f9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromObject(obj) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(obj)) {
        var len = $6c5a0d6caccac2f9$var$checked(obj.length) | 0;
        var buf = $6c5a0d6caccac2f9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6c5a0d6caccac2f9$var$numberIsNaN(obj.length)) return $6c5a0d6caccac2f9$var$createBuffer(0);
        return $6c5a0d6caccac2f9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6c5a0d6caccac2f9$var$fromArrayLike(obj.data);
}
function $6c5a0d6caccac2f9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6c5a0d6caccac2f9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6c5a0d6caccac2f9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6c5a0d6caccac2f9$var$Buffer.alloc(+length);
}
$6c5a0d6caccac2f9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6c5a0d6caccac2f9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6c5a0d6caccac2f9$var$Buffer.compare = function compare(a, b) {
    if ($6c5a0d6caccac2f9$var$isInstance(a, Uint8Array)) a = $6c5a0d6caccac2f9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6c5a0d6caccac2f9$var$isInstance(b, Uint8Array)) b = $6c5a0d6caccac2f9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(a) || !$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6c5a0d6caccac2f9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6c5a0d6caccac2f9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6c5a0d6caccac2f9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $6c5a0d6caccac2f9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($6c5a0d6caccac2f9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) buf = $6c5a0d6caccac2f9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6c5a0d6caccac2f9$var$byteLength(string, encoding) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6c5a0d6caccac2f9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $5f0Cq._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6c5a0d6caccac2f9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6c5a0d6caccac2f9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6c5a0d6caccac2f9$var$Buffer.byteLength = $6c5a0d6caccac2f9$var$byteLength;
function $6c5a0d6caccac2f9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6c5a0d6caccac2f9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6c5a0d6caccac2f9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6c5a0d6caccac2f9$var$latin1Slice(this, start, end);
        case 'base64':
            return $6c5a0d6caccac2f9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c5a0d6caccac2f9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6c5a0d6caccac2f9$var$Buffer.prototype._isBuffer = true;
function $6c5a0d6caccac2f9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$6c5a0d6caccac2f9$var$swap(this, i, i + 1);
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 3);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 7);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 6);
        $6c5a0d6caccac2f9$var$swap(this, i + 2, i + 5);
        $6c5a0d6caccac2f9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6c5a0d6caccac2f9$var$utf8Slice(this, 0, length);
    return $6c5a0d6caccac2f9$var$slowToString.apply(this, arguments);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toLocaleString = $6c5a0d6caccac2f9$var$Buffer.prototype.toString;
$6c5a0d6caccac2f9$var$Buffer.prototype.equals = function equals(b) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6c5a0d6caccac2f9$var$Buffer.compare(this, b) === 0;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6c5a0d6caccac2f9$var$customInspectSymbol) $6c5a0d6caccac2f9$var$Buffer.prototype[$6c5a0d6caccac2f9$var$customInspectSymbol] = $6c5a0d6caccac2f9$var$Buffer.prototype.inspect;
$6c5a0d6caccac2f9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6c5a0d6caccac2f9$var$isInstance(target, Uint8Array)) target = $6c5a0d6caccac2f9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $5f0Cq._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6c5a0d6caccac2f9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6c5a0d6caccac2f9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6c5a0d6caccac2f9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6c5a0d6caccac2f9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6c5a0d6caccac2f9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6c5a0d6caccac2f9$var$utf8Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$asciiWrite(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$asciiToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$base64Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$base64ToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$ucs2Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6c5a0d6caccac2f9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6c5a0d6caccac2f9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6c5a0d6caccac2f9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6c5a0d6caccac2f9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c5a0d6caccac2f9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6c5a0d6caccac2f9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $954a4b447490bcaa$export$6100ba28696e12de(buf);
    else return $954a4b447490bcaa$export$6100ba28696e12de(buf.slice(start, end));
}
function $6c5a0d6caccac2f9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6c5a0d6caccac2f9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6c5a0d6caccac2f9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6c5a0d6caccac2f9$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6c5a0d6caccac2f9$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6c5a0d6caccac2f9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $6c5a0d6caccac2f9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6c5a0d6caccac2f9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6c5a0d6caccac2f9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $f99c5859a5f73a56$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $f99c5859a5f73a56$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $f99c5859a5f73a56$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $f99c5859a5f73a56$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $6c5a0d6caccac2f9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6c5a0d6caccac2f9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6c5a0d6caccac2f9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6c5a0d6caccac2f9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $f99c5859a5f73a56$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, false, noAssert);
};
function $6c5a0d6caccac2f9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $f99c5859a5f73a56$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6c5a0d6caccac2f9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6c5a0d6caccac2f9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $6c5a0d6caccac2f9$var$Buffer.isBuffer(val) ? val : $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $6c5a0d6caccac2f9$var$errors = {};
function $6c5a0d6caccac2f9$var$E(sym, getMessage, Base) {
    $6c5a0d6caccac2f9$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $h6w6E._)(NodeError, Base);
        function NodeError() {
            (0, $7lhcp._)(this, NodeError);
            var _this;
            _this = (0, $07dqX._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $8BtP9._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$6c5a0d6caccac2f9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6c5a0d6caccac2f9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $5f0Cq._)(actual));
}, TypeError);
$6c5a0d6caccac2f9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $5f0Cq._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $6c5a0d6caccac2f9$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength) {
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $5f0Cq._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength);
}
function $6c5a0d6caccac2f9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6c5a0d6caccac2f9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6c5a0d6caccac2f9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6c5a0d6caccac2f9$var$validateNumber(value, type);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6c5a0d6caccac2f9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $6c5a0d6caccac2f9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6c5a0d6caccac2f9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6c5a0d6caccac2f9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6c5a0d6caccac2f9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6c5a0d6caccac2f9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6c5a0d6caccac2f9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6c5a0d6caccac2f9$var$base64ToBytes(str) {
    return $954a4b447490bcaa$export$d622b2ad8d90c771($6c5a0d6caccac2f9$var$base64clean(str));
}
function $6c5a0d6caccac2f9$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6c5a0d6caccac2f9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6c5a0d6caccac2f9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $6c5a0d6caccac2f9$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6c5a0d6caccac2f9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6c5a0d6caccac2f9$var$BufferBigIntNotDefined : fn;
}
function $6c5a0d6caccac2f9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $2576ca1a583f3189$require$Buffer = $6c5a0d6caccac2f9$export$a143d493d941bafc;
var $2576ca1a583f3189$var$mathRound = Math.round;
function $2576ca1a583f3189$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $9148d8aa0f446713$export$98e6a39c04603d36)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $2576ca1a583f3189$var$EPSILON = 1e-4;
function $2576ca1a583f3189$export$4701367f5b4de464(transform) {
    return transform < $2576ca1a583f3189$var$EPSILON && transform > -$2576ca1a583f3189$var$EPSILON;
}
function $2576ca1a583f3189$export$4b9074ac37ee5a23(transform) {
    return $2576ca1a583f3189$var$mathRound(transform * 1e3) / 1e3;
}
function $2576ca1a583f3189$export$52bfc6d3e2ff0fc2(transform) {
    return $2576ca1a583f3189$var$mathRound(transform * 1e4) / 1e4;
}
function $2576ca1a583f3189$export$19676ab5cb1de150(transform) {
    return $2576ca1a583f3189$var$mathRound(transform * 10) / 10;
}
function $2576ca1a583f3189$export$f29a4456cf56ff21(m) {
    return 'matrix(' + $2576ca1a583f3189$export$4b9074ac37ee5a23(m[0]) + ',' + $2576ca1a583f3189$export$4b9074ac37ee5a23(m[1]) + ',' + $2576ca1a583f3189$export$4b9074ac37ee5a23(m[2]) + ',' + $2576ca1a583f3189$export$4b9074ac37ee5a23(m[3]) + ',' + $2576ca1a583f3189$export$52bfc6d3e2ff0fc2(m[4]) + ',' + $2576ca1a583f3189$export$52bfc6d3e2ff0fc2(m[5]) + ')';
}
var $2576ca1a583f3189$export$4062150f0600d971 = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $2576ca1a583f3189$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
function $2576ca1a583f3189$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $2576ca1a583f3189$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function $2576ca1a583f3189$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $2576ca1a583f3189$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $2576ca1a583f3189$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $2576ca1a583f3189$export$41a28f5a000a9d0f(val) {
    return $2576ca1a583f3189$export$2ade673ac4f85dfe(val) || $2576ca1a583f3189$export$30352f47600a13cd(val);
}
function $2576ca1a583f3189$export$7d961bca9d3b47d0(val) {
    return val.type === 'linear';
}
function $2576ca1a583f3189$export$2a9cca6692a0ce3a(val) {
    return val.type === 'radial';
}
function $2576ca1a583f3189$export$545e02bbd5f8fe95(val) {
    return val && (val.type === 'linear' || val.type === 'radial');
}
function $2576ca1a583f3189$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $2576ca1a583f3189$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $2576ca1a583f3189$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $99026af6cdabc3e1$export$bce8e055322a0ce6);
    var scaleX = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $2576ca1a583f3189$var$mathRound(skewX * (0, $99026af6cdabc3e1$export$bce8e055322a0ce6)) + "deg, " + $2576ca1a583f3189$var$mathRound(skewY * (0, $99026af6cdabc3e1$export$bce8e055322a0ce6)) + "deg)");
    return res.join(' ');
}
var $2576ca1a583f3189$export$8fb536984ec8b4d7 = function() {
    if ((0, $e870be04527b939a$export$2e2bcd8739ae039).hasGlobalWindow && (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(window.btoa)) return function(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    if (typeof $2576ca1a583f3189$require$Buffer !== 'undefined') return function(str) {
        return $2576ca1a583f3189$require$Buffer.from(str).toString('base64');
    };
    return function(str) {
        return null;
    };
}();


var $e2970c8322c3e197$var$arraySlice = Array.prototype.slice;
function $e2970c8322c3e197$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $e2970c8322c3e197$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $e2970c8322c3e197$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $e2970c8322c3e197$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $e2970c8322c3e197$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $e2970c8322c3e197$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $e2970c8322c3e197$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $e2970c8322c3e197$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $e2970c8322c3e197$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $e2970c8322c3e197$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $e2970c8322c3e197$export$c5e92b7f105af84e(value) {
    if ((0, $99026af6cdabc3e1$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $99026af6cdabc3e1$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($e2970c8322c3e197$var$arraySlice.call(value[i]));
            return ret;
        }
        return $e2970c8322c3e197$var$arraySlice.call(value);
    }
    return value;
}
function $e2970c8322c3e197$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function $e2970c8322c3e197$var$guessArrayDim(value) {
    return (0, $99026af6cdabc3e1$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $e2970c8322c3e197$var$VALUE_TYPE_NUMBER = 0;
var $e2970c8322c3e197$var$VALUE_TYPE_1D_ARRAY = 1;
var $e2970c8322c3e197$var$VALUE_TYPE_2D_ARRAY = 2;
var $e2970c8322c3e197$var$VALUE_TYPE_COLOR = 3;
var $e2970c8322c3e197$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $e2970c8322c3e197$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $e2970c8322c3e197$var$VALUE_TYPE_UNKOWN = 6;
function $e2970c8322c3e197$var$isGradientValueType(valType) {
    return valType === $e2970c8322c3e197$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $e2970c8322c3e197$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $e2970c8322c3e197$var$isArrayValueType(valType) {
    return valType === $e2970c8322c3e197$var$VALUE_TYPE_1D_ARRAY || valType === $e2970c8322c3e197$var$VALUE_TYPE_2D_ARRAY;
}
var $e2970c8322c3e197$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $e2970c8322c3e197$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $e2970c8322c3e197$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $99026af6cdabc3e1$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $e2970c8322c3e197$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rawValue) && !(0, $99026af6cdabc3e1$export$7d667b9a0c48c975)(rawValue)) valType = $e2970c8322c3e197$var$VALUE_TYPE_NUMBER;
            else if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $e2970c8322c3e197$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $9148d8aa0f446713$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $e2970c8322c3e197$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $99026af6cdabc3e1$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $9148d8aa0f446713$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $2576ca1a583f3189$export$7d961bca9d3b47d0)(rawValue)) valType = $e2970c8322c3e197$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $2576ca1a583f3189$export$2a9cca6692a0ce3a)(rawValue)) valType = $e2970c8322c3e197$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $e2970c8322c3e197$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(easing) ? easing : (0, $d1c20a6f5d1a5fab$export$2e2bcd8739ae039)[easing] || (0, $41d3bbb04c5429c7$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $e2970c8322c3e197$var$isArrayValueType(valType);
        var isGradient = $e2970c8322c3e197$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $e2970c8322c3e197$var$fillArray(value, lastValue, valType);
                else if (isGradient) $e2970c8322c3e197$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $e2970c8322c3e197$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $e2970c8322c3e197$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $e2970c8322c3e197$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $e2970c8322c3e197$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($e2970c8322c3e197$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $e2970c8322c3e197$var$VALUE_TYPE_1D_ARRAY ? $e2970c8322c3e197$var$add1DArray([], kfs[i].value, startValue, -1) : $e2970c8322c3e197$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $e2970c8322c3e197$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $e2970c8322c3e197$var$tmpRgba : target[propName];
        if (($e2970c8322c3e197$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($e2970c8322c3e197$var$isArrayValueType(valType)) valType === $e2970c8322c3e197$var$VALUE_TYPE_1D_ARRAY ? $e2970c8322c3e197$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $e2970c8322c3e197$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($e2970c8322c3e197$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $e2970c8322c3e197$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: $e2970c8322c3e197$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $e2970c8322c3e197$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $e2970c8322c3e197$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $e2970c8322c3e197$var$rgba2String($e2970c8322c3e197$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $e2970c8322c3e197$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $e2970c8322c3e197$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $e2970c8322c3e197$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $e2970c8322c3e197$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $e2970c8322c3e197$var$rgba2String(targetArr);
        } else {
            var value = $e2970c8322c3e197$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $e2970c8322c3e197$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $e2970c8322c3e197$var$VALUE_TYPE_COLOR) {
            $9148d8aa0f446713$export$98e6a39c04603d36(target[propName], $e2970c8322c3e197$var$tmpRgba);
            $e2970c8322c3e197$var$add1DArray($e2970c8322c3e197$var$tmpRgba, $e2970c8322c3e197$var$tmpRgba, additiveValue, 1);
            target[propName] = $e2970c8322c3e197$var$rgba2String($e2970c8322c3e197$var$tmpRgba);
        } else if (valType === $e2970c8322c3e197$var$VALUE_TYPE_1D_ARRAY) $e2970c8322c3e197$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $e2970c8322c3e197$var$VALUE_TYPE_2D_ARRAY) $e2970c8322c3e197$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $e2970c8322c3e197$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $99026af6cdabc3e1$export$58da9968c3170cb1)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $e2970c8322c3e197$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $e2970c8322c3e197$var$VALUE_TYPE_COLOR && initialValue) initialValue = $e2970c8322c3e197$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $e2970c8322c3e197$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $e2970c8322c3e197$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $bda0197cadaf3462$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function onframe(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function ondestroy() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $e2970c8322c3e197$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $e2970c8322c3e197$export$2e2bcd8739ae039 = $e2970c8322c3e197$var$Animator;


function $2b85325ff91a4b8f$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $2b85325ff91a4b8f$var$Animation = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $2b85325ff91a4b8f$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $43ccfca6e1382147$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $43ccfca6e1382147$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $2b85325ff91a4b8f$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $2b85325ff91a4b8f$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $2b85325ff91a4b8f$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $e2970c8322c3e197$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $7e07f1848583fc40$export$2e2bcd8739ae039));
var $2b85325ff91a4b8f$export$2e2bcd8739ae039 = $2b85325ff91a4b8f$var$Animation;







var $0ac8b953ad9305ca$var$TOUCH_CLICK_DELAY = 300;
var $0ac8b953ad9305ca$var$globalEventSupported = (0, $e870be04527b939a$export$2e2bcd8739ae039).domSupported;
var $0ac8b953ad9305ca$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $99026af6cdabc3e1$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $0ac8b953ad9305ca$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $0ac8b953ad9305ca$var$wheelEventSupported = false;
function $0ac8b953ad9305ca$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $0ac8b953ad9305ca$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $0ac8b953ad9305ca$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $0ac8b953ad9305ca$var$normalizeGlobalEvent(instance, event) {
    return (0, $daa01fa9060de3a2$export$40fadb093aebad71)(instance.dom, new $0ac8b953ad9305ca$var$FakeGlobalEvent(instance, event), true);
}
function $0ac8b953ad9305ca$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $0ac8b953ad9305ca$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $99026af6cdabc3e1$export$8793edee2d425525;
        this.stopImmediatePropagation = $99026af6cdabc3e1$export$8793edee2d425525;
        this.preventDefault = $99026af6cdabc3e1$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $0ac8b953ad9305ca$var$localDOMHandlers = {
    mousedown: function mousedown(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function mousemove(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function mouseup(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function mouseout(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$0ac8b953ad9305ca$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function wheel(event) {
        $0ac8b953ad9305ca$var$wheelEventSupported = true;
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function mousewheel(event) {
        if ($0ac8b953ad9305ca$var$wheelEventSupported) return;
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function touchstart(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        $0ac8b953ad9305ca$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $0ac8b953ad9305ca$var$localDOMHandlers.mousemove.call(this, event);
        $0ac8b953ad9305ca$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function touchmove(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        $0ac8b953ad9305ca$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $0ac8b953ad9305ca$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function touchend(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        $0ac8b953ad9305ca$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $0ac8b953ad9305ca$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $0ac8b953ad9305ca$var$TOUCH_CLICK_DELAY) $0ac8b953ad9305ca$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function pointerdown(event) {
        $0ac8b953ad9305ca$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function pointermove(event) {
        if (!$0ac8b953ad9305ca$var$isPointerFromTouch(event)) $0ac8b953ad9305ca$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function pointerup(event) {
        $0ac8b953ad9305ca$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function pointerout(event) {
        if (!$0ac8b953ad9305ca$var$isPointerFromTouch(event)) $0ac8b953ad9305ca$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$99026af6cdabc3e1$export$79b2f7037acddd43([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $0ac8b953ad9305ca$var$localDOMHandlers[name] = function(event) {
        event = (0, $daa01fa9060de3a2$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $0ac8b953ad9305ca$var$globalDOMHandlers = {
    pointermove: function pointermove(event) {
        if (!$0ac8b953ad9305ca$var$isPointerFromTouch(event)) $0ac8b953ad9305ca$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function pointerup(event) {
        $0ac8b953ad9305ca$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function mousemove(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function mouseup(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $0ac8b953ad9305ca$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $e870be04527b939a$export$2e2bcd8739ae039).pointerEventsSupported) $99026af6cdabc3e1$export$79b2f7037acddd43($0ac8b953ad9305ca$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $0ac8b953ad9305ca$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $e870be04527b939a$export$2e2bcd8739ae039).touchEventsSupported) $99026af6cdabc3e1$export$79b2f7037acddd43($0ac8b953ad9305ca$var$localNativeListenerNames.touch, function(nativeEventName) {
            $0ac8b953ad9305ca$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $0ac8b953ad9305ca$var$setTouchTimer(scope);
            });
        });
        $99026af6cdabc3e1$export$79b2f7037acddd43($0ac8b953ad9305ca$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $0ac8b953ad9305ca$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $daa01fa9060de3a2$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $0ac8b953ad9305ca$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $e870be04527b939a$export$2e2bcd8739ae039).pointerEventsSupported) $99026af6cdabc3e1$export$79b2f7037acddd43($0ac8b953ad9305ca$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $e870be04527b939a$export$2e2bcd8739ae039).touchEventsSupported) $99026af6cdabc3e1$export$79b2f7037acddd43($0ac8b953ad9305ca$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $daa01fa9060de3a2$export$4abe0e945399ac1d)(event);
            if (!$0ac8b953ad9305ca$var$isLocalEl(instance, event.target)) {
                event = $0ac8b953ad9305ca$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $0ac8b953ad9305ca$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $0ac8b953ad9305ca$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $daa01fa9060de3a2$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $0ac8b953ad9305ca$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $daa01fa9060de3a2$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $0ac8b953ad9305ca$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $0ac8b953ad9305ca$var$HandlerDomProxy = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $0ac8b953ad9305ca$var$DOMHandlerScope(dom, $0ac8b953ad9305ca$var$localDOMHandlers);
        if ($0ac8b953ad9305ca$var$globalEventSupported) _this._globalHandlerScope = new $0ac8b953ad9305ca$var$DOMHandlerScope(document, $0ac8b953ad9305ca$var$globalDOMHandlers);
        $0ac8b953ad9305ca$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $0ac8b953ad9305ca$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($0ac8b953ad9305ca$var$globalEventSupported) $0ac8b953ad9305ca$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($0ac8b953ad9305ca$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $0ac8b953ad9305ca$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $0ac8b953ad9305ca$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $7e07f1848583fc40$export$2e2bcd8739ae039));
var $0ac8b953ad9305ca$export$2e2bcd8739ae039 = $0ac8b953ad9305ca$var$HandlerDomProxy;




var $3fee4bff41210a9c$var$dpr = 1;
if ((0, $e870be04527b939a$export$2e2bcd8739ae039).hasGlobalWindow) $3fee4bff41210a9c$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $3fee4bff41210a9c$export$7cdcde344c85339c = 0;
var $3fee4bff41210a9c$export$508f096bfcdaac40 = $3fee4bff41210a9c$var$dpr;
var $3fee4bff41210a9c$export$fd81e7ebc7dae256 = 0.4;
var $3fee4bff41210a9c$export$f8ce94761f39398d = '#333';
var $3fee4bff41210a9c$export$3c6e95f318c8369b = '#ccc';
var $3fee4bff41210a9c$export$27682248795c3c6b = '#eee';






var $4640b1300b1537ae$var$mIdentity = $e84a7b06db3848b3$export$f0954fd7d5368655;
var $4640b1300b1537ae$var$EPSILON = 5e-5;
function $4640b1300b1537ae$var$isNotAroundZero(val) {
    return val > $4640b1300b1537ae$var$EPSILON || val < -$4640b1300b1537ae$var$EPSILON;
}
var $4640b1300b1537ae$var$scaleTmp = [];
var $4640b1300b1537ae$var$tmpTransform = [];
var $4640b1300b1537ae$var$originTransform = $e84a7b06db3848b3$export$185802fd694ee1f5();
var $4640b1300b1537ae$var$abs = Math.abs;
var $4640b1300b1537ae$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $4640b1300b1537ae$var$isNotAroundZero(this.rotation) || $4640b1300b1537ae$var$isNotAroundZero(this.x) || $4640b1300b1537ae$var$isNotAroundZero(this.y) || $4640b1300b1537ae$var$isNotAroundZero(this.scaleX - 1) || $4640b1300b1537ae$var$isNotAroundZero(this.scaleY - 1) || $4640b1300b1537ae$var$isNotAroundZero(this.skewX) || $4640b1300b1537ae$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $4640b1300b1537ae$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $e84a7b06db3848b3$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $4640b1300b1537ae$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $e84a7b06db3848b3$export$6e3a27864ab166fe(m, parentTransform, m);
            else $e84a7b06db3848b3$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($4640b1300b1537ae$var$scaleTmp);
            var relX = $4640b1300b1537ae$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $4640b1300b1537ae$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($4640b1300b1537ae$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $4640b1300b1537ae$var$scaleTmp[0] || 0;
            var sy = (($4640b1300b1537ae$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $4640b1300b1537ae$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $e84a7b06db3848b3$export$185802fd694ee1f5();
        $e84a7b06db3848b3$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $e84a7b06db3848b3$export$185802fd694ee1f5();
            $e84a7b06db3848b3$export$6e3a27864ab166fe($4640b1300b1537ae$var$tmpTransform, parent.invTransform, m);
            m = $4640b1300b1537ae$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $4640b1300b1537ae$var$originTransform[4] = ox;
            $4640b1300b1537ae$var$originTransform[5] = oy;
            $e84a7b06db3848b3$export$6e3a27864ab166fe($4640b1300b1537ae$var$tmpTransform, m, $4640b1300b1537ae$var$originTransform);
            $4640b1300b1537ae$var$tmpTransform[4] -= ox;
            $4640b1300b1537ae$var$tmpTransform[5] -= oy;
            m = $4640b1300b1537ae$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $0a1f57488570eee3$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $0a1f57488570eee3$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $4640b1300b1537ae$var$abs(m[0] - 1) > 1e-10 && $4640b1300b1537ae$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($4640b1300b1537ae$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $4640b1300b1537ae$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $e84a7b06db3848b3$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $4640b1300b1537ae$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'anchorX',
    'anchorY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
function $4640b1300b1537ae$export$234b1c16dfa57d6a(target, source) {
    for(var i = 0; i < $4640b1300b1537ae$export$98ab6203ec3396e2.length; i++){
        var propName = $4640b1300b1537ae$export$98ab6203ec3396e2[i];
        target[propName] = source[propName];
    }
}
var $4640b1300b1537ae$export$2e2bcd8739ae039 = $4640b1300b1537ae$var$Transformable;








function $33d0653e48493c02$export$3c49c185de0c2bfc(text, font) {
    return $33d0653e48493c02$export$e6849d91c2a0b61f($33d0653e48493c02$export$23ef3ef10b010856(font), text);
}
function $33d0653e48493c02$export$23ef3ef10b010856(font) {
    if (!$33d0653e48493c02$var$_fontMeasureInfoCache) $33d0653e48493c02$var$_fontMeasureInfoCache = new (0, $66144e99afcfd957$export$2e2bcd8739ae039)(100);
    font = font || (0, $1fba639b3abe29b0$export$7d7a232b6d2cc80c);
    var measureInfo = $33d0653e48493c02$var$_fontMeasureInfoCache.get(font);
    if (!measureInfo) {
        measureInfo = {
            font: font,
            strWidthCache: new (0, $66144e99afcfd957$export$2e2bcd8739ae039)(500),
            asciiWidthMap: null,
            asciiWidthMapTried: false,
            stWideCharWidth: (0, $1fba639b3abe29b0$export$ef5e599365494451).measureText("\u56FD", font).width,
            asciiCharWidth: (0, $1fba639b3abe29b0$export$ef5e599365494451).measureText('a', font).width
        };
        $33d0653e48493c02$var$_fontMeasureInfoCache.put(font, measureInfo);
    }
    return measureInfo;
}
var $33d0653e48493c02$var$_fontMeasureInfoCache;
function $33d0653e48493c02$var$tryCreateASCIIWidthMap(font) {
    if ($33d0653e48493c02$var$_getASCIIWidthMapLongCount >= $33d0653e48493c02$var$GET_ASCII_WIDTH_LONG_COUNT_MAX) return;
    font = font || (0, $1fba639b3abe29b0$export$7d7a232b6d2cc80c);
    var asciiWidthMap = [];
    var start = +new Date();
    for(var code = 0; code <= 127; code++)asciiWidthMap[code] = (0, $1fba639b3abe29b0$export$ef5e599365494451).measureText(String.fromCharCode(code), font).width;
    var cost = +new Date() - start;
    if (cost > 16) $33d0653e48493c02$var$_getASCIIWidthMapLongCount = $33d0653e48493c02$var$GET_ASCII_WIDTH_LONG_COUNT_MAX;
    else if (cost > 2) $33d0653e48493c02$var$_getASCIIWidthMapLongCount++;
    return asciiWidthMap;
}
var $33d0653e48493c02$var$_getASCIIWidthMapLongCount = 0;
var $33d0653e48493c02$var$GET_ASCII_WIDTH_LONG_COUNT_MAX = 5;
function $33d0653e48493c02$export$4e92f5603b5c7bb3(fontMeasureInfo, charCode) {
    if (!fontMeasureInfo.asciiWidthMapTried) {
        fontMeasureInfo.asciiWidthMap = $33d0653e48493c02$var$tryCreateASCIIWidthMap(fontMeasureInfo.font);
        fontMeasureInfo.asciiWidthMapTried = true;
    }
    return 0 <= charCode && charCode <= 127 ? fontMeasureInfo.asciiWidthMap != null ? fontMeasureInfo.asciiWidthMap[charCode] : fontMeasureInfo.asciiCharWidth : fontMeasureInfo.stWideCharWidth;
}
function $33d0653e48493c02$export$e6849d91c2a0b61f(fontMeasureInfo, text) {
    var strWidthCache = fontMeasureInfo.strWidthCache;
    var width = strWidthCache.get(text);
    if (width == null) {
        width = (0, $1fba639b3abe29b0$export$ef5e599365494451).measureText(text, fontMeasureInfo.font).width;
        strWidthCache.put(text, width);
    }
    return width;
}
function $33d0653e48493c02$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $33d0653e48493c02$export$e6849d91c2a0b61f($33d0653e48493c02$export$23ef3ef10b010856(font), text);
    var height = $33d0653e48493c02$export$56204a27a2958a55(font);
    var x = $33d0653e48493c02$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $33d0653e48493c02$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $33d0653e48493c02$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $33d0653e48493c02$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $33d0653e48493c02$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $33d0653e48493c02$export$eb5a525ef00ef9a4(x, width, textAlign, inverse) {
    if (textAlign === 'right') !inverse ? x -= width : x += width;
    else if (textAlign === 'center') !inverse ? x -= width / 2 : x += width / 2;
    return x;
}
function $33d0653e48493c02$export$bf7d6802d2badd9(y, height, verticalAlign, inverse) {
    if (verticalAlign === 'middle') !inverse ? y -= height / 2 : y += height / 2;
    else if (verticalAlign === 'bottom') !inverse ? y -= height : y += height;
    return y;
}
function $33d0653e48493c02$export$56204a27a2958a55(font) {
    return $33d0653e48493c02$export$23ef3ef10b010856(font).stWideCharWidth;
}
function $33d0653e48493c02$export$866cc30a33805630(text, font) {
    return (0, $1fba639b3abe29b0$export$ef5e599365494451).measureText(text, font);
}
function $33d0653e48493c02$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $33d0653e48493c02$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $33d0653e48493c02$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $33d0653e48493c02$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}







var $236df22732ab8ddd$export$97b5e845c7286801 = '__zr_normal__';
var $236df22732ab8ddd$var$PRIMARY_STATES_KEYS = (0, $4640b1300b1537ae$export$98ab6203ec3396e2).concat([
    'ignore'
]);
var $236df22732ab8ddd$var$DEFAULT_ANIMATABLE_MAP = (0, $99026af6cdabc3e1$export$533b26079ad0b4b)((0, $4640b1300b1537ae$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $236df22732ab8ddd$var$tmpTextPosCalcRes = {};
var $236df22732ab8ddd$var$tmpBoundingRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $236df22732ab8ddd$var$tmpInnerTextTrans = [];
var $236df22732ab8ddd$var$Element = function() {
    function Element(props) {
        this.id = (0, $99026af6cdabc3e1$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            var hasPosition = textConfig.position != null;
            var autoOverflowArea = textConfig.autoOverflowArea;
            var layoutRect = void 0;
            if (autoOverflowArea || hasPosition) {
                layoutRect = $236df22732ab8ddd$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
            }
            if (hasPosition) {
                if (this.calculateTextPosition) this.calculateTextPosition($236df22732ab8ddd$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $33d0653e48493c02$export$eee3603b512feab7)($236df22732ab8ddd$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $236df22732ab8ddd$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $236df22732ab8ddd$var$tmpTextPosCalcRes.y;
                textAlign = $236df22732ab8ddd$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $236df22732ab8ddd$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $33d0653e48493c02$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $33d0653e48493c02$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            if (autoOverflowArea) {
                var overflowRect = innerTextDefaultStyle.overflowRect = innerTextDefaultStyle.overflowRect || new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
                innerTransformable.getLocalTransform($236df22732ab8ddd$var$tmpInnerTextTrans);
                (0, $e84a7b06db3848b3$export$6897c284b6f9f4dc)($236df22732ab8ddd$var$tmpInnerTextTrans, $236df22732ab8ddd$var$tmpInnerTextTrans);
                (0, $faa61116fee85ae6$export$2e2bcd8739ae039).copy(overflowRect, layoutRect);
                overflowRect.applyTransform($236df22732ab8ddd$var$tmpInnerTextTrans);
            } else innerTextDefaultStyle.overflowRect = null;
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $3fee4bff41210a9c$export$3c6e95f318c8369b) : (0, $3fee4bff41210a9c$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $9148d8aa0f446713$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $9148d8aa0f446713$export$fac44ee5b035f737)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $99026af6cdabc3e1$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $236df22732ab8ddd$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $236df22732ab8ddd$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($236df22732ab8ddd$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $236df22732ab8ddd$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $99026af6cdabc3e1$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var el = this;
        while(el){
            if (el.silent) return true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return false;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $99026af6cdabc3e1$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $99026af6cdabc3e1$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $99026af6cdabc3e1$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $236df22732ab8ddd$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $236df22732ab8ddd$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $236df22732ab8ddd$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $4640b1300b1537ae$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $e2970c8322c3e197$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $236df22732ab8ddd$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $236df22732ab8ddd$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $236df22732ab8ddd$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = elProto.silent = elProto.ignoreHostSilent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = elProto.__inHover = false;
        elProto.__dirty = (0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function get() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function set(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function get() {
                        return self[xKey];
                    },
                    set: function set(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function get() {
                        return self[yKey];
                    },
                    set: function set(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $99026af6cdabc3e1$export$e36fc9d62a853069)($236df22732ab8ddd$var$Element, (0, $7e07f1848583fc40$export$2e2bcd8739ae039));
(0, $99026af6cdabc3e1$export$e36fc9d62a853069)($236df22732ab8ddd$var$Element, (0, $4640b1300b1537ae$export$2e2bcd8739ae039));
function $236df22732ab8ddd$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $236df22732ab8ddd$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function doneCb() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function abortedCb() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $236df22732ab8ddd$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $236df22732ab8ddd$var$is2DArray(value) {
    return (0, $99026af6cdabc3e1$export$1e2f57719e155213)(value[0]);
}
function $236df22732ab8ddd$var$copyValue(target, source, key) {
    if ((0, $99026af6cdabc3e1$export$1e2f57719e155213)(source[key])) {
        if (!(0, $99026af6cdabc3e1$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $236df22732ab8ddd$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($236df22732ab8ddd$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $236df22732ab8ddd$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $236df22732ab8ddd$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $236df22732ab8ddd$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $99026af6cdabc3e1$export$1e2f57719e155213)(val1) && (0, $99026af6cdabc3e1$export$1e2f57719e155213)(val2) && $236df22732ab8ddd$var$is1DArraySame(val1, val2);
}
function $236df22732ab8ddd$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $236df22732ab8ddd$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(targetVal) && !(0, $99026af6cdabc3e1$export$1e2f57719e155213)(targetVal) && !(0, $99026af6cdabc3e1$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $236df22732ab8ddd$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$236df22732ab8ddd$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $e2970c8322c3e197$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $236df22732ab8ddd$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $e2970c8322c3e197$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $236df22732ab8ddd$export$2e2bcd8739ae039 = $236df22732ab8ddd$var$Element;



var $2b89655bc310a947$var$Group = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $99026af6cdabc3e1$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $99026af6cdabc3e1$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $faa61116fee85ae6$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $236df22732ab8ddd$export$2e2bcd8739ae039));
$2b89655bc310a947$var$Group.prototype.type = 'group';
var $2b89655bc310a947$export$2e2bcd8739ae039 = $2b89655bc310a947$var$Group;


var $b64bfc55c330df69$var$painterCtors = {};
var $b64bfc55c330df69$var$instances = {};
function $b64bfc55c330df69$var$delInstance(id) {
    delete $b64bfc55c330df69$var$instances[id];
}
function $b64bfc55c330df69$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $9148d8aa0f446713$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $3fee4bff41210a9c$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $9148d8aa0f446713$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $3fee4bff41210a9c$export$fd81e7ebc7dae256);
    }
    return false;
}
var $b64bfc55c330df69$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $0c58279aa4affd00$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || 'canvas';
        if (!$b64bfc55c330df69$var$painterCtors[rendererType]) rendererType = $99026af6cdabc3e1$export$ed97f33186d4b816($b64bfc55c330df69$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $b64bfc55c330df69$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $e870be04527b939a$export$2e2bcd8739ae039).node && !(0, $e870be04527b939a$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $0ac8b953ad9305ca$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === 'auto' ? (0, $e870be04527b939a$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $99026af6cdabc3e1$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $c7978fd25ee31f46$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $2b85325ff91a4b8f$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(true);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $b64bfc55c330df69$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (this._disposed) return;
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = (0, $2b85325ff91a4b8f$export$1428f42a7de81803)();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = (0, $2b85325ff91a4b8f$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $2b89655bc310a947$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $b64bfc55c330df69$var$delInstance(this.id);
    };
    return ZRender;
}();
function $b64bfc55c330df69$export$2cd8252107eb640b(dom, opts) {
    var zr = new $b64bfc55c330df69$var$ZRender($99026af6cdabc3e1$export$46e8f25c7328f77e(), dom, opts);
    $b64bfc55c330df69$var$instances[zr.id] = zr;
    return zr;
}
function $b64bfc55c330df69$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $b64bfc55c330df69$export$825f692fb04800ef() {
    for(var key in $b64bfc55c330df69$var$instances)if ($b64bfc55c330df69$var$instances.hasOwnProperty(key)) $b64bfc55c330df69$var$instances[key].dispose();
    $b64bfc55c330df69$var$instances = {};
}
function $b64bfc55c330df69$export$8bedcca5bbd73999(id) {
    return $b64bfc55c330df69$var$instances[id];
}
function $b64bfc55c330df69$export$a3e793ccb11823a5(name, Ctor) {
    $b64bfc55c330df69$var$painterCtors[name] = Ctor;
}
var $b64bfc55c330df69$var$ssrDataGetter;
function $b64bfc55c330df69$export$dd7015a5412ca583(el) {
    if (typeof $b64bfc55c330df69$var$ssrDataGetter === 'function') return $b64bfc55c330df69$var$ssrDataGetter(el);
}
function $b64bfc55c330df69$export$e7a09d7fe68a4f7(getter) {
    $b64bfc55c330df69$var$ssrDataGetter = getter;
}
var $b64bfc55c330df69$export$83d89fbfd8236492 = '6.0.0';






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5f0Cq = parcelRequire("5f0Cq");


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $bfe945a83b4d28b9$var$RADIAN_EPSILON = 1e-4;
// Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $bfe945a83b4d28b9$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $bfe945a83b4d28b9$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
var $bfe945a83b4d28b9$export$e411eeaf23dccbe8 = Math.min;
var $bfe945a83b4d28b9$export$2ca8010d037f830f = Math.max;
var $bfe945a83b4d28b9$export$5860c226b237d9a6 = Math.abs;
function $bfe945a83b4d28b9$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
var $bfe945a83b4d28b9$export$e8514cb5a5e2b40f = $bfe945a83b4d28b9$export$249e1c100b47bcef;
function $bfe945a83b4d28b9$export$249e1c100b47bcef(option, percentBase, percentOffset) {
    switch(option){
        case 'center':
        case 'middle':
            option = '50%';
            break;
        case 'left':
        case 'top':
            option = '0%';
            break;
        case 'right':
        case 'bottom':
            option = '100%';
            break;
    }
    return $bfe945a83b4d28b9$export$6b392db7c2374a1a(option, percentBase, percentOffset);
}
function $bfe945a83b4d28b9$export$6b392db7c2374a1a(option, percentBase, percentOffset) {
    if ($99026af6cdabc3e1$export$844ec244b1367d54(option)) {
        if ($bfe945a83b4d28b9$var$_trim(option).match(/%$/)) return parseFloat(option) / 100 * percentBase + (percentOffset || 0);
        return parseFloat(option);
    }
    // Allow flexible input due to backward compatibility.
    return option == null ? NaN : +option;
}
function $bfe945a83b4d28b9$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) // FIXME: the default precision should not be provided, since there is no universally adaptable
    //  precision. The caller need to input a precision according to the scenarios.
    precision = 10;
    // Avoid range error
    precision = Math.min(Math.max(0, precision), $bfe945a83b4d28b9$var$ROUND_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $bfe945a83b4d28b9$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $bfe945a83b4d28b9$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $bfe945a83b4d28b9$export$6d86ba4ca4984d31(val);
}
function $bfe945a83b4d28b9$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $bfe945a83b4d28b9$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log($bfe945a83b4d28b9$export$5860c226b237d9a6(pixelExtent[1] - pixelExtent[0])) / LN10);
    // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $bfe945a83b4d28b9$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $bfe945a83b4d28b9$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $bfe945a83b4d28b9$export$222dabb13d5320df(valueList, precision) {
    var sum = $99026af6cdabc3e1$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = Math.pow(10, precision);
    var votesPerQuota = $99026af6cdabc3e1$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $99026af6cdabc3e1$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $99026af6cdabc3e1$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $99026af6cdabc3e1$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $99026af6cdabc3e1$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $bfe945a83b4d28b9$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($bfe945a83b4d28b9$export$e0c74b50bbd10f68(val0), $bfe945a83b4d28b9$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $bfe945a83b4d28b9$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $bfe945a83b4d28b9$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $bfe945a83b4d28b9$export$18510406f204a1b9 = 9007199254740991;
function $bfe945a83b4d28b9$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $bfe945a83b4d28b9$export$d1df570aea2868f(val) {
    return val > -$bfe945a83b4d28b9$var$RADIAN_EPSILON && val < $bfe945a83b4d28b9$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $bfe945a83b4d28b9$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $bfe945a83b4d28b9$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($99026af6cdabc3e1$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $bfe945a83b4d28b9$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $bfe945a83b4d28b9$export$82dd68b83a44b253(val) {
    return Math.pow(10, $bfe945a83b4d28b9$export$97256a17b20a0c24(val));
}
function $bfe945a83b4d28b9$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $bfe945a83b4d28b9$export$7a695fe44258210b(val, round) {
    var exponent = $bfe945a83b4d28b9$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $bfe945a83b4d28b9$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $bfe945a83b4d28b9$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $bfe945a83b4d28b9$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$99026af6cdabc3e1$export$844ec244b1367d54(val) || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $bfe945a83b4d28b9$export$e90fb89750dba83f(val) {
    return !isNaN($bfe945a83b4d28b9$export$8b4007b942b45a96(val));
}
function $bfe945a83b4d28b9$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $bfe945a83b4d28b9$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $bfe945a83b4d28b9$export$a368fd580c0d0fe4(b, a % b);
}
function $bfe945a83b4d28b9$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $bfe945a83b4d28b9$export$a368fd580c0d0fe4(a, b);
}



function $08bfa015475effa8$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $08bfa015475effa8$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $08bfa015475effa8$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $08bfa015475effa8$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $08bfa015475effa8$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $08bfa015475effa8$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
];
function $08bfa015475effa8$export$2c944e12edb48d4b(dataItem) {
    return (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dataItem) && !(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $08bfa015475effa8$export$3e1a543f33ef6883(dataItem) {
    return (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $08bfa015475effa8$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $08bfa015475effa8$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $08bfa015475effa8$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $08bfa015475effa8$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $08bfa015475effa8$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $08bfa015475effa8$var$mappingInReplaceAllMode(result, newCmptOptions);
    $08bfa015475effa8$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $08bfa015475effa8$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $08bfa015475effa8$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $08bfa015475effa8$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $08bfa015475effa8$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $99026af6cdabc3e1$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $08bfa015475effa8$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$08bfa015475effa8$export$feece3e7d52a102b(cmptOption) && !$08bfa015475effa8$export$feece3e7d52a102b(existing) && $08bfa015475effa8$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $08bfa015475effa8$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $08bfa015475effa8$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$08bfa015475effa8$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $08bfa015475effa8$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $08bfa015475effa8$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $99026af6cdabc3e1$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $08bfa015475effa8$var$makeComparableKey(opt.name) : existing ? existing.name : $08bfa015475effa8$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $08bfa015475effa8$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $08bfa015475effa8$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $08bfa015475effa8$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $08bfa015475effa8$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $08bfa015475effa8$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $08bfa015475effa8$var$makeComparableKey(val) {
    return $08bfa015475effa8$export$fb1a222ba5dd6e51(val, '');
}
function $08bfa015475effa8$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $99026af6cdabc3e1$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(idOrName) || (0, $99026af6cdabc3e1$export$29d0bb2a4e07b252)(idOrName) ? idOrName + '' : defaultValue;
}
function $08bfa015475effa8$var$warnInvalidateIdOrName(idOrName) {}
function $08bfa015475effa8$var$isValidIdOrName(idOrName) {
    return (0, $99026af6cdabc3e1$export$29d0bb2a4e07b252)(idOrName) || (0, $bfe945a83b4d28b9$export$e90fb89750dba83f)(idOrName);
}
function $08bfa015475effa8$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($08bfa015475effa8$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $08bfa015475effa8$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $08bfa015475effa8$var$makeComparableKey(cmptOption.id).indexOf($08bfa015475effa8$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $08bfa015475effa8$export$1753133c42e665e8(idSuffix) {
    return $08bfa015475effa8$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $08bfa015475effa8$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $08bfa015475effa8$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $08bfa015475effa8$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $08bfa015475effa8$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $08bfa015475effa8$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $08bfa015475effa8$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $08bfa015475effa8$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(payload.name) ? (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $08bfa015475effa8$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $08bfa015475effa8$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $08bfa015475effa8$var$innerUniqueIndex = (0, $bfe945a83b4d28b9$export$474d2ec9aa44a22)();
function $08bfa015475effa8$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $08bfa015475effa8$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $08bfa015475effa8$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $08bfa015475effa8$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illegal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $08bfa015475effa8$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $08bfa015475effa8$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $08bfa015475effa8$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $08bfa015475effa8$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        if (opt.enableNone) {
            result.models = [];
            return result;
        } else indexOption = -1; // Can not query by index but may still query by id/name if specified.
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        if (opt.enableAll) indexOption = idOption = nameOption = null;
        else indexOption = -1;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $08bfa015475effa8$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $08bfa015475effa8$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $08bfa015475effa8$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $e870be04527b939a$export$2e2bcd8739ae039).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $08bfa015475effa8$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $08bfa015475effa8$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(targetValue)) {
        var value = $08bfa015475effa8$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $bfe945a83b4d28b9$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $bfe945a83b4d28b9$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $08bfa015475effa8$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $bfe945a83b4d28b9$export$e0c74b50bbd10f68)(leftVal), (0, $bfe945a83b4d28b9$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}
/**
 * Use an iterator to avoid exposing the internal list or duplicating it
 * for the outside traveller, and no extra heap allocation.
 * @usage
 *  for (const it = resetIterator(); it.next();) {
 *      const item = it.item;
 *      const key = it.key;
 *      const itIdx = it.itIdx;
 *      // ...
 *  }
 * @usage
 *  const it = resetIterator();
 *  while (it.next()) { ... }
 * @usage
 *  for (resetIterator(it); it.next();) { ... }
 */ var $08bfa015475effa8$export$4e38036c4470d56c = /** @class */ function() {
    function ListIterator() {}
    /**
   * The loop condition is `idx < end` if `step > 0`;
   * The loop condition is `idx >= end` if `step < 0`.
   *
   * @param end By default `list.length` if `step > 0`; `0` if `step < 0`.
   * @param step By default `1`.
   */ ListIterator.prototype.reset = function(list, start, end, step) {
        this._list = list;
        this._step = step = step || 1;
        this._idx = start;
        this._end = end != null ? end : step > 0 ? list.length : 0;
        this.item = null;
        this.key = NaN;
        return this;
    };
    ListIterator.prototype.next = function() {
        if (this._step > 0 ? this._idx < this._end : this._idx >= this._end) {
            this.item = this._list[this._idx];
            this.key = this._idx = this._idx + this._step;
            return true;
        }
        return false;
    };
    return ListIterator;
}();
function $08bfa015475effa8$export$be44d6593b016f3e(model) {
    // Clear to avoid memory leak.
    model.option = model.parentModel = model.ecModel = null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5f0Cq = parcelRequire("5f0Cq");

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $cdb9e13510266a6e$var$TYPE_DELIMITER = '.';
var $cdb9e13510266a6e$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $cdb9e13510266a6e$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $cdb9e13510266a6e$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($cdb9e13510266a6e$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $cdb9e13510266a6e$var$checkClassType(componentType) {
    $99026af6cdabc3e1$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $cdb9e13510266a6e$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$cdb9e13510266a6e$var$IS_EXTENDED_CLASS]);
}
function $cdb9e13510266a6e$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($cdb9e13510266a6e$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function ExtendedClass() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $99026af6cdabc3e1$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $99026af6cdabc3e1$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$cdb9e13510266a6e$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $cdb9e13510266a6e$var$superCall;
        ExtendedClass.superApply = $cdb9e13510266a6e$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $cdb9e13510266a6e$var$isESClass(fn) {
    return $99026af6cdabc3e1$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $cdb9e13510266a6e$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $cdb9e13510266a6e$var$classBase = Math.round(Math.random() * 10);
function $cdb9e13510266a6e$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $cdb9e13510266a6e$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $cdb9e13510266a6e$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cdb9e13510266a6e$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cdb9e13510266a6e$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $cdb9e13510266a6e$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $cdb9e13510266a6e$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $cdb9e13510266a6e$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$cdb9e13510266a6e$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $cdb9e13510266a6e$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$cdb9e13510266a6e$var$IS_CONTAINER]) $99026af6cdabc3e1$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $cdb9e13510266a6e$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $cdb9e13510266a6e$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $99026af6cdabc3e1$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $cdb9e13510266a6e$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$cdb9e13510266a6e$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$cdb9e13510266a6e$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$cdb9e13510266a6e$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $9a62b05a77f65632$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $99026af6cdabc3e1$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $99026af6cdabc3e1$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $5128c1babbb42c22$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ]
];
var $5128c1babbb42c22$var$getAreaStyle = (0, $9a62b05a77f65632$export$2e2bcd8739ae039)($5128c1babbb42c22$export$52de6e304d934d85);
var $5128c1babbb42c22$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $5128c1babbb42c22$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ead47d8961005a49$var$globalImageCache = new (0, $66144e99afcfd957$export$2e2bcd8739ae039)(50);
function $ead47d8961005a49$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $ead47d8961005a49$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $ead47d8961005a49$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $ead47d8961005a49$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$ead47d8961005a49$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $1fba639b3abe29b0$export$ef5e599365494451).loadImage(newImageOrSrc, $ead47d8961005a49$var$imageOnLoad, $ead47d8961005a49$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $ead47d8961005a49$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $ead47d8961005a49$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $ead47d8961005a49$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}





var $5a765fd382927af7$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $5a765fd382927af7$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $5a765fd382927af7$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $5a765fd382927af7$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = '';
        out.isTruncated = false;
        return;
    }
    var textLines = (text + '').split('\n');
    options = $5a765fd382927af7$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $5a765fd382927af7$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join('\n');
    out.isTruncated = isTruncated;
}
function $5a765fd382927af7$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, options);
    ellipsis = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(options.minChar, 0);
    var fontMeasureInfo = preparedOpts.fontMeasureInfo = (0, $33d0653e48493c02$export$23ef3ef10b010856)(font);
    var ascCharWidth = fontMeasureInfo.asciiCharWidth;
    preparedOpts.placeholder = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $33d0653e48493c02$export$e6849d91c2a0b61f)(fontMeasureInfo, ellipsis);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $5a765fd382927af7$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var contentWidth = options.contentWidth;
    var fontMeasureInfo = options.fontMeasureInfo;
    if (!containerWidth) {
        out.textLine = '';
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $33d0653e48493c02$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $5a765fd382927af7$var$estimateLength(textLine, contentWidth, fontMeasureInfo) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $33d0653e48493c02$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    }
    if (textLine === '') textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $5a765fd382927af7$var$estimateLength(text, contentWidth, fontMeasureInfo) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++)width += (0, $33d0653e48493c02$export$4e92f5603b5c7bb3)(fontMeasureInfo, text.charCodeAt(i));
    return i;
}
function $5a765fd382927af7$export$5772575e34ef80f9(rawText, style, defaultOuterWidth, defaultOuterHeight) {
    var text = $5a765fd382927af7$var$formatText(rawText);
    var overflow = style.overflow;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var paddingV = padding ? padding[0] + padding[2] : 0;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $33d0653e48493c02$export$56204a27a2958a55)(font);
    var lineHeight = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var isTruncated = false;
    var width = style.width;
    if (width == null && defaultOuterWidth != null) width = defaultOuterWidth - paddingH;
    var height = style.height;
    if (height == null && defaultOuterHeight != null) height = defaultOuterHeight - paddingV;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) lines = text ? $5a765fd382927af7$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    if (height == null) height = contentHeight;
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
        contentHeight = lines.length * lineHeight;
    }
    if (text && truncate && width != null) {
        var options = $5a765fd382927af7$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $5a765fd382927af7$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    var fontMeasureInfo = (0, $33d0653e48493c02$export$23ef3ef10b010856)(font);
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $33d0653e48493c02$export$e6849d91c2a0b61f)(fontMeasureInfo, lines[i]), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = width;
    outerHeight += paddingV;
    outerWidth += paddingH;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $5a765fd382927af7$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $5a765fd382927af7$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $5a765fd382927af7$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $5a765fd382927af7$export$15ec9472ff2d721(rawText, style, defaultOuterWidth, defaultOuterHeight, topTextAlign) {
    var contentBlock = new $5a765fd382927af7$export$ca607d3c98caaf7e();
    var text = $5a765fd382927af7$var$formatText(rawText);
    if (!text) return contentBlock;
    var stlPadding = style.padding;
    var stlPaddingH = stlPadding ? stlPadding[1] + stlPadding[3] : 0;
    var stlPaddingV = stlPadding ? stlPadding[0] + stlPadding[2] : 0;
    var topWidth = style.width;
    if (topWidth == null && defaultOuterWidth != null) topWidth = defaultOuterWidth - stlPaddingH;
    var topHeight = style.height;
    if (topHeight == null && defaultOuterHeight != null) topHeight = defaultOuterHeight - stlPaddingV;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $5a765fd382927af7$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $5a765fd382927af7$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $5a765fd382927af7$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $5a765fd382927af7$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $5a765fd382927af7$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $5a765fd382927af7$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $33d0653e48493c02$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $99026af6cdabc3e1$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || topTextAlign;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $33d0653e48493c02$export$e6849d91c2a0b61f)((0, $33d0653e48493c02$export$23ef3ef10b010856)(font), token.text);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $ead47d8961005a49$export$1b614f30ac2c8867(bgImg);
                        if ($ead47d8961005a49$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        $5a765fd382927af7$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $33d0653e48493c02$export$e6849d91c2a0b61f)((0, $33d0653e48493c02$export$23ef3ef10b010856)(font), token.text);
                    }
                } else token.contentWidth = (0, $33d0653e48493c02$export$e6849d91c2a0b61f)((0, $33d0653e48493c02$export$23ef3ef10b010856)(font), token.text);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    contentBlock.outerWidth += stlPaddingH;
    contentBlock.outerHeight += stlPaddingV;
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $5a765fd382927af7$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $33d0653e48493c02$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $5a765fd382927af7$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    if (!strLines) strLines = str.split('\n');
    var fontMeasureInfo = (0, $33d0653e48493c02$export$23ef3ef10b010856)(font);
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $5a765fd382927af7$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $33d0653e48493c02$export$e6849d91c2a0b61f)(fontMeasureInfo, text);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $5a765fd382927af7$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $5a765fd382927af7$var$RichTextLine([
            token
        ]));
    }
}
function $5a765fd382927af7$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $5a765fd382927af7$var$breakCharMap = (0, $99026af6cdabc3e1$export$533b26079ad0b4b)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $5a765fd382927af7$var$isWordBreakChar(ch) {
    if ($5a765fd382927af7$var$isAlphabeticLetter(ch)) {
        if ($5a765fd382927af7$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $5a765fd382927af7$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    var fontMeasureInfo = (0, $33d0653e48493c02$export$23ef3ef10b010856)(font);
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $33d0653e48493c02$export$4e92f5603b5c7bb3)(fontMeasureInfo, ch.charCodeAt(0));
        var inWord = isBreakAll ? false : !$5a765fd382927af7$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}
function $5a765fd382927af7$export$9a4428591d825b14(out, overflowRect, baseX, baseY, textAlign, textVerticalAlign) {
    out.baseX = baseX;
    out.baseY = baseY;
    out.outerWidth = out.outerHeight = null;
    if (!overflowRect) return;
    var textWidth = overflowRect.width * 2;
    var textHeight = overflowRect.height * 2;
    (0, $faa61116fee85ae6$export$2e2bcd8739ae039).set($5a765fd382927af7$var$tmpCITCTextRect, (0, $33d0653e48493c02$export$eb5a525ef00ef9a4)(baseX, textWidth, textAlign), (0, $33d0653e48493c02$export$bf7d6802d2badd9)(baseY, textHeight, textVerticalAlign), textWidth, textHeight);
    (0, $faa61116fee85ae6$export$2e2bcd8739ae039).intersect(overflowRect, $5a765fd382927af7$var$tmpCITCTextRect, null, $5a765fd382927af7$var$tmpCITCIntersectRectOpt);
    var outIntersectRect = $5a765fd382927af7$var$tmpCITCIntersectRectOpt.outIntersectRect;
    out.outerWidth = outIntersectRect.width;
    out.outerHeight = outIntersectRect.height;
    out.baseX = (0, $33d0653e48493c02$export$eb5a525ef00ef9a4)(outIntersectRect.x, outIntersectRect.width, textAlign, true);
    out.baseY = (0, $33d0653e48493c02$export$bf7d6802d2badd9)(outIntersectRect.y, outIntersectRect.height, textVerticalAlign, true);
}
var $5a765fd382927af7$var$tmpCITCTextRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $5a765fd382927af7$var$tmpCITCIntersectRectOpt = {
    outIntersectRect: {},
    clamp: true
};
function $5a765fd382927af7$var$formatText(text) {
    return text != null ? text += '' : text = '';
}
function $5a765fd382927af7$export$d79289ac0f53b974(style) {
    var text = $5a765fd382927af7$var$formatText(style.text);
    var font = style.font;
    var contentWidth = (0, $33d0653e48493c02$export$e6849d91c2a0b61f)((0, $33d0653e48493c02$export$23ef3ef10b010856)(font), text);
    var contentHeight = (0, $33d0653e48493c02$export$56204a27a2958a55)(font);
    return $5a765fd382927af7$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, null);
}
function $5a765fd382927af7$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, forceLineWidth) {
    var rect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)((0, $33d0653e48493c02$export$eb5a525ef00ef9a4)(style.x || 0, contentWidth, style.textAlign), (0, $33d0653e48493c02$export$bf7d6802d2badd9)(style.y || 0, contentHeight, style.textBaseline), contentWidth, contentHeight);
    var lineWidth = forceLineWidth != null ? forceLineWidth : $5a765fd382927af7$export$c7aae0ffd99a8643(style) ? style.lineWidth : 0;
    if (lineWidth > 0) {
        rect.x -= lineWidth / 2;
        rect.y -= lineWidth / 2;
        rect.width += lineWidth;
        rect.height += lineWidth;
    }
    return rect;
}
function $5a765fd382927af7$export$c7aae0ffd99a8643(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== 'none' && style.lineWidth > 0;
}








var $1ace62598f635263$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $1ace62598f635263$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $1ace62598f635263$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$1ace62598f635263$export$737672163db00fe3[$1ace62598f635263$var$STYLE_MAGIC_KEY] = true;
var $1ace62598f635263$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $1ace62598f635263$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $1ace62598f635263$var$Displayable = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $1ace62598f635263$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths && this.__clipPaths.length) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $faa61116fee85ae6$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $99026af6cdabc3e1$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $8feacd04f2aac739$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $8feacd04f2aac739$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $8feacd04f2aac739$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $99026af6cdabc3e1$export$79c7e160a7743efd)($1ace62598f635263$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$1ace62598f635263$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$1ace62598f635263$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $1ace62598f635263$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $1ace62598f635263$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $1ace62598f635263$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $1ace62598f635263$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $8feacd04f2aac739$export$a7b6db622c6c7dbd) | (0, $8feacd04f2aac739$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $236df22732ab8ddd$export$2e2bcd8739ae039));
var $1ace62598f635263$var$tmpRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $1ace62598f635263$var$viewRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $1ace62598f635263$var$isDisplayableCulled(el, width, height) {
    $1ace62598f635263$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $1ace62598f635263$var$tmpRect.applyTransform(el.transform);
    $1ace62598f635263$var$viewRect.width = width;
    $1ace62598f635263$var$viewRect.height = height;
    return !$1ace62598f635263$var$tmpRect.intersect($1ace62598f635263$var$viewRect);
}
var $1ace62598f635263$export$2e2bcd8739ae039 = $1ace62598f635263$var$Displayable;



var $5f0Cq = parcelRequire("5f0Cq");







var $be54afc435f4ccb0$var$mathMin = Math.min;
var $be54afc435f4ccb0$var$mathMax = Math.max;
var $be54afc435f4ccb0$var$mathSin = Math.sin;
var $be54afc435f4ccb0$var$mathCos = Math.cos;
var $be54afc435f4ccb0$var$PI2 = Math.PI * 2;
var $be54afc435f4ccb0$var$start = $0a1f57488570eee3$export$185802fd694ee1f5();
var $be54afc435f4ccb0$var$end = $0a1f57488570eee3$export$185802fd694ee1f5();
var $be54afc435f4ccb0$var$extremity = $0a1f57488570eee3$export$185802fd694ee1f5();
function $be54afc435f4ccb0$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $be54afc435f4ccb0$var$mathMin(left, p[0]);
        right = $be54afc435f4ccb0$var$mathMax(right, p[0]);
        top = $be54afc435f4ccb0$var$mathMin(top, p[1]);
        bottom = $be54afc435f4ccb0$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $be54afc435f4ccb0$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $be54afc435f4ccb0$var$mathMin(x0, x1);
    min[1] = $be54afc435f4ccb0$var$mathMin(y0, y1);
    max[0] = $be54afc435f4ccb0$var$mathMax(x0, x1);
    max[1] = $be54afc435f4ccb0$var$mathMax(y0, y1);
}
var $be54afc435f4ccb0$var$xDim = [];
var $be54afc435f4ccb0$var$yDim = [];
function $be54afc435f4ccb0$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $196091227dfded05$export$df1a172f100d0457;
    var cubicAt = $196091227dfded05$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $be54afc435f4ccb0$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $be54afc435f4ccb0$var$xDim[i]);
        min[0] = $be54afc435f4ccb0$var$mathMin(x, min[0]);
        max[0] = $be54afc435f4ccb0$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $be54afc435f4ccb0$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $be54afc435f4ccb0$var$yDim[i]);
        min[1] = $be54afc435f4ccb0$var$mathMin(y, min[1]);
        max[1] = $be54afc435f4ccb0$var$mathMax(y, max[1]);
    }
    min[0] = $be54afc435f4ccb0$var$mathMin(x0, min[0]);
    max[0] = $be54afc435f4ccb0$var$mathMax(x0, max[0]);
    min[0] = $be54afc435f4ccb0$var$mathMin(x3, min[0]);
    max[0] = $be54afc435f4ccb0$var$mathMax(x3, max[0]);
    min[1] = $be54afc435f4ccb0$var$mathMin(y0, min[1]);
    max[1] = $be54afc435f4ccb0$var$mathMax(y0, max[1]);
    min[1] = $be54afc435f4ccb0$var$mathMin(y3, min[1]);
    max[1] = $be54afc435f4ccb0$var$mathMax(y3, max[1]);
}
function $be54afc435f4ccb0$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $196091227dfded05$export$752e1f8c6e7f7e11;
    var quadraticAt = $196091227dfded05$export$af17094a950f5073;
    var tx = $be54afc435f4ccb0$var$mathMax($be54afc435f4ccb0$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $be54afc435f4ccb0$var$mathMax($be54afc435f4ccb0$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $be54afc435f4ccb0$var$mathMin(x0, x2, x);
    min[1] = $be54afc435f4ccb0$var$mathMin(y0, y2, y);
    max[0] = $be54afc435f4ccb0$var$mathMax(x0, x2, x);
    max[1] = $be54afc435f4ccb0$var$mathMax(y0, y2, y);
}
function $be54afc435f4ccb0$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $0a1f57488570eee3$export$96ec731ed4dcb222;
    var vec2Max = $0a1f57488570eee3$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $be54afc435f4ccb0$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $be54afc435f4ccb0$var$start[0] = $be54afc435f4ccb0$var$mathCos(startAngle) * rx + x;
    $be54afc435f4ccb0$var$start[1] = $be54afc435f4ccb0$var$mathSin(startAngle) * ry + y;
    $be54afc435f4ccb0$var$end[0] = $be54afc435f4ccb0$var$mathCos(endAngle) * rx + x;
    $be54afc435f4ccb0$var$end[1] = $be54afc435f4ccb0$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $be54afc435f4ccb0$var$start, $be54afc435f4ccb0$var$end);
    vec2Max(max, $be54afc435f4ccb0$var$start, $be54afc435f4ccb0$var$end);
    startAngle = startAngle % $be54afc435f4ccb0$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $be54afc435f4ccb0$var$PI2;
    endAngle = endAngle % $be54afc435f4ccb0$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $be54afc435f4ccb0$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $be54afc435f4ccb0$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $be54afc435f4ccb0$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $be54afc435f4ccb0$var$extremity[0] = $be54afc435f4ccb0$var$mathCos(angle) * rx + x;
        $be54afc435f4ccb0$var$extremity[1] = $be54afc435f4ccb0$var$mathSin(angle) * ry + y;
        vec2Min(min, $be54afc435f4ccb0$var$extremity, min);
        vec2Max(max, $be54afc435f4ccb0$var$extremity, max);
    }
}



var $a1b116230ebefd82$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $a1b116230ebefd82$var$tmpOutX = [];
var $a1b116230ebefd82$var$tmpOutY = [];
var $a1b116230ebefd82$var$min = [];
var $a1b116230ebefd82$var$max = [];
var $a1b116230ebefd82$var$min2 = [];
var $a1b116230ebefd82$var$max2 = [];
var $a1b116230ebefd82$var$mathMin = Math.min;
var $a1b116230ebefd82$var$mathMax = Math.max;
var $a1b116230ebefd82$var$mathCos = Math.cos;
var $a1b116230ebefd82$var$mathSin = Math.sin;
var $a1b116230ebefd82$var$mathAbs = Math.abs;
var $a1b116230ebefd82$var$PI = Math.PI;
var $a1b116230ebefd82$var$PI2 = $a1b116230ebefd82$var$PI * 2;
var $a1b116230ebefd82$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $a1b116230ebefd82$var$tmpAngles = [];
function $a1b116230ebefd82$var$modPI2(radian) {
    var n = Math.round(radian / $a1b116230ebefd82$var$PI * 1e8) / 1e8;
    return n % 2 * $a1b116230ebefd82$var$PI;
}
function $a1b116230ebefd82$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $a1b116230ebefd82$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $a1b116230ebefd82$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $a1b116230ebefd82$var$PI2) newEndAngle = newStartAngle + $a1b116230ebefd82$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $a1b116230ebefd82$var$PI2) newEndAngle = newStartAngle - $a1b116230ebefd82$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($a1b116230ebefd82$var$PI2 - $a1b116230ebefd82$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($a1b116230ebefd82$var$PI2 - $a1b116230ebefd82$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $a1b116230ebefd82$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $a1b116230ebefd82$var$mathAbs(segmentIgnoreThreshold / (0, $3fee4bff41210a9c$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $a1b116230ebefd82$var$mathAbs(segmentIgnoreThreshold / (0, $3fee4bff41210a9c$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($a1b116230ebefd82$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $a1b116230ebefd82$var$mathAbs(x - this._xi);
        var dy = $a1b116230ebefd82$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($a1b116230ebefd82$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($a1b116230ebefd82$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($a1b116230ebefd82$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $a1b116230ebefd82$var$tmpAngles[0] = startAngle;
        $a1b116230ebefd82$var$tmpAngles[1] = endAngle;
        $a1b116230ebefd82$export$bc668021e937022a($a1b116230ebefd82$var$tmpAngles, anticlockwise);
        startAngle = $a1b116230ebefd82$var$tmpAngles[0];
        endAngle = $a1b116230ebefd82$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($a1b116230ebefd82$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $a1b116230ebefd82$var$mathCos(endAngle) * r + cx;
        this._yi = $a1b116230ebefd82$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($a1b116230ebefd82$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($a1b116230ebefd82$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        if (!this._saveData) return;
        var len = data.length;
        if (!(this.data && this.data.length === len) && $a1b116230ebefd82$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!this._saveData) return;
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        var oldData = this.data;
        if ($a1b116230ebefd82$var$hasTypedArray && (oldData instanceof Float32Array || !oldData)) {
            this.data = new Float32Array(offset + appendSize);
            if (offset > 0 && oldData) for(var k = 0; k < offset; k++)this.data[k] = oldData[k];
        }
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($a1b116230ebefd82$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $a1b116230ebefd82$var$min[0] = $a1b116230ebefd82$var$min[1] = $a1b116230ebefd82$var$min2[0] = $a1b116230ebefd82$var$min2[1] = Number.MAX_VALUE;
        $a1b116230ebefd82$var$max[0] = $a1b116230ebefd82$var$max[1] = $a1b116230ebefd82$var$max2[0] = $a1b116230ebefd82$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $a1b116230ebefd82$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $a1b116230ebefd82$var$min2[0] = x0;
                    $a1b116230ebefd82$var$min2[1] = y0;
                    $a1b116230ebefd82$var$max2[0] = x0;
                    $a1b116230ebefd82$var$max2[1] = y0;
                    break;
                case $a1b116230ebefd82$var$CMD.L:
                    (0, $be54afc435f4ccb0$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $a1b116230ebefd82$var$min2, $a1b116230ebefd82$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $a1b116230ebefd82$var$CMD.C:
                    (0, $be54afc435f4ccb0$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $a1b116230ebefd82$var$min2, $a1b116230ebefd82$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $a1b116230ebefd82$var$CMD.Q:
                    (0, $be54afc435f4ccb0$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $a1b116230ebefd82$var$min2, $a1b116230ebefd82$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $a1b116230ebefd82$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $a1b116230ebefd82$var$mathCos(startAngle) * rx + cx;
                        y0 = $a1b116230ebefd82$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $be54afc435f4ccb0$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $a1b116230ebefd82$var$min2, $a1b116230ebefd82$var$max2);
                    xi = $a1b116230ebefd82$var$mathCos(endAngle) * rx + cx;
                    yi = $a1b116230ebefd82$var$mathSin(endAngle) * ry + cy;
                    break;
                case $a1b116230ebefd82$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $be54afc435f4ccb0$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $a1b116230ebefd82$var$min2, $a1b116230ebefd82$var$max2);
                    break;
                case $a1b116230ebefd82$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $0a1f57488570eee3$export$96ec731ed4dcb222($a1b116230ebefd82$var$min, $a1b116230ebefd82$var$min, $a1b116230ebefd82$var$min2);
            $0a1f57488570eee3$export$8960430cfd85939f($a1b116230ebefd82$var$max, $a1b116230ebefd82$var$max, $a1b116230ebefd82$var$max2);
        }
        if (i === 0) $a1b116230ebefd82$var$min[0] = $a1b116230ebefd82$var$min[1] = $a1b116230ebefd82$var$max[0] = $a1b116230ebefd82$var$max[1] = 0;
        return new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)($a1b116230ebefd82$var$min[0], $a1b116230ebefd82$var$min[1], $a1b116230ebefd82$var$max[0] - $a1b116230ebefd82$var$min[0], $a1b116230ebefd82$var$max[1] - $a1b116230ebefd82$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $a1b116230ebefd82$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $a1b116230ebefd82$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($a1b116230ebefd82$var$mathAbs(dx) > ux || $a1b116230ebefd82$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $a1b116230ebefd82$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $196091227dfded05$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $a1b116230ebefd82$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $196091227dfded05$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $a1b116230ebefd82$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $a1b116230ebefd82$var$mathCos(startAngle) * rx + cx;
                        y0 = $a1b116230ebefd82$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $a1b116230ebefd82$var$mathMax(rx, ry) * $a1b116230ebefd82$var$mathMin($a1b116230ebefd82$var$PI2, Math.abs(delta));
                    xi = $a1b116230ebefd82$var$mathCos(endAngle) * rx + cx;
                    yi = $a1b116230ebefd82$var$mathSin(endAngle) * ry + cy;
                    break;
                case $a1b116230ebefd82$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $a1b116230ebefd82$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $a1b116230ebefd82$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $a1b116230ebefd82$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $a1b116230ebefd82$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $a1b116230ebefd82$var$mathAbs(x - xi);
                    var dy = $a1b116230ebefd82$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $a1b116230ebefd82$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $196091227dfded05$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $a1b116230ebefd82$var$tmpOutX);
                            (0, $196091227dfded05$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $a1b116230ebefd82$var$tmpOutY);
                            ctx.bezierCurveTo($a1b116230ebefd82$var$tmpOutX[1], $a1b116230ebefd82$var$tmpOutY[1], $a1b116230ebefd82$var$tmpOutX[2], $a1b116230ebefd82$var$tmpOutY[2], $a1b116230ebefd82$var$tmpOutX[3], $a1b116230ebefd82$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $a1b116230ebefd82$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $196091227dfded05$export$117c659e21a7a060)(xi, x1, x2, t, $a1b116230ebefd82$var$tmpOutX);
                            (0, $196091227dfded05$export$117c659e21a7a060)(yi, y1, y2, t, $a1b116230ebefd82$var$tmpOutY);
                            ctx.quadraticCurveTo($a1b116230ebefd82$var$tmpOutX[1], $a1b116230ebefd82$var$tmpOutY[1], $a1b116230ebefd82$var$tmpOutX[2], $a1b116230ebefd82$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $a1b116230ebefd82$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $a1b116230ebefd82$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $a1b116230ebefd82$var$mathCos(startAngle) * rx + cx;
                        y0 = $a1b116230ebefd82$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $a1b116230ebefd82$var$mathCos(endAngle) * rx + cx;
                    yi = $a1b116230ebefd82$var$mathSin(endAngle) * ry + cy;
                    break;
                case $a1b116230ebefd82$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $a1b116230ebefd82$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $a1b116230ebefd82$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $a1b116230ebefd82$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $a1b116230ebefd82$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $a1b116230ebefd82$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.prototype.canSave = function() {
        return !!this._saveData;
    };
    PathProxy.CMD = $a1b116230ebefd82$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $a1b116230ebefd82$export$2e2bcd8739ae039 = $a1b116230ebefd82$var$PathProxy;



function $570158b31475eafd$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $c6e2e6239e1f72cc$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $196091227dfded05$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $8bf1970e7b94439a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $196091227dfded05$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $15d9e37daabdcd8b$var$PI2 = Math.PI * 2;
function $15d9e37daabdcd8b$export$d44861331f213635(angle) {
    angle %= $15d9e37daabdcd8b$var$PI2;
    if (angle < 0) angle += $15d9e37daabdcd8b$var$PI2;
    return angle;
}


var $2209fe859a4c7742$var$PI2 = Math.PI * 2;
function $2209fe859a4c7742$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $2209fe859a4c7742$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(endAngle);
        endAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(startAngle);
        endAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $2209fe859a4c7742$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $2209fe859a4c7742$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $2209fe859a4c7742$var$PI2 >= startAngle && angle + $2209fe859a4c7742$var$PI2 <= endAngle;
}



function $15b9d442b107cd2e$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $0057205d1626cae7$var$CMD = (0, $a1b116230ebefd82$export$2e2bcd8739ae039).CMD;
var $0057205d1626cae7$var$PI2 = Math.PI * 2;
var $0057205d1626cae7$var$EPSILON = 1e-4;
function $0057205d1626cae7$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $0057205d1626cae7$var$EPSILON;
}
var $0057205d1626cae7$var$roots = [
    -1,
    -1,
    -1
];
var $0057205d1626cae7$var$extrema = [
    -1,
    -1
];
function $0057205d1626cae7$var$swapExtrema() {
    var tmp = $0057205d1626cae7$var$extrema[0];
    $0057205d1626cae7$var$extrema[0] = $0057205d1626cae7$var$extrema[1];
    $0057205d1626cae7$var$extrema[1] = tmp;
}
function $0057205d1626cae7$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $196091227dfded05$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $0057205d1626cae7$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $0057205d1626cae7$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $196091227dfded05$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $196091227dfded05$export$df1a172f100d0457(y0, y1, y2, y3, $0057205d1626cae7$var$extrema);
                if ($0057205d1626cae7$var$extrema[1] < $0057205d1626cae7$var$extrema[0] && nExtrema > 1) $0057205d1626cae7$var$swapExtrema();
                y0_ = $196091227dfded05$export$547c21de482bbcb2(y0, y1, y2, y3, $0057205d1626cae7$var$extrema[0]);
                if (nExtrema > 1) y1_ = $196091227dfded05$export$547c21de482bbcb2(y0, y1, y2, y3, $0057205d1626cae7$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $0057205d1626cae7$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $0057205d1626cae7$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $0057205d1626cae7$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $0057205d1626cae7$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $196091227dfded05$export$fd895ac7ee764967(y0, y1, y2, y, $0057205d1626cae7$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $196091227dfded05$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $196091227dfded05$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $0057205d1626cae7$var$roots[i] === 0 || $0057205d1626cae7$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $196091227dfded05$export$af17094a950f5073(x0, x1, x2, $0057205d1626cae7$var$roots[i]);
                if (x_ < x) continue;
                if ($0057205d1626cae7$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $0057205d1626cae7$var$roots[0] === 0 || $0057205d1626cae7$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $196091227dfded05$export$af17094a950f5073(x0, x1, x2, $0057205d1626cae7$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $0057205d1626cae7$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $0057205d1626cae7$var$roots[0] = -tmp;
    $0057205d1626cae7$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $0057205d1626cae7$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $0057205d1626cae7$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $0057205d1626cae7$var$roots[0] + cx && x <= $0057205d1626cae7$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $0057205d1626cae7$var$PI2;
        endAngle += $0057205d1626cae7$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $0057205d1626cae7$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $0057205d1626cae7$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $0057205d1626cae7$var$PI2 >= startAngle && angle + $0057205d1626cae7$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $0057205d1626cae7$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $0057205d1626cae7$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $15b9d442b107cd2e$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $0057205d1626cae7$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $0057205d1626cae7$var$CMD.L:
                if (isStroke) {
                    if ($570158b31475eafd$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $15b9d442b107cd2e$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $0057205d1626cae7$var$CMD.C:
                if (isStroke) {
                    if ($c6e2e6239e1f72cc$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $0057205d1626cae7$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $0057205d1626cae7$var$CMD.Q:
                if (isStroke) {
                    if ($8bf1970e7b94439a$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $0057205d1626cae7$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $0057205d1626cae7$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $15b9d442b107cd2e$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($2209fe859a4c7742$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $0057205d1626cae7$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $0057205d1626cae7$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($570158b31475eafd$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $570158b31475eafd$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $570158b31475eafd$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $570158b31475eafd$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $15b9d442b107cd2e$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $15b9d442b107cd2e$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $0057205d1626cae7$var$CMD.Z:
                if (isStroke) {
                    if ($570158b31475eafd$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $15b9d442b107cd2e$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$0057205d1626cae7$var$isAroundEqual(yi, y0)) w += (0, $15b9d442b107cd2e$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $0057205d1626cae7$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $0057205d1626cae7$var$containPath(pathProxy, 0, false, x, y);
}
function $0057205d1626cae7$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $0057205d1626cae7$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $d730b349402dd5f7$export$deade517576e293a = (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $1ace62598f635263$export$737672163db00fe3));
var $d730b349402dd5f7$export$71bb6c3c6862c6a5 = {
    style: (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $1ace62598f635263$export$9908943fb57fbe51).style)
};
var $d730b349402dd5f7$var$pathCopyParams = (0, $4640b1300b1537ae$export$98ab6203ec3396e2).concat([
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
]);
var $d730b349402dd5f7$var$Path = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $d730b349402dd5f7$var$pathCopyParams.length; ++i)decalEl[$d730b349402dd5f7$var$pathCopyParams[i]] = this[$d730b349402dd5f7$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $99026af6cdabc3e1$export$8b58be045bf06082)(this.style, value);
            } else if (key === 'shape') (0, $99026af6cdabc3e1$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $9148d8aa0f446713$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $3fee4bff41210a9c$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $3fee4bff41210a9c$export$27682248795c3c6b;
                return 0, $3fee4bff41210a9c$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $3fee4bff41210a9c$export$3c6e95f318c8369b;
        }
        return 0, $3fee4bff41210a9c$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $9148d8aa0f446713$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $3fee4bff41210a9c$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $8feacd04f2aac739$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $a1b116230ebefd82$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $8feacd04f2aac739$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($0057205d1626cae7$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $0057205d1626cae7$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $8feacd04f2aac739$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $99026af6cdabc3e1$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $8feacd04f2aac739$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $99026af6cdabc3e1$export$79c7e160a7743efd)($d730b349402dd5f7$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $99026af6cdabc3e1$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $99026af6cdabc3e1$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if ((0, $5f0Cq._)(targetShape[key]) === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $d730b349402dd5f7$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $8feacd04f2aac739$export$a7b6db622c6c7dbd) | (0, $8feacd04f2aac739$export$ada8b2beb3d76671) | (0, $8feacd04f2aac739$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $1ace62598f635263$export$2e2bcd8739ae039));
var $d730b349402dd5f7$export$2e2bcd8739ae039 = $d730b349402dd5f7$var$Path;





var $b4b666d0d13b3e95$export$5fbb6d98091bcb56 = (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $1fba639b3abe29b0$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $d730b349402dd5f7$export$deade517576e293a));
var $b4b666d0d13b3e95$var$TSpan = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        return (0, $5a765fd382927af7$export$c7aae0ffd99a8643)(this.style);
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $99026af6cdabc3e1$export$79c7e160a7743efd)($b4b666d0d13b3e95$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        if (!this._rect) this._rect = (0, $5a765fd382927af7$export$d79289ac0f53b974)(this.style);
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $1ace62598f635263$export$2e2bcd8739ae039));
$b4b666d0d13b3e95$var$TSpan.prototype.type = 'tspan';
var $b4b666d0d13b3e95$export$2e2bcd8739ae039 = $b4b666d0d13b3e95$var$TSpan;








var $a3b3990206d5aa78$export$8993f922aeeac642 = (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $1ace62598f635263$export$737672163db00fe3));
var $a3b3990206d5aa78$export$4aba8ad70847a488 = {
    style: (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $1ace62598f635263$export$9908943fb57fbe51).style)
};
function $a3b3990206d5aa78$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $a3b3990206d5aa78$var$ZRImage = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $99026af6cdabc3e1$export$79c7e160a7743efd)($a3b3990206d5aa78$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $a3b3990206d5aa78$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $a3b3990206d5aa78$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $1ace62598f635263$export$2e2bcd8739ae039));
$a3b3990206d5aa78$var$ZRImage.prototype.type = 'image';
var $a3b3990206d5aa78$export$2e2bcd8739ae039 = $a3b3990206d5aa78$var$ZRImage;




function $8890f25bb1d58313$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}


var $b1bff4e255524a7b$var$round = Math.round;
function $b1bff4e255524a7b$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($b1bff4e255524a7b$var$round(x1 * 2) === $b1bff4e255524a7b$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $b1bff4e255524a7b$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($b1bff4e255524a7b$var$round(y1 * 2) === $b1bff4e255524a7b$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $b1bff4e255524a7b$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $b1bff4e255524a7b$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $b1bff4e255524a7b$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $b1bff4e255524a7b$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($b1bff4e255524a7b$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($b1bff4e255524a7b$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $b1bff4e255524a7b$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $b1bff4e255524a7b$var$round(position * 2);
    return (doubledPosition + $b1bff4e255524a7b$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $aed3569651b5e3fa$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $aed3569651b5e3fa$var$subPixelOptimizeOutputShape = {};
var $aed3569651b5e3fa$var$Rect = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $aed3569651b5e3fa$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $b1bff4e255524a7b$export$60e2aa74957d0b9d)($aed3569651b5e3fa$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $8890f25bb1d58313$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$aed3569651b5e3fa$var$Rect.prototype.type = 'rect';
var $aed3569651b5e3fa$export$2e2bcd8739ae039 = $aed3569651b5e3fa$var$Rect;





var $97dfecd189304201$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $97dfecd189304201$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $97dfecd189304201$var$tmpCITOverflowAreaOut = {};
var $97dfecd189304201$export$21aaaa0607ee0e2b = {
    style: (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $1ace62598f635263$export$9908943fb57fbe51).style)
};
var $97dfecd189304201$var$ZRText = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $97dfecd189304201$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $97dfecd189304201$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $97dfecd189304201$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $99026af6cdabc3e1$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $97dfecd189304201$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $1fba639b3abe29b0$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        (0, $5a765fd382927af7$export$9a4428591d825b14)($97dfecd189304201$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $97dfecd189304201$var$tmpCITOverflowAreaOut.baseX;
        baseY = $97dfecd189304201$var$tmpCITOverflowAreaOut.baseY;
        var text = $97dfecd189304201$var$getStyleText(style);
        var contentBlock = (0, $5a765fd382927af7$export$5772575e34ef80f9)(text, style, $97dfecd189304201$var$tmpCITOverflowAreaOut.outerWidth, $97dfecd189304201$var$tmpCITOverflowAreaOut.outerHeight);
        var needDrawBg = $97dfecd189304201$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        this.isTruncated = !!contentBlock.isTruncated;
        var textX = baseX;
        var textY = (0, $33d0653e48493c02$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $33d0653e48493c02$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $33d0653e48493c02$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $97dfecd189304201$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var useDefaultFill = false;
        var textFill = $97dfecd189304201$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $97dfecd189304201$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $97dfecd189304201$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $b4b666d0d13b3e95$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $97dfecd189304201$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            el.setBoundingRect((0, $5a765fd382927af7$export$bd5d12d7bf7c9027)(subElStyle, contentBlock.contentWidth, contentBlock.calculatedLineHeight, usingDefaultStroke ? 0 : null));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        (0, $5a765fd382927af7$export$9a4428591d825b14)($97dfecd189304201$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $97dfecd189304201$var$tmpCITOverflowAreaOut.baseX;
        baseY = $97dfecd189304201$var$tmpCITOverflowAreaOut.baseY;
        var text = $97dfecd189304201$var$getStyleText(style);
        var contentBlock = (0, $5a765fd382927af7$export$15ec9472ff2d721)(text, style, $97dfecd189304201$var$tmpCITOverflowAreaOut.outerWidth, $97dfecd189304201$var$tmpCITOverflowAreaOut.outerHeight, textAlign);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $33d0653e48493c02$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $33d0653e48493c02$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($97dfecd189304201$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $97dfecd189304201$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $97dfecd189304201$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $b4b666d0d13b3e95$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var textFill = $97dfecd189304201$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $97dfecd189304201$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $97dfecd189304201$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $1fba639b3abe29b0$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $99026af6cdabc3e1$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $97dfecd189304201$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $99026af6cdabc3e1$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        el.setBoundingRect((0, $5a765fd382927af7$export$bd5d12d7bf7c9027)(subElStyle, token.contentWidth, token.contentHeight, usingDefaultStroke ? 0 : null));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $aed3569651b5e3fa$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $a3b3990206d5aa78$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $99026af6cdabc3e1$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if ($97dfecd189304201$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $97dfecd189304201$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || 'sans-serif'
        ].join(' ');
        return font && (0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $1ace62598f635263$export$2e2bcd8739ae039));
var $97dfecd189304201$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $97dfecd189304201$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $97dfecd189304201$var$FONT_PARTS = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily'
];
function $97dfecd189304201$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === 'string' && (fontSize.indexOf('px') !== -1 || fontSize.indexOf('rem') !== -1 || fontSize.indexOf('em') !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + 'px';
    else return (0, $1fba639b3abe29b0$export$b1461457ea2c1179) + 'px';
}
function $97dfecd189304201$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $97dfecd189304201$var$FONT_PARTS.length; i++){
        var fontProp = $97dfecd189304201$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $97dfecd189304201$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $97dfecd189304201$export$176336068cc5371f(style) {
    $97dfecd189304201$var$normalizeStyle(style);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(style.rich, $97dfecd189304201$var$normalizeStyle);
    return style;
}
function $97dfecd189304201$var$normalizeStyle(style) {
    if (style) {
        style.font = $97dfecd189304201$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $97dfecd189304201$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $97dfecd189304201$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $99026af6cdabc3e1$export$f3a38102c49f4268)(style.padding);
    }
}
function $97dfecd189304201$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $97dfecd189304201$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $97dfecd189304201$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $97dfecd189304201$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $97dfecd189304201$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $97dfecd189304201$export$2e2bcd8739ae039 = $97dfecd189304201$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2 = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $f10cebeaa5f49a40$export$30d6736ebb8e18d5 = function setCommonECData(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = 'chart';
        // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = 'chart';
        });
    }
};






// Reserve 0 as default.
var $ea1f7a1fbd33fd2d$var$_highlightNextDigit = 1;
var $ea1f7a1fbd33fd2d$var$_highlightKeyMap = {};
var $ea1f7a1fbd33fd2d$var$getSavedStates = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $ea1f7a1fbd33fd2d$var$getComponentStates = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $ea1f7a1fbd33fd2d$export$5542daa30722333e = 0;
var $ea1f7a1fbd33fd2d$export$1307d6a87d56baa = 1;
var $ea1f7a1fbd33fd2d$export$f0f2bee145debb31 = 2;
var $ea1f7a1fbd33fd2d$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $ea1f7a1fbd33fd2d$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $ea1f7a1fbd33fd2d$export$1cb9fc6ed5b9836c = 10;
var $ea1f7a1fbd33fd2d$export$3a2f97d39514bbc = 9;
var $ea1f7a1fbd33fd2d$export$df035d873a9de64f = 'highlight';
var $ea1f7a1fbd33fd2d$export$f8a2f7807cc185ea = 'downplay';
var $ea1f7a1fbd33fd2d$export$89616263e7d38fe9 = 'select';
var $ea1f7a1fbd33fd2d$export$7636ad95c0f68a79 = 'unselect';
var $ea1f7a1fbd33fd2d$export$1e90ed8a25542516 = 'toggleSelect';
var $ea1f7a1fbd33fd2d$export$67f8c62bcdfbd39f = 'selectchanged';
function $ea1f7a1fbd33fd2d$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
}
function $ea1f7a1fbd33fd2d$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $ea1f7a1fbd33fd2d$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $ea1f7a1fbd33fd2d$var$doChangeHoverState(el, 'emphasis', $ea1f7a1fbd33fd2d$export$f0f2bee145debb31);
}
function $ea1f7a1fbd33fd2d$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $ea1f7a1fbd33fd2d$export$f0f2bee145debb31) $ea1f7a1fbd33fd2d$var$doChangeHoverState(el, 'normal', $ea1f7a1fbd33fd2d$export$5542daa30722333e);
}
function $ea1f7a1fbd33fd2d$var$singleEnterBlur(el) {
    $ea1f7a1fbd33fd2d$var$doChangeHoverState(el, 'blur', $ea1f7a1fbd33fd2d$export$1307d6a87d56baa);
}
function $ea1f7a1fbd33fd2d$var$singleLeaveBlur(el) {
    if (el.hoverState === $ea1f7a1fbd33fd2d$export$1307d6a87d56baa) $ea1f7a1fbd33fd2d$var$doChangeHoverState(el, 'normal', $ea1f7a1fbd33fd2d$export$5542daa30722333e);
}
function $ea1f7a1fbd33fd2d$var$singleEnterSelect(el) {
    el.selected = true;
}
function $ea1f7a1fbd33fd2d$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $ea1f7a1fbd33fd2d$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, updater, commonParam) {
    $ea1f7a1fbd33fd2d$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $ea1f7a1fbd33fd2d$var$updateElementState(child, updater, commonParam);
    });
}
function $ea1f7a1fbd33fd2d$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $ea1f7a1fbd33fd2d$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $ea1f7a1fbd33fd2d$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $ea1f7a1fbd33fd2d$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $ea1f7a1fbd33fd2d$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $ea1f7a1fbd33fd2d$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveTo(fromState, props);
    }
    return fromState;
}
function $ea1f7a1fbd33fd2d$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $d730b349402dd5f7$export$2e2bcd8739ae039)) {
        var store = $ea1f7a1fbd33fd2d$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($ea1f7a1fbd33fd2d$var$hasFillOrStroke(fromFill) || $ea1f7a1fbd33fd2d$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$ea1f7a1fbd33fd2d$var$hasFillOrStroke(emphasisStyle.fill) && $ea1f7a1fbd33fd2d$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $9148d8aa0f446713$export$2b47e247dfb87a73)(fromFill);
            } else if (!$ea1f7a1fbd33fd2d$var$hasFillOrStroke(emphasisStyle.stroke) && $ea1f7a1fbd33fd2d$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $9148d8aa0f446713$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $ea1f7a1fbd33fd2d$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $ea1f7a1fbd33fd2d$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $ea1f7a1fbd33fd2d$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $ea1f7a1fbd33fd2d$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $ea1f7a1fbd33fd2d$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $ea1f7a1fbd33fd2d$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $ea1f7a1fbd33fd2d$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $ea1f7a1fbd33fd2d$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $ea1f7a1fbd33fd2d$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $ea1f7a1fbd33fd2d$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $ea1f7a1fbd33fd2d$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $ea1f7a1fbd33fd2d$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $ea1f7a1fbd33fd2d$var$elementStateProxy;
}
function $ea1f7a1fbd33fd2d$export$d899507e2598e4ae(el, e) {
    !$ea1f7a1fbd33fd2d$var$shouldSilent(el, e) && !el.__highByOuter && $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleEnterEmphasis);
}
function $ea1f7a1fbd33fd2d$export$784cba1f7fe58cca(el, e) {
    !$ea1f7a1fbd33fd2d$var$shouldSilent(el, e) && !el.__highByOuter && $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleLeaveEmphasis);
}
function $ea1f7a1fbd33fd2d$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleEnterEmphasis);
}
function $ea1f7a1fbd33fd2d$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleLeaveEmphasis);
}
function $ea1f7a1fbd33fd2d$export$207f9cb3e1099375(el) {
    $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleEnterBlur);
}
function $ea1f7a1fbd33fd2d$export$fd4a9ec75456d3c1(el) {
    $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleLeaveBlur);
}
function $ea1f7a1fbd33fd2d$export$252d028dda8ef765(el) {
    $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleEnterSelect);
}
function $ea1f7a1fbd33fd2d$export$ea9a904bd6e32bd3(el) {
    $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$var$singleLeaveSelect);
}
function $ea1f7a1fbd33fd2d$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $ea1f7a1fbd33fd2d$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $ea1f7a1fbd33fd2d$var$getComponentStates(componentModel);
        var isSeries = componentType === 'series';
        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $ea1f7a1fbd33fd2d$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $ea1f7a1fbd33fd2d$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $ea1f7a1fbd33fd2d$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === 'self') return;
                $ea1f7a1fbd33fd2d$var$singleEnterBlur(child);
            });
            if ((0, $99026af6cdabc3e1$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $ea1f7a1fbd33fd2d$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $ea1f7a1fbd33fd2d$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $ea1f7a1fbd33fd2d$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $ea1f7a1fbd33fd2d$var$singleEnterBlur(child);
    });
}
function $ea1f7a1fbd33fd2d$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $08bfa015475effa8$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el);
        $ea1f7a1fbd33fd2d$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $ea1f7a1fbd33fd2d$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $ea1f7a1fbd33fd2d$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $ea1f7a1fbd33fd2d$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $ea1f7a1fbd33fd2d$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $ea1f7a1fbd33fd2d$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $ea1f7a1fbd33fd2d$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $ea1f7a1fbd33fd2d$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $ea1f7a1fbd33fd2d$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $ea1f7a1fbd33fd2d$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $ea1f7a1fbd33fd2d$export$bb1c7b62436282a(dispatcher, e, api) {
    $ea1f7a1fbd33fd2d$export$b2a593c7b5243584(api);
    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $ea1f7a1fbd33fd2d$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $ea1f7a1fbd33fd2d$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $ea1f7a1fbd33fd2d$export$784cba1f7fe58cca(dispatcher, e);
}
function $ea1f7a1fbd33fd2d$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$ea1f7a1fbd33fd2d$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $08bfa015475effa8$export$42b26cae8b8d10)(data, payload);
    if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $ea1f7a1fbd33fd2d$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $ea1f7a1fbd33fd2d$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $ea1f7a1fbd33fd2d$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $ea1f7a1fbd33fd2d$export$252d028dda8ef765(el) : $ea1f7a1fbd33fd2d$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $ea1f7a1fbd33fd2d$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $ea1f7a1fbd33fd2d$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $ea1f7a1fbd33fd2d$export$9ba15aea1e048d48(el, true);
    $ea1f7a1fbd33fd2d$var$traverseUpdateState(el, $ea1f7a1fbd33fd2d$export$20f39bbe322fb9ab);
    $ea1f7a1fbd33fd2d$export$24972466b2b62ac2(el, focus, blurScope);
}
function $ea1f7a1fbd33fd2d$export$912cae7b47c8e437(el) {
    $ea1f7a1fbd33fd2d$export$9ba15aea1e048d48(el, false);
}
function $ea1f7a1fbd33fd2d$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $ea1f7a1fbd33fd2d$export$912cae7b47c8e437(el) : $ea1f7a1fbd33fd2d$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $ea1f7a1fbd33fd2d$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $ea1f7a1fbd33fd2d$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $ea1f7a1fbd33fd2d$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $ea1f7a1fbd33fd2d$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $ea1f7a1fbd33fd2d$var$OTHER_STATES.length; i++){
        var stateName = $ea1f7a1fbd33fd2d$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$ea1f7a1fbd33fd2d$var$defaultStyleGetterMap[styleType]]();
    }
}
function $ea1f7a1fbd33fd2d$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $ea1f7a1fbd33fd2d$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $ea1f7a1fbd33fd2d$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $ea1f7a1fbd33fd2d$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $ea1f7a1fbd33fd2d$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $ea1f7a1fbd33fd2d$var$_highlightNextDigit <= 32) highlightDigit = $ea1f7a1fbd33fd2d$var$_highlightKeyMap[highlightKey] = $ea1f7a1fbd33fd2d$var$_highlightNextDigit++;
    return highlightDigit;
}
function $ea1f7a1fbd33fd2d$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $ea1f7a1fbd33fd2d$export$89616263e7d38fe9 || payloadType === $ea1f7a1fbd33fd2d$export$7636ad95c0f68a79 || payloadType === $ea1f7a1fbd33fd2d$export$1e90ed8a25542516;
}
function $ea1f7a1fbd33fd2d$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $ea1f7a1fbd33fd2d$export$df035d873a9de64f || payloadType === $ea1f7a1fbd33fd2d$export$f8a2f7807cc185ea;
}
function $ea1f7a1fbd33fd2d$export$9fe78019e6f395b6(el) {
    var store = $ea1f7a1fbd33fd2d$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $821b3c1b9ddcee3a$export$ae7433df314f6ec3 = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
function $821b3c1b9ddcee3a$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $821b3c1b9ddcee3a$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'leave';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('leave');
    var animationConfig = $821b3c1b9ddcee3a$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $821b3c1b9ddcee3a$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $821b3c1b9ddcee3a$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $821b3c1b9ddcee3a$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $821b3c1b9ddcee3a$var$animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
function $821b3c1b9ddcee3a$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'leave') return true;
    }
    return false;
}
function $821b3c1b9ddcee3a$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($821b3c1b9ddcee3a$export$5b89d4b643713034(el)) return;
    $821b3c1b9ddcee3a$var$animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}
function $821b3c1b9ddcee3a$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $821b3c1b9ddcee3a$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $821b3c1b9ddcee3a$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $821b3c1b9ddcee3a$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $821b3c1b9ddcee3a$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $821b3c1b9ddcee3a$export$bca7290a9faf0ec9(el) {
    $821b3c1b9ddcee3a$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $821b3c1b9ddcee3a$export$ccb1f1e4d2fa86ac(el) {
    return $821b3c1b9ddcee3a$export$ae7433df314f6ec3(el).oldStyle;
}

var $055606553475f5d6$exports = {};

$parcel$export($055606553475f5d6$exports, "XY", function () { return $055606553475f5d6$export$cb4c12294149dd2d; });
$parcel$export($055606553475f5d6$exports, "WH", function () { return $055606553475f5d6$export$a3fe6d967173a3ac; });
$parcel$export($055606553475f5d6$exports, "extendShape", function () { return $055606553475f5d6$export$d0d5398c9d612037; });
$parcel$export($055606553475f5d6$exports, "extendPath", function () { return $055606553475f5d6$export$53b54a3137026af0; });
$parcel$export($055606553475f5d6$exports, "registerShape", function () { return $055606553475f5d6$export$2b95b62e3aaf6fdd; });
$parcel$export($055606553475f5d6$exports, "getShapeClass", function () { return $055606553475f5d6$export$51df4b5565a58189; });
$parcel$export($055606553475f5d6$exports, "makePath", function () { return $055606553475f5d6$export$aa9bab72412f5613; });
$parcel$export($055606553475f5d6$exports, "resizePath", function () { return $055606553475f5d6$export$566dbf1c62b04fc7; });
$parcel$export($055606553475f5d6$exports, "makeImage", function () { return $055606553475f5d6$export$7a2bdede98851ac5; });
$parcel$export($055606553475f5d6$exports, "mergePath", function () { return $055606553475f5d6$export$7b1dd269fbc4e903; });
$parcel$export($055606553475f5d6$exports, "subPixelOptimizeLine", function () { return $055606553475f5d6$export$8b4b620d7f4aad1b; });
$parcel$export($055606553475f5d6$exports, "subPixelOptimizeRect", function () { return $055606553475f5d6$export$60e2aa74957d0b9d; });
$parcel$export($055606553475f5d6$exports, "subPixelOptimize", function () { return $055606553475f5d6$export$72c4fd4c1b8fcb10; });
$parcel$export($055606553475f5d6$exports, "getTransform", function () { return $055606553475f5d6$export$fce0c6cfca85ed96; });
$parcel$export($055606553475f5d6$exports, "applyTransform", function () { return $055606553475f5d6$export$9f9dcb98c894b623; });
$parcel$export($055606553475f5d6$exports, "transformDirection", function () { return $055606553475f5d6$export$fff94e9792354cfa; });
$parcel$export($055606553475f5d6$exports, "groupTransition", function () { return $055606553475f5d6$export$64fcab7860c216ae; });
$parcel$export($055606553475f5d6$exports, "clipPointsByRect", function () { return $055606553475f5d6$export$e2f409471bbbc1dc; });
$parcel$export($055606553475f5d6$exports, "clipRectByRect", function () { return $055606553475f5d6$export$d0d3709202b8b2a; });
$parcel$export($055606553475f5d6$exports, "createIcon", function () { return $055606553475f5d6$export$274edc73af1ae9c8; });
$parcel$export($055606553475f5d6$exports, "linePolygonIntersect", function () { return $055606553475f5d6$export$4f47c855a5e9ae9; });
$parcel$export($055606553475f5d6$exports, "lineLineIntersect", function () { return $055606553475f5d6$export$6c0a70ea1d8d158b; });
$parcel$export($055606553475f5d6$exports, "expandOrShrinkRect", function () { return $055606553475f5d6$export$81ed941fdeb91c7c; });
$parcel$export($055606553475f5d6$exports, "setTooltipConfig", function () { return $055606553475f5d6$export$fc6410d97fab306c; });
$parcel$export($055606553475f5d6$exports, "traverseElements", function () { return $055606553475f5d6$export$3e564442729bf048; });
$parcel$export($055606553475f5d6$exports, "isBoundingRectAxisAligned", function () { return $055606553475f5d6$export$576610ccf2234b72; });
$parcel$export($055606553475f5d6$exports, "ensureCopyRect", function () { return $055606553475f5d6$export$38128dfd9a498e1; });
$parcel$export($055606553475f5d6$exports, "ensureCopyTransform", function () { return $055606553475f5d6$export$4d61283a070e0362; });
$parcel$export($055606553475f5d6$exports, "retrieveZInfo", function () { return $055606553475f5d6$export$1500a631bea5adda; });
$parcel$export($055606553475f5d6$exports, "calcZ2Range", function () { return $055606553475f5d6$export$8215ea00957327f2; });
$parcel$export($055606553475f5d6$exports, "traverseUpdateZ", function () { return $055606553475f5d6$export$d31cf465bf5e8879; });
$parcel$export($055606553475f5d6$exports, "updateProps", function () { return $821b3c1b9ddcee3a$export$c8dce3c08436e91e; });
$parcel$export($055606553475f5d6$exports, "initProps", function () { return $821b3c1b9ddcee3a$export$a121566aadcfe021; });
$parcel$export($055606553475f5d6$exports, "removeElement", function () { return $821b3c1b9ddcee3a$export$f883456a56996078; });
$parcel$export($055606553475f5d6$exports, "removeElementWithFadeOut", function () { return $821b3c1b9ddcee3a$export$6d0fd725cb4aee8a; });
$parcel$export($055606553475f5d6$exports, "isElementRemoved", function () { return $821b3c1b9ddcee3a$export$5b89d4b643713034; });
$parcel$export($055606553475f5d6$exports, "Group", function () { return $2b89655bc310a947$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Image", function () { return $a3b3990206d5aa78$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Text", function () { return $97dfecd189304201$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Circle", function () { return $4f2941ceb07ff948$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Ellipse", function () { return $5c13c2e3065c8716$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Sector", function () { return $d5aef629841de604$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Ring", function () { return $e87a84613a2ada17$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Polygon", function () { return $8720a9af36a0a965$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Polyline", function () { return $1628fbd4f81c9f94$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Rect", function () { return $aed3569651b5e3fa$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Line", function () { return $a32872499189f58f$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "BezierCurve", function () { return $7918ed3aa6d8b7ed$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Arc", function () { return $b15edc33cfe8221b$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "IncrementalDisplayable", function () { return $073a5fb4a4594a9e$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "CompoundPath", function () { return $dae84e5b487cab8d$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "LinearGradient", function () { return $196fa2034a894932$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "RadialGradient", function () { return $843126af849b36ae$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "BoundingRect", function () { return $faa61116fee85ae6$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "OrientedBoundingRect", function () { return $823478c5f508ba48$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Point", function () { return $c753ea00dcbe469a$export$2e2bcd8739ae039; });
$parcel$export($055606553475f5d6$exports, "Path", function () { return $d730b349402dd5f7$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $ec05be138de23a29$var$CMD = (0, $a1b116230ebefd82$export$2e2bcd8739ae039).CMD;
var $ec05be138de23a29$var$points = [
    [],
    [],
    []
];
var $ec05be138de23a29$var$mathSqrt = Math.sqrt;
var $ec05be138de23a29$var$mathAtan2 = Math.atan2;
function $ec05be138de23a29$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $ec05be138de23a29$var$CMD.M;
    var C = $ec05be138de23a29$var$CMD.C;
    var L = $ec05be138de23a29$var$CMD.L;
    var R = $ec05be138de23a29$var$CMD.R;
    var A = $ec05be138de23a29$var$CMD.A;
    var Q = $ec05be138de23a29$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $ec05be138de23a29$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $ec05be138de23a29$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $ec05be138de23a29$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $ec05be138de23a29$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $6865f055f70add92$var$mathSqrt = Math.sqrt;
var $6865f055f70add92$var$mathSin = Math.sin;
var $6865f055f70add92$var$mathCos = Math.cos;
var $6865f055f70add92$var$PI = Math.PI;
function $6865f055f70add92$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $6865f055f70add92$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($6865f055f70add92$var$vMag(u) * $6865f055f70add92$var$vMag(v));
}
function $6865f055f70add92$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($6865f055f70add92$var$vRatio(u, v));
}
function $6865f055f70add92$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($6865f055f70add92$var$PI / 180.0);
    var xp = $6865f055f70add92$var$mathCos(psi) * (x1 - x2) / 2.0 + $6865f055f70add92$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $6865f055f70add92$var$mathSin(psi) * (x1 - x2) / 2.0 + $6865f055f70add92$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $6865f055f70add92$var$mathSqrt(lambda);
        ry *= $6865f055f70add92$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $6865f055f70add92$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $6865f055f70add92$var$mathCos(psi) * cxp - $6865f055f70add92$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $6865f055f70add92$var$mathSin(psi) * cxp + $6865f055f70add92$var$mathCos(psi) * cyp;
    var theta = $6865f055f70add92$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $6865f055f70add92$var$vAngle(u, v);
    if ($6865f055f70add92$var$vRatio(u, v) <= -1) dTheta = $6865f055f70add92$var$PI;
    if ($6865f055f70add92$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $6865f055f70add92$var$PI * 1e6) / 1e6;
        dTheta = $6865f055f70add92$var$PI * 2 + n % 2 * $6865f055f70add92$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $6865f055f70add92$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $6865f055f70add92$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $6865f055f70add92$var$createPathProxyFromString(data) {
    var path = new (0, $a1b116230ebefd82$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $a1b116230ebefd82$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($6865f055f70add92$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($6865f055f70add92$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $6865f055f70add92$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $6865f055f70add92$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $6865f055f70add92$var$SVGPath = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
function $6865f055f70add92$var$isPathProxy(path) {
    return path.setData != null;
}
function $6865f055f70add92$var$createPathOptions(str, opts) {
    var pathProxy = $6865f055f70add92$var$createPathProxyFromString(str);
    var innerOpts = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        var beProxy = $6865f055f70add92$var$isPathProxy(path);
        if (beProxy && path.canSave()) {
            path.appendPath(pathProxy);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = beProxy ? path.getContext() : path;
            if (ctx) pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $ec05be138de23a29$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $6865f055f70add92$export$ae5b259626f00aeb(str, opts) {
    return new $6865f055f70add92$var$SVGPath($6865f055f70add92$var$createPathOptions(str, opts));
}
function $6865f055f70add92$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $6865f055f70add92$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($6865f055f70add92$var$SVGPath);
    return Sub;
}
function $6865f055f70add92$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $d730b349402dd5f7$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($6865f055f70add92$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $6865f055f70add92$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $d730b349402dd5f7$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $ec05be138de23a29$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $4f2941ceb07ff948$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $4f2941ceb07ff948$var$Circle = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $4f2941ceb07ff948$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$4f2941ceb07ff948$var$Circle.prototype.type = 'circle';
var $4f2941ceb07ff948$export$2e2bcd8739ae039 = $4f2941ceb07ff948$var$Circle;




var $5c13c2e3065c8716$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $5c13c2e3065c8716$var$Ellipse = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $5c13c2e3065c8716$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$5c13c2e3065c8716$var$Ellipse.prototype.type = 'ellipse';
var $5c13c2e3065c8716$export$2e2bcd8739ae039 = $5c13c2e3065c8716$var$Ellipse;





var $ba30f00deb5334fd$var$PI = Math.PI;
var $ba30f00deb5334fd$var$PI2 = $ba30f00deb5334fd$var$PI * 2;
var $ba30f00deb5334fd$var$mathSin = Math.sin;
var $ba30f00deb5334fd$var$mathCos = Math.cos;
var $ba30f00deb5334fd$var$mathACos = Math.acos;
var $ba30f00deb5334fd$var$mathATan2 = Math.atan2;
var $ba30f00deb5334fd$var$mathAbs = Math.abs;
var $ba30f00deb5334fd$var$mathSqrt = Math.sqrt;
var $ba30f00deb5334fd$var$mathMax = Math.max;
var $ba30f00deb5334fd$var$mathMin = Math.min;
var $ba30f00deb5334fd$var$e = 1e-4;
function $ba30f00deb5334fd$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $ba30f00deb5334fd$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $ba30f00deb5334fd$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $ba30f00deb5334fd$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $ba30f00deb5334fd$var$mathSqrt($ba30f00deb5334fd$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $ba30f00deb5334fd$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $ba30f00deb5334fd$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $ba30f00deb5334fd$var$mathMax(shape.r, 0);
    var innerRadius = $ba30f00deb5334fd$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $ba30f00deb5334fd$var$mathAbs(endAngle - startAngle);
    var mod = arc > $ba30f00deb5334fd$var$PI2 && arc % $ba30f00deb5334fd$var$PI2;
    mod > $ba30f00deb5334fd$var$e && (arc = mod);
    if (!(radius > $ba30f00deb5334fd$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $ba30f00deb5334fd$var$PI2 - $ba30f00deb5334fd$var$e) {
        ctx.moveTo(cx + radius * $ba30f00deb5334fd$var$mathCos(startAngle), cy + radius * $ba30f00deb5334fd$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $ba30f00deb5334fd$var$e) {
            ctx.moveTo(cx + innerRadius * $ba30f00deb5334fd$var$mathCos(endAngle), cy + innerRadius * $ba30f00deb5334fd$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $ba30f00deb5334fd$var$mathCos(startAngle);
        var yrs = radius * $ba30f00deb5334fd$var$mathSin(startAngle);
        var xire = innerRadius * $ba30f00deb5334fd$var$mathCos(endAngle);
        var yire = innerRadius * $ba30f00deb5334fd$var$mathSin(endAngle);
        var hasArc = arc > $ba30f00deb5334fd$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $ba30f00deb5334fd$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $ba30f00deb5334fd$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $ba30f00deb5334fd$var$mathMin(halfRd, ocrStart);
            ocre = $ba30f00deb5334fd$var$mathMin(halfRd, ocrEnd);
            icrs = $ba30f00deb5334fd$var$mathMin(halfRd, icrStart);
            icre = $ba30f00deb5334fd$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $ba30f00deb5334fd$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $ba30f00deb5334fd$var$mathMax(icrs, icre);
            if (ocrMax > $ba30f00deb5334fd$var$e || icrMax > $ba30f00deb5334fd$var$e) {
                xre = radius * $ba30f00deb5334fd$var$mathCos(endAngle);
                yre = radius * $ba30f00deb5334fd$var$mathSin(endAngle);
                xirs = innerRadius * $ba30f00deb5334fd$var$mathCos(startAngle);
                yirs = innerRadius * $ba30f00deb5334fd$var$mathSin(startAngle);
                if (arc < $ba30f00deb5334fd$var$PI) {
                    var it_1 = $ba30f00deb5334fd$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $ba30f00deb5334fd$var$mathSin($ba30f00deb5334fd$var$mathACos((x0 * x1 + y0 * y1) / ($ba30f00deb5334fd$var$mathSqrt(x0 * x0 + y0 * y0) * $ba30f00deb5334fd$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $ba30f00deb5334fd$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $ba30f00deb5334fd$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $ba30f00deb5334fd$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $ba30f00deb5334fd$var$e) {
            var crStart = $ba30f00deb5334fd$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $ba30f00deb5334fd$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $ba30f00deb5334fd$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $ba30f00deb5334fd$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $ba30f00deb5334fd$var$mathATan2(ct0.y0, ct0.x0), $ba30f00deb5334fd$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $ba30f00deb5334fd$var$mathATan2(ct0.y0, ct0.x0), $ba30f00deb5334fd$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $ba30f00deb5334fd$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $ba30f00deb5334fd$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $ba30f00deb5334fd$var$mathATan2(ct1.y1, ct1.x1), $ba30f00deb5334fd$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $ba30f00deb5334fd$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $ba30f00deb5334fd$var$e) {
            var crStart = $ba30f00deb5334fd$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $ba30f00deb5334fd$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $ba30f00deb5334fd$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $ba30f00deb5334fd$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $ba30f00deb5334fd$var$mathATan2(ct0.y0, ct0.x0), $ba30f00deb5334fd$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $ba30f00deb5334fd$var$mathATan2(ct0.y0, ct0.x0), $ba30f00deb5334fd$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $ba30f00deb5334fd$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $ba30f00deb5334fd$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $ba30f00deb5334fd$var$mathATan2(ct1.y1, ct1.x1), $ba30f00deb5334fd$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $d5aef629841de604$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $d5aef629841de604$var$Sector = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $d5aef629841de604$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $ba30f00deb5334fd$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$d5aef629841de604$var$Sector.prototype.type = 'sector';
var $d5aef629841de604$export$2e2bcd8739ae039 = $d5aef629841de604$var$Sector;




var $e87a84613a2ada17$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $e87a84613a2ada17$var$Ring = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $e87a84613a2ada17$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$e87a84613a2ada17$var$Ring.prototype.type = 'ring';
var $e87a84613a2ada17$export$2e2bcd8739ae039 = $e87a84613a2ada17$var$Ring;





function $9ace4b0cb33c9b78$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $0a1f57488570eee3$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $0a1f57488570eee3$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $0a1f57488570eee3$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $0a1f57488570eee3$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $0a1f57488570eee3$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $0a1f57488570eee3$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $0a1f57488570eee3$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $0a1f57488570eee3$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $0a1f57488570eee3$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $0a1f57488570eee3$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $0a1f57488570eee3$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $0a1f57488570eee3$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $0a1f57488570eee3$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $0a1f57488570eee3$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $0a1f57488570eee3$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $0a1f57488570eee3$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $0a1f57488570eee3$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $05cdebf31ffb18a5$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $9ace4b0cb33c9b78$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $8720a9af36a0a965$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $8720a9af36a0a965$var$Polygon = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $8720a9af36a0a965$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $05cdebf31ffb18a5$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$8720a9af36a0a965$var$Polygon.prototype.type = 'polygon';
var $8720a9af36a0a965$export$2e2bcd8739ae039 = $8720a9af36a0a965$var$Polygon;





var $1628fbd4f81c9f94$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $1628fbd4f81c9f94$var$Polyline = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $1628fbd4f81c9f94$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $05cdebf31ffb18a5$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$1628fbd4f81c9f94$var$Polyline.prototype.type = 'polyline';
var $1628fbd4f81c9f94$export$2e2bcd8739ae039 = $1628fbd4f81c9f94$var$Polyline;






var $a32872499189f58f$var$subPixelOptimizeOutputShape = {};
var $a32872499189f58f$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $a32872499189f58f$var$Line = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $a32872499189f58f$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $b1bff4e255524a7b$export$8b4b620d7f4aad1b)($a32872499189f58f$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$a32872499189f58f$var$Line.prototype.type = 'line';
var $a32872499189f58f$export$2e2bcd8739ae039 = $a32872499189f58f$var$Line;






var $7918ed3aa6d8b7ed$var$out = [];
var $7918ed3aa6d8b7ed$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $7918ed3aa6d8b7ed$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $196091227dfded05$export$55fce925c60b6271) : (0, $196091227dfded05$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $196091227dfded05$export$55fce925c60b6271) : (0, $196091227dfded05$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $196091227dfded05$export$7e161e77e6fff8cb) : (0, $196091227dfded05$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $196091227dfded05$export$7e161e77e6fff8cb) : (0, $196091227dfded05$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $7918ed3aa6d8b7ed$var$BezierCurve = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $7918ed3aa6d8b7ed$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $196091227dfded05$export$117c659e21a7a060)(x1, cpx1, x2, percent, $7918ed3aa6d8b7ed$var$out);
                cpx1 = $7918ed3aa6d8b7ed$var$out[1];
                x2 = $7918ed3aa6d8b7ed$var$out[2];
                (0, $196091227dfded05$export$117c659e21a7a060)(y1, cpy1, y2, percent, $7918ed3aa6d8b7ed$var$out);
                cpy1 = $7918ed3aa6d8b7ed$var$out[1];
                y2 = $7918ed3aa6d8b7ed$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $196091227dfded05$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $7918ed3aa6d8b7ed$var$out);
                cpx1 = $7918ed3aa6d8b7ed$var$out[1];
                cpx2 = $7918ed3aa6d8b7ed$var$out[2];
                x2 = $7918ed3aa6d8b7ed$var$out[3];
                (0, $196091227dfded05$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $7918ed3aa6d8b7ed$var$out);
                cpy1 = $7918ed3aa6d8b7ed$var$out[1];
                cpy2 = $7918ed3aa6d8b7ed$var$out[2];
                y2 = $7918ed3aa6d8b7ed$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $7918ed3aa6d8b7ed$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $7918ed3aa6d8b7ed$var$someVectorAt(this.shape, t, true);
        return $0a1f57488570eee3$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$7918ed3aa6d8b7ed$var$BezierCurve.prototype.type = 'bezier-curve';
var $7918ed3aa6d8b7ed$export$2e2bcd8739ae039 = $7918ed3aa6d8b7ed$var$BezierCurve;




var $b15edc33cfe8221b$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $b15edc33cfe8221b$var$Arc = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $b15edc33cfe8221b$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
$b15edc33cfe8221b$var$Arc.prototype.type = 'arc';
var $b15edc33cfe8221b$export$2e2bcd8739ae039 = $b15edc33cfe8221b$var$Arc;




var $dae84e5b487cab8d$var$CompoundPath = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $d730b349402dd5f7$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
var $dae84e5b487cab8d$export$2e2bcd8739ae039 = $dae84e5b487cab8d$var$CompoundPath;



var $921f91a7608df01f$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $921f91a7608df01f$export$2e2bcd8739ae039 = $921f91a7608df01f$var$Gradient;


var $196fa2034a894932$var$LinearGradient = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $921f91a7608df01f$export$2e2bcd8739ae039));
var $196fa2034a894932$export$2e2bcd8739ae039 = $196fa2034a894932$var$LinearGradient;




var $843126af849b36ae$var$RadialGradient = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $921f91a7608df01f$export$2e2bcd8739ae039));
var $843126af849b36ae$export$2e2bcd8739ae039 = $843126af849b36ae$var$RadialGradient;





var $823478c5f508ba48$var$mathMin = Math.min;
var $823478c5f508ba48$var$mathMax = Math.max;
var $823478c5f508ba48$var$mathAbs = Math.abs;
var $823478c5f508ba48$var$_extent = [
    0,
    0
];
var $823478c5f508ba48$var$_extent2 = [
    0,
    0
];
var $823478c5f508ba48$var$_intersectCtx = (0, $faa61116fee85ae6$export$a0be2bdbd2369e0e)();
var $823478c5f508ba48$var$_minTv = $823478c5f508ba48$var$_intersectCtx.minTv;
var $823478c5f508ba48$var$_maxTv = $823478c5f508ba48$var$_intersectCtx.maxTv;
var $823478c5f508ba48$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv, opt) {
        var overlapped = true;
        var noMtv = !mtv;
        if (mtv) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).set(mtv, 0, 0);
        $823478c5f508ba48$var$_intersectCtx.reset(opt, !noMtv);
        if (!this._intersectCheckOneSide(this, other, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv && !$823478c5f508ba48$var$_intersectCtx.negativeSize) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).copy(mtv, overlapped ? $823478c5f508ba48$var$_intersectCtx.useDir ? $823478c5f508ba48$var$_intersectCtx.dirMinTv : $823478c5f508ba48$var$_minTv : $823478c5f508ba48$var$_maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = self._axes[i];
            self._getProjMinMaxOnAxis(i, self._corners, $823478c5f508ba48$var$_extent);
            self._getProjMinMaxOnAxis(i, other._corners, $823478c5f508ba48$var$_extent2);
            if ($823478c5f508ba48$var$_intersectCtx.negativeSize || $823478c5f508ba48$var$_extent[1] < $823478c5f508ba48$var$_extent2[0] || $823478c5f508ba48$var$_extent[0] > $823478c5f508ba48$var$_extent2[1]) {
                overlapped = false;
                if ($823478c5f508ba48$var$_intersectCtx.negativeSize || noMtv) return overlapped;
                var dist0 = $823478c5f508ba48$var$mathAbs($823478c5f508ba48$var$_extent2[0] - $823478c5f508ba48$var$_extent[1]);
                var dist1 = $823478c5f508ba48$var$mathAbs($823478c5f508ba48$var$_extent[0] - $823478c5f508ba48$var$_extent2[1]);
                if ($823478c5f508ba48$var$mathMin(dist0, dist1) > $823478c5f508ba48$var$_maxTv.len()) {
                    if (dist0 < dist1) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).scale($823478c5f508ba48$var$_maxTv, axis, -dist0 * inverse);
                    else (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).scale($823478c5f508ba48$var$_maxTv, axis, dist1 * inverse);
                }
            } else if (!noMtv) {
                var dist0 = $823478c5f508ba48$var$mathAbs($823478c5f508ba48$var$_extent2[0] - $823478c5f508ba48$var$_extent[1]);
                var dist1 = $823478c5f508ba48$var$mathAbs($823478c5f508ba48$var$_extent[0] - $823478c5f508ba48$var$_extent2[1]);
                if ($823478c5f508ba48$var$_intersectCtx.useDir || $823478c5f508ba48$var$mathMin(dist0, dist1) < $823478c5f508ba48$var$_minTv.len()) {
                    if (dist0 < dist1 || !$823478c5f508ba48$var$_intersectCtx.bidirectional) {
                        (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).scale($823478c5f508ba48$var$_minTv, axis, dist0 * inverse);
                        if ($823478c5f508ba48$var$_intersectCtx.useDir) $823478c5f508ba48$var$_intersectCtx.calcDirMTV();
                    }
                    if (dist0 >= dist1 || !$823478c5f508ba48$var$_intersectCtx.bidirectional) {
                        (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).scale($823478c5f508ba48$var$_minTv, axis, -dist1 * inverse);
                        if ($823478c5f508ba48$var$_intersectCtx.useDir) $823478c5f508ba48$var$_intersectCtx.calcDirMTV();
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = $823478c5f508ba48$var$mathMin(proj_1, min);
            max = $823478c5f508ba48$var$mathMax(proj_1, max);
        }
        out[0] = min + $823478c5f508ba48$var$_intersectCtx.touchThreshold;
        out[1] = max - $823478c5f508ba48$var$_intersectCtx.touchThreshold;
        $823478c5f508ba48$var$_intersectCtx.negativeSize = out[1] < out[0];
    };
    return OrientedBoundingRect;
}();
var $823478c5f508ba48$export$2e2bcd8739ae039 = $823478c5f508ba48$var$OrientedBoundingRect;






var $073a5fb4a4594a9e$var$m = [];
var $073a5fb4a4594a9e$var$IncrementalDisplayable = function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($073a5fb4a4594a9e$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $1ace62598f635263$export$2e2bcd8739ae039));
var $073a5fb4a4594a9e$export$2e2bcd8739ae039 = $073a5fb4a4594a9e$var$IncrementalDisplayable;







var $055606553475f5d6$var$_customShapeMap = {};
var $055606553475f5d6$export$cb4c12294149dd2d = [
    'x',
    'y'
];
var $055606553475f5d6$export$a3fe6d967173a3ac = [
    'width',
    'height'
];
function $055606553475f5d6$export$d0d5398c9d612037(opts) {
    return (0, $d730b349402dd5f7$export$2e2bcd8739ae039).extend(opts);
}
var $055606553475f5d6$var$extendPathFromString = $6865f055f70add92$export$68e3a51ba2ed417c;
function $055606553475f5d6$export$53b54a3137026af0(pathData, opts) {
    return $055606553475f5d6$var$extendPathFromString(pathData, opts);
}
function $055606553475f5d6$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $055606553475f5d6$var$_customShapeMap[name] = ShapeClass;
}
function $055606553475f5d6$export$51df4b5565a58189(name) {
    if ($055606553475f5d6$var$_customShapeMap.hasOwnProperty(name)) return $055606553475f5d6$var$_customShapeMap[name];
}
function $055606553475f5d6$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $6865f055f70add92$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $055606553475f5d6$var$centerGraphic(rect, path.getBoundingRect());
        $055606553475f5d6$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $055606553475f5d6$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $a3b3990206d5aa78$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function onload(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($055606553475f5d6$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $055606553475f5d6$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $055606553475f5d6$export$7b1dd269fbc4e903 = $6865f055f70add92$export$7b1dd269fbc4e903;
function $055606553475f5d6$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $055606553475f5d6$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $b1bff4e255524a7b$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $055606553475f5d6$export$60e2aa74957d0b9d(shape, style) {
    $b1bff4e255524a7b$export$60e2aa74957d0b9d(shape, shape, style);
    return shape;
}
var $055606553475f5d6$export$72c4fd4c1b8fcb10 = $b1bff4e255524a7b$export$72c4fd4c1b8fcb10;
function $055606553475f5d6$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $e84a7b06db3848b3$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $e84a7b06db3848b3$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $055606553475f5d6$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $99026af6cdabc3e1$export$1e2f57719e155213)(transform)) transform = (0, $4640b1300b1537ae$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $e84a7b06db3848b3$export$6897c284b6f9f4dc([], transform);
    return $0a1f57488570eee3$export$9f9dcb98c894b623([], target, transform);
}
function $055606553475f5d6$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $055606553475f5d6$export$9f9dcb98c894b623(vertex, transform, invert);
    return (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(vertex[0]) > (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $055606553475f5d6$var$isNotGroup(el) {
    return !el.isGroup;
}
function $055606553475f5d6$var$isPath(el) {
    return el.shape != null;
}
function $055606553475f5d6$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($055606553475f5d6$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($055606553475f5d6$var$isPath(el)) obj.shape = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($055606553475f5d6$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $821b3c1b9ddcee3a$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $055606553475f5d6$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(x, rect.x);
        x = (0, $bfe945a83b4d28b9$export$e411eeaf23dccbe8)(x, rect.x + rect.width);
        var y = point[1];
        y = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(y, rect.y);
        y = (0, $bfe945a83b4d28b9$export$e411eeaf23dccbe8)(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $055606553475f5d6$export$d0d3709202b8b2a(targetRect, rect) {
    var x = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(targetRect.x, rect.x);
    var x2 = (0, $bfe945a83b4d28b9$export$e411eeaf23dccbe8)(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(targetRect.y, rect.y);
    var y2 = (0, $bfe945a83b4d28b9$export$e411eeaf23dccbe8)(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $055606553475f5d6$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(style, rect), new (0, $a3b3990206d5aa78$export$2e2bcd8739ae039)(innerOpts)) : $055606553475f5d6$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $055606553475f5d6$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($055606553475f5d6$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $055606553475f5d6$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $055606553475f5d6$var$crossProduct2d(nx, ny, mx, my);
    if ($055606553475f5d6$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $055606553475f5d6$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $055606553475f5d6$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $055606553475f5d6$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $055606553475f5d6$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $055606553475f5d6$export$81ed941fdeb91c7c(rect, delta, shrinkOrExpand, noNegative, minSize // by default [0, 0].
) {
    if (delta == null) return rect;
    else if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(delta)) $055606553475f5d6$var$_tmpExpandRectDelta[0] = $055606553475f5d6$var$_tmpExpandRectDelta[1] = $055606553475f5d6$var$_tmpExpandRectDelta[2] = $055606553475f5d6$var$_tmpExpandRectDelta[3] = delta;
    else {
        $055606553475f5d6$var$_tmpExpandRectDelta[0] = delta[0];
        $055606553475f5d6$var$_tmpExpandRectDelta[1] = delta[1];
        $055606553475f5d6$var$_tmpExpandRectDelta[2] = delta[2];
        $055606553475f5d6$var$_tmpExpandRectDelta[3] = delta[3];
    }
    if (noNegative) {
        $055606553475f5d6$var$_tmpExpandRectDelta[0] = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(0, $055606553475f5d6$var$_tmpExpandRectDelta[0]);
        $055606553475f5d6$var$_tmpExpandRectDelta[1] = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(0, $055606553475f5d6$var$_tmpExpandRectDelta[1]);
        $055606553475f5d6$var$_tmpExpandRectDelta[2] = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(0, $055606553475f5d6$var$_tmpExpandRectDelta[2]);
        $055606553475f5d6$var$_tmpExpandRectDelta[3] = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(0, $055606553475f5d6$var$_tmpExpandRectDelta[3]);
    }
    if (shrinkOrExpand) {
        $055606553475f5d6$var$_tmpExpandRectDelta[0] = -$055606553475f5d6$var$_tmpExpandRectDelta[0];
        $055606553475f5d6$var$_tmpExpandRectDelta[1] = -$055606553475f5d6$var$_tmpExpandRectDelta[1];
        $055606553475f5d6$var$_tmpExpandRectDelta[2] = -$055606553475f5d6$var$_tmpExpandRectDelta[2];
        $055606553475f5d6$var$_tmpExpandRectDelta[3] = -$055606553475f5d6$var$_tmpExpandRectDelta[3];
    }
    $055606553475f5d6$var$expandRectOnOneDimension(rect, $055606553475f5d6$var$_tmpExpandRectDelta, 'x', 'width', 3, 1, minSize && minSize[0] || 0);
    $055606553475f5d6$var$expandRectOnOneDimension(rect, $055606553475f5d6$var$_tmpExpandRectDelta, 'y', 'height', 0, 2, minSize && minSize[1] || 0);
    return rect;
}
var $055606553475f5d6$var$_tmpExpandRectDelta = [
    0,
    0,
    0,
    0
];
function $055606553475f5d6$var$expandRectOnOneDimension(rect, delta, xy, wh, ltIdx, rbIdx, minSize) {
    var deltaSum = delta[rbIdx] + delta[ltIdx];
    var oldSize = rect[wh];
    rect[wh] += deltaSum;
    minSize = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(0, (0, $bfe945a83b4d28b9$export$e411eeaf23dccbe8)(minSize, oldSize));
    if (rect[wh] < minSize) {
        rect[wh] = minSize;
        // Try to make the position of the zero rect reasonable in most visual cases.
        rect[xy] += delta[ltIdx] >= 0 ? -delta[ltIdx] : delta[rbIdx] >= 0 ? oldSize + delta[rbIdx] : (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(deltaSum) > 1e-8 ? (oldSize - minSize) * delta[ltIdx] / deltaSum : 0;
    } else rect[xy] -= delta[ltIdx];
}
function $055606553475f5d6$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $99026af6cdabc3e1$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)((0, $99026af6cdabc3e1$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $055606553475f5d6$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $055606553475f5d6$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$055606553475f5d6$var$traverseElement(els[i], cb);
        else $055606553475f5d6$var$traverseElement(els, cb);
    }
}
function $055606553475f5d6$export$576610ccf2234b72(transform) {
    return !transform || (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(transform[1]) < $055606553475f5d6$var$AXIS_ALIGN_EPSILON && (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(transform[2]) < $055606553475f5d6$var$AXIS_ALIGN_EPSILON || (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(transform[0]) < $055606553475f5d6$var$AXIS_ALIGN_EPSILON && (0, $bfe945a83b4d28b9$export$5860c226b237d9a6)(transform[3]) < $055606553475f5d6$var$AXIS_ALIGN_EPSILON;
}
var $055606553475f5d6$var$AXIS_ALIGN_EPSILON = 1e-5;
function $055606553475f5d6$export$38128dfd9a498e1(target, source) {
    return target ? (0, $faa61116fee85ae6$export$2e2bcd8739ae039).copy(target, source) : source.clone();
}
function $055606553475f5d6$export$4d61283a070e0362(target, source) {
    return source ? $e84a7b06db3848b3$export$784d13d8ee351f07(target || $e84a7b06db3848b3$export$185802fd694ee1f5(), source) : undefined;
}
function $055606553475f5d6$export$1500a631bea5adda(model) {
    return {
        z: model.get('z') || 0,
        zlevel: model.get('zlevel') || 0
    };
}
function $055606553475f5d6$export$8215ea00957327f2(el) {
    var max = -Infinity;
    var min = Infinity;
    $055606553475f5d6$var$traverseElement(el, function(el) {
        visitEl(el);
        visitEl(el.getTextContent());
        visitEl(el.getTextGuideLine());
    });
    function visitEl(el) {
        if (!el || el.isGroup) return;
        var currentStates = el.currentStates;
        if (currentStates.length) for(var idx = 0; idx < currentStates.length; idx++)calcZ2(el.states[currentStates[idx]]);
        calcZ2(el);
    }
    function calcZ2(entity) {
        if (entity) {
            var z2 = entity.z2;
            // Consider z2 may be NullUndefined
            if (z2 > max) max = z2;
            if (z2 < min) min = z2;
        }
    }
    if (min > max) min = max = 0;
    return {
        min: min,
        max: max
    };
}
function $055606553475f5d6$export$d31cf465bf5e8879(el, z, zlevel) {
    $055606553475f5d6$var$doUpdateZ(el, z, zlevel, -Infinity);
}
function $055606553475f5d6$var$doUpdateZ(el, z, zlevel, // FIXME: Ideally all the labels should be above all the glyphs by default,
//  e.g. in graph, edge labels should be above node elements.
//  Currently impl does not guarantee that.
maxZ2) {
    // `ignoreModelZ` is used to intentionally lift elements to cover other elements,
    // where maxZ2 (for label.z2) should also not be counted for its parents.
    if (el.ignoreModelZ) return maxZ2;
    // Group may also have textContent
    var label = el.getTextContent();
    var labelLine = el.getTextGuideLine();
    var isGroup = el.isGroup;
    if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();
        for(var i = 0; i < children.length; i++)maxZ2 = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)($055606553475f5d6$var$doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
    } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(el.z2 || 0, maxZ2);
    }
    // always set z and zlevel if label/labelLine exists
    if (label) {
        label.z = z;
        label.zlevel = zlevel;
        // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.
        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
    }
    if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
    }
    return maxZ2;
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$055606553475f5d6$export$2b95b62e3aaf6fdd('circle', (0, $4f2941ceb07ff948$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('ellipse', (0, $5c13c2e3065c8716$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('sector', (0, $d5aef629841de604$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('ring', (0, $e87a84613a2ada17$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('polygon', (0, $8720a9af36a0a965$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('polyline', (0, $1628fbd4f81c9f94$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('rect', (0, $aed3569651b5e3fa$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('line', (0, $a32872499189f58f$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('bezierCurve', (0, $7918ed3aa6d8b7ed$export$2e2bcd8739ae039));
$055606553475f5d6$export$2b95b62e3aaf6fdd('arc', (0, $b15edc33cfe8221b$export$2e2bcd8739ae039));


var $a4fed78c55651c93$var$EMPTY_OBJ = {};
function $a4fed78c55651c93$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b).length; i++){
        var stateName = (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $a4fed78c55651c93$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b).length; i++){
        var stateName = (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $a4fed78c55651c93$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $a4fed78c55651c93$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $97dfecd189304201$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $ea1f7a1fbd33fd2d$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $97dfecd189304201$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $a4fed78c55651c93$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $a4fed78c55651c93$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($a4fed78c55651c93$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b).length; i++){
            var stateName = (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $a4fed78c55651c93$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $a4fed78c55651c93$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow('silent');
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $a4fed78c55651c93$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $a4fed78c55651c93$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $a4fed78c55651c93$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $a4fed78c55651c93$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b).length; i++){
        var stateName = (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $a4fed78c55651c93$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $a4fed78c55651c93$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $99026af6cdabc3e1$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $a4fed78c55651c93$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magic type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    if (opt.autoOverflowArea != null) textConfig.autoOverflowArea = opt.autoOverflowArea;
    if (opt.layoutRect != null) textConfig.layoutRect = opt.layoutRect;
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $a4fed78c55651c93$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $a4fed78c55651c93$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $a4fed78c55651c93$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        var richInheritPlainLabelOptionName = 'richInheritPlainLabel';
        var richInheritPlainLabel = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.get(richInheritPlainLabelOptionName), ecModel ? ecModel.get(richInheritPlainLabelOptionName) : undefined);
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]);
            // In rich, never `disableBox`.
            // consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            // Since v6, the rich style inherits plain label by default
            // but this behavior can be disabled by setting `richInheritPlainLabel` to `false`.
            $a4fed78c55651c93$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, textStyleModel, richInheritPlainLabel, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var lineOverflow = textStyleModel.get('lineOverflow');
    if (lineOverflow) textStyle.lineOverflow = lineOverflow;
    var labelTextStyle = textStyle;
    // `minMargin` has a higher precedence than `textMargin`, because `textMargin` is allowed
    // to be set in `defaultOption`.
    var minMargin = textStyleModel.get('minMargin');
    if (minMargin != null) {
        // `minMargin` only support number value.
        minMargin = !(0, $99026af6cdabc3e1$export$7e4aa119212bc614)(minMargin) ? 0 : minMargin / 2;
        labelTextStyle.margin = [
            minMargin,
            minMargin,
            minMargin,
            minMargin
        ];
        labelTextStyle.__marginType = $a4fed78c55651c93$export$2b18df2bc75ae422.minMargin;
    } else {
        var textMargin = textStyleModel.get('textMargin');
        if (textMargin != null) {
            labelTextStyle.margin = (0, $99026af6cdabc3e1$export$f3a38102c49f4268)(textMargin);
            labelTextStyle.__marginType = $a4fed78c55651c93$export$2b18df2bc75ae422.textMargin;
        }
    }
    $a4fed78c55651c93$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, null, null, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $a4fed78c55651c93$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $a4fed78c55651c93$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $a4fed78c55651c93$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $a4fed78c55651c93$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign',
    'ellipsis'
];
var $a4fed78c55651c93$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $a4fed78c55651c93$var$setTokenTextStyle(textStyle, // FIXME: check/refactor for ellipsis handling of rich text.
textStyleModel, globalTextStyle, plainTextModel, richInheritPlainLabel, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $a4fed78c55651c93$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) // Might not be a string, e.g, it's a function in axisLabel case; but assume that it will
    // be erased by a correct value outside.
    textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $a4fed78c55651c93$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $a4fed78c55651c93$var$TEXT_PROPS_WITH_GLOBAL[i];
        // props width, height, padding, margin, tag, backgroundColor, borderColor,
        // borderWidth, borderRadius, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY
        // may inappropriate to inherit from plainTextStyle.
        // And if some props is specified in default options, users may have to reset them one by one.
        // Therefore, we only allow these props to inherit from plainTextStyle.
        // `richInheritPlainLabel` is switch for backward compatibility
        var val = richInheritPlainLabel !== false && plainTextModel ? (0, $99026af6cdabc3e1$export$2e94551289abb95b)(textStyleModel.getShallow(key), plainTextModel.getShallow(key), globalTextStyle[key]) : (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $a4fed78c55651c93$var$TEXT_PROPS_SELF.length; i++){
        var key = $a4fed78c55651c93$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $a4fed78c55651c93$var$TEXT_PROPS_BOX.length; i++){
            var key = $a4fed78c55651c93$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $a4fed78c55651c93$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $a4fed78c55651c93$export$f62786d3261ab0f4 = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
function $a4fed78c55651c93$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $a4fed78c55651c93$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $a4fed78c55651c93$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $a4fed78c55651c93$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $08bfa015475effa8$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $a4fed78c55651c93$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $a4fed78c55651c93$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $821b3c1b9ddcee3a$export$a121566aadcfe021) : (0, $821b3c1b9ddcee3a$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}
var $a4fed78c55651c93$export$2b18df2bc75ae422 = {
    minMargin: 1,
    textMargin: 2
};



var $9983d59dbe88f515$var$PATH_COLOR = [
    'textStyle',
    'color'
];
var $9983d59dbe88f515$var$textStyleParams = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'padding',
    'lineHeight',
    'rich',
    'width',
    'height',
    'overflow'
];
// TODO Performance improvement?
var $9983d59dbe88f515$var$tmpText = new (0, $97dfecd189304201$export$2e2bcd8739ae039)();
var $9983d59dbe88f515$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($9983d59dbe88f515$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $a4fed78c55651c93$export$155316a870a9d61e)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
        };
        for(var i = 0; i < $9983d59dbe88f515$var$textStyleParams.length; i++)style[$9983d59dbe88f515$var$textStyleParams[i]] = this.getShallow($9983d59dbe88f515$var$textStyleParams[i]);
        $9983d59dbe88f515$var$tmpText.useStyle(style);
        $9983d59dbe88f515$var$tmpText.update();
        return $9983d59dbe88f515$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $9983d59dbe88f515$export$2e2bcd8739ae039 = $9983d59dbe88f515$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $44542845f644b8de$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ]
];
var $44542845f644b8de$var$getLineStyle = (0, $9a62b05a77f65632$export$2e2bcd8739ae039)($44542845f644b8de$export$9f34de5b59222949);
var $44542845f644b8de$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $44542845f644b8de$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6a8488c27a3e9cc8$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ]
];
var $6a8488c27a3e9cc8$var$getItemStyle = (0, $9a62b05a77f65632$export$2e2bcd8739ae039)($6a8488c27a3e9cc8$export$ffb0bba5dde0130b);
var $6a8488c27a3e9cc8$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $6a8488c27a3e9cc8$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $a48e58444b640d0e$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $99026af6cdabc3e1$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $99026af6cdabc3e1$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $e870be04527b939a$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && (typeof obj === "undefined" ? "undefined" : (0, $5f0Cq._)(obj)) === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $cdb9e13510266a6e$export$cd4c3a4dca301c70)($a48e58444b640d0e$var$Model);
(0, $cdb9e13510266a6e$export$e1aac4552ae82081)($a48e58444b640d0e$var$Model);
(0, $99026af6cdabc3e1$export$e36fc9d62a853069)($a48e58444b640d0e$var$Model, (0, $44542845f644b8de$export$91eeeeed4a69a7e7));
(0, $99026af6cdabc3e1$export$e36fc9d62a853069)($a48e58444b640d0e$var$Model, (0, $6a8488c27a3e9cc8$export$e4f01e48d6fda412));
(0, $99026af6cdabc3e1$export$e36fc9d62a853069)($a48e58444b640d0e$var$Model, (0, $5128c1babbb42c22$export$a3a0ed7e2dd84c9e));
(0, $99026af6cdabc3e1$export$e36fc9d62a853069)($a48e58444b640d0e$var$Model, (0, $9983d59dbe88f515$export$2e2bcd8739ae039));
var $a48e58444b640d0e$export$2e2bcd8739ae039 = $a48e58444b640d0e$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $ea311bef09818b2f$var$base = Math.round(Math.random() * 10);
function $ea311bef09818b2f$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $ea311bef09818b2f$var$base++
    ].join('_');
}
function $ea311bef09818b2f$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $cdb9e13510266a6e$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $cdb9e13510266a6e$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $ea311bef09818b2f$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $99026af6cdabc3e1$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $99026af6cdabc3e1$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $99026af6cdabc3e1$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $99026af6cdabc3e1$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $99026af6cdabc3e1$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($99026af6cdabc3e1$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($99026af6cdabc3e1$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $99026af6cdabc3e1$export$79b2f7037acddd43(originalDeps, function(dep) {
            $99026af6cdabc3e1$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $ea311bef09818b2f$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $99026af6cdabc3e1$export$4950aa0f605343fb($99026af6cdabc3e1$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $90712065166ac0be$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst',
            custom: 'Custom chart',
            chart: 'Chart'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $6ce68af9548fa8ad$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};



var $ead0abccc3f84def$var$LOCALE_ZH = 'ZH';
var $ead0abccc3f84def$var$LOCALE_EN = 'EN';
var $ead0abccc3f84def$var$DEFAULT_LOCALE = $ead0abccc3f84def$var$LOCALE_EN;
var $ead0abccc3f84def$var$localeStorage = {};
var $ead0abccc3f84def$var$localeModels = {};
var $ead0abccc3f84def$export$9a2147b3808d4c6b = !(0, $e870be04527b939a$export$2e2bcd8739ae039).domSupported ? $ead0abccc3f84def$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage || $ead0abccc3f84def$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($ead0abccc3f84def$var$LOCALE_ZH) > -1 ? $ead0abccc3f84def$var$LOCALE_ZH : $ead0abccc3f84def$var$DEFAULT_LOCALE;
}();
function $ead0abccc3f84def$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $ead0abccc3f84def$var$localeModels[locale] = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(localeObj);
    $ead0abccc3f84def$var$localeStorage[locale] = localeObj;
}
function $ead0abccc3f84def$export$ddc371781a6af754(locale) {
    if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(locale)) {
        var localeObj = $ead0abccc3f84def$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $ead0abccc3f84def$var$LOCALE_ZH || locale === $ead0abccc3f84def$var$LOCALE_EN) return (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(localeObj);
        else return (0, $99026af6cdabc3e1$export$4950aa0f605343fb)((0, $99026af6cdabc3e1$export$9cd59f9826255e47)(localeObj), (0, $99026af6cdabc3e1$export$9cd59f9826255e47)($ead0abccc3f84def$var$localeStorage[$ead0abccc3f84def$var$DEFAULT_LOCALE]), false);
    } else return (0, $99026af6cdabc3e1$export$4950aa0f605343fb)((0, $99026af6cdabc3e1$export$9cd59f9826255e47)(locale), (0, $99026af6cdabc3e1$export$9cd59f9826255e47)($ead0abccc3f84def$var$localeStorage[$ead0abccc3f84def$var$DEFAULT_LOCALE]), false);
}
function $ead0abccc3f84def$export$37cc638e0e11865f(lang) {
    return $ead0abccc3f84def$var$localeModels[lang];
}
function $ead0abccc3f84def$export$1188f179b2597821() {
    return $ead0abccc3f84def$var$localeModels[$ead0abccc3f84def$var$DEFAULT_LOCALE];
}
// Default locale
$ead0abccc3f84def$export$bab6a7822cc1e2cd($ead0abccc3f84def$var$LOCALE_EN, (0, $90712065166ac0be$export$2e2bcd8739ae039));
$ead0abccc3f84def$export$bab6a7822cc1e2cd($ead0abccc3f84def$var$LOCALE_ZH, (0, $6ce68af9548fa8ad$export$2e2bcd8739ae039));



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ae704d848942c028$var$_impl = null;
function $ae704d848942c028$export$11977f1e90ef55cf(impl) {
    if (!$ae704d848942c028$var$_impl) $ae704d848942c028$var$_impl = impl;
}
function $ae704d848942c028$export$e79b20ac82c2d660() {
    return $ae704d848942c028$var$_impl;
}


var $3655c9ec749458a4$export$32c0454ceff7f92d = 1000;
var $3655c9ec749458a4$export$35acaebf644db34e = $3655c9ec749458a4$export$32c0454ceff7f92d * 60;
var $3655c9ec749458a4$export$82541edf19e5e3b0 = $3655c9ec749458a4$export$35acaebf644db34e * 60;
var $3655c9ec749458a4$export$a97a1358cbb650ab = $3655c9ec749458a4$export$82541edf19e5e3b0 * 24;
var $3655c9ec749458a4$export$99cafda57477293d = $3655c9ec749458a4$export$a97a1358cbb650ab * 365;
var $3655c9ec749458a4$var$primaryTimeUnitFormatterMatchers = {
    year: /({yyyy}|{yy})/,
    month: /({MMMM}|{MMM}|{MM}|{M})/,
    day: /({dd}|{d})/,
    hour: /({HH}|{H}|{hh}|{h})/,
    minute: /({mm}|{m})/,
    second: /({ss}|{s})/,
    millisecond: /({SSS}|{S})/
};
var $3655c9ec749458a4$var$defaultFormatterSeed = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}'
};
var $3655c9ec749458a4$var$defaultFullFormatter = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}';
var $3655c9ec749458a4$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $3655c9ec749458a4$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $3655c9ec749458a4$var$fullDayFormatter,
    hour: $3655c9ec749458a4$var$fullDayFormatter + ' ' + $3655c9ec749458a4$var$defaultFormatterSeed.hour,
    minute: $3655c9ec749458a4$var$fullDayFormatter + ' ' + $3655c9ec749458a4$var$defaultFormatterSeed.minute,
    second: $3655c9ec749458a4$var$fullDayFormatter + ' ' + $3655c9ec749458a4$var$defaultFormatterSeed.second,
    millisecond: $3655c9ec749458a4$var$defaultFullFormatter
};
var $3655c9ec749458a4$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $3655c9ec749458a4$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $3655c9ec749458a4$export$f16a827770bdffb5(formatter) {
    // Keep the logic the same with function `leveledFormat`.
    return !$99026af6cdabc3e1$export$844ec244b1367d54(formatter) && !$99026af6cdabc3e1$export$f6e2535fb5126e54(formatter) ? $3655c9ec749458a4$var$parseTimeAxisLabelFormatterDictionary(formatter) : formatter;
}
/**
 * The final generated dictionary is like:
 *  generated_dict = {
 *      year: {
 *          year: ['{yyyy}', ...<higher_levels_if_any>]
 *      },
 *      month: {
 *          year: ['{yyyy} {MMM}', ...<higher_levels_if_any>],
 *          month: ['{MMM}', ...<higher_levels_if_any>]
 *      },
 *      day: {
 *          year: ['{yyyy} {MMM} {d}', ...<higher_levels_if_any>],
 *          month: ['{MMM} {d}', ...<higher_levels_if_any>],
 *          day: ['{d}', ...<higher_levels_if_any>]
 *      },
 *      ...
 *  }
 *
 * In echarts option, users can specify the entire dictionary or typically just:
 *  {formatter: {
 *      year: '{yyyy}', // Or an array of leveled templates: `['{yyyy}', '{bold1|{yyyy}}', ...]`,
 *                      // corresponding to `[level0, level1, level2, ...]`.
 *      month: '{MMM}',
 *      day: '{d}',
 *      hour: '{HH}:{mm}',
 *      second: '{HH}:{mm}',
 *      ...
 *  }}
 *  If any time unit is not specified in echarts option, the default template is used,
 *  such as `['{yyyy}', {primary|{yyyy}']`.
 *
 * The `tick.level` is only used to read string from each array, meaning the style type.
 *
 * Let `lowerUnit = getUnitFromValue(tick.value)`.
 * The non-break axis ticks only use `generated_dict[lowerUnit][lowerUnit][level]`.
 * The break axis ticks may use `generated_dict[lowerUnit][upperUnit][level]`, because:
 *  Consider the case: the non-break ticks are `16th, 23th, Feb, 7th, ...`, where `Feb` is in the break
 *  range and pruned by breaks, and the break ends might be in lower time unit than day. e.g., break start
 *  is `Jan 25th 18:00`(in unit `hour`) and break end is `Feb 6th 18:30` (in unit `minute`). Thus the break
 *  label prefers `Jan 25th 18:00` and `Feb 6th 18:30` rather than only `18:00` and `18:30`, otherwise it
 *  causes misleading.
 *  In this case, the tick of the break start and end will both be:
 *      `{level: 1, lowerTimeUnit: 'minute', upperTimeUnit: 'month'}`
 *  And get the final template by `generated_dict[lowerTimeUnit][upperTimeUnit][level]`.
 *  Note that the time unit can not be calculated directly by a single tick value, since the two breaks have
 *  to be at the same time unit to avoid awkward appearance. i.e., `Jan 25th 18:00` is in the time unit "hour"
 *  but we need it to be "minute", following `Feb 6th 18:30`.
 */ function $3655c9ec749458a4$var$parseTimeAxisLabelFormatterDictionary(dictOption) {
    dictOption = dictOption || {};
    var dict = {};
    // Currently if any template is specified by user, it may contain rich text tag,
    // such as `'{my_bold|{YYYY}}'`, thus we do add highlight style to it.
    // (Note that nested tag (`'{some|{some2|xxx}}'`) in rich text is not supported yet.)
    var canAddHighlight = true;
    $99026af6cdabc3e1$export$79b2f7037acddd43($3655c9ec749458a4$export$87100da04d711986, function(lowestUnit) {
        canAddHighlight && (canAddHighlight = dictOption[lowestUnit] == null);
    });
    $99026af6cdabc3e1$export$79b2f7037acddd43($3655c9ec749458a4$export$87100da04d711986, function(lowestUnit, lowestUnitIdx) {
        var upperDictOption = dictOption[lowestUnit];
        dict[lowestUnit] = {};
        var lowerTpl = null;
        for(var upperUnitIdx = lowestUnitIdx; upperUnitIdx >= 0; upperUnitIdx--){
            var upperUnit = $3655c9ec749458a4$export$87100da04d711986[upperUnitIdx];
            var upperDictItemOption = $99026af6cdabc3e1$export$a6cdc56e425d0d0a(upperDictOption) && !$99026af6cdabc3e1$export$43bee75e5e14138e(upperDictOption) ? upperDictOption[upperUnit] : upperDictOption;
            var tplArr = void 0;
            if ($99026af6cdabc3e1$export$43bee75e5e14138e(upperDictItemOption)) {
                tplArr = upperDictItemOption.slice();
                lowerTpl = tplArr[0] || '';
            } else if ($99026af6cdabc3e1$export$844ec244b1367d54(upperDictItemOption)) {
                lowerTpl = upperDictItemOption;
                tplArr = [
                    lowerTpl
                ];
            } else {
                if (lowerTpl == null) lowerTpl = $3655c9ec749458a4$var$defaultFormatterSeed[lowestUnit];
                else if (!$3655c9ec749458a4$var$primaryTimeUnitFormatterMatchers[upperUnit].test(lowerTpl)) lowerTpl = dict[upperUnit][upperUnit][0] + " " + lowerTpl;
                tplArr = [
                    lowerTpl
                ];
                if (canAddHighlight) tplArr[1] = "{primary|" + lowerTpl + "}";
            }
            dict[lowestUnit][upperUnit] = tplArr;
        }
    });
    return dict;
}
function $3655c9ec749458a4$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $3655c9ec749458a4$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $3655c9ec749458a4$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $3655c9ec749458a4$export$1da4b91a25d7e1c8(timeUnit);
}
function $3655c9ec749458a4$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $3655c9ec749458a4$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $bfe945a83b4d28b9$export$6b862160d295c8e(time);
    var y = date[$3655c9ec749458a4$export$8d046fefed9a548e(isUTC)]();
    var M = date[$3655c9ec749458a4$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$3655c9ec749458a4$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$3655c9ec749458a4$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$3655c9ec749458a4$export$8807847c5c71eded(isUTC)]();
    var s = date[$3655c9ec749458a4$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$3655c9ec749458a4$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? 'pm' : 'am';
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $a48e58444b640d0e$export$2e2bcd8739ae039) ? lang : (0, $ead0abccc3f84def$export$37cc638e0e11865f)(lang || (0, $ead0abccc3f84def$export$9a2147b3808d4c6b)) || (0, $ead0abccc3f84def$export$1188f179b2597821)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{a}/g, a + '').replace(/{A}/g, A + '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(y % 100 + '', 2)).replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $3655c9ec749458a4$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $3655c9ec749458a4$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($99026af6cdabc3e1$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($99026af6cdabc3e1$export$f6e2535fb5126e54(formatter)) {
        var extra = {
            time: tick.time,
            level: tick.time.level
        };
        var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) scaleBreakHelper.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
        template = formatter(tick.value, idx, extra);
    } else {
        var tickTime = tick.time;
        if (tickTime) {
            var leveledTplArr = formatter[tickTime.lowerTimeUnit][tickTime.upperTimeUnit];
            template = leveledTplArr[Math.min(tickTime.level, leveledTplArr.length - 1)] || '';
        } else {
            // tick may be from customTicks or timeline therefore no tick.time.
            var unit = $3655c9ec749458a4$export$4dfb0417ad6555b7(tick.value, isUTC);
            template = formatter[unit][unit][0];
        }
    }
    return $3655c9ec749458a4$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $3655c9ec749458a4$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $bfe945a83b4d28b9$export$6b862160d295c8e(value);
    var M = date[$3655c9ec749458a4$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$3655c9ec749458a4$export$4189e6cbc9753260(isUTC)]();
    var h = date[$3655c9ec749458a4$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$3655c9ec749458a4$export$8807847c5c71eded(isUTC)]();
    var s = date[$3655c9ec749458a4$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$3655c9ec749458a4$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $3655c9ec749458a4$export$2ed3384313b02c28(date, timeUnit, isUTC) {
    switch(timeUnit){
        case 'year':
            date[$3655c9ec749458a4$export$233f59998ed71c09(isUTC)](0);
        case 'month':
            date[$3655c9ec749458a4$export$82fd379a67f37fa0(isUTC)](1);
        case 'day':
            date[$3655c9ec749458a4$export$b6f943e8d23c15bb(isUTC)](0);
        case 'hour':
            date[$3655c9ec749458a4$export$50303078793fc7d(isUTC)](0);
        case 'minute':
            date[$3655c9ec749458a4$export$a4a908acda9c3118(isUTC)](0);
        case 'second':
            date[$3655c9ec749458a4$export$c047afab75f6d84(isUTC)](0);
    }
    return date;
}
function $3655c9ec749458a4$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $3655c9ec749458a4$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $3655c9ec749458a4$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $3655c9ec749458a4$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $3655c9ec749458a4$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $3655c9ec749458a4$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $3655c9ec749458a4$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $3655c9ec749458a4$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $3655c9ec749458a4$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $3655c9ec749458a4$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $3655c9ec749458a4$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $3655c9ec749458a4$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $3655c9ec749458a4$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $3655c9ec749458a4$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}





function $031dcf3d7ed28374$export$b6fe44657ce35c42(x) {
    if (!(0, $bfe945a83b4d28b9$export$e90fb89750dba83f)(x)) return $99026af6cdabc3e1$export$844ec244b1367d54(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $031dcf3d7ed28374$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $031dcf3d7ed28374$export$f3a38102c49f4268 = $99026af6cdabc3e1$export$f3a38102c49f4268;
function $031dcf3d7ed28374$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $99026af6cdabc3e1$export$87c2784dc9fc4ab(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $bfe945a83b4d28b9$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $3655c9ec749458a4$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $99026af6cdabc3e1$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $99026af6cdabc3e1$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
    // By default.
    var numericResult = (0, $bfe945a83b4d28b9$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $031dcf3d7ed28374$export$b6fe44657ce35c42(numericResult) : $99026af6cdabc3e1$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var $031dcf3d7ed28374$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $031dcf3d7ed28374$var$wrapVar = function wrapVar(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $031dcf3d7ed28374$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$99026af6cdabc3e1$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $031dcf3d7ed28374$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($031dcf3d7ed28374$var$wrapVar(alias), $031dcf3d7ed28374$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($031dcf3d7ed28374$var$wrapVar($031dcf3d7ed28374$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $031dcf3d7ed28374$export$2fa08233ee42f8e1(tpl, param, encode) {
    $99026af6cdabc3e1$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $031dcf3d7ed28374$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $99026af6cdabc3e1$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $031dcf3d7ed28374$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $bfe945a83b4d28b9$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? 'getUTC' : 'get';
    var y = date[getUTC + 'FullYear']();
    var M = date[getUTC + 'Month']() + 1;
    var d = date[getUTC + 'Date']();
    var h = date[getUTC + 'Hours']();
    var m = date[getUTC + 'Minutes']();
    var s = date[getUTC + 'Seconds']();
    var S = date[getUTC + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $3655c9ec749458a4$export$5d04458e2a6c373e)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', (0, $3655c9ec749458a4$export$5d04458e2a6c373e)(y % 100 + '', 2)).replace('dd', (0, $3655c9ec749458a4$export$5d04458e2a6c373e)(d, 2)).replace('d', d).replace('hh', (0, $3655c9ec749458a4$export$5d04458e2a6c373e)(h, 2)).replace('h', h).replace('mm', (0, $3655c9ec749458a4$export$5d04458e2a6c373e)(m, 2)).replace('m', m).replace('ss', (0, $3655c9ec749458a4$export$5d04458e2a6c373e)(s, 2)).replace('s', s).replace('SSS', (0, $3655c9ec749458a4$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $031dcf3d7ed28374$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $031dcf3d7ed28374$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $99026af6cdabc3e1$export$844ec244b1367d54(color) ? color : $99026af6cdabc3e1$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $031dcf3d7ed28374$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/**
 * FIXME:
 * `nonSeriesBoxCoordSysCreators` and `_nonSeriesBoxMasterList` are hardcoded implementations.
 * Regarding "coord sys layout based on another coord sys", currently we only exprimentally support one level
 * dpendency, such as, "grid(cartesian)s can be laid out based on matrix/calendar coord sys."
 * But a comprehensive implementation may need to support:
 *  - Recursive dependencies. e.g., a matrix coord sys lays out based on another matrix coord sys.
 *    That requires in the implementation `create` and `update` of coord sys are called by a dependency graph.
 *    (@see enableTopologicalTravel in `util/component.ts`)
 */ var $f8a57de9b8820c02$var$nonSeriesBoxCoordSysCreators = {};
var $f8a57de9b8820c02$var$normalCoordSysCreators = {};
var $f8a57de9b8820c02$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._normalMasterList = [];
        this._nonSeriesBoxMasterList = [];
    }
    /**
   * Typically,
   *  - in `create`, a coord sys lays out based on a given rect;
   *  - in `update`, update the pixel and data extent of there axes (if any) based on processed `series.data`.
   * After that, a coord sys can serve (typically by `dataToPoint`/`dataToLayout`/`pointToData`).
   * If the coordinate system do not lay out based on `series.data`, `update` is not needed.
   */ CoordinateSystemManager.prototype.create = function(ecModel, api) {
        this._nonSeriesBoxMasterList = dealCreate($f8a57de9b8820c02$var$nonSeriesBoxCoordSysCreators, true);
        this._normalMasterList = dealCreate($f8a57de9b8820c02$var$normalCoordSysCreators, false);
        function dealCreate(creatorMap, canBeNonSeriesBox) {
            var coordinateSystems = [];
            $99026af6cdabc3e1$export$79b2f7037acddd43(creatorMap, function(creator, type) {
                var list = creator.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            return coordinateSystems;
        }
    };
    /**
   * @see CoordinateSystem['create']
   */ CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $99026af6cdabc3e1$export$79b2f7037acddd43(this._normalMasterList, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._normalMasterList.concat(this._nonSeriesBoxMasterList);
    };
    CoordinateSystemManager.register = function(type, creator) {
        if (type === 'matrix' || type === 'calendar') {
            // FIXME: hardcode, @see nonSeriesBoxCoordSysCreators
            $f8a57de9b8820c02$var$nonSeriesBoxCoordSysCreators[type] = creator;
            return;
        }
        $f8a57de9b8820c02$var$normalCoordSysCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $f8a57de9b8820c02$var$normalCoordSysCreators[type] || $f8a57de9b8820c02$var$nonSeriesBoxCoordSysCreators[type];
    };
    return CoordinateSystemManager;
}();
function $f8a57de9b8820c02$var$canBeNonSeriesBoxCoordSys(coordSysType) {
    return !!$f8a57de9b8820c02$var$nonSeriesBoxCoordSysCreators[coordSysType];
}
var $f8a57de9b8820c02$export$b0f4b35a5e5703d9 = {
    // By default fetch coord from `model.get('coord')`.
    coord: 1,
    // Some model/series, such as pie, is allowed to also get coord from `model.get('center')`,
    // if cannot get from `model.get('coord')`. But historically pie use `center` option, but
    // geo use `layoutCenter` option to specify layout center; they are not able to be unified.
    // Therefor it is not recommended.
    coord2: 2
};
function $f8a57de9b8820c02$export$b8fb890203e861d5(opt) {
    $f8a57de9b8820c02$var$coordSysUseMap.set(opt.fullType, {
        getCoord2: undefined
    }).getCoord2 = opt.getCoord2;
}
var $f8a57de9b8820c02$var$coordSysUseMap = $99026af6cdabc3e1$export$55f8aa7ef875b0a4();
function $f8a57de9b8820c02$export$86c4e85e47608a23(model) {
    var coord = model.getShallow('coord', true);
    var from = $f8a57de9b8820c02$export$b0f4b35a5e5703d9.coord;
    if (coord == null) {
        var store = $f8a57de9b8820c02$var$coordSysUseMap.get(model.type);
        if (store && store.getCoord2) {
            from = $f8a57de9b8820c02$export$b0f4b35a5e5703d9.coord2;
            coord = store.getCoord2(model);
        }
    }
    return {
        coord: coord,
        from: from
    };
}
var $f8a57de9b8820c02$export$20673ff3ebf85e08 = {
    none: 0,
    dataCoordSys: 1,
    boxCoordSys: 2
};
function $f8a57de9b8820c02$export$29cb72d70b6b3a71(// Component or series
model, printError) {
    // For backward compat, still not use `true` in model.get.
    var coordSysType = model.getShallow('coordinateSystem');
    var coordSysUsageOption = model.getShallow('coordinateSystemUsage', true);
    var isDeclaredExplicitly = coordSysUsageOption != null;
    var kind = $f8a57de9b8820c02$export$20673ff3ebf85e08.none;
    if (coordSysType) {
        var isSeries = model.mainType === 'series';
        if (coordSysUsageOption == null) coordSysUsageOption = isSeries ? 'data' : 'box';
        if (coordSysUsageOption === 'data') {
            kind = $f8a57de9b8820c02$export$20673ff3ebf85e08.dataCoordSys;
            if (!isSeries) kind = $f8a57de9b8820c02$export$20673ff3ebf85e08.none;
        } else if (coordSysUsageOption === 'box') {
            kind = $f8a57de9b8820c02$export$20673ff3ebf85e08.boxCoordSys;
            if (!isSeries && !$f8a57de9b8820c02$var$canBeNonSeriesBoxCoordSys(coordSysType)) kind = $f8a57de9b8820c02$export$20673ff3ebf85e08.none;
        }
    }
    return {
        coordSysType: coordSysType,
        kind: kind
    };
}
function $f8a57de9b8820c02$export$7ed0c09d4f5c932e(opt) {
    var targetModel = opt.targetModel, coordSysType = opt.coordSysType, coordSysProvider = opt.coordSysProvider, isDefaultDataCoordSys = opt.isDefaultDataCoordSys, allowNotFound = opt.allowNotFound;
    var _a = $f8a57de9b8820c02$export$29cb72d70b6b3a71(targetModel, true), kind = _a.kind, declaredType = _a.coordSysType;
    if (isDefaultDataCoordSys && kind !== $f8a57de9b8820c02$export$20673ff3ebf85e08.dataCoordSys) {
        // If both dataCoordSys and boxCoordSys declared in one model.
        // There is the only case in series-graph, and no other cases yet.
        kind = $f8a57de9b8820c02$export$20673ff3ebf85e08.dataCoordSys;
        declaredType = coordSysType;
    }
    if (kind === $f8a57de9b8820c02$export$20673ff3ebf85e08.none || declaredType !== coordSysType) return false;
    var coordSys = coordSysProvider(coordSysType, targetModel);
    if (!coordSys) return false;
    if (kind === $f8a57de9b8820c02$export$20673ff3ebf85e08.dataCoordSys) targetModel.coordinateSystem = coordSys;
    else // kind === 'boxCoordSys'
    targetModel.boxCoordinateSystem = coordSys;
    return true;
}
var $f8a57de9b8820c02$export$33b06c851894cd19 = function simpleCoordSysInjectionProvider(coordSysType, injectTargetModel) {
    var coordSysModel = injectTargetModel.getReferringComponents(coordSysType, (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
    return coordSysModel && coordSysModel.coordinateSystem;
};
var $f8a57de9b8820c02$export$2e2bcd8739ae039 = $f8a57de9b8820c02$var$CoordinateSystemManager;


var $4fb3a6a3c6974639$var$each = $99026af6cdabc3e1$export$79b2f7037acddd43;
var $4fb3a6a3c6974639$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $4fb3a6a3c6974639$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $4fb3a6a3c6974639$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $4fb3a6a3c6974639$export$827f4ee28efc37 = $4fb3a6a3c6974639$var$boxLayout;
var $4fb3a6a3c6974639$export$be20d9158c17374c = $99026af6cdabc3e1$export$c3095a23b368d1f2($4fb3a6a3c6974639$var$boxLayout, 'vertical');
var $4fb3a6a3c6974639$export$ae65a483d943e7a7 = $99026af6cdabc3e1$export$c3095a23b368d1f2($4fb3a6a3c6974639$var$boxLayout, 'horizontal');
function $4fb3a6a3c6974639$export$22344244a123da8(boxLayoutModel, ignoreParent) {
    return {
        left: boxLayoutModel.getShallow('left', ignoreParent),
        top: boxLayoutModel.getShallow('top', ignoreParent),
        right: boxLayoutModel.getShallow('right', ignoreParent),
        bottom: boxLayoutModel.getShallow('bottom', ignoreParent),
        width: boxLayoutModel.getShallow('width', ignoreParent),
        height: boxLayoutModel.getShallow('height', ignoreParent)
    };
}
function $4fb3a6a3c6974639$var$getViewRectAndCenterForCircleLayout(seriesModel, api) {
    var layoutRef = $4fb3a6a3c6974639$export$5aec1e94f566e59f(seriesModel, api, {
        enableLayoutOnlyByCenter: true
    });
    var boxLayoutParams = seriesModel.getBoxLayoutParams();
    var viewRect;
    var center;
    if (layoutRef.type === $4fb3a6a3c6974639$export$953b11ffc6912560.point) {
        center = layoutRef.refPoint;
        // `viewRect` is required in `pie/labelLayout.ts`.
        viewRect = $4fb3a6a3c6974639$export$4517a5ca639a7293(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
    } else {
        // layoutRef.type === layout.BoxLayoutReferenceType.rect
        var centerOption = seriesModel.get('center');
        var centerOptionArr = $99026af6cdabc3e1$export$43bee75e5e14138e(centerOption) ? centerOption : [
            centerOption,
            centerOption
        ];
        viewRect = $4fb3a6a3c6974639$export$4517a5ca639a7293(boxLayoutParams, layoutRef.refContainer);
        center = layoutRef.boxCoordFrom === (0, $f8a57de9b8820c02$export$b0f4b35a5e5703d9).coord2 ? layoutRef.refPoint // option `series.center` has been used as coord.
         : [
            (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(centerOptionArr[0], viewRect.width) + viewRect.x,
            (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(centerOptionArr[1], viewRect.height) + viewRect.y
        ];
    }
    return {
        viewRect: viewRect,
        center: center
    };
}
function $4fb3a6a3c6974639$export$3101c00baac0ee1f(seriesModel, api) {
    // center can be string or number when coordinateSystem is specified
    var _a = $4fb3a6a3c6974639$var$getViewRectAndCenterForCircleLayout(seriesModel, api), viewRect = _a.viewRect, center = _a.center;
    var radius = seriesModel.get('radius');
    if (!$99026af6cdabc3e1$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    return {
        cx: center[0],
        cy: center[1],
        r0: r0,
        r: r,
        viewRect: viewRect
    };
}
function $4fb3a6a3c6974639$export$4517a5ca639a7293(positionInfo, containerRect, // This is the space from the `containerRect` to the returned bounding rect.
// Commonly used in option `legend.padding`, `timeline.padding`, `title.padding`,
//  `visualMap.padding`, ...
// [NOTICE]:
//  It's named `margin`, because it's the space that outside the bounding rect. But from
//  the perspective of the the caller, it's commonly used as the `padding` of a component,
//  because conventionally background color covers this space.
// [BEHAVIOR]:
//  - If width/height is specified, `margin` does not effect them.
//  - Otherwise, they are calculated based on the rect that `containerRect` shrinked by `margin`.
//  - left/right/top/bottom are based on the rect that `containerRect` shrinked by `margin`.
margin) {
    margin = $031dcf3d7ed28374$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            // PENDING: if only `left` or `right` is defined, perhaps it's more preferable to
            // calculate size based on `containerWidth - left` or `containerWidth - left` here,
            // but for backward compatibility we do not change it.
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)((containerRect.x || 0) + left + margin[3], (containerRect.y || 0) + top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $4fb3a6a3c6974639$export$9fec79e40d579ea7(component, layoutRect, // That is, `width / height`.
// Assume `aspect` is positive.
aspect) {
    var preserveAspect = component.getShallow('preserveAspect', true);
    if (!preserveAspect) return layoutRect;
    var actualAspect = layoutRect.width / layoutRect.height;
    if (Math.abs(Math.atan(aspect) - Math.atan(actualAspect)) < 1e-9) return layoutRect;
    var preserveAspectAlign = component.getShallow('preserveAspectAlign', true);
    var preserveAspectVerticalAlign = component.getShallow('preserveAspectVerticalAlign', true);
    var layoutOptInner = {
        width: layoutRect.width,
        height: layoutRect.height
    };
    var isCover = preserveAspect === 'cover';
    if (actualAspect > aspect && !isCover || actualAspect < aspect && isCover) {
        layoutOptInner.width = layoutRect.height * aspect;
        preserveAspectAlign === 'left' ? layoutOptInner.left = 0 : preserveAspectAlign === 'right' ? layoutOptInner.right = 0 : layoutOptInner.left = 'center';
    } else {
        layoutOptInner.height = layoutRect.width / aspect;
        preserveAspectVerticalAlign === 'top' ? layoutOptInner.top = 0 : preserveAspectVerticalAlign === 'bottom' ? layoutOptInner.bottom = 0 : layoutOptInner.top = 'middle';
    }
    return $4fb3a6a3c6974639$export$4517a5ca639a7293(layoutOptInner, layoutRect);
}
var $4fb3a6a3c6974639$export$953b11ffc6912560 = {
    rect: 1,
    point: 2
};
function $4fb3a6a3c6974639$export$5aec1e94f566e59f(model, api, opt) {
    var refContainer;
    var refPoint;
    var layoutRefType;
    var boxCoordSys = model.boxCoordinateSystem;
    var boxCoordFrom;
    if (boxCoordSys) {
        var _a = (0, $f8a57de9b8820c02$export$86c4e85e47608a23)(model), coord = _a.coord, from = _a.from;
        // Do not use `clamp` in `dataToLayout` and `dataToPoint`, because:
        //  1. Should support overflow (such as, by dataZoom), where NaN should be in the result.
        //  2. Be consistent with the way used in `series.data`
        if (boxCoordSys.dataToLayout) {
            layoutRefType = $4fb3a6a3c6974639$export$953b11ffc6912560.rect;
            boxCoordFrom = from;
            var result = boxCoordSys.dataToLayout(coord);
            refContainer = result.contentRect || result.rect;
        } else if (opt && opt.enableLayoutOnlyByCenter && boxCoordSys.dataToPoint) {
            layoutRefType = $4fb3a6a3c6974639$export$953b11ffc6912560.point;
            boxCoordFrom = from;
            refPoint = boxCoordSys.dataToPoint(coord);
        }
    }
    if (layoutRefType == null) layoutRefType = $4fb3a6a3c6974639$export$953b11ffc6912560.rect;
    if (layoutRefType === $4fb3a6a3c6974639$export$953b11ffc6912560.rect) {
        if (!refContainer) refContainer = {
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        };
        refPoint = [
            refContainer.x + refContainer.width / 2,
            refContainer.y + refContainer.height / 2
        ];
    }
    return {
        type: layoutRefType,
        refContainer: refContainer,
        refPoint: refPoint,
        boxCoordFrom: boxCoordFrom
    };
}
function $4fb3a6a3c6974639$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $4fb3a6a3c6974639$export$4517a5ca639a7293($99026af6cdabc3e1$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $4fb3a6a3c6974639$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$4fb3a6a3c6974639$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$4fb3a6a3c6974639$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$4fb3a6a3c6974639$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $4fb3a6a3c6974639$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $99026af6cdabc3e1$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $4fb3a6a3c6974639$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$99026af6cdabc3e1$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($4fb3a6a3c6974639$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($4fb3a6a3c6974639$export$d7fd4338c7b20804[1], 1);
    copy($4fb3a6a3c6974639$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($4fb3a6a3c6974639$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $4fb3a6a3c6974639$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $4fb3a6a3c6974639$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            $99026af6cdabc3e1$export$b5a638e9b3fff9f3(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!$99026af6cdabc3e1$export$b5a638e9b3fff9f3(newParams, name_1) && $99026af6cdabc3e1$export$b5a638e9b3fff9f3(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $4fb3a6a3c6974639$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $4fb3a6a3c6974639$export$4b0d20af19c9875e(source) {
    return $4fb3a6a3c6974639$export$7438999faea9b6cc({}, source);
}
function $4fb3a6a3c6974639$export$7438999faea9b6cc(target, source) {
    source && target && $4fb3a6a3c6974639$var$each($4fb3a6a3c6974639$export$a9aa2cc018afbed, function(name) {
        $99026af6cdabc3e1$export$b5a638e9b3fff9f3(source, name) && (target[name] = source[name]);
    });
    return target;
}


var $fefeb1a173623ab2$var$inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $fefeb1a173623ab2$var$ComponentModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $ea311bef09818b2f$export$6d2b3473b0986646('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $4fb3a6a3c6974639$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $4fb3a6a3c6974639$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $99026af6cdabc3e1$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $99026af6cdabc3e1$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $4fb3a6a3c6974639$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $99026af6cdabc3e1$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $4fb3a6a3c6974639$export$3968a28a7cbd6063(this);
        if (layoutMode) $4fb3a6a3c6974639$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        if (!(0, $cdb9e13510266a6e$export$4f3b818f3dd2d182)(ctor)) // When using ES class declaration, defaultOption must be declared as static.
        // And manually inherit the defaultOption from its parent class if needed, such as,
        //  ```ts
        //  static defaultOption = inheritDefaultOption(ParentModel.defaultOption, {...});
        //  ```
        return ctor.defaultOption;
        // FIXME: remove this approach?
        // Legacy: auto merge defaultOption from ancestor classes if using ParentClass.extend(subProto)
        var fields = $fefeb1a173623ab2$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $99026af6cdabc3e1$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $08bfa015475effa8$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        // For backward compatibility, by default do not `ignoreParent`.
        return $4fb3a6a3c6974639$export$22344244a123da8(this, false);
    };
    /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */ ComponentModel.prototype.getZLevelKey = function() {
        return '';
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $a48e58444b640d0e$export$2e2bcd8739ae039));
(0, $cdb9e13510266a6e$export$c9c2d87774f1275d)($fefeb1a173623ab2$var$ComponentModel, (0, $a48e58444b640d0e$export$2e2bcd8739ae039));
(0, $cdb9e13510266a6e$export$241315e45585454d)($fefeb1a173623ab2$var$ComponentModel);
$ea311bef09818b2f$export$b9faf30b7d655a6f($fefeb1a173623ab2$var$ComponentModel);
$ea311bef09818b2f$export$ce592d345a3ec040($fefeb1a173623ab2$var$ComponentModel, $fefeb1a173623ab2$var$getDependencies);
function $fefeb1a173623ab2$var$getDependencies(componentType) {
    var deps = [];
    $99026af6cdabc3e1$export$79b2f7037acddd43($fefeb1a173623ab2$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $99026af6cdabc3e1$export$871de8747c9eaa88(deps, function(type) {
        return (0, $cdb9e13510266a6e$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== 'dataset' && $99026af6cdabc3e1$export$305f7d4e9d4624f2(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $fefeb1a173623ab2$export$2e2bcd8739ae039 = $fefeb1a173623ab2$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $96bd979a273eb9e3$var$tokens = {
    color: {},
    darkColor: {},
    size: {}
};
var $96bd979a273eb9e3$var$color = $96bd979a273eb9e3$var$tokens.color = {
    theme: [
        '#5070dd',
        '#b6d634',
        '#505372',
        '#ff994d',
        '#0ca8df',
        '#ffd10a',
        '#fb628b',
        '#785db0',
        '#3fbe95'
    ],
    neutral00: '#fff',
    neutral05: '#f4f7fd',
    neutral10: '#e8ebf0',
    neutral15: '#dbdee4',
    neutral20: '#cfd2d7',
    neutral25: '#c3c5cb',
    neutral30: '#b7b9be',
    neutral35: '#aaacb2',
    neutral40: '#9ea0a5',
    neutral45: '#929399',
    neutral50: '#86878c',
    neutral55: '#797b7f',
    neutral60: '#6d6e73',
    neutral65: '#616266',
    neutral70: '#54555a',
    neutral75: '#48494d',
    neutral80: '#3c3c41',
    neutral85: '#303034',
    neutral90: '#232328',
    neutral95: '#17171b',
    neutral99: '#000',
    accent05: '#eff1f9',
    accent10: '#e0e4f2',
    accent15: '#d0d6ec',
    accent20: '#c0c9e6',
    accent25: '#b1bbdf',
    accent30: '#a1aed9',
    accent35: '#91a0d3',
    accent40: '#8292cc',
    accent45: '#7285c6',
    accent50: '#6578ba',
    accent55: '#5c6da9',
    accent60: '#536298',
    accent65: '#4a5787',
    accent70: '#404c76',
    accent75: '#374165',
    accent80: '#2e3654',
    accent85: '#252b43',
    accent90: '#1b2032',
    accent95: '#121521',
    transparent: 'rgba(0,0,0,0)',
    highlight: 'rgba(255,231,130,0.8)'
};
(0, $99026af6cdabc3e1$export$8b58be045bf06082)($96bd979a273eb9e3$var$color, {
    primary: $96bd979a273eb9e3$var$color.neutral80,
    secondary: $96bd979a273eb9e3$var$color.neutral70,
    tertiary: $96bd979a273eb9e3$var$color.neutral60,
    quaternary: $96bd979a273eb9e3$var$color.neutral50,
    disabled: $96bd979a273eb9e3$var$color.neutral20,
    border: $96bd979a273eb9e3$var$color.neutral30,
    borderTint: $96bd979a273eb9e3$var$color.neutral20,
    borderShade: $96bd979a273eb9e3$var$color.neutral40,
    background: $96bd979a273eb9e3$var$color.neutral05,
    backgroundTint: 'rgba(234,237,245,0.5)',
    backgroundTransparent: 'rgba(255,255,255,0)',
    backgroundShade: $96bd979a273eb9e3$var$color.neutral10,
    shadow: 'rgba(0,0,0,0.2)',
    shadowTint: 'rgba(129,130,136,0.2)',
    axisLine: $96bd979a273eb9e3$var$color.neutral70,
    axisLineTint: $96bd979a273eb9e3$var$color.neutral40,
    axisTick: $96bd979a273eb9e3$var$color.neutral70,
    axisTickMinor: $96bd979a273eb9e3$var$color.neutral60,
    axisLabel: $96bd979a273eb9e3$var$color.neutral70,
    axisSplitLine: $96bd979a273eb9e3$var$color.neutral15,
    axisMinorSplitLine: $96bd979a273eb9e3$var$color.neutral05
});
for(var $96bd979a273eb9e3$var$key in $96bd979a273eb9e3$var$color)if ($96bd979a273eb9e3$var$color.hasOwnProperty($96bd979a273eb9e3$var$key)) {
    var $96bd979a273eb9e3$var$hex = $96bd979a273eb9e3$var$color[$96bd979a273eb9e3$var$key];
    if ($96bd979a273eb9e3$var$key === 'theme') // Don't modify theme colors.
    $96bd979a273eb9e3$var$tokens.darkColor.theme = $96bd979a273eb9e3$var$color.theme.slice();
    else if ($96bd979a273eb9e3$var$key === 'highlight') $96bd979a273eb9e3$var$tokens.darkColor.highlight = 'rgba(255,231,130,0.4)';
    else if ($96bd979a273eb9e3$var$key.indexOf('accent') === 0) // Desaturate and lighten accent colors.
    $96bd979a273eb9e3$var$tokens.darkColor[$96bd979a273eb9e3$var$key] = (0, $9148d8aa0f446713$export$d898ae866e27bf18)($96bd979a273eb9e3$var$hex, null, function(s) {
        return s * 0.5;
    }, function(l) {
        return Math.min(1, 1.3 - l);
    });
    else $96bd979a273eb9e3$var$tokens.darkColor[$96bd979a273eb9e3$var$key] = (0, $9148d8aa0f446713$export$d898ae866e27bf18)($96bd979a273eb9e3$var$hex, null, function(s) {
        return s * 0.9;
    }, function(l) {
        return 1 - Math.pow(l, 1.5);
    });
}
$96bd979a273eb9e3$var$tokens.size = {
    xxs: 2,
    xs: 5,
    s: 10,
    m: 15,
    l: 20,
    xl: 30,
    xxl: 40,
    xxxl: 50
};
var $96bd979a273eb9e3$export$2e2bcd8739ae039 = $96bd979a273eb9e3$var$tokens;


var $a3cfce7eae875403$var$platform = '';
// Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $a3cfce7eae875403$var$platform = navigator.platform || '';
var $a3cfce7eae875403$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $a3cfce7eae875403$var$themeColor = (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.theme[0];
var $a3cfce7eae875403$var$lightThemeColor = (0, $9148d8aa0f446713$export$d898ae866e27bf18)($a3cfce7eae875403$var$themeColor, null, null, 0.9);
var $a3cfce7eae875403$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.theme,
    gradientColor: [
        $a3cfce7eae875403$var$lightThemeColor,
        $a3cfce7eae875403$var$themeColor
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $a3cfce7eae875403$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $a3cfce7eae875403$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $a3cfce7eae875403$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $a3cfce7eae875403$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $a3cfce7eae875403$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $a3cfce7eae875403$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $a3cfce7eae875403$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b80138b23bdc0dba$export$cd51b5ca77f6f0e4 = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'itemChildGroupId',
    'seriesName'
]);
var $b80138b23bdc0dba$export$2823037fb9d8f0c6 = 'original';
var $b80138b23bdc0dba$export$fcd62ebf51387903 = 'arrayRows';
var $b80138b23bdc0dba$export$703ae8a2d83f441 = 'objectRows';
var $b80138b23bdc0dba$export$6a32b42c754a3cb8 = 'keyedColumns';
var $b80138b23bdc0dba$export$a918cb016a382d45 = 'typedArray';
var $b80138b23bdc0dba$export$c78f1330778d30d = 'unknown';
var $b80138b23bdc0dba$export$7b3f3c6551b4949b = 'column';
var $b80138b23bdc0dba$export$d55da1467cdf7804 = 'row';


var $fbbcfa54d383b92f$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $fbbcfa54d383b92f$var$innerGlobalModel = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
function $fbbcfa54d383b92f$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $fbbcfa54d383b92f$var$innerGlobalModel(ecModel).datasetMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
}
function $fbbcfa54d383b92f$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $fbbcfa54d383b92f$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $fbbcfa54d383b92f$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $fbbcfa54d383b92f$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $fbbcfa54d383b92f$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $b80138b23bdc0dba$export$703ae8a2d83f441) || sourceFormat === (0, $b80138b23bdc0dba$export$6a32b42c754a3cb8)) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $fbbcfa54d383b92f$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $fbbcfa54d383b92f$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $fbbcfa54d383b92f$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $fbbcfa54d383b92f$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $fbbcfa54d383b92f$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $08bfa015475effa8$export$dc741340f7e5f186)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
}
function $fbbcfa54d383b92f$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $08bfa015475effa8$export$dc741340f7e5f186)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $08bfa015475effa8$export$f076738ec84e693c)).models;
}
function $fbbcfa54d383b92f$export$c51adf1a2be01b9c(source, dimIndex) {
    return $fbbcfa54d383b92f$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $fbbcfa54d383b92f$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(data)) return $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $fbbcfa54d383b92f$export$328749e9c5b40760.Must : $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $b80138b23bdc0dba$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $b80138b23bdc0dba$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $b80138b23bdc0dba$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $b80138b23bdc0dba$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(sample)) return $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $08bfa015475effa8$export$2c944e12edb48d4b)(item);
            if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(val)) return $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $99026af6cdabc3e1$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        if (val != null && Number.isFinite(Number(val)) && val !== '') return beStr ? $fbbcfa54d383b92f$export$328749e9c5b40760.Might : $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $fbbcfa54d383b92f$export$328749e9c5b40760.Must;
    }
    return $fbbcfa54d383b92f$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $fc0b6436b03429ea$var$internalOptionCreatorMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
function $fc0b6436b03429ea$export$5a90be4668898d38(mainType, creator) {
    (0, $99026af6cdabc3e1$export$a7a9523472993e97)($fc0b6436b03429ea$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $fc0b6436b03429ea$var$internalOptionCreatorMap.set(mainType, creator);
}
function $fc0b6436b03429ea$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $fc0b6436b03429ea$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0a689a6d69e1cd3c$var$innerColor = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $0a689a6d69e1cd3c$var$innerDecal = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $0a689a6d69e1cd3c$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $08bfa015475effa8$export$4f07b212a02c8051)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $0a689a6d69e1cd3c$var$getFromPalette(this, $0a689a6d69e1cd3c$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $0a689a6d69e1cd3c$var$clearPalette(this, $0a689a6d69e1cd3c$var$innerColor);
    };
    return PaletteMixin;
}();
function $0a689a6d69e1cd3c$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $08bfa015475effa8$export$4f07b212a02c8051)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $0a689a6d69e1cd3c$var$getFromPalette(ecModel, $0a689a6d69e1cd3c$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $0a689a6d69e1cd3c$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $0a689a6d69e1cd3c$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $0a689a6d69e1cd3c$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $0a689a6d69e1cd3c$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2c7aa3955e1b7354$var$ECHARTS_PREFIX = '[ECharts] ';
var $2c7aa3955e1b7354$var$storedLogs = {};
var $2c7aa3955e1b7354$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
function $2c7aa3955e1b7354$var$outputLog(type, str, onlyOnce) {
    if ($2c7aa3955e1b7354$var$hasConsole) {
        if (onlyOnce) {
            if ($2c7aa3955e1b7354$var$storedLogs[str]) return;
            $2c7aa3955e1b7354$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($2c7aa3955e1b7354$var$ECHARTS_PREFIX + str);
    }
}
function $2c7aa3955e1b7354$export$bef1f36f5486a6a3(str, onlyOnce) {
    $2c7aa3955e1b7354$var$outputLog('log', str, onlyOnce);
}
function $2c7aa3955e1b7354$export$c106dd0671a0fc2d(str, onlyOnce) {
    $2c7aa3955e1b7354$var$outputLog('warn', str, onlyOnce);
}
function $2c7aa3955e1b7354$export$a3bc9b8ed74fc(str, onlyOnce) {
    $2c7aa3955e1b7354$var$outputLog('error', str, onlyOnce);
}
function $2c7aa3955e1b7354$export$4a9c0b74eb885aa1(str) {}
function $2c7aa3955e1b7354$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $2c7aa3955e1b7354$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $2c7aa3955e1b7354$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $d0f94fa2d299f1af$var$reCreateSeriesIndices;
var $d0f94fa2d299f1af$var$assertSeriesInitialized;
var $d0f94fa2d299f1af$var$initBase;
var $d0f94fa2d299f1af$var$OPTION_INNER_KEY = '\0_ec_inner';
var $d0f94fa2d299f1af$var$OPTION_INNER_VALUE = 1;
var $d0f94fa2d299f1af$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    matrix: 'MatrixComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $d0f94fa2d299f1af$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    chord: 'ChordChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $d0f94fa2d299f1af$var$componetsMissingLogPrinted = {};
function $d0f94fa2d299f1af$var$checkMissingComponents(option) {
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $fefeb1a173623ab2$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $d0f94fa2d299f1af$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$d0f94fa2d299f1af$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $2c7aa3955e1b7354$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $d0f94fa2d299f1af$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $d0f94fa2d299f1af$var$GlobalModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $d0f94fa2d299f1af$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $d0f94fa2d299f1af$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $d0f94fa2d299f1af$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $fbbcfa54d383b92f$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $fefeb1a173623ab2$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(componentOption) : (0, $99026af6cdabc3e1$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $fefeb1a173623ab2$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $fc0b6436b03429ea$export$c713a6a3b43f401d)(this, mainType, $08bfa015475effa8$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $08bfa015475effa8$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $08bfa015475effa8$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === 'tooltip') {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === 'series') $d0f94fa2d299f1af$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $d0f94fa2d299f1af$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(this.option);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $fefeb1a173623ab2$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $08bfa015475effa8$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$08bfa015475effa8$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$d0f94fa2d299f1af$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.setTheme = function(theme) {
        this._theme = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(theme);
        this._resetOption('recreate', null);
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($08bfa015475effa8$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $d0f94fa2d299f1af$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $d0f94fa2d299f1af$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $d0f94fa2d299f1af$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($d0f94fa2d299f1af$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $99026af6cdabc3e1$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $08bfa015475effa8$export$fb1a222ba5dd6e51(name, null);
        return (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $d0f94fa2d299f1af$var$assertSeriesInitialized(this);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $d0f94fa2d299f1af$var$assertSeriesInitialized(this);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $d0f94fa2d299f1af$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $d0f94fa2d299f1af$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $d0f94fa2d299f1af$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $fefeb1a173623ab2$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$d0f94fa2d299f1af$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $d0f94fa2d299f1af$var$reCreateSeriesIndices = function reCreateSeriesIndices(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $d0f94fa2d299f1af$var$assertSeriesInitialized = function assertSeriesInitialized(ecModel) {};
        $d0f94fa2d299f1af$var$initBase = function initBase(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$d0f94fa2d299f1af$var$OPTION_INNER_KEY] = $d0f94fa2d299f1af$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $d0f94fa2d299f1af$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $99026af6cdabc3e1$export$4950aa0f605343fb)(baseOption, (0, $a3cfce7eae875403$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $a48e58444b640d0e$export$2e2bcd8739ae039));
function $d0f94fa2d299f1af$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $d0f94fa2d299f1af$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer || name === 'color' && option.color) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $fefeb1a173623ab2$export$2e2bcd8739ae039).hasClass(name)) {
            if ((typeof themeItem === "undefined" ? "undefined" : (0, $5f0Cq._)(themeItem)) === 'object') option[name] = !option[name] ? (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(themeItem) : (0, $99026af6cdabc3e1$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $d0f94fa2d299f1af$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $08bfa015475effa8$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $08bfa015475effa8$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $d0f94fa2d299f1af$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $d0f94fa2d299f1af$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    opts && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($08bfa015475effa8$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $99026af6cdabc3e1$export$e36fc9d62a853069)($d0f94fa2d299f1af$var$GlobalModel, (0, $0a689a6d69e1cd3c$export$55a3c39e852b90f4));
var $d0f94fa2d299f1af$export$2e2bcd8739ae039 = $d0f94fa2d299f1af$var$GlobalModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f2525918be30f295$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isSSR',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    // 'getModel',
    'getOption',
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $f2525918be30f295$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $99026af6cdabc3e1$export$79b2f7037acddd43($f2525918be30f295$var$availableMethods, function(methodName) {
            this[methodName] = $99026af6cdabc3e1$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $f2525918be30f295$export$2e2bcd8739ae039 = $f2525918be30f295$var$ExtensionAPI;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $83737f0b0a901c54$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $83737f0b0a901c54$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)((0, $08bfa015475effa8$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(series.data) && (0, $99026af6cdabc3e1$export$112e66431016387b)(series.data);
            });
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)((0, $08bfa015475effa8$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(dataset.source) && (0, $99026af6cdabc3e1$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $83737f0b0a901c54$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($83737f0b0a901c54$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$83737f0b0a901c54$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $83737f0b0a901c54$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(mediaOnRoot)) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $83737f0b0a901c54$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($83737f0b0a901c54$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$83737f0b0a901c54$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $83737f0b0a901c54$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $83737f0b0a901c54$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$83737f0b0a901c54$export$2e2bcd8739ae039 = $83737f0b0a901c54$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5f0Cq = parcelRequire("5f0Cq");

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $94b0f4e27af8fdaa$var$each = $99026af6cdabc3e1$export$79b2f7037acddd43;
var $94b0f4e27af8fdaa$var$isObject = $99026af6cdabc3e1$export$a6cdc56e425d0d0a;
var $94b0f4e27af8fdaa$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $94b0f4e27af8fdaa$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $94b0f4e27af8fdaa$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $94b0f4e27af8fdaa$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $99026af6cdabc3e1$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $99026af6cdabc3e1$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $99026af6cdabc3e1$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $94b0f4e27af8fdaa$var$removeEC3NormalStatus(opt) {
    $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, 'itemStyle');
    $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, 'lineStyle');
    $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, 'areaStyle');
    $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, 'label');
    $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, 'labelLine');
    // treemap
    $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, 'upperLabel');
    // graph
    $94b0f4e27af8fdaa$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $94b0f4e27af8fdaa$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $94b0f4e27af8fdaa$var$isObject(opt) && opt[propName];
    var textStyle = $94b0f4e27af8fdaa$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $08bfa015475effa8$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $08bfa015475effa8$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $94b0f4e27af8fdaa$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $94b0f4e27af8fdaa$var$removeEC3NormalStatus(opt);
        $94b0f4e27af8fdaa$var$compatTextStyle(opt, 'label');
        opt.emphasis && $94b0f4e27af8fdaa$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $94b0f4e27af8fdaa$var$processSeries(seriesOpt) {
    if (!$94b0f4e27af8fdaa$var$isObject(seriesOpt)) return;
    $94b0f4e27af8fdaa$var$compatEC2ItemStyle(seriesOpt);
    $94b0f4e27af8fdaa$var$removeEC3NormalStatus(seriesOpt);
    $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt, 'label');
    // treemap
    $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt, 'upperLabel');
    // graph
    $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt.emphasis, 'label');
        // treemap
        $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
        // graph
        $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $94b0f4e27af8fdaa$var$compatEC2ItemStyle(markPoint);
        $94b0f4e27af8fdaa$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $94b0f4e27af8fdaa$var$compatEC2ItemStyle(markLine);
        $94b0f4e27af8fdaa$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $94b0f4e27af8fdaa$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$99026af6cdabc3e1$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$94b0f4e27af8fdaa$var$compatEC3CommonStyles(edgeData[i]);
        $99026af6cdabc3e1$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $94b0f4e27af8fdaa$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$99026af6cdabc3e1$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$94b0f4e27af8fdaa$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$94b0f4e27af8fdaa$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($99026af6cdabc3e1$export$43bee75e5e14138e(mlData[i])) {
            $94b0f4e27af8fdaa$var$compatEC3CommonStyles(mlData[i][0]);
            $94b0f4e27af8fdaa$var$compatEC3CommonStyles(mlData[i][1]);
        } else $94b0f4e27af8fdaa$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === 'gauge') {
        $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt, 'axisLabel');
        $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt, 'title');
        $94b0f4e27af8fdaa$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $94b0f4e27af8fdaa$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $99026af6cdabc3e1$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $94b0f4e27af8fdaa$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $94b0f4e27af8fdaa$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $94b0f4e27af8fdaa$var$toArr(o) {
    return $99026af6cdabc3e1$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $94b0f4e27af8fdaa$var$toObj(o) {
    return ($99026af6cdabc3e1$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $94b0f4e27af8fdaa$export$2e2bcd8739ae039(option, isTheme) {
    $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option.series), function(seriesOpt) {
        $94b0f4e27af8fdaa$var$isObject(seriesOpt) && $94b0f4e27af8fdaa$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $94b0f4e27af8fdaa$var$each(axes, function(axisName) {
        $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $94b0f4e27af8fdaa$var$compatTextStyle(axisOpt, 'axisLabel');
                $94b0f4e27af8fdaa$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $94b0f4e27af8fdaa$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $94b0f4e27af8fdaa$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option.calendar), function(calendarOpt) {
        $94b0f4e27af8fdaa$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $94b0f4e27af8fdaa$var$compatTextStyle(calendarOpt, 'dayLabel');
        $94b0f4e27af8fdaa$var$compatTextStyle(calendarOpt, 'monthLabel');
        $94b0f4e27af8fdaa$var$compatTextStyle(calendarOpt, 'yearLabel');
    });
    // radar.name.textStyle
    $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option.radar), function(radarOpt) {
        $94b0f4e27af8fdaa$var$compatTextStyle(radarOpt, 'name');
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option.geo), function(geoOpt) {
        if ($94b0f4e27af8fdaa$var$isObject(geoOpt)) {
            $94b0f4e27af8fdaa$var$compatEC3CommonStyles(geoOpt);
            $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(geoOpt.regions), function(regionObj) {
                $94b0f4e27af8fdaa$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option.timeline), function(timelineOpt) {
        $94b0f4e27af8fdaa$var$compatEC3CommonStyles(timelineOpt);
        $94b0f4e27af8fdaa$var$convertNormalEmphasis(timelineOpt, 'label');
        $94b0f4e27af8fdaa$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $94b0f4e27af8fdaa$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $99026af6cdabc3e1$export$43bee75e5e14138e(data) && $99026af6cdabc3e1$export$79b2f7037acddd43(data, function(item) {
            if ($99026af6cdabc3e1$export$a6cdc56e425d0d0a(item)) {
                $94b0f4e27af8fdaa$var$convertNormalEmphasis(item, 'label');
                $94b0f4e27af8fdaa$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $94b0f4e27af8fdaa$var$each($94b0f4e27af8fdaa$var$toArr(option.toolbox), function(toolboxOpt) {
        $94b0f4e27af8fdaa$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $94b0f4e27af8fdaa$var$each(toolboxOpt.feature, function(featureOpt) {
            $94b0f4e27af8fdaa$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $94b0f4e27af8fdaa$var$compatTextStyle($94b0f4e27af8fdaa$var$toObj(option.axisPointer), 'label');
    $94b0f4e27af8fdaa$var$compatTextStyle($94b0f4e27af8fdaa$var$toObj(option.tooltip).axisPointer, 'label');
// Clean logs
// storedLogs = {};
}




function $08c364d5f2e8a2e2$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $08c364d5f2e8a2e2$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $08c364d5f2e8a2e2$var$compatLayoutProperties(option) {
    option && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($08c364d5f2e8a2e2$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $08c364d5f2e8a2e2$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $08c364d5f2e8a2e2$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $08c364d5f2e8a2e2$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $08c364d5f2e8a2e2$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $08c364d5f2e8a2e2$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $08c364d5f2e8a2e2$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $08c364d5f2e8a2e2$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $08c364d5f2e8a2e2$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $08c364d5f2e8a2e2$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $08c364d5f2e8a2e2$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $08c364d5f2e8a2e2$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $08c364d5f2e8a2e2$var$traverseTree(data[i].children, cb);
    }
}
function $08c364d5f2e8a2e2$export$2e2bcd8739ae039(option, isTheme) {
    (0, $94b0f4e27af8fdaa$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $08bfa015475effa8$export$4f07b212a02c8051)(option.series);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $08c364d5f2e8a2e2$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$08c364d5f2e8a2e2$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $08c364d5f2e8a2e2$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $08c364d5f2e8a2e2$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $08c364d5f2e8a2e2$var$compatBarItemStyle(seriesOpt);
            $08c364d5f2e8a2e2$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $08c364d5f2e8a2e2$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if ((0, $5f0Cq._)(data[i]) === 'object') {
                    $08c364d5f2e8a2e2$var$compatBarItemStyle(data[i]);
                    $08c364d5f2e8a2e2$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $08c364d5f2e8a2e2$var$compatSunburstState(seriesOpt);
            $08c364d5f2e8a2e2$var$traverseTree(seriesOpt.data, $08c364d5f2e8a2e2$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $08c364d5f2e8a2e2$var$compatGraphFocus(seriesOpt);
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $08c364d5f2e8a2e2$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($08c364d5f2e8a2e2$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(options, function(option) {
                $08c364d5f2e8a2e2$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $f7caef33b9973858$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack');
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.push(stackInfo);
        }
    });
    // Process each stack group
    stackInfoMap.each(function(stackInfoList) {
        if (stackInfoList.length === 0) return;
        // Check if stack order needs to be reversed
        var firstSeries = stackInfoList[0].seriesModel;
        var stackOrder = firstSeries.get('stackOrder') || 'seriesAsc';
        if (stackOrder === 'seriesDesc') stackInfoList.reverse();
        // Set stackedOnSeries for each series in the final order
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(stackInfoList, function(stackInfo, index) {
            stackInfo.data.setCalculationInfo('stackedOnSeries', index > 0 ? stackInfoList[index - 1].seriesModel : null);
        });
        // Calculate stack values
        $f7caef33b9973858$var$calculateStack(stackInfoList);
    });
}
function $f7caef33b9973858$var$calculateStack(stackInfoList) {
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign';
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === 'all' // single stack group
                     || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $bfe945a83b4d28b9$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $628ec8437ba688c7$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $b80138b23bdc0dba$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $b80138b23bdc0dba$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $fbbcfa54d383b92f$export$c51adf1a2be01b9c)(this, i) === (0, $fbbcfa54d383b92f$export$328749e9c5b40760).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $628ec8437ba688c7$export$22b808bc02a60488(val) {
    return val instanceof $628ec8437ba688c7$var$SourceImpl;
}
function $628ec8437ba688c7$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $628ec8437ba688c7$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $628ec8437ba688c7$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $628ec8437ba688c7$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $628ec8437ba688c7$export$75aef3f97c0a5edf(data) {
    return new $628ec8437ba688c7$var$SourceImpl({
        data: data,
        sourceFormat: (0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(data) ? (0, $b80138b23bdc0dba$export$a918cb016a382d45) : (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6)
    });
}
function $628ec8437ba688c7$export$e0365e7e3555ddd4(source) {
    return new $628ec8437ba688c7$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $628ec8437ba688c7$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $b80138b23bdc0dba$export$c78f1330778d30d);
    if ((0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $b80138b23bdc0dba$export$a918cb016a382d45);
    else if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $b80138b23bdc0dba$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(item) || (0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $b80138b23bdc0dba$export$fcd62ebf51387903);
                break;
            } else if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $b80138b23bdc0dba$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)(data, key) && (0, $99026af6cdabc3e1$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $b80138b23bdc0dba$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $628ec8437ba688c7$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $628ec8437ba688c7$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $b80138b23bdc0dba$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $628ec8437ba688c7$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $628ec8437ba688c7$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $b80138b23bdc0dba$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $b80138b23bdc0dba$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $628ec8437ba688c7$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $b80138b23bdc0dba$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6)) {
        var value0 = (0, $08bfa015475effa8$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $628ec8437ba688c7$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $628ec8437ba688c7$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $628ec8437ba688c7$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += '';
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $628ec8437ba688c7$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $b80138b23bdc0dba$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $628ec8437ba688c7$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $b80138b23bdc0dba$export$703ae8a2d83f441) || sourceFormat === (0, $b80138b23bdc0dba$export$6a32b42c754a3cb8);
}




var $6f754cc48dca56f7$var$_a, $6f754cc48dca56f7$var$_b, $6f754cc48dca56f7$var$_c, $6f754cc48dca56f7$var$_d;
var $6f754cc48dca56f7$var$providerMethods;
var $6f754cc48dca56f7$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $6f754cc48dca56f7$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $628ec8437ba688c7$export$22b808bc02a60488)(sourceParam) ? (0, $628ec8437ba688c7$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        var sourceFormat = source.sourceFormat;
        var seriesLayoutBy = source.seriesLayoutBy;
        // Typed array. TODO IE10+?
        if (sourceFormat === (0, $b80138b23bdc0dba$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        var validator;
        $6f754cc48dca56f7$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $6f754cc48dca56f7$var$mountMethods = function mountMethods(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $6f754cc48dca56f7$var$providerMethods[$6f754cc48dca56f7$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $99026af6cdabc3e1$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $b80138b23bdc0dba$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $6f754cc48dca56f7$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $6f754cc48dca56f7$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function getItemForTypedArray(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function fillStorageForTypedArray(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function countForTypedArray() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $6f754cc48dca56f7$var$providerMethods = (_a = {}, _a[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function appendData() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $b80138b23bdc0dba$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $b80138b23bdc0dba$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function appendData(newData) {
                var data = this._data;
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $b80138b23bdc0dba$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $b80138b23bdc0dba$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function appendData(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function clean() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $6f754cc48dca56f7$var$validateSimply = function validateSimply(rawData) {
    if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(rawData)) (0, $2c7aa3955e1b7354$export$a3bc9b8ed74fc)('series.data or dataset.source must be an array.');
};
/**
 * Only run in dev mode - hint users for debug.
 */ var $6f754cc48dca56f7$var$rawSourceDataValidatorMap = ($6f754cc48dca56f7$var$_a = {}, $6f754cc48dca56f7$var$_a[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b)] = $6f754cc48dca56f7$var$validateSimply, $6f754cc48dca56f7$var$_a[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$d55da1467cdf7804)] = $6f754cc48dca56f7$var$validateSimply, $6f754cc48dca56f7$var$_a[0, $b80138b23bdc0dba$export$703ae8a2d83f441] = $6f754cc48dca56f7$var$validateSimply, $6f754cc48dca56f7$var$_a[0, $b80138b23bdc0dba$export$6a32b42c754a3cb8] = function rawSourceDataValidatorMap(rawData, dimsDef) {
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        if (dimName == null) (0, $2c7aa3955e1b7354$export$a3bc9b8ed74fc)('dimension name must not be null/undefined.');
    }
}, $6f754cc48dca56f7$var$_a[0, $b80138b23bdc0dba$export$2823037fb9d8f0c6] = $6f754cc48dca56f7$var$validateSimply, $6f754cc48dca56f7$var$_a);
var $6f754cc48dca56f7$var$getItemSimply = function getItemSimply(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $6f754cc48dca56f7$var$rawSourceItemGetterMap = ($6f754cc48dca56f7$var$_b = {}, $6f754cc48dca56f7$var$_b[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b)] = function rawSourceItemGetterMap(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $6f754cc48dca56f7$var$_b[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $6f754cc48dca56f7$var$_b[0, $b80138b23bdc0dba$export$703ae8a2d83f441] = $6f754cc48dca56f7$var$getItemSimply, $6f754cc48dca56f7$var$_b[0, $b80138b23bdc0dba$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = dimName != null ? rawData[dimName] : null;
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $6f754cc48dca56f7$var$_b[0, $b80138b23bdc0dba$export$2823037fb9d8f0c6] = $6f754cc48dca56f7$var$getItemSimply, $6f754cc48dca56f7$var$_b);
function $6f754cc48dca56f7$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $6f754cc48dca56f7$var$rawSourceItemGetterMap[$6f754cc48dca56f7$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $6f754cc48dca56f7$var$countSimply = function countSimply(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $6f754cc48dca56f7$var$rawSourceDataCounterMap = ($6f754cc48dca56f7$var$_c = {}, $6f754cc48dca56f7$var$_c[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b)] = function rawSourceDataCounterMap(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $6f754cc48dca56f7$var$_c[(0, $b80138b23bdc0dba$export$fcd62ebf51387903) + '_' + (0, $b80138b23bdc0dba$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $6f754cc48dca56f7$var$_c[0, $b80138b23bdc0dba$export$703ae8a2d83f441] = $6f754cc48dca56f7$var$countSimply, $6f754cc48dca56f7$var$_c[0, $b80138b23bdc0dba$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = dimName != null ? rawData[dimName] : null;
    return col ? col.length : 0;
}, $6f754cc48dca56f7$var$_c[0, $b80138b23bdc0dba$export$2823037fb9d8f0c6] = $6f754cc48dca56f7$var$countSimply, $6f754cc48dca56f7$var$_c);
function $6f754cc48dca56f7$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $6f754cc48dca56f7$var$rawSourceDataCounterMap[$6f754cc48dca56f7$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $6f754cc48dca56f7$var$getRawValueSimply = function getRawValueSimply(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $6f754cc48dca56f7$var$rawSourceValueGetterMap = ($6f754cc48dca56f7$var$_d = {}, $6f754cc48dca56f7$var$_d[0, $b80138b23bdc0dba$export$fcd62ebf51387903] = $6f754cc48dca56f7$var$getRawValueSimply, $6f754cc48dca56f7$var$_d[0, $b80138b23bdc0dba$export$703ae8a2d83f441] = function rawSourceValueGetterMap(dataItem, dimIndex, property) {
    return dataItem[property];
}, $6f754cc48dca56f7$var$_d[0, $b80138b23bdc0dba$export$6a32b42c754a3cb8] = $6f754cc48dca56f7$var$getRawValueSimply, $6f754cc48dca56f7$var$_d[0, $b80138b23bdc0dba$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $08bfa015475effa8$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $6f754cc48dca56f7$var$_d[0, $b80138b23bdc0dba$export$a918cb016a382d45] = $6f754cc48dca56f7$var$getRawValueSimply, $6f754cc48dca56f7$var$_d);
function $6f754cc48dca56f7$export$1752de8084789a14(sourceFormat) {
    var method = $6f754cc48dca56f7$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $6f754cc48dca56f7$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $b80138b23bdc0dba$export$fcd62ebf51387903) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
}
function $6f754cc48dca56f7$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $6f754cc48dca56f7$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6)) result = (0, $08bfa015475effa8$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $6f754cc48dca56f7$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6) && sourceFormat !== (0, $b80138b23bdc0dba$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6) && !(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $7d8ad306dbc6dcbb$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $7d8ad306dbc6dcbb$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $99026af6cdabc3e1$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if ($99026af6cdabc3e1$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($99026af6cdabc3e1$export$844ec244b1367d54(formatter)) {
            var str = (0, $031dcf3d7ed28374$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($7d8ad306dbc6dcbb$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $6f754cc48dca56f7$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $99026af6cdabc3e1$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $6f754cc48dca56f7$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $7d8ad306dbc6dcbb$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($99026af6cdabc3e1$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $2b406be0c81d4324$export$f7292ab7796be73c(define) {
    return new $2b406be0c81d4324$export$2dea7024bcdd7731(define);
}
var $2b406be0c81d4324$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $2b406be0c81d4324$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $2b406be0c81d4324$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $2b406be0c81d4324$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function reset(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5f0Cq = parcelRequire("5f0Cq");



function $73a7ec854790f63e$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' && !(0, $99026af6cdabc3e1$export$7e4aa119212bc614)(value) && value != null && value !== '-') value = +(0, $bfe945a83b4d28b9$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN : Number(value);
}
var $73a7ec854790f63e$var$valueParserMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $bfe945a83b4d28b9$export$6b862160d295c8e)(val);
    },
    'trim': function(val) {
        return (0, $99026af6cdabc3e1$export$844ec244b1367d54)(val) ? (0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $73a7ec854790f63e$export$c88237b7c265b36b(type) {
    return $73a7ec854790f63e$var$valueParserMap.get(type);
}
var $73a7ec854790f63e$var$ORDER_COMPARISON_OP_MAP = {
    lt: function lt(lval, rval) {
        return lval < rval;
    },
    lte: function lte(lval, rval) {
        return lval <= rval;
    },
    gt: function gt(lval, rval) {
        return lval > rval;
    },
    gte: function gte(lval, rval) {
        return lval >= rval;
    }
};
var $73a7ec854790f63e$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rval)) {
            var errMsg = '';
            (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $73a7ec854790f63e$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $bfe945a83b4d28b9$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $bfe945a83b4d28b9$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $73a7ec854790f63e$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(lval) ? lval : (0, $bfe945a83b4d28b9$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rval) ? rval : (0, $bfe945a83b4d28b9$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $99026af6cdabc3e1$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $99026af6cdabc3e1$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $73a7ec854790f63e$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval === "undefined" ? "undefined" : (0, $5f0Cq._)(rval);
        this._rvalFloat = (0, $bfe945a83b4d28b9$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval === "undefined" ? "undefined" : (0, $5f0Cq._)(lval);
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $bfe945a83b4d28b9$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $73a7ec854790f63e$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $73a7ec854790f63e$var$FilterEqualityComparator(op === 'eq', rval) : (0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)($73a7ec854790f63e$var$ORDER_COMPARISON_OP_MAP, op) ? new $73a7ec854790f63e$var$FilterOrderComparator(op, rval) : null;
}




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $4df6b4db1a848cc4$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $73a7ec854790f63e$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $4df6b4db1a848cc4$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $4df6b4db1a848cc4$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b)) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $6f754cc48dca56f7$export$92c8ea8642b3957d)(sourceFormat, (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $99026af6cdabc3e1$export$2385a24977818dd0)($4df6b4db1a848cc4$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $99026af6cdabc3e1$export$2385a24977818dd0)($4df6b4db1a848cc4$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $6f754cc48dca56f7$export$803742e832f4b52c)(sourceFormat, (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b));
    extSource.count = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $6f754cc48dca56f7$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function retrieveValueFromItem(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $99026af6cdabc3e1$export$2385a24977818dd0)($4df6b4db1a848cc4$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $99026af6cdabc3e1$export$2385a24977818dd0)($4df6b4db1a848cc4$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $4df6b4db1a848cc4$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$4df6b4db1a848cc4$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $4df6b4db1a848cc4$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$4df6b4db1a848cc4$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $b80138b23bdc0dba$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $b80138b23bdc0dba$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $4df6b4db1a848cc4$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $4df6b4db1a848cc4$var$cloneAllDimensionInfo(dimensions) {
    return (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(dimensions);
}
var $4df6b4db1a848cc4$var$externalTransformMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
function $4df6b4db1a848cc4$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $4df6b4db1a848cc4$var$externalTransformMap.set(type, externalTransform);
}
function $4df6b4db1a848cc4$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $08bfa015475effa8$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $4df6b4db1a848cc4$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $4df6b4db1a848cc4$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(transOption)) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $4df6b4db1a848cc4$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $4df6b4db1a848cc4$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $08bfa015475effa8$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(result)) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $628ec8437ba688c7$export$52a469afa4653e57)(result.data);
        if (!$4df6b4db1a848cc4$var$isSupportedSourceFormat(sourceFormat)) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $b80138b23bdc0dba$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $628ec8437ba688c7$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $4df6b4db1a848cc4$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $b80138b23bdc0dba$export$fcd62ebf51387903) || sourceFormat === (0, $b80138b23bdc0dba$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5f0Cq = parcelRequire("5f0Cq");



var $6ad4751b8ddd4ab8$var$UNDEFINED = 'undefined';
var $6ad4751b8ddd4ab8$export$859a1fa4f1106aa0 = (typeof Uint32Array === "undefined" ? "undefined" : (0, $5f0Cq._)(Uint32Array)) === $6ad4751b8ddd4ab8$var$UNDEFINED ? Array : Uint32Array;
var $6ad4751b8ddd4ab8$export$78cf73566f32c185 = (typeof Uint16Array === "undefined" ? "undefined" : (0, $5f0Cq._)(Uint16Array)) === $6ad4751b8ddd4ab8$var$UNDEFINED ? Array : Uint16Array;
var $6ad4751b8ddd4ab8$export$b60d945128546f53 = (typeof Int32Array === "undefined" ? "undefined" : (0, $5f0Cq._)(Int32Array)) === $6ad4751b8ddd4ab8$var$UNDEFINED ? Array : Int32Array;
var $6ad4751b8ddd4ab8$export$365b104db51a490a = (typeof Float64Array === "undefined" ? "undefined" : (0, $5f0Cq._)(Float64Array)) === $6ad4751b8ddd4ab8$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $6ad4751b8ddd4ab8$var$dataCtors = {
    'float': $6ad4751b8ddd4ab8$export$365b104db51a490a,
    'int': $6ad4751b8ddd4ab8$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $6ad4751b8ddd4ab8$export$365b104db51a490a
};
var $6ad4751b8ddd4ab8$var$defaultDimValueGetters;
function $6ad4751b8ddd4ab8$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $6ad4751b8ddd4ab8$export$859a1fa4f1106aa0 : $6ad4751b8ddd4ab8$export$78cf73566f32c185;
}
function $6ad4751b8ddd4ab8$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $6ad4751b8ddd4ab8$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $6ad4751b8ddd4ab8$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $6ad4751b8ddd4ab8$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $6ad4751b8ddd4ab8$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $6ad4751b8ddd4ab8$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $628ec8437ba688c7$export$8911336b527f8517)(source);
        this._dimensions = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $6ad4751b8ddd4ab8$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $6ad4751b8ddd4ab8$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $6ad4751b8ddd4ab8$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $6ad4751b8ddd4ab8$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $6ad4751b8ddd4ab8$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $6ad4751b8ddd4ab8$var$getInitialExtent();
            $6ad4751b8ddd4ab8$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $6ad4751b8ddd4ab8$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $6ad4751b8ddd4ab8$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $6ad4751b8ddd4ab8$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $6ad4751b8ddd4ab8$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if ((typeof retValue === "undefined" ? "undefined" : (0, $5f0Cq._)(retValue)) !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($6ad4751b8ddd4ab8$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($6ad4751b8ddd4ab8$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $6ad4751b8ddd4ab8$var$getInitialExtent();
        var newIndices = new ($6ad4751b8ddd4ab8$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $6ad4751b8ddd4ab8$var$getInitialExtent();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $99026af6cdabc3e1$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $6ad4751b8ddd4ab8$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $73a7ec854790f63e$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $6ad4751b8ddd4ab8$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function objectRows(dataItem, property, dataIndex, dimIndex) {
                return (0, $73a7ec854790f63e$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function original(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $73a7ec854790f63e$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function typedArray(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $6ad4751b8ddd4ab8$export$2e2bcd8739ae039 = $6ad4751b8ddd4ab8$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $b51e00c7e02f807b$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($b51e00c7e02f807b$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $99026af6cdabc3e1$export$b119cc7e1840e59c)(data) ? (0, $b80138b23bdc0dba$export$a918cb016a382d45) : (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $628ec8437ba688c7$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $628ec8437ba688c7$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $b51e00c7e02f807b$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $b51e00c7e02f807b$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $4df6b4db1a848cc4$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $628ec8437ba688c7$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($b51e00c7e02f807b$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $6ad4751b8ddd4ab8$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $6f754cc48dca56f7$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($b51e00c7e02f807b$var$isSeries(sourceHost)) {
            var datasetModel = (0, $fbbcfa54d383b92f$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)((0, $fbbcfa54d383b92f$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($b51e00c7e02f807b$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $b51e00c7e02f807b$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $99026af6cdabc3e1$export$112e66431016387b)(datasetModel.option.transform);
}
function $b51e00c7e02f807b$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $b51e00c7e02f807b$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0d43100c4c4de5e1$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
function $0d43100c4c4de5e1$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $0d43100c4c4de5e1$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(lineHeight + '') + "px";
}
// TODO: more textStyle option
function $0d43100c4c4de5e1$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.tertiary;
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.secondary;
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(nameFontSize + '') + "px;color:" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(valueFontSize + '') + "px;color:" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $0d43100c4c4de5e1$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $0d43100c4c4de5e1$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
];
function $0d43100c4c4de5e1$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $0d43100c4c4de5e1$var$isSectionFragment(frag) {
    return frag.type === 'section';
}
function $0d43100c4c4de5e1$var$getBuilder(frag) {
    return $0d43100c4c4de5e1$var$isSectionFragment(frag) ? $0d43100c4c4de5e1$var$buildSection : $0d43100c4c4de5e1$var$buildNameValue;
}
function $0d43100c4c4de5e1$var$getBlockGapLevel(frag) {
    if ($0d43100c4c4de5e1$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $0d43100c4c4de5e1$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $0d43100c4c4de5e1$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $0d43100c4c4de5e1$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $0d43100c4c4de5e1$var$getGap($0d43100c4c4de5e1$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $99026af6cdabc3e1$export$a7a9523472993e97)(!subBlocks || (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $73a7ec854790f63e$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $0d43100c4c4de5e1$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $99026af6cdabc3e1$export$8b58be045bf06082)((0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $0d43100c4c4de5e1$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $031dcf3d7ed28374$export$3cd8db88714decfc)(fragment.header, 'ordinal', ctx.useUTC);
    var nameStyle = $0d43100c4c4de5e1$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $0d43100c4c4de5e1$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === 'richText') return $0d43100c4c4de5e1$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $0d43100c4c4de5e1$var$wrapBlockHTML(toolTipTextStyle, "<div style=\"" + nameStyle + ";" + tooltipLineHeight + ";\">" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
}
function $0d43100c4c4de5e1$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $031dcf3d7ed28374$export$3cd8db88714decfc)(val, (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.secondary, renderMode);
    var readableName = noName ? '' : (0, $031dcf3d7ed28374$export$3cd8db88714decfc)(name, 'ordinal', useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.dataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $0d43100c4c4de5e1$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $0d43100c4c4de5e1$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $0d43100c4c4de5e1$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $0d43100c4c4de5e1$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? '' : markerStr) + (noName ? '' : $0d43100c4c4de5e1$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $0d43100c4c4de5e1$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $0d43100c4c4de5e1$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $0d43100c4c4de5e1$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $0d43100c4c4de5e1$var$getGap(gapLevel) {
    return {
        html: $0d43100c4c4de5e1$var$HTML_GAPS[gapLevel],
        richText: $0d43100c4c4de5e1$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $0d43100c4c4de5e1$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $0d43100c4c4de5e1$var$getTooltipLineHeight(textStyle);
    return "<div style=\"" + marginCSS + ";" + tooltipLineHeight + ";\">" + encodedContent + clearfix + '</div>';
}
function $0d43100c4c4de5e1$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(name) + '</span>';
}
function $0d43100c4c4de5e1$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    valueList = (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $0d43100c4c4de5e1$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $0d43100c4c4de5e1$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(values) ? values.join('  ') : values, styles);
}
function $0d43100c4c4de5e1$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $031dcf3d7ed28374$export$cda04d03233e5555)(color);
}
function $0d43100c4c4de5e1$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $0d43100c4c4de5e1$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $bfe945a83b4d28b9$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $031dcf3d7ed28374$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(styles)) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $99026af6cdabc3e1$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $99026af6cdabc3e1$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $f72341b8bab9ff1e$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(value);
    var markerColor = (0, $0d43100c4c4de5e1$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $f72341b8bab9ff1e$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $6f754cc48dca56f7$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $08bfa015475effa8$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $0d43100c4c4de5e1$export$cf63b23ce77d1921)('section', {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $0d43100c4c4de5e1$export$cf63b23ce77d1921)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                dataIndex: dataIndex
            })
        ].concat(subBlocks || [])
    });
}
function $f72341b8bab9ff1e$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $99026af6cdabc3e1$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $6f754cc48dca56f7$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $0d43100c4c4de5e1$export$cf63b23ce77d1921)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $358fe4ff615f1b87$var$inner = $08bfa015475effa8$export$64df9f8d92ae083f();
function $358fe4ff615f1b87$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $358fe4ff615f1b87$export$e960441116ae2799 = '__universalTransitionEnabled';
var $358fe4ff615f1b87$var$SeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $2b406be0c81d4324$export$f7292ab7796be73c)({
            count: $358fe4ff615f1b87$var$dataTaskCount,
            reset: $358fe4ff615f1b87$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $358fe4ff615f1b87$var$inner(this).sourceManager = new (0, $b51e00c7e02f807b$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $358fe4ff615f1b87$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $358fe4ff615f1b87$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $358fe4ff615f1b87$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $4fb3a6a3c6974639$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $4fb3a6a3c6974639$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $fefeb1a173623ab2$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += 'Series';
        $99026af6cdabc3e1$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $99026af6cdabc3e1$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $08bfa015475effa8$export$abdcc6a26372f94b(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $4fb3a6a3c6974639$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $99026af6cdabc3e1$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $4fb3a6a3c6974639$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $4fb3a6a3c6974639$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $358fe4ff615f1b87$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $358fe4ff615f1b87$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $358fe4ff615f1b87$var$inner(this).dataBeforeProcessed = data;
        $358fe4ff615f1b87$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$99026af6cdabc3e1$export$b119cc7e1840e59c(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $08bfa015475effa8$export$abdcc6a26372f94b(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $358fe4ff615f1b87$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $358fe4ff615f1b87$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $358fe4ff615f1b87$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $358fe4ff615f1b87$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $99026af6cdabc3e1$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $358fe4ff615f1b87$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $358fe4ff615f1b87$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Retrieve the index of nearest value in the view coordinate.
   * Data position is compared with each axis's dataToCoord.
   *
   * @param axisDim axis dimension
   * @param dim data dimension
   * @param value
   * @param [maxDistance=Infinity] The maximum distance in view coordinate space
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesModel.prototype.indicesOfNearest = function(axisDim, dim, value, maxDistance) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var axis = coordSys && coordSys.getAxis(axisDim);
        if (!coordSys || !axis) return [];
        var targetCoord = axis.dataToCoord(value);
        if (maxDistance == null) maxDistance = Infinity;
        var nearestIndices = [];
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        data.each(dim, function(dimValue, idx) {
            var dataCoord = axis.dataToCoord(dimValue);
            var diff = targetCoord - dataCoord;
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = idx;
            }
        });
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $f72341b8bab9ff1e$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $e870be04527b939a$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $0a689a6d69e1cd3c$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === 'series' || selectedMap === 'all') {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $358fe4ff615f1b87$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === 'all') return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $99026af6cdabc3e1$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === 'all' || selectedMap[$358fe4ff615f1b87$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            'select',
            'disabled'
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$358fe4ff615f1b87$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'series') option.selectedMap = 'all';
        else if (selectedMode === 'multiple') {
            if (!$99026af6cdabc3e1$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $358fe4ff615f1b87$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $358fe4ff615f1b87$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle';
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
$99026af6cdabc3e1$export$e36fc9d62a853069($358fe4ff615f1b87$var$SeriesModel, (0, $7d8ad306dbc6dcbb$export$f23396ae04ea95a7));
$99026af6cdabc3e1$export$e36fc9d62a853069($358fe4ff615f1b87$var$SeriesModel, (0, $0a689a6d69e1cd3c$export$55a3c39e852b90f4));
(0, $cdb9e13510266a6e$export$c9c2d87774f1275d)($358fe4ff615f1b87$var$SeriesModel, (0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $358fe4ff615f1b87$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$08bfa015475effa8$export$beae19a2652b3368(seriesModel)) seriesModel.name = $358fe4ff615f1b87$var$getSeriesAutoName(seriesModel) || name;
}
function $358fe4ff615f1b87$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $99026af6cdabc3e1$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $358fe4ff615f1b87$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $358fe4ff615f1b87$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $358fe4ff615f1b87$var$dataTaskProgress;
}
function $358fe4ff615f1b87$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $358fe4ff615f1b87$var$wrapData(data, seriesModel) {
    $99026af6cdabc3e1$export$79b2f7037acddd43($99026af6cdabc3e1$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $99026af6cdabc3e1$export$c3095a23b368d1f2($358fe4ff615f1b87$var$onDataChange, seriesModel));
    });
}
function $358fe4ff615f1b87$var$onDataChange(seriesModel, newList) {
    var task = $358fe4ff615f1b87$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $358fe4ff615f1b87$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $358fe4ff615f1b87$export$2e2bcd8739ae039 = $358fe4ff615f1b87$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $3e14d76796640b86$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $2b89655bc310a947$export$2e2bcd8739ae039)();
        this.uid = $ea311bef09818b2f$export$6d2b3473b0986646('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$cdb9e13510266a6e$export$cd4c3a4dca301c70($3e14d76796640b86$var$ComponentView);
$cdb9e13510266a6e$export$241315e45585454d($3e14d76796640b86$var$ComponentView);
var $3e14d76796640b86$export$2e2bcd8739ae039 = $3e14d76796640b86$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $8771d8b8a75043c1$export$2e2bcd8739ae039() {
    var inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}




var $01349fdbc71d745c$var$inner = $08bfa015475effa8$export$64df9f8d92ae083f();
var $01349fdbc71d745c$var$renderPlanner = (0, $8771d8b8a75043c1$export$2e2bcd8739ae039)();
var $01349fdbc71d745c$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $2b89655bc310a947$export$2e2bcd8739ae039)();
        this.uid = $ea311bef09818b2f$export$6d2b3473b0986646('viewChart');
        this.renderTask = (0, $2b406be0c81d4324$export$f7292ab7796be73c)({
            plan: $01349fdbc71d745c$var$renderTaskPlan,
            reset: $01349fdbc71d745c$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $01349fdbc71d745c$var$toggleHighlight(data, payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $01349fdbc71d745c$var$toggleHighlight(data, payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $055606553475f5d6$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $01349fdbc71d745c$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $01349fdbc71d745c$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $ea1f7a1fbd33fd2d$export$77d1445f699c58b5)(el)) (state === 'emphasis' ? (0, $ea1f7a1fbd33fd2d$export$b2d02638cc34c042) : (0, $ea1f7a1fbd33fd2d$export$11be6f716239ac55))(el, highlightDigit);
}
function $01349fdbc71d745c$var$toggleHighlight(data, payload, state) {
    var dataIndex = $08bfa015475effa8$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $ea1f7a1fbd33fd2d$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($08bfa015475effa8$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $01349fdbc71d745c$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $01349fdbc71d745c$var$elSetState(el, state, highlightDigit);
    });
}
$cdb9e13510266a6e$export$cd4c3a4dca301c70($01349fdbc71d745c$var$ChartView, [
    'dispose'
]);
$cdb9e13510266a6e$export$241315e45585454d($01349fdbc71d745c$var$ChartView);
function $01349fdbc71d745c$var$renderTaskPlan(context) {
    return $01349fdbc71d745c$var$renderPlanner(context.model);
}
function $01349fdbc71d745c$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $01349fdbc71d745c$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $01349fdbc71d745c$var$progressMethodMap[methodName];
}
var $01349fdbc71d745c$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function progress(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function progress(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $01349fdbc71d745c$export$2e2bcd8739ae039 = $01349fdbc71d745c$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b4484a22f72674c6$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $b4484a22f72674c6$var$RATE = '\0__throttleRate';
var $b4484a22f72674c6$var$THROTTLE_TYPE = '\0__throttleType';
function $b4484a22f72674c6$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function cb() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $b4484a22f72674c6$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$b4484a22f72674c6$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$b4484a22f72674c6$var$THROTTLE_TYPE];
    var lastRate = fn[$b4484a22f72674c6$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $b4484a22f72674c6$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$b4484a22f72674c6$var$ORIGIN_METHOD] = originFn;
        fn[$b4484a22f72674c6$var$THROTTLE_TYPE] = throttleType;
        fn[$b4484a22f72674c6$var$RATE] = rate;
    }
    return fn;
}
function $b4484a22f72674c6$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$b4484a22f72674c6$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$b4484a22f72674c6$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $e5c3df17d5a674f3$var$inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $e5c3df17d5a674f3$var$defaultStyleMappers = {
    itemStyle: (0, $9a62b05a77f65632$export$2e2bcd8739ae039)((0, $6a8488c27a3e9cc8$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $9a62b05a77f65632$export$2e2bcd8739ae039)((0, $44542845f644b8de$export$9f34de5b59222949), true)
};
var $e5c3df17d5a674f3$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $e5c3df17d5a674f3$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $e5c3df17d5a674f3$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $e5c3df17d5a674f3$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $e5c3df17d5a674f3$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $e5c3df17d5a674f3$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $e5c3df17d5a674f3$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function reset(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $e5c3df17d5a674f3$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $e5c3df17d5a674f3$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function dataEach(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $e5c3df17d5a674f3$var$sharedModel = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)();
var $e5c3df17d5a674f3$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function reset(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var getStyle = $e5c3df17d5a674f3$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $e5c3df17d5a674f3$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($e5c3df17d5a674f3$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $99026af6cdabc3e1$export$8b58be045bf06082)(existsStyle, style);
                    if ($e5c3df17d5a674f3$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $e5c3df17d5a674f3$var$sharedModel.option.decal);
                        $e5c3df17d5a674f3$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $e5c3df17d5a674f3$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function overallReset(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $e5c3df17d5a674f3$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $e5c3df17d5a674f3$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $e5c3df17d5a674f3$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8994ca305e5da023$var$PI = Math.PI;
function $8994ca305e5da023$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $99026af6cdabc3e1$export$ebe90cb607ad99e(opts, {
        text: 'loading',
        textColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.primary,
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255,255,255,0.8)',
        showSpinner: true,
        color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.theme[0],
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $2b89655bc310a947$export$2e2bcd8739ae039();
    var mask = new $aed3569651b5e3fa$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $97dfecd189304201$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $aed3569651b5e3fa$export$2e2bcd8739ae039({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $b15edc33cfe8221b$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$8994ca305e5da023$var$PI / 2,
                endAngle: -$8994ca305e5da023$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $8994ca305e5da023$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $8994ca305e5da023$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $8c01c749bf05ba4b$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count();
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold');
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $99026af6cdabc3e1$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $2b406be0c81d4324$export$f7292ab7796be73c)({
                plan: $8c01c749bf05ba4b$var$seriesTaskPlan,
                reset: $8c01c749bf05ba4b$var$seriesTaskReset,
                count: $8c01c749bf05ba4b$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $2b406be0c81d4324$export$f7292ab7796be73c)({
            reset: $8c01c749bf05ba4b$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $99026af6cdabc3e1$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $2b406be0c81d4324$export$f7292ab7796be73c)({
                reset: $8c01c749bf05ba4b$var$stubReset,
                onDirty: $8c01c749bf05ba4b$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $8c01c749bf05ba4b$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $ea311bef09818b2f$export$6d2b3473b0986646)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $8c01c749bf05ba4b$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $8c01c749bf05ba4b$var$stubReset(context) {
    return context.overallProgress && $8c01c749bf05ba4b$var$stubProgress;
}
function $8c01c749bf05ba4b$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $8c01c749bf05ba4b$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $8c01c749bf05ba4b$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $8c01c749bf05ba4b$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $08bfa015475effa8$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $8c01c749bf05ba4b$var$makeSeriesTaskProgress(idx);
    }) : $8c01c749bf05ba4b$var$singleSeriesTaskProgress;
}
var $8c01c749bf05ba4b$var$singleSeriesTaskProgress = $8c01c749bf05ba4b$var$makeSeriesTaskProgress(0);
function $8c01c749bf05ba4b$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $8c01c749bf05ba4b$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $8c01c749bf05ba4b$var$detectSeriseType(legacyFunc) {
    $8c01c749bf05ba4b$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($8c01c749bf05ba4b$var$ecModelMock, $8c01c749bf05ba4b$var$apiMock);
    } catch (e) {}
    return $8c01c749bf05ba4b$var$seriesType;
}
var $8c01c749bf05ba4b$var$ecModelMock = {};
var $8c01c749bf05ba4b$var$apiMock = {};
var $8c01c749bf05ba4b$var$seriesType;
$8c01c749bf05ba4b$var$mockMethods($8c01c749bf05ba4b$var$ecModelMock, (0, $d0f94fa2d299f1af$export$2e2bcd8739ae039));
$8c01c749bf05ba4b$var$mockMethods($8c01c749bf05ba4b$var$apiMock, (0, $f2525918be30f295$export$2e2bcd8739ae039));
$8c01c749bf05ba4b$var$ecModelMock.eachSeriesByType = $8c01c749bf05ba4b$var$ecModelMock.eachRawSeriesByType = function(type) {
    $8c01c749bf05ba4b$var$seriesType = type;
};
$8c01c749bf05ba4b$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $8c01c749bf05ba4b$var$seriesType = cond.subType;
};
function $8c01c749bf05ba4b$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $99026af6cdabc3e1$export$8793edee2d425525);
/* eslint-enable */ }
var $8c01c749bf05ba4b$export$2e2bcd8739ae039 = $8c01c749bf05ba4b$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fea6f2a0847222e0$var$color = (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).darkColor;
var $fea6f2a0847222e0$var$backgroundColor = $fea6f2a0847222e0$var$color.background;
var $fea6f2a0847222e0$var$axisCommon = function axisCommon() {
    return {
        axisLine: {
            lineStyle: {
                color: $fea6f2a0847222e0$var$color.axisLine
            }
        },
        splitLine: {
            lineStyle: {
                color: $fea6f2a0847222e0$var$color.axisSplitLine
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    $fea6f2a0847222e0$var$color.backgroundTint,
                    $fea6f2a0847222e0$var$color.backgroundTransparent
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: $fea6f2a0847222e0$var$color.axisMinorSplitLine
            }
        },
        axisLabel: {
            color: $fea6f2a0847222e0$var$color.axisLabel
        },
        axisName: {}
    };
};
var $fea6f2a0847222e0$var$matrixAxis = {
    label: {
        color: $fea6f2a0847222e0$var$color.secondary
    },
    itemStyle: {
        borderColor: $fea6f2a0847222e0$var$color.borderTint
    },
    dividerLineStyle: {
        color: $fea6f2a0847222e0$var$color.border
    }
};
var $fea6f2a0847222e0$var$theme = {
    darkMode: true,
    color: $fea6f2a0847222e0$var$color.theme,
    backgroundColor: $fea6f2a0847222e0$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: $fea6f2a0847222e0$var$color.border
        },
        crossStyle: {
            color: $fea6f2a0847222e0$var$color.borderShade
        },
        label: {
            color: $fea6f2a0847222e0$var$color.tertiary
        }
    },
    legend: {
        textStyle: {
            color: $fea6f2a0847222e0$var$color.secondary
        },
        pageTextStyle: {
            color: $fea6f2a0847222e0$var$color.tertiary
        }
    },
    textStyle: {
        color: $fea6f2a0847222e0$var$color.secondary
    },
    title: {
        textStyle: {
            color: $fea6f2a0847222e0$var$color.primary
        },
        subtextStyle: {
            color: $fea6f2a0847222e0$var$color.quaternary
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $fea6f2a0847222e0$var$color.accent50
        }
    },
    tooltip: {
        backgroundColor: $fea6f2a0847222e0$var$color.neutral20,
        defaultBorderColor: $fea6f2a0847222e0$var$color.border,
        textStyle: {
            color: $fea6f2a0847222e0$var$color.tertiary
        }
    },
    dataZoom: {
        borderColor: $fea6f2a0847222e0$var$color.accent10,
        textStyle: {
            color: $fea6f2a0847222e0$var$color.tertiary
        },
        brushStyle: {
            color: $fea6f2a0847222e0$var$color.backgroundTint
        },
        handleStyle: {
            color: $fea6f2a0847222e0$var$color.neutral00,
            borderColor: $fea6f2a0847222e0$var$color.accent20
        },
        moveHandleStyle: {
            color: $fea6f2a0847222e0$var$color.accent40
        },
        emphasis: {
            handleStyle: {
                borderColor: $fea6f2a0847222e0$var$color.accent50
            }
        },
        dataBackground: {
            lineStyle: {
                color: $fea6f2a0847222e0$var$color.accent30
            },
            areaStyle: {
                color: $fea6f2a0847222e0$var$color.accent20
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: $fea6f2a0847222e0$var$color.accent50
            },
            areaStyle: {
                color: $fea6f2a0847222e0$var$color.accent30
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $fea6f2a0847222e0$var$color.secondary
        },
        handleStyle: {
            borderColor: $fea6f2a0847222e0$var$color.neutral30
        }
    },
    timeline: {
        lineStyle: {
            color: $fea6f2a0847222e0$var$color.accent10
        },
        label: {
            color: $fea6f2a0847222e0$var$color.tertiary
        },
        controlStyle: {
            color: $fea6f2a0847222e0$var$color.accent30,
            borderColor: $fea6f2a0847222e0$var$color.accent30
        }
    },
    calendar: {
        itemStyle: {
            color: $fea6f2a0847222e0$var$color.neutral00,
            borderColor: $fea6f2a0847222e0$var$color.neutral20
        },
        dayLabel: {
            color: $fea6f2a0847222e0$var$color.tertiary
        },
        monthLabel: {
            color: $fea6f2a0847222e0$var$color.secondary
        },
        yearLabel: {
            color: $fea6f2a0847222e0$var$color.secondary
        }
    },
    matrix: {
        x: $fea6f2a0847222e0$var$matrixAxis,
        y: $fea6f2a0847222e0$var$matrixAxis,
        backgroundColor: {
            borderColor: $fea6f2a0847222e0$var$color.axisLine
        },
        body: {
            itemStyle: {
                borderColor: $fea6f2a0847222e0$var$color.borderTint
            }
        }
    },
    timeAxis: $fea6f2a0847222e0$var$axisCommon(),
    logAxis: $fea6f2a0847222e0$var$axisCommon(),
    valueAxis: $fea6f2a0847222e0$var$axisCommon(),
    categoryAxis: $fea6f2a0847222e0$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $fea6f2a0847222e0$var$color.theme
    },
    gauge: {
        title: {
            color: $fea6f2a0847222e0$var$color.secondary
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        $fea6f2a0847222e0$var$color.neutral05
                    ]
                ]
            }
        },
        axisLabel: {
            color: $fea6f2a0847222e0$var$color.axisLabel
        },
        detail: {
            color: $fea6f2a0847222e0$var$color.primary
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92'
        }
    },
    funnel: {
        itemStyle: {
            borderColor: $fea6f2a0847222e0$var$color.background
        }
    },
    radar: function() {
        var radar = $fea6f2a0847222e0$var$axisCommon();
        radar.axisName = {
            color: $fea6f2a0847222e0$var$color.axisLabel
        };
        radar.axisLine.lineStyle.color = $fea6f2a0847222e0$var$color.neutral20;
        return radar;
    }(),
    treemap: {
        breadcrumb: {
            itemStyle: {
                color: $fea6f2a0847222e0$var$color.neutral20,
                textStyle: {
                    color: $fea6f2a0847222e0$var$color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: $fea6f2a0847222e0$var$color.neutral30
                }
            }
        }
    },
    sunburst: {
        itemStyle: {
            borderColor: $fea6f2a0847222e0$var$color.background
        }
    },
    map: {
        itemStyle: {
            borderColor: $fea6f2a0847222e0$var$color.border,
            areaColor: $fea6f2a0847222e0$var$color.neutral10
        },
        label: {
            color: $fea6f2a0847222e0$var$color.tertiary
        },
        emphasis: {
            label: {
                color: $fea6f2a0847222e0$var$color.primary
            },
            itemStyle: {
                areaColor: $fea6f2a0847222e0$var$color.highlight
            }
        },
        select: {
            label: {
                color: $fea6f2a0847222e0$var$color.primary
            },
            itemStyle: {
                areaColor: $fea6f2a0847222e0$var$color.highlight
            }
        }
    },
    geo: {
        itemStyle: {
            borderColor: $fea6f2a0847222e0$var$color.border,
            areaColor: $fea6f2a0847222e0$var$color.neutral10
        },
        emphasis: {
            label: {
                color: $fea6f2a0847222e0$var$color.primary
            },
            itemStyle: {
                areaColor: $fea6f2a0847222e0$var$color.highlight
            }
        },
        select: {
            label: {
                color: $fea6f2a0847222e0$var$color.primary
            },
            itemStyle: {
                color: $fea6f2a0847222e0$var$color.highlight
            }
        }
    }
};
$fea6f2a0847222e0$var$theme.categoryAxis.splitLine.show = false;
var $fea6f2a0847222e0$export$2e2bcd8739ae039 = $fea6f2a0847222e0$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $10ed4f03aa6632a9$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($99026af6cdabc3e1$export$844ec244b1367d54(query)) {
            var condCptType = (0, $cdb9e13510266a6e$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $99026af6cdabc3e1$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $02593f791f8c8232$var$SYMBOL_PROPS_WITH_CB = [
    'symbol',
    'symbolSize',
    'symbolRotate',
    'symbolOffset'
];
var $02593f791f8c8232$var$SYMBOL_PROPS = $02593f791f8c8232$var$SYMBOL_PROPS_WITH_CB.concat([
    'symbolKeepAspect'
]);
// Encoding visual for all series include which is filtered for legend drawing
var $02593f791f8c8232$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function reset(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $02593f791f8c8232$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $02593f791f8c8232$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $99026af6cdabc3e1$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get('symbolKeepAspect')
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $02593f791f8c8232$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function reset(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $02593f791f8c8232$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $02593f791f8c8232$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $efea982454af0f4f$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $efea982454af0f4f$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $efea982454af0f4f$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $565b0fbbdfa36e81$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $99026af6cdabc3e1$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $565b0fbbdfa36e81$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $08bfa015475effa8$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $99026af6cdabc3e1$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $565b0fbbdfa36e81$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $565b0fbbdfa36e81$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $565b0fbbdfa36e81$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $565b0fbbdfa36e81$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $565b0fbbdfa36e81$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $565b0fbbdfa36e81$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $565b0fbbdfa36e81$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $2948406aad695582$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5f0Cq = parcelRequire("5f0Cq");
var $cc564f5d3dc1e7b9$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $cc564f5d3dc1e7b9$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $cc564f5d3dc1e7b9$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $cc564f5d3dc1e7b9$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($cc564f5d3dc1e7b9$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $cc564f5d3dc1e7b9$export$2e2bcd8739ae039 = $cc564f5d3dc1e7b9$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory






/**
 * Triangle shape
 * @inner
 */ var $daf140cd8c7d5a6f$var$Triangle = $d730b349402dd5f7$export$2e2bcd8739ae039.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $daf140cd8c7d5a6f$var$Diamond = $d730b349402dd5f7$export$2e2bcd8739ae039.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $daf140cd8c7d5a6f$var$Pin = $d730b349402dd5f7$export$2e2bcd8739ae039.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $daf140cd8c7d5a6f$var$Arrow = $d730b349402dd5f7$export$2e2bcd8739ae039.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function buildPath(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $daf140cd8c7d5a6f$var$symbolCtors = {
    line: $a32872499189f58f$export$2e2bcd8739ae039,
    rect: $aed3569651b5e3fa$export$2e2bcd8739ae039,
    roundRect: $aed3569651b5e3fa$export$2e2bcd8739ae039,
    square: $aed3569651b5e3fa$export$2e2bcd8739ae039,
    circle: $4f2941ceb07ff948$export$2e2bcd8739ae039,
    diamond: $daf140cd8c7d5a6f$var$Diamond,
    pin: $daf140cd8c7d5a6f$var$Pin,
    arrow: $daf140cd8c7d5a6f$var$Arrow,
    triangle: $daf140cd8c7d5a6f$var$Triangle
};
var $daf140cd8c7d5a6f$var$symbolShapeMakers = {
    line: function line(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function rect(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function roundRect(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function square(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function circle(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function diamond(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function pin(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function arrow(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function triangle(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $daf140cd8c7d5a6f$export$33fc3b478d332725 = {};
(0, $99026af6cdabc3e1$export$79b2f7037acddd43)($daf140cd8c7d5a6f$var$symbolCtors, function(Ctor, name) {
    $daf140cd8c7d5a6f$export$33fc3b478d332725[name] = new Ctor();
});
var $daf140cd8c7d5a6f$var$SymbolClz = $d730b349402dd5f7$export$2e2bcd8739ae039.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function calculateTextPosition1(out, config, rect) {
        var res = (0, $33d0653e48493c02$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function buildPath(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $daf140cd8c7d5a6f$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $daf140cd8c7d5a6f$export$33fc3b478d332725[symbolType];
            }
            $daf140cd8c7d5a6f$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $daf140cd8c7d5a6f$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral00;
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $daf140cd8c7d5a6f$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $055606553475f5d6$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $055606553475f5d6$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $daf140cd8c7d5a6f$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $daf140cd8c7d5a6f$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $daf140cd8c7d5a6f$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $daf140cd8c7d5a6f$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)((0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $aa8f13b286ce6e52$var$isSafeNum(num) {
    return isFinite(num);
}
function $aa8f13b286ce6e52$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $aa8f13b286ce6e52$var$isSafeNum(x) ? x : 0;
    x2 = $aa8f13b286ce6e52$var$isSafeNum(x2) ? x2 : 1;
    y = $aa8f13b286ce6e52$var$isSafeNum(y) ? y : 0;
    y2 = $aa8f13b286ce6e52$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $aa8f13b286ce6e52$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $aa8f13b286ce6e52$var$isSafeNum(x) ? x : 0.5;
    y = $aa8f13b286ce6e52$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $aa8f13b286ce6e52$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $aa8f13b286ce6e52$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $aa8f13b286ce6e52$export$57f098206d57a443(ctx, obj, rect) : $aa8f13b286ce6e52$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $aa8f13b286ce6e52$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $aa8f13b286ce6e52$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $aa8f13b286ce6e52$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        'width',
        'height'
    ][whIdx];
    var cwh = [
        'clientWidth',
        'clientHeight'
    ][whIdx];
    var plt = [
        'paddingLeft',
        'paddingTop'
    ][whIdx];
    var prb = [
        'paddingRight',
        'paddingBottom'
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $aa8f13b286ce6e52$var$parseInt10(stl[wh]) || $aa8f13b286ce6e52$var$parseInt10(root.style[wh])) - ($aa8f13b286ce6e52$var$parseInt10(stl[plt]) || 0) - ($aa8f13b286ce6e52$var$parseInt10(stl[prb]) || 0) | 0;
}







function $b34b04bbb42e79b9$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $b34b04bbb42e79b9$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $b34b04bbb42e79b9$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $26f334be467e031c$var$pathProxyForDraw = new (0, $a1b116230ebefd82$export$2e2bcd8739ae039)(true);
function $26f334be467e031c$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $26f334be467e031c$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $26f334be467e031c$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $26f334be467e031c$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $26f334be467e031c$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $26f334be467e031c$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $ead47d8961005a49$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $ead47d8961005a49$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $99026af6cdabc3e1$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $26f334be467e031c$var$brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = $26f334be467e031c$var$styleHasStroke(style);
    var hasFill = $26f334be467e031c$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $26f334be467e031c$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $aa8f13b286ce6e52$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $aa8f13b286ce6e52$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $26f334be467e031c$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $26f334be467e031c$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = strokePattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $b34b04bbb42e79b9$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $8feacd04f2aac739$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $26f334be467e031c$var$doStrokePath(ctx, style);
            if (hasFill) $26f334be467e031c$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $26f334be467e031c$var$doFillPath(ctx, style);
            if (hasStroke) $26f334be467e031c$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash) ctx.setLineDash([]);
}
function $26f334be467e031c$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $ead47d8961005a49$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $ead47d8961005a49$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $26f334be467e031c$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $1fba639b3abe29b0$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $b34b04bbb42e79b9$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($26f334be467e031c$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($26f334be467e031c$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($26f334be467e031c$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($26f334be467e031c$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $26f334be467e031c$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $26f334be467e031c$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $26f334be467e031c$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $26f334be467e031c$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $1ace62598f635263$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $26f334be467e031c$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $1ace62598f635263$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $26f334be467e031c$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $26f334be467e031c$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $26f334be467e031c$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $26f334be467e031c$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $1ace62598f635263$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $26f334be467e031c$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $26f334be467e031c$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $26f334be467e031c$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $26f334be467e031c$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $26f334be467e031c$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $26f334be467e031c$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $26f334be467e031c$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $26f334be467e031c$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $26f334be467e031c$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $26f334be467e031c$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $26f334be467e031c$var$STROKE_PROPS.length; i++){
        var prop = $26f334be467e031c$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $26f334be467e031c$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $26f334be467e031c$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $26f334be467e031c$var$bindCommonProps(ctx, $26f334be467e031c$var$getStyle(el, scope.inHover), prevEl && $26f334be467e031c$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $26f334be467e031c$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $26f334be467e031c$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $26f334be467e031c$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $26f334be467e031c$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $26f334be467e031c$var$DRAW_TYPE_PATH = 1;
var $26f334be467e031c$var$DRAW_TYPE_IMAGE = 2;
var $26f334be467e031c$var$DRAW_TYPE_TEXT = 3;
var $26f334be467e031c$var$DRAW_TYPE_INCREMENTAL = 4;
function $26f334be467e031c$var$canPathBatch(style) {
    var hasFill = $26f334be467e031c$var$styleHasFill(style);
    var hasStroke = $26f334be467e031c$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $26f334be467e031c$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $26f334be467e031c$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $26f334be467e031c$export$567881adfc3eb7f3(ctx, el) {
    $26f334be467e031c$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $26f334be467e031c$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $8feacd04f2aac739$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $aa8f13b286ce6e52$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $26f334be467e031c$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $26f334be467e031c$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $26f334be467e031c$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $d730b349402dd5f7$export$2e2bcd8739ae039) && el.autoBatch && $26f334be467e031c$var$canPathBatch(el.style);
    if (forceSetTransform || $26f334be467e031c$var$isTransformChanged(m, prevEl.transform)) {
        $26f334be467e031c$var$flushPathDrawn(ctx, scope);
        $26f334be467e031c$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $26f334be467e031c$var$flushPathDrawn(ctx, scope);
    var style = $26f334be467e031c$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $d730b349402dd5f7$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $26f334be467e031c$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $26f334be467e031c$var$DRAW_TYPE_PATH;
        }
        $26f334be467e031c$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $26f334be467e031c$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $b4b666d0d13b3e95$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $26f334be467e031c$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $26f334be467e031c$var$DRAW_TYPE_TEXT;
            }
            $26f334be467e031c$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $26f334be467e031c$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $a3b3990206d5aa78$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $26f334be467e031c$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $26f334be467e031c$var$DRAW_TYPE_IMAGE;
            }
            $26f334be467e031c$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $26f334be467e031c$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $26f334be467e031c$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $26f334be467e031c$var$DRAW_TYPE_INCREMENTAL;
            }
            $26f334be467e031c$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $26f334be467e031c$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $26f334be467e031c$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $26f334be467e031c$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $26f334be467e031c$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $e02bd9bbb6e1fa7d$var$decalMap = new (0, $cc564f5d3dc1e7b9$export$2e2bcd8739ae039)();
var $e02bd9bbb6e1fa7d$var$decalCache = new (0, $66144e99afcfd957$export$2e2bcd8739ae039)(100);
var $e02bd9bbb6e1fa7d$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $e02bd9bbb6e1fa7d$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $e02bd9bbb6e1fa7d$var$decalMap["delete"](decalObject);
    var oldPattern = $e02bd9bbb6e1fa7d$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $e02bd9bbb6e1fa7d$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $e02bd9bbb6e1fa7d$var$decalKeys.length; ++i){
            var value = decalOpt[$e02bd9bbb6e1fa7d$var$decalKeys[i]];
            if (value != null && !(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(value) && !(0, $99026af6cdabc3e1$export$844ec244b1367d54)(value) && !(0, $99026af6cdabc3e1$export$7e4aa119212bc614)(value) && typeof value !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $e02bd9bbb6e1fa7d$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $e02bd9bbb6e1fa7d$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $e02bd9bbb6e1fa7d$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $e02bd9bbb6e1fa7d$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $e02bd9bbb6e1fa7d$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $e02bd9bbb6e1fa7d$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $1fba639b3abe29b0$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: 'g',
            attrs: {},
            key: 'dcl',
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $e02bd9bbb6e1fa7d$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $bfe945a83b4d28b9$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $bfe945a83b4d28b9$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $daf140cd8c7d5a6f$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $26f334be467e031c$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $e02bd9bbb6e1fa7d$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $99026af6cdabc3e1$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $e02bd9bbb6e1fa7d$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $e02bd9bbb6e1fa7d$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $99026af6cdabc3e1$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $e02bd9bbb6e1fa7d$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $e02bd9bbb6e1fa7d$var$normalizeDashArrayY(dash) {
    if (!dash || (typeof dash === "undefined" ? "undefined" : (0, $5f0Cq._)(dash)) === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $e02bd9bbb6e1fa7d$var$getLineBlockLengthX(dash) {
    return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(dash, function(line) {
        return $e02bd9bbb6e1fa7d$var$getLineBlockLengthY(line);
    });
}
function $e02bd9bbb6e1fa7d$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}


function $161b2b79386ee78b$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $e02bd9bbb6e1fa7d$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $e02bd9bbb6e1fa7d$export$a3ba048e1a648972)(decal, api);
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a2807123f46e310e$var$lifecycle = new (0, $7e07f1848583fc40$export$2e2bcd8739ae039)();
var $a2807123f46e310e$export$2e2bcd8739ae039 = $a2807123f46e310e$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $949bd200fba06c03$var$implsStore = {};
function $949bd200fba06c03$export$9b808fd12256ddd3(name, impl) {
    $949bd200fba06c03$var$implsStore[name] = impl;
}
function $949bd200fba06c03$export$73333eb8a09d5f61(name) {
    return $949bd200fba06c03$var$implsStore[name];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ee7642e7d39fbcdf$var$customRenderers = {};
function $ee7642e7d39fbcdf$export$c3e61191887968da(type, renderItem) {
    $ee7642e7d39fbcdf$var$customRenderers[type] = renderItem;
}
function $ee7642e7d39fbcdf$export$2b5db8e5650e8d15(type) {
    return $ee7642e7d39fbcdf$var$customRenderers[type];
}


var $02d15e5d967b8fed$export$83d89fbfd8236492 = '6.0.0';
var $02d15e5d967b8fed$export$b74ff737e0e298b5 = {
    zrender: '6.0.0'
};
var $02d15e5d967b8fed$var$TEST_FRAME_REMAIN_TIME = 1;
var $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// "Data filter" will block the stream, so it should be
// put at the beginning of data processing.
var $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART = 3000;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_BRUSH = 5000;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_ARIA = 6000;
var $02d15e5d967b8fed$var$PRIORITY_VISUAL_DECAL = 7000;
var $02d15e5d967b8fed$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $02d15e5d967b8fed$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $02d15e5d967b8fed$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $02d15e5d967b8fed$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $02d15e5d967b8fed$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $02d15e5d967b8fed$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $02d15e5d967b8fed$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $02d15e5d967b8fed$var$PRIORITY_VISUAL_ARIA,
        DECAL: $02d15e5d967b8fed$var$PRIORITY_VISUAL_DECAL
    }
};
// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
// Useful for detecting outdated rendering results in scenarios that these issues are involved:
//  - Use shortcut (such as, updateTransform, or no update) to start a main process.
//  - Asynchronously update rendered view (e.g., graph force layout).
//  - Multiple ChartView/ComponentView render to one group cooperatively.
var $02d15e5d967b8fed$var$MAIN_PROCESS_VERSION_KEY = '__mainProcessVersion';
var $02d15e5d967b8fed$var$PENDING_UPDATE = '__pendingUpdate';
var $02d15e5d967b8fed$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $02d15e5d967b8fed$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $02d15e5d967b8fed$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $02d15e5d967b8fed$var$CONNECT_STATUS_PENDING = 0;
var $02d15e5d967b8fed$var$CONNECT_STATUS_UPDATING = 1;
var $02d15e5d967b8fed$var$CONNECT_STATUS_UPDATED = 2;
function $02d15e5d967b8fed$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        return $02d15e5d967b8fed$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $02d15e5d967b8fed$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $02d15e5d967b8fed$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $02d15e5d967b8fed$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $7e07f1848583fc40$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $02d15e5d967b8fed$var$MessageCenter = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $7e07f1848583fc40$export$2e2bcd8739ae039));
var $02d15e5d967b8fed$var$messageCenterProto = $02d15e5d967b8fed$var$MessageCenter.prototype;
$02d15e5d967b8fed$var$messageCenterProto.on = $02d15e5d967b8fed$var$createRegisterEventWithLowercaseMessageCenter('on');
$02d15e5d967b8fed$var$messageCenterProto.off = $02d15e5d967b8fed$var$createRegisterEventWithLowercaseMessageCenter('off');
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $02d15e5d967b8fed$var$prepare;
var $02d15e5d967b8fed$var$prepareView;
var $02d15e5d967b8fed$var$updateDirectly;
var $02d15e5d967b8fed$var$updateMethods;
var $02d15e5d967b8fed$var$doConvertPixel;
var $02d15e5d967b8fed$var$updateStreamModes;
var $02d15e5d967b8fed$var$doDispatchAction;
var $02d15e5d967b8fed$var$flushPendingActions;
var $02d15e5d967b8fed$var$triggerUpdatedEvent;
var $02d15e5d967b8fed$var$bindRenderedEvent;
var $02d15e5d967b8fed$var$bindMouseEvent;
var $02d15e5d967b8fed$var$render;
var $02d15e5d967b8fed$var$renderComponents;
var $02d15e5d967b8fed$var$renderSeries;
var $02d15e5d967b8fed$var$createExtensionAPI;
var $02d15e5d967b8fed$var$enableConnect;
var $02d15e5d967b8fed$var$markStatusToUpdate;
var $02d15e5d967b8fed$var$applyChangedStates;
var $02d15e5d967b8fed$var$updateMainProcessVersion;
var $02d15e5d967b8fed$var$ECharts = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $10ed4f03aa6632a9$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultCoarsePointer = 'auto';
        var defaultUseDirtyRect = false;
        _this[$02d15e5d967b8fed$var$MAIN_PROCESS_VERSION_KEY] = 1;
        var root;
        if (opts.ssr) $b64bfc55c330df69$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
            hashMap.set('series_index', ecData.seriesIndex);
            hashMap.set('data_index', dataIndex);
            ecData.ssrType && hashMap.set('ssr_type', ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $b64bfc55c330df69$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $b4484a22f72674c6$export$de363e709c412c8a)((0, $99026af6cdabc3e1$export$2385a24977818dd0)(zr.flush, zr), 17);
        _this._updateTheme(theme);
        _this._locale = (0, $ead0abccc3f84def$export$ddc371781a6af754)(opts.locale || (0, $ead0abccc3f84def$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $f8a57de9b8820c02$export$2e2bcd8739ae039)();
        var api = _this._api = $02d15e5d967b8fed$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $e2ccd138a3d2fc78$export$2e2bcd8739ae039)($02d15e5d967b8fed$var$visualFuncs, prioritySortFunc);
        (0, $e2ccd138a3d2fc78$export$2e2bcd8739ae039)($02d15e5d967b8fed$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $8c01c749bf05ba4b$export$2e2bcd8739ae039)(_this, api, $02d15e5d967b8fed$var$dataProcessorFuncs, $02d15e5d967b8fed$var$visualFuncs);
        _this._messageCenter = new $02d15e5d967b8fed$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $02d15e5d967b8fed$var$bindRenderedEvent(zr, _this);
        $02d15e5d967b8fed$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $99026af6cdabc3e1$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $02d15e5d967b8fed$var$applyChangedStates(this);
        var scheduler = this._scheduler;
        // Lazy update
        if (this[$02d15e5d967b8fed$var$PENDING_UPDATE]) {
            var silent = this[$02d15e5d967b8fed$var$PENDING_UPDATE].silent;
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = true;
            $02d15e5d967b8fed$var$updateMainProcessVersion(this);
            try {
                $02d15e5d967b8fed$var$prepare(this);
                $02d15e5d967b8fed$var$updateMethods.update.call(this, null, this[$02d15e5d967b8fed$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
                this[$02d15e5d967b8fed$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
            this[$02d15e5d967b8fed$var$PENDING_UPDATE] = null;
            $02d15e5d967b8fed$var$flushPendingActions.call(this, silent);
            $02d15e5d967b8fed$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $02d15e5d967b8fed$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $02d15e5d967b8fed$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $02d15e5d967b8fed$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = true;
        $02d15e5d967b8fed$var$updateMainProcessVersion(this);
        if (!this._model || notMerge) {
            var optionManager = new (0, $83737f0b0a901c54$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $d0f94fa2d299f1af$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $02d15e5d967b8fed$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$02d15e5d967b8fed$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $02d15e5d967b8fed$var$prepare(this);
                $02d15e5d967b8fed$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$02d15e5d967b8fed$var$PENDING_UPDATE] = null;
                this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$02d15e5d967b8fed$var$PENDING_UPDATE] = null;
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
            $02d15e5d967b8fed$var$flushPendingActions.call(this, silent);
            $02d15e5d967b8fed$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * Update theme with name or theme option and repaint the chart.
   * @param theme Theme name or theme option.
   * @param opts Optional settings
   */ ECharts.prototype.setTheme = function(theme, opts) {
        if (this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        if (!ecModel) return;
        var silent = opts && opts.silent;
        var updateParams = null;
        if (this[$02d15e5d967b8fed$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$02d15e5d967b8fed$var$PENDING_UPDATE].silent;
            updateParams = this[$02d15e5d967b8fed$var$PENDING_UPDATE].updateParams;
            this[$02d15e5d967b8fed$var$PENDING_UPDATE] = null;
        }
        this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = true;
        $02d15e5d967b8fed$var$updateMainProcessVersion(this);
        try {
            this._updateTheme(theme);
            ecModel.setTheme(this._theme);
            $02d15e5d967b8fed$var$prepare(this);
            $02d15e5d967b8fed$var$updateMethods.update.call(this, {
                type: 'setTheme'
            }, updateParams);
        } catch (e) {
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
        $02d15e5d967b8fed$var$flushPendingActions.call(this, silent);
        $02d15e5d967b8fed$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype._updateTheme = function(theme) {
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(theme)) theme = $02d15e5d967b8fed$var$themeStorage[theme];
        if (theme) {
            theme = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(theme);
            theme && (0, $08c364d5f2e8a2e2$export$2e2bcd8739ae039)(theme, true);
            this._theme = theme;
        }
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $e870be04527b939a$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($02d15e5d967b8fed$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($02d15e5d967b8fed$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $99026af6cdabc3e1$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $1fba639b3abe29b0$export$ef5e599365494451).createCanvas();
            var zr_1 = $b64bfc55c330df69$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $aed3569651b5e3fa$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $a3b3990206d5aa78$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value, opt) {
        return $02d15e5d967b8fed$var$doConvertPixel(this, 'convertToPixel', finder, value, opt);
    };
    /**
   * Convert from logical coordinate system to pixel coordinate system.
   * See CoordinateSystem#convertToPixel.
   *
   * @see CoordinateSystem['dataToLayout'] for parameters and return.
   * @see CoordinateSystemDataCoord
   */ ECharts.prototype.convertToLayout = function(finder, value, opt) {
        return $02d15e5d967b8fed$var$doConvertPixel(this, 'convertToLayout', finder, value, opt);
    };
    // The above are signatures from before v6, thus they should be preserved for backward compat.
    ECharts.prototype.convertFromPixel = function(finder, value, opt) {
        return $02d15e5d967b8fed$var$doConvertPixel(this, 'convertFromPixel', finder, value, opt);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $08bfa015475effa8$export$95de80076abac814(ecModel, finder);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $08bfa015475effa8$export$95de80076abac814(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $efea982454af0f4f$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $efea982454af0f4f$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($02d15e5d967b8fed$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function handler(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout';
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $2948406aad695582$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        var messageCenter = this._messageCenter;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($02d15e5d967b8fed$var$publicEventTypeMap, function(_, eventType) {
            messageCenter.on(eventType, function(event) {
                _this.trigger(eventType, event);
            });
        });
        (0, $565b0fbbdfa36e81$export$2575c83262e49d0c)(messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $08bfa015475effa8$export$9fec4d97f1922e0b(this.getDom(), $02d15e5d967b8fed$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $02d15e5d967b8fed$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$02d15e5d967b8fed$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$02d15e5d967b8fed$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$02d15e5d967b8fed$var$PENDING_UPDATE] = null;
        }
        this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = true;
        $02d15e5d967b8fed$var$updateMainProcessVersion(this);
        try {
            needPrepare && $02d15e5d967b8fed$var$prepare(this);
            $02d15e5d967b8fed$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
        $02d15e5d967b8fed$var$flushPendingActions.call(this, silent);
        $02d15e5d967b8fed$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$02d15e5d967b8fed$var$loadingEffects[name]) return;
        var el = $02d15e5d967b8fed$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, eventObj);
        payload.type = $02d15e5d967b8fed$var$connectionEventRevertMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$02d15e5d967b8fed$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $02d15e5d967b8fed$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $e870be04527b939a$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $02d15e5d967b8fed$var$flushPendingActions.call(this, silent);
        $02d15e5d967b8fed$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $02d15e5d967b8fed$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $02d15e5d967b8fed$var$prepare = function prepare(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $02d15e5d967b8fed$var$prepareView(ecIns, true);
            $02d15e5d967b8fed$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $02d15e5d967b8fed$var$prepareView = function prepareView(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $cdb9e13510266a6e$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $3e14d76796640b86$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $01349fdbc71d745c$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $02d15e5d967b8fed$var$updateDirectly = function updateDirectly(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($08bfa015475effa8$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $08bfa015475effa8$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $ea1f7a1fbd33fd2d$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $358fe4ff615f1b87$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $ea1f7a1fbd33fd2d$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            'emphasis',
                            'disabled'
                        ])) (0, $ea1f7a1fbd33fd2d$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $ea1f7a1fbd33fd2d$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $ea1f7a1fbd33fd2d$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $ea1f7a1fbd33fd2d$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $ea1f7a1fbd33fd2d$export$df035d873a9de64f) ? (0, $ea1f7a1fbd33fd2d$export$b2d02638cc34c042)(dispatcher) : (0, $ea1f7a1fbd33fd2d$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $ea1f7a1fbd33fd2d$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $358fe4ff615f1b87$export$2e2bcd8739ae039)) {
                        (0, $ea1f7a1fbd33fd2d$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $ea1f7a1fbd33fd2d$export$e4ea08ef52e0a73)(model);
                        $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $02d15e5d967b8fed$var$updateMethods = {
            prepareAndUpdate: function prepareAndUpdate(payload) {
                $02d15e5d967b8fed$var$prepare(this);
                $02d15e5d967b8fed$var$updateMethods.update.call(this, payload, payload && {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function update(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $02d15e5d967b8fed$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                // Set background and dark mode before rendering, because they affect auto-color-determination
                // in zrender Text, and consequently affect the bounding rect if stroke is added.
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                var darkMode = ecModel.get('darkMode');
                if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                $02d15e5d967b8fed$var$render(this, ecModel, api, payload, updateParams);
                (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function updateTransform(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $02d15e5d967b8fed$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateView: function updateView(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $01349fdbc71d745c$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateView');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $02d15e5d967b8fed$var$render(this, ecModel, this._api, payload, {});
                (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function updateVisual(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $01349fdbc71d745c$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateVisual');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function updateLayout(payload) {
                $02d15e5d967b8fed$var$updateMethods.update.call(this, payload);
            }
        };
        function doConvertPixelImpl(ecIns, methodName, finder, value, opt) {
            if (ecIns._disposed) {
                $02d15e5d967b8fed$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $08bfa015475effa8$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value, opt)) != null) return result;
            }
        }
        $02d15e5d967b8fed$var$doConvertPixel = doConvertPixelImpl;
        $02d15e5d967b8fed$var$updateStreamModes = function updateStreamModes(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $02d15e5d967b8fed$var$doDispatchAction = function doDispatchAction(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionInfo = $02d15e5d967b8fed$var$actions[payloadType];
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $cdb9e13510266a6e$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = true;
            $02d15e5d967b8fed$var$updateMainProcessVersion(this);
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)((0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var actionResultBatch = [];
            var nonRefinedEventType = actionInfo.nonRefinedEventType;
            var isSelectChange = (0, $ea1f7a1fbd33fd2d$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $ea1f7a1fbd33fd2d$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $ea1f7a1fbd33fd2d$export$b2a593c7b5243584)(this._api);
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                var actionResult = actionInfo.action(batchItem, ecModel, _this._api);
                if (actionInfo.refineEvent) actionResultBatch.push(actionResult);
                else eventObj = actionResult;
                eventObj = eventObj || (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, batchItem);
                eventObj.type = nonRefinedEventType;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $08bfa015475effa8$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $02d15e5d967b8fed$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $02d15e5d967b8fed$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $02d15e5d967b8fed$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $02d15e5d967b8fed$var$markStatusToUpdate(_this);
                } else if (cptType) $02d15e5d967b8fed$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$02d15e5d967b8fed$var$PENDING_UPDATE]) {
                    $02d15e5d967b8fed$var$prepare(this);
                    $02d15e5d967b8fed$var$updateMethods.update.call(this, payload);
                    this[$02d15e5d967b8fed$var$PENDING_UPDATE] = null;
                } else $02d15e5d967b8fed$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: nonRefinedEventType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$02d15e5d967b8fed$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var refinedEvent = void 0;
                if (actionInfo.refineEvent) {
                    var eventContent = actionInfo.refineEvent(actionResultBatch, payload, ecModel, this._api).eventContent;
                    (0, $99026af6cdabc3e1$export$a7a9523472993e97)((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(eventContent));
                    refinedEvent = (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
                        type: actionInfo.refinedEventType
                    }, eventContent);
                    refinedEvent.fromAction = payload.type;
                    refinedEvent.fromActionPayload = payload;
                    refinedEvent.escapeConnect = true;
                }
                var messageCenter = this._messageCenter;
                // - If `refineEvent` created a `refinedEvent`, `eventObj` (replicated from the original payload)
                //  is still needed to be triggered for the feature `connect`. But it will not be triggered to
                //  users in this case.
                // - If no `refineEvent` used, `eventObj` will be triggered for both `connect` and users.
                messageCenter.trigger(eventObj.type, eventObj);
                if (refinedEvent) messageCenter.trigger(refinedEvent.type, refinedEvent);
            }
        };
        $02d15e5d967b8fed$var$flushPendingActions = function flushPendingActions(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $02d15e5d967b8fed$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $02d15e5d967b8fed$var$triggerUpdatedEvent = function triggerUpdatedEvent(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $02d15e5d967b8fed$var$bindRenderedEvent = function bindRenderedEvent(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$02d15e5d967b8fed$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $02d15e5d967b8fed$var$bindMouseEvent = function bindMouseEvent(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $2948406aad695582$export$8a4fca9e04eb4df6)(el, (0, $ea1f7a1fbd33fd2d$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $ea1f7a1fbd33fd2d$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $2948406aad695582$export$8a4fca9e04eb4df6)(el, (0, $ea1f7a1fbd33fd2d$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $ea1f7a1fbd33fd2d$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $2948406aad695582$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get('zlevel') || 0;
                var z = componentModel.get('z') || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === 'series' ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $e2ccd138a3d2fc78$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = '';
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $02d15e5d967b8fed$var$render = function render(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $02d15e5d967b8fed$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $02d15e5d967b8fed$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $02d15e5d967b8fed$var$renderComponents = function renderComponents(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $02d15e5d967b8fed$var$renderSeries = function renderSeries(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $99026af6cdabc3e1$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent');
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $ea1f7a1fbd33fd2d$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('series:layoutlabels', ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $02d15e5d967b8fed$var$markStatusToUpdate = function markStatusToUpdate(ecIns) {
            ecIns[$02d15e5d967b8fed$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $02d15e5d967b8fed$var$updateMainProcessVersion = function updateMainProcessVersion(ecIns) {
            ecIns[$02d15e5d967b8fed$var$MAIN_PROCESS_VERSION_KEY] = (ecIns[$02d15e5d967b8fed$var$MAIN_PROCESS_VERSION_KEY] + 1) % 1000;
        };
        $02d15e5d967b8fed$var$applyChangedStates = function applyChangedStates(ecIns) {
            if (!ecIns[$02d15e5d967b8fed$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($821b3c1b9ddcee3a$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$02d15e5d967b8fed$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $ea1f7a1fbd33fd2d$export$f0f2bee145debb31) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $ea1f7a1fbd33fd2d$export$1307d6a87d56baa) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $e870be04527b939a$export$2e2bcd8739ae039).node && !(0, $e870be04527b939a$export$2e2bcd8739ae039).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.eachRendered(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.eachRendered(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var zInfo = $055606553475f5d6$export$1500a631bea5adda(model);
            // Set z and zlevel
            view.eachRendered(function(el) {
                $055606553475f5d6$export$d31cf465bf5e8879(el, zInfo.z, zInfo.zlevel);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($821b3c1b9ddcee3a$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing')
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($821b3c1b9ddcee3a$export$5b89d4b643713034(el)) return;
                    if (el instanceof $d730b349402dd5f7$export$2e2bcd8739ae039) (0, $ea1f7a1fbd33fd2d$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $02d15e5d967b8fed$var$createExtensionAPI = function createExtensionAPI(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $ea1f7a1fbd33fd2d$export$b2d02638cc34c042)(el, highlightDigit);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $ea1f7a1fbd33fd2d$export$11be6f716239ac55)(el, highlightDigit);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $ea1f7a1fbd33fd2d$export$207f9cb3e1099375)(el);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $ea1f7a1fbd33fd2d$export$fd4a9ec75456d3c1)(el);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $ea1f7a1fbd33fd2d$export$252d028dda8ef765)(el);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $ea1f7a1fbd33fd2d$export$ea9a904bd6e32bd3)(el);
                    $02d15e5d967b8fed$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                class_1.prototype.getMainProcessVersion = function() {
                    return ecIns[$02d15e5d967b8fed$var$MAIN_PROCESS_VERSION_KEY];
                };
                return class_1;
            }((0, $f2525918be30f295$export$2e2bcd8739ae039)))(ecIns);
        };
        $02d15e5d967b8fed$var$enableConnect = function enableConnect(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$02d15e5d967b8fed$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($02d15e5d967b8fed$var$connectionEventRevertMap, function(_, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($02d15e5d967b8fed$var$connectedGroups[chart.group] && chart[$02d15e5d967b8fed$var$CONNECT_STATUS_KEY] !== $02d15e5d967b8fed$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($02d15e5d967b8fed$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $02d15e5d967b8fed$var$CONNECT_STATUS_PENDING);
                        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$02d15e5d967b8fed$var$CONNECT_STATUS_KEY] !== $02d15e5d967b8fed$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $02d15e5d967b8fed$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $7e07f1848583fc40$export$2e2bcd8739ae039));
var $02d15e5d967b8fed$var$echartsProto = $02d15e5d967b8fed$var$ECharts.prototype;
$02d15e5d967b8fed$var$echartsProto.on = $02d15e5d967b8fed$var$createRegisterEventWithLowercaseECharts('on');
$02d15e5d967b8fed$var$echartsProto.off = $02d15e5d967b8fed$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$02d15e5d967b8fed$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $2c7aa3955e1b7354$export$4a9c0b74eb885aa1)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $02d15e5d967b8fed$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $02d15e5d967b8fed$var$disposedWarning(id) {}
var $02d15e5d967b8fed$var$actions = {};
/**
 * Map event type to action type for reproducing action from event for `connect`.
 */ var $02d15e5d967b8fed$var$connectionEventRevertMap = {};
/**
 * To remove duplication.
 */ var $02d15e5d967b8fed$var$publicEventTypeMap = {};
var $02d15e5d967b8fed$var$dataProcessorFuncs = [];
var $02d15e5d967b8fed$var$optionPreprocessorFuncs = [];
var $02d15e5d967b8fed$var$visualFuncs = [];
var $02d15e5d967b8fed$var$themeStorage = {};
var $02d15e5d967b8fed$var$loadingEffects = {};
var $02d15e5d967b8fed$var$instances = {};
var $02d15e5d967b8fed$var$connectedGroups = {};
var $02d15e5d967b8fed$var$idBase = +new Date() - 0;
var $02d15e5d967b8fed$var$groupIdBase = +new Date() - 0;
var $02d15e5d967b8fed$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $02d15e5d967b8fed$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $02d15e5d967b8fed$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $02d15e5d967b8fed$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $02d15e5d967b8fed$var$idBase++;
    $02d15e5d967b8fed$var$instances[chart.id] = chart;
    isClient && $08bfa015475effa8$export$9fec4d97f1922e0b(dom, $02d15e5d967b8fed$var$DOM_ATTRIBUTE_KEY, chart.id);
    $02d15e5d967b8fed$var$enableConnect(chart);
    (0, $a2807123f46e310e$export$2e2bcd8739ae039).trigger('afterinit', chart);
    return chart;
}
function $02d15e5d967b8fed$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $02d15e5d967b8fed$var$groupIdBase++;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $02d15e5d967b8fed$var$connectedGroups[groupId] = true;
    return groupId;
}
function $02d15e5d967b8fed$export$37dfea93db2e14ed(groupId) {
    $02d15e5d967b8fed$var$connectedGroups[groupId] = false;
}
var $02d15e5d967b8fed$export$87cd6834112ecb52 = $02d15e5d967b8fed$export$37dfea93db2e14ed;
function $02d15e5d967b8fed$export$fcfbbcec2cb820d5(chart) {
    if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(chart)) chart = $02d15e5d967b8fed$var$instances[chart];
    else if (!(chart instanceof $02d15e5d967b8fed$var$ECharts)) // Try to treat as dom
    chart = $02d15e5d967b8fed$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $02d15e5d967b8fed$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $02d15e5d967b8fed$export$33b6fbccd4f643f8(dom) {
    return $02d15e5d967b8fed$var$instances[$08bfa015475effa8$export$735ee1799fd02602(dom, $02d15e5d967b8fed$var$DOM_ATTRIBUTE_KEY)];
}
function $02d15e5d967b8fed$export$89b4be35062c4a3f(key) {
    return $02d15e5d967b8fed$var$instances[key];
}
function $02d15e5d967b8fed$export$f9c59eed5de5ff80(name, theme) {
    $02d15e5d967b8fed$var$themeStorage[name] = theme;
}
function $02d15e5d967b8fed$export$77095792a057b768(preprocessorFunc) {
    if ((0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)($02d15e5d967b8fed$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $02d15e5d967b8fed$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $02d15e5d967b8fed$export$d575e6557ac1729f(priority, processor) {
    $02d15e5d967b8fed$var$normalizeRegister($02d15e5d967b8fed$var$dataProcessorFuncs, priority, processor, $02d15e5d967b8fed$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $02d15e5d967b8fed$export$c8c249911ee8c1ed(postInitFunc) {
    $02d15e5d967b8fed$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $02d15e5d967b8fed$export$99560909c18c76bb(postUpdateFunc) {
    $02d15e5d967b8fed$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $02d15e5d967b8fed$export$c9ec4b5faef04865(name, cb) {
    (0, $a2807123f46e310e$export$2e2bcd8739ae039).on(name, cb);
}
function $02d15e5d967b8fed$export$408c24786cd729c6(arg0, arg1, action) {
    var actionType;
    var publicEventType;
    var refineEvent;
    var update;
    var publishNonRefinedEvent;
    if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(arg1)) {
        action = arg1;
        arg1 = '';
    }
    if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(arg0)) {
        actionType = arg0.type;
        publicEventType = arg0.event;
        update = arg0.update;
        publishNonRefinedEvent = arg0.publishNonRefinedEvent;
        if (!action) action = arg0.action;
        refineEvent = arg0.refineEvent;
    } else {
        actionType = arg0;
        publicEventType = arg1;
    }
    function createEventType(actionOrEventType) {
        // Event type should be all lowercase
        return actionOrEventType.toLowerCase();
    }
    publicEventType = createEventType(publicEventType || actionType);
    // See comments on {ActionInfo} for the reason.
    var nonRefinedEventType = refineEvent ? createEventType(actionType) : publicEventType;
    // Support calling `registerAction` multiple times with the same action
    // type; subsequent calls have no effect.
    if ($02d15e5d967b8fed$var$actions[actionType]) return;
    // Validate action type and event name.
    (0, $99026af6cdabc3e1$export$a7a9523472993e97)($02d15e5d967b8fed$var$ACTION_REG.test(actionType) && $02d15e5d967b8fed$var$ACTION_REG.test(publicEventType));
    if (refineEvent) // An event replicated from the action will be triggered internally for `connect` in this case.
    (0, $99026af6cdabc3e1$export$a7a9523472993e97)(publicEventType !== actionType);
    $02d15e5d967b8fed$var$actions[actionType] = {
        actionType: actionType,
        refinedEventType: publicEventType,
        nonRefinedEventType: nonRefinedEventType,
        update: update,
        action: action,
        refineEvent: refineEvent
    };
    $02d15e5d967b8fed$var$publicEventTypeMap[publicEventType] = 1;
    if (refineEvent && publishNonRefinedEvent) $02d15e5d967b8fed$var$publicEventTypeMap[nonRefinedEventType] = 1;
    $02d15e5d967b8fed$var$connectionEventRevertMap[nonRefinedEventType] = actionType;
}
function $02d15e5d967b8fed$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $f8a57de9b8820c02$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $02d15e5d967b8fed$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $f8a57de9b8820c02$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $02d15e5d967b8fed$export$c3e61191887968da(seriesType, renderItem) {
    (0, $ee7642e7d39fbcdf$export$c3e61191887968da)(seriesType, renderItem);
}
function $02d15e5d967b8fed$export$d768f97700ca6bea(priority, layoutTask) {
    $02d15e5d967b8fed$var$normalizeRegister($02d15e5d967b8fed$var$visualFuncs, priority, layoutTask, $02d15e5d967b8fed$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $02d15e5d967b8fed$export$5f32c1eb94c381bb(priority, visualTask) {
    $02d15e5d967b8fed$var$normalizeRegister($02d15e5d967b8fed$var$visualFuncs, priority, visualTask, $02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $02d15e5d967b8fed$var$registeredTasks = [];
function $02d15e5d967b8fed$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(priority) || (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)($02d15e5d967b8fed$var$registeredTasks, fn) >= 0) return;
    $02d15e5d967b8fed$var$registeredTasks.push(fn);
    var stageHandler = (0, $8c01c749bf05ba4b$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $02d15e5d967b8fed$export$e06b68a82007c015(name, loadingFx) {
    $02d15e5d967b8fed$var$loadingEffects[name] = loadingFx;
}
function $02d15e5d967b8fed$export$10425ea7a243b114(creator) {
    (0, $1fba639b3abe29b0$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $02d15e5d967b8fed$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $949bd200fba06c03$export$73333eb8a09d5f61)('registerMap');
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $02d15e5d967b8fed$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $949bd200fba06c03$export$73333eb8a09d5f61)('getMap');
    return getMap && getMap(mapName);
}
var $02d15e5d967b8fed$export$f01d71dd0389d7e4 = (0, $4df6b4db1a848cc4$export$92c96c6d8b255b7d);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$02d15e5d967b8fed$export$5f32c1eb94c381bb($02d15e5d967b8fed$var$PRIORITY_VISUAL_GLOBAL, (0, $e5c3df17d5a674f3$export$7ce4d65f9b69240));
$02d15e5d967b8fed$export$5f32c1eb94c381bb($02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $e5c3df17d5a674f3$export$f7dcb66a065003d1));
$02d15e5d967b8fed$export$5f32c1eb94c381bb($02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $e5c3df17d5a674f3$export$cf9758b0d6dc0aa9));
$02d15e5d967b8fed$export$5f32c1eb94c381bb($02d15e5d967b8fed$var$PRIORITY_VISUAL_GLOBAL, (0, $02593f791f8c8232$export$144ac3beded415d9));
$02d15e5d967b8fed$export$5f32c1eb94c381bb($02d15e5d967b8fed$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $02593f791f8c8232$export$435b956f7f1071fb));
$02d15e5d967b8fed$export$5f32c1eb94c381bb($02d15e5d967b8fed$var$PRIORITY_VISUAL_DECAL, (0, $161b2b79386ee78b$export$2e2bcd8739ae039));
$02d15e5d967b8fed$export$77095792a057b768((0, $08c364d5f2e8a2e2$export$2e2bcd8739ae039));
$02d15e5d967b8fed$export$d575e6557ac1729f($02d15e5d967b8fed$var$PRIORITY_PROCESSOR_DATASTACK, (0, $f7caef33b9973858$export$2e2bcd8739ae039));
$02d15e5d967b8fed$export$e06b68a82007c015('default', (0, $8994ca305e5da023$export$2e2bcd8739ae039));
// Default actions
$02d15e5d967b8fed$export$408c24786cd729c6({
    type: (0, $ea1f7a1fbd33fd2d$export$df035d873a9de64f),
    event: (0, $ea1f7a1fbd33fd2d$export$df035d873a9de64f),
    update: (0, $ea1f7a1fbd33fd2d$export$df035d873a9de64f)
}, (0, $99026af6cdabc3e1$export$8793edee2d425525));
$02d15e5d967b8fed$export$408c24786cd729c6({
    type: (0, $ea1f7a1fbd33fd2d$export$f8a2f7807cc185ea),
    event: (0, $ea1f7a1fbd33fd2d$export$f8a2f7807cc185ea),
    update: (0, $ea1f7a1fbd33fd2d$export$f8a2f7807cc185ea)
}, (0, $99026af6cdabc3e1$export$8793edee2d425525));
$02d15e5d967b8fed$export$408c24786cd729c6({
    type: (0, $ea1f7a1fbd33fd2d$export$89616263e7d38fe9),
    event: (0, $ea1f7a1fbd33fd2d$export$67f8c62bcdfbd39f),
    update: (0, $ea1f7a1fbd33fd2d$export$89616263e7d38fe9),
    action: (0, $99026af6cdabc3e1$export$8793edee2d425525),
    refineEvent: $02d15e5d967b8fed$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$02d15e5d967b8fed$export$408c24786cd729c6({
    type: (0, $ea1f7a1fbd33fd2d$export$7636ad95c0f68a79),
    event: (0, $ea1f7a1fbd33fd2d$export$67f8c62bcdfbd39f),
    update: (0, $ea1f7a1fbd33fd2d$export$7636ad95c0f68a79),
    action: (0, $99026af6cdabc3e1$export$8793edee2d425525),
    refineEvent: $02d15e5d967b8fed$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$02d15e5d967b8fed$export$408c24786cd729c6({
    type: (0, $ea1f7a1fbd33fd2d$export$1e90ed8a25542516),
    event: (0, $ea1f7a1fbd33fd2d$export$67f8c62bcdfbd39f),
    update: (0, $ea1f7a1fbd33fd2d$export$1e90ed8a25542516),
    action: (0, $99026af6cdabc3e1$export$8793edee2d425525),
    refineEvent: $02d15e5d967b8fed$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
function $02d15e5d967b8fed$var$makeSelectChangedEvent(actionResultBatch, payload, ecModel, api) {
    return {
        eventContent: {
            selected: (0, $ea1f7a1fbd33fd2d$export$c529643b619af6b3)(ecModel),
            isFromClick: payload.isFromClick || false
        }
    };
}
// Default theme, so that we can use `chart.setTheme('default')` to revert to
// the default theme after changing to other themes.
$02d15e5d967b8fed$export$f9c59eed5de5ff80('default', {});
$02d15e5d967b8fed$export$f9c59eed5de5ff80('dark', (0, $fea6f2a0847222e0$export$2e2bcd8739ae039));
var $02d15e5d967b8fed$export$73cae5e090579589 = {};










var $80c287a85adc0f08$var$extensions = [];
var $80c287a85adc0f08$var$extensionRegisters = {
    registerPreprocessor: (0, $02d15e5d967b8fed$export$77095792a057b768),
    registerProcessor: (0, $02d15e5d967b8fed$export$d575e6557ac1729f),
    registerPostInit: (0, $02d15e5d967b8fed$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $02d15e5d967b8fed$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $02d15e5d967b8fed$export$c9ec4b5faef04865),
    registerAction: (0, $02d15e5d967b8fed$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $02d15e5d967b8fed$export$1dd5e025a8a37dd),
    registerLayout: (0, $02d15e5d967b8fed$export$d768f97700ca6bea),
    registerVisual: (0, $02d15e5d967b8fed$export$5f32c1eb94c381bb),
    registerTransform: (0, $02d15e5d967b8fed$export$f01d71dd0389d7e4),
    registerLoading: (0, $02d15e5d967b8fed$export$e06b68a82007c015),
    registerMap: (0, $02d15e5d967b8fed$export$d456de060be2dba1),
    registerImpl: (0, $949bd200fba06c03$export$9b808fd12256ddd3),
    PRIORITY: (0, $02d15e5d967b8fed$export$bb34f3538ba26c7e),
    ComponentModel: (0, $fefeb1a173623ab2$export$2e2bcd8739ae039),
    ComponentView: (0, $3e14d76796640b86$export$2e2bcd8739ae039),
    SeriesModel: (0, $358fe4ff615f1b87$export$2e2bcd8739ae039),
    ChartView: (0, $01349fdbc71d745c$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function registerComponentModel(ComponentModelClass) {
        (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function registerComponentView(ComponentViewClass) {
        (0, $3e14d76796640b86$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function registerSeriesModel(SeriesModelClass) {
        (0, $358fe4ff615f1b87$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function registerChartView(ChartViewClass) {
        (0, $01349fdbc71d745c$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerCustomSeries: function registerCustomSeries1(seriesType, renderItem) {
        (0, $ee7642e7d39fbcdf$export$c3e61191887968da)(seriesType, renderItem);
    },
    registerSubTypeDefaulter: function registerSubTypeDefaulter(componentType, defaulter) {
        (0, $fefeb1a173623ab2$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function registerPainter1(painterType, PainterCtor) {
        (0, $b64bfc55c330df69$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $80c287a85adc0f08$export$1f96ae73734a86cc(ext) {
    if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ext, function(singleExt) {
            $80c287a85adc0f08$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)($80c287a85adc0f08$var$extensions, ext) >= 0) return;
    $80c287a85adc0f08$var$extensions.push(ext);
    if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($80c287a85adc0f08$var$extensionRegisters);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $1d3bf007429cab52$var$mathSin = Math.sin;
var $1d3bf007429cab52$var$mathCos = Math.cos;
var $1d3bf007429cab52$var$PI = Math.PI;
var $1d3bf007429cab52$var$PI2 = Math.PI * 2;
var $1d3bf007429cab52$var$degree = 180 / $1d3bf007429cab52$var$PI;
var $1d3bf007429cab52$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $2576ca1a583f3189$export$4701367f5b4de464)(dThetaPositive - $1d3bf007429cab52$var$PI2) || (clockwise ? dTheta >= $1d3bf007429cab52$var$PI2 : -dTheta >= $1d3bf007429cab52$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $1d3bf007429cab52$var$PI2 : dTheta % $1d3bf007429cab52$var$PI2 + $1d3bf007429cab52$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $2576ca1a583f3189$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $1d3bf007429cab52$var$PI === !!clockwise;
        var x0 = cx + rx * $1d3bf007429cab52$var$mathCos(startAngle);
        var y0 = cy + ry * $1d3bf007429cab52$var$mathSin(startAngle);
        if (this._start) this._add('M', x0, y0);
        var xRot = Math.round(psi * $1d3bf007429cab52$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($1d3bf007429cab52$var$PI2 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * $1d3bf007429cab52$var$mathCos(startAngle + dTheta_1), cy + ry * $1d3bf007429cab52$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $1d3bf007429cab52$var$mathCos(endAngle);
            var y = cy + ry * $1d3bf007429cab52$var$mathSin(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $1d3bf007429cab52$export$2e2bcd8739ae039 = $1d3bf007429cab52$var$SVGPathRebuilder;







var $3107b844df202b0f$var$NONE = 'none';
var $3107b844df202b0f$var$mathRound = Math.round;
function $3107b844df202b0f$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $3107b844df202b0f$var$NONE;
}
function $3107b844df202b0f$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $3107b844df202b0f$var$NONE;
}
var $3107b844df202b0f$var$strokeProps = [
    'lineCap',
    'miterLimit',
    'lineJoin'
];
var $3107b844df202b0f$var$svgStrokeProps = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)($3107b844df202b0f$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $3107b844df202b0f$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $a3b3990206d5aa78$export$2e2bcd8739ae039)) {
        updateAttr('opacity', opacity);
        return;
    }
    if ($3107b844df202b0f$var$pathHasFill(style)) {
        var fill = (0, $2576ca1a583f3189$export$4cde5df63f53f473)(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr('fill-opacity', fillOpacity);
    } else updateAttr('fill', $3107b844df202b0f$var$NONE);
    if ($3107b844df202b0f$var$pathHasStroke(style)) {
        var stroke = (0, $2576ca1a583f3189$export$4cde5df63f53f473)(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr('stroke-width', strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        if (forceUpdate || strokeOpacity < 1) updateAttr('stroke-opacity', strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $b34b04bbb42e79b9$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $3107b844df202b0f$var$mathRound(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) updateAttr('stroke-dashoffset', lineDashOffset);
            }
        } else if (forceUpdate) updateAttr('stroke-dasharray', $3107b844df202b0f$var$NONE);
        for(var i = 0; i < $3107b844df202b0f$var$strokeProps.length; i++){
            var propName = $3107b844df202b0f$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $d730b349402dd5f7$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $d730b349402dd5f7$export$deade517576e293a)[propName];
                val && updateAttr($3107b844df202b0f$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr('stroke', $3107b844df202b0f$var$NONE);
}




var $5a8ebb1204068920$export$a690ad4c9a38f86e = 'http://www.w3.org/2000/svg';
var $5a8ebb1204068920$export$b22c6da1792ecec8 = 'http://www.w3.org/1999/xlink';
var $5a8ebb1204068920$export$fac09d762d15fa3b = 'http://www.w3.org/2000/xmlns/';
var $5a8ebb1204068920$export$ad4c4fdecd3b4156 = 'http://www.w3.org/XML/1998/namespace';
var $5a8ebb1204068920$export$d3f79611f155197c = 'ecmeta_';
function $5a8ebb1204068920$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($5a8ebb1204068920$export$a690ad4c9a38f86e, name);
}
function $5a8ebb1204068920$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $5a8ebb1204068920$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += "=\"" + val + "\"";
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function $5a8ebb1204068920$var$createElementClose(name) {
    return "</" + name + ">";
}
function $5a8ebb1204068920$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $5a8ebb1204068920$var$createElementOpen(tag, attrs) + (tag !== 'style' ? (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(text) : text || '') + (children ? "" + S + (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : '') + $5a8ebb1204068920$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $5a8ebb1204068920$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)((0, $99026af6cdabc3e1$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $99026af6cdabc3e1$export$871de8747c9eaa88)((0, $99026af6cdabc3e1$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)((0, $99026af6cdabc3e1$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $99026af6cdabc3e1$export$871de8747c9eaa88)((0, $99026af6cdabc3e1$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $99026af6cdabc3e1$export$871de8747c9eaa88)((0, $99026af6cdabc3e1$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') val = "path(\"" + val + "\")";
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return '';
    return [
        '<![CDATA[',
        selectors,
        animations,
        ']]>'
    ].join(S);
}
function $5a8ebb1204068920$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $5a8ebb1204068920$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $5a8ebb1204068920$export$bf5c4cf060303d58('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': $5a8ebb1204068920$export$a690ad4c9a38f86e,
        'xmlns:xlink': $5a8ebb1204068920$export$b22c6da1792ecec8,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $ee7e2a4d6f7cbe8a$var$cssClassIdx = 0;
function $ee7e2a4d6f7cbe8a$export$9c80c36b7367fb56() {
    return $ee7e2a4d6f7cbe8a$var$cssClassIdx++;
}


var $b5e64753bea494c5$export$54ee1847795bcf37 = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var $b5e64753bea494c5$var$transformOriginKey = 'transform-origin';
function $b5e64753bea494c5$var$buildPathString(el, kfShape, path) {
    var shape = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, el.shape);
    (0, $99026af6cdabc3e1$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $1d3bf007429cab52$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $2576ca1a583f3189$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $b5e64753bea494c5$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$b5e64753bea494c5$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $b5e64753bea494c5$export$f0dede2064ee89d7 = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function $b5e64753bea494c5$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $b5e64753bea494c5$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $5a8ebb1204068920$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $b5e64753bea494c5$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ''
            };
            composedAnim[percent].d += kf.d || '';
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $b5e64753bea494c5$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $b5e64753bea494c5$var$getEasingFunc(easing) {
    return (0, $99026af6cdabc3e1$export$844ec244b1367d54)(easing) ? $b5e64753bea494c5$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $b5e64753bea494c5$export$54ee1847795bcf37[easing] + ")" : (0, $41d3bbb04c5429c7$export$ec0863d806fd857e)(easing) ? easing : '' : '';
}
function $b5e64753bea494c5$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $dae84e5b487cab8d$export$2e2bcd8739ae039)) {
        var animationCfg = $b5e64753bea494c5$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + 's'
        ];
        var easing = $b5e64753bea494c5$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push('linear');
        if (delay) cfgArr.push(delay / 1000 + 's');
        if (animator.getLoop()) cfgArr.push('infinite');
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + '%';
                        var kfEasing = $b5e64753bea494c5$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(rawValue) || (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === 'shape') saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $4640b1300b1537ae$export$234b1c16dfa57d6a)(transform, el);
            (0, $99026af6cdabc3e1$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $2576ca1a583f3189$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $b5e64753bea494c5$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $a1b116230ebefd82$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $b5e64753bea494c5$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === 'style') saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $b5e64753bea494c5$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$b5e64753bea494c5$var$transformOriginKey] !== finalKfs[p1][$b5e64753bea494c5$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$b5e64753bea494c5$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$b5e64753bea494c5$var$transformOriginKey]) delete finalKfs[percent][$b5e64753bea494c5$var$transformOriginKey];
            attrs[$b5e64753bea494c5$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $99026af6cdabc3e1$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $b5e64753bea494c5$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + (0, $ee7e2a4d6f7cbe8a$export$9c80c36b7367fb56)();
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}






function $671c9fe03f2f21f4$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                'pointer-events': 'none'
            };
            $671c9fe03f2f21f4$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf('select') >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $9148d8aa0f446713$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: 'pointer'
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style['stroke-width'] = lineWidth;
            $671c9fe03f2f21f4$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $671c9fe03f2f21f4$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + '-cls-' + (0, $ee7e2a4d6f7cbe8a$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes['.' + className + (withHover ? ':hover' : '')] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + ' ' + className : className;
}



var $c157189b99a8f744$var$round = Math.round;
function $c157189b99a8f744$var$isImageLike(val) {
    return val && (0, $99026af6cdabc3e1$export$844ec244b1367d54)(val.src);
}
function $c157189b99a8f744$var$isCanvasLike(val) {
    return val && (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(val.toDataURL);
}
function $c157189b99a8f744$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $3107b844df202b0f$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && (0, $2576ca1a583f3189$export$545e02bbd5f8fe95)(val)) $c157189b99a8f744$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $2576ca1a583f3189$export$41a28f5a000a9d0f)(val)) $c157189b99a8f744$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else attrs[key] = val;
        if (isFillStroke && scope.ssr && val === 'none') attrs['pointer-events'] = 'visible';
    }, style, el, false);
    $c157189b99a8f744$var$setShadow(el, attrs, scope);
}
function $c157189b99a8f744$var$setMetaData(attrs, el) {
    var metaData = (0, $b64bfc55c330df69$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $5a8ebb1204068920$export$d3f79611f155197c) + key).toLowerCase()] = val + '');
        });
        if (el.isSilent()) attrs[(0, $5a8ebb1204068920$export$d3f79611f155197c) + 'silent'] = 'true';
    }
}
function $c157189b99a8f744$var$noRotateScale(m) {
    return (0, $2576ca1a583f3189$export$4701367f5b4de464)(m[0] - 1) && (0, $2576ca1a583f3189$export$4701367f5b4de464)(m[1]) && (0, $2576ca1a583f3189$export$4701367f5b4de464)(m[2]) && (0, $2576ca1a583f3189$export$4701367f5b4de464)(m[3] - 1);
}
function $c157189b99a8f744$var$noTranslate(m) {
    return (0, $2576ca1a583f3189$export$4701367f5b4de464)(m[4]) && (0, $2576ca1a583f3189$export$4701367f5b4de464)(m[5]);
}
function $c157189b99a8f744$var$setTransform(attrs, m, compress) {
    if (m && !($c157189b99a8f744$var$noTranslate(m) && $c157189b99a8f744$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $c157189b99a8f744$var$noRotateScale(m) ? "translate(" + $c157189b99a8f744$var$round(m[4] * mul) / mul + " " + $c157189b99a8f744$var$round(m[5] * mul) / mul + ")" : (0, $2576ca1a583f3189$export$f29a4456cf56ff21)(m);
    }
}
function $c157189b99a8f744$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($c157189b99a8f744$var$round(points[i][0] * mul) / mul);
        strArr.push($c157189b99a8f744$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function $c157189b99a8f744$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $c157189b99a8f744$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === 'string' ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $c157189b99a8f744$var$round(val * mul) / mul;
        }
    };
}
var $c157189b99a8f744$var$builtinShapesDef = {
    circle: [
        $c157189b99a8f744$var$createAttrsConvert([
            'cx',
            'cy',
            'r'
        ])
    ],
    polyline: [
        $c157189b99a8f744$var$convertPolyShape,
        $c157189b99a8f744$var$validatePolyShape
    ],
    polygon: [
        $c157189b99a8f744$var$convertPolyShape,
        $c157189b99a8f744$var$validatePolyShape
    ]
};
function $c157189b99a8f744$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === 'shape') return true;
    }
    return false;
}
function $c157189b99a8f744$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $c157189b99a8f744$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $2576ca1a583f3189$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $c157189b99a8f744$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $1d3bf007429cab52$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $c157189b99a8f744$var$setTransform(attrs, el.transform);
    $c157189b99a8f744$var$setStyleAttrs(attrs, style, el, scope);
    $c157189b99a8f744$var$setMetaData(attrs, el);
    scope.animation && (0, $b5e64753bea494c5$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $671c9fe03f2f21f4$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $5a8ebb1204068920$export$bf5c4cf060303d58)(svgElType, el.id + '', attrs);
}
function $c157189b99a8f744$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $99026af6cdabc3e1$export$844ec244b1367d54)(image)) {
        if ($c157189b99a8f744$var$isImageLike(image)) image = image.src;
        else if ($c157189b99a8f744$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $c157189b99a8f744$var$setTransform(attrs, el.transform);
    $c157189b99a8f744$var$setStyleAttrs(attrs, style, el, scope);
    $c157189b99a8f744$var$setMetaData(attrs, el);
    scope.animation && (0, $b5e64753bea494c5$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('image', el.id + '', attrs);
}
function $c157189b99a8f744$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $1fba639b3abe29b0$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $2576ca1a583f3189$export$bf7d6802d2badd9)(style.y || 0, (0, $33d0653e48493c02$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $2576ca1a583f3189$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if ((0, $97dfecd189304201$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = (0, $97dfecd189304201$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $1fba639b3abe29b0$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== 'normal') separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs['xml:space'] = 'preserve';
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $c157189b99a8f744$var$setTransform(attrs, el.transform);
    $c157189b99a8f744$var$setStyleAttrs(attrs, style, el, scope);
    $c157189b99a8f744$var$setMetaData(attrs, el);
    scope.animation && (0, $b5e64753bea494c5$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('text', el.id + '', attrs, undefined, text);
}
function $c157189b99a8f744$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $d730b349402dd5f7$export$2e2bcd8739ae039)) return $c157189b99a8f744$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $a3b3990206d5aa78$export$2e2bcd8739ae039)) return $c157189b99a8f744$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $b4b666d0d13b3e95$export$2e2bcd8739ae039)) return $c157189b99a8f744$export$d506f5385e62a84a(el, scope);
}
function $c157189b99a8f744$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $2576ca1a583f3189$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $2576ca1a583f3189$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $2576ca1a583f3189$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $2576ca1a583f3189$export$bb094196179998a5)(shadowId);
    }
}
function $c157189b99a8f744$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global ? 'userSpaceOnUse' : 'objectBoundingBox'
    };
    if ((0, $2576ca1a583f3189$export$7d961bca9d3b47d0)(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $2576ca1a583f3189$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $2576ca1a583f3189$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = (0, $2576ca1a583f3189$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) stopsAttrs['stop-opacity'] = opacity;
        colorStops.push((0, $5a8ebb1204068920$export$bf5c4cf060303d58)('stop', i + '', stopsAttrs));
    }
    var gradientVNode = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = (0, $5a8ebb1204068920$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $2576ca1a583f3189$export$bb094196179998a5)(gradientId);
}
function $c157189b99a8f744$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === 'no-repeat';
    var repeatX = repeat === 'repeat-x';
    var repeatY = repeat === 'repeat-y';
    var child;
    if ((0, $2576ca1a583f3189$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($c157189b99a8f744$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($c157189b99a8f744$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            (0, $99026af6cdabc3e1$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $99026af6cdabc3e1$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function setSizeToVNode_1(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === 'pattern') {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = (0, $ead47d8961005a49$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = 'userSpaceOnUse';
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $2576ca1a583f3189$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('pattern', '', patternAttrs, [
        child
    ]);
    var patternKey = (0, $5a8ebb1204068920$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('pattern', patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $2576ca1a583f3189$export$bb094196179998a5)(patternId);
}
function $c157189b99a8f744$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('clipPath', clipPathId, clipPathAttrs, [
            $c157189b99a8f744$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs['clip-path'] = (0, $2576ca1a583f3189$export$bb094196179998a5)(clipPathId);
}







function $9dae523e6040e9b8$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $9dae523e6040e9b8$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $9dae523e6040e9b8$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $9dae523e6040e9b8$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $9dae523e6040e9b8$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $9dae523e6040e9b8$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $9dae523e6040e9b8$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $9dae523e6040e9b8$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $9dae523e6040e9b8$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $9dae523e6040e9b8$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $9dae523e6040e9b8$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $9dae523e6040e9b8$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $9dae523e6040e9b8$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $3990c833ff7b704f$var$colonChar = 58;
var $3990c833ff7b704f$var$xChar = 120;
var $3990c833ff7b704f$var$emptyNode = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('', '');
function $3990c833ff7b704f$var$isUndef(s) {
    return s === undefined;
}
function $3990c833ff7b704f$var$isDef(s) {
    return s !== undefined;
}
function $3990c833ff7b704f$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $3990c833ff7b704f$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $3990c833ff7b704f$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($3990c833ff7b704f$var$isDef(tag)) {
        var elm = vnode.elm = (0, $5a8ebb1204068920$export$c8a8987d4410bf2d)(tag);
        $3990c833ff7b704f$export$277dcc6f06048f24($3990c833ff7b704f$var$emptyNode, vnode);
        if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $9dae523e6040e9b8$export$1b8e57c9ea42f1d2(elm, $3990c833ff7b704f$var$createElm(ch));
        }
        else if ($3990c833ff7b704f$var$isDef(vnode.text) && !(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(vnode.text)) $9dae523e6040e9b8$export$1b8e57c9ea42f1d2(elm, $9dae523e6040e9b8$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $9dae523e6040e9b8$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $3990c833ff7b704f$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $9dae523e6040e9b8$export$86b68c7dbeb53c22(parentElm, $3990c833ff7b704f$var$createElm(ch), before);
    }
}
function $3990c833ff7b704f$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($3990c833ff7b704f$var$isDef(ch.tag)) {
                var parent_1 = $9dae523e6040e9b8$export$b54be7ce267a037b(ch.elm);
                $9dae523e6040e9b8$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $9dae523e6040e9b8$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $3990c833ff7b704f$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, '');
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === 'style') elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $3990c833ff7b704f$var$xChar) elm.setAttribute(key, cur);
                else if (key === 'xmlns:xlink' || key === 'xmlns') elm.setAttributeNS((0, $5a8ebb1204068920$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $3990c833ff7b704f$var$colonChar) elm.setAttributeNS((0, $5a8ebb1204068920$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $3990c833ff7b704f$var$colonChar) elm.setAttributeNS((0, $5a8ebb1204068920$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $3990c833ff7b704f$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($3990c833ff7b704f$var$sameVnode(oldStartVnode, newStartVnode)) {
            $3990c833ff7b704f$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($3990c833ff7b704f$var$sameVnode(oldEndVnode, newEndVnode)) {
            $3990c833ff7b704f$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($3990c833ff7b704f$var$sameVnode(oldStartVnode, newEndVnode)) {
            $3990c833ff7b704f$var$patchVnode(oldStartVnode, newEndVnode);
            $9dae523e6040e9b8$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $9dae523e6040e9b8$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($3990c833ff7b704f$var$sameVnode(oldEndVnode, newStartVnode)) {
            $3990c833ff7b704f$var$patchVnode(oldEndVnode, newStartVnode);
            $9dae523e6040e9b8$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($3990c833ff7b704f$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $3990c833ff7b704f$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($3990c833ff7b704f$var$isUndef(idxInOld)) $9dae523e6040e9b8$export$86b68c7dbeb53c22(parentElm, $3990c833ff7b704f$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $9dae523e6040e9b8$export$86b68c7dbeb53c22(parentElm, $3990c833ff7b704f$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $3990c833ff7b704f$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $9dae523e6040e9b8$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $3990c833ff7b704f$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $3990c833ff7b704f$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $3990c833ff7b704f$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $3990c833ff7b704f$export$277dcc6f06048f24(oldVnode, vnode);
    if ($3990c833ff7b704f$var$isUndef(vnode.text)) {
        if ($3990c833ff7b704f$var$isDef(oldCh) && $3990c833ff7b704f$var$isDef(ch)) {
            if (oldCh !== ch) $3990c833ff7b704f$var$updateChildren(elm, oldCh, ch);
        } else if ($3990c833ff7b704f$var$isDef(ch)) {
            if ($3990c833ff7b704f$var$isDef(oldVnode.text)) $9dae523e6040e9b8$export$94b0296cab6203e(elm, '');
            $3990c833ff7b704f$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($3990c833ff7b704f$var$isDef(oldCh)) $3990c833ff7b704f$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($3990c833ff7b704f$var$isDef(oldVnode.text)) $9dae523e6040e9b8$export$94b0296cab6203e(elm, '');
    } else if (oldVnode.text !== vnode.text) {
        if ($3990c833ff7b704f$var$isDef(oldCh)) $3990c833ff7b704f$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $9dae523e6040e9b8$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $3990c833ff7b704f$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($3990c833ff7b704f$var$sameVnode(oldVnode, vnode)) $3990c833ff7b704f$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $9dae523e6040e9b8$export$b54be7ce267a037b(elm);
        $3990c833ff7b704f$var$createElm(vnode);
        if (parent_2 !== null) {
            $9dae523e6040e9b8$export$86b68c7dbeb53c22(parent_2, vnode.elm, $9dae523e6040e9b8$export$335219007e689d29(elm));
            $3990c833ff7b704f$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $82b113eaa74af80e$var$svgId = 0;
var $82b113eaa74af80e$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.refreshHover = $82b113eaa74af80e$var$createMethodNotSupport('refreshHover');
        this.configLayer = $82b113eaa74af80e$var$createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = 'zr' + $82b113eaa74af80e$var$svgId++;
        this._oldVNode = (0, $5a8ebb1204068920$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $5a8ebb1204068920$export$c8a8987d4410bf2d)('svg');
            (0, $3990c833ff7b704f$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            (0, $3990c833ff7b704f$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $c157189b99a8f744$export$da5d6544e8c27bc1)(el, (0, $5a8ebb1204068920$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $5a8ebb1204068920$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        scope.ssr = this._opts.ssr;
        var children = [];
        var bgVNode = this._bgVNode = $82b113eaa74af80e$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('g', 'main', {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)((0, $99026af6cdabc3e1$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $5a8ebb1204068920$export$bf5c4cf060303d58)('defs', 'defs', {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $5a8ebb1204068920$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $5a8ebb1204068920$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $5a8ebb1204068920$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $c157189b99a8f744$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $c157189b99a8f744$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = (0, $aa8f13b286ce6e52$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $aa8f13b286ce6e52$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            if (!(0, $2576ca1a583f3189$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute('width', width);
                    svgDom.setAttribute('height', height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute('width', width);
                    bgEl.setAttribute('height', height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = '';
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = (0, $2576ca1a583f3189$export$8fb536984ec8b4d7)(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $82b113eaa74af80e$var$createMethodNotSupport(method) {
    return function() {};
}
function $82b113eaa74af80e$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== 'none') {
        bgVNode = (0, $5a8ebb1204068920$export$bf5c4cf060303d58)('rect', 'bg', {
            width: width,
            height: height,
            x: '0',
            y: '0'
        });
        if ((0, $2576ca1a583f3189$export$545e02bbd5f8fe95)(backgroundColor)) (0, $c157189b99a8f744$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, 'fill', scope);
        else if ((0, $2576ca1a583f3189$export$41a28f5a000a9d0f)(backgroundColor)) (0, $c157189b99a8f744$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $99026af6cdabc3e1$export$8793edee2d425525),
            getBoundingRect: function getBoundingRect() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, 'fill', scope);
        else {
            var _a = (0, $2576ca1a583f3189$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
        }
    }
    return bgVNode;
}
var $82b113eaa74af80e$export$2e2bcd8739ae039 = $82b113eaa74af80e$var$SVGPainter;


function $4a5ecb2ecc6b13b5$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $82b113eaa74af80e$export$2e2bcd8739ae039));
}



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");

var $leE2g = parcelRequire("leE2g");

var $Csf8W = parcelRequire("Csf8W");


var $dKdZ4 = parcelRequire("dKdZ4");

var $6tqvJ = parcelRequire("6tqvJ");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");

var $leE2g = parcelRequire("leE2g");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");

var $1Qmny = parcelRequire("1Qmny");

var $6tqvJ = parcelRequire("6tqvJ");
/**
 * @license
 * web-streams-polyfill v4.2.0
 * Copyright 2025 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ 
var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $5f0Cq = parcelRequire("5f0Cq");
function $7a13843840af5e19$var$e() {}
function $7a13843840af5e19$var$t(e) {
    return "object" == (typeof e === "undefined" ? "undefined" : (0, $5f0Cq._)(e)) && null !== e || "function" == typeof e;
}
var $7a13843840af5e19$var$r = $7a13843840af5e19$var$e;
function $7a13843840af5e19$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
var $7a13843840af5e19$var$n = Promise, $7a13843840af5e19$var$a = Promise.resolve.bind($7a13843840af5e19$var$n), $7a13843840af5e19$var$i = Promise.prototype.then, $7a13843840af5e19$var$l = Promise.reject.bind($7a13843840af5e19$var$n), $7a13843840af5e19$var$s = $7a13843840af5e19$var$a;
function $7a13843840af5e19$var$u(e) {
    return new $7a13843840af5e19$var$n(e);
}
function $7a13843840af5e19$var$c(e) {
    return $7a13843840af5e19$var$u(function(t) {
        return t(e);
    });
}
function $7a13843840af5e19$var$d(e) {
    return $7a13843840af5e19$var$l(e);
}
function $7a13843840af5e19$var$f(e, t, r) {
    return $7a13843840af5e19$var$i.call(e, t, r);
}
function $7a13843840af5e19$var$b(e, t, o) {
    $7a13843840af5e19$var$f($7a13843840af5e19$var$f(e, t, o), void 0, $7a13843840af5e19$var$r);
}
function $7a13843840af5e19$var$h(e, t) {
    $7a13843840af5e19$var$b(e, t);
}
function $7a13843840af5e19$var$m(e, t) {
    $7a13843840af5e19$var$b(e, void 0, t);
}
function $7a13843840af5e19$var$_(e, t, r) {
    return $7a13843840af5e19$var$f(e, t, r);
}
function $7a13843840af5e19$var$p(e) {
    $7a13843840af5e19$var$f(e, void 0, $7a13843840af5e19$var$r);
}
var $7a13843840af5e19$var$y = function(e) {
    if ("function" == typeof queueMicrotask) $7a13843840af5e19$var$y = queueMicrotask;
    else {
        var _$e = $7a13843840af5e19$var$c(void 0);
        $7a13843840af5e19$var$y = function(t) {
            return $7a13843840af5e19$var$f(_$e, t);
        };
    }
    return $7a13843840af5e19$var$y(e);
};
function $7a13843840af5e19$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $7a13843840af5e19$var$g(e, t, r) {
    try {
        return $7a13843840af5e19$var$c($7a13843840af5e19$var$S(e, t, r));
    } catch (e) {
        return $7a13843840af5e19$var$d(e);
    }
}
var $7a13843840af5e19$var$v = /*#__PURE__*/ function() {
    "use strict";
    function v() {
        (0, $7lhcp._)(this, v);
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    (0, $8BtP9._)(v, [
        {
            key: "length",
            get: function get() {
                return this._size;
            }
        },
        {
            key: "push",
            value: function push(e) {
                var t = this._back;
                var r = t;
                16383 === t._elements.length && (r = {
                    _elements: [],
                    _next: void 0
                }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
            }
        },
        {
            key: "shift",
            value: function shift() {
                var _$e = this._front;
                var t = _$e;
                var r = this._cursor;
                var _$o = r + 1;
                var n = _$e._elements, a = n[r];
                return 16384 === _$o && (t = _$e._next, _$o = 0), --this._size, this._cursor = _$o, _$e !== t && (this._front = t), n[r] = void 0, a;
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                var t = this._cursor, r = this._front, _$o = r._elements;
                for(; !(t === _$o.length && void 0 === r._next || t === _$o.length && (r = r._next, _$o = r._elements, t = 0, 0 === _$o.length));)e(_$o[t]), ++t;
            }
        },
        {
            key: "peek",
            value: function peek() {
                var _$e = this._front, t = this._cursor;
                return _$e._elements[t];
            }
        }
    ]);
    return v;
}();
var $7a13843840af5e19$var$w = Symbol("[[AbortSteps]]"), $7a13843840af5e19$var$R = Symbol("[[ErrorSteps]]"), $7a13843840af5e19$var$T = Symbol("[[CancelSteps]]"), $7a13843840af5e19$var$C = Symbol("[[PullSteps]]"), $7a13843840af5e19$var$P = Symbol("[[ReleaseSteps]]");
function $7a13843840af5e19$var$q(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $7a13843840af5e19$var$B(e) : "closed" === t._state ? function(e) {
        $7a13843840af5e19$var$B(e), $7a13843840af5e19$var$A(e);
    }(e) : $7a13843840af5e19$var$k(e, t._storedError);
}
function $7a13843840af5e19$var$E(e, t) {
    return $7a13843840af5e19$var$Or(e._ownerReadableStream, t);
}
function $7a13843840af5e19$var$W(e) {
    var t = e._ownerReadableStream;
    "readable" === t._state ? $7a13843840af5e19$var$j(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $7a13843840af5e19$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$7a13843840af5e19$var$P](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $7a13843840af5e19$var$O(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $7a13843840af5e19$var$B(e) {
    e._closedPromise = $7a13843840af5e19$var$u(function(t, r) {
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $7a13843840af5e19$var$k(e, t) {
    $7a13843840af5e19$var$B(e), $7a13843840af5e19$var$j(e, t);
}
function $7a13843840af5e19$var$j(e, t) {
    void 0 !== e._closedPromise_reject && ($7a13843840af5e19$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $7a13843840af5e19$var$A(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
var $7a13843840af5e19$var$z = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $7a13843840af5e19$var$D = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $7a13843840af5e19$var$L(e, t) {
    if (void 0 !== e && "object" != (0, $5f0Cq._)(r = e) && "function" != typeof r) throw new TypeError("".concat(t, " is not an object."));
    var r;
}
function $7a13843840af5e19$var$F(e, t) {
    if ("function" != typeof e) throw new TypeError("".concat(t, " is not a function."));
}
function $7a13843840af5e19$var$I(e, t) {
    if (!function(e) {
        return "object" == (typeof e === "undefined" ? "undefined" : (0, $5f0Cq._)(e)) && null !== e || "function" == typeof e;
    }(e)) throw new TypeError("".concat(t, " is not an object."));
}
function $7a13843840af5e19$var$$(e, t, r) {
    if (void 0 === e) throw new TypeError("Parameter ".concat(t, " is required in '").concat(r, "'."));
}
function $7a13843840af5e19$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError("".concat(t, " is required in '").concat(r, "'."));
}
function $7a13843840af5e19$var$Y(e) {
    return Number(e);
}
function $7a13843840af5e19$var$x(e) {
    return 0 === e ? 0 : e;
}
function $7a13843840af5e19$var$Q(e, t) {
    var r = Number.MAX_SAFE_INTEGER;
    var _$o = Number(e);
    if (_$o = $7a13843840af5e19$var$x(_$o), !$7a13843840af5e19$var$z(_$o)) throw new TypeError("".concat(t, " is not a finite number"));
    if (_$o = function(e) {
        return $7a13843840af5e19$var$x($7a13843840af5e19$var$D(e));
    }(_$o), _$o < 0 || _$o > r) throw new TypeError("".concat(t, " is outside the accepted range of 0 to ").concat(r, ", inclusive"));
    return $7a13843840af5e19$var$z(_$o) && 0 !== _$o ? _$o : 0;
}
function $7a13843840af5e19$var$N(e, t) {
    if (!$7a13843840af5e19$var$Er(e)) throw new TypeError("".concat(t, " is not a ReadableStream."));
}
function $7a13843840af5e19$var$H(e) {
    return new $7a13843840af5e19$export$a890bf36e2af9168(e);
}
function $7a13843840af5e19$var$V(e, t) {
    e._reader._readRequests.push(t);
}
function $7a13843840af5e19$var$U(e, t, r) {
    var _$o = e._reader._readRequests.shift();
    r ? _$o._closeSteps() : _$o._chunkSteps(t);
}
function $7a13843840af5e19$var$G(e) {
    return e._reader._readRequests.length;
}
function $7a13843840af5e19$var$X(e) {
    var t = e._reader;
    return void 0 !== t && !!$7a13843840af5e19$var$J(t);
}
var $7a13843840af5e19$export$a890bf36e2af9168 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamDefaultReader(e) {
        (0, $7lhcp._)(this, ReadableStreamDefaultReader);
        if ($7a13843840af5e19$var$$(e, 1, "ReadableStreamDefaultReader"), $7a13843840af5e19$var$N(e, "First parameter"), $7a13843840af5e19$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $7a13843840af5e19$var$q(this, e), this._readRequests = new $7a13843840af5e19$var$v;
    }
    (0, $8BtP9._)(ReadableStreamDefaultReader, [
        {
            key: "closed",
            get: function get() {
                return $7a13843840af5e19$var$J(this) ? this._closedPromise : $7a13843840af5e19$var$d($7a13843840af5e19$var$ee("closed"));
            }
        },
        {
            key: "cancel",
            value: function cancel(e) {
                return $7a13843840af5e19$var$J(this) ? void 0 === this._ownerReadableStream ? $7a13843840af5e19$var$d($7a13843840af5e19$var$O("cancel")) : $7a13843840af5e19$var$E(this, e) : $7a13843840af5e19$var$d($7a13843840af5e19$var$ee("cancel"));
            }
        },
        {
            key: "read",
            value: function read() {
                if (!$7a13843840af5e19$var$J(this)) return $7a13843840af5e19$var$d($7a13843840af5e19$var$ee("read"));
                if (void 0 === this._ownerReadableStream) return $7a13843840af5e19$var$d($7a13843840af5e19$var$O("read from"));
                var _$e, t;
                var r = $7a13843840af5e19$var$u(function(r, o) {
                    _$e = r, t = o;
                });
                return $7a13843840af5e19$var$K(this, {
                    _chunkSteps: function(t) {
                        return _$e({
                            value: t,
                            done: !1
                        });
                    },
                    _closeSteps: function() {
                        return _$e({
                            value: void 0,
                            done: !0
                        });
                    },
                    _errorSteps: function(e) {
                        return t(e);
                    }
                }), r;
            }
        },
        {
            key: "releaseLock",
            value: function releaseLock() {
                if (!$7a13843840af5e19$var$J(this)) throw $7a13843840af5e19$var$ee("releaseLock");
                void 0 !== this._ownerReadableStream && function(e) {
                    $7a13843840af5e19$var$W(e);
                    var t = new TypeError("Reader was released");
                    $7a13843840af5e19$var$Z(e, t);
                }(this);
            }
        }
    ]);
    return ReadableStreamDefaultReader;
}();
function $7a13843840af5e19$var$J(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $7a13843840af5e19$export$a890bf36e2af9168;
}
function $7a13843840af5e19$var$K(e, t) {
    var r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$7a13843840af5e19$var$C](t);
}
function $7a13843840af5e19$var$Z(e, t) {
    var r = e._readRequests;
    e._readRequests = new $7a13843840af5e19$var$v, r.forEach(function(e) {
        e._errorSteps(t);
    });
}
function $7a13843840af5e19$var$ee(e) {
    return new TypeError("ReadableStreamDefaultReader.prototype.".concat(e, " can only be used on a ReadableStreamDefaultReader"));
}
var $7a13843840af5e19$var$te, $7a13843840af5e19$var$re, $7a13843840af5e19$var$oe;
function $7a13843840af5e19$var$ne(e) {
    return e.slice();
}
function $7a13843840af5e19$var$ae(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
Object.defineProperties($7a13843840af5e19$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$a890bf36e2af9168.prototype.cancel, "cancel"), $7a13843840af5e19$var$o($7a13843840af5e19$export$a890bf36e2af9168.prototype.read, "read"), $7a13843840af5e19$var$o($7a13843840af5e19$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
var $7a13843840af5e19$var$ie = function(e) {
    return $7a13843840af5e19$var$ie = "function" == typeof e.transfer ? function(e) {
        return e.transfer();
    } : "function" == typeof structuredClone ? function(e) {
        return structuredClone(e, {
            transfer: [
                e
            ]
        });
    } : function(e) {
        return e;
    }, $7a13843840af5e19$var$ie(e);
}, $7a13843840af5e19$var$le = function(e) {
    return $7a13843840af5e19$var$le = "boolean" == typeof e.detached ? function(e) {
        return e.detached;
    } : function(e) {
        return 0 === e.byteLength;
    }, $7a13843840af5e19$var$le(e);
};
function $7a13843840af5e19$var$se(e, t, r) {
    if (e.slice) return e.slice(t, r);
    var _$o = r - t, n = new ArrayBuffer(_$o);
    return $7a13843840af5e19$var$ae(n, 0, e, t, _$o), n;
}
function $7a13843840af5e19$var$ue(e, t) {
    var r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError("".concat(String(t), " is not a function"));
        return r;
    }
}
function $7a13843840af5e19$var$ce(e) {
    try {
        var t = e.done, r = e.value;
        return $7a13843840af5e19$var$f($7a13843840af5e19$var$s(r), function(e) {
            return {
                done: t,
                value: e
            };
        });
    } catch (e) {
        return $7a13843840af5e19$var$d(e);
    }
}
var $7a13843840af5e19$var$de = null !== ($7a13843840af5e19$var$oe = null !== ($7a13843840af5e19$var$te = Symbol.asyncIterator) && void 0 !== $7a13843840af5e19$var$te ? $7a13843840af5e19$var$te : null === ($7a13843840af5e19$var$re = Symbol.for) || void 0 === $7a13843840af5e19$var$re ? void 0 : $7a13843840af5e19$var$re.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $7a13843840af5e19$var$oe ? $7a13843840af5e19$var$oe : "@@asyncIterator";
function $7a13843840af5e19$var$fe(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "sync", _$o = arguments.length > 2 ? arguments[2] : void 0;
    if (void 0 === _$o) {
        if ("async" === r) {
            if (void 0 === (_$o = $7a13843840af5e19$var$ue(e, $7a13843840af5e19$var$de))) return function(e) {
                var r = {
                    next: function() {
                        var _$t;
                        try {
                            _$t = $7a13843840af5e19$var$be(e);
                        } catch (e) {
                            return $7a13843840af5e19$var$d(e);
                        }
                        return $7a13843840af5e19$var$ce(_$t);
                    },
                    return: function(r) {
                        var _$o;
                        try {
                            var _$t = $7a13843840af5e19$var$ue(e.iterator, "return");
                            if (void 0 === _$t) return $7a13843840af5e19$var$c({
                                done: !0,
                                value: r
                            });
                            _$o = $7a13843840af5e19$var$S(_$t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $7a13843840af5e19$var$d(e);
                        }
                        return $7a13843840af5e19$var$t(_$o) ? $7a13843840af5e19$var$ce(_$o) : $7a13843840af5e19$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($7a13843840af5e19$var$fe(e, "sync", $7a13843840af5e19$var$ue(e, Symbol.iterator)));
        } else _$o = $7a13843840af5e19$var$ue(e, Symbol.iterator);
    }
    if (void 0 === _$o) throw new TypeError("The object is not iterable");
    var n = $7a13843840af5e19$var$S(_$o, e, []);
    if (!$7a13843840af5e19$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $7a13843840af5e19$var$be(e) {
    var r = $7a13843840af5e19$var$S(e.nextMethod, e.iterator, []);
    if (!$7a13843840af5e19$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
var $7a13843840af5e19$var$he = /*#__PURE__*/ function() {
    "use strict";
    function he(e, t) {
        (0, $7lhcp._)(this, he);
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    (0, $8BtP9._)(he, [
        {
            key: "next",
            value: function next() {
                var _this = this;
                var _$e = function() {
                    return _this._nextSteps();
                };
                return this._ongoingPromise = this._ongoingPromise ? $7a13843840af5e19$var$_(this._ongoingPromise, _$e, _$e) : _$e(), this._ongoingPromise;
            }
        },
        {
            key: "return",
            value: function _return(e) {
                var _this = this;
                var t = function() {
                    return _this._returnSteps(e);
                };
                return this._ongoingPromise = this._ongoingPromise ? $7a13843840af5e19$var$_(this._ongoingPromise, t, t) : t(), this._ongoingPromise;
            }
        },
        {
            key: "_nextSteps",
            value: function _nextSteps() {
                var _this = this;
                if (this._isFinished) return Promise.resolve({
                    value: void 0,
                    done: !0
                });
                var _$e = this._reader;
                var t, r;
                var _$o = $7a13843840af5e19$var$u(function(e, o) {
                    t = e, r = o;
                });
                return $7a13843840af5e19$var$K(_$e, {
                    _chunkSteps: function(e) {
                        _this._ongoingPromise = void 0, $7a13843840af5e19$var$y(function() {
                            return t({
                                value: e,
                                done: !1
                            });
                        });
                    },
                    _closeSteps: function() {
                        _this._ongoingPromise = void 0, _this._isFinished = !0, $7a13843840af5e19$var$W(_$e), t({
                            value: void 0,
                            done: !0
                        });
                    },
                    _errorSteps: function(t) {
                        _this._ongoingPromise = void 0, _this._isFinished = !0, $7a13843840af5e19$var$W(_$e), r(t);
                    }
                }), _$o;
            }
        },
        {
            key: "_returnSteps",
            value: function _returnSteps(e) {
                if (this._isFinished) return Promise.resolve({
                    value: e,
                    done: !0
                });
                this._isFinished = !0;
                var t = this._reader;
                if (!this._preventCancel) {
                    var r = $7a13843840af5e19$var$E(t, e);
                    return $7a13843840af5e19$var$W(t), $7a13843840af5e19$var$_(r, function() {
                        return {
                            value: e,
                            done: !0
                        };
                    });
                }
                return $7a13843840af5e19$var$W(t), $7a13843840af5e19$var$c({
                    value: e,
                    done: !0
                });
            }
        }
    ]);
    return he;
}();
var $7a13843840af5e19$var$me = (0, $5RfYb._)({
    next: function() {
        return $7a13843840af5e19$var$_e(this) ? this._asyncIteratorImpl.next() : $7a13843840af5e19$var$d($7a13843840af5e19$var$pe("next"));
    },
    return: function(e) {
        return $7a13843840af5e19$var$_e(this) ? this._asyncIteratorImpl.return(e) : $7a13843840af5e19$var$d($7a13843840af5e19$var$pe("return"));
    }
}, $7a13843840af5e19$var$de, function() {
    return this;
});
function $7a13843840af5e19$var$_e(e) {
    if (!$7a13843840af5e19$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $7a13843840af5e19$var$he;
    } catch (e) {
        return !1;
    }
}
function $7a13843840af5e19$var$pe(e) {
    return new TypeError("ReadableStreamAsyncIterator.".concat(e, " can only be used on a ReadableSteamAsyncIterator"));
}
Object.defineProperty($7a13843840af5e19$var$me, $7a13843840af5e19$var$de, {
    enumerable: !1
});
var $7a13843840af5e19$var$ye = Number.isNaN || function(e) {
    return e != e;
};
function $7a13843840af5e19$var$Se(e) {
    var t = $7a13843840af5e19$var$se(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $7a13843840af5e19$var$ge(e) {
    var t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $7a13843840af5e19$var$ve(e, t, r) {
    if ("number" != typeof (_$o = r) || $7a13843840af5e19$var$ye(_$o) || _$o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var _$o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $7a13843840af5e19$var$we(e) {
    e._queue = new $7a13843840af5e19$var$v, e._queueTotalSize = 0;
}
function $7a13843840af5e19$var$Re(e) {
    return e === DataView;
}
var $7a13843840af5e19$export$fbcf11583158d2c = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamBYOBRequest() {
        (0, $7lhcp._)(this, ReadableStreamBYOBRequest);
        throw new TypeError("Illegal constructor");
    }
    (0, $8BtP9._)(ReadableStreamBYOBRequest, [
        {
            key: "view",
            get: function get() {
                if (!$7a13843840af5e19$var$Ce(this)) throw $7a13843840af5e19$var$Ke("view");
                return this._view;
            }
        },
        {
            key: "respond",
            value: function respond(e) {
                if (!$7a13843840af5e19$var$Ce(this)) throw $7a13843840af5e19$var$Ke("respond");
                if ($7a13843840af5e19$var$$(e, 1, "respond"), e = $7a13843840af5e19$var$Q(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
                if ($7a13843840af5e19$var$le(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
                $7a13843840af5e19$var$Ge(this._associatedReadableByteStreamController, e);
            }
        },
        {
            key: "respondWithNewView",
            value: function respondWithNewView(e) {
                if (!$7a13843840af5e19$var$Ce(this)) throw $7a13843840af5e19$var$Ke("respondWithNewView");
                if ($7a13843840af5e19$var$$(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
                if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
                if ($7a13843840af5e19$var$le(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
                $7a13843840af5e19$var$Xe(this._associatedReadableByteStreamController, e);
            }
        }
    ]);
    return ReadableStreamBYOBRequest;
}();
Object.defineProperties($7a13843840af5e19$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$fbcf11583158d2c.prototype.respond, "respond"), $7a13843840af5e19$var$o($7a13843840af5e19$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
var $7a13843840af5e19$export$2047cf34091e94ac = /*#__PURE__*/ function() {
    "use strict";
    function ReadableByteStreamController() {
        (0, $7lhcp._)(this, ReadableByteStreamController);
        throw new TypeError("Illegal constructor");
    }
    (0, $8BtP9._)(ReadableByteStreamController, [
        {
            key: "byobRequest",
            get: function get() {
                if (!$7a13843840af5e19$var$Te(this)) throw $7a13843840af5e19$var$Ze("byobRequest");
                return $7a13843840af5e19$var$Ve(this);
            }
        },
        {
            key: "desiredSize",
            get: function get() {
                if (!$7a13843840af5e19$var$Te(this)) throw $7a13843840af5e19$var$Ze("desiredSize");
                return $7a13843840af5e19$var$Ue(this);
            }
        },
        {
            key: "close",
            value: function close() {
                if (!$7a13843840af5e19$var$Te(this)) throw $7a13843840af5e19$var$Ze("close");
                if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
                var _$e = this._controlledReadableByteStream._state;
                if ("readable" !== _$e) throw new TypeError("The stream (in ".concat(_$e, " state) is not in the readable state and cannot be closed"));
                $7a13843840af5e19$var$xe(this);
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                if (!$7a13843840af5e19$var$Te(this)) throw $7a13843840af5e19$var$Ze("enqueue");
                if ($7a13843840af5e19$var$$(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
                if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
                if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
                if (this._closeRequested) throw new TypeError("stream is closed or draining");
                var t = this._controlledReadableByteStream._state;
                if ("readable" !== t) throw new TypeError("The stream (in ".concat(t, " state) is not in the readable state and cannot be enqueued to"));
                $7a13843840af5e19$var$Qe(this, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$7a13843840af5e19$var$Te(this)) throw $7a13843840af5e19$var$Ze("error");
                $7a13843840af5e19$var$Ne(this, e);
            }
        },
        {
            key: $7a13843840af5e19$var$T,
            value: function value(e) {
                $7a13843840af5e19$var$qe(this), $7a13843840af5e19$var$we(this);
                var t = this._cancelAlgorithm(e);
                return $7a13843840af5e19$var$Ye(this), t;
            }
        },
        {
            key: $7a13843840af5e19$var$C,
            value: function value(e) {
                var _$t = this._controlledReadableByteStream;
                if (this._queueTotalSize > 0) return void $7a13843840af5e19$var$He(this, e);
                var r = this._autoAllocateChunkSize;
                if (void 0 !== r) {
                    var _$t1;
                    try {
                        _$t1 = new ArrayBuffer(r);
                    } catch (t) {
                        return void e._errorSteps(t);
                    }
                    var _$o = {
                        buffer: _$t1,
                        bufferByteLength: r,
                        byteOffset: 0,
                        byteLength: r,
                        bytesFilled: 0,
                        minimumFill: 1,
                        elementSize: 1,
                        viewConstructor: Uint8Array,
                        readerType: "default"
                    };
                    this._pendingPullIntos.push(_$o);
                }
                $7a13843840af5e19$var$V(_$t, e), $7a13843840af5e19$var$Pe(this);
            }
        },
        {
            key: $7a13843840af5e19$var$P,
            value: function value() {
                if (this._pendingPullIntos.length > 0) {
                    var _$e = this._pendingPullIntos.peek();
                    _$e.readerType = "none", this._pendingPullIntos = new $7a13843840af5e19$var$v, this._pendingPullIntos.push(_$e);
                }
            }
        }
    ]);
    return ReadableByteStreamController;
}();
function $7a13843840af5e19$var$Te(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $7a13843840af5e19$export$2047cf34091e94ac;
}
function $7a13843840af5e19$var$Ce(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $7a13843840af5e19$export$fbcf11583158d2c;
}
function $7a13843840af5e19$var$Pe(e) {
    var t = function(e) {
        var t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($7a13843840af5e19$var$X(t) && $7a13843840af5e19$var$G(t) > 0) return !0;
        if ($7a13843840af5e19$var$nt(t) && $7a13843840af5e19$var$ot(t) > 0) return !0;
        var r = $7a13843840af5e19$var$Ue(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $7a13843840af5e19$var$b(e._pullAlgorithm(), function() {
        return e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $7a13843840af5e19$var$Pe(e)), null;
    }, function(t) {
        return $7a13843840af5e19$var$Ne(e, t), null;
    });
}
function $7a13843840af5e19$var$qe(e) {
    $7a13843840af5e19$var$Le(e), e._pendingPullIntos = new $7a13843840af5e19$var$v;
}
function $7a13843840af5e19$var$Ee(e, t) {
    var r = !1;
    "closed" === e._state && (r = !0);
    var _$o = $7a13843840af5e19$var$Oe(t);
    "default" === t.readerType ? $7a13843840af5e19$var$U(e, _$o, r) : function(e, t, r) {
        var _$o = e._reader, n = _$o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, _$o, r);
}
function $7a13843840af5e19$var$We(e, t) {
    for(var r = 0; r < t.length; ++r)$7a13843840af5e19$var$Ee(e, t[r]);
}
function $7a13843840af5e19$var$Oe(e) {
    var t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $7a13843840af5e19$var$Be(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $7a13843840af5e19$var$ke(e, t, r, o) {
    var n;
    try {
        n = $7a13843840af5e19$var$se(t, r, r + o);
    } catch (t) {
        throw $7a13843840af5e19$var$Ne(e, t), t;
    }
    $7a13843840af5e19$var$Be(e, n, 0, o);
}
function $7a13843840af5e19$var$je(e, t) {
    t.bytesFilled > 0 && $7a13843840af5e19$var$ke(e, t.buffer, t.byteOffset, t.bytesFilled), $7a13843840af5e19$var$Me(e);
}
function $7a13843840af5e19$var$Ae(e, t) {
    var r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), _$o = t.bytesFilled + r;
    var n = r, a = !1;
    var i = _$o - _$o % t.elementSize;
    i >= t.minimumFill && (n = i - t.bytesFilled, a = !0);
    var l = e._queue;
    for(; n > 0;){
        var r1 = l.peek(), _$o1 = Math.min(n, r1.byteLength), a1 = t.byteOffset + t.bytesFilled;
        $7a13843840af5e19$var$ae(t.buffer, a1, r1.buffer, r1.byteOffset, _$o1), r1.byteLength === _$o1 ? l.shift() : (r1.byteOffset += _$o1, r1.byteLength -= _$o1), e._queueTotalSize -= _$o1, $7a13843840af5e19$var$ze(e, _$o1, t), n -= _$o1;
    }
    return a;
}
function $7a13843840af5e19$var$ze(e, t, r) {
    r.bytesFilled += t;
}
function $7a13843840af5e19$var$De(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($7a13843840af5e19$var$Ye(e), $7a13843840af5e19$var$Br(e._controlledReadableByteStream)) : $7a13843840af5e19$var$Pe(e);
}
function $7a13843840af5e19$var$Le(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $7a13843840af5e19$var$Fe(e) {
    var t = [];
    for(; e._pendingPullIntos.length > 0 && 0 !== e._queueTotalSize;){
        var r = e._pendingPullIntos.peek();
        $7a13843840af5e19$var$Ae(e, r) && ($7a13843840af5e19$var$Me(e), t.push(r));
    }
    return t;
}
function $7a13843840af5e19$var$Ie(e, t, r, o) {
    var n = e._controlledReadableByteStream, a = t.constructor, i = function(e) {
        return $7a13843840af5e19$var$Re(e) ? 1 : e.BYTES_PER_ELEMENT;
    }(a), l = t.byteOffset, s = t.byteLength, u = r * i;
    var c;
    try {
        c = $7a13843840af5e19$var$ie(t.buffer);
    } catch (e) {
        return void o._errorSteps(e);
    }
    var d = {
        buffer: c,
        bufferByteLength: c.byteLength,
        byteOffset: l,
        byteLength: s,
        bytesFilled: 0,
        minimumFill: u,
        elementSize: i,
        viewConstructor: a,
        readerType: "byob"
    };
    if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $7a13843840af5e19$var$rt(n, o);
    if ("closed" === n._state) {
        var _$e = new a(d.buffer, d.byteOffset, 0);
        return void o._closeSteps(_$e);
    }
    if (e._queueTotalSize > 0) {
        if ($7a13843840af5e19$var$Ae(e, d)) {
            var _$t = $7a13843840af5e19$var$Oe(d);
            return $7a13843840af5e19$var$De(e), void o._chunkSteps(_$t);
        }
        if (e._closeRequested) {
            var _$t1 = new TypeError("Insufficient bytes to fill elements in the given buffer");
            return $7a13843840af5e19$var$Ne(e, _$t1), void o._errorSteps(_$t1);
        }
    }
    e._pendingPullIntos.push(d), $7a13843840af5e19$var$rt(n, o), $7a13843840af5e19$var$Pe(e);
}
function $7a13843840af5e19$var$$e(e, t) {
    var r = e._pendingPullIntos.peek();
    $7a13843840af5e19$var$Le(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $7a13843840af5e19$var$Me(e);
        var r = e._controlledReadableByteStream;
        if ($7a13843840af5e19$var$nt(r)) {
            var _$t = [];
            for(; _$t.length < $7a13843840af5e19$var$ot(r);)_$t.push($7a13843840af5e19$var$Me(e));
            $7a13843840af5e19$var$We(r, _$t);
        }
    }(e, r) : function(e, t, r) {
        if ($7a13843840af5e19$var$ze(0, t, r), "none" === r.readerType) {
            $7a13843840af5e19$var$je(e, r);
            var _$t = $7a13843840af5e19$var$Fe(e);
            return void $7a13843840af5e19$var$We(e._controlledReadableByteStream, _$t);
        }
        if (r.bytesFilled < r.minimumFill) return;
        $7a13843840af5e19$var$Me(e);
        var _$o = r.bytesFilled % r.elementSize;
        if (_$o > 0) {
            var _$t1 = r.byteOffset + r.bytesFilled;
            $7a13843840af5e19$var$ke(e, r.buffer, _$t1 - _$o, _$o);
        }
        r.bytesFilled -= _$o;
        var n = $7a13843840af5e19$var$Fe(e);
        $7a13843840af5e19$var$Ee(e._controlledReadableByteStream, r), $7a13843840af5e19$var$We(e._controlledReadableByteStream, n);
    }(e, t, r), $7a13843840af5e19$var$Pe(e);
}
function $7a13843840af5e19$var$Me(e) {
    return e._pendingPullIntos.shift();
}
function $7a13843840af5e19$var$Ye(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $7a13843840af5e19$var$xe(e) {
    var t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                var t1 = e._pendingPullIntos.peek();
                if (t1.bytesFilled % t1.elementSize !== 0) {
                    var t2 = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $7a13843840af5e19$var$Ne(e, t2), t2;
                }
            }
            $7a13843840af5e19$var$Ye(e), $7a13843840af5e19$var$Br(t);
        }
    }
}
function $7a13843840af5e19$var$Qe(e, t) {
    var r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    var _$o = t.buffer, n = t.byteOffset, a = t.byteLength;
    if ($7a13843840af5e19$var$le(_$o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    var i = $7a13843840af5e19$var$ie(_$o);
    if (e._pendingPullIntos.length > 0) {
        var _$t = e._pendingPullIntos.peek();
        if ($7a13843840af5e19$var$le(_$t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $7a13843840af5e19$var$Le(e), _$t.buffer = $7a13843840af5e19$var$ie(_$t.buffer), "none" === _$t.readerType && $7a13843840af5e19$var$je(e, _$t);
    }
    if ($7a13843840af5e19$var$X(r)) {
        if (function(e) {
            var _$t = e._controlledReadableByteStream._reader;
            for(; _$t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $7a13843840af5e19$var$He(e, _$t._readRequests.shift());
            }
        }(e), 0 === $7a13843840af5e19$var$G(r)) $7a13843840af5e19$var$Be(e, i, n, a);
        else {
            e._pendingPullIntos.length > 0 && $7a13843840af5e19$var$Me(e);
            $7a13843840af5e19$var$U(r, new Uint8Array(i, n, a), !1);
        }
    } else if ($7a13843840af5e19$var$nt(r)) {
        $7a13843840af5e19$var$Be(e, i, n, a);
        $7a13843840af5e19$var$We(r, $7a13843840af5e19$var$Fe(e));
    } else $7a13843840af5e19$var$Be(e, i, n, a);
    $7a13843840af5e19$var$Pe(e);
}
function $7a13843840af5e19$var$Ne(e, t) {
    var r = e._controlledReadableByteStream;
    "readable" === r._state && ($7a13843840af5e19$var$qe(e), $7a13843840af5e19$var$we(e), $7a13843840af5e19$var$Ye(e), $7a13843840af5e19$var$kr(r, t));
}
function $7a13843840af5e19$var$He(e, t) {
    var r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $7a13843840af5e19$var$De(e);
    var _$o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(_$o);
}
function $7a13843840af5e19$var$Ve(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        var t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), _$o = Object.create($7a13843840af5e19$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(_$o, e, r), e._byobRequest = _$o;
    }
    return e._byobRequest;
}
function $7a13843840af5e19$var$Ue(e) {
    var t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $7a13843840af5e19$var$Ge(e, t) {
    var r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $7a13843840af5e19$var$ie(r.buffer), $7a13843840af5e19$var$$e(e, t);
}
function $7a13843840af5e19$var$Xe(e, t) {
    var r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    var _$o = t.byteLength;
    r.buffer = $7a13843840af5e19$var$ie(t.buffer), $7a13843840af5e19$var$$e(e, _$o);
}
function $7a13843840af5e19$var$Je(e, t, r, o, n, a, i) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $7a13843840af5e19$var$we(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = i, t._pendingPullIntos = new $7a13843840af5e19$var$v, e._readableStreamController = t;
    $7a13843840af5e19$var$b($7a13843840af5e19$var$c(r()), function() {
        return t._started = !0, $7a13843840af5e19$var$Pe(t), null;
    }, function(e) {
        return $7a13843840af5e19$var$Ne(t, e), null;
    });
}
function $7a13843840af5e19$var$Ke(e) {
    return new TypeError("ReadableStreamBYOBRequest.prototype.".concat(e, " can only be used on a ReadableStreamBYOBRequest"));
}
function $7a13843840af5e19$var$Ze(e) {
    return new TypeError("ReadableByteStreamController.prototype.".concat(e, " can only be used on a ReadableByteStreamController"));
}
function $7a13843840af5e19$var$et(e, t) {
    if ("byob" !== (e = "".concat(e))) throw new TypeError("".concat(t, " '").concat(e, "' is not a valid enumeration value for ReadableStreamReaderMode"));
    return e;
}
function $7a13843840af5e19$var$tt(e) {
    return new $7a13843840af5e19$export$20068a30393fcc28(e);
}
function $7a13843840af5e19$var$rt(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $7a13843840af5e19$var$ot(e) {
    return e._reader._readIntoRequests.length;
}
function $7a13843840af5e19$var$nt(e) {
    var t = e._reader;
    return void 0 !== t && !!$7a13843840af5e19$var$at(t);
}
Object.defineProperties($7a13843840af5e19$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$2047cf34091e94ac.prototype.close, "close"), $7a13843840af5e19$var$o($7a13843840af5e19$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $7a13843840af5e19$var$o($7a13843840af5e19$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
var $7a13843840af5e19$export$20068a30393fcc28 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamBYOBReader(e) {
        (0, $7lhcp._)(this, ReadableStreamBYOBReader);
        if ($7a13843840af5e19$var$$(e, 1, "ReadableStreamBYOBReader"), $7a13843840af5e19$var$N(e, "First parameter"), $7a13843840af5e19$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$7a13843840af5e19$var$Te(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $7a13843840af5e19$var$q(this, e), this._readIntoRequests = new $7a13843840af5e19$var$v;
    }
    (0, $8BtP9._)(ReadableStreamBYOBReader, [
        {
            key: "closed",
            get: function get() {
                return $7a13843840af5e19$var$at(this) ? this._closedPromise : $7a13843840af5e19$var$d($7a13843840af5e19$var$st("closed"));
            }
        },
        {
            key: "cancel",
            value: function cancel(e) {
                return $7a13843840af5e19$var$at(this) ? void 0 === this._ownerReadableStream ? $7a13843840af5e19$var$d($7a13843840af5e19$var$O("cancel")) : $7a13843840af5e19$var$E(this, e) : $7a13843840af5e19$var$d($7a13843840af5e19$var$st("cancel"));
            }
        },
        {
            key: "read",
            value: function read(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!$7a13843840af5e19$var$at(this)) return $7a13843840af5e19$var$d($7a13843840af5e19$var$st("read"));
                if (!ArrayBuffer.isView(e)) return $7a13843840af5e19$var$d(new TypeError("view must be an array buffer view"));
                if (0 === e.byteLength) return $7a13843840af5e19$var$d(new TypeError("view must have non-zero byteLength"));
                if (0 === e.buffer.byteLength) return $7a13843840af5e19$var$d(new TypeError("view's buffer must have non-zero byteLength"));
                if ($7a13843840af5e19$var$le(e.buffer)) return $7a13843840af5e19$var$d(new TypeError("view's buffer has been detached"));
                var r;
                try {
                    r = function(e, t) {
                        var r;
                        return $7a13843840af5e19$var$L(e, t), {
                            min: $7a13843840af5e19$var$Q(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, "".concat(t, " has member 'min' that"))
                        };
                    }(t, "options");
                } catch (e) {
                    return $7a13843840af5e19$var$d(e);
                }
                var _$o = r.min;
                if (0 === _$o) return $7a13843840af5e19$var$d(new TypeError("options.min must be greater than 0"));
                if (function(e) {
                    return $7a13843840af5e19$var$Re(e.constructor);
                }(e)) {
                    if (_$o > e.byteLength) return $7a13843840af5e19$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
                } else if (_$o > e.length) return $7a13843840af5e19$var$d(new RangeError("options.min must be less than or equal to view's length"));
                if (void 0 === this._ownerReadableStream) return $7a13843840af5e19$var$d($7a13843840af5e19$var$O("read from"));
                var n, a;
                var i = $7a13843840af5e19$var$u(function(e, t) {
                    n = e, a = t;
                });
                return $7a13843840af5e19$var$it(this, e, _$o, {
                    _chunkSteps: function(e) {
                        return n({
                            value: e,
                            done: !1
                        });
                    },
                    _closeSteps: function(e) {
                        return n({
                            value: e,
                            done: !0
                        });
                    },
                    _errorSteps: function(e) {
                        return a(e);
                    }
                }), i;
            }
        },
        {
            key: "releaseLock",
            value: function releaseLock() {
                if (!$7a13843840af5e19$var$at(this)) throw $7a13843840af5e19$var$st("releaseLock");
                void 0 !== this._ownerReadableStream && function(e) {
                    $7a13843840af5e19$var$W(e);
                    var t = new TypeError("Reader was released");
                    $7a13843840af5e19$var$lt(e, t);
                }(this);
            }
        }
    ]);
    return ReadableStreamBYOBReader;
}();
function $7a13843840af5e19$var$at(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $7a13843840af5e19$export$20068a30393fcc28;
}
function $7a13843840af5e19$var$it(e, t, r, o) {
    var n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : $7a13843840af5e19$var$Ie(n._readableStreamController, t, r, o);
}
function $7a13843840af5e19$var$lt(e, t) {
    var r = e._readIntoRequests;
    e._readIntoRequests = new $7a13843840af5e19$var$v, r.forEach(function(e) {
        e._errorSteps(t);
    });
}
function $7a13843840af5e19$var$st(e) {
    return new TypeError("ReadableStreamBYOBReader.prototype.".concat(e, " can only be used on a ReadableStreamBYOBReader"));
}
function $7a13843840af5e19$var$ut(e, t) {
    var r = e.highWaterMark;
    if (void 0 === r) return t;
    if ($7a13843840af5e19$var$ye(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $7a13843840af5e19$var$ct(e) {
    var t = e.size;
    return t || function() {
        return 1;
    };
}
function $7a13843840af5e19$var$dt(e, t) {
    $7a13843840af5e19$var$L(e, t);
    var r = null == e ? void 0 : e.highWaterMark, _$o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $7a13843840af5e19$var$Y(r),
        size: void 0 === _$o ? void 0 : $7a13843840af5e19$var$ft(_$o, "".concat(t, " has member 'size' that"))
    };
}
function $7a13843840af5e19$var$ft(e, t) {
    return $7a13843840af5e19$var$F(e, t), function(t) {
        return $7a13843840af5e19$var$Y(e(t));
    };
}
function $7a13843840af5e19$var$bt(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$g(e, t, [
            r
        ]);
    };
}
function $7a13843840af5e19$var$ht(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function() {
        return $7a13843840af5e19$var$g(e, t, []);
    };
}
function $7a13843840af5e19$var$mt(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$S(e, t, [
            r
        ]);
    };
}
function $7a13843840af5e19$var$_t(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r, o) {
        return $7a13843840af5e19$var$g(e, t, [
            r,
            o
        ]);
    };
}
function $7a13843840af5e19$var$pt(e, t) {
    if (!$7a13843840af5e19$var$gt(e)) throw new TypeError("".concat(t, " is not a WritableStream."));
}
Object.defineProperties($7a13843840af5e19$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$20068a30393fcc28.prototype.cancel, "cancel"), $7a13843840af5e19$var$o($7a13843840af5e19$export$20068a30393fcc28.prototype.read, "read"), $7a13843840af5e19$var$o($7a13843840af5e19$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
var $7a13843840af5e19$export$826849241f7970f8 = /*#__PURE__*/ function() {
    "use strict";
    function WritableStream() {
        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $7lhcp._)(this, WritableStream);
        void 0 === _$e ? _$e = null : $7a13843840af5e19$var$I(_$e, "First parameter");
        var r = $7a13843840af5e19$var$dt(t, "Second parameter"), _$o = function(e, t) {
            $7a13843840af5e19$var$L(e, t);
            var r = null == e ? void 0 : e.abort, _$o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, a = null == e ? void 0 : e.type, i = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $7a13843840af5e19$var$bt(r, e, "".concat(t, " has member 'abort' that")),
                close: void 0 === _$o ? void 0 : $7a13843840af5e19$var$ht(_$o, e, "".concat(t, " has member 'close' that")),
                start: void 0 === n ? void 0 : $7a13843840af5e19$var$mt(n, e, "".concat(t, " has member 'start' that")),
                write: void 0 === i ? void 0 : $7a13843840af5e19$var$_t(i, e, "".concat(t, " has member 'write' that")),
                type: a
            };
        }(_$e, "First parameter");
        $7a13843840af5e19$var$St(this);
        if (void 0 !== _$o.type) throw new RangeError("Invalid type is specified");
        var n = $7a13843840af5e19$var$ct(r);
        !function(e, t, r, o) {
            var n = Object.create($7a13843840af5e19$export$9e6890cb9a51c7c2.prototype);
            var a, i, l, s;
            a = void 0 !== t.start ? function() {
                return t.start(n);
            } : function() {};
            i = void 0 !== t.write ? function(e) {
                return t.write(e, n);
            } : function() {
                return $7a13843840af5e19$var$c(void 0);
            };
            l = void 0 !== t.close ? function() {
                return t.close();
            } : function() {
                return $7a13843840af5e19$var$c(void 0);
            };
            s = void 0 !== t.abort ? function(e) {
                return t.abort(e);
            } : function() {
                return $7a13843840af5e19$var$c(void 0);
            };
            $7a13843840af5e19$var$Ft(e, n, a, i, l, s, r, o);
        }(this, _$o, $7a13843840af5e19$var$ut(r, 1), n);
    }
    (0, $8BtP9._)(WritableStream, [
        {
            key: "locked",
            get: function get() {
                if (!$7a13843840af5e19$var$gt(this)) throw $7a13843840af5e19$var$Nt("locked");
                return $7a13843840af5e19$var$vt(this);
            }
        },
        {
            key: "abort",
            value: function abort(e) {
                return $7a13843840af5e19$var$gt(this) ? $7a13843840af5e19$var$vt(this) ? $7a13843840af5e19$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $7a13843840af5e19$var$wt(this, e) : $7a13843840af5e19$var$d($7a13843840af5e19$var$Nt("abort"));
            }
        },
        {
            key: "close",
            value: function close() {
                return $7a13843840af5e19$var$gt(this) ? $7a13843840af5e19$var$vt(this) ? $7a13843840af5e19$var$d(new TypeError("Cannot close a stream that already has a writer")) : $7a13843840af5e19$var$qt(this) ? $7a13843840af5e19$var$d(new TypeError("Cannot close an already-closing stream")) : $7a13843840af5e19$var$Rt(this) : $7a13843840af5e19$var$d($7a13843840af5e19$var$Nt("close"));
            }
        },
        {
            key: "getWriter",
            value: function getWriter() {
                if (!$7a13843840af5e19$var$gt(this)) throw $7a13843840af5e19$var$Nt("getWriter");
                return $7a13843840af5e19$var$yt(this);
            }
        }
    ]);
    return WritableStream;
}();
function $7a13843840af5e19$var$yt(e) {
    return new $7a13843840af5e19$export$9295348f005d6054(e);
}
function $7a13843840af5e19$var$St(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $7a13843840af5e19$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $7a13843840af5e19$var$gt(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $7a13843840af5e19$export$826849241f7970f8;
}
function $7a13843840af5e19$var$vt(e) {
    return void 0 !== e._writer;
}
function $7a13843840af5e19$var$wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $7a13843840af5e19$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    var _$o = e._state;
    if ("closed" === _$o || "errored" === _$o) return $7a13843840af5e19$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    var n = !1;
    "erroring" === _$o && (n = !0, t = void 0);
    var a = $7a13843840af5e19$var$u(function(r, o) {
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = a, n || $7a13843840af5e19$var$Ct(e, t), a;
}
function $7a13843840af5e19$var$Rt(e) {
    var t = e._state;
    if ("closed" === t || "errored" === t) return $7a13843840af5e19$var$d(new TypeError("The stream (in ".concat(t, " state) is not in the writable state and cannot be closed")));
    var r = $7a13843840af5e19$var$u(function(t, r) {
        var _$o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = _$o;
    }), _$o = e._writer;
    var n;
    return void 0 !== _$o && e._backpressure && "writable" === t && $7a13843840af5e19$var$or(_$o), $7a13843840af5e19$var$ve(n = e._writableStreamController, $7a13843840af5e19$var$Dt, 0), $7a13843840af5e19$var$Mt(n), r;
}
function $7a13843840af5e19$var$Tt(e, t) {
    "writable" !== e._state ? $7a13843840af5e19$var$Pt(e) : $7a13843840af5e19$var$Ct(e, t);
}
function $7a13843840af5e19$var$Ct(e, t) {
    var r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    var _$o = e._writer;
    void 0 !== _$o && $7a13843840af5e19$var$jt(_$o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $7a13843840af5e19$var$Pt(e);
}
function $7a13843840af5e19$var$Pt(e) {
    e._state = "errored", e._writableStreamController[$7a13843840af5e19$var$R]();
    var t = e._storedError;
    if (e._writeRequests.forEach(function(e) {
        e._reject(t);
    }), e._writeRequests = new $7a13843840af5e19$var$v, void 0 === e._pendingAbortRequest) return void $7a13843840af5e19$var$Et(e);
    var r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $7a13843840af5e19$var$Et(e);
    $7a13843840af5e19$var$b(e._writableStreamController[$7a13843840af5e19$var$w](r._reason), function() {
        return r._resolve(), $7a13843840af5e19$var$Et(e), null;
    }, function(t) {
        return r._reject(t), $7a13843840af5e19$var$Et(e), null;
    });
}
function $7a13843840af5e19$var$qt(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $7a13843840af5e19$var$Et(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    var t = e._writer;
    void 0 !== t && $7a13843840af5e19$var$Jt(t, e._storedError);
}
function $7a13843840af5e19$var$Wt(e, t) {
    var r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $7a13843840af5e19$var$Zt(e);
    }(r) : $7a13843840af5e19$var$or(r)), e._backpressure = t;
}
Object.defineProperties($7a13843840af5e19$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$826849241f7970f8.prototype.abort, "abort"), $7a13843840af5e19$var$o($7a13843840af5e19$export$826849241f7970f8.prototype.close, "close"), $7a13843840af5e19$var$o($7a13843840af5e19$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
var $7a13843840af5e19$export$9295348f005d6054 = /*#__PURE__*/ function() {
    "use strict";
    function WritableStreamDefaultWriter(e) {
        (0, $7lhcp._)(this, WritableStreamDefaultWriter);
        if ($7a13843840af5e19$var$$(e, 1, "WritableStreamDefaultWriter"), $7a13843840af5e19$var$pt(e, "First parameter"), $7a13843840af5e19$var$vt(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        var t = e._state;
        if ("writable" === t) !$7a13843840af5e19$var$qt(e) && e._backpressure ? $7a13843840af5e19$var$Zt(this) : $7a13843840af5e19$var$tr(this), $7a13843840af5e19$var$Gt(this);
        else if ("erroring" === t) $7a13843840af5e19$var$er(this, e._storedError), $7a13843840af5e19$var$Gt(this);
        else if ("closed" === t) $7a13843840af5e19$var$tr(this), $7a13843840af5e19$var$Gt(r = this), $7a13843840af5e19$var$Kt(r);
        else {
            var t1 = e._storedError;
            $7a13843840af5e19$var$er(this, t1), $7a13843840af5e19$var$Xt(this, t1);
        }
        var r;
    }
    (0, $8BtP9._)(WritableStreamDefaultWriter, [
        {
            key: "closed",
            get: function get() {
                return $7a13843840af5e19$var$Ot(this) ? this._closedPromise : $7a13843840af5e19$var$d($7a13843840af5e19$var$Vt("closed"));
            }
        },
        {
            key: "desiredSize",
            get: function get() {
                if (!$7a13843840af5e19$var$Ot(this)) throw $7a13843840af5e19$var$Vt("desiredSize");
                if (void 0 === this._ownerWritableStream) throw $7a13843840af5e19$var$Ut("desiredSize");
                return function(e) {
                    var t = e._ownerWritableStream, r = t._state;
                    if ("errored" === r || "erroring" === r) return null;
                    if ("closed" === r) return 0;
                    return $7a13843840af5e19$var$$t(t._writableStreamController);
                }(this);
            }
        },
        {
            key: "ready",
            get: function get() {
                return $7a13843840af5e19$var$Ot(this) ? this._readyPromise : $7a13843840af5e19$var$d($7a13843840af5e19$var$Vt("ready"));
            }
        },
        {
            key: "abort",
            value: function abort(e) {
                return $7a13843840af5e19$var$Ot(this) ? void 0 === this._ownerWritableStream ? $7a13843840af5e19$var$d($7a13843840af5e19$var$Ut("abort")) : function(e, t) {
                    return $7a13843840af5e19$var$wt(e._ownerWritableStream, t);
                }(this, e) : $7a13843840af5e19$var$d($7a13843840af5e19$var$Vt("abort"));
            }
        },
        {
            key: "close",
            value: function close() {
                if (!$7a13843840af5e19$var$Ot(this)) return $7a13843840af5e19$var$d($7a13843840af5e19$var$Vt("close"));
                var _$e = this._ownerWritableStream;
                return void 0 === _$e ? $7a13843840af5e19$var$d($7a13843840af5e19$var$Ut("close")) : $7a13843840af5e19$var$qt(_$e) ? $7a13843840af5e19$var$d(new TypeError("Cannot close an already-closing stream")) : $7a13843840af5e19$var$Bt(this);
            }
        },
        {
            key: "releaseLock",
            value: function releaseLock() {
                if (!$7a13843840af5e19$var$Ot(this)) throw $7a13843840af5e19$var$Vt("releaseLock");
                void 0 !== this._ownerWritableStream && $7a13843840af5e19$var$At(this);
            }
        },
        {
            key: "write",
            value: function write(e) {
                return $7a13843840af5e19$var$Ot(this) ? void 0 === this._ownerWritableStream ? $7a13843840af5e19$var$d($7a13843840af5e19$var$Ut("write to")) : $7a13843840af5e19$var$zt(this, e) : $7a13843840af5e19$var$d($7a13843840af5e19$var$Vt("write"));
            }
        }
    ]);
    return WritableStreamDefaultWriter;
}();
function $7a13843840af5e19$var$Ot(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $7a13843840af5e19$export$9295348f005d6054;
}
function $7a13843840af5e19$var$Bt(e) {
    return $7a13843840af5e19$var$Rt(e._ownerWritableStream);
}
function $7a13843840af5e19$var$kt(e, t) {
    "pending" === e._closedPromiseState ? $7a13843840af5e19$var$Jt(e, t) : function(e, t) {
        $7a13843840af5e19$var$Xt(e, t);
    }(e, t);
}
function $7a13843840af5e19$var$jt(e, t) {
    "pending" === e._readyPromiseState ? $7a13843840af5e19$var$rr(e, t) : function(e, t) {
        $7a13843840af5e19$var$er(e, t);
    }(e, t);
}
function $7a13843840af5e19$var$At(e) {
    var t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $7a13843840af5e19$var$jt(e, r), $7a13843840af5e19$var$kt(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $7a13843840af5e19$var$zt(e, t) {
    var r = e._ownerWritableStream, _$o = r._writableStreamController, n = function(e, t) {
        if (void 0 === e._strategySizeAlgorithm) return 1;
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $7a13843840af5e19$var$Yt(e, t), 1;
        }
    }(_$o, t);
    if (r !== e._ownerWritableStream) return $7a13843840af5e19$var$d($7a13843840af5e19$var$Ut("write to"));
    var a = r._state;
    if ("errored" === a) return $7a13843840af5e19$var$d(r._storedError);
    if ($7a13843840af5e19$var$qt(r) || "closed" === a) return $7a13843840af5e19$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === a) return $7a13843840af5e19$var$d(r._storedError);
    var i = function(e) {
        return $7a13843840af5e19$var$u(function(t, r) {
            var _$o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(_$o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $7a13843840af5e19$var$ve(e, t, r);
        } catch (t) {
            return void $7a13843840af5e19$var$Yt(e, t);
        }
        var _$o = e._controlledWritableStream;
        if (!$7a13843840af5e19$var$qt(_$o) && "writable" === _$o._state) $7a13843840af5e19$var$Wt(_$o, $7a13843840af5e19$var$xt(e));
        $7a13843840af5e19$var$Mt(e);
    }(_$o, t, n), i;
}
Object.defineProperties($7a13843840af5e19$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$9295348f005d6054.prototype.abort, "abort"), $7a13843840af5e19$var$o($7a13843840af5e19$export$9295348f005d6054.prototype.close, "close"), $7a13843840af5e19$var$o($7a13843840af5e19$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $7a13843840af5e19$var$o($7a13843840af5e19$export$9295348f005d6054.prototype.write, "write"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
var $7a13843840af5e19$var$Dt = {};
var $7a13843840af5e19$export$9e6890cb9a51c7c2 = /*#__PURE__*/ function() {
    "use strict";
    function WritableStreamDefaultController() {
        (0, $7lhcp._)(this, WritableStreamDefaultController);
        throw new TypeError("Illegal constructor");
    }
    (0, $8BtP9._)(WritableStreamDefaultController, [
        {
            key: "abortReason",
            get: function get() {
                if (!$7a13843840af5e19$var$Lt(this)) throw $7a13843840af5e19$var$Ht("abortReason");
                return this._abortReason;
            }
        },
        {
            key: "signal",
            get: function get() {
                if (!$7a13843840af5e19$var$Lt(this)) throw $7a13843840af5e19$var$Ht("signal");
                if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
                return this._abortController.signal;
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$7a13843840af5e19$var$Lt(this)) throw $7a13843840af5e19$var$Ht("error");
                "writable" === this._controlledWritableStream._state && $7a13843840af5e19$var$Qt(this, e);
            }
        },
        {
            key: $7a13843840af5e19$var$w,
            value: function value(e) {
                var t = this._abortAlgorithm(e);
                return $7a13843840af5e19$var$It(this), t;
            }
        },
        {
            key: $7a13843840af5e19$var$R,
            value: function value() {
                $7a13843840af5e19$var$we(this);
            }
        }
    ]);
    return WritableStreamDefaultController;
}();
function $7a13843840af5e19$var$Lt(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $7a13843840af5e19$export$9e6890cb9a51c7c2;
}
function $7a13843840af5e19$var$Ft(e, t, r, o, n, a, i, l) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $7a13843840af5e19$var$we(t), t._abortReason = void 0, t._abortController = function() {
        if ("function" == typeof AbortController) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = l, t._strategyHWM = i, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = a;
    var s = $7a13843840af5e19$var$xt(t);
    $7a13843840af5e19$var$Wt(e, s);
    $7a13843840af5e19$var$b($7a13843840af5e19$var$c(r()), function() {
        return t._started = !0, $7a13843840af5e19$var$Mt(t), null;
    }, function(r) {
        return t._started = !0, $7a13843840af5e19$var$Tt(e, r), null;
    });
}
function $7a13843840af5e19$var$It(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $7a13843840af5e19$var$$t(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $7a13843840af5e19$var$Mt(e) {
    var t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $7a13843840af5e19$var$Pt(t);
    if (0 === e._queue.length) return;
    var r = e._queue.peek().value;
    r === $7a13843840af5e19$var$Dt ? function(e) {
        var t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $7a13843840af5e19$var$ge(e);
        var r = e._closeAlgorithm();
        $7a13843840af5e19$var$It(e), $7a13843840af5e19$var$b(r, function() {
            return function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                var t = e._writer;
                void 0 !== t && $7a13843840af5e19$var$Kt(t);
            }(t), null;
        }, function(e) {
            return function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $7a13843840af5e19$var$Tt(e, t);
            }(t, e), null;
        });
    }(e) : function(e, t) {
        var r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        var _$o = e._writeAlgorithm(t);
        $7a13843840af5e19$var$b(_$o, function() {
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            var _$t = r._state;
            if ($7a13843840af5e19$var$ge(e), !$7a13843840af5e19$var$qt(r) && "writable" === _$t) {
                var _$t1 = $7a13843840af5e19$var$xt(e);
                $7a13843840af5e19$var$Wt(r, _$t1);
            }
            return $7a13843840af5e19$var$Mt(e), null;
        }, function(t) {
            return "writable" === r._state && $7a13843840af5e19$var$It(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $7a13843840af5e19$var$Tt(e, t);
            }(r, t), null;
        });
    }(e, r);
}
function $7a13843840af5e19$var$Yt(e, t) {
    "writable" === e._controlledWritableStream._state && $7a13843840af5e19$var$Qt(e, t);
}
function $7a13843840af5e19$var$xt(e) {
    return $7a13843840af5e19$var$$t(e) <= 0;
}
function $7a13843840af5e19$var$Qt(e, t) {
    var r = e._controlledWritableStream;
    $7a13843840af5e19$var$It(e), $7a13843840af5e19$var$Ct(r, t);
}
function $7a13843840af5e19$var$Nt(e) {
    return new TypeError("WritableStream.prototype.".concat(e, " can only be used on a WritableStream"));
}
function $7a13843840af5e19$var$Ht(e) {
    return new TypeError("WritableStreamDefaultController.prototype.".concat(e, " can only be used on a WritableStreamDefaultController"));
}
function $7a13843840af5e19$var$Vt(e) {
    return new TypeError("WritableStreamDefaultWriter.prototype.".concat(e, " can only be used on a WritableStreamDefaultWriter"));
}
function $7a13843840af5e19$var$Ut(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $7a13843840af5e19$var$Gt(e) {
    e._closedPromise = $7a13843840af5e19$var$u(function(t, r) {
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $7a13843840af5e19$var$Xt(e, t) {
    $7a13843840af5e19$var$Gt(e), $7a13843840af5e19$var$Jt(e, t);
}
function $7a13843840af5e19$var$Jt(e, t) {
    void 0 !== e._closedPromise_reject && ($7a13843840af5e19$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $7a13843840af5e19$var$Kt(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $7a13843840af5e19$var$Zt(e) {
    e._readyPromise = $7a13843840af5e19$var$u(function(t, r) {
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $7a13843840af5e19$var$er(e, t) {
    $7a13843840af5e19$var$Zt(e), $7a13843840af5e19$var$rr(e, t);
}
function $7a13843840af5e19$var$tr(e) {
    $7a13843840af5e19$var$Zt(e), $7a13843840af5e19$var$or(e);
}
function $7a13843840af5e19$var$rr(e, t) {
    void 0 !== e._readyPromise_reject && ($7a13843840af5e19$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $7a13843840af5e19$var$or(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($7a13843840af5e19$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
var $7a13843840af5e19$var$nr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
var $7a13843840af5e19$var$ar = function() {
    var _$e = null == $7a13843840af5e19$var$nr ? void 0 : $7a13843840af5e19$var$nr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != (typeof e === "undefined" ? "undefined" : (0, $5f0Cq._)(e))) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(_$e) ? _$e : void 0;
}() || function() {
    var _$e = function e(_e1, t) {
        this.message = _e1 || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $7a13843840af5e19$var$o(_$e, "DOMException"), _$e.prototype = Object.create(Error.prototype), Object.defineProperty(_$e.prototype, "constructor", {
        value: _$e,
        writable: !0,
        configurable: !0
    }), _$e;
}();
function $7a13843840af5e19$var$ir(t, r, o, n, a, i) {
    var l = $7a13843840af5e19$var$H(t), s = $7a13843840af5e19$var$yt(r);
    t._disturbed = !0;
    var _ = !1, y = $7a13843840af5e19$var$c(void 0);
    return $7a13843840af5e19$var$u(function(S, g) {
        var v;
        if (void 0 !== i) {
            if (v = function() {
                var _$e = void 0 !== i.reason ? i.reason : new $7a13843840af5e19$var$ar("Aborted", "AbortError"), _$o = [];
                n || _$o.push(function() {
                    return "writable" === r._state ? $7a13843840af5e19$var$wt(r, _$e) : $7a13843840af5e19$var$c(void 0);
                }), a || _$o.push(function() {
                    return "readable" === t._state ? $7a13843840af5e19$var$Or(t, _$e) : $7a13843840af5e19$var$c(void 0);
                }), q(function() {
                    return Promise.all(_$o.map(function(e) {
                        return e();
                    }));
                }, !0, _$e);
            }, i.aborted) return void v();
            i.addEventListener("abort", v);
        }
        var w, R, T;
        if (P(t, l._closedPromise, function(e) {
            return n ? E(!0, e) : q(function() {
                return $7a13843840af5e19$var$wt(r, e);
            }, !0, e), null;
        }), P(r, s._closedPromise, function(e) {
            return a ? E(!0, e) : q(function() {
                return $7a13843840af5e19$var$Or(t, e);
            }, !0, e), null;
        }), w = t, R = l._closedPromise, T = function() {
            return o ? E() : q(function() {
                return function(e) {
                    var _$t = e._ownerWritableStream, _$r = _$t._state;
                    return $7a13843840af5e19$var$qt(_$t) || "closed" === _$r ? $7a13843840af5e19$var$c(void 0) : "errored" === _$r ? $7a13843840af5e19$var$d(_$t._storedError) : $7a13843840af5e19$var$Bt(e);
                }(s);
            }), null;
        }, "closed" === w._state ? T() : $7a13843840af5e19$var$h(R, T), $7a13843840af5e19$var$qt(r) || "closed" === r._state) {
            var _$e = new TypeError("the destination writable stream closed before all data could be piped to it");
            a ? E(!0, _$e) : q(function() {
                return $7a13843840af5e19$var$Or(t, _$e);
            }, !0, _$e);
        }
        function C() {
            var _$e = y;
            return $7a13843840af5e19$var$f(y, function() {
                return _$e !== y ? C() : void 0;
            });
        }
        function P(e, t, r) {
            "errored" === e._state ? r(e._storedError) : $7a13843840af5e19$var$m(t, r);
        }
        function q(e, t, o) {
            function n() {
                return $7a13843840af5e19$var$b(e(), function() {
                    return O(t, o);
                }, function(e) {
                    return O(!0, e);
                }), null;
            }
            _ || (_ = !0, "writable" !== r._state || $7a13843840af5e19$var$qt(r) ? n() : $7a13843840af5e19$var$h(C(), n));
        }
        function E(e, t) {
            _ || (_ = !0, "writable" !== r._state || $7a13843840af5e19$var$qt(r) ? O(e, t) : $7a13843840af5e19$var$h(C(), function() {
                return O(e, t);
            }));
        }
        function O(e, t) {
            return $7a13843840af5e19$var$At(s), $7a13843840af5e19$var$W(l), void 0 !== i && i.removeEventListener("abort", v), e ? g(t) : S(void 0), null;
        }
        $7a13843840af5e19$var$p($7a13843840af5e19$var$u(function(t, r) {
            !function o(n) {
                n ? t() : $7a13843840af5e19$var$f(_ ? $7a13843840af5e19$var$c(!0) : $7a13843840af5e19$var$f(s._readyPromise, function() {
                    return $7a13843840af5e19$var$u(function(t, r) {
                        $7a13843840af5e19$var$K(l, {
                            _chunkSteps: function(r) {
                                y = $7a13843840af5e19$var$f($7a13843840af5e19$var$zt(s, r), void 0, $7a13843840af5e19$var$e), t(!1);
                            },
                            _closeSteps: function() {
                                return t(!0);
                            },
                            _errorSteps: r
                        });
                    });
                }), o, r);
            }(!1);
        }));
    });
}
var $7a13843840af5e19$export$b0bb6d0989d67700 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStreamDefaultController() {
        (0, $7lhcp._)(this, ReadableStreamDefaultController);
        throw new TypeError("Illegal constructor");
    }
    (0, $8BtP9._)(ReadableStreamDefaultController, [
        {
            key: "desiredSize",
            get: function get() {
                if (!$7a13843840af5e19$var$lr(this)) throw $7a13843840af5e19$var$pr("desiredSize");
                return $7a13843840af5e19$var$hr(this);
            }
        },
        {
            key: "close",
            value: function close() {
                if (!$7a13843840af5e19$var$lr(this)) throw $7a13843840af5e19$var$pr("close");
                if (!$7a13843840af5e19$var$mr(this)) throw new TypeError("The stream is not in a state that permits close");
                $7a13843840af5e19$var$dr(this);
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                if (!$7a13843840af5e19$var$lr(this)) throw $7a13843840af5e19$var$pr("enqueue");
                if (!$7a13843840af5e19$var$mr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
                return $7a13843840af5e19$var$fr(this, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$7a13843840af5e19$var$lr(this)) throw $7a13843840af5e19$var$pr("error");
                $7a13843840af5e19$var$br(this, e);
            }
        },
        {
            key: $7a13843840af5e19$var$T,
            value: function value(e) {
                $7a13843840af5e19$var$we(this);
                var t = this._cancelAlgorithm(e);
                return $7a13843840af5e19$var$cr(this), t;
            }
        },
        {
            key: $7a13843840af5e19$var$C,
            value: function value(e) {
                var t = this._controlledReadableStream;
                if (this._queue.length > 0) {
                    var r = $7a13843840af5e19$var$ge(this);
                    this._closeRequested && 0 === this._queue.length ? ($7a13843840af5e19$var$cr(this), $7a13843840af5e19$var$Br(t)) : $7a13843840af5e19$var$sr(this), e._chunkSteps(r);
                } else $7a13843840af5e19$var$V(t, e), $7a13843840af5e19$var$sr(this);
            }
        },
        {
            key: $7a13843840af5e19$var$P,
            value: function value() {}
        }
    ]);
    return ReadableStreamDefaultController;
}();
function $7a13843840af5e19$var$lr(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $7a13843840af5e19$export$b0bb6d0989d67700;
}
function $7a13843840af5e19$var$sr(e) {
    if (!$7a13843840af5e19$var$ur(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $7a13843840af5e19$var$b(e._pullAlgorithm(), function() {
        return e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $7a13843840af5e19$var$sr(e)), null;
    }, function(t) {
        return $7a13843840af5e19$var$br(e, t), null;
    });
}
function $7a13843840af5e19$var$ur(e) {
    var t = e._controlledReadableStream;
    if (!$7a13843840af5e19$var$mr(e)) return !1;
    if (!e._started) return !1;
    if ($7a13843840af5e19$var$Wr(t) && $7a13843840af5e19$var$G(t) > 0) return !0;
    return $7a13843840af5e19$var$hr(e) > 0;
}
function $7a13843840af5e19$var$cr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $7a13843840af5e19$var$dr(e) {
    if (!$7a13843840af5e19$var$mr(e)) return;
    var t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($7a13843840af5e19$var$cr(e), $7a13843840af5e19$var$Br(t));
}
function $7a13843840af5e19$var$fr(e, t) {
    if (!$7a13843840af5e19$var$mr(e)) return;
    var r = e._controlledReadableStream;
    if ($7a13843840af5e19$var$Wr(r) && $7a13843840af5e19$var$G(r) > 0) $7a13843840af5e19$var$U(r, t, !1);
    else {
        var r1;
        try {
            r1 = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $7a13843840af5e19$var$br(e, t), t;
        }
        try {
            $7a13843840af5e19$var$ve(e, t, r1);
        } catch (t) {
            throw $7a13843840af5e19$var$br(e, t), t;
        }
    }
    $7a13843840af5e19$var$sr(e);
}
function $7a13843840af5e19$var$br(e, t) {
    var r = e._controlledReadableStream;
    "readable" === r._state && ($7a13843840af5e19$var$we(e), $7a13843840af5e19$var$cr(e), $7a13843840af5e19$var$kr(r, t));
}
function $7a13843840af5e19$var$hr(e) {
    var t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $7a13843840af5e19$var$mr(e) {
    var t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $7a13843840af5e19$var$_r(e, t, r, o, n, a, i) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $7a13843840af5e19$var$we(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = i, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $7a13843840af5e19$var$b($7a13843840af5e19$var$c(r()), function() {
        return t._started = !0, $7a13843840af5e19$var$sr(t), null;
    }, function(e) {
        return $7a13843840af5e19$var$br(t, e), null;
    });
}
function $7a13843840af5e19$var$pr(e) {
    return new TypeError("ReadableStreamDefaultController.prototype.".concat(e, " can only be used on a ReadableStreamDefaultController"));
}
function $7a13843840af5e19$var$yr(e, t) {
    return $7a13843840af5e19$var$Te(e._readableStreamController) ? function(e) {
        var t, r, _$o, n, a, i = $7a13843840af5e19$var$H(e), l = !1, s = !1, d = !1, f = !1, b = !1;
        var h = $7a13843840af5e19$var$u(function(e) {
            a = e;
        });
        function _(e) {
            $7a13843840af5e19$var$m(e._closedPromise, function(t) {
                return e !== i || ($7a13843840af5e19$var$Ne(_$o._readableStreamController, t), $7a13843840af5e19$var$Ne(n._readableStreamController, t), f && b || a(void 0)), null;
            });
        }
        function p() {
            $7a13843840af5e19$var$at(i) && ($7a13843840af5e19$var$W(i), i = $7a13843840af5e19$var$H(e), _(i));
            $7a13843840af5e19$var$K(i, {
                _chunkSteps: function(t) {
                    $7a13843840af5e19$var$y(function() {
                        s = !1, d = !1;
                        var r = t;
                        var i = t;
                        if (!f && !b) try {
                            i = $7a13843840af5e19$var$Se(t);
                        } catch (t) {
                            return $7a13843840af5e19$var$Ne(_$o._readableStreamController, t), $7a13843840af5e19$var$Ne(n._readableStreamController, t), void a($7a13843840af5e19$var$Or(e, t));
                        }
                        f || $7a13843840af5e19$var$Qe(_$o._readableStreamController, r), b || $7a13843840af5e19$var$Qe(n._readableStreamController, i), l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: function() {
                    l = !1, f || $7a13843840af5e19$var$xe(_$o._readableStreamController), b || $7a13843840af5e19$var$xe(n._readableStreamController), _$o._readableStreamController._pendingPullIntos.length > 0 && $7a13843840af5e19$var$Ge(_$o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $7a13843840af5e19$var$Ge(n._readableStreamController, 0), f && b || a(void 0);
                },
                _errorSteps: function() {
                    l = !1;
                }
            });
        }
        function S(t, r) {
            $7a13843840af5e19$var$J(i) && ($7a13843840af5e19$var$W(i), i = $7a13843840af5e19$var$tt(e), _(i));
            var _$u = r ? n : _$o, c = r ? _$o : n;
            $7a13843840af5e19$var$it(i, t, 1, {
                _chunkSteps: function(t) {
                    $7a13843840af5e19$var$y(function() {
                        s = !1, d = !1;
                        var _$o = r ? b : f;
                        if (r ? f : b) _$o || $7a13843840af5e19$var$Xe(_$u._readableStreamController, t);
                        else {
                            var _$r;
                            try {
                                _$r = $7a13843840af5e19$var$Se(t);
                            } catch (t) {
                                return $7a13843840af5e19$var$Ne(_$u._readableStreamController, t), $7a13843840af5e19$var$Ne(c._readableStreamController, t), void a($7a13843840af5e19$var$Or(e, t));
                            }
                            _$o || $7a13843840af5e19$var$Xe(_$u._readableStreamController, t), $7a13843840af5e19$var$Qe(c._readableStreamController, _$r);
                        }
                        l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: function(e) {
                    l = !1;
                    var _$t = r ? b : f, _$o = r ? f : b;
                    _$t || $7a13843840af5e19$var$xe(_$u._readableStreamController), _$o || $7a13843840af5e19$var$xe(c._readableStreamController), void 0 !== e && (_$t || $7a13843840af5e19$var$Xe(_$u._readableStreamController, e), !_$o && c._readableStreamController._pendingPullIntos.length > 0 && $7a13843840af5e19$var$Ge(c._readableStreamController, 0)), _$t && _$o || a(void 0);
                },
                _errorSteps: function() {
                    l = !1;
                }
            });
        }
        function g() {
            if (l) return s = !0, $7a13843840af5e19$var$c(void 0);
            l = !0;
            var _$e = $7a13843840af5e19$var$Ve(_$o._readableStreamController);
            return null === _$e ? p() : S(_$e._view, !1), $7a13843840af5e19$var$c(void 0);
        }
        function v() {
            if (l) return d = !0, $7a13843840af5e19$var$c(void 0);
            l = !0;
            var _$e = $7a13843840af5e19$var$Ve(n._readableStreamController);
            return null === _$e ? p() : S(_$e._view, !0), $7a13843840af5e19$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, b) {
                var _$o = $7a13843840af5e19$var$ne([
                    t,
                    r
                ]), n = $7a13843840af5e19$var$Or(e, _$o);
                a(n);
            }
            return h;
        }
        function R(o) {
            if (b = !0, r = o, f) {
                var _$o = $7a13843840af5e19$var$ne([
                    t,
                    r
                ]), n = $7a13843840af5e19$var$Or(e, _$o);
                a(n);
            }
            return h;
        }
        function T() {}
        return _$o = $7a13843840af5e19$var$Pr(T, g, w), n = $7a13843840af5e19$var$Pr(T, v, R), _(i), [
            _$o,
            n
        ];
    }(e) : function(e) {
        var t = $7a13843840af5e19$var$H(e);
        var r, _$o, n, a, i, l = !1, s = !1, d = !1, f = !1;
        var b = $7a13843840af5e19$var$u(function(e) {
            i = e;
        });
        function h() {
            if (l) return s = !0, $7a13843840af5e19$var$c(void 0);
            l = !0;
            return $7a13843840af5e19$var$K(t, {
                _chunkSteps: function(e) {
                    $7a13843840af5e19$var$y(function() {
                        s = !1;
                        var t = e, r = e;
                        d || $7a13843840af5e19$var$fr(n._readableStreamController, t), f || $7a13843840af5e19$var$fr(a._readableStreamController, r), l = !1, s && h();
                    });
                },
                _closeSteps: function() {
                    l = !1, d || $7a13843840af5e19$var$dr(n._readableStreamController), f || $7a13843840af5e19$var$dr(a._readableStreamController), d && f || i(void 0);
                },
                _errorSteps: function() {
                    l = !1;
                }
            }), $7a13843840af5e19$var$c(void 0);
        }
        function _(t) {
            if (d = !0, r = t, f) {
                var _$t = $7a13843840af5e19$var$ne([
                    r,
                    _$o
                ]), n = $7a13843840af5e19$var$Or(e, _$t);
                i(n);
            }
            return b;
        }
        function p(t) {
            if (f = !0, _$o = t, d) {
                var _$t = $7a13843840af5e19$var$ne([
                    r,
                    _$o
                ]), n = $7a13843840af5e19$var$Or(e, _$t);
                i(n);
            }
            return b;
        }
        function S() {}
        return n = $7a13843840af5e19$var$Cr(S, h, _), a = $7a13843840af5e19$var$Cr(S, h, p), $7a13843840af5e19$var$m(t._closedPromise, function(e) {
            return $7a13843840af5e19$var$br(n._readableStreamController, e), $7a13843840af5e19$var$br(a._readableStreamController, e), d && f || i(void 0), null;
        }), [
            n,
            a
        ];
    }(e);
}
function $7a13843840af5e19$var$Sr(r) {
    var _$o;
    return $7a13843840af5e19$var$t(_$o = r) && void 0 !== _$o.getReader ? function(r) {
        var _$o;
        function n() {
            var _$e;
            try {
                _$e = r.read();
            } catch (e) {
                return $7a13843840af5e19$var$d(e);
            }
            return $7a13843840af5e19$var$_(_$e, function(e) {
                if (!$7a13843840af5e19$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $7a13843840af5e19$var$dr(_$o._readableStreamController);
                else {
                    var _$t = e.value;
                    $7a13843840af5e19$var$fr(_$o._readableStreamController, _$t);
                }
            });
        }
        function a(e) {
            try {
                return $7a13843840af5e19$var$c(r.cancel(e));
            } catch (e) {
                return $7a13843840af5e19$var$d(e);
            }
        }
        return _$o = $7a13843840af5e19$var$Cr($7a13843840af5e19$var$e, n, a, 0), _$o;
    }(r.getReader()) : function(r) {
        var _$o;
        var n = $7a13843840af5e19$var$fe(r, "async");
        function a() {
            var _$e;
            try {
                _$e = $7a13843840af5e19$var$be(n);
            } catch (e) {
                return $7a13843840af5e19$var$d(e);
            }
            return $7a13843840af5e19$var$_($7a13843840af5e19$var$c(_$e), function(e) {
                if (!$7a13843840af5e19$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $7a13843840af5e19$var$dr(_$o._readableStreamController);
                else {
                    var _$t = e.value;
                    $7a13843840af5e19$var$fr(_$o._readableStreamController, _$t);
                }
            });
        }
        function i(e) {
            var _$r = n.iterator;
            var _$o;
            try {
                _$o = $7a13843840af5e19$var$ue(_$r, "return");
            } catch (e) {
                return $7a13843840af5e19$var$d(e);
            }
            if (void 0 === _$o) return $7a13843840af5e19$var$c(void 0);
            return $7a13843840af5e19$var$_($7a13843840af5e19$var$g(_$o, _$r, [
                e
            ]), function(e) {
                if (!$7a13843840af5e19$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return _$o = $7a13843840af5e19$var$Cr($7a13843840af5e19$var$e, a, i, 0), _$o;
    }(r);
}
function $7a13843840af5e19$var$gr(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$g(e, t, [
            r
        ]);
    };
}
function $7a13843840af5e19$var$vr(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$g(e, t, [
            r
        ]);
    };
}
function $7a13843840af5e19$var$wr(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$S(e, t, [
            r
        ]);
    };
}
function $7a13843840af5e19$var$Rr(e, t) {
    if ("bytes" !== (e = "".concat(e))) throw new TypeError("".concat(t, " '").concat(e, "' is not a valid enumeration value for ReadableStreamType"));
    return e;
}
function $7a13843840af5e19$var$Tr(e, t) {
    $7a13843840af5e19$var$L(e, t);
    var r = null == e ? void 0 : e.preventAbort, _$o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, a = null == e ? void 0 : e.signal;
    return void 0 !== a && function(e, t) {
        if (!function(e) {
            if ("object" != (typeof e === "undefined" ? "undefined" : (0, $5f0Cq._)(e)) || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError("".concat(t, " is not an AbortSignal."));
    }(a, "".concat(t, " has member 'signal' that")), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(_$o),
        preventClose: Boolean(n),
        signal: a
    };
}
Object.defineProperties($7a13843840af5e19$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$b0bb6d0989d67700.prototype.close, "close"), $7a13843840af5e19$var$o($7a13843840af5e19$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $7a13843840af5e19$var$o($7a13843840af5e19$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
var $7a13843840af5e19$export$5d3e1e5268af5f76 = /*#__PURE__*/ function() {
    "use strict";
    function ReadableStream() {
        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $7lhcp._)(this, ReadableStream);
        void 0 === _$e ? _$e = null : $7a13843840af5e19$var$I(_$e, "First parameter");
        var r = $7a13843840af5e19$var$dt(t, "Second parameter"), _$o = function(e, t) {
            $7a13843840af5e19$var$L(e, t);
            var r = e, _$o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, a = null == r ? void 0 : r.pull, i = null == r ? void 0 : r.start, l = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === _$o ? void 0 : $7a13843840af5e19$var$Q(_$o, "".concat(t, " has member 'autoAllocateChunkSize' that")),
                cancel: void 0 === n ? void 0 : $7a13843840af5e19$var$gr(n, r, "".concat(t, " has member 'cancel' that")),
                pull: void 0 === a ? void 0 : $7a13843840af5e19$var$vr(a, r, "".concat(t, " has member 'pull' that")),
                start: void 0 === i ? void 0 : $7a13843840af5e19$var$wr(i, r, "".concat(t, " has member 'start' that")),
                type: void 0 === l ? void 0 : $7a13843840af5e19$var$Rr(l, "".concat(t, " has member 'type' that"))
            };
        }(_$e, "First parameter");
        if ($7a13843840af5e19$var$qr(this), "bytes" === _$o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                var _$o = Object.create($7a13843840af5e19$export$2047cf34091e94ac.prototype);
                var n, a, i;
                n = void 0 !== t.start ? function() {
                    return t.start(_$o);
                } : function() {}, a = void 0 !== t.pull ? function() {
                    return t.pull(_$o);
                } : function() {
                    return $7a13843840af5e19$var$c(void 0);
                }, i = void 0 !== t.cancel ? function(e) {
                    return t.cancel(e);
                } : function() {
                    return $7a13843840af5e19$var$c(void 0);
                };
                var l = t.autoAllocateChunkSize;
                if (0 === l) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $7a13843840af5e19$var$Je(e, _$o, n, a, i, r, l);
            }(this, _$o, $7a13843840af5e19$var$ut(r, 0));
        } else {
            var _$e1 = $7a13843840af5e19$var$ct(r);
            !function(e, t, r, o) {
                var n = Object.create($7a13843840af5e19$export$b0bb6d0989d67700.prototype);
                var a, i, l;
                a = void 0 !== t.start ? function() {
                    return t.start(n);
                } : function() {}, i = void 0 !== t.pull ? function() {
                    return t.pull(n);
                } : function() {
                    return $7a13843840af5e19$var$c(void 0);
                }, l = void 0 !== t.cancel ? function(e) {
                    return t.cancel(e);
                } : function() {
                    return $7a13843840af5e19$var$c(void 0);
                }, $7a13843840af5e19$var$_r(e, n, a, i, l, r, o);
            }(this, _$o, $7a13843840af5e19$var$ut(r, 1), _$e1);
        }
    }
    (0, $8BtP9._)(ReadableStream, [
        {
            key: "locked",
            get: function get() {
                if (!$7a13843840af5e19$var$Er(this)) throw $7a13843840af5e19$var$jr("locked");
                return $7a13843840af5e19$var$Wr(this);
            }
        },
        {
            key: "cancel",
            value: function cancel(e) {
                return $7a13843840af5e19$var$Er(this) ? $7a13843840af5e19$var$Wr(this) ? $7a13843840af5e19$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $7a13843840af5e19$var$Or(this, e) : $7a13843840af5e19$var$d($7a13843840af5e19$var$jr("cancel"));
            }
        },
        {
            key: "getReader",
            value: function getReader(e) {
                if (!$7a13843840af5e19$var$Er(this)) throw $7a13843840af5e19$var$jr("getReader");
                return void 0 === function(e, t) {
                    $7a13843840af5e19$var$L(e, t);
                    var r = null == e ? void 0 : e.mode;
                    return {
                        mode: void 0 === r ? void 0 : $7a13843840af5e19$var$et(r, "".concat(t, " has member 'mode' that"))
                    };
                }(e, "First parameter").mode ? $7a13843840af5e19$var$H(this) : $7a13843840af5e19$var$tt(this);
            }
        },
        {
            key: "pipeThrough",
            value: function pipeThrough(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!$7a13843840af5e19$var$Er(this)) throw $7a13843840af5e19$var$jr("pipeThrough");
                $7a13843840af5e19$var$$(e, 1, "pipeThrough");
                var r = function(e, t) {
                    $7a13843840af5e19$var$L(e, t);
                    var r = null == e ? void 0 : e.readable;
                    $7a13843840af5e19$var$M(r, "readable", "ReadableWritablePair"), $7a13843840af5e19$var$N(r, "".concat(t, " has member 'readable' that"));
                    var _$o = null == e ? void 0 : e.writable;
                    return $7a13843840af5e19$var$M(_$o, "writable", "ReadableWritablePair"), $7a13843840af5e19$var$pt(_$o, "".concat(t, " has member 'writable' that")), {
                        readable: r,
                        writable: _$o
                    };
                }(e, "First parameter"), _$o = $7a13843840af5e19$var$Tr(t, "Second parameter");
                if ($7a13843840af5e19$var$Wr(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
                if ($7a13843840af5e19$var$vt(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
                return $7a13843840af5e19$var$p($7a13843840af5e19$var$ir(this, r.writable, _$o.preventClose, _$o.preventAbort, _$o.preventCancel, _$o.signal)), r.readable;
            }
        },
        {
            key: "pipeTo",
            value: function pipeTo(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!$7a13843840af5e19$var$Er(this)) return $7a13843840af5e19$var$d($7a13843840af5e19$var$jr("pipeTo"));
                if (void 0 === e) return $7a13843840af5e19$var$d("Parameter 1 is required in 'pipeTo'.");
                if (!$7a13843840af5e19$var$gt(e)) return $7a13843840af5e19$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
                var r;
                try {
                    r = $7a13843840af5e19$var$Tr(t, "Second parameter");
                } catch (e) {
                    return $7a13843840af5e19$var$d(e);
                }
                return $7a13843840af5e19$var$Wr(this) ? $7a13843840af5e19$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $7a13843840af5e19$var$vt(e) ? $7a13843840af5e19$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $7a13843840af5e19$var$ir(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
            }
        },
        {
            key: "tee",
            value: function tee() {
                if (!$7a13843840af5e19$var$Er(this)) throw $7a13843840af5e19$var$jr("tee");
                return $7a13843840af5e19$var$ne($7a13843840af5e19$var$yr(this));
            }
        },
        {
            key: "values",
            value: function values(e) {
                if (!$7a13843840af5e19$var$Er(this)) throw $7a13843840af5e19$var$jr("values");
                return function(e, t) {
                    var r = $7a13843840af5e19$var$H(e), _$o = new $7a13843840af5e19$var$he(r, t), n = Object.create($7a13843840af5e19$var$me);
                    return n._asyncIteratorImpl = _$o, n;
                }(this, function(e, t) {
                    $7a13843840af5e19$var$L(e, t);
                    var r = null == e ? void 0 : e.preventCancel;
                    return {
                        preventCancel: Boolean(r)
                    };
                }(e, "First parameter").preventCancel);
            }
        },
        {
            key: $7a13843840af5e19$var$de,
            value: function value(e) {
                return this.values(e);
            }
        }
    ], [
        {
            key: "from",
            value: function from(e) {
                return $7a13843840af5e19$var$Sr(e);
            }
        }
    ]);
    return ReadableStream;
}();
function $7a13843840af5e19$var$Cr(e, t, r) {
    var _$o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
        return 1;
    };
    var a = Object.create($7a13843840af5e19$export$5d3e1e5268af5f76.prototype);
    $7a13843840af5e19$var$qr(a);
    return $7a13843840af5e19$var$_r(a, Object.create($7a13843840af5e19$export$b0bb6d0989d67700.prototype), e, t, r, _$o, n), a;
}
function $7a13843840af5e19$var$Pr(e, t, r) {
    var _$o = Object.create($7a13843840af5e19$export$5d3e1e5268af5f76.prototype);
    $7a13843840af5e19$var$qr(_$o);
    return $7a13843840af5e19$var$Je(_$o, Object.create($7a13843840af5e19$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), _$o;
}
function $7a13843840af5e19$var$qr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $7a13843840af5e19$var$Er(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $7a13843840af5e19$export$5d3e1e5268af5f76;
}
function $7a13843840af5e19$var$Wr(e) {
    return void 0 !== e._reader;
}
function $7a13843840af5e19$var$Or(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $7a13843840af5e19$var$c(void 0);
    if ("errored" === t._state) return $7a13843840af5e19$var$d(t._storedError);
    $7a13843840af5e19$var$Br(t);
    var _$o = t._reader;
    if (void 0 !== _$o && $7a13843840af5e19$var$at(_$o)) {
        var _$e = _$o._readIntoRequests;
        _$o._readIntoRequests = new $7a13843840af5e19$var$v, _$e.forEach(function(e) {
            e._closeSteps(void 0);
        });
    }
    return $7a13843840af5e19$var$_(t._readableStreamController[$7a13843840af5e19$var$T](r), $7a13843840af5e19$var$e);
}
function $7a13843840af5e19$var$Br(e) {
    e._state = "closed";
    var t = e._reader;
    if (void 0 !== t && ($7a13843840af5e19$var$A(t), $7a13843840af5e19$var$J(t))) {
        var _$e = t._readRequests;
        t._readRequests = new $7a13843840af5e19$var$v, _$e.forEach(function(e) {
            e._closeSteps();
        });
    }
}
function $7a13843840af5e19$var$kr(e, t) {
    e._state = "errored", e._storedError = t;
    var r = e._reader;
    void 0 !== r && ($7a13843840af5e19$var$j(r, t), $7a13843840af5e19$var$J(r) ? $7a13843840af5e19$var$Z(r, t) : $7a13843840af5e19$var$lt(r, t));
}
function $7a13843840af5e19$var$jr(e) {
    return new TypeError("ReadableStream.prototype.".concat(e, " can only be used on a ReadableStream"));
}
function $7a13843840af5e19$var$Ar(e, t) {
    $7a13843840af5e19$var$L(e, t);
    var r = null == e ? void 0 : e.highWaterMark;
    return $7a13843840af5e19$var$M(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $7a13843840af5e19$var$Y(r)
    };
}
Object.defineProperties($7a13843840af5e19$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($7a13843840af5e19$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$5d3e1e5268af5f76.from, "from"), $7a13843840af5e19$var$o($7a13843840af5e19$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $7a13843840af5e19$var$o($7a13843840af5e19$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $7a13843840af5e19$var$o($7a13843840af5e19$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $7a13843840af5e19$var$o($7a13843840af5e19$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $7a13843840af5e19$var$o($7a13843840af5e19$export$5d3e1e5268af5f76.prototype.tee, "tee"), $7a13843840af5e19$var$o($7a13843840af5e19$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($7a13843840af5e19$export$5d3e1e5268af5f76.prototype, $7a13843840af5e19$var$de, {
    value: $7a13843840af5e19$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
var $7a13843840af5e19$var$zr = function(e) {
    return e.byteLength;
};
$7a13843840af5e19$var$o($7a13843840af5e19$var$zr, "size");
var $7a13843840af5e19$export$d386b5f37d154119 = /*#__PURE__*/ function() {
    "use strict";
    function ByteLengthQueuingStrategy(e) {
        (0, $7lhcp._)(this, ByteLengthQueuingStrategy);
        $7a13843840af5e19$var$$(e, 1, "ByteLengthQueuingStrategy"), e = $7a13843840af5e19$var$Ar(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    (0, $8BtP9._)(ByteLengthQueuingStrategy, [
        {
            key: "highWaterMark",
            get: function get() {
                if (!$7a13843840af5e19$var$Lr(this)) throw $7a13843840af5e19$var$Dr("highWaterMark");
                return this._byteLengthQueuingStrategyHighWaterMark;
            }
        },
        {
            key: "size",
            get: function get() {
                if (!$7a13843840af5e19$var$Lr(this)) throw $7a13843840af5e19$var$Dr("size");
                return $7a13843840af5e19$var$zr;
            }
        }
    ]);
    return ByteLengthQueuingStrategy;
}();
function $7a13843840af5e19$var$Dr(e) {
    return new TypeError("ByteLengthQueuingStrategy.prototype.".concat(e, " can only be used on a ByteLengthQueuingStrategy"));
}
function $7a13843840af5e19$var$Lr(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $7a13843840af5e19$export$d386b5f37d154119;
}
Object.defineProperties($7a13843840af5e19$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
var $7a13843840af5e19$var$Fr = function() {
    return 1;
};
$7a13843840af5e19$var$o($7a13843840af5e19$var$Fr, "size");
var $7a13843840af5e19$export$9ebfec18c2dfc625 = /*#__PURE__*/ function() {
    "use strict";
    function CountQueuingStrategy(e) {
        (0, $7lhcp._)(this, CountQueuingStrategy);
        $7a13843840af5e19$var$$(e, 1, "CountQueuingStrategy"), e = $7a13843840af5e19$var$Ar(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    (0, $8BtP9._)(CountQueuingStrategy, [
        {
            key: "highWaterMark",
            get: function get() {
                if (!$7a13843840af5e19$var$$r(this)) throw $7a13843840af5e19$var$Ir("highWaterMark");
                return this._countQueuingStrategyHighWaterMark;
            }
        },
        {
            key: "size",
            get: function get() {
                if (!$7a13843840af5e19$var$$r(this)) throw $7a13843840af5e19$var$Ir("size");
                return $7a13843840af5e19$var$Fr;
            }
        }
    ]);
    return CountQueuingStrategy;
}();
function $7a13843840af5e19$var$Ir(e) {
    return new TypeError("CountQueuingStrategy.prototype.".concat(e, " can only be used on a CountQueuingStrategy"));
}
function $7a13843840af5e19$var$$r(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $7a13843840af5e19$export$9ebfec18c2dfc625;
}
function $7a13843840af5e19$var$Mr(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$g(e, t, [
            r
        ]);
    };
}
function $7a13843840af5e19$var$Yr(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$S(e, t, [
            r
        ]);
    };
}
function $7a13843840af5e19$var$xr(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r, o) {
        return $7a13843840af5e19$var$g(e, t, [
            r,
            o
        ]);
    };
}
function $7a13843840af5e19$var$Qr(e, t, r) {
    return $7a13843840af5e19$var$F(e, r), function(r) {
        return $7a13843840af5e19$var$g(e, t, [
            r
        ]);
    };
}
Object.defineProperties($7a13843840af5e19$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
var $7a13843840af5e19$export$d102341634899398 = /*#__PURE__*/ function() {
    "use strict";
    function TransformStream() {
        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $7lhcp._)(this, TransformStream);
        void 0 === _$e && (_$e = null);
        var _$o = $7a13843840af5e19$var$dt(t, "Second parameter"), n = $7a13843840af5e19$var$dt(r, "Third parameter"), a = function(e, t) {
            $7a13843840af5e19$var$L(e, t);
            var r = null == e ? void 0 : e.cancel, _$o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, a = null == e ? void 0 : e.start, i = null == e ? void 0 : e.transform, l = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $7a13843840af5e19$var$Qr(r, e, "".concat(t, " has member 'cancel' that")),
                flush: void 0 === _$o ? void 0 : $7a13843840af5e19$var$Mr(_$o, e, "".concat(t, " has member 'flush' that")),
                readableType: n,
                start: void 0 === a ? void 0 : $7a13843840af5e19$var$Yr(a, e, "".concat(t, " has member 'start' that")),
                transform: void 0 === i ? void 0 : $7a13843840af5e19$var$xr(i, e, "".concat(t, " has member 'transform' that")),
                writableType: l
            };
        }(_$e, "First parameter");
        if (void 0 !== a.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== a.writableType) throw new RangeError("Invalid writableType specified");
        var i = $7a13843840af5e19$var$ut(n, 0), l = $7a13843840af5e19$var$ct(n), s = $7a13843840af5e19$var$ut(_$o, 1), f = $7a13843840af5e19$var$ct(_$o);
        var h;
        !function(e, t, r, o, n, a) {
            function i() {
                return t;
            }
            function l(t) {
                return function(e, t) {
                    var _$r = e._transformStreamController;
                    if (e._backpressure) return $7a13843840af5e19$var$_(e._backpressureChangePromise, function() {
                        var _$o = e._writable;
                        if ("erroring" === _$o._state) throw _$o._storedError;
                        return $7a13843840af5e19$var$Zr(_$r, t);
                    });
                    return $7a13843840af5e19$var$Zr(_$r, t);
                }(e, t);
            }
            function s(t) {
                return function(e, t) {
                    var _$r = e._transformStreamController;
                    if (void 0 !== _$r._finishPromise) return _$r._finishPromise;
                    var _$o = e._readable;
                    _$r._finishPromise = $7a13843840af5e19$var$u(function(e, t) {
                        _$r._finishPromise_resolve = e, _$r._finishPromise_reject = t;
                    });
                    var _$n = _$r._cancelAlgorithm(t);
                    return $7a13843840af5e19$var$Jr(_$r), $7a13843840af5e19$var$b(_$n, function() {
                        return "errored" === _$o._state ? $7a13843840af5e19$var$ro(_$r, _$o._storedError) : ($7a13843840af5e19$var$br(_$o._readableStreamController, t), $7a13843840af5e19$var$to(_$r)), null;
                    }, function(e) {
                        return $7a13843840af5e19$var$br(_$o._readableStreamController, e), $7a13843840af5e19$var$ro(_$r, e), null;
                    }), _$r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    var t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    var _$r = e._readable;
                    t._finishPromise = $7a13843840af5e19$var$u(function(e, r) {
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    var _$o = t._flushAlgorithm();
                    return $7a13843840af5e19$var$Jr(t), $7a13843840af5e19$var$b(_$o, function() {
                        return "errored" === _$r._state ? $7a13843840af5e19$var$ro(t, _$r._storedError) : ($7a13843840af5e19$var$dr(_$r._readableStreamController), $7a13843840af5e19$var$to(t)), null;
                    }, function(e) {
                        return $7a13843840af5e19$var$br(_$r._readableStreamController, e), $7a13843840af5e19$var$ro(t, e), null;
                    }), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $7a13843840af5e19$var$Gr(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    var _$r = e._transformStreamController;
                    if (void 0 !== _$r._finishPromise) return _$r._finishPromise;
                    var _$o = e._writable;
                    _$r._finishPromise = $7a13843840af5e19$var$u(function(e, t) {
                        _$r._finishPromise_resolve = e, _$r._finishPromise_reject = t;
                    });
                    var _$n = _$r._cancelAlgorithm(t);
                    return $7a13843840af5e19$var$Jr(_$r), $7a13843840af5e19$var$b(_$n, function() {
                        return "errored" === _$o._state ? $7a13843840af5e19$var$ro(_$r, _$o._storedError) : ($7a13843840af5e19$var$Yt(_$o._writableStreamController, t), $7a13843840af5e19$var$Ur(e), $7a13843840af5e19$var$to(_$r)), null;
                    }, function(t) {
                        return $7a13843840af5e19$var$Yt(_$o._writableStreamController, t), $7a13843840af5e19$var$Ur(e), $7a13843840af5e19$var$ro(_$r, t), null;
                    }), _$r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o) {
                var _$n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, _$a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function() {
                    return 1;
                };
                var _$i = Object.create($7a13843840af5e19$export$826849241f7970f8.prototype);
                return $7a13843840af5e19$var$St(_$i), $7a13843840af5e19$var$Ft(_$i, Object.create($7a13843840af5e19$export$9e6890cb9a51c7c2.prototype), e, t, r, o, _$n, _$a), _$i;
            }(i, l, c, s, r, o), e._readable = $7a13843840af5e19$var$Cr(i, d, f, n, a), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $7a13843840af5e19$var$Gr(e, !0), e._transformStreamController = void 0;
        }(this, $7a13843840af5e19$var$u(function(e) {
            h = e;
        }), s, f, i, l), function(e, t) {
            var r = Object.create($7a13843840af5e19$export$a55559184460222.prototype);
            var _$o, n, a;
            _$o = void 0 !== t.transform ? function(e) {
                return t.transform(e, r);
            } : function(e) {
                try {
                    return $7a13843840af5e19$var$Kr(r, e), $7a13843840af5e19$var$c(void 0);
                } catch (e) {
                    return $7a13843840af5e19$var$d(e);
                }
            };
            n = void 0 !== t.flush ? function() {
                return t.flush(r);
            } : function() {
                return $7a13843840af5e19$var$c(void 0);
            };
            a = void 0 !== t.cancel ? function(e) {
                return t.cancel(e);
            } : function() {
                return $7a13843840af5e19$var$c(void 0);
            };
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, _$o, n, a);
        }(this, a), void 0 !== a.start ? h(a.start(this._transformStreamController)) : h(void 0);
    }
    (0, $8BtP9._)(TransformStream, [
        {
            key: "readable",
            get: function get() {
                if (!$7a13843840af5e19$var$Nr(this)) throw $7a13843840af5e19$var$oo("readable");
                return this._readable;
            }
        },
        {
            key: "writable",
            get: function get() {
                if (!$7a13843840af5e19$var$Nr(this)) throw $7a13843840af5e19$var$oo("writable");
                return this._writable;
            }
        }
    ]);
    return TransformStream;
}();
function $7a13843840af5e19$var$Nr(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $7a13843840af5e19$export$d102341634899398;
}
function $7a13843840af5e19$var$Hr(e, t) {
    $7a13843840af5e19$var$br(e._readable._readableStreamController, t), $7a13843840af5e19$var$Vr(e, t);
}
function $7a13843840af5e19$var$Vr(e, t) {
    $7a13843840af5e19$var$Jr(e._transformStreamController), $7a13843840af5e19$var$Yt(e._writable._writableStreamController, t), $7a13843840af5e19$var$Ur(e);
}
function $7a13843840af5e19$var$Ur(e) {
    e._backpressure && $7a13843840af5e19$var$Gr(e, !1);
}
function $7a13843840af5e19$var$Gr(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $7a13843840af5e19$var$u(function(t) {
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($7a13843840af5e19$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
var $7a13843840af5e19$export$a55559184460222 = /*#__PURE__*/ function() {
    "use strict";
    function TransformStreamDefaultController() {
        (0, $7lhcp._)(this, TransformStreamDefaultController);
        throw new TypeError("Illegal constructor");
    }
    (0, $8BtP9._)(TransformStreamDefaultController, [
        {
            key: "desiredSize",
            get: function get() {
                if (!$7a13843840af5e19$var$Xr(this)) throw $7a13843840af5e19$var$eo("desiredSize");
                return $7a13843840af5e19$var$hr(this._controlledTransformStream._readable._readableStreamController);
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                if (!$7a13843840af5e19$var$Xr(this)) throw $7a13843840af5e19$var$eo("enqueue");
                $7a13843840af5e19$var$Kr(this, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                if (!$7a13843840af5e19$var$Xr(this)) throw $7a13843840af5e19$var$eo("error");
                var t;
                t = e, $7a13843840af5e19$var$Hr(this._controlledTransformStream, t);
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                if (!$7a13843840af5e19$var$Xr(this)) throw $7a13843840af5e19$var$eo("terminate");
                !function(e) {
                    var t = e._controlledTransformStream;
                    $7a13843840af5e19$var$dr(t._readable._readableStreamController);
                    var r = new TypeError("TransformStream terminated");
                    $7a13843840af5e19$var$Vr(t, r);
                }(this);
            }
        }
    ]);
    return TransformStreamDefaultController;
}();
function $7a13843840af5e19$var$Xr(e) {
    return !!$7a13843840af5e19$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $7a13843840af5e19$export$a55559184460222;
}
function $7a13843840af5e19$var$Jr(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $7a13843840af5e19$var$Kr(e, t) {
    var r = e._controlledTransformStream, _$o = r._readable._readableStreamController;
    if (!$7a13843840af5e19$var$mr(_$o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $7a13843840af5e19$var$fr(_$o, t);
    } catch (e) {
        throw $7a13843840af5e19$var$Vr(r, e), r._readable._storedError;
    }
    var n = function(e) {
        return !$7a13843840af5e19$var$ur(e);
    }(_$o);
    n !== r._backpressure && $7a13843840af5e19$var$Gr(r, !0);
}
function $7a13843840af5e19$var$Zr(e, t) {
    return $7a13843840af5e19$var$_(e._transformAlgorithm(t), void 0, function(t) {
        throw $7a13843840af5e19$var$Hr(e._controlledTransformStream, t), t;
    });
}
function $7a13843840af5e19$var$eo(e) {
    return new TypeError("TransformStreamDefaultController.prototype.".concat(e, " can only be used on a TransformStreamDefaultController"));
}
function $7a13843840af5e19$var$to(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $7a13843840af5e19$var$ro(e, t) {
    void 0 !== e._finishPromise_reject && ($7a13843840af5e19$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $7a13843840af5e19$var$oo(e) {
    return new TypeError("TransformStream.prototype.".concat(e, " can only be used on a TransformStream"));
}
Object.defineProperties($7a13843840af5e19$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $7a13843840af5e19$var$o($7a13843840af5e19$export$a55559184460222.prototype.enqueue, "enqueue"), $7a13843840af5e19$var$o($7a13843840af5e19$export$a55559184460222.prototype.error, "error"), $7a13843840af5e19$var$o($7a13843840af5e19$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == (0, $5f0Cq._)(Symbol.toStringTag) && Object.defineProperty($7a13843840af5e19$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});


function $2159b752ecc26024$export$99096e10de875468() {
    var handler;
    var stream = new (0, $7a13843840af5e19$export$5d3e1e5268af5f76)({
        start: function(controller) {
            handler = controller;
        }
    });
    function call() {
        for(var _len = arguments.length, input = new Array(_len), _key = 0; _key < _len; _key++){
            input[_key] = arguments[_key];
        }
        var request = {
            context: this,
            input: input,
            output: Promise.withResolvers()
        };
        handler.enqueue(request);
        return request.output.promise;
    }
    return Object.assign(call, {
        stream: stream
    });
}
var $2159b752ecc26024$export$db26ce94c7abc843 = /^on(\w+)/;
var $2159b752ecc26024$var$EventHandlerMap = new WeakMap();
function $2159b752ecc26024$export$d09f5504a38c35a6(name, handler) {
    var _this = this;
    var wrapper = function(detail) {
        var event = new CustomEvent(name, {
            detail: detail
        }), meta = {
            enumerable: true,
            value: _this
        };
        Object.defineProperties(event, {
            eventPhase: Object.assign(Object.assign({}, meta), {
                value: Event.AT_TARGET
            }),
            srcElement: meta,
            target: meta,
            currentTarget: meta
        });
        handler.call(_this, event);
    };
    $2159b752ecc26024$var$EventHandlerMap.set(handler, wrapper);
    return wrapper;
}
var $2159b752ecc26024$export$7c4c84635886a982 = function(handler) {
    return $2159b752ecc26024$var$EventHandlerMap.get(handler);
};


var $3703681daa9862d5$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $3703681daa9862d5$var$_ProxyElement_data;
var $3703681daa9862d5$export$dfca55cafbce2a44 = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $h6w6E._)(ProxyElement, HTMLElement1);
    function ProxyElement() {
        (0, $7lhcp._)(this, ProxyElement);
        var _this;
        _this = (0, $07dqX._)(this, ProxyElement);
        $3703681daa9862d5$var$_ProxyElement_data.set(_this, {});
        (0, $6tqvJ.proxyPrototype)(_this, $3703681daa9862d5$var$__classPrivateFieldGet(_this, $3703681daa9862d5$var$_ProxyElement_data, "f"), function(key, value) {
            return _this.setProperty(key.toString(), value);
        });
        return _this;
    }
    (0, $8BtP9._)(ProxyElement, [
        {
            key: "toJSON",
            value: function toJSON() {
                return Object.fromEntries(Object.entries($3703681daa9862d5$var$__classPrivateFieldGet(this, $3703681daa9862d5$var$_ProxyElement_data, "f")).filter(function(param) {
                    var _param = (0, $leE2g._)(param, 2), key = _param[0], value = _param[1];
                    return typeof value !== 'function' && !key.startsWith('__react');
                }));
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var prototype = Object.getPrototypeOf(this);
                var customAttributes = (0, $fsSDT._)(this.attributes).filter(function(param) {
                    var name = param.name;
                    return !(name in prototype);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (customAttributes[0] && !Object.keys(this.toJSON())[0]) try {
                    for(var _iterator = customAttributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, name = _step_value.name, value = _step_value.value;
                        this.setAttribute(name, value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "setProperty",
            value: function setProperty(key, value) {
                var oldValue = $3703681daa9862d5$var$__classPrivateFieldGet(this, $3703681daa9862d5$var$_ProxyElement_data, "f")[key], name = (0, $6tqvJ.toHyphenCase)(key), eventName = key.slice(2);
                $3703681daa9862d5$var$__classPrivateFieldGet(this, $3703681daa9862d5$var$_ProxyElement_data, "f")[key] = value;
                switch(typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)){
                    case 'boolean':
                        if (value) (0, $5LQ10._)((0, $2JFuQ._)(ProxyElement.prototype), "setAttribute", this).call(this, name, name + '');
                        else (0, $5LQ10._)((0, $2JFuQ._)(ProxyElement.prototype), "removeAttribute", this).call(this, name);
                        break;
                    case 'function':
                        if ((0, $2159b752ecc26024$export$db26ce94c7abc843).test(key)) {
                            this.removeEventListener(eventName, oldValue);
                            this.addEventListener(eventName, value);
                        }
                        break;
                    default:
                        if (value != null) (0, $5LQ10._)((0, $2JFuQ._)(ProxyElement.prototype), "setAttribute", this).call(this, name, (typeof value === "undefined" ? "undefined" : (0, $5f0Cq._)(value)) === 'object' ? JSON.stringify(value) : value);
                        else if ((0, $2159b752ecc26024$export$db26ce94c7abc843).test(key) && typeof oldValue === 'function') this.removeEventListener(eventName, value);
                        else (0, $5LQ10._)((0, $2JFuQ._)(ProxyElement.prototype), "removeAttribute", this).call(this, name);
                }
            }
        },
        {
            key: "setAttribute",
            value: function setAttribute(name, value) {
                (0, $5LQ10._)((0, $2JFuQ._)(ProxyElement.prototype), "setAttribute", this).call(this, name, value);
                var key = (0, $6tqvJ.toCamelCase)(name);
                if (key in Object.getPrototypeOf(this)) return;
                this[key] = name === value || (0, $6tqvJ.parseJSON)(value);
            }
        }
    ]);
    return ProxyElement;
}((0, $1Qmny._)(HTMLElement));
$3703681daa9862d5$var$_ProxyElement_data = new WeakMap();



var $7e446be072ac3937$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7e446be072ac3937$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7e446be072ac3937$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7e446be072ac3937$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $7e446be072ac3937$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e446be072ac3937$var$_EChartsElement_instances, $7e446be072ac3937$var$_EChartsElement_core, $7e446be072ac3937$var$_EChartsElement_coreDefer, $7e446be072ac3937$var$_EChartsElement_init;
var $7e446be072ac3937$export$653143645409d056 = /*#__PURE__*/ function(ProxyElement) {
    "use strict";
    (0, $h6w6E._)(EChartsElement, ProxyElement);
    function EChartsElement() {
        (0, $7lhcp._)(this, EChartsElement);
        var _this;
        _this = (0, $07dqX._)(this, EChartsElement);
        $7e446be072ac3937$var$_EChartsElement_instances.add(_this);
        $7e446be072ac3937$var$_EChartsElement_core.set(_this, void 0);
        $7e446be072ac3937$var$_EChartsElement_coreDefer.set(_this, Promise.withResolvers());
        Object.defineProperty(_this, "setOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "connectOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _this.connectChildStream(function(option) {
                return _this.setOption(option);
            })
        });
        Object.defineProperty(_this, "connectAddListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _this.connectChildStream(function(event, selector, handler) {
                $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").on(event, selector, handler);
            })
        });
        Object.defineProperty(_this, "connectRemoveListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _this.connectChildStream(function(event, handler) {
                $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").off(event, handler);
            })
        });
        Object.defineProperty(_this, "addEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "removeEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "handleResize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $dKdZ4.debounce)(function() {
                return $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").resize(_this.toJSON().resizeOptions);
            })
        });
        _this.attachShadow({
            mode: 'open'
        }).append((0, $6tqvJ.parseDOM)('<div style="height: 100%" />')[0]);
        return _this;
    }
    (0, $8BtP9._)(EChartsElement, [
        {
            key: "renderer",
            get: function get() {
                var _this_tagName_toLowerCase_split = (0, $leE2g._)(this.tagName.toLowerCase().split('-'), 2), _ = _this_tagName_toLowerCase_split[0], type = _this_tagName_toLowerCase_split[1];
                return type;
            }
        },
        {
            key: "options",
            get: function get() {
                return $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_core, "f").getOption();
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _a;
                if ($7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_core, "f")) return;
                (0, $5LQ10._)((0, $2JFuQ._)(EChartsElement.prototype), "connectedCallback", this).call(this);
                this.style.display = 'block';
                $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_instances, "m", $7e446be072ac3937$var$_EChartsElement_init).call(this);
                (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.handleResize);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _a, _b;
                (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.handleResize);
                (_b = $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_core, "f")) === null || _b === void 0 || _b.dispose();
                $7e446be072ac3937$var$__classPrivateFieldSet(this, $7e446be072ac3937$var$_EChartsElement_core, undefined, "f");
            }
        },
        {
            key: "setProperty",
            value: function setProperty(key, value) {
                (0, $5LQ10._)((0, $2JFuQ._)(EChartsElement.prototype), "setProperty", this).call(this, key, value);
                this.setOption(this.toJSON());
            }
        },
        {
            key: "processStream",
            value: function processStream(stream, executor, context) {
                return $7e446be072ac3937$var$__awaiter(this, void 0, void 0, function() {
                    var _a, stream_1, stream_1_1, _b, e_1, _c, _d, request, input, output, data, e_1_1;
                    return (0, $Csf8W.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_coreDefer, "f").promise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    13
                                ]);
                                _a = true, stream_1 = $7e446be072ac3937$var$__asyncValues(stream);
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    stream_1.next()
                                ];
                            case 4:
                                if (!(stream_1_1 = _state.sent(), _b = stream_1_1.done, !_b)) return [
                                    3,
                                    6
                                ];
                                _d = stream_1_1.value;
                                _a = false;
                                request = _d;
                                input = request.input, output = request.output;
                                try {
                                    data = executor.apply(context, input);
                                    output.resolve(data);
                                } catch (error) {
                                    output.reject(error);
                                }
                                _state.label = 5;
                            case 5:
                                _a = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    13
                                ];
                            case 7:
                                e_1_1 = _state.sent();
                                e_1 = {
                                    error: e_1_1
                                };
                                return [
                                    3,
                                    13
                                ];
                            case 8:
                                _state.trys.push([
                                    8,
                                    ,
                                    11,
                                    12
                                ]);
                                if (!(!_a && !_b && (_c = stream_1.return))) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _c.call(stream_1)
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                if (e_1) throw e_1.error;
                                return [
                                    7
                                ];
                            case 12:
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "connectChildStream",
            value: function connectChildStream(executor) {
                var that = this;
                return function(stream) {
                    return that.processStream(stream, executor, this);
                };
            }
        }
    ]);
    return EChartsElement;
}((0, $3703681daa9862d5$export$dfca55cafbce2a44));
$7e446be072ac3937$var$_EChartsElement_core = new WeakMap(), $7e446be072ac3937$var$_EChartsElement_coreDefer = new WeakMap(), $7e446be072ac3937$var$_EChartsElement_instances = new WeakSet(), $7e446be072ac3937$var$_EChartsElement_init = function _EChartsElement_init() {
    var _this = this;
    var _a = this.toJSON(), theme = _a.theme, initOptions = _a.initOptions, setOptions = _a.setOptions, props = $7e446be072ac3937$var$__rest(_a, [
        "theme",
        "initOptions",
        "setOptions"
    ]);
    $7e446be072ac3937$var$__classPrivateFieldSet(this, $7e446be072ac3937$var$_EChartsElement_core, (0, $02d15e5d967b8fed$export$2cd8252107eb640b)(this.shadowRoot.firstElementChild, theme, Object.assign(Object.assign({}, initOptions), {
        renderer: this.renderer
    })), "f");
    $7e446be072ac3937$var$__classPrivateFieldGet(this, $7e446be072ac3937$var$_EChartsElement_coreDefer, "f").resolve();
    // @ts-ignore
    this.setOption(Object.assign({
        grid: {}
    }, props));
    this.processStream(this.setOption.stream, function(data) {
        $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").setOption(data, Object.assign({
            notMerge: false,
            lazyUpdate: true
        }, setOptions));
    });
    this.processStream(this.removeEventListener.stream, function(event, handler) {
        $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").getZr().off(event, (0, $2159b752ecc26024$export$7c4c84635886a982)(handler));
    });
    this.processStream(this.addEventListener.stream, function(name, handler) {
        $7e446be072ac3937$var$__classPrivateFieldGet(_this, $7e446be072ac3937$var$_EChartsElement_core, "f").getZr().on(name, (0, $2159b752ecc26024$export$d09f5504a38c35a6).call(_this, name, handler));
    });
};


var $bf4993a4cb76e3b2$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $4a5ecb2ecc6b13b5$export$4b3e715f166fdd78));
var $bf4993a4cb76e3b2$export$14625ca68d894a68 = /*#__PURE__*/ function(EChartsElement) {
    "use strict";
    (0, $h6w6E._)(ECSVGRenderer, EChartsElement);
    function ECSVGRenderer() {
        (0, $7lhcp._)(this, ECSVGRenderer);
        return (0, $07dqX._)(this, ECSVGRenderer, arguments);
    }
    return ECSVGRenderer;
}((0, $7e446be072ac3937$export$653143645409d056));
($bf4993a4cb76e3b2$var$_a = globalThis.customElements) === null || $bf4993a4cb76e3b2$var$_a === void 0 || $bf4993a4cb76e3b2$var$_a.define('ec-svg-renderer', $bf4993a4cb76e3b2$export$14625ca68d894a68);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $c68ec3db9ff118cf$var$TitleModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = 'title';
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: '',
        target: 'blank',
        subtext: '',
        subtarget: 'blank',
        left: 'center',
        top: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).size.m,
        backgroundColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.primary,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.primary
        },
        subtextStyle: {
            fontSize: 12,
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.quaternary
        }
    };
    return TitleModel;
}((0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
// View
var $c68ec3db9ff118cf$var$TitleView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get('show')) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel('textStyle');
        var subtextStyleModel = titleModel.getModel('subtextStyle');
        var textAlign = titleModel.get('textAlign');
        var textVerticalAlign = $99026af6cdabc3e1$export$995e01f2f5c9d030(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
        var textEl = new $97dfecd189304201$export$2e2bcd8739ae039({
            style: (0, $a4fed78c55651c93$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get('text'),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get('subtext');
        var subTextEl = new $97dfecd189304201$export$2e2bcd8739ae039({
            style: (0, $a4fed78c55651c93$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get('itemGap'),
                verticalAlign: 'top'
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get('link');
        var sublink = titleModel.get('sublink');
        var triggerEvent = titleModel.get('triggerEvent', true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on('click', function() {
            (0, $031dcf3d7ed28374$export$13e13f9b96dbe8fa)(link, '_' + titleModel.get('target'));
        });
        if (sublink) subTextEl.on('click', function() {
            (0, $031dcf3d7ed28374$export$13e13f9b96dbe8fa)(sublink, '_' + titleModel.get('subtarget'));
        });
        (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: 'title',
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRef = (0, $4fb3a6a3c6974639$export$5aec1e94f566e59f)(titleModel, api);
        var layoutRect = (0, $4fb3a6a3c6974639$export$4517a5ca639a7293)(layoutOption, layoutRef.refContainer, titleModel.get('padding'));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get('left') || titleModel.get('right');
            // @ts-ignore
            if (textAlign === 'middle') textAlign = 'center';
            // Adjust layout by text align
            if (textAlign === 'right') layoutRect.x += layoutRect.width;
            else if (textAlign === 'center') layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
            // @ts-ignore
            if (textVerticalAlign === 'center') textVerticalAlign = 'middle';
            if (textVerticalAlign === 'bottom') layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === 'middle') layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || 'top';
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            'color',
            'opacity'
        ]);
        style.fill = titleModel.get('backgroundColor');
        var rect = new $aed3569651b5e3fa$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get('borderRadius')
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = 'title';
    return TitleView;
}((0, $3e14d76796640b86$export$2e2bcd8739ae039));
function $c68ec3db9ff118cf$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($c68ec3db9ff118cf$var$TitleModel);
    registers.registerComponentView($c68ec3db9ff118cf$var$TitleView);
}




var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $5RfYb = parcelRequire("5RfYb");

var $5LQ10 = parcelRequire("5LQ10");

var $2JFuQ = parcelRequire("2JFuQ");

var $h6w6E = parcelRequire("h6w6E");

var $6tqvJ = parcelRequire("6tqvJ");



var $6f6095288b1fca4a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f6095288b1fca4a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6f6095288b1fca4a$var$_ECOptionElement_id, $6f6095288b1fca4a$var$_ECOptionElement_renderer, $6f6095288b1fca4a$var$_ECOptionElement_nextTick;
var $6f6095288b1fca4a$export$37de6f71bb86a769 = /*#__PURE__*/ function(ProxyElement) {
    "use strict";
    (0, $h6w6E._)(ECOptionElement, ProxyElement);
    function ECOptionElement() {
        (0, $7lhcp._)(this, ECOptionElement);
        var _this;
        _this = (0, $07dqX._)(this, ECOptionElement, arguments);
        $6f6095288b1fca4a$var$_ECOptionElement_id.set(_this, (0, $6tqvJ.uniqueID)());
        $6f6095288b1fca4a$var$_ECOptionElement_renderer.set(_this, void 0);
        $6f6095288b1fca4a$var$_ECOptionElement_nextTick.set(_this, void 0);
        Object.defineProperty(_this, "emitOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "emitAddListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        Object.defineProperty(_this, "emitRemoveListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $2159b752ecc26024$export$99096e10de875468)()
        });
        return _this;
    }
    (0, $8BtP9._)(ECOptionElement, [
        {
            key: "chartTagName",
            get: function get() {
                return (0, $6tqvJ.toCamelCase)(this.tagName.replace(/^ec-/i, '').toLowerCase());
            }
        },
        {
            key: "isSeries",
            get: function get() {
                return this.chartTagName.endsWith('Chart');
            }
        },
        {
            key: "chartName",
            get: function get() {
                return this.isSeries ? this.chartTagName.replace(/Chart$/, '') : null;
            }
        },
        {
            key: "eventSelector",
            get: function get() {
                return [
                    this.isSeries && 'series',
                    this.chartName || this.chartTagName,
                    this['type']
                ].filter(Boolean).join('.');
            }
        },
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                if ($6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f")) return;
                (0, $5LQ10._)((0, $2JFuQ._)(ECOptionElement.prototype), "connectedCallback", this).call(this);
                if (!this.attributes[0]) this.updateOption();
                for(var parent = this.parentElement; parent; parent = parent.parentElement)if (parent instanceof (0, $7e446be072ac3937$export$653143645409d056)) $6f6095288b1fca4a$var$__classPrivateFieldSet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, parent, "f");
                if (!$6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f")) throw new ReferenceError("<".concat(this.tagName.toLowerCase(), " /> should be append to a DOM tree within <ec-svg-renderer /> or <ec-canvas-renderer />"));
                $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f").connectOption(this.emitOption.stream);
                $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f").connectRemoveListener(this.emitRemoveListener.stream);
                $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_renderer, "f").connectAddListener(this.emitAddListener.stream);
            }
        },
        {
            key: "setProperty",
            value: function setProperty(key, value) {
                var _this = this;
                var _a;
                (0, $5LQ10._)((0, $2JFuQ._)(ECOptionElement.prototype), "setProperty", this).call(this, key, value);
                $6f6095288b1fca4a$var$__classPrivateFieldSet(this, $6f6095288b1fca4a$var$_ECOptionElement_nextTick, (_a = $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_nextTick, "f")) !== null && _a !== void 0 ? _a : Promise.resolve().then(function() {
                    _this.updateOption();
                    $6f6095288b1fca4a$var$__classPrivateFieldSet(_this, $6f6095288b1fca4a$var$_ECOptionElement_nextTick, null, "f");
                }), "f");
            }
        },
        {
            key: "updateOption",
            value: function updateOption() {
                var data = this.toJSON(), formatter = this.formatter;
                var option = this.isSeries ? {
                    series: [
                        Object.assign(Object.assign({
                            id: $6f6095288b1fca4a$var$__classPrivateFieldGet(this, $6f6095288b1fca4a$var$_ECOptionElement_id, "f")
                        }, data), {
                            type: this.chartName
                        })
                    ]
                } : (0, $5RfYb._)({}, this.chartTagName, Object.assign(Object.assign({}, data), {
                    formatter: formatter
                }));
                return this.emitOption(option);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(name, handler) {
                return this.emitAddListener(name, this.eventSelector, (0, $2159b752ecc26024$export$d09f5504a38c35a6).call(this, name, handler));
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(event, handler) {
                return this.emitRemoveListener(event, (0, $2159b752ecc26024$export$7c4c84635886a982)(handler));
            }
        }
    ]);
    return ECOptionElement;
}((0, $3703681daa9862d5$export$dfca55cafbce2a44));
$6f6095288b1fca4a$var$_ECOptionElement_id = new WeakMap(), $6f6095288b1fca4a$var$_ECOptionElement_renderer = new WeakMap(), $6f6095288b1fca4a$var$_ECOptionElement_nextTick = new WeakMap();


var $f9b6fc07bbb8b781$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $c68ec3db9ff118cf$export$4b3e715f166fdd78));
var $f9b6fc07bbb8b781$export$a07c56df7267ad6f = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECTitleComponent, ECOptionElement);
    function ECTitleComponent() {
        (0, $7lhcp._)(this, ECTitleComponent);
        return (0, $07dqX._)(this, ECTitleComponent, arguments);
    }
    return ECTitleComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($f9b6fc07bbb8b781$var$_a = globalThis.customElements) === null || $f9b6fc07bbb8b781$var$_a === void 0 || $f9b6fc07bbb8b781$var$_a.define('ec-title', $f9b6fc07bbb8b781$export$a07c56df7267ad6f);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $027975b66222afc2$var$getDefaultSelectorOptions = function getDefaultSelectorOptions(ecModel, type) {
    if (type === 'all') return {
        type: 'all',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'all'
        ])
    };
    else if (type === 'inverse') return {
        type: 'inverse',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'inverse'
        ])
    };
};
var $027975b66222afc2$var$LegendModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: 'box',
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            'all',
            'inverse'
        ];
        if ($99026af6cdabc3e1$export$43bee75e5e14138e(selector)) $99026af6cdabc3e1$export$79b2f7037acddd43(selector, function(item, index) {
            $99026af6cdabc3e1$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $99026af6cdabc3e1$export$4950aa0f605343fb(item, $027975b66222afc2$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get('selectedMode') === 'single') {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get('name');
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get('name'));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $08bfa015475effa8$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get('data') || potentialData;
        var legendNameMap = $99026af6cdabc3e1$export$55f8aa7ef875b0a4();
        var legendData = $99026af6cdabc3e1$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($99026af6cdabc3e1$export$844ec244b1367d54(dataItem) || $99026af6cdabc3e1$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $99026af6cdabc3e1$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get('selectedMode');
        if (selectedMode === 'single') {
            var data = this._data;
            $99026af6cdabc3e1$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get('name')] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get('selectedMode') !== 'single') this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? 'unSelect' : 'select'](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $99026af6cdabc3e1$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get('name', true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $99026af6cdabc3e1$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get('name', true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $99026af6cdabc3e1$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get('orient') === 'vertical' ? {
            index: 1,
            name: 'vertical'
        } : {
            index: 0,
            name: 'horizontal'
        };
    };
    LegendModel.type = 'legend.plain';
    LegendModel.dependencies = [
        'series'
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: 'horizontal',
        left: 'center',
        // right: 'center',
        // top: 0,
        bottom: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).size.m,
        align: 'auto',
        backgroundColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 8,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: 'inherit',
        symbolKeepAspect: true,
        inactiveColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderWidth: 'auto',
        itemStyle: {
            color: 'inherit',
            opacity: 'inherit',
            borderColor: 'inherit',
            borderWidth: 'auto',
            borderCap: 'inherit',
            borderJoin: 'inherit',
            borderDashOffset: 'inherit',
            borderMiterLimit: 'inherit'
        },
        lineStyle: {
            width: 'auto',
            color: 'inherit',
            inactiveColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.disabled,
            inactiveWidth: 2,
            opacity: 'inherit',
            type: 'inherit',
            cap: 'inherit',
            join: 'inherit',
            dashOffset: 'inherit',
            miterLimit: 'inherit'
        },
        textStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.secondary
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: 'sans-serif',
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.tertiary,
            borderWidth: 1,
            borderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.border
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.quaternary
            }
        },
        selectorPosition: 'auto',
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        },
        triggerEvent: false
    };
    return LegendModel;
}((0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
var $027975b66222afc2$export$2e2bcd8739ae039 = $027975b66222afc2$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $bf3fcecc8fa5299f$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $031dcf3d7ed28374$export$f3a38102c49f4268(componentModel.get('padding'));
    var style = componentModel.getItemStyle([
        'color',
        'opacity'
    ]);
    style.fill = componentModel.get('backgroundColor');
    var bgRect = new $aed3569651b5e3fa$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get('borderRadius')
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return bgRect;
}








var $2428c3b397031c54$var$curry = $99026af6cdabc3e1$export$c3095a23b368d1f2;
var $2428c3b397031c54$var$each = $99026af6cdabc3e1$export$79b2f7037acddd43;
var $2428c3b397031c54$var$Group = $2b89655bc310a947$export$2e2bcd8739ae039;
var $2428c3b397031c54$var$LegendView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $2428c3b397031c54$var$Group());
        this.group.add(this._selectorGroup = new $2428c3b397031c54$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get('show', true)) return;
        var itemAlign = legendModel.get('align');
        var orient = legendModel.get('orient');
        if (!itemAlign || itemAlign === 'auto') itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
        // selector has been normalized to an array in model
        var selector = legendModel.get('selector', true);
        var selectorPosition = legendModel.get('selectorPosition', true);
        if (selector && (!selectorPosition || selectorPosition === 'auto')) selectorPosition = orient === 'horizontal' ? 'end' : 'start';
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var refContainer = $4fb3a6a3c6974639$export$5aec1e94f566e59f(legendModel, api).refContainer;
        var positionInfo = legendModel.getBoxLayoutParams();
        var padding = legendModel.get('padding');
        var maxSize = $4fb3a6a3c6974639$export$4517a5ca639a7293(positionInfo, refContainer, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $4fb3a6a3c6974639$export$4517a5ca639a7293($99026af6cdabc3e1$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), refContainer, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $bf3fcecc8fa5299f$export$fae23936eedfad4f)(mainRect, // FXIME: most itemStyle options does not work in background because inherit is not handled yet.
        legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $99026af6cdabc3e1$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get('selectedMode');
        var triggerEvent = legendModel.get('triggerEvent');
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
        });
        $2428c3b397031c54$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var _this = this;
            var name = legendItemModel.get('name');
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === '' || name === '\n')) {
                var g = new $2428c3b397031c54$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual('legendLineStyle') || {};
                var legendIcon = data.getVisual('legendIcon');
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual('style');
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on('click', $2428c3b397031c54$var$curry($2428c3b397031c54$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', $2428c3b397031c54$var$curry($2428c3b397031c54$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', $2428c3b397031c54$var$curry($2428c3b397031c54$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = 'legend';
                });
                if (triggerEvent) itemGroup.eachChild(function(child) {
                    _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                var _this = this;
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, 'style');
                    var legendIcon = provider.getItemVisual(idx, 'legendIcon');
                    var colorArr = (0, $9148d8aa0f446713$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $99026af6cdabc3e1$export$8b58be045bf06082($99026af6cdabc3e1$export$8b58be045bf06082({}, style), {
                            fill: (0, $9148d8aa0f446713$export$fac44ee5b035f737)(colorArr, 'rgba')
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on('click', $2428c3b397031c54$var$curry($2428c3b397031c54$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on('mouseover', $2428c3b397031c54$var$curry($2428c3b397031c54$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', $2428c3b397031c54$var$curry($2428c3b397031c54$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = 'legend';
                    });
                    if (triggerEvent) itemGroup.eachChild(function(child) {
                        _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype.packEventData = function(el, legendModel, seriesModel, dataIndex, name) {
        var eventData = {
            componentType: 'legend',
            componentIndex: legendModel.componentIndex,
            dataIndex: dataIndex,
            value: name,
            seriesIndex: seriesModel.seriesIndex
        };
        (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el).eventData = eventData;
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $2428c3b397031c54$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $97dfecd189304201$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: 'center',
                    verticalAlign: 'middle'
                },
                onclick: function onclick() {
                    api.dispatchAction({
                        type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect',
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel('selectorLabel');
            var emphasisLabelModel = legendModel.getModel([
                'emphasis',
                'selectorLabel'
            ]);
            (0, $a4fed78c55651c93$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $ea1f7a1fbd33fd2d$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get('itemWidth');
        var itemHeight = legendModel.get('itemHeight');
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get('symbolRotate');
        var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
        var legendIconType = legendItemModel.get('icon');
        legendIcon = legendIconType || legendIcon || 'roundRect';
        var style = $2428c3b397031c54$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $2428c3b397031c54$var$Group();
        var textStyleModel = legendItemModel.getModel('textStyle');
        if ($99026af6cdabc3e1$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon
            itemGroup.add($2428c3b397031c54$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get('formatter');
        var content = name;
        if ($99026af6cdabc3e1$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace('{name}', name != null ? name : '');
        else if ($99026af6cdabc3e1$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get('inactiveColor');
        itemGroup.add(new $97dfecd189304201$export$2e2bcd8739ae039({
            style: (0, $a4fed78c55651c93$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: 'middle'
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $aed3569651b5e3fa$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: 'transparent'
            }
        });
        var tooltipModel = legendItemModel.getModel('tooltip');
        if (tooltipModel.get('show')) $055606553475f5d6$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $ea1f7a1fbd33fd2d$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $4fb3a6a3c6974639$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $4fb3a6a3c6974639$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get('selectorButtonGap', true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? 'width' : 'height';
            var hw = orientIdx === 0 ? 'height' : 'width';
            var yx = orientIdx === 0 ? 'y' : 'x';
            if (selectorPosition === 'end') selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = 'legend.plain';
    return LegendView;
}((0, $3e14d76796640b86$export$2e2bcd8739ae039));
function $2428c3b397031c54$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === 'auto') style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $2428c3b397031c54$var$each(style, function(propVal, propName) {
            style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel('itemStyle');
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
    var decalStyle = itemStyleModel.getShallow('decal');
    itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : (0, $e02bd9bbb6e1fa7d$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === 'inherit') /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === 'inherit') /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === 'inherit') /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel('lineStyle');
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get('inactiveBorderWidth');
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get('inactiveColor');
        itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
        lineStyle.stroke = legendLineModel.get('inactiveColor');
        lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $2428c3b397031c54$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || 'roundRect';
    var icon = (0, $daf140cd8c7d5a6f$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf('empty') > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral00;
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $2428c3b397031c54$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $2428c3b397031c54$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: 'legendToggleSelect',
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $2428c3b397031c54$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $2428c3b397031c54$var$isUseHoverLayer(api) {
    var list = api.getZr().storage.getDisplayList();
    var emphasisState;
    var i = 0;
    var len = list.length;
    while(i < len && !(emphasisState = list[i].states.emphasis))i++;
    return emphasisState && emphasisState.hoverLayer;
}
function $2428c3b397031c54$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$2428c3b397031c54$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'highlight',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $2428c3b397031c54$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$2428c3b397031c54$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'downplay',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $2428c3b397031c54$export$2e2bcd8739ae039 = $2428c3b397031c54$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $aefa173f0bc2062b$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $2a9cd27aa549107a$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === 'allSelect' || methodName === 'inverseSelect';
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: 'legend',
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $2a9cd27aa549107a$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent('legend', function(legendModel) {
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? 'select' : 'unSelect'](name);
        });
        $2a9cd27aa549107a$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $2a9cd27aa549107a$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(legendModel.getData(), function(model) {
        var name = model.get('name');
        // Wrap element
        if (name === '\n' || name === '') return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $99026af6cdabc3e1$export$b5a638e9b3fff9f3)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $2a9cd27aa549107a$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendToggleSelect', 'legendselectchanged', (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)($2a9cd27aa549107a$var$legendSelectActionHandler, 'toggleSelected'));
    registers.registerAction('legendAllSelect', 'legendselectall', (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)($2a9cd27aa549107a$var$legendSelectActionHandler, 'allSelect'));
    registers.registerAction('legendInverseSelect', 'legendinverseselect', (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)($2a9cd27aa549107a$var$legendSelectActionHandler, 'inverseSelect'));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendSelect', 'legendselected', (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)($2a9cd27aa549107a$var$legendSelectActionHandler, 'select'));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendUnSelect', 'legendunselected', (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)($2a9cd27aa549107a$var$legendSelectActionHandler, 'unSelect'));
}


function $86db58838c077986$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $027975b66222afc2$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $2428c3b397031c54$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $aefa173f0bc2062b$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter('legend', function() {
        return 'plain';
    });
    (0, $2a9cd27aa549107a$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $22a85aef94ff8c35$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $4fb3a6a3c6974639$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $22a85aef94ff8c35$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $22a85aef94ff8c35$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = 'legend.scroll';
    ScrollableLegendModel.defaultOption = (0, $ea311bef09818b2f$export$68acc510e46fef2)((0, $027975b66222afc2$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: 'end',
        pageFormatter: '{current}/{total}',
        pageIcons: {
            horizontal: [
                'M0,0L12,-10L12,10z',
                'M0,0L-12,-10L-12,10z'
            ],
            vertical: [
                'M0,0L20,0L10,-20z',
                'M0,0L20,0L10,20z'
            ]
        },
        pageIconColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.accent50,
        pageIconInactiveColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.accent10,
        pageIconSize: 15,
        pageTextStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.tertiary
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $027975b66222afc2$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $22a85aef94ff8c35$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $4fb3a6a3c6974639$export$1754cb91f16ca028)(target, raw, {
        type: 'box',
        ignoreSize: !!ignoreSize
    });
}
var $22a85aef94ff8c35$export$2e2bcd8739ae039 = $22a85aef94ff8c35$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $cbc09157bb2807da$var$Group = $2b89655bc310a947$export$2e2bcd8739ae039;
var $cbc09157bb2807da$var$WH = [
    'width',
    'height'
];
var $cbc09157bb2807da$var$XY = [
    'x',
    'y'
];
var $cbc09157bb2807da$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $cbc09157bb2807da$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $cbc09157bb2807da$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get('pageIconSize', true);
        var pageIconSizeArr = $99026af6cdabc3e1$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton('pagePrev', 0);
        var pageTextStyleModel = legendModel.getModel('pageTextStyle');
        controllerGroup.add(new $97dfecd189304201$export$2e2bcd8739ae039({
            name: 'pageText',
            style: {
                // Placeholder to calculate a proper layout.
                text: 'xx/xx',
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: 'middle',
                align: 'center'
            },
            silent: true
        }));
        createPageButton('pageNext', 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + 'DataIndex';
            var icon = $055606553475f5d6$export$274edc73af1ae9c8(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $99026af6cdabc3e1$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $cbc09157bb2807da$var$WH[orientIdx];
        var xy = $cbc09157bb2807da$var$XY[orientIdx];
        var hw = $cbc09157bb2807da$var$WH[1 - orientIdx];
        var yx = $cbc09157bb2807da$var$XY[1 - orientIdx];
        selector && $4fb3a6a3c6974639$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
        var selectorButtonGap = legendModel.get('selectorButtonGap', true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $99026af6cdabc3e1$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === 'end') selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $4fb3a6a3c6974639$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $4fb3a6a3c6974639$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $99026af6cdabc3e1$export$995e01f2f5c9d030(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get('pageButtonPosition', true);
            // controller is on the right / bottom.
            if (pageButtonPosition === 'end') controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $aed3569651b5e3fa$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $821b3c1b9ddcee3a$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: 'legendScroll',
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $99026af6cdabc3e1$export$79b2f7037acddd43([
            'pagePrev',
            'pageNext'
        ], function(name) {
            var key = name + 'DataIndex';
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
                icon.cursor = canJump ? 'pointer' : 'default';
            }
        });
        var pageText = controllerGroup.childOfName('pageText');
        var pageFormatter = legendModel.get('pageFormatter');
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle('text', $99026af6cdabc3e1$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get('scrollDataIndex', true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $cbc09157bb2807da$var$WH[orientIdx];
        var xy = $cbc09157bb2807da$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = 'legend.scroll';
    return ScrollableLegendView;
}((0, $2428c3b397031c54$export$2e2bcd8739ae039));
var $cbc09157bb2807da$export$2e2bcd8739ae039 = $cbc09157bb2807da$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $2d1d6e06eb21df07$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction('legendScroll', 'legendscroll', function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: 'legend',
            subType: 'scroll',
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $57f6fec1224a3691$export$4b3e715f166fdd78(registers) {
    (0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $86db58838c077986$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $22a85aef94ff8c35$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $cbc09157bb2807da$export$2e2bcd8739ae039));
    (0, $2d1d6e06eb21df07$export$2e2bcd8739ae039)(registers);
}


function $5473533a887f5744$export$4b3e715f166fdd78(registers) {
    (0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $86db58838c077986$export$4b3e715f166fdd78));
    (0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $57f6fec1224a3691$export$4b3e715f166fdd78));
}




var $9f01206b7394f2b7$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $5473533a887f5744$export$4b3e715f166fdd78));
var $9f01206b7394f2b7$export$daedb98adc4e100e = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECLegendComponent, ECOptionElement);
    function ECLegendComponent() {
        (0, $7lhcp._)(this, ECLegendComponent);
        return (0, $07dqX._)(this, ECLegendComponent, arguments);
    }
    return ECLegendComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($9f01206b7394f2b7$var$_a = globalThis.customElements) === null || $9f01206b7394f2b7$var$_a === void 0 || $9f01206b7394f2b7$var$_a.define('ec-legend', $9f01206b7394f2b7$export$daedb98adc4e100e);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $2735371358a27a2d$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $2735371358a27a2d$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $2735371358a27a2d$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $2735371358a27a2d$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer');
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $2735371358a27a2d$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)(saveTooltipAxisInfo, 'cross', false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$2735371358a27a2d$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $2735371358a27a2d$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var triggerEmphasis = axisPointerModel.get('triggerEmphasis');
            var axisKey = $2735371358a27a2d$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category';
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $2735371358a27a2d$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $2735371358a27a2d$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $2735371358a27a2d$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $2735371358a27a2d$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || !coordSys.model // PENDING: radar do not have a model.
         || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(result.coordSysAxesInfo[$2735371358a27a2d$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $2735371358a27a2d$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($2735371358a27a2d$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $2735371358a27a2d$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $2735371358a27a2d$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $2735371358a27a2d$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(linkPropValue) && (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $2735371358a27a2d$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $2735371358a27a2d$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value');
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $2735371358a27a2d$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $2735371358a27a2d$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$2735371358a27a2d$export$d01b444bafb1a792(axisModel)];
}
function $2735371358a27a2d$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $2735371358a27a2d$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $2735371358a27a2d$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $2735371358a27a2d$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}



var $4cde784d925ed2eb$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $4cde784d925ed2eb$var$AxisView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $2735371358a27a2d$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $2735371358a27a2d$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $4cde784d925ed2eb$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $4cde784d925ed2eb$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $3e14d76796640b86$export$2e2bcd8739ae039));
var $4cde784d925ed2eb$export$2e2bcd8739ae039 = $4cde784d925ed2eb$var$AxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $dbb87199a0b668aa$var$inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $dbb87199a0b668aa$var$clone = $99026af6cdabc3e1$export$9cd59f9826255e47;
var $dbb87199a0b668aa$var$bind = $99026af6cdabc3e1$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $dbb87199a0b668aa$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status');
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $055606553475f5d6$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $99026af6cdabc3e1$export$c3095a23b368d1f2($dbb87199a0b668aa$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $dbb87199a0b668aa$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap');
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $2735371358a27a2d$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemenented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $dbb87199a0b668aa$var$inner(group).pointerEl = new $055606553475f5d6$exports[pointerOption.type]($dbb87199a0b668aa$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $dbb87199a0b668aa$var$inner(group).labelEl = new $055606553475f5d6$exports.Text($dbb87199a0b668aa$var$clone(elOption.label));
            group.add(labelEl);
            $dbb87199a0b668aa$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $dbb87199a0b668aa$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $dbb87199a0b668aa$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $dbb87199a0b668aa$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $055606553475f5d6$exports.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function onmousemove(e) {
                    // For mobile device, prevent screen slider on the button.
                    $daa01fa9060de3a2$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $dbb87199a0b668aa$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $dbb87199a0b668aa$var$bind(this._onHandleDragMove, this),
                ondragend: $dbb87199a0b668aa$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $dbb87199a0b668aa$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ]));
        // update position
        var handleSize = handleModel.get('size');
        if (!$99026af6cdabc3e1$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $b4484a22f72674c6$export$958e3e1a02eac4b6(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $dbb87199a0b668aa$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $dbb87199a0b668aa$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($dbb87199a0b668aa$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($dbb87199a0b668aa$var$getHandleTransProps(trans));
        $dbb87199a0b668aa$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value');
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $b4484a22f72674c6$export$42ffd38884aecdac(this, '_doDispatchAxisPointer');
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $dbb87199a0b668aa$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$dbb87199a0b668aa$var$propsEqual($dbb87199a0b668aa$var$inner(el).lastProp, props)) {
        $dbb87199a0b668aa$var$inner(el).lastProp = props;
        moveAnimation ? $055606553475f5d6$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $dbb87199a0b668aa$var$propsEqual(lastProps, newProps) {
    if ($99026af6cdabc3e1$export$a6cdc56e425d0d0a(lastProps) && $99026af6cdabc3e1$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $99026af6cdabc3e1$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $dbb87199a0b668aa$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $dbb87199a0b668aa$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $dbb87199a0b668aa$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $dbb87199a0b668aa$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $dbb87199a0b668aa$export$2e2bcd8739ae039 = $dbb87199a0b668aa$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $6c4fc73e5e49c10c$export$a8a5b03ea14764df(val) {
    var exp10 = Math.pow(10, (0, $bfe945a83b4d28b9$export$97256a17b20a0c24)(Math.abs(val)));
    var f = Math.abs(val / exp10);
    return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function $6c4fc73e5e49c10c$export$dfc8cd28ed7b22a0(scale) {
    return scale.type === 'interval' || scale.type === 'log';
}
function $6c4fc73e5e49c10c$export$eeea879a611eb991(extent, spanWithBreaks, splitNumber, minInterval, maxInterval) {
    var result = {};
    var interval = result.interval = (0, $bfe945a83b4d28b9$export$7a695fe44258210b)(spanWithBreaks / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    // Tow more digital for tick.
    var precision = result.intervalPrecision = $6c4fc73e5e49c10c$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(Math.ceil(extent[0] / interval) * interval, precision),
        (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $6c4fc73e5e49c10c$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $6c4fc73e5e49c10c$export$f39031e8422f329d(interval) {
    var exp10 = Math.pow(10, (0, $bfe945a83b4d28b9$export$97256a17b20a0c24)(interval));
    // Increase interval
    var f = interval / exp10;
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    return (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(f * exp10);
}
function $6c4fc73e5e49c10c$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return (0, $bfe945a83b4d28b9$export$e0c74b50bbd10f68)(interval) + 2;
}
function $6c4fc73e5e49c10c$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
}
function $6c4fc73e5e49c10c$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $6c4fc73e5e49c10c$var$clamp(niceTickExtent, 0, extent);
    $6c4fc73e5e49c10c$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $6c4fc73e5e49c10c$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
var $6c4fc73e5e49c10c$export$94a76197a12818ce = /** @class */ function() {
    function ScaleCalculator() {
        this.normalize = $6c4fc73e5e49c10c$var$normalize;
        this.scale = $6c4fc73e5e49c10c$var$scale;
    }
    ScaleCalculator.prototype.updateMethods = function(brkCtx) {
        if (brkCtx.hasBreaks()) {
            this.normalize = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(brkCtx.normalize, brkCtx);
            this.scale = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(brkCtx.scale, brkCtx);
        } else {
            this.normalize = $6c4fc73e5e49c10c$var$normalize;
            this.scale = $6c4fc73e5e49c10c$var$scale;
        }
    };
    return ScaleCalculator;
}();
function $6c4fc73e5e49c10c$var$normalize(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $6c4fc73e5e49c10c$var$scale(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}
function $6c4fc73e5e49c10c$export$a6588cdf5be114b3(base, extent, noClampNegative) {
    var loggedBase = Math.log(base);
    return [
        // log(negative) is NaN, so safe guard here.
        // PENDING: But even getting a -Infinity still does not make sense in extent.
        //  Just keep it as is, getting a NaN to make some previous cases works by coincidence.
        Math.log(noClampNegative ? extent[0] : Math.max(0, extent[0])) / loggedBase,
        Math.log(noClampNegative ? extent[1] : Math.max(0, extent[1])) / loggedBase
    ];
}




var $6c47bdccce2666c7$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._calculator = new (0, $6c4fc73e5e49c10c$export$94a76197a12818ce)();
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
        var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) {
            this._brkCtx = scaleBreakHelper.createScaleBreakContext();
            this._brkCtx.update(this._extent);
        }
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerUnionExtent = function(other) {
        var extent = this._extent;
        // Considered that number could be NaN and should not write into the extent.
        this._innerSetExtent(other[0] < extent[0] ? other[0] : extent[0], other[1] > extent[1] ? other[1] : extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this._innerUnionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get a new slice of extent.
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    Scale.prototype.setExtent = function(start, end) {
        this._innerSetExtent(start, end);
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerSetExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
        this._brkCtx && this._brkCtx.update(thisExtent);
    };
    /**
   * Prerequisite: Scale#parse is ready.
   */ Scale.prototype.setBreaksFromOption = function(breakOptionList) {
        var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) this._innerSetBreak(scaleBreakHelper.parseAxisBreakOption(breakOptionList, (0, $99026af6cdabc3e1$export$2385a24977818dd0)(this.parse, this)));
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerSetBreak = function(parsed) {
        if (this._brkCtx) {
            this._brkCtx.setBreaks(parsed);
            this._calculator.updateMethods(this._brkCtx);
            this._brkCtx.update(this._extent);
        }
    };
    /**
   * [CAVEAT]: It should not be overridden!
   */ Scale.prototype._innerGetBreaks = function() {
        return this._brkCtx ? this._brkCtx.breaks : [];
    };
    /**
   * Do not expose the internal `_breaks` unless necessary.
   */ Scale.prototype.hasBreaks = function() {
        return this._brkCtx ? this._brkCtx.hasBreaks() : false;
    };
    Scale.prototype._getExtentSpanWithBreaks = function() {
        return this._brkCtx && this._brkCtx.hasBreaks() ? this._brkCtx.getExtentSpan() : this._extent[1] - this._extent[0];
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$cdb9e13510266a6e$export$241315e45585454d($6c47bdccce2666c7$var$Scale);
var $6c47bdccce2666c7$export$2e2bcd8739ae039 = $6c47bdccce2666c7$var$Scale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a02625578f87cc1c$var$uidBase = 0;
var $a02625578f87cc1c$var$OrdinalMeta = /** @class */ function() {
    /**
   * PENDING - Regarding forcibly converting to string:
   *  In the early days, the underlying hash map impl used JS plain object and converted the key to
   *  string; later in https://github.com/ecomfe/zrender/pull/966 it was changed to a JS Map (in supported
   *  platforms), which does not require string keys. But consider any input that `scale/Ordinal['parse']`
   *  is involved, a number input represents an `OrdinalNumber` (i.e., an index), and affect the query
   *  behavior:
   *    - If forcbily converting to string:
   *      pros: users can use numeric string (such as, '123') to query the raw data (123), tho it's probably
   *      still confusing.
   *      cons: NaN/null/undefined in data will be equals to 'NaN'/'null'/'undefined', if simply using
   *      `val + ''` to convert them, like currently `getName` does.
   *    - Otherwise:
   *      pros: see NaN/null/undefined case above.
   *      cons: users cannot query the raw data (123) any more.
   *  There are two inconsistent behaviors in the current impl:
   *    - Force conversion is applied on the case `xAxis{data: ['aaa', 'bbb', ...]}`,
   *      but no conversion applied to the case `xAxis{data: [{value: 'aaa'}, ...]}` and
   *      the case `dataset: {source: [['aaa', 123], ['bbb', 234], ...]}`.
   *    - behaves differently according to whether JS Map is supported (the polyfill is simply using JS
   *      plain object) (tho it seems rare platform that do not support it).
   *  Since there's no sufficient good solution to offset cost of the breaking change, we preserve the
   *  current behavior, until real issues is reported.
   */ function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$a02625578f87cc1c$var$uidBase;
        this._onCollect = opt.onCollect;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(data, $a02625578f87cc1c$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $99026af6cdabc3e1$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            this._onCollect && this._onCollect(category, index);
            return index;
        }
        var map = this._getOrCreateMap();
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                map.set(category, index);
                this._onCollect && this._onCollect(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $a02625578f87cc1c$var$getName(obj) {
    if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $a02625578f87cc1c$export$2e2bcd8739ae039 = $a02625578f87cc1c$var$OrdinalMeta;




var $8c67945ae6efe20a$var$OrdinalScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta');
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $a02625578f87cc1c$export$2e2bcd8739ae039)({});
        if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $a02625578f87cc1c$export$2e2bcd8739ae039)({
            categories: (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) return NaN;
        return (0, $99026af6cdabc3e1$export$844ec244b1367d54)(val) ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(val) {
        return $6c4fc73e5e49c10c$export$8893e2b90ba10d92(val, this._extent) && val >= 0 && val < this._ordinalMeta.categories.length;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(val);
        return this._calculator.normalize(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round(this._calculator.scale(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.calcNiceTicks = function() {};
    OrdinalScale.prototype.calcNiceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $6c47bdccce2666c7$export$2e2bcd8739ae039));
(0, $6c47bdccce2666c7$export$2e2bcd8739ae039).registerClass($8c67945ae6efe20a$var$OrdinalScale);
var $8c67945ae6efe20a$export$2e2bcd8739ae039 = $8c67945ae6efe20a$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $815493036262e234$var$roundNumber = $bfe945a83b4d28b9$export$2077e0241d6afd3c;
var $815493036262e234$var$IntervalScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval';
        // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        // `Scale#parse` (and its overrids) are typically applied at the axis values input
        // in echarts option. e.g., `axis.min/max`, `dataZoom.min/max`, etc.
        // but `series.data` is not included, which uses `dataValueHelper.ts`#`parseDataValue`.
        // `Scale#parse` originally introduced in fb8c813215098b9d2458966229bb95c510883d5e
        // at 2016 for dataZoom start/end settings (See `parseAxisModelMinMax`).
        //
        // Historically `scale/Interval.ts` returns the input value directly. But numeric
        // values (such as a number-like string '123') effectively passed through here and
        // were involved in calculations, which was error-prone and inconsistent with the
        // declared TS return type. Previously such issues are fixed separately in different
        // places case by case (such as #2475).
        //
        // Now, we perform actual parse to ensure its `number` type here. The parsing rule
        // follows the series data parsing rule (`dataValueHelper.ts`#`parseDataValue`)
        // and maintains compatibility as much as possible (thus a more strict parsing
        // `number.ts`#`numericToNumber` is not used here.)
        //
        // FIXME: `ScaleDataValue` also need to be modified to include numeric string type,
        //  since it effectively does.
        return val == null || val === '' ? NaN : Number(val);
    };
    IntervalScale.prototype.contain = function(val) {
        return $6c4fc73e5e49c10c$export$8893e2b90ba10d92(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return this._calculator.normalize(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return this._calculator.scale(val, this._extent);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval;
        // Dropped auto calculated niceExtent and use user-set extent.
        // We assume user wants to set both interval, min, max to get a better result.
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $6c4fc73e5e49c10c$export$86a060b060d3d31a(interval);
    };
    /**
   * @override
   */ IntervalScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        if (opt.breakTicks === 'only_break' && scaleBreakHelper) {
            scaleBreakHelper.addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
            return ticks;
        }
        // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (opt.expandToNicedExtent) ticks.push({
                value: $815493036262e234$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var estimateNiceMultiple = function estimateNiceMultiple(tickVal, targetTick) {
            return Math.round((targetTick - tickVal) / interval);
        };
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = $815493036262e234$var$roundNumber(tick + interval, intervalPrecision);
            if (this._brkCtx) {
                var moreMultiple = this._brkCtx.calcNiceTickMultiple(tick, estimateNiceMultiple);
                if (moreMultiple >= 0) tick = $815493036262e234$var$roundNumber(tick + moreMultiple * interval, intervalPrecision);
            }
            if (ticks.length > 0 && tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (opt.expandToNicedExtent) ticks.push({
                value: $815493036262e234$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        if (scaleBreakHelper) scaleBreakHelper.pruneTicksByBreak(opt.pruneByBreak, ticks, this._brkCtx.breaks, function(item) {
            return item.value;
        }, this._interval, this._extent);
        if (opt.breakTicks !== 'none' && scaleBreakHelper) scaleBreakHelper.addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks({
            expandToNicedExtent: true
        });
        // NOTE: In log-scale, do not support minor ticks when breaks exist.
        //  because currently log-scale minor ticks is calculated based on raw values
        //  rather than log-transformed value, due to an odd effect when breaks exist.
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            if (prevTick["break"] || nextTick["break"]) continue;
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            var minorIntervalPrecision = $6c4fc73e5e49c10c$export$86a060b060d3d31a(minorInterval);
            while(count < splitNumber - 1){
                var minorTick = $815493036262e234$var$roundNumber(prevTick.value + (count + 1) * minorInterval, minorIntervalPrecision);
                // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
            scaleBreakHelper && scaleBreakHelper.pruneTicksByBreak('auto', minorTicksGroup, this._getNonTransBreaks(), function(value) {
                return value;
            }, this._interval, extent);
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    IntervalScale.prototype._getNonTransBreaks = function() {
        return this._brkCtx ? this._brkCtx.breaks : [];
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $bfe945a83b4d28b9$export$e0c74b50bbd10f68(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $815493036262e234$var$roundNumber(data.value, precision, true);
        return $031dcf3d7ed28374$export$b6fe44657ce35c42(dataNum);
    };
    /**
   * FIXME: refactor - disallow override, use composition instead.
   *
   * The override of `calcNiceTicks` should ensure these members are provided:
   *  this._intervalPrecision
   *  this._interval
   *
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.calcNiceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent.slice();
        var span = this._getExtentSpanWithBreaks();
        if (!isFinite(span)) return;
        // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
            this._innerSetExtent(extent[0], extent[1]);
            extent = this._extent.slice();
        }
        var result = $6c4fc73e5e49c10c$export$eeea879a611eb991(extent, span, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent.slice();
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                // Note that extents can be both negative. See #13154
                var expandSize = Math.abs(extent[0]);
                // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0];
        // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this._innerSetExtent(extent[0], extent[1]);
        extent = this._extent.slice();
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        var interval = this._interval;
        var intervalPrecition = this._intervalPrecision;
        if (!opt.fixMin) extent[0] = $815493036262e234$var$roundNumber(Math.floor(extent[0] / interval) * interval, intervalPrecition);
        if (!opt.fixMax) extent[1] = $815493036262e234$var$roundNumber(Math.ceil(extent[1] / interval) * interval, intervalPrecition);
        this._innerSetExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.setNiceExtent = function(min, max) {
        this._niceExtent = [
            min,
            max
        ];
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $6c47bdccce2666c7$export$2e2bcd8739ae039));
(0, $6c47bdccce2666c7$export$2e2bcd8739ae039).registerClass($815493036262e234$var$IntervalScale);
var $815493036262e234$export$2e2bcd8739ae039 = $815493036262e234$var$IntervalScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $b0859ee1450fbeb2$var$inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $b0859ee1450fbeb2$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $b0859ee1450fbeb2$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $b0859ee1450fbeb2$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $628ec8437ba688c7$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$b0859ee1450fbeb2$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
            dimHash += '$';
            dimHash += $b0859ee1450fbeb2$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $b0859ee1450fbeb2$export$fafbc856132a3a0e(schema) {
    return schema instanceof $b0859ee1450fbeb2$export$a1ef064685775f3e;
}
function $b0859ee1450fbeb2$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $b0859ee1450fbeb2$export$be39ae17310c33f7(source) {
    var innerSource = $b0859ee1450fbeb2$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $b0859ee1450fbeb2$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $b0859ee1450fbeb2$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


function $899284ff307f95b1$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($899284ff307f95b1$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
    // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $899284ff307f95b1$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $b0859ee1450fbeb2$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $899284ff307f95b1$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $899284ff307f95b1$export$909db2be4938fbdf(data, targetDim) {
    return $899284ff307f95b1$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/* global Float32Array */ var $e8c33ceefbbbca26$var$supportFloat32Array = typeof Float32Array !== 'undefined';
var $e8c33ceefbbbca26$var$Float32ArrayCtor = !$e8c33ceefbbbca26$var$supportFloat32Array ? Array : Float32Array;
function $e8c33ceefbbbca26$export$21d2298f3f56bbaf(arg) {
    if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(arg)) // Return self directly if don't support TypedArray.
    return $e8c33ceefbbbca26$var$supportFloat32Array ? new Float32Array(arg) : arg;
    // Else is number
    return new $e8c33ceefbbbca26$var$Float32ArrayCtor(arg);
}


var $bbd57e4b726e3f06$var$STACK_PREFIX = '__ec_stack_';
function $bbd57e4b726e3f06$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $bbd57e4b726e3f06$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $bbd57e4b726e3f06$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $bbd57e4b726e3f06$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $bbd57e4b726e3f06$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $bbd57e4b726e3f06$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$bbd57e4b726e3f06$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $bbd57e4b726e3f06$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($bbd57e4b726e3f06$var$isOnCartesian(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $bbd57e4b726e3f06$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
        // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            }
            // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $bbd57e4b726e3f06$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $bbd57e4b726e3f06$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
        // the auto-calculated bar width might be less than 0.5 / 1.
        seriesModel.get('barMinWidth') || ($bbd57e4b726e3f06$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        var defaultBarGap = seriesModel.get('defaultBarGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            defaultBarGap: defaultBarGap,
            axisKey: $bbd57e4b726e3f06$var$getAxisKey(baseAxis),
            stackId: $bbd57e4b726e3f06$var$getSeriesStackId(seriesModel)
        });
    });
    return $bbd57e4b726e3f06$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $bbd57e4b726e3f06$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: seriesInfo.defaultBarGap || 0,
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(stacks).length;
            // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                // `minWidth` has higher priority. `minWidth` decide that whether the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Because barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $bbd57e4b726e3f06$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$bbd57e4b726e3f06$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$bbd57e4b726e3f06$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $bbd57e4b726e3f06$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $bbd57e4b726e3f06$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $bbd57e4b726e3f06$export$20769dafc84e0299(seriesModels);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $bbd57e4b726e3f06$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$bbd57e4b726e3f06$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
    });
}
function $bbd57e4b726e3f06$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $8771d8b8a75043c1$export$2e2bcd8739ae039)(),
        reset: function reset(seriesModel) {
            if (!$bbd57e4b726e3f06$var$isOnCartesian(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get('showBackground', true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            var stacked = (0, $899284ff307f95b1$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $bbd57e4b726e3f06$var$getValueAxisStart(baseAxis, valueAxis);
            var isLarge = $bbd57e4b726e3f06$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout('size');
            var columnOffset = data.getLayout('offset');
            return {
                progress: function progress(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var stackStartValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) stackStartValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    stackStartValue,
                                    baseValue
                                ]);
                                baseCoord = startCoord[0];
                            }
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    baseValue,
                                    stackStartValue
                                ]);
                                baseCoord = startCoord[1];
                            }
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $bbd57e4b726e3f06$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $bbd57e4b726e3f06$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
// See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $bbd57e4b726e3f06$var$getValueAxisStart(baseAxis, valueAxis) {
    var startValue = valueAxis.model.get('startValue');
    if (!startValue) startValue = 0;
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? startValue > 0 ? startValue : 1 : startValue));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








// FIXME 公用？
var $71cc69c614170ba2$var$bisect = function bisect(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $71cc69c614170ba2$var$TimeScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $3655c9ec749458a4$export$d9468344d3651243)(tick.value, (0, $3655c9ec749458a4$export$445bdbd8d2334e40)[(0, $3655c9ec749458a4$export$124c820721c4f66b)((0, $3655c9ec749458a4$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $3655c9ec749458a4$export$445bdbd8d2334e40).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $3655c9ec749458a4$export$fe777b6293828b5d)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   */ TimeScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = this._extent;
        var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        var useUTC = this.getSetting('useUTC');
        if (scaleBreakHelper && opt.breakTicks === 'only_break') {
            (0, $ae704d848942c028$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent);
            return ticks;
        }
        var extent0Unit = (0, $3655c9ec749458a4$export$4dfb0417ad6555b7)(extent[1], useUTC);
        ticks.push({
            value: extent[0],
            time: {
                level: 0,
                upperTimeUnit: extent0Unit,
                lowerTimeUnit: extent0Unit
            }
        });
        var innerTicks = $71cc69c614170ba2$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent, this._getExtentSpanWithBreaks(), this._brkCtx);
        ticks = ticks.concat(innerTicks);
        var extent1Unit = (0, $3655c9ec749458a4$export$4dfb0417ad6555b7)(extent[1], useUTC);
        ticks.push({
            value: extent[1],
            time: {
                level: 0,
                upperTimeUnit: extent1Unit,
                lowerTimeUnit: extent1Unit
            }
        });
        var isUTC = this.getSetting('useUTC');
        var upperUnitIndex = (0, $3655c9ec749458a4$export$87100da04d711986).length - 1;
        var maxLevel = 0;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ticks, function(tick) {
            upperUnitIndex = Math.min(upperUnitIndex, (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)((0, $3655c9ec749458a4$export$87100da04d711986), tick.time.upperTimeUnit));
            maxLevel = Math.max(maxLevel, tick.time.level);
        });
        if (scaleBreakHelper) (0, $ae704d848942c028$export$e79b20ac82c2d660)().pruneTicksByBreak(opt.pruneByBreak, ticks, this._brkCtx.breaks, function(item) {
            return item.value;
        }, this._approxInterval, this._extent);
        if (scaleBreakHelper && opt.breakTicks !== 'none') (0, $ae704d848942c028$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, this._brkCtx.breaks, this._extent, function(trimmedBrk) {
            // @see `parseTimeAxisLabelFormatterDictionary`.
            var lowerBrkUnitIndex = Math.max((0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)((0, $3655c9ec749458a4$export$87100da04d711986), (0, $3655c9ec749458a4$export$4dfb0417ad6555b7)(trimmedBrk.vmin, isUTC)), (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)((0, $3655c9ec749458a4$export$87100da04d711986), (0, $3655c9ec749458a4$export$4dfb0417ad6555b7)(trimmedBrk.vmax, isUTC)));
            var upperBrkUnitIndex = 0;
            for(var unitIdx = 0; unitIdx < (0, $3655c9ec749458a4$export$87100da04d711986).length; unitIdx++)if (!$71cc69c614170ba2$var$isPrimaryUnitValueAndGreaterSame((0, $3655c9ec749458a4$export$87100da04d711986)[unitIdx], trimmedBrk.vmin, trimmedBrk.vmax, isUTC)) {
                upperBrkUnitIndex = unitIdx;
                break;
            }
            var upperIdx = Math.min(upperBrkUnitIndex, upperUnitIndex);
            var lowerIdx = Math.max(upperIdx, lowerBrkUnitIndex);
            return {
                level: maxLevel,
                lowerTimeUnit: (0, $3655c9ec749458a4$export$87100da04d711986)[lowerIdx],
                upperTimeUnit: (0, $3655c9ec749458a4$export$87100da04d711986)[upperIdx]
            };
        });
        return ticks;
    };
    TimeScale.prototype.calcNiceExtent = function(opt) {
        var extent = this.getExtent();
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $3655c9ec749458a4$export$a97a1358cbb650ab);
            extent[1] += (0, $3655c9ec749458a4$export$a97a1358cbb650ab);
        }
        // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $3655c9ec749458a4$export$a97a1358cbb650ab);
        }
        this._innerSetExtent(extent[0], extent[1]);
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.calcNiceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var span = this._getExtentSpanWithBreaks();
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $71cc69c614170ba2$var$scaleIntervals.length;
        var idx = Math.min($71cc69c614170ba2$var$bisect($71cc69c614170ba2$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
        // Interval that can be used to calculate ticks
        this._interval = $71cc69c614170ba2$var$scaleIntervals[idx][1];
        this._intervalPrecision = $6c4fc73e5e49c10c$export$86a060b060d3d31a(this._interval);
        // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $71cc69c614170ba2$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(val) ? val : +$bfe945a83b4d28b9$export$6b862160d295c8e(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $6c4fc73e5e49c10c$export$8893e2b90ba10d92(val, this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return this._calculator.normalize(val, this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return this._calculator.scale(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $815493036262e234$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $71cc69c614170ba2$var$scaleIntervals = [
    // Format                           interval
    [
        'second',
        (0, $3655c9ec749458a4$export$32c0454ceff7f92d)
    ],
    [
        'minute',
        (0, $3655c9ec749458a4$export$35acaebf644db34e)
    ],
    [
        'hour',
        (0, $3655c9ec749458a4$export$82541edf19e5e3b0)
    ],
    [
        'quarter-day',
        (0, $3655c9ec749458a4$export$82541edf19e5e3b0) * 6
    ],
    [
        'half-day',
        (0, $3655c9ec749458a4$export$82541edf19e5e3b0) * 12
    ],
    [
        'day',
        (0, $3655c9ec749458a4$export$a97a1358cbb650ab) * 1.2
    ],
    [
        'half-week',
        (0, $3655c9ec749458a4$export$a97a1358cbb650ab) * 3.5
    ],
    [
        'week',
        (0, $3655c9ec749458a4$export$a97a1358cbb650ab) * 7
    ],
    [
        'month',
        (0, $3655c9ec749458a4$export$a97a1358cbb650ab) * 31
    ],
    [
        'quarter',
        (0, $3655c9ec749458a4$export$a97a1358cbb650ab) * 95
    ],
    [
        'half-year',
        (0, $3655c9ec749458a4$export$99cafda57477293d) / 2
    ],
    [
        'year',
        (0, $3655c9ec749458a4$export$99cafda57477293d)
    ] // 1Y
];
function $71cc69c614170ba2$var$isPrimaryUnitValueAndGreaterSame(unit, valueA, valueB, isUTC) {
    return (0, $3655c9ec749458a4$export$2ed3384313b02c28)(new Date(valueA), unit, isUTC).getTime() === (0, $3655c9ec749458a4$export$2ed3384313b02c28)(new Date(valueB), unit, isUTC).getTime();
}
// function isUnitValueSame(
//     unit: PrimaryTimeUnit,
//     valueA: number,
//     valueB: number,
//     isUTC: boolean
// ): boolean {
//     const dateA = numberUtil.parseDate(valueA) as any;
//     const dateB = numberUtil.parseDate(valueB) as any;
//     const isSame = (unit: PrimaryTimeUnit) => {
//         return getUnitValue(dateA, unit, isUTC)
//             === getUnitValue(dateB, unit, isUTC);
//     };
//     const isSameYear = () => isSame('year');
//     // const isSameHalfYear = () => isSameYear() && isSame('half-year');
//     // const isSameQuater = () => isSameYear() && isSame('quarter');
//     const isSameMonth = () => isSameYear() && isSame('month');
//     const isSameDay = () => isSameMonth() && isSame('day');
//     // const isSameHalfDay = () => isSameDay() && isSame('half-day');
//     const isSameHour = () => isSameDay() && isSame('hour');
//     const isSameMinute = () => isSameHour() && isSame('minute');
//     const isSameSecond = () => isSameMinute() && isSame('second');
//     const isSameMilliSecond = () => isSameSecond() && isSame('millisecond');
//     switch (unit) {
//         case 'year':
//             return isSameYear();
//         case 'month':
//             return isSameMonth();
//         case 'day':
//             return isSameDay();
//         case 'hour':
//             return isSameHour();
//         case 'minute':
//             return isSameMinute();
//         case 'second':
//             return isSameSecond();
//         case 'millisecond':
//             return isSameMilliSecond();
//     }
// }
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $71cc69c614170ba2$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $3655c9ec749458a4$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $71cc69c614170ba2$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $3655c9ec749458a4$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $71cc69c614170ba2$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $3655c9ec749458a4$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $71cc69c614170ba2$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $3655c9ec749458a4$export$35acaebf644db34e) : (0, $3655c9ec749458a4$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $71cc69c614170ba2$var$getMillisecondsInterval(approxInterval) {
    return $bfe945a83b4d28b9$export$7a695fe44258210b(approxInterval, true);
}
// e.g., if the input unit is 'day', start calculate ticks from the first day of
// that month to make ticks "nice".
function $71cc69c614170ba2$var$getFirstTimestampOfUnit(timestamp, unitName, isUTC) {
    var upperUnitIdx = Math.max(0, (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)((0, $3655c9ec749458a4$export$87100da04d711986), unitName) - 1);
    return (0, $3655c9ec749458a4$export$2ed3384313b02c28)(new Date(timestamp), (0, $3655c9ec749458a4$export$87100da04d711986)[upperUnitIdx], isUTC).getTime();
}
function $71cc69c614170ba2$var$createEstimateNiceMultiple(setMethodName, dateMethodInterval) {
    var tmpDate = new Date(0);
    tmpDate[setMethodName](1);
    var tmpTime = tmpDate.getTime();
    tmpDate[setMethodName](1 + dateMethodInterval);
    var approxTimeInterval = tmpDate.getTime() - tmpTime;
    return function(tickVal, targetValue) {
        // Only in month that accurate result can not get by division of
        // timestamp interval, but no need accurate here.
        return Math.max(0, Math.round((targetValue - tickVal) / approxTimeInterval));
    };
}
function $71cc69c614170ba2$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent, extentSpanWithBreaks, brkCtx) {
    var safeLimit = 10000;
    var unitNames = (0, $3655c9ec749458a4$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var estimateNiceMultiple = $71cc69c614170ba2$var$createEstimateNiceMultiple(setMethodName, interval);
        var dateTime = minTimestamp;
        var date = new Date(dateTime);
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            if (iter++ > safeLimit) break;
            date[setMethodName](date[getMethodName]() + interval);
            dateTime = date.getTime();
            if (brkCtx) {
                var moreMultiple = brkCtx.calcNiceTickMultiple(dateTime, estimateNiceMultiple);
                if (moreMultiple > 0) {
                    date[setMethodName](date[getMethodName]() + moreMultiple * interval);
                    dateTime = date.getTime();
                }
            }
        }
        // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($71cc69c614170ba2$var$isPrimaryUnitValueAndGreaterSame((0, $3655c9ec749458a4$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                value: $71cc69c614170ba2$var$getFirstTimestampOfUnit(extent[0], unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $3655c9ec749458a4$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $3655c9ec749458a4$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $3655c9ec749458a4$export$43fbeac90913b151)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $71cc69c614170ba2$var$getMonthInterval(approxInterval);
                    getterName = (0, $3655c9ec749458a4$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $3655c9ec749458a4$export$233f59998ed71c09)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $71cc69c614170ba2$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $3655c9ec749458a4$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $3655c9ec749458a4$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $71cc69c614170ba2$var$getHourInterval(approxInterval);
                    getterName = (0, $3655c9ec749458a4$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $3655c9ec749458a4$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case 'minute':
                    interval = $71cc69c614170ba2$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $3655c9ec749458a4$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $3655c9ec749458a4$export$50303078793fc7d)(isUTC);
                    break;
                case 'second':
                    interval = $71cc69c614170ba2$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $3655c9ec749458a4$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $3655c9ec749458a4$export$a4a908acda9c3118)(isUTC);
                    break;
                case 'millisecond':
                    interval = $71cc69c614170ba2$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $3655c9ec749458a4$export$312207a92d041116)(isUTC);
                    setterName = (0, $3655c9ec749458a4$export$c047afab75f6d84)(isUTC);
                    break;
            }
            // Notice: This expansion by `getFirstTimestampOfUnit` may cause too many ticks and
            // iteration. e.g., when three levels of ticks is displayed, which can be caused by
            // data zoom and axis breaks. Thus trim them here.
            if (endTick >= extent[0] && startTick <= extent[1]) addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length; ++i){
        var primaryTimeUnit = (0, $3655c9ec749458a4$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $3655c9ec749458a4$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $3655c9ec749458a4$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = extentSpanWithBreaks / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $99026af6cdabc3e1$export$3dea766d36a8935f)((0, $99026af6cdabc3e1$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k){
            var unit = (0, $3655c9ec749458a4$export$4dfb0417ad6555b7)(levelTicks[k].value, isUTC);
            ticks.push({
                value: levelTicks[k].value,
                time: {
                    level: maxLevel - i,
                    upperTimeUnit: unit,
                    lowerTimeUnit: unit
                }
            });
        }
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $6c47bdccce2666c7$export$2e2bcd8739ae039).registerClass($71cc69c614170ba2$var$TimeScale);
var $71cc69c614170ba2$export$2e2bcd8739ae039 = $71cc69c614170ba2$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $05965ca668b07143$var$fixRound = $bfe945a83b4d28b9$export$2077e0241d6afd3c;
var $05965ca668b07143$var$mathFloor = Math.floor;
var $05965ca668b07143$var$mathCeil = Math.ceil;
var $05965ca668b07143$var$mathPow = Math.pow;
var $05965ca668b07143$var$mathLog = Math.log;
var $05965ca668b07143$var$LogScale = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $815493036262e234$export$2e2bcd8739ae039)();
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var extent = this._extent.slice();
        var originalExtent = this._originalScale.getExtent();
        var ticks = _super.prototype.getTicks.call(this, opt);
        var base = this.base;
        var originalBreaks = this._originalScale._innerGetBreaks();
        var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        return $99026af6cdabc3e1$export$871de8747c9eaa88(ticks, function(tick) {
            var val = tick.value;
            var roundingCriterion = null;
            var powVal = $05965ca668b07143$var$mathPow(base, val);
            // Fix #4158
            if (val === extent[0] && this._fixMin) roundingCriterion = originalExtent[0];
            else if (val === extent[1] && this._fixMax) roundingCriterion = originalExtent[1];
            var vBreak;
            if (scaleBreakHelper) {
                var transformed = scaleBreakHelper.getTicksLogTransformBreak(tick, base, originalBreaks, $05965ca668b07143$var$fixRoundingError);
                vBreak = transformed.vBreak;
                if (roundingCriterion == null) roundingCriterion = transformed.brkRoundingCriterion;
            }
            if (roundingCriterion != null) powVal = $05965ca668b07143$var$fixRoundingError(powVal, roundingCriterion);
            return {
                value: powVal,
                "break": vBreak
            };
        }, this);
    };
    LogScale.prototype._getNonTransBreaks = function() {
        return this._originalScale._innerGetBreaks();
    };
    LogScale.prototype.setExtent = function(start, end) {
        this._originalScale.setExtent(start, end);
        var loggedExtent = (0, $6c4fc73e5e49c10c$export$a6588cdf5be114b3)(this.base, [
            start,
            end
        ]);
        _super.prototype.setExtent.call(this, loggedExtent[0], loggedExtent[1]);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = _super.prototype.getExtent.call(this);
        extent[0] = $05965ca668b07143$var$mathPow(base, extent[0]);
        extent[1] = $05965ca668b07143$var$mathPow(base, extent[1]);
        // Fix #4158
        var originalExtent = this._originalScale.getExtent();
        this._fixMin && (extent[0] = $05965ca668b07143$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $05965ca668b07143$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        this._originalScale.unionExtentFromData(data, dim);
        var loggedOther = (0, $6c4fc73e5e49c10c$export$a6588cdf5be114b3)(this.base, data.getApproximateExtent(dim), true);
        this._innerUnionExtent(loggedOther);
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.calcNiceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent.slice();
        var span = this._getExtentSpanWithBreaks();
        if (!isFinite(span) || span <= 0) return;
        var interval = $bfe945a83b4d28b9$export$82dd68b83a44b253(span);
        var err = approxTickNum / span * interval;
        // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
        // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $05965ca668b07143$var$fixRound($05965ca668b07143$var$mathCeil(extent[0] / interval) * interval),
            $05965ca668b07143$var$fixRound($05965ca668b07143$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._intervalPrecision = (0, $6c4fc73e5e49c10c$export$86a060b060d3d31a)(interval);
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.calcNiceExtent = function(opt) {
        _super.prototype.calcNiceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.contain = function(val) {
        val = $05965ca668b07143$var$mathLog(val) / $05965ca668b07143$var$mathLog(this.base);
        return _super.prototype.contain.call(this, val);
    };
    LogScale.prototype.normalize = function(val) {
        val = $05965ca668b07143$var$mathLog(val) / $05965ca668b07143$var$mathLog(this.base);
        return _super.prototype.normalize.call(this, val);
    };
    LogScale.prototype.scale = function(val) {
        val = _super.prototype.scale.call(this, val);
        return $05965ca668b07143$var$mathPow(this.base, val);
    };
    LogScale.prototype.setBreaksFromOption = function(breakOptionList) {
        var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        if (!scaleBreakHelper) return;
        var _a = scaleBreakHelper.logarithmicParseBreaksFromOption(breakOptionList, this.base, $99026af6cdabc3e1$export$2385a24977818dd0(this.parse, this)), parsedOriginal = _a.parsedOriginal, parsedLogged = _a.parsedLogged;
        this._originalScale._innerSetBreak(parsedOriginal);
        this._innerSetBreak(parsedLogged);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $815493036262e234$export$2e2bcd8739ae039));
function $05965ca668b07143$var$fixRoundingError(val, originalVal) {
    return $05965ca668b07143$var$fixRound(val, $bfe945a83b4d28b9$export$e0c74b50bbd10f68(originalVal));
}
(0, $6c47bdccce2666c7$export$2e2bcd8739ae039).registerClass($05965ca668b07143$var$LogScale);
var $05965ca668b07143$export$2e2bcd8739ae039 = $05965ca668b07143$var$LogScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $e6f1add4b8a49dd6$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
    originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, // Usually: data extent from all series on this axis.
    dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = scale.type === 'interval' && model.getNeedCrossZero && model.getNeedCrossZero();
        var axisMinValue = model.get('min', true);
        if (axisMinValue == null) axisMinValue = model.get('startValue', true);
        var modelMinRaw = this._modelMinRaw = axisMinValue;
        if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(modelMinRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMinNum = $e6f1add4b8a49dd6$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $e6f1add4b8a49dd6$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(modelMaxRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMaxNum = $e6f1add4b8a49dd6$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $e6f1add4b8a49dd6$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $33d0653e48493c02$export$e8514cb5a5e2b40f)(boundaryGapArr[0], 1),
                (0, $33d0653e48493c02$export$e8514cb5a5e2b40f)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
        // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum;
        // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        var isBlank = (0, $99026af6cdabc3e1$export$7d667b9a0c48c975)(min) || (0, $99026af6cdabc3e1$export$7d667b9a0c48c975)(max) || isOrdinal && !axisDataLen;
        // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0;
            // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0;
        // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        }
        // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$e6f1add4b8a49dd6$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $e6f1add4b8a49dd6$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $e6f1add4b8a49dd6$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $e6f1add4b8a49dd6$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $e6f1add4b8a49dd6$export$5c3dbcbeb9ce7f5a(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $e6f1add4b8a49dd6$export$c35454f678e99c82(scale, model, originalExtent);
    // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $e6f1add4b8a49dd6$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $99026af6cdabc3e1$export$7d667b9a0c48c975)(minMax) ? NaN : scale.parse(minMax);
}





function $e4f40c424e9cabd2$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $e6f1add4b8a49dd6$export$5c3dbcbeb9ce7f5a)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max;
    // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time' /* || scaleType === 'interval' */ ) {
        var barSeriesModels = (0, $bbd57e4b726e3f06$export$efbd0c3f5ab0d5e4)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $99026af6cdabc3e1$export$79b2f7037acddd43(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $bbd57e4b726e3f06$export$20769dafc84e0299)(barSeriesModels);
            // Adjust axis min and max to account for overflow
            var adjustedScale = $e4f40c424e9cabd2$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $e4f40c424e9cabd2$var$adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = Math.abs(axisExtent[1] - axisExtent[0]);
    // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $bbd57e4b726e3f06$export$35920bb6556da1c2)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $99026af6cdabc3e1$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $99026af6cdabc3e1$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow;
    // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $e4f40c424e9cabd2$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $e4f40c424e9cabd2$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $05965ca668b07143$export$2e2bcd8739ae039)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    var interval = model.get('interval');
    var isIntervalOrTime = scaleType === 'interval' || scaleType === 'time';
    scale.setBreaksFromOption($e4f40c424e9cabd2$export$8094779d9b724f85(model));
    scale.setExtent(extent[0], extent[1]);
    scale.calcNiceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: isIntervalOrTime ? model.get('minInterval') : null,
        maxInterval: isIntervalOrTime ? model.get('maxInterval') : null
    });
    // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $e4f40c424e9cabd2$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $8c67945ae6efe20a$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $71cc69c614170ba2$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $6c47bdccce2666c7$export$2e2bcd8739ae039).getClass(axisType) || (0, $815493036262e234$export$2e2bcd8739ae039))();
    }
}
function $e4f40c424e9cabd2$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $e4f40c424e9cabd2$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    if (axis.type === 'time') {
        var parsed_1 = (0, $3655c9ec749458a4$export$f16a827770bdffb5)(labelFormatter);
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, parsed_1);
        };
    } else if ($99026af6cdabc3e1$export$844ec244b1367d54(labelFormatter)) return function(tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = labelFormatter.replace('{value}', label != null ? label : '');
        return text;
    };
    else if ($99026af6cdabc3e1$export$f6e2535fb5126e54(labelFormatter)) {
        if (axis.type === 'category') return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            return labelFormatter($e4f40c424e9cabd2$export$a5a32f324c1fa457(axis, tick), tick.value - axis.scale.getExtent()[0], null // Using `null` just for backward compat.
            );
        };
        var scaleBreakHelper_1 = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
        return function(tick, idx) {
            // Using `null` just for backward compat. It's been found that in the `test/axis-customTicks.html`,
            // there is a formatter `function (value, index, revers = true) { ... }`. Although the third param
            // `revers` is incorrect and always `null`, changing it might introduce a breaking change.
            var extra = null;
            if (scaleBreakHelper_1) extra = scaleBreakHelper_1.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
            return labelFormatter($e4f40c424e9cabd2$export$a5a32f324c1fa457(axis, tick), idx, extra);
        };
    } else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $e4f40c424e9cabd2$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $e4f40c424e9cabd2$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $e4f40c424e9cabd2$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $e4f40c424e9cabd2$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $e4f40c424e9cabd2$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $99026af6cdabc3e1$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $899284ff307f95b1$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $99026af6cdabc3e1$export$ed97f33186d4b816(dataDimMap);
}
function $e4f40c424e9cabd2$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $99026af6cdabc3e1$export$79b2f7037acddd43($e4f40c424e9cabd2$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}
function $e4f40c424e9cabd2$export$c06aa22293dea9d2(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $e4f40c424e9cabd2$export$75b737736393e03c(axisModel) {
    return axisModel.getShallow('show');
}
function $e4f40c424e9cabd2$export$8094779d9b724f85(model) {
    var option = model.get('breaks', true);
    if (option != null) {
        if (!(0, $ae704d848942c028$export$e79b20ac82c2d660)()) return undefined;
        if (!$e4f40c424e9cabd2$var$isSupportAxisBreak(model.axis)) return undefined;
        return option;
    }
}
function $e4f40c424e9cabd2$var$isSupportAxisBreak(axis) {
    // The polar radius axis can also support break feasibly. Do not do it until the requirements are met.
    return (axis.dim === 'x' || axis.dim === 'y' || axis.dim === 'z' || axis.dim === 'single') && axis.type !== 'category';
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $c9e690af6576c75e$var$LABEL_LAYOUT_BASE_PROPS = [
    'label',
    'labelLine',
    'layoutOption',
    'priority',
    'defaultAttr',
    'marginForce',
    'minMarginForce',
    'marginDefault',
    'suggestIgnore'
];
var $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS = 1;
var $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_BIT_OBB = 2;
var $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_ALL = $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS | $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_BIT_OBB;
function $c9e690af6576c75e$export$1551ece3f059eafb(labelGeometry, dirtyOrClear, dirtyBits) {
    dirtyBits = dirtyBits || $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_ALL;
    dirtyOrClear ? labelGeometry.dirty |= dirtyBits : labelGeometry.dirty &= ~dirtyBits;
}
function $c9e690af6576c75e$var$isLabelLayoutDirty(labelGeometry, dirtyBits) {
    dirtyBits = dirtyBits || $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_ALL;
    return labelGeometry.dirty == null || !!(labelGeometry.dirty & dirtyBits);
}
function $c9e690af6576c75e$export$471916f4e89eb5da(labelLayout) {
    if (!labelLayout) return;
    if ($c9e690af6576c75e$var$isLabelLayoutDirty(labelLayout)) $c9e690af6576c75e$export$af9bffc2d00de2cc(labelLayout, labelLayout.label, labelLayout);
    return labelLayout;
}
function $c9e690af6576c75e$export$af9bffc2d00de2cc(out, label, opt) {
    // [CAUTION] These props may be modified directly for performance consideration,
    //  therefore, do not output the internal data structure of zrender Element.
    var rawTransform = label.getComputedTransform();
    out.transform = (0, $055606553475f5d6$export$4d61283a070e0362)(out.transform, rawTransform);
    // NOTE: should call `getBoundingRect` after `getComputedTransform`, or may get an inaccurate bounding rect.
    //  The reason is that `getComputedTransform` calls `__host.updateInnerText()` internally, which updates the label
    //  by `textConfig` mounted on the host.
    // PENDING: add a dirty bit for that in zrender?
    var outLocalRect = out.localRect = (0, $055606553475f5d6$export$38128dfd9a498e1)(out.localRect, label.getBoundingRect());
    var labelStyleExt = label.style;
    var margin = labelStyleExt.margin;
    var marginForce = opt && opt.marginForce;
    var minMarginForce = opt && opt.minMarginForce;
    var marginDefault = opt && opt.marginDefault;
    var marginType = labelStyleExt.__marginType;
    if (marginType == null && marginDefault) {
        margin = marginDefault;
        marginType = (0, $a4fed78c55651c93$export$2b18df2bc75ae422).textMargin;
    }
    // `textMargin` and `minMargin` can not exist both.
    for(var i = 0; i < 4; i++)$c9e690af6576c75e$var$_tmpLabelMargin[i] = marginType === (0, $a4fed78c55651c93$export$2b18df2bc75ae422).minMargin && minMarginForce && minMarginForce[i] != null ? minMarginForce[i] : marginForce && marginForce[i] != null ? marginForce[i] : margin ? margin[i] : 0;
    if (marginType === (0, $a4fed78c55651c93$export$2b18df2bc75ae422).textMargin) (0, $055606553475f5d6$export$81ed941fdeb91c7c)(outLocalRect, $c9e690af6576c75e$var$_tmpLabelMargin, false, false);
    var outGlobalRect = out.rect = (0, $055606553475f5d6$export$38128dfd9a498e1)(out.rect, outLocalRect);
    if (rawTransform) outGlobalRect.applyTransform(rawTransform);
    // Notice: label.style.margin is actually `minMargin / 2`, handled by `setTextStyleCommon`.
    if (marginType === (0, $a4fed78c55651c93$export$2b18df2bc75ae422).minMargin) (0, $055606553475f5d6$export$81ed941fdeb91c7c)(outGlobalRect, $c9e690af6576c75e$var$_tmpLabelMargin, false, false);
    out.axisAligned = (0, $055606553475f5d6$export$576610ccf2234b72)(rawTransform);
    (out.label = out.label || {}).ignore = label.ignore;
    $c9e690af6576c75e$export$1551ece3f059eafb(out, false);
    $c9e690af6576c75e$export$1551ece3f059eafb(out, true, $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    // Do not remove `obb` (if existing) for reuse, just reset the dirty bit.
    return out;
}
var $c9e690af6576c75e$var$_tmpLabelMargin = [
    0,
    0,
    0,
    0
];
function $c9e690af6576c75e$export$bc37ae3f8412d105(out, rawLocalRect, rawTransform) {
    out.transform = (0, $055606553475f5d6$export$4d61283a070e0362)(out.transform, rawTransform);
    out.localRect = (0, $055606553475f5d6$export$38128dfd9a498e1)(out.localRect, rawLocalRect);
    out.rect = (0, $055606553475f5d6$export$38128dfd9a498e1)(out.rect, rawLocalRect);
    if (rawTransform) out.rect.applyTransform(rawTransform);
    out.axisAligned = (0, $055606553475f5d6$export$576610ccf2234b72)(rawTransform);
    out.obb = undefined; // Reset to undefined, will be created by `ensureOBB` when using.
    (out.label = out.label || {}).ignore = false;
    return out;
}
function $c9e690af6576c75e$export$91f733c27ab0712f(labelLayout, offset) {
    if (!labelLayout) return;
    labelLayout.label.x += offset.x;
    labelLayout.label.y += offset.y;
    labelLayout.label.markRedraw();
    var transform = labelLayout.transform;
    if (transform) {
        transform[4] += offset.x;
        transform[5] += offset.y;
    }
    var globalRect = labelLayout.rect;
    if (globalRect) {
        globalRect.x += offset.x;
        globalRect.y += offset.y;
    }
    var obb = labelLayout.obb;
    if (obb) obb.fromBoundingRect(labelLayout.localRect, transform);
}
function $c9e690af6576c75e$export$a1cfd37e9b88106b(newBaseWithDefaults, source) {
    for(var i = 0; i < $c9e690af6576c75e$var$LABEL_LAYOUT_BASE_PROPS.length; i++){
        var prop = $c9e690af6576c75e$var$LABEL_LAYOUT_BASE_PROPS[i];
        if (newBaseWithDefaults[prop] == null) newBaseWithDefaults[prop] = source[prop];
    }
    return $c9e690af6576c75e$export$471916f4e89eb5da(newBaseWithDefaults);
}
/**
 * Create obb if no one, can cache it.
 */ function $c9e690af6576c75e$var$ensureOBB(labelGeometry) {
    var obb = labelGeometry.obb;
    if (!obb || $c9e690af6576c75e$var$isLabelLayoutDirty(labelGeometry, $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_BIT_OBB)) {
        labelGeometry.obb = obb = obb || new (0, $823478c5f508ba48$export$2e2bcd8739ae039)();
        obb.fromBoundingRect(labelGeometry.localRect, labelGeometry.transform);
        $c9e690af6576c75e$export$1551ece3f059eafb(labelGeometry, false, $c9e690af6576c75e$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    }
    return obb;
}
function $c9e690af6576c75e$export$73ee08bc808f6f3f(list, xyDimIdx, // 0 for x, 1 for y
minBound, // for x, leftBound; for y, topBound
maxBound, // for x, rightBound; for y, bottomBound
// If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    var len = list.length;
    var xyDim = (0, $055606553475f5d6$export$cb4c12294149dd2d)[xyDimIdx];
    var sizeDim = (0, $055606553475f5d6$export$a3fe6d967173a3ac)[xyDimIdx];
    if (len < 2) return false;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    // const shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        // shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $c9e690af6576c75e$export$ff775ae4fbb23435(labelList) {
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var defaultAttr = labelItem.defaultAttr;
        var labelLine = labelItem.labelLine;
        labelItem.label.attr('ignore', defaultAttr.ignore);
        labelLine && labelLine.attr('ignore', defaultAttr.labelGuideIgnore);
    }
}
function $c9e690af6576c75e$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return (b.suggestIgnore ? 1 : 0) - (a.suggestIgnore ? 1 : 0) || b.priority - a.priority;
    });
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = $c9e690af6576c75e$export$471916f4e89eb5da(labelList[i]);
        // The current `el.ignore` is involved, since some previous overlap
        // resolving strategies may have set `el.ignore` to true.
        if (labelItem.label.ignore) continue;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        // NOTICE: even when the with/height of globalRect of a label is 0, the label line should
        // still be displayed, since we should follow the concept of "truncation", meaning that
        // something exists even if it cannot be fully displayed. A visible label line is necessary
        // to allow users to get a tooltip with label info on hover.
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++)if ($c9e690af6576c75e$export$f28bfabef115ba96(labelItem, displayedLabels[j], null, {
            touchThreshold: 0.05
        })) {
            overlapped = true;
            break;
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else displayedLabels.push(labelItem);
    }
}
function $c9e690af6576c75e$export$f28bfabef115ba96(baseLayoutInfo, targetLayoutInfo, mtv, intersectOpt) {
    if (!baseLayoutInfo || !targetLayoutInfo) return false;
    if (baseLayoutInfo.label && baseLayoutInfo.label.ignore || targetLayoutInfo.label && targetLayoutInfo.label.ignore) return false;
    // Fast rejection.
    if (!baseLayoutInfo.rect.intersect(targetLayoutInfo.rect, mtv, intersectOpt)) return false;
    if (baseLayoutInfo.axisAligned && targetLayoutInfo.axisAligned) return true; // obb is the same as the normal bounding rect.
    return $c9e690af6576c75e$var$ensureOBB(baseLayoutInfo).intersect($c9e690af6576c75e$var$ensureOBB(targetLayoutInfo), mtv, intersectOpt);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2d7c12def48f6bbb$var$_impl = null;
function $2d7c12def48f6bbb$export$f5ec8c7ef7a59f4c(impl) {
    if (!$2d7c12def48f6bbb$var$_impl) $2d7c12def48f6bbb$var$_impl = impl;
}
function $2d7c12def48f6bbb$export$c1d9b2cc33e7e5e() {
    return $2d7c12def48f6bbb$var$_impl;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8c57afbd7818ddb3$export$12319e2083cd71ce = 'expandAxisBreak';
var $8c57afbd7818ddb3$export$8ba710d11f5d9b28 = 'collapseAxisBreak';
var $8c57afbd7818ddb3$export$cfaa507333440c5e = 'toggleAxisBreak';
var $8c57afbd7818ddb3$var$AXIS_BREAK_CHANGED_EVENT_TYPE = 'axisbreakchanged';
var $8c57afbd7818ddb3$var$expandAxisBreakActionInfo = {
    type: $8c57afbd7818ddb3$export$12319e2083cd71ce,
    event: $8c57afbd7818ddb3$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $8c57afbd7818ddb3$var$refineAxisBreakChangeEvent
};
var $8c57afbd7818ddb3$var$collapseAxisBreakActionInfo = {
    type: $8c57afbd7818ddb3$export$8ba710d11f5d9b28,
    event: $8c57afbd7818ddb3$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $8c57afbd7818ddb3$var$refineAxisBreakChangeEvent
};
var $8c57afbd7818ddb3$var$toggleAxisBreakActionInfo = {
    type: $8c57afbd7818ddb3$export$cfaa507333440c5e,
    event: $8c57afbd7818ddb3$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $8c57afbd7818ddb3$var$refineAxisBreakChangeEvent
};
function $8c57afbd7818ddb3$var$refineAxisBreakChangeEvent(actionResultBatch, payload, ecModel, api) {
    var breaks = [];
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(actionResultBatch, function(actionResult) {
        breaks = breaks.concat(actionResult.eventBreaks);
    });
    return {
        eventContent: {
            breaks: breaks
        }
    };
}
function $8c57afbd7818ddb3$export$408c24786cd729c6(registers) {
    registers.registerAction($8c57afbd7818ddb3$var$expandAxisBreakActionInfo, actionHandler);
    registers.registerAction($8c57afbd7818ddb3$var$collapseAxisBreakActionInfo, actionHandler);
    registers.registerAction($8c57afbd7818ddb3$var$toggleAxisBreakActionInfo, actionHandler);
    function actionHandler(payload, ecModel) {
        var eventBreaks = [];
        var finderResult = (0, $08bfa015475effa8$export$95de80076abac814)(ecModel, payload);
        function dealUpdate(modelProp, indexProp) {
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(finderResult[modelProp], function(axisModel) {
                var result = axisModel.updateAxisBreaks(payload);
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(result.breaks, function(item) {
                    var _a;
                    eventBreaks.push((0, $99026af6cdabc3e1$export$ebe90cb607ad99e)((_a = {}, _a[indexProp] = axisModel.componentIndex, _a), item));
                });
            });
        }
        dealUpdate('xAxisModels', 'xAxisIndex');
        dealUpdate('yAxisModels', 'yAxisIndex');
        dealUpdate('singleAxisModels', 'singleAxisIndex');
        return {
            eventBreaks: eventBreaks
        };
    }
}






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $d2408e89e8509289$var$modelInner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $d2408e89e8509289$var$axisInner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $d2408e89e8509289$export$31cba7db0a663292 = {
    estimate: 1,
    determine: 2
};
function $d2408e89e8509289$export$12d6ac38274c43e7(kind) {
    return {
        out: {
            noPxChangeTryDetermine: []
        },
        kind: kind
    };
}
function $d2408e89e8509289$var$tickValuesToNumbers(axis, values) {
    var nums = $99026af6cdabc3e1$export$871de8747c9eaa88(values, function(val) {
        return axis.scale.parse(val);
    });
    if (axis.type === 'time' && nums.length > 0) {
        // Time axis needs duplicate first/last tick (see TimeScale.getTicks())
        // The first and last tick/label don't get drawn
        nums.sort();
        nums.unshift(nums[0]);
        nums.push(nums[nums.length - 1]);
    }
    return nums;
}
function $d2408e89e8509289$export$10216ebd3e3e485e(axis, ctx) {
    var custom = axis.getLabelModel().get('customValues');
    if (custom) {
        var labelFormatter_1 = (0, $e4f40c424e9cabd2$export$742f19a75415b2ae)(axis);
        var extent_1 = axis.scale.getExtent();
        var tickNumbers = $d2408e89e8509289$var$tickValuesToNumbers(axis, custom);
        var ticks = $99026af6cdabc3e1$export$3dea766d36a8935f(tickNumbers, function(val) {
            return val >= extent_1[0] && val <= extent_1[1];
        });
        return {
            labels: $99026af6cdabc3e1$export$871de8747c9eaa88(ticks, function(numval) {
                var tick = {
                    value: numval
                };
                return {
                    formattedLabel: labelFormatter_1(tick),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: numval,
                    time: undefined,
                    "break": undefined
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $d2408e89e8509289$var$makeCategoryLabels(axis, ctx) : $d2408e89e8509289$var$makeRealNumberLabels(axis);
}
function $d2408e89e8509289$export$7cccf6836ae8323c(axis, tickModel, opt) {
    var custom = axis.getTickModel().get('customValues');
    if (custom) {
        var extent_2 = axis.scale.getExtent();
        var tickNumbers = $d2408e89e8509289$var$tickValuesToNumbers(axis, custom);
        return {
            ticks: $99026af6cdabc3e1$export$3dea766d36a8935f(tickNumbers, function(val) {
                return val >= extent_2[0] && val <= extent_2[1];
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $d2408e89e8509289$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $99026af6cdabc3e1$export$871de8747c9eaa88(axis.scale.getTicks(opt), function(tick) {
            return tick.value;
        })
    };
}
function $d2408e89e8509289$var$makeCategoryLabels(axis, ctx) {
    var labelModel = axis.getLabelModel();
    var result = $d2408e89e8509289$var$makeCategoryLabelsActually(axis, labelModel, ctx);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: []
    } : result;
}
function $d2408e89e8509289$var$makeCategoryLabelsActually(axis, labelModel, ctx) {
    var labelsCache = $d2408e89e8509289$var$ensureCategoryLabelCache(axis);
    var optionLabelInterval = (0, $e4f40c424e9cabd2$export$6d0bc2429155c088)(labelModel);
    var isEstimate = ctx.kind === $d2408e89e8509289$export$31cba7db0a663292.estimate;
    // In AxisTickLabelComputingKind.estimate, the result likely varies during a single
    // pass of ec main process,due to the change of axisExtent, and will not be shared with
    // splitLine. Therefore no cache is used.
    if (!isEstimate) {
        // PENDING: check necessary?
        var result_1 = $d2408e89e8509289$var$axisCacheGet(labelsCache, optionLabelInterval);
        if (result_1) return result_1;
    }
    var labels;
    var numericLabelInterval;
    if ($99026af6cdabc3e1$export$f6e2535fb5126e54(optionLabelInterval)) labels = $d2408e89e8509289$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $d2408e89e8509289$var$makeAutoCategoryInterval(axis, ctx) : optionLabelInterval;
        labels = $d2408e89e8509289$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    }
    var result = {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    };
    if (!isEstimate) $d2408e89e8509289$var$axisCacheSet(labelsCache, optionLabelInterval, result);
    else ctx.out.noPxChangeTryDetermine.push(function() {
        $d2408e89e8509289$var$axisCacheSet(labelsCache, optionLabelInterval, result);
        return true;
    });
    return result;
}
function $d2408e89e8509289$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $d2408e89e8509289$var$ensureCategoryTickCache(axis);
    var optionTickInterval = (0, $e4f40c424e9cabd2$export$6d0bc2429155c088)(tickModel);
    var result = $d2408e89e8509289$var$axisCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($99026af6cdabc3e1$export$f6e2535fb5126e54(optionTickInterval)) ticks = $d2408e89e8509289$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $d2408e89e8509289$var$makeCategoryLabelsActually(axis, axis.getLabelModel(), $d2408e89e8509289$export$12d6ac38274c43e7($d2408e89e8509289$export$31cba7db0a663292.determine));
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $99026af6cdabc3e1$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $d2408e89e8509289$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $d2408e89e8509289$var$axisCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $d2408e89e8509289$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $e4f40c424e9cabd2$export$742f19a75415b2ae)(axis);
    return {
        labels: $99026af6cdabc3e1$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value,
                time: tick.time,
                "break": tick["break"]
            };
        })
    };
}
// Large category data calculation is performance sensitive, and ticks and label probably will
// be fetched multiple times (e.g. shared by splitLine and axisTick). So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
var $d2408e89e8509289$var$ensureCategoryTickCache = $d2408e89e8509289$var$initAxisCacheMethod('axisTick');
var $d2408e89e8509289$var$ensureCategoryLabelCache = $d2408e89e8509289$var$initAxisCacheMethod('axisLabel');
/**
 * PENDING: refactor to JS Map? Because key can be a function or more complicated object, and
 * cache size always is small, and currently no JS Map object key polyfill, we use a simple
 * array cache instead of plain object hash.
 */ function $d2408e89e8509289$var$initAxisCacheMethod(prop) {
    return function ensureCache(axis) {
        return $d2408e89e8509289$var$axisInner(axis)[prop] || ($d2408e89e8509289$var$axisInner(axis)[prop] = {
            list: []
        });
    };
}
function $d2408e89e8509289$var$axisCacheGet(cache, key) {
    for(var i = 0; i < cache.list.length; i++){
        if (cache.list[i].key === key) return cache.list[i].value;
    }
}
function $d2408e89e8509289$var$axisCacheSet(cache, key, value) {
    cache.list.push({
        key: key,
        value: value
    });
    return value;
}
function $d2408e89e8509289$var$makeAutoCategoryInterval(axis, ctx) {
    if (ctx.kind === $d2408e89e8509289$export$31cba7db0a663292.estimate) {
        // Currently axisTick is not involved in estimate kind, and the result likely varies during a
        // single pass of ec main process, due to the change of axisExtent. Therefore no cache is used.
        var result_2 = axis.calculateCategoryInterval(ctx);
        ctx.out.noPxChangeTryDetermine.push(function() {
            $d2408e89e8509289$var$axisInner(axis).autoInterval = result_2;
            return true;
        });
        return result_2;
    }
    // Both tick and label uses this result, cacah it to avoid recompute.
    var result = $d2408e89e8509289$var$axisInner(axis).autoInterval;
    return result != null ? result : $d2408e89e8509289$var$axisInner(axis).autoInterval = axis.calculateCategoryInterval(ctx);
}
function $d2408e89e8509289$export$9ea1d3f146a5a65f(axis, ctx) {
    var kind = ctx.kind;
    var params = $d2408e89e8509289$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $e4f40c424e9cabd2$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Arbitrary value.
    var maxCount = 40;
    if (tickCount > maxCount) step = Math.max(1, Math.floor(tickCount / maxCount));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $33d0653e48493c02$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top');
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    if (kind === $d2408e89e8509289$export$31cba7db0a663292.estimate) {
        // In estimate kind, the inteval likely varies, thus do not erase the cache.
        ctx.out.noPxChangeTryDetermine.push($99026af6cdabc3e1$export$2385a24977818dd0($d2408e89e8509289$var$calculateCategoryIntervalTryDetermine, null, axis, interval, tickCount));
        return interval;
    }
    var lastInterval = $d2408e89e8509289$var$calculateCategoryIntervalDealCache(axis, interval, tickCount);
    return lastInterval != null ? lastInterval : interval;
}
function $d2408e89e8509289$var$calculateCategoryIntervalTryDetermine(axis, interval, tickCount) {
    return $d2408e89e8509289$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) == null;
}
// Return the lastInterval if need to use it, otherwise return NullUndefined and save cache.
function $d2408e89e8509289$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) {
    var cache = $d2408e89e8509289$var$modelInner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) return lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
}
function $d2408e89e8509289$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $d2408e89e8509289$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $e4f40c424e9cabd2$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = [];
    // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count();
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $e4f40c424e9cabd2$export$c2911c025243d6a6)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
    // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue,
            time: undefined,
            "break": undefined
        });
    }
    return result;
}
function $d2408e89e8509289$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $e4f40c424e9cabd2$export$742f19a75415b2ae)(axis);
    var result = [];
    $99026af6cdabc3e1$export$79b2f7037acddd43(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue,
            time: undefined,
            "break": undefined
        });
    });
    return result;
}


var $71fd40fa855e325e$var$PI = Math.PI;
var $71fd40fa855e325e$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS = [
    [
        1,
        2,
        1,
        2
    ],
    [
        5,
        3,
        5,
        3
    ],
    [
        8,
        3,
        8,
        3
    ]
];
var $71fd40fa855e325e$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS = [
    [
        0,
        1,
        0,
        1
    ],
    [
        0,
        3,
        0,
        3
    ],
    [
        0,
        3,
        0,
        3
    ]
];
var $71fd40fa855e325e$export$c392b818a26a879e = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $71fd40fa855e325e$var$getTickInner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
/**
 * A context shared by difference axisBuilder instances.
 * For cross-axes overlap resolving.
 *
 * Lifecycle constraint: should not over a pass of ec main process.
 *  If model is changed, the context must be disposed.
 *
 * @see AxisBuilderLocalContext
 */ var $71fd40fa855e325e$export$f2e237206f7393f5 = /** @class */ function() {
    function AxisBuilderSharedContext(resolveAxisNameOverlap) {
        /**
     * [CAUTION] Do not modify this data structure outside this class.
     */ this.recordMap = {};
        this.resolveAxisNameOverlap = resolveAxisNameOverlap;
    }
    AxisBuilderSharedContext.prototype.ensureRecord = function(axisModel) {
        var dim = axisModel.axis.dim;
        var idx = axisModel.componentIndex;
        var recordMap = this.recordMap;
        var records = recordMap[dim] || (recordMap[dim] = []);
        return records[idx] || (records[idx] = {
            ready: {}
        });
    };
    return AxisBuilderSharedContext;
}();
/**
 * [CAUTION]
 *  1. The call of this function must be after axisLabel overlap handlings
 *     (such as `hideOverlap`, `fixMinMaxLabelShow`) and after transform calculating.
 *  2. Can be called multiple times and should be idempotent.
 */ function $71fd40fa855e325e$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList) {
    var axis = axisModel.axis;
    var record = shared.ensureRecord(axisModel);
    var labelInfoList = [];
    var stOccupiedRect;
    var useStOccupiedRect = $71fd40fa855e325e$var$hasAxisName(cfg.axisName) && (0, $e4f40c424e9cabd2$export$c06aa22293dea9d2)(cfg.nameLocation);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(labelLayoutList, function(layout) {
        var layoutInfo = (0, $c9e690af6576c75e$export$471916f4e89eb5da)(layout);
        if (!layoutInfo || layoutInfo.label.ignore) return;
        labelInfoList.push(layoutInfo);
        var transGroup = record.transGroup;
        if (useStOccupiedRect) {
            // Transform to "standard axis" for creating stOccupiedRect (the label rects union).
            transGroup.transform ? $e84a7b06db3848b3$export$6897c284b6f9f4dc($71fd40fa855e325e$var$_stTransTmp, transGroup.transform) : $e84a7b06db3848b3$export$f0954fd7d5368655($71fd40fa855e325e$var$_stTransTmp);
            if (layoutInfo.transform) $e84a7b06db3848b3$export$6e3a27864ab166fe($71fd40fa855e325e$var$_stTransTmp, $71fd40fa855e325e$var$_stTransTmp, layoutInfo.transform);
            (0, $faa61116fee85ae6$export$2e2bcd8739ae039).copy($71fd40fa855e325e$var$_stLabelRectTmp, layoutInfo.localRect);
            $71fd40fa855e325e$var$_stLabelRectTmp.applyTransform($71fd40fa855e325e$var$_stTransTmp);
            stOccupiedRect ? stOccupiedRect.union($71fd40fa855e325e$var$_stLabelRectTmp) : (0, $faa61116fee85ae6$export$2e2bcd8739ae039).copy(stOccupiedRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0), $71fd40fa855e325e$var$_stLabelRectTmp);
        }
    });
    var sortByDim = Math.abs(record.dirVec.x) > 0.1 ? 'x' : 'y';
    var sortByValue = record.transGroup[sortByDim];
    labelInfoList.sort(function(info1, info2) {
        return Math.abs(info1.label[sortByDim] - sortByValue) - Math.abs(info2.label[sortByDim] - sortByValue);
    });
    if (useStOccupiedRect && stOccupiedRect) {
        var extent = axis.getExtent();
        var axisLineX = Math.min(extent[0], extent[1]);
        var axisLineWidth = Math.max(extent[0], extent[1]) - axisLineX;
        // If `nameLocation` is 'middle', enlarge axis labels boundingRect to axisLine to avoid bad
        //  case like that axis name is placed in the gap between axis labels and axis line.
        // If only one label exists, the entire band should be occupied for
        // visual consistency, so extent it to [0, canvas width].
        stOccupiedRect.union(new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(axisLineX, 0, axisLineWidth, 1));
    }
    record.stOccupiedRect = stOccupiedRect;
    record.labelInfoList = labelInfoList;
}
var $71fd40fa855e325e$var$_stTransTmp = $e84a7b06db3848b3$export$185802fd694ee1f5();
var $71fd40fa855e325e$var$_stLabelRectTmp = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $71fd40fa855e325e$export$7fcb8742f5816cae = function resolveAxisNameOverlapDefault(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    if ((0, $e4f40c424e9cabd2$export$c06aa22293dea9d2)(cfg.nameLocation)) {
        var stOccupiedRect = thisRecord.stOccupiedRect;
        if (stOccupiedRect) $71fd40fa855e325e$var$moveIfOverlap((0, $c9e690af6576c75e$export$bc37ae3f8412d105)({}, stOccupiedRect, thisRecord.transGroup.transform), nameLayoutInfo, nameMoveDirVec);
    } else $71fd40fa855e325e$export$e033c6449cc6f6a1(thisRecord.labelInfoList, thisRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
};
// [NOTICE] not consider ignore.
function $71fd40fa855e325e$var$moveIfOverlap(basedLayoutInfo, movableLayoutInfo, moveDirVec) {
    var mtv = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
    if ((0, $c9e690af6576c75e$export$f28bfabef115ba96)(basedLayoutInfo, movableLayoutInfo, mtv, {
        direction: Math.atan2(moveDirVec.y, moveDirVec.x),
        bidirectional: false,
        touchThreshold: 0.05
    })) (0, $c9e690af6576c75e$export$91f733c27ab0712f)(movableLayoutInfo, mtv);
}
function $71fd40fa855e325e$export$e033c6449cc6f6a1(baseLayoutInfoList, baseDirVec, movableLayoutInfo, moveDirVec) {
    // Detect and move from far to close.
    var sameDir = (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).dot(moveDirVec, baseDirVec) >= 0;
    for(var idx = 0, len = baseLayoutInfoList.length; idx < len; idx++){
        var labelInfo = baseLayoutInfoList[sameDir ? idx : len - 1 - idx];
        if (!labelInfo.label.ignore) $71fd40fa855e325e$var$moveIfOverlap(labelInfo, movableLayoutInfo, moveDirVec);
    }
}
/**
 * @caution
 * - Ensure it is called after the data processing stage finished.
 * - It might be called before `CahrtView#render`, sush as called at `CoordinateSystem#update`,
 *  thus ensure the result the same whenever it is called.
 *
 * A builder for a straight-line axis.
 *
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A "standard axis" is the axis [0,0]-->[abs(axisExtent[1]-axisExtent[0]),0]
 * for example: [0,0]-->[50,0]
 */ var $71fd40fa855e325e$var$AxisBuilder = /** @class */ function() {
    /**
   * [CAUTION]: axisModel.axis.extent/scale must be ready to use.
   */ function AxisBuilder(axisModel, api, opt, shared) {
        this.group = new $2b89655bc310a947$export$2e2bcd8739ae039();
        this._axisModel = axisModel;
        this._api = api;
        this._local = {};
        this._shared = shared || new $71fd40fa855e325e$export$f2e237206f7393f5($71fd40fa855e325e$export$7fcb8742f5816cae);
        this._resetCfgDetermined(opt);
    }
    /**
   * Regarding axis label related configurations, only the change of label.x/y is supported; other
   * changes are not necessary and not performant. To be specific, only `axis.position`
   * (and consequently `labelOffset`) and `axis.extent` can be changed, and assume everything in
   * `axisModel` are not changed.
   * Axis line related configurations can be changed since this method can only be called
   * before they are created.
   */ AxisBuilder.prototype.updateCfg = function(opt) {
        var ready;
        var raw = this._cfg.raw;
        raw.position = opt.position;
        raw.labelOffset = opt.labelOffset;
        this._resetCfgDetermined(raw);
    };
    /**
   * [CAUTION] For debug usage. Never change it outside!
   */ AxisBuilder.prototype.__getRawCfg = function() {
        return this._cfg.raw;
    };
    AxisBuilder.prototype._resetCfgDetermined = function(raw) {
        var axisModel = this._axisModel;
        // FIXME:
        //  Currently there is no uniformed way to set default values if an option
        //  is specified null/undefined by user (intentionally or unintentionally),
        //  e.g. null/undefined is not a illegal value for `nameLocation`.
        //  Try to use `getDefaultOption` to address it. But radar has no `getDefaultOption`.
        var axisModelDefaultOption = axisModel.getDefaultOption ? axisModel.getDefaultOption() : {};
        // Default value
        var axisName = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(raw.axisName, axisModel.get('name'));
        var nameMoveOverlapOption = axisModel.get('nameMoveOverlap');
        if (nameMoveOverlapOption == null || nameMoveOverlapOption === 'auto') nameMoveOverlapOption = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(raw.defaultNameMoveOverlap, true);
        var cfg = {
            raw: raw,
            position: raw.position,
            rotation: raw.rotation,
            nameDirection: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(raw.nameDirection, 1),
            tickDirection: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(raw.tickDirection, 1),
            labelDirection: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(raw.labelDirection, 1),
            labelOffset: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(raw.labelOffset, 0),
            silent: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(raw.silent, true),
            axisName: axisName,
            nameLocation: (0, $99026af6cdabc3e1$export$2e94551289abb95b)(axisModel.get('nameLocation'), axisModelDefaultOption.nameLocation, 'end'),
            shouldNameMoveOverlap: $71fd40fa855e325e$var$hasAxisName(axisName) && nameMoveOverlapOption,
            optionHideOverlap: axisModel.get([
                'axisLabel',
                'hideOverlap'
            ]),
            showMinorTicks: axisModel.get([
                'minorTick',
                'show'
            ])
        };
        this._cfg = cfg;
        // FIXME Not use a separate text group?
        var transformGroup = new $2b89655bc310a947$export$2e2bcd8739ae039({
            x: cfg.position[0],
            y: cfg.position[1],
            rotation: cfg.rotation
        });
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
        var record = this._shared.ensureRecord(axisModel);
        record.transGroup = this._transformGroup;
        record.dirVec = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(Math.cos(-cfg.rotation), Math.sin(-cfg.rotation));
    };
    AxisBuilder.prototype.build = function(axisPartNameMap, extraParams) {
        var _this = this;
        if (!axisPartNameMap) axisPartNameMap = {
            axisLine: true,
            axisTickLabelEstimate: false,
            axisTickLabelDetermine: true,
            axisName: true
        };
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)($71fd40fa855e325e$var$AXIS_BUILDER_AXIS_PART_NAMES, function(partName) {
            if (axisPartNameMap[partName]) $71fd40fa855e325e$var$builders[partName](_this._cfg, _this._local, _this._shared, _this._axisModel, _this.group, _this._transformGroup, _this._api, extraParams || {});
        });
        return this;
    };
    /**
   * Currently only get text align/verticalAlign by rotation.
   * NO `position` is involved, otherwise it have to be performed for each `updateAxisLabelChangableProps`.
   */ AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $bfe945a83b4d28b9$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $bfe945a83b4d28b9$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $bfe945a83b4d28b9$export$d1df570aea2868f)(rotationDiff - $71fd40fa855e325e$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $71fd40fa855e325e$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
// Sorted by dependency order.
var $71fd40fa855e325e$var$AXIS_BUILDER_AXIS_PART_NAMES = [
    'axisLine',
    'axisTickLabelEstimate',
    'axisTickLabelDetermine',
    'axisName'
];
var $71fd40fa855e325e$var$builders = {
    axisLine: function axisLine(cfg, local, shared, axisModel, group, transformGroup, api) {
        var ready;
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto') {
            shown = true;
            if (cfg.raw.axisLineAutoShow != null) shown = !!cfg.raw.axisLineAutoShow;
        }
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var pathBaseProp = {
            strokeContainThreshold: cfg.raw.strokeContainThreshold || 5,
            silent: true,
            z2: 1,
            style: lineStyle
        };
        if (axisModel.get([
            'axisLine',
            'breakLine'
        ]) && axisModel.axis.scale.hasBreaks()) (0, $2d7c12def48f6bbb$export$c1d9b2cc33e7e5e)().buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp);
        else {
            var line = new $a32872499189f58f$export$2e2bcd8739ae039((0, $99026af6cdabc3e1$export$8b58be045bf06082)({
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                }
            }, pathBaseProp));
            $055606553475f5d6$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
            line.anid = 'line';
            group.add(line);
        }
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(arrowSize) || (0, $99026af6cdabc3e1$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $daf140cd8c7d5a6f$export$e3e292895c033f6d)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)([
                {
                    rotate: cfg.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: cfg.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $daf140cd8c7d5a6f$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(cfg.rotation),
                        y: pt[1] - r * Math.sin(cfg.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisTickLabelEstimate: function axisTickLabelEstimate(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $71fd40fa855e325e$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $71fd40fa855e325e$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $d2408e89e8509289$export$31cba7db0a663292).estimate);
    },
    /**
   * Finish axis tick label build.
   * Can be only called once.
   */ axisTickLabelDetermine: function axisTickLabelDetermine(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $71fd40fa855e325e$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $71fd40fa855e325e$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $d2408e89e8509289$export$31cba7db0a663292).determine);
        var ticksEls = $71fd40fa855e325e$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel);
        $71fd40fa855e325e$var$syncLabelIgnoreToMajorTicks(cfg, local.labelLayoutList, ticksEls);
        $71fd40fa855e325e$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, cfg.tickDirection);
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisName: function axisName(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var sharedRecord = shared.ensureRecord(axisModel);
        var ready;
        // Remove the existing name result created in estimation phase.
        if (local.nameEl) {
            group.remove(local.nameEl);
            local.nameEl = sharedRecord.nameLayout = sharedRecord.nameLocation = null;
        }
        var name = cfg.axisName;
        if (!$71fd40fa855e325e$var$hasAxisName(name)) return;
        var nameLocation = cfg.nameLocation;
        var nameDirection = cfg.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapStartEndSignal = axisModel.axis.inverse ? -1 : 1;
        var pos = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(0, 0);
        var nameMoveDirVec = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(0, 0);
        if (nameLocation === 'start') {
            pos.x = extent[0] - gapStartEndSignal * gap;
            nameMoveDirVec.x = -gapStartEndSignal;
        } else if (nameLocation === 'end') {
            pos.x = extent[1] + gapStartEndSignal * gap;
            nameMoveDirVec.x = gapStartEndSignal;
        } else {
            // 'middle' or 'center'
            pos.x = (extent[0] + extent[1]) / 2;
            pos.y = cfg.labelOffset + nameDirection * gap;
            nameMoveDirVec.y = nameDirection;
        }
        var mt = $e84a7b06db3848b3$export$185802fd694ee1f5();
        nameMoveDirVec.transform($e84a7b06db3848b3$export$bb628a54ab399bc9(mt, mt, cfg.rotation));
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $71fd40fa855e325e$var$PI / 180; // To radian.
        var labelLayout;
        var axisNameAvailableWidth;
        if ((0, $e4f40c424e9cabd2$export$c06aa22293dea9d2)(nameLocation)) labelLayout = $71fd40fa855e325e$var$AxisBuilder.innerTextLayout(cfg.rotation, nameRotation != null ? nameRotation : cfg.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $71fd40fa855e325e$var$endTextLayout(cfg.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = cfg.raw.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $99026af6cdabc3e1$export$8a4d17b6e8486e66)(cfg.raw.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var nameMarginLevel = extraParams.nameMarginLevel || 0;
        var textEl = new $97dfecd189304201$export$2e2bcd8739ae039({
            x: pos.x,
            y: pos.y,
            rotation: labelLayout.rotation,
            silent: $71fd40fa855e325e$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $a4fed78c55651c93$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $055606553475f5d6$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $71fd40fa855e325e$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        transformGroup.add(textEl);
        textEl.updateTransform();
        local.nameEl = textEl;
        var nameLayout = sharedRecord.nameLayout = (0, $c9e690af6576c75e$export$471916f4e89eb5da)({
            label: textEl,
            priority: textEl.z2,
            defaultAttr: {
                ignore: textEl.ignore
            },
            marginDefault: (0, $e4f40c424e9cabd2$export$c06aa22293dea9d2)(nameLocation) ? $71fd40fa855e325e$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS[nameMarginLevel] : $71fd40fa855e325e$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS[nameMarginLevel]
        });
        sharedRecord.nameLocation = nameLocation;
        group.add(textEl);
        textEl.decomposeTransform();
        if (cfg.shouldNameMoveOverlap && nameLayout) {
            var record = shared.ensureRecord(axisModel);
            shared.resolveAxisNameOverlap(cfg, shared, axisModel, nameLayout, nameMoveDirVec, record);
        }
    }
};
function $71fd40fa855e325e$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, kind) {
    if (!$71fd40fa855e325e$var$axisLabelBuildResultExists(local)) $71fd40fa855e325e$var$buildAxisLabel(cfg, local, group, kind, axisModel, api);
    var labelLayoutList = local.labelLayoutList;
    $71fd40fa855e325e$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup);
    $71fd40fa855e325e$var$adjustBreakLabels(axisModel, cfg.rotation, labelLayoutList);
    var optionHideOverlap = cfg.optionHideOverlap;
    $71fd40fa855e325e$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap);
    if (optionHideOverlap) // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.
    (0, $c9e690af6576c75e$export$8ce774e164a49410)(// Filter the already ignored labels by the previous overlap resolving methods.
    (0, $99026af6cdabc3e1$export$3dea766d36a8935f)(labelLayoutList, function(layout) {
        return layout && !layout.label.ignore;
    }));
    // Always call it even this axis has no name, since it serves in overlapping detection
    // and grid outerBounds on other axis.
    $71fd40fa855e325e$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList);
}
function $71fd40fa855e325e$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $bfe945a83b4d28b9$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $bfe945a83b4d28b9$export$d1df570aea2868f)(rotationDiff - $71fd40fa855e325e$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $bfe945a83b4d28b9$export$d1df570aea2868f)(rotationDiff - $71fd40fa855e325e$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $71fd40fa855e325e$var$PI * 1.5 && rotationDiff > $71fd40fa855e325e$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
/**
 * Assume `labelLayoutList` has no `label.ignore: true`.
 * Assume `labelLayoutList` have been sorted by value ascending order.
 */ function $71fd40fa855e325e$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap) {
    if ((0, $e4f40c424e9cabd2$export$c2911c025243d6a6)(axisModel.axis)) return;
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    // Assert no ignore in labels.
    function deal(showMinMaxLabel, outmostLabelIdx, innerLabelIdx) {
        var outmostLabelLayout = (0, $c9e690af6576c75e$export$471916f4e89eb5da)(labelLayoutList[outmostLabelIdx]);
        var innerLabelLayout = (0, $c9e690af6576c75e$export$471916f4e89eb5da)(labelLayoutList[innerLabelIdx]);
        if (!outmostLabelLayout || !innerLabelLayout) return;
        if (showMinMaxLabel === false || outmostLabelLayout.suggestIgnore) {
            $71fd40fa855e325e$var$ignoreEl(outmostLabelLayout.label);
            return;
        }
        if (innerLabelLayout.suggestIgnore) {
            $71fd40fa855e325e$var$ignoreEl(innerLabelLayout.label);
            return;
        }
        // PENDING: Originally we thought `optionHideOverlap === false` means do not hide anything,
        //  since currently the bounding rect of text might not accurate enough and might slightly bigger,
        //  which causes false positive. But `optionHideOverlap: null/undfined` is falsy and likely
        //  be treated as false.
        // In most fonts the glyph does not reach the boundary of the bounding rect.
        // This is needed to avoid too aggressive to hide two elements that meet at the edge
        // due to compact layout by the same bounding rect or OBB.
        var touchThreshold = 0.1;
        // This treatment is for backward compatibility. And `!optionHideOverlap` implies that
        // the user accepts the visual touch between adjacent labels, thus "hide min/max label"
        // should be conservative, since the space might be sufficient in this case.
        if (!optionHideOverlap) {
            var marginForce = [
                0,
                0,
                0,
                0
            ];
            // Make a copy to apply `ignoreMargin`.
            outmostLabelLayout = (0, $c9e690af6576c75e$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, outmostLabelLayout);
            innerLabelLayout = (0, $c9e690af6576c75e$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, innerLabelLayout);
        }
        if ((0, $c9e690af6576c75e$export$f28bfabef115ba96)(outmostLabelLayout, innerLabelLayout, null, {
            touchThreshold: touchThreshold
        })) {
            if (showMinMaxLabel) $71fd40fa855e325e$var$ignoreEl(innerLabelLayout.label);
            else $71fd40fa855e325e$var$ignoreEl(outmostLabelLayout.label);
        }
    }
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]);
    var labelsLen = labelLayoutList.length;
    deal(showMinLabel, 0, 1);
    deal(showMaxLabel, labelsLen - 1, labelsLen - 2);
}
// PENDING: Is it necessary to display a tick while the corresponding label is ignored?
function $71fd40fa855e325e$var$syncLabelIgnoreToMajorTicks(cfg, labelLayoutList, tickEls) {
    if (cfg.showMinorTicks) // It probably unreaasonable to hide major ticks when show minor ticks.
    return;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(labelLayoutList, function(labelLayout) {
        if (labelLayout && labelLayout.label.ignore) for(var idx = 0; idx < tickEls.length; idx++){
            var tickEl = tickEls[idx];
            // Assume small array, linear search is fine for performance.
            // PENDING: measure?
            var tickInner = $71fd40fa855e325e$var$getTickInner(tickEl);
            var labelInner = $71fd40fa855e325e$export$c392b818a26a879e(labelLayout.label);
            if (tickInner.tickValue != null && !tickInner.onBand && tickInner.tickValue === labelInner.tickValue) {
                $71fd40fa855e325e$var$ignoreEl(tickEl);
                return;
            }
        }
    });
}
function $71fd40fa855e325e$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $71fd40fa855e325e$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $a32872499189f58f$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $055606553475f5d6$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
        var inner = $71fd40fa855e325e$var$getTickInner(tickEl);
        inner.onBand = !!ticksCoords[i].onBand;
        inner.tickValue = ticksCoords[i].tickValue;
    }
    return tickEls;
}
function $71fd40fa855e325e$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto') {
        shown = true;
        if (cfg.raw.axisTickAutoShow != null) shown = !!cfg.raw.axisTickAutoShow;
    }
    if (!shown || axis.scale.isBlank()) return [];
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = cfg.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $71fd40fa855e325e$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $71fd40fa855e325e$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!cfg.showMinorTicks || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $71fd40fa855e325e$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
// Return whether need to call `layOutAxisTickLabel` again.
function $71fd40fa855e325e$var$dealLastTickLabelResultReusable(local, group, extraParams) {
    if ($71fd40fa855e325e$var$axisLabelBuildResultExists(local)) {
        var axisLabelsCreationContext = local.axisLabelsCreationContext;
        var noPxChangeTryDetermine = axisLabelsCreationContext.out.noPxChangeTryDetermine;
        if (extraParams.noPxChange) {
            var canDetermine = true;
            for(var idx = 0; idx < noPxChangeTryDetermine.length; idx++)canDetermine = canDetermine && noPxChangeTryDetermine[idx]();
            if (canDetermine) return false;
        }
        if (noPxChangeTryDetermine.length) {
            // Remove the result of `buildAxisLabel`
            group.remove(local.labelGroup);
            $71fd40fa855e325e$var$axisLabelBuildResultSet(local, null, null, null);
        }
    }
    return true;
}
function $71fd40fa855e325e$var$buildAxisLabel(cfg, local, group, kind, axisModel, api) {
    var axis = axisModel.axis;
    var show = (0, $99026af6cdabc3e1$export$8a4d17b6e8486e66)(cfg.raw.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    var labelGroup = new $2b89655bc310a947$export$2e2bcd8739ae039();
    group.add(labelGroup);
    var axisLabelCreationCtx = (0, $d2408e89e8509289$export$12d6ac38274c43e7)(kind);
    if (!show || axis.scale.isBlank()) {
        $71fd40fa855e325e$var$axisLabelBuildResultSet(local, [], labelGroup, axisLabelCreationCtx);
        return;
    }
    var labelModel = axisModel.getModel('axisLabel');
    var labels = axis.getViewLabels(axisLabelCreationCtx);
    // Special label rotate.
    var labelRotation = ((0, $99026af6cdabc3e1$export$8a4d17b6e8486e66)(cfg.raw.labelRotate, labelModel.get('rotate')) || 0) * $71fd40fa855e325e$var$PI / 180;
    var labelLayout = $71fd40fa855e325e$var$AxisBuilder.innerTextLayout(cfg.rotation, labelRotation, cfg.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var triggerEvent = axisModel.get('triggerEvent');
    var z2Min = Infinity;
    var z2Max = -Infinity;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var _a;
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var align = itemLabelModel.getShallow('align', true) || labelLayout.textAlign;
        var alignMin = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMinLabel', true), align);
        var alignMax = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMaxLabel', true), align);
        var verticalAlign = itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMinLabel', true), verticalAlign);
        var verticalAlignMax = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMaxLabel', true), verticalAlign);
        var z2 = 10 + (((_a = labelItem.time) === null || _a === void 0 ? void 0 : _a.level) || 0);
        z2Min = Math.min(z2Min, z2);
        z2Max = Math.max(z2Max, z2);
        var textEl = new $97dfecd189304201$export$2e2bcd8739ae039({
            // --- transform props start ---
            // All of the transform props MUST not be set here, but should be set in
            // `updateAxisLabelChangableProps`, because they may change in estimation,
            // and need to calculate based on global coord sys by `decomposeTransform`.
            x: 0,
            y: 0,
            rotation: 0,
            // --- transform props end ---
            silent: $71fd40fa855e325e$var$AxisBuilder.isLabelSilent(axisModel),
            z2: z2,
            style: (0, $a4fed78c55651c93$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue;
        var inner = $71fd40fa855e325e$export$c392b818a26a879e(textEl);
        inner["break"] = labelItem["break"];
        inner.tickValue = tickValue;
        inner.layoutRotation = labelLayout.rotation;
        $055606553475f5d6$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function isTruncated() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $71fd40fa855e325e$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            if (labelItem["break"]) eventData["break"] = {
                // type: labelItem.break.type,
                start: labelItem["break"].parsedBreak.vmin,
                end: labelItem["break"].parsedBreak.vmax
            };
            if (axis.type === 'category') eventData.dataIndex = tickValue;
            (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            if (labelItem["break"]) $71fd40fa855e325e$var$addBreakEventHandler(axisModel, api, textEl, labelItem["break"]);
        }
        labelEls.push(textEl);
        labelGroup.add(textEl);
    });
    var labelLayoutList = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(labelEls, function(label) {
        return {
            label: label,
            priority: $71fd40fa855e325e$export$c392b818a26a879e(label)["break"] ? label.z2 + (z2Max - z2Min + 1 // Make break labels be highest priority.
            ) : label.z2,
            defaultAttr: {
                ignore: label.ignore
            }
        };
    });
    $71fd40fa855e325e$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelCreationCtx);
}
// Indicate that `layOutAxisTickLabel` has been called.
function $71fd40fa855e325e$var$axisLabelBuildResultExists(local) {
    return !!local.labelLayoutList;
}
function $71fd40fa855e325e$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelsCreationContext) {
    // Ensure the same lifetime.
    local.labelLayoutList = labelLayoutList;
    local.labelGroup = labelGroup;
    local.axisLabelsCreationContext = axisLabelsCreationContext;
}
function $71fd40fa855e325e$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup) {
    var labelMargin = axisModel.get([
        'axisLabel',
        'margin'
    ]);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(labelLayoutList, function(layout, idx) {
        var geometry = (0, $c9e690af6576c75e$export$471916f4e89eb5da)(layout);
        if (!geometry) return;
        var labelEl = geometry.label;
        var inner = $71fd40fa855e325e$export$c392b818a26a879e(labelEl);
        // See the comment in `suggestIgnore`.
        geometry.suggestIgnore = labelEl.ignore;
        // Currently no `ignore:true` is set in `buildAxisLabel`
        // But `ignore:true` may be set subsequently for overlap handling, thus reset it here.
        labelEl.ignore = false;
        (0, $4640b1300b1537ae$export$234b1c16dfa57d6a)($71fd40fa855e325e$var$_tmpLayoutEl, $71fd40fa855e325e$var$_tmpLayoutElReset);
        $71fd40fa855e325e$var$_tmpLayoutEl.x = axisModel.axis.dataToCoord(inner.tickValue);
        $71fd40fa855e325e$var$_tmpLayoutEl.y = cfg.labelOffset + cfg.labelDirection * labelMargin;
        $71fd40fa855e325e$var$_tmpLayoutEl.rotation = inner.layoutRotation;
        transformGroup.add($71fd40fa855e325e$var$_tmpLayoutEl);
        $71fd40fa855e325e$var$_tmpLayoutEl.updateTransform();
        transformGroup.remove($71fd40fa855e325e$var$_tmpLayoutEl);
        $71fd40fa855e325e$var$_tmpLayoutEl.decomposeTransform();
        (0, $4640b1300b1537ae$export$234b1c16dfa57d6a)(labelEl, $71fd40fa855e325e$var$_tmpLayoutEl);
        labelEl.markRedraw();
        (0, $c9e690af6576c75e$export$1551ece3f059eafb)(geometry, true);
        (0, $c9e690af6576c75e$export$471916f4e89eb5da)(geometry);
    });
}
var $71fd40fa855e325e$var$_tmpLayoutEl = new $aed3569651b5e3fa$export$2e2bcd8739ae039();
var $71fd40fa855e325e$var$_tmpLayoutElReset = new $aed3569651b5e3fa$export$2e2bcd8739ae039();
function $71fd40fa855e325e$var$hasAxisName(axisName) {
    return !!axisName;
}
function $71fd40fa855e325e$var$addBreakEventHandler(axisModel, api, textEl, visualBreak) {
    textEl.on('click', function(params) {
        var payload = {
            type: (0, $8c57afbd7818ddb3$export$12319e2083cd71ce),
            breaks: [
                {
                    start: visualBreak.parsedBreak.breakOption.start,
                    end: visualBreak.parsedBreak.breakOption.end
                }
            ]
        };
        payload[axisModel.axis.dim + "AxisIndex"] = axisModel.componentIndex;
        api.dispatchAction(payload);
    });
}
function $71fd40fa855e325e$var$adjustBreakLabels(axisModel, axisRotation, labelLayoutList) {
    var scaleBreakHelper = (0, $ae704d848942c028$export$e79b20ac82c2d660)();
    if (!scaleBreakHelper) return;
    var breakLabelIndexPairs = scaleBreakHelper.retrieveAxisBreakPairs(labelLayoutList, function(layoutInfo) {
        return layoutInfo && $71fd40fa855e325e$export$c392b818a26a879e(layoutInfo.label)["break"];
    }, true);
    var moveOverlap = axisModel.get([
        'breakLabelLayout',
        'moveOverlap'
    ], true);
    if (moveOverlap === true || moveOverlap === 'auto') (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(breakLabelIndexPairs, function(idxPair) {
        (0, $2d7c12def48f6bbb$export$c1d9b2cc33e7e5e)().adjustBreakLabelPair(axisModel.axis.inverse, axisRotation, [
            (0, $c9e690af6576c75e$export$471916f4e89eb5da)(labelLayoutList[idxPair[0]]),
            (0, $c9e690af6576c75e$export$471916f4e89eb5da)(labelLayoutList[idxPair[1]])
        ]);
    });
}
var $71fd40fa855e325e$export$2e2bcd8739ae039 = $71fd40fa855e325e$var$AxisBuilder;



function $ff2a5efaf8c11f84$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $ff2a5efaf8c11f84$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $ff2a5efaf8c11f84$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $031dcf3d7ed28374$export$f3a38102c49f4268(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $33d0653e48493c02$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2);
    // Not overflow ec container
    $ff2a5efaf8c11f84$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $a4fed78c55651c93$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $ff2a5efaf8c11f84$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $ff2a5efaf8c11f84$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $e4f40c424e9cabd2$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $99026af6cdabc3e1$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($99026af6cdabc3e1$export$844ec244b1367d54(formatter)) text = formatter.replace('{value}', text);
        else if ($99026af6cdabc3e1$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $ff2a5efaf8c11f84$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $e84a7b06db3848b3$export$185802fd694ee1f5();
    $e84a7b06db3848b3$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $e84a7b06db3848b3$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $055606553475f5d6$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $ff2a5efaf8c11f84$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    var textLayout = (0, $71fd40fa855e325e$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $ff2a5efaf8c11f84$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $ff2a5efaf8c11f84$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $ff2a5efaf8c11f84$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $ff2a5efaf8c11f84$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $ff2a5efaf8c11f84$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $ebbe81cd5867016d$export$b3219800bda33a1f(rect, axisModel, opt) {
    opt = opt || {};
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($99026af6cdabc3e1$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $ebbe81cd5867016d$export$1a2a248dbebc52b5(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $ebbe81cd5867016d$export$e447722773749af(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $ebbe81cd5867016d$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $99026af6cdabc3e1$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}
function $ebbe81cd5867016d$export$2b2ce820c3e1e776(gridRect, cartesians, axisModel, api, ctx, defaultNameMoveOverlap) {
    var layoutResult = $ebbe81cd5867016d$export$b3219800bda33a1f(gridRect, axisModel);
    var axisLineAutoShow = false;
    var axisTickAutoShow = false;
    // Not show axisTick or axisLine if other axis is category / time
    for(var i = 0; i < cartesians.length; i++)if ((0, $6c4fc73e5e49c10c$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
        // Still show axis tick or axisLine if other axis is value / log
        axisLineAutoShow = axisTickAutoShow = true;
        if (axisModel.axis.type === 'category' && axisModel.axis.onBand) axisTickAutoShow = false;
    }
    layoutResult.axisLineAutoShow = axisLineAutoShow;
    layoutResult.axisTickAutoShow = axisTickAutoShow;
    layoutResult.defaultNameMoveOverlap = defaultNameMoveOverlap;
    return new (0, $71fd40fa855e325e$export$2e2bcd8739ae039)(axisModel, api, layoutResult, ctx);
}
function $ebbe81cd5867016d$export$3e8d41f03e1a6a39(axisBuilder, gridRect, axisModel) {
    var newRaw = $ebbe81cd5867016d$export$b3219800bda33a1f(gridRect, axisModel);
    var oldRaw_1;
    axisBuilder.updateCfg(newRaw);
}


var $7e00afbcbb391800$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $7e00afbcbb391800$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $ff2a5efaf8c11f84$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $7e00afbcbb391800$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $ebbe81cd5867016d$export$b3219800bda33a1f(grid.getRect(), axisModel);
        $ff2a5efaf8c11f84$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $ebbe81cd5867016d$export$b3219800bda33a1f(axisModel.axis.grid.getRect(), axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $ff2a5efaf8c11f84$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $7e00afbcbb391800$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $dbb87199a0b668aa$export$2e2bcd8739ae039));
function $7e00afbcbb391800$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $7e00afbcbb391800$var$pointerShapeBuilder = {
    line: function line(axis, pixelValue, otherExtent) {
        var targetShape = $ff2a5efaf8c11f84$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $7e00afbcbb391800$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function shadow(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $ff2a5efaf8c11f84$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $7e00afbcbb391800$var$getAxisDimIndex(axis))
        };
    }
};
function $7e00afbcbb391800$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $7e00afbcbb391800$export$2e2bcd8739ae039 = $7e00afbcbb391800$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $fd0dbfc612774eb1$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        // zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.border,
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.shadowTint
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral00,
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.accent60,
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.accent40,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
var $fd0dbfc612774eb1$export$2e2bcd8739ae039 = $fd0dbfc612774eb1$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $cbce673d57724c36$var$inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
var $cbce673d57724c36$var$each = $99026af6cdabc3e1$export$79b2f7037acddd43;
function $cbce673d57724c36$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $e870be04527b939a$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $cbce673d57724c36$var$inner(zr).records || ($cbce673d57724c36$var$inner(zr).records = {});
    $cbce673d57724c36$var$initGlobalListeners(zr, api);
    var record = $cbce673d57724c36$var$inner(zr).records[key] || ($cbce673d57724c36$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $cbce673d57724c36$var$initGlobalListeners(zr, api) {
    if ($cbce673d57724c36$var$inner(zr).initialized) return;
    $cbce673d57724c36$var$inner(zr).initialized = true;
    useHandler('click', $99026af6cdabc3e1$export$c3095a23b368d1f2($cbce673d57724c36$var$doEnter, 'click'));
    useHandler('mousemove', $99026af6cdabc3e1$export$c3095a23b368d1f2($cbce673d57724c36$var$doEnter, 'mousemove'));
    // useHandler('mouseout', onLeave);
    useHandler('globalout', $cbce673d57724c36$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $cbce673d57724c36$var$makeDispatchAction(api);
            $cbce673d57724c36$var$each($cbce673d57724c36$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $cbce673d57724c36$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $cbce673d57724c36$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $cbce673d57724c36$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $cbce673d57724c36$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $cbce673d57724c36$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function dispatchAction1(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $cbce673d57724c36$export$d07f55d4c15c0440(key, api) {
    if ((0, $e870be04527b939a$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($cbce673d57724c36$var$inner(zr).records || {})[key];
    if (record) $cbce673d57724c36$var$inner(zr).records[key] = null;
}



var $957cfde991fc7368$var$AxisPointerView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click';
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $cbce673d57724c36$export$6503ec6e8aabbaf('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $cbce673d57724c36$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $cbce673d57724c36$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $3e14d76796640b86$export$2e2bcd8739ae039));
var $957cfde991fc7368$export$2e2bcd8739ae039 = $957cfde991fc7368$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $f8198824a505f509$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $08bfa015475effa8$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $99026af6cdabc3e1$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($99026af6cdabc3e1$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}



var $d0683cd4aafd311e$var$inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
function $d0683cd4aafd311e$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $99026af6cdabc3e1$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($d0683cd4aafd311e$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $f8198824a505f509$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $d0683cd4aafd311e$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $d0683cd4aafd311e$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)($d0683cd4aafd311e$var$showPointer, showValueMap),
        showTooltip: (0, $99026af6cdabc3e1$export$c3095a23b368d1f2)($d0683cd4aafd311e$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $d0683cd4aafd311e$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $d0683cd4aafd311e$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $d0683cd4aafd311e$var$makeMapperParam(srcAxisInfo), $d0683cd4aafd311e$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $d0683cd4aafd311e$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $d0683cd4aafd311e$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $d0683cd4aafd311e$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $d0683cd4aafd311e$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $d0683cd4aafd311e$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $d0683cd4aafd311e$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $99026af6cdabc3e1$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $d0683cd4aafd311e$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.indicesOfNearest(dim, dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $d0683cd4aafd311e$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $d0683cd4aafd311e$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $2735371358a27a2d$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $d0683cd4aafd311e$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
        // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $d0683cd4aafd311e$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($d0683cd4aafd311e$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $d0683cd4aafd311e$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $d0683cd4aafd311e$var$inner(zr)[highDownKey] || {};
    var newHighlights = $d0683cd4aafd311e$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && axisInfo.triggerEmphasis && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $d0683cd4aafd311e$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $d0683cd4aafd311e$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $d0683cd4aafd311e$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $928bdc65399e8455$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $4cde784d925ed2eb$export$2e2bcd8739ae039).registerAxisPointerClass('CartesianAxisPointer', (0, $7e00afbcbb391800$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $fd0dbfc612774eb1$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $957cfde991fc7368$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $2735371358a27a2d$export$bb44f104e3c54dae)(ecModel, api);
    });
    // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $d0683cd4aafd311e$export$2e2bcd8739ae039));
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $73bae0eb07aff4d9$var$TooltipModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click',
        alwaysShowContent: false,
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaults to `false` (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        displayTransition: true,
        enterable: false,
        backgroundColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral00,
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        defaultBorderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.border,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.borderShade,
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.tertiary,
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
var $73bae0eb07aff4d9$export$2e2bcd8739ae039 = $73bae0eb07aff4d9$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $8f8263f20acc30ed$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
}
function $8f8263f20acc30ed$var$testStyle(styleProps) {
    if (!(0, $e870be04527b939a$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $8f8263f20acc30ed$export$7b4286b1e4a23439 = $8f8263f20acc30ed$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $8f8263f20acc30ed$export$70a631ae991b5e76 = $8f8263f20acc30ed$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $8f8263f20acc30ed$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $031dcf3d7ed28374$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $8f8263f20acc30ed$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $7cc3962f5725fe57$var$CSS_TRANSITION_VENDOR = (0, $8f8263f20acc30ed$export$5886acafe29a08d1)((0, $8f8263f20acc30ed$export$70a631ae991b5e76), 'transition');
var $7cc3962f5725fe57$var$CSS_TRANSFORM_VENDOR = (0, $8f8263f20acc30ed$export$5886acafe29a08d1)((0, $8f8263f20acc30ed$export$7b4286b1e4a23439), 'transform');
// eslint-disable-next-line
var $7cc3962f5725fe57$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $e870be04527b939a$export$2e2bcd8739ae039).transform3dSupported ? 'will-change:transform;' : '');
function $7cc3962f5725fe57$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $7cc3962f5725fe57$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $99026af6cdabc3e1$export$844ec244b1367d54)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $031dcf3d7ed28374$export$cda04d03233e5555)(borderColor);
    var arrowPos = $7cc3962f5725fe57$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $7cc3962f5725fe57$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $7cc3962f5725fe57$var$assembleTransition(duration, onlyFadeTransition, enableDisplayTransition) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = '';
    var transitionText = '';
    if (enableDisplayTransition) {
        transitionOption = " " + duration / 2 + "s " + transitionCurve;
        transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    }
    if (!onlyFadeTransition) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (transitionText.length ? ',' : '') + ((0, $e870be04527b939a$export$2e2bcd8739ae039).transformSupported ? "" + $7cc3962f5725fe57$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption);
    }
    return $7cc3962f5725fe57$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $7cc3962f5725fe57$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px';
    // not support transform, use `left` and `top` instead.
    if (!(0, $e870be04527b939a$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
    // support transform
    var is3d = (0, $e870be04527b939a$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $7cc3962f5725fe57$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $8f8263f20acc30ed$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $7cc3962f5725fe57$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(textStyleModel.get('lineHeight'), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push('line-height:' + lineHeight + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $7cc3962f5725fe57$var$assembleCssText(tooltipModel, enableTransition, onlyFadeTransition, enableDisplayTransition) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $0d43100c4c4de5e1$export$3048212c802df496)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow);
    // Animation transition. Do not animate when transitionDuration <= 0.
    enableTransition && transitionDuration > 0 && cssText.push($7cc3962f5725fe57$var$assembleTransition(transitionDuration, onlyFadeTransition, enableDisplayTransition));
    if (backgroundColor) cssText.push('background-color:' + backgroundColor);
    // Border style
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $031dcf3d7ed28374$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    });
    // Text style
    cssText.push($7cc3962f5725fe57$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push('padding:' + (0, $031dcf3d7ed28374$export$f3a38102c49f4268)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
}
// If not able to make, do not modify the input `out`.
function $7cc3962f5725fe57$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $30ce8acf08cde25e$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $7cc3962f5725fe57$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $e870be04527b939a$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement('div');
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $99026af6cdabc3e1$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $7cc3962f5725fe57$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $daa01fa9060de3a2$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $8f8263f20acc30ed$export$3735103072e4a80)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        this._enableDisplayTransition = tooltipModel.get('displayTransition') && tooltipModel.get('transitionDuration') > 0;
        // update className
        this.el.className = tooltipModel.get('className') || '';
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $7cc3962f5725fe57$var$gCssText + $7cc3962f5725fe57$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide, this._enableDisplayTransition) + $7cc3962f5725fe57$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $031dcf3d7ed28374$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $8f8263f20acc30ed$export$a309528050824ba4)(tooltipModel)) arrow = $7cc3962f5725fe57$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $99026af6cdabc3e1$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $7cc3962f5725fe57$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $7cc3962f5725fe57$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        if (this._enableDisplayTransition) {
            style.visibility = 'hidden';
            style.opacity = '0';
        } else style.display = 'none';
        (0, $e870be04527b939a$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $99026af6cdabc3e1$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var zr = this._zr;
        (0, $30ce8acf08cde25e$export$a29dbe4b7d3cd586)(zr && zr.painter && zr.painter.getViewportRoot(), this._container);
        var el = this.el;
        if (el) {
            el.onmouseenter = el.onmousemove = el.onmouseleave = null;
            var parentNode = el.parentNode;
            parentNode && parentNode.removeChild(el);
        }
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $7cc3962f5725fe57$export$2e2bcd8739ae039 = $7cc3962f5725fe57$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $722f3e45cd68c1d5$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $722f3e45cd68c1d5$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($99026af6cdabc3e1$export$a6cdc56e425d0d0a(content)) (0, $2c7aa3955e1b7354$export$8bf7aba4a9e09055)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $97dfecd189304201$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get('textShadowColor'),
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $0d43100c4c4de5e1$export$3048212c802df496)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        $99026af6cdabc3e1$export$79b2f7037acddd43([
            'backgroundColor',
            'borderRadius',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $99026af6cdabc3e1$export$79b2f7037acddd43([
            'textShadowBlur',
            'textShadowOffsetX',
            'textShadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $722f3e45cd68c1d5$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $722f3e45cd68c1d5$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $722f3e45cd68c1d5$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $722f3e45cd68c1d5$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($99026af6cdabc3e1$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $722f3e45cd68c1d5$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $722f3e45cd68c1d5$var$calcShadowOuterSize(style) {
    var shadowBlur = $722f3e45cd68c1d5$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $722f3e45cd68c1d5$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $722f3e45cd68c1d5$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $722f3e45cd68c1d5$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $722f3e45cd68c1d5$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $722f3e45cd68c1d5$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $722f3e45cd68c1d5$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $722f3e45cd68c1d5$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $722f3e45cd68c1d5$export$2e2bcd8739ae039 = $722f3e45cd68c1d5$var$TooltipRichContent;




















var $ec6e8e764d26f21c$var$proxyRect = new (0, $aed3569651b5e3fa$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $ec6e8e764d26f21c$var$TooltipView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $e870be04527b939a$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = this._renderMode = (0, $08bfa015475effa8$export$cc0a17a5d27b4e17)(tooltipModel.get('renderMode'));
        this._tooltipContent = renderMode === 'richText' ? new (0, $722f3e45cd68c1d5$export$2e2bcd8739ae039)(api) : new (0, $7cc3962f5725fe57$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get('appendToBody', true) ? 'body' : tooltipModel.get('appendTo', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $e870be04527b939a$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) (0, $b4484a22f72674c6$export$958e3e1a02eac4b6)(this, '_updatePosition', 50, 'fixRate');
        else (0, $b4484a22f72674c6$export$42ffd38884aecdac)(this, '_updatePosition');
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $cbce673d57724c36$export$6503ec6e8aabbaf('itemTooltip', this._api, (0, $99026af6cdabc3e1$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get('triggerOn');
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== 'none' && triggerOn !== 'click') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $e870be04527b939a$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $ec6e8e764d26f21c$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = '';
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $ec6e8e764d26f21c$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $ec6e8e764d26f21c$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $f8198824a505f509$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($ec6e8e764d26f21c$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $ec6e8e764d26f21c$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === 'legend') // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $2948406aad695582$export$8a4fca9e04eb4df6)(el, function(target) {
                if (target.tooltipDisabled) {
                    seriesDispatcher_1 = cmptDispatcher_1 = null;
                    return true;
                }
                if (seriesDispatcher_1 || cmptDispatcher_1) return;
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(target).dataIndex != null) seriesDispatcher_1 = target;
                else if ((0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) cmptDispatcher_1 = target;
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $ec6e8e764d26f21c$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $0d43100c4c4de5e1$export$cf63b23ce77d1921)('section', {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $0d43100c4c4de5e1$export$2fba3afbcdcf3e18)();
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                // FIXME: when using `tooltip.trigger: 'axis'`, the precision of the axis value displayed in tooltip
                //  should match the original series values rather than using the default stretegy in Interval.ts
                //  (getPrecision(interval) + 2); otherwise it may cuase confusion.
                var axisValueLabel = $ff2a5efaf8c11f84$export$7cffee0f9aed39d0(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $0d43100c4c4de5e1$export$cf63b23ce77d1921)('section', {
                    header: axisValueLabel,
                    noHeader: !(0, $99026af6cdabc3e1$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $e4f40c424e9cabd2$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, $031dcf3d7ed28374$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $7d8ad306dbc6dcbb$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $ec6e8e764d26f21c$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get('valueFormatter');
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $0d43100c4c4de5e1$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $ec6e8e764d26f21c$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $0d43100c4c4de5e1$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', (0, $031dcf3d7ed28374$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $7d8ad306dbc6dcbb$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var valueFormatter = tooltipModel.get('valueFormatter');
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $0d43100c4c4de5e1$export$6969ffb02c1cb49a)(valueFormatter ? (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === 'html';
        var ecData = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(tooltipOpt);
            tooltipOpt.content = (0, $30ce8acf08cde25e$export$f9d6449b9af28dc1)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $ec6e8e764d26f21c$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + '';
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $0d43100c4c4de5e1$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'), tooltipModel.get('defaultBorderColor', true));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $3655c9ec749458a4$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $031dcf3d7ed28374$export$2028496a35766e41)(html, params, true);
            } else if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $99026af6cdabc3e1$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor, defaultBorderColor) {
        if (trigger === 'axis' || (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || defaultBorderColor
        };
        if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $4fb3a6a3c6974639$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $ec6e8e764d26f21c$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $ec6e8e764d26f21c$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $ec6e8e764d26f21c$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $ec6e8e764d26f21c$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $8f8263f20acc30ed$export$a309528050824ba4)(tooltipModel)) {
            var pos = $ec6e8e764d26f21c$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $e870be04527b939a$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $b4484a22f72674c6$export$42ffd38884aecdac)(this, '_updatePosition');
        this._tooltipContent.dispose();
        $cbce673d57724c36$export$d07f55d4c15c0440('itemTooltip', api);
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $3e14d76796640b86$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $ec6e8e764d26f21c$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $a48e58444b640d0e$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get('tooltip', true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $ec6e8e764d26f21c$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $99026af6cdabc3e1$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $ec6e8e764d26f21c$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $ec6e8e764d26f21c$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $ec6e8e764d26f21c$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $ec6e8e764d26f21c$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $ec6e8e764d26f21c$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $08bfa015475effa8$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $08bfa015475effa8$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $ec6e8e764d26f21c$export$2e2bcd8739ae039 = $ec6e8e764d26f21c$var$TooltipView;



function $5521b89ee29e24c4$export$4b3e715f166fdd78(registers) {
    (0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $928bdc65399e8455$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $73bae0eb07aff4d9$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ec6e8e764d26f21c$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, (0, $99026af6cdabc3e1$export$8793edee2d425525));
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, (0, $99026af6cdabc3e1$export$8793edee2d425525));
}




var $a534c0c1c8c0b730$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $5521b89ee29e24c4$export$4b3e715f166fdd78));
var $a534c0c1c8c0b730$export$639fd784fb67c186 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECTooltipComponent, ECOptionElement);
    function ECTooltipComponent() {
        (0, $7lhcp._)(this, ECTooltipComponent);
        return (0, $07dqX._)(this, ECTooltipComponent, arguments);
    }
    return ECTooltipComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($a534c0c1c8c0b730$var$_a = globalThis.customElements) === null || $a534c0c1c8c0b730$var$_a === void 0 || $a534c0c1c8c0b730$var$_a.define('ec-tooltip', $a534c0c1c8c0b730$export$639fd784fb67c186);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $af17b4c830542881$export$57b4bb4ff2a0950c = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $af17b4c830542881$export$e78e6bf4dcc3e485 = [
    '25%',
    '25%'
];
var $af17b4c830542881$var$GridModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var outerBoundsCp = (0, $4fb3a6a3c6974639$export$4b0d20af19c9875e)(option.outerBounds);
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        if (outerBoundsCp && option.outerBounds) (0, $4fb3a6a3c6974639$export$1754cb91f16ca028)(option.outerBounds, outerBoundsCp);
    };
    GridModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.apply(this, arguments);
        if (this.option.outerBounds && newOption.outerBounds) (0, $4fb3a6a3c6974639$export$1754cb91f16ca028)(this.option.outerBounds, newOption.outerBounds);
    };
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: '15%',
        top: 65,
        right: '10%',
        bottom: 80,
        // If grid size contain label
        containLabel: false,
        outerBoundsMode: 'auto',
        outerBounds: $af17b4c830542881$export$57b4bb4ff2a0950c,
        outerBoundsContain: 'all',
        outerBoundsClampWidth: $af17b4c830542881$export$e78e6bf4dcc3e485[0],
        outerBoundsClampHeight: $af17b4c830542881$export$e78e6bf4dcc3e485[1],
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.transparent,
        borderWidth: 1,
        borderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral30
    };
    return GridModel;
}((0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
var $af17b4c830542881$export$2e2bcd8739ae039 = $af17b4c830542881$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $e71310439e7eeb67$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();



var $82a0595664d9a818$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $fefeb1a173623ab2$export$2e2bcd8739ae039));
$99026af6cdabc3e1$export$e36fc9d62a853069($82a0595664d9a818$export$483dc37e6ad83a3c, (0, $e71310439e7eeb67$export$5c54b224726edb5a));
var $82a0595664d9a818$export$2e2bcd8739ae039 = $82a0595664d9a818$export$483dc37e6ad83a3c;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $47dc630195d3df27$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {
    },
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.axisLine,
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ],
        breakLine: true
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12,
        color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.axisLabel,
        // In scenarios like axis labels, when labels text's progression direction matches the label
        // layout direction (e.g., when all letters are in a single line), extra start/end margin is
        // needed to prevent the text from appearing visually joined. In the other case, when lables
        // are stacked (e.g., having rotation or horizontal labels on yAxis), the layout needs to be
        // compact, so NO extra top/bottom margin should be applied.
        textMargin: [
            0,
            3
        ]
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.axisSplitLine,
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.backgroundTint,
                (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.backgroundTransparent
            ]
        }
    },
    breakArea: {
        show: true,
        itemStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral00,
            // Break border color should be darker than the splitLine
            // because it has opacity and should be more prominent
            borderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.border,
            borderWidth: 1,
            borderType: [
                3,
                3
            ],
            opacity: 0.6
        },
        zigzagAmplitude: 4,
        zigzagMinSpan: 4,
        zigzagMaxSpan: 20,
        zigzagZ: 100,
        expandOnClick: true
    },
    breakLabelLayout: {
        moveOverlap: 'auto'
    }
};
var $47dc630195d3df27$var$categoryAxis = $99026af6cdabc3e1$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    jitter: 0,
    jitterOverlap: true,
    jitterMargin: 2,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto',
        show: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $47dc630195d3df27$var$defaultOption);
var $47dc630195d3df27$var$valueAxis = $99026af6cdabc3e1$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.axisMinorSplitLine,
            width: 1
        }
    }
}, $47dc630195d3df27$var$defaultOption);
var $47dc630195d3df27$var$timeAxis = $99026af6cdabc3e1$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $47dc630195d3df27$var$valueAxis);
var $47dc630195d3df27$var$logAxis = $99026af6cdabc3e1$export$ebe90cb607ad99e({
    logBase: 10
}, $47dc630195d3df27$var$valueAxis);
var $47dc630195d3df27$export$2e2bcd8739ae039 = {
    category: $47dc630195d3df27$var$categoryAxis,
    value: $47dc630195d3df27$var$valueAxis,
    time: $47dc630195d3df27$var$timeAxis,
    log: $47dc630195d3df27$var$logAxis
};




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $57bc7f2892242da8$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};




function $8b6678f109b4498b$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)((0, $57bc7f2892242da8$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $99026af6cdabc3e1$export$4950aa0f605343fb)((0, $99026af6cdabc3e1$export$4950aa0f605343fb)({}, (0, $47dc630195d3df27$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $4fb3a6a3c6974639$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $4fb3a6a3c6974639$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $99026af6cdabc3e1$export$4950aa0f605343fb)(option, themeModel.get(axisType + 'Axis'));
                (0, $99026af6cdabc3e1$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $8b6678f109b4498b$var$getAxisType(option);
                if (layoutMode) (0, $4fb3a6a3c6974639$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $a02625578f87cc1c$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.prototype.updateAxisBreaks = function(payload) {
                var axisBreakHelper = (0, $2d7c12def48f6bbb$export$c1d9b2cc33e7e5e)();
                return axisBreakHelper ? axisBreakHelper.updateModelAxisBreak(this, payload) : {
                    breaks: []
                };
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $8b6678f109b4498b$var$getAxisType);
}
function $8b6678f109b4498b$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9489e52fe8fad8c1$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $99026af6cdabc3e1$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $99026af6cdabc3e1$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $9489e52fe8fad8c1$export$2e2bcd8739ae039 = $9489e52fe8fad8c1$var$Cartesian;




var $46c5bcbd58298b18$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $46c5bcbd58298b18$var$canCalculateAffineTransform(scale) {
    return (scale.type === 'interval' || scale.type === 'time') && !scale.hasBreaks();
}
var $46c5bcbd58298b18$var$Cartesian2D = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $46c5bcbd58298b18$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$46c5bcbd58298b18$var$canCalculateAffineTransform(xAxisScale) || !$46c5bcbd58298b18$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $e84a7b06db3848b3$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // [CAVEAT]: Do not add time consuming operation within and before fast path.
        // Fast path.
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        if (this._invTransform) return (0, $0a1f57488570eee3$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $9489e52fe8fad8c1$export$2e2bcd8739ae039));
var $46c5bcbd58298b18$export$2e2bcd8739ae039 = $46c5bcbd58298b18$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $60e9b47e46ac650b$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 *
 * Lifetime: recreate for each main process.
 * [NOTICE]: Some caches is stored on the axis instance (see `axisTickLabelBuilder.ts`)
 *  which is based on this lifetime.
 */ var $60e9b47e46ac650b$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        // Make sure that `extent[0] > extent[1]` only if `inverse: true`.
        // `inverse` can be inferred by `extent` unless `extent[0] === extent[1]`.
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(this.scale.parse(data));
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $bfe945a83b4d28b9$export$666260d9a2dda8a7)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(scale.parse(data));
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $60e9b47e46ac650b$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $bfe945a83b4d28b9$export$d3f68fbaa670562)(data, $60e9b47e46ac650b$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $60e9b47e46ac650b$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $bfe945a83b4d28b9$export$d3f68fbaa670562)(coord, extent, $60e9b47e46ac650b$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $d2408e89e8509289$export$7cccf6836ae8323c)(this, tickModel, {
            breakTicks: opt.breakTicks,
            pruneByBreak: opt.pruneByBreak
        });
        var ticks = result.ticks;
        var ticksCoords = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $60e9b47e46ac650b$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber');
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function(ctx) {
        ctx = ctx || (0, $d2408e89e8509289$export$12d6ac38274c43e7)((0, $d2408e89e8509289$export$31cba7db0a663292).determine);
        return (0, $d2408e89e8509289$export$10216ebd3e3e485e)(this, ctx).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
        // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function(ctx) {
        ctx = ctx || (0, $d2408e89e8509289$export$12d6ac38274c43e7)((0, $d2408e89e8509289$export$31cba7db0a663292).determine);
        return (0, $d2408e89e8509289$export$9ea1d3f146a5a65f)(this, ctx);
    };
    return Axis;
}();
function $60e9b47e46ac650b$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
}
// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $60e9b47e46ac650b$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        ticksCoords[0].onBand = true;
        last = ticksCoords[1] = {
            coord: axisExtent[1],
            tickValue: ticksCoords[0].tickValue,
            onBand: true
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
            ticksItem.onBand = true;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize,
            tickValue: dataExtent[1] + 1,
            onBand: true
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1];
    // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0],
        onBand: true
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1],
        onBand: true
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unnecessary tick added.
        a = (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(a);
        b = (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(b);
        return inverse ? a > b : a < b;
    }
}
var $60e9b47e46ac650b$export$2e2bcd8739ae039 = $60e9b47e46ac650b$var$Axis;


var $2e435b9b73c9fa04$var$Axis2D = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $60e9b47e46ac650b$export$2e2bcd8739ae039));
var $2e435b9b73c9fa04$export$2e2bcd8739ae039 = $2e435b9b73c9fa04$var$Axis2D;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $39febf0efba5cfc4$export$c0b3be0e9eb0c2d9(scale, axisModel, alignToScale) {
    var _a;
    var intervalScaleProto = (0, $815493036262e234$export$2e2bcd8739ae039).prototype;
    // NOTE: There is a precondition for log scale  here:
    // In log scale we store _interval and _extent of exponent value.
    // So if we use the method of InternalScale to set/get these data.
    // It process the exponent value, which is linear and what we want here.
    var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
    var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, {
        expandToNicedExtent: true
    });
    var alignToSplitNumber = alignToTicks.length - 1;
    var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
    var scaleExtent = (0, $e4f40c424e9cabd2$export$9c0ba8df7eb7b328)(scale, axisModel);
    var rawExtent = scaleExtent.extent;
    var isMinFixed = scaleExtent.fixMin;
    var isMaxFixed = scaleExtent.fixMax;
    if (scale.type === 'log') rawExtent = (0, $6c4fc73e5e49c10c$export$a6588cdf5be114b3)(scale.base, rawExtent, true);
    scale.setBreaksFromOption((0, $e4f40c424e9cabd2$export$8094779d9b724f85)(axisModel));
    scale.setExtent(rawExtent[0], rawExtent[1]);
    scale.calcNiceExtent({
        splitNumber: alignToSplitNumber,
        fixMin: isMinFixed,
        fixMax: isMaxFixed
    });
    var extent = intervalScaleProto.getExtent.call(scale);
    // Need to update the rawExtent.
    // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
    if (isMinFixed) rawExtent[0] = extent[0];
    if (isMaxFixed) rawExtent[1] = extent[1];
    var interval = intervalScaleProto.getInterval.call(scale);
    var min = rawExtent[0];
    var max = rawExtent[1];
    if (isMinFixed && isMaxFixed) // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
    else if (isMinFixed) {
        max = rawExtent[0] + interval * alignToSplitNumber;
        // User set min, expand extent on the other side
        while(max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])){
            interval = (0, $6c4fc73e5e49c10c$export$f39031e8422f329d)(interval);
            max = rawExtent[0] + interval * alignToSplitNumber;
        }
    } else if (isMaxFixed) {
        // User set max, expand extent on the other side
        min = rawExtent[1] - interval * alignToSplitNumber;
        while(min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])){
            interval = (0, $6c4fc73e5e49c10c$export$f39031e8422f329d)(interval);
            min = rawExtent[1] - interval * alignToSplitNumber;
        }
    } else {
        var nicedSplitNumber = scale.getTicks().length - 1;
        if (nicedSplitNumber > alignToSplitNumber) interval = (0, $6c4fc73e5e49c10c$export$f39031e8422f329d)(interval);
        var range = interval * alignToSplitNumber;
        max = Math.ceil(rawExtent[1] / interval) * interval;
        min = (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(max - range);
        // Not change the result that crossing zero.
        if (min < 0 && rawExtent[0] >= 0) {
            min = 0;
            max = (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(range);
        } else if (max > 0 && rawExtent[1] <= 0) {
            max = 0;
            min = -(0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(range);
        }
    }
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
    var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval;
    // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
    intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
    intervalScaleProto.setInterval.call(scale, interval);
    if (t0 || t1) intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
    var ticks;
}








// margin is [top, right, bottom, left]
var $3129b721b1bf767f$var$XY_TO_MARGIN_IDX = [
    [
        3,
        1
    ],
    [
        0,
        2
    ] // xyIdx 1 => 'y'
];
var $3129b721b1bf767f$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $46c5bcbd58298b18$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        function updateAxisTicks(axes) {
            var alignTo;
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $99026af6cdabc3e1$export$ed97f33186d4b816)(axes);
            var len = axesIndices.length;
            if (!len) return;
            var axisNeedsAlign = [];
            // Process once and calculate the ticks for those don't use alignTicks.
            for(var i = len - 1; i >= 0; i--){
                var idx = +axesIndices[i]; // Convert to number.
                var axis = axes[idx];
                var model = axis.model;
                var scale = axis.scale;
                if (// Only value and log axis without interval support alignTicks.
                (0, $6c4fc73e5e49c10c$export$dfc8cd28ed7b22a0)(scale) && model.get('alignTicks') && model.get('interval') == null) axisNeedsAlign.push(axis);
                else {
                    (0, $e4f40c424e9cabd2$export$51f3e70a54405d5a)(scale, model);
                    if ((0, $6c4fc73e5e49c10c$export$dfc8cd28ed7b22a0)(scale)) // Can only align to interval or log axis.
                    alignTo = axis;
                }
            }
            // All axes has set alignTicks. Pick the first one.
            // PENDING. Should we find the axis that both set interval, min, max and align to this one?
            if (axisNeedsAlign.length) {
                if (!alignTo) {
                    alignTo = axisNeedsAlign.pop();
                    (0, $e4f40c424e9cabd2$export$51f3e70a54405d5a)(alignTo.scale, alignTo.model);
                }
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                    (0, $39febf0efba5cfc4$export$c0b3be0e9eb0c2d9)(axis.scale, axis.model, alignTo.scale);
                });
            }
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $3129b721b1bf767f$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $3129b721b1bf767f$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid.
   *
   * [NOTE]
   * If both "grid.containLabel/grid.contain" and pixel-required-data-processing (such as, "dataSampling")
   * exist, circular dependency occurs in logic.
   * The final compromised sequence is:
   *  1. Calculate "axis.extent" (pixel extent) and AffineTransform based on only "grid layout options".
   *      Not accurate if "grid.containLabel/grid.contain" is required, but it is a compromise to avoid
   *      circular dependency.
   *  2. Perform "series data processing" (where "dataSampling" requires "axis.extent").
   *  3. Calculate "scale.extent" (data extent) based on "processed series data".
   *  4. Modify "axis.extent" for "grid.containLabel/grid.contain":
   *      4.1. Calculate "axis labels" based on "scale.extent".
   *      4.2. Modify "axis.extent" by the bounding rects of "axis labels and names".
   */ Grid.prototype.resize = function(gridModel, api, beforeDataProcessing) {
        var layoutRef = (0, $4fb3a6a3c6974639$export$5aec1e94f566e59f)(gridModel, api);
        var gridRect = this._rect = (0, $4fb3a6a3c6974639$export$4517a5ca639a7293)(gridModel.getBoxLayoutParams(), layoutRef.refContainer);
        // PENDING: whether to support that if the input `coord` is out of the base coord sys,
        //  do not render anything. At present, the behavior is undefined.
        var axesMap = this._axesMap;
        var coordsList = this._coordsList;
        var optionContainLabel = gridModel.get('containLabel'); // No `.get(, true)` for backward compat.
        $3129b721b1bf767f$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
        if (!beforeDataProcessing) {
            var axisBuilderSharedCtx = $3129b721b1bf767f$var$createAxisBiulders(gridRect, coordsList, axesMap, optionContainLabel, api);
            var noPxChange = void 0;
            if (optionContainLabel) {
                if ($3129b721b1bf767f$var$legacyLayOutGridByContainLabel) {
                    // console.time('legacyLayOutGridByContainLabel');
                    $3129b721b1bf767f$var$legacyLayOutGridByContainLabel(this._axesList, gridRect);
                    $3129b721b1bf767f$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
                // console.timeEnd('legacyLayOutGridByContainLabel');
                } else noPxChange = $3129b721b1bf767f$var$layOutGridByOuterBounds(gridRect.clone(), 'axisLabel', null, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            } else {
                var _a = $3129b721b1bf767f$var$prepareOuterBounds(gridModel, gridRect, layoutRef), outerBoundsRect = _a.outerBoundsRect, parsedOuterBoundsContain = _a.parsedOuterBoundsContain, outerBoundsClamp = _a.outerBoundsClamp;
                if (outerBoundsRect) // console.time('layOutGridByOuterBounds');
                noPxChange = $3129b721b1bf767f$var$layOutGridByOuterBounds(outerBoundsRect, parsedOuterBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            }
            // console.time('buildAxesView_determine');
            $3129b721b1bf767f$var$createOrUpdateAxesView(gridRect, axesMap, (0, $d2408e89e8509289$export$31cba7db0a663292).determine, null, noPxChange, layoutRef);
        // console.timeEnd('buildAxesView_determine');
        } // End of beforeDataProcessing
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $46c5bcbd58298b18$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$3129b721b1bf767f$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $2e435b9b73c9fa04$export$2e2bcd8739ae039)(dimName, (0, $e4f40c424e9cabd2$export$8941c4cacdc8f5a5)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse');
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            // If pie (or other similar series) use cartesian2d, the unionExtent logic below is
            // wrong, therefore skip it temporarily. See also in `defaultAxisExtentFromData.ts`.
            // TODO: support union extent in this case.
            if ((0, $ebbe81cd5867016d$export$e447722773749af)(seriesModel)) {
                var axesModelMap = (0, $ebbe81cd5867016d$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$3129b721b1bf767f$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$3129b721b1bf767f$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                unionExtent(data, xAxis);
                unionExtent(data, yAxis);
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)((0, $e4f40c424e9cabd2$export$e4cf30b1e74cd69d)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            (0, $f8a57de9b8820c02$export$7ed0c09d4f5c932e)({
                targetModel: seriesModel,
                coordSysType: 'cartesian2d',
                coordSysProvider: coordSysProvider
            });
            function coordSysProvider() {
                var axesModelMap = (0, $ebbe81cd5867016d$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                return grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            }
        });
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $46c5bcbd58298b18$export$988a008d2b9120f4);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $3129b721b1bf767f$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $3129b721b1bf767f$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($3129b721b1bf767f$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $3129b721b1bf767f$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $3129b721b1bf767f$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $e4f40c424e9cabd2$export$3eac36a69f37d52)(axis);
}
function $3129b721b1bf767f$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
function $3129b721b1bf767f$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect) {
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap.x, function(axis) {
        return $3129b721b1bf767f$var$updateAxisExtentTransByGridRect(axis, gridRect.x, gridRect.width);
    });
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap.y, function(axis) {
        return $3129b721b1bf767f$var$updateAxisExtentTransByGridRect(axis, gridRect.y, gridRect.height);
    });
}
function $3129b721b1bf767f$var$updateAxisExtentTransByGridRect(axis, gridXY, gridWH) {
    var extent = [
        0,
        gridWH
    ];
    var idx = axis.inverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);
    $3129b721b1bf767f$var$updateAxisTransform(axis, gridXY);
}
var $3129b721b1bf767f$var$legacyLayOutGridByContainLabel;
function $3129b721b1bf767f$export$9da5287b2e41f334(impl) {
    $3129b721b1bf767f$var$legacyLayOutGridByContainLabel = impl;
}
// Return noPxChange.
function $3129b721b1bf767f$var$layOutGridByOuterBounds(outerBoundsRect, outerBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef) {
    // Assume `updateAllAxisExtentTransByGridRect` has been performed once before this call.
    // [NOTE]:
    // - The bounding rect of the axis elements might be sensitve to variations in `axis.extent` due to strategies
    //  like hideOverlap/moveOverlap. @see the comment in `LabelLayoutBase['suggestIgnore']`.
    // - The final `gridRect` might be slightly smaller than the ideally expected result if labels are giant and
    //  get hidden due to overlapping. More iterations could improve precision, but not performant. We consider
    //  the current result acceptable, since no alignment among charts can be guaranteed when using this feature.
    $3129b721b1bf767f$var$createOrUpdateAxesView(gridRect, axesMap, (0, $d2408e89e8509289$export$31cba7db0a663292).estimate, outerBoundsContain, false, layoutRef);
    var margin = [
        0,
        0,
        0,
        0
    ];
    fillLabelNameOverflowOnOneDimension(0);
    fillLabelNameOverflowOnOneDimension(1);
    // If axis is blank, no label can be used to detect overflow.
    // gridRect itself should not overflow.
    fillMarginOnOneDimension(gridRect, 0, NaN);
    fillMarginOnOneDimension(gridRect, 1, NaN);
    var noPxChange = (0, $99026af6cdabc3e1$export$71aa6c912b956294)(margin, function(item) {
        return item > 0;
    }) == null;
    (0, $055606553475f5d6$export$81ed941fdeb91c7c)(gridRect, margin, true, true, outerBoundsClamp);
    $3129b721b1bf767f$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
    return noPxChange;
    function fillLabelNameOverflowOnOneDimension(xyIdx) {
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap[(0, $055606553475f5d6$export$cb4c12294149dd2d)[xyIdx]], function(axis) {
            if (!(0, $e4f40c424e9cabd2$export$75b737736393e03c)(axis.model)) return;
            // FIXME: zr Group.union may wrongly union (0, 0, 0, 0) and not performant.
            // unionRect.union(axis.axisBuilder.group.getBoundingRect());
            // If ussing Group.getBoundingRect to calculate shrink space, it is not strictly accurate when
            // the outermost label is ignored and the secondary label is very long and contribute to the
            // union extension:
            //      -|---|---|---|
            //         1,000,000,000
            // Therefore we calculate them one by one.
            // Also considered axis may be blank or no labels.
            var sharedRecord = axisBuilderSharedCtx.ensureRecord(axis.model);
            var labelInfoList = sharedRecord.labelInfoList;
            if (labelInfoList) for(var idx = 0; idx < labelInfoList.length; idx++){
                var labelInfo = labelInfoList[idx];
                var proportion = axis.scale.normalize((0, $71fd40fa855e325e$export$c392b818a26a879e)(labelInfo.label).tickValue);
                proportion = xyIdx === 1 ? 1 - proportion : proportion;
                // xAxis use proportion on x, yAxis use proprotion on y, otherwise not.
                fillMarginOnOneDimension(labelInfo.rect, xyIdx, proportion);
                fillMarginOnOneDimension(labelInfo.rect, 1 - xyIdx, NaN);
            }
            var nameLayout = sharedRecord.nameLayout;
            if (nameLayout) {
                var proportion = (0, $e4f40c424e9cabd2$export$c06aa22293dea9d2)(sharedRecord.nameLocation) ? 0.5 : NaN;
                fillMarginOnOneDimension(nameLayout.rect, xyIdx, proportion);
                fillMarginOnOneDimension(nameLayout.rect, 1 - xyIdx, NaN);
            }
        });
    }
    function fillMarginOnOneDimension(itemRect, xyIdx, proportion // NaN mean no use proportion
    ) {
        var overflow1 = outerBoundsRect[(0, $055606553475f5d6$export$cb4c12294149dd2d)[xyIdx]] - itemRect[(0, $055606553475f5d6$export$cb4c12294149dd2d)[xyIdx]];
        var overflow2 = itemRect[(0, $055606553475f5d6$export$a3fe6d967173a3ac)[xyIdx]] + itemRect[(0, $055606553475f5d6$export$cb4c12294149dd2d)[xyIdx]] - (outerBoundsRect[(0, $055606553475f5d6$export$a3fe6d967173a3ac)[xyIdx]] + outerBoundsRect[(0, $055606553475f5d6$export$cb4c12294149dd2d)[xyIdx]]);
        overflow1 = applyProportion(overflow1, 1 - proportion);
        overflow2 = applyProportion(overflow2, proportion);
        var minIdx = $3129b721b1bf767f$var$XY_TO_MARGIN_IDX[xyIdx][0];
        var maxIdx = $3129b721b1bf767f$var$XY_TO_MARGIN_IDX[xyIdx][1];
        margin[minIdx] = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(margin[minIdx], overflow1);
        margin[maxIdx] = (0, $bfe945a83b4d28b9$export$2ca8010d037f830f)(margin[maxIdx], overflow2);
    }
    function applyProportion(overflow, proportion) {
        // proportion is not likely to near zero. If so, give up shrink
        if (overflow > 0 && !(0, $99026af6cdabc3e1$export$7d667b9a0c48c975)(proportion) && proportion > 1e-4) overflow /= proportion;
        return overflow;
    }
}
function $3129b721b1bf767f$var$createAxisBiulders(gridRect, cartesians, axesMap, optionContainLabel, api) {
    var axisBuilderSharedCtx = new (0, $71fd40fa855e325e$export$f2e237206f7393f5)($3129b721b1bf767f$var$resolveAxisNameOverlapForGrid);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $e4f40c424e9cabd2$export$75b737736393e03c)(axis.model)) {
                // See `AxisBaseOptionCommon['nameMoveOverlap']`.
                var defaultNameMoveOverlap = !optionContainLabel;
                axis.axisBuilder = (0, $ebbe81cd5867016d$export$2b2ce820c3e1e776)(gridRect, cartesians, axis.model, api, axisBuilderSharedCtx, defaultNameMoveOverlap);
            }
        });
    });
    return axisBuilderSharedCtx;
}
/**
 * Promote the axis-elements-building from "view render" stage to "coordinate system resize" stage.
 * This is aimed to resovle overlap across multiple axes, since currently it's hard to reconcile
 * multiple axes in "view render" stage.
 *
 * [CAUTION] But this promotion assumes that the subsequent "visual mapping" stage does not affect
 * this axis-elements-building; otherwise we have to refactor it again.
 */ function $3129b721b1bf767f$var$createOrUpdateAxesView(gridRect, axesMap, kind, outerBoundsContain, noPxChange, layoutRef) {
    var isDetermine = kind === (0, $d2408e89e8509289$export$31cba7db0a663292).determine;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $e4f40c424e9cabd2$export$75b737736393e03c)(axis.model)) {
                (0, $ebbe81cd5867016d$export$3e8d41f03e1a6a39)(axis.axisBuilder, gridRect, axis.model);
                axis.axisBuilder.build(isDetermine ? {
                    axisTickLabelDetermine: true
                } : {
                    axisTickLabelEstimate: true
                }, {
                    noPxChange: noPxChange
                });
            }
        });
    });
    var nameMarginLevelMap = {
        x: 0,
        y: 0
    };
    calcNameMarginLevel(0);
    calcNameMarginLevel(1);
    function calcNameMarginLevel(xyIdx) {
        nameMarginLevelMap[(0, $055606553475f5d6$export$cb4c12294149dd2d)[1 - xyIdx]] = gridRect[(0, $055606553475f5d6$export$a3fe6d967173a3ac)[xyIdx]] <= layoutRef.refContainer[(0, $055606553475f5d6$export$a3fe6d967173a3ac)[xyIdx]] * 0.5 ? 0 : 1 - xyIdx === 1 ? 2 : 1;
    }
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axesMap, function(axisList, xy) {
        return (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $e4f40c424e9cabd2$export$75b737736393e03c)(axis.model)) {
                if (outerBoundsContain === 'all' || isDetermine) // To resolve overlap, `axisName` layout depends on `axisTickLabel` layout result
                // (all of the axes of the same `grid`; consider multiple x or y axes).
                axis.axisBuilder.build({
                    axisName: true
                }, {
                    nameMarginLevel: nameMarginLevelMap[xy]
                });
                if (isDetermine) axis.axisBuilder.build({
                    axisLine: true
                });
            }
        });
    });
}
function $3129b721b1bf767f$var$prepareOuterBounds(gridModel, rawRridRect, layoutRef) {
    var outerBoundsRect;
    var optionOuterBoundsMode = gridModel.get('outerBoundsMode', true);
    if (optionOuterBoundsMode === 'same') outerBoundsRect = rawRridRect.clone();
    else if (optionOuterBoundsMode == null || optionOuterBoundsMode === 'auto') outerBoundsRect = (0, $4fb3a6a3c6974639$export$4517a5ca639a7293)(gridModel.get('outerBounds', true) || (0, $af17b4c830542881$export$57b4bb4ff2a0950c), layoutRef.refContainer);
    else optionOuterBoundsMode;
    var optionOuterBoundsContain = gridModel.get('outerBoundsContain', true);
    var parsedOuterBoundsContain;
    if (optionOuterBoundsContain == null || optionOuterBoundsContain === 'auto') parsedOuterBoundsContain = 'all';
    else if ((0, $99026af6cdabc3e1$export$305f7d4e9d4624f2)([
        'all',
        'axisLabel'
    ], optionOuterBoundsContain) < 0) parsedOuterBoundsContain = 'all';
    else parsedOuterBoundsContain = optionOuterBoundsContain;
    var outerBoundsClamp = [
        (0, $bfe945a83b4d28b9$export$6b392db7c2374a1a)((0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(gridModel.get('outerBoundsClampWidth', true), (0, $af17b4c830542881$export$e78e6bf4dcc3e485)[0]), rawRridRect.width),
        (0, $bfe945a83b4d28b9$export$6b392db7c2374a1a)((0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(gridModel.get('outerBoundsClampHeight', true), (0, $af17b4c830542881$export$e78e6bf4dcc3e485)[1]), rawRridRect.height)
    ];
    return {
        outerBoundsRect: outerBoundsRect,
        parsedOuterBoundsContain: parsedOuterBoundsContain,
        outerBoundsClamp: outerBoundsClamp
    };
}
var $3129b721b1bf767f$var$resolveAxisNameOverlapForGrid = function resolveAxisNameOverlapForGrid(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    var perpendicularDim = axisModel.axis.dim === 'x' ? 'y' : 'x';
    (0, $71fd40fa855e325e$export$7fcb8742f5816cae)(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord);
    // If nameLocation 'center', and there are multiple axes parallel to this axis, do not adjust by
    //  other axes, because the axis name should be close to its axis line as much as possible even
    //  if overlapping; otherwise it might cause misleading.
    // If nameLocation 'center', do not adjust by perpendicular axes, since they are not likely to overlap.
    // If nameLocation 'start'/'end', move name within the same direction to escape overlap with the
    //  perpendicular axes.
    if (!(0, $e4f40c424e9cabd2$export$c06aa22293dea9d2)(cfg.nameLocation)) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(ctx.recordMap[perpendicularDim], function(perpenRecord) {
        // perpendicular axis may be no name.
        if (perpenRecord && perpenRecord.labelInfoList && perpenRecord.dirVec) (0, $71fd40fa855e325e$export$e033c6449cc6f6a1)(perpenRecord.labelInfoList, perpenRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
    });
};
var $3129b721b1bf767f$export$2e2bcd8739ae039 = $3129b721b1bf767f$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $23cf311db22bc27b$var$inner = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();
function $23cf311db22bc27b$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true,
        breakTicks: 'none',
        pruneByBreak: 'preserve_extent_bound'
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $23cf311db22bc27b$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $99026af6cdabc3e1$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $99026af6cdabc3e1$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $aed3569651b5e3fa$export$2e2bcd8739ae039({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $99026af6cdabc3e1$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $23cf311db22bc27b$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $23cf311db22bc27b$export$48ebf2d6ce8ad076(axisView) {
    $23cf311db22bc27b$var$inner(axisView).splitAreaColors = null;
}




var $cae29c21a0b223c2$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine',
    'breakArea'
];
var $cae29c21a0b223c2$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $2b89655bc310a947$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!(0, $e4f40c424e9cabd2$export$75b737736393e03c)(axisModel)) return;
        this._axisGroup.add(axisModel.axis.axisBuilder.group);
        $99026af6cdabc3e1$export$79b2f7037acddd43($cae29c21a0b223c2$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $cae29c21a0b223c2$var$axisElementBuilders[name](this, this._axisGroup, axisModel, axisModel.getCoordSysModel(), api);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $055606553475f5d6$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $23cf311db22bc27b$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $4cde784d925ed2eb$export$2e2bcd8739ae039));
var $cae29c21a0b223c2$var$axisElementBuilders = {
    splitLine: function splitLine(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var showMinLine = splitLineModel.get('showMinLine') !== false;
        var showMaxLine = splitLineModel.get('showMaxLine') !== false;
        lineColors = $99026af6cdabc3e1$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: 'none',
            pruneByBreak: 'preserve_extent_bound'
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $a32872499189f58f$export$2e2bcd8739ae039({
                anid: tickValue != null ? 'line_' + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $99026af6cdabc3e1$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $055606553475f5d6$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function minorSplitLine(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $a32872499189f58f$export$2e2bcd8739ae039({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $055606553475f5d6$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function splitArea(axisView, axisGroup, axisModel, gridModel, api) {
        (0, $23cf311db22bc27b$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    },
    breakArea: function breakArea(axisView, axisGroup, axisModel, gridModel, api) {
        var axisBreakHelper = (0, $2d7c12def48f6bbb$export$c1d9b2cc33e7e5e)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== 'ordinal') axisBreakHelper.rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, gridModel.coordinateSystem.getRect(), api);
    }
};
var $cae29c21a0b223c2$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($cae29c21a0b223c2$var$CartesianAxisView);
var $cae29c21a0b223c2$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $cae29c21a0b223c2$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($cae29c21a0b223c2$var$CartesianAxisView);
var $cae29c21a0b223c2$export$2e2bcd8739ae039 = $cae29c21a0b223c2$var$CartesianAxisView;


// Grid view
var $33eb11959254e4a8$var$GridView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $aed3569651b5e3fa$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $3e14d76796640b86$export$2e2bcd8739ae039));
var $33eb11959254e4a8$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $33eb11959254e4a8$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($33eb11959254e4a8$var$GridView);
    registers.registerComponentModel((0, $af17b4c830542881$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('cartesian2d', (0, $3129b721b1bf767f$export$2e2bcd8739ae039));
    (0, $8b6678f109b4498b$export$2e2bcd8739ae039)(registers, 'x', (0, $82a0595664d9a818$export$483dc37e6ad83a3c), $33eb11959254e4a8$var$extraOption);
    (0, $8b6678f109b4498b$export$2e2bcd8739ae039)(registers, 'y', (0, $82a0595664d9a818$export$483dc37e6ad83a3c), $33eb11959254e4a8$var$extraOption);
    registers.registerComponentView((0, $cae29c21a0b223c2$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $cae29c21a0b223c2$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}




function $e86e8601d0821891$export$4b3e715f166fdd78(registers) {
    (0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $33eb11959254e4a8$export$4b3e715f166fdd78));
    (0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $928bdc65399e8455$export$4b3e715f166fdd78));
}




var $4da4535132a86ee9$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $e86e8601d0821891$export$4b3e715f166fdd78));
var $4da4535132a86ee9$export$6e19c3cdcdeb670f = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECGridComponent, ECOptionElement);
    function ECGridComponent() {
        (0, $7lhcp._)(this, ECGridComponent);
        return (0, $07dqX._)(this, ECGridComponent, arguments);
    }
    return ECGridComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($4da4535132a86ee9$var$_a = globalThis.customElements) === null || $4da4535132a86ee9$var$_a === void 0 || $4da4535132a86ee9$var$_a.define('ec-grid', $4da4535132a86ee9$export$6e19c3cdcdeb670f);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");



var $3ebea454486cd0b1$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $e86e8601d0821891$export$4b3e715f166fdd78));
var $3ebea454486cd0b1$export$7f67bc504bca3675 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECXAxisComponent, ECOptionElement);
    function ECXAxisComponent() {
        (0, $7lhcp._)(this, ECXAxisComponent);
        return (0, $07dqX._)(this, ECXAxisComponent, arguments);
    }
    return ECXAxisComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($3ebea454486cd0b1$var$_a = globalThis.customElements) === null || $3ebea454486cd0b1$var$_a === void 0 || $3ebea454486cd0b1$var$_a.define('ec-x-axis', $3ebea454486cd0b1$export$7f67bc504bca3675);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");



var $ccb1f2ca897483af$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $e86e8601d0821891$export$4b3e715f166fdd78));
var $ccb1f2ca897483af$export$6c73b4102a25a459 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECYAxisComponent, ECOptionElement);
    function ECYAxisComponent() {
        (0, $7lhcp._)(this, ECYAxisComponent);
        return (0, $07dqX._)(this, ECYAxisComponent, arguments);
    }
    return ECYAxisComponent;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($ccb1f2ca897483af$var$_a = globalThis.customElements) === null || $ccb1f2ca897483af$var$_a === void 0 || $ccb1f2ca897483af$var$_a.define('ec-y-axis', $ccb1f2ca897483af$export$6c73b4102a25a459);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c6a60e985634cbd5$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $c6a60e985634cbd5$var$defaultKeyGetter(item) {
    return item;
}
var $c6a60e985634cbd5$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $c6a60e985634cbd5$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $c6a60e985634cbd5$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $c6a60e985634cbd5$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $c6a60e985634cbd5$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $c6a60e985634cbd5$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $c6a60e985634cbd5$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $c6a60e985634cbd5$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $c6a60e985634cbd5$export$2e2bcd8739ae039 = $c6a60e985634cbd5$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $b3cbe932f42a4db7$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $b3cbe932f42a4db7$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $b3cbe932f42a4db7$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($b3cbe932f42a4db7$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $b3cbe932f42a4db7$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $b80138b23bdc0dba$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $b3cbe932f42a4db7$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $b3cbe932f42a4db7$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $b3cbe932f42a4db7$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $b3cbe932f42a4db7$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $b3cbe932f42a4db7$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3dec8b494a525754$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $99026af6cdabc3e1$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $3dec8b494a525754$export$2e2bcd8739ae039 = $3dec8b494a525754$var$SeriesDimensionDefine;








var $8b95141abf364b52$var$isObject = $99026af6cdabc3e1$export$a6cdc56e425d0d0a;
var $8b95141abf364b52$var$map = $99026af6cdabc3e1$export$871de8747c9eaa88;
var $8b95141abf364b52$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $8b95141abf364b52$var$ID_PREFIX = 'e\0\0';
var $8b95141abf364b52$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $8b95141abf364b52$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $8b95141abf364b52$var$CLONE_PROPERTIES = [
    '_approximateExtent'
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $8b95141abf364b52$var$prepareInvertedIndex;
var $8b95141abf364b52$var$getId;
var $8b95141abf364b52$var$getIdNameFromStore;
var $8b95141abf364b52$var$normalizeDimensions;
var $8b95141abf364b52$var$transferProperties;
var $8b95141abf364b52$var$cloneListForMapAndSample;
var $8b95141abf364b52$var$makeIdFromName;
var $8b95141abf364b52$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'minmaxDownSample',
            'lttbDownSample',
            'map'
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'minmaxDownSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $b0859ee1450fbeb2$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $99026af6cdabc3e1$export$844ec244b1367d54(dimInfoInput) ? new (0, $3dec8b494a525754$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $3dec8b494a525754$export$2e2bcd8739ae039)) ? new (0, $3dec8b494a525754$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            var dimIdx = i;
            if ($99026af6cdabc3e1$export$7e4aa119212bc614(dimensionInfo.storeDimIndex)) dimIdx = dimensionInfo.storeDimIndex;
            if (otherDims.itemName === 0) this._nameDimIdx = dimIdx;
            if (otherDims.itemId === 0) this._idDimIdx = dimIdx;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $99026af6cdabc3e1$export$55f8aa7ef875b0a4();
            $99026af6cdabc3e1$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($99026af6cdabc3e1$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $6ad4751b8ddd4ab8$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $628ec8437ba688c7$export$22b808bc02a60488)(data) || $99026af6cdabc3e1$export$1e2f57719e155213(data) ? new (0, $6f754cc48dca56f7$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $6ad4751b8ddd4ab8$export$2e2bcd8739ae039)();
            var dimensionInfos = $8b95141abf364b52$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $b3cbe932f42a4db7$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $8b95141abf364b52$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $b80138b23bdc0dba$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $08bfa015475effa8$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $08bfa015475effa8$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $08bfa015475effa8$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$8b95141abf364b52$var$makeIdFromName(this, idx);
        $8b95141abf364b52$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $8b95141abf364b52$var$isObject(key) ? $99026af6cdabc3e1$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $8b95141abf364b52$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $8b95141abf364b52$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $99026af6cdabc3e1$export$43bee75e5e14138e(dimensions) ? store.getValues($8b95141abf364b52$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $8b95141abf364b52$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if ($99026af6cdabc3e1$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $8b95141abf364b52$var$map($8b95141abf364b52$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $99026af6cdabc3e1$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if ($99026af6cdabc3e1$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $8b95141abf364b52$var$map($8b95141abf364b52$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $99026af6cdabc3e1$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $99026af6cdabc3e1$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $99026af6cdabc3e1$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if ($99026af6cdabc3e1$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict';
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $8b95141abf364b52$var$map($8b95141abf364b52$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $8b95141abf364b52$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $99026af6cdabc3e1$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $8b95141abf364b52$var$map($8b95141abf364b52$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $99026af6cdabc3e1$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $8b95141abf364b52$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $8b95141abf364b52$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $8b95141abf364b52$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $a48e58444b640d0e$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $c6a60e985634cbd5$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $8b95141abf364b52$var$getId(otherList, idx);
        }, function(idx) {
            return $8b95141abf364b52$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($8b95141abf364b52$var$isObject(kvObj)) $99026af6cdabc3e1$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($99026af6cdabc3e1$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($8b95141abf364b52$var$isObject(val)) val = $99026af6cdabc3e1$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($8b95141abf364b52$var$isObject(key)) $99026af6cdabc3e1$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $8b95141abf364b52$var$isObject(key) ? $99026af6cdabc3e1$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $99026af6cdabc3e1$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $f10cebeaa5f49a40$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $99026af6cdabc3e1$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $8b95141abf364b52$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $8b95141abf364b52$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$99026af6cdabc3e1$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($99026af6cdabc3e1$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $8b95141abf364b52$var$prepareInvertedIndex = function prepareInvertedIndex(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $99026af6cdabc3e1$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $8b95141abf364b52$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $8b95141abf364b52$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $8b95141abf364b52$var$getIdNameFromStore = function getIdNameFromStore(data, dimIdx, idx) {
            return (0, $08bfa015475effa8$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $8b95141abf364b52$var$getId = function getId(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $8b95141abf364b52$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $8b95141abf364b52$var$ID_PREFIX + rawIndex;
            return id;
        };
        $8b95141abf364b52$var$normalizeDimensions = function normalizeDimensions(dimensions) {
            if (!$99026af6cdabc3e1$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $8b95141abf364b52$var$cloneListForMapAndSample = function cloneListForMapAndSample(original) {
            var list = new SeriesData(original._schema ? original._schema : $8b95141abf364b52$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $8b95141abf364b52$var$transferProperties(list, original);
            return list;
        };
        $8b95141abf364b52$var$transferProperties = function transferProperties(target, source) {
            $99026af6cdabc3e1$export$79b2f7037acddd43($8b95141abf364b52$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $99026af6cdabc3e1$export$79b2f7037acddd43($8b95141abf364b52$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $99026af6cdabc3e1$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $99026af6cdabc3e1$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $8b95141abf364b52$var$makeIdFromName = function makeIdFromName(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $8b95141abf364b52$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $8b95141abf364b52$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $8b95141abf364b52$export$2e2bcd8739ae039 = $8b95141abf364b52$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $86a55e4e24f7b742$export$8066c1b52b2e9504(source, opt) {
    return $86a55e4e24f7b742$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $86a55e4e24f7b742$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $628ec8437ba688c7$export$22b808bc02a60488)(source)) source = (0, $628ec8437ba688c7$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $86a55e4e24f7b742$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $b0859ee1450fbeb2$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $b0859ee1450fbeb2$export$be39ae17310c33f7)(source) : (0, $b0859ee1450fbeb2$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $6ad4751b8ddd4ab8$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $3dec8b494a525754$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $08bfa015475effa8$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $99026af6cdabc3e1$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $99026af6cdabc3e1$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $08bfa015475effa8$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $b80138b23bdc0dba$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $86a55e4e24f7b742$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $fbbcfa54d383b92f$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $fbbcfa54d383b92f$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $86a55e4e24f7b742$var$removeDuplication(resultList);
    return new (0, $b0859ee1450fbeb2$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $86a55e4e24f7b742$var$removeDuplication(result) {
    var duplicationMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $86a55e4e24f7b742$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $86a55e4e24f7b742$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $28b2fc918c4af04a$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $99026af6cdabc3e1$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $28b2fc918c4af04a$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $28b2fc918c4af04a$var$CoordSysInfo(coordSysName);
    var fetch = $28b2fc918c4af04a$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
// TODO: refactor them to static member of each coord sys, rather than hard code here.
var $28b2fc918c4af04a$var$fetchers = {
    cartesian2d: function cartesian2d(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($28b2fc918c4af04a$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($28b2fc918c4af04a$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function singleAxis(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($28b2fc918c4af04a$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function polar(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($28b2fc918c4af04a$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($28b2fc918c4af04a$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function geo(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function parallel(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($28b2fc918c4af04a$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    },
    matrix: function matrix(seriesModel, result, axisMap, categoryAxisMap) {
        var matrixModel = seriesModel.getReferringComponents('matrix', (0, $08bfa015475effa8$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        var xModel = matrixModel.getDimensionModel('x');
        var yModel = matrixModel.getDimensionModel('y');
        axisMap.set('x', xModel);
        axisMap.set('y', yModel);
        categoryAxisMap.set('x', xModel);
        categoryAxisMap.set('y', yModel);
    }
};
function $28b2fc918c4af04a$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}






function $036d1b275291163e$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $f8a57de9b8820c02$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $99026af6cdabc3e1$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $b3cbe932f42a4db7$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $036d1b275291163e$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $99026af6cdabc3e1$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $036d1b275291163e$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $628ec8437ba688c7$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $28b2fc918c4af04a$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $036d1b275291163e$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $99026af6cdabc3e1$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $99026af6cdabc3e1$export$c3095a23b368d1f2((0, $fbbcfa54d383b92f$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $86a55e4e24f7b742$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $036d1b275291163e$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $899284ff307f95b1$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $8b95141abf364b52$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $036d1b275291163e$var$isNeedCompleteOrdinalData(source) ? function dimValueGetter(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $036d1b275291163e$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $b80138b23bdc0dba$export$2823037fb9d8f0c6)) {
        var sampleItem = $036d1b275291163e$var$firstDataNotNull(source.data || []);
        return !$99026af6cdabc3e1$export$43bee75e5e14138e((0, $08bfa015475effa8$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $036d1b275291163e$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $036d1b275291163e$export$2e2bcd8739ae039 = $036d1b275291163e$var$createSeriesData;






var $06e2162f8d139cbf$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $036d1b275291163e$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $2b89655bc310a947$export$2e2bcd8739ae039)();
        var line = (0, $daf140cd8c7d5a6f$export$af050e04da3a02e8)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual('symbol');
        var visualRotate = this.getData().getVisual('symbolRotate');
        var symbolType = visualType === 'none' ? 'circle' : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $daf140cd8c7d5a6f$export$af050e04da3a02e8)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf('empty') > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral00;
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = 'series.line';
    LineSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        clip: true,
        label: {
            position: 'top'
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: 'solid'
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: 'emptyCircle',
        symbolSize: 6,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: 'auto',
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: 'none',
        animationEasing: 'linear',
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: 'clone'
        },
        triggerLineEvent: false
    };
    return LineSeriesModel;
}((0, $358fe4ff615f1b87$export$2e2bcd8739ae039));
var $06e2162f8d139cbf$export$2e2bcd8739ae039 = $06e2162f8d139cbf$var$LineSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $1202a9442ec6b59f$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $6f754cc48dca56f7$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $6f754cc48dca56f7$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $1202a9442ec6b59f$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}






var $464fddb9c566bc19$var$Symbol = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, z2, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $daf140cd8c7d5a6f$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(z2, 100),
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $464fddb9c566bc19$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $ea1f7a1fbd33fd2d$export$b2d02638cc34c042)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $ea1f7a1fbd33fd2d$export$11be6f716239ac55)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? 'move' : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var z2 = Symbol.getSymbolZ2(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
            this._createSymbol(symbolType, data, idx, symbolSize, z2, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $821b3c1b9ddcee3a$export$c8dce3c08436e91e(symbolPath, target, seriesModel, idx);
            (0, $821b3c1b9ddcee3a$export$bca7290a9faf0ec9)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $821b3c1b9ddcee3a$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation('leave');
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            selectItemStyle = itemModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            emphasisDisabled = emphasisModel.get('disabled');
            labelStatesModels = (0, $a4fed78c55651c93$export$9739a32674be5893)(itemModel);
            hoverScale = emphasisModel.getShallow('scale');
            cursorStyle = itemModel.getShallow('cursor');
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $daf140cd8c7d5a6f$export$e3e292895c033f6d)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr('cursor', cursorStyle);
        var symbolStyle = data.getItemVisual(idx, 'style');
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $a3b3990206d5aa78$export$2e2bcd8739ae039)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $99026af6cdabc3e1$export$8b58be045bf06082)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, 'liftZ');
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $a4fed78c55651c93$export$9a13992917966657)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $1202a9442ec6b59f$export$5ff20667590927ed)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState('emphasis');
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState('select').style = selectItemStyle;
        symbolPath.ensureState('blur').style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $ea1f7a1fbd33fd2d$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $821b3c1b9ddcee3a$export$f883456a56996078(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function cb() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $821b3c1b9ddcee3a$export$f883456a56996078(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $daf140cd8c7d5a6f$export$a84524f03e8e8dfb)(data.getItemVisual(idx, 'symbolSize'));
    };
    Symbol.getSymbolZ2 = function(data, idx) {
        return data.getItemVisual(idx, 'z2');
    };
    return Symbol;
}($2b89655bc310a947$export$2e2bcd8739ae039);
function $464fddb9c566bc19$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $464fddb9c566bc19$export$2e2bcd8739ae039 = $464fddb9c566bc19$var$Symbol;




function $6db4eaf37251b0cc$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
function $6db4eaf37251b0cc$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $99026af6cdabc3e1$export$a6cdc56e425d0d0a)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $6db4eaf37251b0cc$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel('emphasis');
    return {
        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle(),
        focus: emphasisModel.get('focus'),
        blurScope: emphasisModel.get('blurScope'),
        emphasisDisabled: emphasisModel.get('disabled'),
        hoverScale: emphasisModel.get('scale'),
        labelStatesModels: (0, $a4fed78c55651c93$export$9739a32674be5893)(seriesModel),
        cursorStyle: seriesModel.get('cursor')
    };
}
var $6db4eaf37251b0cc$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $2b89655bc310a947$export$2e2bcd8739ae039();
        this._SymbolCtor = SymbolCtor || (0, $464fddb9c566bc19$export$2e2bcd8739ae039);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $6db4eaf37251b0cc$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $6db4eaf37251b0cc$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($6db4eaf37251b0cc$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$6db4eaf37251b0cc$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $821b3c1b9ddcee3a$export$c8dce3c08436e91e(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $6db4eaf37251b0cc$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $6db4eaf37251b0cc$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($6db4eaf37251b0cc$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $055606553475f5d6$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $6db4eaf37251b0cc$export$2e2bcd8739ae039 = $6db4eaf37251b0cc$var$SymbolDraw;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $d0b99fb37100e8f6$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $d0b99fb37100e8f6$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
    var dims = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo('stackResultDimension');
    if ((0, $899284ff307f95b1$export$1dedc39359ae35c)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $899284ff307f95b1$export$1dedc39359ae35c)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
    };
}
function $d0b99fb37100e8f6$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === 'start') valueStart = extent[0];
    else if (valueOrigin === 'end') valueStart = extent[1];
    else if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $d0b99fb37100e8f6$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}



function $935b67c70e52794b$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: '+',
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: '=',
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: '-',
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $935b67c70e52794b$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $935b67c70e52794b$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $d0b99fb37100e8f6$export$b488a529581b37e)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout('points') || [];
    var newPoints = newData.getLayout('points') || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case '=':
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case '+':
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $d0b99fb37100e8f6$export$c1601aa630e7b5f8)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case '-':
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(len);
    var sortedNextPoints = (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(len);
    var sortedCurrStackedPoints = (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(len);
    var sortedNextStackedPoints = (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $be040fbda4a31ebd$var$mathMin = Math.min;
var $be040fbda4a31ebd$var$mathMax = Math.max;
function $be040fbda4a31ebd$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $be040fbda4a31ebd$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($be040fbda4a31ebd$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($be040fbda4a31ebd$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || $be040fbda4a31ebd$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === 'x') {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === 'y') {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $be040fbda4a31ebd$var$mathMin(nextCpx0, $be040fbda4a31ebd$var$mathMax(nextX, x));
                        nextCpy0 = $be040fbda4a31ebd$var$mathMin(nextCpy0, $be040fbda4a31ebd$var$mathMax(nextY, y));
                        nextCpx0 = $be040fbda4a31ebd$var$mathMax(nextCpx0, $be040fbda4a31ebd$var$mathMin(nextX, x));
                        nextCpy0 = $be040fbda4a31ebd$var$mathMax(nextCpy0, $be040fbda4a31ebd$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $be040fbda4a31ebd$var$mathMin(cpx1, $be040fbda4a31ebd$var$mathMax(prevX, x));
                        cpy1 = $be040fbda4a31ebd$var$mathMin(cpy1, $be040fbda4a31ebd$var$mathMax(prevY, y));
                        cpx1 = $be040fbda4a31ebd$var$mathMax(cpx1, $be040fbda4a31ebd$var$mathMin(prevX, x));
                        cpy1 = $be040fbda4a31ebd$var$mathMax(cpy1, $be040fbda4a31ebd$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $be040fbda4a31ebd$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $be040fbda4a31ebd$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polyline';
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.neutral99,
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $be040fbda4a31ebd$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$be040fbda4a31ebd$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$be040fbda4a31ebd$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $be040fbda4a31ebd$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $a1b116230ebefd82$export$2e2bcd8739ae039).CMD;
        var x0;
        var y0;
        var isDimX = dim === 'x';
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $196091227dfded05$export$ca5d13faa10b167e)(x0, x, x2, x3, xOrY, roots) : (0, $196091227dfded05$export$ca5d13faa10b167e)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $196091227dfded05$export$547c21de482bbcb2)(y0, y, y2, y3, t_1) : (0, $196091227dfded05$export$547c21de482bbcb2)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
var $be040fbda4a31ebd$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($be040fbda4a31ebd$var$ECPolylineShape);
var $be040fbda4a31ebd$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polygon';
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $be040fbda4a31ebd$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$be040fbda4a31ebd$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$be040fbda4a31ebd$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $be040fbda4a31ebd$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $be040fbda4a31ebd$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $4be68cb18e195d91$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $aed3569651b5e3fa$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(during) ? function duringCb(percent) {
            during(percent, clipPath);
        } : null;
        $821b3c1b9ddcee3a$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $4be68cb18e195d91$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $d5aef629841de604$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $bfe945a83b4d28b9$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $821b3c1b9ddcee3a$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $4be68cb18e195d91$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $4be68cb18e195d91$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $4be68cb18e195d91$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $73241c96b18662c0$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}









function $4fadc8bb902036a6$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $4fadc8bb902036a6$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $4fadc8bb902036a6$var$getBoundingDiff(points1, points2) {
    var _a = $4fadc8bb902036a6$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $4fadc8bb902036a6$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $4fadc8bb902036a6$var$getSmooth(smooth) {
    return $99026af6cdabc3e1$export$7e4aa119212bc614(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $4fadc8bb902036a6$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $d0b99fb37100e8f6$export$c1601aa630e7b5f8)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
/**
 * Filter the null data and extend data for step considering `stepTurnAt`
 *
 * @param points data to convert, that may containing null
 * @param basePoints base data to reference, used only for areaStyle points
 * @param coordSys coordinate system
 * @param stepTurnAt 'start' | 'end' | 'middle' | true
 * @param connectNulls whether to connect nulls
 * @returns converted point positions
 */ function $4fadc8bb902036a6$var$turnPointsIntoStep(points, basePoints, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2){
            /**
       * For areaStyle of stepped lines, `stackedOnPoints` should be
       * filtered the same as `points` so that the base axis values
       * should stay the same as the lines above. See #20021
       */ var reference = basePoints || points;
            if (!isNaN(reference[i]) && !isNaN(reference[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        }
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case 'end':
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case 'middle':
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $4fadc8bb902036a6$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $9148d8aa0f446713$export$3a89f8d6f6bf6c9f)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $4fadc8bb902036a6$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual('visualMeta');
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== 'cartesian2d') return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === 'x' || coordDim === 'y') {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $99026af6cdabc3e1$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $4fadc8bb902036a6$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return 'transparent';
    $99026af6cdabc3e1$export$79b2f7037acddd43(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || 'transparent'
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || 'transparent'
    });
    var gradient = new $196fa2034a894932$export$2e2bcd8739ae039(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + '2'] = maxCoord;
    return gradient;
}
function $4fadc8bb902036a6$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get('showAllSymbol');
    var isAuto = showAllSymbol === 'auto';
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $4fadc8bb902036a6$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $99026af6cdabc3e1$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $4fadc8bb902036a6$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $464fddb9c566bc19$export$2e2bcd8739ae039).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $4fadc8bb902036a6$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $4fadc8bb902036a6$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$4fadc8bb902036a6$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $4fadc8bb902036a6$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $4fadc8bb902036a6$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === 'x' ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $4fadc8bb902036a6$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        'endLabel',
        'show'
    ])) return true;
    for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b).length; i++){
        if (seriesModel.get([
            (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b)[i],
            'endLabel',
            'show'
        ])) return true;
    }
    return false;
}
function $4fadc8bb902036a6$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $73241c96b18662c0$export$8567506e6336616)(coordSys, 'cartesian2d')) {
        var endLabelModel_1 = seriesModel.getModel('endLabel');
        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $4fadc8bb902036a6$var$anyStateShowEndLabel(seriesModel) ? function during(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $4be68cb18e195d91$export$83958787eb658d14)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get('clip', true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $4be68cb18e195d91$export$13dc2b2230df3cb5)(coordSys, hasAnimation, seriesModel);
}
function $4fadc8bb902036a6$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
    var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
    return {
        normal: {
            align: endLabelModel.get('align') || align,
            verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
        }
    };
}
var $4fadc8bb902036a6$var$LineView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $2b89655bc310a947$export$2e2bcd8739ae039();
        var symbolDraw = new (0, $6db4eaf37251b0cc$export$2e2bcd8739ae039)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
        this._changePolyState = $99026af6cdabc3e1$export$2385a24977818dd0(this._changePolyState, this);
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel('lineStyle');
        var areaStyleModel = seriesModel.getModel('areaStyle');
        var points = data.getLayout('points') || [];
        var isCoordSysPolar = coordSys.type === 'polar';
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get('animation');
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get('origin');
        var dataCoordInfo = (0, $d0b99fb37100e8f6$export$b488a529581b37e)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $4fadc8bb902036a6$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get('showSymbol');
        var connectNulls = seriesModel.get('connectNulls');
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $4fadc8bb902036a6$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $4fadc8bb902036a6$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function getSymbolPoint(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                if (stackedOnPoints) stackedOnPoints = $4fadc8bb902036a6$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                // TODO If stacked series is not step
                points = $4fadc8bb902036a6$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $031dcf3d7ed28374$export$cda04d03233e5555)(visualColor));
            lineGroup.setClipPath($4fadc8bb902036a6$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $031dcf3d7ed28374$export$cda04d03233e5555)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $4fadc8bb902036a6$var$createLineClipPath(this, coordSys, false, seriesModel);
                $821b3c1b9ddcee3a$export$a121566aadcfe021(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($4fadc8bb902036a6$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function getSymbolPoint(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$4fadc8bb902036a6$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$4fadc8bb902036a6$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        if (stackedOnPoints) stackedOnPoints = $4fadc8bb902036a6$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                        // TODO If stacked series is not step
                        points = $4fadc8bb902036a6$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');
        polyline.useStyle($99026af6cdabc3e1$export$ebe90cb607ad99e(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: 'none',
            stroke: visualColor,
            lineJoin: 'bevel'
        }));
        (0, $ea1f7a1fbd33fd2d$export$48b68047d330bbc9)(polyline, seriesModel, 'lineStyle');
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            'emphasis',
            'lineStyle',
            'width'
        ]) === 'bolder') {
            var emphasisLineStyle = polyline.getState('emphasis').style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $ea1f7a1fbd33fd2d$export$e51187539ff11209)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $4fadc8bb902036a6$var$getSmooth(seriesModel.get('smooth'));
        var smoothMonotone = seriesModel.get('smoothMonotone');
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
            var stackedOnSmooth = 0;
            polygon.useStyle($99026af6cdabc3e1$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: 'bevel',
                decal: data.getVisual('style').decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $4fadc8bb902036a6$var$getSmooth(stackedOnSeries.get('smooth'));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $ea1f7a1fbd33fd2d$export$48b68047d330bbc9)(polygon, seriesModel, 'areaStyle');
            // Needs seriesIndex for focus
            (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $ea1f7a1fbd33fd2d$export$e51187539ff11209)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = this._changePolyState;
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        if (seriesModel.get('triggerLineEvent')) {
            this.packEventData(seriesModel, polyline);
            polygon && this.packEventData(seriesModel, polygon);
        }
    };
    LineView.prototype.packEventData = function(seriesModel, el) {
        (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el).eventData = {
            componentType: 'series',
            componentSubType: 'line',
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: 'line'
        };
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $08bfa015475effa8$export$42b26cae8b8d10(data, payload);
        this._changePolyState('emphasis');
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout('points');
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get('zlevel') || 0;
                var z = seriesModel.get('z') || 0;
                symbol = new (0, $464fddb9c566bc19$export$2e2bcd8739ae039)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $01349fdbc71d745c$export$2e2bcd8739ae039).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $08bfa015475effa8$export$42b26cae8b8d10(data, payload);
        this._changePolyState('normal');
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $01349fdbc71d745c$export$2e2bcd8739ae039).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $ea1f7a1fbd33fd2d$export$868ba38adffa9e39)(this._polyline, toState);
        polygon && (0, $ea1f7a1fbd33fd2d$export$868ba38adffa9e39)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $be040fbda4a31ebd$export$bf7c0585b8f7d00f)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $be040fbda4a31ebd$export$6042a400d113f2bd)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === 'cartesian2d') {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === 'polar') {
            isHorizontalOrRadial = baseAxis.dim === 'angle';
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get('animationDuration');
        if ($99026af6cdabc3e1$export$f6e2535fb5126e54(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get('animationDelay') || 0;
        var seriesDelayValue = $99026af6cdabc3e1$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $99026af6cdabc3e1$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel('endLabel');
        if ($4fadc8bb902036a6$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout('points');
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $97dfecd189304201$export$2e2bcd8739ae039({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $4fadc8bb902036a6$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $a4fed78c55651c93$export$9a13992917966657)(polyline, (0, $a4fed78c55651c93$export$9739a32674be5893)(seriesModel, 'endLabel'), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function defaultText(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $1202a9442ec6b59f$export$5f84815e91ca6775)(data_2, interpolatedValue) : (0, $1202a9442ec6b59f$export$5ff20667590927ed)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $4fadc8bb902036a6$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout('points');
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get('connectNulls');
            var precision = endLabelModel.get('precision');
            var distance = endLabelModel.get('distance') || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? 'x' : 'y';
            var dataIndexRange = $4fadc8bb902036a6$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $4fadc8bb902036a6$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $08bfa015475effa8$export$bd0439821a1869f3(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $4fadc8bb902036a6$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $a4fed78c55651c93$export$f62786d3261ab0f4)(endLabel);
                if (typeof inner.setLabelText === 'function') inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $935b67c70e52794b$export$2e2bcd8739ae039)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            stackedOnCurrent = $4fadc8bb902036a6$var$turnPointsIntoStep(diff.stackedOnCurrent, diff.current, coordSys, step, connectNulls);
            current = $4fadc8bb902036a6$var$turnPointsIntoStep(diff.current, null, coordSys, step, connectNulls);
            stackedOnNext = $4fadc8bb902036a6$var$turnPointsIntoStep(diff.stackedOnNext, diff.next, coordSys, step, connectNulls);
            next = $4fadc8bb902036a6$var$turnPointsIntoStep(diff.next, null, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($4fadc8bb902036a6$var$getBoundingDiff(current, next) > 3000 || polygon && $4fadc8bb902036a6$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $821b3c1b9ddcee3a$export$c8dce3c08436e91e(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $821b3c1b9ddcee3a$export$c8dce3c08436e91e(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === '=') {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = 'line';
    return LineView;
}((0, $01349fdbc71d745c$export$2e2bcd8739ae039));
var $4fadc8bb902036a6$export$2e2bcd8739ae039 = $4fadc8bb902036a6$var$LineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $028272d6d583ddd2$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $8771d8b8a75043c1$export$2e2bcd8739ae039)(),
        reset: function reset(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            if ((0, $899284ff307f95b1$export$1dedc39359ae35c)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $899284ff307f95b1$export$1dedc39359ae35c)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function progress(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $e8c33ceefbbbca26$export$21d2298f3f56bbaf)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout('points', points);
                }
            };
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cf2266f4fb2a2e00$var$samplers = {
    average: function average(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function sum(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function max(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function min(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function nearest(frame) {
        return frame[0];
    }
};
var $cf2266f4fb2a2e00$var$indexSampler = function indexSampler(frame) {
    return Math.round(frame.length / 2);
};
function $cf2266f4fb2a2e00$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function reset(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === 'minmax') seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $99026af6cdabc3e1$export$844ec244b1367d54)(sampling)) sampler = $cf2266f4fb2a2e00$var$samplers[sampling];
                    else if ((0, $99026af6cdabc3e1$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $cf2266f4fb2a2e00$var$indexSampler));
                }
            }
        }
    };
}


function $71df83f2874b0f45$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $4fadc8bb902036a6$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $06e2162f8d139cbf$export$2e2bcd8739ae039));
    registers.registerLayout((0, $028272d6d583ddd2$export$2e2bcd8739ae039)('line', true));
    registers.registerVisual({
        seriesType: 'line',
        reset: function reset(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual('style').fill;
            data.setVisual('legendLineStyle', lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $cf2266f4fb2a2e00$export$2e2bcd8739ae039)('line'));
}




var $8aea70e01756a63b$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $71df83f2874b0f45$export$4b3e715f166fdd78));
var $8aea70e01756a63b$export$e0c3aabe25f1cc08 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECLineChart, ECOptionElement);
    function ECLineChart() {
        (0, $7lhcp._)(this, ECLineChart);
        return (0, $07dqX._)(this, ECLineChart, arguments);
    }
    return ECLineChart;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($8aea70e01756a63b$var$_a = globalThis.customElements) === null || $8aea70e01756a63b$var$_a === void 0 || $8aea70e01756a63b$var$_a.define('ec-line-chart', $8aea70e01756a63b$export$e0c3aabe25f1cc08);



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $02e579cc2d7f1de3$var$PI2 = Math.PI * 2;
var $02e579cc2d7f1de3$var$RADIAN = Math.PI / 180;
function $02e579cc2d7f1de3$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var _a = (0, $4fb3a6a3c6974639$export$3101c00baac0ee1f)(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0, viewRect = _a.viewRect;
        var startAngle = -seriesModel.get('startAngle') * $02e579cc2d7f1de3$var$RADIAN;
        var endAngle = seriesModel.get('endAngle');
        var padAngle = seriesModel.get('padAngle') * $02e579cc2d7f1de3$var$RADIAN;
        endAngle = endAngle === 'auto' ? startAngle - $02e579cc2d7f1de3$var$PI2 : -endAngle * $02e579cc2d7f1de3$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $02e579cc2d7f1de3$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get('clockwise');
        var roseType = seriesModel.get('roseType');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $a1b116230ebefd82$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var layoutData = $02e579cc2d7f1de3$export$4e43b88a06b9f223(seriesModel);
        layoutData.startAngle = startAngle;
        layoutData.endAngle = endAngle;
        layoutData.clockwise = clockwise;
        layoutData.cx = cx;
        layoutData.cy = cy;
        layoutData.r = r;
        layoutData.r0 = r0;
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        // Requird by `pieLabelLayout`.
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== 'area') angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $bfe945a83b4d28b9$export$d3f68fbaa670562)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $02e579cc2d7f1de3$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        layout.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        var angle = layout.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}
var $02e579cc2d7f1de3$export$4e43b88a06b9f223 = (0, $08bfa015475effa8$export$64df9f8d92ae083f)();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $0fced3d8da1a3e5f$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function reset(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: 'legend'
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $b36895861f0e64fe$var$PI2 = Math.PI * 2;
var $b36895861f0e64fe$var$CMD = (0, $a1b116230ebefd82$export$2e2bcd8739ae039).CMD;
var $b36895861f0e64fe$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $b36895861f0e64fe$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $b36895861f0e64fe$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $b36895861f0e64fe$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(endAngle);
        endAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(startAngle);
        endAngle = (0, $15d9e37daabdcd8b$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $b36895861f0e64fe$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $b36895861f0e64fe$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $b36895861f0e64fe$var$PI2 >= startAngle && angle + $b36895861f0e64fe$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $b36895861f0e64fe$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $b36895861f0e64fe$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $b36895861f0e64fe$var$tmpPt = [];
function $b36895861f0e64fe$var$nearestPointOnRect(pt, rect, out) {
    var dist = $b36895861f0e64fe$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $b36895861f0e64fe$var$tmpPt);
    out.set($b36895861f0e64fe$var$tmpPt[0], $b36895861f0e64fe$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $b36895861f0e64fe$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $b36895861f0e64fe$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $b36895861f0e64fe$var$CMD.L:
                d = $b36895861f0e64fe$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $b36895861f0e64fe$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $b36895861f0e64fe$var$CMD.C:
                d = (0, $196091227dfded05$export$dbaa3801d1284367)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $b36895861f0e64fe$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $b36895861f0e64fe$var$CMD.Q:
                d = (0, $196091227dfded05$export$81915a594fe10dee)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $b36895861f0e64fe$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $b36895861f0e64fe$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $b36895861f0e64fe$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $b36895861f0e64fe$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $b36895861f0e64fe$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $b36895861f0e64fe$var$projectPointToRect(x0, y0, width, height, x, y, $b36895861f0e64fe$var$tmpPt);
                break;
            case $b36895861f0e64fe$var$CMD.Z:
                d = $b36895861f0e64fe$var$projectPointToLine(xi, yi, x0, y0, x, y, $b36895861f0e64fe$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($b36895861f0e64fe$var$tmpPt[0], $b36895861f0e64fe$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $b36895861f0e64fe$var$pt0 = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $b36895861f0e64fe$var$pt1 = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $b36895861f0e64fe$var$pt2 = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $b36895861f0e64fe$var$dir = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
var $b36895861f0e64fe$var$dir2 = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
function $b36895861f0e64fe$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $b36895861f0e64fe$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $e84a7b06db3848b3$export$6897c284b6f9f4dc)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $b36895861f0e64fe$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $b36895861f0e64fe$var$getCandidateAnchor(candidate, 0, labelRect, $b36895861f0e64fe$var$pt0, $b36895861f0e64fe$var$dir);
        (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).scaleAndAdd($b36895861f0e64fe$var$pt1, $b36895861f0e64fe$var$pt0, $b36895861f0e64fe$var$dir, len);
        // Transform to target coord space.
        $b36895861f0e64fe$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($b36895861f0e64fe$var$pt1) : target instanceof (0, $d730b349402dd5f7$export$2e2bcd8739ae039) ? $b36895861f0e64fe$var$nearestPointOnPath($b36895861f0e64fe$var$pt1, target.path, $b36895861f0e64fe$var$pt2) : $b36895861f0e64fe$var$nearestPointOnRect($b36895861f0e64fe$var$pt1, boundingRect, $b36895861f0e64fe$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $b36895861f0e64fe$var$pt1.transform(targetTransform);
            $b36895861f0e64fe$var$pt2.transform(targetTransform);
            $b36895861f0e64fe$var$pt2.toArray(points[0]);
            $b36895861f0e64fe$var$pt1.toArray(points[1]);
            $b36895861f0e64fe$var$pt0.toArray(points[2]);
        }
    }
    $b36895861f0e64fe$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $b36895861f0e64fe$var$tmpArr = [];
var $b36895861f0e64fe$var$tmpProjPoint = new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)();
function $b36895861f0e64fe$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $b36895861f0e64fe$var$pt0.fromArray(linePoints[0]);
    $b36895861f0e64fe$var$pt1.fromArray(linePoints[1]);
    $b36895861f0e64fe$var$pt2.fromArray(linePoints[2]);
    (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).sub($b36895861f0e64fe$var$dir, $b36895861f0e64fe$var$pt0, $b36895861f0e64fe$var$pt1);
    (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).sub($b36895861f0e64fe$var$dir2, $b36895861f0e64fe$var$pt2, $b36895861f0e64fe$var$pt1);
    var len1 = $b36895861f0e64fe$var$dir.len();
    var len2 = $b36895861f0e64fe$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $b36895861f0e64fe$var$dir.scale(1 / len1);
    $b36895861f0e64fe$var$dir2.scale(1 / len2);
    var angleCos = $b36895861f0e64fe$var$dir.dot($b36895861f0e64fe$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $b36895861f0e64fe$var$projectPointToLine($b36895861f0e64fe$var$pt1.x, $b36895861f0e64fe$var$pt1.y, $b36895861f0e64fe$var$pt2.x, $b36895861f0e64fe$var$pt2.y, $b36895861f0e64fe$var$pt0.x, $b36895861f0e64fe$var$pt0.y, $b36895861f0e64fe$var$tmpArr, false);
        $b36895861f0e64fe$var$tmpProjPoint.fromArray($b36895861f0e64fe$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $b36895861f0e64fe$var$tmpProjPoint.scaleAndAdd($b36895861f0e64fe$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $b36895861f0e64fe$var$pt2.x !== $b36895861f0e64fe$var$pt1.x ? ($b36895861f0e64fe$var$tmpProjPoint.x - $b36895861f0e64fe$var$pt1.x) / ($b36895861f0e64fe$var$pt2.x - $b36895861f0e64fe$var$pt1.x) : ($b36895861f0e64fe$var$tmpProjPoint.y - $b36895861f0e64fe$var$pt1.y) / ($b36895861f0e64fe$var$pt2.y - $b36895861f0e64fe$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).copy($b36895861f0e64fe$var$tmpProjPoint, $b36895861f0e64fe$var$pt1);
        else if (t > 1) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).copy($b36895861f0e64fe$var$tmpProjPoint, $b36895861f0e64fe$var$pt2);
        $b36895861f0e64fe$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $b36895861f0e64fe$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $b36895861f0e64fe$var$pt0.fromArray(linePoints[0]);
    $b36895861f0e64fe$var$pt1.fromArray(linePoints[1]);
    $b36895861f0e64fe$var$pt2.fromArray(linePoints[2]);
    (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).sub($b36895861f0e64fe$var$dir, $b36895861f0e64fe$var$pt1, $b36895861f0e64fe$var$pt0);
    (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).sub($b36895861f0e64fe$var$dir2, $b36895861f0e64fe$var$pt2, $b36895861f0e64fe$var$pt1);
    var len1 = $b36895861f0e64fe$var$dir.len();
    var len2 = $b36895861f0e64fe$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $b36895861f0e64fe$var$dir.scale(1 / len1);
    $b36895861f0e64fe$var$dir2.scale(1 / len2);
    var angleCos = $b36895861f0e64fe$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $b36895861f0e64fe$var$projectPointToLine($b36895861f0e64fe$var$pt1.x, $b36895861f0e64fe$var$pt1.y, $b36895861f0e64fe$var$pt2.x, $b36895861f0e64fe$var$pt2.y, $b36895861f0e64fe$var$pt0.x, $b36895861f0e64fe$var$pt0.y, $b36895861f0e64fe$var$tmpArr, false);
        $b36895861f0e64fe$var$tmpProjPoint.fromArray($b36895861f0e64fe$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($b36895861f0e64fe$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).copy($b36895861f0e64fe$var$tmpProjPoint, $b36895861f0e64fe$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $b36895861f0e64fe$var$tmpProjPoint.scaleAndAdd($b36895861f0e64fe$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $b36895861f0e64fe$var$pt2.x !== $b36895861f0e64fe$var$pt1.x ? ($b36895861f0e64fe$var$tmpProjPoint.x - $b36895861f0e64fe$var$pt1.x) / ($b36895861f0e64fe$var$pt2.x - $b36895861f0e64fe$var$pt1.x) : ($b36895861f0e64fe$var$tmpProjPoint.y - $b36895861f0e64fe$var$pt1.y) / ($b36895861f0e64fe$var$pt2.y - $b36895861f0e64fe$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).copy($b36895861f0e64fe$var$tmpProjPoint, $b36895861f0e64fe$var$pt1);
            else if (t > 1) (0, $c753ea00dcbe469a$export$2e2bcd8739ae039).copy($b36895861f0e64fe$var$tmpProjPoint, $b36895861f0e64fe$var$pt2);
        }
        $b36895861f0e64fe$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $b36895861f0e64fe$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $b36895861f0e64fe$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $0a1f57488570eee3$export$6c4a311cc157c764(points[0], points[1]);
        var len2 = $0a1f57488570eee3$export$6c4a311cc157c764(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $0a1f57488570eee3$export$3a89f8d6f6bf6c9f([], points[1], points[0], moveLen / len1);
        var midPoint2 = $0a1f57488570eee3$export$3a89f8d6f6bf6c9f([], points[1], points[2], moveLen / len2);
        var midPoint1 = $0a1f57488570eee3$export$3a89f8d6f6bf6c9f([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $b36895861f0e64fe$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$57ee5306b85ad7d5).length; i++){
        var stateName = (0, $ea1f7a1fbd33fd2d$export$57ee5306b85ad7d5)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $99026af6cdabc3e1$export$995e01f2f5c9d030)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $b36895861f0e64fe$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $1628fbd4f81c9f94$export$2e2bcd8739ae039)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $b36895861f0e64fe$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $b36895861f0e64fe$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $99026af6cdabc3e1$export$ebe90cb607ad99e)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $b36895861f0e64fe$var$buildLabelLinePath;
    }
}
function $b36895861f0e64fe$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b).length; i++){
        var stateName = (0, $ea1f7a1fbd33fd2d$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}



var $1870b6c316c5900c$var$RADIAN = Math.PI / 180;
function $1870b6c316c5900c$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt(Math.abs((1 - dy * dy / rB2) * rA2));
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $1870b6c316c5900c$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== 'none') continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $c9e690af6576c75e$export$73ee08bc808f6f3f)(list, 1, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $1870b6c316c5900c$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($1870b6c316c5900c$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$1870b6c316c5900c$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === 'edge') {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === 'labelLine') {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $1870b6c316c5900c$var$constrainTextWidth(layout, targetTextWidth, false);
        }
    }
    $1870b6c316c5900c$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $1870b6c316c5900c$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$1870b6c316c5900c$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === 'edge';
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $1870b6c316c5900c$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        if (overflow && overflow.match('break')) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle('backgroundColor', null);
            // Set constraining width
            label.setStyle('width', availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle('width', Math.ceil(innerRect.width));
            label.setStyle('backgroundColor', bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle('width', newWidth);
        }
        $1870b6c316c5900c$var$computeLabelGlobalRect(textRect, label);
    }
}
function $1870b6c316c5900c$var$computeLabelGlobalRect(out, label) {
    $1870b6c316c5900c$var$_tmpLabelGeometry.rect = out;
    (0, $c9e690af6576c75e$export$af9bffc2d00de2cc)($1870b6c316c5900c$var$_tmpLabelGeometry, label, $1870b6c316c5900c$var$_computeLabelGeometryOpt);
}
var $1870b6c316c5900c$var$_computeLabelGeometryOpt = {
    minMarginForce: [
        null,
        0,
        null,
        0
    ],
    marginDefault: [
        1,
        0,
        1,
        0
    ]
};
var $1870b6c316c5900c$var$_tmpLabelGeometry = {};
function $1870b6c316c5900c$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === 'center';
}
function $1870b6c316c5900c$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * $1870b6c316c5900c$var$RADIAN;
    var viewRect = data.getLayout('viewRect');
    var r = data.getLayout('r');
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label');
        // Use position in normal or emphasis
        var labelPosition = labelModel.get('position') || itemModel.get([
            'emphasis',
            'label',
            'position'
        ]);
        var labelDistance = labelModel.get('distanceToLabelLine');
        var labelAlignTo = labelModel.get('alignTo');
        var edgeDistance = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(labelModel.get('edgeDistance'), viewWidth);
        var bleedMargin = labelModel.get('bleedMargin');
        if (bleedMargin == null) // An arbitrary strategy for small viewRect - especial pie is layout in calendar or matrix coord sys.
        bleedMargin = Math.min(viewWidth, viewHeight) > 200 ? 10 : 2;
        var labelLineModel = itemModel.getModel('labelLine');
        var labelLineLen = labelLineModel.get('length');
        labelLineLen = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get('length2');
        labelLineLen2 = (0, $bfe945a83b4d28b9$export$e8514cb5a5e2b40f)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
        if (labelPosition === 'center') {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = 'center';
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === 'edge') // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get('rotate');
        if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === 'center') labelRotate = 0;
        else if (rotate === 'radial' || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown) rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: 'middle'
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = new (0, $faa61116fee85ae6$export$2e2bcd8739ae039)(0, 0, 0, 0);
            $1870b6c316c5900c$var$computeLabelGlobalRect(textRect, label);
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get('minTurnAngle'),
                maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
                surfaceNormal: new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) $1870b6c316c5900c$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $b36895861f0e64fe$export$ac52062003fbe6a)(linePoints, layout.minTurnAngle);
                (0, $b36895861f0e64fe$export$973e1fdb2708f71b)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $c753ea00dcbe469a$export$2e2bcd8739ae039)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $83680e9b0c30b43d$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get('borderRadius');
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $99026af6cdabc3e1$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $33d0653e48493c02$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}




/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $a3555a8fd8b69018$var$PiePiece = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $97dfecd189304201$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $99026af6cdabc3e1$export$8b58be045bf06082)((0, $83680e9b0c30b43d$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow('animationType');
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $821b3c1b9ddcee3a$export$a121566aadcfe021(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === 'scale') {
                sector.shape.r = layout.r0;
                $821b3c1b9ddcee3a$export$a121566aadcfe021(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $821b3c1b9ddcee3a$export$a121566aadcfe021(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $821b3c1b9ddcee3a$export$c8dce3c08436e91e(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $821b3c1b9ddcee3a$export$bca7290a9faf0ec9)(sector);
            // Transition animation from the old shape
            $821b3c1b9ddcee3a$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, 'style'));
        (0, $ea1f7a1fbd33fd2d$export$48b68047d330bbc9)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get('selectedOffset');
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState('emphasis').shape = (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
            r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
        }, (0, $83680e9b0c30b43d$export$b395eeeb2ad7cce5)(emphasisModel.getModel('itemStyle'), layout));
        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(sector.ensureState('select'), {
            x: dx,
            y: dy,
            shape: (0, $83680e9b0c30b43d$export$b395eeeb2ad7cce5)(itemModel.getModel([
                'select',
                'itemStyle'
            ]), layout)
        });
        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(sector.ensureState('blur'), {
            shape: (0, $83680e9b0c30b43d$export$b395eeeb2ad7cce5)(itemModel.getModel([
                'blur',
                'itemStyle'
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $99026af6cdabc3e1$export$8b58be045bf06082)(labelLine.ensureState('select'), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(labelText.ensureState('select'), {
            x: dx,
            y: dy
        });
        (0, $ea1f7a1fbd33fd2d$export$e51187539ff11209)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel('labelLine');
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $a4fed78c55651c93$export$9a13992917966657)(sector, (0, $a4fed78c55651c93$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = itemModel.get([
            'label',
            'position'
        ]);
        if (labelPosition !== 'outside' && labelPosition !== 'outer') sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $1628fbd4f81c9f94$export$2e2bcd8739ae039();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $b36895861f0e64fe$export$c09e0b0574bdd2dc)(this, (0, $b36895861f0e64fe$export$2979fdbf5ebce521)(itemModel), {
                stroke: visualColor,
                opacity: (0, $99026af6cdabc3e1$export$2e94551289abb95b)(labelLineModel.get([
                    'lineStyle',
                    'opacity'
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($d5aef629841de604$export$2e2bcd8739ae039);
// Pie view
var $a3555a8fd8b69018$var$PieView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
            var layoutData = (0, $02e579cc2d7f1de3$export$4e43b88a06b9f223)(seriesModel);
            var sector = new $d5aef629841de604$export$2e2bcd8739ae039({
                shape: (0, $99026af6cdabc3e1$export$9cd59f9826255e47)(layoutData)
            });
            sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $a3555a8fd8b69018$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off('click');
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $821b3c1b9ddcee3a$export$6d0fd725cb4aee8a(piePiece, seriesModel, idx);
        }).execute();
        (0, $1870b6c316c5900c$export$2e2bcd8739ae039)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get('animationTypeUpdate') !== 'expansion') this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = 'pie';
    return PieView;
}((0, $01349fdbc71d745c$export$2e2bcd8739ae039));
var $a3555a8fd8b69018$export$2e2bcd8739ae039 = $a3555a8fd8b69018$var$PieView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $24cece823cab9781$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $99026af6cdabc3e1$export$43bee75e5e14138e)(opt) && {
        coordDimensions: opt
    } || (0, $99026af6cdabc3e1$export$8b58be045bf06082)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $86a55e4e24f7b742$export$2e2bcd8739ae039)(source, opt).dimensions;
    var list = new (0, $8b95141abf364b52$export$2e2bcd8739ae039)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $2a09274ea6e735b9$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $2a09274ea6e735b9$export$2e2bcd8739ae039 = $2a09274ea6e735b9$var$LegendVisualProvider;




var $dcac4a5c82fc5d9b$var$innerData = $08bfa015475effa8$export$64df9f8d92ae083f();
var $dcac4a5c82fc5d9b$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $2a09274ea6e735b9$export$2e2bcd8739ae039)($99026af6cdabc3e1$export$2385a24977818dd0(this.getData, this), $99026af6cdabc3e1$export$2385a24977818dd0(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $24cece823cab9781$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $99026af6cdabc3e1$export$c3095a23b368d1f2((0, $fbbcfa54d383b92f$export$60b8a57d1f2fed26), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $dcac4a5c82fc5d9b$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension('value'), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $bfe945a83b4d28b9$export$222dabb13d5320df)(valueList_1, data.hostModel.get('percentPrecision'));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push('percent');
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $08bfa015475effa8$export$abdcc6a26372f94b(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = 'series.pie';
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '50%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: 'auto',
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        coordinateSystemUsage: 'box',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: 'truncate',
            // 'outer', 'inside', 'center'
            position: 'outer',
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: 'none',
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: '25%',
            // Works only position is 'outer' and alignTo is not 'edge'.
            // The default `bleedMargin` is auto determined according to view rect size.
            // bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 30,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: 'solid'
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: 'round'
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: 'lightgray',
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: 'expansion',
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: 'transition',
        animationEasingUpdate: 'cubicInOut',
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut'
    };
    return PieSeriesModel;
}((0, $358fe4ff615f1b87$export$2e2bcd8739ae039));
(0, $f8a57de9b8820c02$export$b8fb890203e861d5)({
    fullType: $dcac4a5c82fc5d9b$var$PieSeriesModel.type,
    getCoord2: function getCoord2(model) {
        // Not able to validate `center` type here.
        // But percentage center, such as '12%', is not allowed in this case.
        return model.getShallow('center');
    }
});
var $dcac4a5c82fc5d9b$export$2e2bcd8739ae039 = $dcac4a5c82fc5d9b$var$PieSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $5c74cd3846888007$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function reset(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension('value');
                var curValue = data.get(valueDim, idx);
                if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}


function $f8dd1d8ea37c05d3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a3555a8fd8b69018$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $dcac4a5c82fc5d9b$export$2e2bcd8739ae039));
    (0, $565b0fbbdfa36e81$export$62942ba95693dbfc)('pie', registers.registerAction);
    registers.registerLayout((0, $99026af6cdabc3e1$export$c3095a23b368d1f2)((0, $02e579cc2d7f1de3$export$2e2bcd8739ae039), 'pie'));
    registers.registerProcessor((0, $0fced3d8da1a3e5f$export$2e2bcd8739ae039)('pie'));
    registers.registerProcessor((0, $5c74cd3846888007$export$2e2bcd8739ae039)('pie'));
}




var $6d654604eae4d96c$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $f8dd1d8ea37c05d3$export$4b3e715f166fdd78));
var $6d654604eae4d96c$export$253ea3b174b62ab5 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECPieChart, ECOptionElement);
    function ECPieChart() {
        (0, $7lhcp._)(this, ECPieChart);
        return (0, $07dqX._)(this, ECPieChart, arguments);
    }
    return ECPieChart;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($6d654604eae4d96c$var$_a = globalThis.customElements) === null || $6d654604eae4d96c$var$_a === void 0 || $6d654604eae4d96c$var$_a.define('ec-pie-chart', $6d654604eae4d96c$export$253ea3b174b62ab5);




parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");




var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");

var $arNK5 = parcelRequire("arNK5");


var $6tqvJ = parcelRequire("6tqvJ");

var $22ecc102cfe669d8$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $22ecc102cfe669d8$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $22ecc102cfe669d8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $22ecc102cfe669d8$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $22ecc102cfe669d8$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $22ecc102cfe669d8$export$b1a084c16b711869 = function() {
    var _a, _StatisticModel_overview_accessor_storage, _StatisticModel_monthlyStats_accessor_storage, _StatisticModel_dailyStats_accessor_storage, _StatisticModel_businessTypeDistribution_accessor_storage, _StatisticModel_problemCategoryDistribution_accessor_storage;
    var _classSuper = (0, $a1830bff0fabd0b0$export$d12e20a4eec10acf);
    var _instanceExtraInitializers = [];
    var _overview_decorators;
    var _overview_initializers = [];
    var _overview_extraInitializers = [];
    var _monthlyStats_decorators;
    var _monthlyStats_initializers = [];
    var _monthlyStats_extraInitializers = [];
    var _dailyStats_decorators;
    var _dailyStats_initializers = [];
    var _dailyStats_extraInitializers = [];
    var _businessTypeDistribution_decorators;
    var _businessTypeDistribution_initializers = [];
    var _businessTypeDistribution_extraInitializers = [];
    var _problemCategoryDistribution_decorators;
    var _problemCategoryDistribution_initializers = [];
    var _problemCategoryDistribution_extraInitializers = [];
    var _getOverview_decorators;
    var _getMonthlyStatistic_decorators;
    var _getDailyStatistic_decorators;
    var _getBusinessTypeDistribution_decorators;
    var _getProblemCategoryDistribution_decorators;
    return _a = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(StatisticModel, _classSuper);
        function StatisticModel() {
            (0, $7lhcp._)(this, StatisticModel);
            var _this;
            _this = (0, $07dqX._)(this, StatisticModel, arguments);
            Object.defineProperty(_this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($22ecc102cfe669d8$var$__runInitializers(_this, _instanceExtraInitializers), (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client)
            });
            _StatisticModel_overview_accessor_storage.set(_this, $22ecc102cfe669d8$var$__runInitializers(_this, _overview_initializers, void 0));
            _StatisticModel_monthlyStats_accessor_storage.set(_this, ($22ecc102cfe669d8$var$__runInitializers(_this, _overview_extraInitializers), $22ecc102cfe669d8$var$__runInitializers(_this, _monthlyStats_initializers, [])));
            _StatisticModel_dailyStats_accessor_storage.set(_this, ($22ecc102cfe669d8$var$__runInitializers(_this, _monthlyStats_extraInitializers), $22ecc102cfe669d8$var$__runInitializers(_this, _dailyStats_initializers, [])));
            _StatisticModel_businessTypeDistribution_accessor_storage.set(_this, ($22ecc102cfe669d8$var$__runInitializers(_this, _dailyStats_extraInitializers), $22ecc102cfe669d8$var$__runInitializers(_this, _businessTypeDistribution_initializers, [])));
            _StatisticModel_problemCategoryDistribution_accessor_storage.set(_this, ($22ecc102cfe669d8$var$__runInitializers(_this, _businessTypeDistribution_extraInitializers), $22ecc102cfe669d8$var$__runInitializers(_this, _problemCategoryDistribution_initializers, [])));
            $22ecc102cfe669d8$var$__runInitializers(_this, _problemCategoryDistribution_extraInitializers);
            return _this;
        }
        (0, $8BtP9._)(StatisticModel, [
            {
                key: "overview",
                get: function get() {
                    return $22ecc102cfe669d8$var$__classPrivateFieldGet(this, _StatisticModel_overview_accessor_storage, "f");
                },
                set: function set(value) {
                    $22ecc102cfe669d8$var$__classPrivateFieldSet(this, _StatisticModel_overview_accessor_storage, value, "f");
                }
            },
            {
                key: "monthlyStats",
                get: function get() {
                    return $22ecc102cfe669d8$var$__classPrivateFieldGet(this, _StatisticModel_monthlyStats_accessor_storage, "f");
                },
                set: function set(value) {
                    $22ecc102cfe669d8$var$__classPrivateFieldSet(this, _StatisticModel_monthlyStats_accessor_storage, value, "f");
                }
            },
            {
                key: "dailyStats",
                get: function get() {
                    return $22ecc102cfe669d8$var$__classPrivateFieldGet(this, _StatisticModel_dailyStats_accessor_storage, "f");
                },
                set: function set(value) {
                    $22ecc102cfe669d8$var$__classPrivateFieldSet(this, _StatisticModel_dailyStats_accessor_storage, value, "f");
                }
            },
            {
                key: "businessTypeDistribution",
                get: function get() {
                    return $22ecc102cfe669d8$var$__classPrivateFieldGet(this, _StatisticModel_businessTypeDistribution_accessor_storage, "f");
                },
                set: function set(value) {
                    $22ecc102cfe669d8$var$__classPrivateFieldSet(this, _StatisticModel_businessTypeDistribution_accessor_storage, value, "f");
                }
            },
            {
                key: "problemCategoryDistribution",
                get: function get() {
                    return $22ecc102cfe669d8$var$__classPrivateFieldGet(this, _StatisticModel_problemCategoryDistribution_accessor_storage, "f");
                },
                set: function set(value) {
                    $22ecc102cfe669d8$var$__classPrivateFieldSet(this, _StatisticModel_problemCategoryDistribution_accessor_storage, value, "f");
                }
            },
            {
                key: "getOverview",
                value: function getOverview() {
                    return $22ecc102cfe669d8$var$__awaiter(this, void 0, void 0, function() {
                        var body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.get('statistic/overview')
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        this.overview = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getMonthlyStatistic",
                value: function getMonthlyStatistic() {
                    return $22ecc102cfe669d8$var$__awaiter(this, arguments, void 0, function() {
                        var month, body;
                        var _arguments = arguments;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    month = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : (0, $6tqvJ.formatDate)(Date.now(), 'YYYY-MM');
                                    return [
                                        4,
                                        this.client.get("statistic/monthly/".concat(month))
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        this.monthlyStats = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getDailyStatistic",
                value: function getDailyStatistic() {
                    return $22ecc102cfe669d8$var$__awaiter(this, arguments, void 0, function() {
                        var startDate, endDate, body;
                        var _arguments = arguments;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    startDate = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : (0, $6tqvJ.formatDate)(Date.now() - (0, $6tqvJ.Week), 'YYYY-MM-DD'), endDate = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : (0, $6tqvJ.formatDate)(Date.now(), 'YYYY-MM-DD');
                                    return [
                                        4,
                                        this.client.get("statistic/daily?".concat(new URLSearchParams({
                                            startDate: startDate,
                                            endDate: endDate
                                        })))
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        this.dailyStats = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getBusinessTypeDistribution",
                value: function getBusinessTypeDistribution() {
                    return $22ecc102cfe669d8$var$__awaiter(this, void 0, void 0, function() {
                        var body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.get('statistic/distribution/business-type')
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        this.businessTypeDistribution = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getProblemCategoryDistribution",
                value: function getProblemCategoryDistribution() {
                    return $22ecc102cfe669d8$var$__awaiter(this, void 0, void 0, function() {
                        var body;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        this.client.get('statistic/distribution/problem-category')
                                    ];
                                case 1:
                                    body = _state.sent().body;
                                    return [
                                        2,
                                        this.problemCategoryDistribution = body
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "getAll",
                value: function getAll() {
                    return Promise.all([
                        this.getOverview(),
                        this.getMonthlyStatistic(),
                        this.getDailyStatistic(),
                        this.getBusinessTypeDistribution(),
                        this.getProblemCategoryDistribution()
                    ]).catch(console.error);
                }
            }
        ]);
        return StatisticModel;
    }(_classSuper), _StatisticModel_overview_accessor_storage = new WeakMap(), _StatisticModel_monthlyStats_accessor_storage = new WeakMap(), _StatisticModel_dailyStats_accessor_storage = new WeakMap(), _StatisticModel_businessTypeDistribution_accessor_storage = new WeakMap(), _StatisticModel_problemCategoryDistribution_accessor_storage = new WeakMap(), function() {
        var _b;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _overview_decorators = [
            (0, $arNK5.observable)
        ];
        _monthlyStats_decorators = [
            (0, $arNK5.observable)
        ];
        _dailyStats_decorators = [
            (0, $arNK5.observable)
        ];
        _businessTypeDistribution_decorators = [
            (0, $arNK5.observable)
        ];
        _problemCategoryDistribution_decorators = [
            (0, $arNK5.observable)
        ];
        _getOverview_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('downloading')
        ];
        _getMonthlyStatistic_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('downloading')
        ];
        _getDailyStatistic_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('downloading')
        ];
        _getBusinessTypeDistribution_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('downloading')
        ];
        _getProblemCategoryDistribution_decorators = [
            (0, $a1830bff0fabd0b0$export$e03c1c3201ee8bb7)('downloading')
        ];
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _overview_decorators, {
            kind: "accessor",
            name: "overview",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "overview" in obj;
                },
                get: function(obj) {
                    return obj.overview;
                },
                set: function(obj, value) {
                    obj.overview = value;
                }
            },
            metadata: _metadata
        }, _overview_initializers, _overview_extraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _monthlyStats_decorators, {
            kind: "accessor",
            name: "monthlyStats",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "monthlyStats" in obj;
                },
                get: function(obj) {
                    return obj.monthlyStats;
                },
                set: function(obj, value) {
                    obj.monthlyStats = value;
                }
            },
            metadata: _metadata
        }, _monthlyStats_initializers, _monthlyStats_extraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _dailyStats_decorators, {
            kind: "accessor",
            name: "dailyStats",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "dailyStats" in obj;
                },
                get: function(obj) {
                    return obj.dailyStats;
                },
                set: function(obj, value) {
                    obj.dailyStats = value;
                }
            },
            metadata: _metadata
        }, _dailyStats_initializers, _dailyStats_extraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _businessTypeDistribution_decorators, {
            kind: "accessor",
            name: "businessTypeDistribution",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "businessTypeDistribution" in obj;
                },
                get: function(obj) {
                    return obj.businessTypeDistribution;
                },
                set: function(obj, value) {
                    obj.businessTypeDistribution = value;
                }
            },
            metadata: _metadata
        }, _businessTypeDistribution_initializers, _businessTypeDistribution_extraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _problemCategoryDistribution_decorators, {
            kind: "accessor",
            name: "problemCategoryDistribution",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "problemCategoryDistribution" in obj;
                },
                get: function(obj) {
                    return obj.problemCategoryDistribution;
                },
                set: function(obj, value) {
                    obj.problemCategoryDistribution = value;
                }
            },
            metadata: _metadata
        }, _problemCategoryDistribution_initializers, _problemCategoryDistribution_extraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _getOverview_decorators, {
            kind: "method",
            name: "getOverview",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getOverview" in obj;
                },
                get: function(obj) {
                    return obj.getOverview;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _getMonthlyStatistic_decorators, {
            kind: "method",
            name: "getMonthlyStatistic",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getMonthlyStatistic" in obj;
                },
                get: function(obj) {
                    return obj.getMonthlyStatistic;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _getDailyStatistic_decorators, {
            kind: "method",
            name: "getDailyStatistic",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getDailyStatistic" in obj;
                },
                get: function(obj) {
                    return obj.getDailyStatistic;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _getBusinessTypeDistribution_decorators, {
            kind: "method",
            name: "getBusinessTypeDistribution",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getBusinessTypeDistribution" in obj;
                },
                get: function(obj) {
                    return obj.getBusinessTypeDistribution;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $22ecc102cfe669d8$var$__esDecorate(_a, null, _getProblemCategoryDistribution_decorators, {
            kind: "method",
            name: "getProblemCategoryDistribution",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "getProblemCategoryDistribution" in obj;
                },
                get: function(obj) {
                    return obj.getProblemCategoryDistribution;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    }(), _a;
}();
var $22ecc102cfe669d8$export$2e2bcd8739ae039 = new $22ecc102cfe669d8$export$b1a084c16b711869();




var $d8bb4e3ff7180a53$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d8bb4e3ff7180a53$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d8bb4e3ff7180a53$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8bb4e3ff7180a53$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $d8bb4e3ff7180a53$export$fedd53519a0e2bce = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var DashboardPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "renderNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(title, value) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "text-center",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                className: "fs-6",
                                children: title
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("strong", {
                                className: "fs-3",
                                children: value
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderNumberGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(icon, color, list) {
                    var end = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                        className: "d-flex align-items-center gap-2 ".concat(end ? '' : 'pe-2 border-end'),
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                className: "rounded-circle px-2 bg-light text-".concat(color),
                                name: icon,
                                size: 2
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", {
                                className: "list-unstyled d-flex",
                                children: list.map(function(param) {
                                    var _param = (0, $leE2g._)(param, 2), title = _param[0], value = _param[1];
                                    return _this.renderNumber(title, value);
                                })
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderStatisticsCards", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var totalOrders = param.totalOrders, sensitiveOrders = param.sensitiveOrders, responsibleOrders = param.responsibleOrders, optimizedOrders = param.optimizedOrders, completedSupervisions = param.completedSupervisions, generatedSupervisionOrders = param.generatedSupervisionOrders;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", {
                        className: "list-unstyled d-flex gap-2",
                        children: [
                            _this.renderNumberGroup('file-earmark-text-fill', 'primary', [
                                [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('total_orders'),
                                    totalOrders
                                ]
                            ]),
                            _this.renderNumberGroup('file-earmark-text-fill', 'info', [
                                [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('basic_orders'),
                                    Math.floor(totalOrders / 3)
                                ],
                                [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_orders'),
                                    sensitiveOrders
                                ],
                                [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_orders'),
                                    responsibleOrders
                                ]
                            ]),
                            _this.renderNumberGroup('chat-dots-fill', 'warning', [
                                [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('generated_supervision'),
                                    optimizedOrders
                                ],
                                [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('resolved_orders'),
                                    completedSupervisions
                                ]
                            ]),
                            _this.renderNumberGroup('clipboard2-pulse-fill', 'info', [
                                [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('generated_supervision'),
                                    generatedSupervisionOrders
                                ]
                            ], true)
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderDailyTrendChart", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(dailyStats) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-svg-renderer", {
                        style: {
                            height: '30rem',
                            width: '100%'
                        },
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-tooltip", {
                                trigger: "axis"
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-legend", {
                                data: [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('new_orders'),
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_orders'),
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_orders'),
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_orders')
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-grid", {
                                left: "3%",
                                right: "4%",
                                bottom: "3%",
                                containLabel: true
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-x-axis", {
                                type: "category",
                                boundaryGap: false,
                                data: dailyStats.map(function(s) {
                                    return s.date;
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-y-axis", {
                                type: "value"
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-line-chart", {
                                name: (0, $50993b47476de2e7$export$625550452a3fa3ec)('new_orders'),
                                type: "line",
                                data: dailyStats.map(function(s) {
                                    return s.newOrders;
                                }),
                                smooth: true
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-line-chart", {
                                name: (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_orders'),
                                type: "line",
                                data: dailyStats.map(function(s) {
                                    return s.duplicateOrders;
                                }),
                                smooth: true
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-line-chart", {
                                name: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_orders'),
                                type: "line",
                                data: dailyStats.map(function(s) {
                                    return s.sensitiveOrders;
                                }),
                                smooth: true
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-line-chart", {
                                name: (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_orders'),
                                type: "line",
                                data: dailyStats.map(function(s) {
                                    return s.responsibleOrders;
                                }),
                                smooth: true
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderBusinessTypePieChart", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(businessTypeDistribution) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-svg-renderer", {
                        style: {
                            height: '20rem',
                            width: '100%'
                        },
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-tooltip", {
                                trigger: "item",
                                formatter: "{a} <br/>{b}: {c} ({d}%)"
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-legend", {
                                orient: "vertical",
                                left: "left"
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-pie-chart", {
                                name: (0, $50993b47476de2e7$export$625550452a3fa3ec)('business_type'),
                                radius: "50%",
                                data: businessTypeDistribution,
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderProblemCategoryPieChart", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(problemCategoryDistribution) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-svg-renderer", {
                        style: {
                            height: '20rem',
                            width: '100%'
                        },
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-tooltip", {
                                trigger: "item",
                                formatter: "{a} <br/>{b}: {c} ({d}%)"
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-legend", {
                                orient: "vertical",
                                left: "left"
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-pie-chart", {
                                name: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level1_category'),
                                radius: "50%",
                                data: problemCategoryDistribution,
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderTasksTable", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(tasks) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $ae5c70201edf55c0$export$2e2bcd8739ae039), {
                        hover: true,
                        responsive: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("thead", {
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_serial_number')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_name')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('created_at')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('current_status')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('operation')
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tbody", {
                                children: tasks.slice(0, 4).map(function(param, index) {
                                    var id = param.id, name = param.name, createdAt = param.createdAt, status = param.status;
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: index + 1
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: name
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: new Date(createdAt).toLocaleString()
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                                    bg: status === 'completed' ? 'success' : status === 'in_progress' ? 'warning' : 'danger',
                                                    children: status === 'completed' ? (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_completed') : status === 'in_progress' ? (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_in_progress') : (0, $50993b47476de2e7$export$625550452a3fa3ec)('abnormal')
                                                })
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                                    href: "#/task/classification/".concat(id),
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('view_details')
                                                })
                                            })
                                        ]
                                    }, id);
                                })
                            })
                        ]
                    });
                }
            });
            Object.defineProperty(_this, "renderCategoriesTable", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(categories) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $ae5c70201edf55c0$export$2e2bcd8739ae039), {
                        hover: true,
                        responsive: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("thead", {
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rank')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('business_type')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level1_category')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level2_category')
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("th", {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('level3_category')
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tbody", {
                                children: categories.slice(0, 9).map(function(category, index) {
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("tr", {
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: index + 1
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: category.businessType
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: category.level1Category
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: category.level2Category
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("td", {
                                                children: category.level3Category
                                            })
                                        ]
                                    }, category.id);
                                })
                            })
                        ]
                    });
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    return $d8bb4e3ff7180a53$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $22ecc102cfe669d8$export$2e2bcd8739ae039).getAll()
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        (0, $fb2682a0e3edbe09$export$2e2bcd8739ae039).getList({}, 1, 10)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        4,
                                        (0, $b60bedf248b12f36$export$2e2bcd8739ae039).getList({}, 1, 5)
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var session = (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).session;
                    var overview = (0, $22ecc102cfe669d8$export$2e2bcd8739ae039).overview, dailyStats = (0, $22ecc102cfe669d8$export$2e2bcd8739ae039).dailyStats, businessTypeDistribution = (0, $22ecc102cfe669d8$export$2e2bcd8739ae039).businessTypeDistribution, problemCategoryDistribution = (0, $22ecc102cfe669d8$export$2e2bcd8739ae039).problemCategoryDistribution, downloading = (0, $22ecc102cfe669d8$export$2e2bcd8739ae039).downloading;
                    var tasks = (0, $b60bedf248b12f36$export$2e2bcd8739ae039).allItems;
                    var categories = (0, $fb2682a0e3edbe09$export$2e2bcd8739ae039).allItems;
                    return !overview ? null : (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $eb8ef8f36513dc70$export$2e2bcd8739ae039), {
                        fluid: true,
                        children: [
                            downloading > 0 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Loading), {}),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h2", {
                                className: "my-4",
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('console')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                                className: "mb-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        xs: 12,
                                        lg: 9,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                            body: true,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                                    className: "d-flex align-items-center gap-3",
                                                    children: [
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                                            className: "m-0 fw-bold fs-5 flex-fill",
                                                            children: [
                                                                "\uD83D\uDC4F",
                                                                (0, $50993b47476de2e7$export$625550452a3fa3ec)('welcome_back'),
                                                                "\uFF0C",
                                                                session.name,
                                                                "\uFF01"
                                                            ]
                                                        }),
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Select), {
                                                            variant: "outline-secondary",
                                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Option), {
                                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_branches')
                                                            })
                                                        }),
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Select), {
                                                            variant: "outline-secondary",
                                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Option), {
                                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_power_stations')
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("hr", {}),
                                                this.renderStatisticsCards(overview),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("hr", {}),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_data_7days')
                                                }),
                                                this.renderDailyTrendChart(dailyStats)
                                            ]
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        xs: 12,
                                        lg: 3,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                            body: true,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Title, {
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('business_type_distribution')
                                                }),
                                                this.renderBusinessTypePieChart(businessTypeDistribution),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Title, {
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('problem_category_distribution')
                                                }),
                                                this.renderProblemCategoryPieChart(problemCategoryDistribution)
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                                className: "mb-4",
                                xs: 1,
                                md: 2,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                            body: true,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                                    className: "d-flex justify-content-between align-items-center mb-3",
                                                    children: [
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Title, {
                                                            as: "h3",
                                                            className: "fs-5 m-0",
                                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('current_tasks')
                                                        }),
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                                            className: "text-decoration-none",
                                                            href: "#/task",
                                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('view_more')
                                                        })
                                                    ]
                                                }),
                                                this.renderTasksTable(tasks)
                                            ]
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                            body: true,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                                    className: "d-flex justify-content-between align-items-center mb-3",
                                                    children: [
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Title, {
                                                            as: "h3",
                                                            className: "fs-5 m-0",
                                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_classification')
                                                        }),
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                                            className: "text-decoration-none",
                                                            href: "#/category",
                                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('view_more')
                                                        })
                                                    ]
                                                }),
                                                this.renderCategoriesTable(categories)
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $d8bb4e3ff7180a53$var$__setFunctionName(_classThis, "DashboardPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $d8bb4e3ff7180a53$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        DashboardPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $d8bb4e3ff7180a53$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return DashboardPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $6tqvJ = parcelRequire("6tqvJ");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");


var $34a018c34fa26e49$export$ca7cde60f7d1391d = 536870912; // 512 MB
var $34a018c34fa26e49$export$4b24e3a88bb9f9d0 = 5;
var $34a018c34fa26e49$export$325a02dcb4392658 = [
    'TXT',
    'MARKDOWN',
    'MDX',
    'PDF',
    'HTML',
    'XLSX',
    'XLS',
    'DOCX',
    'CSV',
    'VTT',
    'PROPERTIES',
    'MD',
    'HTM'
];
var $34a018c34fa26e49$export$44362622733d5c3e = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(DocumentModel, TableModel);
    function DocumentModel() {
        (0, $7lhcp._)(this, DocumentModel);
        var _this;
        _this = (0, $07dqX._)(this, DocumentModel, arguments);
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'document'
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        return _this;
    }
    return DocumentModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $34a018c34fa26e49$export$2e2bcd8739ae039 = new $34a018c34fa26e49$export$44362622733d5c3e();



var $023cb9dcafae106b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $023cb9dcafae106b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $023cb9dcafae106b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $023cb9dcafae106b$export$677172e6ba6bc651 = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _get_filterFields_decorators;
    var _get_columns_decorators;
    var DocumentListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            $023cb9dcafae106b$var$__runInitializers(_this, _instanceExtraInitializers);
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "filterFields",
                get: function get() {
                    return [
                        {
                            key: 'keywords',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('search')
                        },
                        {
                            key: 'title',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('document_name')
                        },
                        {
                            key: 'fileName',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('document_name')
                        },
                        {
                            key: 'fileType',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('file_type')
                        },
                        {
                            key: 'category',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('category')
                        }
                    ];
                }
            },
            {
                key: "columns",
                get: function get() {
                    return [
                        {
                            key: 'title',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('document_name')
                        },
                        {
                            key: 'fileType',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('file_type')
                        },
                        {
                            key: 'fileSize',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('file_size'),
                            renderBody: function(param) {
                                var fileSize = param.fileSize;
                                return fileSize ? new (0, $6tqvJ.ByteSize)(fileSize).toShortString() : '-';
                            }
                        },
                        {
                            key: 'updatedAt',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('last_update_time'),
                            renderBody: function(param) {
                                var updatedAt = param.updatedAt;
                                return new Date(updatedAt).toLocaleString();
                            }
                        },
                        {
                            // key: 'status',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('status'),
                            renderBody: function() {
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex align-items-center gap-2",
                                    children: [
                                        "\u542F\u7528",
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c996fbf445bb44a0$export$2e2bcd8739ae039), {
                                            type: "switch"
                                        })
                                    ]
                                });
                            }
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "m-3",
                        body: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between align-items-center mb-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h2", {
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('document_knowledge_base')
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        href: "#/document/upload",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "upload",
                                                className: "me-2"
                                            }),
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('upload_document')
                                        ]
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                className: "text-center",
                                filterFields: this.filterFields,
                                columns: this.columns,
                                store: (0, $34a018c34fa26e49$export$2e2bcd8739ae039),
                                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                striped: true,
                                hover: true,
                                deletable: true
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $023cb9dcafae106b$var$__setFunctionName(_classThis, "DocumentListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_filterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_columns_decorators = [
            (0, $arNK5.computed)
        ];
        $023cb9dcafae106b$var$__esDecorate(_classThis, null, _get_filterFields_decorators, {
            kind: "getter",
            name: "filterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filterFields" in obj;
                },
                get: function(obj) {
                    return obj.filterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $023cb9dcafae106b$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $023cb9dcafae106b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        DocumentListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $023cb9dcafae106b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return DocumentListPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");


var $arNK5 = parcelRequire("arNK5");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $6tqvJ = parcelRequire("6tqvJ");

var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");



parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $6tqvJ = parcelRequire("6tqvJ");


var $5d037859f1be9464$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5d037859f1be9464$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5d037859f1be9464$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5d037859f1be9464$export$38b55230667a95dd = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var Step1SelectFiles = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "handleFileSelect", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var currentTarget = param.currentTarget;
                    var files = Array.from(currentTarget.files || []);
                    _this.addFiles(files);
                }
            });
            Object.defineProperty(_this, "handleDragOver", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            });
            Object.defineProperty(_this, "handleDrop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var files = Array.from(event.dataTransfer.files);
                    _this.addFiles(files);
                }
            });
            Object.defineProperty(_this, "addFiles", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(files) {
                    var _this_props = _this.props, selectedFiles = _this_props.selectedFiles, onFilesChange = _this_props.onFilesChange;
                    // Filter and validate files
                    var validFiles = files.filter(function(file) {
                        if (file.size > (0, $34a018c34fa26e49$export$ca7cde60f7d1391d)) {
                            alert((0, $50993b47476de2e7$export$625550452a3fa3ec)('file_exceeds_limit', {
                                name: file.name
                            }));
                            return false;
                        }
                        return true;
                    });
                    // Limit to max 5 files
                    var newFiles = (0, $fsSDT._)(selectedFiles).concat((0, $fsSDT._)(validFiles)).slice(0, (0, $34a018c34fa26e49$export$4b24e3a88bb9f9d0));
                    onFilesChange(newFiles);
                }
            });
            Object.defineProperty(_this, "removeFile", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(index) {
                    var _this_props = _this.props, selectedFiles = _this_props.selectedFiles, onFilesChange = _this_props.onFilesChange;
                    var newFiles = selectedFiles.filter(function(_, i) {
                        return i !== index;
                    });
                    onFilesChange(newFiles);
                }
            });
            Object.defineProperty(_this, "renderFileItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(file, index) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $a2847098175bdaa7$export$2e2bcd8739ae039).Item, {
                        className: "d-flex justify-content-between align-items-center",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex align-items-center",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                        name: "file-earmark-word",
                                        className: "me-2",
                                        style: {
                                            fontSize: '24px',
                                            color: '#2b579a'
                                        }
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                children: file.name
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("small", {
                                                className: "text-muted",
                                                children: [
                                                    file.type || 'DOCX',
                                                    " \u00B7",
                                                    ' ',
                                                    new (0, $6tqvJ.ByteSize)(file.size).toShortString()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                variant: "link",
                                size: "sm",
                                className: "text-muted",
                                onClick: function() {
                                    return _this.removeFile(index);
                                },
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                    name: "trash"
                                })
                            })
                        ]
                    }, "".concat(file.name, "-").concat(index));
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, selectedFiles = _this_props.selectedFiles, onNext = _this_props.onNext;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                className: "mb-4",
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('upload_text_file')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "border border-2 rounded-3 p-5 text-center position-relative",
                                style: {
                                    borderStyle: 'dashed',
                                    minHeight: '280px',
                                    backgroundColor: '#fafafa'
                                },
                                onDragOver: this.handleDragOver,
                                onDrop: this.handleDrop,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                        name: "cloud-upload",
                                        style: {
                                            fontSize: '48px',
                                            color: '#d0d0d0'
                                        },
                                        className: "mb-3"
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                        className: "mb-2",
                                        style: {
                                            fontSize: '16px'
                                        },
                                        children: [
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('drag_or_select'),
                                            ' ',
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("label", {
                                                style: {
                                                    color: '#4169E1',
                                                    cursor: 'pointer',
                                                    textDecoration: 'none'
                                                },
                                                children: [
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('select_file'),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                                        type: "file",
                                                        className: "d-none",
                                                        accept: ".txt,.md,.mdx,.pdf,.html,.htm,.xlsx,.xls,.docx,.csv,.vtt,.properties",
                                                        multiple: true,
                                                        onChange: this.handleFileSelect
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                        className: "text-muted mb-0",
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: [
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('supported_formats'),
                                            " ",
                                            (0, $34a018c34fa26e49$export$325a02dcb4392658).join("\u3001"),
                                            "\uFF0C",
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('max_files_hint'),
                                            " ",
                                            (0, $34a018c34fa26e49$export$4b24e3a88bb9f9d0),
                                            " ",
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('files_unit'),
                                            "\uFF0C",
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('max_size_hint'),
                                            " ",
                                            (0, $34a018c34fa26e49$export$ca7cde60f7d1391d) / 1024 / 1024,
                                            " MB\u3002"
                                        ]
                                    })
                                ]
                            }),
                            selectedFiles.length > 0 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mt-4",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $a2847098175bdaa7$export$2e2bcd8739ae039), {
                                    children: selectedFiles.map(this.renderFileItem)
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "text-end mt-4",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    style: {
                                        minWidth: '120px',
                                        backgroundColor: '#4169E1',
                                        borderColor: '#4169E1'
                                    },
                                    onClick: onNext,
                                    children: [
                                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('next_step'),
                                        ' ',
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "arrow-right",
                                            className: "ms-1"
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $5d037859f1be9464$var$__setFunctionName(_classThis, "Step1SelectFiles");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $5d037859f1be9464$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Step1SelectFiles = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5d037859f1be9464$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Step1SelectFiles = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $1d03693f13d5b79c$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $1d03693f13d5b79c$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $1d03693f13d5b79c$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $1d03693f13d5b79c$export$9a527d7f244385e3 = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var Step2Preview = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "renderFileDropdownItem", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(file, index) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("button", {
                            className: "dropdown-item",
                            onClick: function() {
                                return _this.props.onFileIndexChange(index);
                            },
                            children: file.name
                        })
                    }, index);
                }
            });
            Object.defineProperty(_this, "renderChunk", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(chunk) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "mb-3",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between align-items-center mb-2",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "text-muted",
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "hash",
                                                style: {
                                                    fontSize: '12px'
                                                }
                                            }),
                                            " Chunk-",
                                            chunk.id
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "text-muted",
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: [
                                            chunk.characters,
                                            " characters"
                                        ]
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "bg-white border rounded p-3",
                                style: {
                                    fontSize: '14px',
                                    lineHeight: '1.6'
                                },
                                children: chunk.text
                            })
                        ]
                    }, chunk.id);
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, selectedFiles = _this_props.selectedFiles, chunks = _this_props.chunks, totalChunks = _this_props.totalChunks, selectedFileIndex = _this_props.selectedFileIndex, onPrev = _this_props.onPrev, onNext = _this_props.onNext;
                    var currentFile = selectedFiles[selectedFileIndex] || {};
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                className: "mb-4",
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('preview')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mb-4",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex align-items-center gap-2",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "file-earmark-word",
                                            style: {
                                                fontSize: '20px',
                                                color: '#2b579a'
                                            }
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "dropdown",
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("button", {
                                                    className: "btn btn-link p-0 text-decoration-none text-dark d-flex align-items-center",
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown",
                                                    children: [
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                            className: "fw-medium",
                                                            children: currentFile.name
                                                        }),
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                            name: "chevron-down",
                                                            className: "ms-2"
                                                        })
                                                    ]
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ul", {
                                                    className: "dropdown-menu",
                                                    children: selectedFiles.map(this.renderFileDropdownItem)
                                                })
                                            ]
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                            className: "text-muted",
                                            children: [
                                                totalChunks,
                                                " ",
                                                (0, $50993b47476de2e7$export$625550452a3fa3ec)('chunks_unit')
                                            ]
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "border rounded p-3 mb-4",
                                style: {
                                    maxHeight: '500px',
                                    overflowY: 'auto',
                                    backgroundColor: '#fafafa'
                                },
                                children: chunks.map(this.renderChunk)
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between mt-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                        variant: "outline-secondary",
                                        style: {
                                            minWidth: '120px'
                                        },
                                        onClick: onPrev,
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "arrow-left",
                                                className: "me-1"
                                            }),
                                            ' ',
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('previous_step')
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        style: {
                                            minWidth: '120px',
                                            backgroundColor: '#4169E1',
                                            borderColor: '#4169E1'
                                        },
                                        onClick: onNext,
                                        children: [
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('next_step'),
                                            ' ',
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "arrow-right",
                                                className: "ms-1"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $1d03693f13d5b79c$var$__setFunctionName(_classThis, "Step2Preview");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $1d03693f13d5b79c$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Step2Preview = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $1d03693f13d5b79c$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Step2Preview = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $3fbd99eb309e2e4e$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $3fbd99eb309e2e4e$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $3fbd99eb309e2e4e$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $3fbd99eb309e2e4e$export$53c10b38782c11dd = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var Step3Processing = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "renderFileProgress", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(file) {
                    var processingFiles = _this.props.processingFiles;
                    var progress = processingFiles.get(file.name) || 0;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "mb-3 p-3 border rounded bg-light",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between align-items-center mb-2",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex align-items-center",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "file-earmark-word",
                                                className: "me-2",
                                                style: {
                                                    fontSize: '20px',
                                                    color: '#2b579a'
                                                }
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                children: file.name
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "fw-bold",
                                        children: [
                                            progress,
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c1e72b825e10557b$export$2e2bcd8739ae039), {
                                now: progress,
                                variant: "primary",
                                style: {
                                    height: '8px'
                                }
                            })
                        ]
                    }, file.name);
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, uploadStatus = _this_props.uploadStatus, selectedFiles = _this_props.selectedFiles, onPrev = _this_props.onPrev;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mb-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                        className: "d-flex align-items-center mb-3",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "emoji-smile",
                                                className: "me-2",
                                                style: {
                                                    fontSize: '32px'
                                                }
                                            }),
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('document_uploaded')
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                        className: "text-muted mb-4",
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('upload_to_kb_hint')
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mb-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex align-items-center mb-3",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "spinner-border spinner-border-sm me-2",
                                                role: "status",
                                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                    className: "visually-hidden",
                                                    children: "Loading..."
                                                })
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                className: "fw-medium",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('embedding_processing')
                                            })
                                        ]
                                    }),
                                    uploadStatus === 'uploading' && selectedFiles.map(this.renderFileProgress)
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "border rounded p-4 mb-4",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "row g-3",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "text-muted small",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('chunking_mode')
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "fw-medium",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('custom')
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "text-muted small",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('max_chunk_length')
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "fw-medium",
                                                children: "1024"
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "text-muted small",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('text_preprocessing')
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "fw-medium",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('replace_whitespace')
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "text-muted small",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('index_method')
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "d-flex align-items-center",
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                        name: "stars",
                                                        className: "me-1",
                                                        style: {
                                                            color: '#ff6b35'
                                                        }
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                        className: "fw-medium",
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('high_quality')
                                                    })
                                                ]
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "text-muted small",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('retrieval_settings')
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "col-6",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                className: "d-flex align-items-center",
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                        name: "grid-3x3-gap",
                                                        className: "me-1",
                                                        style: {
                                                            color: '#6366f1'
                                                        }
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                        className: "fw-medium",
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('hybrid_search')
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-between mt-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                        variant: "outline-secondary",
                                        style: {
                                            minWidth: '120px'
                                        },
                                        disabled: uploadStatus === 'uploading',
                                        onClick: onPrev,
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "arrow-left",
                                                className: "me-1"
                                            }),
                                            ' ',
                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('previous_step')
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        href: "#/document",
                                        style: {
                                            minWidth: '120px',
                                            backgroundColor: '#4169E1',
                                            borderColor: '#4169E1'
                                        },
                                        disabled: uploadStatus === 'uploading',
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('complete')
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $3fbd99eb309e2e4e$var$__setFunctionName(_classThis, "Step3Processing");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $3fbd99eb309e2e4e$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Step3Processing = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $3fbd99eb309e2e4e$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Step3Processing = _classThis;
}();


var $ab3211bddbb859e4$export$484e21a89b8fd234 = [
    {
        id: 1,
        text: "\u7F16\u7801\u89C4\u8303 1 \u76EE\u7684 \u901A\u8FC7\u9075\u5FAA\u826F\u597D\u7684\u7F16\u7801\u89C4\u8303\u63D0\u9AD8\u9AD8\u8D28\u91CF\u4EE3\u7801\uFF0C\u8BA9\u4EE3\u7801\u7684\u53EF\u8BFB\u6027\u66F4\u5F3A\uFF0C\u8BA9\u56E2\u961F\u5F00\u53D1\u53EF\u4EE5\u66F4\u9AD8\u6548\uFF0C\u63D0\u9AD8\u56E2\u961F\u7F16\u7801\u6548\u7387\uFF0C\u907F\u514D\u4E0D\u5FC5\u8981\u7684\u95EE\u9898\uFF0C\u964D\u4F4E\u540E\u671F\u7EF4\u62A4\u5F00\u53D1\u6210\u672C\u3002",
        characters: 79
    },
    {
        id: 2,
        text: "2 \u8303\u56F4 \u9002\u7528\u4E8E\u672C\u516C\u53F8\u7684 Java \u540E\u53F0\u5F00\u53D1\u3001Python \u5DE5\u7A0B\u5F00\u53D1\u3001Python \u7B97\u6CD5\u5F00\u53D1\u548C Web \u524D\u7AEF\u5F00\u53D1\u4EBA\u5458\u3002",
        characters: 59
    },
    {
        id: 3,
        text: "3 \u804C\u8D23 \u5F00\u53D1\u4EBA\u5458\u8D1F\u8D23\u9075\u5FAA\u6B64\u7F16\u7801\u89C4\u8303\u4E0E\u6D41\u7A0B\u5B8C\u6210\u9879\u76EE\u5F00\u53D1\u7684\u7F16\u7801\u5DE5\u4F5C\u3002",
        characters: 33
    },
    {
        id: 4,
        text: "4 \u89C4\u8303 4.1 Java \u7F16\u7A0B\u89C4\u8303 4.1.1 \u683C\u5F0F\u89C4\u8303 4.1.1.1 \u7F29\u8FDB \u4F7F\u7528\u914D\u7F6E\u6587\u4EF6\u8FDB\u884C\u683C\u5F0F\u5316\uFF1A\u914D\u7F6E\u6587\u4EF6\u4E2D\u4E00\u4E2A TAB \u7B49\u4E8E 4 \u4E2A\u7A7A\u683C\u3002",
        characters: 74
    },
    {
        id: 5,
        text: "4.1.1.2 \u884C\u957F\u5EA6 \u6BCF\u884C 100 \u5B57\u7B26",
        characters: 21
    },
    {
        id: 6,
        text: '\u6CE8\uFF1A\u4F7F\u7528 eclipse \u81EA\u5E26\u7684 Format \u65B9\u6CD5\uFF08\u5FEB\u6377\u952E\uFF1ACtrl+Shift+F\uFF09\u65F6\uFF0C\u9700\u8981\u914D\u7F6E"Maximum line width"\u8BBE\u7F6E\u957F\u5EA6\u4E3A 100\u3002',
        characters: 80
    },
    {
        id: 7,
        text: "4.1.1.3 \u58F0\u660E 4.1.1.3.1 \u58F0\u660E\u53D8\u91CF\u3001\u5E38\u91CF \u4E00\u884C\u53EA\u58F0\u660E\u4E00\u4E2A\u53D8\u91CF\u6216\u5E38\u91CF\uFF1A\u5728\u4EE3\u7801\u5757\u7684\u5F00\u59CB\u5904\u58F0\u660E\u5B9E\u4F8B\u53D8\u91CF\uFF0C\u4E0D\u8981\u5728\u9996\u6B21\u7528\u5230\u8BE5\u53D8\u91CF\u65F6\u624D\u58F0\u660E\u3010\u63A8\u8350\u3011\u3002",
        characters: 76
    },
    {
        id: 8,
        text: '4.1.1.3.2 \u58F0\u660E\u7C7B \u5DE6\u5927\u62EC\u53F7"{"\u4F4D\u4E8E\u58F0\u660E\u8BED\u53E5\u540C\u884C\u7684\u672B\u5C3E\uFF0C\u53F3\u5927\u62EC\u53F7"}"\u53E6\u8D77\u4E00\u884C\uFF1B\u65B9\u6CD5\u4E0E\u65B9\u6CD5\u4E4B\u95F4\u4EE5\u7A7A\u884C\u5206\u9694\u3002',
        characters: 58
    },
    {
        id: 9,
        text: '4.1.1.4 \u8BED\u53E5 \u53EF\u4EE5\u4F7F\u7528 eclipse \u81EA\u5E26\u7684 Format \u65B9\u6CD5\uFF08\u5FEB\u6377\u952E\uFF1ACtrl+Shift+F\uFF09\u65F6\u4F7F\u7528 eclipse \u9ED8\u8BA4\u7684"Control Statements"\u683C\u5F0F\u5316\u65B9\u6CD5\u8FDB\u884C\u3002',
        characters: 98
    },
    {
        id: 10,
        text: '\u6CE8\uFF1Aif \u8BED\u53E5\u603B\u662F\u7528"{"\u548C"}"\u62EC\u8D77\u6765\u3002',
        characters: 21
    }
];
var $ab3211bddbb859e4$export$2bf0b9a9f5263247 = 221;



var $61cf78445d01c509$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $61cf78445d01c509$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $61cf78445d01c509$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $61cf78445d01c509$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $61cf78445d01c509$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $61cf78445d01c509$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $61cf78445d01c509$export$f51cb699e685f0f8 = function() {
    var _DocumentUploadPage_currentStep_accessor_storage, _DocumentUploadPage_selectedFiles_accessor_storage, _DocumentUploadPage_uploadStatus_accessor_storage, _DocumentUploadPage_errorMessage_accessor_storage, _DocumentUploadPage_chunks_accessor_storage, _DocumentUploadPage_selectedFileIndex_accessor_storage, _DocumentUploadPage_totalChunks_accessor_storage, _DocumentUploadPage_uploadProgress_accessor_storage, _DocumentUploadPage_processingFiles_accessor_storage;
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _currentStep_decorators;
    var _currentStep_initializers = [];
    var _currentStep_extraInitializers = [];
    var _selectedFiles_decorators;
    var _selectedFiles_initializers = [];
    var _selectedFiles_extraInitializers = [];
    var _uploadStatus_decorators;
    var _uploadStatus_initializers = [];
    var _uploadStatus_extraInitializers = [];
    var _errorMessage_decorators;
    var _errorMessage_initializers = [];
    var _errorMessage_extraInitializers = [];
    var _chunks_decorators;
    var _chunks_initializers = [];
    var _chunks_extraInitializers = [];
    var _selectedFileIndex_decorators;
    var _selectedFileIndex_initializers = [];
    var _selectedFileIndex_extraInitializers = [];
    var _totalChunks_decorators;
    var _totalChunks_initializers = [];
    var _totalChunks_extraInitializers = [];
    var _uploadProgress_decorators;
    var _uploadProgress_initializers = [];
    var _uploadProgress_extraInitializers = [];
    var _processingFiles_decorators;
    var _processingFiles_initializers = [];
    var _processingFiles_extraInitializers = [];
    var DocumentUploadPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _DocumentUploadPage_currentStep_accessor_storage.set(_this, $61cf78445d01c509$var$__runInitializers(_this, _currentStep_initializers, 1));
            _DocumentUploadPage_selectedFiles_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _currentStep_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _selectedFiles_initializers, [])));
            _DocumentUploadPage_uploadStatus_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _selectedFiles_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _uploadStatus_initializers, 'idle')));
            _DocumentUploadPage_errorMessage_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _uploadStatus_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _errorMessage_initializers, void 0)));
            _DocumentUploadPage_chunks_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _errorMessage_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _chunks_initializers, (0, $ab3211bddbb859e4$export$484e21a89b8fd234))));
            _DocumentUploadPage_selectedFileIndex_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _chunks_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _selectedFileIndex_initializers, 0)));
            _DocumentUploadPage_totalChunks_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _selectedFileIndex_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _totalChunks_initializers, 0)));
            _DocumentUploadPage_uploadProgress_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _totalChunks_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _uploadProgress_initializers, 0)));
            _DocumentUploadPage_processingFiles_accessor_storage.set(_this, ($61cf78445d01c509$var$__runInitializers(_this, _uploadProgress_extraInitializers), $61cf78445d01c509$var$__runInitializers(_this, _processingFiles_initializers, new Map())));
            Object.defineProperty(_this, "handleFilesChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($61cf78445d01c509$var$__runInitializers(_this, _processingFiles_extraInitializers), function(files) {
                    _this.selectedFiles = files;
                })
            });
            Object.defineProperty(_this, "handleFileIndexChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(index) {
                    _this.selectedFileIndex = index;
                }
            });
            Object.defineProperty(_this, "handleNextStep", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return $61cf78445d01c509$var$__awaiter(_this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(this.currentStep === 1 && this.selectedFiles.length > 0)) return [
                                        3,
                                        2
                                    ];
                                    // Generate mock chunks when moving to step 2
                                    return [
                                        4,
                                        this.generateChunks()
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    if (this.currentStep === 2) // Start processing when moving to step 3
                                    this.startProcessing();
                                    this.currentStep += 1;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            });
            Object.defineProperty(_this, "handlePrevStep", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return _this.currentStep -= 1;
                }
            });
            Object.defineProperty(_this, "generateChunks", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return $61cf78445d01c509$var$__awaiter(_this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            // Mock chunk generation - in real implementation, this would call backend API
                            this.chunks = (0, $ab3211bddbb859e4$export$484e21a89b8fd234);
                            this.totalChunks = (0, $ab3211bddbb859e4$export$2bf0b9a9f5263247);
                            return [
                                2
                            ];
                        });
                    });
                }
            });
            Object.defineProperty(_this, "startProcessing", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    _this.uploadStatus = 'uploading';
                    // Simulate file processing progress
                    _this.selectedFiles.forEach(function(file) {
                        _this.processingFiles.set(file.name, 0);
                        _this.simulateProgress(file.name);
                    });
                }
            });
            Object.defineProperty(_this, "simulateProgress", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(fileName) {
                    return $61cf78445d01c509$var$__awaiter(_this, void 0, void 0, function() {
                        var i, allComplete;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    i = 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(i <= 100)) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        (0, $6tqvJ.sleep)(0.5)
                                    ];
                                case 2:
                                    _state.sent();
                                    this.processingFiles.set(fileName, i);
                                    _state.label = 3;
                                case 3:
                                    i += 10;
                                    return [
                                        3,
                                        1
                                    ];
                                case 4:
                                    // Check if all files are done
                                    allComplete = Array.from(this.processingFiles.values()).every(function(progress) {
                                        return progress === 100;
                                    });
                                    if (allComplete) this.uploadStatus = 'success';
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            });
            Object.defineProperty(_this, "renderStepIndicator", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(step, index) {
                    var currentStep = _this.currentStep, steps = _this.steps;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "d-flex align-items-center",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex align-items-center",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "rounded-circle d-flex align-items-center justify-content-center fw-bold ".concat(currentStep >= step.number ? 'bg-primary text-white' : 'bg-light text-muted'),
                                        style: {
                                            width: '36px',
                                            height: '36px',
                                            fontSize: '14px'
                                        },
                                        children: step.number
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "ms-2 ".concat(currentStep >= step.number ? 'text-dark fw-semibold' : 'text-muted'),
                                        style: {
                                            fontSize: '15px'
                                        },
                                        children: step.label
                                    })
                                ]
                            }),
                            index < steps.length - 1 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mx-3",
                                style: {
                                    width: '60px',
                                    height: '2px',
                                    backgroundColor: currentStep > step.number ? '#0d6efd' : '#e0e0e0'
                                }
                            })
                        ]
                    }, step.number);
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "steps",
                get: function get() {
                    return [
                        {
                            number: 1,
                            label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('select_data_source')
                        },
                        {
                            number: 2,
                            label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('text_chunking_cleaning')
                        },
                        {
                            number: 3,
                            label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('process_complete')
                        }
                    ];
                }
            },
            {
                key: "currentStep",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_currentStep_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_currentStep_accessor_storage, value, "f");
                }
            },
            {
                key: "selectedFiles",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_selectedFiles_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_selectedFiles_accessor_storage, value, "f");
                }
            },
            {
                key: "uploadStatus",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_uploadStatus_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_uploadStatus_accessor_storage, value, "f");
                }
            },
            {
                key: "errorMessage",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_errorMessage_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_errorMessage_accessor_storage, value, "f");
                }
            },
            {
                key: "chunks",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_chunks_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_chunks_accessor_storage, value, "f");
                }
            },
            {
                key: "selectedFileIndex",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_selectedFileIndex_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_selectedFileIndex_accessor_storage, value, "f");
                }
            },
            {
                key: "totalChunks",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_totalChunks_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_totalChunks_accessor_storage, value, "f");
                }
            },
            {
                key: "uploadProgress",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_uploadProgress_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_uploadProgress_accessor_storage, value, "f");
                }
            },
            {
                key: "processingFiles",
                get: function get() {
                    return $61cf78445d01c509$var$__classPrivateFieldGet(this, _DocumentUploadPage_processingFiles_accessor_storage, "f");
                },
                set: function set(value) {
                    $61cf78445d01c509$var$__classPrivateFieldSet(this, _DocumentUploadPage_processingFiles_accessor_storage, value, "f");
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this, steps = _this.steps, currentStep = _this.currentStep;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "m-3",
                        body: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex justify-content-center align-items-center mb-5",
                                children: steps.map(this.renderStepIndicator)
                            }),
                            currentStep === 1 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5d037859f1be9464$export$38b55230667a95dd), {
                                selectedFiles: this.selectedFiles,
                                onFilesChange: this.handleFilesChange,
                                onNext: this.handleNextStep
                            }),
                            currentStep === 2 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1d03693f13d5b79c$export$9a527d7f244385e3), {
                                selectedFiles: this.selectedFiles,
                                chunks: this.chunks,
                                totalChunks: this.totalChunks,
                                selectedFileIndex: this.selectedFileIndex,
                                onFileIndexChange: this.handleFileIndexChange,
                                onPrev: this.handlePrevStep,
                                onNext: this.handleNextStep
                            }),
                            currentStep === 3 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $3fbd99eb309e2e4e$export$53c10b38782c11dd), {
                                selectedFiles: this.selectedFiles,
                                uploadStatus: this.uploadStatus,
                                processingFiles: this.processingFiles,
                                onPrev: this.handlePrevStep
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _DocumentUploadPage_currentStep_accessor_storage = new WeakMap();
    _DocumentUploadPage_selectedFiles_accessor_storage = new WeakMap();
    _DocumentUploadPage_uploadStatus_accessor_storage = new WeakMap();
    _DocumentUploadPage_errorMessage_accessor_storage = new WeakMap();
    _DocumentUploadPage_chunks_accessor_storage = new WeakMap();
    _DocumentUploadPage_selectedFileIndex_accessor_storage = new WeakMap();
    _DocumentUploadPage_totalChunks_accessor_storage = new WeakMap();
    _DocumentUploadPage_uploadProgress_accessor_storage = new WeakMap();
    _DocumentUploadPage_processingFiles_accessor_storage = new WeakMap();
    $61cf78445d01c509$var$__setFunctionName(_classThis, "DocumentUploadPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _currentStep_decorators = [
            (0, $arNK5.observable)
        ];
        _selectedFiles_decorators = [
            (0, $arNK5.observable)
        ];
        _uploadStatus_decorators = [
            (0, $arNK5.observable)
        ];
        _errorMessage_decorators = [
            (0, $arNK5.observable)
        ];
        _chunks_decorators = [
            (0, $arNK5.observable)
        ];
        _selectedFileIndex_decorators = [
            (0, $arNK5.observable)
        ];
        _totalChunks_decorators = [
            (0, $arNK5.observable)
        ];
        _uploadProgress_decorators = [
            (0, $arNK5.observable)
        ];
        _processingFiles_decorators = [
            (0, $arNK5.observable)
        ];
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _currentStep_decorators, {
            kind: "accessor",
            name: "currentStep",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "currentStep" in obj;
                },
                get: function(obj) {
                    return obj.currentStep;
                },
                set: function(obj, value) {
                    obj.currentStep = value;
                }
            },
            metadata: _metadata
        }, _currentStep_initializers, _currentStep_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _selectedFiles_decorators, {
            kind: "accessor",
            name: "selectedFiles",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "selectedFiles" in obj;
                },
                get: function(obj) {
                    return obj.selectedFiles;
                },
                set: function(obj, value) {
                    obj.selectedFiles = value;
                }
            },
            metadata: _metadata
        }, _selectedFiles_initializers, _selectedFiles_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _uploadStatus_decorators, {
            kind: "accessor",
            name: "uploadStatus",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "uploadStatus" in obj;
                },
                get: function(obj) {
                    return obj.uploadStatus;
                },
                set: function(obj, value) {
                    obj.uploadStatus = value;
                }
            },
            metadata: _metadata
        }, _uploadStatus_initializers, _uploadStatus_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _errorMessage_decorators, {
            kind: "accessor",
            name: "errorMessage",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "errorMessage" in obj;
                },
                get: function(obj) {
                    return obj.errorMessage;
                },
                set: function(obj, value) {
                    obj.errorMessage = value;
                }
            },
            metadata: _metadata
        }, _errorMessage_initializers, _errorMessage_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _chunks_decorators, {
            kind: "accessor",
            name: "chunks",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "chunks" in obj;
                },
                get: function(obj) {
                    return obj.chunks;
                },
                set: function(obj, value) {
                    obj.chunks = value;
                }
            },
            metadata: _metadata
        }, _chunks_initializers, _chunks_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _selectedFileIndex_decorators, {
            kind: "accessor",
            name: "selectedFileIndex",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "selectedFileIndex" in obj;
                },
                get: function(obj) {
                    return obj.selectedFileIndex;
                },
                set: function(obj, value) {
                    obj.selectedFileIndex = value;
                }
            },
            metadata: _metadata
        }, _selectedFileIndex_initializers, _selectedFileIndex_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _totalChunks_decorators, {
            kind: "accessor",
            name: "totalChunks",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "totalChunks" in obj;
                },
                get: function(obj) {
                    return obj.totalChunks;
                },
                set: function(obj, value) {
                    obj.totalChunks = value;
                }
            },
            metadata: _metadata
        }, _totalChunks_initializers, _totalChunks_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _uploadProgress_decorators, {
            kind: "accessor",
            name: "uploadProgress",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "uploadProgress" in obj;
                },
                get: function(obj) {
                    return obj.uploadProgress;
                },
                set: function(obj, value) {
                    obj.uploadProgress = value;
                }
            },
            metadata: _metadata
        }, _uploadProgress_initializers, _uploadProgress_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(_classThis, null, _processingFiles_decorators, {
            kind: "accessor",
            name: "processingFiles",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "processingFiles" in obj;
                },
                get: function(obj) {
                    return obj.processingFiles;
                },
                set: function(obj, value) {
                    obj.processingFiles = value;
                }
            },
            metadata: _metadata
        }, _processingFiles_initializers, _processingFiles_extraInitializers);
        $61cf78445d01c509$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        DocumentUploadPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $61cf78445d01c509$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return DocumentUploadPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $leE2g = parcelRequire("leE2g");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");

var $fClfl = parcelRequire("fClfl");


var $arNK5 = parcelRequire("arNK5");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");

var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $8MJI4 = parcelRequire("8MJI4");


var $6mMqj = parcelRequire("6mMqj");



var $fClfl = parcelRequire("fClfl");
"use client";
var $beea41fc30491526$var$noop = function() {
    return undefined;
};
var $beea41fc30491526$var$ToggleButton = /*#__PURE__*/ $6mMqj.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, name = _param.name, className = _param.className, checked = _param.checked, type = _param.type, onChange = _param.onChange, value = _param.value, disabled = _param.disabled, id = _param.id, inputRef = _param.inputRef, props = (0, $8MJI4._)(_param, [
        "bsPrefix",
        "name",
        "className",
        "checked",
        "type",
        "onChange",
        "value",
        "disabled",
        "id",
        "inputRef"
    ]);
    bsPrefix = (0, $fb3854fa54537b64$export$7f387860ebffb32c)(bsPrefix, 'btn-check');
    return /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: [
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                className: bsPrefix,
                name: name,
                type: type,
                value: value,
                ref: inputRef,
                autoComplete: "off",
                checked: !!checked,
                disabled: !!disabled,
                onChange: onChange || $beea41fc30491526$var$noop,
                id: id
            }),
            /*#__PURE__*/ (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), (0, $ctBui._)((0, $6GCxi._)({}, props), {
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, disabled && 'disabled'),
                type: undefined,
                role: undefined,
                as: "label",
                htmlFor: id
            }))
        ]
    });
});
$beea41fc30491526$var$ToggleButton.displayName = 'ToggleButton';
var $beea41fc30491526$export$2e2bcd8739ae039 = $beea41fc30491526$var$ToggleButton;



var $6tqvJ = parcelRequire("6tqvJ");


var $068daf19f8f6c317$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $068daf19f8f6c317$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $068daf19f8f6c317$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $068daf19f8f6c317$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $068daf19f8f6c317$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $068daf19f8f6c317$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $068daf19f8f6c317$var$validTypes = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];
var $068daf19f8f6c317$export$f17b967ebb337cc7 = function() {
    var _OptimizationTaskCreatorPage_selectedFile_accessor_storage, _OptimizationTaskCreatorPage_uploadProgress_accessor_storage, _OptimizationTaskCreatorPage_formatValidation_accessor_storage, _OptimizationTaskCreatorPage_analysisOptions_accessor_storage;
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _selectedFile_decorators;
    var _selectedFile_initializers = [];
    var _selectedFile_extraInitializers = [];
    var _uploadProgress_decorators;
    var _uploadProgress_initializers = [];
    var _uploadProgress_extraInitializers = [];
    var _formatValidation_decorators;
    var _formatValidation_initializers = [];
    var _formatValidation_extraInitializers = [];
    var _analysisOptions_decorators;
    var _analysisOptions_initializers = [];
    var _analysisOptions_extraInitializers = [];
    var OptimizationTaskCreatorPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _OptimizationTaskCreatorPage_selectedFile_accessor_storage.set(_this, $068daf19f8f6c317$var$__runInitializers(_this, _selectedFile_initializers, void 0));
            _OptimizationTaskCreatorPage_uploadProgress_accessor_storage.set(_this, ($068daf19f8f6c317$var$__runInitializers(_this, _selectedFile_extraInitializers), $068daf19f8f6c317$var$__runInitializers(_this, _uploadProgress_initializers, 0)));
            _OptimizationTaskCreatorPage_formatValidation_accessor_storage.set(_this, ($068daf19f8f6c317$var$__runInitializers(_this, _uploadProgress_extraInitializers), $068daf19f8f6c317$var$__runInitializers(_this, _formatValidation_initializers, {
                status: 'idle'
            })));
            _OptimizationTaskCreatorPage_analysisOptions_accessor_storage.set(_this, ($068daf19f8f6c317$var$__runInitializers(_this, _formatValidation_extraInitializers), $068daf19f8f6c317$var$__runInitializers(_this, _analysisOptions_initializers, [
                {
                    id: 'classification',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_classification_optimization'),
                    description: (0, $50993b47476de2e7$export$625550452a3fa3ec)('auto_identify_work_orders'),
                    checked: true
                },
                {
                    id: 'deduplication',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_work_order_extraction'),
                    description: (0, $50993b47476de2e7$export$625550452a3fa3ec)('identify_duplicate_records'),
                    checked: true
                },
                {
                    id: 'sensitive',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_work_order_extraction'),
                    description: (0, $50993b47476de2e7$export$625550452a3fa3ec)('auto_detect_sensitive_data'),
                    checked: false
                },
                {
                    id: 'employee',
                    title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('employee_work_order_audit'),
                    description: (0, $50993b47476de2e7$export$625550452a3fa3ec)('analyze_employee_handling'),
                    checked: false
                }
            ])));
            Object.defineProperty(_this, "handleFileSelect", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($068daf19f8f6c317$var$__runInitializers(_this, _analysisOptions_extraInitializers), function(param) {
                    var currentTarget = param.currentTarget;
                    var _ref = (0, $leE2g._)(currentTarget.files || [], 1), file = _ref[0];
                    if (file) _this.handleFile(file);
                })
            });
            Object.defineProperty(_this, "handleDrop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(event) {
                    event.preventDefault();
                    var _ref = (0, $leE2g._)(event.dataTransfer.files || [], 1), file = _ref[0];
                    if (file) _this.handleFile(file);
                }
            });
            Object.defineProperty(_this, "handleDragOver", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(event) {
                    return event.preventDefault();
                }
            });
            Object.defineProperty(_this, "handleFile", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(file) {
                    return $068daf19f8f6c317$var$__awaiter(_this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!$068daf19f8f6c317$var$validTypes.includes(file.type) && !file.name.endsWith('.xls')) return [
                                        2,
                                        this.formatValidation = {
                                            status: 'error',
                                            message: (0, $50993b47476de2e7$export$625550452a3fa3ec)('file_format_not_correct')
                                        }
                                    ];
                                    if (file.size > (0, $34a018c34fa26e49$export$ca7cde60f7d1391d)) return [
                                        2,
                                        this.formatValidation = {
                                            status: 'error',
                                            message: (0, $50993b47476de2e7$export$625550452a3fa3ec)('file_exceeds_max_size', {
                                                size: '10MB'
                                            })
                                        }
                                    ];
                                    this.selectedFile = file;
                                    this.formatValidation = {
                                        status: 'validating'
                                    };
                                    // 模拟上传进度
                                    return [
                                        4,
                                        this.simulateUpload()
                                    ];
                                case 1:
                                    _state.sent();
                                    // 模拟格式验证
                                    return [
                                        4,
                                        this.simulateValidation()
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            });
            Object.defineProperty(_this, "simulateUpload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return $068daf19f8f6c317$var$__awaiter(_this, void 0, void 0, function() {
                        var i;
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    i = 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(i <= 100)) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        (0, $6tqvJ.sleep)()
                                    ];
                                case 2:
                                    _state.sent();
                                    this.uploadProgress = i;
                                    _state.label = 3;
                                case 3:
                                    i += 10;
                                    return [
                                        3,
                                        1
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            });
            Object.defineProperty(_this, "simulateValidation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return $068daf19f8f6c317$var$__awaiter(_this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0, $6tqvJ.sleep)()
                                    ];
                                case 1:
                                    _state.sent();
                                    // 模拟验证成功
                                    this.formatValidation = {
                                        status: 'success',
                                        rowCount: 4300,
                                        totalRows: 4320,
                                        message: undefined
                                    };
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            });
            Object.defineProperty(_this, "handleOptionToggle", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var currentTarget = param.currentTarget;
                    var id = currentTarget.id, checked = currentTarget.checked;
                    var option = _this.analysisOptions.find(function(opt) {
                        return opt.id === id;
                    });
                    if (option) option.checked = checked;
                }
            });
            Object.defineProperty(_this, "handleReselect", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    _this.selectedFile = null;
                    _this.uploadProgress = 0;
                    _this.formatValidation = {
                        status: 'idle'
                    };
                }
            });
            Object.defineProperty(_this, "handleSubmit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(event) {
                    event.preventDefault();
                    // TODO: 实现提交逻辑
                    console.log('Submitting task with options:', _this.analysisOptions);
                }
            });
            Object.defineProperty(_this, "renderUploadArea", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "text-center",
                        style: {
                            cursor: 'pointer'
                        },
                        body: true,
                        onDrop: _this.handleDrop,
                        onDragOver: _this.handleDragOver,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                name: "cloud-upload",
                                style: {
                                    fontSize: '64px',
                                    color: '#6c757d'
                                }
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h4", {
                                className: "mt-3",
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('upload_work_order_file')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                className: "text-muted",
                                children: [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('support_excel_format'),
                                    ", ",
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('max_size_10mb')
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("label", {
                                className: "btn btn-primary mt-2",
                                style: {
                                    cursor: 'pointer'
                                },
                                children: [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('select_file'),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("input", {
                                        type: "file",
                                        className: "d-none",
                                        accept: ".xls,.xlsx",
                                        onChange: _this.handleFileSelect
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                className: "text-muted small mt-3",
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('or_drag_file_here')
                            })
                        ]
                    });
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "selectedFile",
                get: function get() {
                    return $068daf19f8f6c317$var$__classPrivateFieldGet(this, _OptimizationTaskCreatorPage_selectedFile_accessor_storage, "f");
                },
                set: function set(value) {
                    $068daf19f8f6c317$var$__classPrivateFieldSet(this, _OptimizationTaskCreatorPage_selectedFile_accessor_storage, value, "f");
                }
            },
            {
                key: "uploadProgress",
                get: function get() {
                    return $068daf19f8f6c317$var$__classPrivateFieldGet(this, _OptimizationTaskCreatorPage_uploadProgress_accessor_storage, "f");
                },
                set: function set(value) {
                    $068daf19f8f6c317$var$__classPrivateFieldSet(this, _OptimizationTaskCreatorPage_uploadProgress_accessor_storage, value, "f");
                }
            },
            {
                key: "formatValidation",
                get: function get() {
                    return $068daf19f8f6c317$var$__classPrivateFieldGet(this, _OptimizationTaskCreatorPage_formatValidation_accessor_storage, "f");
                },
                set: function set(value) {
                    $068daf19f8f6c317$var$__classPrivateFieldSet(this, _OptimizationTaskCreatorPage_formatValidation_accessor_storage, value, "f");
                }
            },
            {
                key: "analysisOptions",
                get: function get() {
                    return $068daf19f8f6c317$var$__classPrivateFieldGet(this, _OptimizationTaskCreatorPage_analysisOptions_accessor_storage, "f");
                },
                set: function set(value) {
                    $068daf19f8f6c317$var$__classPrivateFieldSet(this, _OptimizationTaskCreatorPage_analysisOptions_accessor_storage, value, "f");
                }
            },
            {
                key: "renderFileStatus",
                value: function renderFileStatus() {
                    var _this = this, uploadProgress = _this.uploadProgress, formatValidation = _this.formatValidation;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                body: true,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('uploading')
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c1e72b825e10557b$export$2e2bcd8739ae039), {
                                        now: uploadProgress,
                                        label: "".concat(uploadProgress, "%"),
                                        className: "mb-3",
                                        style: {
                                            height: '24px'
                                        },
                                        variant: uploadProgress === 100 ? 'success' : 'primary'
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                body: true,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('format_validation')
                                    }),
                                    formatValidation.status === 'error' && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex align-items-start text-danger mt-3",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "x-circle",
                                                className: "me-2 mt-1"
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                        className: "fw-bold",
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('file_format_not_correct')
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                        className: "small",
                                                        children: [
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('error_label'),
                                                            ": [",
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('column_missing'),
                                                            "] [",
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('wrong_file_type'),
                                                            "]",
                                                            ' ',
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('word_vs_expected_format')
                                                        ]
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                        className: "text-muted small mt-1",
                                                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('check_file_not_correct')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    formatValidation.status === 'success' && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex align-items-start text-success mt-3",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "check-circle",
                                                className: "me-2 mt-1"
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                        className: "fw-bold",
                                                        children: [
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_count'),
                                                            ": (",
                                                            formatValidation.rowCount,
                                                            " /",
                                                            ' ',
                                                            formatValidation.totalRows,
                                                            ")"
                                                        ]
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                        className: "text-muted small",
                                                        children: [
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('uploaded_orders'),
                                                            ":",
                                                            ' ',
                                                            formatValidation.rowCount,
                                                            ",",
                                                            ' ',
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('orders_excluded')
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                        className: "text-center",
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            className: "mt-3",
                                            onClick: this.handleReselect,
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('reselect_file')
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            },
            {
                key: "renderAnalysisOptions",
                value: function renderAnalysisOptions() {
                    var _this = this;
                    var formatValidation = this.formatValidation;
                    var isDisabled = formatValidation.status !== 'success';
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        body: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_analysis_capabilities')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                                as: "ul",
                                className: "list-unstyled g-3 mt-1",
                                xs: 2,
                                children: this.analysisOptions.map(function(option) {
                                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        as: "li",
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $beea41fc30491526$export$2e2bcd8739ae039), {
                                            className: "w-100 h-100 text-start",
                                            variant: "outline-primary",
                                            type: "checkbox",
                                            name: "type",
                                            value: option.id,
                                            id: option.id,
                                            checked: option.checked,
                                            onChange: _this.handleOptionToggle,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                    className: "d-flex align-items-center mb-2",
                                                    children: [
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h6", {
                                                            className: "mb-0",
                                                            children: option.title
                                                        }),
                                                        option.checked && !isDisabled && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                            name: "check-circle-fill",
                                                            className: "ms-auto text-primary"
                                                        })
                                                    ]
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                                    className: "text-muted small mb-0",
                                                    children: option.description
                                                })
                                            ]
                                        })
                                    }, option.id);
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "text-center mt-3",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                    type: "submit",
                                    variant: "primary",
                                    size: "lg",
                                    disabled: isDisabled,
                                    style: {
                                        minWidth: '200px'
                                    },
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "play-fill"
                                        }),
                                        " ",
                                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('start_now')
                                    ]
                                })
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var selectedFile = this.selectedFile;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $eb8ef8f36513dc70$export$2e2bcd8739ae039), {
                        className: "py-4",
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039), {
                            className: "d-flex flex-column gap-3",
                            onSubmit: this.handleSubmit,
                            children: [
                                this.renderUploadArea(),
                                selectedFile && this.renderFileStatus(),
                                this.renderAnalysisOptions()
                            ]
                        })
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _OptimizationTaskCreatorPage_selectedFile_accessor_storage = new WeakMap();
    _OptimizationTaskCreatorPage_uploadProgress_accessor_storage = new WeakMap();
    _OptimizationTaskCreatorPage_formatValidation_accessor_storage = new WeakMap();
    _OptimizationTaskCreatorPage_analysisOptions_accessor_storage = new WeakMap();
    $068daf19f8f6c317$var$__setFunctionName(_classThis, "OptimizationTaskCreatorPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _selectedFile_decorators = [
            (0, $arNK5.observable)
        ];
        _uploadProgress_decorators = [
            (0, $arNK5.observable)
        ];
        _formatValidation_decorators = [
            (0, $arNK5.observable)
        ];
        _analysisOptions_decorators = [
            (0, $arNK5.observable)
        ];
        $068daf19f8f6c317$var$__esDecorate(_classThis, null, _selectedFile_decorators, {
            kind: "accessor",
            name: "selectedFile",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "selectedFile" in obj;
                },
                get: function(obj) {
                    return obj.selectedFile;
                },
                set: function(obj, value) {
                    obj.selectedFile = value;
                }
            },
            metadata: _metadata
        }, _selectedFile_initializers, _selectedFile_extraInitializers);
        $068daf19f8f6c317$var$__esDecorate(_classThis, null, _uploadProgress_decorators, {
            kind: "accessor",
            name: "uploadProgress",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "uploadProgress" in obj;
                },
                get: function(obj) {
                    return obj.uploadProgress;
                },
                set: function(obj, value) {
                    obj.uploadProgress = value;
                }
            },
            metadata: _metadata
        }, _uploadProgress_initializers, _uploadProgress_extraInitializers);
        $068daf19f8f6c317$var$__esDecorate(_classThis, null, _formatValidation_decorators, {
            kind: "accessor",
            name: "formatValidation",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "formatValidation" in obj;
                },
                get: function(obj) {
                    return obj.formatValidation;
                },
                set: function(obj, value) {
                    obj.formatValidation = value;
                }
            },
            metadata: _metadata
        }, _formatValidation_initializers, _formatValidation_extraInitializers);
        $068daf19f8f6c317$var$__esDecorate(_classThis, null, _analysisOptions_decorators, {
            kind: "accessor",
            name: "analysisOptions",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "analysisOptions" in obj;
                },
                get: function(obj) {
                    return obj.analysisOptions;
                },
                set: function(obj, value) {
                    obj.analysisOptions = value;
                }
            },
            metadata: _metadata
        }, _analysisOptions_initializers, _analysisOptions_extraInitializers);
        $068daf19f8f6c317$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        OptimizationTaskCreatorPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $068daf19f8f6c317$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return OptimizationTaskCreatorPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $fsSDT = parcelRequire("fsSDT");

var $5f0Cq = parcelRequire("5f0Cq");



var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");
var $1a41b297107e66ec$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $1a41b297107e66ec$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $1a41b297107e66ec$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $1a41b297107e66ec$var$LevelColor = {
    SUCCESS: 'text-success',
    WARNING: 'text-warning',
    ERROR: 'text-danger',
    INFO: 'text-info'
};
var $1a41b297107e66ec$export$323c4dba70a36b88 = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var TaskLogs = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "logsEndRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: /*#__PURE__*/ (0, $fClfl.createRef)()
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var _a;
                    if (this.props.autoScroll) (_a = this.logsEndRef.current) === null || _a === void 0 || _a.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var logs = this.props.logs;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "task-logs bg-dark text-light p-3 rounded",
                        style: {
                            fontFamily: 'monospace',
                            fontSize: '0.875rem',
                            maxHeight: '500px',
                            overflowY: 'auto'
                        },
                        children: [
                            logs.map(function(param, index) {
                                var timestamp = param.timestamp, level = param.level, message = param.message;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "mb-1",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                            className: "text-muted",
                                            children: timestamp
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                            className: "ms-2 fw-bold ".concat($1a41b297107e66ec$var$LevelColor[level]),
                                            children: level
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                            className: "ms-2",
                                            children: message
                                        })
                                    ]
                                }, index);
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                ref: this.logsEndRef
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $1a41b297107e66ec$var$__setFunctionName(_classThis, "TaskLogs");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $1a41b297107e66ec$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TaskLogs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $1a41b297107e66ec$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TaskLogs = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $fClfl = parcelRequire("fClfl");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $21905a9c2e485c92$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $21905a9c2e485c92$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $21905a9c2e485c92$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $21905a9c2e485c92$export$7472b03414321c98 = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var TaskSteps = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "renderStep", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var title = param.title, summary = param.summary, index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    var currentStep = _this.props.currentStep;
                    var isDone = currentStep !== undefined && index < currentStep, isDoing = currentStep === index;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("li", {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                                className: "fs-5 d-flex align-items-center gap-2",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "rounded-circle bg-primary text-white d-flex justify-content-center align-items-center",
                                        style: {
                                            width: '2rem',
                                            height: '2rem',
                                            filter: !isDone && !isDoing ? 'grayscale(100%)' : 'none'
                                        },
                                        children: index + 1
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        className: "text-primary",
                                        style: {
                                            filter: !isDone ? 'grayscale(100%)' : 'none'
                                        },
                                        children: title
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                className: "text-muted ms-4 ps-3",
                                children: summary
                            })
                        ]
                    }, index);
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "statusBadge",
                get: function get() {
                    var status = this.props.task.status;
                    return ({
                        completed: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                            bg: "success",
                            text: "white",
                            pill: true,
                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('completed')
                        }),
                        in_progress: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                            bg: "primary",
                            text: "white",
                            pill: true,
                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('in_analysis')
                        }),
                        failed: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                            bg: "danger",
                            text: "white",
                            pill: true,
                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('failed')
                        })
                    })[status];
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this_props = this.props, task = _this_props.task, steps = _this_props.steps, _this_props_currentStep = _this_props.currentStep, currentStep = _this_props_currentStep === void 0 ? 0 : _this_props_currentStep;
                    var name = task.name, startedAt = task.startedAt;
                    var percent = +(currentStep / steps.length * 100).toFixed(1);
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("hgroup", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h2", {
                                                className: "fs-4",
                                                children: name
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("time", {
                                                className: "small text-gray",
                                                children: [
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('start_time'),
                                                    "\uFF1A",
                                                    new Date(startedAt).toLocaleString()
                                                ]
                                            })
                                        ]
                                    }),
                                    this.statusBadge
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("section", {
                                className: "d-flex flex-column gap-3 my-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                        className: "d-flex justify-content-between align-items-center",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('analysis_progress', {
                                                    percent: 0,
                                                    count: 0
                                                }).split("\uFF1A")[0]
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                children: [
                                                    percent,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c1e72b825e10557b$export$2e2bcd8739ae039), {
                                        variant: "danger",
                                        now: percent
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                                        className: "rounded bg-light p-3 d-flex justify-content-between align-items-center",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                children: [
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('current_stage'),
                                                    "\uFF1A"
                                                ]
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                children: [
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('estimated_remaining'),
                                                    "\uFF1A"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ol", {
                                className: "list-unstyled",
                                children: steps.map(this.renderStep)
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $21905a9c2e485c92$var$__setFunctionName(_classThis, "TaskSteps");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $21905a9c2e485c92$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TaskSteps = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $21905a9c2e485c92$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TaskSteps = _classThis;
}();




var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");


var $0b09d8b874d827d5$export$61df44ebcf47f253 = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(DeduplicationTaskModel, TableModel);
    function DeduplicationTaskModel() {
        (0, $7lhcp._)(this, DeduplicationTaskModel);
        var _this;
        _this = (0, $07dqX._)(this, DeduplicationTaskModel, arguments);
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/task/deduplication'
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        return _this;
    }
    return DeduplicationTaskModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $0b09d8b874d827d5$export$2e2bcd8739ae039 = new $0b09d8b874d827d5$export$61df44ebcf47f253();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");


var $c0c4378fd4fa6b7e$export$95addf36e568df18 = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(TaskResultModel, TableModel);
    function TaskResultModel(taskType, taskId) {
        (0, $7lhcp._)(this, TaskResultModel);
        var _this;
        _this = (0, $07dqX._)(this, TaskResultModel);
        Object.defineProperty(_this, "taskType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: taskType
        });
        Object.defineProperty(_this, "taskId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: taskId
        });
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        _this.baseURI = "/task/".concat(taskType, "/").concat(taskId, "/result");
        return _this;
    }
    return TaskResultModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));



var $c793570562ce1529$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c793570562ce1529$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c793570562ce1529$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $c793570562ce1529$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c793570562ce1529$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c793570562ce1529$var$ProcessingStatusColors = {
    pending: 'warning',
    processed: 'success',
    no_change: 'secondary',
    manual_review: 'info'
};
var $c793570562ce1529$export$c1215908a5a09938 = function() {
    var _OptimizationTaskDetailPage_logs_accessor_storage;
    var _classDecorators = [
        (0, $397c81af6d5568dc$export$369b6b2b30582e8e),
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _logs_decorators;
    var _logs_initializers = [];
    var _logs_extraInitializers = [];
    var _get_filterFields_decorators;
    var _get_taskSteps_decorators;
    var _get_commonColumns_decorators;
    var _get_classificationColumns_decorators;
    var _get_deduplicationColumns_decorators;
    var _get_sensitiveColumns_decorators;
    var _get_responsibleColumns_decorators;
    var OptimizationTaskDetailPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _OptimizationTaskDetailPage_logs_accessor_storage.set(_this, ($c793570562ce1529$var$__runInitializers(_this, _instanceExtraInitializers), $c793570562ce1529$var$__runInitializers(_this, _logs_initializers, [])));
            Object.defineProperty(_this, "logPollingTimer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $c793570562ce1529$var$__runInitializers(_this, _logs_extraInitializers)
            });
            Object.defineProperty(_this, "addMockLog", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function() {
                    var now = new Date();
                    var timestamp = "".concat(now.getHours().toString().padStart(2, '0'), ":").concat(now.getMinutes().toString().padStart(2, '0'), ":").concat(now.getSeconds().toString().padStart(2, '0'));
                    var messages = [
                        {
                            level: 'SUCCESS',
                            message: (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t('duplicate_workorder_found', {
                                count: 3
                            })
                        },
                        {
                            level: 'INFO',
                            message: (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t('analyzing_workorders')
                        },
                        {
                            level: 'WARNING',
                            message: (0, $50993b47476de2e7$export$a7357cdd1f0b0168).t('manual_review')
                        }
                    ];
                    var randomMessage = messages[Math.floor(Math.random() * messages.length)];
                    _this.logs = (0, $fsSDT._)(_this.logs).concat([
                        {
                            timestamp: timestamp,
                            level: randomMessage.level,
                            message: randomMessage.message
                        }
                    ]);
                    // Keep only last 50 logs
                    if (_this.logs.length > 50) _this.logs = _this.logs.slice(-50);
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "logs",
                get: function get() {
                    return $c793570562ce1529$var$__classPrivateFieldGet(this, _OptimizationTaskDetailPage_logs_accessor_storage, "f");
                },
                set: function set(value) {
                    $c793570562ce1529$var$__classPrivateFieldSet(this, _OptimizationTaskDetailPage_logs_accessor_storage, value, "f");
                }
            },
            {
                key: "filterFields",
                get: function get() {
                    return [
                        {
                            key: 'processingStatus',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('status'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'pending',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('pending')
                                },
                                {
                                    value: 'processed',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('processed')
                                },
                                {
                                    value: 'no_change',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('no_change')
                                },
                                {
                                    value: 'manual_review',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('manual_review')
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "taskStore",
                get: function get() {
                    var type = this.props.match.params.type;
                    return type === 'classification' ? (0, $b60bedf248b12f36$export$2e2bcd8739ae039) : (0, $0b09d8b874d827d5$export$2e2bcd8739ae039);
                }
            },
            {
                key: "taskResultStore",
                get: function get() {
                    var _this_props_match_params = this.props.match.params, type = _this_props_match_params.type, id = _this_props_match_params.id;
                    return new (0, $c0c4378fd4fa6b7e$export$95addf36e568df18)(type, +id);
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var id = this.props.match.params.id;
                    (0, $0b09d8b874d827d5$export$2e2bcd8739ae039).getOne(+id);
                    this.startLogPolling();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.stopLogPolling();
                }
            },
            {
                key: "startLogPolling",
                value: function startLogPolling() {
                    this.logPollingTimer = setInterval(this.addMockLog, 2000);
                }
            },
            {
                key: "stopLogPolling",
                value: function stopLogPolling() {
                    if (this.logPollingTimer) clearInterval(this.logPollingTimer);
                }
            },
            {
                key: "taskSteps",
                get: function get() {
                    var _deduplicationTaskStore_currentOne = (0, $0b09d8b874d827d5$export$2e2bcd8739ae039).currentOne, status = _deduplicationTaskStore_currentOne.status, processedWorkOrders = _deduplicationTaskStore_currentOne.processedWorkOrders, totalWorkOrders = _deduplicationTaskStore_currentOne.totalWorkOrders;
                    var isInProgress = status === 'in_progress';
                    var progress = (processedWorkOrders || 0) / (totalWorkOrders || 1) * 100;
                    return [
                        {
                            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('data_preprocessing'),
                            summary: (0, $50993b47476de2e7$export$625550452a3fa3ec)('reading_classification_workorders', {
                                task: totalWorkOrders || 0
                            })
                        },
                        {
                            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_workorder_analysis'),
                            summary: isInProgress ? (0, $50993b47476de2e7$export$625550452a3fa3ec)('analysis_progress', {
                                percent: progress.toFixed(0),
                                count: this.taskResultStore.totalCount
                            }) : undefined
                        },
                        {
                            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('completed')
                        }
                    ];
                }
            },
            {
                key: "commonColumns",
                get: function get() {
                    return {
                        id: {
                            key: 'id',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('id_number')
                        },
                        workOrder: {
                            key: 'workOrder',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_id'),
                            renderBody: function(param) {
                                var workOrder = param.workOrder;
                                return (workOrder === null || workOrder === void 0 ? void 0 : workOrder.orderNumber) || '-';
                            }
                        },
                        processingStatus: {
                            key: 'processingStatus',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('status'),
                            renderBody: function(param) {
                                var processingStatus = param.processingStatus;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: $c793570562ce1529$var$ProcessingStatusColors[processingStatus],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)(processingStatus)
                                });
                            }
                        },
                        createdAt: {
                            key: 'createdAt',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('processing_time'),
                            renderBody: function(param) {
                                var createdAt = param.createdAt;
                                return new Date(createdAt).toLocaleString();
                            }
                        }
                    };
                }
            },
            {
                key: "classificationColumns",
                get: function get() {
                    var _this_commonColumns = this.commonColumns, id = _this_commonColumns.id, workOrder = _this_commonColumns.workOrder, processingStatus = _this_commonColumns.processingStatus, createdAt = _this_commonColumns.createdAt;
                    return [
                        id,
                        workOrder,
                        {
                            key: 'oldCategory',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('original_category'),
                            renderBody: function(param) {
                                var oldCategory = param.oldCategory;
                                return (oldCategory === null || oldCategory === void 0 ? void 0 : oldCategory.level1Category) || '-';
                            }
                        },
                        {
                            key: 'newCategory',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('new_category_tag'),
                            renderBody: function(param) {
                                var newCategory = param.newCategory;
                                return (newCategory === null || newCategory === void 0 ? void 0 : newCategory.level1Category) || '-';
                            }
                        },
                        {
                            key: 'changeReason',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('change_reason'),
                            renderBody: function(param) {
                                var changeReason = param.changeReason;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: changeReason || '-'
                                });
                            }
                        },
                        processingStatus,
                        createdAt
                    ];
                }
            },
            {
                key: "deduplicationColumns",
                get: function get() {
                    var _this_commonColumns = this.commonColumns, id = _this_commonColumns.id, workOrder = _this_commonColumns.workOrder, processingStatus = _this_commonColumns.processingStatus, createdAt = _this_commonColumns.createdAt;
                    return [
                        id,
                        workOrder,
                        {
                            key: 'duplicateWorkOrder',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('corresponding_workorder'),
                            renderBody: function(param) {
                                var duplicateWorkOrder = param.duplicateWorkOrder;
                                return (duplicateWorkOrder === null || duplicateWorkOrder === void 0 ? void 0 : duplicateWorkOrder.orderNumber) || '-';
                            }
                        },
                        {
                            key: 'duplicateReason',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('reason_for_duplication'),
                            renderBody: function(param) {
                                var duplicateReason = param.duplicateReason;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: duplicateReason || '-'
                                });
                            }
                        },
                        {
                            key: 'similarityScore',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('similarity'),
                            renderBody: function(param) {
                                var similarityScore = param.similarityScore;
                                return similarityScore ? "".concat((similarityScore * 100).toFixed(1), "%") : '-';
                            }
                        },
                        processingStatus,
                        createdAt
                    ];
                }
            },
            {
                key: "sensitiveColumns",
                get: function get() {
                    var _this_commonColumns = this.commonColumns, id = _this_commonColumns.id, workOrder = _this_commonColumns.workOrder, processingStatus = _this_commonColumns.processingStatus, createdAt = _this_commonColumns.createdAt;
                    return [
                        id,
                        workOrder,
                        {
                            key: 'sensitiveType',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_type')
                        },
                        {
                            key: 'aiExtractionReason',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_extraction_reason'),
                            renderBody: function(param) {
                                var aiExtractionReason = param.aiExtractionReason;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: aiExtractionReason || '-'
                                });
                            }
                        },
                        processingStatus,
                        createdAt
                    ];
                }
            },
            {
                key: "responsibleColumns",
                get: function get() {
                    var _this_commonColumns = this.commonColumns, id = _this_commonColumns.id, workOrder = _this_commonColumns.workOrder, processingStatus = _this_commonColumns.processingStatus, createdAt = _this_commonColumns.createdAt;
                    return [
                        id,
                        workOrder,
                        {
                            key: 'unitName',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('unit_name')
                        },
                        {
                            key: 'powerSupplyOffice',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('power_supply_office')
                        },
                        {
                            key: 'areaManager',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('area_manager')
                        },
                        {
                            key: 'violationIssue',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('violation_issue'),
                            renderBody: function(param) {
                                var violationIssue = param.violationIssue;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: violationIssue || '-'
                                });
                            }
                        },
                        {
                            key: 'rectificationRequirement',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rectification_requirement'),
                            renderBody: function(param) {
                                var rectificationRequirement = param.rectificationRequirement;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: rectificationRequirement || '-'
                                });
                            }
                        },
                        {
                            key: 'referencedPolicy',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('referenced_policy'),
                            renderBody: function(param) {
                                var referencedPolicy = param.referencedPolicy;
                                return (referencedPolicy === null || referencedPolicy === void 0 ? void 0 : referencedPolicy.title) || '-';
                            }
                        },
                        processingStatus,
                        createdAt
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    var downloading = (0, $0b09d8b874d827d5$export$2e2bcd8739ae039).downloading, currentOne = (0, $0b09d8b874d827d5$export$2e2bcd8739ae039).currentOne;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $eb8ef8f36513dc70$export$2e2bcd8739ae039), {
                        className: "py-4",
                        fluid: true,
                        children: [
                            downloading > 0 && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Loading), {}),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                                className: "mb-4",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        md: 6,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                            className: "p-3 shadow-sm",
                                            body: true,
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $21905a9c2e485c92$export$7472b03414321c98), {
                                                task: currentOne,
                                                steps: this.taskSteps,
                                                currentStep: 1
                                            })
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        md: 6,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                            className: "shadow-sm",
                                            body: true,
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Title, {
                                                    as: "h2",
                                                    className: "fs-5",
                                                    children: [
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                            name: "terminal",
                                                            className: "me-2"
                                                        }),
                                                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('real_time_logs')
                                                    ]
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1a41b297107e66ec$export$323c4dba70a36b88), {
                                                    logs: this.logs,
                                                    autoScroll: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                className: "shadow-sm",
                                body: true,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                        className: "d-flex justify-content-between align-items-center gap-3",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Title, {
                                                as: "h2",
                                                className: "fs-5 flex-fill",
                                                children: [
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('deduplication_result'),
                                                    " (",
                                                    this.taskResultStore.totalCount,
                                                    ")"
                                                ]
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $0f0265dfbf11fad4$export$2e2bcd8739ae039), {
                                                className: "w-auto",
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $0f0265dfbf11fad4$export$2e2bcd8739ae039).Text, {
                                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                            name: "search"
                                                        })
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5c296c727f05ae92$export$2e2bcd8739ae039), {
                                                        type: "search",
                                                        placeholder: (0, $50993b47476de2e7$export$625550452a3fa3ec)('search')
                                                    })
                                                ]
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('export_file')
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                        className: "text-center",
                                        filterFields: this.filterFields,
                                        columns: this.deduplicationColumns,
                                        store: this.taskResultStore,
                                        translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                        striped: true,
                                        hover: true
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _OptimizationTaskDetailPage_logs_accessor_storage = new WeakMap();
    $c793570562ce1529$var$__setFunctionName(_classThis, "OptimizationTaskDetailPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _logs_decorators = [
            (0, $arNK5.observable)
        ];
        _get_filterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_taskSteps_decorators = [
            (0, $arNK5.computed)
        ];
        _get_commonColumns_decorators = [
            (0, $arNK5.computed)
        ];
        _get_classificationColumns_decorators = [
            (0, $arNK5.computed)
        ];
        _get_deduplicationColumns_decorators = [
            (0, $arNK5.computed)
        ];
        _get_sensitiveColumns_decorators = [
            (0, $arNK5.computed)
        ];
        _get_responsibleColumns_decorators = [
            (0, $arNK5.computed)
        ];
        $c793570562ce1529$var$__esDecorate(_classThis, null, _logs_decorators, {
            kind: "accessor",
            name: "logs",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "logs" in obj;
                },
                get: function(obj) {
                    return obj.logs;
                },
                set: function(obj, value) {
                    obj.logs = value;
                }
            },
            metadata: _metadata
        }, _logs_initializers, _logs_extraInitializers);
        $c793570562ce1529$var$__esDecorate(_classThis, null, _get_filterFields_decorators, {
            kind: "getter",
            name: "filterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filterFields" in obj;
                },
                get: function(obj) {
                    return obj.filterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c793570562ce1529$var$__esDecorate(_classThis, null, _get_taskSteps_decorators, {
            kind: "getter",
            name: "taskSteps",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "taskSteps" in obj;
                },
                get: function(obj) {
                    return obj.taskSteps;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c793570562ce1529$var$__esDecorate(_classThis, null, _get_commonColumns_decorators, {
            kind: "getter",
            name: "commonColumns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "commonColumns" in obj;
                },
                get: function(obj) {
                    return obj.commonColumns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c793570562ce1529$var$__esDecorate(_classThis, null, _get_classificationColumns_decorators, {
            kind: "getter",
            name: "classificationColumns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "classificationColumns" in obj;
                },
                get: function(obj) {
                    return obj.classificationColumns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c793570562ce1529$var$__esDecorate(_classThis, null, _get_deduplicationColumns_decorators, {
            kind: "getter",
            name: "deduplicationColumns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "deduplicationColumns" in obj;
                },
                get: function(obj) {
                    return obj.deduplicationColumns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c793570562ce1529$var$__esDecorate(_classThis, null, _get_sensitiveColumns_decorators, {
            kind: "getter",
            name: "sensitiveColumns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "sensitiveColumns" in obj;
                },
                get: function(obj) {
                    return obj.sensitiveColumns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c793570562ce1529$var$__esDecorate(_classThis, null, _get_responsibleColumns_decorators, {
            kind: "getter",
            name: "responsibleColumns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "responsibleColumns" in obj;
                },
                get: function(obj) {
                    return obj.responsibleColumns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $c793570562ce1529$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        OptimizationTaskDetailPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $c793570562ce1529$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return OptimizationTaskDetailPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");

var $Csf8W = parcelRequire("Csf8W");



var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");



var $6tqvJ = parcelRequire("6tqvJ");




var $b87e15a3d7e6b005$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b87e15a3d7e6b005$export$1ae2d23b707b7d19 = function(_a) {
    var id = _a.id, name = _a.name, startDate = _a.startDate, endDate = _a.endDate, selectedTemplate = _a.selectedTemplate, props = $b87e15a3d7e6b005$var$__rest(_a, [
        "id",
        "name",
        "startDate",
        "endDate",
        "selectedTemplate"
    ]);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039), Object.assign({}, props, {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h6", {
                className: "mb-3",
                children: "\u57FA\u672C\u4FE1\u606F"
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-3",
                xs: 1,
                md: 2,
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Group, {
                        className: "col",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Label, {
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_name')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Control, {
                                name: "name",
                                placeholder: (0, $50993b47476de2e7$export$625550452a3fa3ec)('enter_task_name'),
                                defaultValue: name
                            })
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Group, {
                        className: "col",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Label, {
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('time_range')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "d-flex align-items-center gap-2",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Control, {
                                        type: "date",
                                        name: "startDate",
                                        defaultValue: startDate
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                        children: "\u81F3"
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Control, {
                                        type: "date",
                                        name: "endDate",
                                        defaultValue: endDate
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h6", {
                className: "mb-3",
                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('select_template')
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-3 g-3",
                children: [
                    {
                        id: 'quality_service_weekly',
                        icon: 'clipboard-data',
                        title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('quality_service_weekly'),
                        description: "".concat((0, $50993b47476de2e7$export$625550452a3fa3ec)('all_business_control'), " ").concat((0, $50993b47476de2e7$export$625550452a3fa3ec)('quality_service'))
                    },
                    {
                        id: 'power_service_issues',
                        icon: 'exclamation-circle',
                        title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('power_service_issues'),
                        description: "".concat((0, $50993b47476de2e7$export$625550452a3fa3ec)('all_business_control'), " ").concat((0, $50993b47476de2e7$export$625550452a3fa3ec)('quality_service'))
                    },
                    {
                        id: 'annual_summary',
                        icon: 'calendar-check',
                        title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('annual_summary'),
                        description: "\u57FA\u4E8E\u5168\u5E74\u5DE5\u5355\u6570\u636E\u5206\u6790\uFF0C\u6307\u5BFC\u670D\u52A1\u7B56\u7565\u4E0E\u6D41\u7A0B\u4F18\u5316"
                    }
                ].map(function(template) {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                            as: "label",
                            className: "h-100 cursor-pointer ".concat(selectedTemplate === template.id ? 'border-primary' : ''),
                            body: true,
                            children: [
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex align-items-center justify-content-between mb-2",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: template.icon
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Check, {
                                            type: "radio",
                                            name: "template",
                                            checked: selectedTemplate === template.id,
                                            readOnly: true
                                        })
                                    ]
                                }),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "fw-bold mb-1",
                                    children: template.title
                                }),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("small", {
                                    className: "text-muted",
                                    children: template.description
                                })
                            ]
                        })
                    }, template.id);
                })
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                className: "bg-primary bg-opacity-10 mb-3",
                body: true,
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                    className: "d-flex align-items-start gap-2",
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                            className: "bg-primary rounded px-3 py-2",
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                name: "robot",
                                size: 2,
                                className: "text-white"
                            })
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                            className: "flex-grow-1 pt-2",
                            children: [
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h6", {
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_suggestion')
                                }),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                    className: "text-muted mb-2",
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('based_on_history')
                                }),
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex flex-column gap-2",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "d-flex align-items-start gap-2",
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                    name: "exclamation-circle",
                                                    className: "text-danger mt-1"
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_rate_increase')
                                                })
                                            ]
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "d-flex align-items-start gap-2",
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                    name: "exclamation-triangle",
                                                    className: "text-warning mt-1"
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('night_failure_low')
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("footer", {
                className: "border-top pt-3 d-flex align-items-center gap-2",
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                        className: "flex-fill text-muted",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                name: "clock-fill",
                                className: "me-2"
                            }),
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('time_range_has_orders')
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                        type: "reset",
                        variant: "secondary",
                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('cancel')
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                        type: "submit",
                        variant: "primary",
                        children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('start_analysis')
                    })
                ]
            })
        ]
    }));
};






var $b9b0795bcdb7f8fb$export$ad7b3d7483fb8b3f = function(param) {
    var title = param.title, value = param.value, icon = param.icon, color = param.color, change = param.change, changeType = param.changeType;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
        className: "h-100",
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Body, {
            className: "d-flex align-items-start",
            children: [
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                    className: "flex-grow-1",
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                            className: "text-muted mb-2",
                            children: title
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h3", {
                            className: "mb-1",
                            children: value
                        }),
                        change && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("small", {
                            className: changeType === 'increase' ? 'text-success' : 'text-danger',
                            children: [
                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                    name: changeType === 'increase' ? 'arrow-up' : 'arrow-down'
                                }),
                                ' ',
                                change,
                                " ",
                                (0, $50993b47476de2e7$export$625550452a3fa3ec)('compare_last_month')
                            ]
                        })
                    ]
                }),
                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                    className: "text-".concat(color),
                    name: icon,
                    size: 2
                })
            ]
        })
    });
};



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");


var $10af6da6882b5253$export$f0944324aec7001a = {
    in_progress: 'report_in_progress',
    queued: 'report_queued',
    completed: 'report_completed'
};
var $10af6da6882b5253$export$fc7115a836868b16 = {
    in_progress: 'warning',
    queued: 'info',
    completed: 'success'
};
var $10af6da6882b5253$export$9cce29ad1c22bfc7 = {
    weekly: 'report_type_weekly',
    monthly: 'report_type_monthly',
    quarterly: 'report_type_quarterly',
    annual: 'report_type_yearly'
};
var $10af6da6882b5253$export$6c0de313609f8f39 = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(ReportModel, TableModel);
    function ReportModel() {
        (0, $7lhcp._)(this, ReportModel);
        var _this;
        _this = (0, $07dqX._)(this, ReportModel, arguments);
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'report'
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        return _this;
    }
    return ReportModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $10af6da6882b5253$export$2e2bcd8739ae039 = new $10af6da6882b5253$export$6c0de313609f8f39();



var $12a70cd1e59ac341$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $12a70cd1e59ac341$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $12a70cd1e59ac341$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $12a70cd1e59ac341$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $12a70cd1e59ac341$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $12a70cd1e59ac341$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $12a70cd1e59ac341$export$83d9752a0a507b5d = function() {
    var _ReportListPage_showCreateModal_accessor_storage;
    var _classDecorators = [
        (0, $397c81af6d5568dc$export$369b6b2b30582e8e),
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _showCreateModal_decorators;
    var _showCreateModal_initializers = [];
    var _showCreateModal_extraInitializers = [];
    var _get_filterFields_decorators;
    var _get_columns_decorators;
    var ReportListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _ReportListPage_showCreateModal_accessor_storage.set(_this, ($12a70cd1e59ac341$var$__runInitializers(_this, _instanceExtraInitializers), $12a70cd1e59ac341$var$__runInitializers(_this, _showCreateModal_initializers, false)));
            Object.defineProperty(_this, "handleCreateReport", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($12a70cd1e59ac341$var$__runInitializers(_this, _showCreateModal_extraInitializers), function(event) {
                    return $12a70cd1e59ac341$var$__awaiter(_this, void 0, void 0, function() {
                        return (0, $Csf8W.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    event.preventDefault();
                                    return [
                                        4,
                                        (0, $10af6da6882b5253$export$2e2bcd8739ae039).updateOne((0, $6tqvJ.formToJSON)(event.currentTarget))
                                    ];
                                case 1:
                                    _state.sent();
                                    // This would normally create the report via API
                                    this.showCreateModal = false;
                                    return [
                                        2
                                    ];
                            }
                        });
                    // Reset form
                    });
                })
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "showCreateModal",
                get: function get() {
                    return $12a70cd1e59ac341$var$__classPrivateFieldGet(this, _ReportListPage_showCreateModal_accessor_storage, "f");
                },
                set: function set(value) {
                    $12a70cd1e59ac341$var$__classPrivateFieldSet(this, _ReportListPage_showCreateModal_accessor_storage, value, "f");
                }
            },
            {
                key: "filterFields",
                get: function get() {
                    return [
                        {
                            key: 'keywords',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('search')
                        },
                        {
                            key: 'name',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_name')
                        },
                        {
                            key: 'reportType',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_type'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'weekly',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_type_weekly')
                                },
                                {
                                    value: 'monthly',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_type_monthly')
                                },
                                {
                                    value: 'quarterly',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_type_quarterly')
                                },
                                {
                                    value: 'annual',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_type_yearly')
                                }
                            ]
                        },
                        {
                            key: 'status',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_status'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'in_progress',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_in_progress')
                                },
                                {
                                    value: 'queued',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_queued')
                                },
                                {
                                    value: 'completed',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_completed')
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "columns",
                get: function get() {
                    return [
                        {
                            key: 'name',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_name'),
                            renderBody: function(param) {
                                var name = param.name;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex align-items-center",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "file-earmark-text",
                                            className: "me-2 text-primary"
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                            children: name
                                        })
                                    ]
                                });
                            }
                        },
                        {
                            key: 'reportType',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_type'),
                            renderBody: function(param) {
                                var reportType = param.reportType;
                                return (0, $50993b47476de2e7$export$625550452a3fa3ec)((0, $10af6da6882b5253$export$9cce29ad1c22bfc7)[reportType]);
                            }
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('analysis_range'),
                            renderBody: function(param) {
                                var startDate = param.startDate, endDate = param.endDate;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                    children: [
                                        new Date(startDate).toLocaleDateString(),
                                        " ~",
                                        ' ',
                                        new Date(endDate).toLocaleDateString()
                                    ]
                                });
                            }
                        },
                        {
                            key: 'createdAt',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('created_at'),
                            renderBody: function(param) {
                                var createdAt = param.createdAt;
                                return new Date(createdAt).toLocaleString();
                            }
                        },
                        {
                            key: 'status',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_status'),
                            renderBody: function(param) {
                                var status = param.status;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: (0, $10af6da6882b5253$export$fc7115a836868b16)[status],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)((0, $10af6da6882b5253$export$f0944324aec7001a)[status])
                                });
                            }
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('operation'),
                            // @ts-expect-error Wait for Back-end updated
                            renderBody: function(param) {
                                var status = param.status, fileLink = param.fileLink;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex gap-2 justify-content-center",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            size: "sm",
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                    name: "eye",
                                                    className: "me-1"
                                                }),
                                                (0, $50993b47476de2e7$export$625550452a3fa3ec)('preview')
                                            ]
                                        }),
                                        status === 'completed' && fileLink && (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            size: "sm",
                                            className: "text-success",
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                    name: "download",
                                                    className: "me-1"
                                                }),
                                                (0, $50993b47476de2e7$export$625550452a3fa3ec)('download')
                                            ]
                                        })
                                    ]
                                });
                            }
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $eb8ef8f36513dc70$export$2e2bcd8739ae039), {
                        className: "py-4",
                        fluid: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                                className: "mb-4 g-3",
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        md: 3,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $b9b0795bcdb7f8fb$export$ad7b3d7483fb8b3f), {
                                            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('monthly_total_orders'),
                                            value: "1,234",
                                            icon: "clipboard-minus-fill",
                                            color: "primary",
                                            change: "15.3%",
                                            changeType: "increase"
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        md: 3,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $b9b0795bcdb7f8fb$export$ad7b3d7483fb8b3f), {
                                            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('pending_orders'),
                                            value: "45",
                                            icon: "clock-fill",
                                            color: "warning",
                                            change: "8.2%",
                                            changeType: "decrease"
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        md: 3,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $b9b0795bcdb7f8fb$export$ad7b3d7483fb8b3f), {
                                            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('processing_timeliness'),
                                            value: "98.5%",
                                            icon: "check-circle-fill",
                                            color: "success",
                                            change: "2.1%",
                                            changeType: "increase"
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                                        md: 3,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $b9b0795bcdb7f8fb$export$ad7b3d7483fb8b3f), {
                                            title: (0, $50993b47476de2e7$export$625550452a3fa3ec)('abnormal_orders'),
                                            value: "23",
                                            icon: "exclamation-triangle-fill",
                                            color: "danger",
                                            change: "12.4%",
                                            changeType: "decrease"
                                        })
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039).Body, {
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "mb-3 d-flex justify-content-between align-items-center",
                                            children: [
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                                                    className: "mb-0",
                                                    children: [
                                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                            name: "list-task",
                                                            className: "me-2"
                                                        }),
                                                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_list')
                                                    ]
                                                }),
                                                (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                                    className: "d-flex gap-2",
                                                    children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                                        variant: "primary",
                                                        onClick: function() {
                                                            return _this.showCreateModal = true;
                                                        },
                                                        children: [
                                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                                name: "plus-circle",
                                                                className: "me-2"
                                                            }),
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('create_report_task')
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                            className: "text-center",
                                            filterFields: this.filterFields,
                                            columns: this.columns,
                                            store: (0, $10af6da6882b5253$export$2e2bcd8739ae039),
                                            translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                            striped: true,
                                            hover: true
                                        })
                                    ]
                                })
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039), {
                                show: this.showCreateModal,
                                size: "lg",
                                onHide: function() {
                                    return _this.showCreateModal = false;
                                },
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Header, {
                                        closeButton: true,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Title, {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('create_report_task')
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Body, {
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $b87e15a3d7e6b005$export$1ae2d23b707b7d19), {
                                            onSubmit: this.handleCreateReport,
                                            onReset: function() {
                                                return _this.showCreateModal = false;
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _ReportListPage_showCreateModal_accessor_storage = new WeakMap();
    $12a70cd1e59ac341$var$__setFunctionName(_classThis, "ReportListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _showCreateModal_decorators = [
            (0, $arNK5.observable)
        ];
        _get_filterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_columns_decorators = [
            (0, $arNK5.computed)
        ];
        $12a70cd1e59ac341$var$__esDecorate(_classThis, null, _showCreateModal_decorators, {
            kind: "accessor",
            name: "showCreateModal",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "showCreateModal" in obj;
                },
                get: function(obj) {
                    return obj.showCreateModal;
                },
                set: function(obj, value) {
                    obj.showCreateModal = value;
                }
            },
            metadata: _metadata
        }, _showCreateModal_initializers, _showCreateModal_extraInitializers);
        $12a70cd1e59ac341$var$__esDecorate(_classThis, null, _get_filterFields_decorators, {
            kind: "getter",
            name: "filterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filterFields" in obj;
                },
                get: function(obj) {
                    return obj.filterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $12a70cd1e59ac341$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $12a70cd1e59ac341$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ReportListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $12a70cd1e59ac341$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ReportListPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");


var $arNK5 = parcelRequire("arNK5");

parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");



var $5f0Cq = parcelRequire("5f0Cq");

var $fClfl = parcelRequire("fClfl");
var $2e41795d340153db$var$r = "diffed", $2e41795d340153db$var$o = "__c", $2e41795d340153db$var$i = "__s", $2e41795d340153db$var$a = "__c", $2e41795d340153db$var$c = "__k", $2e41795d340153db$var$s = "__d", $2e41795d340153db$var$u = "__s", $2e41795d340153db$var$l = /[\s\n\\/='"\0<>]/, $2e41795d340153db$var$f = /^(xlink|xmlns|xml)([A-Z])/, $2e41795d340153db$var$p = /^(?:accessK|auto[A-Z]|cell|ch|col|cont|cross|dateT|encT|form[A-Z]|frame|hrefL|inputM|maxL|minL|noV|playsI|popoverT|readO|rowS|src[A-Z]|tabI|useM|item[A-Z])/, $2e41795d340153db$var$h = /^ac|^ali|arabic|basel|cap|clipPath$|clipRule$|color|dominant|enable|fill|flood|font|glyph[^R]|horiz|image|letter|lighting|marker[^WUH]|overline|panose|pointe|paint|rendering|shape|stop|strikethrough|stroke|text[^L]|transform|underline|unicode|units|^v[^i]|^w|^xH/, $2e41795d340153db$var$d = new Set([
    "draggable",
    "spellcheck"
]);
function $2e41795d340153db$var$v(e) {
    void 0 !== e.__g ? e.__g |= 8 : e[$2e41795d340153db$var$s] = !0;
}
function $2e41795d340153db$var$m(e) {
    void 0 !== e.__g ? e.__g &= -9 : e[$2e41795d340153db$var$s] = !1;
}
function $2e41795d340153db$var$_(e) {
    return void 0 !== e.__g ? !!(8 & e.__g) : !0 === e[$2e41795d340153db$var$s];
}
var $2e41795d340153db$var$y = /["&<]/;
function $2e41795d340153db$var$g(e) {
    if (0 === e.length || !1 === $2e41795d340153db$var$y.test(e)) return e;
    for(var t = 0, n = 0, r = "", o = ""; n < e.length; n++){
        switch(e.charCodeAt(n)){
            case 34:
                o = "&quot;";
                break;
            case 38:
                o = "&amp;";
                break;
            case 60:
                o = "&lt;";
                break;
            default:
                continue;
        }
        n !== t && (r += e.slice(t, n)), r += o, t = n + 1;
    }
    return n !== t && (r += e.slice(t, n)), r;
}
var $2e41795d340153db$var$b = {}, $2e41795d340153db$var$x = new Set([
    "animation-iteration-count",
    "border-image-outset",
    "border-image-slice",
    "border-image-width",
    "box-flex",
    "box-flex-group",
    "box-ordinal-group",
    "column-count",
    "fill-opacity",
    "flex",
    "flex-grow",
    "flex-negative",
    "flex-order",
    "flex-positive",
    "flex-shrink",
    "flood-opacity",
    "font-weight",
    "grid-column",
    "grid-row",
    "line-clamp",
    "line-height",
    "opacity",
    "order",
    "orphans",
    "stop-opacity",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "tab-size",
    "widows",
    "z-index",
    "zoom"
]), $2e41795d340153db$var$k = /[A-Z]/g;
function $2e41795d340153db$var$w(e) {
    var t = "";
    for(var n in e){
        var r = e[n];
        if (null != r && "" !== r) {
            var o = "-" == n[0] ? n : $2e41795d340153db$var$b[n] || ($2e41795d340153db$var$b[n] = n.replace($2e41795d340153db$var$k, "-$&").toLowerCase()), i = ";";
            "number" != typeof r || o.startsWith("--") || $2e41795d340153db$var$x.has(o) || (i = "px;"), t = t + o + ":" + r + i;
        }
    }
    return t || void 0;
}
function $2e41795d340153db$var$C() {
    this.__d = !0;
}
function $2e41795d340153db$var$A(e, t) {
    return {
        __v: e,
        context: t,
        props: e.props,
        setState: $2e41795d340153db$var$C,
        forceUpdate: $2e41795d340153db$var$C,
        __d: !0,
        __h: new Array(0)
    };
}
function $2e41795d340153db$var$S(e, t, n) {
    if (!e.s) {
        if (n instanceof $2e41795d340153db$var$L) {
            if (!n.s) return void (n.o = $2e41795d340153db$var$S.bind(null, e, t));
            1 & t && (t = n.s), n = n.v;
        }
        if (n && n.then) return void n.then($2e41795d340153db$var$S.bind(null, e, t), $2e41795d340153db$var$S.bind(null, e, 2));
        e.s = t, e.v = n;
        var r = e.o;
        r && r(e);
    }
}
var $2e41795d340153db$var$L = /*#__PURE__*/ function() {
    function e() {}
    return e.prototype.then = function(t, n) {
        var r = new e, o = this.s;
        if (o) {
            var i = 1 & o ? t : n;
            if (i) {
                try {
                    $2e41795d340153db$var$S(r, 1, i(this.v));
                } catch (e) {
                    $2e41795d340153db$var$S(r, 2, e);
                }
                return r;
            }
            return this;
        }
        return this.o = function(e) {
            try {
                var o = e.v;
                1 & e.s ? $2e41795d340153db$var$S(r, 1, t ? t(o) : o) : n ? $2e41795d340153db$var$S(r, 1, n(o)) : $2e41795d340153db$var$S(r, 2, o);
            } catch (e) {
                $2e41795d340153db$var$S(r, 2, e);
            }
        }, r;
    }, e;
}();
function $2e41795d340153db$var$E(e) {
    return e instanceof $2e41795d340153db$var$L && 1 & e.s;
}
function $2e41795d340153db$var$j(e, t, n) {
    for(var r;;){
        var o = e();
        if ($2e41795d340153db$var$E(o) && (o = o.v), !o) return i;
        if (o.then) {
            r = 0;
            break;
        }
        var i = n();
        if (i && i.then) {
            if (!$2e41795d340153db$var$E(i)) {
                r = 1;
                break;
            }
            i = i.s;
        }
        if (t) {
            var a = t();
            if (a && a.then && !$2e41795d340153db$var$E(a)) {
                r = 2;
                break;
            }
        }
    }
    var c = new $2e41795d340153db$var$L, s = $2e41795d340153db$var$S.bind(null, c, 2);
    return (0 === r ? o.then(l) : 1 === r ? i.then(u) : a.then(f)).then(void 0, s), c;
    function u(r) {
        i = r;
        do {
            if (t && (a = t()) && a.then && !$2e41795d340153db$var$E(a)) return void a.then(f).then(void 0, s);
            if (!(o = e()) || $2e41795d340153db$var$E(o) && !o.v) return void $2e41795d340153db$var$S(c, 1, i);
            if (o.then) return void o.then(l).then(void 0, s);
            $2e41795d340153db$var$E(i = n()) && (i = i.v);
        }while (!i || !i.then);
        i.then(u).then(void 0, s);
    }
    function l(e) {
        e ? (i = n()) && i.then ? i.then(u).then(void 0, s) : u(i) : $2e41795d340153db$var$S(c, 1, i);
    }
    function f() {
        (o = e()) ? o.then ? o.then(l).then(void 0, s) : l(o) : $2e41795d340153db$var$S(c, 1, i);
    }
}
function $2e41795d340153db$var$T(e, t) {
    try {
        var n = e();
    } catch (e) {
        return t(!0, e);
    }
    return n && n.then ? n.then(t.bind(null, !1), t.bind(null, !0)) : t(!1, n);
}
var $2e41795d340153db$var$D, $2e41795d340153db$var$P, $2e41795d340153db$var$$, $2e41795d340153db$var$U, $2e41795d340153db$export$f3aefc4196cd5f3e = function Z(a, s) {
    try {
        var u = (0, $fClfl.options)[$2e41795d340153db$var$i];
        (0, $fClfl.options)[$2e41795d340153db$var$i] = !0, $2e41795d340153db$var$D = (0, $fClfl.options).__b, $2e41795d340153db$var$P = (0, $fClfl.options)[$2e41795d340153db$var$r], $2e41795d340153db$var$$ = (0, $fClfl.options).__r, $2e41795d340153db$var$U = (0, $fClfl.options).unmount;
        var l = (0, $fClfl.h)((0, $fClfl.Fragment), null);
        return l[$2e41795d340153db$var$c] = [
            a
        ], Promise.resolve($2e41795d340153db$var$T(function() {
            return Promise.resolve($2e41795d340153db$var$O(a, s || $2e41795d340153db$var$F, !1, void 0, l, !0, void 0)).then(function(e) {
                var _$t, _$n = function() {
                    if ($2e41795d340153db$var$W(e)) {
                        var _$n = function n() {
                            var _$e = o.join($2e41795d340153db$var$H);
                            return _$t = 1, _$e;
                        }, r = 0, o = e, i = $2e41795d340153db$var$j(function() {
                            return !!o.some(function(e) {
                                return e && "function" == typeof e.then;
                            }) && r++ < 25;
                        }, void 0, function() {
                            return Promise.resolve(Promise.all(o)).then(function(e) {
                                o = e.flat();
                            });
                        });
                        return i && i.then ? i.then(_$n) : _$n();
                    }
                }();
                return _$n && _$n.then ? _$n.then(function(n) {
                    return _$t ? n : e;
                }) : _$t ? _$n : e;
            });
        }, function(t, n) {
            if ((0, $fClfl.options)[$2e41795d340153db$var$o] && (0, $fClfl.options)[$2e41795d340153db$var$o](a, $2e41795d340153db$var$M), (0, $fClfl.options)[$2e41795d340153db$var$i] = u, $2e41795d340153db$var$M.length = 0, t) throw n;
            return n;
        }));
    } catch (e) {
        return Promise.reject(e);
    }
}, $2e41795d340153db$var$F = {}, $2e41795d340153db$var$M = [], $2e41795d340153db$var$W = Array.isArray, $2e41795d340153db$var$z = Object.assign, $2e41795d340153db$var$H = "", $2e41795d340153db$var$N = "\x3c!--$s--\x3e", $2e41795d340153db$var$q = "\x3c!--/$s--\x3e";
function $2e41795d340153db$export$2e2bcd8739ae039(a, s, u) {
    var l = (0, $fClfl.options)[$2e41795d340153db$var$i];
    (0, $fClfl.options)[$2e41795d340153db$var$i] = !0, $2e41795d340153db$var$D = (0, $fClfl.options).__b, $2e41795d340153db$var$P = (0, $fClfl.options)[$2e41795d340153db$var$r], $2e41795d340153db$var$$ = (0, $fClfl.options).__r, $2e41795d340153db$var$U = (0, $fClfl.options).unmount;
    var f = (0, $fClfl.h)((0, $fClfl.Fragment), null);
    f[$2e41795d340153db$var$c] = [
        a
    ];
    try {
        var p = $2e41795d340153db$var$O(a, s || $2e41795d340153db$var$F, !1, void 0, f, !1, u);
        return $2e41795d340153db$var$W(p) ? p.join($2e41795d340153db$var$H) : p;
    } catch (e) {
        if (e.then) throw new Error('Use "renderToStringAsync" for suspenseful rendering.');
        throw e;
    } finally{
        (0, $fClfl.options)[$2e41795d340153db$var$o] && (0, $fClfl.options)[$2e41795d340153db$var$o](a, $2e41795d340153db$var$M), (0, $fClfl.options)[$2e41795d340153db$var$i] = l, $2e41795d340153db$var$M.length = 0;
    }
}
function $2e41795d340153db$var$I(e, t) {
    var n, r = e.type, o = !0;
    return e[$2e41795d340153db$var$a] ? (o = !1, (n = e[$2e41795d340153db$var$a]).state = n[$2e41795d340153db$var$u]) : n = new r(e.props, t), e[$2e41795d340153db$var$a] = n, n.__v = e, n.props = e.props, n.context = t, $2e41795d340153db$var$v(n), null == n.state && (n.state = $2e41795d340153db$var$F), null == n[$2e41795d340153db$var$u] && (n[$2e41795d340153db$var$u] = n.state), r.getDerivedStateFromProps ? n.state = $2e41795d340153db$var$z({}, n.state, r.getDerivedStateFromProps(n.props, n.state)) : o && n.componentWillMount ? (n.componentWillMount(), n.state = n[$2e41795d340153db$var$u] !== n.state ? n[$2e41795d340153db$var$u] : n.state) : !o && n.componentWillUpdate && n.componentWillUpdate(), $2e41795d340153db$var$$ && $2e41795d340153db$var$$(e), n.render(n.props, n.state, t);
}
function $2e41795d340153db$var$O(t, r, o, i, s, y, b) {
    if (null == t || !0 === t || !1 === t || t === $2e41795d340153db$var$H) return $2e41795d340153db$var$H;
    var x = typeof t === "undefined" ? "undefined" : (0, $5f0Cq._)(t);
    if ("object" != x) return "function" == x ? $2e41795d340153db$var$H : "string" == x ? $2e41795d340153db$var$g(t) : t + $2e41795d340153db$var$H;
    if ($2e41795d340153db$var$W(t)) {
        var k, C = $2e41795d340153db$var$H;
        s[$2e41795d340153db$var$c] = t;
        for(var S = t.length, L = 0; L < S; L++){
            var E = t[L];
            if (null != E && "boolean" != typeof E) {
                var j, T = $2e41795d340153db$var$O(E, r, o, i, s, y, b);
                "string" == typeof T ? C += T : (k || (k = new Array(S)), C && k.push(C), C = $2e41795d340153db$var$H, $2e41795d340153db$var$W(T) ? (j = k).push.apply(j, T) : k.push(T));
            }
        }
        return k ? (C && k.push(C), k) : C;
    }
    if (void 0 !== t.constructor) return $2e41795d340153db$var$H;
    t.__ = s, $2e41795d340153db$var$D && $2e41795d340153db$var$D(t);
    var Z = t.type, M = t.props;
    if ("function" == typeof Z) {
        var _$B, V, K, J = r;
        if (Z === (0, $fClfl.Fragment)) {
            if ("tpl" in M) {
                for(var Q = $2e41795d340153db$var$H, X = 0; X < M.tpl.length; X++)if (Q += M.tpl[X], M.exprs && X < M.exprs.length) {
                    var Y = M.exprs[X];
                    if (null == Y) continue;
                    "object" != (typeof Y === "undefined" ? "undefined" : (0, $5f0Cq._)(Y)) || void 0 !== Y.constructor && !$2e41795d340153db$var$W(Y) ? Q += Y : Q += $2e41795d340153db$var$O(Y, r, o, i, t, y, b);
                }
                return Q;
            }
            if ("UNSTABLE_comment" in M) return "\x3c!--" + $2e41795d340153db$var$g(M.UNSTABLE_comment) + "--\x3e";
            V = M.children;
        } else {
            if (null != (_$B = Z.contextType)) {
                var ee = r[_$B.__c];
                J = ee ? ee.props.value : _$B.__;
            }
            var te = Z.prototype && "function" == typeof Z.prototype.render;
            if (te) V = /**#__NOINLINE__**/ $2e41795d340153db$var$I(t, J), K = t[$2e41795d340153db$var$a];
            else {
                t[$2e41795d340153db$var$a] = K = /**#__NOINLINE__**/ $2e41795d340153db$var$A(t, J);
                for(var ne = 0; $2e41795d340153db$var$_(K) && ne++ < 25;){
                    $2e41795d340153db$var$m(K), $2e41795d340153db$var$$ && $2e41795d340153db$var$$(t);
                    try {
                        V = Z.call(K, M, J);
                    } catch (e) {
                        throw y && (t._suspended = !0), e;
                    }
                }
                $2e41795d340153db$var$v(K);
            }
            if (null != K.getChildContext && (r = $2e41795d340153db$var$z({}, r, K.getChildContext())), te && (0, $fClfl.options).errorBoundaries && (Z.getDerivedStateFromError || K.componentDidCatch)) {
                V = null != V && V.type === (0, $fClfl.Fragment) && null == V.key && null == V.props.tpl ? V.props.children : V;
                try {
                    return $2e41795d340153db$var$O(V, r, o, i, t, y, !1);
                } catch (e) {
                    return Z.getDerivedStateFromError && (K[$2e41795d340153db$var$u] = Z.getDerivedStateFromError(e)), K.componentDidCatch && K.componentDidCatch(e, $2e41795d340153db$var$F), $2e41795d340153db$var$_(K) ? (V = $2e41795d340153db$var$I(t, r), null != (K = t[$2e41795d340153db$var$a]).getChildContext && (r = $2e41795d340153db$var$z({}, r, K.getChildContext())), $2e41795d340153db$var$O(V = null != V && V.type === (0, $fClfl.Fragment) && null == V.key && null == V.props.tpl ? V.props.children : V, r, o, i, t, y, b)) : $2e41795d340153db$var$H;
                } finally{
                    $2e41795d340153db$var$P && $2e41795d340153db$var$P(t), $2e41795d340153db$var$U && $2e41795d340153db$var$U(t);
                }
            }
        }
        V = null != V && V.type === (0, $fClfl.Fragment) && null == V.key && null == V.props.tpl ? V.props.children : V;
        try {
            var re = $2e41795d340153db$var$O(V, r, o, i, t, y, b);
            return $2e41795d340153db$var$P && $2e41795d340153db$var$P(t), (0, $fClfl.options).unmount && (0, $fClfl.options).unmount(t), t._suspended ? "string" == typeof re ? $2e41795d340153db$var$N + re + $2e41795d340153db$var$q : $2e41795d340153db$var$W(re) ? (re.unshift($2e41795d340153db$var$N), re.push($2e41795d340153db$var$q), re) : re.then(function(e) {
                return $2e41795d340153db$var$N + e + $2e41795d340153db$var$q;
            }) : re;
        } catch (n) {
            if (!y && b && b.onError) {
                var oe = b.onError(n, t, function(e, t) {
                    return $2e41795d340153db$var$O(e, r, o, i, t, y, b);
                });
                if (void 0 !== oe) return oe;
                var ie = (0, $fClfl.options).__e;
                return ie && ie(n, t), $2e41795d340153db$var$H;
            }
            if (!y) throw n;
            if (!n || "function" != typeof n.then) throw n;
            return n.then(function e() {
                try {
                    var _$n = $2e41795d340153db$var$O(V, r, o, i, t, y, b);
                    return t._suspended ? $2e41795d340153db$var$N + _$n + $2e41795d340153db$var$q : _$n;
                } catch (t) {
                    if (!t || "function" != typeof t.then) throw t;
                    return t.then(e);
                }
            });
        }
    }
    var ae, ce = "<" + Z, se = $2e41795d340153db$var$H;
    for(var ue in M){
        var le = M[ue];
        if ("function" != typeof (le = $2e41795d340153db$var$G(le) ? le.value : le) || "class" === ue || "className" === ue) {
            switch(ue){
                case "children":
                    ae = le;
                    continue;
                case "key":
                case "ref":
                case "__self":
                case "__source":
                    continue;
                case "htmlFor":
                    if ("for" in M) continue;
                    ue = "for";
                    break;
                case "className":
                    if ("class" in M) continue;
                    ue = "class";
                    break;
                case "defaultChecked":
                    ue = "checked";
                    break;
                case "defaultSelected":
                    ue = "selected";
                    break;
                case "defaultValue":
                case "value":
                    switch(ue = "value", Z){
                        case "textarea":
                            ae = le;
                            continue;
                        case "select":
                            i = le;
                            continue;
                        case "option":
                            i != le || "selected" in M || (ce += " selected");
                    }
                    break;
                case "dangerouslySetInnerHTML":
                    se = le && le.__html;
                    continue;
                case "style":
                    "object" == (typeof le === "undefined" ? "undefined" : (0, $5f0Cq._)(le)) && (le = $2e41795d340153db$var$w(le));
                    break;
                case "acceptCharset":
                    ue = "accept-charset";
                    break;
                case "httpEquiv":
                    ue = "http-equiv";
                    break;
                default:
                    if ($2e41795d340153db$var$f.test(ue)) ue = ue.replace($2e41795d340153db$var$f, "$1:$2").toLowerCase();
                    else {
                        if ($2e41795d340153db$var$l.test(ue)) continue;
                        "-" !== ue[4] && !$2e41795d340153db$var$d.has(ue) || null == le ? o ? $2e41795d340153db$var$h.test(ue) && (ue = "panose1" === ue ? "panose-1" : ue.replace(/([A-Z])/g, "-$1").toLowerCase()) : $2e41795d340153db$var$p.test(ue) && (ue = ue.toLowerCase()) : le += $2e41795d340153db$var$H;
                    }
            }
            null != le && !1 !== le && (ce = !0 === le || le === $2e41795d340153db$var$H ? ce + " " + ue : ce + " " + ue + '="' + ("string" == typeof le ? $2e41795d340153db$var$g(le) : le + $2e41795d340153db$var$H) + '"');
        }
    }
    if ($2e41795d340153db$var$l.test(Z)) throw new Error(Z + " is not a valid HTML tag name in " + ce + ">");
    if (se || ("string" == typeof ae ? se = $2e41795d340153db$var$g(ae) : null != ae && !1 !== ae && !0 !== ae && (se = $2e41795d340153db$var$O(ae, r, "svg" === Z || "foreignObject" !== Z && o, i, t, y, b))), $2e41795d340153db$var$P && $2e41795d340153db$var$P(t), $2e41795d340153db$var$U && $2e41795d340153db$var$U(t), !se && $2e41795d340153db$var$R.has(Z)) return ce + "/>";
    var fe = "</" + Z + ">", pe = ce + ">";
    return $2e41795d340153db$var$W(se) ? [
        pe
    ].concat(se, [
        fe
    ]) : "string" != typeof se ? [
        pe,
        se,
        fe
    ] : pe + se + fe;
}
var $2e41795d340153db$var$R = new Set([
    "area",
    "base",
    "br",
    "col",
    "command",
    "embed",
    "hr",
    "img",
    "input",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]), $2e41795d340153db$export$b3890eb0ae9dca99 = $2e41795d340153db$export$2e2bcd8739ae039, $2e41795d340153db$export$eb3a06aef9e6ee51 = $2e41795d340153db$export$2e2bcd8739ae039;
function $2e41795d340153db$var$G(e) {
    return null !== e && "object" == (typeof e === "undefined" ? "undefined" : (0, $5f0Cq._)(e)) && "function" == typeof e.peek && "value" in e;
}


var $177758e3066bd18e$export$2e2bcd8739ae039 = {
    renderToString: (0, $2e41795d340153db$export$2e2bcd8739ae039),
    renderToStaticMarkup: (0, $2e41795d340153db$export$2e2bcd8739ae039)
};




var $6GCxi = parcelRequire("6GCxi");

var $ctBui = parcelRequire("ctBui");

var $fClfl = parcelRequire("fClfl");







var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $bb3c5ee00fb0b0cf$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $036d1b275291163e$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === 'category' && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get('alignWithLabel');
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === 'x1' || dims[idx] === 'y1';
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod',
        defaultBarGap: '10%'
    };
    return BaseBarSeriesModel;
}((0, $358fe4ff615f1b87$export$2e2bcd8739ae039));
(0, $358fe4ff615f1b87$export$2e2bcd8739ae039).registerClass($bb3c5ee00fb0b0cf$var$BaseBarSeriesModel);
var $bb3c5ee00fb0b0cf$export$2e2bcd8739ae039 = $bb3c5ee00fb0b0cf$var$BaseBarSeriesModel;





var $f0c4a3b81c90d66c$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $036d1b275291163e$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get('progressiveThreshold');
        var largeThreshold = this.get('largeThreshold');
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.bar';
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $ea311bef09818b2f$export$68acc510e46fef2)((0, $bb3c5ee00fb0b0cf$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: (0, $96bd979a273eb9e3$export$2e2bcd8739ae039).color.primary,
                borderWidth: 2
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $bb3c5ee00fb0b0cf$export$2e2bcd8739ae039));
var $f0c4a3b81c90d66c$export$2e2bcd8739ae039 = $f0c4a3b81c90d66c$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $14614c9de2883f03$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $14614c9de2883f03$var$SausagePath = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $14614c9de2883f03$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
var $14614c9de2883f03$export$2e2bcd8739ae039 = $14614c9de2883f03$var$SausagePath;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $e6c1c223c8672980$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $33d0653e48493c02$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $e6c1c223c8672980$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $e6c1c223c8672980$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $e6c1c223c8672980$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $e6c1c223c8672980$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $e6c1c223c8672980$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $e6c1c223c8672980$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $e6c1c223c8672980$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $e6c1c223c8672980$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $33d0653e48493c02$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $e6c1c223c8672980$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $99026af6cdabc3e1$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $99026af6cdabc3e1$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $e6c1c223c8672980$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $e6c1c223c8672980$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}




var $b74bcde642f5414b$var$mathMax = Math.max;
var $b74bcde642f5414b$var$mathMin = Math.min;
function $b74bcde642f5414b$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $73241c96b18662c0$export$8567506e6336616)(coord, 'cartesian2d')) {
        var baseAxis = coord.getBaseAxis();
        // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== 'category' || !baseAxis.onBand) {
            var expandWidth = data.getLayout('bandWidth');
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $b74bcde642f5414b$var$BarView = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $055606553475f5d6$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $b74bcde642f5414b$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        var coordSysClipArea = $b74bcde642f5414b$var$getClipArea(coord, data);
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $b74bcde642f5414b$var$getLayout[coord.type](data, dataIndex);
            if (!bgLayout) return null;
            var bgEl = $b74bcde642f5414b$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            else bgEl.setShape('cornerRadius', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $b74bcde642f5414b$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (!layout) return;
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$b74bcde642f5414b$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $b74bcde642f5414b$var$clip[coord.type](coordSysClipArea, layout);
            var el = $b74bcde642f5414b$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $b74bcde642f5414b$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $b74bcde642f5414b$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $821b3c1b9ddcee3a$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $b74bcde642f5414b$var$getLayout[coord.type](data, newIndex, itemModel);
            if (!layout) return;
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    else bgEl.setShape('cornerRadius', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $b74bcde642f5414b$var$getLayout[coord.type](data, newIndex);
                var shape = $b74bcde642f5414b$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $821b3c1b9ddcee3a$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$b74bcde642f5414b$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $b74bcde642f5414b$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            var roundCapChanged = el && (el.type === 'sector' && roundCap || el.type === 'sausage' && !roundCap);
            if (roundCapChanged) {
                // roundCap changed, there is no way to use animation from a `sector` to a `sausage` shape,
                // so remove the old one and create a new shape
                el && (0, $821b3c1b9ddcee3a$export$6d0fd725cb4aee8a)(el, seriesModel, oldIndex);
                el = null;
            }
            if (!el) el = $b74bcde642f5414b$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, true, roundCap);
            else (0, $821b3c1b9ddcee3a$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $a4fed78c55651c93$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $b74bcde642f5414b$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $b74bcde642f5414b$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $821b3c1b9ddcee3a$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $821b3c1b9ddcee3a$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $2b89655bc310a947$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $b74bcde642f5414b$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $b74bcde642f5414b$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) && (0, $4be68cb18e195d91$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function orderMapping_1(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $99026af6cdabc3e1$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $821b3c1b9ddcee3a$export$6d0fd725cb4aee8a)(el, model, (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = 'bar';
    return BarView;
}((0, $01349fdbc71d745c$export$2e2bcd8739ae039));
var $b74bcde642f5414b$var$clip = {
    cartesian2d: function cartesian2d(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $b74bcde642f5414b$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $b74bcde642f5414b$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $b74bcde642f5414b$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $b74bcde642f5414b$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function polar(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $b74bcde642f5414b$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $b74bcde642f5414b$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $b74bcde642f5414b$var$elementCreator = {
    cartesian2d: function cartesian2d(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $aed3569651b5e3fa$export$2e2bcd8739ae039)({
            shape: (0, $99026af6cdabc3e1$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function polar(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $14614c9de2883f03$export$2e2bcd8739ae039) : (0, $d5aef629841de604$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $b74bcde642f5414b$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $e6c1c223c8672980$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $14614c9de2883f03$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $821b3c1b9ddcee3a$export$c8dce3c08436e91e) : (0, $821b3c1b9ddcee3a$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $b74bcde642f5414b$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $b74bcde642f5414b$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $821b3c1b9ddcee3a$export$c8dce3c08436e91e) : (0, $821b3c1b9ddcee3a$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $821b3c1b9ddcee3a$export$c8dce3c08436e91e) : (0, $821b3c1b9ddcee3a$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $b74bcde642f5414b$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $b74bcde642f5414b$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $b74bcde642f5414b$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $b74bcde642f5414b$var$isValidLayout = {
    cartesian2d: function cartesian2d(layout) {
        return !$b74bcde642f5414b$var$checkPropertiesNotValid(layout, $b74bcde642f5414b$var$rectPropties);
    },
    polar: function polar(layout) {
        return !$b74bcde642f5414b$var$checkPropertiesNotValid(layout, $b74bcde642f5414b$var$polarPropties);
    }
};
var $b74bcde642f5414b$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function cartesian2d(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        if (!layout) return null;
        var fixedLineWidth = itemModel ? $b74bcde642f5414b$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function polar(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $b74bcde642f5414b$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $b74bcde642f5414b$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $b74bcde642f5414b$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) {
        var borderRadius = itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0;
        el.setShape('r', borderRadius);
    } else if (!seriesModel.get('roundCap')) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $83680e9b0c30b43d$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), sectorShape, true);
        (0, $99026af6cdabc3e1$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
    var labelStatesModels = (0, $a4fed78c55651c93$export$9739a32674be5893)(itemModel);
    (0, $a4fed78c55651c93$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $1202a9442ec6b59f$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $e6c1c223c8672980$export$672ce504c0db395a)(el, position === 'outside' ? labelPositionOutside : position, $b74bcde642f5414b$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $a4fed78c55651c93$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $1202a9442ec6b59f$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $ea1f7a1fbd33fd2d$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    (0, $ea1f7a1fbd33fd2d$export$48b68047d330bbc9)(el, itemModel);
    if ($b74bcde642f5414b$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $99026af6cdabc3e1$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
}
// In case width or height are too small.
function $b74bcde642f5414b$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $b74bcde642f5414b$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $b74bcde642f5414b$var$LargePath = /** @class */ function(_super) {
    (0, $3785de68a34a44e8$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $b74bcde642f5414b$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $d730b349402dd5f7$export$2e2bcd8739ae039));
function $b74bcde642f5414b$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('size');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var bgPoints = data.getLayout('largeBackgroundPoints');
    if (bgPoints) {
        var bgEl = new $b74bcde642f5414b$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $b74bcde642f5414b$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: !!incremental,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual('style'));
    // Stroke is rendered first to avoid overlapping with fill
    el.style.stroke = null;
    // Enable tooltip and user mouse/touch event handlers.
    (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $b74bcde642f5414b$var$largePathUpdateDataIndex);
        el.on('mousemove', $b74bcde642f5414b$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $b74bcde642f5414b$var$largePathUpdateDataIndex = (0, $b4484a22f72674c6$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $b74bcde642f5414b$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $f10cebeaa5f49a40$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $b74bcde642f5414b$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $b74bcde642f5414b$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $73241c96b18662c0$export$8567506e6336616)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $b74bcde642f5414b$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $d5aef629841de604$export$2e2bcd8739ae039) : (0, $aed3569651b5e3fa$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $b74bcde642f5414b$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $b74bcde642f5414b$export$2e2bcd8739ae039 = $b74bcde642f5414b$var$BarView;


function $dd49814ccb0a42e1$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $b74bcde642f5414b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f0c4a3b81c90d66c$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $99026af6cdabc3e1$export$c3095a23b368d1f2((0, $bbd57e4b726e3f06$export$b3219800bda33a1f), 'bar'));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $bbd57e4b726e3f06$export$16e8685758531cb6)('bar'));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $cf2266f4fb2a2e00$export$2e2bcd8739ae039)('bar'));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}




var $33a5652a9cc9c0d3$var$_a;
(0, $80c287a85adc0f08$export$1f96ae73734a86cc)((0, $dd49814ccb0a42e1$export$4b3e715f166fdd78));
var $33a5652a9cc9c0d3$export$66307e3e8fac7e52 = /*#__PURE__*/ function(ECOptionElement) {
    "use strict";
    (0, $h6w6E._)(ECBarChart, ECOptionElement);
    function ECBarChart() {
        (0, $7lhcp._)(this, ECBarChart);
        return (0, $07dqX._)(this, ECBarChart, arguments);
    }
    return ECBarChart;
}((0, $6f6095288b1fca4a$export$37de6f71bb86a769));
($33a5652a9cc9c0d3$var$_a = globalThis.customElements) === null || $33a5652a9cc9c0d3$var$_a === void 0 || $33a5652a9cc9c0d3$var$_a.define('ec-bar-chart', $33a5652a9cc9c0d3$export$66307e3e8fac7e52);



var $fClfl = parcelRequire("fClfl");
Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [
        Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
Prism.languages.js = Prism.languages.javascript;


(function(Prism1) {
    var javascript = Prism1.util.clone(Prism1.languages.javascript);
    var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
    var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
    var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    /**
	 * @param {string} source
	 * @param {string} [flags]
	 */ function re(source, flags) {
        source = source.replace(/<S>/g, function() {
            return space;
        }).replace(/<BRACES>/g, function() {
            return braces;
        }).replace(/<SPREAD>/g, function() {
            return spread;
        });
        return RegExp(source, flags);
    }
    spread = re(spread).source;
    Prism1.languages.jsx = Prism1.languages.extend('markup', javascript);
    Prism1.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
    Prism1.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
    Prism1.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
    Prism1.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
    Prism1.languages.jsx.tag.inside['comment'] = javascript['comment'];
    Prism1.languages.insertBefore('inside', 'attr-name', {
        'spread': {
            pattern: re(/<SPREAD>/.source),
            inside: Prism1.languages.jsx
        }
    }, Prism1.languages.jsx.tag);
    Prism1.languages.insertBefore('inside', 'special-attr', {
        'script': {
            // Allow for two levels of nesting
            pattern: re(/=<BRACES>/.source),
            alias: 'language-javascript',
            inside: {
                'script-punctuation': {
                    pattern: /^=(?=\{)/,
                    alias: 'punctuation'
                },
                rest: Prism1.languages.jsx
            }
        }
    }, Prism1.languages.jsx.tag);
    // The following will handle plain text inside tags
    var stringifyToken = function stringifyToken1(token) {
        if (!token) return '';
        if (typeof token === 'string') return token;
        if (typeof token.content === 'string') return token.content;
        return token.content.map(stringifyToken).join('');
    };
    var walkTokens = function walkTokens1(tokens) {
        var openedTags = [];
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            var notTagNorBrace = false;
            if (typeof token !== 'string') {
                if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                    // We found a tag, now find its kind
                    if (token.content[0].content[0].content === '</') // Closing tag
                    {
                        if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                        openedTags.pop();
                    } else {
                        if (token.content[token.content.length - 1].content === '/>') ;
                        else // Opening tag
                        openedTags.push({
                            tagName: stringifyToken(token.content[0].content[1]),
                            openedBraces: 0
                        });
                    }
                } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces++;
                else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces--;
                else notTagNorBrace = true;
            }
            if (notTagNorBrace || typeof token === 'string') {
                if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                    // Here we are inside a tag, and not inside a JSX context.
                    // That's plain text: drop any tokens matched.
                    var plainText = stringifyToken(token);
                    // And merge text with adjacent text
                    if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                        plainText += stringifyToken(tokens[i + 1]);
                        tokens.splice(i + 1, 1);
                    }
                    if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                        plainText = stringifyToken(tokens[i - 1]) + plainText;
                        tokens.splice(i - 1, 1);
                        i--;
                    }
                    tokens[i] = new Prism1.Token('plain-text', plainText, null, plainText);
                }
            }
            if (token.content && typeof token.content !== 'string') walkTokens(token.content);
        }
    };
    Prism1.hooks.add('after-tokenize', function(env) {
        if (env.language !== 'jsx' && env.language !== 'tsx') return;
        walkTokens(env.tokens);
    });
})(Prism);


(function(Prism1) {
    Prism1.languages.typescript = Prism1.languages.extend('javascript', {
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    });
    // The keywords TypeScript adds to JavaScript
    Prism1.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.typescript['parameter'];
    delete Prism1.languages.typescript['literal-property'];
    // a version of typescript specifically for highlighting types
    var typeInside = Prism1.languages.extend('typescript', {});
    delete typeInside['class-name'];
    Prism1.languages.typescript['class-name'].inside = typeInside;
    Prism1.languages.insertBefore('typescript', 'function', {
        'decorator': {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                'at': {
                    pattern: /^@/,
                    alias: 'operator'
                },
                'function': /^[\s\S]+/
            }
        },
        'generic-function': {
            // e.g. foo<T extends "bar" | "baz">( ...
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    alias: 'class-name',
                    inside: typeInside
                }
            }
        }
    });
    Prism1.languages.ts = Prism1.languages.typescript;
})(Prism);


(function(Prism1) {
    var typescript = Prism1.util.clone(Prism1.languages.typescript);
    Prism1.languages.tsx = Prism1.languages.extend('jsx', typescript);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.tsx['parameter'];
    delete Prism1.languages.tsx['literal-property'];
    // This will prevent collisions between TSX tags and TS generic types.
    // Idea by https://github.com/karlhorky
    // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
    var tag = Prism1.languages.tsx.tag;
    tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
    tag.lookbehind = true;
})(Prism);



var $cc348b2c5175bcb1$export$c489dd2bd24850e4 = function(param) {
    var title = param.title, children = param.children;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h2", {
                className: "mt-3",
                children: title
            }),
            children,
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.CodeBlock), {
                language: "tsx",
                children: children
            })
        ]
    });
};


var $2e53d2ece788bedf$export$200ed0c9cbeb911a = undefined;
function $2e53d2ece788bedf$var$_createMdxContent(props) {
    var _components = (0, $6GCxi._)({
        a: "a",
        h1: "h1",
        p: "p"
    }, props.components);
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)(_components.h1, {
                children: "Charts in Markdown"
            }),
            "\n",
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)(_components.p, {
                children: [
                    "This example is based on ",
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)(_components.a, {
                        href: "https://github.com/idea2app/ECharts-JSX",
                        children: "ECharts-JSX"
                    }),
                    " & ",
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)(_components.a, {
                        href: "https://github.com/EasyWebApp/Parcel-transformer-MDX",
                        children: "Parcel-transformer-MDX"
                    }),
                    "."
                ]
            }),
            "\n",
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $cc348b2c5175bcb1$export$c489dd2bd24850e4), {
                title: "ECharts example",
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-svg-renderer", {
                    style: {
                        height: '80vh'
                    },
                    onClick: console.log,
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-title", {
                            text: "ECharts example"
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-legend", {
                            data: [
                                'sales'
                            ]
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-tooltip", {}),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-x-axis", {
                            data: [
                                'Shirts',
                                'Cardigans',
                                'Chiffons',
                                'Pants',
                                'Heels',
                                'Socks'
                            ]
                        }),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-y-axis", {}),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("ec-bar-chart", {
                            name: "sales",
                            data: [
                                5,
                                20,
                                36,
                                10,
                                10,
                                20
                            ],
                            onClick: console.log
                        })
                    ]
                })
            })
        ]
    });
}
function $2e53d2ece788bedf$export$2e2bcd8739ae039() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _ref = props.components || {}, MDXLayout = _ref.wrapper;
    return MDXLayout ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)(MDXLayout, (0, $ctBui._)((0, $6GCxi._)({}, props), {
        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)($2e53d2ece788bedf$var$_createMdxContent, (0, $6GCxi._)({}, props))
    })) : $2e53d2ece788bedf$var$_createMdxContent(props);
}


var $4a04735604ab79b0$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4a04735604ab79b0$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4a04735604ab79b0$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4a04735604ab79b0$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4a04735604ab79b0$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4a04735604ab79b0$export$bbfbacd372342508 = function() {
    var _ReportTemplatePage_previewHTML_accessor_storage, _ReportTemplatePage_editing_accessor_storage, _ReportTemplatePage_editingHTML_accessor_storage;
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _previewHTML_decorators;
    var _previewHTML_initializers = [];
    var _previewHTML_extraInitializers = [];
    var _editing_decorators;
    var _editing_initializers = [];
    var _editing_extraInitializers = [];
    var _editingHTML_decorators;
    var _editingHTML_initializers = [];
    var _editingHTML_extraInitializers = [];
    var ReportTemplatePage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "previewBox", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: /*#__PURE__*/ (0, $fClfl.createRef)()
            });
            _ReportTemplatePage_previewHTML_accessor_storage.set(_this, $4a04735604ab79b0$var$__runInitializers(_this, _previewHTML_initializers, ''));
            _ReportTemplatePage_editing_accessor_storage.set(_this, ($4a04735604ab79b0$var$__runInitializers(_this, _previewHTML_extraInitializers), $4a04735604ab79b0$var$__runInitializers(_this, _editing_initializers, false)));
            _ReportTemplatePage_editingHTML_accessor_storage.set(_this, ($4a04735604ab79b0$var$__runInitializers(_this, _editing_extraInitializers), $4a04735604ab79b0$var$__runInitializers(_this, _editingHTML_initializers, '')));
            $4a04735604ab79b0$var$__runInitializers(_this, _editingHTML_extraInitializers);
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "previewHTML",
                get: function get() {
                    return $4a04735604ab79b0$var$__classPrivateFieldGet(this, _ReportTemplatePage_previewHTML_accessor_storage, "f");
                },
                set: function set(value) {
                    $4a04735604ab79b0$var$__classPrivateFieldSet(this, _ReportTemplatePage_previewHTML_accessor_storage, value, "f");
                }
            },
            {
                key: "editing",
                get: function get() {
                    return $4a04735604ab79b0$var$__classPrivateFieldGet(this, _ReportTemplatePage_editing_accessor_storage, "f");
                },
                set: function set(value) {
                    $4a04735604ab79b0$var$__classPrivateFieldSet(this, _ReportTemplatePage_editing_accessor_storage, value, "f");
                }
            },
            {
                key: "editingHTML",
                get: function get() {
                    return $4a04735604ab79b0$var$__classPrivateFieldGet(this, _ReportTemplatePage_editingHTML_accessor_storage, "f");
                },
                set: function set(value) {
                    $4a04735604ab79b0$var$__classPrivateFieldSet(this, _ReportTemplatePage_editingHTML_accessor_storage, value, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _a;
                    this.previewHTML = ((_a = this.previewBox.current) === null || _a === void 0 ? void 0 : _a.innerHTML) || (0, $2e41795d340153db$export$2e2bcd8739ae039)((0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $2e53d2ece788bedf$export$2e2bcd8739ae039), {}));
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    var _this1 = this, previewHTML = _this1.previewHTML, editing = _this1.editing, editingHTML = _this1.editingHTML;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                        className: "p-3 d-flex flex-column gap-3",
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("header", {
                                className: "d-flex align-items-center justify-content-end gap-2",
                                children: [
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('preview'),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aec14c1b82632aca$export$2e2bcd8739ae039).Check, {
                                        type: "switch",
                                        onClick: function() {
                                            return _this.editing = !_this.editing;
                                        }
                                    }),
                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('edit')
                                ]
                            }),
                            editing ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $09063b8df282f9e7$exports.Editor), {
                                defaultValue: editingHTML || previewHTML,
                                onChange: function(value) {
                                    return _this.editingHTML = value;
                                }
                            }) : editingHTML ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)("article", {
                                dangerouslySetInnerHTML: {
                                    __html: editingHTML
                                }
                            }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)("article", {
                                ref: this.previewBox,
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $2e53d2ece788bedf$export$2e2bcd8739ae039), {})
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _ReportTemplatePage_previewHTML_accessor_storage = new WeakMap();
    _ReportTemplatePage_editing_accessor_storage = new WeakMap();
    _ReportTemplatePage_editingHTML_accessor_storage = new WeakMap();
    $4a04735604ab79b0$var$__setFunctionName(_classThis, "ReportTemplatePage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _previewHTML_decorators = [
            (0, $arNK5.observable)
        ];
        _editing_decorators = [
            (0, $arNK5.observable)
        ];
        _editingHTML_decorators = [
            (0, $arNK5.observable)
        ];
        $4a04735604ab79b0$var$__esDecorate(_classThis, null, _previewHTML_decorators, {
            kind: "accessor",
            name: "previewHTML",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "previewHTML" in obj;
                },
                get: function(obj) {
                    return obj.previewHTML;
                },
                set: function(obj, value) {
                    obj.previewHTML = value;
                }
            },
            metadata: _metadata
        }, _previewHTML_initializers, _previewHTML_extraInitializers);
        $4a04735604ab79b0$var$__esDecorate(_classThis, null, _editing_decorators, {
            kind: "accessor",
            name: "editing",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "editing" in obj;
                },
                get: function(obj) {
                    return obj.editing;
                },
                set: function(obj, value) {
                    obj.editing = value;
                }
            },
            metadata: _metadata
        }, _editing_initializers, _editing_extraInitializers);
        $4a04735604ab79b0$var$__esDecorate(_classThis, null, _editingHTML_decorators, {
            kind: "accessor",
            name: "editingHTML",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "editingHTML" in obj;
                },
                get: function(obj) {
                    return obj.editingHTML;
                },
                set: function(obj, value) {
                    obj.editingHTML = value;
                }
            },
            metadata: _metadata
        }, _editingHTML_initializers, _editingHTML_extraInitializers);
        $4a04735604ab79b0$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ReportTemplatePage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $4a04735604ab79b0$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ReportTemplatePage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $33c723550218b8c0$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $33c723550218b8c0$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $33c723550218b8c0$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $33c723550218b8c0$var$reportTemplates = [
    {
        id: 'weekly',
        nameKey: 'weekly_report_template',
        charCount: 5232,
        relatedData: 10,
        descriptionKey: 'weekly_report_description'
    },
    {
        id: 'monthly',
        nameKey: 'monthly_report_template',
        charCount: 5232,
        relatedData: 10,
        descriptionKey: 'monthly_report_description'
    },
    {
        id: 'quarterly',
        nameKey: 'quarterly_report_template',
        charCount: 5232,
        relatedData: 10,
        descriptionKey: 'quarterly_report_description'
    }
];
var $33c723550218b8c0$export$694549d81a2df1da = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var ReportTemplateListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            Object.defineProperty(_this, "renderTemplateCard", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: function(param) {
                    var id = param.id, nameKey = param.nameKey, charCount = param.charCount, relatedData = param.relatedData, descriptionKey = param.descriptionKey;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        className: "d-flex",
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                            className: "flex-fill shadow-sm",
                            body: true,
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                className: "text-decoration-none d-flex align-items-start gap-3",
                                href: "#/report/template/".concat(id),
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "rounded bg-light p-3 d-flex align-items-center justify-content-center",
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "folder",
                                            className: "text-primary"
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                        className: "flex-fill",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                                                className: "mb-2",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)(nameKey)
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("small", {
                                                className: "text-muted d-block mb-2",
                                                children: [
                                                    charCount,
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('chars_unit'),
                                                    " \u00B7 +",
                                                    relatedData,
                                                    (0, $50993b47476de2e7$export$625550452a3fa3ec)('related_data_unit')
                                                ]
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                                className: "mb-0 text-secondary small",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)(descriptionKey)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }, id);
                }
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $eb8ef8f36513dc70$export$2e2bcd8739ae039), {
                        className: "py-4",
                        fluid: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h4", {
                                className: "mb-4",
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('report_template_library')
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                                className: "g-3",
                                children: $33c723550218b8c0$var$reportTemplates.map(this.renderTemplateCard)
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $33c723550218b8c0$var$__setFunctionName(_classThis, "ReportTemplateListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $33c723550218b8c0$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ReportTemplateListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $33c723550218b8c0$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ReportTemplateListPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");


var $8853b7ad0221f4e7$export$5ea1c82e6a904aa9 = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(RuleModel, TableModel);
    function RuleModel(ruleType) {
        (0, $7lhcp._)(this, RuleModel);
        var _this;
        _this = (0, $07dqX._)(this, RuleModel);
        Object.defineProperty(_this, "ruleType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ruleType
        });
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        _this.baseURI = "/rule/".concat(ruleType);
        return _this;
    }
    return RuleModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $8853b7ad0221f4e7$export$8882a730f538b0ad = new $8853b7ad0221f4e7$export$5ea1c82e6a904aa9('sensitive');
var $8853b7ad0221f4e7$export$afceb7ef6198e7 = new $8853b7ad0221f4e7$export$5ea1c82e6a904aa9('responsible');



var $43584f1a911dceb7$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $43584f1a911dceb7$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $43584f1a911dceb7$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $43584f1a911dceb7$var$RuleTypeLabels = {
    work_order_chain: 'work_order_chain',
    keyword_semantic: 'keyword_semantic'
};
var $43584f1a911dceb7$var$WarningLevelColors = {
    1: 'warning',
    2: 'warning',
    3: 'danger'
};
var $43584f1a911dceb7$var$WarningLevelLabels = {
    1: 'level_1_warning',
    2: 'level_2_warning',
    3: 'level_3_warning'
};
var $43584f1a911dceb7$export$768e5f1aa8c321e9 = function() {
    var _classDecorators = [
        (0, $397c81af6d5568dc$export$369b6b2b30582e8e),
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _get_sensitiveFilterFields_decorators;
    var _get_responsibleFilterFields_decorators;
    var _get_sensitiveColumns_decorators;
    var _get_responsibleColumns_decorators;
    var RuleListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            $43584f1a911dceb7$var$__runInitializers(_this, _instanceExtraInitializers);
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "isSensitive",
                get: function get() {
                    return this.props.match.params.type === 'sensitive';
                }
            },
            {
                key: "pageTitle",
                get: function get() {
                    return this.isSensitive ? (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_rule_list') : (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_rule_list');
                }
            },
            {
                key: "pageIcon",
                get: function get() {
                    return this.isSensitive ? 'shield-exclamation' : 'shield-check';
                }
            },
            {
                key: "sensitiveFilterFields",
                get: function get() {
                    return [
                        {
                            key: 'keywords',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('search')
                        },
                        {
                            key: 'vocabularyName',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('vocabulary_name')
                        },
                        {
                            key: 'ruleType',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rule_type'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'work_order_chain',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_chain')
                                },
                                {
                                    value: 'keyword_semantic',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('keyword_semantic')
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "responsibleFilterFields",
                get: function get() {
                    return [
                        {
                            key: 'keywords',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('search')
                        },
                        {
                            key: 'ruleName',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rule_name')
                        },
                        {
                            key: 'ruleDescription',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rule_description')
                        }
                    ];
                }
            },
            {
                key: "sensitiveColumns",
                get: function get() {
                    return [
                        {
                            key: 'vocabularyName',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('vocabulary_name')
                        },
                        {
                            key: 'vocabularyDescription',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('vocabulary_description')
                        },
                        {
                            key: 'ruleType',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rule_type'),
                            renderBody: function(param) {
                                var ruleType = param.ruleType;
                                return (0, $50993b47476de2e7$export$625550452a3fa3ec)($43584f1a911dceb7$var$RuleTypeLabels[ruleType]);
                            }
                        },
                        {
                            key: 'warningLevel',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('warning_level'),
                            renderBody: function(param) {
                                var warningLevel = param.warningLevel;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: $43584f1a911dceb7$var$WarningLevelColors[warningLevel],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)($43584f1a911dceb7$var$WarningLevelLabels[warningLevel])
                                });
                            }
                        },
                        {
                            key: 'triggeredWorkOrderCount',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('triggered_work_order_count'),
                            renderBody: function(param) {
                                var triggeredWorkOrderCount = param.triggeredWorkOrderCount;
                                return triggeredWorkOrderCount || 0;
                            }
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('operation'),
                            renderBody: function() {
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex gap-2 justify-content-center",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            size: "sm",
                                            className: "p-0",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "pencil"
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            size: "sm",
                                            className: "p-0 text-danger",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "trash"
                                            })
                                        })
                                    ]
                                });
                            }
                        }
                    ];
                }
            },
            {
                key: "responsibleColumns",
                get: function get() {
                    return [
                        {
                            key: 'ruleName',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rule_name')
                        },
                        {
                            key: 'ruleDescription',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('rule_description')
                        },
                        {
                            key: 'associatedDocuments',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('associated_documents'),
                            renderBody: function(param) {
                                var associatedDocuments = param.associatedDocuments;
                                return (associatedDocuments === null || associatedDocuments === void 0 ? void 0 : associatedDocuments.map(function(param) {
                                    var fileName = param.fileName;
                                    return fileName;
                                }).join("\u3001")) || '-';
                            }
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('operation'),
                            renderBody: function() {
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex gap-2 justify-content-center",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            size: "sm",
                                            className: "p-0",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "pencil"
                                            })
                                        }),
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                            variant: "link",
                                            size: "sm",
                                            className: "p-0 text-danger",
                                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                                name: "trash"
                                            })
                                        })
                                    ]
                                });
                            }
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "m-3",
                        body: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                className: "mb-3 d-flex justify-content-between align-items-center",
                                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h4", {
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: this.pageIcon,
                                            className: "me-2"
                                        }),
                                        this.pageTitle
                                    ]
                                })
                            }),
                            this.isSensitive ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                filterFields: this.sensitiveFilterFields,
                                columns: this.sensitiveColumns,
                                store: (0, $8853b7ad0221f4e7$export$8882a730f538b0ad),
                                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                striped: true,
                                hover: true,
                                editable: true,
                                deletable: true
                            }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                filterFields: this.responsibleFilterFields,
                                columns: this.responsibleColumns,
                                store: (0, $8853b7ad0221f4e7$export$afceb7ef6198e7),
                                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                striped: true,
                                hover: true,
                                editable: true,
                                deletable: true
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $43584f1a911dceb7$var$__setFunctionName(_classThis, "RuleListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_sensitiveFilterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_responsibleFilterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_sensitiveColumns_decorators = [
            (0, $arNK5.computed)
        ];
        _get_responsibleColumns_decorators = [
            (0, $arNK5.computed)
        ];
        $43584f1a911dceb7$var$__esDecorate(_classThis, null, _get_sensitiveFilterFields_decorators, {
            kind: "getter",
            name: "sensitiveFilterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "sensitiveFilterFields" in obj;
                },
                get: function(obj) {
                    return obj.sensitiveFilterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $43584f1a911dceb7$var$__esDecorate(_classThis, null, _get_responsibleFilterFields_decorators, {
            kind: "getter",
            name: "responsibleFilterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "responsibleFilterFields" in obj;
                },
                get: function(obj) {
                    return obj.responsibleFilterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $43584f1a911dceb7$var$__esDecorate(_classThis, null, _get_sensitiveColumns_decorators, {
            kind: "getter",
            name: "sensitiveColumns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "sensitiveColumns" in obj;
                },
                get: function(obj) {
                    return obj.sensitiveColumns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $43584f1a911dceb7$var$__esDecorate(_classThis, null, _get_responsibleColumns_decorators, {
            kind: "getter",
            name: "responsibleColumns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "responsibleColumns" in obj;
                },
                get: function(obj) {
                    return obj.responsibleColumns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $43584f1a911dceb7$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        RuleListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $43584f1a911dceb7$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return RuleListPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");


var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");


var $fClfl = parcelRequire("fClfl");


var $1ee5c72f491c8f35$export$fca56b23a8961557 = function() {
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                className: "mb-3",
                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('problem_extraction_info')
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-3",
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('problem_category'),
                            "\uFF1A",
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_order')
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('warning_level'),
                            "\uFF1A",
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                className: "text-danger fw-bold",
                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('red_warning')
                            })
                        ]
                    })
                ]
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-4",
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 6,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('trigger_keywords'),
                            "\uFF1A",
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('complaint')
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 6,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('trigger_count'),
                            "\uFF1A12\u6B21"
                        ]
                    })
                ]
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-4",
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 6,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('trigger_keywords'),
                            "\uFF1A",
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('poor_attitude')
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 6,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('trigger_count'),
                            "\uFF1A3\u6B21"
                        ]
                    })
                ]
            })
        ]
    });
};



var $fClfl = parcelRequire("fClfl");


var $b32fd42aa4b20233$export$d1b165477a834d0f = function(param) {
    var orderNumber = param.orderNumber, category = param.category, department = param.department, acceptanceTime = param.acceptanceTime, uploadTime = param.uploadTime, processingStatus = param.processingStatus, acceptanceContent = param.acceptanceContent;
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fClfl.Fragment), {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h5", {
                className: "mb-3",
                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('work_order_original_info')
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-3",
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_number'),
                            "\uFF1A",
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                className: "text-primary fw-bold",
                                children: orderNumber
                            })
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('category'),
                            "\uFF1A",
                            (category === null || category === void 0 ? void 0 : category.level1Category) || '-'
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('unit_name'),
                            "\uFF1A",
                            department
                        ]
                    })
                ]
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-3",
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('primary_category'),
                            "\uFF1A\u975E\u7535\u529B\u6545\u969C"
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('secondary_category'),
                            "\uFF1A\u7B2C\u4E09\u65B9\u539F\u56E0"
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('tertiary_category'),
                            "\uFF1A\u975E\u76F4\u4F9B\u6237"
                        ]
                    })
                ]
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-3",
                children: [
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_completion_time'),
                            "\uFF1A",
                            acceptanceTime ? new Date(acceptanceTime).toLocaleString() : '-'
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('return_timestamp'),
                            "\uFF1A",
                            uploadTime ? new Date(uploadTime).toLocaleString() : '-'
                        ]
                    }),
                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                        md: 4,
                        children: [
                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('processing_result'),
                            "\uFF1A\u5904\u7406\u5B8C\u6BD5"
                        ]
                    })
                ]
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-4",
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                    children: [
                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('processing_situation'),
                        "\uFF1A",
                        processingStatus
                    ]
                })
            }),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $fc12ef00830c07c6$export$2e2bcd8739ae039), {
                className: "mb-4",
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $27ad5a1fd7e6d114$export$2e2bcd8739ae039), {
                    children: [
                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('acceptance_content'),
                        "\uFF1A",
                        acceptanceContent
                    ]
                })
            })
        ]
    });
};



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");


var $dee6d3a99caede11$export$de9e8b1e104280ea = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(SupervisionOrderModel, TableModel);
    function SupervisionOrderModel() {
        (0, $7lhcp._)(this, SupervisionOrderModel);
        var _this;
        _this = (0, $07dqX._)(this, SupervisionOrderModel, arguments);
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'work-order/pending-supervision'
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        return _this;
    }
    return SupervisionOrderModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $dee6d3a99caede11$export$2e2bcd8739ae039 = new $dee6d3a99caede11$export$de9e8b1e104280ea();




var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $h6w6E = parcelRequire("h6w6E");


var $281cc8452bd676be$export$9dac8013c943120d = /*#__PURE__*/ function(TableModel) {
    "use strict";
    (0, $h6w6E._)(WorkOrderModel, TableModel);
    function WorkOrderModel() {
        (0, $7lhcp._)(this, WorkOrderModel);
        var _this;
        _this = (0, $07dqX._)(this, WorkOrderModel, arguments);
        Object.defineProperty(_this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'work-order'
        });
        Object.defineProperty(_this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).client
        });
        return _this;
    }
    return WorkOrderModel;
}((0, $8cc1d201d3325d46$export$ebde44b8e65d8876));
var $281cc8452bd676be$export$2e2bcd8739ae039 = new $281cc8452bd676be$export$9dac8013c943120d();


var $ad589216e8fd70ae$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ad589216e8fd70ae$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ad589216e8fd70ae$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ad589216e8fd70ae$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ad589216e8fd70ae$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ad589216e8fd70ae$var$OrderTypeLabels = {
    normal: 'normal_order',
    duplicate: 'duplicate_order',
    sensitive: 'sensitive_order',
    responsible: 'responsible_order'
};
var $ad589216e8fd70ae$var$OrderTypeColors = {
    normal: 'success',
    duplicate: 'warning',
    sensitive: 'danger',
    responsible: 'info'
};
var $ad589216e8fd70ae$export$e771cce59804b124 = function() {
    var _SupervisionOrderListPage_selectedWorkOrder_accessor_storage, _SupervisionOrderListPage_activeTab_accessor_storage;
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _selectedWorkOrder_decorators;
    var _selectedWorkOrder_initializers = [];
    var _selectedWorkOrder_extraInitializers = [];
    var _activeTab_decorators;
    var _activeTab_initializers = [];
    var _activeTab_extraInitializers = [];
    var SupervisionOrderListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            _SupervisionOrderListPage_selectedWorkOrder_accessor_storage.set(_this, $ad589216e8fd70ae$var$__runInitializers(_this, _selectedWorkOrder_initializers, void 0));
            _SupervisionOrderListPage_activeTab_accessor_storage.set(_this, ($ad589216e8fd70ae$var$__runInitializers(_this, _selectedWorkOrder_extraInitializers), $ad589216e8fd70ae$var$__runInitializers(_this, _activeTab_initializers, 'all')));
            Object.defineProperty(_this, "handleTabChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ad589216e8fd70ae$var$__runInitializers(_this, _activeTab_extraInitializers), function(key) {
                    if (!key) return;
                    _this.activeTab = key;
                    (0, $281cc8452bd676be$export$2e2bcd8739ae039).getList({}, 1);
                })
            });
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "selectedWorkOrder",
                get: function get() {
                    return $ad589216e8fd70ae$var$__classPrivateFieldGet(this, _SupervisionOrderListPage_selectedWorkOrder_accessor_storage, "f");
                },
                set: function set(value) {
                    $ad589216e8fd70ae$var$__classPrivateFieldSet(this, _SupervisionOrderListPage_selectedWorkOrder_accessor_storage, value, "f");
                }
            },
            {
                key: "activeTab",
                get: function get() {
                    return $ad589216e8fd70ae$var$__classPrivateFieldGet(this, _SupervisionOrderListPage_activeTab_accessor_storage, "f");
                },
                set: function set(value) {
                    $ad589216e8fd70ae$var$__classPrivateFieldSet(this, _SupervisionOrderListPage_activeTab_accessor_storage, value, "f");
                }
            },
            {
                key: "filterFields",
                get: function get() {
                    return [
                        {
                            key: 'keywords',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('search')
                        },
                        {
                            key: 'orderNumber',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_number')
                        },
                        {
                            key: 'orderType',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_type'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'normal',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('normal_order')
                                },
                                {
                                    value: 'duplicate',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_order')
                                },
                                {
                                    value: 'sensitive',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_order')
                                },
                                {
                                    value: 'responsible',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_order')
                                }
                            ]
                        },
                        {
                            key: 'department',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('department')
                        },
                        {
                            key: 'satisfactionLevel',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('satisfaction_level'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'satisfied',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('satisfied')
                                },
                                {
                                    value: 'basic',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('basic')
                                },
                                {
                                    value: 'unsatisfied',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('unsatisfied')
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "columns",
                get: function get() {
                    var _this = this;
                    return [
                        {
                            key: 'id',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_number')
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('supervision_type'),
                            renderBody: function(param) {
                                var deduplicationResult = param.deduplicationResult, sensitiveResult = param.sensitiveResult, responsibleResult = param.responsibleResult;
                                var orderType = deduplicationResult ? 'duplicate' : sensitiveResult ? 'sensitive' : responsibleResult ? 'responsible' : 'normal';
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: $ad589216e8fd70ae$var$OrderTypeColors[orderType],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)($ad589216e8fd70ae$var$OrderTypeLabels[orderType])
                                });
                            }
                        },
                        {
                            key: 'acceptanceContent',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('acceptance_content'),
                            renderBody: function(param) {
                                var acceptanceContent = param.acceptanceContent;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                    className: "m-0 text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: acceptanceContent
                                });
                            }
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('problem_description'),
                            renderBody: function(param) {
                                var acceptanceContent = param.acceptanceContent;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("p", {
                                    className: "m-0 text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: acceptanceContent
                                });
                            }
                        },
                        {
                            key: 'supervisionOrder',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('supervision_status'),
                            renderBody: function(param) {
                                var supervisionOrder = param.supervisionOrder;
                                return supervisionOrder ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: "success",
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('supervision_completed')
                                }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: "warning",
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('pending_supervision')
                                });
                            }
                        },
                        {
                            key: 'id',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('operation'),
                            renderBody: function(workOrder) {
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    size: "sm",
                                    onClick: function() {
                                        return _this.selectedWorkOrder = workOrder;
                                    },
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('create_supervision_order')
                                });
                            }
                        }
                    ];
                }
            },
            {
                key: "fields",
                get: function get() {
                    return [
                        {
                            key: 'supervisorName',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('supervisor')
                        },
                        {
                            key: 'responsibleDepartment',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_department')
                        },
                        {
                            key: 'recipientName',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('receiver')
                        },
                        {
                            key: 'templateName',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('supervision_template'),
                            options: [
                                {
                                    value: "\u7763\u529E\u5355\u6A21\u72481"
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    var selectedWorkOrder = this.selectedWorkOrder;
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $eb8ef8f36513dc70$export$2e2bcd8739ae039), {
                        className: "py-3",
                        fluid: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                                className: "shadow-sm",
                                body: true,
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)("hgroup", {
                                        className: "d-flex justify-content-between align-items-center mb-3",
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h2", {
                                                className: "fs-5 mb-0",
                                                children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('pending_supervision_orders')
                                            }),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e5d030dc0e0e8f4f$export$2e2bcd8739ae039), {
                                                as: "nav",
                                                variant: "pills",
                                                activeKey: this.activeTab,
                                                onSelect: this.handleTabChange,
                                                children: [
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e5d030dc0e0e8f4f$export$2e2bcd8739ae039).Link, {
                                                        eventKey: "all",
                                                        children: [
                                                            "\uD83D\uDCCB ",
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('export_all')
                                                        ]
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e5d030dc0e0e8f4f$export$2e2bcd8739ae039).Link, {
                                                        eventKey: "duplicate",
                                                        children: [
                                                            "\uD83D\uDCCB ",
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_discovery')
                                                        ]
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e5d030dc0e0e8f4f$export$2e2bcd8739ae039).Link, {
                                                        eventKey: "cancelled",
                                                        children: [
                                                            "\uD83D\uDCCB ",
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('cancelled_orders')
                                                        ]
                                                    }),
                                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $e5d030dc0e0e8f4f$export$2e2bcd8739ae039).Link, {
                                                        eventKey: "listed",
                                                        children: [
                                                            "\uD83D\uDCCB ",
                                                            (0, $50993b47476de2e7$export$625550452a3fa3ec)('listed_orders')
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                        filterFields: this.filterFields,
                                        columns: this.columns,
                                        store: (0, $281cc8452bd676be$export$2e2bcd8739ae039),
                                        translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                        striped: true,
                                        hover: true
                                    })
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039), {
                                size: "lg",
                                show: !!selectedWorkOrder,
                                onHide: function() {
                                    return _this.selectedWorkOrder = undefined;
                                },
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Header, {
                                        closeButton: true,
                                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Title, {
                                            children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('new_supervision_order')
                                        })
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $365d964e345f76dd$export$2e2bcd8739ae039).Body, {
                                        children: [
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $b32fd42aa4b20233$export$d1b165477a834d0f), Object.assign({}, selectedWorkOrder)),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1ee5c72f491c8f35$export$fca56b23a8961557), Object.assign({}, selectedWorkOrder === null || selectedWorkOrder === void 0 ? void 0 : selectedWorkOrder.sensitiveResult)),
                                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestForm), {
                                                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                                store: (0, $dee6d3a99caede11$export$2e2bcd8739ae039),
                                                fields: this.fields
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    _SupervisionOrderListPage_selectedWorkOrder_accessor_storage = new WeakMap();
    _SupervisionOrderListPage_activeTab_accessor_storage = new WeakMap();
    $ad589216e8fd70ae$var$__setFunctionName(_classThis, "SupervisionOrderListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _selectedWorkOrder_decorators = [
            (0, $arNK5.observable)
        ];
        _activeTab_decorators = [
            (0, $arNK5.observable)
        ];
        $ad589216e8fd70ae$var$__esDecorate(_classThis, null, _selectedWorkOrder_decorators, {
            kind: "accessor",
            name: "selectedWorkOrder",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "selectedWorkOrder" in obj;
                },
                get: function(obj) {
                    return obj.selectedWorkOrder;
                },
                set: function(obj, value) {
                    obj.selectedWorkOrder = value;
                }
            },
            metadata: _metadata
        }, _selectedWorkOrder_initializers, _selectedWorkOrder_extraInitializers);
        $ad589216e8fd70ae$var$__esDecorate(_classThis, null, _activeTab_decorators, {
            kind: "accessor",
            name: "activeTab",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "activeTab" in obj;
                },
                get: function(obj) {
                    return obj.activeTab;
                },
                set: function(obj, value) {
                    obj.activeTab = value;
                }
            },
            metadata: _metadata
        }, _activeTab_initializers, _activeTab_extraInitializers);
        $ad589216e8fd70ae$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        SupervisionOrderListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ad589216e8fd70ae$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return SupervisionOrderListPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");



var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");




var $61f01ffb82d6bb99$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $61f01ffb82d6bb99$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $61f01ffb82d6bb99$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $61f01ffb82d6bb99$var$TaskStatusColors = {
    in_progress: 'primary',
    completed: 'success',
    failed: 'danger'
};
var $61f01ffb82d6bb99$var$TaskListName = function(param) {
    var t = param.t;
    return {
        deduplication: t('deduplication_task_list'),
        sensitive: t('sensitive_task_list'),
        responsible: t('responsible_task_list')
    };
};
var $61f01ffb82d6bb99$export$60c3bfa6385e2a10 = function() {
    var _classDecorators = [
        (0, $397c81af6d5568dc$export$369b6b2b30582e8e),
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _get_filterFields_decorators;
    var _get_columns_decorators;
    var TaskListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            $61f01ffb82d6bb99$var$__runInitializers(_this, _instanceExtraInitializers);
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "filterFields",
                get: function get() {
                    return [
                        {
                            key: 'name',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_name')
                        },
                        {
                            key: 'status',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_status'),
                            options: [
                                {
                                    value: '',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('all_statuses')
                                },
                                {
                                    value: 'in_progress',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('in_progress')
                                },
                                {
                                    value: 'completed',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('completed')
                                },
                                {
                                    value: 'failed',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('failed')
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "columns",
                get: function get() {
                    return [
                        {
                            key: 'id',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('id_number')
                        },
                        {
                            key: 'name',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_name'),
                            renderBody: function(param) {
                                var name = param.name, id = param.id;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("a", {
                                    href: "#/task/deduplication/".concat(id),
                                    className: "text-decoration-none",
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "file-earmark-text",
                                            className: "me-2"
                                        }),
                                        name
                                    ]
                                });
                            }
                        },
                        {
                            key: 'status',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_status'),
                            renderBody: function(param) {
                                var status = param.status;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: $61f01ffb82d6bb99$var$TaskStatusColors[status],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)(status)
                                });
                            }
                        },
                        {
                            key: 'totalWorkOrders',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_count'),
                            renderBody: function(param) {
                                var totalWorkOrders = param.totalWorkOrders, processedWorkOrders = param.processedWorkOrders;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("span", {
                                    children: [
                                        processedWorkOrders || 0,
                                        " / ",
                                        totalWorkOrders || 0
                                    ]
                                });
                            }
                        },
                        {
                            key: 'startedAt',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('task_time'),
                            renderBody: function(param) {
                                var startedAt = param.startedAt, endedAt = param.endedAt;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            children: startedAt ? new Date(startedAt).toLocaleString() : '-'
                                        }),
                                        endedAt && (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                            className: "text-muted small",
                                            children: new Date(endedAt).toLocaleString()
                                        })
                                    ]
                                });
                            }
                        },
                        {
                            key: 'createdAt',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('upload_time'),
                            renderBody: function(param) {
                                var createdAt = param.createdAt;
                                return new Date(createdAt).toLocaleString();
                            }
                        },
                        {
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('operation'),
                            renderBody: function(param) {
                                var id = param.id;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a228d6edec70b31$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    size: "sm",
                                    href: "#/task/deduplication/".concat(id),
                                    children: [
                                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                            name: "eye",
                                            className: "me-1"
                                        }),
                                        (0, $50993b47476de2e7$export$625550452a3fa3ec)('details')
                                    ]
                                });
                            }
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    var type = this.props.match.params.type;
                    var typeName = $61f01ffb82d6bb99$var$TaskListName((0, $50993b47476de2e7$export$a7357cdd1f0b0168))[type];
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "m-3",
                        body: true,
                        children: [
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)("h4", {
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $def56be66887619b$exports.Icon), {
                                        name: "list-task",
                                        className: "me-2"
                                    }),
                                    typeName
                                ]
                            }),
                            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                                filterFields: this.filterFields,
                                columns: this.columns,
                                store: (0, $0b09d8b874d827d5$export$2e2bcd8739ae039),
                                translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                                striped: true,
                                hover: true
                            })
                        ]
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $61f01ffb82d6bb99$var$__setFunctionName(_classThis, "TaskListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_filterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_columns_decorators = [
            (0, $arNK5.computed)
        ];
        $61f01ffb82d6bb99$var$__esDecorate(_classThis, null, _get_filterFields_decorators, {
            kind: "getter",
            name: "filterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filterFields" in obj;
                },
                get: function(obj) {
                    return obj.filterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $61f01ffb82d6bb99$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $61f01ffb82d6bb99$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TaskListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $61f01ffb82d6bb99$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TaskListPage = _classThis;
}();



var $07dqX = parcelRequire("07dqX");

var $7lhcp = parcelRequire("7lhcp");

var $8BtP9 = parcelRequire("8BtP9");

var $h6w6E = parcelRequire("h6w6E");

var $5f0Cq = parcelRequire("5f0Cq");


var $arNK5 = parcelRequire("arNK5");


parcelRequire("6mMqj");
var $fClfl = parcelRequire("fClfl");



var $4ac4dd251a5c5255$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4ac4dd251a5c5255$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $5f0Cq._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4ac4dd251a5c5255$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5f0Cq._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4ac4dd251a5c5255$var$OrderTypeLabels = {
    normal: 'normal_order',
    duplicate: 'duplicate_order',
    sensitive: 'sensitive_order',
    responsible: 'responsible_order'
};
var $4ac4dd251a5c5255$var$OrderTypeColors = {
    normal: 'success',
    duplicate: 'warning',
    sensitive: 'danger',
    responsible: 'info'
};
var $4ac4dd251a5c5255$var$SatisfactionLabels = {
    satisfied: 'satisfied',
    basic: 'basic',
    unsatisfied: 'unsatisfied'
};
var $4ac4dd251a5c5255$var$SatisfactionColors = {
    satisfied: 'success',
    basic: 'warning',
    unsatisfied: 'danger'
};
var $4ac4dd251a5c5255$export$20e049d2ef60e846 = function() {
    var _classDecorators = [
        (0, $5bcfa0e0ec438674$export$b6ae1bc530f4c149)
    ];
    var _classDescriptor;
    var _classExtraInitializers = [];
    var _classThis;
    var _classSuper = (0, $fClfl.Component);
    var _instanceExtraInitializers = [];
    var _get_filterFields_decorators;
    var _get_columns_decorators;
    var WorkOrderListPage = _classThis = /*#__PURE__*/ function(_classSuper) {
        "use strict";
        (0, $h6w6E._)(_classThis, _classSuper);
        function _classThis() {
            (0, $7lhcp._)(this, _classThis);
            var _this;
            _this = (0, $07dqX._)(this, _classThis, arguments);
            $4ac4dd251a5c5255$var$__runInitializers(_this, _instanceExtraInitializers);
            return _this;
        }
        (0, $8BtP9._)(_classThis, [
            {
                key: "filterFields",
                get: function get() {
                    return [
                        {
                            key: 'keywords',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('search')
                        },
                        {
                            key: 'orderNumber',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_number')
                        },
                        {
                            key: 'department',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('department')
                        },
                        {
                            key: 'orderType',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_type'),
                            options: [
                                {
                                    value: 'normal',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('normal_order')
                                },
                                {
                                    value: 'duplicate',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('duplicate_order')
                                },
                                {
                                    value: 'sensitive',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('sensitive_order')
                                },
                                {
                                    value: 'responsible',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('responsible_order')
                                }
                            ]
                        },
                        {
                            key: 'satisfactionLevel',
                            type: 'select',
                            renderLabel: (0, $50993b47476de2e7$export$625550452a3fa3ec)('satisfaction_level'),
                            options: [
                                {
                                    value: 'satisfied',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('satisfied')
                                },
                                {
                                    value: 'basic',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('basic')
                                },
                                {
                                    value: 'unsatisfied',
                                    label: (0, $50993b47476de2e7$export$625550452a3fa3ec)('unsatisfied')
                                }
                            ]
                        }
                    ];
                }
            },
            {
                key: "columns",
                get: function get() {
                    return [
                        {
                            key: 'id',
                            type: 'number',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_id')
                        },
                        {
                            key: 'orderNumber',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_number')
                        },
                        {
                            key: 'orderType',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('order_type'),
                            renderBody: function(param) {
                                var orderType = param.orderType;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: $4ac4dd251a5c5255$var$OrderTypeColors[orderType],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)($4ac4dd251a5c5255$var$OrderTypeLabels[orderType])
                                });
                            }
                        },
                        {
                            key: 'category',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('category')
                        },
                        {
                            key: 'department',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('department')
                        },
                        {
                            key: 'acceptanceTime',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('acceptance_time'),
                            renderBody: function(param) {
                                var acceptanceTime = param.acceptanceTime;
                                return new Date(acceptanceTime).toLocaleString();
                            }
                        },
                        {
                            key: 'acceptanceContent',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('acceptance_content'),
                            renderBody: function(param) {
                                var acceptanceContent = param.acceptanceContent;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: acceptanceContent
                                });
                            }
                        },
                        {
                            key: 'processingStatus',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('processing_status'),
                            renderBody: function(param) {
                                var processingStatus = param.processingStatus;
                                return (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                                    className: "text-truncate",
                                    style: {
                                        maxWidth: '20rem'
                                    },
                                    children: processingStatus
                                });
                            }
                        },
                        {
                            key: 'satisfactionLevel',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('satisfaction_level'),
                            renderBody: function(param) {
                                var satisfactionLevel = param.satisfactionLevel;
                                return satisfactionLevel ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: $4ac4dd251a5c5255$var$SatisfactionColors[satisfactionLevel],
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)($4ac4dd251a5c5255$var$SatisfactionLabels[satisfactionLevel])
                                }) : null;
                            }
                        },
                        {
                            key: 'isClassificationOptimized',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('ai_optimization_reason'),
                            renderBody: function(param) {
                                var isClassificationOptimized = param.isClassificationOptimized;
                                return isClassificationOptimized ? (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: "primary",
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('edit')
                                }) : (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $f1387cf7abf6568e$export$2e2bcd8739ae039), {
                                    bg: "secondary",
                                    children: (0, $50993b47476de2e7$export$625550452a3fa3ec)('cancel')
                                });
                            }
                        },
                        {
                            key: 'uploadTime',
                            renderHead: (0, $50993b47476de2e7$export$625550452a3fa3ec)('upload_time'),
                            renderBody: function(param) {
                                var uploadTime = param.uploadTime;
                                return new Date(uploadTime).toLocaleString();
                            }
                        }
                    ];
                }
            },
            {
                key: "render",
                value: function render() {
                    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $5144fe88f07c89a5$export$2e2bcd8739ae039), {
                        className: "m-3",
                        body: true,
                        children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $62ac3db46cb6ed0e$exports.RestTable), {
                            filterFields: this.filterFields,
                            columns: this.columns,
                            store: (0, $281cc8452bd676be$export$2e2bcd8739ae039),
                            translator: (0, $50993b47476de2e7$export$a7357cdd1f0b0168),
                            striped: true,
                            hover: true
                        })
                    });
                }
            }
        ]);
        return _classThis;
    }(_classSuper);
    $4ac4dd251a5c5255$var$__setFunctionName(_classThis, "WorkOrderListPage");
    (function() {
        var _a;
        var _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_filterFields_decorators = [
            (0, $arNK5.computed)
        ];
        _get_columns_decorators = [
            (0, $arNK5.computed)
        ];
        $4ac4dd251a5c5255$var$__esDecorate(_classThis, null, _get_filterFields_decorators, {
            kind: "getter",
            name: "filterFields",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "filterFields" in obj;
                },
                get: function(obj) {
                    return obj.filterFields;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4ac4dd251a5c5255$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: function(obj) {
                    return "columns" in obj;
                },
                get: function(obj) {
                    return obj.columns;
                }
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $4ac4dd251a5c5255$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        WorkOrderListPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $4ac4dd251a5c5255$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return WorkOrderListPage = _classThis;
}();


var $94a964d0ae980490$export$953c2efc134d7f79 = function() {
    return (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $77c8f0735dbc1c18$export$a476b4f7d4df5522), {
        children: [
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $aca7ac1a0ae40101$export$8b543871300e74c2), {}),
            (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.HashRouter), {
                children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)("div", {
                    className: "d-flex",
                    children: [
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $7a40ea284503ee0f$export$3cabf771c4f2de), {}),
                        (0, $1c838ced510d5939$export$34b9dba7ce09269b)("main", {
                            className: "flex-fill",
                            style: {
                                height: 'calc(100vh - 4.7rem)',
                                overflowY: 'auto'
                            },
                            children: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Routes), {
                                children: [
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $d8bb4e3ff7180a53$export$fedd53519a0e2bce), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/category",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c455d3a7d8d2d4e1$export$f7d2f673fc2f091d), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/work-order",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4ac4dd251a5c5255$export$20e049d2ef60e846), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/document",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $023cb9dcafae106b$export$677172e6ba6bc651), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/document/upload",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $61cf78445d01c509$export$f51cb699e685f0f8), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/task/optimization/creator",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $068daf19f8f6c317$export$f17b967ebb337cc7), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/task/:type/creator",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c3b841a1e7b08b62$export$af6b5c503c29f2f0), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/task/classification",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $889de7132d9e2a11$export$1bffee0f80fe862b), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/task/:type/:id",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $c793570562ce1529$export$c1215908a5a09938), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/task/:type",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $61f01ffb82d6bb99$export$60c3bfa6385e2a10), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/rule/:type",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $43584f1a911dceb7$export$768e5f1aa8c321e9), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/report",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $12a70cd1e59ac341$export$83d9752a0a507b5d), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/report/template",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $33c723550218b8c0$export$694549d81a2df1da), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/report/template/:name",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $4a04735604ab79b0$export$bbfbacd372342508), {})
                                    }),
                                    (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $1R1LB.Route), {
                                        path: "/supervision-order",
                                        element: (0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $ad589216e8fd70ae$export$e771cce59804b124), {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};


(0, $3959ba5a3cb8c567$export$dfb5619354ba860)();
(0, $arNK5.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', function(param) {
    var reason = param.reason;
    var message = reason.message;
    if (message) self.alert(message);
    if (reason instanceof (0, $hp59o.HTTPError) && reason.response.status === 401) (0, $66f68a4f6b0aa2a1$export$2e2bcd8739ae039).signOut();
});
var $4d6b8652bfb48509$var$serviceWorker = window.navigator.serviceWorker, $4d6b8652bfb48509$var$NODE_ENV = "production";
if ($4d6b8652bfb48509$var$NODE_ENV !== 'development') $4d6b8652bfb48509$var$serviceWorker === null || $4d6b8652bfb48509$var$serviceWorker === void 0 || $4d6b8652bfb48509$var$serviceWorker.register('sw.js').then((0, $6tqvJ.serviceWorkerUpdate)).then(function(worker) {
    if (window.confirm('New version of this Web App detected, update now?')) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$4d6b8652bfb48509$var$serviceWorker === null || $4d6b8652bfb48509$var$serviceWorker === void 0 || $4d6b8652bfb48509$var$serviceWorker.addEventListener('controllerchange', function() {
    return window.location.reload();
});
(0, $e50729c8f73eecd9$export$882461b6382ed46c)(document.querySelector('#app')).render((0, $1c838ced510d5939$export$34b9dba7ce09269b)((0, $94a964d0ae980490$export$953c2efc134d7f79), {}));

})();
//# sourceMappingURL=repo.0e11eb6a.js.map
